// React, ReactDOM available as globals via CDN (see index.html)
const ASG_LOGO = 'data:image/png;base64,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';
// SIGNIN-V1 (7 October 2026): the brand the sign-in shows (the mark, the name
// beside it and the footer line). The companion has no tenant settings yet, so
// this ONE constant is the app's single brand source until a tenant source
// exists; the sign-in reads the brand from nowhere else.
const SIGNIN_BRAND = { short: 'ASG', name: 'ASG' };
const { useState, useEffect, useRef } = React;

// ── SheetPortal: every bottom sheet, scrim and modal dialog goes through it ──
// Andrew, 21 October 2026, on his iPhone on site: the fitting sheet's Log
// button sat under the tab bar and could not be tapped, and the Add a visit
// sheets' buttons likewise. On iOS an element whose overflow scrolls and
// whose -webkit-overflow-scrolling is touch (WebkitOverflowScrolling in the
// inline styles here) is a stacking context: WebKit's StyleAdjuster.cpp gives
// it a used z-index of 0, in iOS builds only. A position: fixed sheet rendered
// inside a screen's scroll area was therefore painted at that scroll area's
// level, whatever its own z-index: under the dock that holds the tab bar
// (zIndex 20) and under the header. Chromium and Linux WebKit have no such rule, so nothing off the
// phone showed it (tools/sim/ios.js now puts the rule back in the simulation).
// A React portal puts the overlay's DOM in document.body, so its z-index is
// compared in the root stacking context on every engine, whichever screen
// opened it. Belt and braces: while any is open the tab bar is not drawn
// (useSheetsOpen, read by TabBar).
//  - An overlay opened from inside another (the project picker over the Add a
//    visit sheet) stays inside its parent's layer, so the two keep the order
//    they always had.
//  - The layer takes the typography the overlay would have inherited where it
//    was rendered (read from a hidden marker left there, before paint), so
//    moving it changes no font, size or colour.
//  - In a server render (renderToString), or without ReactDOM.createPortal
//    (the node render harnesses stub ReactDOM), the overlay renders where it
//    stands, exactly as before.
// tests/sheet_portal.test.js fails if a dialog or a fixed overlay is rendered
// any other way.
const SheetPortalNest = React.createContext(false);
const _sheetsOpen = { n: 0, subs: new Set() };
const _sheetsOpenSubscribe = (fn) => { _sheetsOpen.subs.add(fn); return () => { _sheetsOpen.subs.delete(fn); }; };
const _sheetsOpenNow = () => _sheetsOpen.n;
const _sheetsOpenBump = (d) => {
  _sheetsOpen.n = Math.max(0, _sheetsOpen.n + d);
  _sheetsOpen.subs.forEach((fn) => { try { fn(); } catch (e) {} });
};
// True while any SheetPortal is mounted. A server render has no portals, so
// it reads none open.
const useSheetsOpen = () => React.useSyncExternalStore(_sheetsOpenSubscribe, _sheetsOpenNow, () => 0) > 0;
const _sheetCanPortal = () => typeof ReactDOM !== 'undefined' && !!ReactDOM && typeof ReactDOM.createPortal === 'function'
  && typeof document !== 'undefined' && !!document.body;
const _useSheetLayoutEffect = _sheetCanPortal() ? React.useLayoutEffect : useEffect;
const SHEET_LAYER_INHERITED = ['fontFamily', 'fontSize', 'fontWeight', 'fontStyle', 'lineHeight', 'letterSpacing', 'color',
  'textAlign', 'textTransform', 'whiteSpace', 'fontVariantNumeric', 'wordBreak', 'overflowWrap'];
const _sheetNoSubscribe = () => () => {};
const SheetPortal = ({ children }) => {
  const nested = React.useContext(SheetPortalNest);
  // True only in a server render (renderToString), which cannot draw a portal.
  const serverRender = React.useSyncExternalStore(_sheetNoSubscribe, () => false, () => true);
  const markRef = useRef(null);
  const layerRef = useRef(null);
  useEffect(() => { _sheetsOpenBump(1); return () => _sheetsOpenBump(-1); }, []);
  _useSheetLayoutEffect(() => {
    const mark = markRef.current; const layer = layerRef.current;
    if (!mark || !layer || !mark.parentElement) return;
    try {
      const cs = window.getComputedStyle(mark.parentElement);
      SHEET_LAYER_INHERITED.forEach((k) => { layer.style[k] = cs[k]; });
    } catch (e) {}
  }, []);
  if (nested || serverRender || !_sheetCanPortal()) return <SheetPortalNest.Provider value={true}>{children}</SheetPortalNest.Provider>;
  return (
    <>
      <span hidden ref={markRef} />
      {ReactDOM.createPortal(
        <SheetPortalNest.Provider value={true}><div data-sheet-layer="" ref={layerRef}>{children}</div></SheetPortalNest.Provider>,
        document.body)}
    </>
  );
};

// ── Portal connection ────────────────────────────────
// Railway URL until DNS CNAME is live
const PORTAL_URL = 'https://lumen-portal.up.railway.app';

// ==== BRIEFING_SEAM_START ====
// ── Morning briefing: ONE unwrap, ONE validity test, ONE cache reader ──
// Three separate defects met in `lumen_morning_briefing`, and they masked each
// other. Fixing any one alone leaves the screen blank, so all three resolve
// through these helpers rather than at five separate call sites.
//
// 1. ENVELOPE NEVER UNWRAPPED. GET /api/companion/briefing returns
//    `{briefing: {...}, generated: true}`; the briefing's own fields, and the
//    `meta` block the portal injects from the `briefings` table, live INSIDE
//    `briefing`. Every reader here asked for them on the ENVELOPE, where they
//    are always undefined. On a perfectly good authenticated 200 the screen
//    therefore took its CONTENT branch (the envelope is a truthy object, so
//    not EmptyState) and drew one card with a blank prose line and every other
//    card suppressed.
// 2. REFUSALS WERE CACHED. The Today-screen writer had no Authorization
//    header and no `r.ok` check, so the portal's `{error: 'Unauthorised'}` was
//    stored under today's date.
// 3. THE POISON WAS STICKY. Readers tested `cached.data` for TRUTHINESS, and
//    an error object is truthy -- so the authed fetch short-circuited and never
//    ran, and the entry could not clear until the date rolled over.
//
// `briefingFromPayload` is deliberately TOLERANT of both shapes: it takes the
// envelope's `.briefing` when present and otherwise accepts a flat object, so
// it cannot break if the portal is ever changed to return the briefing flat.
// It returns null for anything that is not a real briefing -- an error body,
// `{briefing: null, generated: false}`, a string, an array -- which is what
// makes a poisoned cache heal on the very next read instead of at midnight.
const briefingFromPayload = (payload) => {
  if (!payload || typeof payload !== 'object' || Array.isArray(payload)) return null;
  if (payload.error) return null;
  let b = (payload.briefing !== undefined) ? payload.briefing : payload;
  // MORNING-BRIEFING-V2 C: the ranked plan rides inside the briefing, or at
  // the top level when no briefing row exists, with plan_error when the portal
  // could not read it. A body with no briefing but a plan (or its error) is
  // still worth keeping; the plan is carried through, never dropped.
  const planArrives = (payload.plan && typeof payload.plan === 'object')
    || (typeof payload.plan_error === 'string' && payload.plan_error.trim() !== '');
  if (planArrives && (!b || typeof b !== 'object' || Array.isArray(b))) b = {};
  if (!b || typeof b !== 'object' || Array.isArray(b) || b.error) return null;
  if (payload !== b && planArrives) {
    const carried = {};
    if (b.plan === undefined && payload.plan) carried.plan = payload.plan;
    if (b.plan_error === undefined && payload.plan_error) carried.plan_error = payload.plan_error;
    if (Object.keys(carried).length) b = Object.assign({}, b, carried);
  }
  // "Is this a briefing at all", NOT "can this screen render it" -- the two
  // are different today and conflating them would throw away real data.
  //
  // The portal CURRENTLY emits `{stand:{prose}, move:{headline,...},
  // momentum:{prose,...}}` (morning_briefing.verify_and_blank), plus a `meta`
  // block injected by the API layer from the `briefings` table. The older
  // `opening` / `score_context` / `sections` shape is RETIRED portal-side --
  // it is accepted here only so a cache entry written before this change, or
  // an old row still in the table, is not discarded.
  //
  // v190 re-pointed both renderers onto stand/move/momentum, so the drift this
  // comment used to warn about is closed; the legacy clauses below stay only
  // to keep old cache entries and old table rows readable, not because any
  // surface still renders them. SELECTION lives in `briefingBeats` -- this
  // function answers "is this a briefing at all", nothing more.
  const nonEmpty = (v) => typeof v === 'string' && v.trim() !== '';
  const looksReal =
       (b.stand && nonEmpty(b.stand.prose))
    || (b.move && nonEmpty(b.move.headline))
    || (b.momentum && nonEmpty(b.momentum.prose))
    || (b.meta && nonEmpty(b.meta.hook_line))
    || nonEmpty(b.opening)
    || briefingPlan(b).hasPlan
    || nonEmpty(b.plan_error)
    // Legacy `sections` was a DICT keyed today/flagged/one_thing/...; the
    // array form appears only in portal test fixtures. Accept either rather
    // than pretend to know which a stored entry holds.
    || (b.sections && typeof b.sections === 'object'
        && Object.keys(b.sections).length > 0);
  return looksReal ? b : null;
};

// Today's cached briefing, or null. Never throws.
const readCachedBriefing = () => {
  try {
    const cached = JSON.parse(localStorage.getItem('lumen_morning_briefing') || '{}');
    if (cached.date !== new Date().toISOString().split('T')[0]) return null;
    return briefingFromPayload(cached.data);
  } catch (e) { return null; }
};

// Cache ONLY a briefing that survived validation. Writing an unvalidated
// payload here is what created the sticky-poison bug; keep the guard.
const cacheBriefing = (briefing) => {
  if (!briefing) return;
  try {
    localStorage.setItem('lumen_morning_briefing', JSON.stringify({
      date: new Date().toISOString().split('T')[0], data: briefing,
    }));
  } catch (e) {}
};

// ── The three beats, selected from the PRODUCER's schema ──────────────
// Every rule below is mirrored from morning_briefing.py, which is the only
// authority on this shape. Do not derive it from a screen, a doc or a memory:
// v188/v189 each shipped a mechanism claim written from someone's model of
// this seam rather than from the generator, and each was wrong.
//
//   verify_and_blank  -> {stand:{prose}, move:{...}, momentum:{...}}
//   _normalise_move   -> EXACTLY six fields, all strings:
//                        headline, reason, contact_name, contact_id,
//                        action_target, tier
//   MOVE_TIERS        -> ('relationship', 'unsent', 'clear')
//   `meta`            -> injected by app.py from the `briefings` TABLE
//                        (hook_line, generated_at; the score fields are
//                        retired, COMPANION-TRUTH-V1), NOT produced by
//                        the generator.
//
// WHAT THE PRODUCER CAN AND CANNOT EMIT -- corrected after review; the first
// draft of this comment claimed the verifier leaves beats BLANK, and it does
// not. It blanks and then BACK-FILLS a deterministic floor in the same
// function: `stand_prose = _deterministic_stand_line(data)` when empty, an
// ungrounded move REPLACED by `_build_fallback_move` (floor `_clear_move`),
// `momentum = _deterministic_momentum(data)` when its prose is empty. The
// `blanked` list is an AUDIT record written to sonnet_call_log; it never
// reaches this app. The module docstring is explicit: "`move` is NEVER blank".
//
// So on any body the current producer emits, all three beats carry prose. The
// null-returning branches below are DEFENSIVE, not an expected path -- they
// exist for a malformed body, an old cache entry, or a future producer change,
// and they must never invent a placeholder to fill the gap.
//
// What genuinely IS optional, and correctly renders nothing when absent:
//   * move.reason, move.contact_name, move.contact_id, move.action_target --
//     empty contact fields are legal ONLY on the `clear` rung (_clear_move),
//     so a missing contact is the ladder floor, not a defect to flag.
//   * momentum.streak_weeks == 0 -- _deterministic_momentum's real "fresh
//     week" answer, not a streak of zero.
const BRIEFING_MOVE_TIERS = ['relationship', 'unsent', 'clear'];

// ── The ranked plan (MORNING-BRIEFING-V2 track B/C) ───────────────────
// Mirrored from the portal's briefing_plan.py: briefing.plan = {version: 2,
// sections: [{key, title, items: [{id, kind, text, why, last_said, contact
// {name, phone, id}, record {type, id, name, href}, action {kind: call|open|
// eva|link, label, tel, href}, figures}]}]}. Eva drafts (the `drafts`
// section, kind `eva`) are never shown on the phone. Everything is read
// defensively: a malformed item is dropped, never guessed at.
//
// A tel number is digits and a leading plus only. Anything else (a script, a
// word) leaves no number, so no link.
const briefingTel = (v) => {
  if (typeof v !== 'string') return '';
  const lead = v.trim().charAt(0) === '+' ? '+' : '';
  const digits = v.replace(/\D/g, '');
  return digits.length >= 3 ? lead + digits : '';
};
const briefingPlan = (briefing) => {
  const b = (briefing && typeof briefing === 'object' && !Array.isArray(briefing)) ? briefing : {};
  const p = (b.plan && typeof b.plan === 'object' && !Array.isArray(b.plan)) ? b.plan : {};
  const str = (v) => (typeof v === 'string' ? v.trim() : '');
  const obj = (v) => (v && typeof v === 'object' && !Array.isArray(v)) ? v : {};
  const err = str(b.plan_error) || null;
  const sections = [];
  (Array.isArray(p.sections) ? p.sections : []).forEach((s) => {
    const sec = obj(s);
    const key = str(sec.key);
    if (!key || key === 'drafts') return;
    const items = [];
    (Array.isArray(sec.items) ? sec.items : []).forEach((raw) => {
      const it = obj(raw);
      const text = str(it.text);
      const ac = obj(it.action);
      if (!text || it.kind === 'eva' || ac.kind === 'eva') return;
      const contact = obj(it.contact);
      const rec = obj(it.record);
      const tel = ac.kind === 'call' ? (briefingTel(ac.tel) || briefingTel(contact.phone)) : '';
      const first = str(contact.name).split(/\s+/)[0];
      items.push({
        id: str(it.id) || null,
        kind: str(it.kind) || null,
        text,
        why: str(it.why) || null,
        lastSaid: str(it.last_said) || null,
        contactName: str(contact.name) || null,
        record: str(rec.name) ? { name: str(rec.name), id: str(rec.id) || null, type: str(rec.type) || null } : null,
        call: tel ? { tel, label: str(ac.label) || (first ? 'Ring ' + first : 'Ring') } : null,
      });
    });
    if (items.length) sections.push({ key, title: str(sec.title) || key, items });
  });
  const lead = sections.find((s) => s.key === 'first');
  const first = lead ? lead.items[0] : null;
  // The portal's first item is a copy of a source item in another section
  // ('first:<id>' and '<id>'). A figure is said once per screen: the source is
  // left out of its own section, matched by id, never by text.
  const firstSrc = first && first.id ? first.id.replace(/^first:/, '') : null;
  if (firstSrc) {
    for (let i = sections.length - 1; i >= 0; i--) {
      const s = sections[i];
      if (s.key === 'first') continue;
      s.items = s.items.filter((it) => it.id !== firstSrc);
      if (!s.items.length) sections.splice(i, 1);
    }
  }
  const more = [];
  sections.forEach((s) => {
    if (s.key !== 'ring' && s.key !== 'quotes') return;
    s.items.forEach((it) => {
      if (more.length >= 3) return;
      if (firstSrc && it.id === firstSrc) return;
      if (it.id && more.some((m) => m.id === it.id)) return;
      more.push(it);
    });
  });
  return { hasPlan: sections.length > 0, error: err, sections, first, more };
};

const briefingBeats = (briefing) => {
  const b = (briefing && typeof briefing === 'object' && !Array.isArray(briefing))
    ? briefing : {};
  const str = (v) => (typeof v === 'string' ? v.trim() : '');
  const obj = (v) => (v && typeof v === 'object' && !Array.isArray(v)) ? v : {};
  const posInt = (v) => (typeof v === 'number' && isFinite(v) && v > 0)
    ? Math.floor(v) : null;

  const stand = str(obj(b.stand).prose) || null;

  const mv = obj(b.move);
  const headline = str(mv.headline);
  // A move with no headline is not a move. The producer's floor always
  // supplies one (CLEAR_MOVE_LINE), so this only fires on a malformed body.
  const move = headline ? {
    headline,
    reason: str(mv.reason) || null,
    contactName: str(mv.contact_name) || null,
    contactId: str(mv.contact_id) || null,
    actionTarget: str(mv.action_target) || null,
    tier: BRIEFING_MOVE_TIERS.indexOf(mv.tier) >= 0 ? mv.tier : null,
  } : null;

  const mo = obj(b.momentum);
  const momProse = str(mo.prose);
  const momentum = momProse ? {
    prose: momProse,
    // 0 weeks is a real "fresh week" answer from _deterministic_momentum, not
    // a streak — so it carries no streak line rather than rendering "0 weeks".
    streakWeeks: posInt(mo.streak_weeks),
    streakWindow: posInt(mo.streak_window),
  } : null;

  // COMPANION-TRUTH-V1: the score is retired (K-retire). The portal no longer
  // sends score_today or score_yesterday; a same-day cached briefing may still
  // carry them until midnight, and they are not read.
  const me = obj(b.meta);
  const meta = {
    hookLine: str(me.hook_line) || null,
    generatedAt: str(me.generated_at) || null,
  };

  const plan = briefingPlan(b);
  const legacyContent = !!(stand || move || momentum || meta.hookLine);
  return {
    stand, move, momentum, meta, plan,
    // The old three-beat content alone (the fallback when there is no plan).
    legacyContent,
    // Is there anything worth putting on the screen? `generated_at` alone is
    // not content -- a briefing row with every beat blanked has nothing to say,
    // and an almost-empty card is worse than an honest empty state. A plan, or
    // the sentence saying the plan could not be read, is content.
    hasContent: legacyContent || plan.hasPlan || !!plan.error,
  };
};
// ==== BRIEFING_SEAM_END ====

// ── Text sanitiser — fix literal unicode escapes from API strings ──
const sanitiseText = (str) => {
  if (typeof str !== 'string') return str;
  return str
    .replace(/\\u00b7/g, '\u00b7')
    .replace(/\\u00a3/g, '\u00a3')
    .replace(/\\u2014/g, '\u2014')
    .replace(/\\u2019/g, '\u2019')
    .replace(/\\u2026/g, '\u2026');
};

// ── Portal sync helpers ───────────────────────────────
const getPortalData = (key, fallback = null) => {
  try {
    const cached = localStorage.getItem(key);
    return cached ? JSON.parse(cached) : fallback;
  } catch (e) {
    return fallback;
  }
};

// ── COMPANION-TRUTH-V1 track C: the portal's figures, read as sent ──
// The figures named in briefs/COMPANION-TRUTH are no longer worked out on the
// phone. Each reads a cached endpoint body (syncPortalData writes it only on
// a 2xx, with its _synced_at) and answers null when the cache is missing or
// the value is not a number, so the screen draws its existing not-available
// state, never 0 and never a figure of its own. These are the user's own
// figures across divisions, as the portal sends them (FINDINGS Open
// question 1): no division filter is applied here.
const truthNumber = (v) => ((typeof v === 'number' && isFinite(v)) ? v : null);
// The app's existing not-available mark, the lone dash U+2014, drawn where a
// figure would be.
const TRUTH_DASH = String.fromCharCode(0x2014);
const truthBody = (key) => {
  const b = getPortalData(key, null);
  return (b && typeof b === 'object' && !Array.isArray(b)) ? b : null;
};
// COMPANION-TRUTH-V2 B1: the one definition of what goes with a person on a
// shared phone. Every value here came from a portal response and is one
// person's own (their jobs by name, their pipeline, their figures, their
// briefing). Switch user, Sign out and session expiry clear it, so the next
// person on this phone sees the existing shimmer or dash until their own
// sync lands, never the last person's data, and never keeps it when their
// own read fails (syncPortalData writes only on a 2xx). Whole keys only,
// never a lumen_ prefix sweep: everything the phone itself made (visits,
// snags, voice notes, every unsent queue) is not here and stays.
// The census is in tests/companion_truth_v2_identity.test.js.
const PORTAL_CACHE_OWNER_KEY = 'lumen_cache_owner';
const PORTAL_CACHE_KEYS = [
  'lumen_pipeline', 'lumen_pipeline_synced_at',             // syncPortalData /api/companion/pipeline
  'lumen_contacts', 'lumen_contacts_synced_at',             // syncPortalData /api/companion/contacts, and the contact search fetch-fallback
  'lumen_intelligence', 'lumen_intelligence_synced_at',     // syncPortalData /api/companion/intelligence
  'lumen_targets', 'lumen_targets_synced_at',               // syncPortalData /api/companion/targets
  'lumen_profile', 'lumen_profile_synced_at',               // syncPortalData /api/companion/profile
  'lumen_figures', 'lumen_figures_synced_at',               // syncPortalData /api/companion/figures
  'lumen_surveys_portal', 'lumen_surveys_portal_synced_at', // syncPortalData /api/companion/surveys
  'lumen_notifications', 'lumen_notifications_synced_at',   // syncPortalData /api/companion/notifications
  'lumen_projects', 'lumen_projects_synced_at',             // syncPortalData /api/companion/projects
  'lumen_company', 'lumen_company_synced_at',               // syncPortalData /api/companion/company (403 clears it too)
  'lumen_week', 'lumen_week_synced_at',                     // syncPortalData /api/companion/week
  'lumen_streaks', 'lumen_streaks_synced_at',               // Today and My performance, /api/companion/streaks
  'lumen_personal_bests', 'lumen_personal_bests_synced_at', // Today and My performance, /api/companion/personal-bests
  'lumen_movement',                                         // Today, /api/companion/movement
  'lumen_morning_briefing',                                 // cacheBriefing, the portal's briefing for one person
  // The monthly target is not here: it is kept per person (readMyMonthlyTarget, COMPANION-TRUTH-V3).
  PORTAL_CACHE_OWNER_KEY,                                  // whose caches these are (syncPortalData, claimPortalCaches)
];
// keep: keys to leave in place (session expiry keeps lumen_profile).
const clearPortalCaches = (keep) => {
  PORTAL_CACHE_KEYS.forEach((k) => {
    if (keep && keep.indexOf(k) !== -1) return;
    try { localStorage.removeItem(k); } catch (e) {}
  });
};
// The signed-in person on this phone (asg_current_user.id), as a string, or
// null when nobody is signed in.
const currentLocalUserId = () => {
  try {
    const u = JSON.parse(localStorage.getItem('asg_current_user') || 'null');
    return (u && u.id != null && u.id !== '') ? String(u.id) : null;
  } catch (e) { return null; }
};
// COMPANION-TRUTH-V3 (DECISIONS 176.158 item 4): the monthly target is one
// person's. It lives under a key per person, lumen_monthly_target_<id> (the
// signed-in person's asg_current_user.id), so a typed target survives a
// switch and is never shown to another person: it is not in
// PORTAL_CACHE_KEYS and a switch never clears it. Every reader and writer
// (Today, Pipeline, Company, My Targets, fetchTargetFromPortal) goes through
// this pair. Nobody signed in: no target (null), never another person's.
// The old shared key cannot say whose it was, so it is never copied to a
// person: it is removed wherever it is met (once, in practice: nothing writes
// it any more), and fetchTargetFromPortal (the portal is the source of
// truth) refills the person's own key at the next sync.
const MONTHLY_TARGET_KEY_PREFIX = 'lumen_monthly_target_';
const dropSharedMonthlyTarget = () => {
  try { localStorage.removeItem('lumen_monthly_target'); } catch (e) {}
};
const readMyMonthlyTarget = () => {
  dropSharedMonthlyTarget();
  const id = currentLocalUserId();
  if (id == null) return null;
  try { return localStorage.getItem(MONTHLY_TARGET_KEY_PREFIX + id); } catch (e) { return null; }
};
// value: the target to keep (a string or number), or null / '' to remove it.
// userId: whose target; the signed-in person when left out. Returns false
// (and says so in the console) when there is nobody to keep it for.
const writeMyMonthlyTarget = (value, userId) => {
  dropSharedMonthlyTarget();
  const id = (userId != null && userId !== '') ? String(userId) : currentLocalUserId();
  if (id == null) { console.warn('[target] nobody is signed in; the monthly target was not kept'); return false; }
  try {
    if (value == null || value === '') localStorage.removeItem(MONTHLY_TARGET_KEY_PREFIX + id);
    else localStorage.setItem(MONTHLY_TARGET_KEY_PREFIX + id, String(value));
    return true;
  } catch (e) { console.warn('[target] the monthly target could not be kept', e); return false; }
};
const portalCacheOwner = () => {
  try { return localStorage.getItem(PORTAL_CACHE_OWNER_KEY); } catch (e) { return null; }
};
// Make the caches this person's: anything another person (or nobody we can
// name) left is cleared first, then the owner is stamped.
const claimPortalCaches = (userId) => {
  if (userId == null || userId === '') return;
  const id = String(userId);
  if (portalCacheOwner() !== id) clearPortalCaches();
  try { localStorage.setItem(PORTAL_CACHE_OWNER_KEY, id); } catch (e) {}
};
// D1 mine and D2 mine: /api/companion/pipeline pipeline_total, quote_count.
const truthPipelineValue = () => { const b = truthBody('lumen_pipeline'); return b ? truthNumber(b.pipeline_total) : null; };
const truthLiveCount = () => { const b = truthBody('lumen_pipeline'); return b ? truthNumber(b.quote_count) : null; };
// D10 mine: /api/companion/figures waiting (count, and the jobs, oldest
// silence first).
const truthWaiting = () => {
  const b = truthBody('lumen_figures');
  const w = b && b.waiting;
  return (w && typeof w === 'object' && !Array.isArray(w)) ? w : null;
};
const truthWaitingCount = () => { const w = truthWaiting(); return w ? truthNumber(w.count) : null; };
// The D10 jobs as rows: { proposal, daysSince, local }. `proposal` carries
// only what the endpoint sends, mapped onto the fields the rows draw (name,
// client, quote ref, value, stage); nothing missing is derived. `local` is
// the phone's own proposal for the same job (the mapper keeps job_id as the
// proposal id), or null, in which case the row is drawn without its tap.
const truthWaitingRows = (proposals) => {
  const w = truthWaiting();
  const jobs = (w && Array.isArray(w.jobs)) ? w.jobs : [];
  const list = Array.isArray(proposals) ? proposals : [];
  const str = (v) => (typeof v === 'string' ? v : (typeof v === 'number' ? String(v) : ''));
  const same = (a, b) => a != null && b != null && String(a) !== '' && String(a) === String(b);
  // COMPANION-TRUTH-V2 B5 (DECISIONS 176.140): a D10 row carries no margin on
  // the wire, so the job's D16 is looked up in the same route's margins list,
  // by job id, then project id. No match: no margin (the not-available words).
  const fb = truthBody('lumen_figures');
  const margins = (fb && Array.isArray(fb.margins)) ? fb.margins.filter(m => m && typeof m === 'object') : [];
  return jobs.filter(j => j && typeof j === 'object').map(j => {
    const local = list.find(p => p && (same(p.id, j.job_id) || same(p.projectId, j.project_id))) || null;
    const value = truthNumber(j.value);
    const mg = margins.find(m => same(m.job_id, j.job_id)) || margins.find(m => same(m.project_id, j.project_id)) || null;
    return {
      proposal: {
        id: j.job_id != null ? j.job_id : null,
        projectId: j.project_id != null ? j.project_id : null,
        projectName: str(j.name),
        projectClient: str(j.client_name),
        client: str(j.client_name),
        quoteRef: str(j.quote_ref),
        reference: str(j.quote_ref),
        capex: value, value, totalValue: value,
        status: str(j.stage),
        marginPct: mg ? truthNumber(mg.margin) : null,
        marginWithheld: mg ? truthWhy(mg.withheld) : null,
      },
      daysSince: truthNumber(j.days_silent),
      local,
    };
  });
};
// COMPANION-TRUTH-V2 B5. Every win rate is D7 mine over the financial year
// and its label says so (DECISIONS 176.135): /api/companion/figures
// win_rate_fy, null while the kernel withholds it. The win_rate_90d key is
// gone from the route and is never read.
const truthWinRateFy = () => { const b = truthBody('lumen_figures'); return b ? truthNumber(b.win_rate_fy) : null; };
// D19 (DECISIONS 176.133): the pound figure beside the D10 count is the
// kernel's sum of D1 over exactly those jobs (waiting.value). The phone never
// adds the jobs up itself.
const truthWaitingValue = () => { const w = truthWaiting(); return w ? truthNumber(w.value) : null; };
// D8 mine over the financial year: /api/companion/figures quotes_built_fy.
const truthQuotesBuiltFy = () => { const b = truthBody('lumen_figures'); return b ? truthNumber(b.quotes_built_fy) : null; };
// A portal reason, or null for anything that is not a non-empty string.
const truthWhy = (v) => (typeof v === 'string' && v.trim() ? v.trim() : null);
// A portal reason read inside a sentence: first letter lower case, no full stop.
const truthReason = (s) => { const r = String(s).trim().replace(/\.$/, ''); return r.charAt(0).toLowerCase() + r.slice(1); };
// A phrase that starts a line: first letter upper case.
const truthSentence = (s) => { const r = String(s).trim(); return r.charAt(0).toUpperCase() + r.slice(1); };
// One /api/companion/pipeline figure, or null when it is missing, not a
// number, or withheld (its `<key>_withheld` reason is set).
const truthPipelineFigure = (key, withheldKey) => {
  const b = truthBody('lumen_pipeline');
  if (!b) return null;
  if (withheldKey && truthWhy(b[withheldKey])) return null;
  return truthNumber(b[key]);
};
const truthObject = (v) => (v && typeof v === 'object' && !Array.isArray(v) ? v : null);
// DECISIONS 176.140, a group's margin: D16 over the live jobs the pipeline
// total sums (/api/companion/pipeline margin), and D20 over this financial
// year's won jobs (/api/companion/figures won_margin). Null when not cached.
const truthLiveMargin = () => { const b = truthBody('lumen_pipeline'); return b ? truthObject(b.margin) : null; };
const truthWonMargin = () => { const b = truthBody('lumen_figures'); return b ? truthObject(b.won_margin) : null; };
// COMPANION-TRUTH-V3 (DECISIONS 176.158 item 2): D20 over this month's won
// jobs (/api/companion/figures won_margin_month), beside "Won this month";
// and the quoted set this year (quoted_fy): D22, the latest quote of every
// job whose first quote was built this year, summed (exactly the jobs
// quotes_built_fy counts), with D23, the blended estimated margin over the
// same jobs. Null when not cached; the value null when not a number.
const truthWonMarginMonth = () => { const b = truthBody('lumen_figures'); return b ? truthObject(b.won_margin_month) : null; };
const truthQuotedFy = () => { const b = truthBody('lumen_figures'); return b ? truthObject(b.quoted_fy) : null; };
const truthQuotedFyValue = () => { const q = truthQuotedFy(); return q ? truthNumber(q.value) : null; };
// D23's percent, or null while withheld (its reason set) or missing.
const truthQuotedFyMarginPct = () => {
  const q = truthQuotedFy();
  const m = q ? truthObject(q.margin) : null;
  if (!m || truthWhy(m.withheld)) return null;
  return truthNumber(m.pct);
};
// The one set of words for a job's own D16 margin (DECISIONS 176.137 and
// 176.140): its percent, or the portal's reason it is held back. It reads the
// portal's field names (margin_pct, margin_withheld: a served pipeline row)
// or the mapped proposal's (marginPct, marginWithheld). A row that carries
// neither reads "margin not available", never a figure of the phone's own.
const truthJobMargin = (q) => {
  const pick = (a, b) => (q && q[a] != null ? q[a] : (q ? q[b] : null));
  const pct = truthNumber(pick('margin_pct', 'marginPct'));
  if (pct != null) return { text: `${pct}% margin`, shown: true };
  const why = truthWhy(pick('margin_withheld', 'marginWithheld'));
  if (why && /no quoted price/i.test(why)) return { text: 'no price yet' };
  return { text: why ? `margin not available, ${truthReason(why)}` : 'margin not available' };
};
// The one set of words for a group's blended margin (DECISIONS 176.140),
// the lit Pipeline's own: "29% estimated margin", or the not-available state
// with the portal's reason. Never hidden and never a bare dash.
const truthGroupMargin = (m) => {
  const pct = m ? truthNumber(m.pct) : null;
  if (pct != null) return { pct, text: `${pct}% estimated margin` };
  const why = m ? truthWhy(m.withheld) : null;
  return { pct: null, text: why ? `Margin not available, ${truthReason(why)}.` : 'Margin not available.' };
};
// COMPANION-TRUTH-V2 B4 (DECISIONS 176.136): the ONE definition of how a sync
// moment reads. Today: "08:40". Another day of this year: "5 October, 08:40".
// Another year: "5 October 2025, 08:40". Every "Last synced" display below
// (Today's strip, the Studio line, Settings) reads it.
const truthWhen = (d, now = new Date()) => {
  const hhmm = d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
  const sameDay = d.getFullYear() === now.getFullYear() && d.getMonth() === now.getMonth() && d.getDate() === now.getDate();
  if (sameDay) return hhmm;
  const day = d.toLocaleDateString('en-GB', Object.assign({ day: 'numeric', month: 'long' }, d.getFullYear() === now.getFullYear() ? {} : { year: 'numeric' }));
  return `${day}, ${hhmm}`;
};
// The OLDEST _synced_at of the two keys Today's figures come from, as a Date,
// or null when neither has ever been fetched.
const truthSyncedAt = () => {
  const ts = ['lumen_pipeline_synced_at', 'lumen_figures_synced_at'].map(k => {
    try { const v = localStorage.getItem(k); const n = v ? new Date(v).getTime() : NaN; return isFinite(n) ? n : null; } catch (e) { return null; }
  }).filter(n => n != null);
  if (ts.length === 0) return null;
  return new Date(Math.min(...ts));
};
// When the figures Today reads were last fetched (truthWhen: the time, with
// the date when it was not today), or null when neither has ever been fetched.
const truthSyncedTime = (now = new Date()) => {
  const d = truthSyncedAt();
  return d ? truthWhen(d, now) : null;
};
// STUDIO-LIT-PHONE-V1 (DECISIONS 176.136): the same moment as a line
// ("Last synced 08:40" today, "Last synced 5 October, 08:40" before), or null
// when nothing was ever fetched.
const truthSyncedLine = (now = new Date()) => {
  const d = truthSyncedAt();
  return d ? `Last synced ${truthWhen(d, now)}` : null;
};

// ── S95 D5 — Personal bests helper (shared by Today + Company > Performance) ──
// Derives the same ten records from a proposals array so the summary tile on
// Today and the full grid on Company always agree. Proposals come from the
// portal pipeline sync; unavailable records are simply omitted so the caller
// can show em-dash placeholders instead of fabricating numbers.
// ==== PB_CONTEXT_LOGIC_START (tests/personal_bests_week.test.js)
// A personal-best context as people read it. The portal and the fallback
// below both name a week by its ISO code ("2026-W16"); the tile shows the
// week's Monday instead ("Week of 13 Apr 2026"). Anything else passes through.
const personalBestContext = (ctx) => {
  const m = /^(\d{4})-W(\d{2})$/.exec(String(ctx || ''));
  if (!m) return ctx || '';
  const year = Number(m[1]), week = Number(m[2]);
  const jan4 = new Date(Date.UTC(year, 0, 4));
  const monday = new Date(jan4.getTime() - (((jan4.getUTCDay() + 6) % 7) * 86400000) + (week - 1) * 7 * 86400000);
  return 'Week of ' + monday.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC' });
};
// A record the portal marks as a percent (unit 'percent', e.g. Highest margin
// won) reads as a whole percent, never as pounds: the same rule My
// performance uses with the switch on. null for anything else, so the tile
// keeps its own formatting (Andrew, 8 October 2026, portal ROADMAP R-580).
const personalBestUnitValue = (value, unit) => {
  if (unit !== 'percent' || typeof value !== 'number' || !isFinite(value)) return null;
  return `${Math.round(value)}%`;
};
// ==== PB_CONTEXT_LOGIC_END
const computePersonalBestsFromProposals = (proposals) => {
  const pros = Array.isArray(proposals) ? proposals : [];
  if (pros.length === 0) return [];
  const monthKey = (d) => `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}`;
  const yearKey = (d) => String(d.getFullYear());
  const isoWeek = (d) => {
    const date = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
    const day = date.getUTCDay() || 7;
    date.setUTCDate(date.getUTCDate() + 4 - day);
    const ys = new Date(Date.UTC(date.getUTCFullYear(), 0, 1));
    const wk = Math.ceil((((date - ys) / 86400000) + 1) / 7);
    return `${date.getUTCFullYear()}-W${String(wk).padStart(2,'0')}`;
  };
  const fmtMonthLabel = (d) => d.toLocaleString('en-GB', { month: 'short', year: 'numeric' });
  const records = [];
  const now = new Date();
  const thisMonth = monthKey(now);
  // Largest quote
  const largest = pros.reduce((m, p) => { const v = parseFloat(p.value || p.totalValue || p.capex || 0); return v > (m?.v || 0) ? { p, v } : m; }, null);
  if (largest && largest.v > 0) {
    const d = new Date(largest.p.createdAt || largest.p.date || Date.now());
    records.push({ key: 'largest_quote', label: 'Largest Quote', value: Math.round(largest.v), context: (largest.p.client || largest.p.projectClient || largest.p.projectName || '') + studioSep() + fmtMonthLabel(d), set_this_month: monthKey(d) === thisMonth });
  }
  // Group by month
  const byMonth = {};
  pros.forEach(p => {
    const d = new Date(p.createdAt || p.date || p.updatedAt || 0);
    if (isNaN(d.getTime())) return;
    const k = monthKey(d);
    if (!byMonth[k]) byMonth[k] = { dt: new Date(d.getFullYear(), d.getMonth(), 1), proposals: [], wonTotal: 0, clients: new Set() };
    byMonth[k].proposals.push(p);
    if (p.won === true || p.status === 'won') byMonth[k].wonTotal += parseFloat(p.value || p.totalValue || 0);
    const c = (p.client || p.projectClient || '').trim();
    if (c) byMonth[k].clients.add(c.toLowerCase());
  });
  const months = Object.entries(byMonth);
  const pipe = months.reduce((m, [k, v]) => { const s = v.proposals.reduce((ss,p)=>ss+parseFloat(p.value||p.totalValue||0),0); return s > (m?.v || 0) ? { k, v: s, dt: v.dt } : m; }, null);
  if (pipe && pipe.v > 0) records.push({ key: 'pipeline_month', label: 'Pipeline / Month', value: Math.round(pipe.v), context: fmtMonthLabel(pipe.dt), set_this_month: pipe.k === thisMonth });
  const sales = months.reduce((m, [k, v]) => v.wonTotal > (m?.v || 0) ? { k, v: v.wonTotal, dt: v.dt } : m, null);
  if (sales && sales.v > 0) records.push({ key: 'best_sales_month', label: 'Best Sales Month', value: Math.round(sales.v), context: fmtMonthLabel(sales.dt), set_this_month: sales.k === thisMonth });
  const pm = months.reduce((m, [k, v]) => v.proposals.length > (m?.v || 0) ? { k, v: v.proposals.length, dt: v.dt } : m, null);
  if (pm && pm.v > 0) records.push({ key: 'proposals_month', label: 'Proposals / Month', value: pm.v, context: fmtMonthLabel(pm.dt), set_this_month: pm.k === thisMonth });
  const byYear = {};
  pros.forEach(p => { const d = new Date(p.createdAt || p.date || 0); if (isNaN(d.getTime())) return; const k = yearKey(d); byYear[k] = (byYear[k] || 0) + 1; });
  const py = Object.entries(byYear).reduce((m, [k, v]) => v > (m?.v || 0) ? { k, v } : m, null);
  if (py && py.v > 0) records.push({ key: 'proposals_year', label: 'Proposals / Year', value: py.v, context: py.k, set_this_month: false });
  const byWeek = {};
  pros.forEach(p => { const d = new Date(p.createdAt || p.date || 0); if (isNaN(d.getTime())) return; const k = isoWeek(d); byWeek[k] = (byWeek[k] || 0) + parseFloat(p.value || p.totalValue || 0); });
  const bw = Object.entries(byWeek).reduce((m, [k, v]) => v > (m?.v || 0) ? { k, v } : m, null);
  if (bw && bw.v > 0) records.push({ key: 'best_week', label: 'Best Week', value: Math.round(bw.v), context: bw.k, set_this_month: false });
  // New clients per month — first-seen walk in chronological order
  const seenClients = new Set();
  const byMonthSorted = months.slice().sort(([,a],[,b]) => a.dt - b.dt);
  const newByMonth = {};
  byMonthSorted.forEach(([k, v]) => {
    let fresh = 0;
    v.clients.forEach(c => { if (!seenClients.has(c)) { seenClients.add(c); fresh++; } });
    newByMonth[k] = { v: fresh, dt: v.dt };
  });
  const nc = Object.entries(newByMonth).reduce((m, [k, v]) => v.v > (m?.v || 0) ? { k, v: v.v, dt: v.dt } : m, null);
  if (nc && nc.v > 0) records.push({ key: 'new_clients_month', label: 'New Clients / Month', value: nc.v, context: fmtMonthLabel(nc.dt), set_this_month: nc.k === thisMonth });
  const ac = months.reduce((m, [k, v]) => v.clients.size > (m?.v || 0) ? { k, v: v.clients.size, dt: v.dt } : m, null);
  if (ac && ac.v > 0) records.push({ key: 'active_clients_month', label: 'Active Clients / Mo', value: ac.v, context: fmtMonthLabel(ac.dt), set_this_month: ac.k === thisMonth });
  return records;
};

// ==== C_SIGNIN_AGAIN_SEAM_START =========================================
// SECURITY-WAVE-1 track C: the portal refuses a dead sign-in; the phone must
// notice, say so, and keep everything.
//
// The portal's fail-closed gate answers 401 to any /api/ call that carries no
// live companion token (and no portal session). Before this seam a 401 was
// treated like any other failure: queued writes spent attempts and parked,
// photo and voice uploads spent their attempts, and the dead token stayed in
// storage. The PIN unlock (UserSelectScreen checkPin) asks for the portal
// password only when NO token is stored, so a surveyor holding a dead one was
// stuck with it and never told.
//
// Now, one rule, applied by every Bearer write and the periodic sync:
//   * a 401 on a call that sent the stored token removes that token, sets
//     lumen_signin_needed and tells the app (lumenSignInNeeded), which shows
//     SIGNIN_AGAIN_MESSAGE with a "Sign in again" button. A 401 to a call
//     that sent no token, or a token the phone no longer holds, starts no
//     hold; a deliberate Sign Out ends one (clearSignInHoldOnSignOut);
//   * a 401 is about the sign-in, not the item: no queue spends an attempt on
//     it, nothing is parked or given up for it, and while a sign-in is needed
//     the queues are held rather than sent;
//   * the PIN still lets the surveyor in, signal or not (pinUnlockNeedsPortal):
//     the phone keeps working offline with the banner showing and every
//     queue held. The banner's "Sign in again" (online only) leads through the
//     PIN to the portal password; on success afterFreshSignIn clears the flag
//     and un-parks the parked writes, and the login's sync flushes them.
// Only a 401 counts. A 403 (signed in, not allowed), a 410, a 5xx (including
// the portal's 503 'auth_unavailable', when it could not check the token) or
// a network error says nothing about the sign-in and keeps its old handling:
// the token stays, and the item is retried like any other failure.
const SIGNIN_NEEDED_KEY = 'lumen_signin_needed';
const SIGNIN_AGAIN_MESSAGE =
  'Your portal sign-in has ended. Sign in again to send your work. ' +
  'Nothing is lost: it stays on this phone until you do.';
const SIGNIN_AGAIN_OFFLINE_MESSAGE =
  'Your portal sign-in has ended. You can sign in again once you have signal. ' +
  'Nothing is lost: your work stays on this phone.';

// status: the portal's answer; sentToken: the token THAT call sent (or null).
// Returns true when the answer refused the sign-in.
// The flag is set only when THIS refusal removes the stored token, i.e. the
// call sent the token the phone still holds. Every other 401 still returns
// true (a refusal: no queue spends an attempt on it) but changes nothing:
//   * no token sent (after Sign Out, say): there was no sign-in to refuse,
//     and the next PIN must ask for the portal password as usual;
//   * the stored token changed while the call was in flight (a new sign-in)
//     or was removed meanwhile (an earlier refusal already set the flag, or a
//     deliberate Sign Out, which must not be turned into a hold).
const bearerRefused = (status, sentToken, where) => {
  if (status !== 401) return false;
  if (!sentToken) return true;
  let current = null;
  try { current = localStorage.getItem('lumen_token'); } catch (e) {}
  if (current !== sentToken) return true;
  // Reaching here means this call removed the stored token, so this is a new
  // hold, even if a flag was left by a hold end the store could not record
  // (endSignInHold): the flag is written again and the app is told.
  try { localStorage.removeItem('lumen_token'); } catch (e) {}
  // COMPANION-TRUTH-V2 B1: the session that read the portal caches has
  // ended, so they go with it. lumen_profile stays: the same person is still
  // working, and removing it would change the whole app's look under them
  // mid-hold (a switch of person clears it).
  clearPortalCaches(['lumen_profile']);
  try { localStorage.setItem(SIGNIN_NEEDED_KEY, new Date().toISOString()); } catch (e) {}
  try { window.dispatchEvent(new CustomEvent('lumenSignInNeeded', { detail: { where: where || null } })); } catch (e) {}
  // Once per hold, since only the call that removes the token gets here: the
  // debug log keeps 500 entries, and a line per sync call (nine a tick) would
  // push the useful history out within hours.
  try { debugLog('auth.signin_needed', { where: where || null, hadToken: !!current }); } catch (e) {}
  return true;
};

// The banner's "Sign in again" asks for ONE trip to the portal password: the
// next PIN unlock takes it (takeSignInAgainRequest), so Back from the portal
// screen and a second PIN lets the surveyor in again rather than trapping them.
let _signInAgainRequested = false;
const requestSignInAgain = () => { _signInAgainRequested = true; };
const takeSignInAgainRequest = () => { const r = _signInAgainRequested; _signInAgainRequested = false; return r; };

// A deliberate Sign Out (Settings) removes the token on purpose: it also ends
// any hold and any pending banner request, so the next PIN asks for the
// portal password like any signed-out phone. Switch User does the same since
// COMPANION-TRUTH-V2 B1 (clearForNextPerson): the token goes, the hold ends.
// The banner's own "Sign in again" also leads to the PIN, but keeps the hold
// and its request (clearForNextPerson with keepSignInHold).
//
// The photo retry queue gives a photo up after 7 days (_PHOTO_RETRY_AGE_MS).
// While a sign-in was needed every photo was held, not tried, so a hold must
// not spend that time, however it ends (a fresh sign-in or a Sign Out): when
// a hold ends, the age clock of every photo queued before now restarts from
// now (PHOTO_AGE_RESTART_KEY, read by flushPhotoRetryQueue). Ending no hold
// changes nothing. endSignInHold is the one place a hold ends.
//
// A full store can refuse the restart stamp. Then, with a token stored (a
// fresh sign-in), the flag stays: with a token it holds nothing back
// (signInAgainNeeded needs no token too), and while it is there the photo
// queue gives nothing up for age, so the next hold end records the restart.
// With no token (a Sign Out) the flag must go, or the next PIN would skip the
// portal password; the Sign Out has just removed the token, which frees more
// room than the stamp needs, so the stamp is written again after the flag
// goes. Either way the failure is logged, never silent.
const PHOTO_AGE_RESTART_KEY = 'lumen_photo_age_restart';
const _stampPhotoAgeRestart = () => {
  try { localStorage.setItem(PHOTO_AGE_RESTART_KEY, new Date().toISOString()); return true; } catch (e) { return false; }
};
const endSignInHold = () => {
  let endsAHold = false, hasToken = false;
  try {
    endsAHold = !!localStorage.getItem(SIGNIN_NEEDED_KEY);
    hasToken = !!localStorage.getItem('lumen_token');
  } catch (e) {}
  if (!endsAHold) return;
  if (_stampPhotoAgeRestart()) {
    try { localStorage.removeItem(SIGNIN_NEEDED_KEY); } catch (e) {}
    return;
  }
  if (hasToken) {
    try { debugLog('auth.hold_end_unrecorded', { kept_flag: true }); } catch (e) {}
    return;
  }
  try { localStorage.removeItem(SIGNIN_NEEDED_KEY); } catch (e) {}
  const stamped = _stampPhotoAgeRestart();
  if (!stamped) { try { debugLog('auth.hold_end_unrecorded', { kept_flag: false }); } catch (e) {} }
};
const clearSignInHoldOnSignOut = () => {
  endSignInHold();
  _signInAgainRequested = false;
};

// COMPANION-TRUTH-V2 B1: the storage half of Switch user (and of Sign out,
// which reaches it too). The next person on a shared phone must never see or
// build on the last person's portal data: the person, the token and every
// portal cache go, and any sign-in hold ends as on Sign out (the token is
// removed first, as Sign out does). Unsent work is not a cache and stays.
// keepSignInHold: the banner's "Sign in again", which needs the hold and its
// one-shot request kept (see pinUnlockNeedsPortal).
const clearForNextPerson = (opts) => {
  const keepSignInHold = !!(opts && opts.keepSignInHold);
  try { localStorage.removeItem('asg_current_user'); } catch (e) {}
  try { localStorage.removeItem('_isDirector'); } catch (e) {}
  try { localStorage.removeItem('lumen_token'); } catch (e) {}
  if (!keepSignInHold) clearSignInHoldOnSignOut();
  clearPortalCaches();
};

// Called by checkPin once the PIN is right. True: ask for the portal password.
//   * a stored token: no (unchanged);
//   * no token and never a portal sign-in on this phone (no flag): yes
//     (unchanged: a new phone must connect to the portal once);
//   * no token because the portal refused it (the flag): no, so a surveyor
//     with no signal can keep working, with the banner showing and every
//     queue held; yes only when they asked through the banner.
const pinUnlockNeedsPortal = () => {
  let hasToken = false, flagged = false;
  try {
    hasToken = !!localStorage.getItem('lumen_token');
    flagged = !!localStorage.getItem(SIGNIN_NEEDED_KEY);
  } catch (e) {}
  if (hasToken) return false;
  if (flagged) return takeSignInAgainRequest();
  return true;
};

// The banner. Online, its button leads to the portal password (through the
// PIN). Offline it says so in plain words and offers nothing to press: a trip
// to the password screen with no signal only ends at "Could not reach the
// portal".
const SignInAgainBanner = ({ online, onSignIn }) => {
  // Studio (track C4): the dark red strip is a dark panel and the jewel is the
  // only one. The banner is raised paper with ink words; "Sign in again" is
  // the action written as the action, in violet text. Same words, same press.
  if (t.theme === 'uv') {
    return (
      <div role="alert" style={{ ...studioSurface.raised(), borderRadius: 0, padding: "10px 18px", display: "flex", alignItems: "center", gap: 12, flexShrink: 0, animation: "slideDown 0.3s ease" }}>
        <p style={{ flex: 1, minWidth: 0, fontSize: 14, fontWeight: 600, color: STUDIO_TOKENS.ink, lineHeight: 1.35, margin: 0 }}>
          {online ? SIGNIN_AGAIN_MESSAGE : SIGNIN_AGAIN_OFFLINE_MESSAGE}
        </p>
        {online && (
          <button onClick={() => { requestSignInAgain(); onSignIn(); }}
            style={{ ...studioType.action(), minHeight: 44, padding: "0 4px", cursor: "pointer", flexShrink: 0, fontFamily: "inherit" }}>
            Sign in again
          </button>
        )}
      </div>
    );
  }
  return (
  <div role="alert" style={{ background: "#7A271C", borderBottom: "0.5px solid rgba(255,255,255,0.14)", padding: "10px 18px", display: "flex", alignItems: "center", gap: 12, flexShrink: 0, animation: "slideDown 0.3s ease" }}>
    <p style={{ flex: 1, minWidth: 0, fontSize: 12, fontWeight: 600, color: "#fff", lineHeight: 1.35 }}>
      {online ? SIGNIN_AGAIN_MESSAGE : SIGNIN_AGAIN_OFFLINE_MESSAGE}
    </p>
    {online && (
      <button onClick={() => { requestSignInAgain(); onSignIn(); }}
        style={{ background: "#fff", color: "#7A271C", border: "none", borderRadius: 8, padding: "7px 12px", fontSize: 12, fontWeight: 800, cursor: "pointer", flexShrink: 0 }}>
        Sign in again
      </button>
    )}
  </div>
  );
};

// True while the portal has refused this phone's sign-in and no new one has
// been made. The queues hold (send nothing, spend nothing) while it is true.
const signInAgainNeeded = () => {
  try {
    return !!localStorage.getItem(SIGNIN_NEEDED_KEY) && !localStorage.getItem('lumen_token');
  } catch (e) { return false; }
};

// Portal routes retired with a 410 that old queue entries may still name.
// /api/leads: retired by SECURITY-WAVE-1 track C (SEC-019).
const PORTAL_RETIRED_ENDPOINTS = ['/api/leads'];

// Called once the portal password has produced a new token (connectPortal).
// Un-parks every parked write but those to retired endpoints (Settings' Retry
// all, done for the user), clears
// the flag and restarts the photo and voice queues. The offline queue itself
// is flushed by the login that follows (login -> syncPortalData), not here: a
// second concurrent flush would send each entry twice.
//
// Ending the hold restarts the photo age clock (endSignInHold, above). The
// offline and voice queues have no age cap, and no queue spends an attempt on
// a refused sign-in.
const afterFreshSignIn = () => {
  endSignInHold();
  // Endpoints the portal has retired stay parked: a replay only gets a 410
  // and parks again. Settings' Retry all still sends them if asked.
  const unparked = retryParkedWrites({ skip: PORTAL_RETIRED_ENDPOINTS });
  try { debugLog('auth.signed_in_again', { unparked }); } catch (e) {}
  try { window.dispatchEvent(new CustomEvent('lumenSignedInAgain', { detail: { unparked } })); } catch (e) {}
  try { flushPhotoRetryQueue(); } catch (e) {}
  try { flushAudioRetryQueue().then(() => backfillVoiceAudio()).catch(() => {}); } catch (e) {}
  return unparked;
};
// ==== C_SIGNIN_AGAIN_SEAM_END ===========================================

const OFFLINE_QUEUE_KEY = 'lumen_offline_queue';

// ── S158 — queue hardening: park, never discard ──────────────────────────
// Pre-S158 the flush silently dropped any entry on its 4th flush cycle
// (`attempts >= 3 → continue`) — a binding-bearing wrap or snag vanished
// without trace. Now an entry that exhausts its attempt cap moves to
// lumen_offline_parked (payload verbatim) where Settings surfaces it with
// Retry all / Discard all. The HUMAN may discard; the code may not.
//
// Cap is 8 flush cycles (flush rides the 5-minute sync tick, so backoff is
// implicit). Retrying harder is only safe because every parked-eligible
// endpoint is replay-absorbed server-side — checked at S158 read time:
//   /api/companion/event  — dedupe_key from client_event_id, UNIQUE + OR IGNORE (PR #87)
//   /api/touchpoints      — sha256 dedupe_key lookup before insert (PR #79)
//   /api/snags            — INSERT OR REPLACE INTO companion_snags
//   /api/survey-wrap      — S106 intent-aware dedup (409 on un-intended re-submit)
//   /api/leads            — NO replay protection (plain INSERT, fresh server id
//                           per request) → keeps the historical cap of 3 rather
//                           than retrying it harder blindly. Flagged for a
//                           portal-side dedupe key.
const OFFLINE_PARKED_KEY = 'lumen_offline_parked';
const _OFFLINE_MAX_ATTEMPTS = 8;
const _OFFLINE_ATTEMPT_CAP_BY_ENDPOINT = { '/api/leads': 3 };

const _readParkedWrites = () => {
  try {
    const arr = JSON.parse(localStorage.getItem(OFFLINE_PARKED_KEY) || '[]');
    return Array.isArray(arr) ? arr : [];
  } catch (e) { return []; }
};
const _writeParkedWrites = (arr) => {
  try { localStorage.setItem(OFFLINE_PARKED_KEY, JSON.stringify(arr)); } catch (e) {}
};
const _parkWrite = (item, lastError) => ({
  endpoint: item.endpoint,
  payload: item.payload,                  // verbatim — same shape as the queue
  queued_at: item.queued_at,
  parked_at: new Date().toISOString(),
  last_error: lastError || item.last_error || null,
  // SEND-STATE-V1: a survey wrap keeps the job it belongs to and its client
  // id, so the job still shows "Send failed" and a retry is still deduped.
  ...(item.projectId ? { projectId: item.projectId } : {}),
  ...(item.client_id ? { client_id: item.client_id } : {}),
  ...(item.jobPrint ? { jobPrint: item.jobPrint } : {}),
  ...(item.conflict ? { conflict: item.conflict } : {}),
  ...(item.userId ? { userId: item.userId } : {}),
});

// Settings actions. Retry-all re-queues with attempts reset to 0; the next
// flush (or an immediate one from the button) takes it from there.
// opts.skip: endpoints left parked (the sign-in un-park skips retired ones;
// the Settings button passes nothing and retries all).
// opts.only: a test each retried write must pass (SEND-STATE-V1: one job's
// "Try again" un-parks that job's survey and nothing else).
const retryParkedWrites = (opts = {}) => {
  const all = _readParkedWrites();
  const skip = new Set(opts.skip || []);
  const picked = (p) => !skip.has(p.endpoint) && (typeof opts.only !== 'function' || !!opts.only(p));
  const parked = all.filter(p => picked(p));
  const kept = all.filter(p => !picked(p));
  if (parked.length === 0) return 0;
  const queue = getPortalData(OFFLINE_QUEUE_KEY, []);
  parked.forEach(p => queue.push(Object.assign(
    { endpoint: p.endpoint, payload: p.payload, queued_at: p.queued_at, attempts: 0 },
    p.projectId ? { projectId: p.projectId } : {},
    p.client_id ? { client_id: p.client_id } : {},
    p.last_error ? { last_error: p.last_error } : {},
    p.jobPrint ? { jobPrint: p.jobPrint } : {},
    p.conflict ? { conflict: p.conflict } : {},
    p.userId ? { userId: p.userId } : {}
  )));
  // Park, never discard: the parked list is cleared only once the queue has
  // them. A full store refuses the queue write; then everything stays parked
  // and the refusal is logged.
  try { localStorage.setItem(OFFLINE_QUEUE_KEY, JSON.stringify(queue)); } catch (e) {
    try { debugLog('offline.parked.retry_refused', { count: parked.length, error: String(e && e.name || e) }); } catch (e2) {}
    return 0;
  }
  _writeParkedWrites(kept);
  debugLog('offline.parked.retry_all', { count: parked.length, left_parked: kept.length });
  if (parked.some(p => p && p.endpoint === WRAP_ENDPOINT)) _sendStateChanged();
  return parked.length;
};
const discardParkedWrites = () => {
  const all = _readParkedWrites();
  const n = all.length;
  _writeParkedWrites([]);
  debugLog('offline.parked.discard_all', { count: n });
  if (all.some(p => p && p.endpoint === WRAP_ENDPOINT)) _sendStateChanged();
  return n;
};

// ==== SEND_STATE_LOGIC_START ============================================
// SEND-STATE-V1: one job's send state, which the surveyor can always see:
//   not_sent  nothing has gone to the portal (or, with `earlier`, the queue
//             delivered a copy and the job has changed since, so the changes
//             have not gone)
//   sending   a send (from Check and send, or the queue) is in flight now
//   waiting   the survey is in lumen_offline_queue: no connection, the portal
//             refused it, a fresh sign-in is due, the job changed after it
//             was queued (`changed`: held, never sent stale), or the portal
//             already holds one for the job (`conflict`: 409 intent_required)
//   sent      the portal holds it (surveyWrapCompletedAt, stamped the same way
//             whether the send went at once or later from the queue)
//   failed    the queue gave up after its attempts and parked it: still on the
//             phone, never discarded, and Try again sends it
// Pure: the caller passes what it read (queue, parked list, delivery records,
// the job's own print, flags). The words for each state live here too, so
// every screen says the same thing.
const WRAP_ENDPOINT = '/api/survey-wrap';
// A time as milliseconds, from a number or an ISO string; 0 when unusable.
const _whenOf = (v) => (typeof v === 'number' ? v : (Date.parse(v || '') || 0));
// A queued or parked write belongs to a job: by the job id stamped on it, or,
// for a write queued before SEND-STATE-V1 (no id), by the survey's name, and
// then only for a job that already existed when it was queued (jobCreatedAt,
// the job's createdAt, at or before the write's queued_at). A later job with
// the same name never takes that copy's state, and never replaces or drops
// it. When either time is unknown, a name-only write matches no job.
const wrapQueueMatches = (item, projectId, projectName, jobCreatedAt) => {
  if (!item || item.endpoint !== WRAP_ENDPOINT) return false;
  if (item.projectId) return !!projectId && item.projectId === projectId;
  if (!projectName || !item.payload || item.payload.projectName !== projectName) return false;
  const queuedAt = _whenOf(item.queued_at);
  const createdAt = _whenOf(jobCreatedAt);
  return !!queuedAt && !!createdAt && createdAt <= queuedAt;
};
// The client id that dedupes a queued survey. A write queued before
// SEND-STATE-V1 has none, so it is derived from what never changes on it
// (when it was queued, and the survey's name).
const wrapClientId = (item) => {
  if (!item) return '';
  if (item.client_id) return String(item.client_id);
  return 'q:' + String(item.queued_at || '') + ':' + String((item.payload && item.payload.projectName) || '');
};
// The job's survey as the portal would get it, as a short print, so the phone
// can tell when a queued copy no longer matches the job (an edit after the
// send was queued). It covers what the surveyor captures and the wire
// carries: the name, client and binding, every fitting line (area, type,
// size, quantities, extras, wattages, its photo ids), every photo's id, area,
// label and note, and the note bodies the send would read (the draft's, when
// the draft is this job's). Not urls or upload flags (an upload landing is not
// an edit), not done marks or timestamps (not on the wire).
const _printJson = (v) => {
  if (Array.isArray(v)) return '[' + v.map(_printJson).join(',') + ']';
  if (v && typeof v === 'object') return '{' + Object.keys(v).sort().filter((k) => v[k] !== undefined).map((k) => JSON.stringify(k) + ':' + _printJson(v[k])).join(',') + '}';
  return JSON.stringify(v === undefined ? null : v);
};
const _printHash = (s) => {
  let h1 = 0x811c9dc5; let h2 = 0x01000193 ^ s.length;
  for (let i = 0; i < s.length; i++) {
    const ch = s.charCodeAt(i);
    h1 = Math.imul(h1 ^ ch, 16777619);
    h2 = Math.imul(h2 ^ ch, 2246822519);
  }
  return (h1 >>> 0).toString(16) + '.' + (h2 >>> 0).toString(16) + '.' + s.length;
};
const wrapJobPrint = (project, draft) => {
  if (!project || typeof project !== 'object') return '';
  const lines = (Array.isArray(project.surveyZones) ? project.surveyZones : []).filter(Boolean).map((z) => {
    const u = z.unit || {};
    const ex = {};
    Object.keys(z.extras || {}).sort().forEach((k) => { const v = z.extras[k]; if (v !== undefined && v !== null && v !== '') ex[k] = v; });
    return _printJson([String(z.zone || ''), String(u.id || ''), String(u.label || ''), String(z.primary || ''), String(z.secondary || ''),
      Number(z.qty) || 0, Number(z.emQty) || 0, ex, Number(u.wattage) || 0, Number(u.replacementW) || 0,
      (Array.isArray(z.photos) ? z.photos : []).map((p) => String((p && p.id) || ''))]);
  }).sort();
  const photos = (Array.isArray(project.sitePhotos) ? project.sitePhotos : []).filter(Boolean)
    .map((p) => _printJson([String(p.id || ''), String(p.zone || ''), String(p.label || ''), String(p.note || ''), String(p.type || 'photo')])).sort();
  const notes = flattenZoneNotesForPayload(resolveZoneNotesForPayload(draft || null, project));
  const b = getProjectBinding(project);
  return _printHash(_printJson({ n: String(project.name || ''), c: String(project.client || ''), b: (b && b.project_id) || null, l: lines, p: photos, z: notes }));
};
// Two builds of one survey are the same survey when they differ only in when
// they were built (completedAt).
const wrapPayloadSame = (a, b) => {
  if (!a || !b || typeof a !== 'object' || typeof b !== 'object') return false;
  const strip = (p) => { const { completedAt, ...rest } = p; return JSON.stringify(rest); };
  return strip(a) === strip(b);
};
// SEND-TIMEOUT-V1: the one of the portal's surveys for a job (`existing`, as
// /api/companion/survey-conflict and a 409 intent_required list them) that is
// this very survey, or null. The portal stores a survey's completedAt as its
// row's submitted_at (sanitised: trimmed, cut to 50 characters, HTML-escaped,
// none of which changes an ISO time), and the phone stamps completedAt to the
// millisecond when it builds a survey, so a row with the same time is this
// build, sent before and taken although no answer reached the phone. A survey
// without a completedAt matches nothing. Pure.
const wrapLandedRow = (payload, existing) => {
  const at = payload && typeof payload.completedAt === 'string' ? payload.completedAt.trim() : '';
  if (!at || !Array.isArray(existing)) return null;
  return existing.find((r) => !!r && typeof r.submitted_at === 'string' && r.submitted_at.trim() === at) || null;
};
// Why a queued survey has not gone yet, from its last error and the phone.
//   signin       the portal refused the sign-in (the queue holds until a new one)
//   offline      no connection (or the request never got through, and the
//                phone's connection is not known)
//   unreachable  the phone says it is online, but the request never got an
//                answer (a timeout, "Failed to fetch"): the portal could not
//                be reached, which is not the same as no connection
//   refused      the portal answered, and not with a yes
//   later        queued and not tried yet, with a connection
const sendWhy = (lastError, ctx) => {
  const c = ctx || {};
  if (c.signInNeeded) return 'signin';
  if (c.online === false) return 'offline';
  const e = String(lastError || '');
  if (/^HTTP \d+/.test(e)) return 'refused';
  if (e) return c.online === true ? 'unreachable' : 'offline';
  return 'later';
};
// The notes a sent survey left out. A voice note not yet transcribed has no
// body, so it never goes on the wire (flattenZoneNotesForPayload drops it, by
// design). When a job is marked sent it keeps the ids of the notes still
// pending then (_unsentNoteIds, beside wrapSentFields); once one of them is
// transcribed, the job has a change the portal does not have, the same as any
// edit. Pure.
const wrapPendingNoteIds = (zoneNotes) => {
  const ids = [];
  if (zoneNotes && typeof zoneNotes === 'object' && !Array.isArray(zoneNotes)) {
    Object.keys(zoneNotes).forEach((k) => {
      const v = zoneNotes[k];
      if (Array.isArray(v)) v.forEach((n) => { const id = n && (n.id || n.audioRef); if (n && n.pending === true && id) ids.push(String(id)); });
    });
  }
  return ids;
};
// The field a job gets when it is marked sent: the ids of the notes the send
// left out, or undefined (no field) when it left none out.
const wrapUnsentNotesField = (zoneNotes) => {
  const ids = wrapPendingNoteIds(zoneNotes);
  return { _unsentNoteIds: ids.length ? ids : undefined };
};
// The notes the sent print was taken from, written onto the job in the same
// update that stamps it sent (COMPANION-FOLLOWUPS-V2 item 2, #121 review note 1).
// A note is saved to the draft at once and to the job a frame later; an app
// killed in between leaves the draft ahead of the job. A send from that draft
// prints the draft's notes, and the draft is cleared once the job is sent, so
// without this the job would later print without them and read Changes not
// sent after a real send. Only when the draft is this job's (else the print
// read the job's own notes and there is nothing to carry). Pure.
const wrapSentNotesField = (draft, project) => {
  const pid = project && project.id;
  if (draft && pid && draft.projectId === pid && draft.zoneNotes && typeof draft.zoneNotes === 'object' && !Array.isArray(draft.zoneNotes)) {
    return { zoneNotes: draft.zoneNotes };
  }
  return {};
};
// How many survey lines carry no fitting type: no unit.id and no unit.label
// (COMPANION-FOLLOWUPS-V2 item 5). Such a line reaches the portal as a bare
// "Fitting"; 185 Fleet Street (20 Oct 2026) sent all 20 lines that way through
// the RESUME-KEEPS-TYPE bug fixed in #104, and nothing said so. Check and send
// records a health report when this is above 0 and sends as before. Pure.
const wrapUntypedLineCount = (zones) => {
  if (!Array.isArray(zones)) return 0;
  return zones.filter((z) => {
    if (!z || typeof z !== 'object') return false;
    const u = z.unit && typeof z.unit === 'object' ? z.unit : {};
    const has = (v) => v != null && String(v).trim() !== '';
    return !has(u.id) && !has(u.label);
  }).length;
};
// True when a note the sent survey left out now has a body.
const wrapLeftOutNoteLanded = (unsentIds, zoneNotes) => {
  if (!Array.isArray(unsentIds) || !unsentIds.length || !zoneNotes || typeof zoneNotes !== 'object') return false;
  const want = new Set(unsentIds.map(String));
  return Object.keys(zoneNotes).some((k) => Array.isArray(zoneNotes[k]) && zoneNotes[k].some((n) => {
    const id = n && (n.id || n.audioRef);
    return !!id && want.has(String(id)) && n.pending !== true && String(n.body || '').trim() !== '';
  }));
};
// ctx: { queue, parked, delivered (this person's delivery records), jobPrint
// (wrapJobPrint of the job as it is now), notes (the notes the send would read
// now; the job's own when absent), sending, inFlight, online, signInNeeded }.
const surveySendState = (project, ctx) => {
  const c = ctx || {};
  if (!project || typeof project !== 'object') return { state: 'not_sent' };
  if (c.sending || c.inFlight) return { state: 'sending' };
  const delivered = (Array.isArray(c.delivered) ? c.delivered : []).filter(Boolean);
  const deliveredIds = new Set(delivered.map((r) => r.client_id));
  // A copy already delivered is not waiting, whatever is left in the queue.
  const mine = (it) => wrapQueueMatches(it, project.id, project.name, project.createdAt) && !deliveredIds.has(wrapClientId(it));
  // Changed: the job is no longer what was queued, so the copy is held (the
  // queue never sends it) until Check and send builds it again.
  const changed = (it) => !!(it.jobPrint && c.jobPrint && it.jobPrint !== c.jobPrint);
  const whyOf = (it, cc) => (it.conflict ? 'conflict' : changed(it) ? 'changed' : sendWhy(it.last_error, cc));
  // A copy in the queue comes first: a sent job sent again (S106 Update or New
  // visit) and refused is waiting again, not sent.
  const parked = (Array.isArray(c.parked) ? c.parked : []).filter(mine);
  if (parked.length) {
    const p = parked[parked.length - 1];
    return { state: 'failed', why: whyOf(p, { online: true }), reason: p.last_error || null, at: p.parked_at || null };
  }
  const queued = (Array.isArray(c.queue) ? c.queue : []).filter(mine);
  if (queued.length) {
    const q = queued[queued.length - 1];
    return { state: 'waiting', why: whyOf(q, c), reason: q.last_error || null, at: q.queued_at || null, attempts: q.attempts || 0 };
  }
  if (project.surveyWrapCompletedAt) {
    // A voice note the sent survey left out (not transcribed when it went),
    // transcribed since: the portal has an earlier copy, and the job has
    // changes not sent, as after any edit.
    if (wrapLeftOutNoteLanded(project._unsentNoteIds, c.notes !== undefined ? c.notes : project.zoneNotes)) {
      return { state: 'not_sent', earlier: project.surveyWrapCompletedAt };
    }
    // Changed since it was sent (a voice note recorded and transcribed after
    // the send, a fitting added): the portal has an earlier copy. A job sent
    // before the print was kept has none, and reads as before.
    if (project._sentJobPrint && c.jobPrint && project._sentJobPrint !== c.jobPrint) {
      return { state: 'not_sent', earlier: project.surveyWrapCompletedAt };
    }
    return { state: 'sent', at: project.surveyWrapCompletedAt };
  }
  // Delivered by the queue and not yet stamped on the job (the App stamps it
  // when it hears): still sent, as long as the job is still what was
  // delivered. Changed since, the changes have not gone: not sent, with the
  // earlier copy named. Matched by job id only; a name can belong to a later
  // job.
  const del = delivered.filter((r) => r.projectId && r.projectId === project.id);
  if (del.length) {
    const r = del[del.length - 1];
    if (!r.jobPrint || !c.jobPrint || r.jobPrint === c.jobPrint) return { state: 'sent', at: r.at || null };
    return { state: 'not_sent', earlier: r.at || null };
  }
  return { state: 'not_sent' };
};
const _SEND_MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
// "10 Jun at 10:30", with the year when it is not this year; '' when unusable.
const sendWhenWords = (ts, now) => {
  if (!ts) return '';
  const d = new Date(ts);
  if (isNaN(d.getTime())) return '';
  const n = now ? new Date(now) : new Date();
  const hhmm = ('0' + d.getHours()).slice(-2) + ':' + ('0' + d.getMinutes()).slice(-2);
  return `${d.getDate()} ${_SEND_MONTHS[d.getMonth()]}${d.getFullYear() === n.getFullYear() ? '' : ' ' + d.getFullYear()} at ${hhmm}`;
};
// { title, line, short, act }: the title and full line for Check and send and
// the job front page, a short line for a list row, and the action (or null).
const sendStateWords = (st, now) => {
  const s = (st && st.state) || 'not_sent';
  if (s === 'sending') return { title: 'Sending', line: 'Sending it to the portal now.', short: 'Going to the portal now.', act: null };
  if (s === 'sent') {
    const when = sendWhenWords(st.at, now);
    return { title: 'Sent', line: when ? `The portal has it. Sent ${when}.` : 'The portal has it.', short: when ? `Sent ${when}.` : 'Sent.', act: null };
  }
  // Changed after it was queued, or the portal already holds a survey for the
  // job: only Check and send can build or route it again, so that is the act.
  const changedLine = 'You’ve changed it since it was queued, so the queued copy won’t go. Send it again from Check and send. Nothing is lost.';
  const conflictLine = 'The portal already has a survey for this job. Choose on Check and send whether this one updates it or is a new visit. Nothing is lost.';
  if (s === 'waiting') {
    if (st.why === 'changed') return { title: 'Waiting to send', line: changedLine, short: 'Changed since it was queued. Send it again.', act: 'Check and send' };
    if (st.why === 'conflict') return { title: 'Waiting to send', line: conflictLine, short: 'The portal already has one. Choose how to send it.', act: 'Check and send' };
    if (st.why === 'signin') return { title: 'Waiting to send', line: 'Sign in again and it will go. It’s saved on this phone, so nothing is lost.', short: 'Sign in again and it will go.', act: null };
    if (st.why === 'refused') return { title: 'Waiting to send', line: 'The portal didn’t take it. It’s saved on this phone and will go when it can. Nothing is lost.', short: 'The portal didn’t take it yet.', act: 'Try now' };
    if (st.why === 'offline') return { title: 'Waiting to send', line: 'No connection. It’s saved on this phone and will go when it can. Nothing is lost.', short: 'No connection yet.', act: 'Try now' };
    if (st.why === 'unreachable') return { title: 'Waiting to send', line: 'The portal couldn’t be reached. It’s saved on this phone and will go when it can. Nothing is lost.', short: 'The portal couldn’t be reached yet.', act: 'Try now' };
    return { title: 'Waiting to send', line: 'It’s saved on this phone and will go when it can. Nothing is lost.', short: 'It’ll go shortly.', act: 'Try now' };
  }
  if (s === 'failed') {
    if (st.why === 'changed') return { title: 'Send failed', line: changedLine, short: 'Changed since it was queued. Send it again.', act: 'Check and send' };
    if (st.why === 'conflict') return { title: 'Send failed', line: conflictLine, short: 'The portal already has one. Choose how to send it.', act: 'Check and send' };
    const lead = st.why === 'refused' ? 'The portal didn’t take it after several tries.' : 'It couldn’t get through after several tries.';
    return { title: 'Send failed', line: `${lead} It’s still saved on this phone, so nothing is lost. Try again, and if it still won’t go, tell the office.`, short: 'It didn’t go after several tries.', act: 'Try again' };
  }
  if (st && st.earlier) {
    const when = sendWhenWords(st.earlier, now);
    return { title: 'Changes not sent', line: `The portal has an earlier copy${when ? `, sent ${when}` : ''}. You’ve changed the job since, and those changes are only on this phone. Send it again to update the portal.`, short: 'Changes not sent yet.', act: null };
  }
  return { title: 'Not sent', line: 'Not sent yet. It stays on this phone until you send it.', short: 'Not sent yet.', act: null };
};
// Waiting, failed or going now: the survey has a copy on its way, so the job
// shows that copy's state (and its Try now) where it would offer Carry on,
// and Check and send offers no plain Send (its Try again builds it again).
// A sent job is not blocked: it can be sent again through the S106 choice.
const sendStateBlocksSend = (st) => !!st && (st.state === 'waiting' || st.state === 'failed' || st.state === 'sending');
// The act needs Check and send (build again, or choose how to send).
const sendStateNeedsWrap = (st) => !!st && (st.why === 'changed' || st.why === 'conflict');
// The fields a sent survey gets on its project, whether the portal took it at
// once or later from the queue (one shape, so the two can never drift).
// jobPrint: the print of the job as it was sent (wrapJobPrint), so a change
// made after the send reads as Changes not sent once the job is stamped sent,
// exactly as it does before the stamp (the delivery record's print).
const wrapSentFields = (summary, iso, jobPrint) => {
  const s = summary || {};
  return {
    status: 'submitted',
    submitted_at: iso,
    surveyWrapCompletedAt: iso,
    stage: 'surveyed',
    _portalSurveyId: s.surveyId || undefined,
    _portalBound: s.bound === true,
    _portalBoundProjectId: s.boundProjectId || undefined,
    _sentJobPrint: jobPrint || undefined,
  };
};
// Which job a delivery record marks sent, or why none: { id, why }.
//   rec       a record from the queue (lumenWrapDelivered, lumen_wrap_delivered_<user>)
//   projects  the jobs on the phone now
//   draft     the survey draft (its notes count for its own job)
//   live      true for a delivery this session's queue made (_wrapHeard), false
//             for the replay at start
// A record names its job by id, and marks it only while the job is still the
// survey that was delivered (its print matches): changed since, the job stays
// live with its changes waiting to send, and its draft is kept. A record with
// no job id (a copy queued before SEND-STATE-V1) is never used on a replay;
// on the live event it marks the one unsent job of that name that existed
// when it was queued and has not changed since, and nothing when that is not
// exactly one job. Pure.
const wrapDeliveryTarget = (rec, projects, draft, live) => {
  if (!rec || !rec.client_id || rec.stub) return { id: null, why: 'no_record' };
  const list = (Array.isArray(projects) ? projects : []).filter(Boolean);
  const recAt = _whenOf(rec.at);
  const queuedAt = _whenOf(rec.queued_at);
  if (rec.projectId) {
    const p = list.find((x) => x.id === rec.projectId);
    if (!p) return { id: null, why: 'no_job' };
    if (p.surveyWrapCompletedAt && _whenOf(p.surveyWrapCompletedAt) >= recAt) return { id: null, why: 'already_sent' };
    if (rec.jobPrint) {
      const now = wrapJobPrint(p, draft && draft.projectId === p.id ? draft : null);
      if (now !== rec.jobPrint) return { id: null, why: 'changed' };
      return { id: p.id, why: 'ok' };
    }
    // No print to compare: only the live event, and only a job untouched
    // since the copy was queued.
    if (!live || !queuedAt || _whenOf(p.updatedAt) > queuedAt) return { id: null, why: 'cannot_tell' };
    return { id: p.id, why: 'ok' };
  }
  if (!live) return { id: null, why: 'name_only_replay' };
  if (!rec.projectName) return { id: null, why: 'no_job' };
  const cands = list.filter((p) => p.name === rec.projectName && !p.surveyWrapCompletedAt
    && (!queuedAt || !p.createdAt || _whenOf(p.createdAt) <= queuedAt));
  if (cands.length !== 1) return { id: null, why: cands.length ? 'ambiguous' : 'no_job' };
  if (!queuedAt || _whenOf(cands[0].updatedAt) > queuedAt) return { id: null, why: 'changed' };
  return { id: cands[0].id, why: 'ok' };
};
// ==== SEND_STATE_LOGIC_END ==============================================

// The survey ids this phone's queue has delivered, so the queue never sends the
// same survey twice (a write left in the queue by a crash between the portal's
// yes and the queue write, or a copy merged back in by _addedSince, is dropped
// instead). Capped; newest kept. One list per person on the phone
// (lumen_wrap_delivered_<user id>), so one person's deliveries never mark
// another's jobs. A record names its job by id; a survey queued before
// SEND-STATE-V1 has no job id, so its record carries the survey's name only
// until the App has judged it once against the person's jobs (see
// wrapDeliveryTarget and _wrapHeard), and is then cut down to its client id,
// kept for the dedupe alone.
// The offline queue is one list for everyone on the phone, so a survey can be
// delivered while someone else is signed in. A queued survey carries the id of
// the person who queued it (userId), and its delivery is recorded in THAT
// person's list (uid), so their job is marked sent when they are next signed
// in. No uid: the person signed in now.
const wrapDeliveredKey = (uid) => 'lumen_wrap_delivered_' + (uid || currentLocalUserId() || 'nobody');
const _WRAP_DELIVERED_CAP = 100;
const _readWrapDelivered = (uid) => {
  try {
    const arr = JSON.parse(localStorage.getItem(wrapDeliveredKey(uid)) || '[]');
    return Array.isArray(arr) ? arr : [];
  } catch (e) { return []; }
};
const _wrapWasDelivered = (cid, uid) => !!cid && _readWrapDelivered(uid).some(r => r && r.client_id === cid);
const _writeWrapDelivered = (all, uid) => {
  localStorage.setItem(wrapDeliveredKey(uid), JSON.stringify(all.slice(-_WRAP_DELIVERED_CAP)));
};
const _recordWrapDelivered = (rec, uid) => {
  try {
    const all = _readWrapDelivered(uid).filter(r => r && r.client_id !== rec.client_id);
    all.push(rec);
    _writeWrapDelivered(all, uid);
    return true;
  } catch (e) {
    // Loud: without the record a crash before the queue write could send it
    // again. The event below still marks the job sent.
    try { console.error('[send-state] could not record a delivered survey', e); debugLog('wrap.delivered.record_failed', { client_id: rec.client_id, error: String(e && e.name || e) }); } catch (e2) {}
    return false;
  }
};
// A record with no job id, once heard: cut down to its client id (the dedupe
// still needs it), so the survey's name can never mark a job later.
const _stubWrapDelivered = (cid) => {
  try {
    const all = _readWrapDelivered();
    let changed = false;
    const next = all.map((r) => {
      if (!r || r.client_id !== cid || r.projectId || r.stub) return r;
      changed = true;
      return { client_id: r.client_id, at: r.at || null, stub: true };
    });
    if (changed) _writeWrapDelivered(next);
  } catch (e) { try { debugLog('wrap.delivered.stub_failed', { client_id: cid, error: String(e && e.name || e) }); } catch (e2) {} }
};
// The deliveries this session's queue has made, each waiting to be judged once
// by the App, as heard live, against the jobs of the person it is recorded for
// (who). Memory only: a restart empties it, so a stored record is only ever
// replayed. The start and sign-in set the person's jobs and start the flush in
// the same moment, so a delivery can land before React has drawn the jobs.
// Judged then, it found no job, and a record with no job id lost its name with
// its job never marked sent although the portal had it (J10 on WebKit). It
// waits here until the jobs are drawn. A delivery for nobody (no person on the
// copy, nobody signed in) waits for nobody: nothing is marked for it.
const _wrapHeard = [];
const _wrapHeardAdd = (rec, who) => { if (rec && rec.client_id && who) _wrapHeard.push({ rec, who: String(who) }); };
// Removes and returns, oldest first, the deliveries waiting for this person.
const _wrapHeardTake = (who) => {
  const mine = [];
  for (let i = 0; i < _wrapHeard.length;) {
    if (_wrapHeard[i].who === who) mine.push(_wrapHeard.splice(i, 1)[0].rec);
    else i += 1;
  }
  return mine;
};
// Jobs whose survey is in flight right now (memory only): from the queue
// (_wrapInFlight) or straight from Check and send (_wrapDirect, which the
// queue also leaves alone while it lasts).
const _wrapInFlight = new Set();
const _wrapDirect = new Set();
const _wrapFlightKey = (projectId, projectName) => projectId ? 'id:' + projectId : 'name:' + (projectName || '');
function _sendStateChanged() {
  try { window.dispatchEvent(new CustomEvent('lumenSendStateChanged')); } catch (e) {}
}
// The survey draft, parsed, or null.
const _readDraft = () => {
  try { return JSON.parse(localStorage.getItem('survey_active') || 'null'); } catch (e) { return null; }
};
// The print of a job as it is stored on the phone now (its row, and the draft
// when the draft is this job's), or null when the row cannot be read. ownerId:
// the person whose job it is (a queued survey's userId); the person signed in
// when absent.
const _storedJobPrint = (projectId, ownerId) => {
  try {
    const uid = ownerId || currentLocalUserId();
    if (!uid || !projectId) return null;
    const rows = JSON.parse(localStorage.getItem('asg_projects_' + uid) || '[]');
    const p = Array.isArray(rows) ? rows.find((r) => r && r.id === projectId) : null;
    if (!p) return null;
    const d = _readDraft();
    return wrapJobPrint(p, d && d.projectId === projectId ? d : null);
  } catch (e) { return null; }
};
// The job's send state as this phone holds it now. opts.sending: the caller's
// own send is in flight.
const readSendState = (project, opts) => {
  if (!project) return { state: 'not_sent' };
  let online = true;
  try { online = !(typeof navigator !== 'undefined' && navigator.onLine === false); } catch (e) {}
  let signIn = false;
  try { signIn = signInAgainNeeded(); } catch (e) {}
  const d = _readDraft();
  const own = d && d.projectId === project.id ? d : null;
  const queue = getPortalData(OFFLINE_QUEUE_KEY, []);
  const parked = _readParkedWrites();
  // A copy queued before job ids goes under the survey's name (its flight
  // key). It is this job's only when it matches this job (wrapQueueMatches),
  // so a later job with the same name never reads as going because of it.
  const ownNamed = queue.concat(parked).some((it) => !!it && !it.projectId && wrapQueueMatches(it, project.id, project.name, project.createdAt));
  const keys = [_wrapFlightKey(project.id, null)].concat(ownNamed ? [_wrapFlightKey(null, project.name)] : []);
  return surveySendState(project, {
    queue,
    parked,
    delivered: _readWrapDelivered(),
    jobPrint: wrapJobPrint(project, own),
    notes: resolveZoneNotesForPayload(own, project),
    sending: !!(opts && opts.sending),
    inFlight: keys.some((k) => _wrapInFlight.has(k) || _wrapDirect.has(k)),
    online, signInNeeded: signIn,
  });
};
// The job's latest queued or parked copy (the one its state reads), or null.
const wrapCopyOf = (project) => {
  if (!project) return null;
  const delivered = new Set(_readWrapDelivered().map((r) => r && r.client_id));
  const mine = (it) => wrapQueueMatches(it, project.id, project.name, project.createdAt) && !delivered.has(wrapClientId(it));
  const parked = _readParkedWrites().filter(mine);
  if (parked.length) return { item: parked[parked.length - 1], where: 'parked' };
  const queued = getPortalData(OFFLINE_QUEUE_KEY, []).filter(mine);
  if (queued.length) return { item: queued[queued.length - 1], where: 'queue' };
  return null;
};
// Every queued and parked copy of the job goes: Check and send has just
// delivered the job as it is now, which supersedes them. Logged. A name-only
// copy goes only when it is this job's (wrapQueueMatches, jobCreatedAt).
const dropWrapCopies = (projectId, projectName, jobCreatedAt) => {
  const mine = (it) => wrapQueueMatches(it, projectId, projectName, jobCreatedAt);
  try {
    const q = getPortalData(OFFLINE_QUEUE_KEY, []);
    const qn = q.filter((it) => !mine(it));
    if (qn.length !== q.length) localStorage.setItem(OFFLINE_QUEUE_KEY, JSON.stringify(qn));
    const p = _readParkedWrites();
    const pn = p.filter((it) => !mine(it));
    if (pn.length !== p.length) _writeParkedWrites(pn);
    if (qn.length !== q.length || pn.length !== p.length) debugLog('wrap.copies.superseded', { projectId: projectId || null, queued: q.length - qn.length, parked: p.length - pn.length });
  } catch (e) { try { console.error('[send-state] could not clear a superseded queued survey', e); debugLog('wrap.copies.clear_failed', { projectId: projectId || null, error: String(e && e.name || e) }); } catch (e2) {} }
  _sendStateChanged();
};

// A screen that shows a send state re-reads it when anything that changes it
// happens: the queue, a delivery, the connection.
const useSendStateTick = () => {
  const [, setTick] = useState(0);
  useEffect(() => {
    const bump = () => setTick(n => n + 1);
    const evs = ['lumenSendStateChanged', 'lumenWrapDelivered', 'online', 'offline'];
    evs.forEach(ev => window.addEventListener(ev, bump));
    return () => evs.forEach(ev => window.removeEventListener(ev, bump));
  }, []);
};

// Queue a write for replay. For a survey wrap, meta carries the job it belongs
// to ({ projectId, last_error, jobPrint, client_id }): the job then shows
// Waiting to send, and the phone holds at most one copy per job. A new copy
// replaces the job's queued and parked ones. It keeps the old copy's client id
// (and its exact payload) only when it is the same survey (wrapPayloadSame);
// a different survey gets a fresh client id, so it is never mistaken for the
// copy already delivered. meta.client_id, when given, is the id to use.
// meta.jobCreatedAt (the job's createdAt) lets it replace a copy queued before
// job ids only when that copy is this job's (wrapQueueMatches); it is not
// stored. The copy carries the id of the person queuing it (userId), so its
// delivery is recorded for them whoever is signed in when it goes.
// Returns false, loudly, when the phone could not store it.
const queueWrite = (endpoint, payload, meta) => {
  const queue = getPortalData(OFFLINE_QUEUE_KEY, []);
  const item = { endpoint, payload, queued_at: new Date().toISOString(), attempts: 0 };
  let parkedLeft = null;
  if (endpoint === WRAP_ENDPOINT && meta && typeof meta === 'object') {
    const pid = meta.projectId || null;
    const pname = (payload && payload.projectName) || null;
    const created = meta.jobCreatedAt || null;
    if (pid) item.projectId = pid;
    if (meta.last_error) item.last_error = String(meta.last_error);
    if (meta.jobPrint) item.jobPrint = String(meta.jobPrint);
    const uid = currentLocalUserId();
    if (uid) item.userId = uid;
    const parked = _readParkedWrites();
    const priors = queue.filter(q => wrapQueueMatches(q, pid, pname, created)).concat(parked.filter(q => wrapQueueMatches(q, pid, pname, created)));
    const prior = priors.length ? priors[priors.length - 1] : null;
    if (meta.client_id) item.client_id = String(meta.client_id);
    else if (prior && wrapPayloadSame(prior.payload, payload)) { item.client_id = wrapClientId(prior); item.payload = prior.payload; }
    else item.client_id = _genClientEventId();
    if (priors.length) {
      try { debugLog('wrap.queue.replaced', { projectId: pid, client_id: item.client_id, same: !!(prior && item.client_id === wrapClientId(prior)), replaced: priors.length }); } catch (e) {}
      for (let i = queue.length - 1; i >= 0; i--) if (wrapQueueMatches(queue[i], pid, pname, created)) queue.splice(i, 1);
      parkedLeft = parked.filter(q => !wrapQueueMatches(q, pid, pname, created));
      if (parkedLeft.length === parked.length) parkedLeft = null;
    }
  }
  queue.push(item);
  let ok = true;
  try { localStorage.setItem(OFFLINE_QUEUE_KEY, JSON.stringify(queue)); } catch(e) {
    ok = false;
    try { console.error('[offline-queue] the phone could not store a write for later', endpoint, e); debugLog('offline.queue.write_refused', { endpoint, error: String(e && e.name || e) }); } catch (e2) {}
  }
  // The parked copy goes only once the new one is safely queued.
  if (ok && parkedLeft) _writeParkedWrites(parkedLeft);
  // Only a survey changes a send state: any other write leaves the screens
  // (and the App) alone.
  if (endpoint === WRAP_ENDPOINT) _sendStateChanged();
  return ok;
};

// The entries of `current` that are not in `snapshot` (compared by value,
// duplicates counted): what another writer added to a queue while a flush,
// which read `snapshot` at its start, was awaiting the network. Every other
// writer only appends (queueWrite, retryParkedWrites, the add-to-retry-queue
// helpers), and each flush is single-flight, so a flush that writes its
// leftovers plus these loses nothing (SECURITY-WAVE-1 track C review: a
// fresh sign-in un-parks writes while the login's own flush may be running).
const _addedSince = (snapshot, current) => {
  const seen = new Map();
  snapshot.forEach((i) => { const k = JSON.stringify(i); seen.set(k, (seen.get(k) || 0) + 1); });
  return (Array.isArray(current) ? current : []).filter((i) => {
    const k = JSON.stringify(i);
    const n = seen.get(k) || 0;
    if (n > 0) { seen.set(k, n - 1); return false; }
    return true;
  });
};

// Single-flight: a second flush while one is awaiting the network would send
// every entry twice (and, with the merge above, keep a copy of each). Because
// of that, every replay fetch has a timeout (_OFFLINE_REPLAY_TIMEOUT_MS, the
// photo and voice uploads' 30 s): one request that never settles would
// otherwise stall every later flush until the app is reloaded. A timeout is an
// ordinary failure (an attempt spent, as for a network error), never a
// refused sign-in.
const _OFFLINE_REPLAY_TIMEOUT_MS = 30000;
// SEND-TIMEOUT-V1 (#112 note 4): how long one survey send waits for the
// portal, the post and the reading of its answer, before it counts as not
// answered, whether Check and send or the queue sends it (the same survey gets
// the same time either way). The photos go first, each on its own upload with
// its own 30 s, so this carries the survey alone: about 0.3 KB a fitting line
// (the golden payload, tests/fixtures/wrap_send_uploaded.json, is 1.5 KB for
// two lines), so a big job of 300 lines with its notes and photo references is
// 150 to 250 KB. On a poor signal, an uplink of 40 to 64 kbit/s (the floor the
// photo uploads' 30 s already assume for one 150 KB photo), that is 20 to 50 s,
// plus the connection's set-up and the portal's own work. A minute covers it,
// and a minute is about as long as a surveyor will watch "Sending" before
// taking the app to have hung. A send that runs out is not lost: it is queued
// exactly as an offline one is, and the job says so.
const _WRAP_SEND_TIMEOUT_MS = 60000;
// SEND-TIMEOUT-V1: the S106 check before Check and send posts, a short GET for
// the portal's surveys of the job. It fails open, as on a network error (the
// post's own 409 is the safety net), so it needs only long enough for a small
// answer on a poor signal; any longer and a dead link would hold "Sending" for
// this as well as for the post's minute.
const _WRAP_CHECK_TIMEOUT_MS = 15000;
// SEND-TIMEOUT-V1: one exchange with the portal under a deadline, the request
// and the reading of its answer. within(p) settles as p does, or fails with
// Error('timeout') once the deadline passes, and the request is then cancelled
// through `signal`. A late answer is never seen: the await that raced it has
// already moved on, so it cannot mark, queue or record anything a second time.
// done() stops the clock.
const _portalDeadline = (ms) => {
  const controller = typeof AbortController === 'function' ? new AbortController() : null;
  let timer = null;
  const expired = new Promise((resolve, reject) => {
    timer = setTimeout(() => {
      // The deadline's own failure first, then the cancel, so a race that both
      // settle fails with 'timeout', the queue's word for it.
      reject(new Error('timeout'));
      try { if (controller) controller.abort(); } catch (e) {}
    }, ms);
  });
  expired.catch(() => {});
  return {
    signal: controller ? controller.signal : undefined,
    within: (p) => Promise.race([p, expired]),
    done: () => clearTimeout(timer),
  };
};
// SEND-TIMEOUT-V1: a survey the portal holds although no answer reached the
// phone (a send that ran out of time, or whose answer was lost, can still
// have landed) is delivered: recorded for the person who queued it and
// announced, exactly as the queue records one the portal took, so the App
// marks its job sent only while the job is still that survey, and no copy of
// it ever goes again. `delivered` carries the portal's survey id; `via` names
// who found out, for the log. Returns the record.
const _noteWrapDelivered = (item, delivered, via) => {
  const cid = wrapClientId(item);
  // The record names the job by id, with the print of the job it was built
  // from (the App stamps the job only if it still matches). A copy queued
  // before SEND-STATE-V1 has no job id: its record carries the name and when
  // it was queued, for the App's one live look. Recorded for the person who
  // queued it (item.userId), whoever is signed in now; the App marks the job
  // only for that person.
  const rec = Object.assign({
    client_id: cid,
    projectId: item.projectId || null,
    ...(item.projectId ? {} : { projectName: (item.payload && item.payload.projectName) || null }),
    jobPrint: item.jobPrint || null,
    queued_at: item.queued_at || null,
    at: new Date().toISOString(),
    ...(item.userId ? { userId: item.userId } : {}),
  }, delivered);
  _recordWrapDelivered(rec, item.userId);
  // Heard (#116): the App judges it once, live, when that person's jobs are
  // drawn. Every delivery route comes through here, once per delivery, so
  // each is heard exactly once: the queue's (a 200, a 409 duplicate, a 409
  // naming this very survey, the portal already holding an Update or New
  // visit copy) and Check and send's (its S106 check finding its own copy).
  _wrapHeardAdd(rec, item.userId || currentLocalUserId());
  try { debugLog('wrap.queue.delivered', { client_id: cid, projectId: rec.projectId, surveyId: rec.surveyId, via: via || 'queue' }); } catch (e) {}
  try { window.dispatchEvent(new CustomEvent('lumenWrapDelivered', { detail: rec })); } catch (e) {}
  return rec;
};
// The intents the portal inserts a survey for even when it already holds one
// for the job (S106 Update, New visit). A copy carrying one is never posted
// again without first asking whether the portal holds it: posting it again
// would add a second visit, or a second copy over the first.
const _WRAP_INSERTING_INTENTS = ['update', 'new_visit'];
let _offlineFlushInFlight = false;
const flushOfflineQueue = async (opts = {}) => {
  if (_offlineFlushInFlight) return;
  _offlineFlushInFlight = true;
  try { await _flushOfflineQueueOnce(opts); } finally { _offlineFlushInFlight = false; }
};

const _flushOfflineQueueOnce = async (opts = {}) => {
  // A survey gets the time Check and send gives it (_WRAP_SEND_TIMEOUT_MS);
  // everything else the replay's 30 s. opts.timeoutMs, when given, is used
  // for every entry.
  const timeoutFor = (item) => opts.timeoutMs || (item && item.endpoint === WRAP_ENDPOINT ? _WRAP_SEND_TIMEOUT_MS : _OFFLINE_REPLAY_TIMEOUT_MS);
  const queue = getPortalData(OFFLINE_QUEUE_KEY, []);
  if (queue.length === 0) return;
  // SECURITY-WAVE-1 track C: hold, do not send, while the portal has refused
  // the sign-in and no new one exists (see C_SIGNIN_AGAIN_SEAM).
  if (signInAgainNeeded()) return;
  const remaining = [];
  const parked = [];
  let signInRefused = false;
  // SEND-STATE-V1: what became of each entry, index for index with `queue`:
  // undefined = it left the queue (sent, dropped or parked), otherwise the
  // entry to keep. Merged into the queue as it is when the flush ends (see
  // _mergeQueueAfterFlush), so an entry another writer removed or replaced
  // meanwhile (Check and send superseding a job's copy) stays removed.
  const outcomes = new Array(queue.length);
  const keep = (i, it) => { outcomes[i] = it; remaining.push(it); };
  // SEND-STATE-V1: survey ids sent in this flush, so a second copy of the same
  // survey later in the same queue is never sent either.
  const sentNow = new Set();
  for (let qi = 0; qi < queue.length; qi++) {
    const item = queue[qi];
    // Once the sign-in is refused, every later entry would be refused too:
    // keep them exactly as they are.
    if (signInRefused) { keep(qi, item); continue; }
    const isWrap = item.endpoint === WRAP_ENDPOINT;
    const cid = isWrap ? wrapClientId(item) : null;
    // SEND-STATE-V1: never the same survey twice. A survey this phone already
    // delivered is dropped from the queue, not sent again. It is recorded for
    // the person who queued it (item.userId); a delivery an earlier build
    // recorded for whoever was signed in is still found.
    if (isWrap && (sentNow.has(cid) || _wrapWasDelivered(cid, item.userId) || _wrapWasDelivered(cid))) {
      try { console.warn('[offline-queue] dropped a survey already delivered', cid); debugLog('wrap.queue.duplicate_dropped', { client_id: cid, projectId: item.projectId || null }); } catch (e) {}
      continue;
    }
    const flightKey = isWrap ? _wrapFlightKey(item.projectId || null, (item.payload && item.payload.projectName) || null) : null;
    // SEND-STATE-V1: Check and send is sending this job itself right now:
    // leave its copy alone (it is replaced or removed when that send ends).
    if (flightKey && _wrapDirect.has(flightKey)) { keep(qi, item); continue; }
    // SEND-STATE-V1: a copy the job has moved on from (edited after it was
    // queued) is held, not sent: the portal must get the job as it is, and
    // only Check and send can build that. No attempt is spent.
    if (isWrap && item.projectId && item.jobPrint) {
      const now = _storedJobPrint(item.projectId, item.userId);
      if (now && now !== item.jobPrint) {
        try { debugLog('wrap.queue.held_changed', { client_id: cid, projectId: item.projectId }); } catch (e) {}
        keep(qi, item);
        continue;
      }
    }
    const cap = _OFFLINE_ATTEMPT_CAP_BY_ENDPOINT[item.endpoint] || _OFFLINE_MAX_ATTEMPTS;
    // Entry already at/over cap (includes pre-S158 entries stranded at
    // attempts>=3 that the old code skipped forever): park, don't drop.
    if (item.attempts >= cap) { parked.push(_parkWrite(item)); continue; }
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), timeoutFor(item));
    // The portal's 409 intent_required: it already holds a survey for this
    // job, and this one can only go once someone chooses Update or New visit.
    let conflict = null;
    if (flightKey) { _wrapInFlight.add(flightKey); _sendStateChanged(); }
    try {
      const _qToken = localStorage.getItem('lumen_token');
      const _qAuth = _qToken ? { 'Authorization': `Bearer ${_qToken}` } : {};
      // SEND-STATE-V1: a survey the portal took is marked sent on the phone
      // exactly as an immediate send marks it (the App applies the record).
      // A 409 "duplicate" means the portal already holds it: the same.
      let delivered = null;
      // SEND-TIMEOUT-V1: a survey whose intent makes the portal insert it
      // whatever it holds (Update, New visit) is never posted again without
      // asking first: a send that got no answer can have landed. The portal
      // stores a survey's completedAt as its row's submitted_at, so a row with
      // this copy's time is this copy (wrapLandedRow), and it is delivered,
      // not sent again. No answer to the question is no answer at all: the
      // attempt fails, nothing is posted, and it is asked again next time.
      if (isWrap && item.payload && _WRAP_INSERTING_INTENTS.includes(item.payload.submit_intent)) {
        const cr = await fetch(`${PORTAL_URL}/api/companion/survey-conflict?project_name=${encodeURIComponent(item.payload.projectName || '')}`, { headers: _qAuth, signal: controller.signal });
        if (bearerRefused(cr.status, _qToken, 'queue survey check')) {
          signInRefused = true;
          keep(qi, { ...item, last_error: `HTTP ${cr.status}` });
          continue;
        }
        if (!cr.ok) throw new Error(`HTTP ${cr.status} survey check`);
        let cb = null;
        try { cb = typeof cr.json === 'function' ? await cr.json() : null; } catch (e) {
          if (e && e.name === 'AbortError') throw e;
          cb = null;
        }
        if (!cb || typeof cb !== 'object') throw new Error('survey check unreadable');
        const row = wrapLandedRow(item.payload, cb.existing);
        if (row) delivered = { surveyId: row.id || null, bound: false, boundProjectId: null };
      }
      const res = delivered ? null : await fetch(`${PORTAL_URL}${item.endpoint}`, {
        method: 'POST',
        headers: Object.assign({ 'Content-Type': 'application/json' }, _qAuth),
        body: JSON.stringify(item.payload),
        signal: controller.signal,
      });
      if (res && bearerRefused(res.status, _qToken, 'queue ' + item.endpoint)) {
        // A refusal of the sign-in says nothing about this entry: no attempt spent.
        signInRefused = true;
        keep(qi, { ...item, last_error: `HTTP ${res.status}` });
        continue;
      }
      if (!res) {
        // Delivered by the question above: nothing posted.
      } else if (isWrap && res.status === 409) {
        let b = {};
        try { b = (typeof res.json === 'function' ? await res.json() : {}) || {}; } catch (e) { b = {}; }
        // SEND-TIMEOUT-V1: the portal wants a choice because it already holds
        // a survey for the job. When one of the surveys it names is this very
        // copy (sent before, taken, the answer lost), the copy is delivered.
        const landed = b.reason === 'intent_required' ? wrapLandedRow(item.payload, b.existing) : null;
        if (b.reason === 'duplicate') delivered = { surveyId: b.existing_id || null, bound: false, boundProjectId: null };
        else if (landed) delivered = { surveyId: landed.id || null, bound: false, boundProjectId: null };
        else if (b.reason === 'intent_required') {
          conflict = { existing: Array.isArray(b.existing) ? b.existing : [] };
          throw new Error(`HTTP ${res.status} intent_required`);
        } else throw new Error(`HTTP ${res.status}`);
      } else if (!res.ok) {
        throw new Error(`HTTP ${res.status}`);
      } else if (isWrap) {
        let b = {};
        try { b = (typeof res.json === 'function' ? await res.json() : {}) || {}; } catch (e) { b = {}; }
        delivered = { surveyId: b.survey_id || null, bound: b.bound === true, boundProjectId: b.bound_project_id || null };
      }
      if (delivered) {
        sentNow.add(cid);
        _noteWrapDelivered(item, delivered, 'queue');
      }
    } catch (e) {
      const attempts = (item.attempts || 0) + 1;
      const lastError = (e && e.name === 'AbortError') ? 'timeout' : ((e && e.message) || String(e));
      const next = conflict ? { ...item, conflict } : item;
      // COMPANION-HEALTH-V1: a failed attempt is a fault; the portal asking
      // for Update or New visit is not (it is the flow working).
      if (!conflict) reportFault('send.attempt_failed', { error: lastError });
      if (attempts >= cap) parked.push(_parkWrite(next, lastError));
      else keep(qi, { ...next, attempts, last_error: lastError });
    } finally {
      clearTimeout(timer);
      if (flightKey) _wrapInFlight.delete(flightKey);
    }
  }
  if (parked.length) {
    _writeParkedWrites(_readParkedWrites().concat(parked));
    debugLog('offline.parked', { count: parked.length, endpoints: parked.map(p => p.endpoint) });
  }
  // Keep what was written while this flush awaited the network, and respect
  // what was removed or replaced meanwhile (see _mergeQueueAfterFlush).
  try { localStorage.setItem(OFFLINE_QUEUE_KEY, JSON.stringify(_mergeQueueAfterFlush(queue, outcomes, getPortalData(OFFLINE_QUEUE_KEY, [])))); } catch(e) {}
  // Only a flush that held a survey can have changed a send state.
  if (queue.some((it) => it && it.endpoint === WRAP_ENDPOINT)) _sendStateChanged();
};

// The queue after a flush: the queue as it is now, with each entry the flush
// read replaced by what became of it (outcomes[i]: undefined = it left, else
// the entry to keep). Entries are matched by value, duplicates counted, as
// _addedSince does. Anything added meanwhile stays (what _addedSince kept);
// an entry the flush read that is no longer there was removed or replaced by
// another writer meanwhile, and stays gone.
const _mergeQueueAfterFlush = (snapshot, outcomes, current) => {
  const pending = new Map();
  snapshot.forEach((it, i) => {
    const k = JSON.stringify(it);
    if (!pending.has(k)) pending.set(k, []);
    pending.get(k).push(outcomes[i]);
  });
  const out = [];
  (Array.isArray(current) ? current : []).forEach((it) => {
    const list = pending.get(JSON.stringify(it));
    if (list && list.length) { const o = list.shift(); if (o) out.push(o); }
    else out.push(it);
  });
  return out;
};

// SEND-STATE-V1: "Try now" / "Try again" for one job, away from Check and
// send. A parked survey goes back in the queue (attempts reset), then the
// queue is flushed. With no connection nothing is spent: it says so and
// waits for the phone to come back online, when the queue flushes by itself.
// A copy the job has changed since, or one the portal wants a choice for,
// cannot go from here: 'needs_wrap', and the caller opens Check and send.
// Returns 'needs_wrap', 'offline' or 'tried'.
const sendQueuedNow = async (project) => {
  if (!project) return 'none';
  if (sendStateNeedsWrap(readSendState(project))) return 'needs_wrap';
  retryParkedWrites({ only: (p) => wrapQueueMatches(p, project.id, project.name, project.createdAt) });
  let online = true;
  try { online = !(typeof navigator !== 'undefined' && navigator.onLine === false); } catch (e) {}
  if (!online) { _sendStateChanged(); return 'offline'; }
  try { await flushOfflineQueue(); } catch (e) {}
  _sendStateChanged();
  return 'tried';
};

// ─── S105 — Photo upload reliability ──────────────────────────────────────
// Pre-S105 photos sat as base64 in activeProject.sitePhotos until wrap
// submit, where they all fired concurrently via Promise.all → /api/photo.
// On Chelsea Harbour LTE, 16 of 20 photos vanished silently because the
// concurrent fetch storm overwhelmed iOS Safari's 6-connection limit and
// failed photos had no retry path. This block delivers the structural fix:
//   • debugLog            — forensic trail for every photo event
//   • _isB64 / _isPhotoPending — render-time pending detection
//   • _uploadPhotoOnce    — single fetch with 30s AbortController timeout
//   • addToPhotoRetryQueue / flushPhotoRetryQueue — exponential-backoff
//                            retry, 5 attempts, 7-day age cap, 200-entry cap
//   • uploadPhotoBatched  — replaces Promise.all storm at submit with
//                            3-concurrent batches
//   • _postPortalProcessUpdate — emits lumenPhotoUploaded events that the
//                            App-level handler turns into setProjects calls
//
// Capture flow now: handlePhotoFile compresses → adds to sitePhotos →
// fires _uploadPhotoOnce immediately. Success = src replaced with URL
// in-place; failure = entry added to retry queue, photo marked
// uploadFailed=true so the UI shows a red dot.

// ── COMPANION-HEALTH-V1: fault reports to the portal (the app half) ─────────
// Faults on a phone reach the portal without anyone having to notice them
// first. docs/HEALTH-CONTRACT.md is the wire contract; read it before changing
// anything here. The portal half (POST /api/companion/health) may not be live:
// until it answers 2xx every report stays on the phone, capped, and backs off.
//
// A REPORT CARRIES NO FREE TEXT (Andrew, 23 October 2026). It is a kind from a
// fixed list, an error code from a fixed list, where it happened (file and
// function, never a message), a count, the device, the build and timestamps.
// The text of an error is read only to pick its code, then dropped: it is
// never stored and never sent, so nothing a person typed, said, photographed
// or is called can reach the portal through a report. healthSanitiseReport
// rebuilds every report from those fields alone, each checked against a
// pattern, at capture and again at send. It is the backstop: a mistake
// anywhere else produces an empty field, never text.
//
// What is captured: uncaught errors and rejections, the #114 start failure
// screen (noted on the phone by index.html, sent by the next start that works),
// the send queue's failed attempts and parking (#112, #118), Check and send's
// own failure, the failure events debugLog already records (photo and voice
// uploads, storage refusals, camera, scan), and the service worker.
//
// Rules, each held by tests/health_report.test.js:
//   1. Never block, never delay a survey send, never throw. Every entry point is
//      wrapped; a broken store or network leaves the app as it would be without
//      this block. A flush waits while a survey is in flight.
//   2. Only the fixed fields leave the phone (healthSanitiseReport).
//   3. Only a 2xx removes a report. Anything else keeps it and backs off.
// No screen, no wording: nothing here is visible to the person using the app.

const HEALTH_ENDPOINT = '/api/companion/health';
const HEALTH_DB = 'lumen_health';
const HEALTH_STORE = 'faults';
const HEALTH_CAP = 50;
const HEALTH_BATCH = 20;
const HEALTH_TIMEOUT_MS = 10000;
const HEALTH_BACKOFF_KEY = 'lumen_health_backoff';
const HEALTH_BOOT_KEY = 'lumen_boot_fault';
const HEALTH_BACKOFF_BASE_MS = 60 * 1000;
const HEALTH_BACKOFF_MAX_MS = 6 * 60 * 60 * 1000;
// A stack and an error's text are cut to these before any pattern reads them,
// so a long blob cannot hold the screen up (review of #119, round 1).
const HEALTH_STACK_IN_MAX = 8000;
const HEALTH_TEXT_IN_MAX = 300;
const HEALTH_IDB_TIMEOUT_MS = 5000;
// A batch is cut to stay under this many bytes as sent (the contract asks the
// portal to accept 64 KB). With fixed fields a full batch is far below it; the
// cut stays as a guard.
const HEALTH_BODY_MAX = 60000;
const _healthBytes = (str) => {
  try { if (typeof TextEncoder !== 'undefined') return new TextEncoder().encode(str).length; } catch (e) {}
  return String(str).length * 3;
};

// The debugLog events that are failures. Everything else debugLog records
// (successes, summaries, counts) stays on the phone only.
const HEALTH_FAULT_EVENTS = new Set([
  'audio.backfill.error', 'audio.idb.move.error', 'audio.reclaim.error', 'audio.retry.error',
  'audio.store.pruned', 'audio.upload.permanent_fail', 'audio.upload.queued',
  'audio.upload.url_persist_failed', 'auth.hold_end_unrecorded',
  'camera.getusermedia.fail', 'camera.snap.fail',
  'offline.parked', 'offline.parked.retry_refused', 'offline.queue.write_refused',
  'photo.draft.patch_failed', 'photo.idb.error', 'photo.retry.error', 'photo.upload.fail',
  'snag.persist.fail', 'survey.conflict_check.fail', 'vision.scan.error', 'vision.scan.fail',
  'wrap.copies.clear_failed', 'wrap.delivered.not_applied', 'wrap.delivered.record_failed',
  'wrap.delivered.stub_failed', 'wrap.submit.unsent_photos', 'wrap.submit.untyped_lines',
]);
// Every kind a report can carry. Anything else becomes 'other'.
const HEALTH_KINDS = new Set([
  'window_error', 'unhandled_rejection', 'boot_unstamped', 'boot_load', 'boot_threw',
  'send.attempt_failed', 'send.direct_failed',
  'sw_error', 'sw_rejection', 'sw_precache_incomplete', 'sw_register_failed',
].concat(Array.from(HEALTH_FAULT_EVENTS)));
// Every error code a report can carry. Anything else becomes 'unknown'.
const HEALTH_CODES = new Set([
  // JavaScript errors, by name
  'Error', 'TypeError', 'ReferenceError', 'SyntaxError', 'RangeError', 'EvalError', 'URIError',
  'InternalError', 'AggregateError',
  // browser errors (DOMException), by name
  'QuotaExceededError', 'AbortError', 'TimeoutError', 'NetworkError', 'NotAllowedError',
  'NotFoundError', 'NotSupportedError', 'NotReadableError', 'SecurityError', 'InvalidStateError',
  'DataCloneError', 'DataError', 'UnknownError', 'TransactionInactiveError', 'VersionError',
  'ConstraintError', 'OverconstrainedError', 'EncodingError',
  // requests
  'timeout', 'network_error',
  'http_400', 'http_401', 'http_403', 'http_404', 'http_405', 'http_409', 'http_413', 'http_429', 'http_4xx',
  'http_500', 'http_502', 'http_503', 'http_504', 'http_5xx',
  // the start screen and the service worker
  'not_built', 'load_failed', 'precache_incomplete',
  // the rest
  'script_error', 'not_an_error', 'none', 'unknown',
]);
const _HEALTH_HTTP = new Set([400, 401, 403, 404, 405, 409, 413, 429, 500, 502, 503, 504]);
function _healthHttpCode(n) {
  if (_HEALTH_HTTP.has(n)) return 'http_' + n;
  if (n >= 400 && n < 500) return 'http_4xx';
  if (n >= 500 && n < 600) return 'http_5xx';
  return 'unknown';
}

// The error code for an error, a status or an error's text. The text is read
// here and nowhere else, and only to choose from HEALTH_CODES.
function healthCode(input) {
  try {
    if (input == null || input === '') return 'none';
    if (typeof input === 'number') return _healthHttpCode(input);
    if (typeof input === 'object') {
      const name = typeof input.name === 'string' ? input.name : '';
      const msg = typeof input.message === 'string' ? input.message.slice(0, HEALTH_TEXT_IN_MAX) : '';
      if (name === 'TypeError' && /^(Failed to fetch|Load failed|NetworkError when attempting)/.test(msg)) return 'network_error';
      if (HEALTH_CODES.has(name)) return name;
      return msg ? healthCode(msg) : 'unknown';
    }
    const s = String(input).slice(0, HEALTH_TEXT_IN_MAX).trim();
    let m;
    if ((m = s.match(/\bHTTP (\d{3})\b/))) return _healthHttpCode(Number(m[1]));
    if (/^timeout\b/i.test(s)) return 'timeout';
    if (/Failed to fetch|Load failed|NetworkError when attempting/i.test(s)) return 'network_error';
    if (/^Script error\.?$/i.test(s)) return 'script_error';
    if ((m = s.match(/\b([A-Z][A-Za-z]*Error)\b/))) return HEALTH_CODES.has(m[1]) ? m[1] : 'Error';
    return 'unknown';
  } catch (e) { return 'unknown'; }
}

// Where it happened: the first stack frame in a script file, as its file's base
// name and its function's name. Nothing else from the stack is kept: no
// message, no host, no query, no line. A function name that is not a plain
// identifier path (Object.method, Class.<anonymous>) is dropped.
const _HEALTH_FILE_RE = /^[A-Za-z0-9_.-]{1,60}\.(?:m?js|html)$/;
const _HEALTH_FN_RE = /^[A-Za-z_$][\w$]{0,79}(?:\.(?:[A-Za-z_$][\w$]{0,79}|<anonymous>)){0,3}$/;
const _healthBaseName = (url) => { const s = String(url || '').split(/[?#]/)[0]; return s.slice(s.lastIndexOf('/') + 1); };
const _healthFn = (fn) => {
  if (!fn) return null;
  const f = String(fn).replace(/^async\*/, '').replace(/^(?:async|new)\s+/, '').trim();
  return _HEALTH_FN_RE.test(f) ? f : null;
};
function healthLocation(stack, filename) {
  try {
    const lines = String(stack || '').slice(0, HEALTH_STACK_IN_MAX).split('\n').slice(0, 12);
    for (const raw of lines) {
      const l = raw.trim().slice(0, 600);
      let m = l.match(/^at\s+(?:(.+?)\s+\()?(\S+?):\d+:\d+\)?$/);
      if (!m) m = l.match(/^([^@\s]*)@(\S+?):\d+:\d+$/);
      if (!m) continue;
      const file = _healthBaseName(m[2]);
      if (!_HEALTH_FILE_RE.test(file)) continue;
      return { file, function: _healthFn(m[1]) };
    }
    if (filename) {
      const f = _healthBaseName(filename);
      if (_HEALTH_FILE_RE.test(f)) return { file: f, function: null };
    }
  } catch (e) {}
  return null;
}

// FNV-1a over kind, code and location: 'h_' + 8 hex.
function healthFingerprint(kind, code, where) {
  const str = String(kind || '') + '\u0001' + String(code || '') + '\u0001' + String(where || '');
  let h = 0x811c9dc5;
  for (let i = 0; i < str.length; i++) { h ^= str.charCodeAt(i); h = Math.imul(h, 0x01000193) >>> 0; }
  return 'h_' + ('0000000' + h.toString(16)).slice(-8);
}

// Device and browser, each by name and major.minor. Never the user agent.
function healthDevice(nav, win) {
  const ua = String((nav && nav.userAgent) || '');
  const touch = !!(nav && nav.maxTouchPoints > 1);
  const mm = (re) => { const m = ua.match(re); return m ? m : null; };
  let device = 'desktop';
  if (/iPad/.test(ua) || (/Macintosh/.test(ua) && touch)) device = 'iPad';
  else if (/iPhone|iPod/.test(ua)) device = 'iPhone';
  else if (/Android/.test(ua)) device = 'Android';
  let os = 'other';
  let m;
  if ((device === 'iPhone' || device === 'iPad') && (m = mm(/OS (\d+)[_.](\d+)/))) os = 'iOS ' + m[1] + '.' + m[2];
  else if (device === 'iPad' && (m = mm(/Version\/(\d+)\.(\d+)/))) os = 'iOS ' + m[1] + '.' + m[2];
  else if ((m = mm(/Android (\d+)(?:\.(\d+))?/))) os = 'Android ' + m[1] + (m[2] ? '.' + m[2] : '');
  else if (/Mac OS X/.test(ua)) os = 'macOS';
  else if (/Windows/.test(ua)) os = 'Windows';
  else if (/Linux/.test(ua)) os = 'Linux';
  let browser = 'other';
  if ((m = mm(/CriOS\/(\d+)\.(\d+)/))) browser = 'Chrome ' + m[1] + '.' + m[2];
  else if ((m = mm(/FxiOS\/(\d+)\.(\d+)/))) browser = 'Firefox ' + m[1] + '.' + m[2];
  else if ((m = mm(/EdgA?\/(\d+)\.(\d+)/))) browser = 'Edge ' + m[1] + '.' + m[2];
  else if ((m = mm(/Chrome\/(\d+)\.(\d+)/))) browser = 'Chrome ' + m[1] + '.' + m[2];
  else if ((m = mm(/Firefox\/(\d+)\.(\d+)/))) browser = 'Firefox ' + m[1] + '.' + m[2];
  else if ((m = mm(/Version\/(\d+)\.(\d+).*Safari/))) browser = 'Safari ' + m[1] + '.' + m[2];
  else if (/AppleWebKit/.test(ua)) browser = 'WebKit';
  let standalone = false;
  try { standalone = (nav && nav.standalone === true) || !!(win && win.matchMedia && win.matchMedia('(display-mode: standalone)').matches); } catch (e) {}
  return { device, os, browser, standalone };
}

// The backstop. A report is rebuilt from the contract's fields alone, each
// checked against a pattern; a field that fails is null (a kind 'other', a
// code 'unknown'), and a report with no valid fingerprint is dropped. No
// field can hold free text.
const _HEALTH_PAT = {
  fingerprint: /^h_[0-9a-f]{8}$/,
  iso: /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/,
  build: /^(?:[0-9a-f]{6,64}|unstamped)$/,
  os: /^(?:(?:iOS|Android) \d{1,3}(?:\.\d{1,3})?|macOS|Windows|Linux|other)$/,
  browser: /^(?:(?:Chrome|Firefox|Edge|Safari) \d{1,4}\.\d{1,4}|WebKit|other)$/,
};
const _HEALTH_DEVICES = new Set(['iPhone', 'iPad', 'Android', 'desktop']);
function healthSanitiseReport(r) {
  try {
    if (!r || typeof r !== 'object') return null;
    const ok = (re, v) => (typeof v === 'string' && re.test(v) ? v : null);
    const fingerprint = ok(_HEALTH_PAT.fingerprint, r.fingerprint);
    if (!fingerprint) return null;
    let location = null;
    if (r.location && typeof r.location === 'object' && typeof r.location.file === 'string' && _HEALTH_FILE_RE.test(r.location.file)) {
      const fn = r.location.function;
      location = { file: r.location.file, function: typeof fn === 'string' && _HEALTH_FN_RE.test(fn) ? fn : null };
    }
    let device = null;
    if (r.device && typeof r.device === 'object') {
      device = {
        device: _HEALTH_DEVICES.has(r.device.device) ? r.device.device : null,
        os: ok(_HEALTH_PAT.os, r.device.os),
        browser: ok(_HEALTH_PAT.browser, r.device.browser),
        standalone: r.device.standalone === true,
      };
    }
    return {
      fingerprint,
      kind: HEALTH_KINDS.has(r.kind) ? r.kind : 'other',
      code: HEALTH_CODES.has(r.code) ? r.code : 'unknown',
      location,
      count: Number.isInteger(r.count) && r.count >= 1 ? Math.min(r.count, 1000000) : 1,
      first_seen: ok(_HEALTH_PAT.iso, r.first_seen),
      last_seen: ok(_HEALTH_PAT.iso, r.last_seen),
      build: ok(_HEALTH_PAT.build, r.build),
      device,
    };
  } catch (e) { return null; }
}

const healthAnswerClears = (status) => typeof status === 'number' && status >= 200 && status < 300;

// After a failed flush: 1 minute, doubling, at most 6 hours.
function healthBackoff(prev, nowMs) {
  const failures = ((prev && prev.failures) || 0) + 1;
  const delay = Math.min(HEALTH_BACKOFF_BASE_MS * Math.pow(2, failures - 1), HEALTH_BACKOFF_MAX_MS);
  return { failures, next_at: nowMs + delay };
}

// A store in memory (tests, and the shape every store follows).
function createHealthMemoryStore() {
  const map = new Map();
  const copy = (e) => (e ? JSON.parse(JSON.stringify(e)) : null);
  return {
    list: async () => Array.from(map.values()).map(copy),
    get: async (k) => copy(map.get(k)),
    put: async (e) => { map.set(e.key, copy(e)); },
    remove: async (k) => { map.delete(k); },
  };
}

// The phone's store: IndexedDB lumen_health / faults, keyed by `key` (the
// person and the fingerprint, so two people's faults never merge; the key and
// the person stay on the phone). Any failure answers empty or does nothing; it
// never rejects, and an open or a transaction that never answers (a known
// WebKit hang) gives up after 5 s. A transaction that gave up can still commit
// later; the cost is bounded and never a throw: a report sent twice (the
// portal counts it twice) or a count restarted at 1.
function createHealthIdbStore(idb) {
  let dbp = null;
  // An open that timed out is not tried again: every later call answers at
  // once with nothing, rather than each waiting out its own timeout in turn
  // (a backlog that grew with every fault). If that open answers late, the
  // store uses it from then on.
  let stuck = false;
  const open = () => {
    if (stuck) return Promise.resolve(null);
    if (!dbp) {
      dbp = new Promise((res) => {
        try {
          const r = idb.open(HEALTH_DB, 1);
          let gaveUp = false;
          const t = setTimeout(() => { gaveUp = true; stuck = true; res(null); }, HEALTH_IDB_TIMEOUT_MS);
          r.onupgradeneeded = () => { try { r.result.createObjectStore(HEALTH_STORE, { keyPath: 'key' }); } catch (e) {} };
          r.onsuccess = () => {
            const db = r.result;
            try { db.onversionchange = () => { try { db.close(); } catch (e) {} dbp = null; }; } catch (e) {}
            if (gaveUp) { dbp = Promise.resolve(db); stuck = false; return; }
            clearTimeout(t);
            res(db);
          };
          r.onerror = () => { clearTimeout(t); res(null); };
          r.onblocked = () => { clearTimeout(t); res(null); };
        } catch (e) { res(null); }
      }).then((db) => { if (!db) dbp = null; return db; });
    }
    return dbp;
  };
  const run = (mode, fn) => open().then((db) => new Promise((res) => {
    if (!db) { res(undefined); return; }
    const t = setTimeout(() => res(undefined), HEALTH_IDB_TIMEOUT_MS);
    const done = (v) => { clearTimeout(t); res(v); };
    try {
      const tx = db.transaction(HEALTH_STORE, mode);
      const req = fn(tx.objectStore(HEALTH_STORE));
      let out;
      if (req) req.onsuccess = () => { out = req.result; };
      tx.oncomplete = () => done(out);
      tx.onerror = () => done(undefined);
      tx.onabort = () => done(undefined);
    } catch (e) { done(undefined); }
  })).catch(() => undefined);
  return {
    list: () => run('readonly', (st) => st.getAll()).then((r) => (Array.isArray(r) ? r : [])),
    get: (k) => run('readonly', (st) => st.get(k)).then((r) => r || null),
    put: (e) => run('readwrite', (st) => st.put(e)),
    remove: (k) => run('readwrite', (st) => st.delete(k)),
  };
}

// The reporter: capture() and flush(). Every dependency is passed in, so the
// tests run it against a memory store and a fake fetch with a fixed clock.
function createHealthReporter(deps) {
  const d = deps || {};
  const now = d.now || (() => Date.now());
  const call = (fn, fallback) => { try { return fn ? fn() : fallback; } catch (e) { return fallback; } };
  let chain = Promise.resolve();
  const serial = (fn) => { const p = chain.then(fn, fn); chain = p.then(() => undefined, () => undefined); return p; };
  let inFlight = false;

  // info: { error (an Error, its text or a status), status, stack, filename,
  // code (one from HEALTH_CODES, when the caller knows it), at }. Built at
  // once, at the fault: nothing here reads storage, and the person is the one
  // signed in when it happened (Sign out clears them in the same turn).
  const build = (kind, info) => {
    const i = info || {};
    const k = HEALTH_KINDS.has(kind) ? kind : 'other';
    let code;
    if (typeof i.code === 'string' && HEALTH_CODES.has(i.code)) code = i.code;
    else if (typeof i.status === 'number' && i.status) code = _healthHttpCode(i.status);
    else code = healthCode(i.error);
    const stack = i.stack != null ? i.stack : (i.error && typeof i.error === 'object' ? i.error.stack : null);
    const location = healthLocation(stack, i.filename);
    const fingerprint = healthFingerprint(k, code, location ? location.file + ':' + (location.function || '') : '');
    const at = (typeof i.at === 'string' && !isNaN(Date.parse(i.at))) ? new Date(i.at).toISOString() : new Date(now()).toISOString();
    const report = healthSanitiseReport({
      fingerprint, kind: k, code, location, count: 1, first_seen: at, last_seen: at,
      build: call(d.build, null), device: call(d.device, null),
    });
    if (!report) return null;
    const user = call(d.getUser, null) || {};
    return Object.assign(report, { key: (user.id || '') + '\u0001' + fingerprint, user_id: user.id || null });
  };

  const capture = (kind, info) => {
    let report = null;
    try { report = build(kind, info); } catch (e) { report = null; }
    if (!report) return Promise.resolve(false);
    return serial(async () => {
      const store = d.store;
      if (!store) return false;
      const cur = await store.get(report.key);
      if (cur) {
        const merged = Object.assign({}, cur, {
          count: (cur.count || 1) + 1,
          first_seen: cur.first_seen < report.first_seen ? cur.first_seen : report.first_seen,
          last_seen: cur.last_seen > report.last_seen ? cur.last_seen : report.last_seen,
          build: report.build, device: report.device,
        });
        await store.put(merged);
        return true;
      }
      const all = await store.list();
      if (all.length >= HEALTH_CAP) {
        const byOld = all.slice().sort((a, b) => (a.last_seen < b.last_seen ? -1 : a.last_seen > b.last_seen ? 1 : 0));
        for (let n = 0; n <= all.length - HEALTH_CAP; n++) await store.remove(byOld[n].key);
      }
      await store.put(report);
      return true;
    }).catch(() => false);
  };

  // What one flush did: 'sent', 'kept', 'empty', 'offline', 'signed_out',
  // 'backoff', 'busy', 'in_flight' or 'error'. It never rejects. d.lock, when
  // given, keeps two tabs from sending the same reports at once.
  const flush = () => {
    try {
      if (!d.lock) return flushOnce();
      return Promise.resolve(d.lock(flushOnce)).catch(() => 'error');
    } catch (e) { return Promise.resolve('error'); }
  };
  const flushOnce = async () => {
    try {
      if (inFlight) return 'in_flight';
      if (!d.store) return 'empty';
      if (!call(d.isOnline, true)) return 'offline';
      const token = call(d.getToken, null);
      const user = call(d.getUser, null);
      if (!token || !user || !user.id) return 'signed_out';
      const b = call(d.readBackoff, null);
      if (b && typeof b.next_at === 'number' && b.next_at > now()) return 'backoff';
      if (call(d.isSendBusy, false)) return 'busy';
      inFlight = true;
      try {
        const all = await serial(() => d.store.list());
        // A batch the portal refused as a whole (400, 413) is not resent as
        // it was: each refusal halves the next batch, and every other attempt
        // takes the newest reports first, so one report the portal cannot
        // take never holds back the rest. Nothing is dropped: only a 2xx
        // removes a report (review of #119, round 2).
        const refused = (b && b.refused) || 0;
        const size = Math.max(1, HEALTH_BATCH >> Math.min(refused, 5));
        const ordered = (all || []).filter((e) => e && (!e.user_id || e.user_id === user.id))
          .sort((x, y) => (x.first_seen < y.first_seen ? -1 : x.first_seen > y.first_seen ? 1 : 0));
        if (refused % 2 === 1) ordered.reverse();
        let mine = ordered.slice(0, size);
        if (!mine.length) return 'empty';
        // Every report is rebuilt by the backstop on the way out: the person
        // and the store key never leave the phone.
        // The batch's build is held to the same pattern as each report's.
        const _b = call(d.build, null);
        const build = typeof _b === 'string' && _HEALTH_PAT.build.test(_b) ? _b : null;
        const bodyOf = (list) => JSON.stringify({ schema: 1, build, sent_at: new Date(now()).toISOString(),
          reports: list.map(healthSanitiseReport).filter(Boolean) });
        let body = bodyOf(mine);
        while (mine.length > 1 && _healthBytes(body) > HEALTH_BODY_MAX) { mine = mine.slice(0, -1); body = bodyOf(mine); }
        let status = 0;
        let timer = null;
        try {
          const ctl = typeof AbortController !== 'undefined' ? new AbortController() : null;
          const setT = d.setTimeout || setTimeout;
          const clearT = d.clearTimeout || clearTimeout;
          const timeout = new Promise((res) => { timer = setT(() => { try { if (ctl) ctl.abort(); } catch (e) {} res(null); }, HEALTH_TIMEOUT_MS); });
          const req = Promise.resolve().then(() => d.fetch((d.portal || '') + HEALTH_ENDPOINT, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
            body,
            signal: ctl ? ctl.signal : undefined,
          }));
          const res = await Promise.race([req.catch(() => null), timeout]);
          try { clearT(timer); } catch (e) {}
          status = res && typeof res.status === 'number' ? res.status : 0;
        } catch (e) { status = 0; }
        if (!healthAnswerClears(status)) {
          const prev = call(d.readBackoff, null);
          const nb = healthBackoff(prev, now());
          const nr = (status === 400 || status === 413) ? ((prev && prev.refused) || 0) + 1 : ((prev && prev.refused) || 0);
          if (nr) nb.refused = nr;
          call(() => d.writeBackoff(nb));
          return 'kept';
        }
        await serial(async () => {
          for (const sent of mine) {
            const cur = await d.store.get(sent.key);
            if (!cur) continue;
            // Evicted and seen afresh while the batch was out: a new report,
            // not the one that was sent, so it stays whole.
            if (cur.first_seen !== sent.first_seen) continue;
            if ((cur.count || 1) <= (sent.count || 1)) await d.store.remove(sent.key);
            else await d.store.put(Object.assign({}, cur, { count: cur.count - sent.count }));
          }
        });
        call(() => d.writeBackoff(null));
        return 'sent';
      } finally { inFlight = false; }
    } catch (e) { return 'error'; }
  };

  return { capture, flush };
}

// ── The phone's wiring ──────────────────────────────────────────────────────
let _healthReporterInst;
const _healthBuildId = () => {
  try {
    const el = document.querySelector('script[src*="app.build.js"]');
    const m = el && String(el.getAttribute('src') || '').match(/[?&]v=([^&#]+)/);
    if (!m) return null;
    return m[1] === '__BUILD' + '_ID__' ? 'unstamped' : m[1];
  } catch (e) { return null; }
};
const _healthJson = (k) => { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } };
function healthReporter() {
  if (_healthReporterInst !== undefined) return _healthReporterInst;
  _healthReporterInst = null;
  try {
    const idb = typeof indexedDB !== 'undefined' ? indexedDB : null;
    if (!idb || typeof window === 'undefined') return null;
    _healthReporterInst = createHealthReporter({
      store: createHealthIdbStore(idb),
      fetch: (u, o) => fetch(u, o),
      portal: PORTAL_URL,
      build: _healthBuildId,
      isOnline: () => navigator.onLine !== false,
      getToken: () => localStorage.getItem('lumen_token'),
      getUser: () => { const u = _healthJson('asg_current_user'); return u && u.id ? { id: u.id } : null; },
      device: () => healthDevice(navigator, window),
      isSendBusy: () => _wrapInFlight.size > 0 || _wrapDirect.size > 0,
      // One flush across every tab of the app (Web Locks where the browser has
      // them; without, each tab guards only itself).
      lock: (fn) => ((typeof navigator !== 'undefined' && navigator.locks && navigator.locks.request)
        ? navigator.locks.request('lumen_health_flush', { ifAvailable: true }, (l) => (l ? fn() : 'in_flight'))
        : fn()),
      readBackoff: () => _healthJson(HEALTH_BACKOFF_KEY),
      writeBackoff: (b) => { try { if (b) localStorage.setItem(HEALTH_BACKOFF_KEY, JSON.stringify(b)); else localStorage.removeItem(HEALTH_BACKOFF_KEY); } catch (e) {} },
    });
  } catch (e) { _healthReporterInst = null; }
  return _healthReporterInst;
}
// Tests only: run the page wiring (debugLog, reportFault) against a reporter
// of their own, since the node harness has no IndexedDB.
const healthUseReporter = (r) => { _healthReporterInst = r || null; };
// Record a fault. Returns at once; never throws.
function reportFault(kind, info) {
  try { const r = healthReporter(); if (r) r.capture(kind, info || {}).catch(() => {}); } catch (e) {}
}
// Send what is waiting, later and in the background. Never throws.
function healthFlushSoon(delayMs) {
  try {
    const r = healthReporter();
    if (!r) return;
    setTimeout(() => { try { r.flush().catch(() => {}); } catch (e) {} }, delayMs || 0);
  } catch (e) {}
}
let _healthInstalled = false;
function healthInstall() {
  if (_healthInstalled || typeof window === 'undefined') return;
  _healthInstalled = true;
  try {
    window.addEventListener('error', (ev) => {
      try {
        if (ev && ev.target && ev.target !== window) return;   // a resource load, not a script error
        reportFault('window_error', { error: (ev && ev.error) || (ev && ev.message) || null, filename: ev && ev.filename });
      } catch (e) {}
    });
    window.addEventListener('unhandledrejection', (ev) => {
      try {
        const r = ev && ev.reason;
        const isErr = !!r && typeof r === 'object' && (typeof r.name === 'string' || typeof r.message === 'string');
        reportFault('unhandled_rejection', isErr ? { error: r } : { code: 'not_an_error' });
      } catch (e) {}
    });
    window.addEventListener('lumen-sw-fault', (ev) => {
      try {
        const dt = (ev && ev.detail) || {};
        const kind = ['sw_error', 'sw_rejection', 'sw_precache_incomplete', 'sw_register_failed'].indexOf(dt.kind) >= 0 ? dt.kind : 'sw_error';
        reportFault(kind, kind === 'sw_precache_incomplete' ? { code: 'precache_incomplete' } : { error: dt.message || null, stack: dt.stack || null });
      } catch (e) {}
    });
    window.addEventListener('online', () => healthFlushSoon(3000));
  } catch (e) {}
  // A start that failed (index.html's boot guard) could not report; this one
  // can. The note is removed only once the reporter exists to take it. Its text
  // is read only to choose an error code.
  try {
    if (healthReporter()) {
      const notes = _healthJson(HEALTH_BOOT_KEY);
      if (Array.isArray(notes) && notes.length) {
        notes.slice(-5).forEach((n) => {
          if (!n || typeof n !== 'object') return;
          const kind = ['unstamped', 'load', 'threw'].indexOf(n.kind) >= 0 ? n.kind : 'threw';
          const info = kind === 'unstamped' ? { code: 'not_built' } : kind === 'load' ? { code: 'load_failed' } : { error: n.detail || null };
          info.at = n.at;
          reportFault('boot_' + kind, info);
        });
      }
      try { localStorage.removeItem(HEALTH_BOOT_KEY); } catch (e) {}
    }
  } catch (e) {}
  healthFlushSoon(8000);
}

healthInstall();

const _DEBUG_LOG_KEY = 'lumen_debug_log';
const _DEBUG_LOG_CAP = 500;
const debugLog = (event, meta = {}) => {
  try {
    const arr = JSON.parse(localStorage.getItem(_DEBUG_LOG_KEY) || '[]');
    arr.push({ ts: new Date().toISOString(), event, ...meta });
    while (arr.length > _DEBUG_LOG_CAP) arr.shift();
    localStorage.setItem(_DEBUG_LOG_KEY, JSON.stringify(arr));
  } catch (e) {
    // best-effort — never throw from logging
  }
  // COMPANION-HEALTH-V1: a failure event also becomes a fault report: the
  // event name is its kind, and its error or status only chooses the code.
  // Nothing else the event carries is read.
  if (HEALTH_FAULT_EVENTS.has(event)) {
    try { reportFault(event, { error: meta ? meta.error : null, status: meta && typeof meta.status === 'number' ? meta.status : undefined }); } catch (e) {}
  }
};

const _isB64 = (s) => typeof s === 'string' && s.startsWith('data:');
// A photo is "pending" if it still carries base64 src (not yet uploaded)
// OR carries an explicit uploadFailed flag from a permanent retry-queue
// failure. Used by every UI surface that renders thumbnails.
const _isPhotoPending = (photo) =>
  !!photo && photo.type !== 'video' && (_isB64(photo.src) || !!photo.uploadFailed);
// SEND-STATE-V1: what the surveyor sees on a photo. The stored copy of a photo
// is a ref (its base64 lives in IndexedDB), so after a restart _isPhotoPending
// could not tell an un-uploaded photo from an uploaded one. The survey now
// stamps uploadState ('pending', or 'failed' once the retry queue gives up)
// on the stored photo when it is taken, and clears it when its url lands.
// Display only; the S105 send guard above is unchanged.
const _photoHasUrl = (photo) => !!photo && ((typeof photo.url === 'string' && photo.url.indexOf('http') === 0) || (typeof photo.src === 'string' && photo.src.indexOf('http') === 0));
// Everything _isPhotoPending showed before, plus a stored photo still flagged
// and with no url yet.
const photoUploadPending = (photo) =>
  _isPhotoPending(photo)
  || (!!photo && photo.type !== 'video' && !_photoHasUrl(photo) && (photo.uploadState === 'pending' || photo.uploadState === 'failed'));
const photoPendingLabel = (photo, online) => {
  if (!photo) return '';
  if (photo.uploadFailed || photo.uploadState === 'failed') return 'Upload failed';
  return (_isB64(photo.src) && online !== false) ? 'Uploading' : 'Waiting to upload';
};
// A photo with its url, as every url-landing path writes it: src becomes the
// url, the upload flags go.
const photoWithUrl = (photo, url) => {
  const { uploadState, ...rest } = photo || {};
  return Object.assign({}, rest, { src: url, url, uploadFailed: false });
};
// The job front page's line for work still on the phone: photos not uploaded
// and voice notes not transcribed. '' when there is none. A photo whose upload
// already failed (the retry queue gave up: uploadFailed, or uploadState
// 'failed', the same test as its "Upload failed" label) is not waiting: it is
// counted apart (failed) and said plainly. Sending the survey tries it again.
const photoUploadFailed = (photo) => !!photo && (!!photo.uploadFailed || photo.uploadState === 'failed');
const frontPendingCounts = (sitePhotos, zoneNotes) => {
  const notUp = (Array.isArray(sitePhotos) ? sitePhotos : []).filter(photoUploadPending);
  const failed = notUp.filter(photoUploadFailed).length;
  const photos = notUp.length - failed;
  let voice = 0;
  if (zoneNotes && typeof zoneNotes === 'object') {
    Object.keys(zoneNotes).forEach((k) => {
      const v = zoneNotes[k];
      if (Array.isArray(v)) v.forEach((n) => { if (n && n.pending === true) voice += 1; });
    });
  }
  return { photos, failed, voice };
};
// SEND-TIMEOUT-V1 (#112 note 5): `sent` is true when the job reads as sent.
// Then nothing still on the phone is in what the portal has (a photo not up,
// or a voice note recorded or transcribed after the send), so the line says
// that, in place of words that read as if it would go with the survey.
const frontPendingLine = (counts, online, sent) => {
  const c = counts || {};
  const parts = [];
  if (c.photos > 0) parts.push(`${c.photos} ${c.photos === 1 ? 'photo' : 'photos'}`);
  if (c.voice > 0) parts.push(`${c.voice} ${c.voice === 1 ? 'voice note' : 'voice notes'}`);
  const out = [];
  if (sent === true) {
    const n = (c.photos > 0 ? c.photos : 0) + (c.voice > 0 ? c.voice : 0);
    if (parts.length) out.push(`${parts.join(' and ')} ${n === 1 ? 'wasn’t' : 'weren’t'} in what was sent. ${n === 1 ? 'It’s' : 'They’re'} still ${online === false ? 'waiting for a connection' : 'waiting to upload'}.`);
    if (c.failed > 0) out.push(c.failed === 1 ? '1 photo didn’t upload, so it wasn’t in what was sent.' : `${c.failed} photos didn’t upload, so they weren’t in what was sent.`);
    return out.join(' ');
  }
  if (parts.length) out.push(`${parts.join(' and ')} ${online === false ? 'waiting for a connection' : 'waiting to upload'}.`);
  if (c.failed > 0) out.push(c.failed === 1 ? '1 photo didn’t upload. It will try again when you send.' : `${c.failed} photos didn’t upload. They will try again when you send.`);
  return out.join(' ');
};

// ── Single-attempt photo upload ──────────────────────────────────────────
// 30-second AbortController timeout per fetch — without this, slow LTE
// connections hold one of iOS Safari's 6 connection slots indefinitely
// while other photos queue behind them. Returns a normalised result so
// callers don't have to reason about AbortError vs network errors vs
// HTTP status separately.
const _uploadPhotoOnce = async (photo, opts = {}) => {
  if (!photo || photo.type === 'video' || !_isB64(photo.src)) {
    return { ok: true, photo, url: photo && photo.url, ms: 0, alreadyUploaded: true };
  }
  const t0 = Date.now();
  const controller = new AbortController();
  const timeoutMs = opts.timeoutMs || 30000;
  const timeout = setTimeout(() => controller.abort(), timeoutMs);
  try {
    const token = localStorage.getItem('lumen_token');
    const headers = Object.assign(
      { 'Content-Type': 'application/json' },
      token ? { 'Authorization': `Bearer ${token}` } : {}
    );
    const resp = await fetch(`${PORTAL_URL}/api/photo`, {
      method: 'POST', headers,
      body: JSON.stringify({ image: photo.src }),
      signal: controller.signal,
    });
    // SECURITY-WAVE-1 track C: a refused sign-in is not a failed upload.
    if (bearerRefused(resp.status, token, 'photo upload')) {
      return { ok: false, photo, authRefused: true, error: `HTTP ${resp.status}`,
               status: resp.status, ms: Date.now() - t0 };
    }
    if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
    const data = await resp.json();
    if (!data || !data.url) throw new Error('no url in response');
    return { ok: true, photo, url: data.url, status: resp.status, ms: Date.now() - t0 };
  } catch (e) {
    const isAbort = e && e.name === 'AbortError';
    return {
      ok: false, photo,
      error: isAbort ? 'timeout' : (e && e.message) || String(e),
      ms: Date.now() - t0,
    };
  } finally {
    clearTimeout(timeout);
  }
};

// ── 3-concurrent batched uploader (used at wrap-submit time) ─────────────
// iOS Safari's 6-connection-per-origin limit means anything above that
// queues at the network layer. 3 keeps headroom for any other in-flight
// requests (auth pings, pull-to-refresh) the user might trigger between
// taps. Sequential batches; no Promise.all-of-N anywhere.
const uploadPhotoBatched = async (photos, concurrency = 3, onProgress) => {
  const results = [];
  for (let i = 0; i < photos.length; i += concurrency) {
    const batch = photos.slice(i, i + concurrency);
    const batchResults = await Promise.all(batch.map(p => _uploadPhotoOnce(p)));
    results.push(...batchResults);
    if (onProgress) {
      const ok = results.filter(r => r.ok && !r.alreadyUploaded).length;
      const failed = results.filter(r => !r.ok).length;
      try { onProgress({ done: results.length, total: photos.length, uploaded: ok, failed }); } catch (e) {}
    }
  }
  return results;
};

// ── Photo retry queue (lumen_photo_retry_queue) ──────────────────────────
// Separate from lumen_offline_queue because photos have very different
// retry semantics: per-attempt backoff, age cap, permanent-failure
// signalling to the UI. Schema per entry:
//   { projectId, photo, attempts, last_attempt_ts, queued_at }
// The `photo` is the FULL photo object (src=base64, ts, zone, label).
const _PHOTO_RETRY_QUEUE_KEY = 'lumen_photo_retry_queue';
const _PHOTO_RETRY_QUEUE_CAP = 200;
const _PHOTO_RETRY_AGE_MS = 7 * 24 * 60 * 60 * 1000;     // 7 days
const _PHOTO_RETRY_MAX_ATTEMPTS = 5;
// Backoff for attempt N (0-indexed). After 5 attempts the entry is
// dropped and the photo is permanently marked as uploadFailed.
const _PHOTO_RETRY_BACKOFF_MS = [
  1 * 1000,        //   1s after 1st failure
  5 * 1000,        //   5s
  30 * 1000,       //  30s
  5 * 60 * 1000,   //   5m
  30 * 60 * 1000,  //  30m
];

const _readPhotoRetryQueue = () => {
  try {
    const arr = JSON.parse(localStorage.getItem(_PHOTO_RETRY_QUEUE_KEY) || '[]');
    return Array.isArray(arr) ? arr : [];
  } catch (e) { return []; }
};
const _writePhotoRetryQueue = (queue) => {
  try {
    // FIFO cap — drop oldest when over capacity. Sort by queued_at
    // ascending and slice from the tail so the oldest entries leave
    // first, matching the behaviour of a bounded ring buffer.
    let next = queue;
    if (next.length > _PHOTO_RETRY_QUEUE_CAP) {
      next = next.slice(-_PHOTO_RETRY_QUEUE_CAP);
    }
    localStorage.setItem(_PHOTO_RETRY_QUEUE_KEY, JSON.stringify(next));
  } catch (e) {
    debugLog('localStorage.persist.fail', { key: _PHOTO_RETRY_QUEUE_KEY, error: (e && e.message) || String(e) });
  }
};

const addToPhotoRetryQueue = (projectId, photo) => {
  if (!projectId || !photo || !_isB64(photo.src)) return;
  const queue = _readPhotoRetryQueue();
  // Dedupe by exact src match — if the same photo is already queued,
  // don't double-add. This guards against handlePhotoFile firing twice
  // in dev or on a rapid double-tap.
  // SEND-STATE-V1: and by photo id, so a photo the send re-reads from
  // IndexedDB (same id, a fresh base64 copy) is never queued twice.
  if (queue.some(e => e && e.photo && (e.photo.src === photo.src || (!!photo.id && e.photo.id === photo.id)))) return;
  queue.push({
    projectId,
    photo,
    attempts: 0,
    last_attempt_ts: 0,
    queued_at: new Date().toISOString(),
  });
  _writePhotoRetryQueue(queue);
  debugLog('photo.queued.retry', {
    projectId,
    zone: photo.zone || null,
    queueLen: queue.length,
  });
};

// SEND-STATE-V1: a photo the send itself uploaded leaves the retry queue, so
// the queue never uploads it a second time.
const dropFromPhotoRetryQueue = (photoId) => {
  if (!photoId) return;
  const queue = _readPhotoRetryQueue();
  const next = queue.filter(e => !(e && e.photo && e.photo.id === photoId));
  if (next.length !== queue.length) {
    _writePhotoRetryQueue(next);
    debugLog('photo.retry.dropped_uploaded', { id: photoId });
  }
};

let _photoRetryFlushInFlight = false;
const flushPhotoRetryQueue = async () => {
  if (_photoRetryFlushInFlight) return;
  _photoRetryFlushInFlight = true;
  try {
    const queue = _readPhotoRetryQueue();
    if (queue.length === 0) return;
    // SECURITY-WAVE-1 track C: hold while a sign-in is needed.
    if (signInAgainNeeded()) return;
    const now = Date.now();
    const remaining = [];
    let attempted = 0, ok = 0, failed = 0, dropped_age = 0, dropped_attempts = 0;
    let signInRefused = false;
    // Track C: time held for a sign-in does not count (see endSignInHold).
    // A flag still stored with a token is a hold end the store could not
    // record, so nothing is given up for age until one is recorded.
    let ageRestartMs = 0, holdEndUnrecorded = false;
    try {
      ageRestartMs = new Date(localStorage.getItem(PHOTO_AGE_RESTART_KEY) || 0).getTime() || 0;
      holdEndUnrecorded = !!localStorage.getItem(SIGNIN_NEEDED_KEY);
    } catch (e) {}
    for (const item of queue) {
      // After a refused sign-in, keep every later photo exactly as it is.
      if (signInRefused) { remaining.push(item); continue; }
      // Age cap: drop entries older than 7 days regardless of state, the age
      // counted from the later of queued_at and the end of any sign-in hold.
      const ageMs = now - Math.max(new Date(item.queued_at || 0).getTime(), ageRestartMs);
      if (!holdEndUnrecorded && (isNaN(ageMs) || ageMs > _PHOTO_RETRY_AGE_MS)) {
        dropped_age += 1;
        try {
          window.dispatchEvent(new CustomEvent('lumenPhotoFailed', {
            detail: { projectId: item.projectId, src: item.photo && item.photo.src, reason: 'age', photoId: (item.photo && item.photo.id) || null },
          }));
        } catch (e) {}
        continue;
      }
      // Permanent-failure cap — 5 attempts and we're done.
      if ((item.attempts || 0) >= _PHOTO_RETRY_MAX_ATTEMPTS) {
        dropped_attempts += 1;
        try {
          window.dispatchEvent(new CustomEvent('lumenPhotoFailed', {
            detail: { projectId: item.projectId, src: item.photo && item.photo.src, reason: 'attempts', photoId: (item.photo && item.photo.id) || null },
          }));
        } catch (e) {}
        continue;
      }
      // Backoff gate — too soon since the previous attempt? Defer.
      const wait = _PHOTO_RETRY_BACKOFF_MS[item.attempts || 0] || 0;
      const sinceLast = now - (item.last_attempt_ts || 0);
      if (sinceLast < wait) {
        remaining.push(item);
        continue;
      }
      // Attempt the upload. Sequential — no Promise.all here so we
      // don't reproduce the storm we're trying to fix.
      attempted += 1;
      const result = await _uploadPhotoOnce(item.photo);
      if (result.authRefused) {
        // No attempt spent: the photo waits for the next sign-in.
        signInRefused = true;
        remaining.push(item);
        continue;
      }
      if (result.ok && result.url) {
        ok += 1;
        debugLog('photo.upload.ok', {
          projectId: item.projectId,
          via: 'retry',
          attempt: (item.attempts || 0) + 1,
          ms: result.ms,
          url: result.url,
        });
        try {
          window.dispatchEvent(new CustomEvent('lumenPhotoUploaded', {
            detail: {
              projectId: item.projectId,
              oldSrc: item.photo && item.photo.src,
              newUrl: result.url,
              // SEND-STATE-V1: the stored photo is a ref with no base64 (it
              // lives in IndexedDB), so it is matched by id, not by image data.
              photoId: (item.photo && item.photo.id) || null,
            },
          }));
        } catch (e) {}
      } else {
        failed += 1;
        debugLog('photo.upload.fail', {
          projectId: item.projectId,
          via: 'retry',
          attempt: (item.attempts || 0) + 1,
          error: result.error,
          ms: result.ms,
        });
        remaining.push({
          ...item,
          attempts: (item.attempts || 0) + 1,
          last_attempt_ts: now,
        });
      }
    }
    // Keep photos queued while this flush awaited the network (_addedSince).
    _writePhotoRetryQueue(remaining.concat(_addedSince(queue, _readPhotoRetryQueue())));
    debugLog('photo.retry.summary', {
      attempted, ok, failed,
      dropped_age, dropped_attempts,
      remaining: remaining.length,
    });
  } catch (e) {
    debugLog('photo.retry.error', { error: (e && e.message) || String(e) });
  } finally {
    _photoRetryFlushInFlight = false;
  }
};

// ==== A5_VOICE_AUDIO_STORE_START (sliced out by tests/voice_audio_store.test.js)
// SLICE-A5 — where a recording's bytes live.
//
// Voice audio used to live as base64 text inside lumen_voice_notes in
// localStorage, which browsers cap at about 5 MB per site (base64 adds a
// third). A few minutes of recording filled it, and persistVoiceNotes then
// cleared the OLDEST audio whether or not it had reached the portal, and at the
// limit kept only the newest note. A recording still waiting for its
// transcript could lose its only copy (10 QSP, 15 October 2026).
//
// Now the bytes go to IndexedDB, in the same store as photos (idbPutBlob),
// under 'voice:<note id>', and the note carries `audioInIdb: true` instead of
// `audioBase64`. A note written by an older build, or on a phone where
// IndexedDB will not open, still carries `audioBase64`; moveVoiceAudioToIdb
// moves those across once the IndexedDB copy reads back. Every reader asks
// this block, never the fields directly, so the two shapes cannot drift.
const VOICE_IDB_PREFIX = 'voice:';
const voiceIdbKey = (noteId) => VOICE_IDB_PREFIX + String(noteId);
// Is this recording's audio still on the phone, in either store?
const voiceHasLocalAudio = (n) => !!(n && (n.audioBase64 || n.audioInIdb));
// The recording's bytes from the phone, or null. A null from IndexedDB is not
// proof the audio is gone (the database can fail to open); callers treat it as
// "try again later", never as "no audio".
const voiceAudioBlob = async (n) => {
  if (!n) return null;
  if (n.audioBase64) {
    try { return _voiceBase64ToBlob(n.audioBase64, n.audioMimeType); } catch (e) { return null; }
  }
  if (n.audioInIdb) {
    try { return (await idbGetBlob(voiceIdbKey(n.id))) || null; } catch (e) { return null; }
  }
  return null;
};
// Audio that may be cleared from the phone: on the portal AND transcribed.
// Anything else exists nowhere else and is never cleared. The same two
// conditions _maybeReclaimAudioBytes has always required.
const voiceAudioSafeToClear = (n) => !!(
  n && voiceHasLocalAudio(n) && n.audioUrl &&
  (String(n.transcript || '').trim() || n.transcriptionStatus === 'done'));
// The fields a NEW recording's note carries for its audio. IndexedDB first,
// confirmed by reading it back; base64 in the note only if IndexedDB fails.
// `toBase64` is the caller's own blob-to-base64 (each recorder already had
// one). Never throws: the worst case is a note with metadata and no audio,
// which is what every recorder already handled.
const voiceAudioFields = async (noteId, blob, toBase64) => {
  try {
    if (blob && await idbPutBlob(voiceIdbKey(noteId), blob, { type: 'voice', noteId: String(noteId) })) {
      const back = await idbGetBlob(voiceIdbKey(noteId));
      if (back && back.size === blob.size) return { audioBase64: null, audioInIdb: true };
    }
  } catch (e) {}
  let audioBase64 = null;
  try { audioBase64 = await toBase64(blob); } catch (e) {}
  return { audioBase64, audioInIdb: false };
};
// Clear one note's local audio after it is safe (see voiceAudioSafeToClear).
// The note is updated first and its IndexedDB copy deleted after, so a failure
// part-way leaves a stray copy, never a note pointing at nothing it needs.
const clearLocalVoiceAudio = (noteId, updates) => {
  const before = loadVoiceNotes().find(x => x && x.id === noteId);
  const w = updateVoiceNote(noteId, Object.assign({ audioBase64: null, audioInIdb: false }, updates || {}));
  if (w && w.ok === true && before && before.audioInIdb) {
    try { Promise.resolve(idbDeleteBlob(voiceIdbKey(noteId))).catch(() => {}); } catch (e) {}
  }
  return w;
};
// What the surveyor sees for a recording's audio. 'saved' means the portal has
// it; 'on phone' means only this phone does; 'not sent' means the upload gave
// up (too large, or out of attempts) and it is still on the phone.
const voiceAudioState = (n) => {
  if (!n) return null;
  if (n.audioUrl) return 'saved';
  if (!voiceHasLocalAudio(n)) return null;
  if (n.audioUploadFailed) return 'not sent';
  return 'on phone';
};
// The one storage message for a voice-store write, '' when there is nothing
// to say. Replaces three copies of the old wording, which used an em dash and
// promised the transcripts were kept over audio that might have had none.
const voiceStoreMessage = (res) => {
  if (!res) return '';
  if (res.ok !== true) return 'This phone is out of storage, so the recording was not saved. Nothing else was deleted.';
  if (res.audioPruned) return 'Storage was nearly full, so audio already saved to the portal was cleared from this phone.';
  return '';
};
// Move every base64 recording into IndexedDB, once each. Oldest first (the
// ones nearest the old limit). A note's base64 is cleared only after its
// IndexedDB copy reads back at the same size, and only if the note still holds
// those same bytes. Stops at the first IndexedDB failure: the store is not
// usable on this phone, and base64 stays exactly as it was.
let _voiceMoveInFlight = false;
const moveVoiceAudioToIdb = async () => {
  if (_voiceMoveInFlight) return { moved: 0 };
  _voiceMoveInFlight = true;
  let moved = 0;
  try {
    const todo = loadVoiceNotes()
      .filter(n => n && n.id && n.audioBase64 && !n.audioInIdb)
      .sort((a, b) => new Date(a.recordedAt || 0) - new Date(b.recordedAt || 0));
    for (const n of todo) {
      let blob = null;
      try { blob = _voiceBase64ToBlob(n.audioBase64, n.audioMimeType); } catch (e) { continue; }
      const put = await idbPutBlob(voiceIdbKey(n.id), blob, { type: 'voice', noteId: String(n.id) });
      if (!put) break;
      const back = await idbGetBlob(voiceIdbKey(n.id));
      if (!back || back.size !== blob.size) break;
      const now = loadVoiceNotes().find(x => x && x.id === n.id);
      if (!now || now.audioBase64 !== n.audioBase64) continue;
      const w = updateVoiceNote(n.id, { audioBase64: null, audioInIdb: true });
      const confirmed = loadVoiceNotes().find(x => x && x.id === n.id);
      if (w && w.ok === true && confirmed && confirmed.audioInIdb && !confirmed.audioBase64) moved += 1;
    }
  } catch (e) {
    try { debugLog('audio.idb.move.error', { error: (e && e.message) || String(e) }); } catch (e2) {}
  } finally {
    _voiceMoveInFlight = false;
  }
  if (moved) { try { debugLog('audio.idb.moved', { moved }); } catch (e) {} }
  return { moved };
};
// ==== A5_VOICE_AUDIO_STORE_END

// ==== S4B_AUDIO_SEAM_START ==============================================
// S4b (SURVEY-NOTES-V1) -- AUDIO OFF THE HANDSET
//
// The START/END markers are load-bearing: tests/audio_backfill_paces.test.js
// slices this exact region out and evaluates it standalone (no babel, no
// jsdom -- see that file's header for why). They follow the same convention
// as S1 VOICE_WATERMARK_START/END below. Anything added between the old
// end-anchor and the next unrelated comment would have been silently pulled
// into the slice; a marker this code OWNS cannot drift that way.
// S4a shipped POST /api/voice-audio on the portal and it has never had a
// client: every recording has lived and died in localStorage, where
// persistVoiceNotes nulled the OLDEST audioBase64 under quota pressure and, at
// the limit, kept only the newest note. This is the route off the device.
// (SLICE-A5: audio now lives in IndexedDB, and persistVoiceNotes clears only
// audio already uploaded and transcribed, or refuses the write. The comments
// in this seam that describe the old pruner are history.)
//
// WHY A SEPARATE QUEUE RATHER THAN A GENERALISED ONE (the brief asked for this
// decision, so it is stated rather than implied):
//   * the generic offline queue (flushOfflineQueue) hardcodes
//     Content-Type: application/json and JSON.stringify -- it structurally
//     cannot carry a multipart blob, so audio can never ride it;
//   * the PHOTO queue's retry machinery is the right shape, but its item is
//     photo-specific (projectId + src-dedup) and its success path dispatches
//     lumenPhotoUploaded, which an App-level handler turns into setProjects.
//     Parameterising identity, dedupe, uploader and event names would mean
//     refactoring the exact path that exists because 16 of 20 photos were lost
//     on LTE at Chelsea Harbour. Not worth that blast radius for this slice.
// So: own queue, own key, own item shape -- but THE CAPS ARE DERIVED FROM THE
// PHOTO CONSTANTS rather than retyped, so they cannot drift.
//
// NB the portal's /api/voice-audio ACCEPTS video/webm (that is how browsers and
// werkzeug label audio-only MediaRecorder output) while its sibling
// /api/voice-transcribe 415s it. We set the blob type explicitly from the
// note's own audioMimeType rather than letting the filename be sniffed.
const _AUDIO_RETRY_QUEUE_KEY    = 'lumen_audio_retry_queue';
const _AUDIO_RETRY_QUEUE_CAP    = 200;
const _AUDIO_RETRY_MAX_ATTEMPTS = _PHOTO_RETRY_MAX_ATTEMPTS;   // derived, never retyped
const _AUDIO_RETRY_BACKOFF_MS   = _PHOTO_RETRY_BACKOFF_MS;     // derived, never retyped
// DELIBERATE DIVERGENCE FROM THE PHOTO QUEUE: no age cap. The photo queue drops
// entries older than 7 days; for audio that would discard precisely the
// recordings most at risk from the quota pruner. Ratified 21 Aug 2026 alongside
// the trickle back-fill.
const _AUDIO_MAX_BYTES = 10 * 1024 * 1024;   // mirrors the portal's MAX_VOICE_AUDIO_BYTES

const _readAudioRetryQueue = () => {
  try {
    const arr = JSON.parse(localStorage.getItem(_AUDIO_RETRY_QUEUE_KEY) || '[]');
    return Array.isArray(arr) ? arr : [];
  } catch (e) { return []; }
};
const _writeAudioRetryQueue = (queue) => {
  try {
    let next = queue;
    if (next.length > _AUDIO_RETRY_QUEUE_CAP) next = next.slice(-_AUDIO_RETRY_QUEUE_CAP);
    localStorage.setItem(_AUDIO_RETRY_QUEUE_KEY, JSON.stringify(next));
  } catch (e) {
    debugLog('localStorage.persist.fail', { key: _AUDIO_RETRY_QUEUE_KEY, error: (e && e.message) || String(e) });
  }
};

// The queue stores the note ID ONLY, never the audio. The bytes already live in
// lumen_voice_notes; copying them here would double the quota pressure this
// slice exists to relieve.
const addToAudioRetryQueue = (noteId) => {
  if (!noteId) return;
  const queue = _readAudioRetryQueue();
  if (queue.some(e => e && e.noteId === noteId)) return;
  queue.push({ noteId, attempts: 0, last_attempt_ts: 0, queued_at: new Date().toISOString() });
  _writeAudioRetryQueue(queue);
  debugLog('audio.queued.retry', { noteId, queueLen: queue.length });
};

// One upload. Returns {ok, url} or {ok:false, error, permanent?}.
// `permanent` means DO NOT RETRY -- a 413 will 413 forever, and retrying it five
// times only burns the surveyor's battery and data to reach the same answer.
const _uploadAudioOnce = async (note, opts = {}) => {
  if (!note) return { ok: false, error: 'note_gone' };
  if (note.audioUrl) return { ok: true, alreadyUploaded: true, url: note.audioUrl };
  if (!voiceHasLocalAudio(note)) return { ok: false, error: 'no_audio' };
  // SLICE-A5: an unreadable IndexedDB copy is a retry, never 'no_audio' (which
  // the retry queue treats as resolved and drops).
  const blob = await voiceAudioBlob(note);
  if (!blob) return { ok: false, error: 'audio_unreadable' };
  const t0 = Date.now();
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), opts.timeoutMs || 30000);
  try {
    if (blob.size > _AUDIO_MAX_BYTES) {
      return { ok: false, permanent: true, error: 'too_large',
               size_bytes: blob.size, limit_bytes: _AUDIO_MAX_BYTES, ms: 0 };
    }
    const ext = String(note.audioMimeType || '').indexOf('mp4') >= 0 ? 'm4a' : 'webm';
    const fd = new FormData();
    // Explicit blob type (see the module comment) -- never filename sniffing.
    fd.append('audio', blob, 'voice.' + ext);
    const token = localStorage.getItem('lumen_token');
    const resp = await fetch(PORTAL_URL + '/api/voice-audio', {
      method: 'POST',
      headers: token ? { 'Authorization': 'Bearer ' + token } : {},
      body: fd,
      signal: controller.signal,
    });
    // SECURITY-WAVE-1 track C: a refused sign-in is not a failed upload, and
    // never permanent (see C_SIGNIN_AGAIN_SEAM).
    if (bearerRefused(resp.status, token, 'voice upload')) {
      return { ok: false, authRefused: true, error: 'HTTP ' + resp.status, ms: Date.now() - t0 };
    }
    if (resp.status === 413) {
      let detail = {};
      try { detail = await resp.json(); } catch (e) {}
      return { ok: false, permanent: true, error: 'too_large',
               size_bytes: detail.size_bytes, limit_bytes: detail.limit_bytes,
               ms: Date.now() - t0 };
    }
    if (!resp.ok) throw new Error('HTTP ' + resp.status);
    const data = await resp.json();
    if (!data || !data.url) throw new Error('no url in response');
    return { ok: true, url: data.url, size: data.size, ms: Date.now() - t0 };
  } catch (e) {
    const isAbort = e && e.name === 'AbortError';
    return { ok: false, error: isAbort ? 'timeout' : (e && e.message) || String(e),
             ms: Date.now() - t0 };
  } finally {
    clearTimeout(timeout);
  }
};

// Upload one note and record the outcome on it.
// ON SUCCESS the bytes are dropped from localStorage -- that is the whole point
// of the slice -- but ONLY after the URL is persisted AND re-read to confirm it
// landed. Never delete local audio that is not confirmed off the device: a
// quota failure on the URL write must not leave a note with neither.
const uploadNoteAudio = async (noteId) => {
  const note = loadVoiceNotes().find(n => n && n.id === noteId);
  if (!note) return { ok: false, error: 'note_gone' };
  if (note.audioUrl) return { ok: true, alreadyUploaded: true, url: note.audioUrl };
  if (!voiceHasLocalAudio(note)) return { ok: false, error: 'no_audio' };

  const res = await _uploadAudioOnce(note);
  if (res.ok && res.url) {
    const w = updateVoiceNote(noteId, {
      audioUrl: res.url, audioUploadedAt: new Date().toISOString(),
    });
    // §9 — EVERY write to the voice store could destroy audio (before SLICE-A5,
    // which made the pruner clear only safe audio). persistVoiceNotes
    // answered QuotaExceededError by nulling the OLDEST audioBase64 and, at the
    // limit, keeping only the newest note — and it returns ok:true while doing
    // it. The population most likely to trigger that is exactly this slice's
    // target (a full store), so an upload must never become a silent
    // audio-loss path. Same rule the rename sidecar already applies.
    _surfaceVoiceStorePruning(w, 'audio upload');
    // Re-read from STORAGE, not from the writer's own return value.
    // updateVoiceNote returns `{...res, all}` where `all` is the in-memory
    // array it just mutated — returned even when the persist FAILED. Trusting
    // it would confirm nothing but our own mutation, which is what an earlier
    // draft of this function did while claiming to "re-read to confirm".
    const confirmed = loadVoiceNotes().find(n => n && n.id === noteId);
    if (!w || w.ok !== true || !confirmed || confirmed.audioUrl !== res.url) {
      // The bytes are still on the device and the file is on the volume; the
      // link between them did not persist. Queue it so a later pass re-links,
      // and mark it so it is not invisible in the meantime.
      updateVoiceNote(noteId, { audioUrlPersistFailed: true });
      addToAudioRetryQueue(noteId);
      debugLog('audio.upload.url_persist_failed', { noteId, persistOk: !!(w && w.ok) });
      return { ok: false, error: 'url_persist_failed' };
    }
    // DO NOT drop the bytes yet unless the transcript is already in hand.
    //
    // A census of every audioBase64 consumer found that dropping on upload
    // alone BREAKS TRANSCRIPTION: retryPendingVoiceTranscriptions filters on
    // `n.audioBase64` and re-posts those exact bytes, so a note uploaded before
    // its transcription succeeded could never be transcribed again. That would
    // trade a recoverable recording for an unrecoverable transcript — the exact
    // inversion of S4a's ratified doctrine that the TRANSCRIPT is the record and
    // the audio is evidence attached to it.
    //
    // So the bytes are reclaimed only once BOTH are safe: the audio is on the
    // portal AND the transcript exists. `_reclaimUploadedAudio` does that on the
    // next pass for notes whose transcription completes later.
    _maybeReclaimAudioBytes(noteId);
    debugLog('audio.upload.ok', { noteId, ms: res.ms, url: res.url });
    return { ok: true, url: res.url };
  }
  if (res.permanent) {
    // Loud and terminal: mark it, do not queue. The surveyor keeps the
    // transcript; the recording stays on the device rather than being retried
    // forever against an answer that cannot change.
    updateVoiceNote(noteId, { audioUploadFailed: true, audioUploadError: res.error });
    debugLog('audio.upload.permanent_fail', { noteId, error: res.error, size_bytes: res.size_bytes });
    return res;
  }
  addToAudioRetryQueue(noteId);
  debugLog('audio.upload.queued', { noteId, error: res.error });
  return res;
};

// §9 — surface a quota prune rather than letting it happen silently.
//
// Before SLICE-A5, persistVoiceNotes responded to QuotaExceededError by
// nulling the OLDEST audioBase64 and, at the limit, keeping only the newest
// note. Now it clears only audio already uploaded and transcribed (still
// reported as audioPruned, so this surfacing stays), or refuses the write.
// The original reasoning, kept as history:
// note — and it returns { ok: true, audioPruned: true } while doing so. So
// EVERY write to the voice store is a potential audio-destruction event, and
// this slice adds several: the URL stamp, the byte reclaim, and one
// back-fill watermark per batch.
//
// The house pattern for this is already in this file: the rename sidecar
// surfaces it with a toast, labelled "a rename is not a destructive action and
// must not become a silent audio-loss path". An upload is not a destructive
// action either. Same rule, applied here.
//
// Deliberately a debugLog + window event rather than a toast: uploads happen
// in the background, often with no screen showing, so there is frequently no
// sensible place to put a toast. The event lets a surface subscribe; the log
// makes it forensically visible either way. What must NOT happen is nothing.
const _surfaceVoiceStorePruning = (writeResult, context) => {
  if (!writeResult || !writeResult.audioPruned) return false;
  debugLog('audio.store.pruned', {
    context,
    otherNotesDropped: !!writeResult.otherNotesDropped,
  });
  try {
    window.dispatchEvent(new CustomEvent('lumenVoiceAudioPruned', {
      detail: { context, otherNotesDropped: !!writeResult.otherNotesDropped },
    }));
  } catch (e) {}
  return true;
};

// Reclaim the local bytes for ONE note, but only when nothing still needs them.
// Two conditions, both required:
//   * the audio is confirmed on the portal (audioUrl), and
//   * the transcript exists — otherwise retryPendingVoiceTranscriptions, which
//     filters on audioBase64 and re-posts those bytes, could never produce one.
// Returns true if bytes were reclaimed.
const _maybeReclaimAudioBytes = (noteId) => {
  const n = loadVoiceNotes().find(x => x && x.id === noteId);
  if (!voiceAudioSafeToClear(n)) return false;
  const w = clearLocalVoiceAudio(noteId, { audioDroppedAfterUpload: true });
  _surfaceVoiceStorePruning(w, 'audio byte reclaim');
  debugLog('audio.bytes.reclaimed', { noteId });
  return true;
};

// Sweep: reclaim every note that has since become safe. Called on the same
// foreground/online signal as the flush, so a note whose transcription
// completed after its upload still gets its bytes reclaimed.
const reclaimUploadedAudioBytes = () => {
  let n = 0;
  try {
    loadVoiceNotes().forEach((v) => {
      if (v && v.id && voiceHasLocalAudio(v) && v.audioUrl) { if (_maybeReclaimAudioBytes(v.id)) n += 1; }
    });
  } catch (e) { debugLog('audio.reclaim.error', { error: (e && e.message) || String(e) }); }
  if (n) debugLog('audio.reclaim.sweep', { reclaimed: n });
  return n;
};

let _audioRetryFlushInFlight = false;
const flushAudioRetryQueue = async () => {
  if (_audioRetryFlushInFlight) return { attempted: 0, ok: 0 };
  _audioRetryFlushInFlight = true;
  try {
    // Do not spend attempts we know will fail. retryPendingVoiceTranscriptions
    // has exactly this guard; without it, five foregrounds on a site with no
    // signal exhaust _AUDIO_RETRY_MAX_ATTEMPTS and the entry is dropped having
    // never once reached the network.
    if (typeof navigator !== 'undefined' && navigator && navigator.onLine === false) {
      return { attempted: 0, ok: 0, offline: true };
    }
    const queue = _readAudioRetryQueue();
    if (queue.length === 0) return { attempted: 0, ok: 0 };
    // SECURITY-WAVE-1 track C: hold while a sign-in is needed.
    if (signInAgainNeeded()) return { attempted: 0, ok: 0, signInNeeded: true };
    const now = Date.now();
    const remaining = [];
    let attempted = 0, ok = 0, failed = 0, dropped_attempts = 0;
    let signInRefused = false;
    for (const item of queue) {
      // After a refused sign-in, keep every later recording exactly as it is.
      if (signInRefused) { remaining.push(item); continue; }
      if ((item.attempts || 0) >= _AUDIO_RETRY_MAX_ATTEMPTS) {
        // Mark the note, as the 413 path does. Without this, a recording that
        // never got off the handset is indistinguishable from one that did.
        updateVoiceNote(item.noteId, {
          audioUploadFailed: true, audioUploadError: 'retries_exhausted',
        });
        dropped_attempts += 1;
        continue;
      }
      const wait = _AUDIO_RETRY_BACKOFF_MS[item.attempts || 0] || 0;
      if (now - (item.last_attempt_ts || 0) < wait) { remaining.push(item); continue; }
      attempted += 1;
      const res = await uploadNoteAudio(item.noteId);   // sequential, never Promise.all
      if (res.authRefused) {
        // No attempt spent: the recording waits for the next sign-in.
        signInRefused = true;
        remaining.push(item);
        continue;
      }
      if (res.ok || res.permanent || res.error === 'note_gone' || res.error === 'no_audio') {
        if (res.ok) ok += 1; else failed += 1;
        continue;   // resolved either way -- drop from the queue
      }
      failed += 1;
      remaining.push({ ...item, attempts: (item.attempts || 0) + 1, last_attempt_ts: now });
    }
    _writeAudioRetryQueue(remaining);
    debugLog('audio.retry.flush', { attempted, ok, failed, dropped_attempts, remaining: remaining.length });
    return { attempted, ok, failed };
  } catch (e) {
    debugLog('audio.retry.error', { error: (e && e.message) || String(e) });
    return { attempted: 0, ok: 0 };
  } finally {
    _audioRetryFlushInFlight = false;
  }
};

// ── S4b — audioRef (LOCAL) → audio_url (PORTAL), at the wire boundary ────
// This is the actual gap the slice exists to close. A structured note carries
// `audioRef`, which is a LOCAL note id and means nothing off the device. The
// portal reads `audio_url` and CONSTRAINS it to /api/voice-audio/ on read
// (survey_notes.py) — because raw_json is whatever the device sent, and an
// arbitrary remote URL would become the src of an <audio> element on a staff
// screen: escaped, so not XSS, but a beacon firing on every view.
//
// Resolved HERE, once, at payload build — not at note-creation time — because
// the upload is asynchronous: a note created seconds before Send may only just
// have got its URL, and a note created last week got its URL from the
// back-fill. Reading the voice store at the wire is the only point that sees
// the current answer for every note at once.
//
// A note with no uploaded audio simply carries no audio_url. That is honest:
// the portal renders it as a note without a recording, which is exactly what
// it is. We never invent a URL, and we never send a local ref as if it were one.
const withAudioUrlsForPayload = (structured) => {
  if (!structured || typeof structured !== 'object') return structured;
  let byId = {};
  try {
    loadVoiceNotes().forEach((n) => { if (n && n.id) byId[String(n.id)] = n; });
  } catch (e) { byId = {}; }
  const out = {};
  Object.keys(structured).forEach((container) => {
    // A container can legitimately hold a STRING in the legacy shape — both
    // flattenZoneNotesForPayload and reconcileZoneNotesWithVoice handle that.
    // Coercing it to [] here would silently narrow the wire; pass it through
    // untouched instead, since it carries no audioRef to resolve anyway.
    if (!Array.isArray(structured[container])) { out[container] = structured[container]; return; }
    const list = structured[container];
    out[container] = list.map((n) => {
      if (!n || !n.audioRef) return n;
      const vn = byId[String(n.audioRef)];
      const url = vn && typeof vn.audioUrl === 'string' ? vn.audioUrl : '';
      // Send ONLY our own path. Anything else is dropped rather than forwarded:
      // the portal would reject it anyway, and a device that somehow held a
      // foreign URL must not be the thing that discovers that.
      if (!url || url.indexOf('/api/voice-audio/') !== 0) return n;
      return Object.assign({}, n, { audio_url: url });
    });
  });
  return out;
};

// ── S4b — the TRICKLE BACK-FILL (ratified 21 Aug 2026) ───────────────────
// Recordings already stranded on handsets are real evidence one quota event
// from deletion, so they are uploaded too. A TRICKLE, not a flush: this runs
// on a device that may be on LTE at a site, and a Promise.all storm here is
// exactly the shape that lost 16 of 20 photos at Chelsea Harbour.
//
// The four ratified rules, each visible below:
//   1. SEPARATE PASS that never blocks the on-stop upload — a new recording is
//      at greatest risk and goes first, so this is only ever called on
//      foreground/sync, never from a recorder's onstop.
//   2. OLDEST-FIRST — the oldest surviving audioBase64 sits nearest the pruner.
//   3. ONCE PER NOTE, EVER — stamped durably BEFORE the attempt, so a relaunch
//      (or a kill mid-back-fill) cannot re-upload. This mirrors the
//      `adoptConsidered` watermark: the recording has had its one chance, and
//      failure is then owned by the retry queue, which has its own attempt cap.
//      Stamping AFTER would let a crash loop re-upload the same note forever.
//   4. 3-CONCURRENT MAXIMUM, sequential batches.
// No age cap, deliberately — see the constants above.
const _AUDIO_BACKFILL_CONCURRENCY = 3;

const _needsAudioBackfill = (n) => !!(
  n && n.id && voiceHasLocalAudio(n) && !n.audioUrl &&
  !n.audioBackfillConsidered && !n.audioUploadFailed
);

let _audioBackfillInFlight = false;
const backfillVoiceAudio = async (opts = {}) => {
  if (_audioBackfillInFlight) return { picked: 0, ok: 0 };
  // SECURITY-WAVE-1 track C: a note gets ONE back-fill chance (rule 3 below);
  // do not spend it while the portal is refusing the sign-in.
  if (signInAgainNeeded()) return { picked: 0, ok: 0, signInNeeded: true };
  _audioBackfillInFlight = true;
  try {
    const pending = loadVoiceNotes()
      .filter(_needsAudioBackfill)
      .sort((a, b) => new Date(a.recordedAt || 0) - new Date(b.recordedAt || 0));
    if (!pending.length) return { picked: 0, ok: 0 };
    const limit = opts.limit || pending.length;
    const batchSize = opts.concurrency || _AUDIO_BACKFILL_CONCURRENCY;
    const work = pending.slice(0, limit);
    debugLog('audio.backfill.start', { pending: pending.length, taking: work.length });

    let ok = 0, failed = 0;
    for (let i = 0; i < work.length; i += batchSize) {
      const batch = work.slice(i, i + batchSize);
      // Stamp the whole batch BEFORE attempting it (rule 3) -- but surface any
      // prune the stamp itself causes. The stamp is a write, and a write to a
      // full store could (before SLICE-A5) null the OLDEST audioBase64, which oldest-first means is
      // very likely the note we are about to upload. It would then return
      // no_audio against an already-durable watermark: the one ordering in
      // which the once-ever rule can consume a recording.
      batch.forEach((n) => {
        const w = updateVoiceNote(n.id, { audioBackfillConsidered: true });
        _surfaceVoiceStorePruning(w, 'back-fill watermark');
      });
      const results = await Promise.all(
        batch.map(n => uploadNoteAudio(n.id).catch(e => ({ ok: false, error: String(e) })))
      );
      results.forEach(r => { if (r && r.ok) ok += 1; else failed += 1; });
      // A refused sign-in: the rest wait (their one chance unspent); the
      // refused ones are already on the retry queue, attempts unspent.
      if (results.some(r => r && r.authRefused)) break;
    }
    debugLog('audio.backfill.done', { picked: work.length, ok, failed });
    return { picked: work.length, ok, failed };
  } catch (e) {
    debugLog('audio.backfill.error', { error: (e && e.message) || String(e) });
    return { picked: 0, ok: 0 };
  } finally {
    _audioBackfillInFlight = false;
  }
};

// ==== S4B_AUDIO_SEAM_END ================================================

// ── S94 — Generic companion event write ──────────────
// Posts {event_type, project_name?, metadata?} to /api/companion/event.
// Mirrors the try/catch + queueWrite pattern used by /api/survey-wrap so a
// failed write (offline / CORS / portal down) is queued in lumen_offline_queue
// for replay rather than silently dropped. Never throws — callers can fire
// and forget without try/catch around the call site.
//
// client_event_id is stamped at COMPOSE time, before queueWrite can ever see
// the body — so an offline replay carries the identical id and the portal's
// UNIQUE(tenant_id, dedupe_key) absorbs it as a no-op. A caller that already
// has a stable id (the voice note id) passes client_event_id in the payload;
// the spread comes after the generated id, so the caller's id wins.
const _genClientEventId = () => {
  try {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }
  } catch (e) { /* fall through to the non-crypto id */ }
  return 'ce-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
};

const writePortalEvent = async (eventType, payload = {}) => {
  const endpoint = '/api/companion/event';
  const body = { client_event_id: _genClientEventId(), event_type: eventType, ...payload };
  try {
    const tk = localStorage.getItem('lumen_token');
    const res = await fetch(`${PORTAL_URL}${endpoint}`, {
      method: 'POST',
      headers: Object.assign({ 'Content-Type': 'application/json' }, tk ? { 'Authorization': `Bearer ${tk}` } : {}),
      body: JSON.stringify(body)
    });
    bearerRefused(res.status, tk, 'event');   // track C: a 401 ends the sign-in
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return true;
  } catch (e) {
    console.warn(`[Event] ${eventType} write failed, queued for retry:`, e && e.message ? e.message : e);
    queueWrite(endpoint, body);
    return false;
  }
};

// ── S96 BRIEF A · D25 — canonical zone-name normaliser ───────
// Single source of truth for zoneFittings keys. All reads AND writes against
// the zoneFittings dict must go through this so case/whitespace differences
// (`Reception` vs `reception` vs ` Reception `) collapse to one bucket.
// Display strings continue to come from the `zones` array (original casing).
const zoneKey = (name) => (name == null ? '' : String(name)).trim().toLowerCase();

// ── S107 — project-name normaliser used for portal-authority match ─────
// The portal returns project_name as the user typed it (case + punctuation
// preserved). Local projects carry the same field but may have been edited
// after submit (whitespace, capitalisation, em-dash drift). Normalise to
// alphanumeric-lowercase so "Michaela Community School", "michaela community
// school", and "Michaela_Community_School" all collapse to one key. Same
// behaviour as the inbox grouping at static/js/inbox.js:90-92 on the portal.
const _normProjName = (s) =>
  (s == null ? '' : String(s)).toLowerCase().replace(/[^a-z0-9]/g, '');

// ── S99 — single source of truth for survey state ─────────────
// Returns one of 'archived' | 'submitted' | 'live' | 'planned'.
// Every screen that branches on survey state MUST go through this
// helper. Adding a new state in future means changing only this
// function — no filter logic anywhere else needs updating.
//
// Rule order (first match wins):
//   1. project.archived === true                                 → 'archived'
//   2. project.surveyWrapCompletedAt is set                      → 'submitted'
//   3. project.surveyZones contains any fitting with qty > 0     → 'live'
//   4. (default — covers brand-new projects and any project with
//       a matching survey_queue row that hasn't logged a fitting) → 'planned'
//
// Legacy stage:'surveyed' on disk is intentionally NOT a signal here.
// Earlier code (pre-S99) wrote it on every fitting log, which created
// phantom "Planned" cards on SurveyLandingScreen. Treat stage='surveyed'
// as 'submitted' ONLY when surveyWrapCompletedAt is also present (caught
// by rule 2); otherwise ignore the flag and fall through to the
// surveyZones / default rules.
//
// ==== S135 PERSISTENCE_LOGIC_START ───────────────────────────────────────
// Pure, side-effect-free draft-lifecycle helpers. Single source of truth for
// the cold-start resume and the wrap-clear gate. tests/persistence.test.js
// slices this block (START→END markers) and exercises it under node:test —
// app.js is JSX and cannot be required directly, so the test evaluates just
// this pure region. Keep everything here free of React / browser globals.
const getSurveyState = (project) => {
  if (!project || typeof project !== 'object') return 'planned';
  if (project.archived === true) return 'archived';
  if (project.surveyWrapCompletedAt) return 'submitted';
  const zones = project.surveyZones;
  if (Array.isArray(zones)) {
    for (const z of zones) {
      if (z && Number(z.qty || 0) > 0) return 'live';
    }
  }
  return 'planned';
};

// localStorage key for the single, stable in-progress survey draft.
const ACTIVE_DRAFT_KEY = 'survey_active';

// The ONLY fields permitted to persist into survey_active. Sub-view / modal /
// inline-edit flags must never land here (a leaked flag boots resume into
// note-edit instead of zone detail). LiveSurveyScreen aliases this list.
const ACTIVE_DRAFT_FIELDS = [
  'projectId', 'surveyName', 'surveyType', 'contactName', 'currentStage',
  'zones', 'currentZoneIndex', 'zoneFittings', 'zoneNotes', 'sitePhotos',
  'startedAt', 'savedAt',
];

// Build the allow-listed survey_active snapshot from a raw source object.
const buildActiveDraft = (source) => {
  const src = source || {};
  const out = {};
  for (let i = 0; i < ACTIVE_DRAFT_FIELDS.length; i++) {
    const k = ACTIVE_DRAFT_FIELDS[i];
    if (src[k] !== undefined) out[k] = src[k];
  }
  return out;
};

// The draft-clear GATE. A draft may be cleared ONLY on a confirmed-successful
// submit. `outcome` is the wrap mode string ('success' | 'queued' | 'error')
// or a result object {ok, status, reason}. Anything that is not a confirmed
// success (or an explicit server "duplicate" ack) returns false, so the draft
// survives offline / failure / unknown — never lose a survey.
const shouldClearActiveDraft = (outcome) => {
  if (outcome === 'success') return true;
  if (outcome && typeof outcome === 'object') {
    if (outcome.ok === true) return true;
    if (outcome.status === 409 && outcome.reason === 'duplicate') return true;
  }
  return false;
};

// The surveyor-facing fitting label: "Panel · 600×600 · PIR". The area screen
// reads the fitting name back as the part before the first " · ", so the name
// must stay first. Hoisted here from LiveSurveyScreen so the one line shape
// below can use it. Pure.
const buildVarLabel = (name, primary, secondary, extras) => {
  const parts = [name];
  if (primary) parts.push(primary);
  if (secondary) parts.push(secondary);
  if (extras) Object.values(extras).filter(Boolean).forEach(v => parts.push(v));
  return parts.join(" · ");
};

// ONE editor entry (a zoneFittings line) → ONE project surveyZones line. This is
// the only place that shape is built: LiveSurveyScreen's persist() and the
// cold-start resume (draftZoneFittingsToSurveyZones) both call it, so the two
// can never drift apart again. They did: the resume converter wrote only
// {uid, zone, qty, emQty, unit:{wattage, replacementW}}, so after a cold-start
// resume every line hydrated as "Fitting"/"unknown" and the next save wrote
// that over the real type, size, extras and photos (RESUME-KEEPS-TYPE).
// costOrNull lives in the EVA-H COST_LOGIC block further down; it is defined at
// module load, long before any survey line is built. Pure.
const surveyLineFromEntry = (zone, e) => ({
  uid: e.uid,
  zone,
  primary: e.primary,
  secondary: e.secondary,
  extras: e.extras,
  unit: {
    id: `${e.fixtureId}-${e.primary||""}`,
    label: buildVarLabel(e.fixtureName, e.primary, e.secondary, e.extras),
    wattage: e.existingW,
    replacementW: e.ledW,
    unitCost: costOrNull(e.cost),
    savingBasis: "energy",
  },
  qty: e.qty,
  emQty: e.emQty,
  photos: e.photos || [],
});

// Convert the editor's zoneFittings map → the project's surveyZones array,
// through surveyLineFromEntry, so it is exactly the shape persist() writes and
// a merged draft both classifies correctly through getSurveyState and hydrates
// with its fitting type intact. Pure.
const draftZoneFittingsToSurveyZones = (zoneFittings) => {
  if (!zoneFittings || typeof zoneFittings !== 'object') return [];
  const out = [];
  const zoneNames = Object.keys(zoneFittings);
  for (let i = 0; i < zoneNames.length; i++) {
    const zone = zoneNames[i];
    const entries = zoneFittings[zone];
    if (!Array.isArray(entries)) continue;
    for (let j = 0; j < entries.length; j++) {
      out.push(surveyLineFromEntry(zone, entries[j] || {}));
    }
  }
  return out;
};

// Resume rehydration. Merge a survey_active draft over its persisted project
// row so a cold start lands back EXACTLY where the surveyor was. The draft's
// survey fields win when it is at least as fresh as the row (savedAt vs
// updatedAt) OR the row lacks fittings; if the row is gone entirely (lost but
// the draft survived), reconstruct a minimal project so work is never
// stranded. Pure.
const mergeDraftIntoProject = (projectRow, draft) => {
  if (!draft || typeof draft !== 'object' || !draft.projectId) {
    return projectRow || null;
  }
  const draftSurveyZones = draftZoneFittingsToSurveyZones(draft.zoneFittings);
  const base = projectRow ? Object.assign({}, projectRow) : {
    id: draft.projectId,
    name: draft.surveyName || '',
    client: draft.contactName || '',
    stage: 'enquiry',
    createdAt: draft.startedAt || draft.savedAt || 0,
  };
  const rowTs = (projectRow && Number(projectRow.updatedAt)) || 0;
  const draftTs = Number(draft.savedAt) || 0;
  const rowHasFittings = Array.isArray(base.surveyZones) &&
    base.surveyZones.some(z => z && Number(z.qty || 0) > 0);
  const draftWins = !projectRow || draftTs >= rowTs || !rowHasFittings;
  if (draftWins) {
    base.surveyZones = draftSurveyZones;
    base.customZones = Array.isArray(draft.zones) ? draft.zones : (base.customZones || []);
    base.zoneNotes = draft.zoneNotes || base.zoneNotes || {};
    if (Array.isArray(draft.sitePhotos)) base.sitePhotos = draft.sitePhotos;
  }
  return base;
};

// The cold-start resume DECISION, routed through getSurveyState as the SOLE
// classifier (no parallel state vocabulary). Returns { resume, state, project }.
const classifyResume = (projectRow, draft) => {
  const project = mergeDraftIntoProject(projectRow, draft);
  const state = getSurveyState(project);
  return { resume: state === 'live', state: state, project: project };
};

// ─── B.2 Slice 1 — capture-time project binding (single code path) ────────
// The binding lives ON the project record as `project.projectBinding`:
//   { project_id: 'PRJ-XXXX' | null, project_name, client_name,
//     picked_at, source: 'picker' | 'none' }
// Absent field = not chosen yet (legal; unbound on the wire).
// project_id: null = the user explicitly chose "No project".
// This accessor pair is the ONLY read/write path for the field — snags and
// voice (Slices 2–3) will read through the same pair. Deliberately NOT a
// floating global localStorage key: a global that outlives the active
// project would leak a binding onto the next survey (approximation by
// accident).
// Persistence through cold-start resume: verified — mergeDraftIntoProject
// copies the persisted project row FIRST and only overlays survey fields,
// so projectBinding survives via asg_projects_<userId> with no
// ACTIVE_DRAFT_FIELDS entry. (Sole exception: the row is lost entirely and
// reconstructed minimal from the draft — the binding is absent and the
// capture honestly stays unbound. Never approximated.)
// No name-matching feeds this field, ever — the user picks, or it's null
// (skill §11: name-norm groups, ids bind).
const getProjectBinding = (project) => {
  const b = project && project.projectBinding;
  return (b && typeof b === 'object') ? b : null;
};

// Returns the normalised `{ projectBinding }` patch for onUpdateProject /
// onCreateProject — React state + asg_projects persistence stay the owners;
// this never mutates. Pass binding = null to clear back to "not chosen".
const setProjectBinding = (project, binding) => {
  if (!binding || typeof binding !== 'object') {
    return { projectBinding: undefined };
  }
  return {
    projectBinding: {
      project_id: binding.project_id || null,
      project_name: binding.project_name || '',
      client_name: binding.client_name || '',
      picked_at: binding.picked_at || new Date().toISOString(),
      source: binding.source === 'picker' ? 'picker' : 'none',
    },
  };
};

// ─── B.2 Slice 2 — shared binding UI (extracted from QuickEntry, Slice 1) ──
// One card + one sheet serve every capture context (surveys, snags; voice in
// Slice 3). Duplicating the sheet would be a second code path by another name
// (skill §5 — multiple entry points are the #1 bug source), so snags REUSE
// these. `accent` carries the context chrome family ONLY — the bound-state
// PRJ chip semantics (mono green id + green check) are identical everywhere,
// so a confirmed bind reads the same in any context.
const BIND_ACCENT_SURVEY = {
  strong: '#2E6838',                  // survey/plans green (skill §18)
  border: 'rgba(46,104,56,0.38)',
  btnBg: 'rgba(46,104,56,0.10)',
  btnBorder: 'rgba(46,104,56,0.30)',
  selBg: 'rgba(46,104,56,0.10)',
  noProjBg: 'rgba(46,104,56,0.07)',
};
const BIND_ACCENT_SNAG = {
  // Sage-teal — the snag chrome family (snag_workspace_v3; S138.2 ratified
  // that terracotta is the snag PIN/type-marker only, never chrome). Literal
  // rgba of #4A6462 because SNAG_TEAL is a const declared much later in the
  // file — referencing it here would be a TDZ ReferenceError at module eval.
  strong: '#4A6462',
  border: 'rgba(74,100,98,0.45)',
  btnBg: 'rgba(74,100,98,0.10)',
  btnBorder: 'rgba(74,100,98,0.35)',
  selBg: 'rgba(74,100,98,0.10)',
  noProjBg: 'rgba(74,100,98,0.07)',
};

// 'none' = not chosen yet · 'bound' = picked a PRJ · 'noproject' = explicit
// No project. All three keep the context's primary CTA enabled (ratified —
// binding is optional and never blocks dispatch).
const bindingStateOf = (binding) => !binding ? 'none' : (binding.project_id ? 'bound' : 'noproject');


// ─── B.2 Slice 3 — shared project-feed accessors ───────────────────────────
// The ONE place the lumen_projects cache (9th syncPortalData GET) is read and
// the ONE place a feed row / "no project" choice becomes a binding object.
// ProjectPickerSheet and VoiceModal both go through these, so the option
// semantics (PRJ-or-explicit-null, picked_at stamp, source vocabulary) cannot
// drift between surfaces. Call once per open (useState initialiser) — offline
// = stale list, and the staleness line says so plainly.
const readProjectFeedCache = () => {
  let feed = null;
  try { feed = JSON.parse(localStorage.getItem('lumen_projects') || 'null'); }
  catch (e) { feed = null; }
  let syncedAt = null;
  try { syncedAt = localStorage.getItem('lumen_projects_synced_at'); } catch (e) { syncedAt = null; }
  const rows = (feed && Array.isArray(feed.projects)) ? feed.projects : [];
  const ageMin = syncedAt
    ? Math.max(0, Math.round((Date.now() - new Date(syncedAt).getTime()) / 60000))
    : null;
  return { rows, syncedAt, ageMin };
};
const bindingFromFeedRow = (p) => ({
  project_id: p.id, project_name: p.name, client_name: p.client_name,
  picked_at: new Date().toISOString(), source: 'picker',
});
const bindingNone = () => ({
  project_id: null, project_name: '', client_name: '',
  picked_at: new Date().toISOString(), source: 'none',
});
// B.2 Slice 4 — binding for a project minted at capture (POST 201). isNew
// drives the NEW tag + "Created from site" line on the card; the wire is
// untouched (dispatch reads project_id exactly like a picked binding).
const bindingFromCreatedProject = (p) => ({
  project_id: p.id, project_name: p.name, client_name: p.client_name,
  picked_at: new Date().toISOString(), source: 'created', isNew: true,
});
// B.2 Slice 4 — optimistic cache append so a just-created project appears in
// the picker immediately. Same key the 9th syncPortalData GET overwrites on
// the next sync — a local patch, never a second cache mechanism.
const appendProjectToFeedCache = (p) => {
  try {
    const feed = JSON.parse(localStorage.getItem('lumen_projects') || 'null') || {};
    const rows = Array.isArray(feed.projects) ? feed.projects : [];
    if (!rows.some(r => r && r.id === p.id)) {
      rows.unshift({ id: p.id, name: p.name || '', client_name: p.client_name || '', stage: p.stage || 'enquiry' });
    }
    feed.projects = rows;
    localStorage.setItem('lumen_projects', JSON.stringify(feed));
  } catch (e) { /* cache-only nicety - the binding itself already carries the id */ }
};

// Pick the best displayable source for a photo/video ref, in DURABILITY order:
// an uploaded portal URL (http) → an object URL the caller resolved from an
// IndexedDB blob → a legacy base64 data src. Returns '' when nothing is
// displayable, so the caller renders a placeholder rather than a broken "?".
const choosePhotoSrc = (photo, resolved) => {
  if (!photo || typeof photo !== 'object') return '';
  if (typeof photo.url === 'string' && photo.url.indexOf('http') === 0) return photo.url;
  if (typeof photo.src === 'string' && photo.src.indexOf('http') === 0) return photo.src;
  if (typeof resolved === 'string' && resolved) return resolved;
  if (typeof photo.src === 'string' && photo.src.indexOf('data:') === 0) return photo.src;
  return '';
};

// Shape a photo for PERSISTENCE. Drops the heavy transient `src` (base64 data:
// or in-memory blob:) ONLY when a durable alternative exists — an uploaded http
// url, OR an IndexedDB blob keyed by `id`. This keeps localStorage free of
// base64 so it can't blow quota (the stale-snapshot loss that rendered reopened
// photos as "?"). A legacy photo with neither url nor id keeps its base64 — it
// is the only copy and must never be dropped.
const photoToRef = (photo) => {
  if (!photo || typeof photo !== 'object') return photo;
  const hasHttp = (typeof photo.url === 'string' && photo.url.indexOf('http') === 0) ||
                  (typeof photo.src === 'string' && photo.src.indexOf('http') === 0);
  const hasBlob = !!photo.id;
  const srcIsTransient = typeof photo.src === 'string' &&
    (photo.src.indexOf('data:') === 0 || photo.src.indexOf('blob:') === 0);
  const out = {};
  const keys = Object.keys(photo);
  for (let i = 0; i < keys.length; i++) {
    const k = keys[i];
    if (k === 'src' && srcIsTransient && (hasHttp || hasBlob)) continue; // drop — durable copy exists
    out[k] = photo[k];
  }
  if (!out.url && typeof photo.src === 'string' && photo.src.indexOf('http') === 0) out.url = photo.src;
  return out;
};
const photosToRefs = (photos) => Array.isArray(photos) ? photos.map(photoToRef) : photos;

// S136 — flatten the stacked-note model {zone: [{type,body,t}] | legacyString}
// back to the portal's {zone: string} contract for /api/survey-wrap. Pure.
//
// S3 (SURVEY-NOTES-V1) — '__project__' is NO LONGER excluded. S136 dropped it
// on the grounds that it rode the additive structured field and so kept the
// portal contract unchanged; the portal never adopted that field (survey-wrap
// stores only the flat `zoneNotes`), so Site-wide notes died here, before the
// wire. Site-wide is the container whose entire job is "photos and notes not
// tied to one area" — the one place notes are the only content — so it was
// exactly the wrong thing to drop.
//
// WIRE CONTRACT: '__project__' is now an ordinary key of the flat `zoneNotes`
// map, carrying the same joined-bodies string as any zone. No new key, no shape
// change. It is inert on the portal until S2 reads it: survey-wrap stores
// `zoneNotes` verbatim, and the zone-schedule renderer looks up by zone NAME,
// which '__project__' never matches.
const flattenZoneNotesForPayload = (zoneNotes) => {
  if (!zoneNotes || typeof zoneNotes !== 'object') return zoneNotes || {};
  const out = {};
  Object.keys(zoneNotes).forEach((k) => {
    const v = zoneNotes[k];
    if (Array.isArray(v)) {
      const joined = v.map((n) => (n && n.body) ? String(n.body) : '').filter(Boolean).join('\n');
      if (joined) out[k] = joined;
    } else if (typeof v === 'string' && v.trim()) {
      out[k] = v;
    }
  });
  return out;
};
// The first note with real text, for the wrap's "What's being sent" line.
// Returns { key, text, siteWide } or null. It reads through
// flattenZoneNotesForPayload, so it sees exactly the bodies the send ships
// (pending notes have none and never show); text is the first non-empty line.
const firstNoteForSummary = (zoneNotes) => {
  const flat = flattenZoneNotesForPayload(zoneNotes);
  const key = Object.keys(flat)[0];
  if (!key) return null;
  const text = String(flat[key]).split('\n').map((s) => s.trim()).find(Boolean) || '';
  return text ? { key, text, siteWide: key === '__project__' } : null;
};

// ==== S1B PAYLOAD_NOTES_LOGIC_START =====================================
// SURVEY-NOTES-V1 S1b — the send reads the authoritative store, not the prop.
//
// The wrap payload sourced zone notes from `activeProject?.zoneNotes`. The
// survey workspace maintains zoneNotesRef AND writes survey_active
// synchronously on every note commit precisely BECAUSE that prop lags (S95 D2 /
// D5) — the ref exists as a standing admission that the prop cannot be trusted
// at the moment of a write. SurveyWrapScreen is a DIFFERENT component and has
// no access to that ref, so it reads the same store the workspace writes:
// survey_active, keyed on the project it belongs to.
//
// This is the same priority chain LiveSurveyScreen itself uses on mount and on
// rehydrate: survey_active (latest, written inline) → project prop → {}.
// Pure: takes the already-parsed draft and the project, returns the notes map.
// The payload's SHAPE and KEYS are unchanged — this only fixes where the value
// is read from.
const resolveZoneNotesForPayload = (activeDraft, project) => {
  const pid = project && project.id;
  if (activeDraft && pid && activeDraft.projectId === pid
      && activeDraft.zoneNotes && typeof activeDraft.zoneNotes === 'object'
      && !Array.isArray(activeDraft.zoneNotes)) {
    return activeDraft.zoneNotes;
  }
  return (project && project.zoneNotes) || {};
};
// ==== S1B PAYLOAD_NOTES_LOGIC_END =======================================

// Decide whether a photo needs its base64 recovered from IndexedDB before a
// wrap-submit upload: ONLY when it has a durable IDB id but is not already
// uploaded (no url), not still carrying base64, and not a video (videos are
// never /api/photo-uploaded). Pure; the IDB read itself is I/O done elsewhere.
const needsIdbHydration = (photo) => {
  if (!photo || typeof photo !== 'object') return false;
  if (photo.type === 'video') return false;
  if (photo.url) return false;
  if (typeof photo.src === 'string' && photo.src.indexOf('data:') === 0) return false;
  if (!photo.id) return false;
  return true;
};

// Merge local submitted surveys with canonical portal echoes for the Recently
// Submitted list. Dedupe each echo against BOTH the local row id and the
// canonical portal id stamped on it (_portalSurveyId), so a survey wrapped on
// this device (whose local row carries _portalSurveyId) shows exactly once,
// while a portal-only survey (no local row) is still surfaced. Pure: identity
// is by real id only, never by name (skill section 11).
const mergeRecentSurveys = (recentSurveys, portalSurveys) => {
  const local = Array.isArray(recentSurveys) ? recentSurveys : [];
  const echoes = Array.isArray(portalSurveys) ? portalSurveys : [];
  const localIds = new Set(local.map(p => p && p.id).filter(Boolean));
  const localPortalIds = new Set(local.map(p => p && p._portalSurveyId).filter(Boolean));
  return [
    ...local,
    ...echoes.filter(s => s && !localIds.has(s.id) && !localPortalIds.has(s.id)),
  ];
};
// ==== S135 PERSISTENCE_LOGIC_END ─────────────────────────────────────────

// S107 portal-authority hydration: which local job a portal survey row is, by
// id only: the job id of the shell made from that row (portal_<id>), or the
// portal survey id a job carries once it is sent (_portalSurveyId). Never by
// name: a later job can share an earlier survey's name, and a name match
// marked that later job sent. Returns the index in `projects`, or -1. Pure.
const portalSurveyLocalIndex = (projects, ps) => {
  if (!ps || ps.id == null || ps.id === '') return -1;
  const sid = String(ps.id);
  return (Array.isArray(projects) ? projects : []).findIndex(p => !!p
    && (p.id === 'portal_' + sid || (p._portalSurveyId != null && p._portalSurveyId !== '' && String(p._portalSurveyId) === sid)));
};

// --- B.2 shared binding UI (ProjectBindingCard / picker sheet / echo) ---
// Moved OUT of the S135 pure block (S160.1): these are JSX components, and
// tests/persistence.test.js evaluates that block as plain JS - JSX inside it
// is a SyntaxError that kills the whole suite at load. The pure binding
// helpers (getProjectBinding, bindingStateOf, readProjectFeedCache, binding
// factories, BIND_ACCENT_*) stay in the block; only render code lives here.
// The binding card — three states, token-for-token the Slice 1 card with the
// context chrome parameterised. The caller owns its surrounding label.
const ProjectBindingCardBody = ({ binding, onChoose, accent, unboundHint }) => {
  const a = accent || BIND_ACCENT_SURVEY;
  const bindState = bindingStateOf(binding);
  // Track 4 (switch on): the green tick is ink; the walker (studioCapture) takes
  // the rest of the card onto the Studio surfaces.
  const tick = t.theme === 'uv' ? STUDIO_TOKENS.ink : '#2E6838';
  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 12, padding: '13px 14px',
      background: 'rgba(255,252,242,0.88)',
      borderTop: '1px solid rgba(255,255,250,0.96)',
      borderLeft: bindState === 'bound' ? `1px solid ${a.border}` : '1px solid rgba(26,22,8,0.06)',
      borderRight: bindState === 'bound' ? `1px solid ${a.border}` : '1px solid rgba(26,22,8,0.06)',
      borderBottom: bindState === 'bound' ? `1px solid ${a.border}` : '1px solid rgba(26,22,8,0.06)',
      borderRadius: 14,
    }}>
      <div style={{
        width: 36, height: 36, borderRadius: 10, flexShrink: 0,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: bindState === 'bound' ? 'rgba(46,104,56,0.12)' : 'transparent',
        border: bindState === 'bound' ? 'none' : '1.5px dashed rgba(26,22,8,0.25)',
      }}>
        {bindState === 'bound' ? (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={tick} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
        ) : (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="rgba(26,22,8,0.35)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71"/></svg>
        )}
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        {bindState === 'bound' ? (
          <>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 2 }}>
              <span style={{ fontSize: 10.5, fontWeight: 700, color: '#2E6838', fontFamily: 'JetBrains Mono, monospace', letterSpacing: 0.4 }}>{binding.project_id}</span>
              {binding.isNew && (
                <span style={{ fontSize: 9, fontWeight: 800, letterSpacing: 0.8, background: '#2E6838', color: '#FAF6EC', borderRadius: 6, padding: '2.5px 7px', ...uvx(() => ({ background: 'transparent', color: STUDIO_MEANING.newText, letterSpacing: 'normal', fontWeight: 700, padding: 0, borderRadius: 0 })) }}>{t.theme === 'uv' ? 'New' : 'NEW'}</span>
              )}
            </div>
            <div style={{ fontSize: 13, fontWeight: 700, color: t.colors.text, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{binding.project_name}</div>
            {binding.isNew ? (
              <div style={{ fontSize: 11, color: t.colors.textTertiary, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>Created from site - flagged for office review</div>
            ) : binding.client_name ? <div style={{ fontSize: 11, color: t.colors.textTertiary, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{binding.client_name}</div> : null}
          </>
        ) : bindState === 'noproject' ? (
          <>
            <div style={{ fontSize: 13, fontWeight: 700, color: t.colors.text }}>No project</div>
            <div style={{ fontSize: 11, color: t.colors.textTertiary, lineHeight: 1.4 }}>This capture stays unbound. Route it from the portal inbox later.</div>
          </>
        ) : (
          <>
            <div style={{ fontSize: 13, fontWeight: 700, color: t.colors.text }}>Not linked yet</div>
            <div style={{ fontSize: 11, color: t.colors.textTertiary, lineHeight: 1.4 }}>{unboundHint || (t.theme === 'uv' ? 'Link this survey to a portal project so it reaches the right job.' : 'Link this survey to a portal project so it lands bound.')}</div>
          </>
        )}
      </div>
      <button onClick={onChoose} style={{
        flexShrink: 0, background: a.btnBg, border: `1px solid ${a.btnBorder}`,
        borderRadius: 9, padding: '8px 14px', fontSize: 12, fontWeight: 700, color: a.strong,
        cursor: 'pointer', fontFamily: 'inherit',
      }}>{bindState === 'none' ? 'Choose' : 'Change'}</button>
    </div>
  );
};

const ProjectBindingCard = (props) => studioCapture(ProjectBindingCardBody(props));

// Staleness line — always honest about cache age. Shared by sheet + VoiceModal.
const ProjectFeedStaleness = (props) => studioCapture(ProjectFeedStalenessBody(props));
const ProjectFeedStalenessBody = ({ syncedAt, ageMin }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 6 }}>
    <div style={{ width: 6, height: 6, borderRadius: '50%', flexShrink: 0, background: (syncedAt && ageMin !== null && ageMin <= 10) ? '#2E6838' : 'rgba(26,22,8,0.30)' }} />
    <span style={{ fontSize: 11, color: 'rgba(26,22,8,0.5)' }}>
      {syncedAt
        ? `Project list synced ${ageMin === 0 ? 'just now' : `${ageMin} min ago`}`
        : `Project list not synced yet${studioDash()}connect to refresh`}
    </span>
  </div>
);

// The bottom-sheet picker — reads ONLY the lumen_projects cache via the
// shared accessor above. Mounts fresh on every open, so the useState
// initialiser is the same once-per-open cache read the Slice 1 memo did.
// Portal projects only, plus first-class "No project" — no name-matching,
// no preselection.
//
// B.2 Slice 4 — create-at-capture. Two ADDITIVE views inside this same
// sheet (never a new surface): 'create' (name + client prefilled from the
// host form) and 'dym' ("Did you mean?" — the portal's 200 candidates).
// Rules locked by the brief:
//   - online-only (D1d): offline the "+ New project" row is inert with the
//     OFFLINE tag. Creation is never queued — a queued create can't return
//     an id to bind the capture in hand, and replays mint duplicates.
//   - refuse-don't-approximate: candidates PRESENT, the user chooses.
//     "Link to this" is a normal pick (no isNew); "Create anyway" repeats
//     the POST with force:true.
//   - errors are honest and inline; nothing bound, nothing cached, no
//     automatic retry.
// `prefill` carries the host form's typed values ({name, client_name,
// site_address?} — site input renders only when the host has the field).
// `noun` adjusts copy per context ('survey' | 'snag job'). `initialView` /
// `initialCandidates` / `offlineOverride` are render-check/preview seams
// only — real callers never pass them.
const ProjectPickerSheetBody = ({ binding, onApply, onClose, accent, prefill, noun,
                              initialView, initialCandidates, offlineOverride }) => {
  const a = accent || BIND_ACCENT_SURVEY;
  // Track 4 (switch on): ticks are ink, an error is the needs-attention word,
  // and the one main action in the create view is the ultraviolet button.
  const tick = t.theme === 'uv' ? STUDIO_TOKENS.ink : '#2E6838';
  const errCol = t.theme === 'uv' ? STUDIO_MEANING.rustText : '#C85040';
  const captureNoun = noun || 'survey';
  const pf = prefill || {};
  const [search, setSearch] = useState('');
  const [{ rows: feedRows, syncedAt: feedSyncedAt, ageMin: feedAgeMin }] = useState(() => readProjectFeedCache());
  // Slice 4 view state. The established reachability read is
  // navigator.onLine (the app-root isOnline pattern); listeners keep the
  // row honest if the connection drops while the sheet is open.
  const [view, setView] = useState(initialView || 'list');
  const [isOnline, setIsOnline] = useState(() => (
    offlineOverride !== undefined ? !offlineOverride : navigator.onLine
  ));
  useEffect(() => {
    if (offlineOverride !== undefined) return undefined;
    const goOn = () => setIsOnline(true);
    const goOff = () => setIsOnline(false);
    window.addEventListener('online', goOn);
    window.addEventListener('offline', goOff);
    return () => { window.removeEventListener('online', goOn); window.removeEventListener('offline', goOff); };
  }, []);
  const [cfName, setCfName] = useState((pf.name || '').trim());
  const [cfClient, setCfClient] = useState((pf.client_name || '').trim());
  const [cfSite, setCfSite] = useState((pf.site_address || '').trim());
  const [creating, setCreating] = useState(false);
  const [createError, setCreateError] = useState('');
  const [candidates, setCandidates] = useState(initialCandidates || []);

  // The create POST — Bearer per the wire contract (no token = portal 401,
  // surfaced honestly). Never queued, never retried automatically.
  const doCreate = async (force) => {
    if (creating) return;
    setCreating(true); setCreateError('');
    try {
      const tk = localStorage.getItem('lumen_token');
      const r = await fetch(`${PORTAL_URL}/api/companion/projects`, {
        method: 'POST',
        headers: Object.assign({ 'Content-Type': 'application/json' }, tk ? { 'Authorization': `Bearer ${tk}` } : {}),
        body: JSON.stringify(Object.assign(
          { name: cfName.trim(), client_name: cfClient.trim() },
          cfSite.trim() ? { site_address: cfSite.trim() } : {},
          force ? { force: true } : {}
        )),
      });
      if (r.status === 401) {
        bearerRefused(r.status, tk, 'create project');   // track C: a 401 ends the sign-in
        setCreateError('Your sign-in has expired - log in again, then retry.');
        return;
      }
      if (!r.ok) {
        setCreateError("Couldn't create the project - check your connection and try again.");
        return;
      }
      const j = await r.json();
      if (j && j.created === false && Array.isArray(j.candidates) && j.candidates.length) {
        setCandidates(j.candidates);
        setView('dym');
        return;
      }
      if (j && j.created === true && j.project && j.project.id) {
        appendProjectToFeedCache(j.project);
        onApply(bindingFromCreatedProject(j.project));
        return;
      }
      setCreateError("Couldn't create the project - check your connection and try again.");
    } catch (e) {
      setCreateError("Couldn't create the project - check your connection and try again.");
    } finally {
      setCreating(false);
    }
  };
  const q = search.trim().toLowerCase();
  const filteredRows = q
    ? feedRows.filter(p =>
        (p.name || '').toLowerCase().includes(q) ||
        (p.client_name || '').toLowerCase().includes(q) ||
        (p.id || '').toLowerCase().includes(q))
    : feedRows;
  const bindState = bindingStateOf(binding);

  const stagePill = (stage) => {
    const s = (stage || '').toLowerCase();
    // Track 4 (switch on): the stage word carries the meaning colour, no fill.
    if (t.theme === 'uv') {
      const M = STUDIO_MEANING;
      const color = (s === 'won' || s === 'delivering') ? M.wonText
        : (s === 'quoting' || s === 'quoted' || s === 'sent') ? M.quotedText
        : (s === '' || s === 'enquiry' || s === 'new') ? M.newText : M.slateText;
      return { label: stage || 'enquiry', bg: 'transparent', color };
    }
    if (s === 'won' || s === 'delivering') {
      return { label: stage, bg: 'rgba(46,104,56,0.12)', color: '#2E6838' };
    }
    if (s === 'quoting' || s === 'quoted' || s === 'sent') {
      return { label: stage, bg: 'rgba(26,90,120,0.10)', color: '#1A5A78' };
    }
    return { label: stage || 'enquiry', bg: 'rgba(26,22,8,0.06)', color: 'rgba(26,22,8,0.55)' };
  };

  return (
    <SheetPortal>
    <div style={{ position: 'fixed', inset: 0, zIndex: 300, display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
      <div onClick={onClose} style={{ flex: 1, background: 'rgba(0,0,0,0.35)' }} />
      <div style={{ background: '#F5ECD8', borderTopLeftRadius: 20, borderTopRightRadius: 20, padding: '0 0 34px', maxHeight: '85vh', display: 'flex', flexDirection: 'column' }}>
        <div style={{ width: 36, height: 4, background: 'rgba(28,24,16,0.16)', borderRadius: 2, margin: '12px auto 0', flexShrink: 0 }} />
        <div style={{ padding: '14px 20px 10px', flexShrink: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            {view !== 'list' && (
              <button onClick={() => { setCreateError(''); setView('list'); }}
                style={{ width: 30, height: 30, borderRadius: 10, background: 'rgba(28,24,16,0.05)', border: '1px solid rgba(28,24,16,0.08)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'rgba(28,24,16,0.62)', cursor: 'pointer', fontFamily: 'inherit', fontSize: 16, flexShrink: 0, padding: 0 }}>‹</button>
            )}
            <span style={{ fontSize: 17, fontWeight: 800, color: '#1C1810', flex: 1 }}>
              {view === 'create' ? 'New project' : view === 'dym' ? 'Did you mean?' : 'Link to portal project'}
            </span>
            <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: 14, fontWeight: 600, color: 'rgba(28,24,16,0.52)', cursor: 'pointer', fontFamily: 'inherit' }}>Cancel</button>
          </div>
          <ProjectFeedStaleness syncedAt={feedSyncedAt} ageMin={feedAgeMin} />
          {view === 'list' && (
            <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search name, client or PRJ id…"
              style={{ width: '100%', marginTop: 10, background: 'rgba(255,255,255,0.8)', border: '1px solid rgba(26,22,8,0.12)', borderRadius: 10, padding: '11px 13px', fontSize: 14, fontWeight: 600, color: '#1C1810', fontFamily: 'inherit', outline: 'none', boxSizing: 'border-box' }} />
          )}
        </div>
        {view === 'list' && (
        <div style={{ overflowY: 'auto', WebkitOverflowScrolling: 'touch', padding: '4px 20px 8px' }}>
          {/* No project — first-class, above the list */}
          <button onClick={() => onApply(bindingNone())}
            style={{ width: '100%', display: 'flex', alignItems: 'center', gap: 12, padding: '12px 14px', background: bindState === 'noproject' ? a.noProjBg : 'rgba(255,252,242,0.7)', border: '1.5px dashed rgba(26,22,8,0.22)', borderRadius: 12, cursor: 'pointer', textAlign: 'left', fontFamily: 'inherit', marginBottom: 14 }}>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 13, fontWeight: 700, color: '#1C1810' }}>No project</div>
              <div style={{ fontSize: 11, color: 'rgba(26,22,8,0.45)', marginTop: 2 }}>Stays unbound. Route it later from the inbox.</div>
            </div>
            {bindState === 'noproject' && (
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={tick} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
            )}
          </button>
          <div style={{ fontSize: 10, fontWeight: 800, color: 'rgba(26,22,8,0.38)', textTransform: 'uppercase', letterSpacing: 0.8, marginBottom: 8 }}>Portal projects</div>
          {filteredRows.length === 0 && (
            <div style={{ padding: '14px 4px 10px', fontSize: 12, color: 'rgba(26,22,8,0.5)', lineHeight: 1.5 }}>
              {feedRows.length === 0
                ? 'No portal projects in the synced list yet.'
                : 'No projects match. Clear the search, or choose No project and route it later.'}
            </div>
          )}
          {filteredRows.map(p => {
            const isSel = !!(binding && binding.project_id === p.id);
            const pill = stagePill(p.stage);
            return (
              <button key={p.id} onClick={() => onApply(bindingFromFeedRow(p))}
                style={{ width: '100%', display: 'flex', alignItems: 'center', gap: 10, padding: '11px 14px', background: isSel ? a.selBg : 'rgba(255,252,242,0.88)', border: isSel ? `1px solid ${a.border}` : '1px solid rgba(26,22,8,0.08)', borderRadius: 12, cursor: 'pointer', textAlign: 'left', fontFamily: 'inherit', marginBottom: 7 }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 10, fontWeight: 700, color: '#2E6838', fontFamily: 'JetBrains Mono, monospace', letterSpacing: 0.4, marginBottom: 2 }}>{p.id}</div>
                  <div style={{ fontSize: 13, fontWeight: 700, color: '#1C1810', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{p.name}</div>
                  {p.client_name ? <div style={{ fontSize: 11, color: 'rgba(26,22,8,0.45)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{p.client_name}</div> : null}
                </div>
                <span style={{ flexShrink: 0, fontSize: 9.5, fontWeight: 700, padding: '3px 8px', borderRadius: 8, background: pill.bg, color: pill.color, textTransform: 'capitalize' }}>{pill.label}</span>
                {isSel && (
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={tick} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}><polyline points="20 6 9 17 4 12"/></svg>
                )}
              </button>
            );
          })}
          {/* B.2 Slice 4 — "+ New project", live online / inert offline (D1d:
              create-DISABLED offline, never create-QUEUED) */}
          {isOnline ? (
            <button onClick={() => { setCreateError(''); setView('create'); }}
              style={{ width: '100%', display: 'flex', alignItems: 'center', gap: 12, padding: '12px 14px', background: 'rgba(46,104,56,0.04)', border: '1.5px dashed rgba(46,104,56,0.4)', borderRadius: 12, cursor: 'pointer', textAlign: 'left', fontFamily: 'inherit', marginTop: 8 }}>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: '#2E6838' }}>+ New project</div>
                <div style={{ fontSize: 11, color: 'rgba(26,22,8,0.45)', marginTop: 2, lineHeight: 1.4 }}>Not in the list? Create it here and the {captureNoun} binds straight away.</div>
              </div>
            </button>
          ) : (
            <div style={{ width: '100%', display: 'flex', alignItems: 'center', gap: 12, padding: '12px 14px', background: 'rgba(255,252,242,0.6)', border: '1.5px dashed rgba(26,22,8,0.2)', borderRadius: 12, opacity: 0.5, marginTop: 8 }}>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: '#1C1810' }}>+ New project</div>
                <div style={{ fontSize: 11, color: 'rgba(26,22,8,0.45)', marginTop: 2, lineHeight: 1.4 }}>Needs a connection. Capture stays unbound for now - route it later from the inbox.</div>
              </div>
              <span style={{ flexShrink: 0, fontSize: 9, fontWeight: 800, letterSpacing: 0.8, padding: '3px 8px', borderRadius: 8, background: 'rgba(26,22,8,0.07)', color: 'rgba(26,22,8,0.45)' }}>{t.theme === 'uv' ? 'Offline' : 'OFFLINE'}</span>
            </div>
          )}
        </div>
        )}

        {/* B.2 Slice 4 — create view: prefilled from the host form's typed
            values; the user confirms or corrects, then creates. */}
        {view === 'create' && (
        <div style={{ overflowY: 'auto', WebkitOverflowScrolling: 'touch', padding: '8px 20px 22px' }}>
          <div style={{ marginBottom: 11 }}>
            <label style={{ display: 'block', fontSize: 10.5, fontWeight: 700, letterSpacing: 0.8, color: 'rgba(26,22,8,0.42)', marginBottom: 5, textTransform: 'uppercase' }}>Project name</label>
            <input value={cfName} onChange={e => setCfName(e.target.value)}
              style={{ width: '100%', background: '#fff', border: '1px solid rgba(28,24,16,0.12)', borderRadius: 12, padding: '12px 13px', fontSize: 14.5, fontFamily: 'inherit', outline: 'none', color: '#1C1810', boxSizing: 'border-box' }} />
          </div>
          <div style={{ marginBottom: 11 }}>
            <label style={{ display: 'block', fontSize: 10.5, fontWeight: 700, letterSpacing: 0.8, color: 'rgba(26,22,8,0.42)', marginBottom: 5, textTransform: 'uppercase' }}>Client</label>
            <input value={cfClient} onChange={e => setCfClient(e.target.value)}
              style={{ width: '100%', background: '#fff', border: '1px solid rgba(28,24,16,0.12)', borderRadius: 12, padding: '12px 13px', fontSize: 14.5, fontFamily: 'inherit', outline: 'none', color: '#1C1810', boxSizing: 'border-box' }} />
          </div>
          {pf.site_address !== undefined && (
            <div style={{ marginBottom: 11 }}>
              <label style={{ display: 'block', fontSize: 10.5, fontWeight: 700, letterSpacing: 0.8, color: 'rgba(26,22,8,0.42)', marginBottom: 5, textTransform: 'uppercase' }}>Site address</label>
              <input value={cfSite} onChange={e => setCfSite(e.target.value)} placeholder="Optional"
                style={{ width: '100%', background: '#fff', border: '1px solid rgba(28,24,16,0.12)', borderRadius: 12, padding: '12px 13px', fontSize: 14.5, fontFamily: 'inherit', outline: 'none', color: '#1C1810', boxSizing: 'border-box' }} />
            </div>
          )}
          <div style={{ fontSize: 11, color: 'rgba(26,22,8,0.42)', lineHeight: 1.5, padding: '2px 2px 10px' }}>
            Created projects are flagged for office review - the {captureNoun} binds to it immediately.
          </div>
          {createError && (
            <div style={{ fontSize: 12, fontWeight: 600, color: errCol, lineHeight: 1.5, padding: '0 2px 10px' }}>{createError}</div>
          )}
          <button onClick={() => doCreate(false)} disabled={creating || !cfName.trim() || !cfClient.trim()}
            style={{ width: '100%', background: (creating || !cfName.trim() || !cfClient.trim()) ? 'rgba(46,104,56,0.35)' : '#2E6838', color: '#FAF6EC', border: 'none', borderRadius: 13, padding: 13, fontSize: 14.5, fontWeight: 700, fontFamily: 'inherit', cursor: (creating || !cfName.trim() || !cfClient.trim()) ? 'default' : 'pointer', ...uvx(() => ({ ...studioSurface.primary(), opacity: (creating || !cfName.trim() || !cfClient.trim()) ? 0.5 : 1 })) }}>
            {creating ? 'Creating…' : 'Create project'}
          </button>
        </div>
        )}

        {/* B.2 Slice 4 — "Did you mean?": the portal found near-matches.
            Nothing is guessed - link to a candidate (a normal pick) or
            create anyway (force). */}
        {view === 'dym' && (
        <div style={{ overflowY: 'auto', WebkitOverflowScrolling: 'touch', padding: '8px 20px 22px' }}>
          <div style={{ fontSize: 13, fontWeight: 650, lineHeight: 1.45, padding: '2px 2px 10px', color: '#1C1810' }}>
            A similar project already exists. <span style={{ color: 'rgba(26,22,8,0.55)', fontWeight: 500 }}>Link to it, or create "{cfName.trim()}" as new?</span>
          </div>
          {candidates.map(c => {
            const pill = stagePill(c.stage);
            return (
              <button key={c.id} onClick={() => onApply(bindingFromFeedRow(c))}
                style={{ width: '100%', display: 'flex', alignItems: 'center', gap: 10, padding: '11px 14px', background: 'rgba(255,252,242,0.88)', border: '1px solid rgba(26,22,8,0.08)', borderRadius: 12, cursor: 'pointer', textAlign: 'left', fontFamily: 'inherit', marginBottom: 7 }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 10, fontWeight: 700, color: 'rgba(26,22,8,0.45)', fontFamily: 'JetBrains Mono, monospace', letterSpacing: 0.4, marginBottom: 2 }}>{c.id}</div>
                  <div style={{ fontSize: 13, fontWeight: 700, color: '#1C1810', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{c.name}</div>
                  <div style={{ fontSize: 11, color: 'rgba(26,22,8,0.45)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{(c.client_name || 'No client') + studioSep() + (pill.label || 'enquiry')}</div>
                </div>
                <span style={{ flexShrink: 0, fontSize: 12, fontWeight: 700, color: '#2E6838' }}>Link to this</span>
              </button>
            );
          })}
          {createError && (
            <div style={{ fontSize: 12, fontWeight: 600, color: errCol, lineHeight: 1.5, padding: '4px 2px 6px' }}>{createError}</div>
          )}
          <button onClick={() => doCreate(true)} disabled={creating}
            style={{ width: '100%', background: 'transparent', border: '1.5px dashed rgba(46,104,56,0.45)', color: '#2E6838', borderRadius: 13, padding: 12, fontSize: 13.5, fontWeight: 650, fontFamily: 'inherit', cursor: creating ? 'default' : 'pointer', marginTop: 6, opacity: creating ? 0.6 : 1 }}>
            {creating ? 'Creating…' : `Create "${cfName.trim()}" anyway`}
          </button>
          <div style={{ fontSize: 11, color: 'rgba(26,22,8,0.42)', lineHeight: 1.5, textAlign: 'center', paddingTop: 9 }}>
            Either way, nothing is guessed - you choose.
          </div>
        </div>
        )}
      </div>
    </div>
    </SheetPortal>
  );
};
const ProjectPickerSheet = (props) => studioCapture(ProjectPickerSheetBody(props));

// B.2 — binding echo, honest in both directions (Slice 1 copy, shared so the
// snag success state can never drift from the survey one). Linked line only
// when the portal CONFIRMED the bind; if the user picked an id and the portal
// refused (stale / merged-away), say so — never pretend. No echo yet (queued
// dispatch) = neither line renders.
const BindingEchoLinesBody = ({ echo, align }) => {
  if (!echo) return null;
  const tick = t.theme === 'uv' ? STUDIO_TOKENS.ink : '#2E6838';
  return (
    <>
      {echo.bound === true && echo.boundProjectId && (
        <p style={{ fontSize: 12, fontWeight: 700, color: '#2E6838', marginTop: 8, display: 'flex', alignItems: 'center', justifyContent: align === 'left' ? 'flex-start' : 'center', gap: 6 }}>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={tick} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
          Linked to <span style={{ fontFamily: 'JetBrains Mono, monospace', letterSpacing: 0.4 }}>{echo.boundProjectId}</span>
        </p>
      )}
      {echo.bound === false && echo.sentProjectId && (
        <p style={{ fontSize: 11.5, color: 'rgba(26,22,8,0.55)', marginTop: 8, lineHeight: 1.5 }}>
          {`Couldn't link to the selected project${studioDash()}it will appear in the portal inbox to route.`}
        </p>
      )}
    </>
  );
};
const BindingEchoLines = (props) => studioCapture(BindingEchoLinesBody(props));

// ==== S160 WRAP_SUMMARY_LOGIC_START ──────────────────────────────────────
// Pure wrap-summary derivation — single source of truth for the wrap header
// zone chip, the hero Zones/Fixtures stats and the Zone breakdown, so they
// cannot disagree with each other or with the area cards (which sum the same
// qty per canonical zone). tests/wrap_summary.test.js slices this block
// (START→END markers) and exercises it under node:test. Keep it free of
// React / browser globals; zoneKey is the only outer dependency (the test
// extracts that const alongside this block).
// Returns { zoneRows, totalFixtures, uniqueTypes, doneCount, totalZoneCount }.
// zoneRows is ONE row per area in customZones (display casing from the area
// list, survey order) PLUS a trailing row for any orphan zone that still
// carries fittings — a zone that vanished from the area list must not silently
// vanish from the count. A done zone with photos and zero fittings stays in
// the list with count 0: surveyed is surveyed. Counts fold case/whitespace
// zone variants through zoneKey, the same canonicalisation the area cards use,
// so every surface sums the same qty per zone.
const deriveWrapSummary = (surveyZones, customZones, doneZones) => {
  const entries = Array.isArray(surveyZones) ? surveyZones : [];
  const areas = Array.isArray(customZones) ? customZones : [];
  const done = (doneZones && typeof doneZones === 'object') ? doneZones : {};
  const NONE = '__none__';
  const byKey = {};
  entries.forEach(e => {
    if (!e) return;
    const k = zoneKey(e.zone) || NONE;
    if (!byKey[k]) byKey[k] = { count: 0, types: [], label: String((e.zone == null ? '' : e.zone)).trim() || 'Unknown' };
    byKey[k].count += (e.qty || 1);
    const t = (e.unit && e.unit.label ? String(e.unit.label).split(' · ')[0] : '') || 'Fitting';
    if (byKey[k].types.indexOf(t) === -1) byKey[k].types.push(t);
  });
  const doneByKey = {};
  Object.keys(done).forEach(z => { if (done[z]) doneByKey[zoneKey(z)] = true; });
  const seen = {};
  const zoneRows = [];
  areas.forEach(z => {
    const k = zoneKey(z);
    if (!k || seen[k]) return;
    seen[k] = true;
    const g = byKey[k];
    zoneRows.push({ zone: String(z).trim(), count: g ? g.count : 0, types: g ? g.types : [], done: !!doneByKey[k] });
  });
  // Orphans: fittings whose zone is no longer (or never was) an area still count.
  Object.keys(byKey).forEach(k => {
    if (seen[k]) return;
    seen[k] = true;
    zoneRows.push({ zone: byKey[k].label, count: byKey[k].count, types: byKey[k].types, done: !!doneByKey[k] });
  });
  const totalFixtures = zoneRows.reduce((s, r) => s + r.count, 0);
  const allTypes = [];
  zoneRows.forEach(r => r.types.forEach(t => { if (allTypes.indexOf(t) === -1) allTypes.push(t); }));
  const doneCount = zoneRows.filter(r => r.done).length;
  return { zoneRows, totalFixtures, uniqueTypes: allTypes.length, doneCount, totalZoneCount: zoneRows.length };
};
// ==== S160 WRAP_SUMMARY_LOGIC_END ────────────────────────────────────────

// ==== P2C WRAP_CARD_START
// Phase 2C, the survey wrap's lit summary (Studio lit only). Pure rules the
// wrap calls so the JSX only draws them (skill section 5, one derivation).
// Nothing here is new data: it reads the wrap's own deriveWrapSummary rows,
// the survey's own fittings and photos, and the same notes the send reads.
// Nothing is sent or stored by these.
//
// An area narrower than this share of the bar cannot hold a readable label, so
// neighbouring ones share one "Other" label (the segments stay separate).
const WRAP_BAR_MIN_SHARE = 0.18;
// The bar's one calm colour (a fill, never text). Signed-off mock-up teal,
// lifted a shade so it stays a light fill and not a dark surface.
const WRAP_BAR_FILL = '#1B8E9B';
// Emergency fittings across the survey: the emQty each fitting line carries.
const wrapEmergencyCount = (surveyZones) => (Array.isArray(surveyZones) ? surveyZones : [])
  .reduce((s, e) => s + (e ? (Number(e.emQty) || 0) : 0), 0);
// The bar's labelled groups, in survey order, from deriveWrapSummary's rows.
// Areas with no fittings have no part. Each group: { label, count, parts, names,
// tiny }; `parts` are the segment sizes inside it.
const wrapBarGroups = (zoneRows) => {
  const rows = (Array.isArray(zoneRows) ? zoneRows : []).filter((r) => r && r.count > 0);
  const total = rows.reduce((s, r) => s + r.count, 0);
  if (!total) return [];
  // The areas wide enough to name keep survey order; every narrow one goes to
  // the end of the bar and shares the one "Other" label.
  const groups = [];
  const other = { tiny: true, label: 'Other', count: 0, parts: [], names: [] };
  rows.forEach((r) => {
    if (r.count / total < WRAP_BAR_MIN_SHARE) { other.count += r.count; other.parts.push(r.count); other.names.push(r.zone); return; }
    groups.push({ tiny: false, label: r.zone, count: r.count, parts: [r.count], names: [r.zone] });
  });
  if (other.parts.length) groups.push(other);
  return groups;
};
// Counts of the notes the send carries, from the stacked-note map (the same
// bodies flattenZoneNotesForPayload keeps): { notes, voice, total }. A note with
// no body (pending transcription) is not counted, as it is not sent.
const wrapNoteCounts = (zoneNotes) => {
  let notes = 0; let voice = 0;
  if (zoneNotes && typeof zoneNotes === 'object') {
    Object.keys(zoneNotes).forEach((k) => {
      const v = zoneNotes[k];
      if (Array.isArray(v)) v.forEach((n) => { if (n && n.body) { if (n.type === 'voice') voice += 1; else notes += 1; } });
      else if (typeof v === 'string' && v.trim()) notes += 1;
    });
  }
  return { notes, voice, total: notes + voice };
};
// The photo rules below mirror the send (SurveyWrapScreen's sendToPortal)
// clause for clause, so the wrap never counts as sent a photo the send would
// drop. tests/wrap_card.test.js pins each one against the send's source, so
// the two cannot drift silently.
//
// Base64 still in it: the send's _isB64, copied so this block stays pure.
const wrapIsB64 = (s) => typeof s === 'string' && s.startsWith('data:');
// A site photo or video the send keeps as it stands (_sitePhotosForPayload: a
// video, a url, or a src that is not base64).
const wrapSiteKeeps = (p) => !!p && (p.type === 'video' || !!p.url || (!!p.src && !wrapIsB64(p.src)));
// A fitting line's photo the send keeps as it stands (the per-zone cleanup: a
// url, or a src that is not base64). The cleanup has no video clause, so
// neither does this.
const wrapZoneKeeps = (p) => !!p && (!!p.url || (!!p.src && !wrapIsB64(p.src)));
// A photo the send would try to upload first (its _needsUpload). `hydrate` is
// the app's needsIdbHydration (an id, no url, no base64), passed in.
const wrapNeedsUpload = (p, hydrate) => !!p && p.type !== 'video' && !p.url && (!!hydrate(p) || wrapIsB64(p.src));
// The wrap's photo figures: `certain` ship as they stand, `pending` still need
// uploading first and ship only if that works. Anything else would be dropped
// by the send whatever happens, so it is in neither.
// Videos are never uploaded: the send keeps one only as its blob: src, which
// points at nothing off this phone, so a kept video is counted apart
// (`videos`) and never in `certain`.
const wrapPhotoCounts = (sitePhotos, surveyZones, hydrate) => {
  let certain = 0; let pending = 0; let videos = 0;
  const one = (p, keeps) => {
    if (keeps(p)) { if (p.type === 'video') videos += 1; else certain += 1; }
    else if (wrapNeedsUpload(p, hydrate)) pending += 1;
  };
  (Array.isArray(sitePhotos) ? sitePhotos : []).forEach((p) => one(p, wrapSiteKeeps));
  (Array.isArray(surveyZones) ? surveyZones : []).forEach((z) => {
    if (z && Array.isArray(z.photos)) z.photos.forEach((p) => one(p, wrapZoneKeeps));
  });
  return { certain, pending, videos };
};
// The plain line for videos, or null when there are none.
const wrapVideoLine = (n) => (n > 0 ? `${n} ${n === 1 ? 'video stays' : 'videos stay'} on this phone` : null);
// One photo's identity across sends: its id, or failing that its src.
const wrapPhotoKey = (p) => (p && (p.id || (typeof p.src === 'string' ? p.src : ''))) || '';
// After an upload step that stopped short: the photos that DID upload, as
// { key: url }, so the follow-up (Try again, Send without them) reuses them
// instead of uploading them again or leaving them out.
const wrapUploadedUrls = (origSite, siteOut, origZones, zonesOut, needsUpload) => {
  const urls = {};
  const take = (p, after) => { const k = wrapPhotoKey(p); if (k && needsUpload(p) && after && after.url) urls[k] = after.url; };
  const so = Array.isArray(siteOut) ? siteOut : [];
  const zo = Array.isArray(zonesOut) ? zonesOut : [];
  (Array.isArray(origSite) ? origSite : []).forEach((p, i) => take(p, so[i]));
  (Array.isArray(origZones) ? origZones : []).forEach((z, zi) => {
    if (!z || !Array.isArray(z.photos)) return;
    const after = zo[zi] && Array.isArray(zo[zi].photos) ? zo[zi].photos : [];
    z.photos.forEach((p, pi) => take(p, after[pi]));
  });
  return urls;
};
// A photo with a url already known from the stopped send gets it, in the same
// shape the send's own upload success gives (src dropped, url set). Anything
// else, and every photo when `urls` is empty, is returned as the same object.
const wrapApplyUrl = (p, urls) => {
  if (!p || p.url || !urls) return p;
  const k = wrapPhotoKey(p);
  if (!k || !Object.prototype.hasOwnProperty.call(urls, k)) return p;
  const { src, ...rest } = p;
  return Object.assign({}, rest, { url: urls[k] });
};
// SEND-STATE-V1: the phone's upload flag never rides the wire. A photo without
// it is returned as the same object, so a survey with none is byte for byte
// what it was.
const wrapWirePhoto = (p) => {
  if (!p || typeof p !== 'object' || !Object.prototype.hasOwnProperty.call(p, 'uploadState')) return p;
  const { uploadState, ...rest } = p;
  return rest;
};
const wrapWirePhotos = (photos) => (Array.isArray(photos) ? photos.map(wrapWirePhoto) : photos);
const wrapWireZones = (zones) => (Array.isArray(zones) ? zones.map((z) => (z && Array.isArray(z.photos) && z.photos.some((p) => p && typeof p === 'object' && Object.prototype.hasOwnProperty.call(p, 'uploadState')) ? Object.assign({}, z, { photos: wrapWirePhotos(z.photos) }) : z)) : zones);
// "1 photo", "3 photos".
const wrapPhotoWords = (n) => `${n} ${n === 1 ? 'photo' : 'photos'}`;
// The plain line under what gets sent, or null when nothing is waiting.
const wrapPendingLine = (n) => (n > 0 ? `${wrapPhotoWords(n)} still to upload` : null);
// The send's decision after its upload step: the photos that needed uploading
// and still would not be kept (the upload failed, or the device store had no
// copy). `orig*` are the arrays before the upload step and `*Out` the same
// arrays after it, index for index, before the send's cleanup filters run.
// `needsUpload` is the send's own _needsUpload. Each entry names its area.
const wrapUploadShortfall = (origSite, siteOut, origZones, zonesOut, needsUpload) => {
  const out = [];
  const so = Array.isArray(siteOut) ? siteOut : [];
  const zo = Array.isArray(zonesOut) ? zonesOut : [];
  (Array.isArray(origSite) ? origSite : []).forEach((p, i) => {
    if (needsUpload(p) && !wrapSiteKeeps(so[i])) out.push({ kind: 'site', area: (p && p.zone) || '' });
  });
  (Array.isArray(origZones) ? origZones : []).forEach((z, zi) => {
    if (!z || !Array.isArray(z.photos)) return;
    const after = zo[zi] && Array.isArray(zo[zi].photos) ? zo[zi].photos : [];
    z.photos.forEach((p, pi) => {
      if (needsUpload(p) && !wrapZoneKeeps(after[pi])) out.push({ kind: 'zone', area: z.zone || '' });
    });
  });
  return out;
};
// The shortfall by area, in the order met: [{ area, n }]. A photo with no area,
// or the Site-wide key, is named Site-wide, never by the raw key.
const wrapLossByArea = (dropped) => {
  const order = []; const n = {};
  (Array.isArray(dropped) ? dropped : []).forEach((d) => {
    const a = !d || !d.area || d.area === '__project__' ? 'Site-wide' : d.area;
    if (!(a in n)) { n[a] = 0; order.push(a); }
    n[a] += 1;
  });
  return order.map((area) => ({ area, n: n[area] }));
};
// "Ground floor 2, Site-wide 1".
const wrapLossWords = (byArea) => (Array.isArray(byArea) ? byArea : []).map((r) => `${r.area} ${r.n}`).join(', ');
// What will be sent, one row each, only where there is something to send.
const wrapSentRows = (fittings, photos, noteTotal) => [
  { key: 'fittings', what: 'Fittings, by area', n: fittings },
  { key: 'photos', what: 'Photos', n: photos },
  { key: 'notes', what: 'Notes and voice notes', n: noteTotal },
].filter((r) => r.n > 0);
// What the wrap already says is unfinished (areas not marked done, or no areas
// at all), as rows with the words and the fix. No new completeness rule.
const wrapMissingRows = (zoneRows, totalZoneCount) => {
  const rows = Array.isArray(zoneRows) ? zoneRows : [];
  if (!totalZoneCount) return [{ key: 'none', text: 'There are no areas in this survey yet', act: 'Add areas' }];
  const open = rows.filter((r) => !r.done).map((r) => r.zone);
  if (open.length === 0) return [];
  if (open.length <= 3) return open.map((z) => ({ key: 'open:' + z, text: `${z} isn’t marked done`, act: 'Finish it' }));
  return [{ key: 'open', text: `${open.length} areas aren’t marked done`, act: 'Open Areas' }];
};
// ==== P2C WRAP_CARD_END

// ==== P1 COPY_AREAS_LOGIC_START
// Phase 1, faster on site. 185 Fleet Street, 19 October 2026: the building's
// floors repeat, but each area was a separate place, so the surveyor merged
// floors into one area name, patched differences into others, and typed the
// same custom fittings again in every area. Two pure rules live here, and the
// JSX only calls them (skill section 5, one derivation):
//   1. copying one area's fitting lines to other areas (planFittingCopy);
//   2. a job's custom fittings, kept with the job and rebuilt from its lines
//      (restoreCustomFittings).
// Every copied area is an ordinary area with real counts: there is no repeat
// multiplier, so the totals and the survey-wrap wire (surveyZones, zoneFittings)
// are exactly what they were. Photos and notes are never copied.

// What makes two lines the same fitting. The Log button merges a new line into
// an existing one with this signature, and a copy into an area that already
// holds the fitting merges the same way, so the two can never disagree.
const fittingSignature = (e) => JSON.stringify([
  e.fixtureId || '',
  e.primary || '',
  e.secondary || '',
  e.extras ? Object.keys(e.extras).sort().map(k => [k, e.extras[k]]) : [],
]);
const mergeFittingLines = (list, newEntry) => {
  const sig = fittingSignature(newEntry);
  const idx = (list || []).findIndex(e => fittingSignature(e) === sig);
  if (idx < 0) return [...(list || []), newEntry];
  const existing = list[idx];
  const merged = {
    ...existing,
    qty: (existing.qty || 0) + (newEntry.qty || 0),
    emQty: (existing.emQty || 0) + (newEntry.emQty || 0),
    photos: [...(existing.photos || []), ...(newEntry.photos || [])],
  };
  const copy = list.slice();
  copy[idx] = merged;
  return copy;
};

// Area names typed in one go ("6, 7, 8"): split on comma, semicolon or new
// line, tidy spacing, drop blanks and repeats (ignoring case).
const parseAreaNames = (text) => {
  const seen = {};
  const out = [];
  String(text == null ? '' : text).split(/[,;\n]/).forEach(raw => {
    const name = raw.trim().replace(/\s+/g, ' ');
    const k = zoneKey(name);
    if (!k || seen[k]) return;
    seen[k] = true;
    out.push(name);
  });
  return out;
};

// A fitting line copied for another area: every field the line carries (type,
// size, extras, quantity, EM, cost, wattages) with a NEW uid. Photos are not
// copied. Plain-data clone, so no object is shared between two areas.
const copyFittingLine = (line, uid) => ({
  ...JSON.parse(JSON.stringify(line)),
  uid,
  photos: [],
});

const copyButtonLabel = (perAreaQty, areaCount) =>
  `Copy ${perAreaQty} fitting${perAreaQty === 1 ? '' : 's'} to ${areaCount} area${areaCount === 1 ? '' : 's'}`;

// Plan a copy. Pure: it returns the next zoneFittings and zones and a summary,
// and mutates nothing; the caller persists it and says so if that fails.
//   zoneFittings  { areaName: [line] }, as held by the survey screen
//   zones         the area list, in order
//   sourceZone    the area whose lines are copied
//   targets       [{ zone, mode }]. mode is 'add' (merge into what the area
//                 holds) or 'replace' (swap it for the copy). A name that is not
//                 an area yet is created, appended to the list.
//   nextUid       () => a fresh uid. A uid already used anywhere in the survey
//                 is never handed out again.
// Returns { ok:true, zoneFittings, zones, summary } or { ok:false, reason, message }.
const planFittingCopy = (opts) => {
  const o = opts || {};
  const zf = (o.zoneFittings && typeof o.zoneFittings === 'object') ? o.zoneFittings : {};
  const zl = Array.isArray(o.zones) ? o.zones : [];
  const refuse = (reason, message) => ({ ok: false, reason, message });
  const keyIn = (name) => {
    const k = zoneKey(name);
    if (!k) return null;
    return Object.keys(zf).find(c => zoneKey(c) === k) || null;
  };
  const srcKey = keyIn(o.sourceZone);
  const srcLines = srcKey ? (zf[srcKey] || []) : [];
  if (!srcLines.length) return refuse('nothing-to-copy', 'That area has no fittings to copy.');
  const srcK = zoneKey(o.sourceZone);
  const perAreaQty = srcLines.reduce((s, l) => s + (l.qty || 0), 0);

  const used = {};
  Object.keys(zf).forEach(z => (zf[z] || []).forEach(l => { used[String(l.uid)] = true; }));
  let uidFailed = false;
  const mkUid = () => {
    for (let n = 0; n < 1000; n++) {
      const u = o.nextUid();
      if (u != null && !used[String(u)]) { used[String(u)] = true; return u; }
    }
    uidFailed = true;
    return null;
  };

  const next = { ...zf };
  const nextZones = zl.slice();
  const areas = [];
  const skipped = [];
  const seen = { [srcK]: true };
  let droppedPhotos = 0;
  (Array.isArray(o.targets) ? o.targets : []).forEach(t => {
    const typed = String(t && t.zone != null ? t.zone : '').trim().replace(/\s+/g, ' ');
    const k = zoneKey(typed);
    if (!k) return;
    if (seen[k]) { skipped.push(typed); return; }
    seen[k] = true;
    const listed = nextZones.find(z => zoneKey(z) === k);
    const name = listed || typed;
    const key = keyIn(name) || name;
    const had = next[key] || [];
    const copies = srcLines.map(l => copyFittingLine(l, mkUid()));
    let mode;
    if (had.length === 0) {
      mode = listed || keyIn(name) ? 'filled' : 'new';
      next[key] = copies;
    } else if (t.mode === 'replace') {
      mode = 'replaced';
      droppedPhotos += had.reduce((s, l) => s + ((l.photos || []).length), 0);
      next[key] = copies;
    } else {
      mode = 'added';
      next[key] = copies.reduce((list, c) => mergeFittingLines(list, c), had);
    }
    if (!listed) nextZones.push(name);
    areas.push({ zone: name, mode, lines: next[key].length, qty: next[key].reduce((s, l) => s + (l.qty || 0), 0) });
  });
  if (uidFailed) return refuse('uid', 'Could not make a unique id for the copy, so nothing was copied.');
  if (!areas.length) return refuse('no-target', 'Pick at least one area to copy to.');
  return {
    ok: true,
    zoneFittings: next,
    zones: nextZones,
    summary: {
      sourceZone: srcKey,
      perAreaQty,
      lineCount: srcLines.length,
      areas,
      createdCount: areas.filter(a => a.mode === 'new').length,
      replacedCount: areas.filter(a => a.mode === 'replaced').length,
      addedCount: areas.filter(a => a.mode === 'added').length,
      droppedPhotos,
      skipped,
    },
  };
};
const copyDoneMessage = (summary) => {
  const n = summary.areas.length;
  return `Copied ${summary.perAreaQty} fitting${summary.perAreaQty === 1 ? '' : 's'} to ${n} area${n === 1 ? '' : 's'}`;
};

// ── Custom fittings kept with the job ──
// A custom fitting's tile id is 'cx-<time>' (supplier matching reads the 'cx'
// prefix to file it under Custom). It used to live only in the survey screen's
// state, so it was gone when the screen closed. It now lives on the project as
// project.customFittings, and is also rebuilt from the job's own survey lines,
// so jobs surveyed before this change get their tiles back too.
// A line's unit id is `${fixtureId}-${primary}`: 'cx-1729000000000-'. The older
// hydrate kept only the part before the first dash ('cx'), so a job that had
// been reopened and saved holds plain 'cx-' and the tile id is lost; those get
// an id derived from the name and wattages, which is stable across reloads.
const customFittingSig = (label, existingW, ledW) =>
  `${String(label || '').trim().replace(/\s+/g, ' ').toLowerCase()}|${Number(existingW) || 0}|${Number(ledW) || 0}`;
const isCustomFixtureId = (id) => typeof id === 'string' && /^cx(-|$)/.test(id);
const customIdFromUnitId = (unitId) => {
  const m = /^(cx-\d+)/.exec(typeof unitId === 'string' ? unitId : '');
  return m ? m[1] : null;
};
const derivedCustomId = (sig) => {
  let h = 5381;
  for (let i = 0; i < sig.length; i++) h = ((h * 33) ^ sig.charCodeAt(i)) >>> 0;
  return 'cx-' + h;
};
const makeCustomTile = (id, label, existingW, ledW) => ({
  id, label, icon: 'deco', cost: null, variants: { primary: [] },
  existingW: Number(existingW) || 0, ledW: Number(ledW) || 0,
});
// stored  project.customFittings (may be missing or damaged)
// lines   the job's survey lines ({ unit: { id, label, wattage, replacementW } })
// Returns { tiles, idForSig }. One tile per name and wattage pair, the first
// seen keeping its id; idForSig(sig) is the tile id a line with that name and
// wattages belongs to, so lines typed again in every area collapse onto one tile.
const restoreCustomFittings = (stored, lines) => {
  const tiles = [];
  const bySig = {};
  const take = (id, label, existingW, ledW) => {
    const name = String(label || '').trim();
    if (!name) return;
    const sig = customFittingSig(name, existingW, ledW);
    if (bySig[sig]) return;
    if (tiles.some(t => t.id === id)) id = derivedCustomId(sig);
    bySig[sig] = id;
    tiles.push(makeCustomTile(id, name, existingW, ledW));
  };
  (Array.isArray(stored) ? stored : []).forEach(t => {
    if (t && typeof t.id === 'string' && /^cx-/.test(t.id) && typeof t.label === 'string') take(t.id, t.label, t.existingW, t.ledW);
  });
  (Array.isArray(lines) ? lines : []).forEach(l => {
    const unit = l && l.unit;
    if (!unit || !isCustomFixtureId(String(unit.id || ''))) return;
    const label = typeof unit.label === 'string' ? unit.label.split(' · ')[0] : '';
    const sig = customFittingSig(label, unit.wattage, unit.replacementW);
    take(customIdFromUnitId(unit.id) || derivedCustomId(sig), label, unit.wattage, unit.replacementW);
  });
  return { tiles, idForSig: (sig) => bySig[sig] || null };
};
// ==== P1 COPY_AREAS_LOGIC_END

// ==== S162 WRAP_BREAKDOWN_ORDER_START ────────────────────────────────────
// Flattens zoneRows into the exact order the breakdown must render: each
// zone's header immediately followed by ITS OWN fitting-type rows when that
// zone is expanded. tests/wrap_breakdown_order.test.js slices this block
// (START -> END markers) under node:test. Keep it free of React / browser
// globals.
//
// Pre-S162 the breakdown rendered ALL zone headers in one map, then ALL
// expansions in a SECOND map appended below them. An expanded zone's fitting
// rows therefore detached from their header and landed at the foot of the
// card, visually under whichever zone happened to render last — so a
// Reception Downlight appeared under a zero-fitting Trading floor. Producing
// the render order from one interleaved list makes a fitting row sit under
// the zone it belongs to, every time. Each row is keyed by its canonical
// zoneKey, the same canonicalisation deriveWrapSummary and the area cards use,
// so two zones that fold to one key never share an expansion-toggle key.
const wrapBreakdownOrder = (zoneRows, expandedZones) => {
  const rows = Array.isArray(zoneRows) ? zoneRows : [];
  const exp = (expandedZones && typeof expandedZones === 'object') ? expandedZones : {};
  const out = [];
  rows.forEach(row => {
    if (!row) return;
    const types = Array.isArray(row.types) ? row.types : [];
    out.push({ kind: 'header', zone: row.zone, count: row.count || 0, types, done: !!row.done });
    if (exp[row.zone] && types.length > 0) {
      out.push({ kind: 'fittings', zone: row.zone, types });
    }
  });
  return out;
};
// ==== S162 WRAP_BREAKDOWN_ORDER_END ──────────────────────────────────────

// ==== S162 PHOTO_UPLOAD_SYNC_START ───────────────────────────────────────
// Applies a background retry-queue upload outcome to a photo list IN PLACE,
// so an open survey's Media grid reflects a completed upload without waiting
// for a remount. tests/photo_upload_sync.test.js slices this block
// (START -> END markers) under node:test. Keep it free of React / browser
// globals.
//
// Pre-S162 ONLY the App-level projects / activeProject state listened for the
// lumenPhotoUploaded event that flushPhotoRetryQueue dispatches. The
// LiveSurvey screen renders its Media grid from a LOCAL sitePhotos state that
// is seeded once at mount, so a photo captured offline that finished
// uploading WHILE the survey was still open kept its in-progress spinner until
// the surveyor left and re-entered (a remount re-seeded from activeProject).
// applyPhotoUploaded swaps that photo's base64 src for the returned URL;
// applyPhotoFailed flags a permanently-failed one. Matching mirrors the App
// handler exactly: the queued photo carries its base64 as oldSrc, so we match
// on src. Returning the SAME array reference when nothing matched lets React
// bail out of a needless re-render.
// SEND-STATE-V1: the stored photo is a ref whose base64 lives in IndexedDB
// (src "" from the moment it is saved), so matching by src never found it and
// the url never landed; the send then uploaded the photo again. Both helpers
// now match by photo id first (photoId, when the event carries one), and by
// src only for a photo with no id. The upload flag (uploadState) goes with
// the url, or turns 'failed' with uploadFailed.
const _photoMatches = (ph, src, photoId) => !!ph && ((!!photoId && ph.id === photoId) || (!!src && ph.src === src));
// keepExisting: a photo that already has its url keeps it (the send's own
// write-back, which must not overwrite an upload that landed meanwhile).
const applyPhotoUploaded = (photos, oldSrc, newUrl, photoId, keepExisting) => {
  if (!Array.isArray(photos) || (!oldSrc && !photoId) || !newUrl) return photos;
  let changed = false;
  const next = photos.map(ph => {
    if (!_photoMatches(ph, oldSrc, photoId)) return ph;
    if (keepExisting && typeof ph.url === 'string' && ph.url.indexOf('http') === 0) return ph;
    changed = true;
    const { src, uploadFailed, uploadState, ...rest } = ph;
    return Object.assign({}, rest, { url: newUrl, src: newUrl });
  });
  return changed ? next : photos;
};
const applyPhotoFailed = (photos, src, photoId) => {
  if (!Array.isArray(photos) || (!src && !photoId)) return photos;
  let changed = false;
  const next = photos.map(ph => {
    if (!_photoMatches(ph, src, photoId)) return ph;
    changed = true;
    return Object.assign({}, ph, ph && ph.uploadState ? { uploadFailed: true, uploadState: 'failed' } : { uploadFailed: true });
  });
  return changed ? next : photos;
};
// ==== S162 PHOTO_UPLOAD_SYNC_END ─────────────────────────────────────────

// ==== S161 FITTING_DESC_LOGIC_START ──────────────────────────────────────
// Pure mapping from a vision-scan fitting proposal to the Description prefill.
// tests/fitting_desc.test.js slices this block (START→END markers) under
// node:test. Keep it free of React / browser globals.
// The scan's read description (e.g. "table lamp") lands in the editable
// Description field as a labelled prefill; absent / non-string / whitespace
// reads land as '' so the field stays genuinely optional.
const descriptionFromScan = (fitting) => {
  if (!fitting || typeof fitting !== 'object') return '';
  return typeof fitting.description === 'string' ? fitting.description.trim() : '';
};
// ==== S161 FITTING_DESC_LOGIC_END ────────────────────────────────────────

// ── S100 — month grouping helpers ─────────────────────────────
// Promoted from inside computePersonalBestsFromProposals so any
// screen that needs to bucket items by month uses one canonical
// implementation. Both helpers return en-GB formatted strings to
// match the rest of the companion's locale.
const monthKey = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
const fmtMonthLabel = (d) => d.toLocaleString('en-GB', { month: 'long', year: 'numeric' });

// Group an array of items into [{key, label, dt, items}, ...]
// sorted by month DESC (most recent first). `getDate(item)` returns
// a Date or a parseable string; items with no parseable date land
// under the 'undated' bucket sorted last.
const groupByMonth = (items, getDate) => {
  const buckets = new Map();
  for (const it of (items || [])) {
    const raw = getDate(it);
    const d = raw instanceof Date ? raw : (raw ? new Date(raw) : null);
    if (d && !isNaN(d.getTime())) {
      const k = monthKey(d);
      if (!buckets.has(k)) {
        buckets.set(k, { key: k, label: fmtMonthLabel(d), dt: new Date(d.getFullYear(), d.getMonth(), 1), items: [] });
      }
      buckets.get(k).items.push(it);
    } else {
      if (!buckets.has('undated')) {
        buckets.set('undated', { key: 'undated', label: 'Undated', dt: new Date(0), items: [] });
      }
      buckets.get('undated').items.push(it);
    }
  }
  const out = Array.from(buckets.values());
  out.sort((a, b) => b.dt - a.dt);
  return out;
};

// ── S100 — canonical delete helper + tombstone ────────────────
// Pre-S100 the per-card delete handlers in SurveyLandingScreen wrote
// only to localStorage — leaving the React `projects` state untouched.
// The App-level useEffect that persists projects on every change then
// rewrote the deleted row back over the localStorage delete on the
// next render, so the card never went away from the user's view.
//
// deleteSurvey() owns the full destructive sweep: project store,
// survey_queue, lumen_visits, lumen_surveys_portal cache, and the
// survey_active / survey_inprogress mid-flight keys when the project
// being deleted is the one currently open. The caller is still
// responsible for invoking onDeleteProject(id) so React state stays
// in step — this helper handles localStorage only.
//
// Tombstone: deleted ids are stamped into lumen_deleted_surveys so
// the next portal sync (which overwrites lumen_surveys_portal whole-
// sale) cannot reflate a deleted entry. Filters that merge portal
// surveys must consult getDeletedSurveyIds() to honour the tombstone.
const LUMEN_DELETED_SURVEYS_KEY = 'lumen_deleted_surveys';

const getDeletedSurveyIds = () => {
  try {
    const arr = JSON.parse(localStorage.getItem(LUMEN_DELETED_SURVEYS_KEY) || '[]');
    return new Set(Array.isArray(arr) ? arr : []);
  } catch (e) { return new Set(); }
};

const markSurveyDeleted = (id) => {
  if (!id) return;
  try {
    const arr = JSON.parse(localStorage.getItem(LUMEN_DELETED_SURVEYS_KEY) || '[]');
    const set = new Set(Array.isArray(arr) ? arr : []);
    if (!set.has(id)) {
      set.add(id);
      // Cap at 500 to keep the tombstone list bounded forever.
      const next = Array.from(set);
      while (next.length > 500) next.shift();
      localStorage.setItem(LUMEN_DELETED_SURVEYS_KEY, JSON.stringify(next));
    }
  } catch (e) {}
};

// ── S101 — snag delete + tombstone (parallel to survey helpers) ──
// Pre-S101 the snag cards on SurveyLandingScreen had no delete
// affordance at all. Same canonical pattern as deleteSurvey: scrub
// localStorage, mark a tombstone so any future re-hydration path
// (voice-note→snag, reconciliation, sync) cannot reflate.
const LUMEN_DELETED_SNAGS_KEY = 'lumen_deleted_snags';

const getDeletedSnagIds = () => {
  try {
    const arr = JSON.parse(localStorage.getItem(LUMEN_DELETED_SNAGS_KEY) || '[]');
    return new Set(Array.isArray(arr) ? arr : []);
  } catch (e) { return new Set(); }
};

const markSnagDeleted = (id) => {
  if (!id) return;
  try {
    const arr = JSON.parse(localStorage.getItem(LUMEN_DELETED_SNAGS_KEY) || '[]');
    const set = new Set(Array.isArray(arr) ? arr : []);
    if (!set.has(id)) {
      set.add(id);
      const next = Array.from(set);
      while (next.length > 500) next.shift();
      localStorage.setItem(LUMEN_DELETED_SNAGS_KEY, JSON.stringify(next));
    }
  } catch (e) {}
};

const deleteSnag = (snagId, opts = {}) => {
  if (!snagId) return false;
  const { projectName, snagStatus } = opts;
  try {
    logDestructiveAction('delete_snag', {
      projectId: snagId,
      meta: { name: projectName || '', status: snagStatus || 'unknown' },
    });
  } catch (e) {}
  try {
    const snags = JSON.parse(localStorage.getItem('lumen_snags') || '[]');
    localStorage.setItem('lumen_snags', JSON.stringify(snags.filter(s => s.id !== snagId)));
  } catch (e) {}
  markSnagDeleted(snagId);
  return true;
};

const deleteSurvey = (projectId, opts = {}) => {
  if (!projectId) return false;
  const { userId, surveyState, projectName } = opts;
  // Forensic FIRST so even a totally-failed sweep leaves a trail.
  try {
    logDestructiveAction('delete_survey', {
      projectId,
      meta: { state: surveyState || 'unknown', name: projectName || '' },
    });
  } catch (e) {}
  // 1. Per-user project store. Removed here AND from React state by
  //    the caller via onDeleteProject(id) so the auto-persist
  //    useEffect can't re-write the deleted row over this.
  try {
    if (userId) {
      const key = `asg_projects_${userId}`;
      const all = JSON.parse(localStorage.getItem(key) || '[]');
      localStorage.setItem(key, JSON.stringify(all.filter(p => p.id !== projectId)));
    }
  } catch (e) {}
  // 2. survey_queue
  try {
    const sq = JSON.parse(localStorage.getItem('survey_queue') || '[]');
    localStorage.setItem('survey_queue', JSON.stringify(sq.filter(item => item.id !== projectId)));
  } catch (e) {}
  // 3. lumen_visits
  try {
    const tv = JSON.parse(localStorage.getItem('lumen_visits') || '[]');
    localStorage.setItem('lumen_visits', JSON.stringify(tv.filter(v => v.surveyId !== projectId)));
  } catch (e) {}
  // 4. lumen_surveys_portal cache + tombstone for future syncs
  try {
    const ps = JSON.parse(localStorage.getItem('lumen_surveys_portal') || 'null');
    if (ps && Array.isArray(ps.surveys)) {
      ps.surveys = ps.surveys.filter(s => s.id !== projectId);
      localStorage.setItem('lumen_surveys_portal', JSON.stringify(ps));
    }
  } catch (e) {}
  markSurveyDeleted(projectId);
  // 5. Mid-flight survey state — only when the deleted project is
  //    the one currently open. Otherwise leave alone.
  try {
    const sa = JSON.parse(localStorage.getItem('survey_active') || 'null');
    if (sa && sa.projectId === projectId) {
      clearActiveDraft('delete_survey', { projectId: projectId, name: projectName || '' });
    }
  } catch (e) {}
  return true;
};

// ── S96 BRIEF A · forensic destructive-action log ────────────
// No behavioural change — purely an append-only forensic trail. Each
// invocation writes {ts, userId, projectId, path, meta} to
// `lumen_destructive_action_log` (capped at 200 entries) AND console.warn so
// a developer tail of the console catches it live. Use at every code path
// that wipes / overwrites / replaces persistent project or visit data.
const logDestructiveAction = (path, payload = {}) => {
  const KEY = 'lumen_destructive_action_log';
  const CAP = 200;
  let userId = '';
  try {
    const raw = localStorage.getItem('asg_current_user');
    if (raw) userId = (JSON.parse(raw) || {}).id || '';
  } catch(e) {}
  const entry = {
    ts: new Date().toISOString(),
    path,
    userId,
    projectId: payload.projectId || '',
    meta: payload.meta || {},
  };
  try {
    const log = JSON.parse(localStorage.getItem(KEY) || '[]');
    log.push(entry);
    while (log.length > CAP) log.shift();
    localStorage.setItem(KEY, JSON.stringify(log));
  } catch(e) {}
  try { console.warn(`[destructive] ${path}`, entry); } catch(e) {}
};

// S135 — the ONLY sanctioned path to clear the in-progress survey draft.
// Forensic-logged on every call (logDestructiveAction + debugLog) per the
// never-lose-a-survey mandate. Callers MUST have a confirmed-successful submit
// (see shouldClearActiveDraft) or an explicit user delete before calling.
const clearActiveDraft = (reason, meta) => {
  const m = meta || {};
  try {
    logDestructiveAction('survey_draft_clear', {
      projectId: m.projectId || '',
      meta: Object.assign({ reason: reason }, m),
    });
  } catch (e) {}
  try { debugLog('survey.draft.cleared', Object.assign({ reason: reason }, m)); } catch (e) {}
  try { localStorage.removeItem('survey_active'); } catch (e) {}
  try { localStorage.removeItem('survey_inprogress'); } catch (e) {}
};

// SEND-STATE-V1: apply fn to the survey draft's photos when the draft is this
// job's. A refused write is logged, never thrown.
const patchActiveDraftPhotos = (projectId, fn) => {
  try {
    const draft = JSON.parse(localStorage.getItem('survey_active') || 'null');
    if (!draft || !projectId || draft.projectId !== projectId || !Array.isArray(draft.sitePhotos)) return;
    const next = fn(draft.sitePhotos);
    if (next === draft.sitePhotos) return;
    draft.sitePhotos = photosToRefs(next);
    localStorage.setItem('survey_active', JSON.stringify(draft));
  } catch (err) { try { debugLog('photo.draft.patch_failed', { projectId, error: String(err && err.name || err) }); } catch (e2) {} }
};

// SEND-STATE-V1: what follows a sent survey on the phone, the same whether the
// portal took it at once (Check and send) or later from the queue: the draft
// is cleared (by the queue only when the draft is this job's, since the
// surveyor may be on another job by then), and the visit and the survey queue
// rows are marked submitted.
const wrapSentAfter = (projectId, surveyId, iso, opts) => {
  const o = opts || {};
  let clear = true;
  if (o.onlyIfDraftIsThisJob) {
    try { const d = JSON.parse(localStorage.getItem('survey_active') || 'null'); clear = !!d && d.projectId === projectId; } catch (e) { clear = false; }
  }
  if (clear) clearActiveDraft(o.reason || 'wrap_submit_success', { projectId: projectId, surveyId: surveyId || '' });
  try {
    const tv = JSON.parse(localStorage.getItem('lumen_visits') || '[]');
    tv.forEach(v => { if (v.surveyId === projectId) { v.status = 'submitted'; v.submitted_at = iso; } });
    localStorage.setItem('lumen_visits', JSON.stringify(tv));
    const sq = JSON.parse(localStorage.getItem('survey_queue') || '[]');
    sq.forEach(s => { if (s.id === projectId) { s.status = 'submitted'; s.submitted_at = iso; } });
    localStorage.setItem('survey_queue', JSON.stringify(sq));
  } catch(e) {}
};

// S135 (4.4) — minimal, bounded success toast. Used ONLY for the three
// sanctioned confirmations (saved-state, submit/wrap success, photo saved);
// not a general notification surface.
const showSavedToast = (message, color) => {
  try {
    if (typeof document === 'undefined') return;
    const te = document.createElement('div');
    te.textContent = message;
    Object.assign(te.style, {
      position: 'fixed', bottom: '104px', left: '50%', transform: 'translateX(-50%)',
      background: color || '#2E6838', color: '#fff', padding: '9px 18px', borderRadius: '20px',
      fontSize: '13px', fontWeight: '700', zIndex: '99999', opacity: '1',
      transition: 'opacity 0.3s', boxShadow: '0 4px 14px rgba(0,0,0,0.22)', pointerEvents: 'none',
    });
    // Studio (track C4): raised paper with ink words. The colour a caller
    // passes (a stage or brand green) is not used: colour is for stages,
    // money and Eva only.
    if (t.theme === 'uv') Object.assign(te.style, studioToastStyle());
    document.body.appendChild(te);
    setTimeout(() => { te.style.opacity = '0'; setTimeout(() => { try { te.remove(); } catch (e) {} }, 300); }, 1400);
  } catch (e) {}
};

// ── Sync target to portal on save ────────────────────
const syncTargetToPortal = async (monthlyRevenue) => {
  const token = localStorage.getItem('lumen_token');
  if (!token) return; // not authenticated, skip silently
  const period = new Date().toISOString().slice(0, 7); // YYYY-MM
  try {
    await fetch(`${PORTAL_URL}/api/targets`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ monthly_revenue: monthlyRevenue, period })
    });
  } catch (e) {
    console.warn('Target sync failed silently', e);
  }
};

// ── Fetch target from portal (portal is source of truth) ─
const fetchTargetFromPortal = async () => {
  const token = localStorage.getItem('lumen_token');
  if (!token) return;
  // COMPANION-TRUTH-V3: the answer is the target of the person whose token
  // asked, so it is kept under that person's key even if someone else is on
  // the phone by the time it lands; never under theirs.
  const askedFor = currentLocalUserId();
  if (askedFor == null) return;
  try {
    const res = await fetch(`${PORTAL_URL}/api/targets`, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    if (res.ok) {
      const data = await res.json();
      if (data.monthly_revenue != null) {
        writeMyMonthlyTarget(data.monthly_revenue.toString(), askedFor);
      }
    }
  } catch (e) {
    console.warn('Target fetch failed silently', e);
  }
};

// The five-minute background sync. One starter for both ways a person comes
// in (sign-in and a restored session), so the two can never drift: before
// COMPANION-FOLLOWUPS-V2 a restored session synced once and never again.
// resetForNextPerson stops it, on both paths to the next person.
const PORTAL_SYNC_EVERY_MS = 5 * 60 * 1000;
const startPortalSyncInterval = () => {
  try { if (window._lumenSyncInterval) clearInterval(window._lumenSyncInterval); } catch (e) {}
  window._lumenSyncInterval = setInterval(() => {
    if (localStorage.getItem('asg_current_user')) syncPortalData();
  }, PORTAL_SYNC_EVERY_MS);
};

const syncPortalData = async () => {
  // COMPANION-HEALTH-V1: fault reports ride the sync (sign-in and every 5
  // minutes), in the background; nothing here waits for them.
  healthFlushSoon(0);
  const token = localStorage.getItem('lumen_token');
  const headers = token ? { 'Authorization': `Bearer ${token}` } : {};
  // COMPANION-TRUTH-V2 B1: this sync belongs to the person (and token) on the
  // phone when it starts. If either has changed by the time a read answers
  // (a switch of user, a sign out, a fresh sign-in), that answer is the last
  // person's and nothing is written: no body, no _synced_at, no 403 removal.
  const startedBy = currentLocalUserId();
  const stillMine = () => {
    let tok = null;
    try { tok = localStorage.getItem('lumen_token'); } catch (e) {}
    return currentLocalUserId() === startedBy && tok === token;
  };
  // The first write stamps the owner, clearing first anything another person
  // (or nobody we can name) left, so hydrateProposalsFromPortal can tell whose
  // lumen_pipeline it is reading.
  let claimed = false;
  const claimOnce = () => {
    if (claimed) return;
    claimed = true;
    claimPortalCaches(startedBy);
  };
  const base = PORTAL_URL;
  await flushOfflineQueue();
  const endpoints = [
    { key: 'lumen_pipeline',       path: '/api/companion/pipeline' },
    { key: 'lumen_contacts',       path: '/api/companion/contacts' },
    { key: 'lumen_intelligence',   path: '/api/companion/intelligence' },
    { key: 'lumen_targets',        path: '/api/companion/targets' },
    { key: 'lumen_profile',        path: '/api/companion/profile' },
    // COMPANION-TRUTH-V1, amended by V2 B5: the user's own D7 and D8 over the
    // financial year, D10 with D19, D16 per job and D20.
    { key: 'lumen_figures',        path: '/api/companion/figures' },
    { key: 'lumen_surveys_portal', path: '/api/companion/surveys' },
    { key: 'lumen_notifications',  path: '/api/companion/notifications' },
    // B.2 Slice 1 — picker feed: active portal projects (canonical PRJ ids,
    // merged/test rows already excluded server-side). The QuickEntry picker
    // reads ONLY this cache (offline = stale list, staleness displayed) —
    // it never fetches inline.
    { key: 'lumen_projects',       path: '/api/companion/projects' },
    // STUDIO-LIT-PHONE-V1: the whole team's figures (Today's "Last 7 days,
    // whole team"). The portal answers 403 to anyone who may not see sales
    // figures; then any copy held from before is cleared, so a figure the
    // person may no longer see is never shown from an old cache.
    { key: 'lumen_company',        path: '/api/companion/company', clearOn403: true },
    // STUDIO-LIT-PHONE-V1 item 5: my quotes built (D8) and sent (D9) this
    // week and last, for My performance. Until the portal serves it the read
    // answers 404 and the two rows are left out.
    { key: 'lumen_week',           path: '/api/companion/week' },
  ];
  await Promise.allSettled(
    endpoints.map(async ({ key, path, clearOn403 }) => {
      try {
        const res = await fetch(`${base}${path}`, { headers, credentials: 'include' });
        // Track C: every /api/companion/* read answers 401 only when it sees
        // no live sign-in, so this 5-minute sync is what notices a dead token
        // even when nothing is being sent.
        bearerRefused(res.status, token, 'sync ' + path);
        if (clearOn403 && res.status === 403) {
          if (!stillMine()) return;
          localStorage.removeItem(key);
          localStorage.removeItem(`${key}_synced_at`);
        }
        if (res.ok) {
          const data = await res.json();
          if (!stillMine()) return;
          claimOnce();
          localStorage.setItem(key, JSON.stringify(data));
          localStorage.setItem(`${key}_synced_at`, new Date().toISOString());
        }
      } catch (e) {
        console.warn(`Sync failed for ${key}:`, e);
      }
    })
  );
  // Notify components to re-render with fresh data
  window.dispatchEvent(new CustomEvent('lumenDataSync'));
};

// ─────────────────────────────────────────────────────
// ASG Companion App v2 — "Turn this site visit into a signed proposal"
// Full sales conversion tool: Pre-Visit → Scope Capture → 
// Live Survey → On-Site Proposal → Portal Sync → Quote Pipeline
// ─────────────────────────────────────────────────────

const SCREENS = ["today", "previsit", "scope", "survey", "proposal", "capture", "newenquiry", "settings", "plans", "voice", "surveylanding", "surveywrap", "snagsetup", "snagcapture", "snagreview", "quotes", "more", "mytargets", "pipeline", "company", "morningbriefing", "contacts", "suppliers"];
const SCREEN_LABELS = ["Today", "Pre-Visit", "Scope Capture", "Live Survey", "Proposal", "Issue Log", "New Enquiry", "Settings", "Plans", "Voice Notes", "Survey Landing", "Survey Wrap", "Snag Setup", "Snag Capture", "Snag Review", "Quotes", "More", "My Targets", "Pipeline", "Company", "Morning Briefing", "Contacts", "Suppliers"];

// ── Shimmer animation for skeleton cards ──
if (!document.getElementById('lumen-shimmer-css')) {
  const shimmerStyle = document.createElement('style');
  shimmerStyle.id = 'lumen-shimmer-css';
  shimmerStyle.textContent = `@keyframes lumenShimmer { 0% { background-position: -200% 0; } 100% { background-position: 200% 0; } } @keyframes micpulse { 0%,100% { box-shadow: 0 0 0 0 rgba(200,80,64,0.4); } 50% { box-shadow: 0 0 0 10px rgba(200,80,64,0); } } @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } } .fixture-tile:active { transform: scale(0.96) !important; opacity: 0.8 !important; }`;
  document.head.appendChild(shimmerStyle);
}
const shimmerBg = (base) => ({
  background: `linear-gradient(90deg, ${base} 25%, rgba(255,255,255,0.12) 50%, ${base} 75%)`,
  backgroundSize: '200% 100%',
  animation: 'lumenShimmer 1.5s infinite ease-in-out',
});
const shimmerBgDark = shimmerBg('rgba(255,255,255,0.05)');
const shimmerBgWarm = shimmerBg('rgba(106,88,64,0.08)');

// ── Design Tokens ─────────────────────────────────────
const t = {
  radius: { sm: 8, md: 12, lg: 16, xl: 20, pill: 999 },
  colors: {
    // Legacy dark-mode aliases — kept for backward compat, now map to warm-stone equivalents
    navy: "#1A1608", navyMid: "#2A2010", navyLight: "#3A3018",
    // New warm stone design system
    bg: "#E8DCC8",
    // Glass panel
    glass: "rgba(255,252,242,0.88)",
    glassBorder: "rgba(255,252,240,0.85)",
    glassBorderTop: "rgba(255,255,250,0.96)",
    glassBorderGold: "rgba(200,144,48,0.28)",
    // Primary text colours (dark on warm stone)
    text: "#1A1608",
    textSecondary: "rgba(28,24,16,0.52)",
    textTertiary: "rgba(28,24,16,0.38)",
    // Gradients
    heroGrad: "linear-gradient(135deg, #C89030 0%, #1A5A78 100%)",
    navGrad: "linear-gradient(90deg, #F0E2B8 0%, #C0DDE8 100%)",
    // Semantic colours — new design system
    gold: "#C89030",         goldText: "#A87818",    goldBright: "#C89030",
    goldLight: "rgba(200,144,48,0.12)", goldGlow: "rgba(200,144,48,0.20)",
    teal: "#1A5A78",
    green: "#2E6838",        greenLight: "rgba(46,104,56,0.10)",
    rose: "#7A4856",
    terracotta: "#C87848",    terracottaLight: "rgba(200,120,72,0.10)", terracottaBorder: "rgba(200,120,72,0.25)",
    amberText: "#8C6018",
    amber: "#C89030",        amberLight: "rgba(200,144,48,0.10)",
    red: "#B04040",          redLight: "rgba(176,64,64,0.08)",
    blue: "#5B9BD5",         blueLight: "rgba(91,155,213,0.10)",
    purple: "#5A6090",       purpleLight: "rgba(90,96,144,0.10)",
    orange: "#C87848",       orangeLight: "rgba(200,120,72,0.10)",
    separator: "rgba(28,24,16,0.08)",
    // Input fields
    input: "rgba(255,255,255,0.65)",
    inputBorder: "rgba(255,252,240,0.90)",
  },
  shadow: {
    md: "0 2px 12px rgba(28,24,16,0.08)",
    lg: "0 4px 24px rgba(28,24,16,0.10)",
    gold: "0 0 20px rgba(200,144,48,0.12), 0 4px 16px rgba(28,24,16,0.08)",
    blue: "0 0 20px rgba(91,155,213,0.12), 0 4px 16px rgba(28,24,16,0.08)",
  },
};

// ==== UV_WAVE1_TOKENS_START ====
// UV-RESKIN-V1 track E: tokens for the wave-1 screens (Today, the survey area
// list, Survey Wrap, Survey Landing). Each standard value below is the exact
// literal the sweep replaced, so with the theme off every swept screen renders
// byte-for-byte as before (tests/uv_reskin_screens.test.js). A null standard
// value renders nothing: it adds a property (the brand card shadow, a label
// spacing) only under the theme. The ultraviolet values are in T_UV_OVERRIDES.
// Family keys are named for the literal: ink38 = rgba(26,22,8,0.38), and
// stone = 28,24,16; olive = 42,58,26; paper = 255,252,242; sand = 221,208,184;
// gold = 200,144,48; green = 46,104,56; teal = 26,90,120; alert = 200,80,64.
Object.assign(t.colors, {
  alert08: "rgba(200,80,64,0.08)", alert11: "rgba(200,80,64,0.11)", alert22: "rgba(200,80,64,0.22)",
  alertB10: "rgba(200,80,60,0.10)", alertB4: "rgba(200,80,60,0.4)", alertE12: "rgba(200,64,48,0.12)",
  bark55: "rgba(90,74,42,0.55)", bark6: "rgba(90,74,42,0.6)", blue30: "rgba(91,155,213,0.30)",
  deep03: "rgba(22,38,58,0.03)", deep55: "rgba(22,38,58,0.55)", gold10: "rgba(200,144,48,0.10)",
  gold2: "rgba(200,144,48,0.2)", gold22: "rgba(200,144,48,0.22)", gold25: "rgba(200,144,48,0.25)",
  gold28: "rgba(200,144,48,0.28)", gold30: "rgba(200,144,48,0.30)", gold4: "rgba(200,144,48,0.4)",
  gold5: "rgba(200,144,48,0.5)", green07: "rgba(46,104,56,0.07)", green08: "rgba(46,104,56,0.08)",
  green1: "rgba(46,104,56,0.1)", green10: "rgba(46,104,56,0.10)", green12: "rgba(46,104,56,0.12)",
  green13: "rgba(46,104,56,0.13)", green14: "rgba(46,104,56,0.14)", green15: "rgba(46,104,56,0.15)",
  green16: "rgba(46,104,56,0.16)", green22: "rgba(46,104,56,0.22)", green25: "rgba(46,104,56,0.25)",
  green28: "rgba(46,104,56,0.28)", green32: "rgba(46,104,56,0.32)", green45: "rgba(46,104,56,0.45)",
  green5: "rgba(46,104,56,0.5)", green65: "rgba(46,104,56,0.65)", green95: "rgba(46,104,56,0.95)",
  ink03: "rgba(26,22,8,0.03)", ink04: "rgba(26,22,8,0.04)", ink05: "rgba(26,22,8,0.05)",
  ink06: "rgba(26,22,8,0.06)", ink07: "rgba(26,22,8,0.07)", ink08: "rgba(26,22,8,0.08)",
  ink10: "rgba(26,22,8,0.10)", ink11: "rgba(26,22,8,0.11)", ink12: "rgba(26,22,8,0.12)",
  ink13: "rgba(26,22,8,0.13)", ink14: "rgba(26,22,8,0.14)", ink18: "rgba(26,22,8,0.18)",
  ink2: "rgba(26,22,8,0.2)", ink22: "rgba(26,22,8,0.22)", ink25: "rgba(26,22,8,0.25)",
  ink3: "rgba(26,22,8,0.3)", ink32: "rgba(26,22,8,0.32)", ink35: "rgba(26,22,8,0.35)",
  ink38: "rgba(26,22,8,0.38)", ink4: "rgba(26,22,8,0.4)", ink42: "rgba(26,22,8,0.42)",
  ink45: "rgba(26,22,8,0.45)", ink5: "rgba(26,22,8,0.5)", ink55: "rgba(26,22,8,0.55)",
  ink6: "rgba(26,22,8,0.6)", ink62: "rgba(26,22,8,0.62)", ink65: "rgba(26,22,8,0.65)",
  ink7: "rgba(26,22,8,0.7)", mint15: "rgba(94,192,128,0.15)", mint2: "rgba(94,192,128,0.2)",
  mint3: "rgba(94,192,128,0.3)", olive06: "rgba(42,58,26,0.06)", olive08: "rgba(42,58,26,0.08)",
  olive12: "rgba(42,58,26,0.12)", olive2: "rgba(42,58,26,0.2)", olive25: "rgba(42,58,26,0.25)",
  paper07: "rgba(255,252,242,0.07)", paper09: "rgba(255,252,242,0.09)", paper14: "rgba(255,252,242,0.14)",
  paper20: "rgba(255,252,242,0.20)", paper38: "rgba(255,252,242,0.38)", paper55: "rgba(255,252,242,0.55)",
  paper60: "rgba(255,252,242,0.60)", paper62: "rgba(255,252,242,0.62)", paper7: "rgba(255,252,242,0.7)",
  paper75: "rgba(255,252,242,0.75)", paper82: "rgba(255,252,242,0.82)", paper85: "rgba(255,252,242,0.85)",
  paper92: "rgba(255,252,242,0.92)", paper94: "rgba(255,252,242,0.94)", paper95: "rgba(255,252,242,0.95)",
  paper96: "rgba(255,252,242,0.96)", sand15: "rgba(221,208,184,0.15)", sand18: "rgba(221,208,184,0.18)",
  sand3: "rgba(221,208,184,0.3)", sand30: "rgba(221,208,184,0.30)", sand35: "rgba(221,208,184,0.35)",
  sky10: "rgba(62,139,191,0.10)", sky25: "rgba(62,139,191,0.25)", stone06: "rgba(28,24,16,0.06)",
  stone08: "rgba(28,24,16,0.08)", stone1: "rgba(28,24,16,0.1)", stone25: "rgba(28,24,16,0.25)",
  stone35: "rgba(28,24,16,0.35)", stone4: "rgba(28,24,16,0.4)", stone42: "rgba(28,24,16,0.42)",
  stone45: "rgba(28,24,16,0.45)", stone48: "rgba(28,24,16,0.48)", stone5: "rgba(28,24,16,0.5)",
  stone55: "rgba(28,24,16,0.55)", stone75: "rgba(28,24,16,0.75)", teal07: "rgba(26,90,120,0.07)",
  teal08: "rgba(26,90,120,0.08)", teal18: "rgba(26,90,120,0.18)", teal24: "rgba(26,90,120,0.24)",
  teal35: "rgba(26,90,120,0.35)", terra08: "rgba(200,120,72,0.08)", umber08: "rgba(106,88,64,0.08)",
  actionsBar: "#C85040",  // section marker bar: ink
  addBlue: "#2A72A8",  // a control: ink
  alert: "#C85040",  // red attention / negative -> needs-you violet text
  alertText: "#A03020",  // needs-you text
  areaRowBg: "#FDFCF9",  // zone row -> paper 2
  areaRowBorder: "#EAE0CE",  // hairline
  areaTodo: "#A86048",  // not started: muted text (progress is never violet)
  barGold: "linear-gradient(180deg, #C89030, #A06820)",  // section marker bar
  barRed: "linear-gradient(180deg, #C85040, #982830)",  // section marker bar: decoration, ink
  barRose: "linear-gradient(180deg, #7A4856, #5A2836)",  // section marker bar: decoration, ink
  barTeal: "linear-gradient(180deg, #1A6A90, #0E4060)",  // section marker bar
  briefAccent: "#C89030",  // accent text on the assistant surface
  briefAlert: "#E05040",  // needs-you count on the assistant surface
  briefBody: "rgba(255,252,242,0.48)",  // body text on the assistant surface
  briefGlow: "radial-gradient(circle at top right, rgba(200,144,48,0.12) 0%, rgba(120,60,180,0.08) 40%, transparent 70%)",  // lamp-amber glow on the assistant surface
  briefGrad: "linear-gradient(145deg, #1A0A2E 0%, #2D1545 30%, #3D1F5A 55%, #2A1A10 80%, #1C1008 100%)",  // briefing hero = assistant surface
  briefPillBg: "rgba(200,144,48,0.20)",  // needs-you pill on dark
  briefPillBorder: "rgba(200,144,48,0.30)",  // needs-you pill on dark
  briefRead: "rgba(200,144,48,0.70)",  // link on the assistant surface
  brown: "#5A4A2A",  // secondary text and labels
  brownMid: "#6A5840",  // secondary text
  budgetNoneBorder: "#C85040",  // "No budget" selected: ink border and text
  budgetNoneDot: "#C85040",  // "No budget" is a category you pick: neutral dot
  budgetNoneSel: "rgba(200,80,64,0.07)",  // "No budget" selected: neutral fill
  calTile: "#D4C8B0",  // date tile -> sand tint
  chaseLink: "#B83020",  // a control: ink
  chevron: "#B7AC99",  // chevron stroke
  chipBg: "#F5EFE3",  // unselected choice chip -> sand tint
  chipFillGreen: "#2E6838",  // filled count chip -> sand-tint chip
  chipGold14: "rgba(200,144,48,0.14)",  // chip fill -> sand tint
  chipGold16: "rgba(200,144,48,0.16)",  // chip -> sand tint
  chipGoldText: "#7A5010",  // chip text
  chipGoldText2: "#8A6010",  // chip text
  chipMeeting: "rgba(60,60,160,0.12)",  // visit-type chip -> sand tint
  chipMeetingText: "#3030A0",  // visit-type chip text
  chipPitch: "rgba(122,24,64,0.12)",  // visit-type chip -> sand tint
  chipPitchText: "#7A1840",  // visit-type chip text
  chipPlannedBg: "rgba(200,144,48,0.12)",  // status chip -> sand tint
  chipSupplier: "rgba(26,90,120,0.12)",  // visit-type chip -> sand tint
  chipSurvey: "rgba(46,104,56,0.14)",  // visit-type chip -> sand tint
  chipTextOnFill: "#fff",  // text on a chip that becomes sand tint
  chipVisitBg: "rgba(200,144,48,0.10)",  // visit-label chip -> sand tint
  competitorGrad: "linear-gradient(145deg, rgba(200,80,60,0.06), rgba(255,252,242,0.5))",  // competitor row: paper 2 (a classification, not a decision)
  competitorLabel: "#C85040",  // section label: ink
  creamCard: "#FBF6E8",  // dialog -> paper
  creamOnFill: "#FBF6E8",  // text on an ink button
  dashSand: "#DDD0B8",  // dashed add marker -> sand (ghost marker)
  discardBtn: "#B04040",  // destructive confirm: still a button you press, so ink (no red)
  discardChoice: "rgba(176,64,64,0.85)",  // a choice button: ink
  discardChoiceBorder: "rgba(176,64,64,0.32)",  // a choice button: ink outline
  discardText: "#FFF",  // text on an ink button
  dockSub: "#9fb0c2",  // secondary text on the ink dock
  dockWrapBg: "#3E8BBF",  // the dock's Wrap button: a cream pill on ink
  dockWrapBgOff: "rgba(62,139,191,0.4)",  // the dock's Wrap button, not yet available
  dockWrapText: "#fff",  // ink text on the cream pill
  fieldBg: "#F5EFE3",  // input fill -> paper 2
  goldInk: "#C89030",  // gold used as text, icon or control colour (lamp amber is never text)
  goldLabel: "#A07020",  // section label
  goldMoney: "#C89030",  // gold used for a money figure -> ochre
  ground: "#E8DCC8",  // screen ground: cream, 10% paper grain, amber light top right, violet bloom bottom left
  heroSnagGrad: "linear-gradient(145deg, rgba(74,100,98,0.88), rgba(200,169,110,0.78))",  // primary action card: ink
  heroSurveyGrad: "linear-gradient(145deg, rgba(46,104,56,0.85), rgba(26,90,120,0.75))",  // primary action card: ink
  inkDeep: "#3A2E1A",  // body text
  inkWarm: "#2a2018",  // body text
  inputWhite: "#FFF",  // input fill -> paper
  intelAction: "#906010",  // a control: ink
  intelCardGrad: "linear-gradient(135deg, #FCF6E4 0%, #F8EAC4 55%, #FCF2DC 100%)",  // insight card -> paper
  jobChipSnag: "#C87848",  // job-type chip -> sand tint
  jobChipSurvey: "#2E6838",  // job-type chip -> sand tint
  jobSnag: "#C87848",  // snag job-type spine and badge: sand ghost marker (BRAND.md)
  jobSnagGlyph: "#fff",  // glyph on the sand snag badge: ink
  khaki: "#8A7A5A",  // secondary text
  knowledgeGrad: "linear-gradient(145deg, rgba(26,90,120,0.07), rgba(255,252,242,0.5))",  // note row -> paper 2
  lineSand: "#E3D9C6",  // hairline
  liveCardGrad: "linear-gradient(135deg, #2A5A38 0%, #6A6820 40%, #283850 100%)",  // survey-in-progress card: an ink card (no green)
  liveDot: "#5EC080",  // live dot: lamp-amber glow (a light, not text)
  liveLabel: "#5EC080",  // accent text on an ink card
  lpcConfirmBg: "rgba(176,64,64,0.92)",  // delete-confirm overlay: ink (no red)
  lpcDeleteText: "#B04040",  // delete is the user's own action: ink
  moneyGreen: "#2E6838",  // a money value drawn green -> ochre
  moneyInput: "#1A1608",  // typed job value is money: ochre
  moneySign: "rgba(26,22,8,0.35)",  // the £ beside the job-value input is money: ochre
  monthClosed: "#FAF8F3",  // closed month header -> paper
  monthOpen: "#F1E9DA",  // open month header -> paper 2
  onDarkFaint: "rgba(255,252,242,0.30)",  // label on the assistant surface (violet on dark)
  onDarkFaint28: "rgba(255,252,242,0.28)",  // label on the assistant surface
  onFill: "#fff",  // text on an ink fill (brand primary-button text)
  heroSnagText: "#fff",  // text and icon on the Start Snag tile (today: the same white as onFill)
  briefCount: "rgba(255,252,242,0.82)",  // the Gone Silent count on the brief card (today: the same value as paper82)
  paperSolid: "#FAF7F0",  // paper card
  pipMeeting: "#2A3080",  // visit-type dot: neutral (the label carries the type)
  pipPitch: "#7A1840",  // visit-type dot: neutral (the label carries the type)
  raiseGrad: "linear-gradient(145deg, rgba(200,144,48,0.08) 0%, rgba(255,252,242,0.6) 60%)",  // talking-point row -> paper 2
  raiseLabel: "rgba(200,144,48,0.7)",  // small label
  readyPillBg: "rgba(46,104,56,0.15)",  // "Ready" is fine: ink tick and word, no pill
  recBg: "#C85040",  // recording in progress: ink (progress is never violet)
  recText: "#C85040",  // recording in progress: ink
  relLabel: "#7A4856",  // section label: ink (decoration is never violet)
  scrim45: "rgba(26,22,8,0.45)",  // modal scrim
  scrim55: "rgba(26,22,8,0.55)",  // modal scrim
  sentPillBg: "rgba(26,90,120,0.10)",  // "Sent" is fine: ink tick and word, no pill
  sentPillBorder: "rgba(26,90,120,0.22)",  // "Sent" is fine: no pill
  sevMedium: "#C89030",  // medium-severity dot: sand marker
  shelfBg: "#2E6838",  // accordion shelf: ink
  shelfHighBg: "rgba(200,80,64,0.30)",  // needs-you pill on ink
  shelfHighText: "#FFE3DD",  // needs-you text on dark
  shelfText: "#FBF6E8",  // text on ink
  siteNavy: "#16263A",  // site-wide card: ink
  staleDot: "#D84030",  // needs-you dot
  staleGrad: "linear-gradient(135deg, #FCECEA 0%, #F9DDD9 55%, #FDEAE6 100%)",  // stale-quote card -> paper (the violet dot and pill carry the state)
  statGold: "#A87818",  // a figure that is not money: ink
  statPurple: "#885AA0",  // figure: ink
  statusCopper: "#C08820",  // area started: muted dot
  statusSage: "#5A9048",  // area done: ink
  statusTerra: "#C06848",  // area not started: sand ghost dot
  stoneLt: "#A09080",  // label and chevron
  stoneMid: "#9A8870",  // secondary text
  streakBuilder: "#3E8BBF",  // streak series colour: muted (progress is never violet)
  streakCloser: "#2E6838",  // streak series colour: muted (progress is never violet)
  streakPlatform: "#C89030",  // streak series colour (categorical; no gold text)
  supplierText: "#7a6a50",  // secondary text
  tabGold: "#BF9428",  // active tab: ink
  tabNavy: "#1A3A5A",  // active tab: ink
  taupe: "#7A6C5A",  // secondary text
  toneNeg: "#C85040",  // a falling count: muted, no colour by sign
  urgentText: "#A02818",  // needs-you pill text
  visitGradMeeting: "linear-gradient(145deg, #1E2848 0%, #1A2240 25%, #221838 55%, #1C2244 80%, #161830 100%)",  // visit card: ink card
  visitGradPitch: "linear-gradient(145deg, #3A1428 0%, #2E1020 25%, #381830 55%, #2A1020 80%, #200C18 100%)",  // visit card: ink card
  visitGradSupplier: "linear-gradient(145deg, #0E2840 0%, #143248 25%, #0E2038 55%, #163040 80%, #0A1E30 100%)",  // visit card: ink card
  visitGradSurvey: "linear-gradient(145deg, #1C4030 0%, #1A3828 25%, #163240 55%, #1E3828 80%, #142C20 100%)",  // visit card: ink card
  visitPitch: "#7A4856",  // visit-type colour used as a button fill: ink
  wrapBtn: "linear-gradient(135deg, #3C8348 0%, #2E6838 52%, #245A2E 100%)",  // primary button: ink pill
  wrapBtnPressed: "linear-gradient(135deg, #245228 0%, #1C3F20 100%)",  // primary button pressed (scale gives the feedback)
  wrapHeaderBg: "rgba(46,104,56,0.1)",  // wrap header -> paper
  wrapHeroBg: "rgba(46,104,56,0.11)",  // summary card -> paper
  wrapHeroBorder: "rgba(46,104,56,0.22)",  // hairline
  wrapSummaryBg: "rgba(46,104,56,0.1)",  // summary card -> paper
  wrapSummaryBorder: "rgba(46,104,56,0.2)",  // hairline
});
Object.assign(t.shadow, {
  card: null,  // brand card shadow, added only under the theme (null renders nothing)
  dialog: "0 20px 48px rgba(26,22,8,0.28)",  // dialog shadow
  dock: "0 12px 30px -12px rgba(22,38,58,0.6)",  // dock shadow
  dropdown: "0 6px 20px rgba(26,22,8,0.12)",  // dropdown shadow
  goldSoft: "0 2px 12px rgba(200,144,48,0.15)",  // pull-to-refresh pill
  heroSnag: "0 2px 12px rgba(74,100,98,0.1)",  // card shadow
  heroSurvey: "0 2px 12px rgba(46,104,56,0.08)",  // card shadow
  inkCard: null,  // brand card shadow without the inset highlight, on an ink card, added only under the theme
  kebab: "0 1px 6px rgba(26,22,8,0.18)",  // small brand shadow
  liveDot: "0 0 6px rgba(94,192,128,0.6)",  // lamp-amber glow
  liveStep: "0 0 0 3px rgba(46,104,56,0.2)",  // current-step halo in ink
  modal: "0 12px 32px rgba(26,22,8,0.25)",  // dialog shadow
  needsYouRing: null,  // needs-you pill outline, added only under the theme
  shelf: "0 1px 3px rgba(46,104,56,0.22)",  // small brand shadow
  staleDot: "0 0 0 4px rgba(216,64,48,0.14)",  // needs-you halo (violet wash)
  visitCard: "0 4px 20px rgba(26,22,8,0.15)",  // brand card shadow without the inset highlight (an ink card)
  wrapBtn: "0 13px 30px -12px rgba(46,104,56,0.75)",  // primary button shadow
  wrapBtnPressed: "0 4px 12px -7px rgba(46,104,56,0.55)",  // primary button pressed
});
Object.assign(t.radius, {
  card14: 14,  // card radius 14 -> brand 18
  dockWrap: 11,  // pill
  wrapBtn: 14,  // primary button: a pill
});
// Type: Georgia headings become Sentient, labels Satoshi 600 at .26em, no italics.
t.font = {
  italic: "italic",  // no italics under the theme
  labelLs: null,  // label spacing added under the theme where the label had none
  labelW: null,  // label weight added under the theme where the label had none
  ls005: 0.05,  // label spacing (was 0.05px)
  ls04em: "0.04em",  // label spacing
  ls05em: "0.05em",  // label spacing
  ls06: 0.6,  // label spacing (was 0.6px)
  ls06em: "0.06em",  // label spacing
  ls07: 0.7,  // label spacing (was 0.7px)
  ls07em: "0.07em",  // label spacing
  ls08em: "0.08em",  // label spacing
  ls09em: "0.09em",  // label spacing
  ls15em: "0.15em",  // label spacing
  ls1em: "0.1em",  // label spacing
  lw700: 700,  // label weight
  lw800: 800,  // label weight
  numFace: null,  // large numbers in Sentient, added only under the theme
  numW700: 700,  // large-number weight (Sentient 300 to 500)
  serif: "Georgia, serif",  // display face
  sysUi: "system-ui, -apple-system, sans-serif",  // body face
  tabular: null,  // tabular figures for money and number columns, added only under the theme
};
// ==== UV_WAVE1_TOKENS_END ====

// ==== UI_THEME_SEAM_START ====
// UV-RESKIN-V1 track B: the per-user interface theme. The portal sends
// `ui_theme` ('uv', or null for today's look) on /api/companion/profile, which
// the 5-minute sync caches as `lumen_profile`. That cached profile is the one
// place this app reads the theme from. Switching rewrites the token object `t`
// IN PLACE (every screen reads t.colors / t.shadow / t.radius at render time),
// so a switch re-renders the tree without remounting it: no screen, survey or
// queue loses state. `t.theme` names the active theme for the few places that
// need more than a token swap.
//
// T_STANDARD is a frozen copy of today's tokens, taken before anything can
// change `t`; switching off restores exactly it. T_UV_OVERRIDES holds the
// theme's values, derived since COMPANION-STUDIO-V1 track 1 from STUDIO_TOKENS
// (below). Track E added a fourth group, `font` (display face, label spacing
// and weight, italics, tabular figures).
const T_GROUPS = ['radius', 'colors', 'shadow', 'font'];
const T_STANDARD = JSON.parse(JSON.stringify(t));
// ==== STUDIO_TOKENS_START ====
// COMPANION-STUDIO-V1 track 1: the Studio values, in one place. Everything the
// theme switch shows comes from here: T_UV_OVERRIDES below is derived from it,
// and applyUiTheme copies it onto CSS custom properties (studioCssVars) so the
// body.theme-uv rules in index.html read the same source. docs/STUDIO.md lists
// the tokens; tests/studio_tokens.test.js checks them against the brief and
// checks the contrast of every text-on-surface pair. One light source, top
// right, so every shadow falls down and to the left. Self-contained on purpose:
// the test evaluates this block on its own.
const STUDIO_TOKENS = (() => {
  const freeze = (o) => { Object.values(o).forEach((v) => { if (v && typeof v === 'object') freeze(v); }); return Object.freeze(o); };
  // STUDIO-LIT-REDO-V1 P2: the Studio, lit v5 values (docs/studio-lit/target/
  // pipeline-flow.html, the `.lt{--ink:` block and its .paper, .well,
  // .litpaper, .jewel, .btn and .lnk rules). The 3 October sand layer is gone:
  // a cool lit grey ground, lit white paper, cool shadows, a cool ink.
  const AMBER = '#F2A23A';
  const INK = '#111827';
  const GROUND_BASE = '#E4E4E1';  // the ground's middle stop; also the browser chrome colour under the theme
  const PRESSED_RGB = '60,62,70';  // the well: rgba(60,62,70,.07)
  const PRESSED_ALPHA = 0.07;
  // A quiet cool grey for categories and ghost states: ink at 40% over the
  // ground base, worked out here so no new hue is typed.
  const MARKER = '#' + [1, 3, 5].map((i) => {
    const c = Math.round(0.4 * parseInt(INK.slice(i, i + 2), 16) + 0.6 * parseInt(GROUND_BASE.slice(i, i + 2), 16));
    return c.toString(16).padStart(2, '0').toUpperCase();
  }).join('');
  return freeze({
    ground: {
      // What the prototype RENDERS on the phone routes (the stylesheet wins):
      // screens/app.css `.lt .app-ground`, no vignette.
      css: 'radial-gradient(70% 34% at 92% -4%, rgba(242,170,80,.20), transparent 70%), radial-gradient(80% 40% at -10% 104%, rgba(75,43,255,.09), transparent 70%), radial-gradient(100% 50% at 60% 0%, rgba(248,248,246,.85), transparent 72%), linear-gradient(180deg, #EBEBE8, #E4E4E1 45%, #D8D8D5)',
      base: GROUND_BASE,
      stops: ['#EBEBE8', GROUND_BASE, '#D8D8D5'],
    },
    grain: {
      image: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='160'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='.9' numOctaves='2' stitchTiles='stitch'/%3E%3CfeColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 .55 0'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")",
      // The deeper grain (Andrew, 5 Oct 13:00): .2, with the `.lt .grain::after`
      // fog layer inside it at .55 multiply (so .2 x .55 on the page).
      opacity: 0.2,
      blend: 'multiply',
      fog: {
        image: "url(\"data:image/svg+xml;utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='900' height='900'%3E%3Cfilter id='m'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='.006' numOctaves='4' seed='7'/%3E%3CfeColorMatrix values='0 0 0 0 .12  0 0 0 0 .12  0 0 0 0 .14  0 0 0 .5 -.12'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23m)'/%3E%3C/svg%3E\")",
        opacity: 0.55,
        blend: 'multiply',
      },
    },
    // Raised paper: things you can act on (cards, job slips, nav rail, tab bar).
    paper: {
      css: 'linear-gradient(200deg, #FFFFFD, #FBFAF7 55%, #F5F3EF)',
      stops: ['#FFFFFD', '#FBFAF7', '#F5F3EF'],
      solid: '#FBFAF7',  // where a plain colour is needed (a value other code appends to)
    },
    // Lit paper: the lamp falls on it (the one card on a screen that matters most).
    litpaper: {
      css: 'radial-gradient(90% 120% at 100% 0%, rgba(255,232,196,.18), transparent 55%), linear-gradient(200deg, #FFFFFE, #FCFBF9 60%, #F7F6F3)',
      stops: ['#FFFFFE', '#FCFBF9', '#F7F6F3'],
      // The deeper `!important` shadow the stylesheet gives .paper and .litpaper alike.
      shadow: '-14px 28px 48px -20px rgba(30,32,40,.48), -3px 6px 12px -4px rgba(30,32,40,.22), inset 0 1px 0 rgba(255,255,255,.9)',
    },
    shadow: {
      raised: '-14px 28px 48px -20px rgba(30,32,40,.48), -3px 6px 12px -4px rgba(30,32,40,.22), inset 0 1px 0 rgba(255,255,255,.9)',
      slip: '-4px 7px 14px -8px rgba(30,32,40,.40), -1px 1px 2px rgba(30,32,40,.14)',
      slipHover: '-6px 11px 20px -9px rgba(30,32,40,.45), -1px 1px 2px rgba(30,32,40,.14)',
      pressed: 'inset 2px 4px 10px rgba(40,42,50,.16), inset -1px -1px 0 rgba(255,250,242,.55)',
    },
    // Pressed in (the well): where you are, or done (current item, finished zones, totals, inputs).
    pressed: {
      rgb: PRESSED_RGB, alpha: PRESSED_ALPHA, alphaMin: 0.07, alphaMax: 0.10,
      fill: `rgba(${PRESSED_RGB},${PRESSED_ALPHA})`,
      radius: 14,
    },
    // The jewel: Eva's place, the only dark surface on a light screen, one per screen.
    jewel: {
      fill: 'radial-gradient(70% 140% at 100% 50%, rgba(140,110,255,.55), transparent 60%), linear-gradient(180deg, #24164F, #1A1040)',
      stops: ['#24164F', '#1A1040'],
      shadow: '-10px 18px 34px -16px rgba(40,20,120,.55)',
      ring: '#B9ADFF',
      text: '#EDE8FF',
      textSecondary: '#C9C0FF',
    },
    ink: INK,                // text and every control that is not Eva
    muted: '#475569',        // secondary text, labels, units
    hairline: 'rgba(17,24,39,.12)',
    ultraviolet: '#4B2BFF',  // Eva, and the one main action per screen
    ultravioletHover: '#3B22E0',
    violetText: '#3B22E0',   // Eva speaking, and actions she needs from you
    onPrimary: '#FBF8FF',    // text on the ultraviolet button and the Eva disc
    lampAmber: AMBER,        // light only, never text
    ochre: '#6A470D',        // money only, tabular figures
    ochreFill: '#B8873A',    // money as a bar or a ring (never text)
    marker: MARKER,          // quiet cool grey marker for categories and ghost states
    // .btn: flat ultraviolet, a fine inner ring and a violet drop below.
    button: { radius: 10, minHeight: 44, ring: 'inset 0 0 0 1px rgba(30,10,140,.25)', shadow: 'inset 0 0 0 1px rgba(30,10,140,.25), -3px 6px 14px -6px rgba(60,30,200,.5)' },
    // Eva's orb (screens/app.css `.app-core`, `.app-ticks`): her voice place, the
    // header mic and the voice recorder. Violet because it is Eva's.
    // The core's light and deep stops are the jewel ring and the ultraviolet
    // (the prototype's #9C8BFF and #3418D8 are near both and carry no meaning
    // of their own), so the orb adds no new hue.
    orb: { core: 'radial-gradient(circle at 35% 30%, #B9ADFF, #4B2BFF 60%)', glow: '0 0 18px rgba(75,43,255,.85), 0 0 40px rgba(75,43,255,.45)', tick: '#B9ADFF', tickLive: '#B9ADFF' },
    // .lnk: a link is ink with an underline (violet is Eva and the main action only).
    link: { colour: INK, underline: 'rgba(17,24,39,.32)' },
    radius: { card: 18 },
    // After Won the lamp brightens towards payment.
    delivery: [
      ['won', 0.40], ['order_received', 0.52], ['materials_ordered', 0.64],
      ['on_site', 0.76], ['handover', 0.88], ['paid', 1.00],
    ].map(([step, alpha]) => ({ step, alpha, colour: `rgba(242,162,58,${alpha})` })),
    programme: { finished: MARKER, upcoming: AMBER, today: '#4B2BFF' },
    typeScale: [13, 14, 16, 20, 25, 31, 39, 49, 61],
    fonts: {
      display: "'Sentient', Georgia, serif",
      body: "'Satoshi', system-ui, -apple-system, sans-serif",
    },
    // The stage spectrum: ONE copy of the six colours.
    stages: {
      enquiry: '#2A1A6B', surveyed: '#4B2BFF', quoted: '#8E3BE8',
      negotiating: '#C2378F', won: AMBER, lost: '#6B1E2E',
    },
    stageOrder: ['enquiry', 'surveyed', 'quoted', 'negotiating', 'won', 'lost'],
    stageTrack: ['enquiry', 'surveyed', 'quoted', 'negotiating', 'won'],
    wonGlow: '0 0 14px rgba(242,162,58,.8)',
    // The stage ids the app writes (proj.stage) onto the Studio stages.
    // 'previsit' is booked but not yet surveyed; 'proposed' is a sent quote.
    // The app has no negotiating stage yet (FINDINGS T1-2).
    appStageMap: {
      enquiry: 'enquiry', previsit: 'enquiry', surveyed: 'surveyed',
      proposed: 'quoted', won: 'won', lost: 'lost',
    },
    themeColor: GROUND_BASE,  // browser chrome follows the lit grey ground under the theme
  });
})();

// COMPANION-STUDIO-LIT-V1: one colour, one meaning (the v6 phone target,
// docs/studio-lit/target/screens/app.js STG and app.css). Bars and rings use
// the fill value, words use the text value; the coloured word carries the
// state. Money is ochre text only. The ONE copy of these values: every
// screen reads them from here and never re-types a hex this object holds.
// STUDIO-LIT-REDO-V1 P2: fills are the v5 values; each TEXT value is the
// v5 value or, where that missed 4.5:1 on the lit ground's darkest stop or on
// a well, the nearest darker shade of the same hue that passes
// (docs/studio-lit/FINDINGS.md, P2 contrast). tests/studio_tokens.test.js
// checks every text value on every lit surface.
const STUDIO_MEANING = Object.freeze({
  // Eva, and the one main action: the Studio ultraviolet and its text value.
  violet: STUDIO_TOKENS.ultraviolet, violetText: STUDIO_TOKENS.violetText,
  client: '#1F7BFF', clientText: '#0056D2',   // the client's own actions
  newFill: '#5AA9FF', newText: '#1B5BB9',     // New
  quotedFill: '#89F336', quotedText: '#396A0F',  // Quoted
  strongFill: '#FB7185', strongText: '#AD2E45',  // Quoted with strong odds
  wonFill: '#F2A23A', wonText: '#8A5105',     // Won, or current
  rustFill: '#F97316', rustText: '#A9380A',   // needs attention
  ochre: STUDIO_TOKENS.ochre, ochreFill: STUDIO_TOKENS.ochreFill,  // money (text; bar or ring)
  slateFill: '#64748B', slateText: '#475569', // ordinary, or lost
});

// The CSS custom properties applyUiTheme sets on <html> and <body>, from the
// same object. index.html's body.theme-uv rules read only these.
function studioCssVars(S) {
  const v = {
    '--uv-ground': S.ground.css, '--uv-ground-base': S.ground.base,
    '--uv-grain': S.grain.image, '--uv-grain-opacity': S.grain.opacity,
    '--uv-grain-fog': S.grain.fog.image, '--uv-grain-fog-opacity': Math.round(S.grain.opacity * S.grain.fog.opacity * 1000) / 1000,
    '--uv-paper': S.paper.css, '--uv-paper-solid': S.paper.solid,
    '--uv-litpaper': S.litpaper.css, '--uv-litpaper-shadow': S.litpaper.shadow,
    '--uv-pressed-radius': S.pressed.radius + 'px',
    '--uv-button-shadow': S.button.shadow,
    '--uv-link': S.link.colour, '--uv-link-underline': S.link.underline,
    '--uv-raised': S.shadow.raised, '--uv-slip': S.shadow.slip,
    '--uv-slip-hover': S.shadow.slipHover, '--uv-pressed': S.shadow.pressed,
    '--uv-pressed-fill': S.pressed.fill,
    '--uv-jewel': S.jewel.fill, '--uv-jewel-shadow': S.jewel.shadow, '--uv-jewel-ring': S.jewel.ring,
    '--uv-jewel-text': S.jewel.text, '--uv-jewel-text-2': S.jewel.textSecondary,
    '--uv-ink': S.ink, '--uv-muted': S.muted, '--uv-hairline': S.hairline,
    '--uv-ultraviolet': S.ultraviolet, '--uv-ultraviolet-hover': S.ultravioletHover,
    '--uv-violet-text': S.violetText, '--uv-on-primary': S.onPrimary,
    '--uv-lamp': S.lampAmber, '--uv-ochre': S.ochre, '--uv-ochre-fill': S.ochreFill, '--uv-marker': S.marker,
    '--uv-button-radius': S.button.radius + 'px', '--uv-button-min-h': S.button.minHeight + 'px',
    '--uv-button-ring': S.button.ring, '--uv-radius-card': S.radius.card + 'px',
    '--uv-font-display': S.fonts.display, '--uv-font-body': S.fonts.body,
    '--uv-prog-finished': S.programme.finished, '--uv-prog-upcoming': S.programme.upcoming,
    '--uv-prog-today': S.programme.today, '--uv-won-glow': S.wonGlow,
  };
  S.stageOrder.forEach((id) => { v['--uv-stage-' + id] = S.stages[id]; });
  S.delivery.forEach((d) => { v['--uv-delivery-' + d.step.replace(/_/g, '-')] = d.colour; });
  S.typeScale.forEach((px) => { v['--uv-fs-' + px] = px + 'px'; });
  return v;
}
// ==== STUDIO_TOKENS_END ====

// The theme's values for the screens, DERIVED from STUDIO_TOKENS (no colour is
// spelt below). Every key keeps the name the screens already read; only the
// values changed from wave 1. Rules: raised paper for cards, pressed in for
// inputs, totals and done; ink text and controls; muted secondary text; violet
// text where Eva needs something from you; ultraviolet only for Eva and the one
// main action; lamp amber is light only; ochre is money only. The wave-1 dark
// surfaces are light now: the briefing hero, visit cards, the live survey card
// and the shelf are raised paper or pressed in (FINDINGS T1-5). heroGrad is the
// one jewel token. The hex keys stay hex, because some screens append a hex
// alpha suffix to them.
const T_UV_OVERRIDES = ((S) => {
  const alphaOf = (hex) => (a) => `rgba(${[1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16)).join(',')},${a})`;
  const ink = alphaOf(S.ink);
  const uv = alphaOf(S.ultraviolet);
  // STUDIO-LIT-PHONE-V1 (decision 1): the old reds and alerts were violet
  // under the theme. Violet is Eva and the one main action only, so a warning,
  // an error or a chase reads rust (needs attention) and a read link reads ink.
  const attention = STUDIO_MEANING.rustText;
  const amber = alphaOf(S.lampAmber);
  const onP = alphaOf(S.onPrimary);
  const jt = alphaOf(S.jewel.text);
  const ring = alphaOf(S.jewel.ring);
  const marker = S.marker;
  return {
  radius: {
    lg: S.radius.card, xl: S.radius.card, card14: S.radius.card,
    dockWrap: S.button.radius, wrapBtn: S.button.radius,
  },
  colors: {
      navy: S.ink, navyMid: S.ink, navyLight: S.muted, bg: S.ground.base, glass: S.paper.solid,
      glassBorder: S.hairline, glassBorderTop: S.hairline, glassBorderGold: S.hairline, text: S.ink,
      textSecondary: S.muted, textTertiary: S.muted, heroGrad: S.jewel.fill, navGrad: S.paper.solid,
      gold: S.lampAmber, goldText: S.ochre, goldBright: S.lampAmber, goldLight: amber(0.12),
      goldGlow: amber(0.26), teal: S.ink, green: S.ink, greenLight: ink(0.06), rose: S.ink,
      // STUDIO-LIT-PHONE-V1 item 8a: the faint violet washes and rings behind
      // what are now rust or ink words (decision 1) are a quiet ink tint and
      // the hairline: violet is Eva and the one main action only.
      terracotta: S.ink, terracottaLight: ink(0.06), terracottaBorder: S.hairline, amberText: S.ink,
      amber: S.lampAmber, amberLight: amber(0.12), red: attention, redLight: ink(0.06), blue: S.ink,
      blueLight: ink(0.06), purple: S.ink, purpleLight: ink(0.06), orange: attention, orangeLight: ink(0.06),
      separator: S.hairline, input: S.pressed.fill, inputBorder: S.hairline, actionsBar: S.ink, addBlue: S.ink,
      alert: attention, alert08: ink(0.06), alert11: ink(0.06), alert22: S.hairline, alertB10: S.pressed.fill,
      alertB4: marker, alertE12: ink(0.06), alertText: attention, areaRowBg: S.paper.css,
      areaRowBorder: S.hairline, areaTodo: S.muted, barGold: S.ink, barRed: S.ink, barRose: S.ink,
      barTeal: S.ink, bark55: S.muted, bark6: S.muted, blue30: ink(0.3), briefAccent: S.ink,
      briefAlert: attention, briefBody: S.muted, briefGlow: 'transparent', briefGrad: S.paper.css,
      briefPillBg: ink(0.06), briefPillBorder: S.hairline, briefRead: S.ink, brown: S.muted,
      brownMid: S.muted, budgetNoneBorder: S.ink, budgetNoneDot: marker, budgetNoneSel: ink(0.06),
      calTile: S.pressed.fill, chaseLink: S.ink, chevron: S.muted, chipBg: S.pressed.fill,
      chipFillGreen: S.pressed.fill, chipGold14: S.pressed.fill, chipGold16: S.pressed.fill, chipGoldText: S.ink,
      chipGoldText2: S.ink, chipMeeting: S.pressed.fill, chipMeetingText: S.ink, chipPitch: S.pressed.fill,
      chipPitchText: S.ink, chipPlannedBg: S.pressed.fill, chipSupplier: S.pressed.fill,
      chipSurvey: S.pressed.fill, chipTextOnFill: S.ink, chipVisitBg: S.pressed.fill,
      competitorGrad: S.paper.stops[2], competitorLabel: S.ink, creamCard: S.paper.css, creamOnFill: S.onPrimary,
      dashSand: marker, deep03: ink(0.03), deep55: uv(0.7), discardBtn: S.ink, discardChoice: S.ink,
      discardChoiceBorder: ink(0.32), discardText: S.onPrimary, dockSub: onP(0.85), dockWrapBg: S.onPrimary,
      dockWrapBgOff: onP(0.4), dockWrapText: S.violetText, fieldBg: S.pressed.fill, gold10: S.pressed.fill,
      gold2: marker, gold22: marker, gold25: marker, gold28: marker, gold30: marker, gold4: marker,
      gold5: marker, goldInk: S.ink, goldLabel: S.ink, goldMoney: S.ochre, green07: ink(0.07),
      green08: ink(0.08), green1: ink(0.1), green10: ink(0.1), green12: ink(0.12), green13: ink(0.13),
      green14: ink(0.14), green15: ink(0.15), green16: ink(0.16), green22: ink(0.22), green25: ink(0.25),
      green28: ink(0.28), green32: ink(0.32), green45: ink(0.45), green5: ink(0.5), green65: S.ink,
      // STUDIO-LIT-REDO-V1 P2: a screen paints no ground of its own; the one
      // lit ground is body.theme-uv's, with the grain and fog on it and the
      // screen's content above them (as the prototype phone).
      green95: S.ink, ground: 'transparent', heroSnagGrad: S.paper.css, heroSnagText: S.ink,
      briefCount: S.ink, heroSurveyGrad: S.ultraviolet,
      ink03: ink(0.03), ink04: ink(0.04), ink05: ink(0.05), ink06: ink(0.06), ink07: ink(0.07), ink08: ink(0.08),
      ink10: ink(0.1), ink11: ink(0.11), ink12: ink(0.12), ink13: ink(0.13), ink14: ink(0.14), ink18: ink(0.18),
      ink2: ink(0.2), ink22: ink(0.22), ink25: ink(0.25), ink3: S.muted, ink32: S.muted, ink35: S.muted,
      ink38: S.muted, ink4: S.muted, ink42: S.muted, ink45: S.muted, ink5: S.muted, ink55: S.muted,
      ink6: S.muted, ink62: S.muted, ink65: S.ink, ink7: S.ink, inkDeep: S.ink, inkWarm: S.ink,
      inputWhite: S.pressed.fill, intelAction: S.ink, intelCardGrad: S.paper.css, jobChipSnag: S.pressed.fill,
      jobChipSurvey: S.pressed.fill, jobSnag: marker, jobSnagGlyph: S.ink, khaki: S.muted,
      knowledgeGrad: S.paper.stops[2], lineSand: S.hairline, liveCardGrad: S.jewel.fill, liveDot: S.lampAmber,
      liveLabel: S.jewel.textSecondary, lpcConfirmBg: uv(0.94), lpcDeleteText: S.ink, mint15: jt(0.15),
      mint2: ring(0.3), mint3: jt(0.3), moneyGreen: S.ochre, moneyInput: S.ochre, moneySign: S.ochre,
      monthClosed: S.paper.solid, monthOpen: S.pressed.fill, olive06: ink(0.06), olive08: ink(0.08),
      olive12: ink(0.12), olive2: ink(0.2), olive25: ink(0.25), onDarkFaint: S.muted, onDarkFaint28: S.muted,
      onFill: S.onPrimary, paper07: ink(0.06), paper09: S.hairline, paper14: S.ultraviolet, paper20: ink(0.2),
      paper38: S.muted, paper55: S.ink, paper60: S.paper.solid, paper62: S.muted, paper7: S.paper.solid,
      paper75: S.paper.solid, paper82: S.ochre, paper85: S.paper.solid, paper92: S.paper.solid,
      paper94: S.paper.solid, paper95: S.ink, paper96: S.paper.solid, paperSolid: S.paper.css,
      pipMeeting: S.muted, pipPitch: marker, raiseGrad: S.paper.stops[2], raiseLabel: S.muted,
      readyPillBg: 'transparent', recBg: S.ink, recText: S.ink, relLabel: S.ink,
      sand15: S.paper.stops[2], sand18: S.paper.stops[2], sand3: S.hairline, sand30: S.hairline,
      sand35: S.hairline, scrim45: ink(0.45), scrim55: ink(0.55), sentPillBg: 'transparent',
      sentPillBorder: 'transparent', sevMedium: marker, shelfBg: S.pressed.fill, shelfHighBg: ink(0.06),
      shelfHighText: attention, shelfText: S.ink, siteNavy: S.ultraviolet, sky10: ink(0.1), sky25: ink(0.25),
      staleDot: S.ultraviolet, staleGrad: S.paper.css, statGold: S.ink, statPurple: S.ink, statusCopper: S.muted,
      statusSage: S.ink, statusTerra: marker, stone06: ink(0.06), stone08: ink(0.08), stone1: ink(0.1),
      stone25: ink(0.25), stone35: S.muted, stone4: S.muted, stone42: S.muted, stone45: S.muted,
      stone48: S.muted, stone5: S.muted, stone55: S.muted, stone75: S.ink, stoneLt: S.muted, stoneMid: S.muted,
      streakBuilder: S.muted, streakCloser: S.muted, streakPlatform: S.ink, supplierText: S.muted,
      tabGold: S.ink, tabNavy: S.ink, taupe: S.muted, teal07: ink(0.07), teal08: ink(0.08), teal18: ink(0.18),
      teal24: ink(0.24), teal35: ink(0.35), terra08: S.pressed.fill, toneNeg: S.muted, umber08: ink(0.08),
      urgentText: attention, visitGradMeeting: S.paper.css, visitGradPitch: S.paper.css,
      visitGradSupplier: S.paper.css, visitGradSurvey: S.paper.css, visitPitch: S.ink, wrapBtn: S.ultraviolet,
      wrapBtnPressed: S.ultravioletHover, wrapHeaderBg: S.paper.css, wrapHeroBg: S.pressed.fill,
      wrapHeroBorder: S.hairline, wrapSummaryBg: S.pressed.fill, wrapSummaryBorder: S.hairline,
    },
    shadow: {
      md: S.shadow.raised, lg: S.shadow.raised, gold: S.shadow.raised, blue: S.shadow.raised,
      card: S.shadow.raised, dialog: S.shadow.raised, dock: S.shadow.raised, dropdown: S.shadow.raised,
      goldSoft: S.shadow.raised, heroSnag: S.shadow.raised, heroSurvey: S.shadow.raised,
      inkCard: S.jewel.shadow, kebab: S.shadow.slip, liveDot: `0 0 6px ${amber(0.6)}`,
      liveStep: `0 0 0 3px ${ink(0.12)}`, modal: S.shadow.raised,
      needsYouRing: `inset 0 0 0 1px ${S.hairline}`, shelf: S.shadow.slip,
      staleDot: `0 0 0 4px ${uv(0.15)}`, visitCard: S.shadow.raised,
      wrapBtn: S.button.shadow, wrapBtnPressed: S.shadow.pressed,
    },
    // Sentient and Satoshi only, no italics, and no capital-letter label
    // spacing (the wave-1 .26em is gone): spacing tokens are 'normal'.
    font: {
      italic: 'normal', labelLs: null, labelW: null, ls005: 'normal', ls04em: 'normal', ls05em: 'normal',
      ls06: 'normal', ls06em: 'normal', ls07: 'normal', ls07em: 'normal', ls08em: 'normal', ls09em: 'normal',
      ls15em: 'normal', ls1em: 'normal', lw700: 600, lw800: 600, numFace: S.fonts.display,
      numW700: 300, serif: S.fonts.display, sysUi: S.fonts.body, tabular: 'tabular-nums',
    },
  };
})(STUDIO_TOKENS);
t.theme = null;

function uiThemeOf(profile) {
  return (profile && profile.ui_theme === 'uv') ? 'uv' : null;
}

function readCachedUiTheme() {
  try {
    return uiThemeOf(JSON.parse(localStorage.getItem('lumen_profile') || 'null'));
  } catch (e) {
    return null;
  }
}

// The browser chrome colour. The switch-off value is read from the tag the
// first time applyUiTheme runs, so index.html stays its only home.
let uiThemeMetaOriginal;
function readUiThemeMetaOriginal() {
  if (uiThemeMetaOriginal !== undefined) return;
  try {
    const meta = document.querySelector('meta[name="theme-color"]');
    uiThemeMetaOriginal = meta ? meta.getAttribute('content') : null;
  } catch (e) { uiThemeMetaOriginal = null; }
}
function syncUiThemeChrome(on) {
  try {
    const meta = document.querySelector('meta[name="theme-color"]');
    if (!meta || uiThemeMetaOriginal == null) return;
    meta.setAttribute('content', on ? STUDIO_TOKENS.themeColor : uiThemeMetaOriginal);
  } catch (e) {}
}

// The Studio CSS custom properties, on <html> and <body> while the theme is on
// (the html:has() ground rule reads them on <html>), and gone when it is off.
function syncStudioCssVars(on) {
  const vars = studioCssVars(STUDIO_TOKENS);
  [document.documentElement, document.body].forEach((el) => {
    try {
      if (!el || !el.style) return;
      Object.keys(vars).forEach((k) => {
        if (on) el.style.setProperty(k, String(vars[k]));
        else el.style.removeProperty(k);
      });
    } catch (e) {}
  });
}

// Point `t` at the theme's values. Returns true when anything changed, so the
// caller knows whether to re-render.
function applyUiTheme(theme) {
  const next = theme === 'uv' ? 'uv' : null;
  readUiThemeMetaOriginal();
  if (t.theme === next) return false;
  T_GROUPS.forEach((g) => {
    const target = t[g];
    Object.keys(target).forEach((k) => { delete target[k]; });
    Object.assign(target, T_STANDARD[g], next === 'uv' ? T_UV_OVERRIDES[g] : {});
  });
  t.theme = next;
  try { syncStudioCssVars(next === 'uv'); } catch (e) {}
  try { document.body.classList.toggle('theme-uv', next === 'uv'); } catch (e) {}
  syncUiThemeChrome(next === 'uv');
  return true;
}
// ==== UI_THEME_SEAM_END ====

// ==== P2A TYPE_COLOUR_START
// Phase 2A, survey screens (Studio lit only). A fitting type's name and count
// on the area screen, and the strokes of its Add-a-fitting symbol, take one
// text colour per type. Nothing else is coloured: no tile, no edge. These are
// variations of the signed lit palette (blue, coral, amber, lime, slate), not
// new hues, chosen by Andrew on 20 October 2026 and awaiting the portal
// DECISIONS entry (DECISIONS NEW). Every value passes 4.5:1 on the paper
// surface. The portal will use the same values, so the names are plain and
// this is the one place they live. Types that are not light fittings (EM
// gear, Controls, Electrics, a custom type, the external keys) get no entry
// and keep the normal ink.
const FITTING_TYPE_INK = Object.freeze({
  downlight:  '#1F6FC4',
  flood:      '#1846A8',
  linear:     '#C2364F',
  decorative: '#8E2A4A',
  t8:         '#94580A',
  t5:         '#94580A',
  bulkhead:   '#3B6E10',
  panel:      '#3E5C7E',  // a bluer slate (P2C, Andrew's lead, 20 October 2026)
});
// A type id to its colour, or the fallback (the ink) for an id with no entry.
// Only an own key counts, so an id such as 'constructor' cannot reach a
// prototype property.
const fittingTypeColour = (typeId, fallback) =>
  (typeof typeId === 'string' && Object.prototype.hasOwnProperty.call(FITTING_TYPE_INK, typeId))
    ? FITTING_TYPE_INK[typeId] : fallback;
// The chosen state of a choice chip on the fitting sheet: pressed in with an
// amber edge. The edge is an inset ring, so the chip does not change size.
const CHOSEN_CHIP_STYLE = Object.freeze({
  background: 'rgba(242,162,58,.16)',
  boxShadow: 'inset 2px 3px 8px rgba(120,70,10,.18), inset 0 0 0 2px #F2A23A',
  color: '#7A4A06',
  fontWeight: 700,
});
// ==== P2A TYPE_COLOUR_END

// ==== P2B FRONT_AREADONE_START
// Phase 2B, survey screens (Studio lit only). Three pure rules the job front
// page and the area complete moment call, so the JSX only draws them (skill
// section 5, one derivation). Nothing here is stored: "done" is the existing
// project.doneZones map, the fittings are the existing zoneFittings lines, and
// a Site-wide voice note is an ordinary note in the '__project__' container.
//
// The job's voice-note button on the front page: a round ink disc. The one
// dark control that is not Eva or the main action, so the style checks name it.
const FRONT_MIC = Object.freeze({ size: 64, fill: '#111827' });

const _p2bKey = (name) => (name == null ? '' : String(name)).trim().toLowerCase();
const _p2bLines = (zoneFittings, zone) => {
  const zf = (zoneFittings && typeof zoneFittings === 'object') ? zoneFittings : {};
  const k = _p2bKey(zone);
  if (!k) return [];
  const key = Object.keys(zf).find(c => _p2bKey(c) === k);
  return key && Array.isArray(zf[key]) ? zf[key] : [];
};
const _p2bQty = (lines) => lines.reduce((s, l) => s + (Number(l && l.qty) || 0), 0);

// The area to carry on with: the area open now if it is started and not done,
// else the first open area already started, else the first open area. -1 when
// every area is done (or there are none). `started[i]` is true when area i has
// a fitting, photo or note; `openIdx` is the index of the area open now.
const frontCurrentIndex = (zones, doneZones, started, openIdx) => {
  const zs = Array.isArray(zones) ? zones : [];
  const done = (doneZones && typeof doneZones === 'object') ? doneZones : {};
  const st = Array.isArray(started) ? started : [];
  const open = zs.map((z, i) => i).filter(i => !done[zs[i]]);
  if (openIdx >= 0 && openIdx < zs.length && !done[zs[openIdx]] && st[openIdx]) return openIdx;
  const first = open.find(i => st[i]);
  return first !== undefined ? first : (open.length ? open[0] : -1);
};
// What each area's row shows on the front page: 'done' (pressed in, "Done"),
// 'now' (raised, amber ring, "Now") or 'next' (raised, "Next").
const frontAreaStates = (zones, doneZones, curIdx) => {
  const zs = Array.isArray(zones) ? zones : [];
  const done = (doneZones && typeof doneZones === 'object') ? doneZones : {};
  return zs.map((z, i) => (done[z] ? 'done' : (i === curIdx ? 'now' : 'next')));
};
const frontDoneLabel = (zones, doneZones) => {
  const zs = Array.isArray(zones) ? zones : [];
  const done = (doneZones && typeof doneZones === 'object') ? doneZones : {};
  return `${zs.filter(z => done[z]).length} of ${zs.length} done`;
};
// Voice notes filed to the job (the Site-wide container). `notes` is that
// container's note array. A text note is not counted.
const siteVoiceNoteCount = (notes) =>
  (Array.isArray(notes) ? notes : []).filter(n => n && n.type === 'voice').length;
const siteVoiceNoteLine = (count) =>
  count > 0 ? `${count} voice note${count === 1 ? '' : 's'} on this job` : '';

// The area complete moment, for one area just marked done. Pure.
//   zones, doneZones, zoneFittings   as the survey screen holds them
//   zone                             the area just marked done
// This area counts as done here whatever doneZones says yet, so the moment is
// right in the same render as the tap. The next area is the next one in survey
// order that is not done; with none, this is the last area to do. Eva offers a
// copy only when there is a next area, it holds no fittings yet, and this area
// has some to copy.
const areaMoment = (opts) => {
  const o = opts || {};
  const zones = Array.isArray(o.zones) ? o.zones : [];
  const done = (o.doneZones && typeof o.doneZones === 'object') ? o.doneZones : {};
  const idx = zones.findIndex(z => _p2bKey(z) === _p2bKey(o.zone));
  if (idx < 0) return null;
  const lines = _p2bLines(o.zoneFittings, zones[idx]);
  const fittings = _p2bQty(lines);
  const emergency = lines.reduce((s, l) => {
    const q = Number(l && l.qty) || 0;
    const e = Number(l && l.emQty) || 0;
    return s + Math.max(0, Math.min(e, q));
  }, 0);
  const marks = zones.map((z, i) => ({ done: i === idx || !!done[z] }));
  let nextIdx = -1;
  for (let i = idx + 1; i < zones.length; i++) if (!marks[i].done) { nextIdx = i; break; }
  const next = nextIdx >= 0 ? zones[nextIdx] : null;
  const nextFittings = next ? _p2bQty(_p2bLines(o.zoneFittings, next)) : 0;
  return {
    name: zones[idx],
    index: idx,
    fittings,
    emergency,
    marks,
    doneCount: marks.filter(m => m.done).length,
    total: zones.length,
    nextIdx,
    next,
    isLast: next === null,
    eva: next !== null && nextFittings === 0 && fittings > 0
      ? { next, count: fittings }
      : null,
  };
};
// The words under the big number: "fittings logged," and "8 of them emergency".
const momentFigureWords = (fittings, emergency) => ({
  logged: `${fittings === 1 ? 'fitting' : 'fittings'} logged${fittings > 0 ? ',' : ''}`,
  emergency: fittings > 0 ? (emergency > 0 ? `${emergency} of them emergency` : 'none of them emergency') : '',
});
const evaCopyOffer = (next, count) =>
  `${next} may be the same layout. Shall I copy ${count === 1 ? 'this 1 fitting' : `these ${count} fittings`} across so you only change what's different?`;
// ==== P2B FRONT_AREADONE_END

// Before the first render: the theme the last sync saw for this device.
applyUiTheme(readCachedUiTheme());

// ==== STUDIO_SHAPE_START ====
// COMPANION-STUDIO-V1 track 2: the rules every Studio screen shares, applied to
// a rendered element tree in one place instead of at hundreds of inline styles.
// With the switch off studioShape returns the very element it was given, so the
// standard look cannot change (tools/uv_offstate_diff.js proves it byte for
// byte). With the switch on, on host elements only (never inside an svg, never
// a <style>, never the output of a child component, which shapes itself):
//   - every font size moves onto the Studio scale (13 to 61, or 84 to 118 for
//     the one display number);
//   - capital-letter label styling (text-transform, positive tracking) goes;
//   - text drawn in ink at an alpha reads muted, ultraviolet text reads violet
//     text, white text reads as the text on the primary button;
//   - anything you tap gets at least 44px of height;
//   - a status pill loses its fill, border and padding and reads as plain words;
//   - a coloured dot with nothing in it is not drawn;
//   - middle dots become commas, arrows on links go, and a dash inside a
//     sentence becomes a comma.
// docs/studio/FINDINGS.md T2-1 records the decision.
const STUDIO_SCALE = STUDIO_TOKENS.typeScale;
// The ink colour as an rgba prefix, from the one source.
const STUDIO_INK_RGB = [1, 3, 5].map((i) => parseInt(STUDIO_TOKENS.ink.slice(i, i + 2), 16)).join(',');
const studioInk = (a) => `rgba(${STUDIO_INK_RGB},${a})`;
// Any Studio hex at an alpha (track C1: the light lightbox scrim is the ground
// sand at an alpha). Derived, so no colour is typed twice.
const studioRgba = (hex, a) => `rgba(${[1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16)).join(',')},${a})`;
function studioSize(n) {
  if (typeof n !== 'number' || !isFinite(n)) return n;
  if (n >= 84) return Math.min(n, 118);
  if (n > 73) return 84;
  let best = STUDIO_SCALE[0];
  for (const s of STUDIO_SCALE) if (Math.abs(s - n) <= Math.abs(best - n)) best = s;
  return best;
}
const _studioPx = (v) => (typeof v === 'number' ? v : (/^-?[\d.]+px$/.test(String(v || '').trim()) ? parseFloat(v) : null));
function _studioPadTop(st) {
  if (st.paddingTop != null) return _studioPx(st.paddingTop);
  if (st.padding == null) return null;
  if (typeof st.padding === 'number') return st.padding;
  return _studioPx(String(st.padding).trim().split(/\s+/)[0]);
}
function _studioText(children) {
  if (children == null || typeof children === 'boolean') return '';
  if (typeof children === 'string' || typeof children === 'number') return String(children);
  if (Array.isArray(children)) return children.map(_studioText).join('');
  if (React.isValidElement(children) && typeof children.type === 'string') return _studioText(children.props.children);
  return '';
}
// Words the screens print in capitals that are real acronyms, kept as they are.
const STUDIO_ACRONYMS = new Set(['ASAP', 'LED', 'ROI', 'PRJ', 'CRM', 'EPC', 'EM', 'PDF', 'OK']);
function studioWords(s, caps) {
  if (typeof s !== 'string') return s;
  let out = s;
  // A capital-letter label ("GONE SILENT") that the screen itself drew in
  // capitals (the text sits inside an element styled text-transform uppercase)
  // reads in sentence case. A string anywhere else may be the surveyor's own
  // data (PIR, CCTV, IKEA, NHS) and keeps its case exactly as typed.
  if (caps && /^[A-Z][A-Z' ’]{2,}$/.test(out.trim()) && !STUDIO_ACRONYMS.has(out.trim())) {
    const low = out.toLowerCase();
    out = low.replace(/[a-z]/, (c) => c.toUpperCase());
  }
  // Nothing else is touched. A string may be the surveyor's own data, and
  // display must never alter data. Authored separators are theme-aware at
  // their source instead (studioSep, studioArrow, studioDash below).
  return out;
}
// Separators the app itself writes, theme-aware at the source. With the
// switch off each returns exactly the characters it replaced, so the standard
// look cannot change. With it on: a middle dot becomes a comma, an arrow on a
// link goes, a dash inside a sentence becomes a comma.
const studioSep = (off = ' · ') => (t.theme === 'uv' ? ', ' : off);
const studioArrow = (off = ' →') => (t.theme === 'uv' ? '' : off);
const studioDash = (off = ' — ') => (t.theme === 'uv' ? ', ' : off);
function _studioColour(c) {
  const S = STUDIO_TOKENS;
  const v = String(c || '').replace(/\s/g, '').toLowerCase();
  if (v.startsWith(`rgba(${STUDIO_INK_RGB},`)) return S.muted;
  // STUDIO-LIT-PHONE-V1 item 8a (decision 1): raw ultraviolet as a text colour
  // was the legacy action colour, so it reads ink now. A word that is Eva's,
  // or the one main action on its button, is written with the violet TEXT
  // value (or the text on the primary button) on purpose and is left alone.
  if (v === S.ultraviolet.toLowerCase()) return S.ink;
  if (v === 'white' || v === '#fff' || v === '#ffffff') return S.onPrimary;
  // Paper as a text colour only ever sat on a fill you press: it is the text
  // on the primary button.
  if (v === S.paper.solid.toLowerCase()) return S.onPrimary;
  return c;
}
function _studioStyle(type, style, children, onClick) {
  const st = Object.assign({}, style);
  if (typeof st.fontSize === 'number') st.fontSize = studioSize(st.fontSize);
  else if (_studioPx(st.fontSize) != null) st.fontSize = studioSize(_studioPx(st.fontSize));
  const caps = st.textTransform === 'uppercase';
  if (caps) delete st.textTransform;
  const ls = _studioPx(st.letterSpacing);
  if (caps || (ls != null && ls > 0) || /^0?\.\d+em$/.test(String(st.letterSpacing || ''))) delete st.letterSpacing;
  if (st.fontStyle === 'italic') st.fontStyle = 'normal';
  if (st.color) st.color = _studioColour(st.color);
  const text = _studioText(children).trim();
  // A status pill: words in a rounded, tightly padded chip. Anything you can
  // tap (a button, an onClick, a pointer cursor) is a control, not a status,
  // and keeps its fill (FINDINGS T2-17).
  const rad = st.borderRadius === '50%' ? 999 : _studioPx(st.borderRadius);
  const pt = _studioPadTop(st);
  const control = type === 'button' || typeof onClick === 'function' || st.cursor === 'pointer';
  if (text && rad != null && rad >= 6 && pt != null && pt <= 4 && !control) {
    delete st.background; delete st.backgroundColor; delete st.border; delete st.boxShadow;
    st.padding = 0; st.borderRadius = 0;
  }
  // A coloured dot: a small round fill with nothing in it. A short accent bar
  // beside a heading (3px by 16px or so) is decoration of the same kind.
  const w = _studioPx(st.width); const h = _studioPx(st.height);
  const filled = (st.background || st.backgroundColor) && !/^(transparent|none)$/.test(String(st.background || st.backgroundColor));
  if (children == null && filled && w != null && h != null && w <= 12 && h <= 12 && rad != null && rad >= w / 2) return null;
  if (children == null && filled && w != null && h != null && w <= 4 && h >= 12 && h <= 24) return null;
  // Touch targets reach 44px.
  const tappable = type === 'button' || st.cursor === 'pointer';
  const tall = [_studioPx(st.minHeight), _studioPx(st.height)].some((x) => x != null && x >= 44);
  if (tappable && !tall && st.display !== 'none') {
    st.minHeight = 44;
    if ((type === 'span' || type === 'a') && !st.display) { st.display = 'inline-flex'; st.alignItems = 'center'; }
  }
  return st;
}
function _studioNode(node, caps) {
  if (typeof node === 'string') return studioWords(node, caps);
  if (Array.isArray(node)) return node.map((n) => _studioNode(n, caps));
  if (!React.isValidElement(node)) return node;
  const type = node.type;
  if (type === 'svg' || type === 'style' || type === 'input' || type === 'textarea') return node;
  const props = node.props || {};
  const next = {};
  if (typeof type === 'string' && props.style) {
    next.style = _studioStyle(type, props.style, props.children, props.onClick);
    if (next.style === null) return null;  // a coloured dot or accent bar: not drawn
  }
  if (props.children === undefined) return React.cloneElement(node, next);
  // text-transform inherits, so everything under an uppercase element was drawn in capitals
  const capsHere = caps || (typeof type === 'string' && !!props.style && props.style.textTransform === 'uppercase');
  const kids = _studioNode(props.children, capsHere);
  // Children go back as arguments, as JSX passed them, so a static list keeps
  // needing no keys.
  return Array.isArray(kids) ? React.cloneElement(node, next, ...kids) : React.cloneElement(node, next, kids);
}
function studioShape(node) {
  return t.theme === 'uv' ? _studioNode(node) : node;
}
// Colour as light: a job's stage colour falls on it from the left, a 3px edge,
// a soft side glow and a wash that is clear by 55%, over raised paper. The
// stage arrives as an app stage id (proj.stage) or a Studio stage id.
function studioStageOf(appStage, fallback) {
  const S = STUDIO_TOKENS;
  const s = String(appStage || '').toLowerCase();
  if (S.stages[s]) return s;
  return S.appStageMap[s] || fallback || 'enquiry';
}
// The light itself, from any colour: used by studioLit (a stage) and by the
// cards that carry a meaning colour directly (rust for a quote with no reply).
function studioLitColour(hex, strong) {
  const S = STUDIO_TOKENS;
  const rgb = [1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16)).join(',');
  return {
    borderLeft: `3px solid ${hex}`,
    boxShadow: `-6px 0 14px -8px rgba(${rgb},${strong ? 0.9 : 0.7}), ${S.shadow.slip}`,
    background: `linear-gradient(90deg, rgba(${rgb},0.15), transparent 55%), ${S.paper.css}`,
  };
}
// COMPANION-STUDIO-LIT-V1 track 4: the light a stage casts is a meaning colour
// (STUDIO_MEANING fills), not the old six-colour spectrum, whose Quoted and
// Surveyed were violet (violet is Eva and the main action only). Enquiry is
// New (light blue), Surveyed is ordinary (slate), Quoted lime, Negotiating
// quoted with strong odds (coral), Won amber, Lost slate.
const STUDIO_STAGE_MEANING = { enquiry: 'newFill', surveyed: 'slateFill', quoted: 'quotedFill', negotiating: 'strongFill', won: 'wonFill', lost: 'slateFill' };
function studioLit(stage) {
  return studioLitColour(STUDIO_MEANING[STUDIO_STAGE_MEANING[stage] || 'newFill'], stage === 'won');
}
// uvx(o): the Studio overrides for one inline style, spread last into it.
// With the switch off it is an empty object, so the style is unchanged.
const uvx = (o) => (t.theme === 'uv' ? (typeof o === 'function' ? o() : o) : {});
// The Studio type roles, as inline styles for the screens.
const studioType = {
  display: () => ({ fontFamily: STUDIO_TOKENS.fonts.display, fontWeight: 300, letterSpacing: '-0.04em', lineHeight: 0.8, fontVariantNumeric: 'tabular-nums', color: STUDIO_TOKENS.ink }),
  title: () => ({ fontFamily: STUDIO_TOKENS.fonts.display, fontWeight: 300, letterSpacing: '-0.018em', textWrap: 'balance', color: STUDIO_TOKENS.ink, margin: 0 }),
  heading: () => ({ fontFamily: STUDIO_TOKENS.fonts.display, fontWeight: 400, fontSize: 20, letterSpacing: '-0.018em', textWrap: 'balance', color: STUDIO_TOKENS.ink }),
  colhead: () => ({ fontSize: 13, fontWeight: 400, color: STUDIO_TOKENS.muted }),
  // An underlined ink link (.lnk): the second action on a screen.
  link: () => ({ color: STUDIO_TOKENS.link.colour, fontSize: 16, fontWeight: 400, textDecoration: 'none', borderBottom: `1px solid ${STUDIO_TOKENS.link.underline}`, background: 'none', padding: 0 }),
  // An action written as the action: ink, weight 600, underlined. Violet is
  // Eva and the one main action only (Andrew's decision 1, 6 October 2026;
  // DECISIONS 176.125); the main action is studioSurface.primary.
  action: () => ({ color: STUDIO_TOKENS.link.colour, fontSize: 16, fontWeight: 600, background: 'none', border: 'none', padding: 0, textDecoration: 'underline', textDecorationColor: STUDIO_TOKENS.link.underline, textUnderlineOffset: 4 }),
};
// Studio surfaces as inline styles.
const studioSurface = {
  raised: () => ({ background: STUDIO_TOKENS.paper.css, boxShadow: STUDIO_TOKENS.shadow.raised, border: 'none' }),
  slip: () => ({ background: STUDIO_TOKENS.paper.css, boxShadow: STUDIO_TOKENS.shadow.slip, border: 'none' }),
  pressed: () => ({ background: STUDIO_TOKENS.pressed.fill, boxShadow: STUDIO_TOKENS.shadow.pressed, border: 'none' }),
  // Lit paper: the lamp falls on it.
  lit: () => ({ background: STUDIO_TOKENS.litpaper.css, boxShadow: STUDIO_TOKENS.litpaper.shadow, border: 'none' }),
  // The one main action on a screen: flat ultraviolet, radius 10, 44px high.
  primary: () => ({ background: STUDIO_TOKENS.ultraviolet, color: STUDIO_TOKENS.onPrimary, boxShadow: STUDIO_TOKENS.button.shadow, borderRadius: STUDIO_TOKENS.button.radius, minHeight: STUDIO_TOKENS.button.minHeight, border: 'none', fontSize: 16, fontWeight: 600, letterSpacing: 'normal' }),
};
// STUDIO-LIT-PHONE-V1 item 8a: Eva's orb (the prototype's `orb()`): a ring of
// ticks round a violet core with a mic, or a stop square while she listens.
// Used for the header mic and the voice recorder, both Eva's voice place.
// The ticks are a drawing at fixed angles, never data.
const STUDIO_ORB_TICKS = (sz) => {
  const c = sz / 2; const out = [];
  for (let i = 0; i < 44; i++) {
    const a = i / 44 * Math.PI * 2; const r1 = c * 0.66; const r2 = c * (0.9 + 0.1 * Math.abs(Math.sin(i * 1.7)));
    out.push([c + Math.sin(a) * r1, c - Math.cos(a) * r1, c + Math.sin(a) * r2, c - Math.cos(a) * r2, 0.45 + 0.55 * Math.abs(Math.cos(a / 2))]);
  }
  return out;
};
const StudioOrb = ({ size = 54, live = false }) => {
  const O = STUDIO_TOKENS.orb;
  const core = Math.round(size * 0.5);
  return (
    <span aria-hidden="true" style={{ position: 'relative', flex: 'none', width: size, height: size, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} style={{ position: 'absolute', inset: 0, stroke: live ? O.tickLive : O.tick, strokeWidth: 1.4, strokeLinecap: 'round', animation: live ? 'studioOrbPulse 1.1s ease-in-out infinite alternate' : 'studioOrbTick 6s linear infinite' }}>
        {STUDIO_ORB_TICKS(size).map((l, i) => <line key={i} x1={l[0].toFixed(1)} y1={l[1].toFixed(1)} x2={l[2].toFixed(1)} y2={l[3].toFixed(1)} opacity={l[4].toFixed(2)} />)}
      </svg>
      <span style={{ position: 'relative', width: core, height: core, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', background: O.core, boxShadow: O.glow }}>
        {live
          ? <svg width="14" height="14" viewBox="0 0 14 14"><rect x="3" y="3" width="8" height="8" rx="1.6" fill={STUDIO_TOKENS.onPrimary} /></svg>
          : <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={STUDIO_TOKENS.onPrimary} strokeWidth="1.9" strokeLinecap="round"><rect x="9" y="3" width="6" height="11" rx="3" /><path d="M5 11a7 7 0 0 0 14 0M12 18v3" /></svg>}
      </span>
    </span>
  );
};
// The orb's two motions, injected once (the prototype's apptick and apppulse).
const STUDIO_ORB_KEYFRAMES = '@keyframes studioOrbTick{to{transform:rotate(360deg)}}@keyframes studioOrbPulse{from{transform:scale(.9);opacity:.75}to{transform:scale(1.05);opacity:1}}@keyframes studioWave{0%{transform:scaleY(.35)}100%{transform:scaleY(1)}}';
// ==== STUDIO_SHAPE_END ====

// ── S95 D21 — canonical currency formatter ────────────
// < £1,000         → £850
// £1,000–£999,999  → £173k  (round to nearest £1k)
// ≥ £1,000,000     → £1.0m  (one decimal, e.g. £1.04m uses .toFixed(1))
// Single source of truth — all currency output everywhere must go through this.
// COMPANION-TRUTH-V2 B3: null, undefined or anything that is not a finite
// number is a failed or missing read, so it prints the not-available mark
// (TRUTH_DASH), never "\u00a30". A real 0 is a signed value and still prints "\u00a30".
const formatCurrency = (v) => {
  if (v == null) return TRUTH_DASH;
  const raw = Number(v);
  if (!isFinite(raw)) return TRUTH_DASH;
  const n = Math.round(raw);
  if (n === 0) return '\u00a30';
  const neg = n < 0 ? '-' : '';
  const abs = Math.abs(n);
  if (abs >= 1000000) return neg + '\u00a3' + (abs / 1000000).toFixed(1) + 'm';
  if (abs >= 1000) {
    const k = Math.round(abs / 1000);
    // Edge case: 999,500+ would round to 1000k — roll up to 1.0m for clarity
    if (k >= 1000) return neg + '\u00a3' + (abs / 1000000).toFixed(1) + 'm';
    return neg + '\u00a3' + k + 'k';
  }
  return neg + '\u00a3' + abs.toLocaleString('en-GB');
};

// ── Image compression utility ─────────────────────────
const compressImage = (file, maxW = 800, quality = 0.65) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onerror = reject;
  reader.onload = (e) => {
    const img = new Image();
    img.onerror = reject;
    img.onload = () => {
      const scale = Math.min(1, maxW / Math.max(img.width, img.height));
      const w = Math.round(img.width * scale);
      const h = Math.round(img.height * scale);
      const canvas = document.createElement("canvas");
      canvas.width = w; canvas.height = h;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, w, h);
      resolve(canvas.toDataURL("image/jpeg", quality));
    };
    img.src = e.target.result;
  };
  reader.readAsDataURL(file);
});

// ── S135 — durable photo/video blob store (IndexedDB) ─────────────────────
// Photos & videos are referenced from a survey by a stable `id`; the blob
// lives here, so a thumbnail still renders after a reload even when the base64
// was dropped from localStorage (quota) or an in-memory object URL died — the
// two mechanisms behind the "?" placeholder. This layers BESIDE the existing
// capture-time upload: an uploaded portal URL is still the preferred source.
// Every entry point degrades gracefully (resolves null/false, never throws).
const _MEDIA_DB = 'asg-companion-media';
const _MEDIA_STORE = 'photos';
let _mediaDbPromise = null;
function _openMediaDb() {
  if (_mediaDbPromise) return _mediaDbPromise;
  _mediaDbPromise = new Promise((resolve) => {
    try {
      if (typeof indexedDB === 'undefined') { resolve(null); return; }
      const req = indexedDB.open(_MEDIA_DB, 1);
      req.onupgradeneeded = () => {
        const db = req.result;
        if (!db.objectStoreNames.contains(_MEDIA_STORE)) {
          db.createObjectStore(_MEDIA_STORE, { keyPath: 'id' });
        }
      };
      req.onsuccess = () => resolve(req.result);
      req.onerror = () => resolve(null);
    } catch (e) { resolve(null); }
  });
  return _mediaDbPromise;
}
function idbPutBlob(id, blob, meta) {
  return _openMediaDb().then((db) => new Promise((resolve) => {
    if (!db || !id || !blob) { resolve(false); return; }
    try {
      const tx = db.transaction(_MEDIA_STORE, 'readwrite');
      tx.objectStore(_MEDIA_STORE).put({ id: id, blob: blob, meta: meta || {}, ts: Date.now() });
      tx.oncomplete = () => resolve(true);
      tx.onerror = () => resolve(false);
      tx.onabort = () => resolve(false);
    } catch (e) { resolve(false); }
  }));
}
function idbGetBlob(id) {
  return _openMediaDb().then((db) => new Promise((resolve) => {
    if (!db || !id) { resolve(null); return; }
    try {
      const tx = db.transaction(_MEDIA_STORE, 'readonly');
      const req = tx.objectStore(_MEDIA_STORE).get(id);
      req.onsuccess = () => resolve(req.result ? req.result.blob : null);
      req.onerror = () => resolve(null);
    } catch (e) { resolve(null); }
  }));
}
function idbDeleteBlob(id) {
  return _openMediaDb().then((db) => new Promise((resolve) => {
    if (!db || !id) { resolve(false); return; }
    try {
      const tx = db.transaction(_MEDIA_STORE, 'readwrite');
      tx.objectStore(_MEDIA_STORE).delete(id);
      tx.oncomplete = () => resolve(true);
      tx.onerror = () => resolve(false);
    } catch (e) { resolve(false); }
  }));
}
// base64 data URL → Blob for durable storage. Returns null on failure.
function dataUrlToBlob(dataUrl) {
  try {
    if (typeof dataUrl !== 'string' || dataUrl.indexOf('data:') !== 0) return null;
    const comma = dataUrl.indexOf(',');
    const header = dataUrl.slice(0, comma);
    const isB64 = header.indexOf('base64') !== -1;
    const mime = (header.match(/data:([^;]+)/) || [])[1] || 'image/jpeg';
    const data = dataUrl.slice(comma + 1);
    const binary = isB64 ? atob(data) : decodeURIComponent(data);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
    return new Blob([bytes], { type: mime });
  } catch (e) { return null; }
}
// Inverse of dataUrlToBlob: read a stored blob back to a base64 data URL. Used
// by the wrap-submit upload safety-net to recover photos whose base64 was moved
// to IndexedDB by photoToRef. Returns null on failure.
function blobToDataUrl(blob) {
  return new Promise((resolve) => {
    try { const r = new FileReader(); r.onload = () => resolve(r.result); r.onerror = () => resolve(null); r.readAsDataURL(blob); }
    catch (e) { resolve(null); }
  });
}
const _photoIdSeq = () => 'ph_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 8);

// ── S135 — durable thumbnail ──────────────────────────────────────────────
// Resolves the best source via choosePhotoSrc (uploaded url → IndexedDB blob →
// base64) and revokes any object URL it creates on unmount. A captured photo
// therefore never renders as the browser's broken "?" after a reload; if even
// the blob is still loading, a calm placeholder shows instead.
const MediaThumb = ({ photo, alt, style, onClick }) => {
  const [resolved, setResolved] = React.useState(null);
  React.useEffect(() => {
    let objectUrl = null; let cancelled = false;
    const direct = choosePhotoSrc(photo, null);
    if (!direct && photo && photo.id) {
      idbGetBlob(photo.id).then((blob) => {
        if (cancelled || !blob) return;
        try { objectUrl = URL.createObjectURL(blob); setResolved(objectUrl); } catch (e) {}
      });
    }
    return () => { cancelled = true; if (objectUrl) { try { URL.revokeObjectURL(objectUrl); } catch (e) {} } };
  }, [photo && photo.id, photo && photo.url, photo && photo.src]);
  const src = choosePhotoSrc(photo, resolved);
  if (!src) {
    return (
      <div onClick={onClick} aria-label="Photo saved" style={Object.assign(
        { display: 'flex', alignItems: 'center', justifyContent: 'center', background: t.theme === 'uv' ? STUDIO_TOKENS.pressed.fill : 'rgba(46,104,56,0.10)' }, style || {})}>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={t.colors.green} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>
      </div>
    );
  }
  return <img src={src} alt={alt || ''} onClick={onClick} style={style} />;
};

// ════════════════════════════════════════════════════════════════════════
// S153 — On-demand vision scan (companion → portal /api/vision)
// ────────────────────────────────────────────────────────────────────────
// The portal endpoint is built and merged; this is the companion half: one
// on-demand Scan per tap (never automatic — that is the cost discipline), the
// Bearer-token call on the SAME PORTAL_URL the snag dispatch uses, and a clean
// fall back to manual on offline / error / success:false. The scan PROPOSES;
// nothing is saved until the surveyor confirms on the existing sheet.
// ════════════════════════════════════════════════════════════════════════

// Vision `type` ids (FIXTURE_TYPES_GRID / portal _FIXTURE_TYPE_SET) → the survey
// SURVEY_FIXTURES ids. Only t8/t5/em/custom differ; the rest are identical.
const VISION_TYPE_TO_FIXTURE = {
  t8_batten: 't8', t5_batten: 't5', em_gear: 'em', panel: 'panel',
  linear: 'linear', downlight: 'downlight', bulkhead: 'bulkhead',
  decorative: 'decorative', flood: 'flood', controls: 'controls',
  electrics: 'electrics', custom: 'custom-btn',
};

// Resolve a captured photo to { b64, mediaType }. Prefer in-memory base64, then
// the IndexedDB blob (the durable store), then the uploaded URL as a last
// resort. Returns null when nothing is readable — the caller drops to manual.
async function loadPhotoBase64(photo) {
  try {
    let dataUrl = (photo && typeof photo.src === 'string' && photo.src.indexOf('data:') === 0) ? photo.src : null;
    if (!dataUrl && photo && photo.id) {
      const blob = await idbGetBlob(photo.id);
      if (blob) dataUrl = await blobToDataUrl(blob);
    }
    if (!dataUrl && photo) {
      const u = photo.url || (typeof photo.src === 'string' && photo.src.indexOf('http') === 0 ? photo.src : null);
      if (u) { try { const r = await fetch(u); const blob = await r.blob(); dataUrl = await blobToDataUrl(blob); } catch (e) { dataUrl = null; } }
    }
    if (!dataUrl || dataUrl.indexOf('data:') !== 0) return null;
    const comma = dataUrl.indexOf(',');
    const header = dataUrl.slice(0, comma);
    const mediaType = (header.match(/data:([^;]+)/) || [])[1] || 'image/jpeg';
    return { b64: dataUrl.slice(comma + 1), mediaType };
  } catch (e) { return null; }
}

// One scan. Returns { ok:true, proposal } or { ok:false, error, offline? }.
// Offline is decided before the call so the survey is never left hanging.
async function callVisionScan(mode, photo, context) {
  if (typeof navigator !== 'undefined' && navigator && navigator.onLine === false) {
    return { ok: false, offline: true, error: 'You are offline. Add it by hand for now.' };
  }
  const img = await loadPhotoBase64(photo);
  if (!img) return { ok: false, error: 'Could not read that photo. Add it by hand.' };
  const token = localStorage.getItem('lumen_token');
  try {
    const r = await fetch(`${PORTAL_URL}/api/vision`, {
      method: 'POST',
      headers: Object.assign({ 'Content-Type': 'application/json' }, token ? { 'Authorization': `Bearer ${token}` } : {}),
      body: JSON.stringify({ mode, image: img.b64, media_type: img.mediaType, context: context || {} }),
    });
    let body = null; try { body = await r.json(); } catch (e) { body = null; }
    if (!r.ok || !body || body.success !== true || !body.proposal) {
      const msg = (body && body.error) ? body.error : ('Scan unavailable (' + r.status + ')');
      debugLog('vision.scan.fail', { mode, status: r.status, error: msg });
      return { ok: false, error: msg };
    }
    debugLog('vision.scan.ok', { mode });
    return { ok: true, proposal: body.proposal };
  } catch (e) {
    debugLog('vision.scan.error', { mode, error: (e && e.message) || String(e) });
    return { ok: false, error: 'Scan unavailable. Add it by hand.' };
  }
}

// Honesty UI shared by both confirm surfaces. A scan is always a proposal: the
// confidence is shown, low is visibly flagged, and never presented as certain.
const visionConfText = (c) => c === 'high' ? 'High confidence' : c === 'medium' ? 'Medium confidence' : 'Low confidence';
// COMPANION-STUDIO-V1 track C1: under the theme the confidence is plain words,
// never a pill; low confidence keeps its warning sign and reads in ink at
// weight 600, the rest muted. Theme off: unchanged.
const VisionConfPill = ({ level, label }) => {
  const low = level === 'low';
  const bg = low ? 'rgba(192,72,59,0.10)' : 'rgba(74,100,98,0.10)';
  const col = low ? '#7A271C' : '#4A6462';
  return (
    <span style={{ display:'inline-flex', alignItems:'center', gap:4, fontSize:10.5, fontWeight:700, color:col, background:bg, border:`0.5px solid ${col}33`, padding:'2px 8px', borderRadius:20, letterSpacing:0.2, ...uvx(() => ({ fontSize:14, fontWeight: low ? 600 : 400, color: low ? STUDIO_TOKENS.ink : STUDIO_TOKENS.muted, background:'none', border:'none', padding:0, borderRadius:0, letterSpacing:'normal' })) }}>
      {low && <span aria-hidden="true">⚠</span>}{(label ? label + studioSep() : '') + visionConfText(level)}
    </span>
  );
};
// Subtle "read from the photo" provenance mark. No such mark existed before
// S153, so this introduces one; it is display-only and never persisted.
const FromPhotoTag = ({ style }) => (
  <span style={Object.assign({ display:'inline-flex', alignItems:'center', gap:4, fontSize:10, fontWeight:700, color:'#4A6462', letterSpacing:0.3, textTransform:'uppercase' }, style || {}, uvx(() => ({ fontSize:13, fontWeight:600, color:STUDIO_TOKENS.muted, letterSpacing:'normal', textTransform:'none' })))}>
    <span aria-hidden="true">✦</span>from photo
  </span>
);
// A guess the model could not be sure of (size, lamp) or a label it read. Shown
// only when present, always labelled, never as read fact.
const VisionGuessRow = ({ label, value, guess }) => {
  if (value === null || value === undefined || value === '') return null;
  return (
    <div style={{ fontSize:11.5, color:'#7A6C5A', marginTop:4, lineHeight:1.4, ...uvx(() => ({ fontSize:14, color:STUDIO_TOKENS.muted })) }}>
      <span style={{ fontWeight:700, color:'#564A38', ...uvx(() => ({ color:STUDIO_TOKENS.ink })) }}>{label}:</span> {value}
      {guess ? <span style={{ fontStyle:'italic', color:'#A09080', ...uvx(() => ({ fontStyle:'normal', color:STUDIO_TOKENS.muted })) }}>{studioSep() + 'AI guess, confirm before you trust it'}</span> : null}
    </div>
  );
};

// S154 — the shared per-photo Scan trigger (Treatment A, signed off). ONE button
// component used by BOTH the survey Media tile and the snag photo card — the
// "one shared capture/photo component" the brief expected (it did not exist; the
// S153 chip and snag button were two separate renders). Sage-teal fill, cream
// label, gold sparkle, sits full-width directly under its photo. White-label safe:
// the label is always "Scan", never a platform name.
// COMPANION-STUDIO-V1 track C1: under the theme the Scan button is a small
// raised slip with the action written in ink, weight 600 (one per photo, so
// never the ultraviolet main action; ink since STUDIO-LIT-PHONE-V1 item 8a,
// decision 1), 44px high; the error reads in ink at 14px.
// Shared with the snag photo card, which therefore also changes with the
// switch on. Theme off: unchanged.
const ScanTriggerButton = ({ onClick, busy, error }) => (
  <div style={{ width:'100%' }}>
    <button onClick={onClick} disabled={!!busy} aria-label="Scan this photo"
      style={{ width:'100%', marginTop:7, display:'flex', alignItems:'center', justifyContent:'center', gap:6, background:'#4A6462', color:'#FDFCF9', fontSize:13, fontWeight:700, border:0, padding:'10px 0', borderRadius:11, boxShadow:'0 2px 6px rgba(74,100,98,0.28)', cursor: busy ? 'default' : 'pointer', fontFamily:'inherit', opacity: busy ? 0.85 : 1, ...uvx(() => ({ ...studioSurface.slip(), minHeight:44, padding:'0 6px', borderRadius:STUDIO_TOKENS.button.radius, color: busy ? STUDIO_TOKENS.muted : STUDIO_TOKENS.ink, fontSize:14, fontWeight:600, opacity:1 })) }}>
      {busy
        ? <><span style={{ width:13, height:13, border:'2px solid rgba(253,252,249,0.4)', borderTopColor:'#FDFCF9', borderRadius:'50%', display:'inline-block', animation:'spin 0.8s linear infinite', ...uvx(() => ({ border:`2px solid ${studioInk(0.2)}`, borderTopColor:STUDIO_TOKENS.muted })) }} />Scanning…</>
        : <><span aria-hidden="true" style={{ color:'#C8A96E', ...uvx({ color:'inherit' }) }}>✦</span>Scan</>}
    </button>
    {error && <p style={{ fontSize:11, color:'#7A271C', margin:'5px 2px 0', lineHeight:1.4, ...uvx(() => ({ fontSize:14, color:STUDIO_TOKENS.ink })) }}>{error}</p>}
  </div>
);

// ════════════════════════════════════════════════════════════════════════
// S138 — Shared capture engine (ONE code path for Survey + Snag)
// ────────────────────────────────────────────────────────────────────────
// The durable photo path was hardened across S136/S137: IndexedDB-first write
// (a shot is never silently dropped), fire-and-forget upload + retry queue,
// and the camZoneRef burst fix (every shot in a session keeps its zone). S138
// lifts that path verbatim out of the Live Survey screen so the Snag tool runs
// the SAME engine instead of forking a second, weaker path — the skill's #1
// bug source (multiple entry points into shared capture). The Survey screen now
// calls these too: one savePhotoReliableCore, one useBurstCamera, one camZoneRef.
// ════════════════════════════════════════════════════════════════════════

// Domain-agnostic durable save. Writes the blob to IndexedDB FIRST, then hands
// the caller the photo via onAdd, then fires the upload in the background. The
// caller owns where the photo lands (survey sitePhotos / snag issue) via
// onAdd + onUrl, so persistence differs by domain but the durable mechanism
// never does. Returns the photo object {id, src, ts, zone, label}.
const savePhotoReliableCore = async ({ dataUrl, rawBlob, zone, label, fromBurst, uploadProjectId, onAdd, onUrl }) => {
  const photoId = _photoIdSeq();
  const ts = new Date().toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
  let idbOk = false;
  try {
    const blob = rawBlob || (dataUrl ? dataUrlToBlob(dataUrl) : null);
    if (blob) idbOk = await idbPutBlob(photoId, blob, { zone: zone || null, label: label || 'Site photo' });
    debugLog('photo.idb.stored', { id: photoId, ok: idbOk, via: fromBurst ? 'burst' : 'file' });
  } catch (e) { debugLog('photo.idb.error', { error: (e && e.message) || String(e) }); }
  const photo = { id: photoId, src: dataUrl || undefined, ts, zone: zone || null, label: label || 'Site photo' };
  if (typeof onAdd === 'function') { try { onAdd(photo); } catch (e) {} }
  if (dataUrl && _isB64(dataUrl)) {
    debugLog('photo.upload.start', { projectId: uploadProjectId || null, zone: zone || null, via: fromBurst ? 'burst' : 'file' });
    (async () => {
      const result = await _uploadPhotoOnce(photo);
      if (result.ok && result.url) {
        debugLog('photo.upload.ok', { via: fromBurst ? 'burst' : 'file', ms: result.ms });
        if (typeof onUrl === 'function') { try { onUrl(photo.id, result.url); } catch (e) {} }
      } else {
        debugLog('photo.upload.fail', { via: fromBurst ? 'burst' : 'file', error: result.error });
        if (uploadProjectId) addToPhotoRetryQueue(uploadProjectId, photo);
      }
    })();
  }
  return photo;
};

// Burst camera as a reusable hook. getUserMedia stays open across shots; every
// shot keeps its zone via camZoneRef (S137 fix B — was read from state that the
// save cleared after shot 1, so shots 2+ misfiled). Falls back to the native
// file input — capture never blocks. The caller supplies onAdd/onUrl (durable
// persistence wiring) and onFileFallback (its own file <input>).
const useBurstCamera = ({ uploadProjectId, getZone, onAdd, onUrl, onFileFallback, onClosed, label } = {}) => {
  const [showCamera, setShowCamera] = useState(false);
  const [camCount, setCamCount] = useState(0);
  const [camThumbs, setCamThumbs] = useState([]);
  const [camError, setCamError] = useState('');
  const camVideoRef = useRef(null);
  const camStreamRef = useRef(null);
  const camZoneRef = useRef(null);

  const _stopCamStream = () => { try { const s = camStreamRef.current; if (s) s.getTracks().forEach(tr => tr.stop()); } catch (e) {} camStreamRef.current = null; };

  const open = async (zone) => {
    const z = (zone === undefined && typeof getZone === 'function') ? getZone() : zone;
    camZoneRef.current = z || null;
    setCamCount(0); setCamThumbs([]); setCamError('');
    try {
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) throw new Error('getUserMedia unavailable');
      const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: { ideal: 'environment' } }, audio: false });
      camStreamRef.current = stream;
      setShowCamera(true);
      setTimeout(() => { if (camVideoRef.current) { try { camVideoRef.current.srcObject = stream; camVideoRef.current.play().catch(() => {}); } catch (e) {} } }, 40);
    } catch (e) {
      debugLog('camera.getusermedia.fail', { error: (e && e.message) || String(e) });
      setShowCamera(false);
      if (typeof onFileFallback === 'function') setTimeout(() => { try { onFileFallback(camZoneRef.current); } catch (e2) {} }, 50);
    }
  };
  const snap = async () => {
    const v = camVideoRef.current;
    if (!v || !v.videoWidth) { setCamError('Camera still warming up…'); return; }
    try {
      const maxW = 1280;
      const scale = Math.min(1, maxW / Math.max(v.videoWidth, v.videoHeight));
      const w = Math.round(v.videoWidth * scale), h = Math.round(v.videoHeight * scale);
      const canvas = document.createElement('canvas');
      canvas.width = w; canvas.height = h;
      canvas.getContext('2d').drawImage(v, 0, 0, w, h);
      const dataUrl = canvas.toDataURL('image/jpeg', 0.65);
      const photo = await savePhotoReliableCore({ dataUrl, zone: camZoneRef.current, label: label || 'Site photo', fromBurst: true, uploadProjectId, onAdd, onUrl });
      if (photo) { setCamThumbs(prev => [...prev, photo]); setCamCount(c => c + 1); setCamError(''); }
    } catch (e) { setCamError('That shot did not capture. Try again.'); debugLog('camera.snap.fail', { error: (e && e.message) || String(e) }); }
  };
  const close = () => {
    _stopCamStream(); setShowCamera(false);
    const n = camCount;
    setCamCount(0); setCamThumbs([]); setCamError('');
    if (typeof onClosed === 'function') { try { onClosed(n); } catch (e) {} }
  };
  useEffect(() => () => { _stopCamStream(); }, []);
  return { showCamera, camCount, camThumbs, camError, camVideoRef, camStreamRef, camZoneRef, open, snap, close };
};

// Full-screen burst camera overlay. Pure presentation; all state lives in the
// useBurstCamera hook so Survey and Snag render an identical camera.
const BurstCameraOverlay = ({ cam, headerLabel, onUseFiles }) => {
  if (!cam || !cam.showCamera) return null;
  return (
    <SheetPortal>
    <div style={{ position:"fixed", inset:0, background:"#0B1410", zIndex:300, display:"flex", flexDirection:"column" }}>
      <div style={{ flex:1, position:"relative", overflow:"hidden", background:"#000" }}>
        <video ref={cam.camVideoRef} autoPlay playsInline muted style={{ width:"100%", height:"100%", objectFit:"cover" }} />
        <div style={{ position:"absolute", top:0, left:0, right:0, padding:"14px 16px calc(14px + env(safe-area-inset-top,0px))", display:"flex", alignItems:"center", justifyContent:"space-between", background:"linear-gradient(180deg, rgba(0,0,0,0.5), transparent)" }}>
          <span style={{ color:"#fff", fontSize:13, fontWeight:600 }}>{headerLabel || 'Photo'}</span>
          {cam.camError && <span style={{ color:"#F0C0B0", fontSize:11, fontWeight:600 }}>{cam.camError}</span>}
        </div>
        <div style={{ position:"absolute", left:14, bottom:`calc(118px + env(safe-area-inset-bottom,0px))`, display:"flex", gap:7, flexWrap:"wrap", maxWidth:"60%" }}>
          {cam.camThumbs.slice(-6).map((th,i)=>(
            <div key={th.id||i} style={{ width:46, height:46, borderRadius:9, overflow:"hidden", border:"1.5px solid rgba(255,255,255,0.6)", animation:"popIn 0.25s ease" }}>
              <MediaThumb photo={th} style={{ width:"100%", height:"100%", objectFit:"cover", display:"block" }} />
            </div>
          ))}
        </div>
      </div>
      <div style={{ background:"#0B1410", padding:`16px 18px calc(20px + env(safe-area-inset-bottom,0px))` }}>
        <div style={{ textAlign:"center", minHeight:18, marginBottom:10, fontSize:13, fontWeight:600, color: cam.camCount>0 ? '#9FD4A8' : 'rgba(255,255,255,0.55)' }}>
          {cam.camCount>0 ? `${cam.camCount} captured this session ✓` : 'Tap the shutter. Camera stays open.'}
        </div>
        <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between" }}>
          <button onClick={cam.close} style={{ minWidth:64, minHeight:44, background:"none", border:"none", color:"#fff", fontSize:14, fontWeight:600, cursor:"pointer", fontFamily:"inherit" }}>Done</button>
          <button aria-label="Capture photo" onClick={cam.snap} style={{ width:70, height:70, borderRadius:"50%", background:"#fff", border:"4px solid rgba(255,255,255,0.35)", cursor:"pointer", boxShadow:"0 6px 18px rgba(0,0,0,0.4)" }} />
          {onUseFiles
            ? <button onClick={onUseFiles} style={{ minWidth:64, minHeight:44, background:"none", border:"none", color:"rgba(255,255,255,0.7)", fontSize:12, fontWeight:600, cursor:"pointer", fontFamily:"inherit" }}>Use files</button>
            : <span style={{ minWidth:64 }} />}
        </div>
      </div>
    </div>
    </SheetPortal>
  );
};

// ── Micro Components ──────────────────────────────────
const Icon = ({ name, size = 20, color = t.colors.text }) => {
  const icons = {
    home: <path d="M3 12l9-8 9 8v8a2 2 0 01-2 2H5a2 2 0 01-2-2v-8z" fill="none" stroke={color} strokeWidth="2"/>,
    calendar: <><rect x="3" y="4" width="18" height="18" rx="2" fill="none" stroke={color} strokeWidth="2"/><path d="M16 2v4M8 2v4M3 10h18" fill="none" stroke={color} strokeWidth="2"/></>,
    mic: <><rect x="9" y="2" width="6" height="11" rx="3" fill="none" stroke={color} strokeWidth="2"/><path d="M5 10a7 7 0 0014 0M12 19v3M8 22h8" fill="none" stroke={color} strokeWidth="2"/></>,
    zap: <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round"/>,
    gear: <><circle cx="12" cy="12" r="3" fill="none" stroke={color} strokeWidth="2"/><path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round"/></>,
    check: <path d="M5 12l5 5L20 7" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>,
    chevron: <path d="M9 6l6 6-6 6" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round"/>,
    plus: <path d="M12 5v14M5 12h14" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round"/>,
    arrow: <path d="M19 12H5M12 5l-7 7 7 7" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>,
    building: <path d="M3 21h18M3 7v14M21 7v14M9 21v-4h6v4M3 7h18M9 3h6M9 3v4M15 3v4" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round"/>,
    user: <><circle cx="12" cy="8" r="4" fill="none" stroke={color} strokeWidth="2"/><path d="M4 21v-1a6 6 0 0112 0v1" fill="none" stroke={color} strokeWidth="2"/></>,
    phone: <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 8.63 19.79 19.79 0 012 2.18 2 2 0 014 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" fill="none" stroke={color} strokeWidth="2"/>,
    location: <><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" fill="none" stroke={color} strokeWidth="2"/><circle cx="12" cy="10" r="3" fill="none" stroke={color} strokeWidth="2"/></>,
    camera: <><rect x="3" y="7" width="18" height="14" rx="2" fill="none" stroke={color} strokeWidth="2"/><circle cx="12" cy="13" r="3" fill="none" stroke={color} strokeWidth="2"/><path d="M8 7V6a2 2 0 012-2h4a2 2 0 012 2v1" fill="none" stroke={color} strokeWidth="2"/></>,
    send: <path d="M22 2L11 13M22 2L15 22l-4-9-9-4 20-7z" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>,
    download: <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round"/>,
    flag: <><path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z" fill="none" stroke={color} strokeWidth="2"/><line x1="4" y1="22" x2="4" y2="15" stroke={color} strokeWidth="2" strokeLinecap="round"/></>,
    bulb: <><path d="M9 21h6M12 3a6 6 0 016 6c0 2.22-1.21 4.16-3 5.2V17a1 1 0 01-1 1H10a1 1 0 01-1-1v-2.8C7.21 13.16 6 11.22 6 9a6 6 0 016-6z" fill="none" stroke={color} strokeWidth="2"/></>,
    chart: <><path d="M18 20V10M12 20V4M6 20v-6" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round"/></>,
    clock: <><circle cx="12" cy="12" r="9" fill="none" stroke={color} strokeWidth="2"/><path d="M12 7v5l3 3" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round"/></>,
    leaf: <path d="M17 8C8 10 5.9 16.17 3.82 19.81M16 17a5 5 0 00-10 0M17 8a5 5 0 01-10 0C7 4 12 2 17 8z" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round"/>,
    shield: <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" fill="none" stroke={color} strokeWidth="2"/>,
    star: <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill="none" stroke={color} strokeWidth="2"/>,
    wifi: <><path d="M1.42 9a16 16 0 0121.16 0M5 12.55a11 11 0 0114.08 0M10.54 16.1a6 6 0 012.92 0" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round"/><circle cx="12" cy="20" r="1" fill={color}/></>,
    map: <><polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6" fill="none" stroke={color} strokeWidth="2" strokeLinejoin="round"/><line x1="8" y1="2" x2="8" y2="18" stroke={color} strokeWidth="2"/><line x1="16" y1="6" x2="16" y2="22" stroke={color} strokeWidth="2"/></>,
    pin: <><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" fill={color} fillOpacity="0.2" stroke={color} strokeWidth="2"/><circle cx="12" cy="10" r="2.5" fill={color}/></>,
    pen: <><path d="M17 3a2.828 2.828 0 114 4L7.5 20.5 2 22l1.5-5.5L17 3z" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></>,
    warning: <><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" fill="none" stroke={color} strokeWidth="2"/><line x1="12" y1="9" x2="12" y2="13" stroke={color} strokeWidth="2" strokeLinecap="round"/><line x1="12" y1="17" x2="12.01" y2="17" stroke={color} strokeWidth="2" strokeLinecap="round"/></>,
    undo: <><path d="M9 14L4 9l5-5" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M4 9h10.5a5.5 5.5 0 010 11H11" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round"/></>,
    trash: <><polyline points="3 6 5 6 21 6" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round"/><path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6M10 11v6M14 11v6M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round"/></>,
    filter: <><line x1="4" y1="6" x2="20" y2="6" stroke={color} strokeWidth="2" strokeLinecap="round"/><line x1="8" y1="12" x2="16" y2="12" stroke={color} strokeWidth="2" strokeLinecap="round"/><line x1="11" y1="18" x2="13" y2="18" stroke={color} strokeWidth="2" strokeLinecap="round"/></>,
    close: <path d="M18 6L6 18M6 6l12 12" fill="none" stroke={color} strokeWidth="2.2" strokeLinecap="round"/>,
    pencil: <><path d="M17 3a2.83 2.83 0 014 4L7.5 20.5 2 22l1.5-5.5L17 3z" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></>,
    person: <><circle cx="12" cy="8" r="4" fill="none" stroke={color} strokeWidth="2"/><path d="M4 21v-1a8 8 0 0116 0v1" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round"/></>,
    plans: <><rect x="3" y="3" width="18" height="18" rx="2" fill="none" stroke={color} strokeWidth="2"/><line x1="3" y1="12" x2="21" y2="12" stroke={color} strokeWidth="1.5"/><line x1="12" y1="3" x2="12" y2="21" stroke={color} strokeWidth="1.5"/><line x1="3" y1="8" x2="21" y2="8" stroke={color} strokeWidth="1" opacity="0.4"/><line x1="3" y1="16" x2="21" y2="16" stroke={color} strokeWidth="1" opacity="0.4"/><line x1="8" y1="3" x2="8" y2="21" stroke={color} strokeWidth="1" opacity="0.4"/><line x1="16" y1="3" x2="16" y2="21" stroke={color} strokeWidth="1" opacity="0.4"/></>,
    package: <><path d="M16.5 9.4l-9-5.19M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><polyline points="3.27 6.96 12 12.01 20.73 6.96" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><line x1="12" y1="22.08" x2="12" y2="12" stroke={color} strokeWidth="2" strokeLinecap="round"/></>,
  };
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{ flexShrink: 0, display: "block" }}>
      {icons[name] || icons.home}
    </svg>
  );
};

const GlassCard = ({ children, style, onClick, gold, hover = true }) => {
  const [hov, setHov] = useState(false);
  const accentColor = gold === true ? t.colors.gold : (typeof gold === "string" ? gold : null);
  const accentBg = accentColor ? `rgba(200,144,48,0.08)` : t.colors.glass;
  const accentBorderSide = accentColor ? "rgba(200,144,48,0.28)" : t.colors.glassBorder;
  const accentBorderTop = accentColor ? "rgba(255,255,250,0.96)" : "rgba(255,255,250,0.96)";
  // Studio (track C4): raised paper, or a slip when it can be tapped. The gold
  // prop is not used: a tint is colour for looks. The caller's style still
  // comes last, as before.
  if (t.theme === 'uv') {
    const lift = hov && onClick;
    return (
      <div
        onMouseEnter={() => hover && setHov(true)}
        onMouseLeave={() => hover && setHov(false)}
        onClick={onClick}
        style={{
          ...(onClick ? studioSurface.slip() : studioSurface.raised()),
          color: STUDIO_TOKENS.ink,
          borderRadius: t.radius.lg,
          transition: "transform 0.15s ease, box-shadow 0.15s ease",
          transform: lift ? "translate(1px, -2px)" : "translate(0, 0)",
          cursor: onClick ? "pointer" : "default",
          ...(onClick ? { minHeight: STUDIO_TOKENS.button.minHeight } : {}),
          ...(lift ? { boxShadow: STUDIO_TOKENS.shadow.slipHover } : {}),
          ...style,
        }}>
        {children}
      </div>
    );
  }
  return (
    <div
      onMouseEnter={() => hover && setHov(true)}
      onMouseLeave={() => hover && setHov(false)}
      onClick={onClick}
      style={{
        background: accentBg,
        border: `1px solid ${accentBorderSide}`,
        borderTop: `1px solid ${accentBorderTop}`,
        borderRadius: t.radius.lg,
        transition: "all 0.2s ease",
        transform: hov && onClick ? "translateY(-1px)" : "translateY(0)",
        cursor: onClick ? "pointer" : "default",
        ...style,
      }}>
      {children}
    </div>
  );
};

// ── Screen ambient blobs ─────────────────────────────
const ScreenBlobs = () =>
  React.createElement('div', { style: { position: 'absolute', inset: 0, zIndex: 0, overflow: 'hidden', pointerEvents: 'none' } },
    React.createElement('div', { className: 'blob blob1' }),
    React.createElement('div', { className: 'blob blob2' }),
    React.createElement('div', { className: 'blob blob3' }),
    React.createElement('div', { className: 'blob blob4' })
  );

// ── Swipe navigation utility — shared across main tabs & voice notes ────────
const createSwipeHandler = (onSwipeLeft, onSwipeRight) => {
  let touchStartX = 0;
  let touchStartY = 0;

  return {
    onTouchStart: (e) => {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    },
    onTouchEnd: (e) => {
      const deltaX = e.changedTouches[0].clientX - touchStartX;
      const deltaY = e.changedTouches[0].clientY - touchStartY;

      // Only trigger if horizontal movement dominates
      if (Math.abs(deltaX) < 60) return;
      if (Math.abs(deltaY) > Math.abs(deltaX)) return;

      // Don't trigger if user is typing
      const tag = document.activeElement && document.activeElement.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA') return;

      if (deltaX < 0 && onSwipeLeft)  onSwipeLeft();   // swipe left  → go forward
      if (deltaX > 0 && onSwipeRight) onSwipeRight();  // swipe right → go back
    }
  };
};

// ── Long-press delete handler ───────────────────────────────────────────────
const useLongPress = (onLongPress, ms = 500) => {
  const timerRef = React.useRef(null);
  const startRef = React.useRef(null);
  const onStart = (e) => {
    startRef.current = { x: e.touches?.[0]?.clientX || 0, y: e.touches?.[0]?.clientY || 0 };
    timerRef.current = setTimeout(() => { onLongPress(); }, ms);
  };
  const onMove = (e) => {
    if (!startRef.current || !timerRef.current) return;
    const dx = Math.abs((e.touches?.[0]?.clientX || 0) - startRef.current.x);
    const dy = Math.abs((e.touches?.[0]?.clientY || 0) - startRef.current.y);
    if (dx > 10 || dy > 10) { clearTimeout(timerRef.current); timerRef.current = null; }
  };
  const onEnd = () => { if (timerRef.current) { clearTimeout(timerRef.current); timerRef.current = null; } };
  return { onTouchStart: onStart, onTouchMove: onMove, onTouchEnd: onEnd };
};

// ── LongPressCard — wraps children with ⋮ menu + long-press delete ──────────
// confirmText / confirmSubtext are optional; when set they render
// inside the red overlay above the Delete / Cancel buttons so the
// user knows exactly what they're about to remove. Backward-compatible:
// callers that omit them get the original buttons-only layout.
// kebabAt: 'bottom' puts the ⋮ in the card's bottom-right corner (beside its
// action links) instead of over its top-right figure (STUDIO-LIT-PHONE-V1,
// Today's time line, where a visit's value sits top right). Default unchanged.
const LongPressCard = ({ children, onDelete, style, confirmText, confirmSubtext, kebabAt }) => {
  const [showConfirm, setShowConfirm] = React.useState(false);
  // Synchronous ref — survives the React re-render race between
  // long-press timer firing and the touchend→click arriving.
  // Without this, cards with onClick (e.g. Survey IN PROGRESS) navigate
  // away before the confirm overlay paints.
  const confirmRef = React.useRef(false);
  const triggerConfirm = () => { confirmRef.current = true; setShowConfirm(true); };
  const clearConfirm = () => { confirmRef.current = false; setShowConfirm(false); };
  const longPressHandlers = useLongPress(triggerConfirm, 500);

  return (
    <div
      style={{ position: 'relative', ...style }}
      {...longPressHandlers}
      onClickCapture={(e) => {
        // Block the click that fires after a long-press touchend on the card body —
        // confirmRef is set synchronously so it's true even before React re-renders.
        // BUT: don't block clicks on the confirm overlay itself (Delete/Cancel buttons).
        if (confirmRef.current && !e.target.closest('[data-lpc-confirm]')) {
          e.stopPropagation(); e.preventDefault();
        }
      }}
    >
      {children}
      {/* ⋮ tap target — top-right, isolated stacking context above all children */}
      {!showConfirm && (
        <div
          onClickCapture={(e) => { e.stopPropagation(); e.preventDefault(); triggerConfirm(); }}
          onTouchEndCapture={(e) => { e.stopPropagation(); e.preventDefault(); triggerConfirm(); }}
          style={{
            position: 'absolute', ...(kebabAt === 'bottom' ? { bottom: 0 } : { top: 0 }), right: 0, zIndex: 50,
            width: 44, height: 44, borderRadius: 8,
            background: 'transparent', cursor: 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            padding: 0,
          }}
        >
          <div style={{
            width: 28, height: 28, borderRadius: 8,
            background: t.colors.paper75,
            border: `0.5px solid ${t.colors.ink12}`,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            boxShadow: t.shadow.kebab,
          }}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <circle cx="8" cy="3" r="1.5" fill={t.colors.ink65}/>
              <circle cx="8" cy="8" r="1.5" fill={t.colors.ink65}/>
              <circle cx="8" cy="13" r="1.5" fill={t.colors.ink65}/>
            </svg>
          </div>
        </div>
      )}
      {showConfirm && (
        <div data-lpc-confirm="1" style={{
          position: 'absolute', inset: 0, zIndex: 20,
          background: t.colors.lpcConfirmBg,
          borderRadius: 18,
          display: 'flex', flexDirection: 'column',
          alignItems: 'center', justifyContent: 'center',
          gap: confirmText ? 8 : 16,
          padding: confirmText ? '10px 14px' : 0,
        }}>
          {confirmText && (
            <div style={{
              color: t.colors.onFill, fontSize: 13, fontWeight: 700,
              textAlign: 'center', lineHeight: 1.3,
            }}>{confirmText}</div>
          )}
          {confirmSubtext && (
            <div style={{
              color: 'rgba(255,255,255,0.85)', fontSize: 11,
              fontWeight: 400, textAlign: 'center',
              lineHeight: 1.35, fontStyle: t.font.italic,
            }}>{confirmSubtext}</div>
          )}
          <div style={{ display: 'flex', gap: 14 }}>
            <button onClick={(e) => { e.stopPropagation(); onDelete(); clearConfirm(); }} style={{
              background: '#fff', border: 'none', borderRadius: 12,
              padding: '8px 22px', fontSize: 14, fontWeight: 700, color: t.colors.lpcDeleteText,
              cursor: 'pointer', fontFamily: 'inherit',
            }}>Delete</button>
            <button onClick={(e) => { e.stopPropagation(); clearConfirm(); }} style={{
              background: 'rgba(255,255,255,0.25)', border: 'none', borderRadius: 12,
              padding: '8px 22px', fontSize: 14, fontWeight: 600, color: t.colors.onFill,
              cursor: 'pointer', fontFamily: 'inherit',
            }}>Cancel</button>
          </div>
        </div>
      )}
    </div>
  );
};

// ── Swipeable card with reveal-delete ───────────────────────────────────────
const SwipeableCard = ({ children, onDelete, style }) => {
  const [offsetX, setOffsetX] = React.useState(0);
  const [isDragging, setIsDragging] = React.useState(false);
  const startXRef = React.useRef(null);
  const REVEAL = 80;
  const DEAD_ZONE = 15;
  const AUTO_DELETE = 180; // swipe past this to auto-delete

  const handleTouchStart = (e) => {
    startXRef.current = e.touches[0].clientX;
    setIsDragging(true);
  };
  const handleTouchMove = (e) => {
    if (startXRef.current === null) return;
    const dx = e.touches[0].clientX - startXRef.current;
    if (Math.abs(dx) < DEAD_ZONE) return;
    e.preventDefault();
    const clamped = Math.min(0, Math.max(-AUTO_DELETE - 20, dx));
    setOffsetX(clamped);
  };
  const handleTouchEnd = () => {
    setIsDragging(false);
    startXRef.current = null;
    if (offsetX < -AUTO_DELETE) {
      onDelete && onDelete();
    } else if (offsetX < -(REVEAL / 2)) {
      setOffsetX(-REVEAL);
    } else {
      setOffsetX(0);
    }
  };
  const close = () => setOffsetX(0);

  // How much of the red zone is visible
  const revealed = Math.abs(Math.min(offsetX, 0));

  return (
    <div style={{ position: "relative", marginBottom: 10, ...style }}>
      {/* Delete zone — only rendered when swiping, sized exactly to revealed amount */}
      <div style={{
        position: "absolute", right: 0, top: 0, bottom: 0,
        width: revealed,
        background: t.colors.red,
        borderRadius: `0 ${t.radius.lg}px ${t.radius.lg}px 0`,
        ...uvx(() => ({ background: revealed > 0 ? STUDIO_TOKENS.pressed.fill : 'transparent' })),
        display: "flex", alignItems: "center", justifyContent: "center",
        overflow: "hidden",
      }}>
        {revealed > 40 && (
          <button onClick={() => { close(); onDelete && onDelete(); }} style={{ background: "none", border: "none", cursor: "pointer", display: "flex", flexDirection: "column", alignItems: "center", gap: 4, padding: "0 10px" }}>
            <Icon name="trash" size={20} color={t.theme === 'uv' ? STUDIO_TOKENS.ink : "#fff"} />
            <span style={{ fontSize: 11, fontWeight: 700, color: "#fff", ...uvx(() => ({ color: STUDIO_TOKENS.ink, fontSize: 13, fontWeight: 500 })) }}>Delete</span>
          </button>
        )}
      </div>
      {/* Card — slides left, its own border-radius covers the red zone edges */}
      <div
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
        style={{
          transform: `translateX(${offsetX}px)`,
          transition: isDragging ? "none" : "transform 0.25s cubic-bezier(0.25,0.46,0.45,0.94)",
          borderRadius: t.radius.lg,
          overflow: "hidden",
          position: "relative",
          zIndex: 1,
        }}
      >
        {offsetX < -10 && (
          <div onClick={close} style={{ position: "absolute", inset: 0, zIndex: 10, cursor: "pointer" }} />
        )}
        {children}
      </div>
    </div>
  );
};

const Pill = ({ label, color = t.colors.gold, small }) => {
  // Studio (track C4): status is plain words, never a badge. No fill, no pill
  // shape, no capitals, and the colour a caller passes is not used. The label
  // is shown exactly as given.
  if (t.theme === 'uv') {
    return <span style={{ fontSize: 14, fontWeight: 400, color: STUDIO_TOKENS.muted, whiteSpace: "nowrap" }}>{label}</span>;
  }
  return (
  <span style={{
    display: "inline-flex", alignItems: "center",
    padding: small ? "2px 8px" : "4px 12px",
    borderRadius: t.radius.pill,
    background: `${color}18`, color,
    fontSize: small ? 10 : 12, fontWeight: 700,
    letterSpacing: 0.4, textTransform: "uppercase", whiteSpace: "nowrap",
  }}>{label}</span>
  );
};

const Btn = ({ label, variant = "primary", icon, onClick, fullWidth, small, disabled, color: accentOverride }) => {
  const [pressed, setPressed] = useState(false);
  const ac = accentOverride || t.colors.gold;
  const acBright = accentOverride || t.colors.goldBright;
  const v = {
    primary: { bg: "#3E8BBF", color: "#fff", border: "none", shadow: "none" },
    secondary: { bg: `${ac}18`, color: ac, border: `0.5px solid ${ac}40`, shadow: "none" },
    ghost: { bg: "transparent", color: t.colors.textSecondary, border: `0.5px solid ${t.colors.glassBorder}`, shadow: "none" },
    green: { bg: "rgba(74,222,128,0.12)", color: t.colors.green, border: `0.5px solid rgba(74,222,128,0.25)`, shadow: "none" },
    danger: { bg: t.colors.redLight, color: t.colors.red, border: `0.5px solid rgba(255,90,90,0.2)`, shadow: "none" },
  }[variant];
  return (
    <button onClick={disabled ? undefined : onClick}
      onMouseDown={() => setPressed(true)} onMouseUp={() => setPressed(false)} onMouseLeave={() => setPressed(false)}
      style={{
        display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 6,
        padding: small ? "8px 16px" : "14px 18px",
        borderRadius: small ? t.radius.md : 12,
        background: disabled ? "rgba(255,255,255,0.05)" : v.bg,
        color: disabled ? t.colors.textTertiary : v.color,
        border: v.border, fontSize: small ? 13 : 16, fontWeight: 700,
        fontFamily: "system-ui, -apple-system, sans-serif",
        cursor: disabled ? "not-allowed" : "pointer", letterSpacing: -0.2,
        transition: "all 0.2s ease",
        transform: pressed ? "scale(0.97)" : "scale(1)",
        width: fullWidth ? "100%" : "auto",
        boxShadow: variant === "primary" && !disabled ? v.shadow : "none",
        opacity: disabled ? 0.5 : 1,
      }}>
      {icon && <Icon name={icon} size={small ? 14 : 16} color={disabled ? t.colors.textTertiary : v.color} />}
      {label}
    </button>
  );
};

const SeverityDot = ({ level }) => {
  const c = { Critical: t.colors.red, High: t.colors.amber, Medium: t.colors.blue, Low: t.colors.green }[level] || t.colors.green;
  return <span style={{ display: "inline-flex", alignItems: "center", gap: 5, fontSize: 11, fontWeight: 700, color: c, textTransform: "uppercase", letterSpacing: 0.3 }}>
    <span style={{ width: 6, height: 6, borderRadius: "50%", background: c, flexShrink: 0 }} />{level}
  </span>;
};

// ── Tab screen mapping — Today · Company · Pipeline · Survey · Worth
const TAB_SCREENS = [0, 19, 18, 10, 15];
const screenToTab = (s) => {
  if (s === 0 || s === 20) return 0;                               // Today + Morning Briefing
  if (s === 19) return 1;                                         // Company
  // STUDIO-LIT-PHONE-V1 item 8a: with the Studio switch on, More is opened
  // from Today's More row (item 2), not from Company, so More and what opens
  // from it sit under Today (New enquiry, 6, keeps its tab: it opens from
  // several places). A voice note is opened from the header's orb on
  // any screen, so it marks no tab. Switch off: unchanged.
  if (t.theme === 'uv' && (s === 16 || s === 17 || s === 7 || s === 21 || s === 22)) return 0;
  if (t.theme === 'uv' && s === 9) return -1;
  if (s === 16 || s === 17 || s === 7 || s === 9 || s === 6 || s === 21 || s === 22) return 1; // More/Settings/Voice/Contacts/Suppliers from Company
  if (s === 18) return 2;                                         // Pipeline
  if ([2, 3, 8, 10, 11, 12, 13, 14].includes(s)) return 3;      // Survey/Snag workflow screens
  if (s === 15) return 4;                                         // Worth
  return -1;
};

const TabBar = ({ active, onChange, divisionId }) => {
  const isAircon = divisionId === "aircon";

  const TodayIcon = ({ col }) => (
    <svg width="22" height="22" viewBox="0 0 28 28" fill="none">
      <circle cx="14" cy="16" r="5" stroke={col} strokeWidth="1.8" fill="none"/>
      <line x1="4" y1="22" x2="24" y2="22" stroke={col} strokeWidth="1.8" strokeLinecap="round"/>
      <line x1="14" y1="4" x2="14" y2="7" stroke={col} strokeWidth="1.8" strokeLinecap="round"/>
      <line x1="6" y1="8" x2="8.2" y2="10.2" stroke={col} strokeWidth="1.8" strokeLinecap="round"/>
      <line x1="22" y1="8" x2="19.8" y2="10.2" stroke={col} strokeWidth="1.8" strokeLinecap="round"/>
      <line x1="3" y1="16" x2="6" y2="16" stroke={col} strokeWidth="1.8" strokeLinecap="round"/>
      <line x1="25" y1="16" x2="22" y2="16" stroke={col} strokeWidth="1.8" strokeLinecap="round"/>
    </svg>
  );
  const PipelineIcon = ({ col }) => (
    <svg width="22" height="22" viewBox="0 0 28 28" fill="none">
      <path d="M4 6h20l-8 9v7l-4-2v-5L4 6z" stroke={col} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    </svg>
  );
  const SurveyIcon = ({ col }) => (
    <svg width="22" height="22" viewBox="0 0 28 28" fill="none">
      <path d="M14 3C10.13 3 7 6.13 7 10c0 5.25 7 15 7 15s7-9.75 7-15c0-3.87-3.13-7-7-7z" stroke={col} strokeWidth="1.8" fill="none"/>
      <circle cx="14" cy="10" r="2.8" stroke={col} strokeWidth="1.5" fill="none"/>
      <line x1="14" y1="7.2" x2="14" y2="12.8" stroke={col} strokeWidth="1.2" strokeLinecap="round"/>
      <line x1="11.2" y1="10" x2="16.8" y2="10" stroke={col} strokeWidth="1.2" strokeLinecap="round"/>
    </svg>
  );
  const QuotesIcon = ({ col }) => (
    <svg width="22" height="22" viewBox="0 0 28 28" fill="none">
      <line x1="14" y1="5" x2="14" y2="22" stroke={col} strokeWidth="1.8" strokeLinecap="round"/>
      <line x1="5" y1="10" x2="23" y2="10" stroke={col} strokeWidth="1.8" strokeLinecap="round"/>
      <line x1="7" y1="10" x2="7" y2="16" stroke={col} strokeWidth="1.4" strokeLinecap="round"/>
      <path d="M4 16 Q7 18 10 16" stroke={col} strokeWidth="1.6" strokeLinecap="round" fill="none"/>
      <line x1="21" y1="10" x2="21" y2="17" stroke={col} strokeWidth="1.4" strokeLinecap="round"/>
      <path d="M18 17 Q21 19 24 17" stroke={col} strokeWidth="1.6" strokeLinecap="round" fill="none"/>
      <line x1="11" y1="22" x2="17" y2="22" stroke={col} strokeWidth="1.8" strokeLinecap="round"/>
    </svg>
  );
  const CompanyIcon = ({ col }) => (
    <svg width="22" height="22" viewBox="0 0 28 28" fill="none">
      <path d="M2 24h24" stroke={col} strokeWidth="2" strokeLinecap="round"/>
      <rect x="11" y="6" width="6" height="18" rx="1" stroke={col} strokeWidth="2"/>
      <rect x="5" y="12" width="5" height="12" rx="1" stroke={col} strokeWidth="1.8"/>
      <rect x="18" y="14" width="5" height="10" rx="1" stroke={col} strokeWidth="1.8"/>
      <line x1="14" y1="6" x2="14" y2="4" stroke={col} strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  );

  const getTabColor = (tabIndex, activeTab) => {
    // UV-RESKIN-V1 track E: tokens; under the theme every active tab is ink.
    if (tabIndex !== activeTab) return t.colors.stone35;
    if (tabIndex === 0) return t.colors.goldInk;      // Today — amber
    if (tabIndex === 1) return t.colors.tabNavy;      // Company — deep navy
    if (tabIndex === 3) return t.colors.green;      // Survey — green
    if (tabIndex === 4) return t.colors.tabGold;      // Worth — muted gold
    return t.colors.stone75;
  };

  const TABS = [
    { label: "Today",    screen: 0,  IconEl: TodayIcon },
    { label: "Company",  screen: 19, IconEl: CompanyIcon },
    { label: "Pipeline", screen: 18, IconEl: PipelineIcon },
    { label: "Survey",   screen: 10, IconEl: SurveyIcon },
    { label: "Worth",    screen: 15, IconEl: QuotesIcon },
  ];

  const activeTab = screenToTab(active);
  const unreadNotifCount = (() => { try { const d = JSON.parse(localStorage.getItem('lumen_notifications') || 'null'); return d ? (d.unread_count || 0) : 0; } catch(e) { return 0; } })();
  // While a sheet or dialog is open (SheetPortal) the bar is not drawn, so it
  // can never sit over a sheet's own buttons, on any engine.
  const sheetsOpen = useSheetsOpen();

  // S95 D23 — hide tab bar while the iOS keyboard is open so note textareas
  // don't bleed through it. We detect keyboard state via focusin/focusout on
  // text-entry elements (textarea + text-like input). On focus we also
  // scrollIntoView so the field sits above the keyboard.
  const [keyboardOpen, setKeyboardOpen] = useState(false);
  useEffect(() => {
    const isTextEntry = (el) => {
      if (!el) return false;
      const tag = (el.tagName || '').toLowerCase();
      if (tag === 'textarea') return true;
      if (tag === 'input') {
        const t = (el.type || 'text').toLowerCase();
        return !['checkbox','radio','range','color','button','submit','reset','file','hidden','image'].includes(t);
      }
      return el.isContentEditable === true;
    };
    // S161 — keyboard reveal. The old scrollIntoView({block:'end'}) aligned the
    // input bottom with the LAYOUT viewport bottom — on iOS the keyboard overlays
    // that viewport (only window.visualViewport shrinks), so the input parked
    // behind the keyboard, and the racing native reveal-scroll shifted the sheet
    // until the caret sat off-screen ABOVE. Fix: measure against the VISUAL
    // viewport and nudge the nearest scrollable ancestor by the actual overlap,
    // in both directions; re-run once when the viewport settles (keyboard
    // animation finishes after any fixed timer).
    const revealField = (el) => {
      try {
        if (!el || !el.getBoundingClientRect || document.activeElement !== el) return;
        const vv = window.visualViewport;
        const visTop = (vv ? vv.offsetTop : 0) + 12;
        const visBottom = (vv ? vv.offsetTop + vv.height : window.innerHeight) - 12;
        const r = el.getBoundingClientRect();
        let delta = 0;
        if (r.bottom > visBottom) delta = r.bottom - visBottom;       // hidden behind the keyboard
        else if (r.top < visTop) delta = r.top - visTop;              // shifted off the top
        if (!delta) return;
        let sc = el.parentElement;
        while (sc && sc !== document.body) {
          const s = getComputedStyle(sc);
          if (/(auto|scroll)/.test(s.overflowY) && sc.scrollHeight > sc.clientHeight) break;
          sc = sc.parentElement;
        }
        if (sc && sc !== document.body) sc.scrollBy({ top: delta, behavior: 'smooth' });
        else window.scrollBy({ top: delta, behavior: 'smooth' });
      } catch(_) {}
    };
    const onFocusIn = (e) => {
      if (!isTextEntry(e.target)) return;
      setKeyboardOpen(true);
      const el = e.target;
      setTimeout(() => revealField(el), 250);
      // One follow-up pass when the visual viewport settles (keyboard fully open).
      const vv = window.visualViewport;
      if (vv) {
        const onSettle = () => { revealField(el); vv.removeEventListener('resize', onSettle); };
        vv.addEventListener('resize', onSettle);
        setTimeout(() => { try { vv.removeEventListener('resize', onSettle); } catch(_) {} }, 1500);
      }
    };
    const onFocusOut = () => {
      // Defer so focus moving between two fields does not flash the bar back in.
      setTimeout(() => {
        if (!isTextEntry(document.activeElement)) setKeyboardOpen(false);
      }, 80);
    };
    document.addEventListener('focusin', onFocusIn);
    document.addEventListener('focusout', onFocusOut);
    return () => {
      document.removeEventListener('focusin', onFocusIn);
      document.removeEventListener('focusout', onFocusOut);
    };
  }, []);

  // The bar floats over the bottom of its screen, so the screen's scroll area
  // must end clear of it, home-indicator inset included. Every screen that
  // draws the bar gets that from here: the scroll area beside it (or beside
  // the dock that holds it) is marked .tab-clear, and index.html's rule adds a
  // safe-area spacer after its content. Fixed or absolute panels (sheets) are
  // not scroll areas of the screen and are left alone.
  const tabRootRef = useRef(null);
  useEffect(() => {
    try {
      const root = tabRootRef.current;
      if (!root) return;
      const scrolls = (el) => {
        const cs = window.getComputedStyle(el);
        return (cs.overflowY === 'auto' || cs.overflowY === 'scroll') && cs.position !== 'fixed' && cs.position !== 'absolute';
      };
      let box = root.parentElement;
      for (let hop = 0; box && hop < 3; hop++, box = box.parentElement) {
        let found = false;
        Array.from(box.children).forEach(ch => {
          if (ch === root || ch.contains(root)) return;
          if (scrolls(ch)) {
            ch.classList.add('tab-clear');
            found = true;
          }
        });
        if (found) return;
        // A page that draws the bar inside its own scroll area (the lit
        // pages built on studioPage: More, Settings and the like) is that
        // scroll area itself (21 October 2026: it was never marked).
        if (box !== window.document.body && scrolls(box)) { box.classList.add('tab-clear'); return; }
      }
    } catch (e) {}
  });

  // COMPANION-STUDIO-V1 track 2: under the theme the tab bar is raised paper
  // floating above the ground, with line icons: the active tab is ink and
  // bold, the rest muted. Same five tabs, same targets, same keyboard hiding;
  // the unread count is written as a number in violet text, never a dot
  // (FINDINGS T2-4).
  if (t.theme === 'uv') {
    const S = STUDIO_TOKENS;
    const stroke = (on) => ({ fill: 'none', stroke: 'currentColor', strokeWidth: on ? 1.9 : 1.5, strokeLinecap: 'round', strokeLinejoin: 'round' });
    const ICONS = [
      (on) => <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true" {...stroke(on)}><path d="M4 11l8-7 8 7v9H4z"/><path d="M10 20v-5h4v5"/></svg>,
      (on) => <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true" {...stroke(on)}><path d="M3 21h18"/><path d="M6 21V9h5v12M13 21V4h5v17"/></svg>,
      (on) => <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true" {...stroke(on)}><path d="M4 6h16M4 12h11M4 18h6"/></svg>,
      (on) => <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true" {...stroke(on)}><path d="M12 21s-6-5.5-6-11a6 6 0 0 1 12 0c0 5.5-6 11-6 11z"/><circle cx="12" cy="10" r="2.2"/></svg>,
      (on) => <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true" {...stroke(on)}><path d="M12 4v16M5 8h14M7 8l-3 6a3 2 0 0 0 6 0zM17 8l-3 6a3 2 0 0 0 6 0zM9 20h6"/></svg>,
    ];
    return (
      <div ref={tabRootRef} style={{
        position: "fixed", left: 12, right: 12, bottom: "calc(env(safe-area-inset-bottom, 0px) + 12px)",
        // STUDIO-LIT-PHONE-V1 item 8a: the prototype's `.app-tabs`: 5px in,
        // radius 22, the tab you are on pressed into the paper (a well).
        display: (keyboardOpen || sheetsOpen) ? "none" : "flex", padding: 5, borderRadius: 22,
        background: S.paper.css, boxShadow: S.shadow.raised, zIndex: 100,
        pointerEvents: (keyboardOpen || sheetsOpen) ? "none" : "auto",
      }}>
        {TABS.map((tab, idx) => {
          const isActive = activeTab === idx;
          const showCount = idx === 0 && unreadNotifCount > 0;
          return (
            <button key={tab.label} onClick={() => onChange(tab.screen)} aria-current={isActive ? 'page' : undefined}
              style={{
                flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 3,
                minHeight: 52, border: "none", cursor: "pointer", padding: 0, borderRadius: 16,
                background: isActive ? S.pressed.fill : "none", boxShadow: isActive ? S.shadow.pressed : "none",
                color: isActive ? S.ink : S.muted, fontFamily: S.fonts.body, fontSize: 13, fontWeight: isActive ? 700 : 400,
              }}>
              {ICONS[idx](isActive)}
              <span>{tab.label}{showCount && <span style={{ color: S.ink, fontWeight: 700, marginLeft: 4, fontVariantNumeric: 'tabular-nums' }}>{unreadNotifCount}</span>}</span>
            </button>
          );
        })}
      </div>
    );
  }

  return (
    <div ref={tabRootRef} style={{
      position: "fixed", bottom: 0, left: 0, right: 0,
      height: 83,
      background: t.colors.bg,
      borderTop: `0.5px solid ${t.colors.olive08}`,
      display: (keyboardOpen || sheetsOpen) ? "none" : "flex", justifyContent: "space-around", alignItems: "flex-start",
      padding: "10px 0",
      paddingBottom: "calc(env(safe-area-inset-bottom, 0px) + 8px)",
      zIndex: 100,
      pointerEvents: (keyboardOpen || sheetsOpen) ? "none" : "auto",
    }}>
      {TABS.map((tab, idx) => {
        const isActive = activeTab === idx;
        const iconColor = getTabColor(idx, activeTab);
        const showBadge = idx === 0 && unreadNotifCount > 0;
        return (
          <button
            key={tab.label}
            onClick={() => onChange(tab.screen)}
            style={{
              display: "flex", flexDirection: "column", alignItems: "center",
              background: "none", border: "none", cursor: "pointer",
              minWidth: 52, minHeight: 44, padding: 0, position: 'relative',
            }}
          >
            {isActive ? (
              <div style={{
                background: "rgba(255,255,255,0.55)",
                border: "1px solid rgba(255,255,255,0.80)",
                borderRadius: 12,
                padding: "5px 10px",
                display: "flex", flexDirection: "column", alignItems: "center", gap: 2,
              }}>
                <tab.IconEl col={iconColor} />
                <span style={{ fontSize: 10, fontWeight: 700, color: getTabColor(idx, activeTab), letterSpacing: "0.03em" }}>{tab.label}</span>
              </div>
            ) : (
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2, padding: "5px 10px" }}>
                <tab.IconEl col={iconColor} />
                <span style={{ fontSize: 10, fontWeight: 500, color: t.colors.stone42, letterSpacing: "0.03em" }}>{tab.label}</span>
              </div>
            )}
            {showBadge && <div style={{ position: 'absolute', top: 4, right: 10, width: 7, height: 7, borderRadius: '50%', background: t.colors.alert, border: `1.5px solid ${t.colors.bg}` }} />}
          </button>
        );
      })}
    </div>
  );
};


const NavBar = ({ title, onBack, right, color, compact }) => {
  const navColor = color || t.colors.gold;
  return (
    <div style={{ padding: compact ? "2px 20px 6px" : "10px 20px 12px", display: "flex", alignItems: "center", justifyContent: "space-between", borderBottom: `0.5px solid ${t.colors.separator}`, flexShrink: 0 }}>
      {onBack ? (
        <button onClick={onBack} style={{ background: "none", border: "none", cursor: "pointer", display: "flex", alignItems: "center", gap: 6 }}>
          <Icon name="arrow" size={20} color={navColor} />
          <span style={{ color: navColor, fontSize: 15, fontWeight: 600 }}>Back</span>
        </button>
      ) : <div style={{ width: 60 }} />}
      <span style={{ fontSize: 16, fontWeight: 700, color: t.colors.text, letterSpacing: -0.3, fontFamily: "system-ui, -apple-system, sans-serif" }}>{title}</span>
      {right || <div style={{ width: 60 }} />}
    </div>
  );
};

// ══════════════════════════════════════════════
// SURVEY WATTAGE TABLE (all variants, 10% ballast)
// ══════════════════════════════════════════════
const WATTAGE_TABLE = {
  t8: {
    "Single 4ft": { w:40,  rw:15 }, "Twin 4ft":  { w:79,  rw:25 },
    "Single 5ft": { w:64,  rw:20 }, "Twin 5ft":  { w:128, rw:35 },
    "Single 6ft": { w:77,  rw:20 }, "Twin 6ft":  { w:154, rw:40 },
    "Single 8ft": { w:138, rw:50 },
    // Andrew, 20 October 2026: a twin is double the single, both figures.
    "Twin 8ft":   { w:276, rw:100 },
  },
  t5: {
    "Single 4ft": { w:31, rw:8  }, "Twin 4ft": { w:62, rw:16 },
    "Single 5ft": { w:39, rw:16 }, "Twin 5ft": { w:77, rw:20 },
    "Single 6ft": { w:54, rw:16 },
    // Andrew, 20 October 2026: a twin is double the single, both figures.
    "Twin 6ft":   { w:108, rw:32 },
  },
  panel: {
    "600\u00d7600":   { w:79,  rw:20 }, "1200\u00d7600": { w:119, rw:35 },
    "300\u00d7600":   { w:44,  rw:15 }, "300\u00d71200":  { w:66,  rw:20 },
    "300\u00d71500":  { w:79,  rw:20 }, "Custom":     { w:48,  rw:20 },
  },
  // 600mm, 1800mm and AR111: the existing (w) figures are Andrew's, 20 October
  // 2026 (600mm 28W, 1800mm 80W, AR111 50W). The LED (rw) figures are typical
  // like-for-like replacements in line with the neighbouring rows; wattages vary
  // by product, and a surveyor's typed figure on a custom fitting still wins.
  linear: {
    "600mm":  { w:28, rw:8  },
    "1000mm": { w:55, rw:15 }, "1200mm": { w:66, rw:15 },
    "1500mm": { w:83, rw:20 }, "1800mm": { w:80, rw:25 },
    "Custom": { w:66, rw:18 },
  },
  downlight: {
    "GU10":      { w:55, rw:8  }, "AR111":     { w:50, rw:12 },
    "PL Single": { w:22, rw:6  },
    "PL Twin":   { w:44, rw:12 }, "Custom":    { w:50, rw:10 },
  },
  bulkhead: {
    "Standard": { w:24, rw:10 }, "IP65": { w:24, rw:10 }, "Stainless": { w:24, rw:10 },
  },
  decorative: {
    "Pendant": { w:60, rw:15 }, "Surface": { w:60, rw:15 },
    "Track":   { w:60, rw:15 }, "Feature batten": { w:60, rw:20 },
  },
  flood: {
    "50W equiv":  { w:165, rw:50  }, "100W equiv": { w:330, rw:100 },
    "150W equiv": { w:495, rw:150 }, "Custom":     { w:300, rw:90  },
  },
};

// ==== EVA-H COST_LOGIC_START (R-236, EVA-FOUNDATIONS-V1 track H) ====
// A fitting's cost is a real positive number or it is NULL. There is no default:
// the old `cost || 80` put an invented figure on the portal survey viewer's
// "Unit £" column. A zero, blank, NaN or negative cost is "no cost", not a price.
const costOrNull = (c) => {
  const n = typeof c === 'string' ? parseFloat(c) : c;
  return (typeof n === 'number' && isFinite(n) && n > 0) ? n : null;
};
// Total fitting cost for a set of survey lines ({qty, unit:{unitCost}}). If ANY
// line has no real cost the total is unavailable (null), never a partial sum and
// never 0: a figure built on a missing cost would be a figure we do not have.
const capexOrNull = (lines) => {
  if (!Array.isArray(lines) || lines.length === 0) return null;
  let total = 0;
  for (const z of lines) {
    const c = costOrNull(z && z.unit && z.unit.unitCost);
    if (c === null) return null;
    total += c * ((z && z.qty) || 0);
  }
  return total;
};
// ==== EVA-H COST_LOGIC_END ====

const SURVEY_FIXTURES = [
  { id:"t8",    label:"T8 Batten",  icon:"batten",  cost:85,  variants:{ primary:["Single","Twin"],    secondary:["4ft","5ft","6ft","8ft"] } },
  { id:"t5",    label:"T5 Batten",  icon:"t5",      cost:90,  variants:{ primary:["Single","Twin"],    secondary:["4ft","5ft","6ft"] } },
  // P1 fitting form: a customExtras entry marked sizeAlias asks for the same
  // thing as the Size row's own "Fitting size" box (Andrew typed 130 into both on
  // Downlight, 19 Oct 2026). The form no longer shows it; records that already
  // carry its key still read back (fittingRowDetail) and still go to the portal.
  { id:"panel", label:"Panel",      icon:"panel",   cost:120, variants:{ primary:["600\u00d7600","1200\u00d7600","300\u00d7600","300\u00d71200","300\u00d71500","Custom"] },
    customExtras:[
      { key:"panelW", label:"Width mm",  placeholder:"e.g. 900", type:"text", showIf:"Custom", sizeAlias:true },
      { key:"panelH", label:"Height mm", placeholder:"e.g. 300", type:"text", showIf:"Custom", sizeAlias:true },
    ]
  },
  { id:"linear",    label:"Linear",     icon:"linear",  cost:160, variants:{ primary:["600mm","1000mm","1200mm","1500mm","1800mm","Custom"] },
    customExtras:[
      { key:"linearLen",   label:"Length",   placeholder:"e.g. 2400mm", type:"text",  showIf:"Custom", sizeAlias:true },
      { key:"linearMount", label:"Mounting", placeholder:"",            type:"chips", chips:["Suspended","Recessed","Surface"], showIf:"Custom" },
    ]
  },
  { id:"downlight", label:"Downlight",  icon:"down",    cost:38,  variants:{ primary:["GU10","AR111","PL Single","PL Twin","Custom"] },
    customExtras:[
      { key:"dlCutout", label:"Cutout", type:"chips", chips:["70mm","90mm","95mm","100mm","150mm","Open / No Cutout","Custom"], customLabel:"Cutout size", customPlaceholder:"Type the cutout, e.g. 120mm" },
      { key:"dlCustomW", label:"Custom dimension", placeholder:"e.g. 110mm", type:"text", showIf:"Custom", sizeAlias:true },
    ]
  },
  { id:"bulkhead",  label:"Bulkhead",   icon:"bulk",    cost:55,  variants:{ primary:["Standard","IP65","Stainless"] } },
  { id:"decorative",label:"Decorative", icon:"deco",    cost:200, variants:{ primary:["Pendant","Surface","Track","Feature batten"] } },
  { id:"flood",     label:"Flood",      icon:"flood",     cost:180, variants:{ primary:["50W equiv","100W equiv","150W equiv","Custom"] },
    customExtras:[{ key:"floodW", label:"LED wattage", placeholder:"e.g. 200W", type:"text", showIf:"Custom" }]
  },
  { id:"em",        label:"EM Gear",    icon:"em",        cost:0,   variants:{ primary:["EM Blade","EM Box","Twinspot","EM Downlight","EM Bulkhead","Self-Test Unit","Central Battery"] } },
  { id:"controls",  label:"Controls",   icon:"controls",  cost:0,   variants:{ primary:["DALI2 Driver","Bluetooth Node","PIR Sensor","Microwave Sensor","DALI Dimmer","Scene Controller","BMS Gateway","Daylight Sensor"] } },
  { id:"electrics", label:"Electrics",  icon:"electrics", cost:0,   variants:{ primary:["Twin Socket","Single Socket","Fused Spur","Isolator","Containment","Distribution Board","Other"] } },
];

// S95 D13 — external / IP-rated fixtures (collapsible section under main grid)
const EXTERNAL_FIXTURES = [
  { id:"bollard",      label:"Bollard",      icon:"bollard",   cost:220, category:"external", variants:{ primary:["600mm","900mm","1200mm","Custom"] },
    customExtras:[{ key:"bollardH", label:"Height", placeholder:"e.g. 750mm", type:"text", showIf:"Custom", sizeAlias:true }] },
  { id:"wallpack",     label:"Wall Pack",    icon:"wallpack",  cost:180, category:"external", variants:{ primary:["Compact","Standard","Large"] } },
  { id:"streetlight",  label:"Street Light", icon:"street",    cost:320, category:"external", variants:{ primary:["Post-Top","Bracket-Mount","Floodhead"],  secondary:["4m","6m","8m","10m","12m"] } },
  { id:"ip_bulkhead",  label:"IP Bulkhead",  icon:"ipbulk",    cost:80,  category:"external", variants:{ primary:["IP54","IP65","IP66","Stainless IP65"] } },
];

// ==== P1 FITTING_FORM_LOGIC_START
// Phase 1, faster on site (185 Fleet Street, 19 October 2026). Pure logic for the
// fitting form, kept free of React so tests/fitting_form.test.js can run it.
// The screen only calls these.

// Quick quantities, two rows of seven so every key stays 44px wide. 7 was
// missing; 40 moved to the typed box and the stepper to make room.
const QUICK_QTY_ROWS = [[1, 2, 3, 4, 5, 6, 7], [8, 10, 15, 20, 30, 50, 100]];

// Emergency count: a whole number from 0 up to the quantity, never above it.
// A quantity below 1 (the box is mid-edit) has no room for EM, so 0.
const clampEm = (em, qty) => {
  const q = Math.floor(Number(qty));
  const e = Math.floor(Number(em));
  if (!isFinite(q) || q < 1 || !isFinite(e) || e < 1) return 0;
  return Math.min(e, q);
};
// The All EM control: every fitting in the row is emergency.
const allEmCount = (qty) => clampEm(qty, qty);
// What a typed EM box means. '' is 0; anything that is not a whole number is
// refused (null) so the screen keeps the number it had.
const parseEmInput = (raw, qty) => {
  const s = String(raw == null ? '' : raw).trim();
  if (s === '') return 0;
  if (!/^\d+$/.test(s)) return null;
  return clampEm(parseInt(s, 10), qty);
};

// Wattages for a size. Exact key ("Single 4ft"), else the size alone, else
// unknown (0 and 0). It used to fall back to the table's first row, so a size
// with no figure (AR111, 600mm and 1800mm, before Andrew's figures of
// 20 October 2026) silently took another size's wattage.
const lookupWattages = (table, fixtureId, primary, secondary) => {
  const none = { existingW: 0, ledW: 0 };
  const tbl = table && table[fixtureId];
  if (!tbl) return none;
  const keys = [];
  if (primary && secondary) keys.push(primary + ' ' + secondary);
  if (primary) keys.push(primary);
  for (const k of keys) {
    if (Object.prototype.hasOwnProperty.call(tbl, k) && tbl[k]) return { existingW: tbl[k].w, ledW: tbl[k].rw };
  }
  return none;
};

// What the form remembers of the last fitting of a type: size, typed size,
// the type's own options (cutout, mounting, wattage). Not quantity, EM,
// description, sensor or dimming: those belong to the one fitting.
const REMEMBER_DROP = ['sensor', 'dim', 'description', 'customSize'];
const choicesFromEntry = (entry, fixture) => {
  if (!entry || !fixture) return null;
  const ex = { ...(entry.extras || {}) };
  const typed = typeof ex.customSize === 'string' ? ex.customSize : '';
  REMEMBER_DROP.forEach(k => { delete ex[k]; });
  const chipCustom = {};
  (fixture.customExtras || []).forEach(cx => {
    if (cx.type === 'chips' && (cx.chips || []).indexOf('Custom') > -1) {
      const v = ex[cx.key];
      if (v && cx.chips.indexOf(v) === -1) { chipCustom[cx.key] = v; ex[cx.key] = 'Custom'; }
    }
  });
  return {
    primary: typed ? 'Custom' : (entry.primary || null),
    secondary: entry.secondary || null,
    sizeCustom: typed,
    extras: ex,
    chipCustom,
  };
};
// Where a form opens: the first size of the type, unless there is a remembered
// choice that is still on offer. Each remembered value is checked against the
// type's own lists, so a stale value falls back to the default rather than
// opening on something the form cannot show.
const startingChoices = (fixture, remembered) => {
  const variants = (fixture && fixture.variants) || {};
  const prim = variants.primary || [];
  const sec = variants.secondary || [];
  const start = { primary: prim[0] || null, secondary: sec[0] || null, sizeCustom: '', extras: {}, chipCustom: {}, remembered: false };
  if (!fixture || !remembered) return start;
  const out = { ...start };
  const canCustom = prim.length > 0;
  if (remembered.primary && (prim.indexOf(remembered.primary) > -1 || (remembered.primary === 'Custom' && canCustom))) {
    out.primary = remembered.primary;
    out.remembered = true;
  }
  if (remembered.secondary && sec.indexOf(remembered.secondary) > -1) out.secondary = remembered.secondary;
  if (out.primary === 'Custom' && typeof remembered.sizeCustom === 'string') out.sizeCustom = remembered.sizeCustom;
  (fixture.customExtras || []).forEach(cx => {
    if (cx.showIf && cx.showIf !== out.primary) return;
    // A hidden size alias (an old record's linearLen, panelW...) is never
    // carried into a new fitting: the size now lives in "Fitting size", and a
    // carried hidden value would put two sizes in one label (review round 1, N2).
    if (cx.sizeAlias) return;
    const v = remembered.extras ? remembered.extras[cx.key] : undefined;
    if (v === undefined || v === null || v === '') return;
    if (cx.type === 'chips') {
      if ((cx.chips || []).indexOf(v) === -1) return;
      out.extras[cx.key] = v;
      if (v === 'Custom' && remembered.chipCustom && remembered.chipCustom[cx.key]) out.chipCustom[cx.key] = remembered.chipCustom[cx.key];
    } else if (typeof v === 'string') {
      out.extras[cx.key] = v;
    }
  });
  return out;
};
// The memory is keyed by area then fixture id. rememberChoice returns a new
// object; rememberedFor reads it, and falls back to the last entry of that type
// already on the area (so a reopened survey also starts from what is there).
const rememberChoice = (memory, areaKey, fixtureId, choices) => ({
  ...(memory || {}),
  [areaKey]: { ...((memory && memory[areaKey]) || {}), [fixtureId]: choices },
});
const rememberedFor = (memory, areaKey, entries, fixtureId, fixture) => {
  const m = memory && memory[areaKey] && memory[areaKey][fixtureId];
  if (m) return m;
  const same = (entries || []).filter(e => e && e.fixtureId === fixtureId);
  return same.length ? choicesFromEntry(same[same.length - 1], fixture) : null;
};

// What a fitting row says besides its type: the real size or length (a typed
// custom one included), then the type's own options, e.g. "1800mm" or
// "130mm, cutout 120mm". sep joins a size to its length (the screen passes its
// own separator). The portal label (buildVarLabel) is not touched.
const fittingRowDetail = (entry, sep) => {
  if (!entry) return '';
  const ex = entry.extras || {};
  const t = (v) => (typeof v === 'string' || typeof v === 'number') ? String(v).trim() : '';
  const same = (a, b) => a.replace(/\s+/g, '').toLowerCase() === b.replace(/\s+/g, '').toLowerCase();
  const typed = t(ex.customSize);
  const w = t(ex.panelW), h = t(ex.panelH);
  const alias = t(ex.linearLen) || t(ex.dlCustomW) || t(ex.bollardH) || (w && h ? w + ' × ' + h : (w || h));
  const details = [];
  let size;
  if (typed) {
    size = typed;
    if (alias && !same(alias, typed)) details.push(alias);
  } else if (entry.primary === 'Custom' && alias) {
    size = alias;
  } else {
    size = [entry.primary, entry.secondary].filter(Boolean).join(sep == null ? ' ' : sep);
  }
  const cut = t(ex.dlCutout);
  if (cut) details.push(cut === 'Custom' ? 'cutout size not typed' : (/^open/i.test(cut) ? 'no cutout' : 'cutout ' + cut));
  const mount = t(ex.linearMount);
  if (mount) details.push(mount.toLowerCase());
  const flood = t(ex.floodW);
  if (flood) details.push('LED ' + flood);
  return [size].concat(details).filter(Boolean).join(', ');
};
// What the photo's count control shows. Nothing is counted unless the surveyor
// asks: 'offer' only offers. A scan already running, failed or finished is
// always shown, whatever the job's setting; 'off' leaves one quiet way back.
const scanOfferView = (s) => {
  if (s && s.busy) return 'busy';
  if (s && s.scanErr) return 'error';
  if (s && s.scanned) return 'results';
  return s && s.off ? 'off' : 'offer';
};

// Sticky Log bar (fix/p1b-sheet-polish, 20 Oct 2026). The bar says what the
// tap will log: "Log 18 × Downlight 130mm", plus " + 2 EM" when some are
// emergency. size is the size as the surveyor sees it (a typed one included);
// with no size the label is the quantity and type alone. A quantity below 1
// (the box is mid-edit) leaves the count out rather than printing 0.
const logButtonLabel = (o) => {
  const q = Math.floor(Number(o && o.qty));
  const type = String((o && o.fixtureLabel) || '').trim();
  const size = String((o && o.size) || '').trim();
  const em = clampEm(o && o.emQty, o && o.qty);
  const parts = [(o && o.editing) ? 'Update' : 'Log'];
  if (isFinite(q) && q >= 1) parts.push(q + ' ×');
  parts.push(type);
  let s = parts.filter(Boolean).join(' ');
  if (size) s += ' ' + size;
  if (em > 0) s += ' + ' + em + ' EM';
  return s;
};
// "More options" holds Sensor and Dimming. A selection other than None counts
// as set, so the disclosure opens by itself and nothing set is ever hidden
// silently. sel: { sensorSel, sensorCustom, dimSel, dimCustom }.
const moreOptionsValues = (sel) => {
  const s = sel || {};
  const one = (choice, custom) => {
    if (!choice || choice === 'None') return '';
    if (choice === 'Custom') return String(custom || '').trim() || 'Custom';
    return choice;
  };
  return [one(s.sensorSel, s.sensorCustom), one(s.dimSel, s.dimCustom)].filter(Boolean);
};
const moreOptionsHasValue = (sel) => moreOptionsValues(sel).length > 0;
// userOpen is null until the surveyor taps the disclosure; then their choice
// wins. Until then it opens itself when something is set.
const moreOptionsIsOpen = (userOpen, sel) => (userOpen === null || userOpen === undefined) ? moreOptionsHasValue(sel) : !!userOpen;
// Typed values are held per field and stay when another size chip is tapped,
// so Custom, another size, Custom again finds the typed size where it was.
// Only what the chosen size shows is saved: a custom size only under Custom,
// and a field that shows only under Custom (showIf) only when Custom is chosen.
const typedSizeToSave = (primary, typed) => (primary === 'Custom' && typeof typed === 'string') ? typed.trim() : '';
const dropHiddenExtras = (fixture, primary, extras) => {
  const out = { ...(extras || {}) };
  ((fixture && fixture.customExtras) || []).forEach(cx => {
    if (cx.showIf && cx.showIf !== primary) delete out[cx.key];
  });
  return out;
};
// ==== P1 FITTING_FORM_LOGIC_END

const FIXTURE_ICONS = {
  batten:<svg width="26" height="26" viewBox="0 0 26 26" fill="none"><rect x="3" y="10" width="20" height="6" rx="2.5" stroke="currentColor" strokeWidth="1.3"/><line x1="7" y1="10" x2="7" y2="8" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round"/><line x1="13" y1="10" x2="13" y2="7" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round"/><line x1="19" y1="10" x2="19" y2="8" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round"/></svg>,
  t5:      <svg width="26" height="26" viewBox="0 0 26 26" fill="none"><rect x="6" y="11" width="14" height="4.5" rx="2" stroke="currentColor" strokeWidth="1.3"/><line x1="9" y1="11" x2="9" y2="8.5" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round"/><line x1="17" y1="11" x2="17" y2="8.5" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round"/></svg>,
  panel:   <svg width="26" height="26" viewBox="0 0 26 26" fill="none"><rect x="4" y="4" width="18" height="18" rx="3" stroke="currentColor" strokeWidth="1.3"/><line x1="4" y1="13" x2="22" y2="13" stroke="currentColor" strokeWidth=".7" opacity=".35"/><line x1="13" y1="4" x2="13" y2="22" stroke="currentColor" strokeWidth=".7" opacity=".35"/></svg>,
  linear:  <svg width="26" height="26" viewBox="0 0 26 26" fill="none"><rect x="2" y="11" width="22" height="4" rx="1.5" stroke="currentColor" strokeWidth="1.3"/><line x1="5" y1="11" x2="5" y2="8" stroke="currentColor" strokeWidth="1" strokeLinecap="round"/><line x1="13" y1="11" x2="13" y2="7" stroke="currentColor" strokeWidth="1" strokeLinecap="round"/><line x1="21" y1="11" x2="21" y2="8" stroke="currentColor" strokeWidth="1" strokeLinecap="round"/></svg>,
  down:    <svg width="26" height="26" viewBox="0 0 26 26" fill="none"><path d="M7.5 9Q13 6.5 18.5 9L17 15Q13 17 9 15Z" stroke="currentColor" strokeWidth="1.3" fill="none"/><path d="M9 15Q13 21 17 15" stroke="currentColor" strokeWidth=".8" strokeDasharray="1.5 1.5" opacity=".45"/></svg>,
  bulk:    <svg width="26" height="26" viewBox="0 0 26 26" fill="none"><rect x="4" y="8" width="18" height="11" rx="4" stroke="currentColor" strokeWidth="1.3"/><circle cx="13" cy="13.5" r="3" stroke="currentColor" strokeWidth="1" opacity=".6"/></svg>,
  deco:    <svg width="26" height="26" viewBox="0 0 26 26" fill="none"><line x1="13" y1="2" x2="13" y2="7" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/><circle cx="13" cy="12" r="5" stroke="currentColor" strokeWidth="1.3"/><path d="M9 16Q13 21 17 16" stroke="currentColor" strokeWidth=".8" strokeDasharray="1.5 1.5" opacity=".4"/></svg>,
  flood:   <svg width="26" height="26" viewBox="0 0 26 26" fill="none"><path d="M5 7L13 4.5L21 7L21 14.5L13 17L5 14.5Z" stroke="currentColor" strokeWidth="1.3" fill="none"/><line x1="13" y1="17" x2="13" y2="22" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/></svg>,
  em:      <svg width="26" height="26" viewBox="0 0 26 26" fill="none"><rect x="3" y="8" width="20" height="10" rx="2" stroke="currentColor" strokeWidth="1.3"/><path d="M8 8V6M13 8V5M18 8V6" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round"/><circle cx="13" cy="13" r="2.5" stroke="currentColor" strokeWidth="1" opacity=".7"/><line x1="7" y1="13" x2="9" y2="13" stroke="currentColor" strokeWidth="1" strokeLinecap="round" opacity=".5"/><line x1="17" y1="13" x2="19" y2="13" stroke="currentColor" strokeWidth="1" strokeLinecap="round" opacity=".5"/></svg>,
  controls:<svg width="26" height="26" viewBox="0 0 26 26" fill="none"><circle cx="8" cy="9" r="2.5" stroke="currentColor" strokeWidth="1.2"/><circle cx="18" cy="17" r="2.5" stroke="currentColor" strokeWidth="1.2"/><line x1="3" y1="9" x2="5.5" y2="9" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/><line x1="10.5" y1="9" x2="23" y2="9" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/><line x1="3" y1="17" x2="15.5" y2="17" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/><line x1="20.5" y1="17" x2="23" y2="17" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/></svg>,
  electrics:<svg width="26" height="26" viewBox="0 0 26 26" fill="none"><rect x="4" y="5" width="18" height="16" rx="2.5" stroke="currentColor" strokeWidth="1.3"/><rect x="8" y="9" width="4" height="3" rx="1" stroke="currentColor" strokeWidth="1"/><rect x="14" y="9" width="4" height="3" rx="1" stroke="currentColor" strokeWidth="1"/><line x1="13" y1="14" x2="13" y2="17" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" opacity=".5"/></svg>,
  plus:    <svg width="26" height="26" viewBox="0 0 26 26" fill="none"><line x1="13" y1="5" x2="13" y2="21" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><line x1="5" y1="13" x2="21" y2="13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>,
  // S95 D13 external icons
  bollard: <svg width="26" height="26" viewBox="0 0 26 26" fill="none"><rect x="10" y="4" width="6" height="18" rx="1.5" stroke="currentColor" strokeWidth="1.3"/><line x1="10" y1="9" x2="16" y2="9" stroke="currentColor" strokeWidth="1" opacity=".55"/><line x1="10" y1="15" x2="16" y2="15" stroke="currentColor" strokeWidth="1" opacity=".55"/><line x1="8" y1="22" x2="18" y2="22" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/></svg>,
  wallpack:<svg width="26" height="26" viewBox="0 0 26 26" fill="none"><path d="M6 6 H20 V14 Q13 19 6 14 Z" stroke="currentColor" strokeWidth="1.3" fill="none"/><line x1="6" y1="6" x2="6" y2="20" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/><path d="M9 15Q13 18 17 15" stroke="currentColor" strokeWidth=".9" strokeDasharray="1.5 1.5" opacity=".45"/></svg>,
  street:  <svg width="26" height="26" viewBox="0 0 26 26" fill="none"><line x1="7" y1="3" x2="7" y2="22" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/><path d="M7 5 H17 Q20 6 20 9" stroke="currentColor" strokeWidth="1.3" fill="none" strokeLinecap="round"/><rect x="17" y="9" width="6" height="3" rx="1" stroke="currentColor" strokeWidth="1.2"/><path d="M17 12 Q20 15 23 12" stroke="currentColor" strokeWidth=".8" strokeDasharray="1.3 1.3" opacity=".45"/></svg>,
  ipbulk:  <svg width="26" height="26" viewBox="0 0 26 26" fill="none"><rect x="4" y="8" width="18" height="11" rx="4" stroke="currentColor" strokeWidth="1.3"/><circle cx="13" cy="13.5" r="3" stroke="currentColor" strokeWidth="1" opacity=".6"/><text x="13" y="6" textAnchor="middle" fontSize="5.5" fontWeight="700" fill="currentColor" opacity=".75">IP65</text></svg>,
};

// ── Initial project data (replaced by state in main app) ──
const INITIAL_PROJECTS = [];

// ── Division configuration ─────────────────────────
// All division-specific content lives here.
// Screens pull from the active user's division config.
const DIVISION_CONFIG = {
  lighting: {
    id: "lighting",
    label: "Lighting",
    accentColor: "#C8A96E", // gold
    surveyTitle: "Lighting Survey",
    unitLabel: "fixtures",
    unitLabelSingular: "fixture",
    roiMetric1Label: "Saving/yr",
    roiMetric2Label: "Payback",
    roiMetric3Label: "CO₂/yr",
    // Unit types for Live Survey
    unitTypes: [
      { id: "t8-4ft",       label: "T8 Batten",    name: "4ft T8 Fluorescent",       wattage: 58,  replacementW: 22, unitCost: 85,  savingBasis: "energy" },
      { id: "t8-2ft",       label: "T8 Short",     name: "2ft T8 Fluorescent",       wattage: 36,  replacementW: 12, unitCost: 65,  savingBasis: "energy" },
      { id: "par38",        label: "PAR38",        name: "PAR38 Halogen",            wattage: 75,  replacementW: 12, unitCost: 45,  savingBasis: "energy" },
      { id: "gu10",         label: "GU10 Hal.",    name: "GU10 Halogen Downlight",   wattage: 50,  replacementW: 7,  unitCost: 35,  savingBasis: "energy" },
      { id: "panel-old",    label: "600 Panel",    name: "600×600 Panel (Old)",      wattage: 48,  replacementW: 36, unitCost: 120, savingBasis: "energy" },
      { id: "surface-old",  label: "Surface",      name: "Surface Mount Fitting",    wattage: 40,  replacementW: 18, unitCost: 75,  savingBasis: "energy" },
      { id: "emergency",    label: "Emergency",    name: "Emergency Bulkhead",       wattage: 8,   replacementW: 5,  unitCost: 95,  savingBasis: "energy" },
      { id: "exterior",     label: "Floodlight",   name: "Exterior Floodlight",      wattage: 150, replacementW: 50, unitCost: 180, savingBasis: "energy" },
    ],
    zones: ["Reception", "Open Plan A", "Open Plan B", "Meeting Rooms", "Corridors", "Stairwells", "WCs", "Server Room", "Plant Room"],
    // Scope capture question variants
    driverOptions: ["MEES / EPC compliance", "Energy cost reduction", "Planned refit / remodel", "Fault / end of life", "Client experience upgrade"],
    timelineOptions: ["Urgent — within 3 months", "Q2 2026", "Q3/Q4 2026", "2027 MEES deadline", "Flexible"],
    outcomeOptions: ["Lowest cost solution", "Best energy saving %", "Minimal disruption", "Turnkey — design to install", "Ongoing maintenance contract"],
    // New Enquiry driver chips
    enquiryDrivers: ["MEES / EPC compliance", "Energy cost reduction", "Planned refit", "Fault / end of life", "New build", "Unknown"],
    // Proposal tiers
    proposalTiers: [
      { name: "Value",    label: "Value Engineering", desc: "Like-for-like LED replacement. Maximum energy saving at lowest CAPEX. Proven brands, no controls.", capex: 24800, saving: 18200, payback: 1.4, co2: 4200, products: ["QVIS LED Panels", "Ansell Emergency", "JCC Downlights"] },
      { name: "Standard", label: "Standard LED",      desc: "LED upgrade with 3yr warranty. Improved lux levels, dimming capability. Mid-tier specification.", capex: 38500, saving: 21400, payback: 1.8, co2: 4900, products: ["Thorn LED Panels", "Ansell Emergency", "Bell GU10", "Hubsense Dimming"] },
      { name: "Premium",  label: "Premium + Controls",desc: "Full DALI controls, tunable white, presence detection. Maximum EPC uplift. Full turnkey delivery.", capex: 62000, saving: 26800, payback: 2.3, co2: 6100, products: ["Thorn/LightForms", "DALI Controls", "Presence Detection", "5yr Warranty"] },
    ],
    // ROI calculation — energy saving based on wattage reduction
    calcROI: (units) => {
      const totalOldW = units.reduce((s, z) => s + (z.unit.wattage * z.qty), 0);
      const totalNewW = units.reduce((s, z) => s + (z.unit.replacementW * z.qty), 0);
      const annualSaving = ((totalOldW - totalNewW) / 1000) * 8 * 365 * 0.28;
      const capex = capexOrNull(units);
      const co2 = ((totalOldW - totalNewW) / 1000) * 8 * 365 * 0.233;
      const payback = capex > 0 && annualSaving > 0 ? (capex / annualSaving).toFixed(1) : "—";
      return { annualSaving, capex, co2, payback };
    },
    calcLineSaving: (unit, qty) => ((unit.wattage - unit.replacementW) * qty / 1000) * 8 * 365 * 0.28,
    lineDetail: (unit, qty) => `${qty}× ${unit.label} · ${unit.wattage}W → ${unit.replacementW}W`,
  },

  aircon: {
    id: "aircon",
    label: "Mechanical",
    accentColor: "#5B9BD5", // blue
    surveyTitle: "Mechanical Survey",
    unitLabel: "units",
    unitLabelSingular: "unit",
    roiMetric1Label: "Saving/yr",
    roiMetric2Label: "Payback",
    roiMetric3Label: "Capacity",
    unitTypes: [
      { id: "chiller",      label: "Chiller",      name: "Chiller Replacement",      wattage: 8000,  replacementW: 5200, unitCost: 18000, savingBasis: "energy" },
      { id: "ahu",          label: "AHU",          name: "Air Handling Unit",        wattage: 3500,  replacementW: 2100, unitCost: 12000, savingBasis: "energy" },
      { id: "vrv",          label: "VRV System",   name: "VRV / VRF System",         wattage: 4200,  replacementW: 2800, unitCost: 22000, savingBasis: "energy" },
      { id: "fancoil",      label: "Fan Coil",     name: "Fan Coil Unit",            wattage: 120,   replacementW: 75,   unitCost: 2300,  savingBasis: "energy" },
      { id: "ahu-upgrade",  label: "AHU Upgrade",  name: "AHU Upgrade / Refurb",     wattage: 3500,  replacementW: 2400, unitCost: 8500,  savingBasis: "energy" },
      { id: "ashp",         label: "ASHP",         name: "Air Source Heat Pump",     wattage: 2200,  replacementW: 600,  unitCost: 14000, savingBasis: "energy" },
      { id: "splitac",      label: "Split AC",     name: "Split Mechanicalditioning",   wattage: 900,   replacementW: 550,  unitCost: 2800,  savingBasis: "energy" },
      { id: "boiler",       label: "Boiler",       name: "Boiler Upgrade",           wattage: 0,     replacementW: 0,    unitCost: 9500,  savingBasis: "maintenance", maintenanceSaving: 3200 },
    ],
    zones: ["Plant Room", "Roof", "Server Room", "Reception", "Open Plan A", "Open Plan B", "Meeting Rooms", "Corridors", "Basement"],
    driverOptions: ["F-Gas refrigerant phase-out", "Energy cost reduction", "Planned replacement cycle", "Breakdown / end of life", "Comfort complaints", "EPC improvement"],
    timelineOptions: ["Urgent — within 3 months", "Q2 2026", "Q3/Q4 2026", "Pre-winter 2026", "Flexible"],
    outcomeOptions: ["Lowest cost replacement", "Best energy saving %", "Minimal downtime", "Turnkey — design to install", "Ongoing maintenance contract"],
    enquiryDrivers: ["F-Gas phase-out", "Energy cost reduction", "Planned replacement", "Breakdown / EoL", "Comfort complaints", "Unknown"],
    proposalTiers: [
      { name: "Value",    label: "Direct Replacement", desc: "Like-for-like unit replacement. Minimal disruption, fastest delivery. Same capacity, modern efficiency.", capex: 38000, saving: 12400, payback: 3.1, co2: 5800, products: ["Daikin VRV IV", "Standard Controls", "2yr Warranty"] },
      { name: "Standard", label: "Efficiency Upgrade",  desc: "Higher EER-rated replacement with BMS integration. Improved seasonal performance and monitoring.", capex: 56000, saving: 18600, payback: 3.0, co2: 8700, products: ["Mitsubishi City Multi", "BMS Integration", "Remote Monitoring", "3yr Warranty"] },
      { name: "Premium",  label: "Full Mechanical Overhaul",   desc: "Full system redesign with heat recovery, zoning, and smart controls. Maximum EPC uplift and future-proofing.", capex: 94000, saving: 28000, payback: 3.4, co2: 13200, products: ["Daikin Applied", "Heat Recovery", "Full BMS", "Smart Zoning", "5yr Warranty"] },
    ],
    calcROI: (units) => {
      const annualSaving = units.reduce((s, z) => {
        if (z.unit.savingBasis === "maintenance") return s + (z.unit.maintenanceSaving * z.qty);
        const wSaved = (z.unit.wattage - z.unit.replacementW) * z.qty;
        return s + (wSaved / 1000) * 8 * 365 * 0.28;
      }, 0);
      const capex = capexOrNull(units);
      const co2 = units.reduce((s, z) => {
        if (z.unit.savingBasis === "maintenance") return s;
        return s + ((z.unit.wattage - z.unit.replacementW) * z.qty / 1000) * 8 * 365 * 0.233;
      }, 0);
      const payback = capex > 0 && annualSaving > 0 ? (capex / annualSaving).toFixed(1) : "—";
      return { annualSaving, capex, co2, payback };
    },
    calcLineSaving: (unit, qty) => {
      if (unit.savingBasis === "maintenance") return unit.maintenanceSaving * qty;
      return ((unit.wattage - unit.replacementW) * qty / 1000) * 8 * 365 * 0.28;
    },
    lineDetail: (unit, qty) => {
      if (unit.savingBasis === "maintenance") return `${qty}× ${unit.label} · Maintenance saving`;
      return `${qty}× ${unit.label} · ${(unit.wattage/1000).toFixed(1)}kW → ${(unit.replacementW/1000).toFixed(1)}kW`;
    },
  },
};

// Helper — get division config for a user (defaults to lighting)
// Respects _forcedDiv localStorage override for testing Mechanical / Director views
const getDivisionConfig = (user) => {
  if (!user) return DIVISION_CONFIG.lighting;
  try {
    const forced = localStorage.getItem('_forcedDiv');
    if (forced === 'aircon') return DIVISION_CONFIG.aircon || DIVISION_CONFIG.me || DIVISION_CONFIG.lighting;
    // 'director' keeps own division but App checks _forcedDiv separately for director routing
  } catch(e) {}
  return DIVISION_CONFIG[user.division] || DIVISION_CONFIG.lighting;
};

// Fixture type constants — single source of truth for all fixture surfaces
const FIXTURE_TYPES_GRID = [
  {
    id: 't8_batten', label: 'T8 Batten', color: '#5870B0',
    gradient: 'linear-gradient(145deg, rgba(88,112,176,0.22) 0%, rgba(88,112,176,0.06) 100%)',
    border: 'rgba(88,112,176,0.28)',
    svgPath: `<rect x="2" y="4" width="24" height="6" rx="3" stroke="COLOR" stroke-width="1.8" fill="rgba(88,112,176,0.12)"/><rect x="2" y="14" width="24" height="6" rx="3" stroke="COLOR" stroke-width="1.8" fill="rgba(88,112,176,0.12)"/><rect x="2" y="4" width="2.5" height="16" rx="1" fill="COLOR" opacity="0.35"/><rect x="23.5" y="4" width="2.5" height="16" rx="1" fill="COLOR" opacity="0.35"/>`,
    vb: '0 0 28 24',
  },
  {
    id: 't5_batten', label: 'T5 Batten', color: '#48987A',
    gradient: 'linear-gradient(145deg, rgba(72,152,122,0.22) 0%, rgba(72,152,122,0.06) 100%)',
    border: 'rgba(72,152,122,0.28)',
    svgPath: `<rect x="2" y="9" width="24" height="5" rx="2.5" stroke="COLOR" stroke-width="1.8" fill="rgba(72,152,122,0.12)"/><rect x="2" y="9" width="2.5" height="5" rx="1" fill="COLOR" opacity="0.35"/><rect x="23.5" y="9" width="2.5" height="5" rx="1" fill="COLOR" opacity="0.35"/><line x1="5" y1="7" x2="23" y2="7" stroke="COLOR" stroke-width="1" stroke-dasharray="2,2" opacity="0.4"/><line x1="5" y1="17" x2="23" y2="17" stroke="COLOR" stroke-width="1" stroke-dasharray="2,2" opacity="0.4"/>`,
    vb: '0 0 28 24',
  },
  {
    id: 'panel', label: 'Panel', color: '#987840',
    gradient: 'linear-gradient(145deg, rgba(152,120,64,0.22) 0%, rgba(152,120,64,0.06) 100%)',
    border: 'rgba(152,120,64,0.28)',
    svgPath: `<rect x="2" y="2" width="22" height="22" rx="3" stroke="COLOR" stroke-width="1.8" fill="rgba(152,120,64,0.08)"/><line x1="9" y1="2" x2="9" y2="24" stroke="COLOR" stroke-width="1" opacity="0.45"/><line x1="17" y1="2" x2="17" y2="24" stroke="COLOR" stroke-width="1" opacity="0.45"/><line x1="2" y1="9" x2="24" y2="9" stroke="COLOR" stroke-width="1" opacity="0.45"/><line x1="2" y1="17" x2="24" y2="17" stroke="COLOR" stroke-width="1" opacity="0.45"/><circle cx="5.5" cy="5.5" r="1" fill="COLOR" opacity="0.5"/><circle cx="13" cy="5.5" r="1" fill="COLOR" opacity="0.5"/><circle cx="20.5" cy="5.5" r="1" fill="COLOR" opacity="0.5"/><circle cx="5.5" cy="13" r="1" fill="COLOR" opacity="0.5"/><circle cx="13" cy="13" r="1.4" fill="COLOR" opacity="0.7"/><circle cx="20.5" cy="13" r="1" fill="COLOR" opacity="0.5"/><circle cx="5.5" cy="20.5" r="1" fill="COLOR" opacity="0.5"/><circle cx="13" cy="20.5" r="1" fill="COLOR" opacity="0.5"/><circle cx="20.5" cy="20.5" r="1" fill="COLOR" opacity="0.5"/>`,
    vb: '0 0 26 26',
  },
  {
    id: 'linear', label: 'Linear', color: '#885AA0',
    gradient: 'linear-gradient(145deg, rgba(136,90,160,0.22) 0%, rgba(136,90,160,0.06) 100%)',
    border: 'rgba(136,90,160,0.28)',
    svgPath: `<rect x="3" y="10" width="22" height="4" rx="1" fill="rgba(136,90,160,0.15)" stroke="COLOR" stroke-width="1.5"/><circle cx="8" cy="12" r="1.2" fill="COLOR"/><circle cx="12" cy="12" r="1.2" fill="COLOR"/><circle cx="16" cy="12" r="1.2" fill="COLOR"/><circle cx="20" cy="12" r="1.2" fill="COLOR"/><path d="M3 8v8" stroke="COLOR" stroke-width="2" stroke-linecap="round"/><path d="M25 8v8" stroke="COLOR" stroke-width="2" stroke-linecap="round"/>`,
    vb: '0 0 28 24',
  },
  {
    id: 'downlight', label: 'Downlight', color: '#4E8BC4',
    gradient: 'linear-gradient(145deg, rgba(78,139,196,0.22) 0%, rgba(78,139,196,0.06) 100%)',
    border: 'rgba(78,139,196,0.28)',
    svgPath: `<circle cx="13" cy="13" r="11" stroke="COLOR" stroke-width="1.8" fill="rgba(78,139,196,0.08)"/><circle cx="13" cy="13" r="6" stroke="COLOR" stroke-width="1.5" fill="rgba(78,139,196,0.12)"/><circle cx="13" cy="13" r="2.5" fill="COLOR"/><line x1="1" y1="13" x2="4" y2="13" stroke="COLOR" stroke-width="1.2" opacity="0.35"/><line x1="22" y1="13" x2="25" y2="13" stroke="COLOR" stroke-width="1.2" opacity="0.35"/>`,
    vb: '0 0 26 26',
  },
  {
    id: 'bulkhead', label: 'Bulkhead', color: '#7A6BBE',
    gradient: 'linear-gradient(145deg, rgba(122,107,190,0.22) 0%, rgba(122,107,190,0.06) 100%)',
    border: 'rgba(122,107,190,0.28)',
    svgPath: `<rect x="2" y="18" width="22" height="4" rx="2" stroke="COLOR" stroke-width="1.5" fill="rgba(122,107,190,0.12)"/><path d="M5 18 Q5 6 13 6 Q21 6 21 18" stroke="COLOR" stroke-width="1.8" fill="rgba(122,107,190,0.1)"/><circle cx="13" cy="14" r="2.5" fill="COLOR" opacity="0.7"/>`,
    vb: '0 0 26 26',
  },
  {
    id: 'decorative', label: 'Decorative', color: '#B8685A',
    gradient: 'linear-gradient(145deg, rgba(184,104,90,0.22) 0%, rgba(184,104,90,0.06) 100%)',
    border: 'rgba(184,104,90,0.28)',
    svgPath: `<line x1="13" y1="2" x2="13" y2="8" stroke="COLOR" stroke-width="1.8" stroke-linecap="round"/><rect x="9" y="2" width="8" height="2.5" rx="1.2" fill="COLOR" opacity="0.5"/><path d="M7 8 Q6 16 5 20 h16 Q20 16 19 8 Z" stroke="COLOR" stroke-width="1.5" fill="rgba(184,104,90,0.12)"/><ellipse cx="13" cy="20" rx="8" ry="2" stroke="COLOR" stroke-width="1.2" fill="rgba(184,104,90,0.1)"/>`,
    vb: '0 0 26 26',
  },
  {
    id: 'flood', label: 'Flood', color: '#5E9E4A',
    gradient: 'linear-gradient(145deg, rgba(94,158,74,0.22) 0%, rgba(94,158,74,0.06) 100%)',
    border: 'rgba(94,158,74,0.28)',
    svgPath: `<rect x="10" y="6" width="10" height="8" rx="2" stroke="COLOR" stroke-width="1.8" fill="rgba(94,158,74,0.12)"/><path d="M15 2v4" stroke="COLOR" stroke-width="1.8" stroke-linecap="round"/><path d="M11 2h8" stroke="COLOR" stroke-width="1.5" stroke-linecap="round"/><path d="M10 10 L3 22" stroke="COLOR" stroke-width="1.2" opacity="0.5" stroke-linecap="round"/><path d="M20 10 L25 22" stroke="COLOR" stroke-width="1.2" opacity="0.5" stroke-linecap="round"/><path d="M3 22 h22" stroke="COLOR" stroke-width="1" stroke-dasharray="2,2" opacity="0.4"/>`,
    vb: '0 0 28 26',
  },
  {
    id: 'em_gear', label: 'EM Gear', color: '#2E8848',
    gradient: 'linear-gradient(145deg, rgba(46,136,72,0.22) 0%, rgba(46,136,72,0.06) 100%)',
    border: 'rgba(46,136,72,0.3)',
    svgPath: `<rect x="2" y="2" width="22" height="22" rx="5" stroke="COLOR" stroke-width="1.8" fill="rgba(46,136,72,0.1)"/><rect x="10" y="5" width="6" height="16" rx="3" fill="COLOR"/><rect x="5" y="10" width="16" height="6" rx="3" fill="COLOR"/>`,
    vb: '0 0 26 26',
  },
  {
    id: 'controls', label: 'Controls', color: '#3A8CA8',
    gradient: 'linear-gradient(145deg, rgba(58,140,168,0.22) 0%, rgba(58,140,168,0.06) 100%)',
    border: 'rgba(58,140,168,0.28)',
    svgPath: `<circle cx="13" cy="19" r="2.5" fill="COLOR"/><path d="M8 15 Q13 9 18 15" stroke="COLOR" stroke-width="1.8" stroke-linecap="round" fill="none"/><path d="M5 11.5 Q13 3 21 11.5" stroke="COLOR" stroke-width="1.5" stroke-linecap="round" fill="none" opacity="0.55"/>`,
    vb: '0 0 26 26',
  },
  {
    id: 'electrics', label: 'Electrics', color: '#C8983A',
    gradient: 'linear-gradient(145deg, rgba(200,152,58,0.22) 0%, rgba(200,152,58,0.06) 100%)',
    border: 'rgba(200,152,58,0.28)',
    svgPath: `<path d="M15 2 L6 15 h7 L9 24 L20 11 h-7 Z" stroke="COLOR" stroke-width="1.5" stroke-linejoin="round" fill="rgba(200,152,58,0.18)"/>`,
    vb: '0 0 26 26',
  },
  {
    id: 'custom', label: 'Custom', color: '#788A9A',
    gradient: 'linear-gradient(145deg, rgba(120,138,154,0.22) 0%, rgba(120,138,154,0.06) 100%)',
    border: 'rgba(120,138,154,0.22)',
    svgPath: `<circle cx="13" cy="13" r="11" stroke="COLOR" stroke-width="1.8" fill="rgba(120,138,154,0.08)" stroke-dasharray="3,2"/><path d="M13 8v10M8 13h10" stroke="COLOR" stroke-width="2" stroke-linecap="round"/>`,
    vb: '0 0 26 26',
  },
];

// Helper — renders fixture icon as JSX-safe dangerouslySetInnerHTML
const fixtureIcon = (type, size = 26) => ({
  __html: `<svg width="${size}" height="${size}" viewBox="${type.vb}" fill="none">${type.svgPath.replace(/COLOR/g, type.color)}</svg>`
});
const FIXTURE_TYPES = DIVISION_CONFIG.lighting.unitTypes;
const ZONES = DIVISION_CONFIG.lighting.zones;

// ── Supplier localStorage helpers ──
const getSuppliers = () => { try { return JSON.parse(localStorage.getItem('lumen_suppliers') || '[]'); } catch(e) { return []; } };
const saveSuppliers = (arr) => { localStorage.setItem('lumen_suppliers', JSON.stringify(arr)); };
// ==== SLICE-A1 SUPPLIER_MATCH_LOGIC_START
// A supplier covers grid CATEGORIES (FIXTURE_TYPES_GRID labels: 'Custom',
// 'Panel', ...), never a fitting's display name. Prices from used to match the
// display name ('Stretch - barrasol'), so a custom fitting never found the
// supplier who covers Custom (10 QSP, 15 October 2026). The category comes from
// the line's unit id, `${fixtureId}-${primary}`: a custom fitting's id is
// 'cx-<time>'. An id with no category here (an external fitting, or an old
// line with no unit id) has none, and only an all-types supplier matches it.
const SUPPLIER_CATEGORY_BY_FIXTURE = {
  t8: 'T8 Batten', t5: 'T5 Batten', panel: 'Panel', linear: 'Linear', downlight: 'Downlight',
  bulkhead: 'Bulkhead', decorative: 'Decorative', flood: 'Flood', em: 'EM Gear',
  controls: 'Controls', electrics: 'Electrics', cx: 'Custom',
};
const supplierCategoryFor = (line) => {
  const id = line && line.unit && typeof line.unit.id === 'string' ? line.unit.id : '';
  const fixtureId = id.split('-')[0];
  return Object.prototype.hasOwnProperty.call(SUPPLIER_CATEGORY_BY_FIXTURE, fixtureId)
    ? SUPPLIER_CATEGORY_BY_FIXTURE[fixtureId] : null;
};
// The Prices from rows: one per fitting name (the routing key the portal
// receives), each with its quantity and its supplier category. Two lines with
// the same name and different categories (a custom fitting named 'Panel') get
// no category rather than either one's.
const supplierTypeRows = (lines) => {
  const rows = new Map();
  (lines || []).forEach(z => {
    const type = (z && z.unit && typeof z.unit.label === 'string') ? z.unit.label.split(' · ')[0] : '';
    if (!type) return;
    const category = supplierCategoryFor(z);
    const qty = (z.qty || 1);
    const row = rows.get(type);
    if (!row) { rows.set(type, { type, qty, category }); return; }
    row.qty += qty;
    if (row.category !== category) row.category = null;
  });
  return [...rows.values()].filter(r => r.qty > 0);
};
// Suppliers for a category: every supplier covering it, plus every supplier
// covering all types (no covers ticked).
const suppliersCovering = (all, category) => (all || []).filter(s =>
  !s.covers || s.covers.length === 0 || (!!category && s.covers.includes(category)));
// SLICE-A2: why Add to supply chain cannot add, shown under the button, or
// null when it can. A duplicate is the same name ignoring case and spacing; it
// names the supplier already held so the screen can offer to change its cover.
// covers: the grid labels ticked. Andrew ruled (20 October 2026) that a supplier
// is added only with at least one fitting type ticked, so a new supplier is
// never silently "every type". Suppliers already held with no covers still
// match every type (suppliersCovering), so nothing held changes meaning.
const supplierAddBlock = (name, suppliers, covers) => {
  const clean = String(name || '').trim().replace(/\s+/g, ' ').toLowerCase();
  if (!clean) return { reason: "Type the supplier's name to add it.", duplicate: null };
  const dup = (suppliers || []).find(s => String(s.name || '').trim().replace(/\s+/g, ' ').toLowerCase() === clean);
  if (dup) return { reason: 'Already in your supply chain.', duplicate: dup };
  if (!Array.isArray(covers) || covers.length === 0) {
    return { reason: 'Tick the fitting types this supplier covers.', duplicate: null };
  }
  return null;
};
// SLICE-A3: the ONE add rule. SuppliersScreen (More) and the Add a supplier
// sheet over the survey wrap both add through this, so the two can never
// disagree about what a duplicate is or what a new supplier looks like (skill
// section 5, one derivation). Pure: it takes the held list and returns the next
// list; the caller persists it and says so if the persist fails.
//   covers  the grid labels ticked; at least one is required (supplierAddBlock).
//   idSeed  the id for the new supplier (callers pass Date.now(); tests pass a fixed one).
const supplierAddOutcome = (suppliers, name, covers, idSeed) => {
  const held = Array.isArray(suppliers) ? suppliers : [];
  const block = supplierAddBlock(name, held, covers);
  if (block) return { ok: false, block, suppliers: held, supplier: null };
  const clean = String(name).trim().replace(/\s+/g, ' ');
  const supplier = {
    id: String(idSeed),
    name: clean,
    initials: clean.slice(0, 2).toUpperCase(),
    covers: Array.isArray(covers) ? [...covers] : [],
  };
  return { ok: true, block: null, suppliers: [...held, supplier], supplier };
};
// A duplicate offers to change what the held supplier covers instead of adding
// a second copy. Returns the next list and the changed supplier (null if the id
// is not held).
const supplierCoversOutcome = (suppliers, id, covers) => {
  const held = Array.isArray(suppliers) ? suppliers : [];
  // Never widen a held supplier to every type by an empty tick list (#94
  // review note 1; Andrew's ruling, 20 October 2026). Nothing changes.
  if (!Array.isArray(covers) || covers.length === 0) return { suppliers: held, supplier: null, refused: true };
  const next = held.map(s => s.id === id ? { ...s, covers: [...covers] } : s);
  return { suppliers: next, supplier: next.find(s => s.id === id) || null };
};
// The category a sheet or screen opens with ticked: only a real grid label, so
// the tick is always visibly reflected; anything else lands plainly (all types).
const supplierInitialCover = (category, gridLabels) =>
  (category && Array.isArray(gridLabels) && gridLabels.includes(category)) ? [category] : [];
// Where SuppliersScreen's Back goes. More unless the screen was opened from the
// survey (navOpts.backTo); only the survey screens are accepted, so a stray
// value can never send Back to an arbitrary screen.
const SUPPLIER_BACK_TARGETS = { 3: 'Areas', 11: 'Check and send' };
const supplierBackTarget = (navOpts) => {
  const to = navOpts && navOpts.backTo;
  return Object.prototype.hasOwnProperty.call(SUPPLIER_BACK_TARGETS, to)
    ? { screen: to, label: SUPPLIER_BACK_TARGETS[to] }
    : { screen: 16, label: 'More' };
};
// ==== SLICE-A1 SUPPLIER_MATCH_LOGIC_END
const getSuppliersForType = (category) => suppliersCovering(getSuppliers(), category);

// ── Voice notes shared helpers (S95 D1 fix — data-loss hardening) ────────
// Both the in-zone voice sheet (LiveSurveyScreen) and the header mic recorder
// (VoiceNotesScreen) must write audio to localStorage IMMEDIATELY on stop,
// BEFORE any transcription attempt. Transcription failure must never delete
// the note. If localStorage is full, drop oldest audio blobs to free space
// rather than silently failing.
const VOICE_NOTES_KEY = 'lumen_voice_notes';
const loadVoiceNotes = () => { try { return JSON.parse(localStorage.getItem(VOICE_NOTES_KEY) || '[]'); } catch(e) { return []; } };
const persistVoiceNotes = (arr) => {
  try {
    localStorage.setItem(VOICE_NOTES_KEY, JSON.stringify(arr));
    return { ok: true };
  } catch(e) {
    // SLICE-A5: quota exceeded. Clear base64 audio ONLY where it is already on
    // the portal and transcribed (voiceAudioSafeToClear), oldest first. Audio
    // that exists nowhere else is never cleared, and no note is ever dropped:
    // if that is not enough, the write is refused and the caller says so.
    // (This used to clear the oldest audio regardless, then keep only the
    // newest note, and report ok either way.)
    const pruned = arr.slice();
    const idxByAge = pruned.map((_, i) => i).sort((a, b) => {
      const ta = new Date((pruned[a] && pruned[a].recordedAt) || 0).getTime();
      const tb = new Date((pruned[b] && pruned[b].recordedAt) || 0).getTime();
      return ta - tb;
    });
    for (const i of idxByAge) {
      if (pruned[i] && pruned[i].audioBase64 && voiceAudioSafeToClear(pruned[i])) {
        pruned[i] = { ...pruned[i], audioBase64: null, audioDroppedAfterUpload: true };
        try {
          localStorage.setItem(VOICE_NOTES_KEY, JSON.stringify(pruned));
          return { ok: true, audioPruned: true };
        } catch(_e) { /* keep clearing safe audio */ }
      }
    }
    return { ok: false, error: e, storageFull: true };
  }
};
// ==== S1 VOICE_WATERMARK_START ==========================================
// S1 — the adoption watermark. A recording that has been CONSIDERED for
// adoption is stamped here, once, for the life of the device. It is the whole
// reason a deleted note stays deleted: the recording has already had its one
// chance, so no later sweep can bring it back.
//
// Two authors write notes — the reconcile sweep and the voice sheet's own save
// — and BOTH must stamp, or the premise above is false for every note the user
// creates normally (which is how a delete-then-sweep resurrected it).
//
// Pure decision half, so tests can reach it without localStorage.
const applyVoiceConsidered = (all, ids) => {
  const want = {};
  (Array.isArray(ids) ? ids : []).forEach((i) => { if (i) want[String(i)] = true; });
  let hit = false;
  const next = (Array.isArray(all) ? all : []).map((n) => {
    if (!n || !n.id || n.adoptConsidered || !want[String(n.id)]) return n;
    hit = true;
    return Object.assign({}, n, { adoptConsidered: true });
  });
  return { next: next, changed: hit };
};
// ==== S1 VOICE_WATERMARK_END ============================================

// I/O half. Re-reads the store immediately before writing, so a recording added
// between a sweep's loadVoiceNotes() and this call is preserved.
const markVoiceNotesConsidered = (ids) => {
  if (!Array.isArray(ids) || !ids.length) return { ok: true, changed: false };
  try {
    const res = applyVoiceConsidered(loadVoiceNotes(), ids);
    if (!res.changed) return { ok: true, changed: false };
    const w = persistVoiceNotes(res.next);
    // §9 — persistVoiceNotes drops audio under quota pressure, so this write,
    // which used to be a read-only sweep, can now destroy recordings. Report it
    // rather than discard the result (the rename sidecar does the same).
    if (!w || w.ok !== true) {
      try { console.warn('[voice] considered-watermark write FAILED — adoption is best-effort until it succeeds'); } catch (e) {}
      return { ok: false, changed: false };
    }
    return { ok: true, changed: true, audioPruned: !!w.audioPruned, otherNotesDropped: !!w.otherNotesDropped };
  } catch (e) {
    try { console.warn('[voice] considered-watermark threw', e); } catch (e2) {}
    return { ok: false, changed: false };
  }
};

// `emitEvent` is REQUIRED and deliberately has no default: every caller states
// whether this recording scores. D2 (ratified 18 Aug 2026) — an IN-ZONE survey
// note is capture, not prospecting, and `survey_submitted` already credits
// Platform for the visit, so it emits NOTHING. The STANDALONE Voice Notes
// screen (header mic) keeps emitting: that is prospecting-adjacent capture and
// is not this thread's business. Historical portal_events rows are left alone
// — no backfill, no deletion, past streak weeks keep their dots.
//
// The two call sites are the whole census: LiveSurveyScreen's in-zone recorder
// (emitEvent false) and VoiceNotesScreen's recorder (emitEvent true).
//
// TWO THINGS THIS DOES **NOT** DO, stated because the obvious reading is wrong:
//
// 1. It does not make every note on a survey score-identical. The header mic on
//    a project whose `type` is 'survey' still emits, and its metadata.context is
//    ALSO 'survey' (see ctxTag in VoiceNotesScreen) — so `context` does NOT
//    identify an in-zone note, and nothing downstream (S2, any reconciliation,
//    any backfill) may key off it to tell the two apart. Only the in-zone
//    RECORDER stopped emitting.
//
// 2. It does not unsend anything already queued, and it does not reach a phone
//    that has not upgraded. writePortalEvent queues to lumen_offline_queue on
//    failure and flushOfflineQueue replays verbatim, so an in-zone note recorded
//    OFFLINE before v186 still POSTs once after it; and a device still running
//    v185 keeps EMITTING in-zone events live until it loads the new build. The
//    tail therefore runs per-device-upgrade, not per-deploy-date — anyone
//    reconciling portal_events must not expect zero in-zone-shaped rows after
//    the v186 deploy timestamp.
//
//    NOT filtered — and the honest reason is a cost call, not an impossibility.
//    A discriminator DOES exist, device-side: the event carries
//    `client_event_id: note.id`, and that note in lumen_voice_notes carries
//    `source: 'in-zone'` or `'header-mic'` (both predate this change, so queued
//    pre-v186 events are covered). A flush-time filter dropping only on a
//    POSITIVE `source === 'in-zone'` match, keeping whenever the note is absent,
//    would be safe and fail-open. It is not built because it puts voice-specific
//    knowledge into the generic queue flusher for a bounded one-off, and quota
//    pruning of the note store makes it best-effort anyway. If the live volume
//    ever turns out to be material, that is the door to open — it is unlocked.
const addVoiceNote = (note, emitEvent) => {
  const all = loadVoiceNotes();
  all.unshift(note);
  const res = persistVoiceNotes(all);
  if (emitEvent !== true) return res;
  // S94 — fire portal event once per saved note. Fire-and-forget; the
  // helper queues on failure and never throws, so storage persistence
  // (the user's actual work) is unaffected by the network call.
  try {
    // B.2 Slice 3 — project_id rides the event body top-level (PRJ from the
    // note's binding, or explicit null — never omitted, never a local id);
    // metadata.project_name is for portal-side readability only. Additive on
    // writePortalEvent's payload spread — no helper change, visit_checkin
    // untouched. Fire-and-forget: no echo UI for voice (ratified).
    const b = (note && note.projectBinding && typeof note.projectBinding === 'object') ? note.projectBinding : null;
    writePortalEvent('voice_note_logged', {
      // S158 — replay identity: reuse the note's own UUID so a re-fire for the
      // same note (not just a queue replay) carries the same client_event_id.
      // Conditional spread — an explicit undefined would clobber the helper's
      // generated id via the payload spread.
      ...((note && note.id) ? { client_event_id: String(note.id) } : {}),
      project_id: (b && b.project_id) ? b.project_id : null,
      metadata: {
        context: note && note.context ? note.context : 'general',
        has_transcription: !!(note && (note.text || note.transcript)),
        project_name: (b && b.project_name) ? b.project_name : '',
      },
    });
  } catch (e) { /* defensive — writePortalEvent already swallows errors */ }
  return res;
};
const updateVoiceNote = (id, updates) => {
  const all = loadVoiceNotes();
  const idx = all.findIndex(n => n.id === id);
  if (idx < 0) return { ok: false, notFound: true, all };
  all[idx] = { ...all[idx], ...updates };
  const res = persistVoiceNotes(all);
  return { ...res, all };
};
// ==== S1 NOTE_SAVE_LOGIC_START ==========================================
// SURVEY-NOTES-V1 S1 — no recording is ever silently discarded.
//
// Pre-S1, saveVoiceSheetNote called addNoteTo only `if (body)` and addNoteTo
// itself early-returned on an empty body, so a recording whose transcription
// failed produced NO note at all: the zone note count did not move, the audio
// was stranded in lumen_voice_notes, and the modal had already told the user
// it was saved. §9 — that is as silent as failure gets.
//
// Both helpers below are PURE so tests/note_save.test.js can lock them with no
// DOM and no localStorage. Callers persist; these only decide.

// HH:MM from an ISO stamp, '' when unusable. Matches LiveSurveyScreen's _nowHM
// format so an adopted note's timestamp reads like every other note's.
const _voiceHmFromIso = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '';
  return ('0' + d.getHours()).slice(-2) + ':' + ('0' + d.getMinutes()).slice(-2);
};

// Decide what a save should write. Returns the note to persist, or null when
// there is genuinely nothing to keep.
//   transcript present            -> an ordinary note (pending false)
//   no transcript, audio present  -> a PENDING note that owns its audio
//   neither                       -> null. We are removing a silent discard,
//                                   NOT starting to create empty notes.
const deriveNoteToSave = (input) => {
  const src = input || {};
  const zoneId = src.zoneId;
  if (!zoneId) return null;
  const body = String(src.transcript == null ? '' : src.transcript).trim();
  const audioRef = src.audioRef ? String(src.audioRef) : null;
  if (body) return { zoneId: zoneId, type: 'voice', body: body, audioRef: audioRef, pending: false };
  if (audioRef) return { zoneId: zoneId, type: 'voice', body: '', audioRef: audioRef, pending: true };
  return null;
};

// When a save arrives for a recording some note ALREADY owns — a sweep adopted
// it while the sheet was still open — decide what to do with the body the user
// is holding. The sheet's textarea is seeded from the same transcript the
// adoption used and then EDITED by the surveyor, which is the whole reason that
// textarea exists, so the sheet's copy is authoritative: last write wins.
//
// The first cut of this only filled a note that was pending or empty-bodied. A
// transcription that SUCCEEDED produced a non-pending adopted note carrying the
// raw transcript, so a correction (“T8” → “T5” — a number that feeds the
// estimate) was silently dropped, under a green “Voice note saved” toast, and
// the sheet then cleared the textarea. Silent-wrong beating loud-duplicate is
// the one trade §9 refuses.
const decideOwnedNoteUpdate = (owned, body) => {
  const b = String(body == null ? '' : body).trim();
  const cur = String((owned && owned.body) || '').trim();
  if (!b) return { action: 'noop', reason: 'nothing-typed' };
  if (b === cur) return { action: 'noop', reason: 'identical' };
  return { action: 'fill', body: b };
};

// Reconcile a zoneNotes map against the voice store. Pure — takes both, returns
// a NEW map plus counts. Never mutates, never deletes.
//
// Two jobs, one sweep:
//   (1) TRANSCRIPTION WRITE-BACK — a pending note whose audio has since been
//       transcribed (by the lifted retry, or on the standalone screen) gets its
//       body filled and its pending flag cleared.
//   (2) ORPHAN ADOPTION — an in-zone recording that never became a note (every
//       one captured before S1 shipped) is adopted into its zone. Best effort:
//       an orphan carrying no zone CANNOT be placed, so it is LEFT ALONE in the
//       voice store, where the standalone Voice Notes screen still lists it.
//       Never deleted. A rescue, not a guarantee.
// Normalise for claim-matching: case, punctuation and whitespace all differ
// between a raw transcript and the note the user actually saved.
const _voiceNormText = (s) => String(s == null ? '' : s)
  .toLowerCase().replace(/[^a-z0-9\s]/g, ' ').replace(/\s+/g, ' ').trim();
// Below this length a containment match is coincidence, not evidence.
const VOICE_CLAIM_MIN_CHARS = 12;

const reconcileZoneNotesWithVoice = (zoneNotes, voiceNotes, projectId, knownZones) => {
  const toArr = (val) => {
    if (Array.isArray(val)) return val;
    if (typeof val === 'string' && val.trim()) return [{ id: 'legacy', type: 'text', body: val, t: '' }];
    return [];
  };
  const base = (zoneNotes && typeof zoneNotes === 'object' && !Array.isArray(zoneNotes)) ? zoneNotes : {};
  const store = Array.isArray(voiceNotes) ? voiceNotes : [];
  const out = {};
  Object.keys(base).forEach((k) => { out[k] = toArr(base[k]).slice(); });

  const byRef = {};
  store.forEach((vn) => { if (vn && vn.id) byRef[String(vn.id)] = vn; });

  // (1) fill pending notes whose audio now carries a transcript
  let filled = 0;
  Object.keys(out).forEach((k) => {
    out[k] = out[k].map((n) => {
      if (!n || !n.pending || !n.audioRef) return n;
      const vn = byRef[String(n.audioRef)];
      const text = (vn && typeof vn.transcript === 'string') ? vn.transcript.trim() : '';
      if (!text) return n;
      filled++;
      return Object.assign({}, n, { body: text, pending: false });
    });
  });

  // (2) adopt orphans — recordings that never became notes.
  //
  // CONSIDERED-ONCE is the load-bearing rule, and it replaces the tombstone /
  // fuzzy-claim machinery that three review passes kept finding holes in.
  //
  // Every recording this sweep looks at is returned in `considered`, and the
  // CALLER stamps `adoptConsidered` on it in the voice store. A recording is
  // only ever a candidate ONCE, for the whole life of the device. That single
  // rule gives us, by construction:
  //   • deleting an adopted note is permanent — the recording is already
  //     considered, so no sweep can resurrect it, and no tombstone is needed;
  //   • no dependence on whether the notes map happened to be committed;
  //   • any mis-judgement below can cost at most ONE note, once, which the
  //     user can delete permanently — never a duplicate that returns.
  //
  // Within that single consideration we still try not to duplicate a note the
  // user already has, but this is now a HEURISTIC whose failure is bounded,
  // not a correctness mechanism:
  //   (a) a note already carrying the recording's audioRef;
  //   (b) a VOICE note in the same zone whose normalised body CONTAINS the
  //       normalised transcript. Pre-S1 a successful transcription wrote a note
  //       with no audioRef, and the transcript lands in an editable textarea
  //       that APPENDS, so equality never matched. Restricted to voice notes: a
  //       typed note must never silently swallow a recording.
  //   (c) too short to judge — under VOICE_CLAIM_MIN_CHARS we cannot tell a
  //       real match from a coincidence, so for a recording we have never seen
  //       before we REFUSE to adopt rather than risk a duplicate. It stays in
  //       the voice store, listed on the standalone Voice Notes screen.
  const claimed = {};
  Object.keys(out).forEach((k) => {
    out[k].forEach((n) => { if (n && n.audioRef) claimed[String(n.audioRef)] = true; });
  });

  const zoneAllowed = (z) => {
    if (z === '__project__') return true;
    if (!Array.isArray(knownZones)) return true;   // caller did not scope us
    return knownZones.indexOf(z) !== -1;
  };

  // Ours, in a zone we still have, not yet considered.
  const candidates = store.filter((vn) =>
    vn && vn.id && !vn.adoptConsidered
    && vn.context === 'survey'
    && projectId && vn.projectId === projectId
    && vn.zone && zoneAllowed(vn.zone)
  ).sort((x, y) => {
    const tx = new Date((x && x.recordedAt) || 0).getTime();
    const ty = new Date((y && y.recordedAt) || 0).getTime();
    return tx - ty;                                 // oldest first, capture order
  });

  let adopted = 0;
  let mutated = false;
  const considered = [];
  candidates.forEach((vn) => {
    const ref = String(vn.id);
    considered.push(ref);
    if (claimed[ref]) return;                                        // (a)
    const vt = _voiceNormText(vn.transcript);
    const text = (typeof vn.transcript === 'string') ? vn.transcript.trim() : '';
    if (text && vt.length < VOICE_CLAIM_MIN_CHARS) {                  // (c)
      // Too short to judge by content — but "cannot judge" only matters when
      // there is something to collide WITH. A zone holding no unclaimed voice
      // note has no pre-S1 note this could duplicate, so adopting is safe and
      // the rescue still works (that is the whole point of the net for a
      // recording whose save failed). Otherwise refuse: a duplicate on the
      // wire is worse than a recording left on the standalone screen.
      const rival = (out[vn.zone] || []).some(n => n && n.type === 'voice' && !n.audioRef);
      if (rival) return;
    }
    if (vt.length >= VOICE_CLAIM_MIN_CHARS) {                        // (b)
      const arr = out[vn.zone] || [];
      let hit = -1;
      for (let i = 0; i < arr.length; i++) {
        const n = arr[i];
        if (!n || n.type !== 'voice') continue;
        const nb = _voiceNormText(n.body);
        if (nb.length >= VOICE_CLAIM_MIN_CHARS && nb.indexOf(vt) !== -1) { hit = i; break; }
      }
      if (hit !== -1) {
        claimed[ref] = true;
        if (!arr[hit].audioRef) {
          out[vn.zone] = arr.slice();
          out[vn.zone][hit] = Object.assign({}, arr[hit], { audioRef: ref, claimedBy: 'content' });
          mutated = true;
        }
        return;
      }
    }
    if (!out[vn.zone]) out[vn.zone] = [];
    out[vn.zone].push({
      id: 'n_adopt_' + ref,
      type: 'voice',
      body: text,
      audioRef: ref,
      pending: !text,
      adopted: true,
      t: _voiceHmFromIso(vn.recordedAt),
      at: vn.recordedAt ? new Date(vn.recordedAt).getTime() : 0,
    });
    claimed[ref] = true;
    adopted++;
  });

  return { zoneNotes: out, adopted: adopted, filled: filled, mutated: mutated, considered: considered };
};
// ==== S1 NOTE_SAVE_LOGIC_END ============================================

// ==== SLICE-A4 SURVEY_VOICE_LOGIC_START =================================
// SLICE-A4: a voice note recorded during a survey belongs to the survey.
//
// The 10 QSP click-test (15 October 2026): the header mic, pressed in
// Reception, opened the standalone Voice notes screen, which binds a note to the
// project only. The note never reached Reception's Notes (Notes 0). Now, with a
// survey open, the header mic opens the SAME voice sheet the in-zone recorder
// uses (LiveSurveyScreen), so the note is filed by the same path: addNoteTo,
// the S1 audioRef adoption, no voice_note_logged event.
//
// Where a note files, decided once:
//   in the Site-wide workspace, or on the Areas list (no area open) -> '__project__'
//   with an area open                                                 -> that area
// '__project__' is the Site-wide container. It is a raw internal key and is
// never shown as a label (CLAUDE.md wire contract); the screens say "Site-wide".
const VOICE_SITE_KEY = '__project__';
const voiceTargetKey = (ctx) => {
  const c = ctx || {};
  if (c.projectMode) return VOICE_SITE_KEY;
  if (c.lview === 'area' && typeof c.currentZone === 'string' && c.currentZone) return c.currentZone;
  return VOICE_SITE_KEY;
};
// NOTES-IN-AREA (21 October 2026). On site Andrew could not find where to add a
// note about an area: the only way in was the Notes tab, which reads as a count.
// The Fittings tab of an open area now opens with one slim row, Add a note and
// Add a voice note, directly under the Fittings / Photos / Notes tabs (so it is
// on screen on every visit however many fittings are logged), and lists the
// area's newest notes under the fitting keys so a surveyor sees the note land
// where they meant. Both buttons open the sheets
// the Notes tab opens and save through addNoteTo, so a note filed here is under
// the area's own key (its name) and reaches the wire in zoneNotes like any other.
// This is the list: the newest few in the order the Notes tab stacks them
// (oldest first), and how many older ones were left out. A voice note whose
// transcription has not come back has no words yet, so it says so, never blank.
// Pure.
const AREA_NOTES_SHOWN = 3;
const areaNoteLines = (notes, max) => {
  const all = (Array.isArray(notes) ? notes : []).filter((n) => n && typeof n === 'object');
  const cap = Number(max) >= 1 ? Math.floor(Number(max)) : AREA_NOTES_SHOWN;
  const lines = all.slice(-cap).map((n, i) => {
    const voice = n.type === 'voice';
    const body = typeof n.body === 'string' ? n.body.trim() : '';
    return { id: n.id ? String(n.id) : 'line' + i, time: typeof n.t === 'string' ? n.t : '', voice: voice, text: body || (voice ? 'Not transcribed yet' : '') };
  });
  return { lines: lines, more: all.length - lines.length, total: all.length };
};
// Header-mic recordings (made outside any area, e.g. from Today) that belong to
// this survey's project and are not yet on any note. They file to the project
// only, so they are listed as Unassigned notes and can be moved to an area.
//   ids.projectId  the project's local id (a note's `projectId`)
//   ids.bindingId  the project's PRJ binding id, when it has one (a note's
//                  `projectBinding.project_id`); either match is enough
// A recording counts as taken once any note anywhere carries its audioRef, so
// moving one removes it from this list and a delete elsewhere cannot revive it
// here (the move stamps the recording's zone as well). Newest first. Pure.
const unassignedVoiceNotes = (voiceNotes, ids, zoneNotes) => {
  const store = Array.isArray(voiceNotes) ? voiceNotes : [];
  const who = ids || {};
  if (!who.projectId && !who.bindingId) return [];
  const taken = {};
  const map = (zoneNotes && typeof zoneNotes === 'object' && !Array.isArray(zoneNotes)) ? zoneNotes : {};
  Object.keys(map).forEach((k) => {
    if (!Array.isArray(map[k])) return;
    map[k].forEach((n) => { if (n && n.audioRef) taken[String(n.audioRef)] = true; });
  });
  const mine = (vn) => (who.projectId && vn.projectId === who.projectId)
    || (who.bindingId && vn.projectBinding && vn.projectBinding.project_id === who.bindingId);
  return store
    .filter(vn => vn && vn.id && vn.source === 'header-mic' && !vn.zone && mine(vn) && !taken[String(vn.id)])
    .sort((x, y) => new Date((y && y.recordedAt) || 0).getTime() - new Date((x && x.recordedAt) || 0).getTime());
};
// How long a recording ran, in whole seconds, from the voice store by the id a
// note's audioRef names. 0 when unknown (never a guess). Pure.
const voiceDurationFor = (voiceNotes, ref) => {
  if (!ref || !Array.isArray(voiceNotes)) return 0;
  const vn = voiceNotes.find(v => v && String(v.id) === String(ref));
  const d = vn ? Number(vn.duration) : 0;
  return Number.isFinite(d) && d > 0 ? Math.round(d) : 0;
};
// "0:07", "1:05". Empty for an unknown length, so a note never claims one.
const voiceDurationWords = (seconds) => {
  const s = Number(seconds);
  if (!Number.isFinite(s) || s <= 0) return '';
  const whole = Math.round(s);
  return `${Math.floor(whole / 60)}:${String(whole % 60).padStart(2, '0')}`;
};
// SLICE-A4 (review round 1): how long a recording ran, in whole seconds, from
// the time it started to the time it stopped. 0 when the start is unknown or
// the clock went backwards, so a note never claims a length. Pure.
const recordingSeconds = (startedAtMs, stoppedAtMs) => {
  const a = Number(startedAtMs), b = Number(stoppedAtMs);
  if (!Number.isFinite(a) || !Number.isFinite(b) || a <= 0 || b < a) return 0;
  return Math.round((b - a) / 1000);
};
// SLICE-A4 (review round 1): move ONE note from one container to another, as a
// single new notes map, so it is never in both and never in neither. The note
// keeps its id, body, audioRef, pending state and duration. If the target
// already holds a note owning the same recording, the moved copy is dropped
// rather than duplicated (one recording, one note). Returns null when there is
// nothing to move. Pure.
const moveNoteBetween = (zoneNotes, fromKey, noteId, toKey) => {
  const map = (zoneNotes && typeof zoneNotes === 'object' && !Array.isArray(zoneNotes)) ? zoneNotes : {};
  if (!fromKey || !toKey || fromKey === toKey || !noteId) return null;
  const from = Array.isArray(map[fromKey]) ? map[fromKey] : [];
  const note = from.find(n => n && n.id === noteId);
  if (!note) return null;
  const to = Array.isArray(map[toKey]) ? map[toKey] : [];
  const owned = note.audioRef && to.some(n => n && n.audioRef && String(n.audioRef) === String(note.audioRef));
  const next = { ...map, [fromKey]: from.filter(n => n !== note), [toKey]: owned ? to : [...to, note] };
  if (next[fromKey].length === 0) delete next[fromKey];
  return next;
};
// ==== SLICE-A4 SURVEY_VOICE_LOGIC_END ===================================

// ==== WRITE_UP_LOGIC_START (sliced out by tests/write_up.test.js) ========
// WRITE-UP-APP-V1 (ruling 47, board 10). At the end of a survey the app asks
// whether the client wants a report, and which kind, then prompts the
// surveyor to talk or type while still on site. The answers ride the survey
// to the portal as `report_request`; Eva drafts there and a person checks and
// sends it. Nothing here drafts, previews or sends a report.
//
// The keys are fixed: the portal reads them (briefs/WRITE-UP-V1/APP-CONTRACT.md
// in the portal repo). Plain JS, no JSX, so the test can evaluate this block.
//
// What the phone keeps (on the job, as `reportRequest`):
//   { wanted: true|false, kind: 'problem'|'scope'|null, askedAt: ISO,
//     step: index of the prompt on screen, done: true once the last is passed,
//     answers: { <key>: { text: 'what is in the answer box',
//                         voiceNoteIds: ['<voice note id>', ...] } } }
// A recording made on a prompt is an ordinary voice note: it is stored in the
// voice store, uploaded and transcribed like any other, and filed as a
// Site-wide note whose own id IS the voice note id, so `voice_note_ids` names
// both the app's voice note and the note the survey carries in
// zoneNotesStructured (which is how the portal finds its words).
const REPORT_PROMPTS = {
  problem: [
    { key: 'asked', name: 'What they asked', heading: 'What did they ask you to look at? What should happen, and what happens instead?',
      help: 'In their words: what is wrong, where it happens and since when.' },
    { key: 'found', name: 'What you found', heading: 'Walk through each area you looked at.',
      help: 'What you saw, and what should happen there. The booths, the sensors, the controller, anything labelled.' },
    { key: 'told', name: 'What they told you', heading: 'Anything they told you that you did not see yourself.',
      help: 'What the client or their staff said, like when it started or what has been changed. Say who said it.' },
    { key: 'cause', name: 'The cause', heading: 'What do you think is causing it? Anything you ruled out?',
      help: 'Your best guess and why. Say what you checked and could rule out.' },
    { key: 'recommend', name: 'What you recommend', heading: 'What would you recommend, and who installed it?',
      help: 'The fix, roughly what it involves, and who put the system in, if you know.' },
    { key: 'recipient', name: 'Who gets it', heading: 'Who should get the report?',
      help: 'Their name, their role and their email, and anyone to copy in.' },
  ],
  scope: [
    { key: 'proposal', name: 'The proposal', heading: 'What were you checking against: which proposal?',
      help: 'The proposal or quote you checked, and which version, if you know.' },
    { key: 'found', name: 'What you found', heading: 'Walk through what you saw. Does anything change the proposal?',
      help: 'Area by area: what matches the proposal, and anything different, missing or extra.' },
    { key: 'options', name: 'Options', heading: 'Did they ask for options, or something kept separate?',
      help: 'Anything they want priced as an option, or kept on a quote of its own.' },
    { key: 'timing', name: 'Timing', heading: 'Access, working hours, dates, anything about when?',
      help: 'How to get in, when work can happen, dates to avoid and when they want it done.' },
    { key: 'other_work', name: 'Other work', heading: 'Did they show you anything else, a separate job?',
      help: 'Anything else they showed you that could be a job of its own.' },
    { key: 'recipient', name: 'Who gets it', heading: 'Who should get the report?',
      help: 'Their name, their role and their email, and anyone to copy in.' },
  ],
};
const REPORT_KIND_WORDS = { problem: 'A problem to solve', scope: 'A check of our scope' };
const reportPromptsFor = (kind) => (Object.prototype.hasOwnProperty.call(REPORT_PROMPTS, kind) ? REPORT_PROMPTS[kind] : []);
// "2 of 6 · What you found", '' for a step the kind does not have.
const reportStepWords = (kind, i) => {
  const ps = reportPromptsFor(kind);
  const p = ps[i];
  return p ? `${i + 1} of ${ps.length} · ${p.name}` : '';
};
const _reportAnswer = (stored, key) => {
  const a = stored && stored.answers && typeof stored.answers === 'object' ? stored.answers[key] : null;
  return {
    text: a && typeof a.text === 'string' ? a.text : '',
    voiceNoteIds: a && Array.isArray(a.voiceNoteIds) ? a.voiceNoteIds.filter((x) => x != null && x !== '').map(String) : [],
  };
};
// Has this prompt been answered (typed or recorded)?
const reportAnswered = (stored, key) => {
  const a = _reportAnswer(stored, key);
  return !!a.text.trim() || a.voiceNoteIds.length > 0;
};
// Has the question been answered at all? Only a true or false `wanted` counts.
const reportAsked = (stored) => !!stored && typeof stored === 'object' && typeof stored.wanted === 'boolean';
// Which stage the end of the survey opens on:
//   'ask'    the question, when it has not been answered and nothing has gone;
//   'notes'  the prompts, when a report is wanted and they were not finished;
//   null     Check and send.
const reportStageFor = (stored, sendStateName) => {
  if (reportAsked(stored)) return (stored.wanted === true && !stored.done && reportPromptsFor(stored.kind).length) ? 'notes' : null;
  return sendStateName === 'not_sent' ? 'ask' : null;
};
// The answer to the question. 'none' is No report.
const reportChoose = (stored, choice, nowIso) => {
  const prev = stored && typeof stored === 'object' ? stored : {};
  // asked_at is when the question was first answered; a later change keeps it.
  const askedAt = typeof prev.askedAt === 'string' && prev.askedAt ? prev.askedAt : nowIso;
  if (choice !== 'problem' && choice !== 'scope') {
    return { wanted: false, kind: null, askedAt, step: 0, done: true, answers: prev.answers || {} };
  }
  // Changing the kind keeps every answer already given: a key both kinds ask,
  // like `found`, carries over, and the others are still sent, after the new
  // kind's own (buildReportRequest).
  return { wanted: true, kind: choice, askedAt, step: prev.kind === choice ? (prev.step || 0) : 0, done: false, answers: prev.answers || {} };
};
// One answer changed: { text } and/or { addVoiceNoteId }.
const reportWithAnswer = (stored, key, change) => {
  const prev = stored && typeof stored === 'object' ? stored : {};
  const cur = _reportAnswer(prev, key);
  const c = change || {};
  const next = {
    text: typeof c.text === 'string' ? c.text : cur.text,
    voiceNoteIds: c.addVoiceNoteId && cur.voiceNoteIds.indexOf(String(c.addVoiceNoteId)) === -1
      ? cur.voiceNoteIds.concat([String(c.addVoiceNoteId)]) : cur.voiceNoteIds,
  };
  if (typeof c.appendText === 'string' && c.appendText.trim()) {
    const t = next.text.trim();
    next.text = t ? t + ' ' + c.appendText.trim() : c.appendText.trim();
  }
  return Object.assign({}, prev, { answers: Object.assign({}, prev.answers || {}, { [key]: next }) });
};
const _reportNorm = (s) => String(s == null ? '' : s).toLowerCase().replace(/[^a-z0-9\s]/g, ' ').replace(/\s+/g, ' ').trim();
// The `report_request` the survey carries, or null when the question was never
// answered (the key is then left out, as an older app leaves it out).
//   text: what is in the answer box; a recording's transcript is added when
//         the box does not already hold it (it came back after the prompt was
//         left). Empty when nothing was typed and no transcript is back yet.
//   skipped: nothing typed and nothing recorded.
// voiceNotes is the voice store (loadVoiceNotes()), read for transcripts only.
const buildReportRequest = (stored, voiceNotes) => {
  if (!reportAsked(stored)) return null;
  const askedAt = typeof stored.askedAt === 'string' ? stored.askedAt : '';
  if (stored.wanted !== true) return { wanted: false, kind: null, answers: [], asked_at: askedAt };
  const kind = stored.kind === 'problem' || stored.kind === 'scope' ? stored.kind : null;
  const byId = {};
  (Array.isArray(voiceNotes) ? voiceNotes : []).forEach((n) => { if (n && n.id) byId[String(n.id)] = n; });
  const one = (key) => {
    const a = _reportAnswer(stored, key);
    let text = a.text.trim();
    a.voiceNoteIds.forEach((id) => {
      const vn = byId[id];
      const tr = vn && typeof vn.transcript === 'string' ? vn.transcript.trim() : '';
      if (!tr) return;
      if (text && _reportNorm(text).indexOf(_reportNorm(tr)) !== -1) return;
      text = text ? text + ' ' + tr : tr;
    });
    return { key, text, voice_note_ids: a.voiceNoteIds.slice(), skipped: !text && a.voiceNoteIds.length === 0 };
  };
  const own = reportPromptsFor(kind).map((p) => p.key);
  const answers = own.map(one);
  // Never lose what was said: an answer given under the other kind before the
  // kind was changed still goes, after this kind's own (the portal keeps a
  // key the kind does not ask and shows it as "from the app"). Only answers
  // that hold something; an empty one is not an answer.
  const stash = stored.answers && typeof stored.answers === 'object' ? stored.answers : {};
  const order = REPORT_PROMPTS.problem.concat(REPORT_PROMPTS.scope).map((p) => p.key);
  Object.keys(stash).sort((x, y) => {
    const ix = order.indexOf(x), iy = order.indexOf(y);
    return (ix === -1 ? 99 : ix) - (iy === -1 ? 99 : iy);
  }).forEach((key) => {
    if (own.indexOf(key) !== -1 || answers.some((a) => a.key === key)) return;
    const a = one(key);
    if (!a.skipped) answers.push(a);
  });
  return { wanted: true, kind, answers, asked_at: askedAt };
};
// The Site-wide note a prompt's recording files as. Its id is the voice note
// id (see the head of this block).
const reportSiteNote = (voiceNoteId, durationSec, nowMs, hm) => Object.assign({
  id: String(voiceNoteId), type: 'voice', body: '', audioRef: String(voiceNoteId), pending: true, t: hm || '', at: nowMs || 0,
}, Number(durationSec) > 0 ? { duration: Math.round(Number(durationSec)) } : {});
// Add that note under '__project__', once. Returns a new map.
const withReportSiteNote = (zoneNotes, note) => {
  const map = zoneNotes && typeof zoneNotes === 'object' && !Array.isArray(zoneNotes) ? zoneNotes : {};
  const cur = map.__project__;
  const arr = Array.isArray(cur) ? cur : (typeof cur === 'string' && cur.trim() ? [{ id: 'legacy', type: 'text', body: cur, t: '' }] : []);
  if (!note || arr.some((n) => n && (n.id === note.id || (n.audioRef && String(n.audioRef) === String(note.audioRef))))) return map;
  return Object.assign({}, map, { __project__: arr.concat([note]) });
};
// Give a pending note its words once its recording's transcript is back.
// Returns { zoneNotes, changed }. A note that already has words is left alone
// (the surveyor may have typed it up).
const fillReportSiteNotes = (zoneNotes, voiceNotes, ids) => {
  const map = zoneNotes && typeof zoneNotes === 'object' && !Array.isArray(zoneNotes) ? zoneNotes : {};
  const want = {};
  (Array.isArray(ids) ? ids : []).forEach((i) => { if (i) want[String(i)] = true; });
  const byId = {};
  (Array.isArray(voiceNotes) ? voiceNotes : []).forEach((n) => { if (n && n.id) byId[String(n.id)] = n; });
  const arr = Array.isArray(map.__project__) ? map.__project__ : null;
  if (!arr) return { zoneNotes: map, changed: false };
  let changed = false;
  const next = arr.map((n) => {
    if (!n || !n.pending || !n.audioRef || !want[String(n.audioRef)]) return n;
    const vn = byId[String(n.audioRef)];
    const tr = vn && typeof vn.transcript === 'string' ? vn.transcript.trim() : '';
    if (!tr) return n;
    changed = true;
    return Object.assign({}, n, { body: tr, pending: false });
  });
  return { zoneNotes: changed ? Object.assign({}, map, { __project__: next }) : map, changed };
};
// Every voice note id the answers name.
const reportVoiceIds = (stored) => {
  const out = [];
  const answers = stored && stored.answers && typeof stored.answers === 'object' ? stored.answers : {};
  Object.keys(answers).forEach((k) => _reportAnswer(stored, k).voiceNoteIds.forEach((id) => { if (out.indexOf(id) === -1) out.push(id); }));
  return out;
};
// The line on Check and send. '' when the question was not answered.
const reportSummaryWords = (stored) => {
  if (!reportAsked(stored)) return '';
  if (stored.wanted !== true) return 'No report.';
  const ps = reportPromptsFor(stored.kind);
  const n = ps.filter((p) => reportAnswered(stored, p.key)).length;
  return `${REPORT_KIND_WORDS[stored.kind] || 'A report'}. ${n} of ${ps.length} notes for the report.`;
};
// ==== WRITE_UP_LOGIC_END ==================================================

// -- S1 — pending-transcription retry, lifted to module level -------------
// Pre-S1 the ONLY retry was `retryPending` INSIDE VoiceNotesScreen, so an
// in-zone recording transcribed only if the user later opened that standalone
// screen by hand. That is why "will retry when online" was a promise nothing
// kept. Lifted here so the survey screen, the sync tick and app-foreground can
// all drive it, mirroring flushPhotoRetryQueue's trigger set. Never throws.
// ==== COST_V1_TRANSCRIBE_SEAM_START (sliced out by tests/transcribe_refusal.test.js)
const _voiceBase64ToBlob = (b64, mime) => {
  const byteChars = atob(String(b64).split(',')[1] || String(b64));
  const bytes = new Uint8Array(byteChars.length);
  for (let i = 0; i < byteChars.length; i++) bytes[i] = byteChars.charCodeAt(i);
  return new Blob([bytes], { type: mime || 'audio/webm' });
};
// CHIP-COST-V1 item 1 — the portal's two transcription endpoints
// (/api/voice-transcribe, /api/transcribe) now require a signed-in user and
// carry a per-user limit of 60 an hour. Every transcription call sends the
// companion Bearer token AND the session cookie (credentials: 'include'), so
// either identity the portal accepts is present. Shipped BEFORE the portal
// gate, per the ordering constraint in the portal's own comment above
// /api/voice-transcribe.
const _transcribeFetchInit = (formData) => {
  let tk = null;
  try { tk = localStorage.getItem('lumen_token'); } catch (e) {}
  return {
    method: 'POST',
    body: formData,
    credentials: 'include',
    headers: tk ? { 'Authorization': 'Bearer ' + tk } : {},
  };
};
// A 401 (not signed in) or 429 (over the hourly limit) is a REFUSAL, not an
// attempt at transcription: the audio was never sent to Whisper. Counting it
// against VOICE_RETRY_MAX_ATTEMPTS would strand good recordings after five
// refusals with nothing on screen saying why.
const _isTranscribeRefusal = (status) => status === 401 || status === 429;
const VOICE_RETRY_MAX_ATTEMPTS = 5;
let _voiceRetryInFlight = false;
const retryPendingVoiceTranscriptions = async () => {
  if (_voiceRetryInFlight) return { attempted: 0, transcribed: 0 };
  if (typeof navigator !== 'undefined' && navigator.onLine === false) {
    return { attempted: 0, transcribed: 0 };
  }
  _voiceRetryInFlight = true;
  let attempted = 0, transcribed = 0;
  try {
    // 'pending' AND 'failed', both under the attempt cap. Excluding 'failed'
    // permanently stranded notes, because VoiceNotesScreen's transcribeNote
    // POSTs /api/transcribe — which returns 200 with {transcript:null} on a
    // SERVER-side failure (missing key, transcription error) and so stamps
    // 'failed' on what was only a transient outage. The cap, not the status, is
    // what stops us re-uploading unintelligible audio forever.
    // (reviewer findings 5 + 6)
    const pending = loadVoiceNotes().filter(n =>
      voiceHasLocalAudio(n)
      && (n.transcriptionStatus === 'pending' || n.transcriptionStatus === 'failed')
      && (n.transcribeAttempts || 0) < VOICE_RETRY_MAX_ATTEMPTS
    );
    for (const n of pending) {
      // SLICE-A5: a recording whose IndexedDB copy cannot be read right now is
      // left for the next sweep, and the attempt is not counted.
      const audioBlob = await voiceAudioBlob(n);
      if (!audioBlob) continue;
      attempted++;
      const _attempt = (n.transcribeAttempts || 0) + 1;
      try {
        const fd = new FormData();
        fd.append('audio', audioBlob, 'voice.webm');
        const resp = await fetch(PORTAL_URL + '/api/voice-transcribe', _transcribeFetchInit(fd));
        if (_isTranscribeRefusal(resp.status)) {
          // Not an attempt (see _isTranscribeRefusal). Every other note would
          // get the same refusal, so stop this sweep rather than re-upload
          // them all; the next sync tick or foreground tries again.
          attempted--;
          try { console.warn(`[voice-retry] transcription refused (HTTP ${resp.status}); stopping this sweep, attempts not counted`); } catch (e2) {}
          break;
        }
        if (!resp.ok) { updateVoiceNote(n.id, { transcriptionStatus: 'pending', transcribeAttempts: _attempt }); continue; }
        const data = await resp.json();
        const text = (data.text || data.transcript || '').trim();
        if (text) {
          updateVoiceNote(n.id, { transcriptionStatus: 'done', transcript: text, transcribedAt: new Date().toISOString(), transcribeAttempts: _attempt });
          transcribed++;
        } else {
          updateVoiceNote(n.id, { transcriptionStatus: 'failed', transcribeAttempts: _attempt });
        }
      } catch (e) {
        updateVoiceNote(n.id, { transcriptionStatus: 'pending', transcribeAttempts: _attempt });
      }
    }
    if (transcribed > 0) {
      // Let any mounted survey screen fold the new transcripts into its notes.
      try { window.dispatchEvent(new CustomEvent('lumenVoiceTranscribed', { detail: { transcribed: transcribed } })); } catch (e) {}
    }
  } catch (e) { /* never throw — this is fire-and-forget */ }
  _voiceRetryInFlight = false;
  return { attempted: attempted, transcribed: transcribed };
};
// ==== COST_V1_TRANSCRIBE_SEAM_END

const blobToBase64Async = (blob) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onloadend = () => resolve((reader.result || '').split(',')[1] || '');
  reader.onerror = reject;
  reader.readAsDataURL(blob);
});

// ════════════════════════════════════════════════════
// DIRECTOR HOME SCREEN — Steve & Colin's commercial view
// Fetches from /api/company-stats + /api/director-stats, role-gated
// ════════════════════════════════════════════════════

// SEC-007 (SECURITY-WAVE-1 track A1): the portal's /api/company-stats now
// needs the companion Bearer token (or a portal session). It answers 401 with
// no identity and 403 to an account the company figures are not shown to
// (skill section 25: sales_visible false, or a coordinator). So this
// call sends the token AND the session cookie, as _transcribeFetchInit does.
// A non-OK answer throws with its status: before this, the screen parsed the
// refusal body as figures and rendered zeros, with nothing saying why.
// ==== A1_COMPANY_STATS_SEAM_START (sliced out by tests/company_stats_auth.test.js)
const _companyStatsFetch = () => {
  let tk = null;
  try { tk = localStorage.getItem('lumen_token'); } catch (e) {}
  return fetch(PORTAL_URL + '/api/company-stats', {
    credentials: 'include',
    headers: tk ? { 'Authorization': 'Bearer ' + tk } : {},
  }).then(r => {
    if (!r.ok) { const err = new Error('company-stats ' + r.status); err.status = r.status; throw err; }
    return r.json();
  });
};
const _companyStatsErrorText = (e) => {
  const s = e && e.status;
  if (s === 401) return 'Sign in again to see the company figures.';
  if (s === 403) return 'The company figures are not shown for your account.';
  return 'Could not load data';
};
// ==== A1_COMPANY_STATS_SEAM_END

// SEC-028 (SECURITY-WAVE-1 track D): a voice note whose bytes were reclaimed
// after upload plays from the portal. It used to be handed to an Audio element
// as a bare URL, which sends no Bearer token, so it worked only while the
// portal served recordings to anyone. The portal now serves them to a
// signed-in session or a companion Bearer only, so the recording is fetched
// here with the token and played from a blob: URL, which the player releases
// when it is done. Today's portal answers with or without the header, so this
// works before and after that portal change. Any refusal or network failure
// rejects with its status and the player keeps its existing failure words.
// ==== D_VOICE_PLAY_SEAM_START (sliced out by tests/voice_play_auth.test.js)
const _portalAudioObjectUrl = (audioUrl) => {
  let tk = null;
  try { tk = localStorage.getItem('lumen_token'); } catch (e) {}
  return fetch(PORTAL_URL + audioUrl, {
    headers: tk ? { 'Authorization': 'Bearer ' + tk } : {},
  }).then(r => {
    if (!r.ok) { const err = new Error('voice-audio ' + r.status); err.status = r.status; throw err; }
    return r.blob();
  }).then(blob => URL.createObjectURL(blob));
};
const _releaseAudioUrl = (url) => {
  if (typeof url === 'string' && url.indexOf('blob:') === 0) {
    try { URL.revokeObjectURL(url); } catch (e) {}
  }
};
// A tiny silent WAV (8 samples). Played on the element inside the user's tap
// so iOS Safari counts the element as started by a gesture; the portal copy
// arrives after fetch() and blob(), outside the tap, and a play() there on a
// never-unlocked element can be refused (NotAllowedError).
const _SILENT_AUDIO = 'data:audio/wav;base64,UklGRiwAAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQgAAACAgICAgICAgA==';
// ONE player path for both voice players. Call it INSIDE the tap handler.
//   localSrc  a data: URI of the note's own bytes, or null
//   audioUrl  the portal path, used when there is no localSrc
//   onEnded / onFail  called at most once, and never after stop()
// Returns { stop }. stop() detaches the element's handlers FIRST, then
// pauses and releases the blob: URL, so a late event from a replaced
// element cannot touch the state of the note that replaced it. Every way
// playback can fail (a refused or throwing play(), an element error, a
// portal refusal or no signal) reaches onFail: never a silent reset, never
// a player left showing "playing".
//   localLoad SLICE-A5: for audio held in IndexedDB, a function returning a
//             Promise of the Blob (or null). It is read after the unlock, like
//             the portal copy; a null falls back to the portal copy if there
//             is one, otherwise onFail.
const _playVoiceSource = ({ localSrc, localLoad, audioUrl, onEnded, onFail }) => {
  const audio = new Audio();
  let blobUrl = null;
  let done = false;
  const finish = (cb) => {
    if (done) return;
    done = true;
    audio.onended = null; audio.onerror = null;
    try { audio.pause(); } catch (e) {}
    if (blobUrl) { _releaseAudioUrl(blobUrl); blobUrl = null; }
    if (cb) { try { cb(); } catch (e) {} }
  };
  const playReal = (src) => {
    audio.onended = () => finish(onEnded);
    audio.onerror = () => finish(onFail);
    audio.src = src;
    let p;
    try { p = audio.play(); } catch (e) { finish(onFail); return; }
    if (p && typeof p.catch === 'function') p.catch(() => finish(onFail));
  };
  const handle = { stop: () => finish(null) };
  if (localSrc) { playReal(localSrc); return handle; }
  // The unlock: synchronous, inside the tap. Its own outcome is ignored: it
  // is silent, and the real play() below reports any failure that matters.
  try {
    audio.src = _SILENT_AUDIO;
    const u = audio.play();
    if (u && typeof u.catch === 'function') u.catch(() => {});
  } catch (e) {}
  const source = localLoad
    ? Promise.resolve().then(() => localLoad()).then((blob) => {
        if (blob) return URL.createObjectURL(blob);
        if (audioUrl) return _portalAudioObjectUrl(audioUrl);
        throw new Error('voice audio unreadable');
      })
    : _portalAudioObjectUrl(audioUrl);
  source.then((url) => {
    if (done) { _releaseAudioUrl(url); return; }   // stopped while fetching
    blobUrl = url;
    playReal(url);
  }).catch(() => finish(onFail));
  return handle;
};
// ==== D_VOICE_PLAY_SEAM_END

// ==== STUDIO_DESK_START ====
// COMPANION-STUDIO-V1 track C2: the desk-side screens (Director home, Pipeline,
// Company, Worth, Morning briefing) carry hundreds of wave-1 colour, face and
// surface literals. Each screen's return goes through studioDesk(node), which
// with the switch off returns the very element it was given (the standard look
// cannot change), and with it on walks the screen's own host elements (the same
// reach as studioShape) and, from the element's own style and the surface it
// sits on, puts each onto a Studio token:
//   - a dark or coloured panel is raised paper, and the text on it reads ink
//     (and muted for the quieter lines); only the one ultraviolet main action
//     keeps a dark fill and its light text;
//   - a dark bar or cell fill is lamp amber (light, delivery progress);
//   - a tinted chip fill is pressed in (or a raised slip when you can tap it);
//   - any text colour off the palette is ink, muted, or ochre for a money figure;
//   - Georgia is Sentient (light, 300 to 500) and any other face is Satoshi;
//   - coloured borders become the hairline, coloured shadows go, decorative
//     blurred glows and glass blurs are not drawn.
// It rewrites no string and drops no control. studioShape then applies the
// shared rules (sizes, capitals, 44px targets, pills, dots).
const _deskColour = (c) => {
  const v = String(c == null ? '' : c).trim().toLowerCase();
  if (!v) return null;
  if (v === 'white') return { r: 255, g: 255, b: 255, a: 1 };
  if (v === 'transparent') return { r: 0, g: 0, b: 0, a: 0 };
  let m = /^#([0-9a-f]{6})([0-9a-f]{2})?$/.exec(v);
  if (m) return { r: parseInt(m[1].slice(0, 2), 16), g: parseInt(m[1].slice(2, 4), 16), b: parseInt(m[1].slice(4, 6), 16), a: m[2] ? parseInt(m[2], 16) / 255 : 1 };
  m = /^#([0-9a-f])([0-9a-f])([0-9a-f])$/.exec(v);
  if (m) return { r: parseInt(m[1] + m[1], 16), g: parseInt(m[2] + m[2], 16), b: parseInt(m[3] + m[3], 16), a: 1 };
  m = /^rgba?\(([^)]*)\)$/.exec(v.replace(/\s/g, ''));
  if (m) { const p = m[1].split(',').map(parseFloat); return { r: p[0], g: p[1], b: p[2], a: p.length > 3 ? p[3] : 1 }; }
  return null;
};
const _deskLum = (c) => {
  const f = (x) => { x /= 255; return x <= 0.03928 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4); };
  return 0.2126 * f(c.r) + 0.7152 * f(c.g) + 0.0722 * f(c.b);
};
const _deskHex = (h) => _deskColour(h);
const _deskSame = (c, hex) => { const k = _deskHex(hex); return !!c && c.r === k.r && c.g === k.g && c.b === k.b; };
// Every colour written in a background value (a gradient has several).
const _deskColours = (s) => (String(s || '').match(/rgba?\([^)]*\)|#[0-9a-fA-F]{3,8}\b|\bwhite\b/g) || []).map(_deskColour).filter(Boolean);
const _deskMoney = (s) => /^[\s£\d.,\-+]*£[\s\d.,]*[kKmM]?(\s*\/\s*\w+)?\s*$/.test(s) || /^£[\d.,]+[kKmM]?(\s|$)/.test(s) && s.length <= 12;
// COMPANION-STUDIO-LIT-V1 track 3b: the meaning colours (STUDIO_MEANING) are
// Studio colours on a desk screen too. A fill keeps its hue on a bar, an edge
// or a drawn ring, and a text value stays the colour of its word. Nothing
// drew these hexes before this run, so no earlier switch-on render moves.
const _DESK_MEANING_FILLS = ['client', 'newFill', 'quotedFill', 'strongFill', 'wonFill', 'rustFill', 'slateFill', 'ochreFill'];
// STUDIO-LIT-REDO-V1 P2: the client's words are clientText (the #1F7BFF fill
// is 3.1:1 on the lit ground, so it is a bar and edge colour only).
const _DESK_MEANING_TEXTS = ['clientText', 'newText', 'quotedText', 'strongText', 'wonText', 'rustText', 'slateText'];
const _deskMeaningFill = (c) => _DESK_MEANING_FILLS.some((k) => _deskSame(c, STUDIO_MEANING[k]));
const _deskMeaningText = (c) => _DESK_MEANING_TEXTS.some((k) => _deskSame(c, STUDIO_MEANING[k]));
function _deskStyle(type, st0, children, onClick, ctx, ctl) {
  const S = STUDIO_TOKENS;
  const st = Object.assign({}, st0);
  const text = _studioText(children).trim();
  const control = type === 'button' || typeof onClick === 'function' || st.cursor === 'pointer';
  const h = _studioPx(st.height); const w = typeof st.width === 'string' && /px$/.test(st.width) ? _studioPx(st.width) : (typeof st.width === 'number' ? st.width : null);
  let surface = ctx;
  // Surfaces.
  const bgRaw = st.background != null ? st.background : st.backgroundColor;
  const bgKey = st.background != null ? 'background' : 'backgroundColor';
  let panel = false;
  if (bgRaw != null && typeof bgRaw === 'string') {
    const cs = _deskColours(bgRaw);
    const gradient = /gradient\(/.test(bgRaw);
    const isStudio = bgRaw === S.paper.css || bgRaw === S.jewel.fill || bgRaw === S.ground.css || bgRaw === S.pressed.fill || bgRaw.includes(S.paper.css);
    const barLike = children == null && ((h != null && h <= 24) || (w != null && w <= 24));
    const solidUv = !gradient && cs.length === 1 && _deskSame(cs[0], S.ultraviolet) && cs[0].a >= 0.5;
    if (isStudio) { if (bgRaw.includes(S.paper.css)) panel = true; }
    else if (solidUv) { surface = 'uv'; }
    else if (!gradient && cs.length === 1 && (_deskSame(cs[0], S.ink) || _deskSame(cs[0], S.lampAmber) || _deskMeaningFill(cs[0])) && cs[0].a === 1) { /* already a Studio colour */ }
    else if (cs.length) {
      const dark = cs.some((c) => c.a >= 0.5 && _deskLum(c) < 0.18);
      const saturated = cs.some((c) => c.a >= 0.3 && Math.max(c.r, c.g, c.b) - Math.min(c.r, c.g, c.b) > 28);
      const lightFill = cs.every((c) => c.a >= 0.5 && _deskLum(c) > 0.55);
      const faint = cs.every((c) => c.a < 0.5);
      if (_deskSame(cs[0], T_STANDARD.colors.bg) && !gradient && cs[0].a === 1) st[bgKey] = 'transparent';  // a wave-1 page ground: the Studio ground shows through
      else if (barLike && (dark || saturated)) st[bgKey] = S.lampAmber;
      else if (barLike) { /* a track: ink at a low alpha stays */ }
      else if (children == null && (dark || saturated)) st[bgKey] = S.lampAmber;
      else if (gradient || dark) {
        if (control) { st[bgKey] = S.paper.css; st.boxShadow = S.shadow.slip; surface = 'paper'; }
        else { st[bgKey] = S.paper.css; panel = true; surface = 'paper'; }
        if (st.background == null) { delete st.backgroundColor; st.background = S.paper.css; }
      } else if (lightFill) {
        st[bgKey] = S.paper.css; panel = !control; if (control) st.boxShadow = S.shadow.slip;
        if (st.background == null) { delete st.backgroundColor; st.background = S.paper.css; }
      } else if (saturated || faint) {
        st[bgKey] = control ? S.paper.css : S.pressed.fill;
        if (control) { st.boxShadow = S.shadow.slip; if (st.background == null) { delete st.backgroundColor; st.background = S.paper.css; } }
        else if (st.background == null) { delete st.backgroundColor; st.background = S.pressed.fill; }
      }
    }
  }
  // Colour as light (a stage's 3px edge, side glow and wash, from studioLit)
  // keeps its edge and shadow; its other borders go.
  const lit = typeof st.borderLeft === 'string' && (Object.values(S.stages).some((hx) => st.borderLeft.toLowerCase().includes(hx.toLowerCase()))
    || _DESK_MEANING_FILLS.some((k) => st.borderLeft.toLowerCase().includes(STUDIO_MEANING[k].toLowerCase())));
  if (lit) { delete st.border; delete st.borderTop; delete st.borderBottom; delete st.borderRight; panel = false; }
  if (panel) { st.boxShadow = S.shadow.raised; st.border = 'none'; delete st.borderTop; delete st.borderBottom; delete st.borderLeft; delete st.borderRight; }
  // Borders.
  ['border', 'borderTop', 'borderBottom', 'borderLeft', 'borderRight'].forEach((k) => {
    const v = st[k];
    if (typeof v !== 'string' || /^(none|0)/.test(v.trim())) return;
    const cs = _deskColours(v);
    if (!cs.length) return;
    if (cs.some((c) => Object.values(S.stages).some((hx) => _deskSame(c, hx)) || _deskSame(c, S.ink) || _deskSame(c, S.ultraviolet) || _deskMeaningFill(c))) return;
    if (v.includes(S.hairline)) return;
    const wd = /^\s*(\d+(?:\.\d+)?)px/.exec(v);
    if (k === 'borderLeft' && wd && parseFloat(wd[1]) >= 2) { st[k] = 'none'; return; }
    st[k] = v.replace(/rgba?\([^)]*\)|#[0-9a-fA-F]{3,8}\b|\bwhite\b/g, S.hairline);
  });
  // Shadows and glass. A shadow in the Studio's own shadow colour is kept.
  const tint = /rgba\((\d+,\d+,\d+)/.exec(S.shadow.slip)[1];
  if (typeof st.boxShadow === 'string' && !st.boxShadow.includes(tint) && !panel && !st.boxShadow.includes(S.shadow.slip)) delete st.boxShadow;
  if (st.textShadow) delete st.textShadow;
  if (st.filter && /blur/.test(String(st.filter))) delete st.filter;
  delete st.backdropFilter;
  delete st.WebkitBackdropFilter;
  // Faces.
  const fam = st.fontFamily;
  if (typeof fam === 'string' && !/^inherit$/i.test(fam.trim()) && !/Sentient|Satoshi/.test(fam)) {
    if (/Georgia|serif/i.test(fam) && !/sans-serif/i.test(fam.replace(/Georgia/i, ''))) {
      st.fontFamily = S.fonts.display;
      const fs = _studioPx(st.fontSize);
      st.fontWeight = (fs != null && fs >= 39) ? 300 : 400;
      st.fontVariantNumeric = 'tabular-nums';
    } else st.fontFamily = S.fonts.body;
  }
  // Text colour.
  if (typeof st.color === 'string') {
    const c = _deskColour(st.color);
    if (c) {
      const palette = [S.ink, S.muted, S.violetText, S.ochre, S.onPrimary].some((p) => _deskSame(c, p)) || _deskSame(c, S.ultraviolet) || _deskMeaningText(c);
      const light = _deskLum(c) > 0.75 && c.a >= 0.3;
      if (surface === 'uv') { if (light || !palette) st.color = S.onPrimary; }
      else if (light || (!palette && c.a < 1 && _deskLum(c) > 0.5)) st.color = (c.a >= 0.7) ? S.ink : S.muted;
      else if (!palette) {
        if (_deskMoney(text)) st.color = S.ochre;
        else {
          const fs = _studioPx(st.fontSize); const wt = Number(st.fontWeight) || 400;
          st.color = (wt >= 600 || (fs != null && fs >= 16)) ? S.ink : S.muted;
        }
      } else if (_deskSame(c, S.onPrimary) && surface !== 'uv') st.color = S.ink;
      // Violet is Eva and the one main action (decision 1, DECISIONS 176.125),
      // and the main action is the filled ultraviolet button (surface 'uv').
      // A control written in violet words is a second action: ink, weight 600
      // (STUDIO-LIT-PHONE-V1 item 8a; it stayed violet before). A figure or a
      // status word that is not a control, and not inside one, reads ink
      // (muted if small).
      else if (surface !== 'uv' && (control || ctl) && (_deskSame(c, S.violetText) || _deskSame(c, S.ultraviolet))) {
        st.color = S.ink;
        if (!((Number(st.fontWeight) || 400) >= 600)) st.fontWeight = 600;
      }
      else if (surface !== 'uv' && !control && !ctl && (_deskSame(c, S.violetText) || _deskSame(c, S.ultraviolet))) {
        const fs = _studioPx(st.fontSize); const wt = Number(st.fontWeight) || 400;
        st.color = (wt >= 600 || (fs != null && fs >= 16)) ? S.ink : S.muted;
      }
    }
  }
  if (type === 'input') { st.accentColor = S.ink; if (st.cursor === 'pointer' && !(_studioPx(st.height) >= 44)) st.height = 44; }
  return { style: st, surface, control };
}
// A drawing's strokes and fills (svg attributes and style.fill): the same
// roles, so a ring or a bar drawn in white or a hue reads on paper.
function _deskPaint(v) {
  const S = STUDIO_TOKENS;
  if (typeof v !== 'string') return v;
  const k = v.trim().toLowerCase();
  if (!k || k === 'none' || k === 'currentcolor' || k === 'inherit' || k.startsWith('url(')) return v;
  const c = _deskColour(v);
  if (!c) return v;
  if (_deskSame(c, S.violetText) || _deskSame(c, S.ultraviolet)) return S.ink;  // a drawn icon is not an action
  if ([S.ink, S.muted, S.ochre, S.lampAmber, S.onPrimary].some((p) => _deskSame(c, p)) || _deskMeaningFill(c)) return v;
  if (c.a < 0.05) return v;
  const warm = c.r >= c.g && c.g >= c.b && c.r - c.b > 60;
  if (_deskLum(c) > 0.75) return c.a >= 0.7 ? S.ink : c.a >= 0.35 ? S.muted : S.hairline;
  if (warm && c.a >= 0.4) return S.lampAmber;
  if (c.a >= 0.7) return _deskLum(c) < 0.2 ? S.ink : S.muted;
  return c.a >= 0.3 ? S.muted : S.hairline;
}
function _deskSvg(node) {
  if (Array.isArray(node)) return node.map(_deskSvg);
  if (!React.isValidElement(node)) return node;
  const props = node.props || {};
  const next = {};
  ['stroke', 'fill'].forEach((k) => { if (typeof props[k] === 'string') next[k] = _deskPaint(props[k]); });
  // Lamp amber is light only: words drawn in an svg that would come out amber read muted.
  if (node.type === 'text' && next.fill === STUDIO_TOKENS.lampAmber) next.fill = STUDIO_TOKENS.muted;
  if (props.style) {
    const st = Object.assign({}, props.style);
    ['fill', 'stroke'].forEach((k) => { if (typeof st[k] === 'string') st[k] = _deskPaint(st[k]); });
    if (/Georgia|serif/i.test(String(st.fontFamily || '')) && !/sans-serif/i.test(String(st.fontFamily || ''))) { st.fontFamily = STUDIO_TOKENS.fonts.display; st.fontStyle = 'normal'; st.fontWeight = 400; }
    if (st.textTransform) delete st.textTransform;
    next.style = st;
  }
  if (props.children === undefined) return React.cloneElement(node, next);
  const kids = _deskSvg(props.children);
  return Array.isArray(kids) ? React.cloneElement(node, next, ...kids) : React.cloneElement(node, next, kids);
}
function _deskNode(node, ctx, ctl) {
  if (Array.isArray(node)) return node.map((n) => _deskNode(n, ctx, ctl));
  if (!React.isValidElement(node)) return node;
  const type = node.type;
  if (type === 'style') return node;
  if (type === 'svg') return _deskSvg(node);
  const props = node.props || {};
  const next = {};
  let surface = ctx;
  let inControl = !!ctl;
  if (typeof type === 'string' && props.style) {
    const st = props.style;
    // A decorative glow: absolutely placed, untouchable, nothing in it.
    if (props.children == null && st.position === 'absolute' && (st.filter || st.background || st.backgroundColor)
      && (st.pointerEvents === 'none' || (st.borderRadius === '50%' && _studioPx(st.width) >= 50))) return null;
    const r = _deskStyle(type, st, props.children, props.onClick, ctx, inControl);
    next.style = r.style; surface = r.surface;
    if (r.control) inControl = true;
  }
  if (props.children === undefined) return React.cloneElement(node, next);
  const kids = _deskNode(props.children, surface, inControl);
  return Array.isArray(kids) ? React.cloneElement(node, next, ...kids) : React.cloneElement(node, next, kids);
}
function studioDesk(node) {
  return t.theme === 'uv' ? studioShape(_deskNode(node, 'paper')) : node;
}
// A desk screen's content is one readable column, not the full width of a monitor.
const studioColumn = { width: '100%', maxWidth: 960, alignSelf: 'center', boxSizing: 'border-box' };
// The same column inside a pane whose width is set by its parent (a swiped strip).
const studioWrapColumn = (node) => (t.theme === 'uv' ? <div style={{ width: '100%', maxWidth: 960, margin: '0 auto' }}>{node}</div> : node);
// Section heading (Sentient Regular 20), page title (Sentient Light 39).
const studioSection = () => ({ ...studioType.heading(), fontSize: 20, lineHeight: 1.2, letterSpacing: '-0.018em' });
const studioPageTitle = () => ({ ...studioType.title(), fontSize: 39, lineHeight: 1.1 });
// The open/closed mark on a toggle. Off: the glyph the screen always drew.
// On: a chevron drawn as a line, turned over when open (no arrow glyphs).
const studioCaret = (open, offUp = '▴', offDown = '▾') => (t.theme === 'uv'
  ? <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ transform: open ? 'rotate(180deg)' : 'none', verticalAlign: 'middle' }}><polyline points="6 9 12 15 18 9" /></svg>
  : (open ? offUp : offDown));
// A pound sign drawn beside its figure is two text nodes today ('£', '128.00').
// On, the figure carries its own pound sign in one node (ochre text must contain
// the pound), and the second slot is empty. Off: the same two nodes as before.
const studioPound = (figure) => (t.theme === 'uv' ? ['£' + figure, null] : ['£', figure]);
// The ' · ' the screen wrote as three text nodes (space, dot, space). On: a comma
// and a space in the first slot, the other two empty. Off: the three it wrote.
const studioDot3 = () => (t.theme === 'uv' ? [', ', null, null] : [' ', '·', ' ']);
// ==== STUDIO_DESK_END ====

const DirectorHomeScreen = ({ onNav, currentUser, onSwitchToPM }) => {
  const [data, setData] = useState(null);
  const [dirData, setDirData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const div = getDivisionConfig(currentUser);
  const divColor = t.colors.gold;

  useEffect(() => {
    Promise.all([
      _companyStatsFetch(),
      fetch(PORTAL_URL + '/api/director-stats').then(r => r.json()).catch(() => null),
    ]).then(([cs, ds]) => {
      setData(cs); setDirData(ds); setLoading(false);
    }).catch(e => { setError(_companyStatsErrorText(e)); setLoading(false); });
  }, []);

  const firstName = currentUser ? currentUser.name.split(" ")[0] : "Director";
  const hour = new Date().getHours();
  const greeting = hour < 12 ? "Good morning" : hour < 17 ? "Good afternoon" : "Good evening";
  const _todayLong = new Date().toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long" });
  const todayStr = t.theme === 'uv' ? _todayLong : _todayLong.toUpperCase();

  // S95 D21 — shared formatter
  const fmtMoney = (v) => formatCurrency(v);
  const fmtTime = (s) => { if (!s) return "0s"; const m = Math.floor(s / 60), r = s % 60; return m > 0 ? m + "m " + r + "s" : r + "s"; };

  const KpiCard = ({ label, value, sub, color, accent, big }) => studioDesk(
    <div style={{ background: "rgba(255,255,255,0.05)", border: "0.5px solid rgba(255,255,255,0.12)", borderRadius: 14, padding: "14px 16px", position: "relative", overflow: "hidden" }}>
      <div style={{ position: "absolute", top: -8, right: -8, width: 50, height: 50, borderRadius: "50%", background: accent, filter: "blur(25px)", opacity: 0.25, pointerEvents: "none" }} />
      <div style={{ fontSize: 10, fontWeight: 700, color: t.colors.textSecondary, textTransform: "uppercase", letterSpacing: 0.8, marginBottom: 6 }}>{label}</div>
      <div style={{ fontSize: 26, fontWeight: 700, letterSpacing: -1, lineHeight: 1, color, ...uvx(big ? () => ({ ...studioType.display(), fontSize: 84, color: STUDIO_TOKENS.ochre }) : {}) }}>{value}</div>
      {sub && <div style={{ fontSize: 11, color: t.colors.textSecondary, marginTop: 4 }}>{sub}</div>}
    </div>
  );

  // Derive insights from data
  const getInsights = () => {
    if (!data) return {};
    const pipeline = data.pipeline || {};
    const won = pipeline.won || {};
    const lost = pipeline.lost || {};
    const pending = pipeline.pending || {};
    const hot = data.hot_proposals || [];

    // Uninvoiced: won jobs minus invoiced_ids
    const invoicedIds = (dirData && dirData.invoiced_ids) || [];
    const wonCount = won.count || (dirData ? dirData.won_count : 0) || 0;
    const uninvoicedCount = Math.max(0, wonCount - invoicedIds.length);
    const uninvoicedValue = won.value ? Math.round(won.value * (uninvoicedCount / Math.max(1, wonCount))) : 0;

    // Stale proposals: in hot_proposals with 0 opens
    const stale = hot.filter(p => p.opens === 0);

    // Revenue velocity: won value / weeks elapsed this month
    const now = new Date();
    const dayOfMonth = now.getDate();
    const weeksElapsed = Math.max(1, dayOfMonth / 7);
    const monthWonValue = (dirData && dirData.month_won_value) || 0;
    const velocityPerWeek = Math.round(monthWonValue / weeksElapsed);
    // Compare to last month average (rough: total won / months active)
    const totalWonValue = won.value || 0;

    // Repeat clients: count clients appearing 2+ times in pm table data
    // (approximation from available data)

    return { pipeline, won, lost, pending, hot, invoicedIds, uninvoicedCount, uninvoicedValue, stale, velocityPerWeek, monthWonValue, totalWonValue };
  };

  return studioDesk(
    <div style={{ flex: 1, overflowY: "auto", WebkitOverflowScrolling: "touch", overscrollBehavior: "contain", paddingBottom: 100, background: "#E8DCC8", display: "flex", flexDirection: "column" }}>
      <div style={{ flex: 1, overflowY: "auto", WebkitOverflowScrolling: "touch", padding: "0 20px 24px", ...uvx(studioColumn) }}>
        {/* Greeting */}
        <div style={{ paddingTop: 56, ...uvx({ display: 'flex', flexDirection: 'column' }) }}>
          <div style={{ fontSize: 11, fontWeight: 600, color: t.colors.textTertiary, textTransform: "uppercase", letterSpacing: 1.2, marginBottom: 4, ...uvx({ order: 2, marginBottom: 18, fontSize: 14 }) }}>{todayStr}</div>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 18, ...uvx({ order: 1, marginBottom: 4 }) }}>
            <div style={{ fontSize: 26, fontWeight: 700, letterSpacing: -0.5, lineHeight: 1.2, ...uvx(studioPageTitle) }}>
              {greeting}, <span style={{ color: t.colors.gold }}>{firstName}.</span>
            </div>
            <div style={{ display:"flex", gap:8, alignItems:"center" }}>
              {onSwitchToPM && (
                <button onClick={onSwitchToPM} style={{ background: "rgba(255,255,255,0.06)", border: "0.5px solid rgba(255,255,255,0.12)", borderRadius: 20, padding: "5px 12px", fontSize: 11, fontWeight: 600, color: t.colors.textSecondary, cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap" }}>
                  My View
                </button>
              )}
              <button onClick={() => onNav(7)} style={{ display:"flex", alignItems:"center", justifyContent:"center", width:32, height:32, borderRadius:"50%", background:"rgba(255,255,255,0.05)", border:"0.5px solid rgba(255,255,255,0.10)", cursor:"pointer" }}>
                <Icon name="gear" size={15} color={t.colors.textSecondary} />
              </button>
            </div>
          </div>
        </div>

        {loading && (
          <div style={{ textAlign: "center", padding: "60px 0" }}>
            <div style={{ width: 28, height: 28, border: `3px solid ${t.colors.separator}`, borderTopColor: t.colors.gold, borderRadius: "50%", animation: "spin 0.8s linear infinite", margin: "0 auto 12px" }} />
            <p style={{ fontSize: 13, color: t.colors.textTertiary }}>Loading dashboard…</p>
          </div>
        )}

        {error && (
          <GlassCard style={{ textAlign: "center", padding: 32 }}>
            <p style={{ fontSize: 14, color: t.colors.textSecondary, marginBottom: 8 }}>{error}</p>
            {error === _companyStatsErrorText(null) && <p style={{ fontSize: 12, color: t.colors.textTertiary }}>Check your connection and try again.</p>}
          </GlassCard>
        )}

        {!loading && !error && data && (() => {
          const ins = getInsights();

          return (
            <>
              {/* KPI Grid */}
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 18 }}>
                {/* COMPANION-TRUTH-V2 B3: a missing month_value is the dash as its own text node, so it reads as the lone not-available mark (TASKS decision 15). */}
                <KpiCard label="Quotes This Month" value={data.month_quotes || 0} sub={data.month_quotes_delta > 0 ? "+" + data.month_quotes_delta + " vs last month" : data.month_quotes_delta < 0 ? data.month_quotes_delta + " vs last month" : fmtMoney(data.month_value) === TRUTH_DASH ? <>{TRUTH_DASH}{" value"}</> : fmtMoney(data.month_value) + " value"} color={t.colors.gold} accent={t.colors.gold} />
                <KpiCard label="Live Pipeline" value={fmtMoney((ins.pending.value || 0))} sub={(ins.pending.count || 0) + " pending"} color={t.colors.green} accent={t.colors.green} big />
                {/* COMPANION-TRUTH-V2 B5 (DECISIONS 176.135): company-stats win_rate is D7 over the financial year, so the label says so; the 90-day words are gone. */}
                <KpiCard label="Win rate" value={data.win_rate != null ? data.win_rate + "%" : TRUTH_DASH} sub="This financial year" color={t.colors.amber} accent={t.colors.amber} />
                <KpiCard label="Revenue Velocity" value={ins.velocityPerWeek ? fmtMoney(ins.velocityPerWeek) + "/wk" : "—"} sub={ins.monthWonValue ? fmtMoney(ins.monthWonValue) + " won this month" : "No wins yet"} color={t.colors.green} accent={t.colors.green} />
                <KpiCard label="Days to Win" value={data.avg_days_to_win != null ? data.avg_days_to_win + "d" : "—"} sub={data.fastest_win ? "Fastest: " + data.fastest_win + " days" : ""} color={t.colors.blue} accent={t.colors.blue} />
                <KpiCard label="Lost" value={(ins.lost.count || 0)} sub={fmtMoney(ins.lost.value || 0) + " value"} color={t.theme === 'uv' ? STUDIO_MEANING.slateText : t.colors.red} accent={t.theme === 'uv' ? STUDIO_MEANING.slateFill : t.colors.red} />
              </div>

              {/* Uninvoiced Work — the money card */}
              {ins.uninvoicedCount > 0 && (
                <GlassCard gold style={{ padding: 16, marginBottom: 12, border: "1px solid rgba(200,169,110,0.25)" }}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10 }}>
                    <div style={{ fontSize: 13, fontWeight: 700, display: "flex", alignItems: "center", gap: 7 }}>
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>Uninvoiced Work
                    </div>
                    <div style={{ fontSize: 11, fontWeight: 600, color: t.colors.amber, background: t.colors.amberLight, padding: "3px 10px", borderRadius: 20 }}>{t.theme === 'uv' ? 'Action' : 'ACTION'}</div>
                  </div>
                  <div style={{ fontSize: 28, fontWeight: 700, color: t.colors.gold, letterSpacing: -1 }}>{fmtMoney(ins.uninvoicedValue)}</div>
                  <div style={{ fontSize: 12, color: t.colors.textSecondary, marginTop: 4 }}>{ins.uninvoicedCount} won job{ins.uninvoicedCount !== 1 ? "s" : ""} not yet invoiced</div>
                </GlassCard>
              )}

              {/* Stale Proposals — zero engagement */}
              {ins.stale.length > 0 && (
                <GlassCard style={{ padding: 16, marginBottom: 12, border: t.theme === 'uv' ? 'none' : "1px solid rgba(255,90,90,0.15)" }}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10 }}>
                    <div style={{ fontSize: 13, fontWeight: 700, display: "flex", alignItems: "center", gap: 7 }}>
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/><line x1="1" y1="1" x2="23" y2="23"/></svg>Gone Silent
                    </div>
                    <div style={{ fontSize: 11, fontWeight: 600, color: t.colors.red, background: t.colors.redLight, padding: "3px 10px", borderRadius: 20 }}>{t.theme === 'uv' ? 'Chase' : 'CHASE'}</div>
                  </div>
                  <div style={{ fontSize: 12, color: t.colors.textSecondary, marginBottom: 8 }}>{ins.stale.length} proposal{ins.stale.length !== 1 ? "s" : ""} sent with zero client engagement</div>
                  {ins.stale.slice(0, 4).map((p, i) => (
                    <div key={i} style={{ display: "flex", alignItems: "center", gap: 8, padding: "6px 0", borderBottom: i < Math.min(ins.stale.length, 4) - 1 ? `1px solid ${t.colors.separator}` : "none" }}>
                      <span style={{ width: 26, height: 26, borderRadius: 7, display: "flex", alignItems: "center", justifyContent: "center", background: t.colors.redLight, flexShrink: 0 }}><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={t.colors.red} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/></svg></span>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontSize: 12, fontWeight: 600, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{p.client || p.job_id}</div>
                        <div style={{ fontSize: 10, color: t.colors.textTertiary }}>{'0 opens' + studioSep() + 'Needs chasing'}</div>
                      </div>
                    </div>
                  ))}
                </GlassCard>
              )}

              {/* Pipeline by Status */}
              <GlassCard style={{ padding: 16, marginBottom: 12 }}>
                <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 12, display: "flex", alignItems: "center", gap: 7 }}>
                  <span style={{ width: 7, height: 7, borderRadius: "50%", background: t.colors.gold }} />Pipeline by Status
                </div>
                {[{label:"Pending",color:t.colors.amber,d:ins.pending},{label:"Won",color:t.colors.green,d:ins.won},{label:"Lost",color:t.theme === 'uv' ? STUDIO_MEANING.slateText : t.colors.red,d:ins.lost}].map(st => (
                  <div key={st.label} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 0", borderBottom: `1px solid ${t.colors.separator}` }}>
                    <span style={{ fontSize: 12, color: t.colors.textSecondary, display: "flex", alignItems: "center", gap: 7 }}>
                      <span style={{ width: 7, height: 7, borderRadius: "50%", background: st.color }} />{st.label}
                    </span>
                    <span>
                      <span style={{ fontSize: 18, fontWeight: 700, color: st.color }}>{st.d.count || 0}</span>
                      <span style={{ fontSize: 11, color: t.colors.textTertiary, marginLeft: 6 }}>{fmtMoney(st.d.value || 0)}</span>
                    </span>
                  </div>
                ))}
              </GlassCard>

              {/* Hot Proposals */}
              {ins.hot.length > 0 && (
                <GlassCard style={{ padding: 16, marginBottom: 12 }}>
                  <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 12, display: "flex", alignItems: "center", gap: 7 }}>
                    <span style={{ width: 7, height: 7, borderRadius: "50%", background: t.colors.green }} />Hot Proposals
                  </div>
                  {ins.hot.filter(p => p.opens > 0).slice(0, 6).map((p, i) => {
                    const heat = p.opens >= 3 ? "fire" : "warm";
                    const heatIcon = heat === "fire" ? "fire" : "eye";
                    const heatBg = heat === "fire" ? t.colors.amberLight : t.colors.goldLight;
                    const heatColor = heat === "fire" ? t.colors.amber : t.colors.gold;
                    return (
                      <div key={i} style={{ display: "flex", alignItems: "center", gap: 10, padding: "8px 0", borderBottom: `1px solid ${t.colors.separator}` }}>
                        <div style={{ width: 32, height: 32, borderRadius: 9, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, background: heatBg }}>{heatIcon === "fire" ? <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={heatColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"/></svg> : <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={heatColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>}</div>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ fontSize: 12, fontWeight: 600, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{p.client || p.job_id || "Unknown"}</div>
                          <div style={{ fontSize: 10, color: t.colors.textTertiary, marginTop: 1 }}>{p.opens}{' opens' + studioSep()}{fmtTime(p.total_time)}{studioSep()}{p.max_scroll}{'% scrolled'}{p.signed ? studioSep() + "Signed" : ""}</div>
                        </div>
                        <div style={{ fontSize: 16, fontWeight: 700, color: heatColor, flexShrink: 0 }}>{p.opens}</div>
                      </div>
                    );
                  })}
                </GlassCard>
              )}

              {/* PM League Table */}
              {data.pm_table && data.pm_table.length > 0 && (
                <GlassCard style={{ padding: 16, marginBottom: 12 }}>
                  <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 12, display: "flex", alignItems: "center", gap: 7 }}>
                    <span style={{ width: 7, height: 7, borderRadius: "50%", background: t.colors.blue }} />PM League Table
                  </div>
                  {data.pm_table.map((pm, i) => {
                    const maxQ = Math.max(...data.pm_table.map(p => p.quoted));
                    const barW = maxQ > 0 ? Math.round(pm.quoted / maxQ * 100) : 0;
                    const rankBg = i < 2 ? t.colors.goldLight : t.colors.blueLight;
                    const rankColor = i < 2 ? t.colors.gold : t.colors.blue;
                    return (
                      <div key={i} style={{ display: "flex", alignItems: "center", padding: "8px 0", borderBottom: i < data.pm_table.length - 1 ? `1px solid ${t.colors.separator}` : "none", gap: 10 }}>
                        <div style={{ width: 18, height: 18, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 10, fontWeight: 700, flexShrink: 0, background: rankBg, color: rankColor }}>{i + 1}</div>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ fontSize: 13, fontWeight: 600, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{pm.name || "Unknown"}</div>
                          <div style={{ fontSize: 11, color: t.colors.textTertiary, marginTop: 1 }}>{pm.quoted}{' quoted' + studioSep()}{fmtMoney(pm.value || 0)}{' pipeline'}</div>
                        </div>
                        <div style={{ width: 40, height: 4, background: t.colors.separator, borderRadius: 2, flexShrink: 0 }}>
                          <div style={{ height: "100%", borderRadius: 2, background: t.colors.gold, width: barW + "%" }} />
                        </div>
                        <div style={{ fontSize: 14, fontWeight: 700, color: pm.win_rate != null ? t.colors.green : t.colors.textTertiary, flexShrink: 0, minWidth: 32, textAlign: "right" }}>{pm.win_rate != null ? pm.win_rate + "%" : "—"}</div>
                      </div>
                    );
                  })}
                </GlassCard>
              )}

              {/* Division Split */}
              <GlassCard style={{ padding: 16, marginBottom: 12 }}>
                <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 12, display: "flex", alignItems: "center", gap: 7 }}>
                  <span style={{ width: 7, height: 7, borderRadius: "50%", background: t.colors.amber }} />Division Split
                </div>
                {(() => { const divisions = data.divisions || {}; const ld = divisions.lighting || {}; const ad = divisions.aircon || {}; return (
                <div style={{ display: "flex", gap: 10 }}>
                  <div style={{ flex: 1, padding: 14, borderRadius: 10, textAlign: "center", background: t.colors.goldLight, border: "1px solid rgba(200,169,110,0.15)" }}>
                    <div style={{ fontSize: 10, fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 4, color: t.colors.gold }}>Lighting</div>
                    <div style={{ fontSize: 22, fontWeight: 700, color: t.colors.gold }}>{fmtMoney(ld.value || 0)}</div>
                    <div style={{ fontSize: 10, color: t.colors.textTertiary, marginTop: 3 }}>{ld.count || 0}{' proposals' + studioSep()}{ld.won || 0}{' won'}</div>
                  </div>
                  <div style={{ flex: 1, padding: 14, borderRadius: 10, textAlign: "center", background: t.colors.blueLight, border: "1px solid rgba(91,155,213,0.15)" }}>
                    <div style={{ fontSize: 10, fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 4, color: t.colors.blue }}>Mechanicalditioning</div>
                    <div style={{ fontSize: 22, fontWeight: 700, color: t.colors.blue }}>{fmtMoney(ad.value || 0)}</div>
                    <div style={{ fontSize: 10, color: t.colors.textTertiary, marginTop: 3 }}>{ad.count || 0}{' proposals' + studioSep()}{ad.won || 0}{' won'}</div>
                  </div>
                </div>); })()}
              </GlassCard>

              {/* Repeat Business */}
              {data.repeat_clients && data.repeat_clients.length > 0 && (
                <GlassCard style={{ padding: 16, marginBottom: 12 }}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12 }}>
                    <div style={{ fontSize: 13, fontWeight: 700, display: "flex", alignItems: "center", gap: 7 }}>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/></svg>Repeat Business
                    </div>
                    <div style={{ fontSize: 11, fontWeight: 600, color: t.colors.green, background: t.colors.greenLight, padding: "3px 10px", borderRadius: 20 }}>{t.theme === 'uv' ? 'Loyalty' : 'LOYALTY'}</div>
                  </div>
                  <div style={{ fontSize: 12, color: t.colors.textSecondary, marginBottom: 10 }}>{data.repeat_count} of {data.total_clients} clients have come back</div>
                  {data.repeat_clients.slice(0, 5).map((c, i) => {
                    const wrColor = c.win_rate != null ? (c.win_rate >= 60 ? t.colors.green : c.win_rate >= 40 ? t.colors.amber : t.colors.red) : t.colors.textTertiary;
                    return (
                      <div key={i} style={{ display: "flex", alignItems: "center", gap: 8, padding: "7px 0", borderBottom: i < Math.min(data.repeat_clients.length, 5) - 1 ? `1px solid ${t.colors.separator}` : "none" }}>
                        <span style={{ width: 26, height: 26, borderRadius: 7, display: "flex", alignItems: "center", justifyContent: "center", background: t.colors.greenLight, flexShrink: 0 }}><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={t.colors.green} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg></span>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ fontSize: 12, fontWeight: 600, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{c.name}</div>
                          <div style={{ fontSize: 10, color: t.colors.textTertiary }}>{c.proposals}{' proposals' + studioSep()}{fmtMoney(c.value)}{' total'}</div>
                        </div>
                        <div style={{ fontSize: 13, fontWeight: 700, color: wrColor, flexShrink: 0 }}>{c.win_rate != null ? c.win_rate + "%" : "—"}</div>
                      </div>
                    );
                  })}
                </GlassCard>
              )}
            </>
          );
        })()}

        {/* Empty state when no data */}
        {!loading && !error && data && !data.month_quotes && (!data.pipeline || Object.keys(data.pipeline).length === 0) && (
          <GlassCard style={{ textAlign: "center", padding: "40px 24px" }}>
            <Icon name="chart" size={40} color={t.colors.textTertiary} />
            <p style={{ fontSize: 16, fontWeight: 700, color: t.colors.textSecondary, marginTop: 12 }}>No data yet</p>
            <p style={{ fontSize: 13, color: t.colors.textTertiary, marginTop: 4 }}>Once the team starts generating proposals, your dashboard will populate here.</p>
          </GlassCard>
        )}
      </div>
      <TabBar active={0} onChange={onNav} divisionId={div && div.id ? div.id : "lighting"} />
    </div>
  );
};

// ════════════════════════════════════════════════════
// SCREEN 1: DASHBOARD — SALES COMMAND CENTRE
// ════════════════════════════════════════════════════

// ── Pipeline Drawer (bottom sheet) ─────────────────
const PipelineDrawer = ({ projects, filter, onClose, onOpenProject, onUpdateProject, divColor, STAGES }) => {
  const [activeFilter, setActiveFilter] = useState(filter || "all");
  const stageOf = (p) => STAGES.find(s => s.id === (p.stage || "enquiry")) || STAGES[0];

  const filtered = projects.filter(p => {
    if (activeFilter === "all") return true;
    if (activeFilter === "active") return !["won","lost"].includes(p.stage || "enquiry");
    return (p.stage || "enquiry") === activeFilter;
  }).sort((a, b) => (b.lastProposal?.capex || 0) - (a.lastProposal?.capex || 0));

  const totalValue = filtered.reduce((s, p) => s + (p.lastProposal?.capex || 0), 0);
  const chipFilters = [
    { id: "all", label: "All" },
    { id: "active", label: "Active" },
    { id: "proposed", label: "Proposed", color: t.colors.purple },
    { id: "won", label: "Won", color: t.colors.green },
    { id: "lost", label: "Lost", color: t.theme === 'uv' ? STUDIO_MEANING.slateText : t.colors.red },  // Lost is slate under the theme (item 8a)
  ];

  return (
    <SheetPortal>
    <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", zIndex: 500, display: "flex", flexDirection: "column", justifyContent: "flex-end" }}>
      <div onClick={e => e.stopPropagation()} style={{ background: t.colors.bg, borderRadius: "20px 20px 0 0", maxHeight: "85vh", display: "flex", flexDirection: "column", boxShadow: "0 -8px 40px rgba(0,0,0,0.3)" }}>
        {/* Handle */}
        <div style={{ display: "flex", justifyContent: "center", padding: "12px 0 0" }}>
          <div style={{ width: 36, height: 4, borderRadius: 2, background: t.colors.separator }} />
        </div>
        {/* Header */}
        <div style={{ padding: "12px 20px 8px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <p style={{ fontSize: 16, fontWeight: 800, color: t.colors.text, letterSpacing: -0.4 }}>All Projects</p>
          {totalValue > 0 && <p style={{ fontSize: 13, fontWeight: 700, color: divColor }}>{formatCurrency(totalValue)} total</p>}
        </div>
        {/* Filter chips */}
        <div style={{ padding: "0 20px 10px", display: "flex", gap: 8, overflowX: "auto" }}>
          {chipFilters.map(f => (
            <button key={f.id} onClick={() => setActiveFilter(f.id)} style={{
              padding: "6px 14px", borderRadius: 99, border: "none", cursor: "pointer", flexShrink: 0,
              background: activeFilter === f.id ? (f.color || divColor) : "rgba(255,255,255,0.06)",
              color: activeFilter === f.id ? "#fff" : t.colors.textSecondary,
              fontSize: 12, fontWeight: 700, transition: "all 0.2s ease",
            }}>{f.label}</button>
          ))}
        </div>
        {/* Project list */}
        <div style={{ flex: 1, overflowY: "auto", WebkitOverflowScrolling: "touch", padding: "0 20px 32px" }}>
          {filtered.length === 0 ? (
            <p style={{ textAlign: "center", color: t.colors.textTertiary, fontSize: 13, padding: "32px 0" }}>No projects in this stage</p>
          ) : filtered.map(proj => {
            const stage = stageOf(proj);
            const daysSince = proj.updatedAt ? Math.floor((Date.now() - proj.updatedAt) / 86400000) : null;
            return (
              <div key={proj.id} onClick={() => onOpenProject(proj)} style={{ padding: "13px 0", borderBottom: `0.5px solid ${t.colors.separator}`, cursor: "pointer" }}>
                <div style={{ display: "flex", alignItems: "flex-start", gap: 12 }}>
                  <div style={{ width: 36, height: 36, borderRadius: 10, background: `${stage.color}14`, border: `0.5px solid ${stage.color}30`, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, marginTop: 2 }}>
                    <Icon name="building" size={16} color={stage.color} />
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 2 }}>
                      <p style={{ fontSize: 14, fontWeight: 700, color: t.colors.text, letterSpacing: -0.2 }}>{proj.name}</p>
                      <span style={{ fontSize: 10, fontWeight: 700, color: stage.color, background: `${stage.color}14`, borderRadius: 6, padding: "1px 6px" }}>{stage.label}</span>
                    </div>
                    <p style={{ fontSize: 11, color: t.colors.textSecondary }}>{proj.client}{proj.contact ? ` · ${proj.contact}` : ""}</p>
                    <div style={{ display: "flex", gap: 10, marginTop: 4, flexWrap: "wrap" }}>
                      {proj.lastProposal?.capex > 0 && <span style={{ fontSize: 11, fontWeight: 700, color: divColor }}>{formatCurrency(proj.lastProposal.capex)} {proj.lastProposal.tierLabel}</span>}
                      {daysSince !== null && <span style={{ fontSize: 11, color: daysSince > 14 ? t.colors.red : t.colors.textTertiary }}>{daysSince === 0 ? "Today" : `${daysSince}d ago`}</span>}
                      {proj.surveyZones?.length > 0 && <span style={{ fontSize: 11, color: t.colors.textTertiary }}>{proj.surveyZones.length} zones</span>}
                    </div>
                  </div>
                  <div style={{ display: "flex", gap: 6, alignItems: "center", flexShrink: 0 }}>
                    {!["won","lost"].includes(proj.stage) && (
                      <>
                        <button onClick={e => { e.stopPropagation(); onUpdateProject(proj.id, { stage: "won" }); }} style={{ background: t.colors.green, border: "none", borderRadius: 8, padding: "5px 10px", cursor: "pointer", color: "#fff", fontSize: 12, fontWeight: 800 }}>Won</button>
                        <button onClick={e => { e.stopPropagation(); handleLost(proj); }} style={{ background: t.theme === 'uv' ? STUDIO_MEANING.slateFill : t.colors.red, border: "none", borderRadius: 8, padding: "5px 10px", cursor: "pointer", color: "#fff", fontSize: 12, fontWeight: 800 }}>Lost</button>
                      </>
                    )}
                    {proj.stage === "lost" && (
                      <button onClick={e => { e.stopPropagation(); onUpdateProject(proj.id, { stage: "proposed" }); }} style={{ background: `${t.colors.orange}20`, border: `0.5px solid ${t.colors.orange}50`, borderRadius: 8, padding: "5px 10px", cursor: "pointer", color: t.colors.orange, fontSize: 12, fontWeight: 800 }}>↩ Restore</button>
                    )}
                    {proj.stage === "won" && (
                      <button onClick={e => { e.stopPropagation(); onUpdateProject(proj.id, { stage: "proposed" }); }} style={{ background: `${t.colors.textSecondary}15`, border: `0.5px solid ${t.colors.textSecondary}30`, borderRadius: 8, padding: "5px 10px", cursor: "pointer", color: t.colors.textSecondary, fontSize: 12, fontWeight: 700 }}>↩ Reopen</button>
                    )}
                    <Icon name="chevron" size={14} color={t.colors.textTertiary} />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
    </SheetPortal>
  );
};

// ════════════════════════════════════════════════════
// WIN/LOSS DEBRIEF MODAL
// ════════════════════════════════════════════════════
const LOSS_REASONS = [
  { id: "price", label: "Price too high", icon: "dollar" },
  { id: "competitor", label: "Lost to competitor", icon: "flag" },
  { id: "incumbent", label: "Went with incumbent", icon: "refresh" },
  { id: "cancelled", label: "Cancelled / postponed", icon: "pause" },
  { id: "scope", label: "Spec / scope mismatch", icon: "ruler" },
  { id: "silent", label: "No response / went silent", icon: "mute" },
];

const LossIcon = ({ name, color, size = 14 }) => {
  const props = { width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" };
  switch (name) {
    case "dollar": return <svg {...props}><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>;
    case "flag": return <svg {...props}><path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"/><line x1="4" y1="22" x2="4" y2="15"/></svg>;
    case "refresh": return <svg {...props}><polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/></svg>;
    case "pause": return <svg {...props}><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></svg>;
    case "ruler": return <svg {...props}><path d="M21 3L3 21"/><path d="M21 3l-4 0 0 4"/><path d="M3 21l4 0 0-4"/><path d="M15 3l-6 6"/><path d="M21 9l-6 6"/></svg>;
    case "mute": return <svg {...props}><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/></svg>;
    default: return null;
  }
};

const DebriefModal = ({ project, onSubmit, onCancel, divColor }) => {
  const [selectedReason, setSelectedReason] = useState(null);
  const [freeText, setFreeText] = useState("");
  const [competitorName, setCompetitorName] = useState("");

  const handleSubmit = () => {
    const debrief = {
      reason: selectedReason,
      reasonLabel: (LOSS_REASONS.find(r => r.id === selectedReason) || {}).label || selectedReason,
      competitor: selectedReason === "competitor" ? competitorName : undefined,
      notes: freeText.trim() || undefined,
      timestamp: new Date().toISOString(),
    };
    onSubmit(debrief);
  };

  return (
    <SheetPortal>
    <div style={{ position: "fixed", inset: 0, zIndex: 9999, background: "rgba(0,0,0,0.85)", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}
      onClick={e => { if (e.target === e.currentTarget) onCancel(); }}>
      <div style={{ width: "100%", maxWidth: 400, background: t.colors.bg, borderRadius: t.radius.xl, border: `0.5px solid ${t.colors.glassBorder}`, overflow: "hidden" }}>
        <div style={{ padding: "20px 20px 0", textAlign: "center" }}>
          <div style={{ width: 48, height: 48, borderRadius: "50%", background: t.colors.redLight, display: "inline-flex", alignItems: "center", justifyContent: "center", marginBottom: 12 }}>
            <Icon name="flag" size={22} color={t.colors.red} />
          </div>
          <h3 style={{ fontSize: 18, fontWeight: 800, color: t.colors.text, letterSpacing: -0.3 }}>Why did we lose this?</h3>
          <p style={{ fontSize: 13, color: t.colors.textSecondary, marginTop: 4 }}>{project?.name || "Project"} · {project?.client || ""}</p>
        </div>
        <div style={{ padding: "16px 20px", display: "flex", flexWrap: "wrap", gap: 8 }}>
          {LOSS_REASONS.map(r => (
            <button key={r.id} onClick={() => setSelectedReason(r.id)} style={{
              padding: "8px 14px", borderRadius: t.radius.pill, cursor: "pointer", fontSize: 13, fontWeight: 600,
              background: selectedReason === r.id ? `${t.colors.red}20` : t.colors.glass,
              border: `1px solid ${selectedReason === r.id ? t.colors.red : t.colors.glassBorder}`,
              color: selectedReason === r.id ? t.colors.red : t.colors.textSecondary,
              transition: "all 0.15s ease",
            }}>
              <LossIcon name={r.icon} color={selectedReason === r.id ? t.colors.red : t.colors.textSecondary} /> {r.label}
            </button>
          ))}
        </div>
        {selectedReason === "competitor" && (
          <div style={{ padding: "0 20px 8px" }}>
            <input value={competitorName} onChange={e => setCompetitorName(e.target.value)}
              placeholder="Who did we lose to?"
              style={{ width: "100%", padding: "10px 14px", background: t.colors.glass, border: `0.5px solid ${t.colors.glassBorder}`,
                borderRadius: t.radius.md, color: t.colors.text, fontSize: 13, fontFamily: "system-ui, -apple-system, sans-serif", outline: "none" }} />
          </div>
        )}
        <div style={{ padding: "0 20px 16px" }}>
          <textarea value={freeText} onChange={e => setFreeText(e.target.value)}
            placeholder="Anything else worth knowing? (optional)"
            rows={3} style={{ width: "100%", padding: "10px 14px", background: t.colors.glass, border: `0.5px solid ${t.colors.glassBorder}`,
              borderRadius: t.radius.md, color: t.colors.text, fontSize: 13, fontFamily: "system-ui, -apple-system, sans-serif", resize: "none", outline: "none", lineHeight: 1.5 }} />
        </div>
        <div style={{ padding: "0 20px 20px", display: "flex", gap: 10 }}>
          <button onClick={onCancel} style={{ flex: 1, padding: "12px", borderRadius: t.radius.md, background: t.colors.glass,
            border: `0.5px solid ${t.colors.glassBorder}`, color: t.colors.textSecondary, fontSize: 14, fontWeight: 700, cursor: "pointer" }}>Cancel</button>
          <button onClick={handleSubmit} disabled={!selectedReason} style={{
            flex: 2, padding: "12px", borderRadius: t.radius.md, cursor: selectedReason ? "pointer" : "default",
            background: selectedReason ? t.colors.red : `${t.colors.red}30`,
            border: "none", color: "#fff", fontSize: 14, fontWeight: 800, opacity: selectedReason ? 1 : 0.5,
          }}>Mark as Lost</button>
        </div>
      </div>
    </div>
    </SheetPortal>
  );
};

// COMPANION-STUDIO-LIT-V1 track 3b: the ONE stale-quote rule, used by Today's
// chase list and Pipeline's "No reply in over a week". A quote is stale when it
// is still open (not won or lost) and more than 7 days have passed since its
// last update. Lifted unchanged from TodayScreen, so Today's list (and its
// order) is exactly what it was. `list` is already division-filtered.
const staleQuoteList = (list, nowMs) => {
  const out = [];
  (list || []).forEach(p => {
    if (['won', 'lost'].includes(p.status)) return;
    const updated = p.updatedAt || p.createdAt || 0;
    const daysSince = Math.floor((nowMs - new Date(updated).getTime()) / 86400000);
    if (daysSince > 7) {
      out.push({ proposal: p, daysSince });
    }
  });
  return out;
};

// COMPANION-STUDIO-LIT-V1 track 3b: Today's chase sheet (S95 D15: Call, Voice
// note, Log update to /api/touchpoints) as a component, so Pipeline's Chase
// opens the same action. The markup, the payload and the queue fallback are
// TodayScreen's, copied unchanged; `source` names the screen that sent it.
// TodayScreen still draws its own inline copy (track 3a is in review and this
// track may not touch TodayScreen); moving Today onto this component is owed
// (docs/studio-lit/FINDINGS.md, track 3b).
const chaseProposalPhone = (p) => {
  if (p.clientPhone) return p.clientPhone;
  if (p.contactPhone) return p.contactPhone;
  try {
    const stored = JSON.parse(localStorage.getItem('lumen_contacts') || '{}');
    const contacts = (stored.contacts || stored || []);
    const clientName = (p.client || p.projectClient || '').toLowerCase();
    const match = (Array.isArray(contacts) ? contacts : []).find(c => (c.company||'').toLowerCase() === clientName || (c.name||'').toLowerCase() === clientName);
    return match?.phone || '';
  } catch(e) { return ''; }
};
// Track 4 (switch on): a quote that is not stale (7 days or fewer since its last
// update) is not "unanswered"; the sheet says when it last changed. The stale
// wording is unchanged, and so is everything with the switch off.
const chaseAgeLine = (days) => (days <= 0 ? 'Last update today' : `Last update ${days} day${days === 1 ? '' : 's'} ago`);
const ChaseSheet = ({ item, onClose, onNav, currentUser, source }) => {
  const [chaseStep, setChaseStep] = useState('menu'); // 'menu' | 'log' | 'sent'
  const [chaseLogText, setChaseLogText] = useState('');
  const [chaseSending, setChaseSending] = useState(false);
  const p = item.proposal;
  const submitChaseLog = async () => {
    const text = (chaseLogText || '').trim();
    if (!text) return;
    setChaseSending(true);
    const payload = {
      project_id: p.projectId || null,
      proposal_id: p.id || p.proposalId || null,
      client: p.client || p.projectClient || '',
      quote_ref: (p.quoteRef || p.reference || '').replace('SP-L','').trim(),
      kind: 'chase_update',
      body: text,
      source: source || 'companion-today',
      recorded_at: new Date().toISOString(),
      user: currentUser?.name || currentUser?.email || null,
    };
    try {
      const tk = localStorage.getItem('lumen_token');
      const res = await fetch(`${PORTAL_URL}/api/touchpoints`, {
        method: 'POST',
        headers: Object.assign({ 'Content-Type': 'application/json' }, tk ? { 'Authorization': `Bearer ${tk}` } : {}),
        body: JSON.stringify(payload)
      });
      bearerRefused(res.status, tk, 'touchpoint');   // track C: a 401 ends the sign-in; the write is queued below
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
    } catch(e) {
      console.error('[chase] touchpoint POST failed:', e);
      queueWrite('/api/touchpoints', payload);
    }
    setChaseSending(false);
    setChaseStep('sent');
    // auto-close after confirmation
    setTimeout(() => onClose(), 1400);
  };
  const phone = chaseProposalPhone(p);
  const telHref = phone ? `tel:${phone.replace(/\s+/g,'')}` : null;
  const rawRef = (p.quoteRef || p.reference || '').replace('SP-L','').trim();
  const title = p.client || p.projectName || p.projectClient || (rawRef ? `Quote ${rawRef}` : 'Quote');
  // Switch on: studioShape applies the shared Studio rules (type scale, no
  // capitals, no dot, 44px targets); the scrim is the ground sand (as the
  // Studio lightboxes), the action tiles are pressed sand with ink glyphs,
  // and "Log it" is the one ultraviolet main action.
  const chaseGlyph = t.theme === 'uv' ? STUDIO_TOKENS.ink : 'white';
  return studioShape(
    <SheetPortal>
      <div onClick={onClose} style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', zIndex:9000, touchAction:'none', ...uvx(() => ({ background: studioRgba(STUDIO_TOKENS.ground.base, 0.85) })) }} />
      <div onClick={(e)=>e.stopPropagation()} role="dialog" aria-modal="true" style={{ position:'fixed', top:'50%', left:'50%', transform:'translate(-50%,-50%)', width:'calc(100% - 48px)', maxWidth:360, maxHeight:'calc(100dvh - 48px)', overflowY:'auto', background:t.colors.paperSolid, borderRadius:t.radius.lg, padding:'18px 18px 22px', boxShadow:t.shadow.dialog, zIndex:9001 }}>
        <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:4 }}>
          <div style={{ width:8, height:8, borderRadius:'50%', background:t.colors.staleDot, boxShadow:t.shadow.staleDot }} />
          <div style={{ fontSize:15, fontWeight:800, color:t.colors.text, flex:1, minWidth:0, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{title}</div>
          <button onClick={onClose} aria-label="Close" style={{ width:44, height:44, borderRadius:10, background:t.colors.ink06, border:'none', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:'inherit' }}>
            <svg width="12" height="12" viewBox="0 0 10 10" fill="none" stroke={t.colors.stone5} strokeWidth="1.5" strokeLinecap="round"><line x1="2" y1="2" x2="8" y2="8"/><line x1="8" y1="2" x2="2" y2="8"/></svg>
          </button>
        </div>
        <div style={{ fontSize:11, color:t.colors.ink5, marginBottom:14 }}>
          {t.theme === 'uv' && item.daysSince <= 7 ? chaseAgeLine(item.daysSince) : <>{item.daysSince} days unanswered</>}{rawRef ? `${studioSep()}Quote ${rawRef}` : ''}
        </div>

        {chaseStep === 'menu' && (
          <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
            {/* Call — S95 D15b: hide the row entirely when no phone stored */}
            {telHref && (
              <a href={telHref} onClick={() => { /* tel: handled by OS */ }} style={{ display:'flex', alignItems:'center', gap:12, padding:'14px 16px', minHeight:56, background:t.colors.green10, border:`1px solid ${t.colors.green28}`, borderRadius:14, textDecoration:'none', color:t.colors.text }}>
                <div style={{ width:40, height:40, borderRadius:10, background:t.colors.green, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0, ...uvx(studioSurface.pressed) }}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={chaseGlyph} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
                </div>
                <div style={{ flex:1, minWidth:0 }}>
                  <div style={{ fontSize:14, fontWeight:700 }}>Call</div>
                  <div style={{ fontSize:12, color:t.colors.ink55, marginTop:2 }}>{phone}</div>
                </div>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={t.colors.ink4} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
              </a>
            )}

            {/* Voice note */}
            <button onClick={() => {
              // Carry project context into the voice recorder
              try {
                localStorage.setItem('lumen_voice_context', JSON.stringify({
                  source: 'chase', projectId: p.projectId || null,
                  client: p.client || '', quoteRef: rawRef, at: new Date().toISOString(),
                }));
              } catch(e) {}
              onClose();
              onNav(9); // voice notes screen (CENSUS F3)
            }} style={{ display:'flex', alignItems:'center', gap:12, padding:'14px 16px', minHeight:56, background:t.colors.gold10, border:`1px solid ${t.colors.gold28}`, borderRadius:14, cursor:'pointer', fontFamily:'inherit', textAlign:'left' }}>
              <div style={{ width:40, height:40, borderRadius:10, background:t.colors.goldInk, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0, ...uvx(studioSurface.pressed) }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={chaseGlyph} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" y1="19" x2="12" y2="23"/><line x1="8" y1="23" x2="16" y2="23"/></svg>
              </div>
              <div style={{ flex:1, minWidth:0 }}>
                <div style={{ fontSize:14, fontWeight:700, color:t.colors.text }}>Voice note</div>
                <div style={{ fontSize:12, color:t.colors.ink55, marginTop:2 }}>Quick audio log against this job</div>
              </div>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={t.colors.ink4} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            </button>

            {/* Log update */}
            <button onClick={() => setChaseStep('log')} style={{ display:'flex', alignItems:'center', gap:12, padding:'14px 16px', minHeight:56, background:t.colors.teal08, border:`1px solid ${t.colors.teal24}`, borderRadius:14, cursor:'pointer', fontFamily:'inherit', textAlign:'left' }}>
              <div style={{ width:40, height:40, borderRadius:10, background:t.colors.teal, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0, ...uvx(studioSurface.pressed) }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={chaseGlyph} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>
              </div>
              <div style={{ flex:1, minWidth:0 }}>
                <div style={{ fontSize:14, fontWeight:700, color:t.colors.text }}>Log update</div>
                <div style={{ fontSize:12, color:t.colors.ink55, marginTop:2 }}>{t.theme === 'uv' ? 'A written note on the portal timeline' : 'Text touchpoint → portal timeline'}</div>
              </div>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={t.colors.ink4} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            </button>
          </div>
        )}

        {chaseStep === 'log' && (
          <div>
            <label style={{ fontSize:10, fontWeight:t.font.lw800, color:t.colors.khaki, textTransform:'uppercase', letterSpacing:t.font.ls07, marginBottom:6, display:'block' }}>Update</label>
            <textarea
              value={chaseLogText}
              onChange={e => setChaseLogText(e.target.value)}
              autoFocus
              placeholder="e.g. Left voicemail with John. He said he'd review and come back Thursday."
              style={{ width:'100%', minHeight:120, background:'rgba(255,255,255,0.75)', border:`1px solid ${t.colors.ink12}`, borderRadius:12, padding:'12px 14px', fontSize:14, fontFamily:'inherit', color:t.colors.text, outline:'none', resize:'vertical' }} />
            <div style={{ display:'flex', gap:8, marginTop:12 }}>
              <button onClick={() => setChaseStep('menu')} style={{ flex:'0 0 auto', minHeight:44, padding:'0 18px', borderRadius:10, background:t.colors.ink06, border:`1px solid ${t.colors.ink12}`, color:t.colors.text, fontSize:13, fontWeight:700, cursor:'pointer', fontFamily:'inherit' }}>Back</button>
              <button onClick={submitChaseLog} disabled={chaseSending || !chaseLogText.trim()} style={{ flex:1, minHeight:44, padding:'0 18px', borderRadius:10, background: chaseSending ? t.colors.green5 : t.colors.green, border:'none', color:t.colors.onFill, fontSize:14, fontWeight:800, cursor: chaseSending||!chaseLogText.trim() ? 'default':'pointer', fontFamily:'inherit', opacity: !chaseLogText.trim() ? 0.55 : 1, ...uvx(() => ({ ...studioSurface.primary(), flex: 1, padding: '0 18px', cursor: chaseSending||!chaseLogText.trim() ? 'default' : 'pointer', opacity: !chaseLogText.trim() ? 0.55 : 1 })) }}>
                {chaseSending ? 'Saving…' : 'Log it'}
              </button>
            </div>
          </div>
        )}

        {chaseStep === 'sent' && (
          <div style={{ padding:'24px 12px', textAlign:'center' }}>
            <div style={{ width:48, height:48, margin:'0 auto 10px', borderRadius:'50%', background:t.colors.green15, display:'flex', alignItems:'center', justifyContent:'center' }}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={t.colors.green} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
            </div>
            <div style={{ fontSize:15, fontWeight:800, color:t.colors.green }}>Logged to timeline</div>
          </div>
        )}
      </div>
    </SheetPortal>
  );
};

const TodayScreen = ({ onNav, projects: allProjects, proposals, setActiveProject, currentUser, onDeleteProject, onUpdateProject, restoreAvailable, onRestore, onDismissRestore, isDirector, onSwitchToDirector }) => {
  const div = getDivisionConfig(currentUser);
  const projects = allProjects.filter(p => !p.division || p.division === div.id);
  const divId = div.id || "lighting";
  const divColor = divId === "aircon" ? t.colors.blue : t.colors.gold;

  // ── Brief open state for visit cards ──
  const [openBriefs, setOpenBriefs] = React.useState({});
  const toggleBrief = (id) => setOpenBriefs(prev => ({ ...prev, [id]: !prev[id] }));

  // ── Forecast data ──
  const monthlyTarget = parseFloat(readMyMonthlyTarget()) || 0;
  const quarterlyTarget = monthlyTarget * 3;

  const activeProposals = proposals.filter(p => !['won','lost'].includes(p.status));
  const forecastAmount = activeProposals.reduce((sum, p) => {
    const prob = parseFloat(p.winProbability || p.win_probability || 0) / 100;
    const val = parseFloat(p.value || p.totalValue || 0);
    return sum + (val * prob);
  }, 0);

  const now = new Date();
  const monthlyForecast = activeProposals
    .filter(p => {
      const d = new Date(p.updatedAt || p.createdAt || 0);
      return d.getMonth() === now.getMonth() && d.getFullYear() === now.getFullYear();
    })
    .reduce((sum, p) => sum + (parseFloat(p.value || 0) * (parseFloat(p.winProbability || 0) / 100)), 0);

  const ringPercent = quarterlyTarget > 0 ? Math.min(100, Math.round((forecastAmount / quarterlyTarget) * 100)) : 0;
  const monthlyPercent = monthlyTarget > 0 ? Math.min(100, Math.round((monthlyForecast / monthlyTarget) * 100)) : 0;

  const verdict = ringPercent < 50 ? 'Getting started'
    : ringPercent < 75 ? 'Needs attention'
    : ringPercent < 90 ? 'On track'
    : 'Strong';
  const verdictDot = ringPercent < 50 ? '#C85040'
    : ringPercent < 75 ? '#C89030'
    : ringPercent < 90 ? '#7FE8A0'
    : '#40E8A0';

  const needleQuote = [...activeProposals].sort((a, b) => parseFloat(b.value || 0) - parseFloat(a.value || 0))[0];
  let needleTip = '';
  if (needleQuote && quarterlyTarget > 0) {
    const newForecast = forecastAmount + parseFloat(needleQuote.value || 0) * (1 - parseFloat(needleQuote.winProbability || 0) / 100);
    const newPct = Math.round((newForecast / quarterlyTarget) * 100);
    const ref = (needleQuote.quoteRef || needleQuote.reference || '').replace('SP-L', '');
    if (ref) needleTip = `Winning quote ${ref} takes you to ${newPct}%`;
  }

  // S95 D21 — shared formatter; return without £ prefix for legacy {'\u00a3'}{fmtCurrency(v)} sites
  const fmtCurrency = (v) => formatCurrency(v).replace(/^\u00a3/, '');

  // ── Visits (Your Day) ──
  const visits = JSON.parse(localStorage.getItem('lumen_visits') || '[]');
  const todayStr = new Date().toISOString().split('T')[0];
  const todayVisitsRaw = visits.filter(v => {
    const vDate = (v.date || '').split('T')[0];
    const show = vDate === todayStr;
    console.log(`[Today] Visit "${v.name}" date="${vDate}" today="${todayStr}" — ${show ? 'SHOW' : 'HIDE'}`);
    return show;
  }).sort((a, b) => (a.time || '').localeCompare(b.time || ''));
  // S95 D20 — collapse duplicates for the same site (e.g. a lingering "planned"
  // visit after the live/submitted survey has begun). Priority submitted > live > planned;
  // only the most-progressed card for a given site-name key renders.
  const visitStatusRank = { submitted: 3, live: 2, planned: 1 };
  const todayVisits = (() => {
    const winnerIdxByKey = new Map();
    todayVisitsRaw.forEach((v, i) => {
      const key = (v.projectName || v.name || '').trim().toLowerCase();
      if (!key) { winnerIdxByKey.set(`__nokey_${i}`, i); return; }
      const rank = visitStatusRank[v.status] || 0;
      const prev = winnerIdxByKey.get(key);
      if (prev === undefined) { winnerIdxByKey.set(key, i); return; }
      const prevRank = visitStatusRank[todayVisitsRaw[prev].status] || 0;
      if (rank > prevRank) winnerIdxByKey.set(key, i);
    });
    const keep = new Set(winnerIdxByKey.values());
    return todayVisitsRaw.filter((_, i) => keep.has(i));
  })();
  const upcomingVisits = visits.filter(v => {
    const vDate = (v.date || '').split('T')[0];
    return vDate > todayStr;
  }).sort((a, b) => ((a.date || '').split('T')[0]).localeCompare((b.date || '').split('T')[0]));
  // P0 tidy: "Connect your calendar" is gone. Its only action opened More, which
  // has no calendar to connect, and nothing in the app ever wrote the flag it
  // read (lumen_calendar_connected), so the card could never go away.

  const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  const todayFormatted = `${dayNames[now.getDay()]} ${now.getDate()} ${monthNames[now.getMonth()]}`;

  const openMaps = (address) => {
    const encoded = encodeURIComponent(address);
    const isApple = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    const url = isApple ? `maps://maps.apple.com/?q=${encoded}` : `https://maps.google.com/?q=${encoded}`;
    window.open(url, '_blank');
  };

  // ── Surveys ──
  // S99: 'live' state means at least one fitting logged. Projects in
  // 'planned' state (no fittings yet) are still listed under active so
  // mid-prep work surfaces here, matching pre-S99 behaviour where
  // scopeAnswers/customZones counted as active.
  const activeSurveys = allProjects.filter(p => {
    const s = getSurveyState(p);
    if (s === 'live') return true;
    if (s === 'planned' && p.scopeAnswers && Object.keys(p.scopeAnswers).length >= 6) return true;
    return false;
  });
  activeSurveys.sort((a, b) => {
    const aInProgress = getSurveyState(a) === 'live' ? 0 : 1;
    const bInProgress = getSurveyState(b) === 'live' ? 0 : 1;
    return aInProgress - bInProgress;
  });

  // ── Actions (division-filtered — Lighting users must not see AC quotes) ──
  const todayDiv = getDivisionConfig(currentUser);
  const divProposals = (proposals || []).filter(p => p.division === todayDiv.id || !p.division);
  // COMPANION-TRUTH-V1 (b): the quotes waiting on you are the portal's D10
  // jobs (truthWaitingRows), the rows Pipeline's "No reply in over a week"
  // draws too; the count beside them is the D10 count, null when the figures
  // were never fetched.
  const staleQuotes = truthWaitingRows(proposals);
  const waitingCount = truthWaitingCount();

  // ── S103 — Intelligence cards: categorise + sort by urgency ──
  // Cards are pulled from the lumen_intelligence portal cache (filled
  // by syncPortalData). Each card carries an insight_type that maps to
  // one of four categories. We render them grouped under accordion
  // shelves on the Today screen — most-urgent category expanded by
  // default, others collapsed. Within a category, sort by severity
  // (high→medium→low) then created_at desc.
  const _intelDataRaw = getPortalData('lumen_intelligence', { cards: [] });
  const _intelCardsAll = (_intelDataRaw.cards || []);
  const _SEVERITY_WEIGHT = { high: 3, medium: 2, low: 1 };

  // S104 — every insight_type the portal can emit needs a destination.
  // S103 only mapped 4 keys (pipeline/commercial/financial/operational)
  // but the portal aliases `type AS insight_type`, and the underlying
  // intelligence_engine.py:INSIGHT_TYPES list has ~14 detailed types
  // (relationship, stale_pipeline, grow_campaign, ...) — none of those
  // were in the S103 map, so every real card resolved to navTarget=null
  // and tapped dead. The expanded map below covers every type.
  //
  // Routing principle: most insights are about open work, deals, or
  // engagement — those land in Pipeline. Margin / pricing / ROI cards
  // land in Worth where the won-vs-lost margin benchmarking lives.
  // streak_director_note is explicit-null because it's director-only
  // and shouldn't be tappable if it accidentally surfaces on a PM's
  // Today screen.
  const _CATEGORY_NAV = {
    // Pipeline-shaped — open work, deals, engagement, prospects
    pipeline:           18,
    commercial:         18,
    operational:        18,
    relationship:       18,
    stale_pipeline:     18,
    engagement_signal:  18,
    engagement_cold:    18,
    opportunity:        18,
    client_returning:   18,
    conversion_insight: 18,
    risk:               18,
    strategic:          18,
    grow_epc:           18,
    grow_tender:        18,
    grow_campaign:      18,
    // Margin / financial — Worth holds the won-vs-lost benchmarks
    financial:          15,
    pricing_outlier:    15,
    missing_roi:        15,
    win_pattern:        15,
    // Director-only insight — never tappable from PM Today even if it
    // somehow leaks into the payload.
    streak_director_note: null,
  };
  // Resolve a card's nav target. `key in map` distinguishes explicit
  // null (intentionally inert) from absent (unknown type → land
  // somewhere useful instead of dead). Default fallback: PipelineScreen.
  const _navForType = (key) =>
    (key in _CATEGORY_NAV) ? _CATEGORY_NAV[key] : 18;
  // Display helper — turns "stale_pipeline" → "Stale Pipeline" so
  // shelf headers don't show raw underscores. Pure display only;
  // the underlying card.insight_type stays unchanged.
  const _formatCategoryLabel = (key) =>
    String(key || '')
      .split('_')
      .filter(Boolean)
      .map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
      .join(' ');

  const _intelByCategory = new Map();
  for (const card of _intelCardsAll) {
    const k = (card && card.insight_type) || 'pipeline';
    if (!_intelByCategory.has(k)) _intelByCategory.set(k, []);
    _intelByCategory.get(k).push(card);
  }
  for (const arr of _intelByCategory.values()) {
    arr.sort((a, b) => {
      const wA = _SEVERITY_WEIGHT[a.severity] || 0;
      const wB = _SEVERITY_WEIGHT[b.severity] || 0;
      if (wA !== wB) return wB - wA;
      return String(b.created_at || '').localeCompare(String(a.created_at || ''));
    });
  }
  const intelCategoryGroups = Array.from(_intelByCategory.entries())
    .map(([key, items]) => ({
      key,
      label: _formatCategoryLabel(key),
      navTarget: _navForType(key),
      items,
      urgencyScore: items.reduce((s, c) => s + (_SEVERITY_WEIGHT[c.severity] || 0), 0),
    }))
    .sort((a, b) => b.urgencyScore - a.urgencyScore);
  const intelCardsCount = _intelCardsAll.length;
  const flaggedCount = waitingCount == null ? TRUTH_DASH : waitingCount + intelCardsCount;

  // Same tri-state accordion pattern as SurveyLandingScreen monthState
  // (S101): only populated for explicit toggles. Untouched categories
  // fall back to idx === 0 ? 'expanded' : 'collapsed'.
  const [intelCategoryState, setIntelCategoryState] = useState(() => new Map());
  const isIntelCategoryExpanded = (key, idx) => {
    if (intelCategoryState.has(key)) return intelCategoryState.get(key) === 'expanded';
    return idx === 0;
  };
  const toggleIntelCategory = (key, idx) => {
    const wasExpanded = isIntelCategoryExpanded(key, idx);
    setIntelCategoryState(prev => {
      const next = new Map(prev);
      next.set(key, wasExpanded ? 'collapsed' : 'expanded');
      return next;
    });
  };
  const _intelSeverityDot = (sev) =>
    sev === 'high'   ? t.colors.alert :
    sev === 'medium' ? t.colors.sevMedium :
                       t.colors.stoneMid;

  // ── Morning briefing state ──
  const [briefingOpen, setBriefingOpen] = useState(false);
  const [briefingData, setBriefingData] = useState(() => readCachedBriefing());
  const [briefingRead, setBriefingRead] = useState(() => {
    try { return localStorage.getItem('lumen_briefing_read_' + new Date().toISOString().split('T')[0]) === '1'; } catch(e) { return false; }
  });
  // S95 D15 — Gone Silent "Chase now" action sheet
  const [chaseSheet, setChaseSheet] = useState(null); // { proposal, daysSince } | null
  const [chaseStep, setChaseStep] = useState('menu'); // 'menu' | 'log' | 'sent'
  const [chaseLogText, setChaseLogText] = useState('');
  const [chaseSending, setChaseSending] = useState(false);
  const openChaseSheet = (item) => { setChaseSheet(item); setChaseStep('menu'); setChaseLogText(''); };
  const closeChaseSheet = () => { setChaseSheet(null); setChaseStep('menu'); setChaseLogText(''); setChaseSending(false); };
  const getProposalPhone = (p) => {
    if (p.clientPhone) return p.clientPhone;
    if (p.contactPhone) return p.contactPhone;
    try {
      const stored = JSON.parse(localStorage.getItem('lumen_contacts') || '{}');
      const contacts = (stored.contacts || stored || []);
      const clientName = (p.client || p.projectClient || '').toLowerCase();
      const match = (Array.isArray(contacts) ? contacts : []).find(c => (c.company||'').toLowerCase() === clientName || (c.name||'').toLowerCase() === clientName);
      return match?.phone || '';
    } catch(e) { return ''; }
  };
  const submitChaseLog = async () => {
    if (!chaseSheet) return;
    const p = chaseSheet.proposal;
    const text = (chaseLogText || '').trim();
    if (!text) return;
    setChaseSending(true);
    const payload = {
      project_id: p.projectId || null,
      proposal_id: p.id || p.proposalId || null,
      client: p.client || p.projectClient || '',
      quote_ref: (p.quoteRef || p.reference || '').replace('SP-L','').trim(),
      kind: 'chase_update',
      body: text,
      source: 'companion-today',
      recorded_at: new Date().toISOString(),
      user: currentUser?.name || currentUser?.email || null,
    };
    try {
      const tk = localStorage.getItem('lumen_token');
      const res = await fetch(`${PORTAL_URL}/api/touchpoints`, {
        method: 'POST',
        headers: Object.assign({ 'Content-Type': 'application/json' }, tk ? { 'Authorization': `Bearer ${tk}` } : {}),
        body: JSON.stringify(payload)
      });
      bearerRefused(res.status, tk, 'touchpoint');   // track C: a 401 ends the sign-in; the write is queued below
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
    } catch(e) {
      console.error('[chase] touchpoint POST failed:', e);
      queueWrite('/api/touchpoints', payload);
    }
    setChaseSending(false);
    setChaseStep('sent');
    // auto-close after confirmation
    setTimeout(() => closeChaseSheet(), 1400);
  };
  const [showAddVisitSheet, setShowAddVisitSheet] = useState(false);
  const [newVisitType, setNewVisitType] = useState(null);
  const [newVisitName, setNewVisitName] = useState('');
  const [newVisitContact, setNewVisitContact] = useState('');
  const [contactSuggestions, setContactSuggestions] = useState([]);
  const [showContactDrop, setShowContactDrop] = useState(false);
  const [newVisitTime, setNewVisitTime] = useState('');
  const [newVisitDate, setNewVisitDate] = useState(() => new Date().toISOString().split('T')[0]);
  const [newVisitNotes, setNewVisitNotes] = useState('');
  const [newVisitAddress, setNewVisitAddress] = useState('');
  const [newVisitPostcode, setNewVisitPostcode] = useState('');
  // B.2 — capture-time project binding for a logged visit. Same id-only
  // channel (canonical PRJ or explicit null) and shared picker that surveys,
  // snags and voice use; never name-matched. The portal canonicalises this
  // id and stamps the site_visit_scheduled project_id COLUMN so the visit
  // routes onto the bound project's contact card.
  const [visitBinding, setVisitBinding] = useState(null);
  const [visitPickerOpen, setVisitPickerOpen] = useState(false);
  // Contact id-binding: the picked cs_contacts canonical id. Null when
  // the field is free-typed (typing ≠ picking — never name-matched).
  const [newVisitContactId, setNewVisitContactId] = useState(null);
  // Loading + refs for the contact picker's fetch-fallback. When the
  // lumen_contacts cache is empty on this device the field would silently look
  // like a plain text box (no match -> no dropdown), so we fetch portal
  // contacts inline once, populate the shared cache, and re-filter against the
  // latest keystroke. _contactQRef holds the newest query so the async
  // re-filter uses it (not a stale closure); _contactFetchedRef fires the fetch
  // at most once per open, and is reset on failure so a later keystroke retries.
  const [contactsLoading, setContactsLoading] = useState(false);
  const [contactsError, setContactsError] = useState(false); // fetch-fallback failed (auth/network) — surfaced, not silent
  const _contactQRef = useRef('');
  const _contactFetchedRef = useRef(false);
  const _contactFocusedRef = useRef(false); // field has focus — gates the async reopen so a late fetch can't reopen under a blurred field
  const _readContactsCache = () => {
    try {
      const stored = JSON.parse(localStorage.getItem('lumen_contacts') || '{}');
      const contacts = (stored.contacts || stored || []);
      return Array.isArray(contacts) ? contacts : [];
    } catch (e) { return []; }
  };
  const _filterContacts = (list, val) => {
    const q = (val || '').toLowerCase();
    return (Array.isArray(list) ? list : []).filter(c =>
      (c.name||'').toLowerCase().includes(q) || (c.company||'').toLowerCase().includes(q)
    ).slice(0, 4);
  };
  const handleContactInput = (val) => {
    setNewVisitContact(val);
    setNewVisitContactId(null); // typing clears any prior pick — only a suggestion click binds
    _contactQRef.current = val;
    if (val.length < 2) { setContactSuggestions([]); setShowContactDrop(false); setContactsError(false); return; }
    const local = _readContactsCache();
    setContactSuggestions(_filterContacts(local, val));
    setShowContactDrop(true); // open once >=2 chars — the empty state shows when nothing matches
    // Fetch-fallback: empty cache on this device -> fetch portal contacts once,
    // populate the shared cache, then re-filter against the latest keystroke.
    if (local.length === 0 && !_contactFetchedRef.current) {
      _contactFetchedRef.current = true;
      setContactsLoading(true);
      setContactsError(false);
      (async () => {
        try {
          const _tk = localStorage.getItem('lumen_token');
          const r = await fetch(`${PORTAL_URL}/api/companion/contacts`, {
            headers: Object.assign({}, _tk ? { 'Authorization': `Bearer ${_tk}` } : {}),
            credentials: 'include',
          });
          if (!r.ok) throw new Error('HTTP ' + r.status);
          const data = await r.json();
          localStorage.setItem('lumen_contacts', JSON.stringify(data));
          localStorage.setItem('lumen_contacts_synced_at', new Date().toISOString());
          setContactsError(false);
          const q = _contactQRef.current;
          if (q && q.length >= 2) {
            const fresh = Array.isArray(data.contacts) ? data.contacts : [];
            setContactSuggestions(_filterContacts(fresh, q));
            if (_contactFocusedRef.current) setShowContactDrop(true); // don't reopen under a blurred field
          }
        } catch (e) {
          _contactFetchedRef.current = false; // allow a later keystroke to retry
          setContactsError(true); // loud (§9): a real fetch failure is a visible "couldn't load" state, never a false "no contacts"
        } finally {
          setContactsLoading(false);
        }
      })();
    }
  };
  const clearVisitModal = () => {
    setShowAddVisitSheet(false); setNewVisitType(null);
    setNewVisitName(''); setNewVisitContact('');
    setContactSuggestions([]); setShowContactDrop(false);
    setNewVisitTime(''); setNewVisitDate(new Date().toISOString().split('T')[0]);
    setNewVisitNotes(''); setNewVisitAddress(''); setNewVisitPostcode('');
    setVisitBinding(null); setVisitPickerOpen(false); setNewVisitContactId(null);
    setContactsLoading(false); setContactsError(false); _contactFetchedRef.current = false; _contactQRef.current = ''; _contactFocusedRef.current = false;
  };
  const firstName = (currentUser?.name || 'there').split(' ')[0];
  const todayHour = new Date().getHours();
  const greeting = todayHour >= 5 && todayHour < 12 ? "Good morning" : todayHour >= 12 && todayHour < 18 ? "Good afternoon" : "Good evening";

  // ── Pull-to-refresh ──
  const [todayPullY, setTodayPullY] = useState(0);
  const [todayIsPulling, setTodayIsPulling] = useState(false);
  const [todayIsSyncing, setTodayIsSyncing] = useState(false);
  // COMPANION-TRUTH-V1: the time the figures on this screen were fetched, the
  // oldest _synced_at of the keys they read (truthSyncedTime), not a stamp
  // written after every pull whether or not any read succeeded.
  const [lastSyncTime, setLastSyncTime] = useState(() => truthSyncedTime());
  const todayPullRef = React.useRef({ startY: 0, active: false });
  const handleTodayPullStart = (e) => { todayPullRef.current = { startY: e.touches[0].clientY, active: true }; };
  const handleTodayPullMove = (e) => {
    if (!todayPullRef.current.active) return;
    if (e.currentTarget.scrollTop > 0) return;
    const dist = e.touches[0].clientY - todayPullRef.current.startY;
    if (dist > 0 && dist < 80) { setTodayPullY(dist); setTodayIsPulling(true); }
  };
  const handleTodayPullEnd = async () => {
    if (todayIsPulling && todayPullY > 60) {
      setTodayIsSyncing(true);
      await syncPortalData();
      setLastSyncTime(truthSyncedTime());
      setTodayIsSyncing(false);
    }
    setTodayPullY(0);
    setTodayIsPulling(false);
    todayPullRef.current.active = false;
  };

  // ── Briefing fetch ──
  // This is the call site that poisoned the cache. It sent no Authorization
  // header against an endpoint the portal gates, took no `r.ok` check, and
  // wrote the resulting `{error: 'Unauthorised'}` into today's cache entry --
  // which the briefing screen then read as truthy, short-circuiting its OWN
  // correctly-authed fetch. The unfixed writer defeated the fixed reader every
  // day, because Today is the home screen and mounts first.
  React.useEffect(() => {
    if (briefingData) return;
    const token = (() => { try { return localStorage.getItem('lumen_token'); } catch(e) { return null; } })();
    fetch(PORTAL_URL + '/api/companion/briefing',
          { headers: token ? { 'Authorization': `Bearer ${token}` } : {} })
      .then(r => { if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.json(); })
      .then(payload => {
        const briefing = briefingFromPayload(payload);
        // No briefing generated for this user today is a NORMAL answer, not a
        // failure: cache nothing and leave the strip absent. Only a validated
        // briefing is ever stored.
        if (!briefing) return;
        setBriefingData(briefing);
        cacheBriefing(briefing);
      })
      .catch(e => {
        try {
          console.warn('[briefing] Today-screen fetch failed: '
            + ((e && e.message) ? e.message : String(e))
            + (token ? '' : ' (no lumen_token in storage -- signed out?)'));
        } catch (e2) {}
      });
  }, []);

  // ── Dashboard intelligence: streaks, personal bests, weekly movement ──
  // S95 D5 — fabricated placeholder numbers (previously {current:8,best:14,…})
  // were misleading users. Per brief: compute from real local data (lumen_visits,
  // portal-synced proposals, portal_events) and show em-dash when nothing is
  // available. Portal endpoints, once live, override the computed values.
  const emptyStreaks = {
    platform: { current: 0, best: 0, best_range: null, history: [] },
    builder:  { current: 0, best: 0, best_range: null, history: [] },
    closer:   { current: 0, best: 0, best_range: null, history: [] },
    weeks_since_joining: null,
    active_week_rate: null,
  };
  const emptyMovement = {
    new_enquiries: null,
    quoted: null,
    won: null,
    went_silent: null,
    pipeline_delta: null,
  };
  // S95 D5 — real streak + best computation from local + portal-synced data.
  // Week key = ISO year-week (Mon→Sun). Consecutive-week streak terminates on
  // the first miss walking back from the current week.
  const computedIntel = React.useMemo(() => {
    const isoWeek = (d) => {
      const date = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
      const day = date.getUTCDay() || 7;
      date.setUTCDate(date.getUTCDate() + 4 - day);
      const ys = new Date(Date.UTC(date.getUTCFullYear(), 0, 1));
      const wk = Math.ceil((((date - ys) / 86400000) + 1) / 7);
      return `${date.getUTCFullYear()}-W${String(wk).padStart(2,'0')}`;
    };
    // ── Source arrays (resilient to absent keys) ──
    const visits = (() => { try { return JSON.parse(localStorage.getItem('lumen_visits') || '[]'); } catch(e) { return []; } })();
    const portalEvents = (() => { try { return JSON.parse(localStorage.getItem('portal_events') || '[]'); } catch(e) { return []; } })();
    const portalSync = (() => { try { return JSON.parse(localStorage.getItem('lumen_portal_sync') || '[]'); } catch(e) { return []; } })();
    const pros = Array.isArray(proposals) ? proposals : [];
    // ── Weekly flags for each streak dimension ──
    const platformWeeks = new Set();
    const builderWeeks = new Set();
    const closerWeeks = new Set();
    const mark = (set, ts) => { if (!ts) return; const d = new Date(ts); if (isNaN(d.getTime())) return; set.add(isoWeek(d)); };
    visits.forEach(v => mark(platformWeeks, v.date || v.createdAt));
    portalSync.forEach(s => mark(platformWeeks, s.ts || s.at || s.timestamp));
    portalEvents.forEach(e => mark(platformWeeks, e.ts || e.at || e.created_at));
    pros.forEach(p => {
      const ts = p.createdAt || p.updatedAt || p.date || p.sentAt;
      mark(platformWeeks, ts);
      mark(builderWeeks, ts);
    });
    portalEvents.filter(e => e.type === 'quote_won' || e.event === 'quote_won').forEach(e => mark(closerWeeks, e.ts || e.at || e.created_at));
    pros.filter(p => p.won === true || p.status === 'won').forEach(p => mark(closerWeeks, p.wonAt || p.updatedAt || p.date));
    // ── Build 14-week history arrays (oldest→newest) and compute current+best ──
    const histAndStreak = (weekSet) => {
      const hist = [];
      const now = new Date();
      const startOfWeek = new Date(now); startOfWeek.setDate(now.getDate() - 13 * 7);
      for (let i = 0; i < 14; i++) {
        const d = new Date(startOfWeek); d.setDate(startOfWeek.getDate() + i * 7);
        hist.push(weekSet.has(isoWeek(d)) ? 1 : 0);
      }
      // Current streak walks back from the most recent week until a miss.
      let current = 0;
      for (let i = hist.length - 1; i >= 0; i--) {
        if (hist[i]) current++; else break;
      }
      // Best streak is the longest consecutive run of 1s in the recorded history.
      let best = 0, run = 0;
      for (const h of hist) { if (h) { run++; if (run > best) best = run; } else { run = 0; } }
      return { current, best, best_range: null, history: hist };
    };
    const streaks = {
      platform: histAndStreak(platformWeeks),
      builder:  histAndStreak(builderWeeks),
      closer:   histAndStreak(closerWeeks),
      weeks_since_joining: null,
      active_week_rate: platformWeeks.size > 0 ? Math.round((platformWeeks.size / 14) * 100) : null,
    };
    // ── Personal bests (shared helper; see module-scope definition) ──
    const records = computePersonalBestsFromProposals(pros);
    // Movement (this week vs last) — derived from real proposals only.
    const nowD = new Date();
    const thisWeek = isoWeek(nowD);
    const lastWeekD = new Date(nowD); lastWeekD.setDate(nowD.getDate() - 7);
    const lastWeek = isoWeek(lastWeekD);
    const perWeek = (pred) => {
      const a = { tw: 0, lw: 0 };
      pros.forEach(p => {
        if (!pred(p)) return;
        const d = new Date(p.createdAt || p.date || 0);
        if (isNaN(d.getTime())) return;
        const w = isoWeek(d);
        if (w === thisWeek) a.tw++; else if (w === lastWeek) a.lw++;
      });
      return a;
    };
    const enq = perWeek(p => (p.status === 'enquiry' || p.status === 'new' || !p.status));
    const quoted = perWeek(p => quoteIsLive(p.status));
    const won = perWeek(p => p.won === true || p.status === 'won');
    const pipeTW = pros.filter(p => { const d = new Date(p.createdAt || p.date || 0); return !isNaN(d.getTime()) && isoWeek(d) === thisWeek; }).reduce((s,p)=>s+parseFloat(p.value||p.totalValue||0),0);
    const pipeLW = pros.filter(p => { const d = new Date(p.createdAt || p.date || 0); return !isNaN(d.getTime()) && isoWeek(d) === lastWeek; }).reduce((s,p)=>s+parseFloat(p.value||p.totalValue||0),0);
    const movement = {
      new_enquiries: pros.length > 0 ? (enq.tw - enq.lw) : null,
      quoted: pros.length > 0 ? (quoted.tw - quoted.lw) : null,
      won: pros.length > 0 ? won.tw : null,
      went_silent: null,
      pipeline_delta: pros.length > 0 ? Math.round(pipeTW - pipeLW) : null,
    };
    return { streaks, bests: { records }, movement };
  }, [proposals]);
  const [streaksData, setStreaksData] = useState(() => {
    try {
      const cached = JSON.parse(localStorage.getItem('lumen_streaks') || 'null');
      if (cached && cached.data && cached.data.platform) return cached.data;
    } catch(e) {}
    return null;
  });
  const [personalBests, setPersonalBests] = useState(() => {
    try {
      const cached = JSON.parse(localStorage.getItem('lumen_personal_bests') || 'null');
      if (cached && cached.data && Array.isArray(cached.data.records) && cached.data.records.length > 0) return cached.data;
    } catch(e) {}
    return null;
  });
  const [movementData, setMovementData] = useState(() => {
    try {
      const cached = JSON.parse(localStorage.getItem('lumen_movement') || 'null');
      if (cached && cached.data) return cached.data;
    } catch(e) {}
    return null;
  });
  React.useEffect(() => {
    const tk = localStorage.getItem('lumen_token');
    const authHeaders = tk ? { Authorization: `Bearer ${tk}` } : {};
    const todayKey = new Date().toISOString().split('T')[0];
    fetch(PORTAL_URL + '/api/companion/streaks', { headers: authHeaders })
      .then(r => r.ok ? r.json() : null)
      .then(d => { if (d && d.platform) { setStreaksData(d); try { localStorage.setItem('lumen_streaks', JSON.stringify({ date: todayKey, data: d })); } catch(e) {} } })
      .catch(() => {});
    fetch(PORTAL_URL + '/api/companion/personal-bests', { headers: authHeaders })
      .then(r => r.ok ? r.json() : null)
      .then(d => { if (d && Array.isArray(d.records)) { setPersonalBests(d); try { localStorage.setItem('lumen_personal_bests', JSON.stringify({ date: todayKey, data: d })); } catch(e) {} } })
      .catch(() => {});
    fetch(PORTAL_URL + '/api/companion/movement', { headers: authHeaders })
      .then(r => r.ok ? r.json() : null)
      .then(d => { if (d && typeof d === 'object') { setMovementData(d); try { localStorage.setItem('lumen_movement', JSON.stringify({ date: todayKey, data: d })); } catch(e) {} } })
      .catch(() => {});
  }, []);
  // Effective values: prefer portal response, else computed-from-local, else zero shape.
  const effStreaks  = streaksData || computedIntel.streaks || emptyStreaks;
  const effBests    = personalBests || computedIntel.bests || { records: [] };
  const effMovement = movementData || computedIntel.movement || emptyMovement;
  // COMPANION-TRUTH-V1: went_silent for a user with no live jobs shows
  // nothing, not 0. The portal answers 0 then, so the phone draws the cell's
  // null state unless the portal's live count (D2) says there are live jobs;
  // with no pipeline cache that is not known, and it is null too.
  const truthLiveJobs = truthLiveCount();
  const wentSilentShown = (truthLiveJobs != null && truthLiveJobs > 0 && effMovement) ? (effMovement.went_silent ?? null) : null;

  // Ring SVG constants
  const ringR = 32;
  const ringCirc = 2 * Math.PI * ringR; // ~201.06

  // Save visit helper
  const saveVisit = () => {
    if (!newVisitType || !newVisitName.trim()) return;
    const surveyId = newVisitType === 'survey' ? ('proj_' + Date.now() + '_' + Math.random().toString(36).slice(2,8)) : undefined;
    // B.2 — the picked binding (canonical PRJ id, or explicit null for "No
    // project" / unbound). The id is the ONLY routable identity sent to the
    // portal; a name is never sent as identity (skill §11).
    const _vb = (visitBinding && typeof visitBinding === 'object') ? visitBinding : null;
    const _vProjectId = _vb ? (_vb.project_id || null) : null;
    const visits2 = JSON.parse(localStorage.getItem('lumen_visits') || '[]');
    visits2.push({
      id: 'v_' + Date.now(),
      date: newVisitDate || todayStr,
      type: newVisitType,
      name: newVisitName.trim(),
      projectName: newVisitName.trim(),
      contact: newVisitContact.trim(),
      contact_id: newVisitContactId || null,
      time: newVisitTime || '',
      notes: newVisitNotes || '',
      address: newVisitAddress.trim() || undefined,
      postcode: newVisitPostcode.trim() || undefined,
      createdAt: Date.now(),
      surveyId: surveyId || undefined,
      status: newVisitType === 'survey' ? 'planned' : undefined,
      project_id: _vProjectId,
      projectBinding: _vb || undefined,
    });
    localStorage.setItem('lumen_visits', JSON.stringify(visits2));
    // For survey type, also write to survey_queue
    if (newVisitType === 'survey' && surveyId) {
      try {
        const sq = JSON.parse(localStorage.getItem('survey_queue') || '[]');
        sq.push({
          id: surveyId,
          name: newVisitName.trim(),
          contact: newVisitContact.trim(),
          status: 'planned',
          createdAt: Date.now(),
        });
        localStorage.setItem('survey_queue', JSON.stringify(sq));
      } catch(e) {}
    }
    // B.2 — send the visit to the portal so it mirrors a site_visit_scheduled
    // event. Carries the picked project_id (PART A canonicalises it and stamps
    // the event's project_id COLUMN, which is what routes the visit onto the
    // bound project's contact card). Fire-and-forget with the same offline
    // queue every other companion write uses: a queued payload replays through
    // flushOfflineQueue byte-for-byte, so project_id survives an offline log.
    const _visitPayload = {
      type: newVisitType,
      name: newVisitName.trim(),
      contact: newVisitContact.trim(),
      contact_id: newVisitContactId || null,
      date: newVisitDate || todayStr,
      survey_id: surveyId || null,
      notes: newVisitNotes || '',
      status: newVisitType === 'survey' ? 'planned' : 'planned',
      project_id: _vProjectId,
    };
    (async () => {
      if (!navigator.onLine) { queueWrite('/api/companion/visits', _visitPayload); return; }
      try {
        const _tk = localStorage.getItem('lumen_token');
        const r = await fetch(`${PORTAL_URL}/api/companion/visits`, {
          method: 'POST',
          headers: Object.assign({ 'Content-Type': 'application/json' }, _tk ? { 'Authorization': `Bearer ${_tk}` } : {}),
          body: JSON.stringify(_visitPayload),
        });
        bearerRefused(r.status, _tk, 'visit');   // track C: a 401 ends the sign-in; the write is queued below
        if (!r.ok) throw new Error('HTTP ' + r.status);
        debugLog('visit.post.ok', { project_id: _vProjectId || null, contact_id: newVisitContactId || null, type: newVisitType });
      } catch (e) {
        queueWrite('/api/companion/visits', _visitPayload);
        debugLog('visit.post.queued', { project_id: _vProjectId || null, contact_id: newVisitContactId || null, reason: (e && e.message) || String(e) });
      }
    })();
    clearVisitModal();
  };

  // Active survey project detection. S99: state classification goes
  // through getSurveyState — 'live' means at least one fitting logged.
  // Won/lost is a separate lifecycle dimension and stays as a direct
  // stage check; getSurveyState is concerned with the survey loop only.
  const activeSurveyProj = allProjects.find(p =>
    getSurveyState(p) === 'live' &&
    !['won','lost'].includes(p.stage || 'enquiry')
  );

  // ── Stats strip values for briefing card (division-filtered) ──
  // COMPANION-TRUTH-V1: the strip's PIPELINE is the portal's D1 (mine), and
  // GONE SILENT keeps the source it shared with "flagged", now the D10 count
  // (FINDINGS Open question 3). Null draws the dash.
  const pipelineTotal = truthPipelineValue();
  const goneSilentCount = waitingCount;
  const readyToSendValue = divProposals.filter(p => {
    const s = (p.status || '').toLowerCase();
    return quoteIsUnsent(s) && !p.won && !p.lost && parseInt(p.opens || 0) === 0;
  }).reduce((sum, p) => sum + parseFloat(p.value || p.totalValue || 0), 0);

  // ── Visit behaviours, shared by the switch-off visit cards and the Studio
  // time line (COMPANION-STUDIO-LIT-V1 track 3a lifted them out of the card
  // map unchanged, so both looks run the same code). ──
  const todayVisitDelete = (visit, idx) => () => {
    try {
      const visits = JSON.parse(localStorage.getItem('lumen_visits') || '[]');
      const updated = visits.filter((v, i) => visit.id ? v.id !== visit.id : i !== idx);
      localStorage.setItem('lumen_visits', JSON.stringify(updated));
      window.dispatchEvent(new CustomEvent('lumenDataSync'));
    } catch(e) { console.warn('Delete visit failed:', e); }
  };
  const todayVisitPrimary = (visit, idx) => (e) => {
    e.stopPropagation();
    const isSurvey = visit.type === 'survey';
    const surveyStatus = visit.status || 'planned';
    if (isSurvey && surveyStatus !== 'submitted') {
      // S94 — fire visit_checkin event ONCE per visit on the
      // initial Start tap. Per-visit dedupe via localStorage
      // so navigating back and re-entering doesn't double-fire.
      // Wrapped in try/catch so a write failure can't block
      // the navigation the user actually asked for.
      try {
        const visitKey = visit.id || (visit.projectName || visit.name || '') + ':' + (visit.date || '');
        const loggedRaw = localStorage.getItem('lumen_visit_checkin_logged') || '[]';
        const logged = JSON.parse(loggedRaw);
        if (visitKey && !logged.includes(visitKey)) {
          writePortalEvent('visit_checkin', {
            project_name: visit.projectName || visit.name || '',
            metadata: { visit_id: visit.id || null, action: 'checkin' },
          });
          logged.push(visitKey);
          try { localStorage.setItem('lumen_visit_checkin_logged', JSON.stringify(logged)); } catch(_e) {}
        }
      } catch(_e) { /* never block navigation */ }
      // If survey project already exists (by ID or name), go straight to live survey
      const visitName = (visit.projectName || visit.name || '').toLowerCase().trim();
      const existingSurveyProj = (visit.surveyId && allProjects.find(p => p.id === visit.surveyId))
        || (visitName && allProjects.find(p => (p.name || '').toLowerCase().trim() === visitName));
      if (existingSurveyProj) {
        setActiveProject(existingSurveyProj);
        onNav(3);
        return;
      }
      try { localStorage.setItem('survey_prefill', JSON.stringify({ surveyId: visit.surveyId, visitName: visit.projectName || visit.name, contactName: visit.contact || visit.contactName })); } catch(e2) {}
      onNav(10);
    } else {
      toggleBrief(visit.id || idx);
    }
  };
  // The pre-visit brief under a visit card (both theme states; the Studio
  // switch restyles it through studioShape).
  const todayVisitBrief = (visit) => (
                  <div style={{ background: t.colors.paper94, borderRadius: t.radius.lg, borderTop: "1px solid rgba(255,255,255,0.92)", overflow: "hidden", marginTop: 8, boxShadow: t.shadow.card }}>
                    <div style={{ padding: "14px 16px", borderBottom: `1px solid ${t.colors.umber08}` }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 9, marginBottom: 10 }}>
                        <div style={{ width: 3, height: 18, borderRadius: 2, background: t.colors.barRose, flexShrink: 0 }} />
                        <span style={{ fontSize: 11, fontWeight: t.font.lw700, textTransform: "uppercase", letterSpacing: t.font.ls08em, color: t.colors.relLabel }}>Client relationship</span>
                      </div>
                      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 5 }}>
                        <span style={{ fontSize: 13, color: t.colors.brownMid }}>Relationship score</span>
                        <span style={{ fontSize: 13, fontWeight: 600, color: t.colors.inkDeep }}>{visit.relationshipScore || '—'}</span>
                      </div>
                      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 5 }}>
                        <span style={{ fontSize: 13, color: t.colors.brownMid }}>Last contact</span>
                        <span style={{ fontSize: 13, fontWeight: 600, color: t.colors.inkDeep }}>{visit.lastContact || '—'}</span>
                      </div>
                      {visit.openQuote && (
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                          <span style={{ fontSize: 13, color: t.colors.brownMid }}>Open quote</span>
                          <span style={{ fontSize: 13, fontWeight: 600, color: t.colors.moneyGreen, fontVariantNumeric: t.font.tabular }}>{visit.openQuote}</span>
                        </div>
                      )}
                    </div>
                    <div style={{ padding: "14px 16px", borderBottom: `1px solid ${t.colors.umber08}` }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 9, marginBottom: 10 }}>
                        <div style={{ width: 3, height: 18, borderRadius: 2, background: t.colors.barGold, flexShrink: 0 }} />
                        <span style={{ fontSize: 11, fontWeight: t.font.lw700, textTransform: "uppercase", letterSpacing: t.font.ls08em, color: t.colors.goldLabel }}>Raise today</span>
                      </div>
                      {(() => {
                        const raises = [];
                        const matchedQuote = proposals.find(pr => !['won','lost'].includes(pr.status) && (pr.projectName === visit.projectName || pr.client === visit.clientName));
                        if (matchedQuote) {
                          const qDays = Math.floor((Date.now() - new Date(matchedQuote.updatedAt || matchedQuote.createdAt || 0).getTime()) / 86400000);
                          const qRef = (matchedQuote.quoteRef || matchedQuote.reference || '').replace('SP-L', '');
                          if (qDays > 7) raises.push(`Quote ${qRef} sent ${qDays} days ago${studioDash()}no response. Ask directly: does the budget still have approval?`);
                        }
                        const linkedScope = allProjects.find(pr => pr.scopeAnswers && Object.keys(pr.scopeAnswers).length >= 6 && (pr.name === visit.projectName || pr.client === visit.clientName) && !(pr.surveyZones && pr.surveyZones.length > 0));
                        if (linkedScope) raises.push(`Confirm go-ahead on ${linkedScope.name} — scope is ready to start.`);
                        if (raises.length === 0) raises.push('Review open items with this client before the meeting.');
                        return raises.map((r, ri) => (
                          <div key={ri} style={{ fontSize: 12.5, color: t.colors.inkDeep, lineHeight: 1.5, padding: "8px 11px", borderRadius: 10, marginBottom: ri < raises.length - 1 ? 6 : 0, borderLeft: `2.5px solid ${t.colors.gold5}`, background: t.colors.raiseGrad }}>
                            <div style={{ fontSize: 10, fontWeight: t.font.lw700, color: t.colors.raiseLabel, textTransform: "uppercase", letterSpacing: t.font.ls05em, marginBottom: 3 }}>{ri + 1} of {raises.length}</div>
                            {r}
                          </div>
                        ));
                      })()}
                    </div>
                    {visit.competitors && (
                      <div style={{ padding: "14px 16px", borderBottom: `1px solid ${t.colors.umber08}` }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 9, marginBottom: 10 }}>
                          <div style={{ width: 3, height: 18, borderRadius: 2, background: t.colors.barRed, flexShrink: 0 }} />
                          <span style={{ fontSize: 11, fontWeight: t.font.lw700, textTransform: "uppercase", letterSpacing: t.font.ls08em, color: t.colors.competitorLabel }}>{t.theme === 'uv' ? 'Other firms quoting' : 'Competitors in play'}</span>
                        </div>
                        <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 10, padding: "8px 10px", borderRadius: 10, background: t.colors.competitorGrad, borderLeft: `2.5px solid ${t.colors.alertB4}` }}>
                          <div style={{ fontSize: 13, fontWeight: 600, color: t.colors.inkDeep, marginBottom: 2 }}>{typeof visit.competitors === 'string' ? visit.competitors : 'Competitor flagged'}</div>
                          {/* Switch on: no "High risk" pill. The portal sends no risk figure, so the label said more than the data does. */}
                          {t.theme !== 'uv' && <div style={{ fontSize: 11, fontWeight: 700, color: t.colors.competitorLabel, padding: "3px 9px", background: t.colors.alertB10, borderRadius: 20, flexShrink: 0 }}>High risk</div>}
                        </div>
                      </div>
                    )}
                    {visit.buildingKnowledge && (
                      <div style={{ padding: "14px 16px" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 9, marginBottom: 10 }}>
                          <div style={{ width: 3, height: 18, borderRadius: 2, background: t.colors.barTeal, flexShrink: 0 }} />
                          <span style={{ fontSize: 11, fontWeight: t.font.lw700, textTransform: "uppercase", letterSpacing: t.font.ls08em, color: t.colors.teal }}>Building knowledge</span>
                        </div>
                        <div style={{ fontSize: 12.5, color: t.colors.inkDeep, lineHeight: 1.5, fontStyle: t.font.italic, padding: "8px 11px", borderRadius: 10, background: t.colors.knowledgeGrad, borderLeft: `2.5px solid ${t.colors.teal35}` }}>
                          {visit.buildingKnowledge}
                          <span style={{ fontSize: 11, fontWeight: 700, color: t.colors.teal, marginTop: 5, display: "block", fontStyle: "normal" }}>{'View details' + studioArrow()}</span>
                        </div>
                      </div>
                    )}
                  </div>
  );

  // ════ COMPANION-STUDIO-LIT-V1 track 3a: Today to the v6 phone target ════
  // Switch on only (each part below is null with it off). In the target's
  // order: Eva's read, Your day, This week, the quarter; the briefing card,
  // streaks, personal bests, the chase list, Add a visit and the calendar
  // follow. Every figure is data the screen already holds; where the data
  // is absent the part is left out. docs/studio-lit/CENSUS.md "today" maps
  // each part; docs/studio-lit/FINDINGS.md "Track 3a" records the decisions.
  const uvM = STUDIO_MEANING;
  const uvS = STUDIO_TOKENS;
  const uvSec = { fontFamily: uvS.fonts.body, fontSize: 16, fontWeight: 700, color: uvS.ink, margin: '0 0 8px' };
  const uvAct = { ...studioType.action(), minHeight: 44, display: 'inline-flex', alignItems: 'center', cursor: 'pointer', fontFamily: 'inherit' };
  const uvLink = { background: 'none', border: 'none', padding: 0, minHeight: 44, display: 'inline-flex', alignItems: 'center', cursor: 'pointer', fontFamily: 'inherit', fontSize: 16, color: uvS.ink, textDecoration: 'underline', textUnderlineOffset: 4, textDecorationColor: uvS.hairline };
  const uvHHMM = (d) => d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
  const uvTypeWord = (v) => (v.type ? v.type.charAt(0).toUpperCase() + v.type.slice(1) : '');
  const userInitials = (currentUser && typeof currentUser.name === 'string' && currentUser.name.trim())
    ? currentUser.name.trim().split(/\s+/).map(n => n[0]).join('').toUpperCase().slice(0, 2) : '';

  // Eva's read: the morning briefing's move beat (briefingBeats), the nearest
  // real text to an Eva read the app holds. No move beat, no read.
  const uvBeats = briefingBeats(briefingData);
  const uvMove = uvBeats.move;
  const uvEvaAt = uvBeats.meta.generatedAt ? new Date(uvBeats.meta.generatedAt) : null;
  // STUDIO-LIT-PHONE-V1: the prototype's jewel (.app-eva): the read in
  // Sentient light, the evidence line under it, the one action and the time.
  // The contact is named on its own only when the read and the reason do not
  // already name them (each thing said once).
  const uvEvaContact = uvMove && uvMove.contactName
    && !String(uvMove.headline || '').includes(uvMove.contactName)
    && !String(uvMove.reason || '').includes(uvMove.contactName) ? uvMove.contactName : '';
  // MORNING-BRIEFING-V2 C: with a ranked plan the plan card replaces the
  // single-move jewel (the move is the plan's first item); with none, or an
  // old portal, the jewel stands as it was. A plan that could not be read says
  // so in the portal's own sentence when there is no move to show instead.
  const uvPlan = uvBeats.plan;
  const uvPlanCard = (t.theme === 'uv' && (uvPlan.first || (uvPlan.error && !uvMove)))
    ? <BriefingPlanToday plan={uvPlan} onRead={() => onNav(20)} /> : null;
  const uvEva = (t.theme === 'uv' && uvMove) ? (
    <section aria-label="Eva" style={{ position: 'relative', overflow: 'hidden', margin: '18px 16px 16px', padding: '14px 14px 12px 16px', borderRadius: uvS.radius.card, background: uvS.jewel.fill, boxShadow: uvS.jewel.shadow, display: 'flex', flexDirection: 'column', gap: 6 }}>
      {/* The lamp in the jewel's corner (.app-evaglow), the jewel's own light. */}
      <span aria-hidden="true" style={{ position: 'absolute', right: -30, top: -34, width: 120, height: 120, borderRadius: '50%', background: `radial-gradient(circle, ${uvS.jewel.text}, ${studioRgba(uvS.ultraviolet, 0.45)} 30%, ${studioRgba(uvS.ultraviolet, 0)} 66%)`, opacity: 0.9, pointerEvents: 'none' }} />
      <p style={{ position: 'relative', margin: 0, paddingRight: 14, fontFamily: uvS.fonts.display, fontWeight: 300, fontSize: 20, lineHeight: 1.3, color: uvS.jewel.text }}>
        <span aria-hidden="true" style={{ display: 'inline-flex', verticalAlign: -2, marginRight: 8, color: uvS.jewel.ring }}>
          <svg width="17" height="17" viewBox="0 0 20 20"><circle cx="10" cy="10" r="9" fill="none" stroke="currentColor" strokeWidth="1.4" strokeDasharray="1.2 1.6" /><circle cx="10" cy="10" r="4.5" fill="currentColor" /></svg>
        </span>
        {sanitiseText(uvMove.headline)}
      </p>
      {(uvMove.reason || uvEvaContact) && (
        <p style={{ position: 'relative', margin: 0, fontSize: 14, lineHeight: 1.42, color: uvS.jewel.textSecondary }}>
          {uvMove.reason ? sanitiseText(uvMove.reason) : ''}{uvMove.reason && uvEvaContact ? ' ' : ''}{uvEvaContact ? <b style={{ color: uvS.jewel.text, fontWeight: 600 }}>{sanitiseText(uvEvaContact)}</b> : null}
        </p>
      )}
      <div style={{ position: 'relative', display: 'flex', alignItems: 'center', gap: 14, flexWrap: 'wrap', marginTop: 2 }}>
        {/* The one action: the morning briefing, Eva's own read in full. */}
        <button onClick={() => onNav(20)} style={{ minHeight: 44, padding: '0 18px', borderRadius: 10, border: 'none', background: uvS.jewel.text, color: uvS.violetText, fontSize: 16, fontWeight: 700, fontFamily: 'inherit', cursor: 'pointer', boxShadow: `0 0 22px -4px ${studioRgba(uvS.jewel.ring, 0.8)}` }}>Read the briefing</button>
        {uvEvaAt && !isNaN(uvEvaAt.getTime()) && <span style={{ marginLeft: 'auto', fontSize: 13, color: uvS.jewel.textSecondary }}>{uvHHMM(uvEvaAt)}</span>}
      </div>
    </section>
  ) : null;

  // Your day: today's visits and the survey in progress as one time line.
  // The survey's areas are deriveWrapSummary's count (the wrap's own), never
  // a recount. A visit for the survey's own site carries the survey in its
  // row; otherwise the survey is its own row at the time it started.
  const surveyForDay = activeSurveyProj || null;
  const surveyWrap = surveyForDay ? deriveWrapSummary(surveyForDay.surveyZones, surveyForDay.customZones, surveyForDay.doneZones) : null;
  const surveyStartAt = surveyForDay && surveyForDay.surveyStartedAt ? new Date(surveyForDay.surveyStartedAt) : null;
  const surveyStart = surveyStartAt && !isNaN(surveyStartAt.getTime()) ? uvHHMM(surveyStartAt) : '';
  const visitIsSurvey = (v) => {
    if (!surveyForDay) return false;
    if (v.surveyId && v.surveyId === surveyForDay.id) return true;
    const n = (v.projectName || v.name || '').trim().toLowerCase();
    return !!n && n === String(surveyForDay.name || '').trim().toLowerCase();
  };
  const surveyVisitIdx = surveyForDay ? todayVisits.findIndex(visitIsSurvey) : -1;
  const dayRows = [];
  if (surveyForDay && surveyVisitIdx < 0) dayRows.push({ key: 'survey', kind: 'survey', time: surveyStart });
  todayVisits.forEach((v, i) => dayRows.push({ key: 'v_' + (v.id || i), kind: 'visit', visit: v, idx: i, time: v.time || '', survey: i === surveyVisitIdx }));
  dayRows.sort((a, b) => (a.time || '').localeCompare(b.time || ''));
  const nowHHMM = uvHHMM(now);
  let nowAt = -1;
  if (dayRows.some(r => r.time)) {
    nowAt = dayRows.findIndex(r => r.time && r.time > nowHHMM);
    if (nowAt < 0) nowAt = dayRows.length;
  }
  const COUNT_WORDS = ['One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten'];
  const dayCountLine = dayRows.length === 0 ? '' : `${COUNT_WORDS[dayRows.length - 1] || dayRows.length} thing${dayRows.length === 1 ? '' : 's'} for today.`;
  const uvVisitCta = {
    survey: { secondary: "Pre-visit brief", primary: "Start survey" },
    meeting: { secondary: "Pre-visit brief", primary: "Open notes" },
    supplier: { secondary: "Products & pricing", primary: "Log visit" },
    pitch: { secondary: "Pre-pitch brief", primary: "Start pitch" },
  };
  // The survey in progress: its areas, then the details the survey card
  // carried (start time, fittings, existing load, zones with fittings, Maps,
  // Continue survey). Each figure once.
  // STUDIO-LIT-PHONE-V1: the survey as the prototype draws it (.app-tlsurvey):
  // the areas as marks, done in amber and the next one lit, then Continue
  // survey and Maps. The fittings, load and zone figures live on the survey's
  // own screens, not here (the prototype's row carries the areas only).
  const uvSurveyDetails = ({ showContinue }) => {
    const asp = surveyForDay;
    const address = asp.address || asp.siteAddress || asp.site_address || '';
    const total = surveyWrap ? surveyWrap.totalZoneCount : 0;
    const nextIdx = total > 0 ? surveyWrap.zoneRows.findIndex(r => !r.done) : -1;
    return (
      <>
        {total > 0 && (
          <div role="img" aria-label={`${surveyWrap.doneCount} of ${total} areas done`} style={{ display: 'grid', gridTemplateColumns: `repeat(${total}, minmax(0, 1fr))`, gap: 4, marginTop: 6 }}>
            {surveyWrap.zoneRows.map((r, i) => (
              <i key={i} style={{ display: 'block', height: 8, borderRadius: 3, background: r.done ? uvM.wonFill : i === nextIdx ? uvM.wonFill : uvS.hairline, boxShadow: i === nextIdx ? `0 0 0 1.5px ${uvS.onPrimary}, 0 0 12px ${studioRgba(uvM.wonFill, 0.95)}` : 'none', opacity: r.done ? 0.85 : 1 }} />
            ))}
          </div>
        )}
        {(showContinue || address) && (
          <div style={{ display: 'flex', gap: 18, flexWrap: 'wrap' }}>
            {showContinue && <button onClick={() => { setActiveProject(asp); onNav(3); }} style={uvAct}>Continue survey</button>}
            {address && <button onClick={(e) => { e.stopPropagation(); openMaps(address); }} style={uvLink}>Maps</button>}
          </div>
        )}
      </>
    );
  };
  // A visit's quote: the portal's pipeline row for the project the visit is
  // bound to (visit.project_id, the canonical id the picker stamps). Matched by
  // id only, never by name. An open quote wins over a closed one, then the
  // latest sent.
  const uvPipeRows = (() => { const b = truthBody('lumen_pipeline'); return b && Array.isArray(b.quotes) ? b.quotes : []; })();
  const uvQuoteFor = (visit) => {
    const pid = visit && (visit.project_id || (visit.projectBinding && visit.projectBinding.project_id));
    if (!pid) return null;
    const rows = uvPipeRows.filter(q => q && q.project_id != null && String(q.project_id) === String(pid));
    if (rows.length === 0) return null;
    const when = (q) => String(q.sent_at || q.timestamp || '');
    const open = rows.filter(q => !q.won && !q.lost);
    return (open.length ? open : rows).slice().sort((a, b) => when(b).localeCompare(when(a)))[0];
  };
  // The stage words with odds (the prototype's sw()), coloured by meaning. A
  // sent quote is Quoted, with the odds the portal holds (confidence stops 10,
  // 25, 50, 75, 90: 75 and up strong, 50 even, under 50 low, as the desk's
  // Pipeline reads them). A quote still being built has no stage word: which
  // live stage is New is DEC-1, not decided here.
  // (One rule, shared with Pipeline: studioQuoteStage, beside PipelineScreen.)
  const uvStageWord = studioQuoteStage;
  const uvAreas = () => (surveyWrap && surveyWrap.totalZoneCount > 0
    ? <span style={{ fontSize: 14, fontWeight: 700, color: uvS.muted, whiteSpace: 'nowrap' }}>{surveyWrap.doneCount} of {surveyWrap.totalZoneCount} areas</span>
    : null);
  const uvRowHead = (name, right) => (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 10 }}>
      <b style={{ fontSize: 16, fontWeight: 700, color: uvS.ink, minWidth: 0, overflowWrap: 'anywhere' }}>{name}</b>
      {right}
    </div>
  );
  // The ground behind a time and the Now word, so the day's line breaks
  // around them as in the prototype (.app-tlrow time).
  const uvGroundBehind = { background: uvS.ground.base, position: 'relative', zIndex: 1 };
  // A visit row (.app-tlbody.job): the name and, when the visit's project has
  // a quote, its value in ochre; who and where with the stage words and the
  // job's margin (176.140); the note; the actions. The next thing after Now is
  // the hot row: the lamp's paper with its stage's light at the side.
  const uvVisitRow = (row, hot) => {
    const visit = row.visit; const idx = row.idx;
    const briefOpen = openBriefs[visit.id || idx] || false;
    const cta = uvVisitCta[(visit.type || '').toLowerCase()] || uvVisitCta.survey;
    const q = uvQuoteFor(visit);
    const sw = uvStageWord(q);
    const value = q ? truthNumber(q.total) : null;
    const margin = !q ? null : truthNumber(q.margin_pct) != null ? `${q.margin_pct}% estimated margin`
      : q.margin_withheld ? `margin not available, ${String(q.margin_withheld)}` : null;
    const who = [uvTypeWord(visit), visit.contactName || visit.contact, visit.clientName || visit.client].filter(Boolean).join(', ');
    const glow = sw ? sw.fill : null;
    // SEND-STATE-V1: a survey visit whose job is waiting to send, failed,
    // going or sent (or sent and changed since) shows that job's send state
    // where it offered Start survey, and opens the job's front page. The job
    // by the visit's own id only, never by name.
    const sendJob = (visit.type || '').toLowerCase() === 'survey' && visit.surveyId
      ? (allProjects || []).find(p => p && p.id === visit.surveyId) : null;
    const sendSt = sendJob ? readSendState(sendJob) : null;
    const sendShown = !!sendSt && (sendStateBlocksSend(sendSt) || sendSt.state === 'sent' || !!sendSt.earlier);
    const sendW = sendShown ? sendStateWords(sendSt) : null;
    // SEND-TIMEOUT-V1 (#112 note 6): what the button says, and its accessible
    // name carries the same words (it used to drop the reason).
    const sendSays = sendW ? ((sendSt.state === 'sent' || sendSt.earlier) ? sendW.short : `${sendW.title}. ${sendW.short}`) : '';
    const body = {
      borderRadius: 12, padding: hot ? '12px 14px 6px 18px' : '2px 0 2px', display: 'flex', flexDirection: 'column', gap: 4,
      ...(hot ? { background: uvS.paper.css, boxShadow: `${uvS.shadow.raised}${glow ?`, -8px 0 22px -12px ${studioRgba(glow, 0.9)}` : ''}` } : {}),
    };
    return (
      <LongPressCard onDelete={todayVisitDelete(visit, idx)} kebabAt="bottom">
        <div style={body}>
          {uvRowHead(visit.projectName || visit.name || 'Site visit', row.survey ? uvAreas()
            : value != null ? <span style={{ fontSize: 16, fontWeight: 700, color: uvM.ochre, fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' }}>{formatCurrency(value)}</span> : null)}
          {(who || sw) && (
            <p style={{ margin: 0, fontSize: 14, lineHeight: 1.4, color: uvS.ink, overflowWrap: 'anywhere' }}>
              {who}{who && sw ? ', ' : ''}{sw && <span style={{ fontWeight: 600, color: sw.c }}>{sw.word}</span>}
            </p>
          )}
          {margin && <p style={{ margin: 0, fontSize: 13, color: uvS.muted }}>{margin.charAt(0).toUpperCase() + margin.slice(1)}</p>}
          {visit.notes && <p style={{ margin: 0, fontSize: 14, lineHeight: 1.4, color: uvS.ink, overflowWrap: 'anywhere' }}>{visit.notes}</p>}
          {row.survey && uvSurveyDetails({ showContinue: false })}
          <div style={{ display: 'flex', gap: 18, flexWrap: 'wrap' }}>
            {sendShown
              ? <button data-send-state={sendSt.state} aria-label={`Open ${sendJob.name || 'the survey'}: ${sendSays}`} onClick={(e) => { e.stopPropagation(); setActiveProject(sendJob); onNav(3); }} style={{ ...uvAct, textAlign: 'left', flexBasis: '100%' }}>{sendSays}</button>
              : <button onClick={todayVisitPrimary(visit, idx)} style={uvAct}>{cta.primary}</button>}
            <button onClick={(e) => { e.stopPropagation(); toggleBrief(visit.id || idx); }} style={uvLink}>{briefOpen ? 'Hide brief' : cta.secondary}</button>
          </div>
        </div>
        {briefOpen && todayVisitBrief(visit)}
      </LongPressCard>
    );
  };
  const uvNow = (
    <div aria-label={`Now, ${nowHHMM}`} style={{ position: 'relative', display: 'flex', alignItems: 'center', gap: 8, height: 20, margin: '-2px 0' }}>
      <span style={{ ...uvGroundBehind, width: 50, flexShrink: 0, fontSize: 13, fontWeight: 700, color: uvM.wonText }}>Now</span>
      <span aria-hidden="true" style={{ flex: 1, height: 2, borderRadius: 2, background: uvM.wonFill, boxShadow: `0 0 10px ${studioRgba(uvM.wonFill, 0.9)}` }} />
    </div>
  );
  // The first row after Now is the hot one (the prototype's .app-tlhot).
  const uvHotAt = nowAt >= 0 && nowAt < dayRows.length && dayRows[nowAt].kind === 'visit' ? nowAt : -1;
  const uvDay = t.theme === 'uv' ? (
    <section aria-label="Your day" style={{ margin: '4px 16px 14px' }}>
      {dayRows.length === 0 ? (
        <p style={{ margin: 0, fontSize: 14, color: uvS.muted }}>Nothing booked for today.</p>
      ) : (
        <div style={{ position: 'relative', display: 'flex', flexDirection: 'column', gap: 12 }}>
          {/* The day's line runs down behind the times (.app-tl::before). */}
          <div aria-hidden="true" style={{ position: 'absolute', left: 18, top: 8, bottom: 8, width: 2, background: uvS.hairline }} />
          {dayRows.map((row, i) => (
            <React.Fragment key={row.key}>
              {i === nowAt && uvNow}
              <div style={{ position: 'relative', display: 'grid', gridTemplateColumns: '50px minmax(0, 1fr)', gap: 10, alignItems: 'start' }}>
                <time style={{ ...uvGroundBehind, fontSize: 14, fontWeight: 700, color: uvS.ink, padding: '4px 0' }}>{row.time}</time>
                {row.kind === 'survey' ? (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 6, padding: '2px 0' }}>
                    {uvRowHead(surveyForDay.name, uvAreas())}
                    {uvSurveyDetails({ showContinue: true })}
                  </div>
                ) : uvVisitRow(row, i === uvHotAt)}
              </div>
            </React.Fragment>
          ))}
          {nowAt === dayRows.length && uvNow}
        </div>
      )}
      {/* Upcoming: the visits booked after today, as before (long press
          deletes). */}
      {upcomingVisits.length > 0 && (
        <div style={{ marginTop: 18 }}>
          <h2 style={uvSec}>Upcoming</h2>
          {upcomingVisits.map((visit, idx) => {
            const vDate = new Date((visit.date || '').split('T')[0] + 'T00:00:00');
            const dateOk = !isNaN(vDate.getTime());
            const who = [uvTypeWord(visit), visit.contactName || visit.contact, visit.clientName || visit.client].filter(Boolean).join(', ');
            return (
              <LongPressCard key={visit.id || ('up_' + idx)} onDelete={todayVisitDelete(visit, idx)} style={{ marginBottom: 8 }}>
                <div style={{ ...studioSurface.slip(), borderRadius: 14, padding: '10px 44px 10px 14px', display: 'grid', gridTemplateColumns: '50px minmax(0, 1fr)', gap: 10, alignItems: 'baseline' }}>
                  <span style={{ fontSize: 14, fontWeight: 700, color: uvS.ink, lineHeight: 1.3 }}>{dateOk ? <>{dayNames[vDate.getDay()].slice(0, 3)}<br />{vDate.getDate()} {monthNames[vDate.getMonth()].slice(0, 3)}</> : ''}</span>
                  <span style={{ display: 'flex', flexDirection: 'column', gap: 2, minWidth: 0 }}>
                    <b style={{ fontSize: 16, fontWeight: 700, color: uvS.ink, overflowWrap: 'anywhere' }}>{visit.projectName || visit.name || 'Visit'}</b>
                    {who && <span style={{ fontSize: 14, color: uvS.muted }}>{who}</span>}
                  </span>
                </div>
              </LongPressCard>
            );
          })}
        </div>
      )}
    </section>
  ) : null;

  // This week: the movement strip's five figures (/api/companion/movement, or
  // the same five computed from the proposals here), the user's own jobs.
  // The portal's week starts on Monday. Each figure and its word take their
  // meaning's colour; money is ochre. A figure with no value has no row.
  // STUDIO-LIT-PHONE-V1: Last 7 days, whole team, from the portal's company
  // read (/api/companion/company last_7_days, synced as lumen_company): D9
  // quotes sent and D5 won against the 7 days before, N3 gone silent (10 or
  // more days since anything happened, DECISIONS 176.134) and the D1 pipeline
  // change from the daily snapshot. Not sent (403 for someone who may not see
  // sales figures, or the feed not there yet): the card is left out. New
  // enquiries is DEC-3 (no signed definition) and is left out. Each figure
  // takes its meaning's colour; money is ochre. A figure the portal does not
  // send has no row; never a zero standing in for unknown.
  const uvTeam = (() => {
    if (t.theme !== 'uv') return null;
    const co = truthBody('lumen_company');
    const l7 = co && co.last_7_days && typeof co.last_7_days === 'object' ? co.last_7_days : null;
    if (!l7) return null;
    const vs = (now, prev) => {
      if (prev == null) return '';
      const d = now - prev;
      return d > 0 ? `up ${d}` : d < 0 ? `down ${-d}` : 'same as the week before';
    };
    const rows = [];
    const qs = l7.quotes_sent || {}; const wn = l7.won || {}; const gs = l7.gone_silent || {}; const pc = l7.pipeline_change || {};
    if (truthNumber(qs.count) != null) rows.push({ k: 'quoted', fig: String(qs.count), word: 'quotes sent', note: vs(qs.count, truthNumber(qs.previous)), c: uvM.quotedText });
    if (truthNumber(wn.count) != null) rows.push({ k: 'won', fig: String(wn.count), word: 'won', note: vs(wn.count, truthNumber(wn.previous)), c: uvM.wonText });
    if (truthNumber(gs.count) != null) rows.push({ k: 'silent', fig: String(gs.count), word: 'gone silent, nothing in 10 days or more', note: vs(gs.count, truthNumber(gs.previous)), c: uvM.rustText });
    const pv = truthNumber(pc.value);
    if (pv != null) {
      const pp = truthNumber(pc.previous);
      rows.push({ k: 'pipe', fig: (pv > 0 ? '+' : '') + formatCurrency(pv), word: 'pipeline change', c: uvM.ochre,
        note: pp == null ? '' : pp === 0 ? 'no change the week before'
          : <>it {pp > 0 ? 'rose' : 'fell'} <span style={{ color: uvM.ochre, fontVariantNumeric: 'tabular-nums' }}>{formatCurrency(Math.abs(pp))}</span> the week before</> });
    }
    if (rows.length === 0) return null;
    return (
      <section aria-label="Last 7 days, whole team" style={{ margin: '14px 16px 14px', padding: '14px 16px', borderRadius: uvS.radius.card, ...studioSurface.raised() }}>
        <h2 style={uvSec}>Last 7 days, whole team</h2>
        {rows.map((r, i) => (
          <div key={r.k} style={{ display: 'grid', gridTemplateColumns: '72px minmax(0, 1fr)', columnGap: 10, alignItems: 'baseline', padding: '7px 0', borderTop: i === 0 ? 'none' : `1px solid ${studioRgba(uvS.ink, 0.07)}` }}>
            <b style={{ gridRow: 'span 2', fontFamily: uvS.fonts.display, fontWeight: 300, fontSize: 25, lineHeight: 1, color: r.c, fontVariantNumeric: 'tabular-nums' }}>{r.fig}</b>
            <span style={{ fontSize: 14, color: uvS.ink }}>{r.word}</span>
            {r.note ? <span style={{ fontSize: 13, color: uvS.muted }}>{r.note}</span> : <span />}
          </div>
        ))}
      </section>
    );
  })();

  // The quarter (the prototype's well, .app-qtr): what the portal says you
  // won this quarter (lumen_targets.actual_this_quarter, D4) against the
  // portal's own quarter target (quarterly_target), as an amber ring, with the
  // weeks left (weeks_left) and the quarter's margin (quarter_profit,
  // quarter_margin_pct), or "margin not available" with the portal's reason
  // (quarter_margin_withheld, DECISIONS 176.140). No device sums: the monthly
  // target times three is NOT a quarter target.
  const uvQuarter = (() => {
    if (t.theme !== 'uv') return null;
    const pt = getPortalData('lumen_targets', null);
    if (!pt || typeof pt !== 'object' || pt.quarter_unavailable) return null;
    const won = truthNumber(pt.actual_this_quarter);
    if (won == null) return null;
    const target = (truthNumber(pt.quarterly_target) || 0) > 0 ? pt.quarterly_target : null;
    const pct = target ? Math.round((won / target) * 100) : null;
    const weeks = truthNumber(pt.weeks_left);
    const profit = truthNumber(pt.quarter_profit);
    const mpct = truthNumber(pt.quarter_margin_pct);
    const R = 30; const C = 2 * Math.PI * R;
    const money = { color: uvM.ochre, fontWeight: 700, fontVariantNumeric: 'tabular-nums' };
    const toGo = weeks == null ? '' : weeks === 1 ? ', with 1 week to go' : `, with ${weeks} weeks to go`;
    let marginLine = null;
    if (mpct != null && profit != null) marginLine = <> That's <span style={money}>{formatCurrency(profit)}</span> profit at {mpct}% estimated margin.</>;
    else if (mpct != null) marginLine = <> That's {mpct}% estimated margin.</>;
    else if (pt.quarter_margin_withheld) marginLine = <> Margin not available, {sanitiseText(String(pt.quarter_margin_withheld))}.</>;
    return (
      <section aria-label="The quarter" style={{ margin: '0 16px 12px', padding: '14px 16px', borderRadius: 14, display: 'flex', alignItems: 'center', gap: 16, ...studioSurface.pressed() }}>
        {target && (
          <svg width="76" height="76" viewBox="0 0 76 76" role="img" aria-label={`${pct}% of your quarter target`} style={{ flexShrink: 0 }}>
            <circle cx="38" cy="38" r={R} fill="none" stroke={studioRgba(uvS.ink, 0.1)} strokeWidth="8" />
            {pct > 0 && <circle cx="38" cy="38" r={R} fill="none" stroke={uvM.wonFill} strokeWidth="8" strokeLinecap="round" strokeDasharray={`${(C * Math.min(pct, 100) / 100).toFixed(1)} ${C.toFixed(1)}`} transform="rotate(-90 38 38)" style={{ filter: `drop-shadow(0 0 5px ${studioRgba(uvM.wonFill, 0.7)})` }} />}
            <text x="38" y="44" textAnchor="middle" fontFamily={uvS.fonts.display} fontSize="20" fill={uvS.ink}>{pct}%</text>
          </svg>
        )}
        <p style={{ margin: 0, fontSize: 16, lineHeight: 1.45, color: uvS.ink }}>
          <span style={money}>{formatCurrency(won)}</span>{target ? <> won of your <span style={money}>{formatCurrency(target)}</span> target this quarter{toGo}.</> : <> won this quarter{toGo}.</>}{marginLine}
        </p>
      </section>
    );
  })();

  // The run at risk (the prototype's .app-stk): the portal's own at-risk list
  // (/api/companion/streaks at_risk, streaks_at_risk), the day it breaks, and
  // how many of the other runs are not at risk. The new job nobody has taken
  // is said only when the portal sends it (unowned_new); otherwise left out.
  // Taps through to My performance, where the runs live.
  const uvRisk = (() => {
    if (t.theme !== 'uv') return null;
    const s = streaksData;
    // STUDIO-LIT-PHONE-V1 item 5: at_risk is about the day the portal read
    // it (streaks_at_risk: streak_type, label, current_length,
    // days_remaining), so only a copy written today is used, and the day it
    // breaks is today plus days_remaining.
    const sc = perfStreaksCache();
    if (!sc || !sc.today) return null;
    const runKey = (r) => String(r.streak_type || '');
    const list = s && Array.isArray(s.at_risk) ? s.at_risk.filter(r => r && (r.label || runKey(r))) : [];
    if (list.length === 0) return null;
    const RUN_KEYS = ['platform', 'builder', 'closer', 'prospector', 'conversion'];
    const runCount = RUN_KEYS.filter(k => s[k] && typeof s[k] === 'object').length;
    const names = list.map(r => String(r.label || (runKey(r).charAt(0).toUpperCase() + runKey(r).slice(1))));
    const nameLine = names.length === 1 ? names[0] : `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;
    const dl = list.map(r => (typeof r.days_remaining === 'number' && isFinite(r.days_remaining)
      ? new Date(now.getFullYear(), now.getMonth(), now.getDate() + r.days_remaining, 12)
      : null)).filter(d => d && !isNaN(d.getTime())).sort((a, b) => a - b)[0] || null;
    const days = dl ? Math.round((new Date(dl.getFullYear(), dl.getMonth(), dl.getDate()) - new Date(now.getFullYear(), now.getMonth(), now.getDate())) / 86400000) : null;
    const when = days == null ? '' : days <= 0 ? ' today' : days === 1 ? ' tomorrow' : days < 7 ? ` on ${dayNames[dl.getDay()]}` : ` on ${dl.getDate()} ${monthNames[dl.getMonth()]}`;
    const verb = names.length === 1 ? 'breaks' : 'break';
    const unowned = s && Array.isArray(s.unowned_new) ? s.unowned_new.map(j => j && (j.name || j.project_name)).filter(Boolean) : [];
    const COUNT_WORD = ['no', 'one', 'two', 'three', 'four', 'five'];
    const others = runCount > list.length ? runCount - list.length : 0;
    const parts = [];
    if (unowned.length === 1) parts.push(`${unowned[0]} came in today and nobody has taken it.`);
    else if (unowned.length > 1) parts.push(`${unowned.length} new jobs came in today and nobody has taken them.`);
    if (others > 0) parts.push(others === 1 ? 'Your other run is safe.' : `Your other ${COUNT_WORD[others] || others} runs are safe.`);
    return (
      <button onClick={() => onNav(17)} aria-label={`${nameLine} ${verb}${when}`} style={{ ...studioSurface.raised(), boxSizing: 'border-box', display: 'grid', gridTemplateColumns: '34px minmax(0, 1fr) 14px', gap: 10, alignItems: 'center', width: 'calc(100% - 32px)', margin: '12px 16px 0', padding: '13px 14px', minHeight: 44, borderRadius: uvS.radius.card, textAlign: 'left', fontFamily: 'inherit', cursor: 'pointer' }}>
        {/* The run's own mark, in the one calm run colour (decision 5). */}
        <span aria-hidden="true" style={{ position: 'relative', width: 30, height: 30, borderRadius: '50%', boxShadow: `inset 0 0 0 4px ${uvM.slateFill}` }}>
          <span style={{ position: 'absolute', top: 8, left: 8, width: 14, height: 14, borderRadius: '50%', background: uvM.slateFill }} />
        </span>
        <span style={{ display: 'flex', flexDirection: 'column', gap: 2, minWidth: 0 }}>
          <b style={{ fontSize: 14, fontWeight: 700, color: uvS.ink }}>{nameLine} {verb}{when}</b>
          {parts.length > 0 && <span style={{ fontSize: 13, lineHeight: 1.4, color: uvS.muted }}>{parts.join(' ')}</span>}
        </span>
        <span aria-hidden="true" style={{ fontSize: 20, color: uvS.muted, alignSelf: 'center' }}>{'›'}</span>
      </button>
    );
  })();

  // Add a visit: the same four types and the same destinations as before, in
  // the target's layout.
  const uvVisitIcons = {
    survey: <><path d="M4 20V6l8-3 8 3v14" /><path d="M9 20v-6h6v6" /></>,
    meeting: <><circle cx="9" cy="8" r="3" /><circle cx="17" cy="9" r="2.4" /><path d="M3 20c0-3.5 2.7-6 6-6s6 2.5 6 6M15 20c.3-2.6 1.8-4.5 4-4.5 1.2 0 2 .4 2 .4" /></>,
    supplier: <><path d="M3 7h11v10H3zM14 10h4l3 3v4h-7" /><circle cx="7" cy="18" r="1.6" /><circle cx="17.5" cy="18" r="1.6" /></>,
    pitch: <><path d="M4 5h16v11H4zM8 20h8M12 16v4" /></>,
  };
  // STUDIO-LIT-PHONE-V1: the four doors are the prototype's ghost buttons
  // (pressed in), with ink icons: violet is Eva and the main action only.
  const uvAddVisit = t.theme === 'uv' ? (
    <section aria-label="Add a visit" style={{ margin: '16px 16px 0' }}>
      <h2 style={uvSec}>Add a visit</h2>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, minmax(0, 1fr))', gap: 8 }}>
        {[['survey', 'Survey'], ['meeting', 'Meeting'], ['supplier', 'Supplier'], ['pitch', 'Pitch']].map(([type, label]) => (
          <button key={type} onClick={() => { setNewVisitType(type); setShowAddVisitSheet(true); }} style={{ background: studioRgba(uvS.ink, 0.06), boxShadow: uvS.shadow.pressed, border: 'none', borderRadius: 10, minHeight: 64, padding: '12px 4px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 5, fontSize: 13, fontWeight: 600, color: uvS.ink, fontFamily: 'inherit', cursor: 'pointer' }}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={uvS.ink} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{uvVisitIcons[type]}</svg>
            {label}
          </button>
        ))}
      </div>
    </section>
  ) : null;
  // More stays reached from Today (decision 2 keeps the tab bar, which has no
  // More), as a quiet row of raised paper; then when the figures were last
  // fetched, with the date when it was not today (176.136).
  const uvSynced = t.theme === 'uv' ? truthSyncedLine(now) : null;
  const uvMore = t.theme === 'uv' ? (
    <>
      <button onClick={() => onNav(16)} style={{ ...studioSurface.raised(), display: 'grid', gridTemplateColumns: 'minmax(0, 1fr) 14px', alignItems: 'center', gap: 10, width: 'calc(100% - 32px)', margin: '12px 16px 0', padding: '13px 16px', borderRadius: uvS.radius.card, minHeight: 44, textAlign: 'left', fontFamily: 'inherit', cursor: 'pointer' }}>
        <span style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <span style={{ fontSize: 14, fontWeight: 700, color: uvS.ink }}>More</span>
          <span style={{ fontSize: 13, color: uvS.muted }}>Contacts, voice notes and about</span>
        </span>
        <span aria-hidden="true" style={{ fontSize: 20, color: uvS.muted }}>{'›'}</span>
      </button>
      {uvSynced && <p style={{ margin: '14px 16px 0', fontSize: 13, color: uvS.muted }}>{uvSynced}</p>}
    </>
  ) : null;

  return studioShape(
    <div style={{ flex: 1, overflowY: "auto", WebkitOverflowScrolling: "touch", overscrollBehavior: "contain", paddingBottom: 100, background: t.colors.ground, display: "flex", flexDirection: "column" }}>
      <ScreenBlobs />
      {/* Pull-to-refresh indicator */}
      {(todayIsPulling || todayIsSyncing) && (
        <div style={{ position: 'absolute', top: 8, left: '50%', transform: 'translateX(-50%)', zIndex: 10, display: 'flex', alignItems: 'center', gap: 8, padding: '7px 16px', borderRadius: 22, background: t.colors.paper92, border: `1px solid ${t.colors.gold4}`, boxShadow: t.shadow.goldSoft }}>
          {todayIsSyncing ? (
            <div style={{ width: 18, height: 18, borderRadius: '50%', border: `2.5px solid ${t.colors.gold2}`, borderTopColor: t.colors.goldInk, animation: 'spin 0.8s linear infinite' }} />
          ) : (
            <div style={{ width: 26, height: 26, borderRadius: '50%', border: `1.5px solid ${t.colors.gold4}`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={t.colors.goldInk} strokeWidth="2.5" strokeLinecap="round"><line x1="12" y1="19" x2="12" y2="5"/><polyline points="5 12 12 5 19 12"/></svg>
            </div>
          )}
          <span style={{ fontSize: 12, fontWeight: 600, color: t.colors.goldInk, letterSpacing: -0.2 }}>{todayIsSyncing ? 'Syncing with portal…' : 'Release to refresh'}</span>
        </div>
      )}

      {/* No zIndex on this scroll area: a z-index here traps every sheet opened
          inside it (Add a visit, the chase sheet) beneath the tab bar and the
          header, so their buttons sat under the bar and could not be reached
          (Andrew, 7 October 2026). tests/overlay_layers.test.js. */}
      <div style={{ flex: 1, overflowY: "auto", overflowX: "hidden", WebkitOverflowScrolling: "touch", position: "relative", paddingBottom: 83, overscrollBehavior: "contain" }}
        onTouchStart={handleTodayPullStart}
        onTouchMove={handleTodayPullMove}
        onTouchEnd={handleTodayPullEnd}
      >

        {/* COMPANION-STUDIO-V1 track 2: the Studio page head. Today's date is
            the one big number (real data, the clock), the greeting is the
            page title. Theme off: nothing renders here. FINDINGS T2-2. */}
        {t.theme === 'uv' && (
          <div style={{ padding: '18px 16px 0' }}>
            <div style={{ display: 'flex', alignItems: 'flex-end', gap: 14 }}>
              <div style={{ ...studioType.display(), fontSize: 96, lineHeight: 0.78 }}>{String(now.getDate()).padStart(2, '0')}</div>
              <div style={{ paddingBottom: 4, fontSize: 16, lineHeight: 1.3, color: STUDIO_TOKENS.muted }}>{dayNames[now.getDay()]}<br />{monthNames[now.getMonth()]}</div>
              {/* COMPANION-STUDIO-LIT-V1 track 3a: the signed-in user's
                  initials (the same derivation as the profile screens). */}
              {userInitials && (
                <span aria-label={currentUser.name} style={{ marginLeft: 'auto', alignSelf: 'flex-start', width: 44, height: 44, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, fontWeight: 700, color: STUDIO_TOKENS.ink, flexShrink: 0, ...studioSurface.raised() }}>{userInitials}</span>
              )}
            </div>
            <h1 style={{ ...studioType.title(), fontSize: 25, lineHeight: 1.14, marginTop: 18 }}>{greeting.replace(/^Good m/, 'M').replace(/^Good a/, 'A').replace(/^Good e/, 'E')}, {firstName}.{dayCountLine ? ' ' + dayCountLine : ''}</h1>
          </div>
        )}

        {/* COMPANION-STUDIO-LIT-V1 track 3a: the v6 phone target's top half,
            switch on only: Eva's read, Your day (with Upcoming), This week
            and the quarter. The briefing card, streaks, personal bests and
            everything after them follow in place. */}
        {t.theme === 'uv' && (uvPlanCard || uvEva)}
        {t.theme === 'uv' && uvDay}
        {t.theme === 'uv' && uvTeam}
        {t.theme === 'uv' && uvQuarter}
        {t.theme === 'uv' && uvRisk}
        {t.theme === 'uv' && uvAddVisit}
        {t.theme === 'uv' && uvMore}

        {/* ══════ SECTION 0: MOVEMENT STRIP (this week) ══════ */}
        {/* Studio switch on: the whole team's last 7 days (uvTeam) above
            replaces this strip of your own week. */}
        {t.theme !== 'uv' && (() => {
          const m = effMovement || {};
          // S95 D5 — null (vs 0) now means "no data yet"; render em-dash instead
          // of fabricated zeros so the strip honours the "never fabricate" rule.
          const fmtSigned = (n) => (n == null ? '\u2014' : n > 0 ? `+${n}` : `${n}`);
          const fmtSignedK = (n) => {
            if (n == null) return '\u2014';
            const sign = n > 0 ? '+' : n < 0 ? '-' : '';
            const abs = Math.abs(n);
            return `${sign}\u00A3${abs >= 1000 ? (abs / 1000).toFixed(abs >= 10000 ? 0 : 1) + 'k' : abs}`;
          };
          const items = [
            { key: 'enq',    value: fmtSigned(m.new_enquiries),  label: 'New Enquiries', source: 'portal inbox',      tone: m.new_enquiries == null ? 'neutral' : m.new_enquiries >= 0 ? 'pos' : 'neg' },
            { key: 'quoted', value: fmtSigned(m.quoted),         label: 'Quoted',        source: 'proposals sent',    tone: m.quoted == null ? 'neutral' : m.quoted >= 0 ? 'pos' : 'neg' },
            { key: 'won',    value: m.won == null ? '\u2014' : `${m.won}`, label: 'Won', source: m.won > 0 ? 'this week' : 'awaiting first win', tone: m.won == null ? 'neutral' : m.won > 0 ? 'pos' : 'neutral' },
            { key: 'silent', value: wentSilentShown == null ? '\u2014' : `${wentSilentShown}`, label: 'Went Silent', source: 'silence threshold', tone: wentSilentShown == null ? 'neutral' : wentSilentShown < 0 ? 'neg' : 'neutral' },
            { key: 'delta',  value: fmtSignedK(m.pipeline_delta), label: 'Pipeline \u0394', source: 'vs last week',    tone: m.pipeline_delta == null ? 'neutral' : m.pipeline_delta >= 0 ? 'gold' : 'neg' },
          ];
          // UV-RESKIN-V1 track E: under the theme there is no colour by sign. A
          // count rises in ink and falls in muted; money (the pipeline delta) is
          // ochre whatever its sign.
          const toneColor = (tone, key) => (t.theme === 'uv' && key === 'delta') ? t.colors.goldMoney
            : tone === 'pos' ? t.colors.green : tone === 'neg' ? t.colors.toneNeg : tone === 'gold' ? t.colors.goldMoney : t.colors.stone55;
          return (
            <div style={{ margin: '4px 12px 10px', padding: '11px 12px', background: t.colors.glass, border: `1px solid ${t.colors.sand35}`, borderRadius: t.radius.card14, overflow: 'hidden', boxShadow: t.shadow.card, ...uvx(studioSurface.pressed) }}>
              <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', marginBottom: 8 }}>
                <span style={{ fontSize: 11, fontWeight: t.font.lw700, letterSpacing: t.font.ls09em, textTransform: 'uppercase', color: t.colors.stone5, ...uvx(studioType.heading) }}>{t.theme === 'uv' ? 'This week' : 'This Week'}</span>
                <span style={{ fontSize: 11, color: t.colors.textTertiary }}>movement</span>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: 6 }}>
                {items.map(it => (
                  <div key={it.key} style={{ textAlign: 'center', minWidth: 0 }}>
                    <div style={{ fontFamily: t.font.serif, fontStyle: t.font.italic, fontSize: 17, color: toneColor(it.tone, it.key), lineHeight: 1, marginBottom: 4, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontVariantNumeric: t.font.tabular }}>{it.value}</div>
                    <div style={{ fontSize: 11, fontWeight: 700, color: t.colors.text, marginBottom: 2, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{it.label}</div>
                    <div style={{ fontSize: 11, color: t.colors.textTertiary, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{it.source}</div>
                  </div>
                ))}
              </div>
            </div>
          );
        })()}

        {/* ══════ SECTION 1: TODAY'S BRIEFING HERO CARD ══════ */}
        {/* STUDIO-LIT-PHONE-V1: switch on, Eva's jewel above is the briefing
            on Today (its read and Read the briefing); this card's figures are
            said on Pipeline, so it is not drawn twice. */}
        {t.theme !== 'uv' && (
        <div id="morning-briefing-card" onClick={() => {
          if (!briefingRead) {
            setBriefingRead(true);
            try { localStorage.setItem('lumen_briefing_read_' + new Date().toISOString().split('T')[0], '1'); } catch(e) {}
          }
        }} style={{
          borderRadius: t.radius.xl,
          background: t.colors.briefGrad,
          padding: "20px 20px 18px",
          margin: "4px 12px 20px",
          position: "relative",
          overflow: "hidden",
          cursor: "pointer",
          ...uvx(() => ({ ...studioSurface.raised(), margin: "4px 12px 14px" }))
        }}>
          {/* Decorative glow */}
          <div style={{ position: "absolute", top: -40, right: -40, width: 160, height: 160, borderRadius: "50%", background: t.colors.briefGlow }} />
          {/* Top row */}
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 9, position: "relative", zIndex: 1 }}>
            <div style={{ width: 6, height: 6, borderRadius: "50%", background: t.colors.gold, flexShrink: 0 }} />
            <span style={{ fontSize: 10, fontWeight: 600, letterSpacing: t.font.ls1em, color: t.colors.onDarkFaint, textTransform: "uppercase", flex: 1, ...uvx(studioType.heading) }}>{t.theme === 'uv' ? "Today's briefing" : "TODAY'S BRIEFING"}</span>
            {!briefingRead && (
              <span style={{ background: t.colors.briefPillBg, border: `1px solid ${t.colors.briefPillBorder}`, fontSize: 10, fontWeight: t.font.lw700, color: t.colors.briefAccent, textTransform: "uppercase", borderRadius: 20, padding: "2px 9px" }}>UNREAD</span>
            )}
            <span onClick={(e) => { e.stopPropagation(); onNav(20); }} style={{ fontSize: 12, fontWeight: 600, color: t.colors.briefRead, marginLeft: 8, cursor: "pointer" }}>{'Read' + studioArrow()}</span>
          </div>
          {/* Title */}
          {t.theme !== 'uv' && (
          <div style={{ fontFamily: t.font.serif, fontStyle: t.font.italic, fontSize: 23, color: t.colors.paper95, lineHeight: 1.2, marginBottom: 9, position: "relative", zIndex: 1 }}>
            {greeting}, {firstName}.
          </div>
          )}
          {/* Body */}
          <div style={{ fontSize: 13, color: t.colors.briefBody, lineHeight: 1.6, display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden", position: "relative", zIndex: 1 }}>
            {/* Was `briefingData?.summary` -- a field the portal has NEVER
                emitted at any version, so this line only ever rendered its
                fallback. Now reads the producer's own beats via briefingBeats:
                the STAND line is the one-sentence "where you stand"; the MOVE
                headline is the next best thing to say in two clamped lines. If
                neither is present the beat was blanked by the verifier or no
                briefing exists, and the honest fallback stands. */}
            {(() => {
              const tb = briefingBeats(briefingData);
              // Studio switch on: the move headline is Eva's read at the top
              // of the screen, so it is not said again here (each line once).
              if (t.theme === 'uv' && tb.move && !tb.stand) return null;
              const line = (tb.plan.first && tb.plan.first.text) || tb.stand || (tb.move && tb.move.headline) || (tb.plan.error || null);
              // tb.stand is the portal's own sentence (data), shown as sent.
              return line ? sanitiseText(line) : `Nothing in the diary yet${studioDash()}clean slate. Time to build something.`
            })()}
          </div>
          {/* Divider */}
          <div style={{ height: 1, background: t.colors.paper07, margin: "14px 0", position: "relative", zIndex: 1 }} />
          {/* Stats strip */}
          <div style={{ display: "flex", gap: 20, position: "relative", zIndex: 1 }}>
            <div>
              <div style={{ fontFamily: t.font.serif, fontStyle: t.font.italic, fontSize: 16, color: t.colors.paper82, fontVariantNumeric: t.font.tabular }}>{pipelineTotal == null ? TRUTH_DASH : formatCurrency(pipelineTotal)}</div>
              <div style={{ fontSize: 10, textTransform: "uppercase", color: t.colors.onDarkFaint28, letterSpacing: t.font.labelLs, fontWeight: t.font.labelW }}>PIPELINE</div>
            </div>
            <div>
              <div style={{ fontFamily: t.font.serif, fontStyle: t.font.italic, fontSize: 16, color: goneSilentCount > 0 ? t.colors.briefAlert : t.colors.briefCount, ...uvx(() => (goneSilentCount > 0 ? { color: STUDIO_MEANING.rustText } : {})) }}>{goneSilentCount == null ? TRUTH_DASH : goneSilentCount}</div>
              <div style={{ fontSize: 10, textTransform: "uppercase", color: t.colors.onDarkFaint28, letterSpacing: t.font.labelLs, fontWeight: t.font.labelW }}>GONE SILENT</div>
            </div>
          </div>
        </div>
        )}

        {/* ══════ SECTION 1b: STREAK CARD (daily habit hook) ══════ */}
        {/* STUDIO-LIT-PHONE-V1: switch on, the runs live on My performance
            (the prototype's place); Today keeps only the run at risk. */}
        {t.theme !== 'uv' && (() => {
          const s = effStreaks || emptyStreaks;
          const streaks = [
            { key: 'platform', name: 'Platform', color: t.colors.streakPlatform, bg: t.colors.gold10, border: t.colors.gold25, dotBg: t.colors.gold25, desc: 'Any platform action', data: s.platform || { current: 0, best: 0, history: [] } },
            { key: 'builder',  name: 'Builder',  color: t.colors.streakBuilder, bg: t.colors.sky10,  border: t.colors.sky25,  dotBg: t.colors.sky25,  desc: 'Proposal built or sent', data: s.builder || { current: 0, best: 0, history: [] } },
            { key: 'closer',   name: 'Closer',   color: t.colors.streakCloser, bg: t.colors.green10,   border: t.colors.green25,   dotBg: t.colors.green25,   desc: 'Follow-up logged on sent proposal', data: s.closer || { current: 0, best: 0, history: [] } },
          ];
          return (
            <div style={{ margin: '0 12px 10px', padding: '14px 14px 12px', background: t.colors.glass, border: `1px solid ${t.colors.sand35}`, borderRadius: t.radius.card14, boxShadow: t.shadow.card }}>
              <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', marginBottom: 11 }}>
                <span style={{ fontSize: 11, fontWeight: t.font.lw700, letterSpacing: t.font.ls09em, textTransform: 'uppercase', color: t.colors.stone5, ...uvx(studioType.heading) }}>Streaks</span>
                <span style={{ fontSize: 11, color: t.colors.textTertiary }}>last 14 weeks</span>
              </div>

              {/* Three rows */}
              {streaks.map((row, idx) => {
                const hist = Array.isArray(row.data.history) ? row.data.history.slice(-14) : [];
                while (hist.length < 14) hist.unshift(0);
                return (
                  <div key={row.key} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '9px 0', borderTop: idx === 0 ? 'none' : `1px solid ${t.colors.sand30}` }}>
                    {/* Count */}
                    <div style={{ width: 44, flexShrink: 0, textAlign: 'left' }}>
                      {/* S95 D5 — 0 means "no activity yet" per the never-fabricate
                          rule; render em-dash so users don't read a genuine zero-
                          data state as a measured "zero-week" streak. */}
                      <div style={{ fontFamily: t.font.serif, fontStyle: t.font.italic, fontSize: 22, color: row.color, lineHeight: 1 }}>{row.data.current ? row.data.current : '\u2014'}</div>
                      <div style={{ fontSize: 11, color: t.colors.stone4, marginTop: 2 }}>weeks</div>
                    </div>
                    {/* Name + description */}
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: 13, fontWeight: 800, color: t.colors.text }}>{row.name}</div>
                      <div style={{ fontSize: 11, color: t.colors.stone48, marginTop: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{row.desc}</div>
                    </div>
                    {/* Dot history — 14 squares, faded opacity left→right (older fainter) */}
                    <div style={{ display: 'flex', gap: 2, flexShrink: 0 }}>
                      {hist.map((on, i) => {
                        const opacity = 0.35 + (i / 13) * 0.65;
                        return (
                          <span key={i} style={{ width: 7, height: 7, borderRadius: 2, background: on ? row.color : t.colors.sand3, opacity: on ? opacity : 1, display: 'block' }} />
                        );
                      })}
                    </div>
                    {/* Best */}
                    <div style={{ width: 40, flexShrink: 0, textAlign: 'right' }}>
                      <div style={{ fontFamily: t.font.serif, fontStyle: t.font.italic, fontSize: 15, color: t.colors.text, lineHeight: 1 }}>{row.data.best ? row.data.best : '\u2014'}</div>
                      <div style={{ fontSize: 11, fontWeight: t.font.lw700, color: t.colors.textTertiary, marginTop: 2, letterSpacing: t.font.ls06em, textTransform: 'uppercase' }}>Best</div>
                    </div>
                  </div>
                );
              })}

              {/* Records section */}
              <div style={{ marginTop: 10, paddingTop: 10, borderTop: `1px solid ${t.colors.sand30}` }}>
                <div style={{ fontSize: 11, fontWeight: t.font.lw700, letterSpacing: t.font.ls09em, textTransform: 'uppercase', color: t.colors.stone45, marginBottom: 7 }}>Records</div>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 6, marginBottom: 8 }}>
                  {streaks.map(r => (
                    <div key={r.key} style={{ background: r.bg, border: `1px solid ${r.border}`, borderRadius: 10, padding: '8px 10px', minWidth: 0 }}>
                      <div style={{ fontFamily: t.font.serif, fontStyle: t.font.italic, fontSize: 18, color: r.color, lineHeight: 1 }}>{r.data.best ? r.data.best : '\u2014'}</div>
                      <div style={{ fontSize: 11, fontWeight: 700, color: t.colors.text, marginTop: 3 }}>{r.name} Best</div>
                      <div style={{ fontSize: 11, color: t.colors.stone42, marginTop: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.data.best_range || '\u2014'}</div>
                    </div>
                  ))}
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6 }}>
                  <div style={{ background: t.colors.sand18, border: `1px solid ${t.colors.sand35}`, borderRadius: 10, padding: '8px 10px' }}>
                    <div style={{ fontFamily: t.font.serif, fontStyle: t.font.italic, fontSize: 15, color: t.colors.text, lineHeight: 1 }}>{s.weeks_since_joining ?? '\u2014'}</div>
                    <div style={{ fontSize: 11, fontWeight: 700, color: t.colors.stone55, marginTop: 3 }}>Weeks Since Joining</div>
                  </div>
                  <div style={{ background: t.colors.sand18, border: `1px solid ${t.colors.sand35}`, borderRadius: 10, padding: '8px 10px' }}>
                    <div style={{ fontFamily: t.font.serif, fontStyle: t.font.italic, fontSize: 15, color: t.colors.text, lineHeight: 1 }}>{s.active_week_rate != null ? `${s.active_week_rate}%` : '\u2014'}</div>
                    <div style={{ fontSize: 11, fontWeight: 700, color: t.colors.stone55, marginTop: 3 }}>Active Week Rate</div>
                  </div>
                </div>
              </div>
            </div>
          );
        })()}

        {/* ══════ SECTION 1c: PERSONAL BESTS CARD (10 records) ══════ */}
        {/* STUDIO-LIT-PHONE-V1: switch on, personal bests live on My
            performance (the prototype's place), not as a grid of tiles here. */}
        {t.theme !== 'uv' && (() => {
          const records = (effBests && Array.isArray(effBests.records)) ? effBests.records : [];
          const byKey = (k) => records.find(r => r.key === k) || null;
          const fmtGold = (v) => (v == null || v === '') ? '\u2014' : (typeof v === 'number' ? `\u00A3${v >= 1000 ? (v >= 1000000 ? (v/1000000).toFixed(1)+'m' : (v/1000).toFixed(0)+'k') : v}` : v);
          const tiles = [
            { key: 'largest_quote',      label: 'Largest Quote',        tone: 'gold' },
            { key: 'pipeline_month',     label: 'Pipeline / Month',     tone: 'gold' },
            { key: 'best_sales_month',   label: 'Best Sales Month',     tone: 'gold' },
            { key: 'highest_margin',     label: 'Highest Margin Order', tone: 'gold' },
            { key: 'proposals_month',    label: 'Proposals / Month',    tone: 'plain' },
            { key: 'proposals_year',     label: 'Proposals / Year',     tone: 'plain' },
            { key: 'best_week',          label: 'Best week quoting',    tone: 'gold' },
            { key: 'avg_margin_month',   label: 'Best Avg Margin',      tone: 'plain' },
            { key: 'new_clients_month',  label: 'New Clients / Month',  tone: 'plain' },
            { key: 'active_clients_month', label: 'Active Clients / Mo', tone: 'plain' },
          ];
          const thisMonthRecord = records.find(r => r.set_this_month);
          return (
            <div style={{ margin: '0 12px 10px', padding: '14px 14px 12px', background: t.colors.glass, border: `1px solid ${t.colors.sand35}`, borderRadius: t.radius.card14, boxShadow: t.shadow.card }}>
              <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', marginBottom: 10 }}>
                <span style={{ fontSize: 11, fontWeight: t.font.lw700, letterSpacing: t.font.ls09em, textTransform: 'uppercase', color: t.colors.stone5, ...uvx(studioType.heading) }}>{t.theme === 'uv' ? 'Personal bests' : 'Personal Bests'}</span>
                <span style={{ fontSize: 11, color: t.colors.textTertiary }}>{records.length > 0 ? `${records.length} records` : '\u2014'}</span>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6 }}>
                {tiles.map(t2 => {
                  const rec = byKey(t2.key);
                  const valueRaw = rec?.value;
                  const byUnit = personalBestUnitValue(valueRaw, rec?.unit);
                  const valueStr = byUnit != null ? byUnit : t2.tone === 'gold'
                    ? (valueRaw != null && valueRaw !== '' ? fmtGold(valueRaw) : 'None yet')
                    : (valueRaw != null && valueRaw !== '' ? String(valueRaw) : 'None yet');
                  const numColor = (t2.tone === 'gold' && valueRaw != null && valueRaw !== '') ? t.colors.goldMoney : t.colors.text;
                  return (
                    <div key={t2.key} style={{ background: t.colors.sand15, border: `1px solid ${t.colors.sand35}`, borderRadius: 10, padding: '9px 10px', minWidth: 0 }}>
                      <div style={{ fontFamily: t.font.serif, fontStyle: t.font.italic, fontSize: 17, color: numColor, lineHeight: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontVariantNumeric: t.font.tabular }}>{valueStr}</div>
                      {/* S95 D5 D34 — labels like "Active Clients / Mo" were being
                          clipped by nowrap. Allow two-line wrap instead of ellipsis
                          so every tile label stays fully legible. */}
                      <div style={{ fontSize: 11, fontWeight: 700, color: t.colors.text, marginTop: 4, whiteSpace: 'normal', lineHeight: 1.2 }}>{t2.label}</div>
                      <div style={{ fontSize: 11, color: t.colors.stone4, marginTop: 2, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{personalBestContext(rec?.context) || 'None yet'}</div>
                    </div>
                  );
                })}
              </div>
              {thisMonthRecord && (
                <div style={{ fontSize: 11, fontStyle: t.font.italic, color: t.colors.stone5, marginTop: 10, textAlign: 'center' }}>
                  New record this month: <b style={{ color: t.colors.goldInk }}>{thisMonthRecord.label}</b>
                </div>
              )}
              {records.length === 0 && (
                <div style={{ fontSize: 11, fontStyle: t.font.italic, color: t.colors.stone4, marginTop: 10, textAlign: 'center' }}>
                  Records appear as you use the app.
                </div>
              )}
            </div>
          );
        })()}

        {/* ══════ SECTION 2: ACTIVE SURVEY CARD ══════ */}
        {/* Studio switch on: the survey in progress is a row in uvDay, with
            these same details. */}
        {t.theme !== 'uv' && activeSurveyProj && (() => {
          const asp = activeSurveyProj;
          const aspAddress = asp.address || asp.siteAddress || asp.site_address || '';
          const aspZones = asp.surveyZones || [];
          // S95 D22 — surveyZones is a FLAT array of entries (persist() in LiveSurveyScreen
          // flatMaps to {uid, zone, unit:{wattage,…}, qty, …}). Earlier code treated each
          // entry as a zone with a nested .fittings array, so totals were always 0.
          const aspFittings = aspZones.reduce((s, e) => s + (parseInt(e.qty) || 1), 0);
          const aspExistingKw = aspZones.reduce((s, e) => {
            const w = parseFloat(e.unit?.wattage ?? e.wattage ?? 0);
            const q = parseInt(e.qty) || 1;
            return s + (w * q) / 1000;
          }, 0);
          const aspZoneCount = new Set(aspZones.map(e => e.zone).filter(Boolean)).size
            || (asp.customZones?.length || 0);
          const aspStartTime = asp.surveyStartedAt ? new Date(asp.surveyStartedAt).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' }) : '';
          return (
            <div style={{ margin: "10px 12px 0", borderRadius: t.radius.lg, background: t.colors.liveCardGrad, border: `1px solid ${t.colors.mint2}`, padding: "16px 18px", position: "relative", overflow: "hidden", boxShadow: t.shadow.inkCard }}>
              <div style={{ position: "absolute", top: -20, right: -20, width: 90, height: 90, background: "rgba(255,255,255,0.03)", borderRadius: "50%", ...uvx({ display: "none" }) }} />
              <div style={{ position: "relative", zIndex: 1 }}>
                {/* Label row with pulsing dot */}
                <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
                  <div style={{ width: 8, height: 8, borderRadius: "50%", background: t.colors.liveDot, boxShadow: t.shadow.liveDot, flexShrink: 0, animation: "pulse-green 2s ease-in-out infinite" }} />
                  <span style={{ fontSize: 10, fontWeight: t.font.lw700, textTransform: "uppercase", letterSpacing: t.font.ls1em, color: t.colors.liveLabel }}>{t.theme === 'uv' ? 'Survey in progress' : 'Survey in Progress'}</span>
                </div>
                <style>{t.theme === 'uv'
                  ? `@keyframes pulse-green { 0%,100% { opacity:1; box-shadow: 0 0 6px rgba(242,162,58,.6); } 50% { opacity:0.5; box-shadow: 0 0 12px rgba(242,162,58,.9); } }`
                  : `@keyframes pulse-green { 0%,100% { opacity:1; box-shadow: 0 0 6px rgba(94,192,128,0.6); } 50% { opacity:0.5; box-shadow: 0 0 12px rgba(94,192,128,0.9); } }`}</style>

                {/* Site name */}
                <div style={{ fontSize: 16, fontWeight: 700, color: t.colors.onFill, marginBottom: 3 }}>{asp.name}</div>
                <div style={{ fontSize: 12, color: "rgba(255,255,255,0.45)", marginBottom: 12, ...uvx(() => ({ color: STUDIO_TOKENS.jewel.textSecondary })) }}>
                  {aspStartTime ? `Started ${aspStartTime}` : ''}{aspStartTime && aspFittings > 0 ? studioSep() : ''}{aspFittings > 0 ? `${aspFittings} fittings logged` : ''}
                </div>

                {/* Stat tiles */}
                <div style={{ display: "flex", gap: 6, marginBottom: 12 }}>
                  {[
                    { label: 'Fixtures', value: aspFittings || '0' },
                    { label: 'Existing kW', value: aspExistingKw > 0 ? aspExistingKw.toFixed(1) : '0' },
                    { label: 'Zones', value: aspZoneCount || '0' },
                  ].map(tile => (
                    <div key={tile.label} style={{ flex: 1, background: "rgba(255,255,255,0.05)", borderRadius: 10, padding: "8px 10px", textAlign: "center", ...uvx({ background: "rgba(237,232,255,0.08)" }) }}>
                      <div style={{ fontFamily: t.font.serif, fontStyle: t.font.italic, fontSize: 16, color: t.colors.onFill, lineHeight: 1.2 }}>{tile.value}</div>
                      <div style={{ fontSize: 9, color: "rgba(255,255,255,0.4)", textTransform: "uppercase", letterSpacing: t.font.ls05em, marginTop: 2, fontWeight: t.font.labelW, ...uvx(() => ({ color: STUDIO_TOKENS.jewel.textSecondary })) }}>{tile.label}</div>
                    </div>
                  ))}
                </div>

                {/* Button row */}
                <div style={{ display: "flex", gap: 8 }}>
                  {aspAddress && (
                    <button onClick={(e) => { e.stopPropagation(); openMaps(aspAddress); }} style={{
                      flex: 1, padding: "9px 12px", borderRadius: 12, background: "transparent", border: "1px solid rgba(255,255,255,0.15)",
                      color: t.colors.onFill, fontSize: 12, fontWeight: 600, cursor: "pointer", fontFamily: "inherit",
                      ...uvx(() => ({ border: `1px solid ${t.colors.mint2}`, color: STUDIO_TOKENS.jewel.text }))
                    }}>Maps</button>
                  )}
                  <button onClick={() => { setActiveProject(asp); onNav(3); }} style={{
                    flex: 3, padding: "9px 14px", borderRadius: 12, background: t.colors.mint15, border: `1px solid ${t.colors.mint3}`,
                    color: t.colors.liveLabel, fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: "inherit"
                  }}>{'Continue survey' + studioArrow()}</button>
                </div>
              </div>
            </div>
          );
        })()}

        {/* B2 — compact in-progress survey card removed (S82 Polish Fix 3: hero card is sufficient) */}

        {/* Sync strip */}
        {/* STUDIO-LIT-PHONE-V1: switch on, the line at the foot (uvMore). */}
        {t.theme !== 'uv' && lastSyncTime && (
          <div style={{ margin: '10px 12px 0', padding: '9px 14px', borderRadius: 12, background: t.colors.paper7, border: `1px solid ${t.colors.ink06}`, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke={t.colors.ink3} strokeWidth="2" strokeLinecap="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
              <span style={{ fontSize: 11, fontWeight: 600, color: t.colors.ink38 }}>Portal data synced</span>
            </div>
            <span style={{ fontSize: 11, fontFamily: t.font.sysUi, color: t.colors.ink3 }}>{lastSyncTime}</span>
          </div>
        )}

        {/* ══════ SECTION 5: YOUR DAY ══════ */}
        {/* Studio switch on: the time line (uvDay, at the top) replaces these
            cards and the survey hero above; the visit behaviours are shared
            helpers (todayVisitPrimary, todayVisitDelete, todayVisitBrief). */}
        {t.theme !== 'uv' && (
        <div style={{ margin: "14px 0 0", padding: "0 12px" }}>
          {/* Section header */}
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px 2px 9px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <div style={{ width: 3, height: 17, borderRadius: 2, background: t.colors.green }} />
              <div>
                <div style={{ fontSize: 12, fontWeight: t.font.lw700, color: t.colors.text, letterSpacing: t.font.ls06em, textTransform: "uppercase", ...uvx(studioType.heading) }}>{t.theme === 'uv' ? 'Your day' : 'Your Day'}</div>
                <div style={{ fontSize: 11, color: t.colors.ink38, marginTop: 1 }}>{todayFormatted}</div>
              </div>
            </div>
            <span style={{ fontSize: 11, fontWeight: 600, padding: "4px 10px", borderRadius: 20, background: t.colors.chipFillGreen, color: t.colors.chipTextOnFill }}>{todayVisits.length} visit{todayVisits.length !== 1 ? 's' : ''}</span>
          </div>

          {/* Visit cards */}
          {todayVisits.map((visit, idx) => {
            const briefOpen = openBriefs[visit.id || idx] || false;
            const isSurvey = visit.type === 'survey';
            const surveyStatus = visit.status || 'planned';
            const visitGradients = {
              survey: t.colors.visitGradSurvey,
              meeting: t.colors.visitGradMeeting,
              supplier: t.colors.visitGradSupplier,
              pitch: t.colors.visitGradPitch,
            };
            const visitTypeNorm = (visit.type || '').toLowerCase();
            const cardGradient = visitGradients[visitTypeNorm] || visitGradients.survey;
            const visitCtaLabels = {
              survey: { secondary: "Pre-visit brief", primary: "Start survey" + studioArrow() },
              meeting: { secondary: "Pre-visit brief", primary: "Open notes" + studioArrow() },
              supplier: { secondary: "Products & pricing", primary: "Log visit" + studioArrow() },
              pitch: { secondary: "Pre-pitch brief", primary: "Start pitch" + studioArrow() },
            };
            const ctaLabels = visitCtaLabels[visitTypeNorm] || visitCtaLabels.survey;
            const deleteVisit = todayVisitDelete(visit, idx);
            return (
              <LongPressCard key={visit.id || idx} onDelete={deleteVisit} style={{ marginBottom: 10 }}>
                <div style={{ borderRadius: 18, overflow: "hidden", boxShadow: t.shadow.visitCard, ...uvx(() => ({ boxShadow: STUDIO_TOKENS.shadow.slip })) }}>
                  <div style={{ background: cardGradient, padding: "15px 44px 14px 17px", ...uvx(() => ({ ...studioLit('enquiry'), boxShadow: 'none' })) }}>
                    {/* Top row */}
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontFamily: t.font.serif, fontStyle: t.font.italic, fontSize: 19, color: t.colors.paper95, letterSpacing: "-0.01em" }}>
                          {visit.projectName || visit.name || 'Site Visit'}
                        </div>
                        <div style={{ fontSize: 12, color: t.colors.paper38, marginBottom: 13 }}>
                          {[visit.clientName || visit.client, visit.contactName || visit.contact].filter(Boolean).join(studioSep())}{visit.type ? `${[visit.clientName || visit.client, visit.contactName || visit.contact].some(Boolean) || t.theme !== 'uv' ? studioSep() : ''}${(visit.type || '').charAt(0).toUpperCase() + (visit.type || '').slice(1)}` : ''}
                        </div>
                      </div>
                      {visit.time && <div style={{ fontSize: 13, color: t.colors.paper38, flexShrink: 0, marginLeft: 12 }}>{visit.time}</div>}
                    </div>
                    {/* Action buttons */}
                    <div style={{ display: "flex", gap: 8 }}>
                      <button onClick={(e) => { e.stopPropagation(); toggleBrief(visit.id || idx); }} style={{
                        flex: 1, padding: "9px 0", borderRadius: 10,
                        background: t.colors.paper07, border: `1px solid ${t.colors.paper09}`,
                        fontSize: 12, fontWeight: 500, color: t.colors.paper55, textAlign: "center",
                        cursor: "pointer", fontFamily: "inherit"
                      }}>{briefOpen ? 'Hide brief' : ctaLabels.secondary}</button>
                      <button onClick={todayVisitPrimary(visit, idx)} style={{
                        flex: 1, padding: "9px 0", borderRadius: 10,
                        background: t.colors.paper14, border: `1px solid ${t.colors.paper20}`,
                        fontSize: 12, fontWeight: 600, color: t.colors.paper92, textAlign: "center",
                        cursor: "pointer", fontFamily: "inherit"
                      }}>{ctaLabels.primary}</button>
                    </div>
                  </div>
                </div>
                {/* Pre-visit brief panel */}
                {briefOpen && todayVisitBrief(visit)}
              </LongPressCard>
            );
          })}
        </div>
        )}

        {/* ══════ SECTION 5b: UPCOMING ══════ */}
        {/* Studio switch on: Upcoming follows Your day inside uvDay. */}
        {t.theme !== 'uv' && upcomingVisits.length > 0 && (
          <div style={{ margin: "14px 0 0", padding: "0 12px" }}>
            {/* Section header */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px 2px 9px" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <div style={{ width: 3, height: 17, borderRadius: 2, background: t.colors.goldInk }} />
                <div>
                  <div style={{ fontSize: 12, fontWeight: t.font.lw700, color: t.colors.text, letterSpacing: t.font.ls06em, textTransform: "uppercase", ...uvx(studioType.heading) }}>Upcoming</div>
                  <div style={{ fontSize: 11, color: t.colors.ink38, marginTop: 1 }}>Scheduled visits</div>
                </div>
              </div>
              <span style={{ fontSize: 11, fontWeight: 600, padding: "4px 10px", borderRadius: 20, background: t.colors.chipGold14, color: t.colors.chipGoldText }}>{upcomingVisits.length} scheduled</span>
            </div>
            {upcomingVisits.map((visit, idx) => {
              const vDate = new Date((visit.date || '').split('T')[0] + 'T00:00:00');
              const diffDays = Math.round((vDate - new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())) / 86400000);
              const shortDayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
              const typeBadgeStyles = {
                survey: { bg: t.colors.chipSurvey, color: t.colors.green },
                meeting: { bg: t.colors.chipMeeting, color: t.colors.chipMeetingText },
                supplier: { bg: t.colors.chipSupplier, color: t.colors.teal },
                pitch: { bg: t.colors.chipPitch, color: t.colors.chipPitchText },
              };
              const badge = typeBadgeStyles[visit.type] || typeBadgeStyles.survey;
              const deleteVisit = () => {
                try {
                  const vs = JSON.parse(localStorage.getItem('lumen_visits') || '[]');
                  const updated = vs.filter((v, i) => visit.id ? v.id !== visit.id : i !== idx);
                  localStorage.setItem('lumen_visits', JSON.stringify(updated));
                  window.dispatchEvent(new CustomEvent('lumenDataSync'));
                } catch(e) { console.warn('Delete visit failed:', e); }
              };
              return (
                <LongPressCard key={visit.id || ('up_' + idx)} onDelete={deleteVisit} style={{ marginBottom: 8 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 13, background: t.colors.ink04, borderRadius: 15, border: `1px solid ${t.colors.ink07}`, padding: "12px 15px", ...uvx(() => ({ border: 'none', ...studioLitColour(STUDIO_MEANING.slateFill) })) }}>
                    {/* Calendar tile */}
                    <div style={{ width: 46, background: t.colors.calTile, borderRadius: 10, padding: "6px 4px", textAlign: "center", flexShrink: 0 }}>
                      <div style={{ fontSize: 10, fontWeight: 600, color: t.colors.ink45, textTransform: "uppercase", letterSpacing: t.font.ls06em }}>{shortDayNames[vDate.getDay()]}</div>
                      <div style={{ fontSize: 21, fontWeight: t.font.numW700, color: t.colors.text, lineHeight: 1.05, fontFamily: t.font.numFace }}>{vDate.getDate()}</div>
                    </div>
                    {/* Body */}
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontFamily: t.font.serif, fontStyle: t.font.italic, fontSize: 15, color: t.colors.text, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{visit.projectName || visit.name || 'Visit'}</div>
                      <div style={{ fontSize: 12, color: t.colors.ink42, marginTop: 2 }}>{[visit.clientName || visit.client, visit.contactName || visit.contact].filter(Boolean).join(studioSep())}</div>
                      {visit.type && (
                        <span style={{ display: "inline-block", fontSize: 10, fontWeight: 600, textTransform: "uppercase", letterSpacing: t.font.ls04em, padding: "3px 8px", borderRadius: 20, marginTop: 5, background: badge.bg, color: badge.color }}>{(visit.type || '').charAt(0).toUpperCase() + (visit.type || '').slice(1)}</span>
                      )}
                    </div>
                    {/* Chevron */}
                    <div style={{ color: t.colors.ink18, fontSize: 20, flexShrink: 0 }}>{'\u203A'}</div>
                  </div>
                </LongPressCard>
              );
            })}
          </div>
        )}

        {/* ══════ SECTION 6: ACTIONS ══════ */}
        {/* STUDIO-LIT-PHONE-V1: switch on, the quotes to chase live on
            Pipeline (the prototype's place); no chase cards on Today. */}
        {t.theme !== 'uv' && (
        <div style={{ margin: "14px 0 0", padding: "0 12px" }}>
          {/* Section header */}
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px 2px 9px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <div style={{ width: 3, height: 17, borderRadius: 2, background: t.colors.actionsBar }} />
              <div>
                {/* COMPANION-STUDIO-LIT-V1 track 3a: "Needs you" and
                    "intelligence" are on the run's banned list; under the
                    switch the heading says what the section holds. */}
                <div style={{ fontSize: 12, fontWeight: t.font.lw700, color: t.colors.text, letterSpacing: t.font.ls06em, textTransform: "uppercase", ...uvx(studioType.heading) }}>{t.theme === 'uv' ? 'To chase' : 'Actions'}</div>
                <div style={{ fontSize: 11, color: t.colors.ink38, marginTop: 1 }}>{t.theme === 'uv' ? 'Quotes with no reply, and flags from the portal' : 'Platform intelligence'}</div>
              </div>
            </div>
            <span style={{ fontSize: 11, fontWeight: 600, padding: "4px 10px", borderRadius: 20, background: t.colors.alert11, color: t.colors.alertText, boxShadow: t.shadow.needsYouRing }}>{flaggedCount} flagged</span>
          </div>

          {/* Stale quote cards — red style. Kept visually prominent
              (per brief: "remain visually prominent") even as the
              intel cards below compress. Capped at 3 with an overflow
              link to Pipeline if more exist. */}
          {staleQuotes.slice(0, 3).map((item, idx) => {
            const p = item.proposal;
            const rawRef = (p.quoteRef || p.reference || '').replace('SP-L', '').trim();
            const refPlaceholders = ['Q-000', 'Q-QQ', 'QQ', 'Q-', '000', 'PROJECT'];
            const namePlaceholders = ['project', 'quote project', 'client', 'unnamed', 'untitled', 'test', ''];
            const hasRealRef = rawRef && !refPlaceholders.includes(rawRef.toUpperCase());
            const rawLabel = p.projectName || p.project || p.title || p.client || p.projectClient || '';
            const projectLabel = namePlaceholders.includes(rawLabel.toLowerCase().trim()) ? '' : rawLabel;
            const quoteRefLabel = rawRef ? `Quote ${rawRef}` : '';
            const cardTitle = hasRealRef
              ? `Quote ${rawRef}${studioDash()}no response`
              : projectLabel
                ? `${projectLabel}${studioDash()}no response`
                : quoteRefLabel
                  ? `${quoteRefLabel}${studioDash()}no response`
                  : `Unnamed quote${studioDash()}no response`;
            const val = parseFloat(p.value || p.totalValue || 0);
            return (
              <div key={idx} style={{ display: "flex", alignItems: "flex-start", gap: 13, borderRadius: t.radius.lg, padding: "15px 16px", marginBottom: 8, border: `1px solid ${t.colors.ink06}`, background: t.colors.staleGrad, boxShadow: t.shadow.card, ...uvx(() => ({ border: 'none', ...studioLitColour(STUDIO_MEANING.rustFill) })) }}>
                {/* Dot */}
                <div style={{ width: 8, height: 8, borderRadius: "50%", background: t.colors.staleDot, boxShadow: t.shadow.staleDot, flexShrink: 0, marginTop: 4 }} />
                {/* Body */}
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 14, fontWeight: 600, color: t.colors.text }}>{cardTitle}</div>
                  <div style={{ fontSize: 12, color: t.colors.ink42, marginTop: 3 }}>
                    {p.client || p.projectName || ''}{val > 0 ? (t.theme === 'uv'
                      // UV-RESKIN-V1 track E: money is ochre with tabular figures,
                      // even inside a muted line. Theme off: the original string.
                      ? <>{studioSep()}<span style={{ color: t.colors.goldMoney, fontVariantNumeric: t.font.tabular }}>{formatCurrency(val)}</span></>
                      : ` \u00b7 ${formatCurrency(val)}`) : ''}{studioSep()}{item.daysSince} days unanswered
                  </div>
                  {/* COMPANION-TRUTH-V2 B5 (DECISIONS 176.137, 176.140): the job's own D16 margin, matched from the figures route's margins list. */}
                  <div style={{ fontSize: 12, color: t.colors.ink42, marginTop: 3 }}>{truthSentence(truthJobMargin(p).text)}</div>
                  {item.local && <button onClick={() => openChaseSheet({ proposal: item.local, daysSince: item.daysSince })} aria-label={`Chase ${cardTitle}`} style={{ minHeight:36, fontSize: 12, fontWeight: 700, color: t.colors.chaseLink, marginTop: 8, background:'none', border:'none', padding:'0', cursor:'pointer', fontFamily:'inherit', ...uvx(studioType.action) }}>{'Chase now' + studioArrow()}</button>}
                </div>
                {/* Right side */}
                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", flexShrink: 0 }}>
                  {item.daysSince > 21 && <span style={{ fontSize: 10, fontWeight: 700, background: t.colors.alertE12, color: t.colors.urgentText, padding: "4px 10px", borderRadius: 20, marginBottom: 4, boxShadow: t.shadow.needsYouRing }}>Urgent</span>}
                  <span style={{ fontSize: 12, fontWeight: 500, color: t.colors.ink22 }}>{item.daysSince}d</span>
                </div>
              </div>
            );
          })}

          {/* Overflow link when more than 3 stale quotes — drops user
              into Pipeline filtered view rather than rendering a wall
              of red cards. */}
          {staleQuotes.length > 3 && (
            <button onClick={() => onNav(18)} style={{
              width: '100%', padding: '8px 14px', marginBottom: 8,
              background: 'transparent', border: 'none', cursor: 'pointer',
              fontFamily: 'inherit', fontSize: 12, fontWeight: 600,
              color: t.colors.chaseLink, textAlign: 'left', display: 'flex',
              alignItems: 'center', gap: 6,
            }}>
              <span>+ {staleQuotes.length - 3} more stale quote{staleQuotes.length - 3 === 1 ? '' : 's'} →</span>
            </button>
          )}

          {/* Empty state when no stale quotes */}
          {staleQuotes.length === 0 && !localStorage.getItem('lumen_intelligence') && (
            <div style={{ marginBottom: 8, background: t.colors.paper60, borderRadius: t.radius.card14, padding: "13px 14px", textAlign: "center" }}>
              <div style={{ fontSize: 11, color: t.colors.stoneMid, fontStyle: t.font.italic }}>No flagged quotes right now. Keep quoting.</div>
            </div>
          )}

          {/* S103 — Portal intelligence cards, grouped by category in
              an accordion. Most-urgent category expanded by default,
              others collapsed under shelf headers (same dark-forest
              treatment as SurveyLandingScreen month headers).
              Compressed card layout: title 1-2 lines, project_name +
              score_impact on a single muted subline, body only when
              meaningfully different from title, action label as a
              right-aligned text link that navigates by insight_type. */}
          {intelCategoryGroups.length > 0 && intelCategoryGroups.map((group, idx) => {
            const expanded = isIntelCategoryExpanded(group.key, idx);
            const hasHigh = group.items.some(c => c.severity === 'high');
            return (
              <div key={'intel::' + group.key} style={{ marginBottom: 6 }}>
                {/* Shelf header — dark forest, matches SurveyLanding */}
                <button onClick={() => toggleIntelCategory(group.key, idx)}
                  aria-expanded={expanded ? 'true' : 'false'}
                  style={{
                    width: '100%',
                    display: 'flex', alignItems: 'center', gap: 10,
                    padding: '7px 14px', margin: '8px 0 8px',
                    background: t.colors.shelfBg, border: 'none',
                    borderRadius: 6,
                    boxShadow: t.shadow.shelf,
                    cursor: 'pointer', fontFamily: 'inherit',
                    textAlign: 'left', minHeight: 34,
                  }}>
                  <span style={{
                    fontFamily: t.font.serif, fontStyle: t.font.italic,
                    fontSize: 15, fontWeight: 400, lineHeight: 1.15,
                    color: t.colors.shelfText,
                  }}>{group.label}</span>
                  <span style={{
                    fontSize: 11, fontWeight: 500,
                    color: t.colors.paper62,
                  }}>· {group.items.length} flag{group.items.length === 1 ? '' : 's'}</span>
                  {hasHigh && (
                    <span style={{
                      fontSize: 9, fontWeight: 700,
                      background: t.colors.shelfHighBg,
                      color: t.colors.shelfHighText,
                      padding: '1px 7px', borderRadius: 8,
                      letterSpacing: t.font.ls005,
                    }}>HIGH</span>
                  )}
                  <span style={{ flex: 1 }} />
                  <svg width="12" height="12" viewBox="0 0 14 14" fill="none"
                    style={{
                      transition: 'transform 0.2s ease',
                      transform: expanded ? 'rotate(0deg)' : 'rotate(-90deg)',
                      flexShrink: 0,
                    }}>
                    <polyline points="3.5,6 7,9.5 10.5,6"
                      stroke={t.colors.paper85} strokeWidth="2"
                      strokeLinecap="round" strokeLinejoin="round" fill="none"/>
                  </svg>
                </button>
                {/* Cards — only when expanded */}
                {expanded && group.items.map((card, ci) => {
                  const dotColor = _intelSeverityDot(card.severity);
                  // Issue 1 — drop body div when redundant.
                  const sameAsTitle = !card.body || card.body === card.title;
                  // Issue 3 — wire onClick by insight_type. Map at
                  // _CATEGORY_NAV; null target = inert card (no cursor:pointer).
                  const navTarget = group.navTarget;
                  const cardClick = navTarget ? (() => onNav(navTarget)) : undefined;
                  return (
                    <div key={'intel::' + group.key + '::' + ci} onClick={cardClick}
                      style={{
                        display: 'flex', alignItems: 'center', gap: 10,
                        borderRadius: 12, padding: '12px 14px', marginBottom: 6,
                        border: `1px solid ${t.colors.ink06}`,
                        background: t.colors.intelCardGrad,
                        cursor: navTarget ? 'pointer' : 'default',
                      }}>
                      <div style={{
                        width: 7, height: 7, borderRadius: '50%',
                        background: dotColor, flexShrink: 0,
                        alignSelf: 'flex-start', marginTop: 5,
                      }} />
                      <div style={{ flex: 1, minWidth: 0 }}>
                        {/* Title — 1-2 lines max, ellipsis on overflow */}
                        <div style={{
                          fontSize: 13, fontWeight: 600, color: t.colors.text,
                          lineHeight: 1.3,
                          display: '-webkit-box', WebkitLineClamp: 2,
                          WebkitBoxOrient: 'vertical',
                          overflow: 'hidden', textOverflow: 'ellipsis',
                        }}>{card.title}</div>
                        {/* Compact subline: project_name + score_impact */}
                        {(card.project_name || (card.score_impact || 0) > 0) && (
                          <div style={{
                            fontSize: 11, color: t.colors.ink5,
                            marginTop: 2, display: 'flex',
                            alignItems: 'center', gap: 6,
                          }}>
                            {card.project_name && (
                              <span style={{
                                overflow: 'hidden', textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap', minWidth: 0,
                              }}>{card.project_name}</span>
                            )}
                            {(card.score_impact || 0) > 0 && (
                              <span style={{
                                fontSize: 9, fontWeight: 700,
                                background: t.colors.chipGold16,
                                color: t.colors.chipGoldText2,
                                padding: '1px 5px', borderRadius: 8,
                                flexShrink: 0,
                              }}>+{card.score_impact}pts</span>
                            )}
                          </div>
                        )}
                        {/* Body — only when meaningfully different from title */}
                        {!sameAsTitle && (
                          <div style={{
                            fontSize: 11, color: t.colors.ink55,
                            marginTop: 3, lineHeight: 1.35,
                            overflow: 'hidden', textOverflow: 'ellipsis',
                            display: '-webkit-box', WebkitLineClamp: 1,
                            WebkitBoxOrient: 'vertical',
                          }}>{sanitiseText(card.body)}</div>
                        )}
                      </div>
                      {/* Action label — right-aligned text link, not a CTA block */}
                      {card.action_label && (
                        <span style={{
                          fontSize: 11, fontWeight: 600, color: t.colors.intelAction,
                          flexShrink: 0, alignSelf: 'center',
                          whiteSpace: 'nowrap',
                        }}>{sanitiseText(card.action_label)} →</span>
                      )}
                    </div>
                  );
                })}
              </div>
            );
          })}

          {/* Empty state — only when both stale and intel are empty
              AND there's no cached intelligence payload yet */}
          {intelCategoryGroups.length === 0 && staleQuotes.length === 0
            && !localStorage.getItem('lumen_intelligence') && (
            <div style={{ background: t.colors.paper60, borderRadius: t.radius.card14, padding: "14px 16px", textAlign: "center" }}>
              <div style={{ fontSize: 11, color: t.colors.stoneMid, fontStyle: t.font.italic, lineHeight: 1.5 }}>{t.theme === 'uv' ? 'Flags appear here as you use the app' : 'Intelligence builds as you use the app'}</div>
            </div>
          )}
        </div>
        )}

        {/* ══════ ADD A VISIT ══════ */}
        {/* Studio switch on: uvAddVisit, after the quarter. */}
        {t.theme !== 'uv' && (
        <div style={{ margin: "0 12px", marginTop: 8 }}>
          <div style={{ background: t.colors.ink04, borderRadius: 18, border: `1px dashed ${t.colors.ink11}`, padding: 15 }}>
            <div style={{ fontSize: 10, fontWeight: t.font.lw700, letterSpacing: t.font.ls09em, color: t.colors.ink32, textTransform: "uppercase", marginBottom: 10, ...uvx(studioType.heading) }}>{t.theme === 'uv' ? 'Add a visit' : 'ADD A VISIT'}</div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
              {[
                { type: 'survey', label: 'Survey', pip: t.colors.green },
                { type: 'meeting', label: 'Meeting', pip: t.colors.pipMeeting },
                { type: 'supplier', label: 'Supplier', pip: t.colors.teal },
                { type: 'pitch', label: 'Pitch', pip: t.colors.pipPitch },
              ].map(btn => (
                <button key={btn.type} onClick={() => { setNewVisitType(btn.type); setShowAddVisitSheet(true); }} style={{
                  padding: "12px 13px", borderRadius: 13, background: t.colors.calTile,
                  display: "flex", alignItems: "center", gap: 9, border: "none",
                  cursor: "pointer", fontFamily: "inherit"
                }}>
                  <div style={{ width: 7, height: 7, borderRadius: "50%", background: btn.pip, flexShrink: 0 }} />
                  <span style={{ fontSize: 13, fontWeight: 500, color: t.colors.text }}>{btn.label}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
        )}

        {/* ══════ SECTION 7: MORE TOOLS ══════ */}
        {/* STUDIO-LIT-PHONE-V1: switch on, uvMore after Add a visit. */}
        {t.theme !== 'uv' && (
        <div style={{ padding: "12px 12px 12px" }}>
          <button onClick={() => onNav(16)} style={{ width: "100%", display: "flex", alignItems: "center", gap: 12, padding: "14px 16px", background: t.colors.glass, border: `1px solid ${t.colors.glassBorder}`, borderTop: `1px solid ${t.colors.glassBorderTop}`, borderRadius: t.radius.lg, cursor: "pointer", textAlign: "left", fontFamily: "inherit", boxShadow: t.shadow.card }}>
            <div style={{ width: 32, height: 32, borderRadius: 9, background: t.colors.stone06, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="5" r="2" fill={t.colors.stone4}/><circle cx="12" cy="12" r="2" fill={t.colors.stone4}/><circle cx="12" cy="19" r="2" fill={t.colors.stone4}/></svg>
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 13, fontWeight: 700, color: t.colors.text }}>More tools</div>
              <div style={{ fontSize: 11, color: t.colors.textTertiary, marginTop: 1 }}>Contacts, voice notes & about</div>
            </div>
            <svg width="8" height="14" viewBox="0 0 8 14" fill="none"><path d="M1 1l6 6-6 6" stroke={t.colors.stone25} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
          </button>
        </div>
        )}

        {/* Restore from portal */}
        {restoreAvailable && restoreAvailable.projects && restoreAvailable.projects.length > 0 && (
          <div style={{ padding: "0 12px 24px" }}>
            <GlassCard style={{ padding: 16, background: t.colors.blueLight, border: `1px solid ${t.colors.blue30}` }} hover={false}>
              <p style={{ fontSize: 14, fontWeight: 700, color: t.colors.text, marginBottom: 3 }}>Restore from Portal</p>
              <p style={{ fontSize: 12, color: t.colors.textSecondary, lineHeight: 1.4, marginBottom: 12 }}>
                Found {restoreAvailable.projects.length} project{restoreAvailable.projects.length !== 1 ? "s" : ""} on the portal. Restore them here?
              </p>
              <div style={{ display: "flex", gap: 8 }}>
                {/* Studio switch on (track 3a): the ink fill was a dark
                    surface the Studio rules refuse; restoring is the card's
                    main action, so it is the ultraviolet button. */}
                <button onClick={onRestore} style={{ padding: "8px 16px", borderRadius: t.radius.md, background: t.colors.blue, border: "none", color: t.colors.onFill, fontSize: 13, fontWeight: 700, cursor: "pointer", ...uvx(studioSurface.primary) }}>Restore All</button>
                <button onClick={onDismissRestore} style={{ padding: "8px 16px", borderRadius: t.radius.md, background: t.colors.glass, border: `0.5px solid ${t.colors.glassBorder}`, color: t.colors.textSecondary, fontSize: 13, fontWeight: 600, cursor: "pointer" }}>Dismiss</button>
              </div>
            </GlassCard>
          </div>
        )}

        {/* S95 D15 — Gone Silent chase action sheet */}
        {chaseSheet && (() => {
          const p = chaseSheet.proposal;
          const phone = getProposalPhone(p);
          const telHref = phone ? `tel:${phone.replace(/\s+/g,'')}` : null;
          const rawRef = (p.quoteRef || p.reference || '').replace('SP-L','').trim();
          const title = p.client || p.projectName || p.projectClient || (rawRef ? `Quote ${rawRef}` : 'Quote');
          return (
            /* S95 D5 D26 — centre-screen modal (backdrop z:9000, modal z:9001).
               Backdrop tap closes. Previously a bottom-sheet; brief now requires
               dialog at centre with fixed positioning and 48px side gutters. */
            <SheetPortal>
              <div onClick={closeChaseSheet} style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', zIndex:9000, touchAction:'none' }} />
              <div onClick={(e)=>e.stopPropagation()} role="dialog" aria-modal="true" style={{ position:'fixed', top:'50%', left:'50%', transform:'translate(-50%,-50%)', width:'calc(100% - 48px)', maxWidth:360, maxHeight:'calc(100dvh - 48px)', overflowY:'auto', background:t.colors.paperSolid, borderRadius:t.radius.lg, padding:'18px 18px 22px', boxShadow:t.shadow.dialog, zIndex:9001 }}>
                <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:4 }}>
                  <div style={{ width:8, height:8, borderRadius:'50%', background:t.colors.staleDot, boxShadow:t.shadow.staleDot }} />
                  <div style={{ fontSize:15, fontWeight:800, color:t.colors.text, flex:1, minWidth:0, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{title}</div>
                  <button onClick={closeChaseSheet} aria-label="Close" style={{ width:44, height:44, borderRadius:10, background:t.colors.ink06, border:'none', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:'inherit' }}>
                    <svg width="12" height="12" viewBox="0 0 10 10" fill="none" stroke={t.colors.stone5} strokeWidth="1.5" strokeLinecap="round"><line x1="2" y1="2" x2="8" y2="8"/><line x1="8" y1="2" x2="2" y2="8"/></svg>
                  </button>
                </div>
                <div style={{ fontSize:11, color:t.colors.ink5, marginBottom:14 }}>
                  {t.theme === 'uv' && chaseSheet.daysSince <= 7 ? chaseAgeLine(chaseSheet.daysSince) : <>{chaseSheet.daysSince} days unanswered</>}{rawRef ? ` · Quote ${rawRef}` : ''}
                </div>

                {chaseStep === 'menu' && (
                  <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
                    {/* Call — S95 D15b: hide the row entirely when no phone stored */}
                    {telHref && (
                      <a href={telHref} onClick={() => { /* tel: handled by OS */ }} style={{ display:'flex', alignItems:'center', gap:12, padding:'14px 16px', minHeight:56, background:t.colors.green10, border:`1px solid ${t.colors.green28}`, borderRadius:14, textDecoration:'none', color:t.colors.text }}>
                        <div style={{ width:40, height:40, borderRadius:10, background:t.colors.green, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
                        </div>
                        <div style={{ flex:1, minWidth:0 }}>
                          <div style={{ fontSize:14, fontWeight:700 }}>Call</div>
                          <div style={{ fontSize:12, color:t.colors.ink55, marginTop:2 }}>{phone}</div>
                        </div>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={t.colors.ink4} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
                      </a>
                    )}

                    {/* Voice note */}
                    <button onClick={() => {
                      // Carry project context into the voice recorder
                      try {
                        localStorage.setItem('lumen_voice_context', JSON.stringify({
                          source: 'chase', projectId: p.projectId || null,
                          client: p.client || '', quoteRef: rawRef, at: new Date().toISOString(),
                        }));
                      } catch(e) {}
                      closeChaseSheet();
                      // CENSUS F3 (COMPANION-STUDIO-LIT-V1 track 3a): this
                      // said onNav(17), which is My targets; voice notes is 9.
                      onNav(9); // voice notes screen
                    }} style={{ display:'flex', alignItems:'center', gap:12, padding:'14px 16px', minHeight:56, background:t.colors.gold10, border:`1px solid ${t.colors.gold28}`, borderRadius:14, cursor:'pointer', fontFamily:'inherit', textAlign:'left' }}>
                      <div style={{ width:40, height:40, borderRadius:10, background:t.colors.goldInk, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" y1="19" x2="12" y2="23"/><line x1="8" y1="23" x2="16" y2="23"/></svg>
                      </div>
                      <div style={{ flex:1, minWidth:0 }}>
                        <div style={{ fontSize:14, fontWeight:700, color:t.colors.text }}>Voice note</div>
                        <div style={{ fontSize:12, color:t.colors.ink55, marginTop:2 }}>Quick audio log against this job</div>
                      </div>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={t.colors.ink4} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
                    </button>

                    {/* Log update */}
                    <button onClick={() => setChaseStep('log')} style={{ display:'flex', alignItems:'center', gap:12, padding:'14px 16px', minHeight:56, background:t.colors.teal08, border:`1px solid ${t.colors.teal24}`, borderRadius:14, cursor:'pointer', fontFamily:'inherit', textAlign:'left' }}>
                      <div style={{ width:40, height:40, borderRadius:10, background:t.colors.teal, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>
                      </div>
                      <div style={{ flex:1, minWidth:0 }}>
                        <div style={{ fontSize:14, fontWeight:700, color:t.colors.text }}>Log update</div>
                        <div style={{ fontSize:12, color:t.colors.ink55, marginTop:2 }}>Text touchpoint → portal timeline</div>
                      </div>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={t.colors.ink4} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
                    </button>
                  </div>
                )}

                {chaseStep === 'log' && (
                  <div>
                    <label style={{ fontSize:10, fontWeight:t.font.lw800, color:t.colors.khaki, textTransform:'uppercase', letterSpacing:t.font.ls07, marginBottom:6, display:'block' }}>Update</label>
                    <textarea
                      value={chaseLogText}
                      onChange={e => setChaseLogText(e.target.value)}
                      autoFocus
                      placeholder="e.g. Left voicemail with John. He said he'd review and come back Thursday."
                      style={{ width:'100%', minHeight:120, background:'rgba(255,255,255,0.75)', border:`1px solid ${t.colors.ink12}`, borderRadius:12, padding:'12px 14px', fontSize:14, fontFamily:'inherit', color:t.colors.text, outline:'none', resize:'vertical' }} />
                    <div style={{ display:'flex', gap:8, marginTop:12 }}>
                      <button onClick={() => setChaseStep('menu')} style={{ flex:'0 0 auto', minHeight:44, padding:'0 18px', borderRadius:10, background:t.colors.ink06, border:`1px solid ${t.colors.ink12}`, color:t.colors.text, fontSize:13, fontWeight:700, cursor:'pointer', fontFamily:'inherit' }}>Back</button>
                      <button onClick={submitChaseLog} disabled={chaseSending || !chaseLogText.trim()} style={{ flex:1, minHeight:44, padding:'0 18px', borderRadius:10, background: chaseSending ? t.colors.green5 : t.colors.green, border:'none', color:t.colors.onFill, fontSize:14, fontWeight:800, cursor: chaseSending||!chaseLogText.trim() ? 'default':'pointer', fontFamily:'inherit', opacity: !chaseLogText.trim() ? 0.55 : 1 }}>
                        {chaseSending ? 'Saving…' : 'Log it'}
                      </button>
                    </div>
                  </div>
                )}

                {chaseStep === 'sent' && (
                  <div style={{ padding:'24px 12px', textAlign:'center' }}>
                    <div style={{ width:48, height:48, margin:'0 auto 10px', borderRadius:'50%', background:t.colors.green15, display:'flex', alignItems:'center', justifyContent:'center' }}>
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={t.colors.green} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                    </div>
                    <div style={{ fontSize:15, fontWeight:800, color:t.colors.green }}>Logged to timeline</div>
                  </div>
                )}
              </div>
            </SheetPortal>
          );
        })()}

        {/* Add visit modal (fixed overlay) */}
        {showAddVisitSheet && (() => {
          const visitColors = { survey: t.colors.green, meeting: t.colors.goldInk, supplier: t.colors.teal, pitch: t.colors.visitPitch };
          const visitLabels = { survey: 'Start Survey', meeting: 'Log Meeting', supplier: 'Log Visit', pitch: 'Log Pitch' };
          const visitTitles = { survey: 'New Survey Visit', meeting: 'New Meeting', supplier: 'New Supplier Visit', pitch: 'New Pitch' };
          const vColor = visitColors[newVisitType] || t.colors.goldInk;
          return (
          // P0 tidy (Studio switch on): the sheet covers the tab bar (z 500 over its
          // 100) and keeps the home-indicator inset clear at the bottom; its two
          // buttons are a sticky footer, so Cancel and the main button are on
          // screen whatever the fields above are scrolled to. Switch off is as it was.
          <SheetPortal>
          <div onClick={clearVisitModal} style={{ position: "fixed", inset: 0, background: t.colors.scrim45, zIndex: 500, display: "flex", alignItems: "center", justifyContent: "center", padding: 20, ...uvx({ padding: "20px 20px calc(20px + env(safe-area-inset-bottom, 0px))" }) }}>
            <div onClick={(e) => e.stopPropagation()} style={{
              background: t.colors.paperSolid,
              borderRadius: t.radius.xl,
              padding: "20px 18px 16px",
              width: "100%",
              maxWidth: 400,
              maxHeight: "85vh",
              overflowY: "auto",
              WebkitOverflowScrolling: "touch",
              // Switch on: the footer carries the bottom padding itself, so no
              // scrolled field shows in a strip beneath the buttons.
              ...uvx({ paddingBottom: 0 }),
            }}>
              <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:16 }}>
                <div style={{ width:8, height:8, borderRadius:"50%", background: vColor, flexShrink:0 }} />
                <div style={{ fontSize: 16, fontWeight: 700, color: t.colors.text }}>{visitTitles[newVisitType] || 'New Visit'}</div>
              </div>

              <div style={{ marginBottom: 12 }}>
                <label style={{ fontSize: 11, fontWeight: t.font.lw700, color: t.colors.brown, textTransform: "uppercase", letterSpacing: t.font.ls08em, display: "block", marginBottom: 4 }}>Visit name</label>
                <input value={newVisitName} onChange={(e) => setNewVisitName(e.target.value)} placeholder="e.g. Meadowbank House survey" style={{
                  width: "100%", padding: "10px 12px", borderRadius: 10, border: `0.5px solid ${t.colors.olive12}`,
                  background: t.colors.fieldBg, fontSize: 15, fontFamily: "inherit", color: t.colors.text, boxSizing: "border-box"
                }} />
              </div>

              {/* B.2 — project binding (canonical PRJ id or explicit null).
                  Shown for every visit type; binding is optional and never
                  blocks Save. Reuses the shared ProjectBindingCard. */}
              <div style={{ marginBottom: 12 }}>
                <label style={{ fontSize: 11, fontWeight: t.font.lw700, color: t.colors.brown, textTransform: "uppercase", letterSpacing: t.font.ls08em, display: "block", marginBottom: 6 }}>Project <span style={{ fontWeight: 600, color: t.colors.bark55 }}>(optional)</span></label>
                <ProjectBindingCard
                  binding={visitBinding}
                  accent={BIND_ACCENT_SURVEY}
                  unboundHint="Link this visit to a portal project so it lands on the contact's card."
                  onChoose={() => setVisitPickerOpen(true)} />
              </div>

              <div style={{ marginBottom: 12, position: "relative" }}>
                <label style={{ fontSize: 11, fontWeight: t.font.lw700, color: t.colors.brown, textTransform: "uppercase", letterSpacing: t.font.ls08em, display: "block", marginBottom: 4 }}>Contact</label>
                <input value={newVisitContact} onChange={(e) => handleContactInput(e.target.value)} onFocus={() => { _contactFocusedRef.current = true; const v = (newVisitContact || '').trim(); if (!newVisitContactId && v.length >= 2) { setContactSuggestions(_filterContacts(_readContactsCache(), v)); setShowContactDrop(true); } }} onBlur={() => { _contactFocusedRef.current = false; setTimeout(() => setShowContactDrop(false), 150); }} placeholder="Name or company…" style={{
                  width: "100%", padding: "10px 12px", borderRadius: 10, border: `0.5px solid ${t.colors.olive12}`,
                  background: t.colors.fieldBg, fontSize: 15, fontFamily: "inherit", color: t.colors.text, boxSizing: "border-box"
                }} />
                {showContactDrop && (newVisitContact || '').trim().length >= 2 && (
                  <div style={{ position: "absolute", left: 0, right: 0, top: "100%", marginTop: 4, background: t.colors.paperSolid, borderRadius: 10, border: `0.5px solid ${t.colors.olive12}`, zIndex: 600, overflow: "hidden", boxShadow: t.shadow.dropdown }}>
                    {contactSuggestions.length > 0 ? (
                      contactSuggestions.map((c, i) => (
                        <div key={i} onMouseDown={() => { setNewVisitContact(c.name || c.company || ''); setNewVisitContactId(c.id || null); setShowContactDrop(false); setContactSuggestions([]); }} style={{ padding: "9px 12px", borderBottom: i < contactSuggestions.length - 1 ? `0.5px solid ${t.colors.olive08}` : "none", cursor: "pointer" }}>
                          <div style={{ fontSize: 13, fontWeight: 700, color: t.colors.text }}>{c.name}</div>
                          {c.company && <div style={{ fontSize: 11, color: t.colors.khaki, marginTop: 1 }}>{c.company}</div>}
                        </div>
                      ))
                    ) : (
                      <div style={{ padding: "10px 12px", fontSize: 12, color: contactsError ? t.colors.alert : t.colors.khaki, fontStyle: t.font.italic }}>
                        {contactsLoading ? "Searching portal contacts…" : contactsError ? "Couldn't load contacts. Check your connection, then keep typing to retry." : "No matching portal contact. Saves as a typed name."}
                      </div>
                    )}
                  </div>
                )}
                <div style={{ fontSize: 10, color: t.colors.bark6, marginTop: 5, lineHeight: 1.35 }}>
                  {newVisitContactId ? "Linked to a portal contact. This visit will show on their card." : "Type to search your portal contacts, then pick one to link them."}
                </div>
              </div>

              <div style={{ display: 'flex', gap: 10, marginBottom: 12 }}>
                {/* minWidth 0 and no native appearance: iOS gives date and time
                    inputs a fixed intrinsic width, so without these the Time
                    field ran off the sheet's right edge (7 October 2026). */}
                <div style={{ flex: 1, minWidth: 0 }}>
                  <label style={{ fontSize: 11, fontWeight: t.font.lw700, color: t.colors.brown, textTransform: "uppercase", letterSpacing: t.font.ls08em, display: "block", marginBottom: 4 }}>Date</label>
                  <input type="date" value={newVisitDate} onChange={(e) => setNewVisitDate(e.target.value)} style={{
                    width: "100%", minWidth: 0, display: "block", WebkitAppearance: "none", appearance: "none", minHeight: 40, padding: "10px 12px", borderRadius: 10, border: `0.5px solid ${t.colors.olive12}`,
                    background: t.colors.ink08, fontSize: 13, fontFamily: "inherit", color: t.colors.text, boxSizing: "border-box"
                  }} />
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <label style={{ fontSize: 11, fontWeight: t.font.lw700, color: t.colors.brown, textTransform: "uppercase", letterSpacing: t.font.ls08em, display: "block", marginBottom: 4 }}>Time</label>
                  <input type="time" value={newVisitTime} onChange={(e) => setNewVisitTime(e.target.value)} style={{
                    width: "100%", minWidth: 0, display: "block", WebkitAppearance: "none", appearance: "none", minHeight: 40, padding: "10px 12px", borderRadius: 10, border: `0.5px solid ${t.colors.olive12}`,
                    background: t.colors.fieldBg, fontSize: 13, fontFamily: "inherit", color: t.colors.text, boxSizing: "border-box"
                  }} />
                </div>
              </div>

              <div style={{ marginBottom: 12 }}>
                <label style={{ fontSize: 11, fontWeight: t.font.lw700, color: t.colors.brown, textTransform: "uppercase", letterSpacing: t.font.ls08em, display: "block", marginBottom: 4 }}>Address</label>
                <input value={newVisitAddress} onChange={(e) => setNewVisitAddress(e.target.value)} placeholder="Site address…" style={{
                  width: "100%", padding: "10px 12px", borderRadius: 10, border: `0.5px solid ${t.colors.olive12}`,
                  background: t.colors.fieldBg, fontSize: 15, fontFamily: "inherit", color: t.colors.text, boxSizing: "border-box"
                }} />
              </div>

              <div style={{ marginBottom: 12 }}>
                <label style={{ fontSize: 11, fontWeight: t.font.lw700, color: t.colors.brown, textTransform: "uppercase", letterSpacing: t.font.ls08em, display: "block", marginBottom: 4 }}>Postcode</label>
                <input value={newVisitPostcode} onChange={(e) => setNewVisitPostcode(e.target.value)} placeholder="e.g. M1 1AA" style={{
                  width: "100%", maxWidth: 160, padding: "10px 12px", borderRadius: 10, border: `0.5px solid ${t.colors.olive12}`,
                  background: t.colors.fieldBg, fontSize: 15, fontFamily: "inherit", color: t.colors.text, boxSizing: "border-box"
                }} />
              </div>

              <div style={{ marginBottom: 16 }}>
                <label style={{ fontSize: 10, fontWeight: t.font.lw700, color: t.colors.khaki, textTransform: "uppercase", letterSpacing: t.font.ls08em, display: "block", marginBottom: 4 }}>Notes</label>
                <textarea value={newVisitNotes} onChange={(e) => setNewVisitNotes(e.target.value)} placeholder="Optional notes..." rows={3} style={{
                  width: "100%", padding: "10px 12px", borderRadius: 10, border: `0.5px solid ${t.colors.olive12}`,
                  background: t.colors.fieldBg, fontSize: 13, fontFamily: "inherit", color: t.colors.text, resize: "none", boxSizing: "border-box", fontStyle: newVisitNotes ? "normal" : t.font.italic
                }} />
              </div>

              <div style={{ display:"flex", gap:8, ...uvx(() => ({ position: "sticky", bottom: 0, zIndex: 1, margin: "0 -18px", padding: "12px 18px 16px", background: t.colors.paperSolid, borderTop: `1px solid ${STUDIO_TOKENS.hairline}` })) }}>
                <button onClick={clearVisitModal} style={{
                  flex:1, padding: "13px", borderRadius: 14, background: t.colors.olive08, border: "none",
                  color: t.colors.brown, fontSize: 14, fontWeight: 700, cursor: "pointer", fontFamily: "inherit"
                }}>Cancel</button>
                <button onClick={saveVisit} style={{
                  flex:1, padding: "13px", borderRadius: 14, background: vColor, border: "none",
                  color: t.colors.onFill, fontSize: 14, fontWeight: 700, cursor: "pointer", fontFamily: "inherit"
                }}>{newVisitDate > todayStr ? 'Save Visit' : (visitLabels[newVisitType] || 'Save visit')}</button>
              </div>
            </div>
          </div>
          </SheetPortal>
          );
        })()}

        {/* B.2 — shared project picker for the Add-visit sheet. Rendered as a
            sibling of the visit modal inside a z-600 stacking context so the
            sheet's own z-300 paints ABOVE the z-500 visit modal. Reuses
            ProjectPickerSheet (surveys/snags/voice) — no parallel picker. */}
        {/* The z-600 box itself goes through SheetPortal, so it sits beside
            the visit modal in document.body; the picker's own SheetPortal is
            then nested and stays inside it. */}
        {showAddVisitSheet && visitPickerOpen && (
          <SheetPortal>
          <div style={{ position: "relative", zIndex: 600 }}>
            <ProjectPickerSheet
              binding={visitBinding}
              accent={BIND_ACCENT_SURVEY}
              noun="visit"
              prefill={{ name: newVisitName.trim(), client_name: newVisitContact.trim(), site_address: newVisitAddress.trim() }}
              onApply={(b) => { setVisitBinding(b); setVisitPickerOpen(false); }}
              onClose={() => setVisitPickerOpen(false)} />
          </div>
          </SheetPortal>
        )}

      </div>

      <TabBar active={0} onChange={onNav} divisionId={divId} />
    </div>
  );
};

// ==== STUDIO_CAPTURE_START ====
// COMPANION-STUDIO-V1 track C3: the capture screens (QuickEntry, VoiceNotes, the
// Snag screens, Issue, NewEnquiry, PreVisit, SitePlan) in the Studio look.
// studioCapture(node) is studioShape plus the part of the look that is colour:
// it runs first, on the same element tree, and only with the switch on (with it
// off the input is returned untouched, so the standard look cannot change).
// On host elements, and on the style prop of GlassCard, it moves:
//   - every font family onto Sentient or Satoshi;
//   - a dark panel onto raised paper (the jewel and the ultraviolet main action
//     are left; the screens give the main action itself), a tinted or white
//     fill onto pressed in (a field) or paper, a coloured gradient onto paper;
//   - any other text colour onto ink or muted (white text onto the text on the
//     primary button when it sits on ultraviolet), ochre text without a pound
//     sign onto ink;
//   - every border colour onto the hairline.
// It also draws NavBar as the Studio page head and Pill as plain words. It
// changes no string and no value the surveyor typed (FINDINGS C3-1).
const _CAP_COLOUR_RE = /rgba?\([^)]*\)|#[0-9a-fA-F]{8}\b|#[0-9a-fA-F]{6}\b|#[0-9a-fA-F]{3}\b/g;
function _capParse(c) {
  const v = String(c == null ? '' : c).trim().toLowerCase();
  if (v === 'white') return { rgb: [255, 255, 255], a: 1 };
  if (v === 'black') return { rgb: [0, 0, 0], a: 1 };
  let m = /^#([0-9a-f]{3})$/.exec(v);
  if (m) return { rgb: m[1].split('').map((x) => parseInt(x + x, 16)), a: 1 };
  m = /^#([0-9a-f]{6})([0-9a-f]{2})?$/.exec(v);
  if (m) return { rgb: [0, 2, 4].map((i) => parseInt(m[1].slice(i, i + 2), 16)), a: m[2] ? parseInt(m[2], 16) / 255 : 1 };
  m = /^rgba?\(([^)]*)\)$/.exec(v);
  if (m) {
    const p = m[1].split(',').map((x) => parseFloat(x));
    if (p.length >= 3 && p.slice(0, 3).every((x) => isFinite(x))) return { rgb: p.slice(0, 3), a: p.length > 3 ? p[3] : 1 };
  }
  return null;
}
function _capLum(rgb) {
  const f = (c) => { c /= 255; return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4); };
  return 0.2126 * f(rgb[0]) + 0.7152 * f(rgb[1]) + 0.0722 * f(rgb[2]);
}
const _capKey = (hex) => [1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16)).join(',');
// The Studio colours, as 'r,g,b' keys, built from the one source.
const _CAP = (() => {
  const S = STUDIO_TOKENS;
  const k = _capKey;
  const std = _capParse(T_STANDARD.colors.bg);
  return {
    ink: k(S.ink), muted: k(S.muted), uv: k(S.ultraviolet), violet: k(S.violetText), onP: k(S.onPrimary), ochre: k(S.ochre),
    jewel: S.jewel.stops[0].toLowerCase(), stdBg: std ? std.rgb.join(',') : null,
    // Track 4: the meaning TEXT colours (STUDIO_MEANING) are Studio text too, so a
    // capture screen's stage word keeps the colour it carries.
    text: [k(S.ink), k(S.muted), k(S.ultraviolet), k(S.violetText), k(S.onPrimary), k(S.ochre)]
      .concat(['clientText', 'newText', 'quotedText', 'strongText', 'wonText', 'rustText', 'slateText'].map((n) => k(STUDIO_MEANING[n]))),
    surface: [k(S.ink), k(S.muted), S.pressed.rgb, k(S.paper.solid), k(S.ground.base), k(S.jewel.ring), k(S.jewel.text), k(S.jewel.textSecondary), k(S.lampAmber)].concat(S.paper.stops.map(k), S.ground.stops.map(k)),
  };
})();
function _capColours(s) {
  return (String(s || '').match(_CAP_COLOUR_RE) || []).map((x) => _capParse(x)).filter(Boolean);
}
// The text direct children of an element hold (not those of its child elements).
function _capOwnText(children) {
  const out = [];
  const walk = (c) => {
    if (c == null || typeof c === 'boolean') return;
    if (typeof c === 'string' || typeof c === 'number') { out.push(String(c)); return; }
    if (Array.isArray(c)) c.forEach(walk);
  };
  walk(children);
  return out.map((x) => x.trim()).filter(Boolean);
}
function _capTextColour(c, ctx, own) {
  const S = STUDIO_TOKENS;
  const p = _capParse(c);
  if (!p) return c;
  const key = p.rgb.join(',');
  if (ctx.uv) return S.onPrimary;
  if (ctx.jewel) return (key === _capKey(S.jewel.textSecondary) || key === _capKey(S.jewel.ring)) ? c : (p.a < 0.75 ? S.jewel.textSecondary : S.jewel.text);
  if (key === _CAP.ochre && p.a === 1) {
    // Ochre is money only: it stays where every line of text carries a pound sign.
    return own.every((x) => x.includes('£') || x === '—') ? c : S.ink;
  }
  // STUDIO-LIT-PHONE-V1 item 8a (decision 1): violet words on a light surface
  // were legacy actions; violet is Eva and the one main action, which is the
  // filled ultraviolet button (ctx.uv above) or Eva's jewel. Any other violet
  // word reads ink (_capStyle gives it weight 600).
  if (key === _CAP.uv || key === _CAP.violet) return S.ink;
  if (p.a === 1 && _CAP.text.includes(key)) return c;
  if (key === _CAP.ink) return S.muted;
  const L = _capLum(p.rgb);
  if (L > 0.6) return p.a < 0.7 ? S.muted : S.ink;
  return (p.a >= 0.75 && L < 0.12) ? S.ink : S.muted;
}
function _capStyle(type, style, props, ctx) {
  const S = STUDIO_TOKENS;
  const st = Object.assign({}, style);
  let sub = ctx;
  const w = _studioPx(st.width); const h = _studioPx(st.height);
  const tiny = w != null && h != null && w <= 24 && h <= 24;
  const field = type === 'input' || type === 'textarea' || type === 'select';
  for (const key of ['background', 'backgroundColor']) {
    const v = st[key];
    if (typeof v !== 'string') continue;
    const raw = v.replace(/\s/g, '');
    if (!raw || /^(transparent|none|inherit|initial|unset|currentcolor)$/i.test(raw) || raw.startsWith('var(') || raw.includes('url(')) continue;
    if (/^#[0-9a-f]{8}$/i.test(raw)) { st[key] = S.pressed.fill; continue; }
    if (raw.toLowerCase().includes(_CAP.jewel)) { sub = Object.assign({}, sub, { jewel: true }); continue; }
    const cols = _capColours(v);
    if (!cols.length) continue;
    const dark = cols.filter((c) => c.a >= 0.5 && _capLum(c.rgb) < 0.18);
    if (dark.length && dark.every((c) => c.rgb.join(',') === _CAP.uv)) { sub = Object.assign({}, sub, { uv: true }); continue; }
    if (dark.length) {
      if (tiny) { st[key] = S.ink; sub = Object.assign({}, sub, { uv: true }); continue; }
      st[key] = S.paper.css;
      if (!st.boxShadow || st.boxShadow === 'none') st.boxShadow = S.shadow.slip;
      continue;
    }
    if (cols.length === 1 && cols[0].rgb.join(',') === _CAP.stdBg && key === 'background') { st[key] = S.ground.css; continue; }
    if (raw.includes(S.paper.stops[0]) || raw.includes(S.ground.stops[0])) continue;
    if (cols.every((c) => _CAP.surface.includes(c.rgb.join(',')))) continue;
    if (field) st[key] = S.pressed.fill;
    else if (raw.includes('gradient(')) st[key] = S.paper.css;
    else st[key] = cols[0].a >= 0.6 ? S.paper.solid : S.pressed.fill;
  }
  for (const key of Object.keys(st)) {
    if (!/^border(Top|Right|Bottom|Left)?(Color)?$/.test(key) || typeof st[key] !== 'string') continue;
    st[key] = st[key].replace(_CAP_COLOUR_RE, (m) => {
      const p = _capParse(m);
      return p && _CAP.surface.includes(p.rgb.join(',')) ? m : S.hairline;
    });
  }
  if (typeof st.fontFamily === 'string' && !/^\s*inherit\s*$/i.test(st.fontFamily) && !/Sentient|Satoshi/.test(st.fontFamily)) {
    const f = st.fontFamily;
    const serif = /Georgia|Playfair|Cormorant/i.test(f) || /serif/i.test(f.replace(/sans-serif/gi, ''));
    st.fontFamily = serif ? S.fonts.display : S.fonts.body;
    if (serif && Number(st.fontWeight) >= 500) st.fontWeight = 400;
    if (/mono/i.test(f)) st.fontVariantNumeric = 'tabular-nums';
  }
  if (typeof st.color === 'string') {
    const was = _capParse(st.color);
    st.color = _capTextColour(st.color, sub, _capOwnText(props.children));
    // A violet word turned ink keeps the weight of an action (decision 1).
    if (was && (was.rgb.join(',') === _CAP.uv || was.rgb.join(',') === _CAP.violet) && st.color === S.ink && !((Number(st.fontWeight) || 400) >= 600)) st.fontWeight = 600;
  }
  // A rounded block that holds text and says "padding: 0" reads as a pill to the
  // rule; a div's default padding is already 0, so the key is simply dropped.
  if (type !== 'button' && (st.padding === 0 || st.padding === '0') && st.paddingTop == null) delete st.padding;
  if (field) {
    if (typeof st.fontSize === 'number') st.fontSize = studioSize(st.fontSize);
    else if (_studioPx(st.fontSize) != null) st.fontSize = studioSize(_studioPx(st.fontSize));
    if (typeof st.color !== 'string') st.color = S.ink;
  }
  return { style: st, ctx: sub };
}
// NavBar as the Studio page head: Back in ink, the title in Sentient Light.
function _capNav(props) {
  const S = STUDIO_TOKENS;
  const h = React.createElement;
  const title = props.title;
  const long = typeof title === 'string' && title.length > 22;
  return h('div', { style: { padding: '8px 20px 4px', flexShrink: 0, position: 'relative', zIndex: 1 } },
    h('div', { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', minHeight: 44 } },
      props.onBack
        ? h('button', { onClick: props.onBack, style: { background: 'none', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6, minHeight: 44, padding: 0, color: S.ink, fontSize: 16, fontWeight: 600, fontFamily: S.fonts.body } },
          h(Icon, { name: 'arrow', size: 20, color: S.ink }), 'Back')
        : h('div', { style: { width: 60 } }),
      props.right || null),
    h('div', { style: Object.assign(studioType.title(), { fontSize: long ? 31 : 39, lineHeight: 1.1, padding: '2px 0 8px' }) }, title));
}
// Btn as a Studio button: a raised slip in ink, or, when the screen marks it
// studioMain, the one flat ultraviolet main action.
function _capBtn(p) {
  const S = STUDIO_TOKENS;
  const surface = p.studioMain ? studioSurface.primary() : Object.assign(studioSurface.slip(), { color: S.ink });
  return React.createElement('button', {
    onClick: p.disabled ? undefined : p.onClick,
    style: Object.assign({
      display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 8, minHeight: S.button.minHeight,
      padding: p.small ? '8px 16px' : '12px 18px', borderRadius: S.button.radius, fontFamily: S.fonts.body,
      fontSize: p.small ? 14 : 16, fontWeight: 600, cursor: p.disabled ? 'not-allowed' : 'pointer',
      width: p.fullWidth ? '100%' : 'auto', opacity: p.disabled ? 0.5 : 1,
    }, surface),
  }, p.icon ? React.createElement(Icon, { name: p.icon, size: p.small ? 14 : 16, color: p.studioMain ? S.onPrimary : S.ink }) : null, p.label);
}
// The enquiry form's Field, ChipSelect and TimeSelect (shared, also used by the
// sign-in setup, which another track owns) drawn in the Studio look when one of
// the capture screens renders them: a column head in muted words, a field
// pressed in, chips pressed in when chosen and raised slips otherwise.
function _capField(p) {
  const S = STUDIO_TOKENS;
  const h = React.createElement;
  return h('div', { style: { marginBottom: 16, flex: p.half ? '1' : 'none' } },
    h('label', { style: Object.assign(studioType.colhead(), { fontSize: 14, display: 'block', marginBottom: 6 }) }, p.label),
    h('input', {
      value: p.value, onChange: (e) => p.onChange(e.target.value), placeholder: p.placeholder,
      style: Object.assign(studioSurface.pressed(), { width: '100%', padding: '12px 14px', borderRadius: S.button.radius, fontSize: 16, color: S.ink, outline: 'none', WebkitAppearance: 'none', fontFamily: S.fonts.body, boxSizing: 'border-box', minHeight: 44 }),
    }));
}
function _capChipButton(on, onClick, label, extra, key) {
  const S = STUDIO_TOKENS;
  return React.createElement('button', {
    key: key != null ? key : label, onClick,
    style: Object.assign({}, on ? studioSurface.pressed() : studioSurface.slip(), {
      padding: '10px 14px', borderRadius: S.button.radius, cursor: 'pointer', minHeight: 44, color: S.ink,
      fontSize: 14, fontWeight: on ? 700 : 400, fontFamily: S.fonts.body,
    }, extra || {}),
  }, label);
}
function _capChips(p) {
  const h = React.createElement;
  // The chosen value is the option as authored; only its shown words take the
  // Studio separator (an authored spaced em dash reads as a comma).
  const shown = (opt) => String(opt).replace(/ — /g, studioDash());
  return h('div', { style: { marginBottom: 14 } },
    h('label', { style: Object.assign(studioType.colhead(), { fontSize: 14, display: 'block', marginBottom: 8 }) }, p.label),
    h('div', { style: { display: 'flex', gap: 8, flexWrap: 'wrap' } }, p.options.map((opt) => _capChipButton(p.value === opt, () => p.onChange(opt), shown(opt), null, opt))));
}
function _capTimes(p) {
  const h = React.createElement;
  const make = (from, to) => { const out = []; for (let hr = from; hr < to; hr++) for (let m = 0; m < 60; m += 15) out.push(`${String(hr).padStart(2, '0')}:${String(m).padStart(2, '0')}`); return out; };
  const section = (label, times) => h('div', { key: label, style: { marginBottom: 12 } },
    h('p', { style: Object.assign(studioType.colhead(), { marginBottom: 8 }) }, label),
    h('div', { style: { display: 'flex', flexWrap: 'wrap', gap: 8 } }, times.map((tm) => _capChipButton(p.value === tm, () => p.onChange(tm), tm, { minWidth: 64, textAlign: 'center', fontVariantNumeric: 'tabular-nums' }))));
  return h('div', { style: { marginBottom: 14 } },
    h('label', { style: Object.assign(studioType.colhead(), { fontSize: 14, display: 'block', marginBottom: 10 }) }, 'Time *'),
    section('Morning', make(7, 13)), section('Afternoon', make(13, 18)));
}
function _capNode(node, ctx) {
  if (Array.isArray(node)) return node.map((n) => _capNode(n, ctx));
  if (!React.isValidElement(node)) return node;
  const type = node.type;
  if (type === 'svg' || type === 'style') return node;
  if (type === NavBar) return _capNode(_capNav(node.props), ctx);
  if (type === Pill) {
    const p = node.props;
    return React.createElement('span', { style: { color: STUDIO_TOKENS.muted, fontSize: 13, fontWeight: 400, fontFamily: STUDIO_TOKENS.fonts.body, whiteSpace: 'nowrap' } }, p.label);
  }
  if (type === Btn) return _capNode(_capBtn(node.props), ctx);
  if (type === Field) return _capNode(_capField(node.props), ctx);
  if (type === ChipSelect) return _capNode(_capChips(node.props), ctx);
  if (type === TimeSelect) return _capNode(_capTimes(node.props), ctx);
  const props = node.props || {};
  const next = {};
  let sub = ctx;
  if (typeof type === 'string' && props['data-cap-keep']) {
    // A swatch the surveyor chose from (a pen colour): the colour is data, so the
    // walker leaves its style as authored. The marker is dropped from the output.
    next['data-cap-keep'] = undefined;
  } else if (typeof type === 'string' && props.style) {
    const r = _capStyle(type, props.style, props, ctx);
    next.style = r.style; sub = r.ctx;
  } else if (type === GlassCard) {
    const S = STUDIO_TOKENS;
    const r = _capStyle('div', Object.assign({ background: S.paper.css, boxShadow: S.shadow.raised, border: 'none', borderTop: 'none', borderRadius: S.radius.card }, props.style || {}), props, ctx);
    next.style = r.style; sub = r.ctx;
    if (typeof props.onClick === 'function' && !(next.style.minHeight >= 44)) next.style.minHeight = 44;
  }
  if (props.children === undefined) return Object.keys(next).length ? React.cloneElement(node, next) : node;
  const kids = _capNode(props.children, sub);
  return Array.isArray(kids) ? React.cloneElement(node, next, ...kids) : React.cloneElement(node, next, kids);
}
const studioCapture = (node) => (t.theme === 'uv' ? studioShape(_capNode(node, {})) : node);
// Each capture screen is its Body, called inside a component of the same name
// (so its hooks belong to that component), with the result passed through
// studioCapture. With the switch off this returns exactly what the Body returns.
const PreCallBriefCard = (props) => studioCapture(PreCallBriefCardBody(props));
const PreVisitScreen = (props) => studioCapture(PreVisitScreenBody(props));
const QuickEntryScreen = (props) => studioCapture(QuickEntryScreenBody(props));
const VoiceNotesScreen = (props) => studioCapture(VoiceNotesScreenBody(props));
const SnagSetupScreen = (props) => studioCapture(SnagSetupScreenBody(props));
const SnagCaptureScreen = (props) => studioCapture(SnagCaptureScreenBody(props));
// STUDIO-LIT-PHONE-V1 item 8a: with the switch on the sheet is A snag
// (#app/snag), drawn by SnagSheetLit, outside the capture walker.
const SnagSheet = (props) => (t.theme === 'uv' ? SnagSheetLit(props) : studioCapture(SnagSheetBody(props)));
const SnagReviewScreen = (props) => studioCapture(SnagReviewScreenBody(props));
const IssueCaptureScreen = (props) => studioCapture(IssueCaptureScreenBody(props));
const NewEnquiryScreen = (props) => studioCapture(NewEnquiryScreenBody(props));
const ProjectTimeline = (props) => studioCapture(ProjectTimelineBody(props));
const SitePlanScreen = (props) => studioCapture(SitePlanScreenBody(props));
// ==== STUDIO_CAPTURE_END ====

// ════════════════════════════════════════════════════
// PRE-CALL BRIEF CARD (fetches from portal contacts)
// ════════════════════════════════════════════════════
const PreCallBriefCardBody = ({ contactName, company, divColor, divBorder }) => {
  const [brief, setBrief] = useState(null);
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(null);
  const [expanded, setExpanded] = useState(true);

  useEffect(() => {
    // Reset on every dep change, and ignore a resolve that lands after the
    // deps moved on. Without this, `failed` from contact A survives into
    // contact B's load window (nothing re-arms `loading`, so the loading
    // branch cannot mask it) and an out-of-order resolve from A can raise a
    // banner that now takes render priority over B's valid brief. Only one
    // mount site exists today and it unmounts on screen change, so this is
    // latent rather than live — but the failure state introduced here is what
    // would make it visible, so it is guarded here rather than left for the
    // surface that reuses this card.
    let stale = false;
    setFailed(null);
    setBrief(null);
    if (!contactName) { setLoading(false); return; }
    setLoading(true);
    const params = new URLSearchParams({ name: contactName });
    if (company) params.set("company", company);
    // Bearer token: the portal gated this endpoint in S179 (#369) after finding
    // it served the personal block -- family, interests, away dates -- to any
    // caller with no session. Most authed portal calls in this file already
    // send the token; this one never did, which is why it 401s until now.
    // It was not the only one that was missing it: the Today-screen
    // /api/companion/briefing fetch was header-less against a gated endpoint
    // too, and cached the 401 body. FIXED in v189 -- see briefingFromPayload
    // at the head of this file. This note is kept because the PAIR is the
    // lesson: one file, two calls to gated endpoints, one of them fixed long
    // before the other, and the unfixed one quietly defeating the fixed one.
    const tk = localStorage.getItem('lumen_token');
    fetch(PORTAL_URL + "/api/contacts/companion/brief?" + params.toString(),
          { headers: tk ? { 'Authorization': `Bearer ${tk}` } : {} })
      .then(r => {
        // A non-ok response is a FAILURE, not an absent brief -- and nothing
        // here used to notice. The 401 body IS valid JSON
        // (`jsonify({"error": "Not authenticated"})`, application/json), so
        // the old `.then(r => r.json())` PARSED IT CLEANLY: `data.found` came
        // back undefined, `setBrief` never ran, and `if (!brief) return null`
        // deleted the whole card. The empty `.catch` was never reached on the
        // auth path -- there was no exception anywhere. A refusal and "nothing
        // known about this contact" rendered identically: nothing at all, in
        // the field, with no trace. Checking `r.ok` is what separates them.
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.json();
      })
      .then(data => { if (stale) return; if (data.found) setBrief(data); })
      .catch(e => {
        if (stale) return;
        const why = (e && e.message) ? e.message : String(e);
        try {
          console.warn('[precall-brief] lookup failed for '
            + `${contactName}${company ? ' @ ' + company : ''}: ${why}`
            + (tk ? '' : ' (no lumen_token in storage -- signed out?)'));
        } catch (e2) {}
        setFailed(why);
      })
      .finally(() => { if (!stale) setLoading(false); });
    return () => { stale = true; };
  }, [contactName, company]);

  if (loading) {
    return (
      <>
        <p style={{ fontSize: 11, fontWeight: 700, color: t.colors.textSecondary, letterSpacing: 0.8, textTransform: "uppercase", marginBottom: 10 }}>{t.theme === 'uv' ? 'What you know about them' : 'Relationship Intelligence'}</p>
        <GlassCard style={{ padding: 20, marginBottom: 20, background: `${divColor}06`, border: `0.5px solid ${divBorder}` }} hover={false}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div style={{ width: 14, height: 14, borderRadius: "50%", border: `2px solid ${divColor}`, borderTopColor: "transparent", animation: "spin 0.8s linear infinite", ...uvx(() => ({ border: `2px solid ${STUDIO_TOKENS.muted}`, borderTopColor: "transparent" })) }} />
            <span style={{ fontSize: 12, color: t.colors.textSecondary }}>{t.theme === 'uv' ? 'Getting what you know about them…' : 'Loading contact intelligence…'}</span>
          </div>
        </GlassCard>
      </>
    );
  }

  // An absent brief is silent BY DESIGN -- nothing is known about this contact,
  // and an empty card would be noise on a field surface. A FAILED lookup is not
  // the same thing and must never be silent: the surveyor is looking at a screen
  // that is missing intelligence the portal may well hold, and without this they
  // would have no way to tell the two apart.
  if (failed) {
    return (
      <>
        <p style={{ fontSize: 11, fontWeight: 700, color: t.colors.textSecondary, letterSpacing: 0.8, textTransform: "uppercase", marginBottom: 10 }}>{t.theme === 'uv' ? 'What you know about them' : 'Relationship Intelligence'}</p>
        {/* Deliberately NOT the default card border: an error styled like every
            healthy card on the screen is a quiet failure, which is the thing
            this branch exists to stop. Amber is the warm-stone system's warning
            hue and is not used for a resting card here. */}
        <GlassCard style={{ padding: 16, marginBottom: 20, background: t.colors.amberLight, border: `0.5px solid ${t.colors.amber}` }} hover={false}>
          <div style={{ fontSize: 12, fontWeight: 600, color: t.colors.amberText, marginBottom: 4 }}>
            Couldn't load contact intelligence.
          </div>
          <div style={{ fontSize: 11, color: t.colors.textSecondary }}>
            {failed === 'HTTP 401'
              ? "You may need to sign in again on this device."
              : `The portal didn't answer. This is a display problem${studioDash()}nothing you've captured is affected.`}
          </div>
        </GlassCard>
      </>
    );
  }

  if (!brief) return null;

  const prompts = brief.prompts || [];
  const family = (brief.personal?.family || []);
  const interests = (brief.personal?.interests || []);
  const awayDates = (brief.personal?.away_dates || []);
  const concerns = brief.concerns || [];
  const influencers = brief.influencers || [];
  const actions = brief.pending_actions || [];
  const budget = brief.budget || "";
  const decision = brief.decision_process || "";
  const lastContact = brief.last_contact;

  const daysSince = lastContact ? Math.floor((Date.now() - new Date(lastContact).getTime()) / 86400000) : null;

  // Build intel rows — ordered by importance
  const rows = [];

  // Prompts first — these are the gold
  prompts.forEach(p => {
    rows.push({ iconName: "bulb", text: p.message, type: "prompt", color: t.colors.gold });
  });

  // Family / personal
  family.forEach(f => {
    const detail = f.detail || f.relation || "";
    rows.push({ iconName: "users", text: `${f.name}${detail ? studioDash() + detail : ""}`, type: "personal", color: t.colors.blue });
  });

  // Away dates (current or upcoming)
  const today = new Date().toISOString().split("T")[0];
  awayDates.forEach(a => {
    if (a.to >= today) {
      rows.push({ iconName: "send", text: a.detail || `Away ${a.from} to ${a.to}`, type: "away", color: t.colors.purple });
    }
  });

  // Concerns / risks
  concerns.forEach(c => {
    rows.push({ iconName: "alert", text: c, type: "concern", color: t.colors.amber });
  });

  // Influencers
  influencers.forEach(inf => {
    const stance = inf.stance ? `${studioDash()}${inf.stance}` : "";
    rows.push({ iconName: "user", text: `${inf.name}${inf.role ? " (" + inf.role + ")" : ""}${stance}`, type: "influencer", color: t.colors.orange });
  });

  // Budget + decision
  if (budget) {
    rows.push({ iconName: "dollar", text: `Budget: ${budget}`, type: "budget", color: t.colors.green });
  }
  if (decision) {
    rows.push({ iconName: "calendar", text: decision, type: "decision", color: t.colors.blue });
  }

  // Pending actions
  actions.forEach(a => {
    const due = a.due ? `${studioSep()}Due ${new Date(a.due).toLocaleDateString("en-GB", { day: "numeric", month: "short" })}` : "";
    rows.push({ iconName: "check", text: `${a.action}${due}`, type: "action", color: t.colors.green });
  });

  // Interests
  if (interests.length > 0) {
    rows.push({ iconName: "tag", text: interests.join(", "), type: "interest", color: t.colors.textSecondary });
  }

  if (rows.length === 0) return null;

  const visibleRows = expanded ? rows : rows.slice(0, 3);

  return (
    <>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          {t.theme !== 'uv' && <div style={{ width: 8, height: 8, borderRadius: "50%", background: divColor, boxShadow: `0 0 8px ${divColor}` }} />}
          <p style={{ fontSize: 11, fontWeight: 700, color: t.colors.textSecondary, letterSpacing: 0.8, textTransform: "uppercase" }}>{t.theme === 'uv' ? 'What you know about them' : 'Relationship Intelligence'}</p>
        </div>
        {daysSince !== null && (
          <span style={{ fontSize: 10, color: daysSince > 14 ? t.colors.amber : t.colors.textTertiary, fontWeight: 600 }}>
            {daysSince === 0 ? "Today" : daysSince === 1 ? "Yesterday" : `${daysSince}d ago`}
          </span>
        )}
      </div>
      <GlassCard style={{ padding: 0, marginBottom: 20, background: `${divColor}08`, border: `0.5px solid ${divBorder}`, overflow: "hidden" }} hover={false}>
        {visibleRows.map((row, i) => (
          <div key={i} style={{
            padding: "11px 16px", display: "flex", alignItems: "flex-start", gap: 12,
            borderBottom: i < visibleRows.length - 1 ? `0.5px solid ${t.colors.separator}` : "none",
            background: row.type === "prompt" ? `${t.colors.gold}08` : "transparent",
          }}>
            <span style={{ lineHeight: "20px", flexShrink: 0, display: "flex", alignItems: "center" }}><Icon name={row.iconName} size={15} color={t.theme === 'uv' ? STUDIO_TOKENS.ink : row.color} /></span>
            <p style={{
              fontSize: 13, color: row.type === "prompt" ? t.colors.text : t.colors.textSecondary,
              lineHeight: 1.5, fontWeight: row.type === "prompt" ? 600 : 400,
            }}>{row.text}</p>
          </div>
        ))}
        {rows.length > 3 && (
          <button onClick={() => setExpanded(!expanded)} style={{
            width: "100%", padding: "10px 16px", background: "none", border: "none",
            cursor: "pointer", fontSize: 12, fontWeight: 700, color: divColor, textAlign: "center",
          }}>
            {expanded ? "Show less" : `Show all ${rows.length} insights`}
          </button>
        )}
      </GlassCard>
    </>
  );
};

// ════════════════════════════════════════════════════
// SCREEN 2: PRE-VISIT
// ════════════════════════════════════════════════════
const PreVisitScreenBody = ({ onBack, onNav, project, currentUser, onUpdateProject }) => {
  const div = getDivisionConfig(currentUser);
  const divColor = div.id === "aircon" ? t.colors.blue : t.colors.gold;
  const divColorLight = div.id === "aircon" ? t.colors.blueLight : t.colors.goldLight;
  const divBorder = div.id === "aircon" ? "rgba(91,155,213,0.25)" : t.colors.glassBorderGold;
  const proj = project || { name: "No project selected", client: "", contact: "", contactRole: "", contactEmail: "", floors: "", driver: "", budget: "", timeline: "", notes: "", existingAnnualCost: null, source: "" };
  const checklist = [
    { item: "Review last visit notes", done: false },
    { item: div.id === "aircon" ? "Check F-Gas / refrigerant status" : "Check MEES 2027 compliance status", done: false },
    { item: div.id === "aircon" ? "Load plant room layout / schematics" : "Load floor plan / site drawings", done: false },
    { item: div.id === "aircon" ? `Confirm ${div.unitLabel} database up to date` : "Confirm fixture database up to date", done: false },
    { item: "Prepare three-tier proposal templates", done: false },
  ];
  const [checks, setChecks] = useState(() => project?.checklist || checklist.map(c => c.done));
  const [noteText, setNoteText] = useState("");
  const [showNoteInput, setShowNoteInput] = useState(false);
  const [pvLightbox, setPvLightbox] = useState(null);
  const visitNotes = project?.visitNotes || [];
  const [editingField, setEditingField] = useState(null); // null | 'driver' | 'budget' | 'timeline' | 'cost' | 'source'
  const [editingName, setEditingName] = useState(false);
  const [draftName, setDraftName] = useState("");
  const [fieldDraft, setFieldDraft] = useState("");

  // STUDIO-LIT-PHONE-V1 item 8b: sentence-case words with the switch on; the
  // switch-off words are untouched.
  const uvWords = (off, on) => (t.theme === 'uv' ? on : off);
  const saveField = (field, value) => {
    if (!project?.id || !onUpdateProject) return;
    const fieldMap = {
      driver: { driver: value },
      budget: { budget: value },
      timeline: { visitTimeline: value },
      cost: { existingAnnualCost: value ? parseFloat(value.replace(/[^0-9.]/g,"")) || null : null },
      source: { source: value },
    };
    onUpdateProject(project.id, fieldMap[field] || {});
    setEditingField(null);
    setFieldDraft("");
  };

  return (
    <div style={{ flex: 1, overflowY: "auto", WebkitOverflowScrolling: "touch", overscrollBehavior: "contain", paddingBottom: 100, background: "#E8DCC8", display: "flex", flexDirection: "column" }}>
      <ScreenBlobs />
      {pvLightbox && (
        <SheetPortal>
        <div onClick={() => setPvLightbox(null)} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.92)", zIndex: 9999, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: 20, ...uvx(() => ({ background: studioRgba(STUDIO_TOKENS.ground.base, 0.97) })) }}>
          {pvLightbox.photo
            ? <MediaThumb photo={pvLightbox.photo} style={{ maxWidth: "100%", maxHeight: "75vh", borderRadius: 12, objectFit: "contain" }} />
            : <img src={pvLightbox.src} alt="" style={{ maxWidth: "100%", maxHeight: "75vh", borderRadius: 12, objectFit: "contain" }} />}
          {pvLightbox.caption && <p style={{ color: "rgba(255,255,255,0.6)", fontSize: 13, marginTop: 14, textAlign: "center", ...uvx({ color: STUDIO_TOKENS.ink }) }}>{pvLightbox.caption}</p>}
          <p style={{ color: "rgba(255,255,255,0.3)", fontSize: 12, marginTop: 12, ...uvx({ color: STUDIO_TOKENS.muted }) }}>Tap to close</p>
        </div>
        </SheetPortal>
      )}
      <NavBar title={uvWords("Pre-Visit Brief", "Before the visit")} onBack={onBack} color={divColor} />
      <div style={{ flex: 1, overflowY: "auto", padding: "20px 20px 100px" }}>

        {/* Project header */}
        <GlassCard gold={divColor} style={{ padding: 18, marginBottom: 20 }} hover={false}>
          <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: 12 }}>
            <div>
              {/* No eyebrow with the switch on (studio-lit.md). */}
              {t.theme === 'uv' ? null : <p style={{ fontSize: 11, color: divColor, fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 4 }}>Today's site</p>}
              {editingName ? (
                <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:4 }}>
                  <input value={draftName} onChange={e=>setDraftName(e.target.value)}
                    onKeyDown={e=>{ if(e.key==="Enter"){ if(draftName.trim()&&project?.id) onUpdateProject(project.id,{name:draftName.trim()}); setEditingName(false); } if(e.key==="Escape") setEditingName(false); }}
                    autoFocus
                    style={{ flex:1,background:"rgba(255,255,255,0.06)",border:`1px solid ${divBorder}`,borderRadius:9,padding:"8px 12px",color:t.colors.text,fontFamily:"inherit",fontSize:18,fontWeight:800,outline:"none",letterSpacing:-0.5 }}
                  />
                  <button onClick={()=>{ if(draftName.trim()&&project?.id) onUpdateProject(project.id,{name:draftName.trim()}); setEditingName(false); }} style={{ padding:"8px 12px",borderRadius:9,background:divColorLight,border:`1px solid ${divBorder}`,color:divColor,fontFamily:"inherit",fontSize:13,fontWeight:800,cursor:"pointer" }}>Save</button>
                </div>
              ) : (
                <button onClick={()=>{ setDraftName(proj.name); setEditingName(true); }} style={{ background:"none",border:"none",padding:0,textAlign:"left",cursor:"pointer",display:"flex",alignItems:"center",gap:6,marginBottom:2 }}>
                  <h2 style={{ fontSize: 22, fontWeight: 800, color: t.colors.text, letterSpacing: -0.5, fontFamily: "system-ui, -apple-system, sans-serif" }}>{proj.name}</h2>
                  <Icon name="pen" size={12} color={t.colors.textTertiary} />
                </button>
              )}
              <p style={{ fontSize: 13, color: t.colors.textSecondary, marginTop: 2 }}>{proj.client}{studioSep()}{proj.floors}</p>
            </div>
            {(() => {
              const stageMap = { enquiry: { label: "Enquiry", color: t.colors.textSecondary }, previsit: { label: uvWords("Pre-Visit", "Visit booked"), color: t.colors.blue }, surveyed: { label: "Surveyed", color: divColor }, proposed: { label: "Proposed", color: t.colors.purple }, won: { label: "Won", color: t.colors.green }, lost: { label: "Lost", color: t.theme === 'uv' ? STUDIO_MEANING.slateText : t.colors.red } };  // Lost is slate under the theme (item 8a)
              const s = stageMap[proj.stage || "enquiry"] || stageMap.enquiry;
              return <Pill label={s.label} color={s.color} small />;
            })()}
          </div>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            {proj.driver && <Pill label={proj.driver.length > 28 ? proj.driver.slice(0,28)+"\u2026" : proj.driver} color={t.colors.amber} small />}
            {proj.visitTimeline && <Pill label={proj.visitTimeline} color={t.colors.red} small />}
            {proj.budget && <Pill label={proj.budget} color={t.colors.blue} small />}
          </div>
        </GlassCard>

        {/* Client contact */}
        <p style={{ fontSize: 11, fontWeight: 700, color: t.colors.textSecondary, letterSpacing: 0.8, textTransform: "uppercase", marginBottom: 10 }}>{uvWords("Client Contact", "Client contact")}</p>
        <GlassCard style={{ padding: 0, marginBottom: 20 }} hover={false}>
          <div style={{ padding: "14px 16px", display: "flex", alignItems: "center", gap: 14, borderBottom: `0.5px solid ${t.colors.separator}` }}>
            <div style={{ width: 44, height: 44, borderRadius: "50%", background: divColor, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, ...uvx(() => ({ background: STUDIO_TOKENS.pressed.fill })) }}>
              <span style={{ color: t.colors.navy, fontWeight: 800, fontSize: 16, ...uvx(() => ({ color: STUDIO_TOKENS.ink, fontWeight: 500 })) }}>{proj.contact ? proj.contact.split(" ").filter(n => t.theme !== 'uv' || /[A-Za-z0-9]/.test(n[0] || '')).map(n=>n[0]).join("").toUpperCase().slice(0,2) : "—"}</span>
            </div>
            <div style={{ flex: 1 }}>
              <p style={{ fontSize: 15, fontWeight: 700, color: t.colors.text, letterSpacing: -0.2 }}>{proj.contact}</p>
              <p style={{ fontSize: 12, color: t.colors.textSecondary }}>{proj.contactRole}{studioSep()}{proj.client}</p>
            </div>
          </div>
          {[
            { icon: "phone", label: proj.contactEmail },
            { icon: "location", label: proj.address || proj.name },
          ].map((row, i, arr) => (
            <div key={i} style={{ padding: "12px 16px", display: "flex", alignItems: "center", gap: 12, borderBottom: i < arr.length - 1 ? `0.5px solid ${t.colors.separator}` : "none" }}>
              <Icon name={row.icon} size={16} color={t.colors.textSecondary} />
              <span style={{ fontSize: 13, color: t.colors.textSecondary }}>{row.label}</span>
            </div>
          ))}
        </GlassCard>

        {/* Pre-call relationship intelligence — fetched from portal contacts */}
        <PreCallBriefCard contactName={proj.contact} company={proj.client} divColor={divColor} divBorder={divBorder} />

        {/* Intelligence */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10 }}>
          <p style={{ fontSize: 11, fontWeight: 700, color: t.colors.textSecondary, letterSpacing: 0.8, textTransform: "uppercase" }}>{uvWords("Project Intelligence", "About the job")}</p>
          <p style={{ fontSize: 10, color: t.colors.textTertiary, fontWeight: 600 }}>{uvWords("Tap any row to edit", "Tap a row to change it")}</p>
        </div>
        <GlassCard style={{ padding: 0, marginBottom: 20 }} hover={false}>
          {(() => {
            const intelRows = [
              {
                key: "driver", label: "What's driving this", icon: "zap", color: t.colors.amber,
                value: proj.driver || "", placeholder: "Not yet captured",
                type: "chips", options: div.driverOptions,
              },
              {
                key: "budget", label: "Budget range", icon: "chart", color: t.colors.green,
                value: proj.budget || "", placeholder: "TBC",
                type: "chips", options: ["< £10k", "£10k–£25k", "£25k–£50k", "£50k–£100k", "£100k+", "TBC"],
              },
              {
                key: "timeline", label: "Timeline", icon: "clock", color: t.colors.blue,
                value: proj.visitTimeline || "", placeholder: "TBC",
                type: "chips", options: div.timelineOptions,
              },
              {
                key: "cost", label: "Current annual cost", icon: "bulb", color: t.colors.red,
                value: proj.existingAnnualCost ? String(proj.existingAnnualCost) : "", placeholder: "Not yet measured",
                type: "number", prefix: "£",
              },
              {
                key: "source", label: "Enquiry source", icon: "phone", color: divColor,
                value: proj.source || "", placeholder: "Not recorded",
                type: "chips", options: ["Referral", "Existing client", "Cold call", "LinkedIn", "Website", "FM contract", "Broker", "Unknown"],
              },
            ];
            return intelRows.map((row, i, arr) => {
              const isEditing = editingField === row.key;
              const displayVal = row.key === "cost" && row.value
                ? formatCurrency(parseFloat(row.value))
                : row.value || row.placeholder;
              const isEmpty = !row.value;
              return (
                <div key={row.key}>
                  <div
                    onClick={() => { if (!isEditing) { setEditingField(row.key); setFieldDraft(row.value); } }}
                    style={{ padding: "13px 16px", display: "flex", alignItems: "center", gap: 12, borderBottom: (isEditing || i < arr.length - 1) ? `0.5px solid ${t.colors.separator}` : "none", cursor: "pointer", transition: "background .15s", background: isEditing ? `${row.color}07` : "transparent" }}>
                    <div style={{ width: 30, height: 30, borderRadius: t.radius.sm, background: `${row.color}15`, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                      <Icon name={row.icon} size={15} color={t.theme === 'uv' ? STUDIO_TOKENS.ink : row.color} />
                    </div>
                    <div style={{ flex: 1 }}>
                      <p style={{ fontSize: 11, color: t.colors.textTertiary, fontWeight: 600, letterSpacing: 0.3, textTransform: "uppercase" }}>{row.label}</p>
                      <p style={{ fontSize: 13, fontWeight: 600, color: isEmpty ? t.colors.textTertiary : t.colors.text, marginTop: 1, fontStyle: isEmpty ? "italic" : "normal" }}>{displayVal}</p>
                    </div>
                    <div style={{ width: 18, height: 18, borderRadius: 5, background: isEditing ? `${row.color}20` : "rgba(255,255,255,0.04)", border: `0.5px solid ${isEditing ? row.color+"50" : "rgba(255,255,255,0.08)"}`, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                      <Icon name={isEditing ? "check" : "pencil"} size={9} color={t.theme === 'uv' ? STUDIO_TOKENS.ink : (isEditing ? row.color : t.colors.textTertiary)} />
                    </div>
                  </div>
                  {isEditing && (
                    <div style={{ padding: "10px 14px 14px", background: `${row.color}05`, borderBottom: i < arr.length - 1 ? `0.5px solid ${t.colors.separator}` : "none" }}>
                      {row.type === "chips" ? (
                        <>
                          <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 10 }}>
                            {row.options.map(opt => (
                              <button key={opt} onClick={() => { setFieldDraft(opt); saveField(row.key, opt); }} style={{ padding: "7px 12px", borderRadius: 16, fontSize: 12, fontWeight: 700, cursor: "pointer", fontFamily: "inherit", background: fieldDraft === opt ? `${row.color}20` : "rgba(255,255,255,0.05)", border: `0.5px solid ${fieldDraft === opt ? row.color+"60" : "rgba(255,255,255,0.1)"}`, color: fieldDraft === opt ? row.color : t.colors.textSecondary, transition: "all .12s", ...uvx(() => ({ ...(fieldDraft === opt ? studioSurface.pressed() : studioSurface.slip()), color: STUDIO_TOKENS.ink, fontSize: 14, fontWeight: fieldDraft === opt ? 700 : 400, borderRadius: STUDIO_TOKENS.button.radius })) }}>
                                {opt}
                              </button>
                            ))}
                          </div>
                          <div style={{ display: "flex", gap: 8 }}>
                            <input value={fieldDraft} onChange={e => setFieldDraft(e.target.value)} placeholder="Or type custom…"
                              onKeyDown={e => { if (e.key === "Enter") saveField(row.key, fieldDraft); if (e.key === "Escape") setEditingField(null); }}
                              style={{ flex: 1, background: "rgba(255,255,255,0.05)", border: `0.5px solid rgba(255,255,255,0.12)`, borderRadius: 8, padding: "8px 10px", color: t.colors.text, fontFamily: "inherit", fontSize: 13, fontWeight: 600, outline: "none" }} />
                            <button onClick={() => saveField(row.key, fieldDraft)} style={{ padding: "8px 14px", borderRadius: 8, background: `${row.color}18`, border: `0.5px solid ${row.color}50`, color: row.color, fontFamily: "inherit", fontSize: 12, fontWeight: 800, cursor: "pointer" }}>Save</button>
                            <button onClick={() => setEditingField(null)} style={{ padding: "8px 10px", borderRadius: 8, background: "none", border: "0.5px solid rgba(255,255,255,0.08)", color: t.colors.textTertiary, fontFamily: "inherit", fontSize: 12, cursor: "pointer" }}><svg width="10" height="10" viewBox="0 0 10 10" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><line x1="2" y1="2" x2="8" y2="8"/><line x1="8" y1="2" x2="2" y2="8"/></svg></button>
                          </div>
                        </>
                      ) : (
                        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                          <div style={{ display: "flex", alignItems: "center", flex: 1, background: "rgba(255,255,255,0.05)", border: `0.5px solid rgba(255,255,255,0.12)`, borderRadius: 8, padding: "8px 10px", gap: 4 }}>
                            {row.prefix && <span style={{ fontSize: 14, fontWeight: 700, color: t.colors.textTertiary }}>{row.prefix}</span>}
                            <input type="number" inputMode="numeric" value={fieldDraft} onChange={e => setFieldDraft(e.target.value)} placeholder="0"
                              onKeyDown={e => { if (e.key === "Enter") saveField(row.key, fieldDraft); if (e.key === "Escape") setEditingField(null); }}
                              style={{ flex: 1, background: "none", border: "none", outline: "none", color: t.colors.text, fontFamily: "inherit", fontSize: 16, fontWeight: 700 }} />
                          </div>
                          <button onClick={() => saveField(row.key, fieldDraft)} style={{ padding: "8px 14px", borderRadius: 8, background: `${row.color}18`, border: `0.5px solid ${row.color}50`, color: row.color, fontFamily: "inherit", fontSize: 12, fontWeight: 800, cursor: "pointer" }}>Save</button>
                          <button onClick={() => setEditingField(null)} style={{ padding: "8px 10px", borderRadius: 8, background: "none", border: "0.5px solid rgba(255,255,255,0.08)", color: t.colors.textTertiary, fontFamily: "inherit", fontSize: 12, cursor: "pointer" }}><svg width="10" height="10" viewBox="0 0 10 10" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><line x1="2" y1="2" x2="8" y2="8"/><line x1="8" y1="2" x2="2" y2="8"/></svg></button>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              );
            });
          })()}
        </GlassCard>

        {/* Notes from enquiry */}
        {proj.notes && (
          <GlassCard style={{ padding: 16, marginBottom: 20, background: "rgba(91,155,213,0.05)", border: `0.5px solid rgba(91,155,213,0.15)` }} hover={false}>
            <div style={{ display: "flex", gap: 12 }}>
              <div style={{ width: 32, height: 32, borderRadius: t.radius.md, background: t.colors.blueLight, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                <Icon name="flag" size={15} color={t.colors.blue} />
              </div>
              <div>
                <p style={{ fontSize: 12, fontWeight: 700, color: t.colors.blue, marginBottom: 4 }}>{uvWords("Enquiry Notes", "Enquiry notes")}</p>
                <p style={{ fontSize: 12, color: t.colors.textSecondary, lineHeight: 1.6 }}>{proj.notes}</p>
              </div>
            </div>
          </GlassCard>
        )}

        {/* Compliance alert — only if relevant */}
        {proj.driver && (proj.driver.toLowerCase().includes("mees") || proj.driver.toLowerCase().includes("f-gas") || proj.driver.toLowerCase().includes("epc")) && (
          <GlassCard style={{ padding: 16, marginBottom: 20, background: "rgba(251,176,64,0.06)", border: `0.5px solid rgba(251,176,64,0.25)` }} hover={false}>
            <div style={{ display: "flex", gap: 12 }}>
              <div style={{ width: 36, height: 36, borderRadius: t.radius.md, background: t.colors.amberLight, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                <Icon name="shield" size={18} color={t.colors.amber} />
              </div>
              <div>
                <p style={{ fontSize: 13, fontWeight: 700, color: t.colors.amber, marginBottom: 4 }}>
                  {div.id === "aircon" ? "F-Gas / Refrigerant Flag" : "MEES 2027 Flag"}
                </p>
                <p style={{ fontSize: 12, color: t.colors.textSecondary, lineHeight: 1.5 }}>
                  {div.id === "aircon"
                    ? "R22 and some R404A refrigerants are being phased out under F-Gas regulations. Non-compliant systems face service restrictions. This is <strong style={{ color: t.colors.text }}>the regulatory trigger</strong>" + studioDash() + "lead with it."
                    : <>Current EPC likely below Band C. Non-compliance from April 2027 means the building cannot be legally let. This is <strong style={{ color: t.colors.text }}>the commercial trigger</strong>{`${studioDash()}lead with it.`}</>
                  }
                </p>
              </div>
            </div>
          </GlassCard>
        )}

        {/* Scope summary — if captured */}
        {proj.scopeAnswers && Object.keys(proj.scopeAnswers).length > 0 && (
          <>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10 }}>
              <p style={{ fontSize: 11, fontWeight: 700, color: t.colors.textSecondary, letterSpacing: 0.8, textTransform: "uppercase" }}>{uvWords("Scope Brief", "Scope brief")}</p>
              <button onClick={() => onNav(2)} style={{ background: "none", border: "none", cursor: "pointer", fontSize: 12, fontWeight: 700, color: divColor, padding: "2px 0", ...uvx(() => ({ ...studioType.action(), fontSize: 12, minHeight: 44 })) }}>{`Edit${studioArrow()}`}</button>
            </div>
            <GlassCard style={{ padding: 0, marginBottom: 20, background: `${divColor}06`, border: `0.5px solid ${divBorder}` }} hover={false}>
              {[
                proj.scopeAnswers.driver && { label: "Driver", value: proj.scopeAnswers.driver },
                proj.scopeAnswers.decision && { label: "Decision maker", value: proj.scopeAnswers.decision },
                proj.scopeAnswers.budget && { label: "Budget", value: proj.scopeAnswers.budget },
                proj.scopeAnswers.timeline && { label: "Timeline", value: proj.scopeAnswers.timeline },
                proj.scopeAnswers.outcome && { label: "Success", value: proj.scopeAnswers.outcome },
              ].filter(Boolean).map((row, i, arr) => (
                <div key={i} style={{ padding: "10px 16px", display: "flex", justifyContent: "space-between", gap: 12, borderBottom: i < arr.length - 1 ? `0.5px solid ${t.colors.separator}` : "none" }}>
                  <p style={{ fontSize: 11, color: t.colors.textSecondary, fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.4, flexShrink: 0, paddingTop: 1 }}>{row.label}</p>
                  <p style={{ fontSize: 13, color: divColor, fontWeight: 600, textAlign: "right" }}>{row.value}</p>
                </div>
              ))}
            </GlassCard>
          </>
        )}

        {/* Pre-visit checklist */}
        <p style={{ fontSize: 11, fontWeight: 700, color: t.colors.textSecondary, letterSpacing: 0.8, textTransform: "uppercase", marginBottom: 10 }}>{uvWords("Pre-Visit Checklist", "Before you go")}</p>
        <GlassCard style={{ padding: 0, marginBottom: 24 }} hover={false}>
          {checklist.map((c, i) => (
            <div key={i} onClick={() => setChecks(prev => { const n = [...prev]; n[i] = !n[i]; if (project?.id && onUpdateProject) onUpdateProject(project.id, { checklist: n }); return n; })}
              style={{ padding: "13px 16px", display: "flex", alignItems: "center", gap: 12, borderBottom: i < checklist.length - 1 ? `0.5px solid ${t.colors.separator}` : "none", cursor: "pointer" }}>
              <div style={{ width: 22, height: 22, borderRadius: 6, background: checks[i] ? divColorLight : t.colors.glass, border: `0.5px solid ${checks[i] ? divBorder : t.colors.glassBorder}`, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                {checks[i] && <Icon name="check" size={12} color={divColor} />}
              </div>
              <span style={{ fontSize: 13, color: checks[i] ? t.colors.textSecondary : t.colors.text, textDecoration: checks[i] ? "line-through" : "none" }}>{c.item}</span>
            </div>
          ))}
        </GlassCard>

        {/* Visit Notes Log */}
        <p style={{ fontSize: 11, fontWeight: 700, color: t.colors.textSecondary, letterSpacing: 0.8, textTransform: "uppercase", marginBottom: 10 }}>{uvWords("Visit Notes", "Visit notes")}</p>
        <GlassCard style={{ padding: 0, marginBottom: 16 }} hover={false}>
          {visitNotes.length === 0 && !showNoteInput && (
            <div style={{ padding: "16px", textAlign: "center" }}>
              <p style={{ fontSize: 13, color: t.colors.textTertiary }}>No notes yet</p>
            </div>
          )}
          {visitNotes.map((note, i) => (
            <div key={i} style={{ padding: "12px 16px", borderBottom: `0.5px solid ${t.colors.separator}` }}>
              <p style={{ fontSize: 11, color: t.colors.textTertiary, fontWeight: 600, marginBottom: 3 }}>{note.date}{studioSep()}{note.author}</p>
              <p style={{ fontSize: 13, color: t.colors.text, lineHeight: 1.5 }}>{note.text}</p>
            </div>
          ))}
          {showNoteInput ? (
            <div style={{ padding: "12px 16px" }}>
              <textarea value={noteText} onChange={e => setNoteText(e.target.value)}
                placeholder="E.g. Called 14 Feb — confirmed budget £50k, wants Q2, Arup also quoting..."
                rows={3} style={{ width: "100%", background: "none", border: "none", outline: "none", color: t.colors.text, fontSize: 13, fontFamily: "'SF Pro Text', sans-serif", resize: "none", lineHeight: 1.5 }} />
              <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
                <Btn label="Save Note" variant="secondary" small color={divColor} onClick={() => {
                  if (noteText.trim() && project?.id && onUpdateProject) {
                    const newNote = { date: new Date().toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }), author: currentUser?.name || "Unknown", text: noteText.trim() };
                    onUpdateProject(project.id, { visitNotes: [...visitNotes, newNote], stage: "previsit" });
                  }
                  setNoteText(""); setShowNoteInput(false);
                }} />
                <Btn label="Cancel" variant="ghost" small color={divColor} onClick={() => { setNoteText(""); setShowNoteInput(false); }} />
              </div>
            </div>
          ) : (
            <button onClick={() => setShowNoteInput(true)} style={{ width: "100%", padding: "12px 16px", background: "none", border: "none", cursor: "pointer", textAlign: "left", fontSize: 13, color: divColor, fontWeight: 700 }}>{uvWords("+ Add Note", "Add note")}</button>
          )}
        </GlassCard>

        {/* Site Issues — if any logged */}
        {(proj.issues || []).length > 0 && (
          <>
            <p style={{ fontSize: 11, fontWeight: 700, color: t.colors.textSecondary, letterSpacing: 0.8, textTransform: "uppercase", marginBottom: 10 }}>{`Site Issues${studioDash()}`}{proj.issues.length}</p>
            <GlassCard style={{ padding: 0, marginBottom: 20 }} hover={false}>
              {proj.issues.map((issue, i) => {
                const sevColor = { Critical: t.colors.red, High: t.colors.amber, Medium: t.colors.blue, Low: t.colors.green }[issue.severity] || t.colors.blue;
                return (
                  <div key={issue.id || i} style={{ padding: "12px 16px", display: "flex", alignItems: "flex-start", gap: 12, borderBottom: i < proj.issues.length - 1 ? `0.5px solid ${t.colors.separator}` : "none" }}>
                    <div style={{ width: 8, height: 8, borderRadius: "50%", background: sevColor, marginTop: 5, flexShrink: 0 }} />
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <p style={{ fontSize: 13, color: t.colors.text, lineHeight: 1.45 }}>{issue.description}</p>
                      <p style={{ fontSize: 11, color: t.colors.textTertiary, marginTop: 3 }}>{issue.severity}{studioSep()}{issue.date} {issue.time}</p>
                    </div>
                    {issue.photo && <img src={issue.photo} alt="" style={{ width: 44, height: 44, borderRadius: 8, objectFit: "cover", flexShrink: 0 }} />}
                  </div>
                );
              })}
            </GlassCard>
          </>
        )}

        {/* Site Photos — if any captured */}
        {(() => {
          const allPhotos = [
            ...(proj.sitePhotos || []),
            ...(proj.surveyZones || []).flatMap(z => (z.photos || []).map(p => ({ ...p, label: z.zone }))),
          ];
          if (allPhotos.length === 0) return null;
          return (
            <>
              <p style={{ fontSize: 11, fontWeight: 700, color: t.colors.textSecondary, letterSpacing: 0.8, textTransform: "uppercase", marginBottom: 10 }}>{`Site Photos${studioDash()}`}{allPhotos.length}</p>
              <GlassCard style={{ padding: 12, marginBottom: 20 }} hover={false}>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 6 }}>
                  {allPhotos.map((ph, i) => (
                    <button key={i} onClick={() => setPvLightbox({ photo: ph, caption: ph.label || ph.zone || "" })} style={{
                      aspectRatio: "1", borderRadius: 8, overflow: "hidden",
                      border: `0.5px solid ${t.colors.glassBorder}`, cursor: "pointer", padding: 0,
                    }}>
                      <MediaThumb photo={ph} style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
                    </button>
                  ))}
                </div>
              </GlassCard>
            </>
          );
        })()}

        {(() => {
          const hasSurveyZones = (project?.surveyZones?.length || 0) > 0;
          const scopeCount = project?.scopeAnswers ? Object.keys(project.scopeAnswers).length : 0;
          const scopeComplete = scopeCount >= 6;
          const scopeStarted = scopeCount > 0;

          let primaryLabel, primaryNav, hint;
          if (hasSurveyZones) {
            primaryLabel = uvWords(`Continue Survey${studioArrow()}`, 'Carry on the survey');
            primaryNav = 3;
            hint = `${project.surveyZones.length} zone${project.surveyZones.length !== 1 ? "s" : ""} logged${studioDash()}pick up where you left off`;
          } else if (scopeComplete) {
            primaryLabel = uvWords(`Continue Survey${studioArrow()}`, 'Carry on the survey');
            primaryNav = 3;
            hint = `Scope brief captured${studioDash()}tap Edit above to amend`;
          } else if (scopeStarted) {
            primaryLabel = uvWords(`Continue Scope Capture${studioArrow()}`, 'Carry on the scope');
            primaryNav = 2;
            hint = `${scopeCount} of 6 questions answered`;
          } else {
            primaryLabel = uvWords(`Start Scope Capture${studioArrow()}`, 'Start the scope');
            primaryNav = 2;
            hint = uvWords("Next: structured client meeting mode", "Six questions to go through with the client");
          }

          return (
            <>
              <div style={{ display: "flex", gap: 10, marginBottom: 8 }}>
                <Btn label={uvWords("Log Site Issue", "Log an issue")} variant="secondary" onClick={() => onNav(5)} color={divColor} />
                <div style={{ flex: 1 }}>
                  <Btn label={primaryLabel} variant="primary" fullWidth color={divColor} studioMain={t.theme === 'uv'} onClick={() => {
                    if (project?.id && onUpdateProject) onUpdateProject(project.id, { stage: "previsit" });
                    onNav(primaryNav);
                  }} />
                </div>
              </div>
              <p style={{ textAlign: "center", fontSize: 11, color: t.colors.textTertiary, marginTop: 10 }}>{hint}</p>
            </>
          );
        })()}

        {/* ── Project Timeline ── */}
        {project && (
          <GlassCard style={{ padding: "16px 18px", marginTop: 16 }} hover={false}>
            <ProjectTimeline project={project} divColor={divColor} />
          </GlassCard>
        )}
      </div>
      <TabBar active={0} onChange={onNav} divisionId={div && div.id ? div.id : "lighting"} />
    </div>
  );
};

// ════════════════════════════════════════════════════
// SCREEN 3: SCOPE CAPTURE
// ════════════════════════════════════════════════════
const QuickEntryScreenBody = ({ onBack, onNav, currentUser, project, onUpdateProject, onCreateProject }) => {
  // S99 — read survey_prefill once on mount. The Today-card "Start
  // survey" button (TodayScreen ~2664) and SurveyLanding planned-card
  // tap (~4498) both write {surveyId, visitName, contactName} to
  // localStorage.survey_prefill before navigating here. We use those
  // values to (a) pre-fill the form and (b) reuse the same id for the
  // new project so it matches the existing lumen_visits / survey_queue
  // rows. Without this, the project gets a fresh id and the queue row
  // is left orphaned, leaking through SurveyLanding as a phantom.
  const [prefill] = useState(() => {
    try { return JSON.parse(localStorage.getItem('survey_prefill') || 'null') || {}; }
    catch (e) { return {}; }
  });
  const [siteName, setSiteName] = useState(project?.name || prefill.visitName || '');
  const [address, setAddress] = useState(project?.address || '');
  const [client, setClient] = useState(project?.client || prefill.contactName || '');
  const canStart = siteName.trim().length > 0;

  const filledStyle = (val) => val.trim() ? { borderColor: 'rgba(46,104,56,0.3)', background: 'rgba(255,255,255,0.9)' } : {};

  // ── B.2 Slice 1 — capture-time binding ─────────────────────────────
  // Set ONCE here (the single convergence point every survey-start path
  // funnels through); everything captured under the project inherits it.
  // Binding is OPTIONAL — Start is never blocked on a choice. No
  // name-matching, no preselection: the user picks, or it's unbound.
  const [binding, setBinding] = useState(() => getProjectBinding(project));
  const [pickerOpen, setPickerOpen] = useState(false);
  // Card + sheet are the shared B.2 components (ProjectBindingCard /
  // ProjectPickerSheet, extracted Slice 2) — the cache read, staleness line
  // and search all live inside the sheet now.

  const applyBinding = (b) => {
    setBinding(b);
    // Existing project: persist immediately (set once at open). Brand-new
    // project: the binding rides handleStart's create payload below.
    if (project && project.id && onUpdateProject) {
      onUpdateProject(project.id, setProjectBinding(project, b));
    }
    setPickerOpen(false);
  };

  const handleStart = () => {
    if (!canStart) return;
    let projId;
    if (project?.id && onUpdateProject) {
      projId = project.id;
      onUpdateProject(project.id, {
        name: siteName.trim(), address: address.trim(), client: client.trim(),
        // B.2 — re-assert the chosen binding on start (no-op when the
        // applyBinding write already landed; absent when never chosen).
        ...(binding ? setProjectBinding(project, binding) : {}),
      });
      onNav(3);
    } else if (onCreateProject) {
      // S99 — if we arrived here from a Today/landing flow, addProject
      // gets the prefilled surveyId so the queue row matches. The
      // addProject reducer (~13694) spreads `...proj` after its default
      // id, so passing `id: prefill.surveyId` overrides it cleanly.
      const newProj = onCreateProject({
        name: siteName.trim(),
        address: address.trim(),
        client: client.trim(),
        stage: 'new',
        ...(prefill.surveyId ? { id: prefill.surveyId } : {}),
        // B.2 — binding chosen before the project existed rides the
        // create payload (addProject spreads ...proj onto the record).
        ...(binding ? setProjectBinding(null, binding) : {}),
      });
      projId = newProj?.id;
      onNav(3);
    }
    // S99 — prefill is consumed; clear it so the next survey doesn't
    // inherit a stale id from a prior visit.
    try { localStorage.removeItem('survey_prefill'); } catch (e) {}
    // Write today_visits + survey_queue entries (or update if they
    // already exist for this id — covers the visit-scheduled-then-
    // started flow and the brand-new-from-Landing flow uniformly).
    if (projId) {
      try {
        const todayStr = new Date().toISOString().split('T')[0];
        const tv = JSON.parse(localStorage.getItem('lumen_visits') || '[]');
        const existingVisit = tv.find(v => v.surveyId === projId);
        if (existingVisit) {
          existingVisit.status = 'live';
        } else {
          tv.push({ id: 'v_' + Date.now(), date: todayStr, type: 'survey', name: siteName.trim(), projectName: siteName.trim(), contact: client.trim(), surveyId: projId, status: 'live', createdAt: Date.now() });
        }
        localStorage.setItem('lumen_visits', JSON.stringify(tv));
        // Update or add to survey_queue
        const sq = JSON.parse(localStorage.getItem('survey_queue') || '[]');
        const existing = sq.find(q => q.id === projId);
        if (existing) { existing.status = 'live'; }
        else { sq.push({ id: projId, name: siteName.trim(), contact: client.trim(), status: 'live', createdAt: Date.now() }); }
        localStorage.setItem('survey_queue', JSON.stringify(sq));
      } catch(e) {}
    }
  };

  return (
    <div style={{ flex: 1, overflowY: 'auto', WebkitOverflowScrolling: 'touch', overscrollBehavior: 'contain', paddingBottom: 100, background: '#E8DCC8', display: 'flex', flexDirection: 'column' }}>
      <ScreenBlobs />
      <NavBar title="New survey" onBack={onBack} />
      <div style={{ flex: 1, overflowY: 'auto', padding: '16px 20px 40px' }}>

        {/* Hint card */}
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10, padding: '12px 14px', background: 'rgba(200,144,48,0.08)', border: '1px solid rgba(200,144,48,0.2)', borderRadius: 10, marginBottom: 24 }}>
          <div style={{ width: 6, height: 6, borderRadius: '50%', background: t.colors.amber, flexShrink: 0, marginTop: 5 }} />
          <span style={{ fontSize: 13, color: t.colors.text, lineHeight: 1.5 }}>Site name is all you need. Everything else can wait.</span>
        </div>

        {/* Site name */}
        <div style={{ marginBottom: 20 }}>
          <label style={{ fontSize: 10, fontWeight: 700, color: t.colors.textTertiary, textTransform: 'uppercase', letterSpacing: 0.8, marginBottom: 6, display: 'block' }}>Site / building name *</label>
          <input value={siteName} onChange={e => setSiteName(e.target.value)} placeholder="e.g. Broadgate Tower" autoFocus
            style={{ width: '100%', background: 'rgba(255,255,255,0.7)', border: '1px solid rgba(0,0,0,0.1)', borderRadius: 10, padding: '13px 14px', fontSize: 15, fontWeight: 600, color: t.colors.text, fontFamily: 'inherit', outline: 'none', boxSizing: 'border-box', ...filledStyle(siteName) }} />
        </div>

        {/* Address */}
        <div style={{ marginBottom: 20 }}>
          <label style={{ fontSize: 10, fontWeight: 700, color: t.colors.textTertiary, textTransform: 'uppercase', letterSpacing: 0.8, marginBottom: 6, display: 'block' }}>Address</label>
          <input value={address} onChange={e => setAddress(e.target.value)} placeholder={`Optional${studioDash()}helps match to portal`}
            style={{ width: '100%', background: 'rgba(255,255,255,0.7)', border: '1px solid rgba(0,0,0,0.1)', borderRadius: 10, padding: '13px 14px', fontSize: 15, fontWeight: 600, color: t.colors.text, fontFamily: 'inherit', outline: 'none', boxSizing: 'border-box', ...filledStyle(address) }} />
          <span style={{ fontSize: 11, color: t.colors.textTertiary, marginTop: 4, display: 'block' }}>Optional</span>
        </div>

        {/* Client */}
        <div style={{ marginBottom: 20 }}>
          <label style={{ fontSize: 10, fontWeight: 700, color: t.colors.textTertiary, textTransform: 'uppercase', letterSpacing: 0.8, marginBottom: 6, display: 'block' }}>Client</label>
          <input value={client} onChange={e => setClient(e.target.value)} placeholder="Start typing to search contacts..."
            style={{ width: '100%', background: 'rgba(255,255,255,0.7)', border: '1px solid rgba(0,0,0,0.1)', borderRadius: 10, padding: '13px 14px', fontSize: 15, fontWeight: 600, color: t.colors.text, fontFamily: 'inherit', outline: 'none', boxSizing: 'border-box', ...filledStyle(client) }} />
        </div>

        {/* B.2 — binding card (three states; Start never blocked) */}
        <div style={{ marginBottom: 32 }}>
          <label style={{ fontSize: 10, fontWeight: 700, color: t.colors.textTertiary, textTransform: 'uppercase', letterSpacing: 0.8, marginBottom: 6, display: 'block' }}>Portal project</label>
          <ProjectBindingCard binding={binding} onChoose={() => setPickerOpen(true)} />
        </div>

        {/* CTA */}
        <button onClick={handleStart} disabled={!canStart}
          style={{ width: '100%', background: canStart ? '#2E6838' : 'rgba(46,104,56,0.3)', border: 'none', borderRadius: 12, padding: 16, cursor: canStart ? 'pointer' : 'default', fontFamily: 'inherit', transition: 'all .2s', ...uvx(() => ({ ...studioSurface.primary(), opacity: canStart ? 1 : 0.5 })) }}>
          <div style={{ fontSize: 15, fontWeight: 800, color: '#fff' }}>{`Start surveying${studioArrow()}`}</div>
          <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.55)', marginTop: 4 }}>You can add scope and details at the end</div>
        </button>
      </div>

      {/* B.2 — bottom sheet picker (shared ProjectPickerSheet; reads the
          lumen_projects cache only, staleness line inside) */}
      {pickerOpen && (
        <ProjectPickerSheet binding={binding} onApply={applyBinding} onClose={() => setPickerOpen(false)}
          prefill={{ name: siteName, client_name: client, site_address: address }} />
      )}
    </div>
  );
};

// ════════════════════════════════════════════════════
// SCREEN 4: LIVE SURVEY — THE MAGIC SCREEN
// ════════════════════════════════════════════════════
// ════════════════════════════════════════════════════
// SCREEN 9: VOICE NOTES — Whisper-powered field recorder
// ════════════════════════════════════════════════════
// STUDIO-LIT-PHONE-V1 item 8a: the switch-on voice screen renders inside its
// own component, so the capture walker does not re-colour Eva's violet.
const VoiceLitBody = ({ draw }) => draw();
const VoiceNotesScreenBody = ({ onNav, currentUser, activeProject, onUpdateProject, noteBinding, onPickJob }) => {
  const div = getDivisionConfig(currentUser);

  // ── localStorage helpers (S95 D1 Event B — delegate to module-scope quota-safe helpers) ──
  const loadNotes = () => loadVoiceNotes();
  // saveNotes returns the persist result so callers can respond to quota errors.
  const saveNotes = (arr) => persistVoiceNotes(arr);
  const updateNoteInStorage = (id, updates) => {
    const res = updateVoiceNote(id, updates);
    // Backwards-compat: previously returned the full array. Keep that contract.
    return res.all || loadVoiceNotes();
  };

  // ── Base64 helpers ──
  const blobToBase64 = (blob) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result.split(',')[1]);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
  const base64ToBlob = (b64, mime) => {
    const bin = atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
    return new Blob([arr], { type: mime });
  };

  // ── State ──
  const [recording, setRecording] = useState(false);
  const [recTime, setRecTime] = useState(0);
  const [status, setStatus] = useState("idle"); // idle | recording
  const [notes, setNotes] = useState(loadNotes);
  const [voiceTab, setVoiceTab] = useState(0); // 0=Capture, 1=Notes
  const [playingId, setPlayingId] = useState(null);
  const [saveError, setSaveError] = useState(null); // S95 D1 Event B — surface quota/persist failures
  const mediaRecorderRef = useRef(null);
  const chunksRef = useRef([]);
  const mimeRef = useRef("audio/webm");
  const timerRef = useRef(null);
  const audioRef = useRef(null);   // SEC-028: the _playVoiceSource handle now playing
  const recTimeRef = useRef(0);

  const fmtTime = (s) => `${Math.floor(s/60)}:${String(s%60).padStart(2,"0")}`;

  // ── Context from how the screen was opened ──
  const ctxTag = activeProject?.name ? (activeProject.type || "general") : "general";

  // ── Transcription logic (never blocks UI) ──
  const transcribeNote = async (note) => {
    if (!navigator.onLine) return;
    // S4b — explicit guard. The bytes can now be reclaimed after upload, and
    // base64ToBlob does atob(null) -> the STRING "null", which is valid base64
    // and decodes to 3 bytes rather than throwing: it would POST 3 bytes of
    // rubbish to Whisper. Today the status predicates make this unreachable
    // (reclaim needs a transcript; this needs status 'pending'), but that is a
    // transitive invariant across two functions and one edit to either breaks
    // it silently.
    if (!voiceHasLocalAudio(note)) return;
    if (note.transcriptionStatus !== 'pending') return;
    // SLICE-A5: read the bytes from whichever store holds them; unreadable
    // just now means leave it pending for the retry sweep.
    const blob = await voiceAudioBlob(note);
    if (!blob) return;
    // Mark transcribing in state + storage
    setNotes(prev => prev.map(n => n.id === note.id ? { ...n, transcriptionStatus: 'transcribing' } : n));
    updateNoteInStorage(note.id, { transcriptionStatus: 'transcribing' });
    try {
      const formData = new FormData();
      formData.append('audio', blob, 'recording.webm');
      const res = await fetch(`${PORTAL_URL}/api/transcribe`, _transcribeFetchInit(formData));
      if (_isTranscribeRefusal(res.status)) {
        // Refused (not signed in / over the hourly limit): keep it pending
        // for the retry sweep rather than stamping 'failed' on good audio.
        const updated = updateNoteInStorage(note.id, { transcriptionStatus: 'pending' });
        setNotes(updated);
        return;
      }
      const data = await res.json();
      if (data.transcript) {
        const updated = updateNoteInStorage(note.id, { transcriptionStatus: 'done', transcript: data.transcript, transcribedAt: new Date().toISOString() });
        setNotes(updated);
      } else {
        const updated = updateNoteInStorage(note.id, { transcriptionStatus: 'failed' });
        setNotes(updated);
      }
    } catch(e) {
      // Reset to pending for retry
      const updated = updateNoteInStorage(note.id, { transcriptionStatus: 'pending' });
      setNotes(updated);
    }
  };

  // S1 (reviewer FLAG-04) — ONE retry derivation. This screen used to run its
  // own loop with different selection rules to the module-level one, so a single
  // foreground could POST the same recording twice and the two writers could
  // race each other's status. Delegates now; the local transcribeNote stays for
  // the per-note manual "retry" affordance only.
  const retryPending = () => {
    Promise.resolve(retryPendingVoiceTranscriptions())
      .then(() => { try { setNotes(loadNotes()); } catch (e) {} })
      .catch(() => {});
  };

  // ── Recording flow ──
  const startRecord = async () => {
    if (recording || (mediaRecorderRef.current && mediaRecorderRef.current.state !== "inactive")) return;
    // Immediately switch to recording UI
    setRecording(true); setStatus("recording"); setRecTime(0);
    recTimeRef.current = 0;
    if (timerRef.current) clearInterval(timerRef.current);
    timerRef.current = setInterval(() => { recTimeRef.current += 1; setRecTime(prev => prev + 1); }, 1000);
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio:true });
      const mimeType = MediaRecorder.isTypeSupported("audio/webm;codecs=opus") ? "audio/webm;codecs=opus"
        : MediaRecorder.isTypeSupported("audio/webm") ? "audio/webm" : "audio/mp4";
      mimeRef.current = mimeType;
      const mr = new MediaRecorder(stream, { mimeType });
      chunksRef.current = [];
      mr.ondataavailable = e => { if (e.data.size > 0) chunksRef.current.push(e.data); };
      mr.onstop = async () => {
        stream.getTracks().forEach(tr => tr.stop());
        // ── S95 D1 Event B FIX — save to localStorage BEFORE transcription. Never lose audio. ──
        const blob = new Blob(chunksRef.current, { type: mimeType });
        const dur = recTimeRef.current;
        const noteId = crypto.randomUUID ? crypto.randomUUID() : Date.now().toString(36) + Math.random().toString(36).substr(2,9);
        // Stop recording UI immediately — persistence happens below, transcription is async.
        setRecording(false);
        setStatus("idle");
        setVoiceTab(1); // Switch to Notes tab so user can see the new entry.
        // SLICE-A5: the bytes go to IndexedDB (base64 only if that fails).
        const audioFields = await voiceAudioFields(noteId, blob, blobToBase64);
        const newNote = {
          id: noteId,
          recordedAt: new Date().toISOString(),
          duration: dur,
          context: ctxTag,
          projectId: activeProject?.id || null,
          // B.2 Slice 3 — wire identity. projectId above stays for local
          // display/filter (local context, not wire identity); this is what
          // voice_note_logged carries: a PRJ binding or null, never local ids.
          projectBinding: (noteBinding && typeof noteBinding === 'object') ? noteBinding : null,
          ...audioFields,
          audioMimeType: mimeType,
          transcript: null,
          transcriptionStatus: 'pending',
          transcribedAt: null,
          source: 'header-mic',
        };
        // Persist via quota-safe helper. Result tells us whether we had to prune.
        // The standalone header-mic screen keeps its emission (D2 scopes the
        // removal to in-zone survey notes only).
        const saveRes = addVoiceNote(newNote, true);
        const refreshed = loadNotes();
        setNotes(refreshed);
        setSaveError(voiceStoreMessage(saveRes) || null);
        // Attempt transcription in background — never deletes the note on failure.
        transcribeNote(newNote);
        // S4b — get the audio OFF THE HANDSET. Fire-and-forget, and deliberately
        // INDEPENDENT of transcription above: a note may end up with a transcript
        // and no URL, a URL and no transcript, both, or neither (S4a doctrine —
        // the transcript is the record, the audio is evidence attached to it).
        // On success this drops the local bytes, which is what relieves the
        // quota pruner that has been destroying these recordings.
        Promise.resolve(uploadNoteAudio(noteId))
          .then(() => { try { setNotes(loadNotes()); } catch (e) {} })
          .catch(() => {});
      };
      mediaRecorderRef.current = mr;
      mr.start(200);
    } catch(e) {
      setRecording(false); setStatus("idle");
      if (timerRef.current) { clearInterval(timerRef.current); timerRef.current = null; }
    }
  };

  const stopRecord = () => {
    if (mediaRecorderRef.current && mediaRecorderRef.current.state !== "inactive") {
      mediaRecorderRef.current.stop();
    }
    if (timerRef.current) { clearInterval(timerRef.current); timerRef.current = null; }
  };

  // ── Playback ──
  const playNote = (note) => {
    // S4b — an uploaded note has had its local bytes reclaimed; play it from
    // the portal. Only a note with neither is genuinely unplayable.
    if (!voiceHasLocalAudio(note) && !note.audioUrl) return;
    // SEC-028: stop() detaches the old element's handlers before it pauses and
    // releases, so nothing the old one does later can touch this note's state.
    if (audioRef.current) { audioRef.current.stop(); audioRef.current = null; }
    const failed = () => {
      setPlayingId(null); audioRef.current = null;
      // S4b — a reclaimed note streams from the portal, so this is what a
      // surveyor hits with no signal. Silence reads as a broken button; say
      // which it is. (The in-zone player already toasts; this one did not.)
      // SEC-028: a portal refusal (401/403) or a refused play() lands here
      // too, with the same words.
      setSaveError(note && !voiceHasLocalAudio(note) && note.audioUrl
        ? 'That recording is saved to the portal. Reconnect to play it.'
        : 'Could not play that recording.');
    };
    setPlayingId(note.id);
    // SEC-028: started here, inside the tap (the iOS unlock); the portal copy
    // is fetched with the Bearer token and played from a blob: URL.
    const handle = _playVoiceSource({
      localSrc: note.audioBase64 ? `data:${note.audioMimeType};base64,${note.audioBase64}` : null,
      localLoad: (!note.audioBase64 && note.audioInIdb) ? () => voiceAudioBlob(note) : null,
      audioUrl: note.audioUrl,
      onEnded: () => { setPlayingId(null); audioRef.current = null; },
      onFail: failed,
    });
    audioRef.current = handle;
  };

  // Reset timer on mount; pre-warm mic permission; set up visibility retry
  useEffect(() => {
    setRecTime(0); setRecording(false); setStatus("idle");
    if (timerRef.current) { clearInterval(timerRef.current); timerRef.current = null; }
    navigator.mediaDevices?.getUserMedia({ audio: true }).then(stream => {
      stream.getTracks().forEach(tr => tr.stop());
    }).catch(() => {});
    // Retry pending on foreground
    const onVisibility = () => { if (document.visibilityState === 'visible') { setNotes(loadNotes()); retryPending(); } };
    document.addEventListener('visibilitychange', onVisibility);
    // Retry pending on portal sync (pull to refresh)
    const onSync = () => { setNotes(loadNotes()); retryPending(); };
    window.addEventListener('lumenDataSync', onSync);
    // Initial retry
    retryPending();
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
      // SEC-028: stop() also cancels a portal fetch still in flight.
      if (audioRef.current) { audioRef.current.stop(); audioRef.current = null; }
      document.removeEventListener('visibilitychange', onVisibility);
      window.removeEventListener('lumenDataSync', onSync);
    };
  }, []);

  const PILL_COLORS = {
    survey:  { bg:"rgba(46,104,56,0.12)",  border:"rgba(46,104,56,0.25)",  color:"#2E6838" },
    meeting: { bg:"rgba(200,144,48,0.1)",  border:"rgba(200,144,48,0.2)",  color:"#8A6010" },
    general: { bg:"rgba(42,58,26,0.08)", border:"rgba(42,58,26,0.15)", color:"#5A4A2A" },
    wrap:    { bg:"rgba(46,104,56,0.12)",  border:"rgba(46,104,56,0.25)",  color:"#2E6838" },
  };
  const getPill = (ctx) => PILL_COLORS[ctx] || PILL_COLORS.general;
  const ctxLabel = (ctx) => ctx === 'survey' ? 'Survey' : ctx === 'meeting' ? 'Meeting' : ctx === 'wrap' ? 'Survey wrap' : 'General';

  const deleteNote = (id) => {
    const gone = loadNotes().find(n => n.id === id);
    const all = loadNotes().filter(n => n.id !== id);
    const w = saveNotes(all);
    setNotes(all);
    // SLICE-A5: a deleted note takes its IndexedDB copy with it, as it always
    // took its base64. Only once the delete has persisted: if it did not, the
    // note is still there and still needs its audio.
    if (w && w.ok === true && gone && gone.audioInIdb) {
      try { Promise.resolve(idbDeleteBlob(voiceIdbKey(id))).catch(() => {}); } catch (e) {}
    }
  };

  // Seeded waveform generator — 15 bars from note id
  const getWaveHeights = (noteId) => {
    let seed = 0;
    const s = String(noteId || 'x');
    for (let i = 0; i < s.length; i++) seed = ((seed << 5) - seed + s.charCodeAt(i)) | 0;
    return Array.from({ length: 15 }, (_, i) => {
      seed = (seed * 16807 + 1) & 0x7fffffff;
      return 20 + (seed % 65);
    });
  };

  const waveHeights = [30,55,42,72,48,80,36,62,44,76,40,66,32,56,44,72,38,60];

  const showRecording = recording;

  // Voice notes swipe — Capture ↔ Notes (disabled while recording)
  const voiceSwipe = createSwipeHandler(
    () => { if (!recording) setVoiceTab(1); },
    () => { if (!recording) setVoiceTab(0); }
  );

  // STUDIO-LIT-PHONE-V1 item 8a: Voice note (#app/voice) with the switch on.
  // One column, no Capture and Notes tabs: the recorder (Eva's orb, her
  // place, so violet; while she listens the title reads Recording, the timer
  // and the wave are violet), the job the note files to (the binding chosen
  // from the header orb's list; "A different job" opens that list again),
  // then the notes on this phone. The prototype's live words and what Eva
  // took from them (To do, By, Decision) are not built: the phone has no live
  // transcript and no extraction (a capability for its own run).
  if (t.theme === 'uv') {
    const drawLit = () => {
      const S = STUDIO_TOKENS; const M = STUDIO_MEANING;
      const b = (noteBinding && typeof noteBinding === 'object' && noteBinding.project_id) ? noteBinding : null;
      const act = { ...studioType.action(), fontSize: 14, minHeight: 44, cursor: 'pointer', fontFamily: 'inherit' };
      const bars = [];
      for (let i = 0; i < 48; i++) bars.push(8 + Math.round(Math.abs(Math.sin(i * 1.31) * Math.cos(i * 0.47)) * 64 + (i % 5) * 3));
      const filing = (
        <section style={{ ...studioSurface.raised(), borderRadius: S.radius.card, padding: '12px 16px 4px', display: 'flex', flexDirection: 'column' }}>
          <p style={{ fontSize: 16, lineHeight: 1.4, margin: 0 }}>
            {b ? <>Filing this to <b style={{ fontWeight: 700 }}>{b.project_name || b.project_id}</b>{b.project_name ? ', ' + b.project_id : ''}.</> : 'A general note, not filed to a job.'}
          </p>
          {onPickJob && <button onClick={onPickJob} style={{ ...act, alignSelf: 'flex-start' }}>{b ? 'A different job' : 'File it to a job'}</button>}
        </section>
      );
      return (
        <div style={{ flex: 1, overflowY: 'auto', WebkitOverflowScrolling: 'touch', overscrollBehavior: 'contain', padding: '4px 20px 130px', display: 'flex', flexDirection: 'column', gap: 16, fontFamily: S.fonts.body, color: S.ink }}>
          <style>{STUDIO_ORB_KEYFRAMES}</style>
          <div style={{ minHeight: 44, display: 'flex', alignItems: 'center', marginBottom: -12 }}><SnagBack label="Today" onClick={() => onNav(0)} /></div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, minHeight: 50 }}>
            <h1 style={{ ...studioType.title(), fontSize: 39, lineHeight: 1.02 }}>{recording ? 'Recording' : 'Voice note'}</h1>
            {recording && <span role="timer" style={{ fontFamily: S.fonts.display, fontWeight: 300, fontSize: 31, fontVariantNumeric: 'tabular-nums', color: S.violetText }}>{fmtTime(recTime)}</span>}
          </div>
          {recording ? (
            <svg viewBox="0 0 334 96" preserveAspectRatio="none" role="img" aria-label={`Recording, ${recTime} seconds`} style={{ width: '100%', height: 96, flexShrink: 0, filter: `drop-shadow(0 0 10px ${studioRgba(S.ultraviolet, 0.35)})` }}>
              <g fill={S.ultraviolet}>
                {bars.map((h, i) => <rect key={i} x={i * 7} y={48 - h / 2} width="4" height={h} rx="2" style={{ transformBox: 'fill-box', transformOrigin: 'center', animation: `studioWave .7s ease-in-out ${((i % 7) * 0.08).toFixed(2)}s infinite alternate` }} />)}
              </g>
            </svg>
          ) : (
            <p style={{ fontSize: 16, color: S.muted, lineHeight: 1.45, margin: 0 }}>Say what you see: observations, measurements and decisions as they happen.</p>
          )}
          {filing}
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6 }}>
            <button onClick={recording ? stopRecord : startRecord} aria-label={recording ? 'Stop recording and file the note' : 'Start recording'} style={{ width: 88, height: 88, padding: 0, border: 'none', background: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <StudioOrb size={88} live={recording} />
            </button>
            <p style={{ fontSize: 14, color: S.muted, margin: 0, textAlign: 'center' }}>{recording ? 'Tap to stop. Navigating away will not stop the recording.' : 'Tap to record'}</p>
          </div>
          {saveError && (
            <div role="alert" style={{ ...studioSurface.pressed(), borderRadius: S.pressed.radius, padding: '10px 6px 10px 14px', display: 'flex', alignItems: 'flex-start', gap: 8 }}>
              <p style={{ flex: 1, fontSize: 14, lineHeight: 1.42, color: M.rustText, margin: 0 }}>{saveError}</p>
              <button onClick={() => setSaveError(null)} aria-label="Dismiss" style={{ width: 44, height: 44, border: 'none', background: 'none', color: S.ink, cursor: 'pointer', fontSize: 18 }}>✕</button>
            </div>
          )}
          {notes.length > 0
            ? <h2 style={{ fontFamily: S.fonts.body, fontSize: 16, fontWeight: 700, margin: '4px 0 -6px' }}>On this phone</h2>
            : <p style={{ fontSize: 14, color: S.muted, margin: 0 }}>No notes yet. They show here once you stop recording.</p>}
          {notes.map((note) => {
            const isPlaying = playingId === note.id;
            const isDone = note.transcriptionStatus === 'done';
            const isFailed = note.transcriptionStatus === 'failed';
            const isTranscribing = note.transcriptionStatus === 'transcribing';
            const at = note.recordedAt ? new Date(note.recordedAt) : null;
            const when = at && !isNaN(at.getTime())
              ? (at.toDateString() === new Date().toDateString() ? at.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' }) : at.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' }) + ', ' + at.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' }))
              : '';
            const nb = note.projectBinding && note.projectBinding.project_id ? note.projectBinding : null;
            const where = note.zone ? (note.zone === '__project__' ? 'Site-wide' : note.zone) : null;
            // SLICE-A5: where the audio is (on phone, saved, not sent).
            const audioState = voiceAudioState(note);
            const head = [when, note.duration > 0 ? fmtTime(note.duration) : null, nb ? (nb.project_name || nb.project_id) : null, where, note.portalSynced ? 'synced' : null, audioState ? 'audio ' + audioState : null].filter(Boolean).join(', ');
            return (
              <SwipeableCard key={note.id} onDelete={() => deleteNote(note.id)} style={{ margin: 0 }}>
                <div style={{ ...studioSurface.slip(), borderRadius: S.radius.card, padding: '12px 14px', display: 'flex', flexDirection: 'column', gap: 8 }}>
                  <p style={{ fontSize: 14, color: S.muted, margin: 0 }}>{head}</p>
                  <button onClick={() => playNote(note)} aria-label={isPlaying ? 'Playing' : 'Play this note'} style={{ display: 'flex', gap: 2, alignItems: 'flex-end', height: 44, padding: '6px 0', border: 'none', background: 'none', cursor: 'pointer' }}>
                    {getWaveHeights(note.id).map((h, i) => <span key={i} style={{ flex: 1, height: `${h}%`, borderRadius: 1.5, background: isPlaying ? S.lampAmber : studioInk(0.25) }} />)}
                  </button>
                  {isDone && <p style={{ fontSize: 16, lineHeight: 1.45, margin: 0, display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{note.transcript}</p>}
                  {!isDone && !isFailed && <p style={{ fontSize: 14, color: S.muted, margin: 0 }}>{isTranscribing ? 'Writing it up' : 'Saved. Tap the wave to play it.'}</p>}
                  {isFailed && (
                    <p style={{ fontSize: 14, color: S.muted, margin: 0, display: 'flex', alignItems: 'center', gap: 10 }}>
                      {'Transcription failed.'}
                      <button onClick={() => { updateNoteInStorage(note.id, { transcriptionStatus: 'pending', transcribeAttempts: 0 }); setNotes(loadNotes()); transcribeNote({ ...note, transcriptionStatus: 'pending' }); }} style={act}>Try again</button>
                    </p>
                  )}
                  {isDone && (
                    <div style={{ display: 'flex', gap: 18, flexWrap: 'wrap' }}>
                      <button onClick={() => { const sub = encodeURIComponent(`Voice note, ${ctxLabel(note.context)}`); const bod = encodeURIComponent(`Context: ${ctxLabel(note.context)}\nRecorded: ${when}\n\n${note.transcript}`); window.open(`mailto:?subject=${sub}&body=${bod}`); }} style={act}>Email to the desk</button>
                      <button onClick={() => { if (navigator.clipboard) navigator.clipboard.writeText(note.transcript); }} style={act}>Copy the words</button>
                    </div>
                  )}
                </div>
              </SwipeableCard>
            );
          })}
          <TabBar active={9} onChange={onNav} divisionId={div && div.id ? div.id : 'lighting'} />
        </div>
      );
    };
    return <VoiceLitBody draw={drawLit} />;
  }

  return (
    <div style={{ flex:1, overflowY:"auto", WebkitOverflowScrolling:"touch", overscrollBehavior:"contain", paddingBottom:100, background:"#E8DCC8", display:"flex", flexDirection:"column" }}>

      <NavBar title="Voice Notes" onBack={() => onNav(0)} color="#C89030" />

      {/* ── 2-Tab Switcher: Capture | Notes ── */}
      <div style={{ display:"flex", margin:"0 16px", background:"rgba(26,22,8,0.06)", borderRadius:12, padding:3, flexShrink:0, ...uvx({ background: 'transparent', padding: 0, gap: 8 }) }}>
        {["Capture", "Notes"].map((label, idx) => (
          <button key={label} onClick={() => setVoiceTab(idx)} style={{
            flex:1, padding:"8px 0", borderRadius:10, border:"none", cursor:"pointer", fontFamily:"inherit",
            fontSize:13, fontWeight:700, letterSpacing:0.2,
            background: voiceTab === idx ? "rgba(255,252,242,0.92)" : "transparent",
            color: voiceTab === idx ? "#1A1608" : "rgba(26,22,8,0.38)",
            boxShadow: voiceTab === idx ? "0 1px 4px rgba(26,22,8,0.08)" : "none",
            transition:"all 0.2s ease",
            ...uvx(() => (voiceTab === idx ? { ...studioSurface.pressed(), borderRadius: STUDIO_TOKENS.button.radius, color: STUDIO_TOKENS.ink, fontSize: 16, fontWeight: 600 } : { background: 'transparent', boxShadow: 'none', color: STUDIO_TOKENS.muted, fontSize: 16, fontWeight: 400 })),
          }}>{label}</button>
        ))}
      </div>

      <div style={{ flex:1, overflowY:"auto", paddingBottom:83, overscrollBehavior:"contain" }}
        onTouchStart={voiceSwipe.onTouchStart} onTouchEnd={voiceSwipe.onTouchEnd}>

        {/* ═══ CAPTURE TAB — IDLE ═══ */}
        {voiceTab === 0 && !showRecording && (
          <>
            <div style={{ margin:"16px 16px 0", background:"rgba(255,252,242,0.88)", borderRadius:24, borderTop:"1px solid rgba(255,255,250,0.96)", padding:"28px 20px 24px", display:"flex", flexDirection:"column", alignItems:"center", ...uvx(() => ({ ...studioSurface.raised(), borderRadius: STUDIO_TOKENS.radius.card })) }}>
              {t.theme === 'uv' ? null : <p style={{ fontSize:10, fontWeight:700, textTransform:"uppercase", letterSpacing:1.4, color:"rgba(26,22,8,0.35)", marginBottom:10 }}>Voice Capture</p>}
              <p style={{ fontFamily:"Georgia, serif", fontStyle:"italic", fontSize:22, color:"#1A1608", marginBottom:6, textAlign:"center", lineHeight:1.2, ...uvx(() => ({ ...studioType.heading(), fontSize: 25 })) }}>Say what you see.</p>
              <p style={{ fontSize:12, color:"rgba(26,22,8,0.45)", textAlign:"center", marginBottom:28, lineHeight:1.6, maxWidth:280 }}>Observations, measurements and decisions as they happen.</p>

              <div style={{ position:"relative", width:100, height:100, display:"flex", alignItems:"center", justifyContent:"center", marginBottom:16 }}>
                <div style={{ position:"absolute", inset:0, borderRadius:"50%", border:"1px solid rgba(42,58,26,0.12)" }} />
                <div style={{ position:"absolute", inset:7, borderRadius:"50%", border:"1px solid rgba(42,58,26,0.25)" }} />
                <button onClick={startRecord} style={{ width:72, height:72, borderRadius:"50%", background:"linear-gradient(145deg, #2A3A1A 0%, #1C2A10 50%, #0E1A08 100%)", border:"none", cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", boxShadow:"0 6px 24px rgba(42,58,26,0.35),0 2px 8px rgba(42,58,26,0.18)", position:"relative", zIndex:2, ...uvx({ background: STUDIO_TOKENS.ultraviolet, boxShadow: STUDIO_TOKENS.button.ring }) }}>
                  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke={t.theme === 'uv' ? STUDIO_TOKENS.onPrimary : "rgba(255,255,255,0.92)"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" y1="19" x2="12" y2="23"/><line x1="8" y1="23" x2="16" y2="23"/>
                  </svg>
                </button>
              </div>
              <p style={{ fontSize:11, color:"rgba(26,22,8,0.38)", letterSpacing:.2 }}>Tap to record</p>
            </div>

          </>
        )}

        {/* ═══ CAPTURE TAB — RECORDING MODE (LOCKED gradient) ═══ */}
        {voiceTab === 0 && showRecording && (
          <div style={{ margin:"16px 16px 0", background:"linear-gradient(145deg, #5A1C14 0%, #321608 30%, #142008 65%, #0E1820 100%)", borderRadius:16, padding:"26px 20px 22px", display:"flex", flexDirection:"column", alignItems:"center", ...uvx(() => ({ background: STUDIO_TOKENS.jewel.fill, boxShadow: STUDIO_TOKENS.jewel.shadow, borderRadius: STUDIO_TOKENS.radius.card })) }}>
            <p style={{ fontFamily:"Georgia, serif", fontStyle:"italic", fontSize:20, color:"rgba(240,120,80,0.95)", marginBottom:22, letterSpacing:-.2, ...uvx(() => ({ ...studioType.heading(), color: STUDIO_TOKENS.jewel.text })) }}>Recording</p>

            <div style={{ display:"flex", gap:5, alignItems:"center", height:48, marginBottom:18, padding:"0 4px" }}>
              {[...Array(14)].map((_, i) => {
                const opacity = 0.65 + (i % 5) * 0.05;
                return (
                  <div key={i} style={{
                    width:5, borderRadius:3, transformOrigin:"center",
                    background:`rgba(220,100,70,${opacity})`,
                    height:"100%",
                    animation:`waveBar 0.7s ease-in-out ${(i * 0.05).toFixed(2)}s infinite alternate`,
                    ...uvx(() => ({ background: studioRgba(STUDIO_TOKENS.jewel.ring, opacity) })),
                  }} />
                );
              })}
            </div>

            <p style={{ fontSize:36, fontWeight:300, color:"#FFFFFF", letterSpacing:-1, marginBottom:4, fontVariantNumeric:"tabular-nums", lineHeight:1, ...uvx({ ...studioType.display(), fontSize: 84, lineHeight: 1, color: STUDIO_TOKENS.jewel.text }) }}>
              {fmtTime(recTime)}
            </p>
            <p style={{ fontSize:9, fontWeight:700, textTransform:"uppercase", letterSpacing:1.4, color:"rgba(240,240,232,0.4)", marginBottom:22, ...uvx({ color: STUDIO_TOKENS.jewel.textSecondary }) }}>Transcribing automatically</p>

            <button onClick={stopRecord} aria-label={t.theme === 'uv' ? 'Stop recording' : undefined} style={{ width:52, height:52, borderRadius:"50%", background:"rgba(210,90,60,0.22)", border:"1.5px solid rgba(210,90,60,0.5)", cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", marginBottom:14, ...uvx({ background: STUDIO_TOKENS.ultraviolet, border: `1.5px solid ${STUDIO_TOKENS.jewel.ring}`, boxShadow: STUDIO_TOKENS.button.ring, minHeight: 52 }) }}>
              <div style={{ width:18, height:18, borderRadius:3, background:"rgba(210,90,60,0.9)", ...uvx({ background: STUDIO_TOKENS.onPrimary }) }} />
            </button>

            <p style={{ fontSize:11, color:"rgba(240,240,232,0.28)", ...uvx({ color: STUDIO_TOKENS.jewel.textSecondary }) }}>{`${t.theme === 'uv' ? '' : '· '}Navigating away will not stop the recording.`}</p>
          </div>
        )}

        {/* ═══ NOTES TAB ═══ */}
        {voiceTab === 1 && (
          <>
            {saveError && (
              <div role="alert" style={{ margin:"14px 16px 0", background:"rgba(192,112,112,0.12)", border:"1px solid rgba(192,112,112,0.35)", borderRadius:12, padding:"12px 14px", display:"flex", alignItems:"flex-start", gap:10 }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#7A3A3A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink:0, marginTop:1 }}>
                  <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
                </svg>
                <div style={{ flex:1 }}>
                  <p style={{ fontSize:12, fontWeight:700, color:"#7A3A3A", marginBottom:2 }}>Storage warning</p>
                  <p style={{ fontSize:12, color:"#7A3A3A", lineHeight:1.4 }}>{saveError}</p>
                </div>
                <button onClick={() => setSaveError(null)} aria-label="Dismiss" style={{ background:"transparent", border:"none", color:"#7A3A3A", cursor:"pointer", fontSize:18, lineHeight:1, padding:"0 2px", fontFamily:"inherit", minWidth:44, minHeight:44 }}>×</button>
              </div>
            )}
            <div style={{ margin:"18px 16px 8px", display:"flex", alignItems:"center", justifyContent:"space-between" }}>
              <p style={{ fontSize:10, fontWeight:700, textTransform:"uppercase", letterSpacing:1.4, color:"#8A7A5A", ...uvx(() => studioType.heading()) }}>Recent</p>
              <p style={{ fontSize:11, color:"#8A7A5A" }}>{notes.length} note{notes.length !== 1 ? "s" : ""}</p>
            </div>

            {notes.length === 0 && (
              <div style={{ margin:"0 16px", background:"rgba(255,252,242,0.6)", borderRadius:14, padding:"28px 16px", textAlign:"center" }}>
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="rgba(42,58,26,0.25)" strokeWidth="1.5" strokeLinecap="round" style={{ margin:"0 auto 10px", display:"block" }}>
                  <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
                </svg>
                <p style={{ fontSize:13, fontWeight:500, color:"#8A7A5A", marginBottom:4 }}>No notes yet</p>
                <p style={{ fontSize:11, color:"#AAA090" }}>Recordings appear here after transcription.</p>
              </div>
            )}

            {notes.map(note => {
              const pill = getPill(note.context);
              const isPlaying = playingId === note.id;
              const isDone = note.transcriptionStatus === 'done';
              const isFailed = note.transcriptionStatus === 'failed';
              const isTranscribing = note.transcriptionStatus === 'transcribing';
              const isPending = !isDone && !isFailed && !isTranscribing;
              const ts = note.recordedAt ? new Date(note.recordedAt).toLocaleTimeString("en-GB", { hour:"2-digit", minute:"2-digit" }) : "";
              const noteWave = getWaveHeights(note.id);
              const projName = (() => { if (!note.projectId) return null; try { const allP = JSON.parse(localStorage.getItem(`asg_projects_${currentUser?.id}`) || '[]'); const p = allP.find(pp => pp.id === note.projectId); return p ? p.name : null; } catch(e) { return null; } })();
              return (
                <SwipeableCard key={note.id} onDelete={() => deleteNote(note.id)} style={{ margin:"0 16px" }}>
                  <div style={{ background:"rgba(255,252,242,0.88)", borderTop:"1.5px solid rgba(255,255,250,0.96)", borderRadius:14, padding:"12px 14px", overflow:"hidden", ...uvx(() => ({ ...studioSurface.slip(), borderRadius: STUDIO_TOKENS.radius.card })) }}>
                    {/* S95 D10 — zone label appears above the pill row when the note is scoped to a zone */}
                    {note.zone && (
                      <div style={{ fontSize:10, fontWeight:700, textTransform:"uppercase", letterSpacing:0.8, color:"#3A5A2A", marginBottom:6 }}>
                        {/* S1 (reviewer FLAG-07) — '__project__' is an internal
                            key. Site-wide recordings now carry it so adoption can
                            place them, so it must never reach the user as-is. */}
                        {`Note${studioSep()}`}{note.zone === '__project__' ? 'Site-wide' : note.zone}
                      </div>
                    )}
                    {/* Row 1: context chip, duration, time, portal status */}
                    <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:8 }}>
                      <span style={{ fontSize:10, fontWeight:600, borderRadius:6, padding:"2px 8px", background:pill.bg, border:`0.5px solid ${pill.border}`, color:pill.color, flexShrink:0 }}>{ctxLabel(note.context)}</span>
                      {note.duration > 0 && (
                        <span style={{ fontFamily:"system-ui, -apple-system, sans-serif", fontSize:11, color:"#8A7A5A" }}>{fmtTime(note.duration)}</span>
                      )}
                      <span style={{ flex:1 }} />
                      {voiceAudioState(note) && <span style={{ fontSize:11, color:"#8A7A5A" }}>{'audio ' + voiceAudioState(note)}</span>}
                      <span style={{ fontSize:11, color:"#8A7A5A" }}>{ts}</span>
                      {note.portalSynced && (
                        <span style={{ display:"inline-flex", alignItems:"center", gap:3, flexShrink:0 }}>
                          <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke={t.theme === 'uv' ? STUDIO_TOKENS.ink : "#2E6838"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"/></svg>
                          <span style={{ fontSize:9, color:"#2E6838" }}>Synced</span>
                        </span>
                      )}
                    </div>

                    {/* Row 2: waveform thumbnail */}
                    <div onClick={() => playNote(note)} style={{ display:"flex", gap:2, alignItems:"flex-end", height:16, cursor:"pointer", marginBottom:8 }}>
                      {noteWave.map((h, i) => (
                        <div key={i} style={{ width:3, flex:1, height:`${h}%`, borderRadius:1.5, background: isPlaying ? "rgba(200,144,48,0.5)" : "rgba(42,58,26,0.2)", transition:"background 0.3s", ...uvx(() => ({ background: isPlaying ? STUDIO_TOKENS.lampAmber : studioInk(0.25) })) }} />
                      ))}
                    </div>

                    {/* Row 3: transcript or pending state */}
                    {isDone && (
                      <p style={{ fontSize:12, color:"#1A1608", lineHeight:1.45, marginBottom:8, display:"-webkit-box", WebkitLineClamp:3, WebkitBoxOrient:"vertical", overflow:"hidden" }}>{note.transcript}</p>
                    )}
                    {(isPending || isTranscribing) && (
                      <p style={{ fontSize:11, color:"#8A7A5A", fontStyle:"italic", marginBottom:8, animation: isTranscribing ? "vnPulse 2s ease-in-out infinite" : "none" }}>
                        {isTranscribing ? "Transcribing\u2026" : `Saved${studioSep()}tap waveform to play`}
                      </p>
                    )}
                    {isFailed && (
                      <div style={{ marginBottom:8 }}>
                        <span style={{ fontSize:11, color:"#8A7A5A" }}>Transcription failed</span>
                        {" "}
                        {/* §9 (reviewer finding 6) — a user-initiated retry resets
                            transcribeAttempts. The cap exists to stop the AUTOMATIC
                            retry re-uploading dead audio on every foreground; it must
                            never turn an explicit tap into a silent no-op. */}
                        <span onClick={() => { updateNoteInStorage(note.id, { transcriptionStatus: 'pending', transcribeAttempts: 0 }); setNotes(loadNotes()); transcribeNote({ ...note, transcriptionStatus: 'pending' }); }}
                          style={{ fontSize:11, color:"#C89030", cursor:"pointer", fontWeight:600, ...uvx(() => ({ ...studioType.action(), fontSize: 14 })) }}>{t.theme === 'uv' ? 'Retry' : 'Retry \\u2192'}</span>
                      </div>
                    )}

                    {/* Row 4: action buttons (only when transcript exists) */}
                    {isDone && (
                      <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
                        <button onClick={() => { const sub = encodeURIComponent(`Voice note \u2014 ${ctxLabel(note.context)}`); const bod = encodeURIComponent(`Context: ${ctxLabel(note.context)}\nRecorded: ${ts}\n\n${note.transcript}`); window.open(`mailto:?subject=${sub}&body=${bod}`); }}
                          style={{ background:"transparent", border:"0.5px solid rgba(42,58,26,0.18)", borderRadius:7, padding:"4px 10px", fontSize:11, color:"#8A7A5A", cursor:"pointer", fontFamily:"inherit", display:"inline-flex", alignItems:"center", gap:4 }}>
                          Email to desk
                        </button>
                        <button onClick={() => { if (navigator.clipboard) navigator.clipboard.writeText(note.transcript); }}
                          style={{ background:"transparent", border:"0.5px solid rgba(42,58,26,0.18)", borderRadius:7, padding:"4px 10px", fontSize:11, color:"#8A7A5A", cursor:"pointer", fontFamily:"inherit", display:"inline-flex", alignItems:"center", gap:4 }}>
                          Copy text
                        </button>
                      </div>
                    )}

                    {/* Project link chip */}
                    {projName && (
                      <div onClick={() => onNav(18)} style={{ marginTop:8, display:"inline-flex", alignItems:"center", gap:4, background:"rgba(200,144,48,0.08)", border:"0.5px solid rgba(200,144,48,0.15)", borderRadius:6, padding:"2px 8px", cursor:"pointer" }}>
                        <span style={{ fontSize:10, color:"#8A6010" }}>{t.theme === 'uv' ? null : '\\ud83d\\udcc1 '}{projName}</span>
                      </div>
                    )}
                  </div>
                </SwipeableCard>
              );
            })}
          </>
        )}

      </div>

      <style>{`
        @keyframes waveBar     { 0%{transform:scaleY(0.12)} 100%{transform:scaleY(1)} }
        @keyframes recDotBlink { 0%,100%{opacity:1} 50%{opacity:0.15} }
        @keyframes vnPulse     { 0%,100%{opacity:1} 50%{opacity:0.4} }
      `}</style>
      <TabBar active={9} onChange={onNav} divisionId={div && div.id ? div.id : "lighting"} />
    </div>
  );
};

// ════════════════════════════════════════════════════
// SCREEN 10: SURVEY LANDING — Fork between Survey and Snag
// ════════════════════════════════════════════════════

// ── Jobs-list type distinction (Option B, jobs_list_type_distinction.html) ──
// Survey and snag jobs share the landing list. Type is carried by a coloured
// left spine + a filled icon badge (two distinct glyphs, so it never relies on
// colour alone) + a faint left-edge tint + a filled type chip. The hexes match
// the map / workspace PINS so the list, the workspace and the map all agree:
// survey green #2E6838, snag terracotta #C87848 (the sanctioned snag marker).
// UV-RESKIN-V1 track E: the colours are getters on the token object, so they
// follow the theme at render time (standard values unchanged).
const JOB_TYPE = {
  survey: { get color() { return t.colors.green; }, get tint() { return t.colors.green07; }, get chipBg() { return t.colors.jobChipSurvey; }, get glyph() { return t.colors.onFill; }, label: 'Survey' },
  snag:   { get color() { return t.colors.jobSnag; }, get tint() { return t.colors.terra08; }, get chipBg() { return t.colors.jobChipSnag; }, get glyph() { return t.colors.jobSnagGlyph; }, label: 'Snag' },
};
const _jobGlyph = (type) => type === 'snag'
  ? (<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3l9 16H3z"/><path d="M12 10v4M12 17h.01"/></svg>)
  : (<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="5" y="3" width="14" height="18" rx="2"/><path d="M9 8h6M9 12h6M9 16h3"/></svg>);
// COMPANION-STUDIO-V1 track 2: under the theme the job's STAGE is the light
// on the card (studioLit, a 3px edge from the left), so the spine is not
// drawn; the type keeps its glyph, pressed into the paper in ink, and its word
// in muted detail text, never a filled chip (FINDINGS T2-5).
const JobSpine = ({ type }) => (t.theme === 'uv' ? null : <span style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: 6, background: (JOB_TYPE[type] || JOB_TYPE.survey).color }} />);
const JobBadge = ({ type }) => { const c = JOB_TYPE[type] || JOB_TYPE.survey; if (t.theme === 'uv') return <div style={{ flexShrink: 0, width: 32, height: 32, borderRadius: 10, background: STUDIO_TOKENS.pressed.fill, boxShadow: STUDIO_TOKENS.shadow.pressed, color: STUDIO_TOKENS.ink, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{_jobGlyph(type)}</div>; return <div style={{ flexShrink: 0, width: 30, height: 30, borderRadius: 9, background: c.color, color: c.glyph, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{_jobGlyph(type)}</div>; };
const JobChip = ({ type }) => { const c = JOB_TYPE[type] || JOB_TYPE.survey; if (t.theme === 'uv') return <span style={{ fontSize: 14, color: STUDIO_TOKENS.muted, flexShrink: 0 }}>{c.label}</span>; return <span style={{ background: c.chipBg, color: t.colors.chipTextOnFill, border: 0, borderRadius: 20, padding: '2px 9px', fontSize: 10, fontWeight: 700, flexShrink: 0 }}>{c.label}</span>; };
// The light a job card carries under the theme (nothing with it off). Survey
// jobs: in progress or planned is Enquiry, submitted is Surveyed, unless the
// project carries a later stage of its own. Snags happen on won work.
const jobLit = (type, proj, submitted) => {
  if (t.theme !== 'uv') return {};
  if (type === 'snag') return studioLit('won');
  const own = studioStageOf(proj && proj.stage, null);
  const floor = submitted ? 'surveyed' : 'enquiry';
  const order = STUDIO_TOKENS.stageOrder;
  const stage = own && order.indexOf(own) > order.indexOf(floor) ? own : floor;
  return { border: 'none', borderTop: 'none', ...studioLit(stage) };
};
// UV-RESKIN-V1 track E: "matched or fine" is an ink tick and the word, no pill.
// Renders nothing with the theme off.
const UvTick = () => (t.theme === 'uv'
  ? <svg aria-hidden="true" width="10" height="10" viewBox="0 0 10 10" fill="none" style={{ marginRight: 4, verticalAlign: '-1px' }}><polyline points="2,5 4.2,7.5 8,2.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
  : null);
const jobCardBg = (type) =>`linear-gradient(90deg, ${(JOB_TYPE[type] || JOB_TYPE.survey).tint}, ${t.colors.glass} 62%)`;

// ==== STUDIO-LIT-PHONE-V1 item 7: the survey screens with the switch on ====
// On site (the survey's Start step), Areas, an area (fittings, photos and
// notes) and Check and send, drawn to the lit v5 prototype (#app/site, areas,
// zone, media, wrap). Everything here is survey data held on the phone
// (surveyZones, sitePhotos, zoneNotes, doneZones, deriveWrapSummary); nothing
// is worked out that the portal sends. Only ever rendered with t.theme 'uv'.
// The lit parts sit inside SvLit so studioShape's walker (which restyles the
// legacy markup) never reaches them: they are drawn from the lit tokens
// already, and the walker would ink Eva's light text on the jewel.
const SvLit = ({ draw }) => draw();
const SV_MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
// A time for Eva's read: HH:MM, with the date when it was not today
// (DECISIONS 176.136). null when the stamp is unusable.
const svWhen = (ts) => {
  if (ts == null || ts === '') return null;
  const d = new Date(ts);
  if (isNaN(d.getTime())) return null;
  const hhmm = d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
  const now = new Date();
  const same = d.getFullYear() === now.getFullYear() && d.getMonth() === now.getMonth() && d.getDate() === now.getDate();
  return same ? hhmm : `${d.getDate()} ${SV_MONTHS[d.getMonth()]}${d.getFullYear() === now.getFullYear() ? '' : ' ' + d.getFullYear()}, ${hhmm}`;
};
// "8 Sep" (with the year when not this year), or '' when unusable.
const svDay = (ts) => {
  if (!ts) return '';
  const d = new Date(ts);
  if (isNaN(d.getTime())) return '';
  return `${d.getDate()} ${SV_MONTHS[d.getMonth()]}${d.getFullYear() === new Date().getFullYear() ? '' : ' ' + d.getFullYear()}`;
};
// The town from a typed address: its last part ("4 Linden Court, Cardiff" is
// Cardiff). A one-part address is shown whole.
const svPlace = (address) => {
  const parts = String(address || '').split(',').map((s) => s.trim()).filter(Boolean);
  return parts.length ? parts[parts.length - 1] : '';
};
const svPlural = (n, one, many) => `${n} ${n === 1 ? one : (many || one + 's')}`;
// "A", "A and B", "A, B and C".
const svList = (xs) => (xs.length <= 1 ? (xs[0] || '') : xs.slice(0, -1).join(', ') + ' and ' + xs[xs.length - 1]);
// Survey facts for one project, from what the phone holds: areas in survey
// order (deriveWrapSummary), done, fittings and photos, and the area to carry
// on with (the first open area already started, else the first open one).
const svSurveyFacts = (proj) => {
  const p = proj || {};
  const w = deriveWrapSummary(p.surveyZones, p.customZones, p.doneZones);
  const photos = (Array.isArray(p.sitePhotos) ? p.sitePhotos : []).filter((ph) => ph && ph.type !== 'video');
  const photosIn = (z) => photos.filter((ph) => ph.zone && zoneKey(ph.zone) === zoneKey(z)).length;
  const open = w.zoneRows.filter((r) => !r.done);
  const started = open.find((r) => r.count > 0 || photosIn(r.zone) > 0);
  const current = started || open[0] || null;
  return { w, photos: photos.length, photosIn, open, current };
};
const SvGlyph = ({ size }) => (
  <svg width={size || 17} height={size || 17} viewBox="0 0 20 20" aria-hidden="true"><circle cx="10" cy="10" r="9" fill="none" stroke="currentColor" strokeWidth="1.4" strokeDasharray="1.2 1.6" /><circle cx="10" cy="10" r="4.5" fill="currentColor" /></svg>
);
// Eva's read on the jewel: her mark starts the sentence, her time ends the
// row, one light button for her offer. Never money on the jewel.
const SvEva = ({ read, ev, act, onAct, when }) => {
  const S = STUDIO_TOKENS;
  return (
    <section aria-label="Eva" style={{ position: 'relative', overflow: 'hidden', padding: '14px 14px 12px 16px', borderRadius: S.radius.card, background: S.jewel.fill, boxShadow: S.jewel.shadow, display: 'flex', flexDirection: 'column', gap: 6 }}>
      <span aria-hidden="true" style={{ position: 'absolute', right: -30, top: -34, width: 120, height: 120, borderRadius: '50%', background: `radial-gradient(circle, ${S.jewel.text}, ${studioRgba(S.ultraviolet, 0.45)} 30%, ${studioRgba(S.ultraviolet, 0)} 66%)`, opacity: 0.9, pointerEvents: 'none' }} />
      <p style={{ position: 'relative', margin: 0, paddingRight: 14, fontFamily: S.fonts.display, fontWeight: 300, fontSize: 20, lineHeight: 1.3, color: S.jewel.text }}>
        <span aria-hidden="true" style={{ display: 'inline-flex', verticalAlign: -2, marginRight: 8, color: S.jewel.ring }}><SvGlyph /></span>
        {read}
      </p>
      {ev ? <p style={{ position: 'relative', margin: 0, fontSize: 14, lineHeight: 1.42, color: S.jewel.textSecondary }}>{ev}</p> : null}
      <div style={{ position: 'relative', display: 'flex', alignItems: 'center', gap: 14, flexWrap: 'wrap', marginTop: 2 }}>
        {act ? <button onClick={onAct} style={{ minHeight: 44, padding: '0 15px', borderRadius: S.button.radius, border: 'none', background: S.jewel.text, color: S.violetText, fontFamily: 'inherit', fontSize: 16, fontWeight: 600, cursor: 'pointer' }}>{act}</button> : null}
        {when ? <span style={{ marginLeft: 'auto', fontSize: 13, color: S.jewel.textSecondary }}>{when}</span> : null}
      </div>
    </section>
  );
};
// Progress marks: one per area in survey order. Done is amber (progress, the
// current thing), the area you are in glows, the rest are hairline.
const SvMarks = ({ rows, cur, label, h }) => {
  const S = STUDIO_TOKENS; const M = STUDIO_MEANING;
  const list = Array.isArray(rows) ? rows : [];
  if (!list.length) return null;
  return (
    <div role="img" aria-label={label} style={{ display: 'grid', gridTemplateColumns: `repeat(${list.length}, minmax(0,1fr))`, gap: 4 }}>
      {list.map((r, i) => (
        <i key={i} style={{ display: 'block', height: h || 8, borderRadius: 3, background: r.done ? M.wonFill : (i === cur ? S.lampAmber : studioInk(0.1)), boxShadow: !r.done && i === cur ? `0 0 0 1.5px ${S.onPrimary}, 0 0 12px ${studioRgba(S.lampAmber, 0.95)}` : 'none' }} />
      ))}
    </div>
  );
};
// The survey's three steps: Start, Survey, Send.
const SvSteps = ({ cur }) => {
  const S = STUDIO_TOKENS; const M = STUDIO_MEANING;
  return (
    <ol aria-label="Survey steps" style={{ listStyle: 'none', margin: 0, padding: 0, display: 'flex', gap: 14, fontSize: 13, color: S.muted }}>
      {['Start', 'Survey', 'Send'].map((s, i) => (
        <li key={s} aria-current={i === cur ? 'step' : undefined} style={{ display: 'flex', alignItems: 'center', gap: 6, color: i === cur ? S.ink : S.muted, fontWeight: i === cur ? 700 : 400 }}>
          <i aria-hidden="true" style={{ display: 'block', width: i === cur ? 22 : 16, height: 4, borderRadius: 2, background: i < cur ? M.wonFill : i === cur ? S.lampAmber : studioInk(0.14), boxShadow: i === cur ? `0 0 8px ${studioRgba(S.lampAmber, 0.9)}` : 'none' }} />{s}
        </li>
      ))}
    </ol>
  );
};
const SvBack = ({ label, onClick, aria }) => (
  <button onClick={onClick} aria-label={aria} style={{ minHeight: 44, display: 'inline-flex', alignItems: 'center', gap: 4, padding: '0 6px 0 0', marginLeft: -6, border: 'none', background: 'none', cursor: 'pointer', fontFamily: 'inherit', fontSize: 16, fontWeight: 600, color: STUDIO_TOKENS.ink }}>
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7" /></svg>{label}
  </button>
);
// Type and links on these screens.
const svH1 = () => ({ ...studioType.title(), fontSize: 39, lineHeight: 1.04 });
const svH2 = () => ({ ...studioType.heading(), fontSize: 20, margin: 0 });
const svLink = () => ({ ...studioType.action(), minHeight: 44, display: 'inline-flex', alignItems: 'center', cursor: 'pointer', fontFamily: 'inherit', alignSelf: 'flex-start' });
const svGhost = () => ({ ...studioSurface.pressed(), color: STUDIO_TOKENS.ink, borderRadius: STUDIO_TOKENS.button.radius, minHeight: 52, fontFamily: 'inherit', fontSize: 16, fontWeight: 600, cursor: 'pointer', padding: '0 14px' });
const svMain = () => ({ ...studioSurface.primary(), minHeight: 52, fontFamily: 'inherit', cursor: 'pointer', padding: '0 14px' });
// The two doors on On site, drawn (no images): a survey board, and a snag.
const SvDoorPic = ({ kind }) => {
  const S = STUDIO_TOKENS; const ink = S.ink;
  if (kind === 'survey') return (
    <svg viewBox="0 0 120 70" aria-hidden="true" style={{ width: '100%', height: 'auto', marginBottom: 2 }}><rect x="10" y="12" width="64" height="46" rx="3" fill="none" stroke={ink} strokeWidth="1.6" /><path d="M10 30h64M42 12v46" stroke={ink} strokeWidth="1.2" opacity=".5" /><circle cx="26" cy="21" r="3.2" fill={S.lampAmber} style={{ filter: `drop-shadow(0 0 4px ${studioRgba(S.lampAmber, 0.9)})` }} /><circle cx="58" cy="21" r="3.2" fill={ink} opacity=".35" /><circle cx="26" cy="44" r="3.2" fill={ink} opacity=".35" /><rect x="82" y="16" width="26" height="40" rx="5" fill={S.onPrimary} stroke={ink} strokeWidth="1.6" /><rect x="86" y="22" width="18" height="13" rx="2" fill={studioInk(0.14)} /><path d="M87 41h16M87 46h11" stroke={ink} strokeWidth="1.4" strokeLinecap="round" /></svg>
  );
  const rust = STUDIO_MEANING.rustFill;
  return (
    <svg viewBox="0 0 120 70" aria-hidden="true" style={{ width: '100%', height: 'auto', marginBottom: 2 }}><rect x="12" y="10" width="44" height="50" rx="4" fill={S.onPrimary} stroke={ink} strokeWidth="1.6" /><path d="M20 22h28M20 32h28M20 42h18" stroke={ink} strokeWidth="1.4" strokeLinecap="round" opacity=".5" /><circle cx="76" cy="34" r="16" fill="none" stroke={rust} strokeWidth="2.2" /><path d="M76 25v11" stroke={rust} strokeWidth="2.6" strokeLinecap="round" /><circle cx="76" cy="42" r="1.8" fill={rust} /><rect x="96" y="20" width="16" height="28" rx="4" fill="none" stroke={ink} strokeWidth="1.6" /></svg>
  );
};
// SEND-STATE-V1: one job's send state, drawn lit (Check and send and the job
// front page). The words come from sendStateWords, so every screen says the
// same. `act` overrides the action word (Check and send says Try again right
// after a refused send); `note` is the answer to the last try; `alert` makes a
// refusal read out at once.
const SvSendState = ({ st, onAct, act, note, alert, extra }) => {
  const S = STUDIO_TOKENS; const M = STUDIO_MEANING;
  const w = sendStateWords(st);
  const word = act || w.act;
  const failed = st && st.state === 'failed';
  const tone = failed ? M.rustText : (st && st.state === 'sent' ? M.wonText : S.ink);
  return (
    <section role={alert ? 'alert' : 'status'} aria-label={w.title} data-send-state={(st && st.state) || 'not_sent'} style={{ ...studioSurface.slip(), ...(failed ? { boxShadow:`${S.shadow.slip}, inset 0 0 0 2px ${studioRgba(M.rustFill, 0.55)}` } : {}), borderRadius:14, padding:'14px 16px', display:'flex', flexDirection:'column', gap:8 }}>
      <p style={{ margin:0, fontSize:16, fontWeight:700, color:tone }}>{w.title}</p>
      <p style={{ margin:0, fontSize:14, lineHeight:1.4, color:S.ink }}>{w.line}</p>
      {extra || null}
      {note ? <p style={{ margin:0, fontSize:14, lineHeight:1.4, color:S.muted }}>{note}</p> : null}
      {word && onAct ? <button onClick={onAct} style={{ ...svMain(), width:'100%', minHeight:52, fontSize:16, borderRadius:14 }}>{word}</button> : null}
    </section>
  );
};
// ==== STUDIO-LIT-PHONE-V1 item 7 helpers end ====

const SurveyLandingScreen = ({ onBack, onNav, currentUser, projects, onOpenProject, onCreateProject, onDeleteProject }) => {
  const div = getDivisionConfig(currentUser);

  // Follow-up fix 1:refresh the CANONICAL portal survey list when the Survey
  // tab opens, so the device shows what it created/submitted even if its local
  // side cache fell out of step. syncPortalData refreshes lumen_surveys_portal
  // and fires lumenDataSync (re-hydrate + re-render). Guarded; no-op offline.
  React.useEffect(() => {
    try { if (typeof syncPortalData === 'function') syncPortalData(); } catch (e) {}
  }, []);

  const allProjects = projects || [];

  // S99 — single source of truth for survey state. Every list filter
  // goes through getSurveyState(p); no direct reads of stage,
  // surveyWrapCompletedAt, survey_queue.status, or lumen_visits.status
  // for state classification. Compute once per render.
  const _projState = new Map();
  for (const p of allProjects) _projState.set(p.id, getSurveyState(p));

  // S100 — tombstone set so a deleted survey can't be reflated by a
  // stale portal sync write into lumen_surveys_portal. Read once per
  // render; deleteSurvey() updates the underlying localStorage.
  const _deletedIds = getDeletedSurveyIds();
  const _deletedSnagIds = getDeletedSnagIds();

  const activeSurveys = allProjects.filter(p =>
    _projState.get(p.id) === 'live' && !_deletedIds.has(p.id)
  );

  const activeSnags = JSON.parse(localStorage.getItem('lumen_snags') || '[]')
    .filter(s => s.status === 'in-progress' && !_deletedSnagIds.has(s.id));

  // S100 — recentSurveys was capped at 3; lift the cap so month-grouped
  // accordion renders the full submitted history. Sort newest first.
  const recentSurveys = allProjects
    .filter(p => _projState.get(p.id) === 'submitted' && !_deletedIds.has(p.id))
    .sort((a, b) => new Date(b.surveyWrapCompletedAt) - new Date(a.surveyWrapCompletedAt));

  const recentSnags = JSON.parse(localStorage.getItem('lumen_snags') || '[]')
    .filter(s => s.status === 'submitted' && !_deletedSnagIds.has(s.id))
    .sort((a,b) => new Date(b.submittedAt) - new Date(a.submittedAt))
    .slice(0, 3);

  // Merge portal surveys with local (portal is source of truth, dedupe by id).
  // S100 — also drop any portal entry whose id matches a tombstone, so a
  // re-sync that re-includes a deleted row doesn't resurrect it.
  const portalSurveysData = getPortalData('lumen_surveys_portal', { surveys: [] });
  const portalSurveys = (portalSurveysData.surveys || []).filter(s => !_deletedIds.has(s.id));
  // Dedupe extracted to the pure mergeRecentSurveys helper (node:test-locked):
  // echoes are deduped by BOTH the local id and the canonical _portalSurveyId.
  const mergedRecentSurveys = mergeRecentSurveys(recentSurveys, portalSurveys);

  // queuePlanned: projects in 'planned' state, minus anything already
  // surfaced in active or recent (id- or name-deduped). No survey_queue
  // / lumen_visits reads — state comes from the project itself.
  const _activeIds = new Set([
    ...activeSurveys.map(p => p.id),
    ...mergedRecentSurveys.map(p => p.id),
  ]);
  const _activeNames = new Set([
    ...activeSurveys.map(p => (p.name || '').toLowerCase().trim()),
    ...mergedRecentSurveys.map(p => (p.name || p.project_name || '').toLowerCase().trim()),
  ].filter(Boolean));
  const queuePlanned = allProjects.filter(p =>
    _projState.get(p.id) === 'planned' &&
    !_deletedIds.has(p.id) &&
    !_activeIds.has(p.id) &&
    !_activeNames.has((p.name || '').toLowerCase().trim())
  );

  // S101 — month-accordion state, three-valued.
  // Map<sectionKey, 'expanded'|'collapsed'>. Only populated for months
  // the user has explicitly toggled. Untouched months fall back to
  // idx === 0 ? 'expanded' : 'collapsed' so newly-added months
  // "Just Work" without seeding state.
  //
  // S100 originally used a Set<sectionKey> of "explicitly collapsed"
  // ids and defaulted older months to collapsed when absent. The two
  // collapsed-states (default vs explicit) collapsed (no pun) into
  // one bucket — adding an older month's key on tap left it still
  // reading as "collapsed" on the next render, so taps were no-ops
  // for every month except the most recent.
  const [monthState, setMonthState] = useState(() => new Map());
  const isMonthExpanded = (sectionMonthKey, idx) => {
    if (monthState.has(sectionMonthKey)) {
      return monthState.get(sectionMonthKey) === 'expanded';
    }
    return idx === 0;
  };
  const toggleMonth = (sectionMonthKey, idx) => {
    const wasExpanded = isMonthExpanded(sectionMonthKey, idx);
    setMonthState(prev => {
      const next = new Map(prev);
      next.set(sectionMonthKey, wasExpanded ? 'collapsed' : 'expanded');
      return next;
    });
  };

  // Recently Submitted groups EVERYTHING submitted that month — surveys AND
  // snags — into one set of month buckets, so a submitted snag files into its
  // submission month rather than dangling below the months. Each entry is
  // wrapped with its type (_jt) and submission date (_jd); the renderer reuses
  // the PR #12 Option B survey/snag cards. (In Progress grouping is unchanged.)
  const _submittedItems = [
    ...mergedRecentSurveys.map(p => ({ _jt: 'survey', _jd: p.surveyWrapCompletedAt || p.submitted_at || p.submittedAt, item: p })),
    ...recentSnags.map(s => ({ _jt: 'snag', _jd: s.submittedAt, item: s })),
  ];
  const submittedMonthGroups = groupByMonth(_submittedItems, x => x._jd);
  const groupActiveByMonth = activeSurveys.length >= 3;
  const activeMonthGroups = groupActiveByMonth
    ? groupByMonth(
        activeSurveys,
        p => p.updatedAt || p.createdAt || p.surveyWrapCompletedAt
      )
    : null;

  // Month-group header — a CALM NEUTRAL row, shared by BOTH the In Progress and
  // Recently Submitted accordions. The month is a grouping, not a job type, so
  // it must not wear the survey green; colour on this screen belongs only to the
  // card type spines/badges. (Replaces the old solid-green shelf, which read as
  // jarring structural colour against the typed cards.) Mock:
  // recently_submitted_grouping.html. The count shows the mix and omits a zero
  // type. An open row squares its bottom corners to connect to the group box.
  const renderMonthGroupHeader = (group, sectionKey, expanded, idx, surveyN, snagN) => {
    const parts = [];
    if (surveyN) parts.push(surveyN + ' survey' + (surveyN === 1 ? '' : 's'));
    if (snagN) parts.push(snagN + ' snag' + (snagN === 1 ? '' : 's'));
    return (
      <button key={sectionKey + '__hdr'}
        onClick={() => toggleMonth(sectionKey, idx)}
        aria-expanded={expanded ? 'true' : 'false'}
        style={{
          width: '100%', display: 'flex', alignItems: 'center', gap: 8,
          padding: '12px 15px',
          background: expanded ? t.colors.monthOpen : t.colors.monthClosed,
          border: `1px solid ${t.colors.lineSand}`,
          borderRadius: expanded ? '11px 11px 0 0' : 11,
          cursor: 'pointer', fontFamily: 'inherit', textAlign: 'left',
        }}>
        <span style={{ fontFamily: t.font.serif, fontStyle: t.font.italic, fontWeight: 600, fontSize: 16, lineHeight: 1.15, color: t.colors.text }}>{group.label}</span>
        <span style={{ fontSize: 12.5, color: t.colors.taupe }}>{t.theme === 'uv' ? parts.join(', ') : <>· {parts.join(' · ')}</>}</span>
        <span style={{ flex: 1 }} />
        <svg width="12" height="12" viewBox="0 0 14 14" fill="none"
          style={{ transition: 'transform 0.2s ease', transform: expanded ? 'rotate(0deg)' : 'rotate(-90deg)', flexShrink: 0 }}>
          <polyline points="3.5,6 7,9.5 10.5,6" stroke={t.colors.chevron} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
        </svg>
      </button>
    );
  };

  // S99 mount-time reconciliation — clean up orphan queue / visit rows
  // whose corresponding project is actually submitted. Idempotent.
  // Catches phantoms left behind by the pre-S99 persist() stage flip
  // and any ID-mismatch between visits and projects.
  useEffect(() => {
    try {
      const submittedIds = new Set();
      const submittedNames = new Set();
      for (const p of allProjects) {
        if (getSurveyState(p) === 'submitted') {
          if (p.id) submittedIds.add(p.id);
          const nm = (p.name || '').toLowerCase().trim();
          if (nm) submittedNames.add(nm);
        }
      }
      try {
        const sq = JSON.parse(localStorage.getItem('survey_queue') || '[]');
        let changed = false;
        for (const r of sq) {
          if (r.status === 'submitted') continue;
          const nm = (r.name || '').toLowerCase().trim();
          if ((r.id && submittedIds.has(r.id)) || (nm && submittedNames.has(nm))) {
            r.status = 'submitted';
            changed = true;
          }
        }
        if (changed) localStorage.setItem('survey_queue', JSON.stringify(sq));
      } catch (e) {}
      try {
        const tv = JSON.parse(localStorage.getItem('lumen_visits') || '[]');
        let changed = false;
        for (const v of tv) {
          if (v.status === 'submitted') continue;
          const nm = ((v.projectName || v.name) || '').toLowerCase().trim();
          if ((v.surveyId && submittedIds.has(v.surveyId)) || (nm && submittedNames.has(nm))) {
            v.status = 'submitted';
            changed = true;
          }
        }
        if (changed) localStorage.setItem('lumen_visits', JSON.stringify(tv));
      } catch (e) {}
    } catch (e) {}
    // Mount-only: re-running on every projects change would fight other
    // pending writes (e.g. an in-flight wrap submit). One pass is enough.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const statusChipStyle = (status) => {
    if (status === 'planned') return { background:t.colors.chipPlannedBg, color:t.colors.chipGoldText2 };
    if (status === 'live') return { background:t.colors.green1, color:t.colors.green };
    if (status === 'wrap') return { background:t.colors.green1, color:t.colors.green };
    return { background:t.colors.olive06, color:t.colors.khaki };
  };

  // Lookup visits for date display on survey cards
  const allVisits = (() => { try { return JSON.parse(localStorage.getItem('lumen_visits') || '[]'); } catch(e) { return []; } })();

  // S135 (4.5) — reconcile Today vs Survey. Survey-type visits scheduled from
  // Today write lumen_visits / survey_queue rows but NO project until "Start
  // survey", so Today showed them and this screen did not — the two lists
  // disagreed. Surface those orphan PLANNED visits here using the EXACT id /
  // lower-cased-name keys already used for dedup (no fuzzy matching). A row
  // matching an existing project (any state) or a tombstone is excluded; a
  // no-match simply doesn't appear and the existing empty state stands.
  const _knownProjIds = new Set(allProjects.map(p => p.id));
  const _knownProjNames = new Set(allProjects.map(p => (p.name || '').toLowerCase().trim()).filter(Boolean));
  const plannedVisitOrphans = (() => {
    const out = []; const seen = new Set();
    let sq = [];
    try { sq = JSON.parse(localStorage.getItem('survey_queue') || '[]'); } catch (e) {}
    const candidates = [
      ...allVisits
        .filter(v => v && v.surveyId && (v.status || 'planned') === 'planned')
        .map(v => ({ id: v.surveyId, name: v.projectName || v.name || '', contact: v.contact || v.contactName || '' })),
      ...sq
        .filter(q => q && q.id && (q.status || 'planned') === 'planned')
        .map(q => ({ id: q.id, name: q.name || q.projectName || '', contact: q.contact || '' })),
    ];
    for (const c of candidates) {
      const nameKey = (c.name || '').toLowerCase().trim();
      if (!c.id && !nameKey) continue;
      if (_deletedIds.has(c.id)) continue;
      if (_knownProjIds.has(c.id)) continue;            // already a project (any state)
      if (nameKey && _knownProjNames.has(nameKey)) continue;
      const dedupeKey = c.id || nameKey;
      if (seen.has(dedupeKey)) continue;
      seen.add(dedupeKey);
      out.push(c);
    }
    return out;
  })();

  const hasActive = activeSurveys.length + activeSnags.length + queuePlanned.length + plannedVisitOrphans.length > 0;
  const hasRecent = mergedRecentSurveys.length + recentSnags.length > 0;

  // STUDIO-LIT-PHONE-V1 item 7: On site with the switch on (#app/site). The
  // same lists as above (active, planned, snags, recently sent), drawn lit.
  // With the switch off nothing below runs.
  const [svShowAllSent, setSvShowAllSent] = useState(false);
  // SEND-STATE-V1: each job's send state, re-read when it can change.
  useSendStateTick();
  if (t.theme === 'uv') {
    const S = STUDIO_TOKENS; const M = STUDIO_MEANING;
    const byRecent = (a, b) => new Date(b.updatedAt || b.createdAt || 0) - new Date(a.updatedAt || a.createdAt || 0);
    // SEND-STATE-V1: a survey waiting to send (or parked, or going now) is
    // not one to carry on: it has its own rows with its state and Try now.
    // The row still opens the job (it stays editable, as before). A survey
    // the queue delivered that the job does not yet carry as sent is listed
    // under Recently sent, never under Waiting to send.
    const liveAll = activeSurveys.slice().sort(byRecent);
    const sendStOf = new Map(liveAll.concat(recentSurveys).map((p) => [p.id, readSendState(p)]));
    const resent = recentSurveys.filter((p) => sendStateBlocksSend(sendStOf.get(p.id)));
    const waitingJobs = liveAll.filter((p) => sendStateBlocksSend(sendStOf.get(p.id))).concat(resent.slice().sort(byRecent));
    const deliveredJobs = liveAll.filter((p) => (sendStOf.get(p.id) || {}).state === 'sent');
    const deliveredAt = new Map(deliveredJobs.map((p) => [p.id, sendStOf.get(p.id).at || null]));
    const sentAt = (p) => p.surveyWrapCompletedAt || deliveredAt.get(p.id) || p.submitted_at || 0;
    const live = liveAll.filter((p) => !sendStateBlocksSend(sendStOf.get(p.id)) && (sendStOf.get(p.id) || {}).state !== 'sent');
    const waitingRows = waitingJobs.map((p) => {
      const st = sendStOf.get(p.id); const w = sendStateWords(st);
      const act = () => {
        if (sendStateNeedsWrap(st)) { if (onOpenProject) onOpenProject(p); onNav(11); return; }
        sendQueuedNow(p);
      };
      return (
        <div key={'send-' + p.id} data-send-state={st.state} role="group" aria-label={`${p.name}: ${w.title}`} style={{ ...studioSurface.slip(), ...(st.state === 'failed' ? { boxShadow:`${S.shadow.slip}, inset 0 0 0 2px ${studioRgba(M.rustFill, 0.55)}` } : {}), borderRadius: 16, padding: '10px 14px', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 2 }}>
          <button onClick={() => { if (onOpenProject) onOpenProject(p); }} aria-label={`Open ${p.name}`} style={{ background: 'none', border: 'none', padding: 0, margin: 0, minHeight: 44, width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 2, textAlign: 'left', cursor: 'pointer', fontFamily: 'inherit' }}>
            <b style={{ fontSize: 16, fontWeight: 600, color: S.ink }}>{p.name}</b>
            <span style={{ fontSize: 14, lineHeight: 1.4, color: st.state === 'failed' ? M.rustText : S.muted }}>{w.title}. {w.short}</span>
          </button>
          {w.act ? <button onClick={act} style={{ ...svLink(), fontSize: 16 }}>{w.act}</button> : null}
        </div>
      );
    });
    const carry = live[0] || null;
    const cf = carry ? svSurveyFacts(carry) : null;
    const firstName = String((currentUser && currentUser.name) || '').trim().split(/\s+/)[0] || '';
    const initials = String((currentUser && currentUser.name) || '').trim().split(/\s+/).map((s) => s[0] || '').join('').slice(0, 2).toUpperCase();
    const hour = new Date().getHours();
    const hello = hour < 12 ? 'Morning' : hour < 18 ? 'Afternoon' : 'Evening';
    const deleteLive = (proj) => () => {
      deleteSurvey(proj.id, { userId: currentUser?.id, surveyState: 'live', projectName: proj.name });
      if (onDeleteProject) onDeleteProject(proj.id);
      window.dispatchEvent(new CustomEvent('lumenDataSync'));
    };
    // Eva's read: only facts this phone holds about the survey in progress.
    let eva = null;
    if (carry && cf.w.totalZoneCount > 0) {
      const openNames = cf.open.map((r) => r.zone);
      const read = openNames.length === 0
        ? `${hello}${firstName ? ', ' + firstName : ''}. Every area at ${carry.name} is done. It's ready to check and send.`
        : openNames.length <= 3
          ? `${hello}${firstName ? ', ' + firstName : ''}. Just ${svList(openNames)} left at ${carry.name}.`
          : `${hello}${firstName ? ', ' + firstName : ''}. ${openNames.length} areas left at ${carry.name}.`;
      eva = <SvEva read={read} act="Open the survey" onAct={() => { if (onOpenProject) onOpenProject(carry); }} when={svWhen(carry.updatedAt)} />;
    }
    const door = (kind, title, sub, onClick) => (
      <button onClick={onClick} style={{ ...studioSurface.raised(), borderRadius: 20, padding: '14px 14px 16px', display: 'flex', flexDirection: 'column', gap: 6, textAlign: 'left', cursor: 'pointer', fontFamily: 'inherit', minWidth: 0, minHeight: 44 }}>
        <SvDoorPic kind={kind} />
        <span style={{ fontFamily: S.fonts.display, fontWeight: 400, fontSize: 20, lineHeight: 1.1, color: S.ink }}>{title}</span>
        <span style={{ fontSize: 14, lineHeight: 1.38, color: S.muted }}>{sub}</span>
      </button>
    );
    const carryCard = carry ? (
      <LongPressCard onDelete={deleteLive(carry)} kebabAt="bottom" confirmText="Delete in-progress survey?" confirmSubtext="Removes this survey and any captured zones / photos from the companion. Cannot be undone.">
        <section role="button" tabIndex={0} aria-label={`Carry on with ${carry.name}`} onClick={() => { if (onOpenProject) onOpenProject(carry); }} style={{ ...studioSurface.lit(), borderRadius: S.radius.card, padding: '16px 16px 6px', display: 'flex', flexDirection: 'column', gap: 8, cursor: 'pointer', minHeight: 44 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', gap: 10 }}>
            <b style={{ fontSize: 20, fontWeight: 700, color: S.ink, minWidth: 0, overflowWrap: 'anywhere' }}>{carry.name}</b>
            {cf.w.totalZoneCount > 0 && <span style={{ fontSize: 16, color: S.muted, whiteSpace: 'nowrap' }}><span style={{ ...studioType.display(), fontSize: 49, lineHeight: 1 }}>{cf.w.doneCount}</span>/{cf.w.totalZoneCount}</span>}
          </div>
          <p style={{ margin: 0, fontSize: 14, lineHeight: 1.4, color: S.muted }}>
            {[svPlace(carry.address), carry.client ? `for ${carry.client}` : ''].filter(Boolean).join(', ')}{svPlace(carry.address) || carry.client ? '. ' : ''}{svPlural(cf.w.totalFixtures, 'fitting')}, {svPlural(cf.photos, 'photo')} so far.
          </p>
          <SvMarks rows={cf.w.zoneRows} cur={cf.current ? cf.w.zoneRows.indexOf(cf.current) : -1} label={`${cf.w.doneCount} of ${cf.w.totalZoneCount} areas done`} />
          <span style={{ ...svLink(), fontSize: 16 }}>{cf.current ? `Carry on with ${cf.current.zone}` : 'Carry on'}</span>
        </section>
      </LongPressCard>
    ) : null;
    // Anything else on the go: other surveys, planned visits, open snags.
    const row = (key, name, line, onClick, onDelete, confirmText, confirmSubtext) => {
      const body = (
        <button onClick={onClick} style={{ ...studioSurface.slip(), width: '100%', borderRadius: 16, minHeight: 56, padding: '10px 44px 10px 14px', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 2, textAlign: 'left', cursor: 'pointer', fontFamily: 'inherit' }}>
          <b style={{ fontSize: 16, fontWeight: 600, color: S.ink }}>{name}</b>
          {line ? <span style={{ fontSize: 14, color: S.muted }}>{line}</span> : null}
        </button>
      );
      return onDelete
        ? <LongPressCard key={key} onDelete={onDelete} style={{ marginBottom: 8 }} confirmText={confirmText} confirmSubtext={confirmSubtext}>{body}</LongPressCard>
        : <div key={key} style={{ marginBottom: 8 }}>{body}</div>;
    };
    const others = [
      ...live.slice(1).map((p) => { const f = svSurveyFacts(p); return row(p.id, p.name, `Survey, ${f.w.doneCount} of ${svPlural(f.w.totalZoneCount, 'area')} done`, () => { if (onOpenProject) onOpenProject(p); }, deleteLive(p), 'Delete in-progress survey?', 'Removes this survey and any captured zones / photos from the companion. Cannot be undone.'); }),
      ...activeSnags.map((s) => row(s.id, s.projectName, `Snag, ${svPlural((s.issues || []).length, 'issue')}`, () => onNav(13, { snagId: s.id }), () => { deleteSnag(s.id, { projectName: s.projectName, snagStatus: s.status || 'in-progress' }); window.dispatchEvent(new CustomEvent('lumenDataSync')); }, 'Delete snag?', 'Removes the snag and any captured issues from your companion. Cannot be undone.')),
      ...queuePlanned.map((p) => row(p.id, p.name, ['Planned', p.client || p.contact || ''].filter(Boolean).join(', '), () => { if (onOpenProject) onOpenProject(p); }, () => { deleteSurvey(p.id, { userId: currentUser?.id, surveyState: 'planned', projectName: p.name }); if (onDeleteProject) onDeleteProject(p.id); window.dispatchEvent(new CustomEvent('lumenDataSync')); }, 'Delete planned visit?', 'Removes the planned visit from your companion. The site visit can be re-scheduled from Today.')),
      ...plannedVisitOrphans.map((o) => row('orphan_' + (o.id || o.name), o.name || 'Planned survey', ['Planned', o.contact].filter(Boolean).join(', '), () => { try { localStorage.setItem('survey_prefill', JSON.stringify({ surveyId: o.id, visitName: o.name, contactName: o.contact })); } catch (e) {} onNav(2); }, () => { deleteSurvey(o.id, { userId: currentUser?.id, surveyState: 'planned', projectName: o.name }); window.dispatchEvent(new CustomEvent('lumenDataSync')); }, 'Delete planned visit?', 'Removes the planned visit from your companion. The site visit can be re-scheduled from Today.')),
    ];
    // Recently sent: the surveys this phone sent (and the portal's echoes),
    // newest first. A survey bound to a portal project shows that project's
    // quote from the served pipeline rows, matched by project id only.
    const pipe = getPortalData('lumen_pipeline', null);
    const servedRows = pipe ? [...(Array.isArray(pipe.quotes) ? pipe.quotes : []), ...(Array.isArray(pipe.all_quotes) ? pipe.all_quotes : [])] : [];
    const resentIds = new Set(resent.map((p) => p.id));
    const sentList = mergedRecentSurveys.filter((p) => !resentIds.has(p.id)).concat(deliveredJobs).sort((a, b) => new Date(sentAt(b)) - new Date(sentAt(a)));
    const sentShown = svShowAllSent ? sentList : sentList.slice(0, 4);
    const sentRow = (proj) => {
      const isPortalAuthority = !!proj._portalAuthority;
      const portalSurveyId = proj._portalSurveyId || (typeof proj.id === 'string' && proj.id.startsWith('portal_') ? proj.id.slice(7) : null);
      const open = () => {
        if (isPortalAuthority && portalSurveyId) {
          try { window.open(`${PORTAL_URL}/survey/view/${portalSurveyId}`, '_blank'); }
          catch (e) { try { location.href = `${PORTAL_URL}/survey/view/${portalSurveyId}`; } catch (_e) {} }
          return;
        }
        if (onOpenProject) onOpenProject(proj);
        onNav(3);
      };
      const hasLocal = Array.isArray(proj.surveyZones) && proj.surveyZones.length > 0;
      const f = hasLocal ? svSurveyFacts(proj) : null;
      const areasN = f ? f.w.totalZoneCount : (typeof proj.zone_count === 'number' ? proj.zone_count : null);
      const fitN = f ? f.w.totalFixtures : (typeof proj.fixture_count === 'number' && proj.fixture_count > 0 ? proj.fixture_count : null);
      const photoN = f ? f.photos : (typeof proj.photo_count === 'number' ? proj.photo_count : null);
      const facts = [areasN != null ? svPlural(areasN, 'area') : null, fitN != null ? svPlural(fitN, 'fitting') : null, photoN != null ? svPlural(photoN, 'photo') : null].filter(Boolean).join(', ');
      const day = svDay(sentAt(proj) || null);
      const b = getProjectBinding(proj);
      const q = b && b.project_id ? servedRows.find((r) => r && r.project_id != null && String(r.project_id) === String(b.project_id)) : null;
      const st = q ? studioQuoteStage(q) : null;
      const val = q ? truthNumber(q.total) : null;
      return (
        <LongPressCard key={proj.id} onDelete={() => { deleteSurvey(proj.id, { userId: currentUser?.id, surveyState: 'submitted', projectName: proj.name || proj.project_name }); if (onDeleteProject) onDeleteProject(proj.id); window.dispatchEvent(new CustomEvent('lumenDataSync')); }} kebabAt="bottom" style={{ marginBottom: 8 }}
          confirmText="Delete submitted survey?" confirmSubtext={isPortalAuthority ? 'This hides the portal-authority entry from your companion. The submitted record on the portal is unaffected.' : 'This will hide the survey from your companion. The submitted record on the portal is unaffected.'}>
          <button onClick={open} style={{ ...studioSurface.pressed(), width: '100%', borderRadius: 16, padding: '12px 14px 30px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12, textAlign: 'left', cursor: 'pointer', fontFamily: 'inherit', minHeight: 56 }}>
            <span style={{ display: 'flex', flexDirection: 'column', gap: 2, minWidth: 0 }}>
              <b style={{ fontSize: 16, fontWeight: 700, color: S.ink }}>{proj.name || proj.project_name}</b>
              <span style={{ fontSize: 14, lineHeight: 1.4, color: S.muted }}>{[day ? `Surveyed ${day}.` : '', facts ? facts + '.' : ''].filter(Boolean).join(' ')}</span>
            </span>
            {(val != null && val > 0) || st ? (
              <span style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 2, textAlign: 'right', flexShrink: 0 }}>
                {val != null && val > 0 ? <span style={{ fontFamily: S.fonts.display, fontWeight: 300, fontSize: 25, color: M.ochre, fontVariantNumeric: 'tabular-nums' }}>{formatCurrency(val)}</span> : null}
                {st ? <span style={{ fontSize: 14, color: st.c }}>{st.word}</span> : null}
              </span>
            ) : null}
          </button>
        </LongPressCard>
      );
    };
    const draw = () => (
      <div style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
        <div style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden', WebkitOverflowScrolling: 'touch', overscrollBehavior: 'contain', padding: '4px 16px 120px', display: 'grid', gridTemplateColumns: 'minmax(0,1fr)', gridAutoRows: 'max-content', alignContent: 'start', gap: 12 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, minHeight: 50 }}>
            <h1 style={{ ...svH1(), fontSize: 39 }}>On site</h1>
            {initials ? <span aria-label={currentUser && currentUser.name} style={{ width: 44, height: 44, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, fontWeight: 700, color: S.ink, ...studioSurface.slip(), flexShrink: 0 }}>{initials}</span> : null}
          </div>
          {eva}
          <div style={{ display: 'grid', gridTemplateColumns: 'minmax(0,1fr) minmax(0,1fr)', gap: 10 }}>
            {door('survey', 'Survey a site', 'Areas, fittings, photos and notes, in one place.', () => onNav(2))}
            {door('snag', 'Snag a job', 'Photograph each defect, give it an owner and send the list.', () => onNav(12))}
          </div>
          {waitingRows.length > 0 && (
            <section aria-label="Waiting to send" style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <h2 style={svH2()}>Waiting to send</h2>
              {waitingRows}
            </section>
          )}
          {carryCard}
          {others.length > 0 && <div>{others}</div>}
          {sentList.length > 0 && (
            <section aria-label="Recently sent" style={{ display: 'flex', flexDirection: 'column', paddingTop: 6 }}>
              <h2 style={{ ...svH2(), marginBottom: 8 }}>Recently sent</h2>
              {sentShown.map(sentRow)}
              {sentList.length > sentShown.length && <button onClick={() => setSvShowAllSent(true)} style={svLink()}>Show all {sentList.length}</button>}
            </section>
          )}
        </div>
        <TabBar active={10} onChange={onNav} divisionId={div && div.id ? div.id : 'lighting'} />
      </div>
    );
    return <SvLit draw={draw} />;
  }

  return studioShape(
    <div style={{ flex:1, overflowY:"auto", WebkitOverflowScrolling:"touch", overscrollBehavior:"contain", paddingBottom:100, background:t.colors.ground, display:"flex", flexDirection:"column" }}>
      <ScreenBlobs />
      <div style={{ flex:1, overflowY:"auto", overflowX:"hidden", WebkitOverflowScrolling:"touch", position:"relative", padding:"0 16px 100px", overscrollBehavior:"contain" }}>

        {/* Hero fork — two equal cards (no title above — aligns with Today hero) */}
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginTop:4, marginBottom:20 }}>
          {/* Start Survey */}
          <button onClick={() => onNav(2)} style={{ borderRadius:18, cursor:"pointer", border:"none", overflow:"hidden", padding:0, textAlign:"center", boxShadow:t.shadow.heroSurvey, ...uvx(() => ({ boxShadow:STUDIO_TOKENS.shadow.slip })) }}>
            <div style={{ padding:"18px 16px 14px", display:"flex", flexDirection:"column", alignItems:"center", gap:8, background:t.colors.heroSurveyGrad }}>
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke={t.colors.onFill} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="9" y="2" width="6" height="4" rx="1"/><path d="M9 2H7a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2h-2"/><path d="M12 11h4M12 15h4M8 11h.01M8 15h.01"/></svg>
              <span style={{ fontSize:15, fontWeight:800, color:t.colors.onFill }}>Start Survey</span>
            </div>
            <div style={{ background:t.colors.glass, borderTop:`1px solid ${t.colors.glassBorderTop}`, padding:"10px 16px 12px" }}>
              <span style={{ fontSize:11, color:t.colors.textSecondary }}>{['Start', 'Survey', 'Send'].join(studioSep(' · '))}</span>
            </div>
          </button>
          {/* Start Snag */}
          <button onClick={() => onNav(12)} style={{ borderRadius:18, cursor:"pointer", border:"none", overflow:"hidden", padding:0, textAlign:"center", boxShadow:t.shadow.heroSnag }}>
            <div style={{ padding:"18px 16px 14px", display:"flex", flexDirection:"column", alignItems:"center", gap:8, background:t.colors.heroSnagGrad }}>
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke={t.colors.heroSnagText} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg>
              <span style={{ fontSize:15, fontWeight:800, color:t.colors.heroSnagText }}>Start Snag</span>
            </div>
            <div style={{ background:t.colors.glass, borderTop:`1px solid ${t.colors.glassBorderTop}`, padding:"10px 16px 12px" }}>
              <span style={{ fontSize:11, color:t.colors.textSecondary }}>{['Issues', 'Photos', 'Review'].join(studioSep(' · '))}</span>
            </div>
          </button>
        </div>

        {/* Resume card removed (S82 Polish Fix 4: IN PROGRESS section is sufficient) */}

        {/* In progress zone */}
        {hasActive && (
          <>
            <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:10 }}>
              <div style={{ width:3, height:16, borderRadius:2, background:t.colors.green }} />
              <span style={{ fontSize:10, fontWeight:t.font.lw700, letterSpacing:t.font.ls15em, textTransform:"uppercase", color:t.colors.green }}>In progress</span>
            </div>
            {(() => {
              // S100 — render helper. Used both for the flat list (when
              // activeSurveys.length < 3) and inside each month-group
              // accordion section (when ≥ 3).
              const renderActiveCard = (proj) => {
                const zoneCount = (proj.customZones || []).length;
                const fixtureCount = (proj.surveyZones || []).reduce((s,z) => s + (z.qty || 1), 0);
                const deleteSurveyProj = () => {
                  deleteSurvey(proj.id, {
                    userId: currentUser?.id,
                    surveyState: 'live',
                    projectName: proj.name,
                  });
                  if (onDeleteProject) onDeleteProject(proj.id);
                  window.dispatchEvent(new CustomEvent('lumenDataSync'));
                };
                // FIX 3: find scheduled date from linked visit
                const linkedVisit = allVisits.find(v => v.surveyId === proj.id || v.projectName === proj.name);
                const visitDateStr = linkedVisit ? (linkedVisit.date || '').split('T')[0] : (proj.date || proj.scheduledDate || '').split('T')[0];
                const todayDateStr = new Date().toISOString().split('T')[0];
                const isFuture = visitDateStr && visitDateStr > todayDateStr;
                const formatFutureDate = (dateStr) => {
                  const d = new Date(dateStr + 'T00:00:00');
                  if (isNaN(d.getTime())) return '';
                  const now = new Date();
                  const diffDays = Math.round((d - new Date(now.getFullYear(), now.getMonth(), now.getDate())) / 86400000);
                  if (diffDays <= 7) {
                    return d.toLocaleDateString('en-GB', { weekday: 'long' });
                  }
                  return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
                };
                const futureDateLabel = isFuture ? formatFutureDate(visitDateStr) : '';
                return (
                  <LongPressCard key={proj.id} onDelete={deleteSurveyProj} style={{ marginBottom: 8 }}
                    confirmText="Delete in-progress survey?"
                    confirmSubtext="Removes this survey and any captured zones / photos from the companion. Cannot be undone.">
                    <div onClick={(e) => {
                      // Don't navigate if tapping the ⋮ zone (top-right 44x44)
                      const rect = e.currentTarget.getBoundingClientRect();
                      if (e.clientX > rect.right - 44 && e.clientY < rect.top + 44) return;
                      if (onOpenProject) onOpenProject(proj);
                    }} style={{ width:"100%", padding:"14px 16px", paddingRight: 36, background:jobCardBg('survey'), border:`1px solid ${t.colors.glassBorder}`, borderTop:`1px solid ${t.colors.glassBorderTop}`, borderRadius:t.radius.lg, overflow:"hidden", cursor:"pointer", textAlign:"left", display:"flex", alignItems:"center", gap:12, boxSizing:"border-box", position:"relative", zIndex:1, boxShadow:t.shadow.card, ...jobLit('survey', proj, false) }}>
                      <JobSpine type="survey" />
                      <JobBadge type="survey" />
                      <div style={{ flex:1, minWidth:0 }}>
                        <div style={{ fontSize:14, fontWeight:700, color:t.colors.text, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{proj.name}</div>
                        <div style={{ fontSize:11, color:t.colors.textSecondary, marginTop:2 }}>{proj.client || ""}</div>
                        {futureDateLabel && <div style={{ fontSize:12, color:t.colors.ink5, marginTop:3 }}>{futureDateLabel}</div>}
                        {/* SEND-STATE-V1: drawn only when the survey is waiting, failed or going. */}
                        {(() => { const _st = readSendState(proj); if (!sendStateBlocksSend(_st) && _st.state !== 'sent') return null; const _w = sendStateWords(_st); return <div data-send-state={_st.state} style={{ fontSize:12, fontWeight:700, color:t.colors.amberText, marginTop:3 }}>{_st.state === 'sent' ? _w.short : `${_w.title}. ${_w.short}`}</div>; })()}
                        <div style={{ display:"flex", gap:6, marginTop:6 }}>
                          <JobChip type="survey" />
                          {zoneCount > 0 && <span style={{ fontSize:10, color:t.colors.textTertiary }}>{zoneCount} zone{zoneCount!==1?"s":""}{studioSep()}{fixtureCount} fit.</span>}
                        </div>
                      </div>
                      <Icon name="chevron" size={16} color={t.colors.textTertiary} />
                    </div>
                  </LongPressCard>
                );
              };
              // Below the 3-row threshold: flat list. At/above: month-grouped
              // accordion (most-recent expanded by default, rest collapsed).
              if (!groupActiveByMonth) return activeSurveys.map(renderActiveCard);
              return activeMonthGroups.map((group, idx) => {
                const sectionKey = `active::${group.key}`;
                const expanded = isMonthExpanded(sectionKey, idx);
                return (
                  <div key={sectionKey} style={{ marginBottom: 11 }}>
                    {renderMonthGroupHeader(group, sectionKey, expanded, idx, group.items.length, 0)}
                    {expanded && (
                      <div style={{ border:`1px solid ${t.colors.lineSand}`, borderTop:0, borderRadius:'0 0 12px 12px', background:'rgba(255,255,255,0.35)', padding:'9px 9px 4px' }}>
                        {group.items.map(renderActiveCard)}
                      </div>
                    )}
                  </div>
                );
              });
            })()}
            {activeSnags.map(snag => {
              const issueCount = (snag.issues || []).length;
              const deleteThisSnag = () => {
                deleteSnag(snag.id, {
                  projectName: snag.projectName,
                  snagStatus: snag.status || 'in-progress',
                });
                window.dispatchEvent(new CustomEvent('lumenDataSync'));
              };
              return (
                <LongPressCard key={snag.id} onDelete={deleteThisSnag} style={{ marginBottom: 8 }}
                  confirmText="Delete snag?"
                  confirmSubtext="Removes the snag and any captured issues from your companion. Cannot be undone.">
                  <div onClick={(e) => {
                    // Don't navigate if tapping the ⋮ zone (top-right 44x44)
                    const rect = e.currentTarget.getBoundingClientRect();
                    if (e.clientX > rect.right - 44 && e.clientY < rect.top + 44) return;
                    onNav(13, { snagId: snag.id });
                  }} style={{ width:"100%", padding:"14px 16px", paddingRight: 36, background:jobCardBg('snag'), border:`1px solid ${t.colors.glassBorder}`, borderTop:`1px solid ${t.colors.glassBorderTop}`, borderRadius:t.radius.lg, overflow:"hidden", cursor:"pointer", textAlign:"left", display:"flex", alignItems:"center", gap:12, boxSizing:"border-box", position:"relative", zIndex:1, boxShadow:t.shadow.card, ...jobLit('snag', snag, false) }}>
                    <JobSpine type="snag" />
                    <JobBadge type="snag" />
                    <div style={{ flex:1, minWidth:0 }}>
                      <div style={{ fontSize:14, fontWeight:700, color:t.colors.text, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{snag.projectName}</div>
                      <div style={{ fontSize:11, color:t.colors.textSecondary, marginTop:2 }}>{snag.clientName || ""}</div>
                      <div style={{ display:"flex", gap:6, marginTop:6 }}>
                        <JobChip type="snag" />
                        <span style={{ fontSize:10, color:t.colors.textTertiary }}>{issueCount} issue{issueCount!==1?"s":""}</span>
                      </div>
                    </div>
                    <Icon name="chevron" size={16} color={t.colors.textTertiary} />
                  </div>
                </LongPressCard>
              );
            })}
            {/* S99 — planned-state projects (was: survey_queue rows) */}
            {queuePlanned.map(p => {
              const chipStyle = statusChipStyle('planned');
              const contactLabel = p.client || p.contact || '';
              const deletePlannedProj = () => {
                deleteSurvey(p.id, {
                  userId: currentUser?.id,
                  surveyState: 'planned',
                  projectName: p.name,
                });
                if (onDeleteProject) onDeleteProject(p.id);
                window.dispatchEvent(new CustomEvent('lumenDataSync'));
              };
              return (
                <LongPressCard key={p.id} onDelete={deletePlannedProj} style={{ marginBottom: 8 }}
                  confirmText="Delete planned visit?"
                  confirmSubtext="Removes the planned visit from your companion. The site visit can be re-scheduled from Today.">
                  <div onClick={() => { if (onOpenProject) onOpenProject(p); }}
                    style={{ width:"100%", padding:"14px 16px", paddingRight: 36, background:t.colors.glass, border:`1px solid ${t.colors.glassBorder}`, borderTop:`1px solid ${t.colors.glassBorderTop}`, borderRadius:t.radius.lg, cursor:"pointer", textAlign:"left", display:"flex", alignItems:"center", gap:12, fontFamily:'inherit', boxSizing:"border-box", boxShadow:t.shadow.card, ...jobLit('survey', p, false) }}>
                    <div style={{ flex:1, minWidth:0 }}>
                      <div style={{ fontSize:14, fontWeight:700, color:t.colors.text, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{p.name}</div>
                      {contactLabel && <div style={{ fontSize:11, color:t.colors.textSecondary, marginTop:2 }}>{contactLabel}</div>}
                      <div style={{ display:"flex", gap:6, marginTop:6 }}>
                        <span style={{ background:chipStyle.background, borderRadius:20, padding:"2px 8px", fontSize:10, fontWeight:600, color:chipStyle.color }}>Planned</span>
                      </div>
                    </div>
                    <Icon name="chevron" size={16} color={t.colors.textTertiary} />
                  </div>
                </LongPressCard>
              );
            })}
            {/* S135 (4.5) — planned survey visits scheduled from Today with no project yet.
                Tap routes through the existing QuickEntry create flow (prefill carries the
                surveyId), so the project is created exactly as "Start survey" would. */}
            {plannedVisitOrphans.map(o => {
              const chipStyle = statusChipStyle('planned');
              const deleteOrphan = () => {
                deleteSurvey(o.id, { userId: currentUser?.id, surveyState: 'planned', projectName: o.name });
                window.dispatchEvent(new CustomEvent('lumenDataSync'));
              };
              return (
                <LongPressCard key={'orphan_' + (o.id || o.name)} onDelete={deleteOrphan} style={{ marginBottom: 8 }}
                  confirmText="Delete planned visit?"
                  confirmSubtext="Removes the planned visit from your companion. The site visit can be re-scheduled from Today.">
                  <div onClick={() => {
                    try { localStorage.setItem('survey_prefill', JSON.stringify({ surveyId: o.id, visitName: o.name, contactName: o.contact })); } catch (e) {}
                    onNav(2);
                  }}
                    style={{ width:"100%", padding:"14px 16px", paddingRight: 36, background:t.colors.glass, border:`1px solid ${t.colors.glassBorder}`, borderTop:`1px solid ${t.colors.glassBorderTop}`, borderRadius:t.radius.lg, cursor:"pointer", textAlign:"left", display:"flex", alignItems:"center", gap:12, fontFamily:'inherit', boxSizing:"border-box", boxShadow:t.shadow.card, ...jobLit('survey', null, false) }}>
                    <div style={{ flex:1, minWidth:0 }}>
                      <div style={{ fontSize:14, fontWeight:700, color:t.colors.text, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{o.name || 'Planned survey'}</div>
                      {o.contact && <div style={{ fontSize:11, color:t.colors.textSecondary, marginTop:2 }}>{o.contact}</div>}
                      <div style={{ display:"flex", gap:6, marginTop:6 }}>
                        <span style={{ background:chipStyle.background, borderRadius:20, padding:"2px 8px", fontSize:10, fontWeight:600, color:chipStyle.color }}>Planned</span>
                      </div>
                    </div>
                    <Icon name="chevron" size={16} color={t.colors.textTertiary} />
                  </div>
                </LongPressCard>
              );
            })}
          </>
        )}

        {/* Recently submitted zone */}
        {hasRecent && (
          <>
            <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:10, marginTop: hasActive ? 12 : 0 }}>
              <div style={{ width:3, height:16, borderRadius:2, background:t.colors.teal }} />
              <span style={{ fontSize:10, fontWeight:t.font.lw700, letterSpacing:t.font.ls15em, textTransform:"uppercase", color:t.colors.teal }}>Recently submitted</span>
            </div>
            {(() => {
              // S100 — render helper for one submitted-survey card.
              // S107 — portal-authority shells get a "Portal" badge and
              // tap-through opens the portal /survey/view/<id> URL
              // instead of the local LiveSurveyScreen (the shell has no
              // local zone data to edit). Both _portalSurveyId and the
              // 'portal_<id>' key prefix can drive the URL.
              const renderRecentCard = (proj) => {
                const isPortalAuthority = !!proj._portalAuthority;
                const portalSurveyId = proj._portalSurveyId
                  || (typeof proj.id === 'string' && proj.id.startsWith('portal_')
                      ? proj.id.slice(7) : null);
                const visitLabel = proj.visit_label || '';
                const deleteRecentSurvey = () => {
                  deleteSurvey(proj.id, {
                    userId: currentUser?.id,
                    surveyState: 'submitted',
                    projectName: proj.name || proj.project_name,
                  });
                  if (onDeleteProject) onDeleteProject(proj.id);
                  window.dispatchEvent(new CustomEvent('lumenDataSync'));
                };
                const handleTap = () => {
                  if (isPortalAuthority && portalSurveyId) {
                    // Open the portal viewer in a new tab. The user
                    // may need to be authed in the portal; the page
                    // handles its own auth gate.
                    try {
                      window.open(`${PORTAL_URL}/survey/view/${portalSurveyId}`, '_blank');
                    } catch (e) {
                      // Fallback for environments where window.open is
                      // blocked — at minimum avoid a no-op silent click.
                      try { location.href = `${PORTAL_URL}/survey/view/${portalSurveyId}`; }
                      catch (_e) {}
                    }
                    return;
                  }
                  if (onOpenProject) onOpenProject(proj);
                  onNav(3);
                };
                return (
                  <LongPressCard key={proj.id} onDelete={deleteRecentSurvey} style={{ marginBottom: 6 }}
                    confirmText="Delete submitted survey?"
                    confirmSubtext={isPortalAuthority
                      ? "This hides the portal-authority entry from your companion. The submitted record on the portal is unaffected."
                      : "This will hide the survey from your companion. The submitted record on the portal is unaffected."}>
                    <div onClick={handleTap} style={{ width:"100%", padding:"10px 16px", paddingRight: 36, background:jobCardBg('survey'), border:`1px solid ${t.colors.glassBorder}`, borderRadius:12, overflow:"hidden", display:"flex", alignItems:"center", gap:10, cursor:"pointer", textAlign:"left", fontFamily:"inherit", boxSizing:"border-box", position:"relative", zIndex:1, ...jobLit('survey', proj, true) }}>
                      <JobSpine type="survey" />
                      <JobBadge type="survey" />
                      <div style={{ flex:1, minWidth:0 }}>
                        <div style={{ display:'flex', alignItems:'center', gap:6 }}>
                          <span style={{ fontSize:13, fontWeight:600, color:t.colors.text, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{proj.name || proj.project_name}</span>
                          {visitLabel && (
                            <span style={{ fontSize:10, fontWeight:600, color:t.colors.brown, background:t.colors.chipVisitBg, border:`1px solid ${t.colors.gold22}`, borderRadius:6, padding:'1px 5px', flexShrink:0 }}>{visitLabel}</span>
                          )}
                        </div>
                        <div style={{ fontSize:10, color:t.colors.textTertiary, marginTop:2, display:'flex', alignItems:'center', gap:6 }}>
                          <span>{proj.surveyWrapCompletedAt ? new Date(proj.surveyWrapCompletedAt).toLocaleDateString('en-GB', { day:'numeric', month:'short' }) : proj.submitted_at ? new Date(proj.submitted_at).toLocaleDateString('en-GB', { day:'numeric', month:'short' }) : ''}</span>
                          {isPortalAuthority && (
                            <>
                              <span style={{ opacity:0.5 }}>·</span>
                              <span aria-label="Synced from portal" style={{ display:'inline-flex', alignItems:'center', gap:3, color:t.colors.teal }}>
                                <svg width="9" height="9" viewBox="0 0 12 12" fill="none">
                                  <path d="M2 6a4 4 0 0 1 7-2.7M10 6a4 4 0 0 1-7 2.7M9 1.5V4H6.5M3 10.5V8H5.5"
                                    stroke={t.colors.teal} strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
                                </svg>
                                <span style={{ fontWeight:600 }}>Portal</span>
                              </span>
                            </>
                          )}
                        </div>
                      </div>
                      <span style={{ background:t.colors.sentPillBg, border:`1px solid ${t.colors.sentPillBorder}`, borderRadius:20, padding:"2px 8px", fontSize:10, fontWeight:600, color:t.colors.teal, flexShrink:0 }}><UvTick />Sent</span>
                      <Icon name="chevron" size={14} color={t.colors.textTertiary} />
                    </div>
                  </LongPressCard>
                );
              };
              // Snag recent card — extracted so submitted snags render INSIDE
              // their month group alongside surveys (same Option B treatment),
              // instead of dangling as loose cards below the months.
              const renderRecentSnagCard = (snag) => {
                const deleteThisSnag = () => {
                  deleteSnag(snag.id, {
                    projectName: snag.projectName,
                    snagStatus: snag.status || 'submitted',
                  });
                  window.dispatchEvent(new CustomEvent('lumenDataSync'));
                };
                return (
                  <LongPressCard key={snag.id} onDelete={deleteThisSnag} style={{ marginBottom: 6 }}
                    confirmText="Delete submitted snag?"
                    confirmSubtext="This will hide the snag from your companion. The submitted record on the portal is unaffected.">
                    <div style={{ padding:"10px 16px", paddingRight: 36, background:jobCardBg('snag'), border:`1px solid ${t.colors.glassBorder}`, borderRadius:12, overflow:"hidden", display:"flex", alignItems:"center", gap:10, boxSizing:"border-box", position:"relative", zIndex:1, ...jobLit('snag', snag, true) }}>
                      <JobSpine type="snag" />
                      <JobBadge type="snag" />
                      <div style={{ flex:1 }}>
                        <div style={{ fontSize:13, fontWeight:600, color:t.colors.text }}>{snag.projectName}</div>
                        <div style={{ fontSize:10, color:t.colors.textTertiary, marginTop:2 }}>{snag.submittedAt ? new Date(snag.submittedAt).toLocaleDateString('en-GB', { day:'numeric', month:'short' }) : ''}{studioSep()}{(snag.issues||[]).length} issues</div>
                      </div>
                      <span style={{ background:t.colors.sentPillBg, border:`1px solid ${t.colors.sentPillBorder}`, borderRadius:20, padding:"2px 8px", fontSize:10, fontWeight:600, color:t.colors.teal }}><UvTick />Sent</span>
                    </div>
                  </LongPressCard>
                );
              };
              // One set of month groups for everything submitted that month —
              // surveys and snags together, date-ordered inside, under calm
              // neutral header rows. Most-recent month open by default; the rest
              // start collapsed and toggle on tap.
              return submittedMonthGroups.map((group, idx) => {
                const sectionKey = `submitted::${group.key}`;
                const expanded = isMonthExpanded(sectionKey, idx);
                const sorted = group.items.slice().sort((a, b) => new Date(b._jd) - new Date(a._jd));
                const surveyN = group.items.filter(x => x._jt === 'survey').length;
                const snagN = group.items.filter(x => x._jt === 'snag').length;
                return (
                  <div key={sectionKey} style={{ marginBottom: 11 }}>
                    {renderMonthGroupHeader(group, sectionKey, expanded, idx, surveyN, snagN)}
                    {expanded && (
                      <div style={{ border:`1px solid ${t.colors.lineSand}`, borderTop:0, borderRadius:'0 0 12px 12px', background:'rgba(255,255,255,0.35)', padding:'9px 9px 4px' }}>
                        {sorted.map(x => x._jt === 'survey' ? renderRecentCard(x.item) : renderRecentSnagCard(x.item))}
                      </div>
                    )}
                  </div>
                );
              });
            })()}
          </>
        )}

        {/* PATCH 2: "Recently submitted" header when no real cards exist */}
        {!hasRecent && (
          <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:10, marginTop: hasActive ? 12 : 4 }}>
            <div style={{ width:3, height:16, borderRadius:2, background:t.colors.teal }} />
            <span style={{ fontSize:10, fontWeight:t.font.lw700, letterSpacing:t.font.ls15em, textTransform:"uppercase", color:t.colors.teal }}>Recently submitted</span>
          </div>
        )}

        {/* Skeleton placeholder — only show when genuinely loading (no synced data yet) */}
        {!localStorage.getItem('lumen_pipeline') && !localStorage.getItem('lumen_surveys_portal') && [0,1].map(i => (
          <div key={`skel-${i}`} style={{ width:"100%", padding:"14px 16px", background:t.colors.olive06, borderRadius:12, marginBottom:6, display:"flex", alignItems:"center", gap:10 }}>
            <div style={{ flex:1 }}>
              <div style={{ width:"60%", height:13, borderRadius:6, background:t.colors.olive08, marginBottom:6 }} />
              <div style={{ width:"35%", height:10, borderRadius:5, background:t.colors.olive06 }} />
            </div>
            <div style={{ width:36, height:16, borderRadius:10, background:t.colors.olive06 }} />
          </div>
        ))}


      </div>
      <TabBar active={10} onChange={onNav} divisionId={div && div.id ? div.id : "lighting"} />
    </div>
  );
};

// RESUME-KEEPS-TYPE: console-only notice for a saved survey line that arrives
// without its fitting type (no unit.id or unit.label). Once per line uid per
// page load; never shown to the surveyor.
const _warnedUntypedSurveyLines = new Set();
const warnUntypedSurveyLine = (uid) => {
  const k = String(uid);
  if (_warnedUntypedSurveyLines.has(k)) return;
  _warnedUntypedSurveyLines.add(k);
  try { console.warn(`[hydrate] survey line ${k} has no fitting type (unit.id/unit.label missing); showing "Fitting"`); } catch (e) {}
};

const LiveSurveyScreen = ({ onBack, onNav, currentUser, activeProject, onUpdateProject, projects, onOpenProject, voiceRequest }) => {
  const div = getDivisionConfig(currentUser);
  const divColor = div.id === "aircon" ? t.colors.blue : t.colors.gold;
  const divColorLight = div.id === "aircon" ? t.colors.blueLight : t.colors.goldLight;
  const divBorder = div.id === "aircon" ? "rgba(91,155,213,0.25)" : t.colors.glassBorderGold;

  // ── Zone state ──
  // S95 D24 — dedupe on hydrate. Historical saves sometimes persisted the active zone as
  // a second entry, causing the Schedule list to render two rows for the same zone (one
  // regular + one with · LIVE). Keep order of first occurrence.
  const [zones, setZones] = useState(() => {
    const saved = activeProject?.customZones;
    if (!saved || saved.length === 0) return [];
    // S95 D5 D24/D25 — dedupe AND trim on hydrate. Legacy saves occasionally
    // stored zone names with trailing whitespace; that would break zoneFittings
    // lookups (zoneFittings[" Ground Floor "] !== zoneFittings["Ground Floor"])
    // and cause the Schedule fixture count to render as 0.
    const seen = new Set(); const out = [];
    for (const raw of saved) {
      const z = (raw || '').trim();
      if (!z) continue;
      const key = z.toLowerCase();
      if (seen.has(key)) continue;
      seen.add(key); out.push(z);
    }
    return out;
  });
  const [zIdx, setZIdx] = useState(0);
  const [newZoneName, setNewZoneName] = useState("");
  const [addingZone, setAddingZone] = useState(false);
  const [renamingZone, setRenamingZone] = useState(false);
  const [renameText, setRenameText] = useState('');

  // ── Survey entries: { zoneName: [entry...] } ──
  const [zoneFittings, setZoneFittings] = useState(() => {
    const saved = activeProject?.surveyZones || [];
    const customZones = activeProject?.customZones || [];
    const _custRestore = restoreCustomFittings(activeProject?.customFittings, saved);
    const result = {};
    // S96 BRIEF A · D25 — case-insensitive merge on hydrate. Earlier hydrate
    // (S95 D25) trimmed but did not lowercase, so a project with surveyZones
    // entries logged against `reception` and a customZones entry of `Reception`
    // ended up with zoneFittings keyed on `reception` while the schedule
    // iterated `zones=["Reception"]` — Reception row rendered "0 fittings".
    //
    // Hydrate now picks a canonical display-case key per zoneKey() bucket,
    // preferring the casing from customZones (the user-facing source of truth
    // for zone names). All entries whose zone field collapses to the same
    // zoneKey land under that single canonical key. Orphan entries (no
    // matching customZone) fall back to the first occurrence's casing.
    const canonicalByKey = {};
    customZones.forEach(cz => {
      const k = zoneKey(cz);
      if (k && !canonicalByKey[k]) canonicalByKey[k] = String(cz || '').trim();
    });
    saved.forEach(e => {
      const k = zoneKey(e.zone);
      if (!k) return;
      let canonical = canonicalByKey[k];
      if (!canonical) {
        canonical = String(e.zone || '').trim();
        canonicalByKey[k] = canonical;
      }
      if (!result[canonical]) result[canonical] = [];
      // RESUME-KEEPS-TYPE: a saved line with no unit.id or unit.label has lost
      // its fitting type. The fallbacks below ("Fitting" / "unknown") keep the
      // screen usable, but say so in the console, once per line, so a future
      // regression of the line shape is visible rather than silent.
      if (!e.unit?.id || !e.unit?.label) warnUntypedSurveyLine(e.uid);
      result[canonical].push({
        uid: e.uid || (Date.now() + Math.random()),
        // P1: a custom line keeps its own tile id ('cx-<time>') so its tile
        // counts it after a reload; every other line keeps the part before
        // the first dash, as before.
        fixtureId: (e.unit?.id && isCustomFixtureId(e.unit.id))
          ? (_custRestore.idForSig(customFittingSig(String(e.unit.label || '').split(' · ')[0], e.unit.wattage, e.unit.replacementW)) || e.unit.id.split("-")[0])
          : (e.unit?.id ? e.unit.id.split("-")[0] : "unknown"),
        fixtureName: e.unit?.label?.split(" · ")[0] || "Fitting",
        primary: e.primary || null,
        secondary: e.secondary || null,
        extras: e.extras || {},
        qty: e.qty || 1,
        emQty: e.emQty || 0,
        existingW: e.unit?.wattage || 0,
        ledW: e.unit?.replacementW || 0,
        cost: costOrNull(e.unit?.unitCost),
        photos: e.photos || [],
      });
    });
    return result;
  });

  // ── Selection state ──
  const [selFixId, setSelFixId] = useState(null);
  const [selPrimary, setSelPrimary] = useState(null);
  const [selSecondary, setSelSecondary] = useState(null);
  const [selExtras, setSelExtras] = useState({});
  const [selChips, setSelChips] = useState({});
  const [qty, setQty] = useState(1);
  const [emQty, setEmQty] = useState(0);
  // P1: EM can never be above the quantity. It is clamped where it is SHOWN and
  // where it is SAVED (the EM box, the Log label, commitFitting), never by an
  // effect on [qty]: the quantity box sets qty on every keystroke, so typing
  // 20 -> 24 passes through 2, and an effect would cut the surveyor's EM to 2
  // for good (P1 review round 1, B1). The stored emQty is left as typed.
  // P1: the last choices made per type, per area (size, typed size, cutout...),
  // so the next fitting of that type opens where the surveyor just was.
  const lastChoicesRef = useRef({});

  // ── Custom fittings (this job only) ──
  // P1: held on the project (project.customFittings) and rebuilt from the
  // job's own survey lines, so a custom fitting is a tile in every area of the
  // job and is still there after the app restarts. It was screen state before,
  // and was gone when the screen closed.
  const [customFittings, setCustomFittings] = useState(() =>
    restoreCustomFittings(activeProject?.customFittings, activeProject?.surveyZones).tiles);
  const [showCustomModal, setShowCustomModal] = useState(false);
  const [cName, setCName] = useState("");
  const [cOldW, setCOldW] = useState("");
  const [cNewW, setCNewW] = useState("");

  // ── Collapsible schedule zones + zone notes ──
  const [collapsedZones, setCollapsedZones] = useState({});
  // S95 D2 (3rd attempt) — localStorage `survey_active` is the authoritative source for zoneNotes.
  // _commitNotes writes synchronously to survey_active, so on any mount / remount we must read
  // from there FIRST (matching projectId), then fall back to the React prop. Reading the prop
  // first lost fresh saves because the parent's asg_projects_* persist is flushed via useEffect
  // (async tick later than localStorage survey_active which we write inline in _commitNotes).
  const [zoneNotes, setZoneNotes] = useState(() => {
    try {
      const sa = JSON.parse(localStorage.getItem('survey_active') || '{}');
      if (sa && sa.projectId && activeProject?.id && sa.projectId === activeProject.id && sa.zoneNotes) {
        return sa.zoneNotes;
      }
    } catch(e) {}
    return activeProject?.zoneNotes || {};
  });
  // S95 D5 D2 (third attempt) — authoritative refs prevent stale-closure
  // writes and block useEffect rehydrate from stomping a committed save.
  // notesSavedRef: flips true on first note save (_commitNotes); only reset when project
  //   id genuinely changes (different survey opened).
  // zoneNotesRef: always mirrors the latest committed zoneNotes map — used by
  //   saveSurveyActive so background persists never flush a stale closure.
  // lastProjectIdRef: tracks the id we were mounted with, so we can detect a
  //   real project change vs a reference-only re-render of activeProject.
  const notesSavedRef = useRef(false);
  const zoneNotesRef = useRef(zoneNotes);
  const lastProjectIdRef = useRef(activeProject?.id || null);
  const [showNoteSheet, setShowNoteSheet] = useState(false);
  const [noteSheetText, setNoteSheetText] = useState('');
  const [editQtyId, setEditQtyId] = useState(null);
  const [editQtyVal, setEditQtyVal] = useState("");
  const [editEmId, setEditEmId] = useState(null);    // S95 D5
  const [editEmVal, setEditEmVal] = useState("");    // S95 D5
  const [editAttrId, setEditAttrId] = useState(null);  // S95 D12 — uid of row being edited
  const [editAttrKey, setEditAttrKey] = useState(null); // S95 D12 — 'sensor' | 'dim'
  const [sensorPromptShown, setSensorPromptShown] = useState({}); // S95 D12 — per-zone "any sensors?" shown
  const [externalExpanded, setExternalExpanded] = useState(false); // S95 D13 — external/IP-rated section
  const toggleZoneCollapse = (zone) => setCollapsedZones(prev => ({ ...prev, [zone]: !prev[zone] }));

  // ── Photo state ──
  const [lightbox, setLightbox] = useState(null);
  const [sitePhotos, setSitePhotos] = useState(() => activeProject?.sitePhotos || []);
  const photoInputRef = useRef(null);
  const videoInputRef = useRef(null);
  const [photoTargetZone, setPhotoTargetZone] = useState(null);
  // S135 (4.4) — bounded autosave confirmation. A subtle "Saved" pill that
  // appears on every persist and fades 1.2s after the last change.
  const [savedFlash, setSavedFlash] = useState(false);
  const savedFlashRef = useRef(null);
  const flashSaved = () => {
    setSavedFlash(true);
    if (savedFlashRef.current) clearTimeout(savedFlashRef.current);
    savedFlashRef.current = setTimeout(() => setSavedFlash(false), 1200);
  };

  // ── Helpers ──
  const currentZone = zones[zIdx] || "";

  // S96 BRIEF A · D25 — case-insensitive zoneFittings lookup helpers.
  // Defense-in-depth on top of the canonical-case merge in the hydrate
  // initializer above. Even if some future code path adds a zoneFittings key
  // with mismatched casing, reads still find it and writes still merge into
  // the existing key rather than creating a duplicate bucket.
  // findZFKey: returns the zoneFittings key whose zoneKey() matches the
  //   requested zone. If none, returns the requested zone unchanged so a
  //   write creates a new bucket (with the caller's casing).
  // zfEntries: returns the entries array for a zone via case-insensitive
  //   lookup, or [] if absent. Use at every read site that maps a `zone`
  //   string from the zones array onto zoneFittings.
  const findZFKey = (zone, zf) => {
    const target = zf || zoneFittings;
    if (target && Object.prototype.hasOwnProperty.call(target, zone)) return zone;
    const k = zoneKey(zone);
    if (!k || !target) return zone;
    for (const candidate in target) {
      if (zoneKey(candidate) === k) return candidate;
    }
    return zone;
  };
  const zfEntries = (zone, zf) => {
    const target = zf || zoneFittings;
    if (!target) return [];
    return target[findZFKey(zone, target)] || [];
  };

  // S96 BRIEF A · D25 — one-time post-mount migration. The hydrate initializer
  // above produces canonical-case keys for entries that were already in
  // surveyZones at mount time. This effect catches any residual case-mismatch
  // collisions that survived hydrate (e.g. from a partially-rolled-out write
  // path that wrote a new key without going through findZFKey). Runs once on
  // mount, no-op when no collisions exist.
  useEffect(() => {
    setZoneFittings(prev => {
      if (!prev || typeof prev !== 'object') return prev;
      const merged = {};
      const collisions = [];
      Object.keys(prev).forEach(rawKey => {
        const entries = prev[rawKey] || [];
        const k = zoneKey(rawKey);
        if (!k) { merged[rawKey] = entries; return; }
        let canonical = null;
        for (const existing in merged) {
          if (zoneKey(existing) === k) { canonical = existing; break; }
        }
        if (canonical) {
          merged[canonical] = [...(merged[canonical] || []), ...entries];
          collisions.push({ from: rawKey, into: canonical, count: entries.length });
        } else {
          merged[rawKey] = entries;
        }
      });
      if (collisions.length === 0) return prev;
      try { console.warn('[zoneFittings migration] collapsed duplicate keys:', collisions); } catch(e) {}
      return merged;
    });
  }, []);

  // S95 D8 — when the active zone changes, clear stale in-progress editor state so nothing
  // from the previous zone (rename buffer, inline EM stepper) bleeds through.
  useEffect(() => {
    setRenamingZone(false);
    setRenameText('');
    setEditQtyId(null);
    setEditQtyVal('');
    setEditEmId(null);
    setEditEmVal('');
    setEditAttrId(null);
    setEditAttrKey(null);
  }, [zIdx]);

  // S95 D19 — any time we ENTER a survey (new project, resumed from Today, or returning via
  // Back from Wrap), every transient editor flag MUST start closed. Otherwise stale UI state
  // (e.g. "note editor open with Save button showing") is what the user sees first. This effect
  // is belt-and-braces on top of the initial useState(false) values.
  useEffect(() => {
    setRenamingZone(false);
    setRenameText('');
    setShowNoteSheet(false);
    setNoteSheetText('');
    setEditQtyId(null);
    setEditQtyVal('');
    setEditEmId(null);
    setEditEmVal('');
    setEditAttrId(null);
    setEditAttrKey(null);
    setAddingZone(false);
    setNewZoneName('');
  }, [activeProject?.id]);

  // S96 BRIEF A · D2 — mount-only belt-and-braces. The [activeProject?.id]
  // effect above only fires when the id dep changes. If React reconciles the
  // component instance across screen 3 → 0 → 3 with the same project id (or
  // any future code path keeps the LiveSurveyScreen mounted while the user
  // navigates away and back), that effect would not re-fire. This empty-deps
  // effect runs exactly once at mount and guarantees that the resume view
  // never boots with a sub-state / modal / inline-edit flag still set.
  useEffect(() => {
    setRenamingZone(false);
    setRenameText('');
    setShowNoteSheet(false);
    setNoteSheetText('');
    setEditQtyId(null);
    setEditQtyVal('');
    setEditEmId(null);
    setEditEmVal('');
    setEditAttrId(null);
    setEditAttrKey(null);
    setAddingZone(false);
    setNewZoneName('');
  }, []);

  // S95 D17 — keep zIdx in valid range. If zones shrinks below zIdx (delete, rehydrate
  // with fewer zones), the sub-header would render "Zone N" where N is out of bounds and
  // currentZone would be empty. Clamp to the last valid slot.
  useEffect(() => {
    if (zones.length === 0) { if (zIdx !== 0) setZIdx(0); return; }
    if (zIdx > zones.length - 1) setZIdx(zones.length - 1);
    if (zIdx < 0) setZIdx(0);
  }, [zones.length]);

  // S95 D5 D2 (third attempt) — rehydrate zoneNotes strictly on a genuine
  // project change. Two guard paths:
  //   (a) if lastProjectIdRef matches activeProject.id, React only re-ran this
  //       effect because the dep identity was re-compared; nothing to do, and
  //       we must not touch zoneNotes (notesSavedRef may already be true).
  //   (b) if a genuine id change happened, we reset the saved-guard and
  //       rehydrate from localStorage first, then fall back to the prop.
  //   (c) if notesSavedRef is already true AND ids match (no genuine change),
  //       bail — any rehydrate at this point would overwrite a local save.
  // Priority chain for the rehydrate path: survey_active localStorage (latest)
  // → activeProject.zoneNotes prop (initial) → {} (empty).
  useEffect(() => {
    if (!activeProject?.id) return;
    const projectChanged = lastProjectIdRef.current !== activeProject.id;
    if (projectChanged) {
      lastProjectIdRef.current = activeProject.id;
      notesSavedRef.current = false;
    } else if (notesSavedRef.current) {
      return;
    }
    try {
      const sa = JSON.parse(localStorage.getItem('survey_active') || '{}');
      if (sa && sa.projectId === activeProject.id && sa.zoneNotes) {
        zoneNotesRef.current = sa.zoneNotes;
        setZoneNotes(sa.zoneNotes);
        return;
      }
    } catch(e) {}
    const fromProp = activeProject?.zoneNotes || {};
    zoneNotesRef.current = fromProp;
    setZoneNotes(fromProp);
  }, [activeProject?.id]);

  // S95 D13 — external fixtures included in the master list so existing lookups (entries, tile totals,
  // wattages) find them, but the UI grid splits them into their own collapsible section.
  const allFixtures = () => [
    ...SURVEY_FIXTURES,
    ...EXTERNAL_FIXTURES,
    ...customFittings,
    { id:"custom-btn", label:"Custom", icon:"plus", cost:null, variants:{ primary:[] }, isCustomBtn:true },
  ];
  const internalFixtures = () => [
    ...SURVEY_FIXTURES,
    ...customFittings,
    { id:"custom-btn", label:"Custom", icon:"plus", cost:null, variants:{ primary:[] }, isCustomBtn:true },
  ];
  const externalFixtures = () => [...EXTERNAL_FIXTURES];

  // P1: unknown sizes are 0, never another size's figure (lookupWattages, tested).
  const getWattages = (fixtureId, primary, secondary) => lookupWattages(WATTAGE_TABLE, fixtureId, primary, secondary);

  // buildVarLabel is module-level now, in the S135 PERSISTENCE_LOGIC block,
  // beside surveyLineFromEntry (RESUME-KEEPS-TYPE).

  // ── Persist to project + survey_active localStorage ──
  // S96 BRIEF A · D2 — survey_active is DATA ONLY. The keys below are the
  // only fields that may be persisted — sub-view / modal / inline-edit flags
  // (showNoteSheet, editQtyId, etc.)
  // must NEVER land here. Resume from Today reads this payload and rebuilds
  // zoneFittings/zones/zoneNotes; if a sub-state flag leaks in, the resumed
  // view boots into note-edit / fixture-edit instead of zone detail. The
  // overrides arg is filtered against an explicit allow-list rather than
  // spread blindly so that future callers cannot regress this contract by
  // accident.
  // S135 — alias the module-level allow-list so the persisted-field contract
  // has a single source of truth shared with buildActiveDraft (tested).
  const SURVEY_ACTIVE_ALLOWED_FIELDS = ACTIVE_DRAFT_FIELDS;
  const saveSurveyActive = (overrides = {}) => {
    let _draftOk = false;
    try {
      const filteredOverrides = {};
      Object.keys(overrides || {}).forEach(k => {
        if (SURVEY_ACTIVE_ALLOWED_FIELDS.indexOf(k) !== -1) {
          filteredOverrides[k] = overrides[k];
        } else {
          try { console.warn(`[saveSurveyActive] dropped non-data override "${k}"`); } catch(e) {}
        }
      });
      const state = {
        projectId: activeProject?.id || '',
        surveyName: activeProject?.name || '',
        surveyType: 'survey',
        contactName: activeProject?.client || '',
        currentStage: 'live',
        zones: zones,
        currentZoneIndex: zIdx,
        zoneFittings: zoneFittings,
        // S95 D5 D2 — use zoneNotesRef so background persists (fitting add,
        // zone rename, back-button save) never flush a stale closure value
        // and overwrite a freshly-saved note on survey_active.
        zoneNotes: zoneNotesRef.current || zoneNotes,
        sitePhotos: photosToRefs(sitePhotos),
        startedAt: activeProject?.createdAt || Date.now(),
        savedAt: Date.now(),
        ...filteredOverrides,
      };
      // S135 — enforce the allow-list through the tested pure builder.
      const _draftJson = JSON.stringify(buildActiveDraft(state));
      localStorage.setItem('survey_active', _draftJson);
      // P1: a write is only a write if it reads back. A full or blocked store
      // can accept nothing without throwing in some browsers.
      _draftOk = localStorage.getItem('survey_active') === _draftJson;
      // Also update survey_inprogress for backward compat
      localStorage.setItem('survey_inprogress', JSON.stringify({
        projectId: activeProject?.id || '',
        projectName: activeProject?.name || '',
        zoneCount: (overrides.zones || zones).length,
        fittingCount: Object.values(overrides.zoneFittings || zoneFittings).flat().reduce((s, e) => s + (e.qty || 1), 0),
        savedAt: new Date().toISOString(),
      }));
      // Sync today_visits status
      try {
        const tv = JSON.parse(localStorage.getItem('lumen_visits') || '[]');
        const stage = overrides.currentStage || 'live';
        let changed = false;
        tv.forEach(v => { if (v.surveyId === activeProject?.id) { v.status = stage; changed = true; } });
        if (changed) localStorage.setItem('lumen_visits', JSON.stringify(tv));
      } catch(e2) {}
    } catch(e) {}
    return _draftOk;
  };

  // Returns true only when the survey_active write read back. The project
  // itself is written by the App in an effect that cannot report here, so this
  // is the one write this screen can confirm; callers that tell the surveyor
  // "Copied" must check it (silent failure is the enemy).
  const persist = (zf, zl) => {
    const fittings = zf || zoneFittings;
    const zoneList = zl || zones;
    // RESUME-KEEPS-TYPE: the line shape is surveyLineFromEntry, shared with the
    // cold-start resume converter so the two cannot drift.
    const surveyZones = Object.entries(fittings).flatMap(([zone, entries]) =>
      entries.map(e => surveyLineFromEntry(zone, e))
    );
    let projectOk = true;
    if (activeProject?.id && onUpdateProject) {
      // S99 phantom-survey fix: do NOT flip stage here. Earlier code wrote
      // stage:"surveyed" on every fitting log, which removed the project
      // from SurveyLanding's activeSurveys filter (which excludes
      // stage='surveyed') AND prevented it from entering mergedRecentSurveys
      // (which requires surveyWrapCompletedAt). The matching survey_queue
      // row then leaked through queuePlanned as a phantom card. Stage flips
      // belong exclusively to the wrap submit (sendToPortal at ~6948).
      try { onUpdateProject(activeProject.id, { surveyZones, customZones:zoneList }); } catch (e) { projectOk = false; }
    }
    const draftOk = saveSurveyActive({ zones: zoneList, zoneFittings: fittings });
    const ok = draftOk && projectOk;
    if (ok) flashSaved();
    return ok;
  };

  // ── Energy calculations (wattage only — no cost estimates) ──
  const totalExistingW = Object.values(zoneFittings).flat()
    .reduce((s, e) => s + (e.existingW * e.qty), 0);
  const totalLedW = Object.values(zoneFittings).flat()
    .reduce((s, e) => s + (e.ledW * e.qty), 0);
  const reductionPct = totalExistingW > 0
    ? Math.round((1 - totalLedW / totalExistingW) * 100) : 0;
  const totalFixtureCount = Object.values(zoneFittings).flat()
    .reduce((s, e) => s + e.qty, 0);

  // Legacy roiCalc for Propose button compatibility
  const roiCalc = { total: totalFixtureCount };

  const completedZones = Object.keys(zoneFittings).length;
  const hasCompletedZones = zones.some((z, i) => i < zIdx && zfEntries(z).length > 0) || (zones.length > 0 && Object.keys(zoneFittings).length > 0);

  // ── Back handler — saves in-progress state before navigating away ──
  const handleBack = () => {
    const hasData = zones.length > 0 || Object.keys(zoneFittings).length > 0;
    if (hasData && activeProject?.id) {
      persist();
    }
    onBack();
  };

  // ── Voice bottom sheet state ──
  const [showVoiceSheet, setShowVoiceSheet] = useState(false);
  const [showDrawingsSheet, setShowDrawingsSheet] = useState(false);
  const [voiceSheetText, setVoiceSheetText] = useState('');
  const [voiceSheetRecording, setVoiceSheetRecording] = useState(false);
  const [voiceSheetRecTime, setVoiceSheetRecTime] = useState(0);
  const [voiceSheetError, setVoiceSheetError] = useState('');
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);
  // S1 — the voice-store id of the recording just captured, handed to
  // saveVoiceSheetNote so a save with no transcript still owns its audio.
  const voiceSheetAudioIdRef = useRef(null);
  // S1 (reviewer finding 4) — stopVoiceSheetRecorder clears `recording`
  // synchronously, but voiceSheetAudioIdRef is only set inside the async
  // recorder.onstop (after a base64 encode). Save tapped in that window used to
  // decide on nothing and write nothing. `finalising` covers the gap.
  const [voiceSheetFinalising, setVoiceSheetFinalising] = useState(false);
  // Bumped whenever this screen writes the voice store (save, sweep, rename), so
  // the audio-availability index re-reads after a quota prune. It is only an
  // index: playNoteAudio still re-checks and refuses honestly, because another
  // tab or a later prune can invalidate it at any time.
  const [voiceStoreTick, setVoiceStoreTick] = useState(0);
  // The ref is the one that matters: state is set inside the ASYNC onstop, so
  // between the stop tap and onstop firing the button would otherwise be live
  // again with no audio id yet. stopVoiceSheetRecorder sets this synchronously.
  const voiceSheetFinalisingRef = useRef(false);
  // Bumped every time the sheet opens or is dismissed. recorder.onstop is async
  // and LiveSurveyScreen never unmounts, so a backdrop dismiss mid-recording
  // used to clear voiceSheetAudioIdRef only for onstop to set it again moments
  // later — binding the NEXT note the user typed to a recording they believed
  // they had cancelled. onstop only claims the id if its session still matches.
  const voiceSheetSessionRef = useRef(0);
  // S1 — in-zone playback + the desk escape hatch. typeUpNote holds
  // {key, id} for the pending note being transcribed by hand.
  const noteAudioElRef = useRef(null);   // SEC-028: the _playVoiceSource handle now playing
  const [playingNoteId, setPlayingNoteId] = useState(null);
  const [typeUpNote, setTypeUpNote] = useState(null);
  const [typeUpText, setTypeUpText] = useState('');
  const [moveOpenId, setMoveOpenId] = useState(null);   // SLICE-A4: the Unassigned note whose area picker is open
  const voiceSheetTimerRef = useRef(null);
  // SLICE-A4 (review round 1): when the current recording started. onstop is
  // created when record is tapped, so reading voiceSheetRecTime there gave the
  // timer's value at THAT moment (0, or the previous recording's length).
  const voiceSheetStartedAtRef = useRef(0);
  const voiceSheetStartingRef = useRef(false);

  // The one way the voice sheet opens: the Add a voice note buttons (the row
  // under the area's tabs, the Notes tab) and the header mic (SLICE-A4) all call
  // this, so a fresh session starts from the same clean state any of the three ways.
  const openVoiceSheet = () => {
    voiceSheetSessionRef.current += 1;
    voiceSheetAudioIdRef.current = null;
    voiceSheetFinalisingRef.current = false;
    setVoiceSheetFinalising(false);
    setShowVoiceSheet(true);
  };
  // SLICE-A4: the header mic, pressed while this screen is open, asks for the
  // sheet by bumping voiceRequest (App owns the counter). The value this screen
  // mounts with is already seen, so coming back to the survey never opens it.
  const voiceRequestSeenRef = useRef(voiceRequest || 0);
  useEffect(() => {
    if (!voiceRequest || voiceRequest === voiceRequestSeenRef.current) return;
    voiceRequestSeenRef.current = voiceRequest;
    // Already open (maybe recording): re-opening would reset the session and
    // orphan the recording in progress. The mic press is a no-op then.
    if (showVoiceSheet) return;
    openVoiceSheet();
  }, [voiceRequest]);

  // Cleanup: stop recorder + timer when voice sheet closes or component unmounts
  useEffect(() => {
    if (!showVoiceSheet) {
      if (voiceSheetTimerRef.current) { clearInterval(voiceSheetTimerRef.current); voiceSheetTimerRef.current = null; }
      if (mediaRecorderRef.current) {
        try { mediaRecorderRef.current.stream?.getTracks().forEach(t => t.stop()); } catch(e) {}
        if (mediaRecorderRef.current.state !== 'inactive') {
          try { mediaRecorderRef.current.stop(); } catch(e) {}
        }
      }
      setVoiceSheetRecording(false);
      voiceSheetStartingRef.current = false;
    }
  }, [showVoiceSheet]);

  // ── Anomaly warnings state ──
  const [dismissedWarnings, setDismissedWarnings] = useState([]);

  // ── Scope done check ──
  const scopeDone = activeProject?.scopeAnswers && Object.keys(activeProject.scopeAnswers).length >= 6;

  // ── Complete zone ──
  const completeZone = () => {
    clearSel();
    if (zIdx < zones.length - 1) {
      // Advance to next incomplete zone
      let nextIdx = zIdx + 1;
      for (let i = zIdx + 1; i < zones.length; i++) {
        if (!(zfEntries(zones[i]).length > 0)) { nextIdx = i; break; }
      }
      setZIdx(nextIdx);
    }
    persist();
  };

  // ── Anomaly check ──
  const checkSurveyAnomalies = () => {
    const warnings = [];
    const allEntries = Object.values(zoneFittings).flat();
    const hasEM = allEntries.some(e => e.fixtureId === 'em' || e.emQty > 0);
    if (!hasEM && allEntries.length > 0) {
      warnings.push({ type:'em', message:'No EM logged anywhere on this survey. Is the building compliant? Worth confirming before you send it.', action:'Add EM gear', actionFn:() => { tapFixture('em'); } });
    }
    const emptyZones = zones.filter(z => !(zfEntries(z).length > 0));
    if (emptyZones.length > 0) {
      warnings.push({ type:'empty-zones', message:'Some zones have nothing in them. Worth a check before you leave the building.', action:'Review', actionFn:() => { setZIdx(zones.indexOf(emptyZones[0])); } });
    }
    return warnings.filter(w => !dismissedWarnings.includes(w.type));
  };

  // ── Voice sheet helpers ──
  const stopVoiceSheetRecorder = () => {
    if (voiceSheetTimerRef.current) { clearInterval(voiceSheetTimerRef.current); voiceSheetTimerRef.current = null; }
    // Synchronously, BEFORE the re-render that re-enables Save: from this
    // instant until onstop has persisted the audio there is nothing to save.
    voiceSheetFinalisingRef.current = true;
    setVoiceSheetFinalising(true);
    if (mediaRecorderRef.current) {
      try { mediaRecorderRef.current.stream?.getTracks().forEach(t => t.stop()); } catch(e) {}
      if (mediaRecorderRef.current.state !== 'inactive') {
        try { mediaRecorderRef.current.stop(); } catch(e) {}
      }
    }
    setVoiceSheetRecording(false);
  };

  // ── Voice sheet handlers ──
  const handleVoiceSheetRecord = async () => {
    if (voiceSheetRecording) {
      stopVoiceSheetRecorder();
      voiceSheetStartingRef.current = false;
      return;
    }
    // Guard: prevent double-invocation from mobile ghost-click (touchend + click both fire)
    if (voiceSheetStartingRef.current) return;
    voiceSheetStartingRef.current = true;
    // Captured at ENTRY, not after the getUserMedia await: a sheet dismissed
    // while the permission prompt is up would otherwise capture the NEXT
    // session and claim its audio id.
    const _session = voiceSheetSessionRef.current;
    setVoiceSheetError('');
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const recorder = new MediaRecorder(stream, { mimeType: MediaRecorder.isTypeSupported('audio/webm') ? 'audio/webm' : 'audio/mp4' });
      audioChunksRef.current = [];
      recorder.ondataavailable = (e) => { if (e.data.size > 0) audioChunksRef.current.push(e.data); };
      recorder.onstop = async () => {
        voiceSheetFinalisingRef.current = true;
        setVoiceSheetFinalising(true);
        stream.getTracks().forEach(tk => tk.stop());
        const blob = new Blob(audioChunksRef.current, { type: recorder.mimeType });
        // ── S95 D1 FIX — save audio to localStorage BEFORE any transcription.
        // Transcription failure must never delete the note. Audio survives
        // regardless of network state or server response.
        const noteId = (typeof crypto !== 'undefined' && crypto.randomUUID)
          ? crypto.randomUUID()
          : 'vn_' + Date.now() + '_' + Math.random().toString(36).slice(2,9);
        const capturedDuration = recordingSeconds(voiceSheetStartedAtRef.current, Date.now());
        // S1 — capture the SAME key saveVoiceSheetNote will use, so the orphan
        // adoption sweep can place this recording back on its own container.
        // (S3: Site-wide notes now DO reach the wire — the flattener no longer
        // drops '__project__'. This comment previously said they stopped here.)
        const capturedZone = voiceKey || null;
        // SLICE-A5: the bytes go to IndexedDB (base64 only if that fails).
        const audioFields = await voiceAudioFields(noteId, blob, blobToBase64Async);
        const newNote = {
          id: noteId,
          recordedAt: new Date().toISOString(),
          duration: capturedDuration,
          context: 'survey',
          projectId: activeProject?.id || null,
          zone: capturedZone,
          ...audioFields,
          audioMimeType: recorder.mimeType,
          transcript: null,
          transcriptionStatus: 'pending',
          transcribedAt: null,
          source: 'in-zone',
        };
        // D2 — an in-zone survey note does NOT emit voice_note_logged. Capture,
        // not prospecting; survey_submitted already credits the visit.
        const saveResult = addVoiceNote(newNote, false);
        // S1 — hand this recording's id to the save. Even if transcription
        // fails below, the save now produces a real note that owns the audio.
        // Clearing `finalising` here (not at the end of transcription) is
        // deliberate: the moment the id exists, Save can safely decide.
        // Only claim the recording if it ACTUALLY persisted. Otherwise Save
        // would produce a pending note owning an audioRef that resolves to
        // nothing, and toast "Recording saved to note" over a lost recording.
        // Only claim the id if this sheet session is still the live one. The
        // audio is persisted either way — an abandoned recording is rescued by
        // the sweep, not silently bound to somebody else's note.
        if (voiceSheetSessionRef.current === _session) {
          voiceSheetAudioIdRef.current = saveResult.ok ? noteId : null;
        }
        voiceSheetFinalisingRef.current = false;
        setVoiceSheetFinalising(false);
        if (!saveResult.ok) {
          setVoiceSheetError(voiceStoreMessage(saveResult) + ' Please note the key points by hand.');
        } else if (saveResult.audioPruned) {
          console.warn('[voice-sheet] ' + voiceStoreMessage(saveResult));
        }
        // S4b — get the audio OFF THE HANDSET, before transcription is attempted
        // and independent of whether it succeeds. Fire-and-forget so a slow or
        // failed upload never delays the sheet, and never blocks the transcript
        // the surveyor is waiting to see.
        Promise.resolve(uploadNoteAudio(noteId)).catch(() => {});
        // Now attempt transcription in the background — never deletes the note.
        // SLICE-A5 (review note 3): after a refused save the sheet already
        // says the recording was not saved; a transcription message must not
        // replace that with a claim that it is saved to this note.
        const _sheetSaidMsg = (m) => { if (saveResult.ok) setVoiceSheetError(m); };
        updateVoiceNote(noteId, { transcriptionStatus: 'transcribing' });
        try {
          const fd = new FormData();
          fd.append('audio', blob, 'voice.webm');
          const resp = await fetch(PORTAL_URL + '/api/voice-transcribe', _transcribeFetchInit(fd));
          if (resp.ok) {
            const data = await resp.json();
            const transcript = data.text || data.transcript || '';
            if (transcript) {
              updateVoiceNote(noteId, { transcriptionStatus: 'done', transcript, transcribedAt: new Date().toISOString() });
              setVoiceSheetText(prev => prev ? prev + ' ' + transcript : transcript);
            } else {
              updateVoiceNote(noteId, { transcriptionStatus: 'failed' });
            }
          } else {
            // Keep pending so the retry loop in VoiceNotesScreen will pick it up.
            updateVoiceNote(noteId, { transcriptionStatus: 'pending' });
            // S1 — say what actually happens. The old copy promised a retry
            // that only fired if the user later opened the standalone Voice
            // Notes screen by hand. The recording is now on the note itself.
            try { console.warn(`[voice-sheet] transcribe HTTP ${resp.status}`); } catch (e2) {}
            // CHIP-COST-V1 — a refusal is not "no signal"; say which it was.
            if (resp.status === 401) {
              _sheetSaidMsg('Transcription needs you to sign in again. The recording is saved to this note and will transcribe once you have.');
            } else if (resp.status === 429) {
              _sheetSaidMsg('Transcription limit reached for this hour. The recording is saved to this note and will transcribe later.');
            } else {
              _sheetSaidMsg('No signal for transcription. The recording is saved to this note. Play it back and type it up when you are back online.');
            }
          }
        } catch(e) {
          console.error('[voice-sheet] Transcription failed:', e);
          updateVoiceNote(noteId, { transcriptionStatus: 'pending' });
          _sheetSaidMsg('No signal for transcription. The recording is saved to this note. Play it back and type it up when you are back online.');
        }
      };
      mediaRecorderRef.current = recorder;
      recorder.start();
      voiceSheetStartedAtRef.current = Date.now();
      setVoiceSheetRecTime(0);
      setVoiceSheetRecording(true);
      // Start timer — exactly 1000ms, single interval, cleared on stop
      if (voiceSheetTimerRef.current) clearInterval(voiceSheetTimerRef.current);
      voiceSheetTimerRef.current = setInterval(() => setVoiceSheetRecTime(prev => prev + 1), 1000);
    } catch(e) {
      console.warn('Mic access failed:', e);
      voiceSheetStartingRef.current = false;
      voiceSheetFinalisingRef.current = false;
      setVoiceSheetFinalising(false);
      setVoiceSheetError('Microphone access denied, check browser settings');
    }
  };

  const saveVoiceSheetNote = () => {
    // S1 (reviewer FLAG-05) — refuse rather than silently discard. The button
    // is disabled while recording; this is the belt to that brace, because
    // recorder.onstop has not run yet and there is genuinely nothing to save.
    if (voiceSheetRecording) { stopVoiceSheetRecorder(); return; }
    // Read the REF, not the state: the state lags the stop tap by a render.
    if (voiceSheetFinalisingRef.current || voiceSheetFinalising) return;
    // S136 — append a stacked voice note to the active area (or the whole project).
    // S1 — WHAT to save is decided by the pure deriveNoteToSave: a failed
    // transcription still yields a note, carrying its audio, marked pending.
    const key = voiceKey;
    const decided = deriveNoteToSave({
      transcript: voiceSheetText,
      audioRef: voiceSheetAudioIdRef.current,
      zoneId: key,
    });
    // SLICE-A4: the note carries how long the recording ran, so the Notes tab
    // can show it beside the time and the playback control.
    const _dur = decided && decided.audioRef ? voiceDurationFor(loadVoiceNotes(), decided.audioRef) : 0;
    if (decided) addNoteTo(key, _dur > 0 ? { ...decided, duration: _dur } : decided);
    setVoiceStoreTick(t => t + 1);
    voiceSheetSessionRef.current += 1;
    voiceSheetAudioIdRef.current = null;
    setVoiceSheetText('');
    setVoiceSheetError('');
    setVoiceSheetRecTime(0);
    setShowVoiceSheet(false);
    // S1 — a pending note earns one immediate retry: if the radio came back
    // between the failure and the save, it transcribes now rather than never.
    if (decided && decided.pending) { try { retryPendingVoiceTranscriptions(); } catch (e) {} }
  };

  // ── Zone tile total ──
  const zoneTileTotal = (fixId) =>
    zfEntries(currentZone).filter(e=>e.fixtureId===fixId).reduce((s,e)=>s+e.qty,0);

  // ── Select / clear fixture ──
  const tapFixture = (fixId) => {
    if (selFixId===fixId) { clearSel(); return; }
    const f = allFixtures().find(x=>x.id===fixId);
    setSelFixId(fixId);
    setSelExtras({}); setSelChips({}); setQty(1); setEmQty(0);
    setSelPrimary(f?.variants?.primary?.[0] || null);
    setSelSecondary(f?.variants?.secondary?.[0] || null);
  };

  const clearSel = () => {
    setSelFixId(null); setSelPrimary(null); setSelSecondary(null);
    setSelExtras({}); setSelChips({}); setQty(1); setEmQty(0);
  };

  // ── Log entry ──
  // S95 D6 — merge duplicate fixtures: when a logged entry has the same fixtureId / primary / secondary /
  // extras signature as an existing row in the same zone, increment qty + emQty instead of creating a new row.
  // P1: the rule now lives in fittingSignature / mergeFittingLines (module
  // level, test-locked) so the Copy sheet merges exactly as Log does.
  const entrySignature = fittingSignature;
  const mergeOrAppend = mergeFittingLines;

  const logEntry = () => {
    if (!selFixId) return;
    // Auto-create a zone if none exist
    if (!currentZone) {
      const autoName = 'Zone 1';
      const newZ = [autoName];
      setZones(newZ);
      setZIdx(0);
      persist(null, newZ);
      const f2 = allFixtures().find(x=>x.id===selFixId);
      if (!f2) return;
      const w2 = getWattages(selFixId, selPrimary, selSecondary);
      const entry2 = {
        uid: Date.now()+Math.random(), fixtureId: selFixId, fixtureName: f2.label,
        primary: selPrimary, secondary: selSecondary, extras: { ...selExtras, ...selChips },
        qty, emQty, existingW: f2.existingW || w2.existingW, ledW: f2.ledW || w2.ledW,
        cost: costOrNull(f2.cost), photos:[],
      };
      const newZF = { [autoName]: mergeOrAppend([], entry2) };
      setZoneFittings(newZF);
      persist(newZF, newZ);
      setSelPrimary(f2?.variants?.primary?.[0] || null);
      setSelSecondary(f2?.variants?.secondary?.[0] || null);
      setSelExtras({}); setSelChips({}); setQty(1); setEmQty(0);
      return;
    }
    const f = allFixtures().find(x=>x.id===selFixId);
    if (!f) return;
    const wattages = getWattages(selFixId, selPrimary, selSecondary);
    const entry = {
      uid: Date.now()+Math.random(),
      fixtureId: selFixId,
      fixtureName: f.label,
      primary: selPrimary,
      secondary: selSecondary,
      extras: { ...selExtras, ...selChips },
      qty, emQty,
      existingW: f.existingW || wattages.existingW,
      ledW: f.ledW || wattages.ledW,
      cost: costOrNull(f.cost),
      photos:[],
    };
    // S96 BRIEF A · D25 — merge into existing zone bucket via case-insensitive
    // lookup so a zone added as "Reception" but stored as "reception" still
    // accumulates fittings under one key.
    const _addKey = findZFKey(currentZone);
    const newZF = { ...zoneFittings, [_addKey]: mergeOrAppend(zoneFittings[_addKey] || [], entry) };
    setZoneFittings(newZF);
    persist(newZF, null);
    // reset to ready for another variant
    setSelPrimary(f?.variants?.primary?.[0] || null);
    setSelSecondary(f?.variants?.secondary?.[0] || null);
    setSelExtras({}); setSelChips({}); setQty(1); setEmQty(0);
  };

  const deleteEntry = (zone, uid) => {
    const newZF = { ...zoneFittings };
    const k = findZFKey(zone, newZF);
    if (!newZF[k]) return;
    newZF[k] = newZF[k].filter(e=>e.uid!==uid);
    if (!newZF[k].length) delete newZF[k];
    setZoneFittings(newZF);
    persist(newZF, null);
  };

  const updateEntryQty = (zone, uid, newQty) => {
    const q2 = parseInt(newQty);
    if (isNaN(q2) || q2 < 1) return;
    const newZF = { ...zoneFittings };
    const k = findZFKey(zone, newZF);
    if (!newZF[k]) return;
    // P1: lowering the quantity lowers EM with it; EM is never above the quantity.
    newZF[k] = newZF[k].map(e => e.uid === uid ? { ...e, qty: q2, emQty: clampEm(e.emQty || 0, q2) } : e);
    setZoneFittings(newZF);
    persist(newZF, null);
    setEditQtyId(null);
  };

  // S95 D5 — inline EM quantity edit on fixture row
  const updateEntryEmQty = (zone, uid, newEmQty) => {
    const n = parseInt(newEmQty);
    if (isNaN(n) || n < 0) return;
    const newZF = { ...zoneFittings };
    const k = findZFKey(zone, newZF);
    if (!newZF[k]) return;
    newZF[k] = newZF[k].map(e => e.uid === uid ? { ...e, emQty: clampEm(n, e.qty) } : e);
    setZoneFittings(newZF);
    persist(newZF, null);
    setEditEmId(null);
  };

  // S95 D12 — inline sensor/dimming on fixture row. Attribute value is stored in entry.extras
  // so signature-based merge still works (changing the attribute intentionally separates the row).
  const updateEntryAttr = (zone, uid, key, value) => {
    const newZF = { ...zoneFittings };
    const zk = findZFKey(zone, newZF);
    if (!newZF[zk]) return;
    newZF[zk] = newZF[zk].map(e => {
      if (e.uid !== uid) return e;
      const extras = { ...(e.extras || {}) };
      if (value == null || value === '' || value === 'none') delete extras[key];
      else extras[key] = value;
      return { ...e, extras };
    });
    setZoneFittings(newZF);
    persist(newZF, null);
  };

  // ── Zone nav ──
  const navZone = (d) => {
    const ni = zIdx+d;
    if (ni<0||ni>=zones.length) return;
    setZIdx(ni); clearSel();
  };

  const confirmAddZone = () => {
    const name = newZoneName.trim();
    if (!name) return;
    // S95 D5 D24 (third attempt) — reject duplicates at source. Previously a user
    // could add "Ground Floor" twice and both rows rendered in the Schedule list.
    // Case-insensitive match against existing zones; if duplicate, just jump to
    // the existing slot rather than creating a second row.
    const existingIdx = zones.findIndex(z => (z || '').toLowerCase().trim() === name.toLowerCase());
    if (existingIdx !== -1) {
      setZIdx(existingIdx);
      setNewZoneName(""); setAddingZone(false);
      clearSel();
      return;
    }
    const newZ = [...zones, name];
    setZones(newZ); setZIdx(newZ.length-1);
    setNewZoneName(""); setAddingZone(false);
    clearSel(); persist(null, newZ);
  };

  const confirmRenameZone = () => {
    const newName = renameText.trim();
    if (!newName || !currentZone) { setRenamingZone(false); return; }
    const oldName = currentZone;
    const newZ = zones.map(z => z === oldName ? newName : z);
    setZones(newZ);
    // S96 BRIEF A · D25 — rename via case-insensitive lookup so the entry
    // bucket is found even when oldName casing has drifted from the key.
    const oldKey = findZFKey(oldName);
    if (zoneFittings[oldKey]) {
      const newZF = { ...zoneFittings };
      newZF[newName] = newZF[oldKey];
      if (newName !== oldKey) delete newZF[oldKey];
      setZoneFittings(newZF);
      persist(newZF, newZ);
    } else {
      persist(null, newZ);
    }
    // Update zoneNotes key — keep ref in sync so subsequent saveSurveyActive
    // flushes use the renamed map, not the stale pre-rename one.
    if (zoneNotes[oldName]) {
      const updNotes = { ...zoneNotes };
      updNotes[newName] = updNotes[oldName];
      delete updNotes[oldName];
      zoneNotesRef.current = updNotes;
      setZoneNotes(updNotes);
    }
    // S1 (reviewer FLAG-08) — carry the voice store's zone stamps across the
    // rename too. Without this a recording keeps pointing at the old name and
    // the reconcile sweep can no longer place it (the zone gate refuses a name
    // the survey no longer has), so it would silently stop being adoptable.
    try {
      const _vAll = loadVoiceNotes();
      let _vHit = false;
      const _vNext = _vAll.map((v) => {
        if (v && v.context === 'survey' && v.projectId === activeProject?.id && v.zone === oldName) {
          _vHit = true;
          return Object.assign({}, v, { zone: newName });
        }
        return v;
      });
      if (_vHit) {
        const _vRes = persistVoiceNotes(_vNext);
        // §9 — persistVoiceNotes drops the oldest base64 blobs under quota
        // pressure. A rename is not a destructive action and must not become a
        // silent audio-loss path. (reviewer finding 8)
        if (_vRes && (_vRes.audioPruned || _vRes.ok !== true)) {
          showSavedToast(_vRes.ok === true
            ? 'Renamed. ' + voiceStoreMessage(_vRes)
            : 'Renamed, but storage is full, so recordings still point at the old name');
        }
      }
    } catch (e) { /* rename must never fail on the audio sidecar */ }
    setRenamingZone(false);
  };

  // ── Custom fitting ──
  const saveCustomFitting = () => {
    if (!cName.trim()) return;
    const nameNow = cName.trim(), oldWNow = parseFloat(cOldW)||0, newWNow = parseFloat(cNewW)||0;
    // P1: the same name and wattages is the same fitting. Reuse its tile rather
    // than stacking a second one, so typing it again in another area is one tap.
    const sigNow = customFittingSig(nameNow, oldWNow, newWNow);
    const sameTile = customFittings.find(f => customFittingSig(f.label, f.existingW, f.ledW) === sigNow);
    const id = sameTile ? sameTile.id : "cx-"+Date.now();
    if (!sameTile) {
      const nf = makeCustomTile(id, nameNow, oldWNow, newWNow);
      const nextTiles = [...customFittings, nf];
      setCustomFittings(nextTiles);
      // P1: kept with the job, not just on this screen.
      if (activeProject?.id && onUpdateProject) {
        onUpdateProject(activeProject.id, { customFittings: nextTiles.map(f => ({ id:f.id, label:f.label, existingW:f.existingW, ledW:f.ledW })) });
      }
    }
    setShowCustomModal(false); setCName(""); setCOldW(""); setCNewW("");
    tapFixture(id);
  };

  // ── Photo ──
  // S105 — capture-time upload. Pre-S105 photos waited as base64 in
  // localStorage until wrap submit, where 20 of them fired Promise.all
  // and 16 silently dropped on Chelsea Harbour LTE. Now: every captured
  // photo POSTs to /api/photo immediately. Success → src replaced
  // with URL in component AND project state. Failure → entry queued
  // in lumen_photo_retry_queue with exponential backoff, photo flagged
  // uploadFailed so the UI shows a red dot.
  // S136 — reliable capture. ROOT CAUSE of the production silent-drop:
  // compressImage rejects on HEIC / oversized files (img.onerror=reject), the
  // await threw, and the only catch was console.error — the photo vanished with
  // a "Photo saved" toast that had already fired. Now: compress with a raw
  // data-URL fallback (never reject), then route through savePhotoReliable which
  // writes the durable IndexedDB blob FIRST and confirms only AFTER that write.
  const handlePhotoFile = async (file) => {
    if (!file) return;
    const targetZone = photoTargetZone || (projectMode ? null : currentZone) || null;
    let dataUrl = null, rawBlob = null;
    try {
      dataUrl = await compressImage(file, 1280, 0.6);
    } catch (e) {
      debugLog('photo.compress.fallback', { error: (e && e.message) || String(e), name: file && file.name, size: file && file.size });
      try { dataUrl = await blobToDataUrl(file); } catch (e2) { dataUrl = null; }
      if (!dataUrl) rawBlob = file;  // last resort — keep the original blob, never drop
    }
    await savePhotoReliable({ dataUrl, rawBlob, zone: targetZone, label: 'Site photo' });
  };

  // S136 — video now confirms (production had no confirmation at all). Blob is
  // stored durably in IndexedDB by id first; the blob: URL is session-only.
  const handleVideoFile = async (file) => {
    if (!file) return;
    const targetZone = photoTargetZone || (projectMode ? null : currentZone) || null;
    const videoId = _photoIdSeq();
    let idbOk = false;
    try { idbOk = await idbPutBlob(videoId, file, { type: 'video', label: 'Video walkthrough', zone: targetZone }); } catch (e) {}
    debugLog('video.idb.stored', { projectId: activeProject?.id || null, id: videoId, ok: idbOk });
    const url = URL.createObjectURL(file);
    const ts = new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
    const vid = { id: videoId, type: "video", src: url, fileName: file.name, ts, zone: targetZone, label: "Video walkthrough" };
    setSitePhotos(prev => {
      const updated = [...prev, vid];
      if (activeProject?.id && onUpdateProject) onUpdateProject(activeProject.id, { sitePhotos: updated });
      return updated;
    });
    setPhotoTargetZone(null);
    showSavedToast('Video saved');
    flashSaved();
  };

  // ── Variant description ──
  const varDesc = (f) => {
    if (!f) return "";
    const extras=(f.customExtras||[]).filter(cx=>!cx.showIf||selPrimary===cx.showIf);
    const parts=[];
    if (selPrimary) parts.push(selPrimary);
    if (selSecondary) parts.push(selSecondary);
    extras.forEach(cx=>{
      const v=cx.type==="chips"?selChips[cx.key]:selExtras[cx.key];
      if(v) parts.push(v);
    });
    return parts.join(" · ");
  };

  const selFixture = allFixtures().find(x=>x.id===selFixId)||null;
  const activeExtras = selFixture ? (selFixture.customExtras||[]).filter(cx=>!cx.sizeAlias&&(!cx.showIf||selPrimary===cx.showIf)) : [];
  const currentEntries = zfEntries(currentZone);
  const zoneHasEntries = currentEntries.length>0;

  // ════════════════════════════════════════════════════════════════
  // S136 — two-level Live survey (Areas list → Area/Project workspace)
  // ════════════════════════════════════════════════════════════════
  const [lview, setLview] = useState('list');            // 'list' | 'area'
  // P1: "Not on this job" hides the count offer for this job on this phone (a
  // per-viewer convenience, so browser storage; an unreadable store shows the offer).
  const scanOfferKey = 'lumen_scan_offer_off_' + (activeProject?.id || '');
  const readScanOfferOff = () => { try { return localStorage.getItem(scanOfferKey) === '1'; } catch (e) { return false; } };
  const [scanOfferOff, setScanOfferOff] = useState(readScanOfferOff);
  useEffect(() => { setScanOfferOff(readScanOfferOff()); }, [scanOfferKey]);
  const setScanOfferFor = (off) => {
    setScanOfferOff(off);
    try { if (off) localStorage.setItem(scanOfferKey, '1'); else localStorage.removeItem(scanOfferKey); } catch (e) {}
  };
  const [uvShotId, setUvShotId] = useState(null);       // STUDIO-LIT-PHONE-V1 item 7: the photo shown large (switch on)
  const [projectMode, setProjectMode] = useState(false); // whole-project workspace
  // SLICE-A4: where a voice note files (the open area, else Site-wide).
  const voiceKey = voiceTargetKey({ projectMode, lview, currentZone });
  const voiceIsSite = voiceKey === VOICE_SITE_KEY;
  const [seg, setSeg] = useState('fix');                 // 'fix' | 'media' | 'notes'
  const [doneZones, setDoneZones] = useState(() => activeProject?.doneZones || {});
  const [wrapBtnPressed, setWrapBtnPressed] = useState(false); // S163 — area-list Wrap up press feedback

  // Attribute-sheet additions (S136 — Sensor/Dim moved into the sheet + Custom size)
  const [selSizeCustom, setSelSizeCustom] = useState('');
  // S159 — typed values for chips extras that offer a 'Custom' chip (e.g. the
  // downlight cutout). Keyed by the extra's key; the typed value replaces the
  // literal 'Custom' marker at commit, mirroring the size's selSizeCustom.
  const [selChipCustom, setSelChipCustom] = useState({});
  // S161 — optional free-text Description. Hand-typed or pre-filled from a
  // vision scan's read description (the table-lamp case: type Decorative,
  // identity in the description). Persists as extras.description.
  const [selDesc, setSelDesc] = useState('');
  const [selSensorSel, setSelSensorSel] = useState('None');
  const [selSensorCustom, setSelSensorCustom] = useState('');
  const [selDimSel, setSelDimSel] = useState('None');
  const [selDimCustom, setSelDimCustom] = useState('');
  // The sheet's "More options" (Sensor, Dimming): null until the surveyor taps
  // it, so it opens by itself while either holds a value (moreOptionsIsOpen).
  const [moreOpen, setMoreOpen] = useState(null);
  const [editFitUid, setEditFitUid] = useState(null);    // uid being edited via card tap

  // S153 — fitting scan (on-demand /api/vision). The review sheet lists what the
  // scan proposed; each fitting opens the existing attribute sheet pre-filled and
  // is only saved when the surveyor taps Log. scanProvenance flags a sheet the
  // scan pre-filled so the "from photo" mark shows; it clears on any manual edit.
  // S154 — accumulating results collector. Each scan is one call = one proposal,
  // pushed onto scanQueue tied to its source photo + zone. The pill counts pending
  // proposals IN THE CURRENT AREA, opening it steps through them one at a time.
  // Survey and snag never mix (separate components); within the survey, the queue
  // is scoped to the current area so area A's results never bleed into area B.
  const [scanQueue, setScanQueue] = useState([]);         // [{id, photoId, zone, proposal}]
  const [scanBusy, setScanBusy] = useState(null);         // null | {running, photoId}|{error, photoId}
  const [scanOpenId, setScanOpenId] = useState(null);     // queue entry id shown in the review sheet
  const [scanReviewOpen, setScanReviewOpen] = useState(false);
  const [scanProvenance, setScanProvenance] = useState(false);

  // ── S138 — Survey wiring for the shared capture engine (one code path) ──
  // savePhotoReliableCore + useBurstCamera are module-level and shared with the
  // Snag tool. The survey owns only WHERE a photo lands: append to sitePhotos,
  // then swap base64 → uploaded URL when the background upload completes.
  // SEND-STATE-V1: a photo taken with its base64 in hand is about to upload;
  // uploadState 'pending' rides on the stored copy (it survives a restart,
  // when the base64 is only in IndexedDB) until its url lands.
  const _addSitePhoto = (p) => {
    const stamped = p && _isB64(p.src) && !p.url ? Object.assign({}, p, { uploadState: 'pending' }) : p;
    setSitePhotos(prev => { const updated = [...prev, stamped]; if (activeProject?.id && onUpdateProject) onUpdateProject(activeProject.id, { sitePhotos: updated }); return updated; });
  };
  const _setSitePhotoUrl = (id, url) => {
    setSitePhotos(prev => { const updated = prev.map(ph => ph && ph.id === id ? photoWithUrl(ph, url) : ph); if (activeProject?.id && onUpdateProject) onUpdateProject(activeProject.id, { sitePhotos: updated }); return updated; });
  };
  const cam = useBurstCamera({
    uploadProjectId: activeProject?.id || null,
    onAdd: (p) => { _addSitePhoto(p); flashSaved(); },
    onUrl: _setSitePhotoUrl,
    onFileFallback: (z) => { setPhotoTargetZone(z || (projectMode ? null : currentZone) || null); setTimeout(() => { if (photoInputRef.current) photoInputRef.current.click(); }, 50); },
    onClosed: (n) => { if (n > 0) showSavedToast(`${n} photo${n > 1 ? 's' : ''} saved`); },
  });

  // S162 — keep the LOCAL sitePhotos in step with background retry-queue
  // uploads while the survey is open. flushPhotoRetryQueue dispatches
  // lumenPhotoUploaded / lumenPhotoFailed; the App-level handler turns those
  // into projects / activeProject updates, but this screen renders its Media
  // grid from its own sitePhotos state (seeded once at mount). Without this
  // listener a photo captured offline that finished uploading mid-survey kept
  // its in-progress spinner until a remount. Same events, same matching as the
  // App handler, applied in place via the test-locked pure helpers.
  useEffect(() => {
    const pid = activeProject?.id || null;
    if (!pid) return undefined;
    const onUploaded = (e) => {
      const { projectId, oldSrc, newUrl, photoId, keepExisting } = e.detail || {};
      if (projectId !== pid || (!oldSrc && !photoId) || !newUrl) return;
      setSitePhotos(prev => applyPhotoUploaded(prev, oldSrc, newUrl, photoId, keepExisting));
    };
    const onFailed = (e) => {
      const { projectId, src, photoId } = e.detail || {};
      if (projectId !== pid || (!src && !photoId)) return;
      setSitePhotos(prev => applyPhotoFailed(prev, src, photoId));
    };
    window.addEventListener('lumenPhotoUploaded', onUploaded);
    window.addEventListener('lumenPhotoFailed', onFailed);
    return () => {
      window.removeEventListener('lumenPhotoUploaded', onUploaded);
      window.removeEventListener('lumenPhotoFailed', onFailed);
    };
  }, [activeProject?.id]);

  // ── Stacked notes model (arrays per area + project) ──
  // Legacy zoneNotes values were plain strings; migrate lazily on read so we
  // never rewrite the whole map. New notes append {id,type,body,t,at}. The
  // wrap payload flattens arrays back to the portal's {zone: string} contract.
  const _toNoteArray = (val) => {
    if (Array.isArray(val)) return val;
    if (typeof val === 'string' && val.trim()) return [{ id: 'legacy', type: 'text', body: val, t: '' }];
    return [];
  };
  const notesFor = (key) => _toNoteArray((zoneNotesRef.current || zoneNotes || {})[key]);
  const _noteId = () => 'n_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 7);
  const _nowHM = () => { const d = new Date(); return ('0' + d.getHours()).slice(-2) + ':' + ('0' + d.getMinutes()).slice(-2); };
  const _commitNotes = (updated) => {
    notesSavedRef.current = true;
    zoneNotesRef.current = updated;
    setZoneNotes(updated);
    try { saveSurveyActive({ zoneNotes: updated }); } catch (e) {}
    if (activeProject?.id && onUpdateProject) onUpdateProject(activeProject.id, { zoneNotes: updated });
  };
  // S1 (reviewer BLOCK-03) — the reconcile sweep registers its listeners once,
  // on mount, so it would otherwise hold the MOUNT render's _commitNotes. That
  // closure's saveSurveyActive rebuilds the WHOLE survey_active draft from
  // mount-time `zones`, `zoneFittings` and `sitePhotos` — so a sweep firing
  // after the user added a zone or a fitting would silently write those back
  // out of the draft, and the loss would only surface on cold-start resume.
  // Exactly the S95/S135 class this codebase has already paid for. Re-synced
  // every render; the sweep calls through the ref, never the closure.
  // One storage warning per wedged store, not one per sweep (see _stampWarning).
  const _stampWarnedRef = useRef({});
  const commitNotesRef = useRef(_commitNotes);
  commitNotesRef.current = _commitNotes;
  // Same reason: adoption must be scoped against the zone list as it is NOW.
  // NOTE: `zones` is an array of zone-name STRINGS (see `currentZone = zones[zIdx]`),
  // which is what reconcile's knownZones.indexOf() check requires. If this ever
  // becomes an array of objects, zoneAllowed() silently refuses every zone and
  // adoption stops — with every unit test still green.
  const zonesRef = useRef(zones);
  zonesRef.current = zones;
  // S1 — a note may now be PENDING: empty body, but owning an audioRef. That
  // is the recording whose transcription failed, and it must exist the moment
  // the user taps Save. A note with NEITHER body nor audio is still refused —
  // we are removing a silent discard, not starting to create empty notes.
  // §9 — the watermark is a WRITE, and persistVoiceNotes drops the oldest audio
  // under quota pressure (and, in its last-ditch branch, every recording but
  // one). Three of the four stamp sites used to discard that result, so a
  // failed stamp silently downgraded considered-once to best-effort while the
  // user was told their note was saved. Report it everywhere instead. Mirrors
  // the existing three-tier storage message on the standalone screen.
  // Returns the storage warning to show, or '' when the write was clean. It does
  // NOT toast: showSavedToast appends a fixed pill at one fixed position, so two
  // calls in a single action stack two pills at identical coordinates and the
  // later one paints over the earlier. The warning this exists to surface would
  // have been hidden underneath the success message that followed it one line
  // later. The caller emits exactly ONE toast, warning first.
  const _stampWarning = (ids, context) => {
    const r = markVoiceNotesConsidered(ids);
    if (!r || r.ok !== true) {
      // Once per wedged store, not once per sweep. The sweep fires on mount, on
      // foreground, on `online` and on a 5-minute interval, so without this the
      // surveyor is nagged every time they pick the phone up, about something
      // they did not do.
      // Keyed by CONTEXT, not one flag: a save-context failure must not
      // silence the delete-context message, whose consequence is different
      // (that message is the one predicting a resurrection).
      const _k = context || 'save';
      if (_stampWarnedRef.current[_k]) return '';
      _stampWarnedRef.current[_k] = true;
      return context === 'delete'
        ? 'Storage is full, so this device could not record the deletion. That recording may come back.'
        : 'Storage is full, so this device could not file the audio against the note.';
    }
    return voiceStoreMessage(r);
  };
  const addNoteTo = (key, note) => {
    if (!key) return;
    const body = (note && note.body || '').trim();
    const audioRef = (note && note.audioRef) ? String(note.audioRef) : null;
    if (!body && !audioRef) return;
    const base = zoneNotesRef.current || zoneNotes || {};
    const arr = _toNoteArray(base[key]);
    // One recording, one note. A sweep can fire while the voice sheet is still
    // open — reading the transcript, or following "play it back and type it up"
    // — and ADOPT the recording that was persisted at onstop. Without this the
    // subsequent Save appended a second note with the same audioRef, and
    // flattenZoneNotesForPayload would ship the body to the portal twice.
    if (audioRef) {
      const owned = arr.find(n => n && n.audioRef && String(n.audioRef) === audioRef);
      if (owned) {
        // The adopted note IS this note. Update it, never create a second one.
        const decided = decideOwnedNoteUpdate(owned, body);
        if (decided.action === 'fill') {
          updateNoteIn(key, owned.id, { body: decided.body, pending: false });
        } else {
          flashSaved();
        }
        const _warn = _stampWarning([audioRef], 'save');
        showSavedToast(_warn || (decided.action === 'fill' ? 'Voice note saved' : 'Recording already saved to this note'));
        return;
      }
    }
    const entry = {
      id: _noteId(),
      type: note.type === 'voice' ? 'voice' : 'text',
      body,
      audioRef,
      pending: !body && !!audioRef,
      t: _nowHM(),
      at: Date.now(),
      // SLICE-A4: only when known, so a text note's shape is unchanged.
      ...(Number(note && note.duration) > 0 ? { duration: Math.round(Number(note.duration)) } : {}),
    };
    _commitNotes({ ...base, [key]: [...arr, entry] });
    // This note now OWNS its recording, so the recording has had its one
    // chance at adoption. Without this stamp, deleting a normally-saved note
    // left its recording unconsidered and the next sweep adopted it straight
    // back, toasting "1 earlier recording restored to notes".
    const _warn = audioRef ? _stampWarning([audioRef], 'save') : '';
    showSavedToast(_warn || (entry.pending ? 'Recording saved to note' : (entry.type === 'voice' ? 'Voice note saved' : 'Note saved')));
    flashSaved();
  };
  // S1 — play a pending note's audio without leaving the zone. The audio
  // lives in lumen_voice_notes (there is still no audio upload endpoint — that
  // is its own slice), so we resolve it by audioRef and refuse honestly when
  // the blob has been pruned out from under us rather than showing a dead
  // control. §9: an unplayable note says so.
  // Which recordings still have audio on the device? Storage pressure prunes the
  // oldest base64 blobs (persistVoiceNotes) while keeping the metadata.
  //
  // Built ONCE per render of the notes list, not once per note: lumen_voice_notes
  // holds the base64 blobs, so a per-note JSON.parse meant megabytes parsed
  // synchronously on every keystroke-driven re-render. (reviewer finding 7)
  // SLICE-A4: the same single read also yields each recording's length (for the
  // notes that predate the duration field, e.g. adopted ones) and the
  // Unassigned notes list, so the megabytes are still parsed once.
  const _voiceIndex = React.useMemo(() => {
    const s = {};
    const dur = {};
    let unassigned = [];
    try {
      // S4b — "playable" now means local bytes OR a portal URL. Without the
      // second clause an uploaded note loses its play affordance even though
      // the recording is safe and streamable.
      const store = loadVoiceNotes();
      store.forEach((v) => {
        if (v && v.id && (voiceHasLocalAudio(v) || v.audioUrl)) s[String(v.id)] = true;
        if (v && v.id) { const d = voiceDurationFor([v], v.id); if (d > 0) dur[String(v.id)] = d; }
      });
      const binding = getProjectBinding(activeProject);
      unassigned = unassignedVoiceNotes(store, {
        projectId: activeProject && activeProject.id,
        bindingId: binding && binding.project_id,
      }, zoneNotesRef.current || zoneNotes);
    } catch (e) { /* no audio index is better than a throw mid-render */ }
    return { present: s, dur, unassigned };
  }, [zoneNotes, playingNoteId, voiceStoreTick, activeProject && activeProject.id]);
  const _audioPresentRefs = _voiceIndex.present;
  const unassignedNotes = _voiceIndex.unassigned;
  const _noteAudioAvailable = (note) => !!(note && note.audioRef && _audioPresentRefs[String(note.audioRef)]);
  const playNoteAudio = (note) => {
    // SEC-028: any tap stops what is playing AND cancels a portal fetch still
    // in flight (a second tap on the same note is "stop", and must not start
    // playing when the fetch lands). stop() detaches the old element's
    // handlers first, so it cannot touch the next note's state.
    if (noteAudioElRef.current) { noteAudioElRef.current.stop(); noteAudioElRef.current = null; }
    if (playingNoteId === note.id) { setPlayingNoteId(null); return; }
    const vn = loadVoiceNotes().find(v => v && String(v.id) === String(note.audioRef));
    if (!vn) { showSavedToast('That recording is no longer on this device'); return; }
    // S4b — bytes may have been reclaimed AFTER a successful upload, which is
    // not the same thing as being pruned away. Play from the portal instead;
    // only say "cleared" when the recording is genuinely gone.
    if (!voiceHasLocalAudio(vn) && !vn.audioUrl) { showSavedToast('That audio was cleared to free storage'); return; }
    setPlayingNoteId(note.id);
    // SEC-028: started here, inside the tap (the iOS unlock). A refused play(),
    // an element error, a portal refusal (401/403) or no signal all say the
    // same words as before, and clear "playing".
    noteAudioElRef.current = _playVoiceSource({
      localSrc: vn.audioBase64 ? `data:${vn.audioMimeType || 'audio/webm'};base64,${vn.audioBase64}` : null,
      localLoad: (!vn.audioBase64 && vn.audioInIdb) ? () => voiceAudioBlob(vn) : null,
      audioUrl: vn.audioUrl,
      onEnded: () => { setPlayingNoteId(null); noteAudioElRef.current = null; },
      onFail: () => { setPlayingNoteId(null); noteAudioElRef.current = null; showSavedToast('Could not play that recording'); },
    });
  };

  // S1 — patch ONE note in place. Used by "Type it up" and by the voice-store
  // reconcile. Goes through _commitNotes like add and delete, so there is still
  // exactly one write path for the notes map (§5, one derivation).
  const updateNoteIn = (key, id, patch) => {
    if (!key || !id) return;
    const base = zoneNotesRef.current || zoneNotes || {};
    const arr = _toNoteArray(base[key]);
    let hit = false;
    const next = arr.map((n) => {
      if (!n || n.id !== id) return n;
      hit = true;
      return Object.assign({}, n, patch);
    });
    if (!hit) return;
    _commitNotes({ ...base, [key]: next });
    flashSaved();
  };
  // SLICE-A4: file an Unassigned recording (a header-mic note made outside any
  // area) onto an area, or keep it Site-wide. It goes through addNoteTo like
  // every other voice note: one write path, the recording's audioRef kept, no
  // voice_note_logged (the header mic already sent its one event when it was
  // recorded). The note is committed FIRST; only then is the recording stamped
  // with its container. If that stamp fails the note still owns the audioRef,
  // so the list still drops it and nothing is lost or doubled.
  const moveUnassignedNote = (vn, key) => {
    if (!vn || !key) return;
    const decided = deriveNoteToSave({ transcript: vn.transcript, audioRef: vn.id, zoneId: key });
    if (!decided) return;
    const dur = voiceDurationFor([vn], vn.id);
    addNoteTo(key, dur > 0 ? { ...decided, duration: dur } : decided);
    // The note now owns the recording (addNoteTo stamped it considered). The
    // zone stamp is the voice store's own record of where it went; if storage
    // refuses it, say so rather than claim it.
    const _zw = updateVoiceNote(vn.id, { zone: key });
    if (_zw && _zw.ok !== true && !_zw.notFound) showSavedToast(voiceStoreMessage(_zw));
    setMoveOpenId(null);
    setVoiceStoreTick(n => n + 1);
  };
  // SLICE-A4 (review round 1): a Site-wide voice note (one recorded with no
  // area open, on the Areas list or the Site-wide workspace) can be moved to an
  // area. One commit (moveNoteBetween), so it is never in two places.
  const moveSiteNote = (noteId, toKey) => {
    const base = zoneNotesRef.current || zoneNotes || {};
    const note = _toNoteArray(base[VOICE_SITE_KEY]).find(n => n && n.id === noteId);
    const next = moveNoteBetween(base, VOICE_SITE_KEY, noteId, toKey);
    if (!next || !note) return;
    _commitNotes(next);
    if (note.audioRef) {
      const _zw = updateVoiceNote(String(note.audioRef), { zone: toKey });
      if (_zw && _zw.ok !== true && !_zw.notFound) showSavedToast(voiceStoreMessage(_zw));
    }
    setMoveOpenId(null);
    setVoiceStoreTick(n => n + 1);
    flashSaved();
  };
  const deleteNoteFrom = (key, id) => {
    const base = zoneNotesRef.current || zoneNotes || {};
    const arr = _toNoteArray(base[key]);
    logDestructiveAction('survey.note.delete', { projectId: activeProject?.id || null, key, id });
    // Burn the recording's adoption chance on the way out. addNoteTo and the
    // sweep both stamp already, so this is the belt to that brace — it makes
    // the delete permanent no matter which author created the note, and no
    // matter whether a sweep has run yet. The audio itself is left alone and
    // stays listed on the standalone Voice Notes screen.
    const _goneNote = arr.find(n => n && n.id === id);
    if (_goneNote && _goneNote.audioRef) {
      const _warn = _stampWarning([String(_goneNote.audioRef)], 'delete');
      if (_warn) showSavedToast(_warn);
    }
    const next = arr.filter(n => n.id !== id);
    const updated = { ...base, [key]: next };
    if (next.length === 0) delete updated[key];
    _commitNotes(updated);
    flashSaved();
  };

  // ── S1 — fold the voice store back into the notes map ────────────────
  // Runs on survey open, on foreground, on the portal sync tick, and whenever
  // the lifted retry lands a transcript. Two jobs in one pure sweep
  // (reconcileZoneNotesWithVoice): fill pending notes whose audio has since
  // been transcribed, and ADOPT in-zone recordings that never became notes at
  // all — every one captured before S1 shipped, including anything already
  // stranded on a handset. Nothing is ever deleted: an orphan we cannot place
  // stays in the voice store, where the standalone screen still lists it.
  //
  // Declared AFTER the rehydrate effect on purpose — effects run in order, so
  // the resume path settles zoneNotes before this sweep adds to it.
  useEffect(() => {
    if (!activeProject?.id) return;
    const sweep = () => {
      const base = zoneNotesRef.current || zoneNotes || {};
      const res = reconcileZoneNotesWithVoice(
        base, loadVoiceNotes(), activeProject.id, zonesRef.current
      );
      // Stamp EVERY recording this sweep looked at as considered, BEFORE the
      // notes commit and regardless of whether anything was adopted. This is
      // what makes a delete permanent and what stops a claim-only sweep from
      // silently discarding its own work. It writes to the voice store, not to
      // the notes map, so it cannot be lost by the commit predicate below.
      // Commit FIRST, then stamp. If the app dies between the two, the next
      // sweep re-adopts (and claim (a) makes a duplicate impossible); stamping
      // first would burn the recording while losing the note it produced — the
      // worse failure, and likeliest under exactly the storage pressure this
      // feature lives in.
      if (res.adopted > 0 || res.filled > 0 || res.mutated) {
        commitNotesRef.current(res.zoneNotes);
        try { debugLog('survey.notes.reconciled', { projectId: activeProject.id, adopted: res.adopted, filled: res.filled }); } catch (e) {}
      }
      // One toast for the whole sweep, warning first: a storage failure is the
      // more important thing to say, and the two would otherwise overlap.
      const _warn = res.considered.length ? _stampWarning(res.considered, 'sweep') : '';
      if (res.considered.length) setVoiceStoreTick(t => t + 1);
      if (_warn) showSavedToast(_warn);
      else if (res.adopted > 0) showSavedToast(`${res.adopted} earlier recording${res.adopted > 1 ? 's' : ''} restored to notes`);
    };
    const sweepAndRetry = () => { sweep(); try { retryPendingVoiceTranscriptions(); } catch (e) {} };
    const stopAudio = () => {
      // SEC-028: stop() also cancels a portal fetch still in flight.
      if (noteAudioElRef.current) { noteAudioElRef.current.stop(); noteAudioElRef.current = null; }
    };
    const onVisible = () => { if (document.visibilityState === 'visible') sweepAndRetry(); };
    sweepAndRetry();
    document.addEventListener('visibilitychange', onVisible);
    window.addEventListener('online', sweepAndRetry);
    window.addEventListener('lumenDataSync', sweepAndRetry);
    window.addEventListener('lumenVoiceTranscribed', sweep);
    return () => {
      document.removeEventListener('visibilitychange', onVisible);
      window.removeEventListener('online', sweepAndRetry);
      window.removeEventListener('lumenDataSync', sweepAndRetry);
      window.removeEventListener('lumenVoiceTranscribed', sweep);
      stopAudio();   // never leave a note playing after the survey closes
    };
  }, [activeProject?.id]);

  // ── Navigation between list and workspaces ──
  const openArea = (i) => { setProjectMode(false); setZIdx(i); setSeg('fix'); setLview('area'); clearSelEx(); };
  const openProject = () => { setProjectMode(true); setSeg('media'); setLview('area'); clearSelEx(); };
  const backToList = () => { setLview('list'); setProjectMode(false); setRenamingZone(false); clearSelEx(); };
  // NOTES-IN-AREA, where the body scrolls. The Areas list and every area (and
  // Site-wide) are drawn in ONE scroller, and nothing reset it when the open view
  // changed: an area opened from a scrolled list, or reached by Next area from the
  // foot of the last one, came up at the old offset with its name, its tabs and
  // the note row scrolled off the top of the screen. Now every change of view
  // starts an area at the top, whatever route opened it (the list, Next or
  // Previous area, Area complete moving on, Site-wide, a tab change such as See
  // all notes), and the list keeps its own offset: it is remembered as the
  // surveyor scrolls it and put back on Back to areas. The offset is set in a
  // layout effect, once the new view's content is in the DOM and before it is
  // painted, and again on the next frame if the browser (WebKit, with touch
  // momentum or a late layout) left it elsewhere.
  const bodyScrollRef = useRef(null);
  const listScrollRef = useRef(0);
  const bodyOwnerRef = useRef(lview);
  bodyOwnerRef.current = lview;
  const bodyViewKey = lview === 'list' ? 'list' : (projectMode ? 'site' : 'area:' + zIdx) + ':' + seg;
  _useSheetLayoutEffect(() => {
    const el = bodyScrollRef.current;
    if (!el) return undefined;
    const top = lview === 'list' ? listScrollRef.current : 0;
    el.scrollTop = top;
    let raf = null;
    if (typeof requestAnimationFrame === 'function') {
      raf = requestAnimationFrame(() => { raf = null; if (Math.abs(el.scrollTop - top) > 1) el.scrollTop = top; });
    }
    return () => { if (raf !== null && typeof cancelAnimationFrame === 'function') cancelAnimationFrame(raf); };
  }, [bodyViewKey]);
  // S163 — ONE reused path into Wrap, identical to the stepper's
  // (persist(); onNav(11)). Always navigates: the surveyor decides when they
  // are finished, so the area-list "Wrap up" button is never hard-gated. The
  // stepper keeps its own (hasCompletedZones-gated) call untouched — this is an
  // additional, more obvious entry, not a replacement or a second navigation.
  // WRITE-UP-APP-V1: arriving from the survey asks about a report first.
  const goToWrap = () => { persist(); onNav(11, { askReport: true }); };
  const prevAreaNav = () => { if (zIdx > 0) { setProjectMode(false); setZIdx(zIdx - 1); setSeg('fix'); clearSelEx(); } };
  const nextAreaNav = () => { if (zIdx < zones.length - 1) { setProjectMode(false); setZIdx(zIdx + 1); setSeg('fix'); clearSelEx(); } };
  const toggleDone = (zone) => {
    const updated = { ...doneZones };
    if (updated[zone]) { delete updated[zone]; } else { updated[zone] = true; }
    setDoneZones(updated);
    if (activeProject?.id && onUpdateProject) onUpdateProject(activeProject.id, { doneZones: updated });
    if (updated[zone]) showSavedToast(zone + ' marked done');
    flashSaved();
    // P2B: with the switch on, marking an area done opens the complete moment.
    // What was saved above is unchanged; the moment only reads it.
    if (updated[zone] && t.theme === 'uv') { setDoneMoment(zone); setMomentError(''); }
  };
  // P2B: the area complete moment (lit only). `doneMoment` is the area just
  // marked done; the figures come from areaMoment, never stored.
  const [doneMoment, setDoneMoment] = useState(null);
  const [momentError, setMomentError] = useState('');
  const leaveMoment = (idx) => {
    setDoneMoment(null); setMomentError('');
    if (idx >= 0) openArea(idx); else backToList();
  };
  // "Copy them": the existing copy rule (planFittingCopy) and the existing
  // writer (persist), as the Copy sheet's confirm does. A refusal or a failed
  // write is said out loud and the surveyor stays on the moment.
  const copyIntoNext = (m) => {
    if (!m || !m.next) return;
    const plan = planFittingCopy({
      zoneFittings, zones, sourceZone: m.name,
      targets: [{ zone: m.next, mode: 'add' }],
      nextUid: () => Date.now() + Math.random(),
    });
    if (!plan.ok) { setMomentError(plan.message); return; }
    setZoneFittings(plan.zoneFittings);
    setZones(plan.zones);
    const saved = persist(plan.zoneFittings, plan.zones);
    // A failed write is said out loud on the next area (its Copy panel shows
    // the retry) and never toasted over as "Copied".
    setCopySaveFailed(!saved);
    if (saved) showSavedToast(copyDoneMessage(plan.summary));
    leaveMoment(m.nextIdx);
  };

  // ── P1: copy fittings between areas ──
  // The rule is planFittingCopy (module level, test-locked). This is only the
  // sheet's state and the one place the result is saved, through persist.
  //   copySheet  null, or { mode:'to'|'from', zone } for the area it was opened on
  const [copySheet, setCopySheet] = useState(null);
  const [copyPicked, setCopyPicked] = useState({});      // zoneKey -> true
  const [copyModes, setCopyModes] = useState({});        // zoneKey -> 'add' | 'replace'
  const [copyNewText, setCopyNewText] = useState('');
  const [copyNewNames, setCopyNewNames] = useState([]);  // areas that do not exist yet
  const [copyFromZone, setCopyFromZone] = useState(null);
  const [copyError, setCopyError] = useState('');
  const [copySaveFailed, setCopySaveFailed] = useState(false);
  const openCopySheet = (mode) => {
    setCopyPicked({}); setCopyModes({}); setCopyNewText(''); setCopyNewNames([]);
    setCopyFromZone(null); setCopyError('');
    setCopySheet({ mode, zone: currentZone });
  };
  const closeCopySheet = () => { setCopySheet(null); setCopyError(''); };
  const addCopyNames = () => {
    const srcK = zoneKey(copySheet ? copySheet.zone : '');
    const names = parseAreaNames(copyNewText);
    const picked = { ...copyPicked };
    const fresh = copyNewNames.slice();
    names.forEach(n => {
      const k = zoneKey(n);
      if (k === srcK) return;
      const existing = zones.find(z => zoneKey(z) === k);
      if (existing) { picked[k] = true; return; }
      if (!fresh.some(f => zoneKey(f) === k)) fresh.push(n);
    });
    setCopyPicked(picked); setCopyNewNames(fresh); setCopyNewText(''); setCopyError('');
  };
  // What the sheet would copy, derived once for the buttons and the confirm.
  const copyTargets = () => {
    if (!copySheet) return [];
    if (copySheet.mode === 'from') return [{ zone: copySheet.zone, mode: copyModes[zoneKey(copySheet.zone)] || 'add' }];
    const srcK = zoneKey(copySheet.zone);
    // Names typed but not yet added with the Add button still count, so the
    // confirm button never silently drops what is in the box.
    const fresh = copyNewNames.slice();
    const extra = {};
    parseAreaNames(copyNewText).forEach(n => {
      const k = zoneKey(n);
      if (k === srcK) return;
      if (zones.some(z => zoneKey(z) === k)) extra[k] = true;
      else if (!fresh.some(f => zoneKey(f) === k)) fresh.push(n);
    });
    return [
      ...zones.filter(z => (copyPicked[zoneKey(z)] || extra[zoneKey(z)]) && zoneKey(z) !== srcK)
        .map(z => ({ zone: z, mode: copyModes[zoneKey(z)] || 'add' })),
      ...fresh.map(n => ({ zone: n, mode: 'add' })),
    ];
  };
  const confirmCopy = () => {
    if (!copySheet) return;
    const sourceZone = copySheet.mode === 'from' ? copyFromZone : copySheet.zone;
    const plan = planFittingCopy({
      zoneFittings, zones, sourceZone, targets: copyTargets(),
      nextUid: () => Date.now() + Math.random(),
    });
    if (!plan.ok) { setCopyError(plan.message); return; }
    // Apply on screen, then write through the one writer. A failed write is
    // said out loud and never toasted over as "Copied".
    setZoneFittings(plan.zoneFittings);
    setZones(plan.zones);
    const saved = persist(plan.zoneFittings, plan.zones);
    setCopySheet(null); setCopyError('');
    if (saved) {
      setCopySaveFailed(false);
      showSavedToast(copyDoneMessage(plan.summary));
    } else {
      setCopySaveFailed(true);
    }
  };
  const retryCopySave = () => {
    if (persist()) { setCopySaveFailed(false); showSavedToast('Saved'); }
  };

  // ── Attribute-sheet helpers ──
  const _effSensor = () => selSensorSel === 'None' ? '' : (selSensorSel === 'Custom' ? selSensorCustom.trim() : selSensorSel);
  const _effDim = () => selDimSel === 'None' ? '' : (selDimSel === 'Custom' ? selDimCustom.trim() : selDimSel);
  const effSizeLabel = () => {
    if (selPrimary === 'Custom') return selSizeCustom.trim() || 'Custom';
    return [selPrimary, selSecondary].filter(Boolean).join(studioSep());
  };
  const clearSelEx = () => {
    clearSel();
    setSelSizeCustom(''); setSelChipCustom({}); setSelDesc(''); setSelSensorSel('None'); setSelSensorCustom('');
    setSelDimSel('None'); setSelDimCustom(''); setEditFitUid(null); setMoreOpen(null);
    setScanProvenance(false);
  };
  const tapFixtureSel = (fixId) => {
    if (selFixId === fixId && !editFitUid) { clearSelEx(); return; }
    const f = allFixtures().find(x => x.id === fixId);
    // P1: open on this type's most recent choices in this area (size, typed
    // size, cutout...), else on its first size. Quantity and EM never carry over.
    const areaKey = findZFKey(currentZone);
    const start = startingChoices(f, rememberedFor(lastChoicesRef.current, areaKey, zfEntries(currentZone), fixId, f));
    setSelFixId(fixId);
    setSelExtras({ ...start.extras }); setSelChips({ ...start.extras }); setQty(1); setEmQty(0);
    setSelPrimary(start.primary);
    setSelSecondary(start.secondary);
    setSelSizeCustom(start.sizeCustom); setSelChipCustom({ ...start.chipCustom }); setSelDesc(''); setSelSensorSel('None'); setSelSensorCustom('');
    setSelDimSel('None'); setSelDimCustom(''); setEditFitUid(null); setMoreOpen(null);
    setScanProvenance(false);
  };

  // S153 — run one fitting scan, then surface the proposal in the review sheet.
  // One tap = one sequential call = one proposal. The wait state shows on the
  // photo's own button (scanBusy.photoId); on success the proposal accumulates in
  // the queue and the pill count goes up. Offline / error fall back to manual: the
  // photo button shows a short message, nothing is queued, the survey is not blocked.
  const scanFitting = async (photo, zoneName) => {
    if (!photo) { showSavedToast('Add a photo to scan'); return; }
    const photoId = photo.id || null;
    if (scanBusy && scanBusy.running) return;   // sequential only — never fire parallel calls
    setScanBusy({ running: true, photoId });
    const res = await callVisionScan('fitting', photo, { area_name: zoneName || '', job_type: 'survey' });
    if (!res.ok) { setScanBusy({ error: res.error || 'Scan unavailable. Add fittings by hand.', photoId }); return; }
    const id = 'sc_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
    setScanQueue(q => [...q, { id, photoId, zone: zoneName || null, proposal: res.proposal || {} }]);
    setScanBusy(null);
    setScanOpenId(id);
    setScanReviewOpen(true);
  };
  // Remove one photo's proposal from the queue (the surveyor is done with it).
  const dismissScan = (id) => { setScanQueue(q => q.filter(e => e.id !== id)); };
  // Open the existing attribute sheet pre-filled from one scanned fitting. Nothing
  // is saved here — the surveyor confirms (and may correct) then taps Log.
  const prefillFitFromScan = (fitting) => {
    if (!fitting) return;
    const fixId = VISION_TYPE_TO_FIXTURE[fitting.type] || 'custom-btn';
    const f = allFixtures().find(x => x.id === fixId);
    setSelFixId(fixId);
    setSelExtras({}); setSelChips({});
    const count = Math.max(1, parseInt(fitting.count, 10) || 1);
    setQty(count);
    setEmQty(fitting.emergency ? count : 0);
    setSelSecondary(f?.variants?.secondary?.[0] || null);
    const sg = (fitting.size_guess && fitting.size_guess.value) ? String(fitting.size_guess.value) : '';
    if (sg) { setSelPrimary('Custom'); setSelSizeCustom(sg); }
    else { setSelPrimary(f?.variants?.primary?.[0] || null); setSelSizeCustom(''); }
    setSelChipCustom({});
    // S161 — the scan's read description lands in the editable Description
    // field (the table-lamp case: Decorative tile + 'table lamp' here).
    setSelDesc(descriptionFromScan(fitting));
    setSelSensorSel('None'); setSelSensorCustom(''); setSelDimSel('None'); setSelDimCustom(''); setMoreOpen(null);
    setEditFitUid(null);
    setScanProvenance(true);
    setSeg('fix');
    setScanReviewOpen(false);
  };
  const commitFitting = () => {
    const zone = currentZone;
    if (!selFixId || !zone) return;
    const f = allFixtures().find(x => x.id === selFixId);
    if (!f) return;
    const sensor = _effSensor(), dim = _effDim();
    // primary may be null (custom fixtures with no size list, legacy no-size
    // records) — every consumer handles it (wrap payload `e.primary || null`,
    // signature `e.primary || ''`, card label filters falsy). Keep it nullable.
    // The typed values stay in state when another size chip is tapped (so the
    // surveyor can come back to Custom and find them), so what is saved is
    // filtered here: only what the chosen size shows.
    const customSize = typedSizeToSave(selPrimary, selSizeCustom);
    const extras = dropHiddenExtras(f, selPrimary, { ...selExtras, ...selChips });
    if (sensor) extras.sensor = sensor; else delete extras.sensor;
    if (dim) extras.dim = dim; else delete extras.dim;
    if (customSize) extras.customSize = customSize; else delete extras.customSize;
    const desc = selDesc.trim();
    if (desc) extras.description = desc; else delete extras.description;
    // Chips extras with a 'Custom' chip: the typed value replaces the marker, so
    // the record carries the real value (e.g. dlCutout: '120mm'), never 'Custom'
    // unless the box was left empty.
    (f.customExtras || []).forEach(cx => {
      if (cx.type === 'chips' && extras[cx.key] === 'Custom') {
        const typed = (selChipCustom[cx.key] || '').trim();
        if (typed) extras[cx.key] = typed;
      }
    });
    const wattages = getWattages(selFixId, selPrimary, selSecondary);
    const base = {
      fixtureId: selFixId, fixtureName: f.label, primary: selPrimary, secondary: selSecondary,
      extras, qty, emQty: clampEm(emQty, qty),
      existingW: f.existingW || wattages.existingW, ledW: f.ledW || wattages.ledW, cost: costOrNull(f.cost),
    };
    const k = findZFKey(zone);
    // P1: remember this fitting's choices for the next one of its type in this area.
    const mem = choicesFromEntry(base, f);
    if (mem) lastChoicesRef.current = rememberChoice(lastChoicesRef.current, k, selFixId, mem);
    if (editFitUid) {
      const newZF = { ...zoneFittings };
      newZF[k] = (newZF[k] || []).map(e => e.uid === editFitUid ? { ...e, ...base, uid: e.uid, photos: e.photos || [] } : e);
      setZoneFittings(newZF); persist(newZF, null);
      showSavedToast('Fitting updated'); clearSelEx(); flashSaved();
    } else {
      const entry = { uid: Date.now() + Math.random(), ...base, photos: [] };
      const newZF = { ...zoneFittings, [k]: mergeOrAppend(zoneFittings[k] || [], entry) };
      setZoneFittings(newZF); persist(newZF, null);
      // P1: saving closes the sheet and leaves the area where it was. Tapping
      // the type again opens it on what was just logged (lastChoicesRef).
      showSavedToast(`Logged ${base.qty}× ${f.label}`); clearSelEx(); flashSaved();
    }
  };
  const editFitFromCard = (uid) => {
    const e = zfEntries(currentZone).find(x => x.uid === uid);
    if (!e) return;
    const fdef = allFixtures().find(x => x.id === e.fixtureId);
    setSelFixId(e.fixtureId);
    // null primary (legacy no-size record) edits with no size chip selected;
    // re-logging keeps primary: null — the S161 chip removal is UI-only.
    setSelPrimary(e.extras?.customSize ? 'Custom' : (e.primary || null));
    setSelSecondary(e.secondary);
    setSelSizeCustom(e.extras?.customSize || '');
    setSelDesc(e.extras?.description || '');
    const ex = { ...(e.extras || {}) }; delete ex.sensor; delete ex.dim; delete ex.customSize; delete ex.description;
    // Chips extras with a 'Custom' chip: a stored value not in the list is a
    // typed custom — re-select 'Custom' and restore the typed value.
    const chipCustom = {};
    (fdef?.customExtras || []).forEach(cx => {
      if (cx.type === 'chips' && (cx.chips || []).indexOf('Custom') > -1) {
        const v = ex[cx.key];
        if (v && (cx.chips || []).indexOf(v) === -1) { ex[cx.key] = 'Custom'; chipCustom[cx.key] = v; }
      }
    });
    setSelChipCustom(chipCustom);
    setSelExtras(ex); setSelChips(ex);
    setQty(e.qty); setEmQty(e.emQty || 0);
    const SENS = ['Sensor', 'PIR', 'Microwave', 'Daylight'];
    const sv = e.extras?.sensor || '';
    if (!sv) { setSelSensorSel('None'); setSelSensorCustom(''); }
    else if (SENS.indexOf(sv) > -1) { setSelSensorSel(sv); setSelSensorCustom(''); }
    else { setSelSensorSel('Custom'); setSelSensorCustom(sv); }
    const DIMS = ['Dimmable', 'DALI', '1-10V', 'Mains/Triac', 'Push', 'Casambi'];
    const dv = e.extras?.dim || '';
    if (!dv) { setSelDimSel('None'); setSelDimCustom(''); }
    else if (DIMS.indexOf(dv) > -1) { setSelDimSel(dv); setSelDimCustom(''); }
    else { setSelDimSel('Custom'); setSelDimCustom(dv); }
    setMoreOpen(null);
    setEditFitUid(uid);
  };
  const removeEditedFit = () => {
    if (!editFitUid) return;
    logDestructiveAction('survey.fitting.delete', { projectId: activeProject?.id || null, zone: currentZone, uid: editFitUid });
    deleteEntry(currentZone, editFitUid);
    clearSelEx();
    showSavedToast('Fitting removed');
  };
  const bumpFitQty = (zone, uid, delta) => {
    const e = zfEntries(zone).find(x => x.uid === uid);
    if (!e) return;
    updateEntryQty(zone, uid, Math.max(1, (e.qty || 1) + delta));
  };

  // ── Media ──
  const removeMedia = (i) => {
    const ph = sitePhotos[i];
    logDestructiveAction('survey.media.delete', { projectId: activeProject?.id || null, id: ph?.id || null, zone: ph?.zone || null, type: ph?.type || 'photo' });
    try { if (ph && ph.id) idbDeleteBlob(ph.id); } catch (e) {}
    const newP = sitePhotos.filter((_, j) => j !== i);
    setSitePhotos(newP);
    if (activeProject?.id && onUpdateProject) onUpdateProject(activeProject.id, { sitePhotos: newP });
    flashSaved();
  };

  // S138 — file-path photo save now delegates to the shared durable core
  // (savePhotoReliableCore). Same IDB-first write, same upload + retry, same
  // engine the burst camera uses; the survey supplies only its persistence
  // wiring. The burst camera lives in the shared useBurstCamera hook (`cam`).
  const savePhotoReliable = async ({ dataUrl, rawBlob, zone, label, fromBurst }) => {
    const photo = await savePhotoReliableCore({
      dataUrl, rawBlob, zone, label, fromBurst,
      uploadProjectId: activeProject?.id || null,
      onAdd: _addSitePhoto,
      onUrl: _setSitePhotoUrl,
    });
    if (!fromBurst) setPhotoTargetZone(null);
    if (!fromBurst) showSavedToast('Photo saved');
    flashSaved();
    return photo;
  };

  // SEND-STATE-V1: the front page shows the job's send state and what is still
  // waiting on the phone, so it re-reads both when the connection or queue changes.
  useSendStateTick();

  // ── No project guard — redirect to Survey Landing ──
  if (!activeProject?.id) {
    // Defer redirect to avoid rendering issues
    setTimeout(() => onNav(10), 0);
    return null;
  }

  // ── S136 derived view values ──
  const PROJECT_NOTE_KEY = '__project__';
  const areasCount = zones.length;
  const totalPhotos = sitePhotos.filter(p => p && p.type !== 'video').length;
  const activeKey = projectMode ? PROJECT_NOTE_KEY : currentZone;

  // Scan results scoped to the current area — ONE definition at component scope,
  // shared by the floating pill, the review sheet and the scroller padding that
  // reserves space for the pill. A second IIFE-local copy of this is how the
  // S154 isProj out-of-scope bug happened; do not duplicate it.
  const areaScans = scanQueue.filter(e => (e.zone || null) === (projectMode ? null : (currentZone || null)));

  // COMPANION-STUDIO-V1 track C1: the Studio look for the area workspace, the
  // fitting sheet, scan results, the note and voice sheets and the lightbox.
  // Every helper below is only ever called inside uvx(() => ...), which is an
  // empty object with the switch off, so the standard look cannot change.
  // One main action per state: a sheet with its own commit (Log, Save fitting,
  // Save note, Save transcript, Save voice note) holds the ultraviolet while it
  // is open; otherwise it is Next area (Back to areas at the last zone), or on
  // the Site-wide workspace the capture for its tab (FINDINGS C1-4).
  const ST = STUDIO_TOKENS;
  const uvSheetCommit = showCustomModal || !!copySheet || showNoteSheet || !!typeUpNote || showVoiceSheet
    || (lview === 'area' && !projectMode && seg === 'fix' && !!selFixture && !selFixture.isCustomBtn);
  // P2A: a chosen chip is pressed in with an amber edge (CHOSEN_CHIP_STYLE);
  // an unchosen one is unchanged.
  const uvChip = (sel) => ({ ...(sel ? { ...studioSurface.pressed(), ...CHOSEN_CHIP_STYLE } : { ...studioSurface.slip(), color: ST.ink, fontWeight: 500 }), borderRadius: ST.button.radius, fontSize: 14 });
  const uvField = () => ({ ...studioSurface.pressed(), borderRadius: ST.button.radius, color: ST.ink, fontSize: 16 });
  const uvLabel = () => ({ ...studioType.colhead(), fontSize: 14, textTransform: 'none', letterSpacing: 'normal' });
  const uvSheet = () => ({ ...studioSurface.raised(), borderRadius: ST.radius.card });
  const uvScrim = () => ({ background: studioInk(0.45) });
  const uvClose = () => ({ ...studioSurface.slip(), width: 44, height: 44, borderRadius: 12, color: ST.ink });
  const uvSlipBtn = () => ({ ...studioSurface.slip(), color: ST.ink, borderRadius: 12, minHeight: 44, fontSize: 16, fontWeight: 600 });
  const uvHeading = () => ({ ...studioType.heading(), fontStyle: 'normal', fontWeight: 400 });

  // Status dot per area — brief §5.1: sage done / copper in-progress / terra not-started.
  // NB this uses copper (#C08820) for a non-financial status, which the master skill
  // reserves for financial values; the brief explicitly mandates it. Flagged in the report.
  // UV-RESKIN-V1 track E: under the theme, done is ink, started is a sand
  // marker and not-started is the needs-you violet (no traffic light).
  const STATUS_SAGE = t.colors.statusSage, STATUS_COPPER = t.colors.statusCopper, STATUS_TERRA = t.colors.statusTerra;
  const areaSummary = (zone) => {
    const ents = zfEntries(zone);
    const fitN = ents.reduce((s, e) => s + (e.qty || 0), 0);
    const photoN = sitePhotos.filter(p => p && p.zone === zone && p.type !== 'video').length;
    const noteN = notesFor(zone).length;
    const started = fitN > 0 || photoN > 0 || noteN > 0;
    const done = !!doneZones[zone];
    return { fitN, photoN, noteN, started, done,
      dot: done ? STATUS_SAGE : started ? STATUS_COPPER : STATUS_TERRA,
      line: started ? `${fitN} fitting${fitN!==1?'s':''}${studioSep()}${photoN} photo${photoN!==1?'s':''}${studioSep()}${noteN} note${noteN!==1?'s':''}` : 'Not started' };
  };

  return studioShape(
    <div style={{ flex:1, overflow:"hidden", background:t.colors.ground, display:"flex", flexDirection:"column" }}>
      <style>{`@keyframes lumen-photo-spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } } @keyframes popIn { from { transform: scale(.7); opacity:0 } to { transform: scale(1); opacity:1 } }`}</style>

      {/* S135 (4.4) — bounded autosave confirmation pill */}
      {savedFlash && (
        <div style={{ position:'fixed', top:'calc(env(safe-area-inset-top,0px) + 8px)', left:'50%', transform:'translateX(-50%)', background:t.colors.green95, color:t.colors.onFill, padding:'5px 12px', borderRadius:14, fontSize:11, fontWeight:700, zIndex:9998, display:'flex', alignItems:'center', gap:5, boxShadow:'0 2px 8px rgba(0,0,0,0.18)', pointerEvents:'none', ...uvx(() => ({ ...studioSurface.slip(), color:STUDIO_TOKENS.ink, padding:'8px 14px', borderRadius:12, fontSize:14, fontWeight:600 })) }}>
          <svg width="11" height="11" viewBox="0 0 14 14" fill="none"><polyline points="2,7 5.5,10.5 12,3.5" stroke={t.theme === 'uv' ? STUDIO_TOKENS.ink : t.colors.onFill} strokeWidth="2.2" fill="none" strokeLinecap="round" strokeLinejoin="round"/></svg>
          Saved
        </div>
      )}

      {/* Hidden inputs — file-input fallback for capture (getUserMedia denied / absent) */}
      <input ref={photoInputRef} type="file" accept="image/*" capture="environment"
        style={{ display:"none" }} onChange={e=>{ if(e.target.files[0]) handlePhotoFile(e.target.files[0]); e.target.value=""; }} />
      <input ref={videoInputRef} type="file" accept="video/*" capture="environment"
        style={{ display:"none" }} onChange={e=>{ if(e.target.files[0]) handleVideoFile(e.target.files[0]); e.target.value=""; }} />

      {/* Lightbox */}
      {lightbox && (
        <SheetPortal>
        <div onClick={()=>setLightbox(null)} style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.92)", zIndex:9999, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:20, ...uvx(() => ({ background:studioRgba(STUDIO_TOKENS.ground.base, 0.97) })) }}>
          {lightbox.photo
            ? <MediaThumb photo={lightbox.photo} style={{ maxWidth:"100%", maxHeight:"75vh", borderRadius:12, objectFit:"contain", ...uvx(() => ({ borderRadius:STUDIO_TOKENS.radius.card, boxShadow:STUDIO_TOKENS.shadow.raised })) }} />
            : <img src={lightbox.src} alt="" style={{ maxWidth:"100%", maxHeight:"75vh", borderRadius:12, objectFit:"contain" }} />}
          {lightbox.caption && <p style={{ color:"rgba(255,255,255,0.7)", fontSize:13, marginTop:14, textAlign:"center", ...uvx(() => ({ color:STUDIO_TOKENS.ink, fontSize:16 })) }}>{lightbox.caption}</p>}
          <p style={{ color:"rgba(255,255,255,0.35)", fontSize:12, marginTop:12, ...uvx(() => ({ color:STUDIO_TOKENS.muted, fontSize:14 })) }}>Tap to close</p>
        </div>
        </SheetPortal>
      )}

      {/* P1: Copy fittings sheet. Opens over the survey (fixed, z 200, above the
          dock at z 20 as #75 required), never a new screen. */}
      {copySheet && (() => {
        const isFrom = copySheet.mode === 'from';
        const srcName = isFrom ? copyFromZone : copySheet.zone;
        const srcLines = srcName ? zfEntries(srcName) : [];
        const perAreaQty = srcLines.reduce((s, l) => s + (l.qty || 0), 0);
        const targets = copyTargets();
        const srcK = zoneKey(copySheet.zone);
        const ink = t.theme === 'uv' ? ST.ink : '#1A1608';
        const muted = t.theme === 'uv' ? ST.muted : '#6A5C42';
        const rowBtn = (on) => ({ width:'100%', minHeight:48, display:'flex', alignItems:'center', gap:12, padding:'6px 12px', marginBottom:6, borderRadius:12, cursor:'pointer', fontFamily:'inherit', textAlign:'left', background: on ? '#E3EFDD' : '#FDFCF9', border:`1.5px solid ${on ? '#2E6838' : '#EAE0CE'}`, color:ink, ...uvx(() => ({ ...(on ? studioSurface.pressed() : studioSurface.slip()), border:'none', borderRadius:12 })) });
        const tick = (on) => (
          <span aria-hidden="true" style={{ width:22, height:22, flexShrink:0, borderRadius: isFrom ? 11 : 6, border:`2px solid ${on ? '#2E6838' : '#B8AA90'}`, background: on ? '#2E6838' : 'transparent', display:'inline-flex', alignItems:'center', justifyContent:'center', ...uvx(() => ({ border:`2px solid ${ST.ink}`, background: on ? ST.ink : 'transparent' })) }}>
            {on && <svg width="12" height="12" viewBox="0 0 10 10" fill="none"><polyline points="2,5 4.2,7.5 8,2.5" stroke={t.theme === 'uv' ? ST.onPrimary : '#fff'} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>}
          </span>
        );
        const modeBtn = (k, m, label) => {
          const on = (copyModes[k] || 'add') === m;
          return (
            <button key={m} onClick={() => setCopyModes(prev => ({ ...prev, [k]: m }))} aria-pressed={on}
              style={{ flex:1, minHeight:44, borderRadius:10, fontSize:14, fontWeight: on ? 700 : 500, fontFamily:'inherit', cursor:'pointer', color:ink, border:`1.5px solid ${on ? '#2E6838' : '#EAE0CE'}`, background: on ? '#E3EFDD' : '#FDFCF9', ...uvx(() => ({ ...(on ? studioSurface.pressed() : studioSurface.slip()), border:'none' })) }}>{label}</button>
          );
        };
        const replaceNames = targets.filter(x => x.mode === 'replace' && zfEntries(x.zone).length > 0).map(x => x.zone);
        const canConfirm = targets.length > 0 && srcLines.length > 0;
        const confirmLabel = !canConfirm
          ? (isFrom && !srcName ? 'Pick an area to copy from' : 'Pick an area to copy to')
          : isFrom
            ? `Copy ${perAreaQty} fitting${perAreaQty === 1 ? '' : 's'} from ${srcName}`
            : copyButtonLabel(perAreaQty, targets.length);
        const ownLines = zfEntries(copySheet.zone);
        const ownHas = ownLines.length > 0;
        return (
          <SheetPortal>
          <div onClick={e => { if (e.target === e.currentTarget) closeCopySheet(); }}
            style={{ position:'fixed', inset:0, background:'rgba(26,22,8,0.45)', zIndex:200, display:'flex', alignItems:'flex-end', ...uvx(uvScrim) }}>
            <div role="dialog" aria-modal="true" aria-label={isFrom ? 'Copy fittings from' : 'Copy these fittings to'}
              style={{ background:'#FAF7F0', borderRadius:'22px 22px 0 0', padding:'18px 18px 100px', width:'100%', maxHeight:'88vh', overflowY:'auto', WebkitOverflowScrolling:'touch', boxSizing:'border-box', ...uvx(() => ({ ...uvSheet(), borderRadius:`${ST.radius.card}px ${ST.radius.card}px 0 0` })) }}>
              <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', gap:10, marginBottom:4 }}>
                <div style={{ fontFamily:'Georgia, serif', fontStyle:'italic', fontSize:19, fontWeight:700, color:ink, ...uvx(uvHeading) }}>{isFrom ? 'Copy fittings from…' : 'Copy these fittings to…'}</div>
                <button onClick={closeCopySheet} aria-label="Close" style={{ width:44, height:44, flexShrink:0, borderRadius:'50%', background:'rgba(26,22,8,0.07)', display:'flex', alignItems:'center', justifyContent:'center', border:'none', cursor:'pointer', ...uvx(uvClose) }}>
                  <svg width="12" height="12" viewBox="0 0 10 10" fill="none" stroke={ink} strokeWidth="1.5" strokeLinecap="round"><line x1="2" y1="2" x2="8" y2="8"/><line x1="8" y1="2" x2="2" y2="8"/></svg>
                </button>
              </div>
              <div style={{ fontSize:14, color:muted, marginBottom:14, lineHeight:1.4 }}>
                {isFrom
                  ? `Into ${copySheet.zone}. Photos and notes are not copied.`
                  : `${copySheet.zone}${studioSep()}${perAreaQty} fitting${perAreaQty === 1 ? '' : 's'}. Each area gets its own lines to adjust. Photos and notes are not copied.`}
              </div>

              {isFrom ? (
                <>
                  <div style={{ fontSize:14, fontWeight:700, color:ink, marginBottom:8 }}>Copy from</div>
                  {zones.filter(z => zoneKey(z) !== srcK && zfEntries(z).length > 0).map(z => {
                    const n = zfEntries(z).reduce((s, l) => s + (l.qty || 0), 0);
                    const on = copyFromZone != null && zoneKey(copyFromZone) === zoneKey(z);
                    return (
                      <button key={z} role="radio" aria-checked={on} onClick={() => { setCopyFromZone(z); setCopyError(''); }} style={rowBtn(on)}>
                        {tick(on)}
                        <span style={{ flex:1, minWidth:0, fontSize:16, fontWeight:600, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{z}</span>
                        <span style={{ fontSize:14, color:muted, flexShrink:0 }}>{n} fitting{n === 1 ? '' : 's'}</span>
                      </button>
                    );
                  })}
                  {ownHas && (
                    <div style={{ marginTop:8 }}>
                      <div style={{ fontSize:14, color:muted, marginBottom:6 }}>{copySheet.zone} already has fittings.</div>
                      <div style={{ display:'flex', gap:8 }}>{modeBtn(zoneKey(copySheet.zone), 'add', 'Add to them')}{modeBtn(zoneKey(copySheet.zone), 'replace', 'Replace them')}</div>
                    </div>
                  )}
                </>
              ) : (
                <>
                  <div style={{ fontSize:14, fontWeight:700, color:ink, marginBottom:8 }}>Areas in this survey</div>
                  {zones.filter(z => zoneKey(z) !== srcK).length === 0 && (
                    <div style={{ fontSize:14, color:muted, marginBottom:8 }}>No other areas yet. Add them below.</div>
                  )}
                  {zones.filter(z => zoneKey(z) !== srcK).map(z => {
                    const k = zoneKey(z);
                    const on = !!copyPicked[k];
                    const have = zfEntries(z);
                    const n = have.reduce((s, l) => s + (l.qty || 0), 0);
                    return (
                      <div key={z}>
                        <button role="checkbox" aria-checked={on} onClick={() => { setCopyPicked(prev => ({ ...prev, [k]: !prev[k] })); setCopyError(''); }} style={rowBtn(on)}>
                          {tick(on)}
                          <span style={{ flex:1, minWidth:0, fontSize:16, fontWeight:600, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{z}</span>
                          <span style={{ fontSize:14, color:muted, flexShrink:0 }}>{n > 0 ? `${n} fitting${n === 1 ? '' : 's'}` : 'Empty'}</span>
                        </button>
                        {on && have.length > 0 && (
                          <div style={{ display:'flex', gap:8, margin:'0 0 10px 34px' }}>
                            {modeBtn(k, 'add', 'Add to them')}{modeBtn(k, 'replace', 'Replace them')}
                          </div>
                        )}
                      </div>
                    );
                  })}

                  <div style={{ fontSize:14, fontWeight:700, color:ink, margin:'14px 0 8px' }}>New areas</div>
                  <div style={{ display:'flex', gap:8, alignItems:'stretch' }}>
                    <input value={copyNewText} onChange={e => setCopyNewText(e.target.value)}
                      onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); addCopyNames(); } }}
                      aria-label="New area names" placeholder="e.g. 6, 7, 8"
                      style={{ flex:1, minWidth:0, minHeight:44, boxSizing:'border-box', padding:'0 12px', borderRadius:12, border:'1.5px solid rgba(26,22,8,0.12)', background:'rgba(26,22,8,0.04)', fontFamily:'inherit', fontSize:16, color:ink, outline:'none', ...uvx(uvField) }} />
                    <button onClick={addCopyNames} style={{ minHeight:44, minWidth:64, padding:'0 14px', borderRadius:12, fontFamily:'inherit', fontSize:14, fontWeight:700, cursor:'pointer', color:ink, border:'1.5px solid #EAE0CE', background:'#FDFCF9', ...uvx(() => ({ ...uvSlipBtn(), border:'none' })) }}>Add</button>
                  </div>
                  <div style={{ fontSize:14, color:muted, margin:'6px 0 0' }}>Separate names with commas. They become new areas with a copy of these fittings.</div>
                  {copyNewNames.length > 0 && (
                    <div style={{ display:'flex', flexWrap:'wrap', gap:8, marginTop:10 }}>
                      {copyNewNames.map(n => (
                        <button key={n} onClick={() => setCopyNewNames(prev => prev.filter(x => x !== n))} aria-label={`Remove new area ${n}`}
                          style={{ minHeight:44, padding:'0 14px', borderRadius:12, fontFamily:'inherit', fontSize:14, fontWeight:600, cursor:'pointer', color:ink, border:'1.5px solid #2E6838', background:'#E3EFDD', display:'inline-flex', alignItems:'center', gap:8, ...uvx(() => ({ ...studioSurface.pressed(), border:'none' })) }}>
                          {n}<span aria-hidden="true" style={{ fontSize:18, lineHeight:1 }}>&times;</span>
                        </button>
                      ))}
                    </div>
                  )}
                </>
              )}

              {replaceNames.length > 0 && (
                <div style={{ fontSize:14, color:muted, marginTop:12, lineHeight:1.4 }}>
                  {`Replaces what is in ${replaceNames.join(', ')}. Photos attached to those fittings go with them.`}
                </div>
              )}
              {copyError && <div role="alert" style={{ fontSize:14, color: t.theme === 'uv' ? ST.ink : '#7A2A18', marginTop:12, fontWeight:600 }}>{copyError}</div>}
              <button onClick={confirmCopy} disabled={!canConfirm}
                style={{ width:'100%', minHeight:48, marginTop:16, padding:'0 14px', borderRadius:14, border:'none', fontFamily:'inherit', fontSize:16, fontWeight:700, cursor: canConfirm ? 'pointer' : 'default', background: canConfirm ? '#2E6838' : 'rgba(26,22,8,0.12)', color: canConfirm ? '#fff' : muted, ...uvx(() => (canConfirm ? { ...studioSurface.primary(), width:'100%', color:ST.onPrimary, fontWeight:600 } : { ...studioSurface.pressed(), width:'100%', color:ST.muted, fontWeight:600 })) }}>
                {confirmLabel}
              </button>
            </div>
          </div>
          </SheetPortal>
        );
      })()}

      {/* Custom fitting modal */}
      {showCustomModal && (
        <SheetPortal>
        <div onClick={e=>{ if(e.target===e.currentTarget) setShowCustomModal(false); }} style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.75)", zIndex:200, display:"flex", alignItems:"flex-end", ...uvx(uvScrim) }}>
          <div style={{ background:t.colors.glass, borderRadius:"22px 22px 0 0", border:"1px solid rgba(255,252,240,0.85)", borderTop:"1px solid rgba(255,255,250,0.96)", padding:"18px 18px 100px", width:"100%", maxHeight:"85vh", overflowY:"auto", WebkitOverflowScrolling:"touch", ...uvx(() => ({ ...uvSheet(), borderRadius:`${ST.radius.card}px ${ST.radius.card}px 0 0` })) }}>
            <div style={{ width:34, height:4, borderRadius:2, background:"rgba(255,255,255,0.1)", margin:"0 auto 14px", ...uvx(() => ({ background:ST.hairline })) }} />
            <p style={{ fontSize:15, fontWeight:800, color:t.colors.text, marginBottom:3, ...uvx(() => ({ ...uvHeading(), marginBottom:4 })) }}>Custom fitting</p>
            <p style={{ fontSize:11, color:t.colors.textTertiary, marginBottom:14, ...uvx({ fontSize:14 }) }}>{`Saved to this survey${studioDash()}usable in any area`}</p>
            <div style={{ background:"rgba(255,255,255,0.04)", border:"0.5px solid rgba(255,255,255,0.1)", borderRadius:9, padding:"10px 12px", marginBottom:8, ...uvx(uvField) }}>
              <p style={{ fontSize:10, fontWeight:700, color:t.colors.textTertiary, textTransform:"uppercase", letterSpacing:.5, marginBottom:3, ...uvx(() => ({ ...uvLabel(), fontSize:13 })) }}>Fitting name</p>
              <input value={cName} onChange={e=>setCName(e.target.value)} placeholder="e.g. Custom Linear 2400mm" style={{ width:"100%", background:"none", border:"none", outline:"none", color:t.colors.text, fontFamily:"inherit", fontSize:16, fontWeight:700, ...uvx({ fontWeight:600, minHeight:28 }) }} />
            </div>
            <div style={{ display:"flex", gap:8, marginBottom:8, ...uvx({ marginBottom:14 }) }}>
              {[{l:"Existing W",v:cOldW,s:setCOldW},{l:"New LED W",v:cNewW,s:setCNewW}].map(f=>(
                <div key={f.l} style={{ flex:1, background:"rgba(255,255,255,0.04)", border:"0.5px solid rgba(255,255,255,0.1)", borderRadius:9, padding:"10px 12px", ...uvx(uvField) }}>
                  <p style={{ fontSize:10, fontWeight:700, color:t.colors.textTertiary, textTransform:"uppercase", letterSpacing:.5, marginBottom:3, ...uvx(() => ({ ...uvLabel(), fontSize:13 })) }}>{f.l}</p>
                  <input type="number" value={f.v} onChange={e=>f.s(e.target.value)} placeholder="—" style={{ width:"100%", background:"none", border:"none", outline:"none", color:t.colors.text, fontFamily:"inherit", fontSize:16, fontWeight:700, ...uvx({ fontWeight:600, minHeight:28, fontVariantNumeric:'tabular-nums' }) }} />
                </div>
              ))}
            </div>
            <button onClick={saveCustomFitting} style={{ width:"100%", padding:13, borderRadius:10, background:divColorLight, border:`1.5px solid ${divBorder}`, color:divColor, fontFamily:"inherit", fontSize:14, fontWeight:800, cursor:"pointer", ...uvx(() => ({ ...studioSurface.primary(), width:'100%' })) }}>Save fitting</button>
          </div>
        </div>
        </SheetPortal>
      )}

      {/* ── Burst camera modal (getUserMedia, stays open) ── */}
      <BurstCameraOverlay cam={cam}
        headerLabel={projectMode ? 'Site photo' : `Photo${studioSep()}${currentZone||''}`}
        onUseFiles={()=>{ cam.close(); setTimeout(()=>{ setPhotoTargetZone(projectMode?null:currentZone); if (photoInputRef.current) photoInputRef.current.click(); }, 60); }} />

      {/* ── S154 — Scan results collector (fitting mode): accumulate, step, confirm, dismiss.
              Scoped to the current area so a survey's results never mix between areas, and
              never with a snag (separate component). A proposal to confirm, never saved alone. ── */}
      {(() => {
        const openEntry = areaScans.find(e => e.id === scanOpenId) || areaScans[0] || null;
        const openIdx = openEntry ? areaScans.indexOf(openEntry) : -1;
        const srcPhoto = openEntry ? sitePhotos.find(p => (p.id || null) === openEntry.photoId) : null;
        return (
          <>
            {areaScans.length > 0 && !(scanReviewOpen && openEntry) && (
              <button onClick={()=>{ setScanOpenId(areaScans[0].id); setScanReviewOpen(true); }} aria-label="Open scan results"
                style={{ position:'fixed', right:16, bottom:'calc(96px + env(safe-area-inset-bottom,0px))', zIndex:180, display:'inline-flex', alignItems:'center', gap:6, padding:'10px 15px', borderRadius:22, background:'#4A6462', border:'none', color:'#FDFCF9', fontSize:12.5, fontWeight:700, cursor:'pointer', fontFamily:'inherit', boxShadow:'0 8px 20px -8px rgba(74,100,98,0.7)', ...uvx(() => ({ ...studioSurface.raised(), minHeight:44, padding:'0 16px', borderRadius:14, color:ST.ink, fontSize:16, fontWeight:600, bottom:'calc(176px + env(safe-area-inset-bottom,0px))' })) }}>
                <span aria-hidden="true" style={{ color:'#C8A96E', ...uvx({ color:'inherit' }) }}>✦</span>Scan results ({areaScans.length})
              </button>
            )}
            {scanReviewOpen && openEntry && (
              <SheetPortal>
                <div onClick={()=>setScanReviewOpen(false)} style={{ position:'fixed', inset:0, background:'rgba(58,48,24,0.4)', zIndex:199, ...uvx(uvScrim) }} />
                <div style={{ position:'fixed', left:0, right:0, bottom:0, background:'#FAF8F3', borderRadius:'22px 22px 0 0', zIndex:200, padding:'8px 18px calc(83px + env(safe-area-inset-bottom,0px))', maxHeight:'88%', overflowY:'auto', WebkitOverflowScrolling:'touch', ...uvx(() => ({ ...uvSheet(), borderRadius:`${ST.radius.card}px ${ST.radius.card}px 0 0` })) }}>
                  <div style={{ width:40, height:4, borderRadius:2, background:t.colors.separator, margin:'4px auto 12px' }} />
                  <div style={{ display:'flex', alignItems:'center', gap:11, marginBottom:6 }}>
                    {srcPhoto && <MediaThumb photo={srcPhoto} style={{ width:44, height:44, borderRadius:9, objectFit:'cover', display:'block', flexShrink:0 }} />}
                    <div style={{ flex:1, minWidth:0 }}>
                      <div style={{ fontFamily:'Georgia, serif', fontStyle:'italic', fontSize:21, color:t.colors.text, lineHeight:1.1, ...uvx(() => ({ ...uvHeading(), fontSize:25, lineHeight:1.15 })) }}>What the scan saw</div>
                      {areaScans.length > 1 && <div style={{ fontSize:11.5, color:t.colors.textTertiary, marginTop:2, ...uvx({ fontSize:14 }) }}>Photo {openIdx + 1} of {areaScans.length} in this area</div>}
                    </div>
                    <button onClick={()=>setScanReviewOpen(false)} style={{ width:38, height:38, borderRadius:11, background:t.colors.glass, border:'none', fontSize:17, color:t.colors.textSecondary, cursor:'pointer', flexShrink:0, ...uvx(uvClose) }}>✕</button>
                  </div>
                  {areaScans.length > 1 && (
                    <div style={{ display:'flex', gap:8, marginBottom:12 }}>
                      <button onClick={()=>setScanOpenId(areaScans[(openIdx - 1 + areaScans.length) % areaScans.length].id)} style={{ flex:1, minHeight:40, borderRadius:10, border:`1px solid ${t.colors.separator}`, background:t.colors.glass, color:t.colors.textSecondary, fontFamily:'inherit', fontSize:13, fontWeight:700, cursor:'pointer', ...uvx(uvSlipBtn) }}>{t.theme === 'uv' ? 'Previous' : '‹ Previous'}</button>
                      <button onClick={()=>setScanOpenId(areaScans[(openIdx + 1) % areaScans.length].id)} style={{ flex:1, minHeight:40, borderRadius:10, border:`1px solid ${t.colors.separator}`, background:t.colors.glass, color:t.colors.textSecondary, fontFamily:'inherit', fontSize:13, fontWeight:700, cursor:'pointer', ...uvx(uvSlipBtn) }}>{t.theme === 'uv' ? 'Next' : 'Next ›'}</button>
                    </div>
                  )}
                  <p style={{ fontSize:12, color:t.colors.textTertiary, margin:'0 0 14px', lineHeight:1.45, ...uvx({ fontSize:14 }) }}>A proposal, not a count. Confirm each fitting on the sheet before it is saved. Nothing here is added on its own.</p>
                  {(() => {
                    const r = openEntry.proposal || {};
                    const fittings = Array.isArray(r.fittings) ? r.fittings : [];
                    const nonLight = Array.isArray(r.non_lighting) ? r.non_lighting : [];
                    return (
                      <>
                        {fittings.length === 0 && (
                          <p style={{ fontSize:13.5, color:t.colors.textSecondary, lineHeight:1.5, padding:'4px 2px 10px', ...uvx({ fontSize:16 }) }}>No lighting fittings were read with any confidence. Add what you see by hand.</p>
                        )}
                        {fittings.map((fit, fi) => {
                          const fixId = VISION_TYPE_TO_FIXTURE[fit.type] || 'custom-btn';
                          const fl = allFixtures().find(x => x.id === fixId);
                          const label = fl ? fl.label : (fit.type || 'Fitting');
                          // Under the theme a proposal is a row of what the scan
                          // saw, not a card: the count right-aligned in tabular
                          // figures, as phone-recording.html shows what was heard.
                          return (
                            <div key={fi} style={{ background:t.colors.glass, border:`1px solid ${t.colors.glassBorder}`, borderRadius:14, padding:13, marginBottom:10, ...uvx(() => ({ background:'none', border:'none', borderTop:`1px solid ${ST.hairline}`, borderRadius:0, padding:'12px 0', marginBottom:0 })) }}>
                              <div style={{ display:'flex', alignItems:'baseline', gap:8, flexWrap:'wrap', ...uvx({ flexWrap:'nowrap' }) }}>
                                {t.theme === 'uv'
                                  ? <><span style={{ flex:1, fontSize:16, fontWeight:700, color:ST.ink }}>{label}{fit.emergency && <span style={{ fontWeight:400, color:ST.muted }}>{studioSep()}EM</span>}</span><span style={{ fontSize:16, fontWeight:700, color:ST.ink, fontVariantNumeric:'tabular-nums' }}>{fit.count || 1}</span></>
                                  : <span style={{ fontSize:16, fontWeight:700, color:t.colors.text }}>{fit.count || 1}× {label}</span>}
                                {fit.emergency && t.theme !== 'uv' && <span style={{ fontSize:10.5, fontWeight:700, color:'#2E6838', background:'rgba(46,104,56,0.1)', padding:'2px 8px', borderRadius:20 }}>EM</span>}
                              </div>
                              {fit.description && <div style={{ fontSize:12.5, color:t.colors.textSecondary, marginTop:4, lineHeight:1.4, ...uvx({ fontSize:14 }) }}>{fit.description}</div>}
                              <div style={{ display:'flex', gap:6, flexWrap:'wrap', marginTop:8, ...uvx({ gap:14, marginTop:4 }) }}>
                                <VisionConfPill level={fit.type_confidence} label="Type" />
                                <VisionConfPill level={fit.count_confidence} label="Count" />
                              </div>
                              <VisionGuessRow label="Size" value={fit.size_guess && fit.size_guess.value} guess={true} />
                              <VisionGuessRow label="Lamp" value={fit.lamp_guess && fit.lamp_guess.value} guess={true} />
                              <VisionGuessRow label="Label read" value={fit.label_text} guess={false} />
                              {fit.note && <div style={{ fontSize:11.5, color:'#A09080', fontStyle:'italic', marginTop:5, lineHeight:1.4, ...uvx(() => ({ fontSize:14, color:ST.muted, fontStyle:'normal' })) }}>{fit.note}</div>}
                              <button onClick={()=>prefillFitFromScan(fit)} style={{ marginTop:11, width:'100%', minHeight:46, borderRadius:11, border:'none', background:'linear-gradient(135deg, #C89030, #1A5A78)', color:'#fff', fontFamily:'inherit', fontSize:13.5, fontWeight:800, cursor:'pointer', ...uvx(() => ({ ...studioType.action(), width:'auto', minHeight:44, marginTop:2, textAlign:'left' })) }}>Review and add</button>
                            </div>
                          );
                        })}

                        {nonLight.length > 0 && (
                          <div style={{ marginTop:6, padding:'12px 13px', borderRadius:12, background:'rgba(28,24,16,0.03)', border:'1px solid rgba(28,24,16,0.08)', ...uvx(() => ({ ...studioSurface.pressed(), borderRadius:14, marginTop:10, padding:'12px 14px' })) }}>
                            <div style={{ fontSize:11, fontWeight:700, letterSpacing:'0.08em', textTransform:'uppercase', color:t.colors.textTertiary, marginBottom:8, ...uvx(() => ({ ...uvLabel() })) }}>{t.theme === 'uv' ? 'Not added, not lighting' : 'Not added · not lighting'}</div>
                            {nonLight.map((nl, ni) => (
                              <div key={ni} style={{ fontSize:12.5, color:t.colors.textSecondary, marginBottom:5, lineHeight:1.4, ...uvx({ fontSize:14 }) }}>
                                <span style={{ fontWeight:600, color:'#564A38', ...uvx(() => ({ color:ST.ink })) }}>{nl.item || 'Item'}</span>{nl.note ? studioSep() + nl.note : ''}
                              </div>
                            ))}
                            <div style={{ fontSize:11, color:t.colors.textTertiary, marginTop:6, lineHeight:1.4, ...uvx({ fontSize:14 }) }}>Left out so the count stays honest. If one is a fitting, add it by hand from the tiles.</div>
                          </div>
                        )}

                        {r.overall_note && <p style={{ fontSize:12, color:t.colors.textTertiary, fontStyle:'italic', margin:'12px 2px 0', lineHeight:1.45, ...uvx({ fontSize:14, fontStyle:'normal' }) }}>{r.overall_note}</p>}
                        <button onClick={()=>{ const remaining = areaScans.filter(e => e.id !== openEntry.id); dismissScan(openEntry.id); if (remaining.length > 0) setScanOpenId(remaining[0].id); else setScanReviewOpen(false); }} style={{ marginTop:16, width:'100%', minHeight:46, borderRadius:11, border:'1px solid #C06848', background:'none', color:'#7A2E18', fontFamily:'inherit', fontSize:13.5, fontWeight:700, cursor:'pointer', ...uvx(uvSlipBtn) }}>Dismiss this photo's result</button>
                        <button onClick={()=>setScanReviewOpen(false)} style={{ marginTop:10, width:'100%', minHeight:46, borderRadius:11, border:`1px solid ${t.colors.separator}`, background:'none', color:t.colors.textSecondary, fontFamily:'inherit', fontSize:13.5, fontWeight:700, cursor:'pointer', ...uvx(() => ({ ...studioType.link(), width:'auto', minHeight:44, display:'block', margin:'10px auto 0', borderBottom:'none', textDecoration:'underline', textDecorationColor:studioInk(0.32), textUnderlineOffset:4 })) }}>Done for now</button>
                      </>
                    );
                  })()}
                </div>
              </SheetPortal>
            )}
          </>
        );
      })()}


      {/* ── Sticky header ── (STUDIO-LIT-PHONE-V1 item 7: with the switch
          on the back link and the steps are drawn in the page instead, as
          the prototype's #app/areas and #app/zone) */}
      {t.theme !== 'uv' && (
      <div style={{ background:t.colors.paper96, borderBottom:`0.5px solid ${t.colors.olive08}`, padding:'8px 16px 8px', flexShrink:0, zIndex:10 }}>
        <div style={{ display:'flex', alignItems:'center', gap:8 }}>
          <button onClick={handleBack} style={{ background:'none', border:'none', cursor:'pointer', display:'flex', alignItems:'center', gap:4, padding:0, flexShrink:0 }}>
            <svg width="7" height="12" viewBox="0 0 7 12" fill="none"><path d="M6 1L1 6l5 5" stroke={t.colors.green} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>
            <span style={{ color:t.colors.green, fontSize:13, fontWeight:500 }}>Today</span>
          </button>
          <div style={{ flex:1, fontFamily:t.font.serif, fontStyle:t.font.italic, fontSize:18, color:t.colors.text, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', minWidth:0, textAlign:'center' }}>
            {activeProject?.name || 'Live Survey'}
          </div>
          <div style={{ width:54, flexShrink:0, display:'flex', justifyContent:'flex-end' }}>
            {savedFlash && <span style={{ fontSize:10, color:t.colors.green, fontWeight:600 }}>Saved</span>}
          </div>
        </div>
        {/* Stage track */}
        <div style={{ padding:'8px 2px 2px', display:'flex', alignItems:'center', justifyContent:'center' }}>
          <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:3 }}>
            <div style={{ width:15, height:15, borderRadius:'50%', background:t.colors.green, display:'flex', alignItems:'center', justifyContent:'center' }}>
              <svg width="8" height="8" viewBox="0 0 10 10" fill="none"><polyline points="2,5 4.2,7.5 8,2.5" stroke={t.colors.onFill} strokeWidth="1.8" fill="none" strokeLinecap="round" strokeLinejoin="round"/></svg>
            </div>
            <span style={{ fontSize:8, color:t.colors.khaki }}>Start</span>
          </div>
          <div style={{ flex:1, height:1, background:t.colors.olive25, margin:'0 6px', marginBottom:11 }} />
          <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:3 }}>
            <div style={{ width:15, height:15, borderRadius:'50%', background:t.colors.green, boxShadow:t.shadow.liveStep, display:'flex', alignItems:'center', justifyContent:'center' }}>
              <div style={{ width:5, height:5, borderRadius:'50%', background:t.colors.onFill }} />
            </div>
            <span style={{ fontSize:8, fontWeight:600, color:t.colors.green }}>Survey</span>
          </div>
          <div style={{ flex:1, height:1, background:t.colors.olive12, margin:'0 6px', marginBottom:11 }} />
          <div onClick={() => { if (hasCompletedZones) { persist(); onNav(11, { askReport: true }); } }} style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:3, cursor: hasCompletedZones ? 'pointer' : 'default' }}>
            <div style={{ width:15, height:15, borderRadius:'50%', border:`1.5px solid ${hasCompletedZones ? t.colors.green : t.colors.olive2}`, background:'transparent' }} />
            <span style={{ fontSize:8, color: hasCompletedZones ? t.colors.green : t.colors.khaki, fontWeight: hasCompletedZones ? 600 : 400 }}>Send</span>
          </div>
        </div>
      </div>
      )}

      {/* ── Scrollable body — Areas list OR Area workspace ──
          While the floating "Scan results" pill is up, reserve extra bottom
          padding so the last in-flow content (the Previous / Next area footer)
          comes to rest ABOVE the pill band instead of underneath it. The pill
          sits at bottom calc(96px + safe-area inset); on a notched handset the
          inset lifts it straight into the footer's resting position unless the
          scroller end is pushed up to clear it. */}
      {/* COMPANION-STUDIO-V1 track C1: under the theme the dock floats 86px up
          (track 2) and the scan pill sits above it, so the scroller ends lower
          down to keep the last row (Next area) clear of both. */}
      <div ref={bodyScrollRef} onScroll={(e) => { if (bodyOwnerRef.current === 'list') listScrollRef.current = e.currentTarget.scrollTop; }} style={{ flex:1, overflowY:"auto", WebkitOverflowScrolling:"touch", overscrollBehavior:"contain", padding:'14px 16px', paddingBottom: areaScans.length > 0 ? 206 : 150, ...uvx(() => ({ paddingBottom: areaScans.length > 0 ? 250 : 190 })) }}>

        {lview === 'list' && (() => {
          const projPhotos = sitePhotos.filter(p => p && !p.zone && p.type !== 'video').length;
          const projNotes = notesFor(PROJECT_NOTE_KEY).length;
          // S163 — soft readiness for the Wrap up button: areas not yet marked done.
          const openAreas = zones.filter(z => !doneZones[z]).length;
          // STUDIO-LIT-PHONE-V1 item 7: Areas with the switch on (#app/areas).
          if (t.theme === 'uv') {
            const S = STUDIO_TOKENS;
            const sums = zones.map(z => areaSummary(z));
            const fitAll = sums.reduce((n, s) => n + s.fitN, 0);
            const doneN = zones.filter(z => doneZones[z]).length;
            // The area to carry on with: the one open now, else the first open
            // area already started, else the first open area (P2B rule).
            const curIdx = frontCurrentIndex(zones, doneZones, sums.map(s => s.started), zIdx);
            const rowStates = frontAreaStates(zones, doneZones, curIdx);
            // P2B: the job's own voice notes (Site-wide), and a way into them.
            const siteVoiceN = siteVoiceNoteCount(notesFor(PROJECT_NOTE_KEY));
            const openSiteNotes = () => { setProjectMode(true); setSeg('notes'); setLview('area'); clearSelEx(); };
            const projNoteBodies = flattenZoneNotesForPayload({ [PROJECT_NOTE_KEY]: notesFor(PROJECT_NOTE_KEY) })[PROJECT_NOTE_KEY];
            const projFirst = projNoteBodies ? String(projNoteBodies).split('\n').map(s => s.trim()).find(Boolean) : '';
            const siteLine = [projPhotos > 0 ? svPlural(projPhotos, 'photo') : '', projNotes > 0 ? `${svPlural(projNotes, 'note')}${projFirst ? ': ' + projFirst : ''}` : '', unassignedNotes.length > 0 ? `${unassignedNotes.length} unassigned` : ''].filter(Boolean).join(', ') || 'Photos and notes not tied to one area';
            const firstPhotoOf = (z) => sitePhotos.find(p => p && p.zone === z && p.type !== 'video') || null;
            const counts = (s) => [svPlural(s.fitN, 'fitting'), svPlural(s.photoN, 'photo'), s.noteN ? svPlural(s.noteN, 'note') : ''].filter(Boolean).join(', ');
            const place = svPlace(activeProject?.address);
            // SEND-STATE-V1: the job's send state, and a plain line for whatever
            // is still waiting on the phone while it is not sent. Waiting,
            // failed or sent, the state takes Carry on's place as the main
            // thing on the page (waiting: its Try now is the violet action);
            // the areas, Add an area and Finish the survey stay, so the job
            // stays editable and a sent job can still be sent again (S106).
            const frontSt = readSendState(activeProject);
            const frontBlocked = sendStateBlocksSend(frontSt) || frontSt.state === 'sent';
            const frontCard = frontBlocked || !!frontSt.earlier;
            const frontOnline = !(typeof navigator !== 'undefined' && navigator.onLine === false);
            // Sent or not: a voice note not yet transcribed (or a photo not up)
            // was not in what went, so it stays said, never hidden.
            const frontPending = frontPendingLine(frontPendingCounts(sitePhotos, zoneNotesRef.current || zoneNotes || {}), frontOnline, frontSt.state === 'sent');
            const draw = () => (
              <div style={{ display:'grid', gridTemplateColumns:'minmax(0,1fr)', gridAutoRows:'max-content', gap:12, paddingBottom:24 }}>
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', gap:10, minHeight:46 }}>
                  <SvBack label="On site" onClick={handleBack} />
                  <SvSteps cur={1} />
                </div>
                <div>
                  <h1 style={{ ...svH1(), fontSize:39, lineHeight:1.05, overflowWrap:'break-word' }}>{activeProject?.name || 'Survey'}</h1>
                  <p style={{ margin:'6px 0 0', fontSize:16, lineHeight:1.45, color:S.muted }}>{place ? place + '. ' : ''}{svPlural(fitAll, 'fitting')} and {svPlural(totalPhotos, 'photo')} so far.</p>
                  {frontPending ? <p data-front-pending="" role="status" style={{ margin:'6px 0 0', fontSize:14, lineHeight:1.4, fontWeight:600, color:S.ink }}>{frontPending}</p> : null}
                </div>
                {/* P2B: the job's own voice note. It files to Site-wide (the sheet
                    picks that key on this list), the same sheet and save path as
                    the in-area recorder, and emits no voice_note_logged. */}
                <div>
                  <div style={{ ...studioSurface.lit(), borderRadius:20, padding:18, display:'flex', alignItems:'center', gap:16 }}>
                    <button onClick={openVoiceSheet} aria-label="Record a voice note for this job" style={{ width:FRONT_MIC.size, height:FRONT_MIC.size, flexShrink:0, border:'none', borderRadius:FRONT_MIC.size / 2, background:FRONT_MIC.fill, display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer', boxShadow:'-6px 12px 20px -8px rgba(30,32,40,.5)' }}>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={S.onPrimary} strokeWidth="2" strokeLinecap="round" aria-hidden="true"><rect x="9" y="3" width="6" height="11" rx="3" /><path d="M5 11a7 7 0 0 0 14 0M12 18v3" /></svg>
                    </button>
                    <div style={{ minWidth:0 }}>
                      <h2 style={{ ...svH2(), lineHeight:1.2 }}>Add a voice note to this job</h2>
                      <p style={{ margin:'4px 0 0', fontSize:14, lineHeight:1.4, color:S.muted }}>Access, parking, who you met. It stays with the job, not an area.</p>
                    </div>
                  </div>
                  {siteVoiceN > 0 && (
                    <button onClick={openSiteNotes} style={{ ...svLink(), marginTop:2, padding:'0 4px', fontSize:14 }}>{siteVoiceNoteLine(siteVoiceN)}</button>
                  )}
                </div>
                {zones.length > 0 && (
                  <div style={{ display:'flex', alignItems:'baseline', justifyContent:'space-between', gap:10, marginTop:6 }}>
                    <h2 style={svH2()}>Areas</h2>
                    <span style={{ fontSize:14, color:S.muted }}>{frontDoneLabel(zones, doneZones)}</span>
                  </div>
                )}
                {zones.map((z, i) => {
                  const s = sums[i]; const st = rowStates[i];
                  return (
                    <button key={'area-' + i} onClick={() => openArea(i)} style={{ ...(st === 'done' ? { ...studioSurface.pressed(), borderRadius:S.pressed.radius } : { ...studioSurface.slip(), borderRadius:16 }), ...(st === 'now' ? { boxShadow:`${S.shadow.slip}, 0 0 0 2px ${S.lampAmber}` } : {}), minHeight:56, padding:'10px 16px', display:'flex', alignItems:'center', gap:12, textAlign:'left', cursor:'pointer', fontFamily:'inherit' }}>
                      <span style={{ flex:1, minWidth:0 }}>
                        <b style={{ display:'block', fontSize:16, fontWeight:700, color:S.ink, overflowWrap:'break-word' }}>{z}</b>
                        <span style={{ display:'block', fontSize:14, lineHeight:1.35, color:S.muted, marginTop:2 }}>{s.started ? counts(s) : 'Not started'}</span>
                      </span>
                      <span style={{ flexShrink:0, fontSize:14, fontWeight: st === 'next' ? 400 : 700, color: st === 'next' ? S.muted : STUDIO_MEANING.wonText }}>{st === 'done' ? 'Done' : (st === 'now' ? 'Now' : 'Next')}</span>
                    </button>
                  );
                })}
                <button onClick={openProject} style={{ ...studioSurface.pressed(), borderRadius:16, minHeight:52, padding:'10px 14px', display:'flex', justifyContent:'space-between', alignItems:'center', gap:10, textAlign:'left', cursor:'pointer', fontFamily:'inherit' }}>
                  <b style={{ fontSize:16, fontWeight:700, color:S.ink, flexShrink:0 }}>Site-wide</b>
                  <span style={{ fontSize:14, lineHeight:1.35, color:S.muted, textAlign:'right', minWidth:0 }}>{siteLine}</span>
                </button>
                {addingZone && (
                  <div style={{ display:'flex', gap:8, alignItems:'center' }}>
                    <input value={newZoneName} onChange={e=>setNewZoneName(e.target.value)} autoFocus aria-label="Area name"
                      onKeyDown={e=>{ if(e.key==="Enter") confirmAddZone(); if(e.key==="Escape"){ setAddingZone(false); setNewZoneName(""); } }}
                      placeholder="Area name"
                      style={{ flex:1, minWidth:0, ...studioSurface.pressed(), borderRadius:S.button.radius, minHeight:48, padding:'0 14px', color:S.ink, fontFamily:'inherit', fontSize:16, outline:'none' }} />
                    <button onClick={confirmAddZone} style={{ ...svGhost(), ...studioSurface.slip(), minHeight:48 }}>Add</button>
                    <button onClick={()=>{ setAddingZone(false); setNewZoneName(""); }} style={{ ...svLink(), fontSize:16 }}>Cancel</button>
                  </div>
                )}
                {/* P2B: the one violet action is carrying on with the current area;
                    with every area done (or none yet) it is Finish the survey.
                    Finish the survey stays reachable either way. */}
                {frontCard ? (
                  <SvSendState st={frontSt} onAct={() => { if (sendStateNeedsWrap(frontSt)) goToWrap(); else sendQueuedNow(activeProject); }} />
                ) : null}
                {!frontBlocked && curIdx >= 0 && <button onClick={() => openArea(curIdx)} style={{ ...svMain(), minHeight:54, width:'100%', marginTop:4, overflowWrap:'break-word' }}>{`Carry on with ${zones[curIdx]}`}</button>}
                <div style={{ display:'flex', gap:10, marginTop: curIdx >= 0 ? 0 : 4 }}>
                  {!addingZone && <button onClick={()=>setAddingZone(true)} style={{ ...svGhost(), flex:1 }}>Add an area</button>}
                  <button onClick={goToWrap} style={{ ...(curIdx >= 0 || frontBlocked ? svGhost() : svMain()), flex:1 }}>Finish the survey</button>
                </div>
              </div>
            );
            return <SvLit draw={draw} />;
          }
          return (
            <>
              {/* COMPANION-STUDIO-V1 track 2: the one big number on the area
                  list is the fittings counted so far (real survey data), with
                  photos and zones done beside it. Theme off: not rendered. */}
              {t.theme === 'uv' && (() => {
                const fitTotal = zones.reduce((n, z) => n + areaSummary(z).fitN, 0);
                const doneN = zones.filter(z => doneZones[z]).length;
                return (
                  <div style={{ display:'flex', alignItems:'flex-end', gap:14, margin:'4px 6px 18px' }}>
                    <div style={{ ...studioType.display(), fontSize:84 }}>{fitTotal}</div>
                    <div style={{ paddingBottom:4, fontSize:16, lineHeight:1.35, color:STUDIO_TOKENS.ink }}>fitting{fitTotal!==1?'s':''}<br /><span style={{ fontSize:14, color:STUDIO_TOKENS.muted }}>{totalPhotos} photo{totalPhotos!==1?'s':''}, {doneN} of {areasCount} zone{areasCount!==1?'s':''} done</span></div>
                  </div>
                );
              })()}
              {/* SEND-STATE-V1: what is still waiting on the phone (switch off;
                  drawn only when something is). */}
              {t.theme !== 'uv' && (() => {
                const _sst = readSendState(activeProject);
                // Sent or not, as the lit page: nothing still on the phone is hidden.
                const _l = frontPendingLine(frontPendingCounts(sitePhotos, zoneNotesRef.current || zoneNotes || {}), !(typeof navigator !== 'undefined' && navigator.onLine === false), _sst.state === 'sent');
                const _sw = (sendStateBlocksSend(_sst) || _sst.state === 'sent' || _sst.earlier) ? sendStateWords(_sst) : null;
                if (!_l && !_sw) return null;
                return (
                  <div role="status" style={{ margin:'0 2px 12px', display:'flex', flexDirection:'column', gap:4 }}>
                    {_l ? <div data-front-pending="" style={{ fontSize:12.5, fontWeight:600, color:t.colors.amberText }}>{_l}</div> : null}
                    {_sw ? <div data-send-state={_sst.state} style={{ fontSize:12.5, fontWeight:700, color:t.colors.amberText }}>{_sst.state === 'sent' ? _sw.short : `${_sw.title}. ${_sw.short}`}</div> : null}
                  </div>
                );
              })()}
              {/* Whole-project card */}
              <button onClick={openProject} style={{ width:'100%', display:'flex', alignItems:'center', gap:11, border:`1.5px solid ${t.colors.siteNavy}`, borderRadius:t.radius.card14, padding:'14px 15px', marginBottom:14, cursor:'pointer', background:t.colors.deep03, fontFamily:'inherit', textAlign:'left', ...uvx(() => ({ ...studioSurface.slip(), borderRadius:14, minHeight:56, padding:'8px 14px' })) }}>
                <span style={{ width:11, height:11, borderRadius:'50%', background:t.colors.siteNavy, flexShrink:0 }} />
                <div style={{ flex:1, minWidth:0 }}>
                  <div style={{ fontSize:15, fontWeight:600, color:t.colors.siteNavy, ...uvx(() => ({ fontSize:16, fontWeight:700, color:STUDIO_TOKENS.ink })) }}>Site-wide</div>
                  {/* S160 — a capture bucket, not a summary: when empty, state the
                      purpose rather than counts that read like a broken rollup. */}
                  <div style={{ fontSize:12.5, color:t.colors.khaki, marginTop:2 }}>{projPhotos + projNotes + unassignedNotes.length === 0
                    ? 'For photos and notes not tied to one area'
                    : `${projPhotos} site photo${projPhotos!==1?'s':''} · ${projNotes} project note${projNotes!==1?'s':''}${unassignedNotes.length > 0 ? ` · ${unassignedNotes.length} unassigned` : ''}`}</div>
                </div>
                <span style={{ color:t.colors.stoneLt, fontSize:20 }}>›</span>
              </button>

              {/* Areas section */}
              <div style={{ fontSize:11, letterSpacing:t.font.ls1em, textTransform:'uppercase', color:t.colors.stoneLt, fontWeight:600, margin:'4px 2px 11px', ...uvx(() => ({ ...studioType.colhead(), fontSize:14 })) }}>{t.theme === 'uv' ? 'Zones' : <>Areas ({areasCount})</>}</div>

              {zones.map((z, i) => {
                const s = areaSummary(z);
                // Under the theme: a finished zone is pressed in with an ink
                // tick in a filled ring; an open zone is raised paper with an
                // empty ring, and one not yet started asks for it in violet.
                const uvRow = t.theme === 'uv' ? (s.done ? studioSurface.pressed() : studioSurface.slip()) : null;
                return (
                  <button key={`area-${i}-${z}`} onClick={()=>openArea(i)} style={{ width:'100%', display:'flex', alignItems:'center', gap:12, background:t.colors.areaRowBg, border:`1px solid ${t.colors.areaRowBorder}`, borderRadius:t.radius.card14, padding:'14px 15px', marginBottom:9, cursor:'pointer', fontFamily:'inherit', textAlign:'left', ...uvx(() => ({ ...uvRow, borderRadius:14, minHeight:56, padding:'8px 14px', gap:14 })) }}>
                    {t.theme === 'uv'
                      ? <span aria-hidden="true" style={{ flexShrink:0, width:24, height:24, borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', ...(s.done ? { background:STUDIO_TOKENS.ink } : { border:`1.5px solid ${studioInk(0.35)}` }) }}>{s.done && <svg width="12" height="12" viewBox="0 0 10 10" fill="none"><polyline points="2,5 4.2,7.5 8,2.5" stroke={STUDIO_TOKENS.onPrimary} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>}</span>
                      : <span style={{ width:11, height:11, borderRadius:'50%', background:s.dot, flexShrink:0 }} />}
                    <div style={{ flex:1, minWidth:0 }}>
                      <div style={{ fontSize:16, fontWeight:600, color:t.colors.text, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', ...uvx({ fontWeight:700 }) }}>{z}</div>
                      <div style={{ fontSize:12.5, color: s.started ? t.colors.khaki : t.colors.areaTodo, marginTop:2, ...uvx(() => (s.started ? { fontSize:14, color:STUDIO_TOKENS.muted } : { fontSize:14, color:STUDIO_TOKENS.ink, fontWeight:600 })) }}>{t.theme === 'uv' && !s.started ? 'Tap to survey' : s.line}</div>
                    </div>
                    {s.done && t.theme !== 'uv' && <svg width="16" height="16" viewBox="0 0 10 10" fill="none" style={{ flexShrink:0 }}><polyline points="2,5 4,8 8,2" stroke={t.colors.statusSage} strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/></svg>}
                    <span style={{ color:t.colors.stoneLt, fontSize:20 }}>›</span>
                  </button>
                );
              })}

              {/* Add area */}
              {addingZone ? (
                <div style={{ display:"flex", gap:6, alignItems:"center", marginTop:4 }}>
                  <input value={newZoneName} onChange={e=>setNewZoneName(e.target.value)} autoFocus
                    onKeyDown={e=>{ if(e.key==="Enter") confirmAddZone(); if(e.key==="Escape"){ setAddingZone(false); setNewZoneName(""); } }}
                    placeholder="Area name…"
                    style={{ flex:1, background:t.colors.ink04, border:`1px solid ${t.colors.ink12}`, borderRadius:11, padding:"12px 14px", color:t.colors.text, fontFamily:"inherit", fontSize:15, fontWeight:600, outline:"none" }} />
                  <button onClick={confirmAddZone} style={{ minHeight:46, padding:"0 16px", borderRadius:11, background:t.colors.green, border:'none', color:t.colors.onFill, fontFamily:"inherit", fontSize:14, fontWeight:700, cursor:"pointer" }}>Add</button>
                  <button onClick={()=>{ setAddingZone(false); setNewZoneName(""); }} aria-label="Cancel" style={{ width:46, height:46, borderRadius:11, background:"none", border:`1px solid ${t.colors.ink12}`, color:t.colors.ink45, cursor:"pointer", display:'flex', alignItems:'center', justifyContent:'center' }}><svg width="11" height="11" viewBox="0 0 10 10" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"><line x1="2" y1="2" x2="8" y2="8"/><line x1="8" y1="2" x2="2" y2="8"/></svg></button>
                </div>
              ) : (
                <button onClick={()=>setAddingZone(true)} style={{ width:'100%', padding:15, border:`1.5px dashed ${t.colors.dashSand}`, borderRadius:t.radius.card14, background:'none', color:t.colors.addBlue, fontWeight:600, fontSize:15, cursor:'pointer', marginTop:4, display:'flex', alignItems:'center', justifyContent:'center', gap:8, fontFamily:'inherit', ...uvx(() => ({ border:'none', borderRadius:0, padding:'0 2px', justifyContent:'flex-start', fontSize:16, fontWeight:400, color:STUDIO_TOKENS.ink, textDecoration:'underline', textDecorationColor:studioInk(0.32), textUnderlineOffset:4 })) }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={t.colors.addBlue} strokeWidth="2" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                  {t.theme === 'uv' ? 'Add a zone' : 'Add area'}
                </button>
              )}

              {/* S163 — Wrap up: an obvious primary entry into Wrap from the area
                  list, below "+ Add area". Reuses the stepper's exact navigation
                  via goToWrap (no second path) and is always tappable. A quiet
                  readiness line above it reflects open areas without gating. */}
              {areasCount > 0 && (
                <div style={{ textAlign:'center', fontSize:12, fontWeight:600, margin:'18px 0 8px', display:'flex', alignItems:'center', justifyContent:'center', gap:5, color: openAreas > 0 ? t.colors.areaTodo : t.colors.statusSage }}>
                  {openAreas > 0
                    ? `${openAreas} area${openAreas !== 1 ? 's' : ''} still open`
                    : (<><svg width="13" height="13" viewBox="0 0 10 10" fill="none"><polyline points="2,5 4,8 8,2" stroke={t.colors.statusSage} strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/></svg>All areas done</>)}
                </div>
              )}
              <button onClick={goToWrap}
                onPointerDown={()=>setWrapBtnPressed(true)}
                onPointerUp={()=>setWrapBtnPressed(false)}
                onPointerLeave={()=>setWrapBtnPressed(false)}
                onPointerCancel={()=>setWrapBtnPressed(false)}
                style={{ width:'100%', boxSizing:'border-box', padding:'16px', borderRadius:t.radius.wrapBtn, border:'none',
                  marginTop: areasCount > 0 ? 0 : 16,
                  background: wrapBtnPressed
                    ? t.colors.wrapBtnPressed
                    : t.colors.wrapBtn,
                  color:t.colors.onFill, fontFamily:'inherit', fontSize:16, fontWeight:700, cursor:'pointer',
                  boxShadow: wrapBtnPressed ? t.shadow.wrapBtnPressed : t.shadow.wrapBtn,
                  transform: wrapBtnPressed ? 'scale(0.975)' : 'scale(1)',
                  transition:'transform 0.12s ease, box-shadow 0.12s ease, background 0.12s ease',
                  display:'flex', alignItems:'center', justifyContent:'center', gap:9,
                  ...uvx(() => ({ ...studioSurface.primary(), width:'100%', padding:'0 18px', background: wrapBtnPressed ? STUDIO_TOKENS.ultravioletHover : STUDIO_TOKENS.ultraviolet, transform:'none' })) }}>
                Finish the survey
                {t.theme !== 'uv' && <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke={t.colors.onFill} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><line x1="4" y1="12" x2="19" y2="12"/><polyline points="13 6 19 12 13 18"/></svg>}
              </button>
            </>
          );
        })()}

        {lview === 'area' && (() => {
          // ── Workspace top bar: back + (name / rename) + mark-done ──
          const isProj = projectMode;
          const zone = isProj ? null : currentZone;
          const s = isProj ? null : areaSummary(zone);
          const segDef = isProj
            ? [{ k:'media', label:'Media', n: sitePhotos.filter(p=>p && !p.zone).length }, { k:'notes', label:'Notes', n: notesFor(PROJECT_NOTE_KEY).length }]
            : [{ k:'fix', label:'Fittings', n: zfEntries(zone).length }, { k:'media', label:'Media', n: sitePhotos.filter(p=>p && p.zone===zone).length }, { k:'notes', label:'Notes', n: notesFor(zone).length }];
          // STUDIO-LIT-PHONE-V1 item 7: with the switch on the tabs read as the
          // prototype's: Fittings counts the fittings (the quantities, as the
          // area list does), and Media is Photos unless the area holds a video.
          const uvSegLabel = (sd) => (sd.k === 'media' && !sitePhotos.some(p => p && p.type === 'video' && (isProj ? !p.zone : p.zone === zone)) ? 'Photos' : sd.label);
          const uvSegN = (sd) => (sd.k === 'fix' && !isProj ? s.fitN : sd.n);
          const segNow = isProj && seg === 'fix' ? 'media' : seg;
          return (
            <>
              {/* Top bar (switch off; the switch-on header is below) */}
              {t.theme !== 'uv' && (
              <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:14 }}>
                <button onClick={backToList} aria-label="Back to areas" style={{ width:38, height:38, borderRadius:11, border:'1px solid #EAE0CE', background:'#FDFCF9', color:'#2E6838', cursor:'pointer', flexShrink:0, display:'flex', alignItems:'center', justifyContent:'center', ...uvx(uvClose) }}>
                  <svg width="9" height="14" viewBox="0 0 7 12" fill="none"><path d="M6 1L1 6l5 5" stroke={t.theme === 'uv' ? ST.ink : '#2E6838'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                </button>
                {(!isProj && renamingZone) ? (
                  <input value={renameText} onChange={e=>setRenameText(e.target.value)} autoFocus
                    onKeyDown={e=>{ if(e.key==='Enter') confirmRenameZone(); if(e.key==='Escape') setRenamingZone(false); }}
                    onBlur={confirmRenameZone}
                    style={{ flex:1, background:'rgba(26,22,8,0.04)', border:'1px solid rgba(26,22,8,0.12)', borderRadius:8, padding:'6px 10px', fontFamily:'Georgia, serif', fontStyle:'italic', fontSize:21, color:'#1A1608', outline:'none', minWidth:0, ...uvx(() => ({ ...uvField(), minHeight:44, padding:'4px 12px', fontFamily:ST.fonts.display, fontStyle:'normal', fontWeight:300, fontSize:25 })) }} />
                ) : (
                  <div onClick={()=>{ if(!isProj){ setRenameText(zone); setRenamingZone(true); } }} style={{ flex:1, minWidth:0, display:'flex', alignItems:'center', gap:6, cursor: isProj?'default':'pointer', ...uvx({ minHeight:44, gap:8 }) }}>
                    <span style={{ fontFamily:'Georgia, serif', fontStyle:'italic', fontSize:21, color:'#1A1608', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', ...uvx(() => ({ ...studioType.title(), fontSize:25, lineHeight:1.15, whiteSpace:'nowrap' })) }}>{isProj ? 'Site-wide' : zone}</span>
                    {!isProj && <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke={t.theme === 'uv' ? ST.muted : '#5A4A2A'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ opacity:0.35, flexShrink:0, ...uvx({ opacity:1 }) }}><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>}
                  </div>
                )}
                {/* Under the theme Mark done is a raised slip you press; once
                    done it is pressed in with an ink tick (done is pressed in). */}
                {!isProj && (
                  <button onClick={()=>toggleDone(zone)} style={{ fontSize:12, fontWeight:600, padding:'7px 12px', borderRadius:9, border:`1px solid ${s.done?'#5A9048':'#DDD0B8'}`, background: s.done?'#D5EACF':'#FDFCF9', color: s.done?'#284820':'#564A38', cursor:'pointer', fontFamily:'inherit', flexShrink:0, ...uvx(() => ({ ...(s.done ? studioSurface.pressed() : studioSurface.slip()), color:ST.ink, fontSize:14, minHeight:44, padding:'0 14px', borderRadius:12, display:'inline-flex', alignItems:'center', gap:6 })) }}>
                    {t.theme === 'uv'
                      ? (s.done ? <><svg aria-hidden="true" width="12" height="12" viewBox="0 0 10 10" fill="none"><polyline points="2,5 4.2,7.5 8,2.5" stroke={ST.ink} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>Done</> : 'Mark done')
                      : (s.done ? '✓ Done' : 'Mark done')}
                  </button>
                )}
              </div>
              )}

              {/* STUDIO-LIT-PHONE-V1 item 7: with the switch on, an area opens
                  as the prototype's #app/zone: "Areas" back and Mark done on one
                  row, then the area's name as the heading (tap it to rename).
                  The track C1 big number above the tabs is gone: the prototype
                  has none, and the tabs carry the counts. */}
              {t.theme === 'uv' && <SvLit draw={() => (
                <div style={{ marginBottom:14 }}>
                  <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', gap:10, minHeight:46 }}>
                    <SvBack label="Areas" aria="Back to areas" onClick={backToList} />
                    {!isProj && (
                      <button onClick={()=>toggleDone(zone)} style={{ ...(s.done ? studioSurface.pressed() : studioSurface.slip()), color:ST.ink, fontSize:16, fontWeight:600, minHeight:44, padding:'0 14px', borderRadius:ST.button.radius, display:'inline-flex', alignItems:'center', gap:6, cursor:'pointer', fontFamily:'inherit' }}>
                        {s.done ? <><svg aria-hidden="true" width="12" height="12" viewBox="0 0 10 10" fill="none"><polyline points="2,5 4.2,7.5 8,2.5" stroke={ST.ink} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>Done</> : 'Mark done'}
                      </button>
                    )}
                  </div>
                  {(!isProj && renamingZone) ? (
                    <input value={renameText} onChange={e=>setRenameText(e.target.value)} autoFocus
                      onKeyDown={e=>{ if(e.key==='Enter') confirmRenameZone(); if(e.key==='Escape') setRenamingZone(false); }}
                      onBlur={confirmRenameZone}
                      style={{ ...uvField(), width:'100%', boxSizing:'border-box', minHeight:52, marginTop:6, padding:'4px 12px', fontFamily:ST.fonts.display, fontWeight:300, fontSize:31, outline:'none' }} />
                  ) : (
                    <h1 onClick={()=>{ if(!isProj){ setRenameText(zone); setRenamingZone(true); } }} style={{ ...svH1(), fontSize:31, lineHeight:1.08, marginTop:6, cursor: isProj ? 'default' : 'text' }}>{isProj ? 'Site-wide' : zone}</h1>
                  )}
                </div>
              )} />}

              {/* Segmented tabs. Under the theme the tab you are on is pressed
                  in (where you are), the others are words on the ground. */}
              <div style={{ display:'flex', background:'#F4EFE5', borderRadius:12, padding:4, marginBottom:16, ...uvx(() => ({ ...studioSurface.pressed(), borderRadius:12, padding:4, gap:4 })) }}>
                {segDef.map(sd => (
                  <button key={sd.k} onClick={()=>setSeg(sd.k)} style={{ flex:1, textAlign:'center', padding:'10px 4px', borderRadius:9, fontSize:13.5, fontWeight:600, color: segNow===sd.k?'#2E6838':'#7A6C5A', cursor:'pointer', fontFamily:'inherit', background: segNow===sd.k?'#FDFCF9':'transparent', boxShadow: segNow===sd.k?'0 1px 4px rgba(0,0,0,0.06)':'none', border:'none', ...uvx(() => ({ ...(segNow===sd.k ? { ...studioSurface.slip(), boxShadow:`-3px 5px 10px -6px ${studioInk(0.45)}` } : { background:'none', boxShadow:'none', border:'none' }), minHeight:44, borderRadius:9, fontSize:16, fontWeight: segNow===sd.k ? 600 : 400, color: segNow===sd.k ? ST.ink : ST.muted })) }}>
                    {t.theme === 'uv' ? uvSegLabel(sd) : sd.label}<span style={{ fontSize:11, opacity:0.6, marginLeft:3, ...uvx({ fontSize:16, opacity:1, marginLeft:6, fontWeight:800, fontVariantNumeric:'tabular-nums' }) }}>{t.theme === 'uv' ? uvSegN(sd) : sd.n}</span>
                  </button>
                ))}
              </div>

              {/* ── FITTINGS TAB ── */}
              {!isProj && segNow === 'fix' && (
                <>
                  {/* NOTES-IN-AREA, the way in (21 October 2026, Andrew on site: "It was
                      not obvious where I could add notes"). One slim row directly under
                      the tabs, so a note about this area is a tap away on every visit,
                      however many fittings are logged below: it is the first thing under
                      the tab strip, never pushed down the page. Both buttons open the
                      sheets the Notes tab opens (the typed note sheet, the voice sheet)
                      and save through addNoteTo under this area's name: no editor and no
                      save of its own. Secondary actions, never the violet one. */}
                  <div role="group" aria-label={`Add a note about ${zone}`} style={{ display:'flex', gap:9, marginTop:-4, marginBottom:12 }}>
                    <button onClick={()=>{ setNoteSheetText(''); setShowNoteSheet(true); }} style={{ flex:1, minHeight:44, padding:'0 10px', border:'1px solid #DDD0B8', borderRadius:12, background:'#FDFCF9', fontWeight:600, fontSize:13.5, color:'#4A6462', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', gap:7, fontFamily:'inherit', ...uvx(() => ({ ...uvSlipBtn(), fontSize:14, padding:'0 10px', gap:8 })) }}>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={t.theme === 'uv' ? ST.ink : "#4A6462"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                      Add a note
                    </button>
                    <button onClick={openVoiceSheet} style={{ flex:1, minHeight:44, padding:'0 10px', border:'1px solid #C06848', borderRadius:12, background:'#FDFCF9', fontWeight:600, fontSize:13.5, color:'#C06848', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', gap:7, fontFamily:'inherit', ...uvx(() => ({ ...uvSlipBtn(), fontSize:14, padding:'0 10px', gap:8 })) }}>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={t.theme === 'uv' ? ST.ink : "#C06848"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><rect x="9" y="1" width="6" height="11" rx="3"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" y1="19" x2="12" y2="23"/><line x1="8" y1="23" x2="16" y2="23"/></svg>
                      Add a voice note
                    </button>
                  </div>

                  {/* Logged fittings as calm cards */}
                  {zfEntries(zone).map(e => {
                    // P1: the real size or length, a typed custom one included, and the type's own options (cutout...).
                    const sizeLabel = fittingRowDetail(e, studioSep());
                    const sensorV = e.extras?.sensor || '';
                    const dimV = e.extras?.dim || '';
                    // Under the theme each logged fitting is a raised slip (you
                    // can act on it: tap to edit, step the count), its count in
                    // Satoshi tabular figures between two 44px steppers, and EM,
                    // sensor and dimming as plain muted words, never chips.
                    const uvStep = () => ({ ...studioSurface.pressed(), width:44, height:44, borderRadius:12, color:ST.ink, fontFamily:ST.fonts.body, fontSize:20 });
                    return (
                      <div key={e.uid} style={{ background:'#FDFCF9', border:'1px solid #EAE0CE', borderRadius:12, padding:'12px 14px', marginBottom:8, display:'flex', alignItems:'center', gap:11, ...uvx(() => ({ ...studioSurface.slip(), borderRadius:14, padding:'6px 6px 6px 14px' })) }}>
                        <button onClick={()=>editFitFromCard(e.uid)} style={{ flex:1, minWidth:0, background:'none', border:'none', padding:0, textAlign:'left', cursor:'pointer', fontFamily:'inherit', ...uvx({ minHeight:44 }) }}>
                          <div style={{ display:'flex', alignItems:'baseline', gap:9, flexWrap:'wrap' }}>
                            <span style={{ fontWeight:600, fontSize:16, color:'#1A1608', ...uvx(() => ({ fontWeight:700, color:fittingTypeColour(e.fixtureId, ST.ink) })) }}>{e.fixtureName}</span>
                            {sizeLabel && <span style={{ fontSize:13.5, color:'#8A7A5A', ...uvx(() => ({ fontSize:14, color:ST.muted })) }}>{sizeLabel}</span>}
                          </div>
                          {(e.emQty>0 || sensorV || dimV) && (
                            <div style={{ display:'flex', flexWrap:'wrap', gap:6, marginTop:8, ...uvx({ gap:12, marginTop:2 }) }}>
                              {e.emQty>0 && <span style={{ fontSize:10.5, fontWeight:600, padding:'3px 8px', borderRadius:6, background:'#D5EACF', color:'#284820', ...uvx(() => ({ fontSize:14, fontWeight:400, padding:0, borderRadius:0, background:'none', color:ST.muted })) }}>{e.emQty} EM</span>}
                              {sensorV && <span style={{ fontSize:10.5, fontWeight:600, padding:'3px 8px', borderRadius:6, background:'#E4ECEB', color:'#4A6462', ...uvx(() => ({ fontSize:14, fontWeight:400, padding:0, borderRadius:0, background:'none', color:ST.muted })) }}>{sensorV==='Sensor'?'Sensor':'Sensor'+studioSep()+sensorV}</span>}
                              {dimV && <span style={{ fontSize:10.5, fontWeight:600, padding:'3px 8px', borderRadius:6, background:'#E4ECEB', color:'#4A6462', ...uvx(() => ({ fontSize:14, fontWeight:400, padding:0, borderRadius:0, background:'none', color:ST.muted })) }}>{dimV==='Dimmable'?'Dim':'Dim'+studioSep()+dimV}</span>}
                            </div>
                          )}
                        </button>
                        <div style={{ display:'flex', alignItems:'center', border:'1px solid #EAE0CE', borderRadius:10, overflow:'hidden', flexShrink:0, background:'#FAF8F3', ...uvx(() => ({ background:'none', border:'none', boxShadow:'none', gap:2 })) }}>
                          <button aria-label="Decrease quantity" onClick={()=>bumpFitQty(zone, e.uid, -1)} style={{ width:38, height:38, border:'none', background:'#FAF8F3', fontSize:20, color:'#2E6838', cursor:'pointer', fontFamily:'Georgia, serif', ...uvx(uvStep) }}>−</button>
                          <span style={{ minWidth:30, textAlign:'center', fontFamily:'Georgia, serif', fontSize:17, color:'#1A1608', ...uvx(() => ({ minWidth:52, fontFamily:ST.fonts.display, fontSize:39, fontWeight:300, lineHeight:1, color:fittingTypeColour(e.fixtureId, ST.ink), fontVariantNumeric:'tabular-nums' })) }}>{e.qty}</span>
                          <button aria-label="Increase quantity" onClick={()=>bumpFitQty(zone, e.uid, 1)} style={{ width:38, height:38, border:'none', background:'#FAF8F3', fontSize:20, color:'#2E6838', cursor:'pointer', fontFamily:'Georgia, serif', ...uvx(uvStep) }}>+</button>
                        </div>
                      </div>
                    );
                  })}
                  {zfEntries(zone).length === 0 && !selFixId && (
                    <div style={{ textAlign:'center', color:'#8A7A5A', fontSize:14, padding:'14px 10px 16px', ...uvx(() => ({ textAlign:'left', color:ST.muted, fontSize:16, padding:'4px 6px 14px' })) }}>No fittings yet. Add them by hand below.</div>
                  )}

                  {/* P1: floors repeat, so an area's fittings copy to other areas
                      (or in from one), instead of being logged again by hand. */}
                  {!selFixId && (() => {
                    const hasHere = zfEntries(zone).length > 0;
                    const otherWithFittings = zones.some(z => zoneKey(z) !== zoneKey(zone) && zfEntries(z).length > 0);
                    if (!hasHere && !otherWithFittings && !copySaveFailed) return null;
                    const copyBtn = { width:'100%', minHeight:44, margin:'2px 0 10px', padding:'0 14px', borderRadius:12, background:'#FDFCF9', border:'1px solid #EAE0CE', color:'#2E6838', fontSize:14, fontWeight:600, cursor:'pointer', fontFamily:'inherit', textAlign:'center', ...uvx(() => ({ ...uvSlipBtn(), border:'none', width:'100%' })) };
                    return (
                      <>
                        {copySaveFailed && (
                          <div role="alert" style={{ padding:'12px 14px', marginBottom:10, borderRadius:12, background:'#FBE9E4', border:'1px solid #E3B3A6', color:'#7A2A18', fontSize:14, lineHeight:1.4, ...uvx(() => ({ ...studioSurface.pressed(), border:'none', color:ST.ink })) }}>
                            The copy is on screen but this phone did not save it. Storage may be full. Free some space, then try saving again.
                            <button onClick={retryCopySave} style={{ display:'block', marginTop:8, minHeight:44, padding:'0 14px', borderRadius:10, border:'1px solid #E3B3A6', background:'#FDFCF9', color:'#7A2A18', fontSize:14, fontWeight:600, cursor:'pointer', fontFamily:'inherit', ...uvx(() => ({ ...uvSlipBtn(), border:'none' })) }}>Try saving again</button>
                          </div>
                        )}
                        {hasHere && <button onClick={() => openCopySheet('to')} style={copyBtn}>Copy these fittings to…</button>}
                        {!hasHere && otherWithFittings && <button onClick={() => openCopySheet('from')} style={copyBtn}>Copy fittings from…</button>}
                      </>
                    );
                  })()}

                  {/* Fixture grid. Under the theme the heading is a sentence-case
                      column head and the rules either side are hairlines. */}
                  {/* STUDIO-LIT-PHONE-V1 item 7: with the switch on, a heading
                      with "External or IP rated" beside it as an ink link (it
                      opens the external keys, as the switch-off bar does). */}
                  {t.theme === 'uv' ? <SvLit draw={() => {
                    const extN = externalFixtures().reduce((n2, f) => n2 + zoneTileTotal(f.id), 0);
                    return (
                      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'baseline', gap:10, margin:'18px 0 8px' }}>
                        <h2 style={svH2()}>Add a fitting</h2>
                        <button onClick={()=>setExternalExpanded(v=>!v)} aria-expanded={externalExpanded} style={{ ...svLink(), fontSize:16 }}>External or IP rated{extN > 0 ? `, ${extN}` : ''}</button>
                      </div>
                    );
                  }} /> : (
                  <div style={{ display:'flex', alignItems:'center', gap:8, margin:'8px 0 10px', ...uvx({ margin:'14px 0 10px' }) }}>
                    <div style={{ flex:1, height:0.5, background:'rgba(42,58,26,0.10)', ...uvx(() => ({ height:1, background:ST.hairline })) }} />
                    <span style={{ fontSize:9, fontWeight:700, color:'#8A7A5A', textTransform:'uppercase', letterSpacing:'0.08em', flexShrink:0, ...uvx(uvLabel) }}>Add a fitting</span>
                    <div style={{ flex:1, height:0.5, background:'rgba(42,58,26,0.10)', ...uvx(() => ({ height:1, background:ST.hairline })) }} />
                  </div>
                  )}
                  {(() => {
                    const renderTile = (f) => {
                      const total=zoneTileTotal(f.id);
                      const isSel=selFixId===f.id;
                      const has=total>0;
                      const gridType = FIXTURE_TYPES_GRID.find(ft => ft.id === f.id.replace(/^(t8|t5)$/, '$1_batten')) || FIXTURE_TYPES_GRID.find(ft => ft.label.toLowerCase() === f.label.toLowerCase());
                      const tileColor = gridType ? gridType.color : (isSel ? t.colors.teal : has ? t.colors.green : 'rgba(28,24,16,0.38)');
                      const tileGradient = gridType ? gridType.gradient : (isSel ? 'linear-gradient(145deg,rgba(26,90,120,0.14),rgba(255,252,242,0.88))' : has ? 'linear-gradient(145deg,rgba(46,104,56,0.10),rgba(255,252,242,0.88))' : 'rgba(255,252,242,0.55)');
                      const tileBorder = gridType ? gridType.border : (isSel ? 'rgba(26,90,120,0.4)' : has ? 'rgba(46,104,56,0.28)' : 'rgba(160,138,100,0.22)');
                      // Under the theme a tile is raised paper with an ink line
                      // icon (the per-type tints were colour for looks); the one
                      // you have open is pressed in. Its count is ink figures in
                      // the corner, not a filled badge. The Custom tile keeps its
                      // dashed edge (it adds a type, it is not one).
                      // P2A: the symbol's strokes take the type's colour; the label stays ink.
                      const uvIcon = fittingTypeColour(f.id, isSel || has ? ST.ink : ST.muted);
                      return (
                        <button key={f.id} className="fixture-tile" onClick={()=>{ if(f.isCustomBtn){ setShowCustomModal(true); } else { tapFixtureSel(f.id); } }} style={{
                          borderRadius:14, padding:'14px 8px 11px', cursor:"pointer", position:"relative",
                          background: isSel ? `${tileGradient.replace('0.22','0.35').replace('0.06','0.15')}` : tileGradient,
                          border:`${isSel?2:1.5}px ${f.isCustomBtn?"dashed":"solid"} ${isSel ? tileColor : tileBorder}`,
                          outline: isSel ? '2px solid #2E6838' : 'none', outlineOffset: -1,
                          display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", gap:8, transition:"all .15s",
                          ...uvx(() => ({ ...(isSel ? studioSurface.pressed() : has ? studioSurface.slip() : { background:studioRgba(ST.paper.stops[0], 0.6), boxShadow:`inset 0 0 0 1px ${studioInk(0.08)}`, border:'none' }), ...(f.isCustomBtn ? { border:`1.5px dashed ${studioInk(0.32)}`, boxShadow:'none', background:'none' } : {}), outline:'none', minHeight:76, padding:'12px 4px 10px', gap:6 })),
                        }}>
                          {gridType ? (
                            <div dangerouslySetInnerHTML={{ __html: `<svg width="26" height="26" viewBox="${gridType.vb}" fill="none">${t.theme === 'uv' ? gridType.svgPath.replace(/COLOR/g, uvIcon).replace(/fill="rgba\([^)]*\)"/g, 'fill="none"') : gridType.svgPath.replace(/COLOR/g, isSel ? tileColor : (has ? tileColor : tileColor + '80'))}</svg>` }} />
                          ) : (
                            <div style={{ color: tileColor, ...uvx({ color:uvIcon }) }}>{FIXTURE_ICONS[f.icon]||FIXTURE_ICONS.plus}</div>
                          )}
                          <span style={{ fontSize:10, fontWeight:800, textTransform:"uppercase", letterSpacing:'0.04em', color: tileColor, textAlign:"center", lineHeight:1.2, ...uvx(() => ({ fontSize:13, fontWeight: isSel || has ? 700 : 400, textTransform:'none', letterSpacing:'normal', color: isSel || has ? ST.ink : ST.muted })) }}>{f.label}</span>
                          {total>0 && <div style={{ position:"absolute", top:-1, right:-1, background:'#2E6838', borderRadius:'0 12px 0 8px', padding:'1px 6px', ...uvx({ top:6, right:8, background:'none', borderRadius:0, padding:0 }) }}><span style={{ fontSize:10, fontWeight:700, color:'white', ...uvx(() => ({ fontSize:13, color:ST.ink, fontVariantNumeric:'tabular-nums' })) }}>{total}</span></div>}
                        </button>
                      );
                    };
                    const extList = externalFixtures();
                    const extTotal = extList.reduce((s2,f)=>s2+zoneTileTotal(f.id),0);
                    const selIsExt = selFixId && extList.some(f => f.id === selFixId);
                    const showExt = externalExpanded || selIsExt;
                    return (
                      <>
                        <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:7, marginBottom: selFixId?0:10, ...uvx({ gap:8 }) }}>
                          {internalFixtures().map(renderTile)}
                        </div>
                        <div style={{ marginBottom:14, ...uvx({ marginTop: selFixId ? 10 : 0 }) }}>
                          {t.theme !== 'uv' && (
                          <button onClick={()=>setExternalExpanded(v=>!v)} aria-expanded={showExt}
                            style={{ width:'100%', minHeight:44, display:'flex', alignItems:'center', gap:8, background:'rgba(26,90,120,0.06)', border:'1px solid rgba(26,90,120,0.22)', borderRadius:10, padding:'0 12px', cursor:'pointer', fontFamily:'inherit', ...uvx(() => ({ ...(showExt ? studioSurface.pressed() : studioSurface.slip()), borderRadius:12, padding:'0 14px' })) }}>
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={t.theme === 'uv' ? ST.ink : '#1A5A78'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 12h18M12 3v18M5.6 5.6l12.8 12.8M18.4 5.6L5.6 18.4"/></svg>
                            <span style={{ flex:1, textAlign:'left', fontSize:12, fontWeight:800, color:'#1A5A78', textTransform:'uppercase', letterSpacing:0.6, ...uvx(() => ({ fontSize:16, fontWeight:600, color:ST.ink, textTransform:'none', letterSpacing:'normal' })) }}>External / IP-rated</span>
                            {extTotal > 0 && <span style={{ fontSize:11, fontWeight:700, color:'#1A5A78', background:'rgba(26,90,120,0.12)', padding:'2px 7px', borderRadius:8, ...uvx(() => ({ fontSize:14, color:ST.muted, background:'none', padding:0, borderRadius:0, fontVariantNumeric:'tabular-nums' })) }}>{extTotal}</span>}
                            <span style={{ fontSize:14, color:'#1A5A78', fontWeight:700, ...uvx(() => ({ color:ST.muted })) }}>{showExt ? '▾' : '▸'}</span>
                          </button>
                          )}
                          {showExt && (
                            <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:7, marginTop:8 }}>
                              {extList.map(renderTile)}
                            </div>
                          )}
                        </div>
                      </>
                    );
                  })()}

                  {/* NOTES-IN-AREA, the list: under the fitting keys, the area's newest
                      notes, so a surveyor sees a note land where they meant it. Drawn
                      only once the area has a note (the buttons that add one are the
                      row under the tabs, above). A row or See all notes opens the
                      Notes tab. */}
                  {(() => {
                    const preview = areaNoteLines(notesFor(zone), AREA_NOTES_SHOWN);
                    if (!preview.total) return null;
                    const rowStyle = { display:'flex', alignItems:'baseline', gap:12, width:'100%', minHeight:44, boxSizing:'border-box', padding:'10px 14px', marginBottom:8, border:'1px solid #EAE0CE', borderRadius:12, background:'#FDFCF9', textAlign:'left', cursor:'pointer', fontFamily:'inherit', fontSize:14, lineHeight:1.45, color:'#1A1608', ...uvx(() => ({ background:'none', border:'none', borderTop:`1px solid ${ST.hairline}`, borderRadius:0, padding:'10px 0', marginBottom:0, fontSize:16, color:ST.ink })) };
                    return (
                      <section aria-label="Area notes" style={{ marginBottom:6 }}>
                        <h2 style={{ margin:'6px 2px 10px', fontSize:15, fontWeight:700, color:'#1A1608', ...uvx(() => ({ ...svH2(), margin:'10px 0 8px' })) }}>{`Notes for ${zone}`}</h2>
                        {preview.lines.map((ln) => (
                          <button key={ln.id} onClick={()=>setSeg('notes')} style={rowStyle}>
                            <span style={{ flex:'0 0 44px', fontSize:12, color:'#8A7A5A', ...uvx(() => ({ fontSize:14, color:ST.muted, fontVariantNumeric:'tabular-nums' })) }}>{ln.time}</span>
                            <span style={{ flex:1, minWidth:0, display:'-webkit-box', WebkitLineClamp:3, WebkitBoxOrient:'vertical', overflow:'hidden', overflowWrap:'anywhere' }}>
                              {ln.voice && <span style={{ color:'#8A7A5A', ...uvx(() => ({ color:ST.muted })) }}>Voice note: </span>}{ln.text}
                            </span>
                          </button>
                        ))}
                        {preview.more > 0 && (
                          <button onClick={()=>setSeg('notes')} style={{ minHeight:44, padding:'0 4px', border:'none', background:'none', color:'#4A6462', fontSize:13.5, fontWeight:600, textDecoration:'underline', cursor:'pointer', fontFamily:'inherit', ...uvx(() => ({ ...svLink(), fontSize:16 })) }}>See all notes</button>
                        )}
                      </section>
                    );
                  })()}

                  {/* Attribute panel */}
                  {selFixture && !selFixture.isCustomBtn && (() => {
                    const sizes = (selFixture.variants?.primary)||[];
                    // S159 — every size row offers Custom (type a value). The 'No size'
                    // chip was dropped in S161 (v176 device pass): UI removal only — the
                    // record-level primary: null handling stays everywhere (wrap
                    // derivation, signature, labels, payload) because legacy records
                    // and custom fixtures still produce null.
                    const sizeChips = sizes.indexOf('Custom') === -1 ? [...sizes, 'Custom'] : sizes;
                    const SENS = ['None','Sensor','PIR','Microwave','Daylight','Custom'];
                    const DIMS = ['None','Dimmable','DALI','1-10V','Mains/Triac','Push','Casambi','Custom'];
                    const sizeIsCustom = selPrimary === 'Custom';
                    // More options (Sensor, Dimming) opens by itself while either holds a value.
                    const moreSel = { sensorSel:selSensorSel, sensorCustom:selSensorCustom, dimSel:selDimSel, dimCustom:selDimCustom };
                    const moreVals = moreOptionsValues(moreSel);
                    const moreIsOpen = moreOptionsIsOpen(moreOpen, moreSel);
                    return (
                    <SheetPortal>
                    {/* P1: the fitting form is a sheet over the area, above the tab bar, so it is in view the moment a type is tapped. Closing or saving leaves the area exactly where it was.
                        It goes through SheetPortal: rendered here, inside the area's scroll area, it was drawn under the tab bar on iOS (21 October 2026). */}
                    <div onClick={clearSelEx} style={{ position:'fixed', inset:0, background:'rgba(58,48,24,0.4)', zIndex:199, ...uvx(uvScrim) }} />
                    <div role="dialog" aria-label={`${editFitUid?'Edit ':'Add '}${selFixture.label}`} style={{ position:'fixed', left:0, right:0, bottom:0, zIndex:200, maxHeight:'88%', display:'flex', flexDirection:'column', background:"rgba(255,252,242,0.99)", borderRadius:'22px 22px 0 0', borderTop:"1px solid rgba(255,255,250,0.96)", boxShadow:'0 -10px 32px rgba(28,24,16,0.28)', paddingBottom:'env(safe-area-inset-bottom, 0px)', overflow:"hidden", ...uvx(() => ({ ...uvSheet(), borderRadius:`${ST.radius.card}px ${ST.radius.card}px 0 0` })) }}>
                      <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", flexShrink:0, padding:"10px 14px", borderBottom:"0.5px solid rgba(28,24,16,0.08)", ...uvx(() => ({ borderBottom:`1px solid ${ST.hairline}`, padding:'8px 8px 8px 16px' })) }}>
                        <p style={{ fontSize:15, fontWeight:700, color:"#1A1608", ...uvx(uvHeading) }}>{editFitUid?'Edit ':''}{selFixture.label}</p>
                        <button aria-label="Close fixture editor" onClick={clearSelEx} style={{ width:44, height:44, borderRadius:8, background:"rgba(28,24,16,0.06)", border:"0.5px solid rgba(28,24,16,0.12)", display:"flex", alignItems:"center", justifyContent:"center", cursor:"pointer", ...uvx(uvClose) }}>
                          <Icon name="close" size={12} color={t.theme === 'uv' ? ST.ink : "rgba(28,24,16,0.55)"} />
                        </button>
                      </div>
                      <div style={{ padding:"10px 14px 14px", flex:'1 1 auto', minHeight:0, overflowY:'auto', WebkitOverflowScrolling:'touch', overscrollBehavior:'contain', ...uvx({ padding:'14px 16px 16px' }) }}>
                        {/* S153 — provenance: this sheet was pre-filled by a scan */}
                        {scanProvenance && (
                          <div style={{ display:'flex', alignItems:'center', gap:9, padding:'8px 11px', borderRadius:10, background:'rgba(74,100,98,0.06)', border:'1px solid rgba(74,100,98,0.2)', marginBottom:12, ...uvx(() => ({ ...studioSurface.pressed(), borderRadius:12, padding:'10px 12px', flexWrap:'wrap' })) }}>
                            <FromPhotoTag />
                            <span style={{ fontSize:11, color:'#7A6C5A', lineHeight:1.35, ...uvx(() => ({ fontSize:14, color:ST.ink })) }}>Pre-filled from the scan. Check every value, then Log.</span>
                          </div>
                        )}
                        {/* S161 — optional Description, directly under the type heading.
                            Hand-typed, or pre-filled by the scan's read description (the
                            table-lamp case) and editable like every other scan value. */}
                        <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:8 }}>
                          <p style={{ fontSize:13, fontWeight:700, color:'#1A1608', textTransform:"uppercase", letterSpacing:0.08, ...uvx(uvLabel) }}>Description</p>
                          {scanProvenance && selDesc.trim() !== '' && <FromPhotoTag />}
                        </div>
                        <input value={selDesc} onChange={e=>setSelDesc(e.target.value)} placeholder="Optional, e.g. table lamp, brass twin pendant"
                          style={{ width:'100%', minHeight:44, background:'rgba(255,255,255,0.65)', border:'1px solid rgba(255,252,240,0.90)', borderRadius:10, padding:'10px 13px', color:'#1A1608', fontFamily:'inherit', fontSize:15, fontWeight:600, outline:'none', marginBottom:12, boxSizing:'border-box', ...uvx(uvField) }} />
                        {/* Size */}
                        {sizes.length>0 && (<>
                          <p style={{ fontSize:13, fontWeight:700, color:'#1A1608', textTransform:"uppercase", letterSpacing:0.08, marginBottom:8, ...uvx(uvLabel) }}>Size</p>
                          <div style={{ display:"flex", gap:5, flexWrap:"wrap", marginBottom: sizeIsCustom?8:10 }}>
                            {sizeChips.map(v=>(
                              <button key={v} onClick={()=>{ setSelPrimary(v); setSelSecondary(selFixture.variants?.secondary?.[0]||null); /* Typed values (the Fitting size box and the fields that show only under Custom) are kept in state, per field, and filtered at Log (typedSizeToSave, dropHiddenExtras), so Custom, another size, Custom finds what was typed. */ }} style={{ minHeight:44, padding:"0 16px", borderRadius:10, fontSize:13, fontWeight:selPrimary===v?700:500, cursor:"pointer", fontFamily:"inherit", background:selPrimary===v?"rgba(42,58,26,0.12)":"rgba(42,58,26,0.06)", border:`1px solid ${selPrimary===v?"rgba(42,58,26,0.35)":"rgba(42,58,26,0.15)"}`, color:selPrimary===v?"#1A1608":"#3A2A10", ...uvx(() => uvChip(selPrimary===v)) }}>{v}</button>
                            ))}
                          </div>
                          {sizeIsCustom && (<>
                            <label htmlFor="fit-size-custom" style={{ display:'block', fontSize:13, fontWeight:700, color:'#1A1608', marginBottom:6, ...uvx(uvLabel) }}>Fitting size</label>
                            <input id="fit-size-custom" value={selSizeCustom} onChange={e=>setSelSizeCustom(e.target.value)} placeholder="Type the size, e.g. 130mm or 155x155"
                              style={{ width:'100%', minHeight:44, background:'rgba(62,139,191,0.06)', border:'1.5px solid rgba(62,139,191,0.4)', borderRadius:10, padding:'10px 13px', color:'#1A1608', fontFamily:'inherit', fontSize:15, fontWeight:600, outline:'none', ...uvx(uvField), marginBottom:10, boxSizing:'border-box' }} />
                          </>)}
                        </>)}

                        {/* Secondary length */}
                        {(selFixture.variants?.secondary||[]).length>0 && (<>
                          <p style={{ fontSize:10, fontWeight:700, color:t.colors.textTertiary, textTransform:"uppercase", letterSpacing:.8, marginBottom:7, ...uvx(() => ({ ...uvLabel(), marginBottom:8 })) }}>Length</p>
                          <div style={{ display:"flex", gap:5, flexWrap:"wrap", marginBottom:10 }}>
                            {(selFixture.variants.secondary||[]).map(v=>(
                              <button key={v} onClick={()=>setSelSecondary(v)} style={{ minHeight:44, padding:"0 14px", borderRadius:22, fontSize:12, fontWeight:700, cursor:"pointer", fontFamily:"inherit", background:selSecondary===v?"linear-gradient(135deg, rgba(200,144,48,0.18), rgba(26,90,120,0.14))":"rgba(255,255,255,0.65)", border:`1px solid ${selSecondary===v?"rgba(200,144,48,0.35)":"rgba(255,252,240,0.90)"}`, color:selSecondary===v?"#1A1608":"rgba(28,24,16,0.52)", ...uvx(() => uvChip(selSecondary===v)) }}>{v}</button>
                            ))}
                          </div>
                        </>)}

                        {/* Custom extras (per-fixture) */}
                        {activeExtras.map(cx=>(
                          <div key={cx.key} style={{ marginBottom:10 }}>
                            <p style={{ fontSize:10, fontWeight:700, color:t.colors.textTertiary, textTransform:"uppercase", letterSpacing:.8, marginBottom:7, ...uvx(() => ({ ...uvLabel(), marginBottom:8 })) }}>{cx.label}</p>
                            {cx.type==="chips" ? (<>
                              <div style={{ display:"flex", gap:5, flexWrap:"wrap" }}>
                                {(cx.chips||[]).map(c=>(
                                  <button key={c} onClick={()=>{ setSelChips(prev=>({...prev,[cx.key]:c})); if(c!=='Custom') setSelChipCustom(prev=>{ const n={...prev}; delete n[cx.key]; return n; }); }} style={{ minHeight:44, padding:"0 14px", borderRadius:22, fontSize:12, fontWeight:700, cursor:"pointer", fontFamily:"inherit", background:selChips[cx.key]===c?"linear-gradient(135deg, rgba(200,144,48,0.18), rgba(26,90,120,0.14))":"rgba(255,255,255,0.65)", border:`1px solid ${selChips[cx.key]===c?"rgba(200,144,48,0.35)":"rgba(255,252,240,0.90)"}`, color:selChips[cx.key]===c?"#1A1608":"rgba(28,24,16,0.52)", ...uvx(() => uvChip(selChips[cx.key]===c)) }}>{c}</button>
                                ))}
                              </div>
                              {/* S159 — a 'Custom' chip reveals an input; the typed value replaces the marker at Log */}
                              {(cx.chips||[]).indexOf('Custom') > -1 && selChips[cx.key]==='Custom' && (<>
                                <label htmlFor={`fit-chip-custom-${cx.key}`} style={{ display:'block', fontSize:13, fontWeight:700, color:'#1A1608', marginTop:8, ...uvx(uvLabel) }}>{cx.customLabel||cx.label}</label>
                                <input id={`fit-chip-custom-${cx.key}`} value={selChipCustom[cx.key]||''} onChange={ev=>setSelChipCustom(prev=>({...prev,[cx.key]:ev.target.value}))} placeholder={cx.customPlaceholder||'Type the value'}
                                  style={{ width:'100%', minHeight:44, background:'rgba(62,139,191,0.06)', border:'1.5px solid rgba(62,139,191,0.4)', borderRadius:10, padding:'10px 13px', color:'#1A1608', fontFamily:'inherit', fontSize:15, fontWeight:600, outline:'none', ...uvx(uvField), marginTop:8, boxSizing:'border-box' }} />
                              </>)}
                            </>) : (
                              <input value={selExtras[cx.key]||""} onChange={e=>setSelExtras(prev=>({...prev,[cx.key]:e.target.value}))} placeholder={cx.placeholder}
                                style={{ width:"100%", minHeight:44, background:"rgba(255,255,255,0.65)", border:"1px solid rgba(255,252,240,0.90)", borderRadius:8, padding:"8px 12px", color:"#1A1608", fontFamily:"inherit", fontSize:14, fontWeight:700, outline:"none", boxSizing:'border-box', ...uvx(() => ({ ...uvField(), fontWeight:600 })) }} />
                            )}
                          </div>
                        ))}

                        {/* Quantity */}
                        <p style={{ fontSize:13, fontWeight:700, color:'#1A1608', textTransform:"uppercase", letterSpacing:0.08, marginBottom:8, ...uvx(uvLabel) }}>Quantity</p>
                        <div style={{ display:"grid", gridTemplateColumns:"repeat(7,1fr)", gap:5, marginBottom:6 }}>
                          {QUICK_QTY_ROWS[0].map(n=>(<button key={n} onClick={()=>setQty(n)} style={{ minHeight:44, borderRadius:8, cursor:"pointer", fontFamily:"inherit", background:qty===n?"rgba(42,58,26,0.12)":"rgba(42,58,26,0.06)", border:`1px solid ${qty===n?"rgba(42,58,26,0.35)":"rgba(42,58,26,0.15)"}`, color:"#1A1608", fontSize:16, fontWeight:600, ...uvx(() => ({ ...uvChip(qty===n), fontSize:16, padding:0, fontVariantNumeric:'tabular-nums' })) }}>{n}</button>))}
                        </div>
                        <div style={{ display:"grid", gridTemplateColumns:"repeat(7,1fr)", gap:5, marginBottom:8 }}>
                          {QUICK_QTY_ROWS[1].map(n=>(<button key={n} onClick={()=>setQty(n)} style={{ minHeight:44, borderRadius:8, cursor:"pointer", fontFamily:"inherit", background:qty===n?"rgba(42,58,26,0.12)":"rgba(42,58,26,0.06)", border:`1px solid ${qty===n?"rgba(42,58,26,0.35)":"rgba(42,58,26,0.15)"}`, color:"#1A1608", fontSize:16, fontWeight:600, ...uvx(() => ({ ...uvChip(qty===n), fontSize:16, padding:0, fontVariantNumeric:'tabular-nums' })) }}>{n}</button>))}
                        </div>
                        <div style={{ display:"flex", alignItems:"center", gap:7, marginBottom:10 }}>
                          <button aria-label="Decrease quantity" onClick={()=>setQty(q=>Math.max(1,q-1))} style={{ width:44,height:44,borderRadius:9,background:"rgba(255,255,255,0.65)",border:"1px solid rgba(255,252,240,0.90)",color:"#1A1608",fontSize:22,fontWeight:700,cursor:"pointer",flexShrink:0,display:"flex",alignItems:"center",justifyContent:"center", ...uvx(() => ({ ...uvChip(false), fontSize:20 })) }}>−</button>
                          <input type="number" inputMode="numeric" min={1} value={qty === 0 ? "" : qty}
                            onChange={e=>{ const raw=e.target.value; if(raw==="") { setQty(0); return; } const n=parseInt(raw); if(!isNaN(n)&&n>0) setQty(n); }}
                            onBlur={()=>{ if(!qty||qty<1) setQty(1); }}
                            style={{ flex:1,minHeight:44,background:"rgba(255,255,255,0.65)",border:"1px solid rgba(255,252,240,0.90)",borderRadius:9,padding:"9px 12px",color:"#1A1608",fontFamily:"inherit",fontSize:18,fontWeight:800,outline:"none",textAlign:"center",boxSizing:'border-box', ...uvx(() => ({ ...uvField(), fontSize:20, fontWeight:700, fontVariantNumeric:'tabular-nums', minWidth:0, width:'100%' })) }} />
                          <button aria-label="Increase quantity" onClick={()=>setQty(q=>q+1)} style={{ width:44,height:44,borderRadius:9,background:"rgba(255,255,255,0.65)",border:"1px solid rgba(255,252,240,0.90)",color:"#1A1608",fontSize:22,fontWeight:700,cursor:"pointer",flexShrink:0,display:"flex",alignItems:"center",justifyContent:"center", ...uvx(() => ({ ...uvChip(false), fontSize:20 })) }}>+</button>
                        </div>

                        {/* EM */}
                        {selFixId !== "em" && (
                          <div style={{ display:"flex", alignItems:"center", flexWrap:"wrap", gap:8, padding:"10px 12px", borderRadius:10, background:"rgba(46,104,56,0.06)", border:"1px solid rgba(46,104,56,0.35)", marginBottom:10, ...uvx(() => ({ ...studioSurface.pressed(), borderRadius:12, padding:'8px 8px 8px 14px', marginBottom:14 })) }}>
                            <div style={{ flex:"1 1 120px" }}>
                              <p style={{ fontSize:11, fontWeight:700, color:"#2E6838", ...uvx(() => ({ fontSize:16, color:ST.ink })) }}>Emergency fittings</p>
                              <p style={{ fontSize:10, color:"rgba(46,104,56,0.7)", marginTop:1, ...uvx(() => ({ fontSize:14, color:ST.muted })) }}>How many of these are EM?</p>
                            </div>
                            <div style={{ display:"flex", alignItems:"center", gap:8, flexWrap:"wrap" }}>
                              <button aria-label="Decrease EM quantity" onClick={()=>setEmQty(clampEm(clampEm(emQty, qty)-1, qty))} style={{ width:44, height:44, borderRadius:8, background:"rgba(46,104,56,0.06)", border:"1px solid rgba(46,104,56,0.35)", color:"#2E6838", fontSize:18, fontWeight:700, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0, ...uvx(() => ({ ...uvChip(false), fontSize:20 })) }}>−</button>
                              <input type="number" inputMode="numeric" min={0} max={qty} aria-label="Emergency count" value={clampEm(emQty, qty)}
                                onFocus={ev=>{ try { ev.target.select(); } catch(err) {} }}
                                onChange={ev=>{ const n = parseEmInput(ev.target.value, qty); if (n !== null) setEmQty(n); }}
                                style={{ width:56, minHeight:44, background:"rgba(255,255,255,0.65)", border:"1px solid rgba(46,104,56,0.35)", borderRadius:8, padding:"9px 4px", color:"#2E6838", fontFamily:"inherit", fontSize:18, fontWeight:800, outline:"none", textAlign:"center", boxSizing:"border-box", ...uvx(() => ({ ...uvField(), fontSize:20, fontWeight:700, fontVariantNumeric:'tabular-nums', width:56, padding:'9px 4px' })) }} />
                              <button aria-label="Increase EM quantity" onClick={()=>setEmQty(clampEm(emQty+1, qty))} style={{ width:44, height:44, borderRadius:8, background:"rgba(46,104,56,0.06)", border:"1px solid rgba(46,104,56,0.35)", color:"#2E6838", fontSize:18, fontWeight:700, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0, ...uvx(() => ({ ...uvChip(false), fontSize:20 })) }}>+</button>
                              <button aria-label="Make every fitting emergency" aria-pressed={qty >= 1 && clampEm(emQty, qty) === qty} onClick={()=>setEmQty(allEmCount(qty))} style={{ minHeight:44, padding:"0 14px", borderRadius:8, background:"rgba(46,104,56,0.06)", border:"1px solid rgba(46,104,56,0.35)", color:"#2E6838", fontSize:14, fontWeight:700, cursor:"pointer", fontFamily:"inherit", flexShrink:0, ...uvx(() => ({ ...uvChip(qty >= 1 && clampEm(emQty, qty) === qty), fontSize:16 })) }}>All EM</button>
                            </div>
                          </div>
                        )}

                        {/* Sensor + Dimming chip groups (S136 — moved into the sheet), now under a
                            "More options" disclosure that opens by itself when either holds a value
                            (fix/p1b-sheet-polish). When shut, the button names what is set. */}
                        {selFixId !== 'em' && selFixId !== 'controls' && (
                          <button type="button" data-testid="fitting-sheet-more" aria-expanded={moreIsOpen} onClick={()=>setMoreOpen(!moreIsOpen)}
                            style={{ width:'100%', minHeight:44, display:'flex', alignItems:'center', justifyContent:'space-between', gap:10, padding:'0 4px', marginBottom:moreIsOpen?10:4, background:'none', border:'none', borderTop:'1px solid rgba(28,24,16,0.10)', cursor:'pointer', fontFamily:'inherit', textAlign:'left', color:'#1A1608', fontSize:14, fontWeight:700, ...uvx(() => ({ borderTop:`1px solid ${ST.hairline}`, color:ST.ink, fontSize:16 })) }}>
                            <span>More options{!moreIsOpen && moreVals.length > 0 ? ': ' + moreVals.join(', ') : ''}</span>
                            <span aria-hidden="true" style={{ display:'inline-block', transform:moreIsOpen?'rotate(90deg)':'none', fontSize:18, lineHeight:1 }}>›</span>
                          </button>
                        )}
                        {selFixId !== 'em' && selFixId !== 'controls' && moreIsOpen && (<>
                          <p style={{ fontSize:13, fontWeight:700, color:'#1A1608', textTransform:"uppercase", letterSpacing:0.08, marginBottom:8, ...uvx(uvLabel) }}>Sensor</p>
                          <div style={{ display:"flex", gap:6, flexWrap:"wrap", marginBottom: selSensorSel==='Custom'?8:12 }}>
                            {SENS.map(o=>(<button key={o} onClick={()=>{ setSelSensorSel(o); if(o!=='Custom') setSelSensorCustom(''); }} style={{ minHeight:44, padding:'0 14px', borderRadius:10, fontSize:13, fontWeight:selSensorSel===o?700:500, cursor:'pointer', fontFamily:'inherit', background:selSensorSel===o?'rgba(74,100,98,0.16)':'rgba(255,255,255,0.65)', border:`1px solid ${selSensorSel===o?'rgba(74,100,98,0.45)':'rgba(255,252,240,0.90)'}`, color:selSensorSel===o?'#1A1608':'rgba(28,24,16,0.55)', ...uvx(() => uvChip(selSensorSel===o)) }}>{o}</button>))}
                          </div>
                          {selSensorSel==='Custom' && (
                            <input value={selSensorCustom} onChange={e=>setSelSensorCustom(e.target.value)} placeholder="Sensor type, e.g. absence detection"
                              style={{ width:'100%', minHeight:44, background:'rgba(62,139,191,0.06)', border:'1.5px solid rgba(62,139,191,0.4)', borderRadius:10, padding:'10px 13px', color:'#1A1608', fontFamily:'inherit', fontSize:15, fontWeight:600, outline:'none', ...uvx(uvField), marginBottom:12, boxSizing:'border-box' }} />
                          )}
                          <p style={{ fontSize:13, fontWeight:700, color:'#1A1608', textTransform:"uppercase", letterSpacing:0.08, marginBottom:8, ...uvx(uvLabel) }}>Dimming</p>
                          <div style={{ display:"flex", gap:6, flexWrap:"wrap", marginBottom: selDimSel==='Custom'?8:12 }}>
                            {DIMS.map(o=>(<button key={o} onClick={()=>{ setSelDimSel(o); if(o!=='Custom') setSelDimCustom(''); }} style={{ minHeight:44, padding:'0 14px', borderRadius:10, fontSize:13, fontWeight:selDimSel===o?700:500, cursor:'pointer', fontFamily:'inherit', background:selDimSel===o?'rgba(74,100,98,0.16)':'rgba(255,255,255,0.65)', border:`1px solid ${selDimSel===o?'rgba(74,100,98,0.45)':'rgba(255,252,240,0.90)'}`, color:selDimSel===o?'#1A1608':'rgba(28,24,16,0.55)', ...uvx(() => uvChip(selDimSel===o)) }}>{o}</button>))}
                          </div>
                          {selDimSel==='Custom' && (
                            <input value={selDimCustom} onChange={e=>setSelDimCustom(e.target.value)} placeholder="Dimming type, e.g. DALI-2 or Casambi"
                              style={{ width:'100%', minHeight:44, background:'rgba(62,139,191,0.06)', border:'1.5px solid rgba(62,139,191,0.4)', borderRadius:10, padding:'10px 13px', color:'#1A1608', fontFamily:'inherit', fontSize:15, fontWeight:600, outline:'none', ...uvx(uvField), marginBottom:12, boxSizing:'border-box' }} />
                          )}
                        </>)}
                      </div>

                      {/* Log / Update: pinned to the bottom of the sheet, outside the scrolling
                          body, so it is in view whatever has been scrolled (fix/p1b-sheet-polish).
                          It is the sheet's one main action (ultraviolet) and says what it will
                          log: quantity × type and size (logButtonLabel). */}
                      <div data-testid="fitting-sheet-log-bar" style={{ flexShrink:0, padding:'10px 14px 12px', borderTop:'0.5px solid rgba(28,24,16,0.10)', background:'rgba(255,252,242,0.99)', ...uvx(() => ({ padding:'10px 16px 12px', borderTop:`1px solid ${ST.hairline}`, background:'transparent' })) }}>
                        <button data-testid="fitting-sheet-log" onClick={commitFitting} style={{ width:"100%", minHeight:52, padding:"14px 16px", borderRadius:10, cursor:"pointer", background:"linear-gradient(135deg, #C89030, #1A5A78)", border:"none", color:"#fff", fontFamily:"inherit", fontSize:14, fontWeight:800, ...uvx(() => ({ ...studioSurface.primary(), width:'100%', padding:'12px 16px', lineHeight:1.3 })) }}>
                          {logButtonLabel({ editing: !!editFitUid, qty, fixtureLabel: selFixture.label, size: effSizeLabel(), emQty })}
                        </button>
                        {editFitUid && (
                          <button onClick={removeEditedFit} style={{ width:'100%', marginTop:10, padding:14, border:'1px solid #C06848', borderRadius:13, background:'none', color:'#7A2E18', fontWeight:600, fontSize:14.5, cursor:'pointer', fontFamily:'inherit', ...uvx(uvSlipBtn) }}>Remove this fitting</button>
                        )}
                      </div>
                    </div>
                    </SheetPortal>
                    );
                  })()}
                </>
              )}

              {/* ── MEDIA TAB (area + project) ── */}
              {segNow === 'media' && (() => {
                const mediaItems = sitePhotos
                  .map((ph, i) => ({ ph, i }))
                  .filter(({ ph }) => isProj ? !ph.zone : ph.zone === zone);
                // STUDIO-LIT-PHONE-V1 item 7: an area's photos with the switch on
                // (#app/media): the photo you are looking at, Eva's offer to count
                // its fittings (the existing per-photo scan, which adds nothing
                // until you confirm), the area's other photos as thumbnails, then
                // what was said and written in this area, newest first.
                if (t.theme === 'uv' && !isProj) return <SvLit draw={() => {
                  const M = STUDIO_MEANING;
                  const lead = mediaItems.find(m => (m.ph.id || m.i) === uvShotId) || mediaItems.filter(m => m.ph.type !== 'video').slice(-1)[0] || mediaItems.slice(-1)[0] || null;
                  const leadIsPhoto = lead && lead.ph.type !== 'video';
                  const leadId = lead ? (lead.ph.id || null) : null;
                  const scanned = leadId ? areaScans.find(e => e.photoId === leadId) : null;
                  const busy = scanBusy && scanBusy.running && scanBusy.photoId === leadId;
                  const scanErr = scanBusy && scanBusy.error && scanBusy.photoId === leadId ? scanBusy.error : null;
                  const log = notesFor(zone).slice().sort((a, b) => (b.at || 0) - (a.at || 0));
                  const bars = Array.from({ length: 30 }, (_, k) => 4 + Math.round(Math.abs(Math.sin(k * 1.4) * Math.cos(k * 0.5)) * 18));
                  const tile = { flex:'0 0 64px', width:64, height:52, borderRadius:10, overflow:'hidden', border:'none', padding:0, cursor:'pointer' };
                  return (
                    <div style={{ display:'grid', gridTemplateColumns:'minmax(0,1fr)', gridAutoRows:'max-content', gap:10 }}>
                      {lead ? (
                        <figure style={{ margin:0, position:'relative', display:'flex', flexDirection:'column' }}>
                          {leadIsPhoto
                            ? <MediaThumb photo={lead.ph} onClick={()=>setLightbox({photo:lead.ph, caption:`${lead.ph.zone || 'Site-wide'}${studioSep()}${lead.ph.ts}`})} alt={`Photo, ${zone}`} style={{ display:'block', width:'100%', minHeight:44, aspectRatio:'3 / 2', objectFit:'cover', borderRadius:ST.radius.card, boxShadow:STUDIO_TOKENS.shadow.raised, cursor:'pointer' }} />
                            : <div style={{ ...studioSurface.pressed(), width:'100%', aspectRatio:'3 / 2', borderRadius:ST.radius.card, display:'flex', alignItems:'center', justifyContent:'center', fontSize:16, color:ST.ink }}>Video, {lead.ph.ts}</div>}
                          <button aria-label={leadIsPhoto ? 'Remove photo' : 'Remove video'} onClick={()=>{ removeMedia(lead.i); setUvShotId(null); }} style={{ position:'absolute', top:0, right:0, width:44, height:44, border:'none', background:'none', display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer' }}>
                            <span style={{ ...studioSurface.slip(), width:26, height:26, borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', color:ST.ink }}><svg width="10" height="10" viewBox="0 0 10 10" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"><line x1="2" y1="2" x2="8" y2="8"/><line x1="8" y1="2" x2="2" y2="8"/></svg></span>
                          </button>
                          {/* P1: the count offer no longer sits on the photo (it covered part of it on every shot, control gear included). It is a small control below the photo strip. The upload status stays here, under the photo. */}
                          {leadIsPhoto && photoUploadPending(lead.ph) && (() => { const lbl = photoPendingLabel(lead.ph, !(typeof navigator !== 'undefined' && navigator.onLine === false)); const bad = lbl === 'Upload failed'; return <p style={{ margin:'6px 2px 0', fontSize:14, color: bad ? ST.ink : ST.muted, fontWeight: bad ? 600 : 400 }}>{lbl}</p>; })()}
                        </figure>
                      ) : (
                        <p style={{ margin:'4px 2px', fontSize:16, color:ST.muted }}>No photos in this area yet.</p>
                      )}
                      <div style={{ display:'flex', gap:6, alignItems:'center' }}>
                        <div style={{ flex:1, minWidth:0, display:'flex', gap:6, overflowX:'auto' }}>
                          {mediaItems.slice().reverse().map(({ ph, i }) => {
                            const on = lead && lead.i === i;
                            return (
                              <button key={ph.id || i} aria-label={ph.type === 'video' ? `Video, ${ph.ts}` : `Photo, ${ph.ts}`} aria-pressed={on} onClick={()=>setUvShotId(ph.id || i)} style={{ ...tile, boxShadow: on ? `0 0 0 2px ${ST.ink}` : 'none', ...(ph.type === 'video' ? { ...studioSurface.pressed(), boxShadow: on ? `0 0 0 2px ${ST.ink}` : STUDIO_TOKENS.shadow.pressed } : {}) }}>
                                {ph.type === 'video'
                                  ? <svg width="14" height="14" viewBox="0 0 24 24" fill={ST.ink} aria-hidden="true"><polygon points="8,5 20,12 8,19"/></svg>
                                  : <MediaThumb photo={ph} style={{ display:'block', width:'100%', height:'100%', objectFit:'cover' }} />}
                              </button>
                            );
                          })}
                        </div>
                        <button aria-label="Take a photo" onClick={()=>cam.open(zone)} style={{ ...tile, ...studioSurface.pressed(), display:'flex', alignItems:'center', justifyContent:'center', color:ST.ink }}>
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><path d="M4 8h3l2-2h6l2 2h3v11H4z"/><circle cx="12" cy="13" r="3.5"/></svg>
                        </button>
                      </div>
                      {leadIsPhoto && (() => {
                        const view = scanOfferView({ busy: !!busy, scanErr: scanErr, scanned: !!scanned, off: scanOfferOff });
                        if (view === 'off') return <button onClick={()=>setScanOfferFor(false)} style={{ ...svLink(), fontSize:14 }}>Offer to count fittings in photos</button>;
                        return (
                          <div style={{ display:'flex', flexWrap:'wrap', alignItems:'center', columnGap:16 }}>
                            {view === 'busy' && <span style={{ fontSize:14, color:ST.muted, minHeight:44, display:'inline-flex', alignItems:'center' }}>Scanning the photo for fittings.</span>}
                            {view === 'error' && <span style={{ fontSize:14, color:ST.ink, minHeight:44, display:'inline-flex', alignItems:'center' }}>{String(scanErr)}</span>}
                            {view === 'results' && <button onClick={()=>{ setScanOpenId(scanned.id); setScanReviewOpen(true); }} style={svLink()}>Check what I found</button>}
                            {(view === 'offer' || view === 'error') && <button onClick={()=>scanFitting(lead.ph, zone)} style={svLink()}>{view === 'error' ? 'Try again' : 'Count the fittings'}</button>}
                            {view === 'offer' && <button onClick={()=>setScanOfferFor(true)} style={{ ...svLink() }}>Not on this job</button>}
                            {view === 'offer' && <span style={{ fontSize:13, color:ST.muted, flexBasis:'100%' }}>Nothing’s added until you say so.</span>}
                          </div>
                        );
                      })()}
                      <button onClick={()=>{ setPhotoTargetZone(zone); setTimeout(()=>videoInputRef.current?.click(),50); }} style={svLink()}>Record a video</button>
                      {log.length > 0 && (
                        <section aria-label="In this area" style={{ display:'flex', flexDirection:'column', gap:8, paddingTop:6 }}>
                          <h2 style={svH2()}>In this area</h2>
                          {log.map((n, k) => (
                            <React.Fragment key={n.id || k}>
                              <div style={{ display:'grid', gridTemplateColumns:'48px minmax(0,1fr)', gap:10, alignItems:'center', fontSize:16, color:ST.ink }}>
                                <time style={{ fontSize:13, fontWeight:700, color:ST.muted }}>{n.t || ''}</time>
                                {n.type === 'voice'
                                  ? <div style={{ ...studioSurface.pressed(), borderRadius:12, padding:'8px 12px', display:'flex', alignItems:'center', gap:10, fontSize:14, fontWeight:700 }}>
                                      <svg viewBox="0 0 120 26" aria-hidden="true" style={{ flex:1, height:26, fill:ST.muted }}>{bars.map((hh, b) => <rect key={b} x={b * 4} y={13 - hh / 2} width="2.4" height={hh} rx="1.2" />)}</svg>
                                      <span>Voice note</span>
                                    </div>
                                  : <p style={{ margin:0 }}>Note: {n.body}</p>}
                              </div>
                              {n.type === 'voice' && <p style={{ margin:'0 0 0 58px', fontFamily:ST.fonts.display, fontWeight:300, fontSize:16, lineHeight:1.42, color:ST.muted }}>{n.pending || !n.body ? 'Not written up yet. Open Notes to type it up.' : `“${n.body}”`}</p>}
                            </React.Fragment>
                          ))}
                        </section>
                      )}
                    </div>
                  );
                }} />;
                return (
                  <>
                    {/* alignItems start: grid rows must never stretch a shorter tile
                        (bare video / capture tiles) to the height of a photo card —
                        the stretch read as a second, smaller photo variant on device */}
                    {/* Under the theme: a video is pressed into the page (no dark
                        tile), its label in sentence case; the remove control is a
                        44px target holding a small paper disc; an upload still
                        going, or failed, is written in words under the photo
                        instead of a coloured dot on it. */}
                    <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:8, alignItems:'start' }}>
                      {mediaItems.map(({ ph, i }) => (
                        ph.type === 'video' ? (
                          <div key={ph.id||i} style={{ aspectRatio:'1', borderRadius:12, background:'linear-gradient(135deg, #1A1608, #2A2A1A)', position:'relative', overflow:'hidden', animation:'popIn 0.25s ease', ...uvx(() => ({ ...studioSurface.pressed(), borderRadius:14 })) }}>
                            <span style={{ position:'absolute', top:6, left:8, fontSize:8, color:'rgba(255,255,255,0.6)', fontWeight:700, ...uvx(() => ({ top:8, left:10, fontSize:13, fontWeight:600, color:ST.ink })) }}>{t.theme === 'uv' ? 'Video' : 'VIDEO'}</span>
                            <div style={{ position:'absolute', inset:0, display:'flex', alignItems:'center', justifyContent:'center' }}>
                              <div style={{ width:30, height:30, borderRadius:'50%', background:'rgba(255,255,255,0.85)', display:'flex', alignItems:'center', justifyContent:'center', ...uvx(() => ({ ...studioSurface.slip(), borderRadius:'50%' })) }}>
                                <svg width="11" height="11" viewBox="0 0 24 24" fill={t.theme === 'uv' ? ST.ink : '#1A1608'}><polygon points="8,5 20,12 8,19"/></svg>
                              </div>
                            </div>
                            <span style={{ position:'absolute', bottom:6, right:8, fontSize:9, color:'white', ...uvx(() => ({ bottom:8, right:10, fontSize:13, color:ST.ink, fontVariantNumeric:'tabular-nums' })) }}>{ph.ts}</span>
                            <button aria-label="Remove video" onClick={()=>removeMedia(i)} style={{ position:'absolute', top:-1, right:-1, width:22, height:22, borderRadius:'0 12px 0 9px', background:'#16263A', border:'none', color:'#fff', fontSize:12, display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer', ...uvx(() => ({ top:0, right:0, width:44, height:44, borderRadius:0, background:'none', color:ST.ink, fontSize:16 })) }}>{t.theme === 'uv' ? <span aria-hidden="true" style={{ width:24, height:24, borderRadius:'50%', ...studioSurface.slip(), color:ST.ink, display:'flex', alignItems:'center', justifyContent:'center' }}>×</span> : '×'}</button>
                          </div>
                        ) : (
                          <div key={ph.id||i} style={{ display:'flex', flexDirection:'column' }}>
                            <div style={{ aspectRatio:'1', borderRadius:12, position:'relative', overflow:'hidden', background:'linear-gradient(135deg, #b9c2bd, #8a958f)', animation:'popIn 0.25s ease', ...uvx(() => ({ ...studioSurface.pressed(), borderRadius:14 })) }}>
                              <MediaThumb photo={ph} onClick={()=>setLightbox({photo:ph, caption:`${ph.zone || 'Site-wide'}${studioSep()}${ph.ts}`})} style={{ width:'100%', height:'100%', objectFit:'cover', display:'block', cursor:'pointer', ...uvx({ minHeight:44 }) }} />
                              {photoUploadPending(ph) && t.theme !== 'uv' && (() => {
                                const bad = !!ph.uploadFailed || ph.uploadState === 'failed';
                                return (
                                <span aria-label={photoPendingLabel(ph, !(typeof navigator !== 'undefined' && navigator.onLine === false))} style={{ position:'absolute', top:6, left:6, width:14, height:14, borderRadius:'50%', background: bad ? '#C85040' : 'rgba(255,255,255,0.92)', border: bad ? '1px solid #FFF' : '1px solid rgba(91,155,213,0.55)', display:'flex', alignItems:'center', justifyContent:'center' }}>
                                  {!bad && <span style={{ width:7, height:7, borderRadius:'50%', border:'1.5px solid rgba(91,155,213,0.85)', borderTopColor:'transparent', animation:'lumen-photo-spin 0.7s linear infinite' }} />}
                                </span>
                                );
                              })()}
                              <button aria-label="Remove photo" onClick={()=>removeMedia(i)} style={{ position:'absolute', top:-1, right:-1, width:22, height:22, borderRadius:'0 12px 0 9px', background:'#16263A', border:'none', color:'#fff', fontSize:12, display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer', ...uvx(() => ({ top:0, right:0, width:44, height:44, borderRadius:0, background:'none', color:ST.ink, fontSize:16 })) }}>{t.theme === 'uv' ? <span aria-hidden="true" style={{ width:24, height:24, borderRadius:'50%', ...studioSurface.slip(), color:ST.ink, display:'flex', alignItems:'center', justifyContent:'center' }}>×</span> : '×'}</button>
                            </div>
                            {photoUploadPending(ph) && t.theme === 'uv' && (() => {
                              const lbl = photoPendingLabel(ph, !(typeof navigator !== 'undefined' && navigator.onLine === false));
                              const bad = lbl === 'Upload failed';
                              return <span aria-label={lbl} style={{ fontSize:13, marginTop:6, color: bad ? ST.ink : ST.muted, fontWeight: bad ? 600 : 400 }}>{lbl}</span>;
                            })()}
                            {/* Per-photo Scan trigger (Treatment A), area photos only, tied to THIS photo.
                                EVERY photo carries it — upload state must never change the render path
                                (the old !_isPhotoPending gate split a live area into scan-bar cards and
                                bare thumbnails mid-survey; scan reads base64/IndexedDB/URL so a photo
                                still uploading is perfectly scannable). */}
                            {!isProj && (
                              <ScanTriggerButton onClick={()=>scanFitting(ph, zone)}
                                busy={scanBusy && scanBusy.running && scanBusy.photoId === (ph.id || null)}
                                error={scanBusy && scanBusy.error && scanBusy.photoId === (ph.id || null) ? scanBusy.error : null} />
                            )}
                          </div>
                        )
                      ))}
                      {/* Photo tile */}
                      <button onClick={()=>cam.open(isProj?null:zone)} style={{ aspectRatio:'1', borderRadius:12, border:'1.5px dashed rgba(62,139,191,0.5)', background:'rgba(62,139,191,0.06)', color:'#2A72A8', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', gap:3, cursor:'pointer', fontFamily:'inherit', ...uvx(() => (isProj ? { ...studioSurface.primary(), borderRadius:14, gap:6 } : { ...studioSurface.slip(), borderRadius:14, color:ST.ink, minHeight:44, gap:6 })) }}>
                        <Icon name="camera" size={22} color={t.theme === 'uv' ? (isProj ? ST.onPrimary : ST.ink) : "#2A72A8"} />
                        <span style={{ fontSize:11, fontWeight:600, ...uvx({ fontSize:14 }) }}>Photo</span>
                      </button>
                      {/* Video tile */}
                      <button onClick={()=>{ setPhotoTargetZone(isProj?null:zone); setTimeout(()=>videoInputRef.current?.click(),50); }} style={{ aspectRatio:'1', borderRadius:12, border:'1.5px dashed rgba(62,139,191,0.5)', background:'rgba(62,139,191,0.06)', color:'#2A72A8', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', gap:3, cursor:'pointer', fontFamily:'inherit', ...uvx(() => ({ ...studioSurface.slip(), borderRadius:14, color:ST.ink, minHeight:44, gap:6 })) }}>
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={t.theme === 'uv' ? ST.ink : "#2A72A8"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="5" width="14" height="14" rx="2"/><path d="M16 10l5-3v10l-5-3"/></svg>
                        <span style={{ fontSize:11, fontWeight:600, ...uvx({ fontSize:14 }) }}>Video</span>
                      </button>
                    </div>
                    <div style={{ textAlign:'left', padding:'12px 2px 0', color:'#8A7A5A', fontSize:12, ...uvx(() => ({ color:ST.muted, fontSize:14, padding:'14px 6px 0' })) }}>
                      {mediaItems.filter(m=>m.ph.type!=='video').length} photo{mediaItems.filter(m=>m.ph.type!=='video').length!==1?'s':''}{t.theme === 'uv' ? ', ' : ' · '}{mediaItems.filter(m=>m.ph.type==='video').length} video{mediaItems.filter(m=>m.ph.type==='video').length!==1?'s':''}. Every capture confirms and is saved to this {isProj?'project':'area'}.
                    </div>

                    {/* Plans (project-level only — preserves Site Plans access) */}
                    {isProj && (
                      <div onClick={() => onNav(8)} style={{ background:'#FDFCF9', border:'1px solid #EAE0CE', borderRadius:12, padding:'12px 14px', cursor:'pointer', marginTop:14, display:'flex', alignItems:'center', gap:11, ...uvx(() => ({ ...studioSurface.slip(), borderRadius:14, minHeight:56, padding:'8px 14px', marginTop:18, gap:14 })) }}>
                        <div style={{ width:36, height:36, borderRadius:10, background:'rgba(46,104,56,0.1)', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0, ...uvx(() => ({ ...studioSurface.pressed(), borderRadius:10 })) }}>
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={t.theme === 'uv' ? ST.ink : "#2E6838"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>
                        </div>
                        <div style={{ flex:1 }}>
                          <div style={{ fontSize:13, fontWeight:600, color:'#1A1608', ...uvx(() => ({ fontSize:16, fontWeight:700, color:ST.ink })) }}>Site plans</div>
                          <div style={{ fontSize:11, color:'#8A7A5A', ...uvx(() => ({ fontSize:14, color:ST.muted })) }}>{(activeProject?.plans||[]).length > 0 ? `${(activeProject?.plans||[]).length} plan${(activeProject?.plans||[]).length!==1?'s':''}${studioSep()}tap to view` : 'No plans uploaded yet'}</div>
                        </div>
                        <span style={{ color:'#A09080', fontSize:18, ...uvx(() => ({ color:ST.muted, fontSize:20 })) }}>›</span>
                      </div>
                    )}
                  </>
                );
              })()}

              {/* ── NOTES TAB (area + project) ── */}
              {segNow === 'notes' && (() => {
                const notes = notesFor(activeKey);
                let tn = 0, vn = 0;
                return (
                  <>
                    {notes.map((n) => {
                      const isVoice = n.type === 'voice';
                      if (isVoice) vn++; else tn++;
                      const lbl = isVoice ? `Voice note ${vn}` : `Note ${tn}`;
                      // Under the theme the notes read as rows of what was
                      // said, on hairlines (phone-recording.html): the label in
                      // muted words (no tinted chip, no emoji), the time in
                      // Satoshi tabular figures (no monospace), the delete
                      // control a 44px target, the note itself in ink at 16.
                      return (
                        <div key={n.id} style={{ background:'#FDFCF9', border:'1px solid #EAE0CE', borderRadius:12, padding:'12px 14px', marginBottom:9, ...uvx(() => ({ background:'none', border:'none', borderTop:`1px solid ${ST.hairline}`, borderRadius:0, padding:'8px 0 12px', marginBottom:0 })) }}>
                          <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:5, ...uvx({ marginBottom:2 }) }}>
                            <span style={{ fontSize:10, fontWeight:700, letterSpacing:'0.04em', padding:'3px 8px', borderRadius:6, background:isVoice?'#F0DDD6':'#E4ECEB', color:isVoice?'#7A2E18':'#4A6462', ...uvx(() => ({ ...uvLabel(), padding:0, borderRadius:0, background:'none' })) }}>{isVoice && t.theme !== 'uv' ? `🎙 ${lbl}` : lbl}</span>
                            <span style={{ marginLeft:'auto', fontSize:10.5, color:'#A09080', fontFamily:'JetBrains Mono, monospace', ...uvx(() => ({ fontSize:14, color:ST.muted, fontFamily:ST.fonts.body, fontVariantNumeric:'tabular-nums' })) }}>{n.t||''}</span>
                            <button aria-label="Delete note" onClick={()=>deleteNoteFrom(activeKey, n.id)} style={{ width:28, height:28, borderRadius:7, background:'rgba(192,104,72,0.08)', border:'none', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', ...uvx({ width:44, height:44, background:'none', marginRight:-10 }) }}>
                              <svg width="10" height="10" viewBox="0 0 10 10" fill="none" stroke={t.theme === 'uv' ? ST.muted : "#A8543A"} strokeWidth="1.6" strokeLinecap="round"><line x1="2" y1="2" x2="8" y2="8"/><line x1="8" y1="2" x2="2" y2="8"/></svg>
                            </button>
                          </div>
                          {n.pending ? (() => {
                            // Refuse, do not approximate: if the audio has been
                            // pruned to free storage there is nothing to play, and
                            // the card says so INSTEAD of offering a control that
                            // fails on tap.
                            const _hasAudio = _noteAudioAvailable(n);
                            return (
                            <div>
                              <div style={{ fontSize:13, lineHeight:1.5, color:'#7A2E18', fontStyle:'italic', marginBottom:10, ...uvx(() => ({ fontSize:16, color:ST.ink, fontStyle:'normal' })) }}>
                                {_hasAudio
                                  ? 'Recording saved to this note. Not transcribed yet.'
                                  : 'This note\u2019s audio was cleared to free storage. Type up whatever you remember.'}
                              </div>
                              <div style={{ display:'flex', gap:8 }}>
                                {_hasAudio && (
                                <button onClick={()=>playNoteAudio(n)}
                                  style={{ flex:1, minHeight:40, padding:'9px 12px', border:'1px solid #C06848', borderRadius:10, background:'#FDFCF9', fontWeight:700, fontSize:12.5, color:'#C06848', cursor:'pointer', fontFamily:'inherit', ...uvx(() => (playingNoteId === n.id ? { ...uvSlipBtn(), ...studioSurface.pressed(), color:ST.ink } : uvSlipBtn())) }}>
                                  {playingNoteId === n.id ? 'Stop' : 'Play back'}
                                </button>
                                )}
                                <button onClick={()=>{ setTypeUpNote({ key: activeKey, id: n.id }); setTypeUpText(''); }}
                                  style={{ flex:1, minHeight:40, padding:'9px 12px', border:'1px solid #4A6462', borderRadius:10, background:'#FDFCF9', fontWeight:700, fontSize:12.5, color:'#4A6462', cursor:'pointer', fontFamily:'inherit', ...uvx(uvSlipBtn) }}>
                                  Type it up
                                </button>
                              </div>
                            </div>
                            );
                          })() : (
                            <>
                            <div style={{ fontSize:14, lineHeight:1.5, color:'#1A1608', ...uvx(() => ({ fontSize:16, color:ST.ink })) }}>{n.body}</div>
                            {/* SLICE-A4: a transcribed voice note still carries its
                                recording: how long it ran, and a way to hear it. */}
                            {n.type === 'voice' && n.audioRef && (() => {
                              const _secs = Number(n.duration) > 0 ? Number(n.duration) : (_voiceIndex.dur[String(n.audioRef)] || 0);
                              const _canPlay = _noteAudioAvailable(n);
                              if (!_secs && !_canPlay) return null;
                              return (
                                <div style={{ display:'flex', alignItems:'center', gap:10, marginTop:6 }}>
                                  {_secs > 0 && <span style={{ fontSize:12, color:'#8A7A5A', ...uvx(() => ({ fontSize:14, color:ST.muted, fontVariantNumeric:'tabular-nums' })) }}>{voiceDurationWords(_secs)}</span>}
                                  {_canPlay && (
                                    <button onClick={()=>playNoteAudio(n)}
                                      style={{ minHeight:44, padding:'0 14px', border:'1px solid #C06848', borderRadius:10, background:'#FDFCF9', fontWeight:700, fontSize:12.5, color:'#C06848', cursor:'pointer', fontFamily:'inherit', ...uvx(() => (playingNoteId === n.id ? { ...uvSlipBtn(), ...studioSurface.pressed(), color:ST.ink } : uvSlipBtn())) }}>
                                      {playingNoteId === n.id ? 'Stop' : 'Play back'}
                                    </button>
                                  )}
                                </div>
                              );
                            })()}
                            </>
                          )}
                          {/* SLICE-A4 (review round 1): a Site-wide voice note can
                              be moved to the area it belongs to. */}
                          {isProj && isVoice && n.audioRef && zones.length > 0 && (
                            moveOpenId === 'note:' + n.id ? (
                              <div role="group" aria-label="Move to" style={{ display:'flex', flexWrap:'wrap', gap:8, marginTop:8 }}>
                                {zones.map((z) => (
                                  <button key={z} onClick={() => moveSiteNote(n.id, z)} style={{ minHeight:44, padding:'0 14px', border:'1px solid #DDD0B8', borderRadius:12, background:'#FDFCF9', fontWeight:600, fontSize:14, color:'#4A6462', cursor:'pointer', fontFamily:'inherit', ...uvx(uvSlipBtn) }}>{z}</button>
                                ))}
                                <button onClick={() => setMoveOpenId(null)} style={{ minHeight:44, padding:'0 14px', border:'none', background:'none', fontWeight:600, fontSize:14, color:'#8A7A5A', cursor:'pointer', fontFamily:'inherit', ...uvx(() => ({ color:ST.muted })) }}>Cancel</button>
                              </div>
                            ) : (
                              <button onClick={() => setMoveOpenId('note:' + n.id)} style={{ minHeight:44, marginTop:6, padding:'0 14px', border:'1px solid #DDD0B8', borderRadius:12, background:'#FDFCF9', fontWeight:600, fontSize:14, color:'#4A6462', cursor:'pointer', fontFamily:'inherit', ...uvx(uvSlipBtn) }}>Move to an area</button>
                            )
                          )}
                        </div>
                      );
                    })}
                    {notes.length === 0 && (
                      <div style={{ textAlign:'left', padding:'6px 2px 12px', color:'#8A7A5A', fontSize:14, ...uvx(() => ({ color:ST.muted, fontSize:16, padding:'4px 6px 14px' })) }}>No notes yet. Add them one at a time, typed or spoken, and they stack here in order.</div>
                    )}
                    {/* SLICE-A4: Unassigned notes. Recordings made with the header mic
                        outside any area (e.g. from Today) are filed to the project
                        only; they are listed here, on the Site-wide workspace, and
                        can be moved to an area or kept Site-wide. */}
                    {isProj && unassignedNotes.length > 0 && (
                      <section aria-label="Unassigned notes" style={{ marginTop:14, paddingTop:12, borderTop:`1px solid ${t.theme === 'uv' ? ST.hairline : '#EAE0CE'}` }}>
                        <div style={{ fontSize:13, fontWeight:700, color:'#1A1608', ...uvx(() => ({ ...studioType.heading(), fontStyle:'normal', fontWeight:400 })) }}>Unassigned notes</div>
                        <div style={{ fontSize:12, color:'#8A7A5A', margin:'2px 0 8px', ...uvx(() => ({ fontSize:14, color:ST.muted })) }}>Recorded with the microphone outside an area. Move each to the area it belongs to.</div>
                        {unassignedNotes.map((vn) => {
                          const _words = typeof vn.transcript === 'string' ? vn.transcript.trim() : '';
                          const _secs = voiceDurationFor([vn], vn.id);
                          const _when = _voiceHmFromIso(vn.recordedAt);
                          return (
                            <div key={vn.id} style={{ padding:'8px 0 10px', borderTop:`1px solid ${t.theme === 'uv' ? ST.hairline : '#EAE0CE'}` }}>
                              <div style={{ fontSize:12, color:'#8A7A5A', marginBottom:3, ...uvx(() => ({ fontSize:14, color:ST.muted, fontVariantNumeric:'tabular-nums' })) }}>
                                {[_when, _secs > 0 ? voiceDurationWords(_secs) : ''].filter(Boolean).join(studioSep())}
                              </div>
                              <div style={{ fontSize:14, lineHeight:1.5, color:'#1A1608', ...uvx(() => ({ fontSize:16, color:ST.ink })) }}>{_words || 'Not transcribed yet. The recording is saved.'}</div>
                              {moveOpenId === vn.id ? (
                                <div role="group" aria-label="Move to" style={{ display:'flex', flexWrap:'wrap', gap:8, marginTop:8 }}>
                                  {zones.map((z) => (
                                    <button key={z} onClick={() => moveUnassignedNote(vn, z)} style={{ minHeight:44, padding:'0 14px', border:'1px solid #DDD0B8', borderRadius:12, background:'#FDFCF9', fontWeight:600, fontSize:14, color:'#4A6462', cursor:'pointer', fontFamily:'inherit', ...uvx(uvSlipBtn) }}>{z}</button>
                                  ))}
                                  <button onClick={() => moveUnassignedNote(vn, VOICE_SITE_KEY)} style={{ minHeight:44, padding:'0 14px', border:'1px solid #DDD0B8', borderRadius:12, background:'#FDFCF9', fontWeight:600, fontSize:14, color:'#4A6462', cursor:'pointer', fontFamily:'inherit', ...uvx(uvSlipBtn) }}>Keep Site-wide</button>
                                  <button onClick={() => setMoveOpenId(null)} style={{ minHeight:44, padding:'0 14px', border:'none', background:'none', fontWeight:600, fontSize:14, color:'#8A7A5A', cursor:'pointer', fontFamily:'inherit', ...uvx(() => ({ color:ST.muted })) }}>Cancel</button>
                                </div>
                              ) : (
                                <button onClick={() => setMoveOpenId(vn.id)} style={{ minHeight:44, marginTop:6, padding:'0 14px', border:'1px solid #DDD0B8', borderRadius:12, background:'#FDFCF9', fontWeight:600, fontSize:14, color:'#4A6462', cursor:'pointer', fontFamily:'inherit', ...uvx(uvSlipBtn) }}>Move to an area</button>
                              )}
                            </div>
                          );
                        })}
                      </section>
                    )}
                    {/* On the Site-wide workspace (no next zone) Add a note is the
                        main action of its tab (FINDINGS C1-4). */}
                    <div style={{ display:'flex', gap:9, marginTop:6, ...uvx(() => ({ marginTop:10, borderTop: notes.length ? `1px solid ${ST.hairline}` : 'none', paddingTop: notes.length ? 14 : 0 })) }}>
                      <button onClick={()=>{ setNoteSheetText(''); setShowNoteSheet(true); }} style={{ flex:1, minHeight:48, padding:13, border:'1px solid #DDD0B8', borderRadius:12, background:'#FDFCF9', fontWeight:600, fontSize:13.5, color:'#4A6462', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', gap:7, fontFamily:'inherit', ...uvx(() => (isProj && !uvSheetCommit ? { ...studioSurface.primary(), padding:'0 12px', gap:8 } : { ...uvSlipBtn(), fontSize:14, padding:'0 10px', gap:8 })) }}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={t.theme === 'uv' ? (isProj && !uvSheetCommit ? ST.onPrimary : ST.ink) : "#4A6462"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                        Add a note
                      </button>
                      <button onClick={openVoiceSheet} style={{ flex:1, minHeight:48, padding:13, border:'1px solid #C06848', borderRadius:12, background:'#FDFCF9', fontWeight:600, fontSize:13.5, color:'#C06848', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', gap:7, fontFamily:'inherit', ...uvx(() => ({ ...uvSlipBtn(), fontSize:14, padding:'0 10px', gap:8 })) }}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={t.theme === 'uv' ? ST.ink : "#C06848"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="9" y="1" width="6" height="11" rx="3"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" y1="19" x2="12" y2="23"/><line x1="8" y1="23" x2="16" y2="23"/></svg>
                        Add a voice note
                      </button>
                    </div>
                  </>
                );
              })()}

              {/* Prev / Next area nav (areas only). Under the theme Next area
                  (or Back to areas at the last zone) is the workspace's one
                  main action unless a sheet with its own commit is open. */}
              {!isProj && zones.length > 1 && (
                <div style={{ display:'flex', gap:9, marginTop:20 }}>
                  <button onClick={prevAreaNav} disabled={zIdx<=0} style={{ flex:1, padding:14, border:'1px solid #DDD0B8', borderRadius:12, background:'#FDFCF9', fontWeight:600, fontSize:14, color:'#4A6462', cursor: zIdx<=0?'default':'pointer', opacity: zIdx<=0?0.35:1, fontFamily:'inherit', ...uvx(() => ({ ...uvSlipBtn(), ...studioSurface.pressed(), minHeight:52, borderRadius:ST.button.radius, padding:'0 14px', opacity: zIdx<=0 ? 0.45 : 1 })) }}>{t.theme === 'uv' ? 'Previous' : '‹ Previous'}</button>
                  {zIdx >= zones.length-1 ? (
                    <button onClick={backToList} style={{ flex:1, padding:14, border:'none', borderRadius:12, background:'#4A6462', fontWeight:600, fontSize:14, color:'#fff', cursor:'pointer', fontFamily:'inherit', ...uvx(() => (uvSheetCommit ? { ...uvSlipBtn(), padding:'0 14px' } : { ...studioSurface.primary(), padding:'0 14px' })) }}>Back to areas</button>
                  ) : (
                    <button onClick={nextAreaNav} style={{ flex:1, padding:14, border:'none', borderRadius:12, background:'#4A6462', fontWeight:600, fontSize:14, color:'#fff', cursor:'pointer', fontFamily:'inherit', ...uvx(() => (uvSheetCommit ? { ...uvSlipBtn(), padding:'0 14px' } : { ...studioSurface.primary(), padding:'0 14px' })) }}>{t.theme === 'uv' ? 'Next area' : 'Next area ›'}</button>
                  )}
                </div>
              )}
            </>
          );
        })()}
      </div>

      {/* ── Voice centre-screen modal (records + transcribes; appends a stacked voice note) ── */}
      {/* P2B: the area complete moment (lit only). Full screen; reads the
          saved done flag and the area's lines, changes nothing itself. */}
      {t.theme === 'uv' && doneMoment && (() => {
        const m = areaMoment({ zones, doneZones, zoneFittings, zone: doneMoment });
        if (!m) return null;
        const S = STUDIO_TOKENS;
        const words = momentFigureWords(m.fittings, m.emergency);
        return <SvLit draw={() => (
          <SheetPortal>
          <div role="dialog" aria-modal="true" aria-label={`${m.name} done`} style={{ position:'fixed', inset:0, zIndex:250, boxSizing:'border-box', overflowY:'auto', WebkitOverflowScrolling:'touch', display:'flex', flexDirection:'column', padding:'calc(env(safe-area-inset-top,0px) + 56px) 20px calc(env(safe-area-inset-bottom,0px) + 24px)', background:`radial-gradient(70% 45% at 50% 22%, ${studioRgba(S.lampAmber, 0.30)}, transparent 70%), ${S.ground.css}`, backgroundColor:S.ground.base, color:S.ink, fontFamily:S.fonts.body }}>
            <style>{'@keyframes p2bPop{from{transform:scale(.8);opacity:0}to{transform:scale(1);opacity:1}}.p2b-tick{animation:p2bPop .4s ease-out both}@media (prefers-reduced-motion: reduce){.p2b-tick{animation:none}}'}</style>
            <div style={{ display:'flex', flexDirection:'column', alignItems:'center', textAlign:'center' }}>
              <div className="p2b-tick" aria-hidden="true" style={{ width:88, height:88, borderRadius:44, background:'radial-gradient(60% 60% at 65% 35%, #FFC977, #F2A23A 75%)', boxShadow:`0 0 0 10px ${studioRgba(S.lampAmber, 0.16)}, 0 0 44px ${studioRgba(S.lampAmber, 0.55)}, -8px 16px 30px -10px rgba(150,90,10,.55)`, display:'flex', alignItems:'center', justifyContent:'center' }}>
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5" /></svg>
              </div>
              <h1 style={{ ...svH1(), fontSize:39, marginTop:22, overflowWrap:'break-word', maxWidth:'100%' }}>{m.name} done</h1>
              <div style={{ display:'flex', alignItems:'center', gap:12, marginTop:14 }}>
                <span style={{ ...studioType.display(), fontSize:61, lineHeight:1 }}>{m.fittings}</span>
                <span style={{ fontSize:16, lineHeight:1.35, color:S.muted, textAlign:'left' }}>{words.logged}{words.emergency ? <><br />{words.emergency}</> : null}</span>
              </div>
            </div>
            <div style={{ marginTop:26 }}>
              <div style={{ display:'flex', justifyContent:'space-between', fontSize:14, color:S.muted }}><span>This survey</span><span>{`${m.doneCount} of ${m.total} areas`}</span></div>
              <div style={{ marginTop:8 }}><SvMarks rows={m.marks} cur={-1} h={10} label={`${m.doneCount} of ${m.total} areas done`} /></div>
            </div>
            {m.eva && (
              <section aria-label="Eva" style={{ marginTop:22, position:'relative', overflow:'hidden', padding:'14px 14px 12px 16px', borderRadius:S.radius.card, background:S.jewel.fill, boxShadow:S.jewel.shadow, display:'flex', flexDirection:'column', gap:6 }}>
                <span aria-hidden="true" style={{ position:'absolute', right:-30, top:-34, width:120, height:120, borderRadius:'50%', background:`radial-gradient(circle, ${S.jewel.text}, ${studioRgba(S.ultraviolet, 0.45)} 30%, ${studioRgba(S.ultraviolet, 0)} 66%)`, opacity:0.9, pointerEvents:'none' }} />
                <p style={{ position:'relative', margin:0, paddingRight:14, fontFamily:S.fonts.display, fontWeight:300, fontSize:20, lineHeight:1.3, color:S.jewel.text }}>
                  <span aria-hidden="true" style={{ display:'inline-flex', verticalAlign:-2, marginRight:8, color:S.jewel.ring }}><SvGlyph /></span>
                  {evaCopyOffer(m.eva.next, m.eva.count)}
                </p>
                {momentError && <p role="alert" style={{ position:'relative', margin:0, fontSize:14, lineHeight:1.4, color:S.jewel.textSecondary }}>{momentError}</p>}
                <div style={{ position:'relative', display:'flex', alignItems:'center', gap:16, flexWrap:'wrap', marginTop:2 }}>
                  <button onClick={() => copyIntoNext(m)} style={{ minHeight:44, padding:'0 15px', borderRadius:S.button.radius, border:'none', background:S.jewel.text, color:S.violetText, fontFamily:'inherit', fontSize:16, fontWeight:600, cursor:'pointer' }}>Copy them</button>
                  <button onClick={() => leaveMoment(m.nextIdx)} style={{ minHeight:44, padding:0, border:'none', background:'transparent', fontFamily:'inherit', fontSize:16, fontWeight:600, color:S.jewel.text, textDecoration:'underline', cursor:'pointer' }}>Start it empty</button>
                </div>
              </section>
            )}
            <div style={{ marginTop:'auto', paddingTop:24, display:'flex', flexDirection:'column', alignItems:'center', gap:8 }}>
              <button onClick={() => leaveMoment(m.nextIdx)} style={{ ...svMain(), minHeight:54, width:'100%', overflowWrap:'break-word' }}>{m.isLast ? 'Back to all areas' : `Go to ${m.next}`}</button>
              {!m.isLast && <button onClick={() => leaveMoment(-1)} style={{ ...studioType.action(), minHeight:44, padding:'0 12px', fontFamily:'inherit', cursor:'pointer' }}>Back to all areas</button>}
            </div>
          </div>
          </SheetPortal>
        )} />;
      })()}

      {showVoiceSheet && (
        <SheetPortal>
        <div onClick={e => { if(e.target===e.currentTarget) { if(voiceSheetRecording) stopVoiceSheetRecorder(); setVoiceSheetRecTime(0); setVoiceSheetError(''); voiceSheetSessionRef.current += 1; voiceSheetAudioIdRef.current = null; voiceSheetFinalisingRef.current = false; setVoiceSheetFinalising(false); setShowVoiceSheet(false); } }}
          style={{ position:'fixed', inset:0, background:'rgba(26,22,8,0.45)', zIndex:200, display:'flex', alignItems:'center', justifyContent:'center', padding:20, ...uvx(uvScrim) }}>
          <div style={{ width:'100%', maxWidth:400, background:'#FAF7F0', borderRadius:20, padding:'20px 18px 16px', maxHeight:'85vh', display:'flex', flexDirection:'column', ...uvx(uvSheet) }}>
            <div style={{ flex:1, overflowY:'auto', WebkitOverflowScrolling:'touch' }}>
            <p style={{ fontSize:15, fontWeight:800, color:t.colors.text, marginBottom:4, ...uvx(uvHeading) }}>{voiceIsSite ? 'Site-wide' : currentZone}{studioSep() + 'voice note'}</p>
            <p style={{ fontSize:12, color:t.colors.textSecondary, marginBottom:18, lineHeight:1.4, ...uvx({ fontSize:14 }) }}>Say what you see. You can read it back at the desk.</p>
            {/* COMPANION-STUDIO-V1 track C1: under the theme, the record control
                is a raised slip until you tap it; while recording it becomes
                the jewel, the one dark surface (FINDINGS T1-15), carrying what
                the app really does: it is recording, the time, and how to stop.
                It never names Eva and makes no claim about photos (the sheet
                covers the camera controls while it is open). The pulse is the
                lamp-amber glow, light only. Theme off: unchanged. */}
            <button onClick={handleVoiceSheetRecord}
              style={{ width:64, height:64, borderRadius:'50%', background: voiceSheetRecording ? '#C85040' : 'rgba(28,24,16,0.12)', color:'white', border:'none', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 14px', cursor:'pointer', boxShadow: voiceSheetRecording ? '0 4px 20px rgba(200,80,64,0.4)' : '0 2px 10px rgba(28,24,16,0.1)', ...uvx(() => (voiceSheetRecording
                ? { width:'100%', height:'auto', minHeight:76, borderRadius:ST.radius.card, background:ST.jewel.fill, boxShadow:ST.jewel.shadow, color:ST.jewel.text, justifyContent:'space-between', gap:14, padding:'12px 14px 12px 18px', textAlign:'left', fontFamily:'inherit' }
                : { width:'100%', height:'auto', minHeight:56, borderRadius:ST.radius.card, ...studioSurface.slip(), color:ST.ink, justifyContent:'flex-start', gap:12, padding:'6px 14px', fontFamily:'inherit', fontSize:16, fontWeight:600 })) }}>
              {t.theme === 'uv' && voiceSheetRecording && (
                <span style={{ flex:1, minWidth:0 }}>
                  <span style={{ display:'block', fontSize:13, color:ST.jewel.textSecondary }}>Recording</span>
                  <span style={{ display:'block', fontSize:16, marginTop:2, color:ST.jewel.text }}>Tap to stop</span>
                </span>
              )}
              {t.theme === 'uv' && voiceSheetRecording && (
                <span style={{ fontSize:25, fontWeight:300, fontFamily:ST.fonts.display, fontVariantNumeric:'tabular-nums', color:ST.jewel.text }}>{`${Math.floor(voiceSheetRecTime/60)}:${String(voiceSheetRecTime%60).padStart(2,'0')}`}</span>
              )}
              {t.theme === 'uv'
                ? <span aria-hidden="true" style={{ flexShrink:0, width:44, height:44, borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', ...(voiceSheetRecording ? { border:`1.5px solid ${ST.jewel.ring}`, animation:'micpulseUv 1.6s ease-in-out infinite' } : studioSurface.pressed()) }}>
                    {voiceSheetRecording
                      ? <span style={{ width:14, height:14, borderRadius:3, background:ST.jewel.text }} />
                      : <Icon name="mic" size={22} color={ST.ink} />}
                  </span>
                : <Icon name="mic" size={26} color={voiceSheetRecording ? "#fff" : "rgba(28,24,16,0.45)"} />}
              {t.theme === 'uv' && !voiceSheetRecording && 'Tap to record'}
            </button>
            {t.theme !== 'uv' && (
            <p style={{ textAlign:'center', fontSize:12, fontWeight:600, color: voiceSheetRecording ? '#C85040' : t.colors.textSecondary, marginBottom: voiceSheetRecording ? 4 : 16 }}>
              {voiceSheetRecording ? 'Recording… tap to stop' : 'Tap to record'}
            </p>
            )}
            {voiceSheetRecording && t.theme !== 'uv' && (
              <p style={{ textAlign:'center', fontSize:18, fontWeight:800, color:'#C85040', marginBottom:14, letterSpacing:'0.04em', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
                {`${Math.floor(voiceSheetRecTime/60)}:${String(voiceSheetRecTime%60).padStart(2,'0')}`}
              </p>
            )}
            {voiceSheetError && (
              <p style={{ textAlign:'center', fontSize:12, fontWeight:600, color:'#C85040', background:'rgba(200,80,64,0.08)', border:'1px solid rgba(200,80,64,0.22)', borderRadius:10, padding:'8px 12px', marginBottom:12, ...uvx(() => ({ ...studioSurface.pressed(), textAlign:'left', fontSize:14, color:ST.ink, borderRadius:12, padding:'10px 12px' })) }}>{voiceSheetError}</p>
            )}
            <p style={{ textAlign:'center', fontSize:11, color:t.colors.textTertiary, marginBottom:12, ...uvx({ fontSize:14 }) }}>{t.theme === 'uv' ? 'or type' : '— or type —'}</p>
            <textarea value={voiceSheetText} onChange={e => setVoiceSheetText(e.target.value)}
              placeholder="Access issues, special requirements, things to flag for the quote…"
              style={{ width:'100%', background:t.colors.input, border:`1px solid ${t.colors.separator}`, borderRadius:12, padding:'11px 13px', fontFamily:'inherit', fontSize:13, color:t.colors.text, resize:'none', minHeight:64, lineHeight:1.5, boxSizing:'border-box', ...uvx(uvField) }} />
            {/* S1 (reviewer FLAG-05) — Save is disabled while the recorder is
                still running. recorder.onstop is async, so a Save tapped mid-
                recording decided before the audio id or the transcript existed
                and wrote NOTHING: the very defect this slice exists to kill, on
                the most natural gesture. Stop first, then save. */}
            <button onClick={saveVoiceSheetNote} disabled={voiceSheetRecording || voiceSheetFinalising}
              style={{ width:'100%', marginTop:12, background: (voiceSheetRecording || voiceSheetFinalising) ? 'rgba(26,90,120,0.32)' : t.colors.teal, color:'white', border:'none', borderRadius:12, padding:13, fontSize:13, fontWeight:800, cursor: (voiceSheetRecording || voiceSheetFinalising) ? 'not-allowed' : 'pointer', boxShadow: (voiceSheetRecording || voiceSheetFinalising) ? 'none' : '0 4px 14px rgba(26,90,120,0.25)', fontFamily:'inherit', ...uvx(() => ({ ...studioSurface.primary(), width:'100%', padding:'0 14px', opacity: (voiceSheetRecording || voiceSheetFinalising) ? 0.5 : 1, cursor: (voiceSheetRecording || voiceSheetFinalising) ? 'not-allowed' : 'pointer' })) }}>
              {voiceSheetRecording
                ? 'Stop the recording first'
                : voiceSheetFinalising
                  ? 'Saving the recording\u2026'
                  : `Save voice note to ${voiceIsSite ? 'site-wide notes' : (currentZone || 'area')}`}
            </button>
            </div>
          </div>
        </div>
        </SheetPortal>
      )}

      {/* ── S1 — "Type it up": transcribe a pending note by hand at the desk ── */}
      {typeUpNote && (
        <SheetPortal>
        <div onClick={() => setTypeUpNote(null)} style={{ position:'fixed', inset:0, background:'rgba(26,22,8,0.45)', zIndex:200, display:'flex', alignItems:'center', justifyContent:'center', padding:20, ...uvx(uvScrim) }}>
          <div onClick={e => e.stopPropagation()} style={{ width:'100%', maxWidth:400, background:'#FAF7F0', borderRadius:20, padding:'20px 18px 16px', maxHeight:'85vh', display:'flex', flexDirection:'column', ...uvx(uvSheet) }}>
            <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:4 }}>
              <div style={{ fontFamily:'Georgia, serif', fontStyle:'italic', fontSize:18, fontWeight:700, color:'#1A1608', ...uvx(uvHeading) }}>Type it up</div>
              <button onClick={() => setTypeUpNote(null)} aria-label="Close" style={{ width:28, height:28, borderRadius:'50%', background:'rgba(26,22,8,0.07)', display:'flex', alignItems:'center', justifyContent:'center', border:'none', cursor:'pointer', ...uvx(uvClose) }}>
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" stroke={t.theme === 'uv' ? ST.ink : "rgba(26,22,8,0.4)"} strokeWidth="1.5" strokeLinecap="round"><line x1="2" y1="2" x2="8" y2="8"/><line x1="8" y1="2" x2="2" y2="8"/></svg>
              </button>
            </div>
            <div style={{ fontSize:12, color:'rgba(26,22,8,0.45)', marginBottom:14, ...uvx(() => ({ fontSize:14, color:ST.muted })) }}>Play the recording back and write what it says. The note becomes an ordinary note.</div>
            <textarea value={typeUpText} onChange={e => setTypeUpText(e.target.value)}
              placeholder="What the recording says…" autoFocus
              style={{ width:'100%', background:'rgba(26,22,8,0.04)', border:'1.5px solid rgba(26,22,8,0.1)', borderRadius:12, padding:'12px 14px', fontFamily:'inherit', fontSize:13, color:'#1A1608', resize:'none', minHeight:96, lineHeight:1.5, boxSizing:'border-box', outline:'none', ...uvx(uvField) }} />
            <button onClick={() => {
                const v = typeUpText.trim();
                if (v && typeUpNote) {
                  updateNoteIn(typeUpNote.key, typeUpNote.id, { body: v, pending: false, typedUp: true });
                  showSavedToast('Note transcribed');
                }
                setTypeUpNote(null); setTypeUpText('');
              }}
              style={{ width:'100%', marginTop:14, background:'#2E6838', borderRadius:14, padding:13, border:'none', cursor:'pointer', fontFamily:'inherit', display:'flex', alignItems:'center', justifyContent:'center', ...uvx(() => ({ ...studioSurface.primary(), width:'100%', padding:'0 14px' })) }}>
              <span style={{ color:'white', fontSize:15, fontWeight:700, ...uvx(() => ({ color:ST.onPrimary, fontSize:16, fontWeight:600 })) }}>Save transcript</span>
            </button>
          </div>
        </div>
        </SheetPortal>
      )}

      {/* ── Typed note centre-screen modal ── */}
      {showNoteSheet && (
        <SheetPortal>
        <div onClick={() => setShowNoteSheet(false)} style={{ position:'fixed', inset:0, background:'rgba(26,22,8,0.45)', zIndex:200, display:'flex', alignItems:'center', justifyContent:'center', padding:20, ...uvx(uvScrim) }}>
          <div onClick={e => e.stopPropagation()} style={{ width:'100%', maxWidth:400, background:'#FAF7F0', borderRadius:20, padding:'20px 18px 16px', maxHeight:'85vh', display:'flex', flexDirection:'column', ...uvx(uvSheet) }}>
            <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:4 }}>
              <div style={{ fontFamily:'Georgia, serif', fontStyle:'italic', fontSize:18, fontWeight:700, color:'#1A1608', ...uvx(uvHeading) }}>Add a note</div>
              <button onClick={() => setShowNoteSheet(false)} aria-label="Close" style={{ width:28, height:28, borderRadius:'50%', background:'rgba(26,22,8,0.07)', display:'flex', alignItems:'center', justifyContent:'center', border:'none', cursor:'pointer', ...uvx(uvClose) }}>
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" stroke={t.theme === 'uv' ? ST.ink : "rgba(26,22,8,0.4)"} strokeWidth="1.5" strokeLinecap="round"><line x1="2" y1="2" x2="8" y2="8"/><line x1="8" y1="2" x2="2" y2="8"/></svg>
              </button>
            </div>
            <div style={{ fontSize:12, color:'rgba(26,22,8,0.45)', marginBottom:14, ...uvx(() => ({ fontSize:14, color:ST.muted })) }}>{projectMode ? 'Site-wide' : (currentZone || 'Area')}</div>
            <textarea value={noteSheetText} onChange={e => setNoteSheetText(e.target.value)}
              placeholder="Access issues, special requirements, things to flag for the quote…" autoFocus
              style={{ width:'100%', background:'rgba(26,22,8,0.04)', border:'1.5px solid rgba(26,22,8,0.1)', borderRadius:12, padding:'12px 14px', fontFamily:'inherit', fontSize:13, color:'#1A1608', resize:'none', minHeight:80, lineHeight:1.5, boxSizing:'border-box', outline:'none', ...uvx(uvField) }} />
            <button onClick={() => { const v=noteSheetText.trim(); if(v){ addNoteTo(activeKey, { type:'text', body:v }); } setShowNoteSheet(false); setNoteSheetText(''); }}
              style={{ width:'100%', marginTop:14, background:'#2E6838', borderRadius:14, padding:13, border:'none', cursor:'pointer', fontFamily:'inherit', display:'flex', alignItems:'center', justifyContent:'center', ...uvx(() => ({ ...studioSurface.primary(), width:'100%', padding:'0 14px' })) }}>
              <span style={{ color:'white', fontSize:15, fontWeight:700, ...uvx(() => ({ color:ST.onPrimary, fontSize:16, fontWeight:600 })) }}>Save note</span>
            </button>
          </div>
        </div>
        </SheetPortal>
      )}

      {/* ── Dock: status bar + tab bar ── */}
      <div style={{ position:'absolute', left:0, right:0, bottom:0, zIndex:20 }}>
        {/* STUDIO-LIT-PHONE-V1 item 7: with the switch on the status bar is
            not drawn. "Finish the survey" on Areas opens Check and send, and
            a second violet "Check and send" here would be a second main
            action on every survey screen. */}
        {t.theme !== 'uv' && (
        <div onClick={() => { if (hasCompletedZones) { persist(); onNav(11, { askReport: true }); } }}
          style={{ margin:'0 12px 8px', background: hasCompletedZones?t.colors.siteNavy:t.colors.deep55, color:t.colors.onFill, borderRadius:15, padding:'12px 15px', display:'flex', alignItems:'center', gap:12, cursor: hasCompletedZones?'pointer':'default', boxShadow:t.shadow.dock, ...uvx(() => ({ ...studioSurface.raised(), color:STUDIO_TOKENS.ink, borderRadius:18, marginBottom:86 })) }}>
          <div style={{ flex:1, minWidth:0 }}>
            <div style={{ fontSize:13, fontWeight:600, ...uvx({ fontSize:16, fontWeight:700 }) }}>{areasCount} area{areasCount!==1?'s':''}{studioSep()}{totalPhotos} photo{totalPhotos!==1?'s':''}</div>
            <div style={{ fontSize:11.5, color:t.colors.dockSub, marginTop:2, ...uvx(() => ({ fontSize:14, color:STUDIO_TOKENS.muted })) }}>{hasCompletedZones ? 'Tap to check and send' : 'Log a fitting before you send'}</div>
          </div>
          <span style={{ fontWeight:700, fontSize:13, padding:'11px 16px', borderRadius:t.radius.dockWrap, flexShrink:0, background: hasCompletedZones?t.colors.dockWrapBg:t.colors.dockWrapBgOff, color:t.colors.dockWrapText, ...uvx(() => ({ background:'none', padding:0, fontSize:16, fontWeight:600, color: hasCompletedZones ? STUDIO_TOKENS.violetText : STUDIO_TOKENS.muted })) }}>{t.theme === 'uv' ? 'Check and send' : 'Check and send →'}</span>
        </div>
        )}
        <TabBar active={3} onChange={onNav} divisionId={div && div.id ? div.id : "lighting"} />
      </div>
    </div>
  );
};


// ════════════════════════════════════════════════════
// SCREEN 11: SURVEY WRAP
// ════════════════════════════════════════════════════

// WRITE-UP-APP-V1: the end of the survey asks about a report, then "Notes for
// the report", one prompt per screen (board 10, column 0). Drawn in the
// survey screens' own look. The logic is WRITE_UP_LOGIC above; what is kept
// and sent is decided there. This only draws it and records.
//   stage     'ask' | 'notes'
//   value     the job's reportRequest
//   onChoose  (choice) for the question: 'problem' | 'scope' | 'none'
//   onChange  (next reportRequest) for a typed answer or a step change
//   onRecorded(key, voiceNoteId, seconds), onTranscript(key, voiceNoteId, text)
//   onFinish  () the last prompt passed;  onBack () out of the question
const ReportWriteUp = ({ stage, value, projectName, projectId, onChoose, onChange, onRecorded, onTranscript, onFinish, onBack, onAsk, voiceTick }) => {
  const S = STUDIO_TOKENS;
  const [recording, setRecording] = useState(false);
  const [recSecs, setRecSecs] = useState(0);
  const [msg, setMsg] = useState('');
  const holdRef = useRef(false);
  const recRef = useRef(null);
  const chunksRef = useRef([]);
  const timerRef = useRef(null);
  const startedAtRef = useRef(0);
  const startingRef = useRef(false);
  const kind = value && value.kind;
  const prompts = reportPromptsFor(kind);
  const step = Math.min(Math.max(0, (value && value.step) || 0), Math.max(0, prompts.length - 1));
  const prompt = prompts[step] || null;
  const answer = prompt ? ((value && value.answers && value.answers[prompt.key]) || {}) : {};
  const ids = Array.isArray(answer.voiceNoteIds) ? answer.voiceNoteIds : [];
  // This prompt's recordings, read from the voice store when it can have changed.
  const recs = React.useMemo(() => {
    if (!ids.length) return [];
    let store = [];
    try { store = loadVoiceNotes(); } catch (e) { store = []; }
    return ids.map((id, i) => {
      const vn = store.find((n) => n && String(n.id) === String(id));
      const words = vn && typeof vn.transcript === 'string' && vn.transcript.trim();
      return { id, n: i + 1, len: voiceDurationWords(vn && vn.duration), words: words ? 'Words back' : 'Words still to come' };
    });
  }, [ids.join('|'), voiceTick, recording]);

  const stopTimer = () => { if (timerRef.current) { clearInterval(timerRef.current); timerRef.current = null; } };
  useEffect(() => () => {
    stopTimer();
    holdRef.current = false;
    const r = recRef.current;
    if (r && r.state !== 'inactive') { try { r.stop(); } catch (e) {} }
  }, []);

  const startRec = async () => {
    holdRef.current = true;
    if (recRef.current || startingRef.current || !prompt) return;
    startingRef.current = true;
    const key = prompt.key;
    setMsg('');
    let stream = null;
    try {
      stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    } catch (e) {
      startingRef.current = false;
      holdRef.current = false;
      setMsg('The microphone is not available. Type the answer instead.');
      return;
    }
    if (!holdRef.current) {
      // Let go before the microphone opened: a tap, not a recording.
      try { stream.getTracks().forEach((tk) => tk.stop()); } catch (e) {}
      startingRef.current = false;
      setMsg('Hold the button down while you talk.');
      return;
    }
    let recorder;
    try {
      recorder = new MediaRecorder(stream, { mimeType: MediaRecorder.isTypeSupported('audio/webm') ? 'audio/webm' : 'audio/mp4' });
    } catch (e) {
      try { stream.getTracks().forEach((tk) => tk.stop()); } catch (e2) {}
      startingRef.current = false;
      holdRef.current = false;
      setMsg('This phone cannot record here. Type the answer instead.');
      return;
    }
    chunksRef.current = [];
    recorder.ondataavailable = (e) => { if (e.data && e.data.size > 0) chunksRef.current.push(e.data); };
    recorder.onstop = async () => {
      stopTimer();
      try { stream.getTracks().forEach((tk) => tk.stop()); } catch (e) {}
      recRef.current = null;
      setRecording(false);
      const blob = new Blob(chunksRef.current, { type: recorder.mimeType });
      const noteId = (typeof crypto !== 'undefined' && crypto.randomUUID)
        ? crypto.randomUUID()
        : 'vn_' + Date.now() + '_' + Math.random().toString(36).slice(2, 9);
      const secs = recordingSeconds(startedAtRef.current, Date.now());
      // Never lose what was said: the bytes are kept on the phone (IndexedDB,
      // or the note itself) before anything is sent anywhere.
      const audioFields = await voiceAudioFields(noteId, blob, blobToBase64Async);
      if (!voiceHasLocalAudio(audioFields)) {
        setMsg('This phone could not keep the recording. Type the answer instead.');
        return;
      }
      const res = addVoiceNote({
        id: noteId,
        recordedAt: new Date().toISOString(),
        duration: secs,
        context: 'survey',
        projectId: projectId || null,
        zone: VOICE_SITE_KEY,
        ...audioFields,
        audioMimeType: recorder.mimeType,
        transcript: null,
        transcriptionStatus: 'pending',
        transcribedAt: null,
        source: 'report',
        reportKey: key,
      }, false);
      if (!res || res.ok !== true) {
        setMsg(voiceStoreMessage(res) + ' Type the answer instead.');
        return;
      }
      // Filed now, so no sweep adopts it a second time.
      try { markVoiceNotesConsidered([noteId]); } catch (e) {}
      onRecorded(key, noteId, secs);
      // Off the phone, then the words. Neither failing loses the recording.
      Promise.resolve(uploadNoteAudio(noteId)).catch(() => {});
      updateVoiceNote(noteId, { transcriptionStatus: 'transcribing' });
      try {
        const fd = new FormData();
        fd.append('audio', blob, 'voice.webm');
        const resp = await fetch(PORTAL_URL + '/api/voice-transcribe', _transcribeFetchInit(fd));
        if (resp.ok) {
          const data = await resp.json();
          const text = String(data.text || data.transcript || '').trim();
          if (text) {
            updateVoiceNote(noteId, { transcriptionStatus: 'done', transcript: text, transcribedAt: new Date().toISOString() });
            onTranscript(key, noteId, text);
          } else {
            updateVoiceNote(noteId, { transcriptionStatus: 'failed' });
            setMsg('The recording is kept, but no words came back from it. Type the key points if you can.');
          }
        } else {
          updateVoiceNote(noteId, { transcriptionStatus: 'pending' });
          setMsg(resp.status === 401
            ? 'The recording is kept. Its words will come once you sign in again.'
            : 'The recording is kept. Its words will come when the phone has signal.');
        }
      } catch (e) {
        updateVoiceNote(noteId, { transcriptionStatus: 'pending' });
        setMsg('The recording is kept. Its words will come when the phone has signal.');
      }
    };
    recRef.current = recorder;
    recorder.start();
    startedAtRef.current = Date.now();
    startingRef.current = false;
    setRecSecs(0);
    setRecording(true);
    stopTimer();
    timerRef.current = setInterval(() => setRecSecs((s) => s + 1), 1000);
    if (!holdRef.current) stopRec();
  };
  const stopRec = () => {
    holdRef.current = false;
    const r = recRef.current;
    if (r && r.state !== 'inactive') { try { r.stop(); } catch (e) {} }
  };

  const head = (backLabel, onBackTap) => (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10, minHeight: 46 }}>
      <SvBack label={backLabel} onClick={onBackTap} />
      <SvSteps cur={2} />
    </div>
  );
  const wrapStyle = { display: 'grid', gridTemplateColumns: 'minmax(0,1fr)', gridAutoRows: 'max-content', gap: 14, padding: '4px 16px 12px' };

  if (stage === 'ask') {
    return (
      <div style={wrapStyle} data-write-up="ask">
        {head('Areas', onBack)}
        <p style={{ margin: 0, fontSize: 16, color: S.muted }}>{projectName}</p>
        <h1 style={{ ...svH1(), fontSize: 29, lineHeight: 1.12 }}>Does the client want a report?</h1>
        <p style={{ margin: 0, fontSize: 16, lineHeight: 1.45, color: S.ink }}>Is it a problem to solve, or a check of our scope before they order?</p>
        <div role="group" aria-label="Does the client want a report?" style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <button onClick={() => onChoose('problem')} style={{ ...svGhost(), width: '100%' }}>A problem to solve</button>
          <button onClick={() => onChoose('scope')} style={{ ...svGhost(), width: '100%' }}>A check of our scope</button>
          <button onClick={() => onChoose('none')} style={{ ...svGhost(), width: '100%' }}>No report</button>
        </div>
      </div>
    );
  }
  if (!prompt) return null;
  const last = step === prompts.length - 1;
  const go = (i) => { if (recording) stopRec(); onChange(Object.assign({}, value, { step: i })); };
  const next = () => { if (recording) stopRec(); if (last) onFinish(); else go(step + 1); };
  const field = { ...studioSurface.pressed(), borderRadius: S.button.radius, minHeight: 112, padding: '10px 12px', boxSizing: 'border-box', width: '100%', color: S.ink, fontFamily: 'inherit', fontSize: 16, outline: 'none', resize: 'vertical', lineHeight: 1.45 };
  const holdProps = {
    onPointerDown: (e) => { try { e.currentTarget.setPointerCapture(e.pointerId); } catch (e2) {} startRec(); },
    onPointerUp: () => stopRec(),
    onPointerCancel: () => stopRec(),
    // A keyboard or switch press has no pointer: it toggles instead.
    onClick: (e) => { if (e.detail !== 0) return; if (recording) stopRec(); else startRec(); },
    onContextMenu: (e) => e.preventDefault(),
  };
  return (
    <div style={wrapStyle} data-write-up="notes">
      {head('Back', () => (step > 0 ? go(step - 1) : onAsk()))}
      <div>
        <p style={{ margin: 0, fontSize: 16, color: S.muted }}>{projectName}</p>
        <h1 style={{ ...svH1(), fontSize: 31, lineHeight: 1.08, marginTop: 4 }}>Notes for the report</h1>
      </div>
      <p data-step style={{ margin: 0, fontSize: 14, fontWeight: 700, color: S.ink }}>{reportStepWords(kind, step)}</p>
      <section aria-label={prompt.name} style={{ ...studioSurface.lit(), borderRadius: S.radius.card, padding: '16px 16px', display: 'flex', flexDirection: 'column', gap: 10 }}>
        <h2 style={{ ...svH2(), lineHeight: 1.25 }}>{prompt.heading}</h2>
        <p style={{ margin: 0, fontSize: 14, lineHeight: 1.42, color: S.muted }}>{prompt.help}</p>
        <button {...holdProps} aria-pressed={recording}
          style={{ ...svGhost(), ...(recording ? { boxShadow: `inset 0 0 0 2px ${S.ink}` } : {}), width: '100%', minHeight: 64, fontSize: 16, fontWeight: 700, touchAction: 'none', userSelect: 'none', WebkitUserSelect: 'none', WebkitTouchCallout: 'none' }}>
          {recording ? `Recording, ${voiceDurationWords(recSecs) || '0:00'} so far` : 'Hold to talk'}
        </button>
        {recs.length ? (
          <ul aria-label="Recordings for this prompt" style={{ listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexDirection: 'column', gap: 4 }}>
            {recs.map((r) => <li key={r.id} style={{ fontSize: 14, color: S.ink }}>Recording {r.n}{r.len ? `, ${r.len}` : ''}. {r.words}.</li>)}
          </ul>
        ) : null}
        <label style={{ display: 'flex', flexDirection: 'column', gap: 6, fontSize: 14, fontWeight: 700, color: S.ink }}>
          Or type
          <textarea aria-label={`Answer: ${prompt.name}`} value={typeof answer.text === 'string' ? answer.text : ''}
            onChange={(e) => onChange(reportWithAnswer(value, prompt.key, { text: e.target.value }))}
            placeholder="What you would say" style={field} />
        </label>
        {msg ? <p role="status" style={{ margin: 0, fontSize: 14, lineHeight: 1.4, color: STUDIO_MEANING.rustText }}>{msg}</p> : null}
      </section>
      <div style={{ display: 'flex', gap: 10 }}>
        <button onClick={next} style={{ ...svGhost(), flex: 1 }}>Skip</button>
        <button onClick={next} style={{ ...svMain(), flex: 1 }}>{last ? 'Done' : 'Next'}</button>
      </div>
      <nav aria-label="The prompts">
        <ol style={{ listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexDirection: 'column', gap: 4 }}>
          {prompts.map((p, i) => {
            const done = reportAnswered(value, p.key);
            return (
              <li key={p.key}>
                <button onClick={() => go(i)} aria-current={i === step ? 'step' : undefined}
                  style={{ ...svGhost(), width: '100%', minHeight: 44, display: 'flex', alignItems: 'center', gap: 10, textAlign: 'left', fontWeight: i === step ? 700 : 500, ...(i === step ? {} : { background: 'transparent', boxShadow: 'none' }) }}>
                  <span aria-hidden="true" style={{ width: 18, display: 'inline-flex', justifyContent: 'center', color: done ? S.ink : S.muted }}>{done ? '✓' : String(i + 1)}</span>
                  <span>{p.name}</span>
                  {done ? <span style={{ position: 'absolute', width: 1, height: 1, overflow: 'hidden', clip: 'rect(0 0 0 0)' }}>, answered</span> : null}
                </button>
              </li>
            );
          })}
        </ol>
      </nav>
    </div>
  );
};

const SurveyWrapScreen = ({ onBack, onNav, activeProject, onUpdateProject, currentUser, askReport }) => {
  const div = getDivisionConfig(currentUser);
  const [wrapNote, setWrapNote] = useState(activeProject?.surveyWrapNote || '');
  const [wrapPhotos, setWrapPhotos] = useState(activeProject?.surveyWrapPhotos || []);
  const [scopeDriver, setScopeDriver] = useState(() => {
    const saved = activeProject?.scopeDriver;
    return Array.isArray(saved) ? saved : (saved ? [saved] : []);
  });
  const [scopeTimeline, setScopeTimeline] = useState(() => {
    const saved = activeProject?.scopeTimeline;
    return Array.isArray(saved) ? saved : (saved ? [saved] : []);
  });
  const [scopeBudget, setScopeBudget] = useState(() => {
    const saved = activeProject?.scopeBudget;
    return Array.isArray(saved) ? saved : (saved ? [saved] : []);
  });
  const [scopeDecisionMaker, setScopeDecisionMaker] = useState(activeProject?.scopeDecisionMaker || '');
  const [scopeAccessNotes, setScopeAccessNotes] = useState(activeProject?.scopeAccessNotes || '');
  const [followUpDate, setFollowUpDate] = useState(activeProject?.followUpDate || '');
  const [followUpChip, setFollowUpChip] = useState('');
  const [scopeBudgetValue, setScopeBudgetValue] = useState(activeProject?.scopeBudgetValue || '');
  const [wrapRecording, setWrapRecording] = useState(false);
  const [wrapVoiceMsg, setWrapVoiceMsg] = useState('');   // CHIP-COST-V1: why a recording did not transcribe
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [sendError, setSendError] = useState(false);
  const [sentMode, setSentMode] = useState('success'); // S95 D14 — 'success' | 'queued'
  const [sentSummary, setSentSummary] = useState(null); // S95 D14 — routing outcome
  const [uploadStatus, setUploadStatus] = useState(null); // S98 — photo upload progress label
  const [expandedZones, setExpandedZones] = useState({});
  const [routingSelections, setRoutingSelections] = useState({});
  // SLICE-A3: Add a supplier opens as a sheet over this screen (never a
  // navigation away). supplierSheet is { category } while it is open;
  // supplierTick makes Prices from re-run its match after a supplier is saved,
  // because the held suppliers are read from storage at render.
  const [supplierSheet, setSupplierSheet] = useState(null);
  const [supplierTick, setSupplierTick] = useState(0);
  const supplierAdded = () => { setSupplierSheet(null); setSupplierTick(n => n + 1); };
  // S105 — pre-submit guard. When the user taps Send and pending photos
  // (base64 still in sitePhotos OR uploadFailed=true) are present, we
  // pause and show a Wait / Send anyway dialog. State is cleared once
  // the user picks an option or the upload completes.
  const [pendingPhotoWarn, setPendingPhotoWarn] = useState(null); // null | { count, onWait, onSendAnyway }
  const [waitFlushProgress, setWaitFlushProgress] = useState(null); // null | { attempted, ok, failed }
  // P2C: the send stopped after its upload step because photos that needed
  // uploading did not get a url (failed upload, or no copy on the device).
  // null | { total, byArea: [{ area, n }], submitIntent, visitLabel }. Nothing
  // is posted while this is set; the surveyor picks Try again or Send without
  // them.
  const [uploadShortfall, setUploadShortfall] = useState(null);
  // S106 — pre-submit conflict resolution. When the GET conflict-check
  // returns existing rows for this project, this state holds them and
  // the modal step (one of 'choose' | 'name_visit' | 'confirm_duplicate').
  // The modal three-way picker writes the chosen submit_intent (and
  // optionally a visit_label) into the next sendToPortal call.
  const [conflictModal, setConflictModal] = useState(null);
  // SEND-TIMEOUT-V1 (#118 round 1): the client id of the job's queued copy
  // when the S106 choice opened, or null. The send has ended while the choice
  // is open, so the queue may deliver that copy meanwhile; the chosen intent
  // is checked against it before anything is posted.
  const _choiceCopyRef = useRef(null);
  // null | { existing: [...], step: 'choose' | 'name_visit' | 'confirm_duplicate', visitLabel: '' }
  // SEND-STATE-V1: this job's send state, re-read whenever it can change, and
  // the answer to the last Try now / Try again.
  useSendStateTick();
  // WRITE-UP-APP-V1: the report question and "Notes for the report" (see
  // WRITE_UP_LOGIC). The answers are the job's `reportRequest`, saved on every
  // change; the ref is the latest copy for the recorder's late callbacks and
  // the send. The stage opens on the question only while nothing has gone.
  const reportReqRef = useRef((activeProject && activeProject.reportRequest) || null);
  const [reportReq, setReportReqState] = useState(reportReqRef.current);
  // Only Finish the survey (askReport) opens on the question or the prompts.
  // Any other way in (the job's send state, a test mounting the screen) opens
  // Check and send, where the report's line leads back in.
  const [reportStage, setReportStage] = useState(() => {
    if (!askReport) return null;
    let st = 'not_sent';
    try { st = readSendState(activeProject).state; } catch (e) {}
    return reportStageFor(reportReqRef.current, st);
  });
  const [reportVoiceTick, setReportVoiceTick] = useState(0);
  const saveReportReq = (next) => {
    reportReqRef.current = next;
    setReportReqState(next);
    if (activeProject?.id && onUpdateProject) onUpdateProject(activeProject.id, { reportRequest: next });
  };
  // A prompt's recording files as a Site-wide note, in the store the send
  // reads (survey_active when it is this job's draft, and the job).
  // When the draft is another job's, the job's own notes are the store, and
  // the prop can lag a write made a moment ago (two recordings in quick
  // succession), so the last map written here is built on instead.
  const lastSiteNotesRef = useRef(null);
  const editSiteNotes = (fn) => {
    if (!activeProject?.id) return;
    let sa = null;
    try { sa = JSON.parse(localStorage.getItem('survey_active') || 'null'); } catch (e) { sa = null; }
    const own = !!(sa && sa.projectId === activeProject.id);
    const base = own ? resolveZoneNotesForPayload(sa, activeProject)
      : (lastSiteNotesRef.current || resolveZoneNotesForPayload(null, activeProject));
    const next = fn(base);
    if (!next || next === base) return;
    lastSiteNotesRef.current = own ? null : next;
    if (own) {
      try { localStorage.setItem('survey_active', JSON.stringify(Object.assign({}, sa, { zoneNotes: next, savedAt: Date.now() }))); }
      catch (e) { debugLog('localStorage.persist.fail', { key: 'survey_active', error: (e && e.message) || String(e) }); }
    }
    if (onUpdateProject) onUpdateProject(activeProject.id, { zoneNotes: next });
  };
  // Only while nothing has gone: once a copy is waiting to send, words coming
  // back are left to the survey's own sweep, as for any other note (filling
  // here would hold the waiting copy as changed the moment the signal
  // returned, so a survey finished offline would not go by itself).
  const fillReportNotes = () => {
    const ids = reportVoiceIds(reportReqRef.current);
    if (!ids.length) return;
    try { if (readSendState(activeProject).state !== 'not_sent') { setReportVoiceTick((n) => n + 1); return; } } catch (e) { return; }
    let store = [];
    try { store = loadVoiceNotes(); } catch (e) { store = []; }
    editSiteNotes((base) => { const r = fillReportSiteNotes(base, store, ids); return r.changed ? r.zoneNotes : base; });
    setReportVoiceTick((n) => n + 1);
  };
  // Words that come back later (the retry sweep) reach the notes too.
  useEffect(() => {
    fillReportNotes();
    const onWords = () => fillReportNotes();
    window.addEventListener('lumenVoiceTranscribed', onWords);
    return () => window.removeEventListener('lumenVoiceTranscribed', onWords);
  }, []);
  const reportChoice = (choice) => {
    const next = reportChoose(reportReqRef.current, choice, new Date().toISOString());
    saveReportReq(next);
    setReportStage(next.wanted ? 'notes' : null);
  };
  const reportRecorded = (key, noteId, secs) => {
    const d = new Date();
    editSiteNotes((base) => withReportSiteNote(base, reportSiteNote(noteId, secs, d.getTime(), ('0' + d.getHours()).slice(-2) + ':' + ('0' + d.getMinutes()).slice(-2))));
    saveReportReq(reportWithAnswer(reportReqRef.current, key, { addVoiceNoteId: noteId }));
  };
  const reportTranscript = (key, noteId, text) => {
    saveReportReq(reportWithAnswer(reportReqRef.current, key, { appendText: text }));
    fillReportNotes();
  };
  const reportFinish = () => {
    saveReportReq(Object.assign({}, reportReqRef.current, { done: true }));
    setReportStage(null);
  };
  const [tryMsg, setTryMsg] = useState('');
  // Try again on Check and send builds the survey again from the job as it is
  // now (sendToPortal): the same survey goes as the queued copy, byte for byte
  // and under its client id; a changed one replaces it under a fresh id. With
  // no connection and nothing changed, nothing is spent.
  const tryQueuedSend = () => {
    setTryMsg('');
    setSendError(false);
    let online = true;
    try { online = !(typeof navigator !== 'undefined' && navigator.onLine === false); } catch (e) {}
    if (!online && !sendStateNeedsWrap(readSendState(activeProject))) {
      setTryMsg('Still no connection. It’ll go by itself when the phone is back online.');
      return;
    }
    sendToPortal();
  };
  const photoRef = useRef(null);
  const videoRef = useRef(null);
  const wrapMediaRef = useRef(null);
  const wrapAudioChunks = useRef([]);

  // Save survey_active with wrap stage on mount
  useEffect(() => {
    if (activeProject?.id) {
      try {
        const existing = JSON.parse(localStorage.getItem('survey_active') || '{}');
        existing.currentStage = 'wrap';
        existing.savedAt = Date.now();
        localStorage.setItem('survey_active', JSON.stringify(existing));
        // Sync today_visits status
        const tv = JSON.parse(localStorage.getItem('lumen_visits') || '[]');
        let changed = false;
        tv.forEach(v => { if (v.surveyId === activeProject.id) { v.status = 'wrap'; changed = true; } });
        if (changed) localStorage.setItem('lumen_visits', JSON.stringify(tv));
      } catch(e) {}
    }
  }, []);

  const surveyZones = activeProject?.surveyZones || [];
  // S160 — ONE canonical derivation for zone rows / fixture total / type count
  // (deriveWrapSummary, module level, test-locked). Header chip, hero stats and
  // the Zone breakdown all read from this so they cannot disagree with each
  // other or with the area cards.
  const wrapSummary = deriveWrapSummary(surveyZones, activeProject?.customZones, activeProject?.doneZones);
  const totalFixtures = wrapSummary.totalFixtures;
  const totalZoneCount = wrapSummary.totalZoneCount;
  const uniqueTypes = wrapSummary.uniqueTypes;
  // COMPANION-STUDIO-LIT-V1 track 2: completion words follow the summary, so
  // the wrap never says "complete" while areas are open.
  const openAreasCount = Math.max(0, totalZoneCount - wrapSummary.doneCount);
  const openAreasText = `${openAreasCount} area${openAreasCount !== 1 ? 's' : ''} still open`;
  const totalExistingKw = (surveyZones.reduce((s,z) => s + ((z.unit?.wattage||0)*(z.qty||1)), 0) / 1000).toFixed(1);

  const totalLedKw = (surveyZones.reduce((s,z) => s + ((z.unit?.replacementW||0)*(z.qty||1)), 0) / 1000).toFixed(1);
  const reductionPct = parseFloat(totalExistingKw) > 0 ? Math.round((1 - parseFloat(totalLedKw) / parseFloat(totalExistingKw)) * 100) : 0;
  const photoCount = (activeProject?.sitePhotos || []).filter(p => p.type !== 'video').length;
  const dateStr = new Date().toLocaleDateString('en-GB', { weekday:'long', day:'numeric', month:'long' });
  const dateTimeStr = new Date().toLocaleString('en-GB', { day:'numeric', month:'short', hour:'2-digit', minute:'2-digit' });
  // SEND-STATE-V1 (switch off): the same state the lit screen draws.
  const sendStNow = readSendState(activeProject, { sending });
  const offBlocked = sendStateBlocksSend(sendStNow) && sendStNow.state !== 'sending';
  const offQueued = !sent && (sendStNow.state === 'waiting' || sendStNow.state === 'failed');
  // The state's action on Check and send builds the survey again
  // (tryQueuedSend), so it is named for that. A sign-in hold has none (the
  // sign-in banner is its action).
  const wrapActFor = (st) => (!st || st.why === 'signin') ? null
    : st.why === 'changed' ? 'Send the changes'
    : st.why === 'conflict' ? 'Choose how to send'
    : (st.state === 'failed' || sentMode === 'queued') ? 'Try again' : 'Try now';

  const toggleArrayItem = (arr, setter, item) => {
    setter(prev => prev.includes(item) ? prev.filter(x => x !== item) : [...prev, item]);
  };

  const handleWrapRecord = async () => {
    if (wrapRecording) {
      if (wrapMediaRef.current) wrapMediaRef.current.stop();
      setWrapRecording(false);
      return;
    }
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const recorder = new MediaRecorder(stream, { mimeType: MediaRecorder.isTypeSupported('audio/webm') ? 'audio/webm' : 'audio/mp4' });
      wrapAudioChunks.current = [];
      recorder.ondataavailable = (e) => { if (e.data.size > 0) wrapAudioChunks.current.push(e.data); };
      recorder.onstop = async () => {
        stream.getTracks().forEach(tk => tk.stop());
        const blob = new Blob(wrapAudioChunks.current, { type: recorder.mimeType });
        // CHIP-COST-V1 — this recording lived only in memory, so any failed or
        // refused transcription threw it away with nothing on screen. Once
        // the portal requires sign-in, a 401 is the ordinary answer for a
        // signed-out surveyor, so keep the audio as a pending voice note (the
        // retry sweep transcribes it later) and say what happened.
        const keepForLater = async (why) => {
          let saved = false;
          let pruneNote = '';
          try {
            const noteId = (typeof crypto !== 'undefined' && crypto.randomUUID)
              ? crypto.randomUUID()
              : 'vn_' + Date.now() + '_' + Math.random().toString(36).slice(2, 9);
            // SLICE-A5: the bytes go to IndexedDB (base64 only if that fails).
            const audioFields = await voiceAudioFields(noteId, blob, blobToBase64Async);
            if (!voiceHasLocalAudio(audioFields)) throw new Error('voice audio could not be stored');
            const res = addVoiceNote({
              id: noteId,
              recordedAt: new Date().toISOString(),
              context: 'wrap',
              projectId: (activeProject && activeProject.id) || null,
              ...audioFields,
              audioMimeType: recorder.mimeType,
              transcript: null,
              transcriptionStatus: 'pending',
              transcribedAt: null,
              source: 'wrap',
            }, false);
            saved = !!(res && res.ok);
            // Round 2 review: a full store makes persistVoiceNotes clear older
            // audio, or drop every other note, and still report ok. Say so,
            // as every sibling writer does, rather than "saved" over a loss.
            _surfaceVoiceStorePruning(res, 'wrap rescue');
            if (saved && res.audioPruned) pruneNote = ' ' + voiceStoreMessage(res);
          } catch (e2) { console.warn('Wrap voice could not be kept:', e2); }
          const lead = why === 401 ? 'Transcription needs you to sign in again.'
            : why === 429 ? 'Transcription limit reached for this hour.'
            : 'No signal for transcription.';
          setWrapVoiceMsg(saved
            ? lead + ' The recording is saved in Voice Notes and will transcribe later.' + pruneNote
            : lead + ' The recording could not be saved on this device, so type the key points into the note.');
        };
        setWrapVoiceMsg('');
        try {
          const fd = new FormData(); fd.append('audio', blob, 'voice.webm');
          const resp = await fetch(PORTAL_URL + '/api/voice-transcribe', _transcribeFetchInit(fd));
          if (resp.ok) {
            const data = await resp.json();
            setWrapNote(prev => prev ? prev + ' ' + (data.text || data.transcript || '') : (data.text || data.transcript || ''));
          } else {
            await keepForLater(resp.status);
          }
        } catch(e) { console.warn('Wrap voice failed:', e); await keepForLater(null); }
      };
      wrapMediaRef.current = recorder;
      recorder.start();
      setWrapRecording(true);
    } catch(e) { console.warn('Mic access failed:', e); }
  };

  const handleWrapPhoto = async (file) => {
    if (!file) return;
    try {
      const compressed = await compressImage(file, 800, 0.65);
      setWrapPhotos(prev => [...prev, compressed]);
    } catch(e) { console.error("Wrap photo:", e); }
  };

  // S105 — Send-button guard. Counts pending (base64 / uploadFailed)
  // photos and surfaces a confirm dialog before letting the wrap go
  // out. `force=true` skips the guard.
  // S106 — accepts submitIntent / visitLabel for re-submissions of an
  // existing project. On a fresh send (no intent supplied), we GET
  // /api/companion/survey-conflict first; if prior non-superseded rows
  // exist, the conflict modal is shown and sendToPortal returns. The
  // modal's chosen option re-invokes sendToPortal with the right intent.
  // P2C: `withoutUnsent` is set only by "Send without them". It skips the
  // upload step (the photos just failed) and lets the send go without the
  // photos still not uploaded, saying which areas lost how many. Nothing else,
  // `force` included, lets the send post past a photo that did not upload.
  // `knownUrls` ({ key: url }) carries the photos a stopped send DID upload,
  // so the follow-up neither uploads them again nor leaves them out.
  const sendToPortal = async (force = false, submitIntent = null, visitLabel = null, withoutUnsent = false, knownUrls = null) => {
    // SEND-TIMEOUT-V1: one of the portal's surveys for the job (`existing`)
    // can be this job's own queued copy, from a send that ran out of time (or
    // lost its answer) and landed all the same. That copy is then delivered,
    // exactly as the queue delivers one (the App marks the job sent while the
    // job is still that survey), and goes no more. 'same': the job is
    // unchanged since the copy, so it is sent and nothing more goes from here.
    // 'changed': the portal holds an earlier copy, and the S106 choice is for
    // the job as it is now. null: the portal does not hold the copy.
    const _deliverLandedCopy = (copy, existing) => {
      const row = copy ? wrapLandedRow(copy.item.payload, existing) : null;
      if (!row) return null;
      _noteWrapDelivered(copy.item, { surveyId: row.id || null, bound: false, boundProjectId: null }, 'wrap_check');
      dropWrapCopies(activeProject?.id, activeProject?.name, activeProject?.createdAt);
      const d = _readDraft();
      const same = !!copy.item.jobPrint && copy.item.jobPrint === wrapJobPrint(activeProject, d && activeProject && d.projectId === activeProject.id ? d : null);
      try { debugLog('wrap.submit.already_landed', { projectId: activeProject?.id, surveyId: row.id || null, same }); } catch (e) {}
      return same ? 'same' : 'changed';
    };
    // SEND-TIMEOUT-V1 (#118 round 1): the S106 choice opens here only, noting
    // the job's queued copy as it is now (after any landed copy was
    // delivered and dropped above), so the choice can be checked against it.
    const _openChoice = (existing) => {
      const c = wrapCopyOf(activeProject);
      _choiceCopyRef.current = c ? wrapClientId(c.item) : null;
      setConflictModal({ existing: existing || [], step: 'choose', visitLabel: '' });
    };
    // SEND-TIMEOUT-V1 (#118 round 1): a chosen intent (Update, New visit,
    // Duplicate) is for the surveys the choice listed. If the queue delivered
    // the job's copy while the choice was open, the portal holds more than it
    // listed: the job unchanged since that copy is sent, and nothing is
    // posted; changed since, the choice is asked again from what the portal
    // holds now. Either way the chosen intent never posts a second copy.
    if (submitIntent && _choiceCopyRef.current) {
      const _cid = _choiceCopyRef.current;
      const _rec = _readWrapDelivered().find((r) => r && r.client_id === _cid);
      if (_rec) {
        _choiceCopyRef.current = null;
        const _d = _readDraft();
        const _same = !!_rec.jobPrint && _rec.jobPrint === wrapJobPrint(activeProject, _d && activeProject && _d.projectId === activeProject.id ? _d : null);
        try { debugLog('wrap.submit.choice_overtaken', { projectId: activeProject?.id, same: _same, intent: submitIntent }); } catch (e) {}
        setConflictModal(null);
        if (_same) return;
        return sendToPortal();
      }
    }
    // SEND-STATE-V1: while a copy of this job is going (from the queue, or a
    // send from here already in flight), nothing more goes. A sent job can be
    // sent again exactly as before (the S106 choice below). A waiting or
    // parked one is built again below from the job as it is now, and replaces
    // its queued copy (wrapCopyOf, at the post). One the portal already holds
    // a survey for (409 intent_required in the queue) asks the S106 choice
    // first, from the rows the portal named, rather than replaying a copy
    // that can never go.
    {
      const _st = readSendState(activeProject);
      if (_st.state === 'sending') {
        try { debugLog('wrap.submit.blocked', { projectId: activeProject?.id, state: _st.state }); } catch (e) {}
        return;
      }
      const _copy = wrapCopyOf(activeProject);
      if (_copy && _copy.item.conflict && !submitIntent) {
        // SEND-TIMEOUT-V1: a copy an earlier build held for a choice can be
        // one the portal already holds itself.
        if (_deliverLandedCopy(_copy, _copy.item.conflict.existing) === 'same') return;
        setSendError(false);
        _openChoice((_copy.item.conflict && _copy.item.conflict.existing) || []);
        return;
      }
    }
    if (!force) {
      const pending = (activeProject?.sitePhotos || []).filter(_isPhotoPending);
      if (pending.length > 0) {
        setPendingPhotoWarn({ count: pending.length });
        return;
      }
    }
    setSending(true);
    setSendError(false);
    setUploadStatus(null);
    setPendingPhotoWarn(null);
    setWaitFlushProgress(null);
    setConflictModal(null);
    setUploadShortfall(null);
    // S95 D5 D22 (third attempt) — cache projectId at entry so that any stale
    // prop reference later in this async function cannot silently skip the
    // status writes (the `if (activeProject?.id && onUpdateProject)` guard was
    // failing when activeProject became stale across awaits).
    const projectId = activeProject?.id;
    // SEND-STATE-V1: the job is being sent from here, from now (the S106
    // check and its photo uploads included) until this send ends, however it
    // ends. A queue flush that starts meanwhile leaves the job's queued copy
    // alone (_wrapDirect), so it cannot deliver that copy under this send
    // (whose post would then meet a 409 and open the S106 choice). The copy is
    // replaced or removed when this send ends. SEND-TIMEOUT-V1 (#112 note 4):
    // set before the S106 check, so a second tap while the check waits finds
    // the job sending, and so does the queue.
    const _directKeys = projectId ? [_wrapFlightKey(projectId, null), _wrapFlightKey(null, activeProject?.name)] : [];
    _directKeys.forEach((k) => _wrapDirect.add(k));
    if (_directKeys.length) _sendStateChanged();
    try {
      // S106 — pre-submit conflict check. Fail open on network error;
      // the portal's 409 response is the safety net. SEND-TIMEOUT-V1: and on
      // no answer within _WRAP_CHECK_TIMEOUT_MS.
      if (!submitIntent && !force) {
        const _projName = activeProject?.name || '';
        if (_projName) {
          const _ccDl = _portalDeadline(_WRAP_CHECK_TIMEOUT_MS);
          try {
            const _ccTok = localStorage.getItem('lumen_token');
            const _ccRes = await _ccDl.within(fetch(
              `${PORTAL_URL}/api/companion/survey-conflict?project_name=${encodeURIComponent(_projName)}`,
              { headers: _ccTok ? { 'Authorization': `Bearer ${_ccTok}` } : {}, signal: _ccDl.signal }
            ));
            if (_ccRes.ok) {
              const _cc = await _ccDl.within(_ccRes.json());
              if (_cc && _cc.conflict && Array.isArray(_cc.existing) && _cc.existing.length > 0) {
                // SEND-TIMEOUT-V1: one of them can be this job's own queued
                // copy, landed although its send got no answer
                // (_deliverLandedCopy): unchanged since, the job is sent.
                if (_deliverLandedCopy(projectId ? wrapCopyOf(activeProject) : null, _cc.existing) === 'same') {
                  setSending(false);
                  return;
                }
                try { debugLog('survey.conflict.detected', { projectId: activeProject?.id, count: _cc.existing.length }); } catch (e) {}
                setSending(false);
                _openChoice(_cc.existing);
                return;
              }
            }
          } catch (e) {
            try { debugLog('survey.conflict_check.fail', { error: (e && e.message) || String(e) }); } catch (_e) {}
          } finally {
            _ccDl.done();
          }
        }
      }
      // ── S105 photo sync ────────────────────────────────────────────
      // Pre-S105 this block fired Promise.all(_origSitePhotos.map(...))
      // — 20 simultaneous /api/photo POSTs that overran iOS Safari's
      // 6-connection limit and silently dropped 16 of 20 photos on
      // Chelsea Harbour LTE. Replaced with uploadPhotoBatched (3
      // concurrent + 30s AbortController timeout per fetch). Failed
      // uploads land in lumen_photo_retry_queue rather than vanishing.
      //
      // Most photos should already carry .url at this point because
      // S105 also added capture-time upload — uploadPhotoBatched is
      // a no-op for photos that aren't base64. This block is now a
      // safety net for: photos captured offline mid-survey,
      // capture-time upload that failed and didn't get a chance to
      // retry yet, and surveys created on older companion versions.
      // S135 — hydrate ref-only photos (base64 moved to IndexedDB by
      // photoToRef) back to base64 so this safety-net still uploads AND includes
      // photos captured offline and reopened before the retry queue flushed.
      const _hydrateFromIdb = async (photo) => {
        if (!needsIdbHydration(photo)) return photo;
        try {
          const blob = await idbGetBlob(photo.id);
          if (!blob) return photo;
          const dataUrl = await blobToDataUrl(blob);
          if (dataUrl) return Object.assign({}, photo, { src: dataUrl });
        } catch (e) {}
        return photo;
      };
      // S136 (§5.8) — keep photo arrays as lightweight REFS; do NOT hydrate
      // every offline photo to base64 up front (the iOS memory-spike / black-
      // screen class). Hydration happens one photo at a time, bounded, below.
      // P2C: wrapApplyUrl returns each photo unchanged unless a stopped send
      // already uploaded it (knownUrls), so a normal send is as before.
      const _origSitePhotos = (activeProject?.sitePhotos || []).map(p => wrapApplyUrl(p, knownUrls));
      const _origSurveyZones = (activeProject?.surveyZones || []).map(z =>
        z && Array.isArray(z.photos) ? Object.assign({}, z, { photos: z.photos.map(p => wrapApplyUrl(p, knownUrls)) }) : z
      );
      const _needsUpload = (p) => !!p && p.type !== 'video' && !p.url && (needsIdbHydration(p) || _isB64(p.src));
      const _siteToUpload = _origSitePhotos.filter(_needsUpload).length;
      const _zonePhotoCount = _origSurveyZones.reduce(
        (s, z) => s + (Array.isArray(z?.photos) ? z.photos.filter(_needsUpload).length : 0), 0
      );
      const _totalToUpload = _siteToUpload + _zonePhotoCount;

      if (_totalToUpload > 0 && !withoutUnsent) {
        setUploadStatus(`Uploading ${_totalToUpload} photo${_totalToUpload === 1 ? '' : 's'}…`);
      }

      // Build one combined input list so the 3-concurrent batcher
      // schedules across both sitePhotos and per-zone photos as a
      // single queue (instead of two parallel storms). Tag each entry
      // so we can route the result back to the right collection.
      const _siteInputs = _origSitePhotos.map((p, i) => ({ kind: 'site', i, photo: p }));
      const _zoneInputs = [];
      _origSurveyZones.forEach((z, zi) => {
        if (Array.isArray(z?.photos)) {
          z.photos.forEach((p, pi) => _zoneInputs.push({ kind: 'zone', zi, pi, photo: p }));
        }
      });
      const _allInputs = _siteInputs.concat(_zoneInputs);

      const _sitePhotosOut = _origSitePhotos.slice();
      const _surveyZonesOut = _origSurveyZones.map(z =>
        z && Array.isArray(z.photos) ? Object.assign({}, z, { photos: z.photos.slice() }) : z
      );
      let _uploaded = 0, _failed = 0;

      // Hydrate (from IndexedDB) + upload exactly ONE photo, releasing its
      // base64 as soon as the upload settles. The output never retains base64:
      // success keeps the URL, failure keeps the ref (durable in IndexedDB and
      // re-queued with the base64 we just hydrated).
      const _processOne = async (input) => {
        const photo = input.photo;
        if (!_needsUpload(photo)) return;
        const hydrated = await _hydrateFromIdb(photo); // base64 lives only in `hydrated`
        if (!_isB64(hydrated.src)) return;             // nothing to send; stays durable in IDB
        let res;
        try { res = await _uploadPhotoOnce(hydrated); }
        catch (e) { res = { ok: false, error: String((e && e.message) || e) }; }
        if (res && res.ok && res.url) {
          _uploaded += 1;
          const { src, uploadState, ...rest } = photo; // ref only — no base64 retained
          const swapped = Object.assign({}, rest, { url: res.url });
          // SEND-STATE-V1: uploaded here, so the retry queue must not upload it again.
          try { dropFromPhotoRetryQueue(photo.id); } catch (e) {}
          if (input.kind === 'site') _sitePhotosOut[input.i] = swapped;
          else if (input.kind === 'zone' && _surveyZonesOut[input.zi]) _surveyZonesOut[input.zi].photos[input.pi] = swapped;
          debugLog('photo.upload.ok', { projectId, via: 'wrap-submit', ms: res.ms, url: res.url });
        } else {
          _failed += 1;
          try { if (projectId) addToPhotoRetryQueue(projectId, hydrated); } catch (e) {}
          debugLog('photo.upload.fail', { projectId, via: 'wrap-submit', error: res && res.error });
        }
        if (_totalToUpload > 0) setUploadStatus(`${_uploaded}/${_totalToUpload} uploaded`);
      };

      // Bounded worker pool — at most 3 photos hydrated / in flight at once,
      // never the whole survey's base64 at once (the §5.8 memory fix).
      let _cursor = 0;
      const _worker = async () => {
        while (_cursor < _allInputs.length) {
          const idx = _cursor++;
          try { await _processOne(_allInputs[idx]); } catch (e) {}
        }
      };
      // P2C: "Send without them" skips the upload step; the photos just failed
      // and were queued for retry then.
      if (!withoutUnsent) await Promise.all([_worker(), _worker(), _worker()]);
      // SEND-STATE-V1: the urls this send got go back on the stored photos
      // (and the draft), so they no longer show as waiting to upload and no
      // later send uploads them again. Each goes as the same lumenPhotoUploaded
      // event a background upload sends, so the App merges it by photo id into
      // the job as it is NOW (not the photos this send read when Send was
      // tapped), and a photo whose url already landed meanwhile keeps it.
      if (_uploaded > 0 && projectId) {
        _origSitePhotos.forEach((p, i) => {
          const o = _sitePhotosOut[i];
          if (!p || !p.id || p.url || !o || !o.url) return;
          try { window.dispatchEvent(new CustomEvent('lumenPhotoUploaded', { detail: { projectId, photoId: p.id, newUrl: o.url, keepExisting: true } })); } catch (e) {}
        });
      }

      // P2C: never drop a photo quietly. A photo that needed uploading and
      // still would not be kept (failed upload, or no copy on the device) stops
      // the send here, before anything is posted, and the wrap asks the
      // surveyor. Only "Send without them" goes on past this.
      const _unsent = wrapUploadShortfall(_origSitePhotos, _sitePhotosOut, _origSurveyZones, _surveyZonesOut, _needsUpload);
      const _unsentByArea = wrapLossByArea(_unsent);
      if (_unsent.length > 0 && !withoutUnsent) {
        debugLog('wrap.submit.unsent_photos', { projectId, count: _unsent.length, uploaded: _uploaded, failed: _failed });
        // Keep what did upload (this run's and any earlier run's) for the follow-up.
        const _knownNext = Object.assign({}, knownUrls || {}, wrapUploadedUrls(_origSitePhotos, _sitePhotosOut, _origSurveyZones, _surveyZonesOut, _needsUpload));
        setUploadShortfall({ total: _unsent.length, byArea: _unsentByArea, submitIntent, visitLabel, knownUrls: _knownNext });
        setUploadStatus(null);
        setSending(false);
        return;
      }

      // Per-zone cleanup — drop any photo that still holds base64
      // (upload failed) so raw data doesn't bleed into raw_json.
      _surveyZonesOut.forEach(z => {
        if (z && Array.isArray(z.photos)) {
          z.photos = z.photos.filter(p => p && (p.url || (p.src && !_isB64(p.src))));
        }
      });

      // Drop site photos that still hold base64 (upload failed); keep videos
      // (their src is a blob URL, not data:) and successfully uploaded URLs.
      const _sitePhotosForPayload = _sitePhotosOut.filter(p => {
        if (!p) return false;
        if (p.type === 'video') return true;
        if (p.url) return true;
        if (p.src && !_isB64(p.src)) return true;
        return false;
      });

      // Mirror the legacy handoff photo_meta shape so any consumer that reads
      // photo_meta (proposal_routes.py) finds the same fields it expects.
      const _photoMeta = _sitePhotosForPayload
        .filter(p => p.type !== 'video' && p.url)
        .map(p => ({ type: p.type || 'photo', zone: p.zone, ts: p.ts, label: p.label, note: p.note || '', url: p.url }));

      if (withoutUnsent) {
        if (_unsent.length > 0) setUploadStatus(`Sending without ${wrapPhotoWords(_unsent.length)}: ${wrapLossWords(_unsentByArea)}`);
      } else if (_totalToUpload > 0) {
        if (_uploaded === 0) {
          setUploadStatus('Photo upload offline — queued for retry');
        } else if (_failed === 0) {
          setUploadStatus('Photos uploaded');
        } else {
          setUploadStatus(`${_uploaded}/${_totalToUpload} uploaded — ${_failed} queued for retry`);
        }
      }
      debugLog('wrap.submit.summary', {
        projectId,
        totalUploadAttempted: _totalToUpload,
        uploaded: _uploaded,
        failed: _failed,
      });
      // ── /S105 photo sync ────────────────────────────────────────────

      // Persist wrap inputs immediately — these are user work and must survive
      // even if the portal POST fails and the write gets queued. Deliberately
      // DO NOT set surveyWrapCompletedAt or stage here; those are submission
      // markers that should only flip when the portal confirms receipt.
      if (projectId && onUpdateProject) {
        onUpdateProject(projectId, {
          surveyWrapNote: wrapNote,
          surveyWrapPhotos: wrapPhotos,
          scopeDriver, scopeTimeline, scopeBudget, scopeDecisionMaker, scopeAccessNotes, followUpDate,
        });
      }
      // S1b — read zone notes from survey_active, the store the workspace
      // writes SYNCHRONOUSLY on every note commit, rather than from the
      // activeProject prop that lags it. A note written moments before Send
      // was previously dropped from the payload non-deterministically, and a
      // re-send did not reliably recover it because the prop could still be
      // stale on the second attempt.
      const _zoneNotesForSend = (() => {
        let _sa = null;
        try { _sa = JSON.parse(localStorage.getItem('survey_active') || 'null'); } catch (e) { _sa = null; }
        const _resolved = resolveZoneNotesForPayload(_sa, activeProject);
        // §9 — an explicit empty draft map is a REAL state (the user deleted
        // every note), so it legitimately beats a prop that still holds them.
        // But it is also what a corrupted draft looks like, so say so loudly
        // rather than shipping a silently empty notes map. (reviewer note)
        try {
          const _propKeys = Object.keys((activeProject && activeProject.zoneNotes) || {}).length;
          if (_propKeys > 0 && Object.keys(_resolved).length === 0) {
            console.warn('[survey-wrap] survey_active reports ZERO zone notes while the project still holds ' + _propKeys + ' — sending empty, as the draft is authoritative.');
          }
        } catch (e) {}
        return _resolved;
      })();
      const surveyWrapPayload = {
        projectName: activeProject?.name,
        client: activeProject?.client,
        // B.2 Slice 1 — capture-time binding. The picked canonical
        // PRJ-XXXX, or EXPLICIT null when unchosen / "No project" —
        // unbound must be visibly deliberate on the wire (never omit).
        // queueWrite passes the payload verbatim, so a queued wrap
        // carries its project_id through retry unchanged.
        project_id: (() => {
          const _b = getProjectBinding(activeProject);
          return (_b && _b.project_id) ? _b.project_id : null;
        })(),
        // SEND-STATE-V1: uploadState is the phone's own flag, never the wire's
        // (a photo without it is passed through as the same object).
        surveyZones: wrapWireZones(_surveyZonesOut),
        sitePhotos: wrapWirePhotos(_sitePhotosForPayload),
        photo_meta: _photoMeta,
        zoneNotes: flattenZoneNotesForPayload(_zoneNotesForSend),
        // S4b — resolve each note's LOCAL audioRef to the PORTAL audio_url it
        // now has (see withAudioUrlsForPayload). The flat `zoneNotes` map above
        // is deliberately untouched: it is {container: joined-string} and can
        // carry nothing per note, which is exactly why the structured map
        // exists and why the URL rides here.
        zoneNotesStructured: withAudioUrlsForPayload(_zoneNotesForSend),
        // WRITE-UP-APP-V1: the report question's answers, when it was
        // answered (left out otherwise, as an older app leaves it out).
        ...(() => {
          let _vs = [];
          try { _vs = loadVoiceNotes(); } catch (e) { _vs = []; }
          const _rr = buildReportRequest(reportReqRef.current, _vs);
          return _rr ? { report_request: _rr } : {};
        })(),
        wrapNote,
        totalFixtures,
        totalExistingKw,
        completedAt: new Date().toISOString(),
        scope_driver: scopeDriver,
        scope_timeline: scopeTimeline,
        scope_budget: scopeBudget,
        scope_budget_value: scopeBudgetValue,
        scope_decision_maker: scopeDecisionMaker,
        scope_access_notes: scopeAccessNotes,
        follow_up_date: followUpDate,
        // S106 — only present when the user resolved a conflict via the
        // pre-submit modal. First-time submissions omit these fields and
        // the portal handler falls through to the default-insert branch.
        ...(submitIntent ? { submit_intent: submitIntent } : {}),
        ...(visitLabel   ? { visit_label:   visitLabel   } : {}),
        supplier_routing: (() => {
          const allSuppliers = getSuppliers();
          const routing = {};
          Object.entries(routingSelections).forEach(([type, ids]) => {
            if (ids && ids.length > 0) {
              routing[type] = ids.map(id => { const s = allSuppliers.find(sup => sup.id === id); return s ? s.name : ''; }).filter(Boolean);
            }
          });
          return routing;
        })(),
      };
      // COMPANION-FOLLOWUPS-V2 item 5: a line with no fitting type reaches the
      // portal as a bare "Fitting". Loud, not silent: a health report (kind
      // wrap.submit.untyped_lines). The send itself goes on exactly as before,
      // and nothing changes on screen.
      try {
        const _untyped = wrapUntypedLineCount(_surveyZonesOut);
        if (_untyped > 0) debugLog('wrap.submit.untyped_lines', { projectId, count: _untyped, total: _surveyZonesOut.length });
      } catch (e) {}
      // S95 D14 — surface routing outcome to user (routed types + unassigned types)
      const routingObj = surveyWrapPayload.supplier_routing || {};
      const routedTypes = Object.keys(routingObj).filter(t => (routingObj[t] || []).length > 0);
      const summary = {
        routedCount: routedTypes.length,
        perType: routedTypes.map(t => ({ type: t, suppliers: routingObj[t] })),
      };
      // P2C: what "Send without them" left out, for the sent panel to say.
      if (withoutUnsent && _unsent.length > 0) summary.photosLeftOut = { total: _unsent.length, byArea: _unsentByArea };
      // SEND-STATE-V1: the print of the job this survey was built from (the
      // same project and draft the payload read), carried by a queued copy so
      // the queue can tell when the job has moved on from it.
      const _printDraft = (() => { const d = _readDraft(); return d && d.projectId === projectId ? d : null; })();
      const _jobPrint = wrapJobPrint(activeProject, _printDraft);
      // SEND-STATE-V1: a queued or parked copy of this job is replaced by this
      // send. The same survey (wrapPayloadSame) goes as that copy, byte for
      // byte and under its client id; a different one under a fresh id. The
      // queue leaves the job alone while this send is in flight (_wrapDirect,
      // set at the start of the send).
      const _prior = projectId ? wrapCopyOf(activeProject) : null;
      const _postPayload = _prior && wrapPayloadSame(_prior.item.payload, surveyWrapPayload) ? _prior.item.payload : surveyWrapPayload;
      const _postCid = _prior ? (_postPayload === _prior.item.payload ? wrapClientId(_prior.item) : _genClientEventId()) : null;
      let mode = 'success';
      // SEND-TIMEOUT-V1 (#112 note 4): the post and the reading of its answer
      // get _WRAP_SEND_TIMEOUT_MS. With no answer by then the request is
      // cancelled and the send fails like any request that got no answer: the
      // survey is queued below (last_error 'timeout'), the job reads as
      // waiting, and this send ends, clearing its being-sent mark. An answer
      // after that is never read (_portalDeadline). Should the post have
      // landed all the same, the next try finds it on the portal by its
      // completedAt (wrapLandedRow) and sends nothing more.
      const _wrapDl = _portalDeadline(_WRAP_SEND_TIMEOUT_MS);
      try {
        const _wrapToken = localStorage.getItem('lumen_token');
        const wrapRes = await _wrapDl.within(fetch(`${PORTAL_URL}/api/survey-wrap`, {
          method: 'POST',
          headers: Object.assign({ 'Content-Type': 'application/json' }, _wrapToken ? { 'Authorization': `Bearer ${_wrapToken}` } : {}),
          body: JSON.stringify(_postPayload),
          signal: _wrapDl.signal,
        }));
        // Track C: a 401 ends the sign-in; the wrap is queued below (not ok).
        bearerRefused(wrapRes.status, _wrapToken, 'survey wrap');
        // S106 — 409 conflict resolution. The portal returns 409 with
        // a JSON body carrying { reason } in two cases:
        //   intent_required → prior non-superseded rows exist for this
        //     project but the wrap arrived without a submit_intent.
        //     Surface the modal so the user picks Update / New visit /
        //     Duplicate, then re-call sendToPortal with the right intent.
        //   duplicate       → user explicitly said this is a duplicate;
        //     portal didn't insert. Treat as success locally so the
        //     project is cleared from the in-progress UI.
        if (wrapRes.status === 409) {
          let _409 = {};
          try { _409 = await _wrapDl.within(wrapRes.json()); } catch (e) {}
          // SEND-TIMEOUT-V1: the survey the portal already holds for the job
          // is this very one (sent before, taken, the answer lost): taken.
          const _landed409 = _409 && _409.reason === 'intent_required' ? wrapLandedRow(_postPayload, _409.existing) : null;
          if (_landed409) {
            try { debugLog('wrap.submit.already_landed', { projectId, surveyId: _landed409.id || null, via: 'wrap_409' }); } catch (e) {}
            summary.surveyId = _landed409.id || null;
            // Fall through into the success-mode cleanup below.
          } else if (_409 && _409.reason === 'intent_required') {
            // SEND-TIMEOUT-V1 (#118 round 1): this post is a fresh build, but
            // one of the rows can be the job's queued copy (an earlier build,
            // perhaps with an Update or New visit intent, that landed although
            // no answer came). Checked against the copy too, before any
            // choice: unchanged since, the job is sent and nothing more goes;
            // changed since, the copy is delivered and dropped, and the choice
            // is for the job as it is now.
            if (_deliverLandedCopy(_prior, _409.existing) === 'same') {
              setSending(false);
              return;
            }
            try { debugLog('survey.conflict.detected', { projectId, count: (_409.existing||[]).length, via: 'wrap_409' }); } catch (e) {}
            setSending(false);
            _openChoice(_409.existing);
            return;
          } else if (_409 && _409.reason === 'duplicate') {
            try { debugLog('survey.duplicate.acknowledged', { projectId, existing_id: _409.existing_id }); } catch (e) {}
            // Treat as success — server kept its existing canonical
            // row, our submission was acknowledged as duplicate.
            summary.surveyId = _409.existing_id || null;
            // Fall through into the success-mode cleanup below.
          } else {
            throw new Error(`HTTP 409: ${(_409 && _409.error) || 'conflict'}`);
          }
        } else if (!wrapRes.ok) {
          throw new Error(`HTTP ${wrapRes.status}`);
        } else {
          const wrapData = await _wrapDl.within(wrapRes.json());
          console.log(`[Survey] Wrap sent to portal — survey_id: ${wrapData.survey_id}`);
          if (wrapData.survey_id) summary.surveyId = wrapData.survey_id;
          // B.2 — binding echo: what the portal ACTUALLY bound (post-
          // canonicalisation; may differ from what we sent if the id had
          // merged). sentProjectId lets the success state say honestly
          // when a picked id failed to bind.
          summary.bound = wrapData.bound === true;
          summary.boundProjectId = wrapData.bound_project_id || null;
          summary.sentProjectId = surveyWrapPayload.project_id || null;
        }
        // SEND-STATE-V1: this send replaced a queued copy and the portal took
        // it. Recorded as delivered (so no copy of it is ever sent again; the
        // replaced copy's id too, should its removal not stick), then every
        // queued or parked copy of the job goes, before the queue can look.
        if (_prior) {
          const _at = new Date().toISOString();
          _recordWrapDelivered({ client_id: _postCid, projectId, jobPrint: _jobPrint, queued_at: _prior.item.queued_at || null, at: _at, surveyId: summary.surveyId || null, bound: summary.bound === true, boundProjectId: summary.boundProjectId || null });
          const _oldCid = wrapClientId(_prior.item);
          if (_oldCid !== _postCid) _recordWrapDelivered({ client_id: _oldCid, at: _at, stub: true, superseded: true });
          dropWrapCopies(projectId, activeProject?.name, activeProject?.createdAt);
        }
      } catch(e) {
        console.error(`[Survey] Wrap failed: ${e.message || e}`);
        // SEND-STATE-V1: the queue entry names its job, why it is waiting, and
        // the print of the job it was built from, so every screen can say so
        // and the queue never sends it once the job has moved on. It replaces
        // the job's earlier copy. A phone too full to hold it says so too.
        // SEND-TIMEOUT-V1: a request cancelled at the deadline is 'timeout',
        // as the queue says it.
        const _lastErr = (e && e.name === 'AbortError') ? 'timeout' : ((e && e.message) || String(e));
        reportFault('send.direct_failed', { error: _lastErr });
        const _queuedOk = queueWrite('/api/survey-wrap', _postPayload, Object.assign({ projectId: projectId || null, last_error: _lastErr, jobPrint: _jobPrint, jobCreatedAt: activeProject?.createdAt || null }, _postCid ? { client_id: _postCid } : {}));
        if (!_queuedOk) {
          setUploadStatus(null);
          setSending(false);
          setSendError('full');
          return;
        }
        mode = 'queued';
      } finally {
        _wrapDl.done();
      }
      setSentMode(mode);
      setSentSummary(summary);
      setSending(false);
      // SEND-STATE-V1: only a send the portal took ends on the sent panel. A
      // queued one stays on Check and send, which says it is waiting and why.
      if (mode === 'success') setSent(true);
      // S95 D5 D22 (third attempt) — status writes are gated by POST success.
      // On queue (portal unreachable / error), the project stays in "live" on
      // Today so the user can see it's still pending sync. When the queued
      // retry eventually succeeds, the App marks it sent from the queue's
      // delivery record (SEND-STATE-V1), with these same fields.
      if (mode === 'success') {
        const submittedIso = new Date().toISOString();
        if (projectId && onUpdateProject) {
          // Follow-up fix 1: the canonical portal survey id (skill §11), and
          // B.2: the binding echo, what was actually bound. wrapSentFields is
          // the one shape the queue's delivery uses too. Beside it, the voice
          // notes this send left out (not transcribed yet, so not on the wire),
          // so the job reads as changed once one is transcribed. And the notes
          // the print was taken from, in this same update (wrapSentNotesField).
          onUpdateProject(projectId, Object.assign(wrapSentNotesField(_printDraft, activeProject), wrapSentFields(summary, submittedIso, _jobPrint), wrapUnsentNotesField(_zoneNotesForSend)));
        }
        // S135 — confirmed-successful submit: clear the draft via the single
        // forensic-logged path (never an unlogged removeItem).
        wrapSentAfter(projectId, summary.surveyId, submittedIso, { reason: 'wrap_submit_success' });
      } else {
        // Queued: user work is preserved on disk (survey_active kept, wrap
        // payload is queued for retry). Today card continues to show the
        // survey as "live" until the portal confirms.
        try {
          const tv = JSON.parse(localStorage.getItem('lumen_visits') || '[]');
          tv.forEach(v => { if (v.surveyId === projectId && v.status !== 'submitted') v.status = 'live'; });
          localStorage.setItem('lumen_visits', JSON.stringify(tv));
        } catch(e) {}
      }
      // S99 — shorten the post-submit nav delay from 1500ms to 250ms.
      // All four state writes above (onUpdateProject, lumen_visits flip,
      // survey_queue flip, clearActiveDraft of survey_active /
      // survey_inprogress) are synchronous and complete before the
      // timer is scheduled, so the SurveyLanding render sees a
      // fully-settled state when it mounts. The 250ms gives the user
      // a brief "Sent" confirmation flash without the long window
      // during which a phantom card could surface on a re-render.
      // P2C: when photos were left out, stay on the sent panel so the loss is
      // read, not flashed; its Done button moves on.
      if (mode === 'success' && !summary.photosLeftOut) setTimeout(() => onNav(10), 250);
    } catch(e) {
      console.error('[SurveyWrapScreen] sendToPortal crashed:', e);
      setSending(false);
      setSendError(true);
    } finally {
      // The send has ended (sent, queued, stopped or crashed): the queue may
      // look at the job again.
      _directKeys.forEach((k) => _wrapDirect.delete(k));
      if (_directKeys.length) _sendStateChanged();
    }
  };

  // P2C: the two answers to "photos didn't upload". Try again re-runs the send
  // with its upload step (and stops again if they still fail); Send without
  // them sends and says what was left out. Both carry the stopped send's
  // conflict answer, and `force` only skips the S105 base64 dialog, as before.
  const retryShortfall = (without) => {
    const s = uploadShortfall;
    if (!s) return;
    setUploadShortfall(null);
    setSendError(false);
    sendToPortal(true, s.submitIntent, s.visitLabel, !!without, s.knownUrls || null);
  };

  const labelStyle = { fontSize:10, fontWeight:t.font.lw700, color:t.colors.ink38, letterSpacing:t.font.ls07em, textTransform:'uppercase', marginBottom:8 };
  const glassCardStyle = { background:t.colors.glass, borderTop:`1px solid ${t.colors.glassBorderTop}`, borderLeft:`1px solid ${t.colors.ink06}`, borderRight:`1px solid ${t.colors.ink06}`, borderBottom:`1px solid ${t.colors.ink06}`, borderRadius:t.radius.card14, boxShadow:t.shadow.card };

  const CheckCircleSVG = ({ size = 10, color = t.colors.green }) => (
    <svg width={size} height={size} viewBox="0 0 10 10"><circle cx="5" cy="5" r="4.2" fill={`${color}33`}/><polyline points="2.5,5 4.2,7 7.5,3" stroke={color} strokeWidth="1.4" fill="none" strokeLinecap="round" strokeLinejoin="round"/></svg>
  );

  // STUDIO-LIT-PHONE-V1 item 7: Check and send with the switch on (#app/wrap).
  // Every part is the phone's own survey data and the same state the switch-off
  // wrap edits; the answers keep their stored values (they ride the payload as
  // scope_driver, scope_timeline, scope_budget), only the words shown differ.
  // Eva's read states facts the phone holds and nothing it does not ("a quote
  // within the hour" and "I've filled in the questions" are capabilities, left
  // out). One violet main action: Send.
  const drawLitWrap = () => {
    const S = STUDIO_TOKENS; const M = STUDIO_MEANING;
    // SEND-STATE-V1: waiting, failed or sent, the job offers no Send (and no
    // way back into editing it from here): the state and its action instead.
    const sendSt = readSendState(activeProject, { sending });
    const sendBlocked = sendStateBlocksSend(sendSt) && sendSt.state !== 'sending';
    const wrapAct = wrapActFor(sendSt);
    const head = (
      <>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', gap:10, minHeight:46 }}>
          <SvBack label="Areas" onClick={() => onNav(3)} />
          <SvSteps cur={2} />
        </div>
        <div>
          <h1 style={{ ...svH1(), fontSize:31, lineHeight:1.08 }}>Check and send</h1>
          <p style={{ margin:'6px 0 0', fontSize:16, color:S.muted }}>{activeProject?.name}</p>
        </div>
      </>
    );
    const wrapStyle = { display:'grid', gridTemplateColumns:'minmax(0,1fr)', gridAutoRows:'max-content', gap:12, padding:'4px 16px 12px' };
    if (sent) return <div style={wrapStyle}>{head}</div>;
    const allDone = totalZoneCount > 0 && wrapSummary.doneCount === totalZoneCount;
    const openNames = wrapSummary.zoneRows.filter(r => !r.done).map(r => r.zone);
    const evaRead = totalZoneCount === 0
      ? 'There are no areas in this survey yet. Add them on Areas before you send it.'
      : allDone
      ? 'That’s every area done. Send it when you’re ready.'
      : openNames.length > 0 && openNames.length <= 3
        ? `${svList(openNames)} ${openNames.length === 1 ? 'isn’t' : 'aren’t'} marked done yet. You can send it now or finish ${openNames.length === 1 ? 'it' : 'them'} first.`
        : `${openNames.length} areas aren’t marked done yet. You can send it now or finish them first.`;
    // The first note with text, from the store the send reads (survey_active,
    // then the project), through the send's own body reader: pending notes
    // never show, and the Site-wide key is named, never shown raw.
    const sentNotes = (() => {
      let sa = null;
      try { sa = JSON.parse(localStorage.getItem('survey_active') || 'null'); } catch (e) { sa = null; }
      return resolveZoneNotesForPayload(sa, activeProject);
    })();
    const firstNote = firstNoteForSummary(sentNotes);
    // P2C: the card, what is sent and what is unfinished, all from figures the
    // wrap already holds (wrapSummary, the fittings, photoCount, the same notes).
    const emTotal = wrapEmergencyCount(surveyZones);
    const barGroups = wrapBarGroups(wrapSummary.zoneRows);
    const barTotal = barGroups.reduce((s, g) => s + g.count, 0);
    // P2C: photos count only when certain to ship; ones still to upload are a
    // separate plain line (they ship only if the upload works).
    const photoFigures = wrapPhotoCounts(activeProject?.sitePhotos, surveyZones, needsIdbHydration);
    const sentRows = wrapSentRows(totalFixtures, photoFigures.certain, wrapNoteCounts(sentNotes).total);
    const pendingLine = wrapPendingLine(photoFigures.pending);
    const videoLine = wrapVideoLine(photoFigures.videos);
    const missing = wrapMissingRows(wrapSummary.zoneRows, totalZoneCount);
    const sec ={ display:'flex', flexDirection:'column', gap:10, paddingTop:12, borderTop:`1px solid ${S.hairline}` };
    const qLabel = { fontSize:14, fontWeight:700, color:S.ink };
    const field = { ...studioSurface.pressed(), borderRadius:S.button.radius, minHeight:48, padding:'10px 12px', boxSizing:'border-box', width:'100%', color:S.ink, fontFamily:'inherit', fontSize:16, outline:'none', resize:'none', lineHeight:1.45 };
    const opts = (values, words, isOn, onPick, label) => (
      <div role="group" aria-label={label} style={{ ...studioSurface.pressed(), borderRadius:12, padding:5, display:'grid', gridTemplateColumns:'1fr 1fr', gap:4 }}>
        {values.map((v, k) => {
          const on = isOn(v);
          return (
            <button key={v} aria-pressed={on} onClick={() => onPick(v)} style={{ minHeight:44, padding:'4px 6px', borderRadius:9, border:'none', fontFamily:'inherit', fontSize:14, lineHeight:1.2, cursor:'pointer', color: on ? S.ink : S.muted, fontWeight: on ? 700 : 400, ...(on ? { ...studioSurface.slip(), boxShadow:`-3px 5px 10px -6px ${studioInk(0.45)}` } : { background:'transparent', boxShadow:'none' }) }}>{words[k]}</button>
          );
        })}
      </div>
    );
    const followWords = (() => {
      if (!followUpDate) return '';
      const d = new Date(followUpDate + 'T00:00:00');
      return isNaN(d.getTime()) ? '' : d.toLocaleDateString('en-GB', { weekday:'long', day:'numeric', month:'long' });
    })();
    const pickFollow = (chip) => {
      const now = new Date();
      if (chip === 'This week') { const d = new Date(now); d.setDate(d.getDate() + (5 - d.getDay())); setFollowUpDate(d.toISOString().split('T')[0]); setFollowUpChip('This week'); }
      else if (chip === 'Next week') { const d = new Date(now); d.setDate(d.getDate() + (8 - d.getDay())); setFollowUpDate(d.toISOString().split('T')[0]); setFollowUpChip('Next week'); }
      else setFollowUpChip('pick');
    };
    // The phone's own energy figures (existing and LED wattage per fitting).
    const nowKw = parseFloat(totalExistingKw); const ledKw = parseFloat(totalLedKw);
    // Prices from: the fitting types, and who each is routed to.
    const typeRows = supplierTypeRows(surveyZones);
    const toggleRoute = (type, id) => setRoutingSelections(prev => { const cur = prev[type] || []; return { ...prev, [type]: cur.includes(id) ? cur.filter(x => x !== id) : [...cur, id] }; });
    // P0 tidy: the Send block, moved and otherwise untouched. It sat above
    // "Before you leave" (the questions), so the Send button came first and the
    // questions after it. Same elements, conditions and handlers as when it sat
    // there (SEND-STATE-V1), drawn last: after the questions and the supplier
    // routing, which both ride the send.
    const sendBlock = (
      <>
        {sendBlocked && !(uploadShortfall && !sending) ? (
          // SEND-STATE-V1: the state takes the Send button's place; its action
          // (Try again: build it again from the job as it is now) is the one
          // violet action. Right after this screen's own send was refused it
          // reads out at once.
          <SvSendState st={sendSt} onAct={tryQueuedSend} act={wrapAct} note={tryMsg} alert={sentMode === 'queued' && sendSt.state === 'waiting' && sendSt.why === 'refused'}
            extra={sentSummary && sentSummary.photosLeftOut ? <p style={{ margin:0, fontSize:14, lineHeight:1.4, color:S.ink }}>Going without {wrapPhotoWords(sentSummary.photosLeftOut.total)}: {wrapLossWords(sentSummary.photosLeftOut.byArea)}</p> : null} />
        ) : uploadShortfall && !sending ? (
          // P2C: the send stopped before posting because photos did not upload.
          // The choice takes the Send button's place, so Try again is still
          // the one violet action.
          <section role="alert" aria-label="Photos didn’t upload" style={{ ...studioSurface.slip(), boxShadow:`${S.shadow.slip}, inset 0 0 0 2px ${studioRgba(M.rustFill, 0.55)}`, borderRadius:14, padding:'14px 16px', display:'flex', flexDirection:'column', gap:10 }}>
            <p style={{ margin:0, fontSize:16, fontWeight:700, color:M.rustText }}>{wrapPhotoWords(uploadShortfall.total)} didn’t upload</p>
            <p style={{ margin:0, fontSize:14, lineHeight:1.4, color:S.ink }}>{wrapLossWords(uploadShortfall.byArea)}. Nothing has been sent yet.</p>
            <button onClick={() => retryShortfall(false)} style={{ ...svMain(), width:'100%', minHeight:52, fontSize:16, borderRadius:14 }}>Try again</button>
            <button onClick={() => retryShortfall(true)} style={{ ...svLink(), alignSelf:'center', minHeight:44 }}>Send without them</button>
          </section>
        ) : (
          <>
            {/* SEND-STATE-V1: a sent job says when it went, and can still be
                sent again through the S106 choice, exactly as before. */}
            {!sending && (sendSt.state === 'sent' || sendSt.earlier) ? <SvSendState st={sendSt} /> : null}
            <button onClick={() => { setSendError(false); sendToPortal(); }} disabled={sending} style={{ ...svMain(), width:'100%', minHeight:56, fontSize:16, borderRadius:14, opacity: sending ? 0.7 : 1 }}>{sending ? (uploadStatus || 'Sending') : `Send ${activeProject?.name || 'the survey'}`}</button>
          </>
        )}
        {!sendBlocked && !sending && !sendError && !uploadShortfall && sendSt.state === 'not_sent' && !sendSt.earlier ? <p data-send-state="not_sent" style={{ margin:0, fontSize:14, lineHeight:1.4, color:S.muted }}>{sendStateWords(sendSt).line}</p> : null}
        {sendError && <p role="alert" style={{ margin:0, fontSize:14, fontWeight:600, color:M.rustText }}>{sendError === 'full' ? 'It didn’t send, and this phone is too full to keep a copy to send later. Your survey is still here. Free some space, then send it again.' : 'It didn’t send. Check your connection and try again.'}</p>}
      </>
    );
    return (
      <div style={wrapStyle}>
        {head}
        <SvEva read={evaRead} act={wrapRecording ? 'Stop recording' : 'Record first impressions'} onAct={handleWrapRecord} when={svWhen(activeProject?.updatedAt)} />
        {wrapVoiceMsg ? <p role="status" style={{ margin:0, fontSize:14, color:M.rustText }}>{wrapVoiceMsg}</p> : null}
        {reportRow}
        <section aria-label="Fittings by area" style={{ ...studioSurface.lit(), borderRadius:S.radius.card, padding:'16px 18px' }}>
          <p style={{ margin:0, display:'flex', alignItems:'baseline', gap:10 }}>
            <span style={{ ...studioType.display(), fontSize:84, lineHeight:0.9 }}>{totalFixtures}</span>
            <span style={{ fontSize:16, lineHeight:1.35, color:S.muted }}>{totalFixtures === 1 ? 'fitting' : 'fittings'} across {svPlural(totalZoneCount, 'area')}, {emTotal} emergency</span>
          </p>
          {barTotal > 0 ? (
            <div style={{ marginTop:14 }}>
              <div role="img" aria-label={barGroups.map(g => g.names.map((n, k) => `${n} ${g.parts[k]}`).join(', ')).join(', ')} style={{ display:'flex', gap:3, height:14 }}>
                {barGroups.map(g => g.parts.map((c, k) => <i key={g.names[k]} style={{ display:'block', flex:c, minWidth:2, borderRadius:3, background:WRAP_BAR_FILL }} />))}
              </div>
              <div style={{ display:'flex', gap:3, marginTop:6 }}>
                {barGroups.map(g => (
                  <span key={g.names.join('|')} style={{ flex:g.count, minWidth:0, display:'flex', flexDirection:'column', alignItems: g.tiny ? 'flex-end' : 'flex-start', fontSize:13, lineHeight:1.3 }}>
                    <span style={g.tiny ? { color:S.muted, whiteSpace:'nowrap' } : { color:S.muted, overflow:'hidden', textOverflow:'ellipsis' }}>{g.label}</span>
                    <b style={{ color:S.ink, fontVariantNumeric:'tabular-nums' }}>{g.count}</b>
                  </span>
                ))}
              </div>
            </div>
          ) : null}
          {nowKw > 0 ? (
            <div style={{ display:'flex', gap:28, marginTop:16 }}>
              <div><div style={{ fontSize:14, color:S.muted }}>Existing load</div><div style={{ fontSize:20, fontWeight:700, color:S.ink, marginTop:2, fontVariantNumeric:'tabular-nums' }}>{totalExistingKw} kW</div></div>
              <div><div style={{ fontSize:14, color:S.muted }}>LED load</div><div style={{ fontSize:20, fontWeight:700, color:S.ink, marginTop:2, fontVariantNumeric:'tabular-nums' }}>{totalLedKw} kW</div></div>
            </div>
          ) : null}
        </section>
        <section aria-label="What gets sent" style={{ display:'flex', flexDirection:'column', gap:6 }}>
          <h2 style={{ ...svH2(), marginBottom:4 }}>What gets sent</h2>
          {sentRows.length === 0 && !pendingLine && !videoLine ?<p style={{ margin:0, fontSize:16, color:S.muted }}>Nothing to send yet.</p> : null}
          {sentRows.map(r => (
            <div key={r.key} style={{ ...studioSurface.pressed(), borderRadius:14, display:'flex', alignItems:'center', gap:12, padding:'10px 14px', minHeight:44, boxSizing:'border-box' }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={M.wonText} strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ flexShrink:0 }}><path d="M5 12.5l4.5 4.5L19 7.5" /></svg>
              <span style={{ flex:1, minWidth:0, fontSize:16, fontWeight:600, color:S.ink }}>{r.what}</span>
              <span style={{ fontSize:16, color:S.ink, fontVariantNumeric:'tabular-nums' }}>{r.n}</span>
            </div>
          ))}
          {pendingLine ? <p data-wrap-pending="" style={{ margin:'2px 14px 0', fontSize:14, lineHeight:1.4, color:S.muted }}>{pendingLine}</p> : null}
          {videoLine ? <p data-wrap-videos="" style={{ margin:'2px 14px 0', fontSize:14, lineHeight:1.4, color:S.muted }}>{videoLine}</p> : null}
          {missing.map(m => (
            <div key={m.key} style={{ ...studioSurface.slip(), boxShadow:`${S.shadow.slip}, inset 0 0 0 2px ${studioRgba(M.rustFill, 0.55)}`, borderRadius:14, display:'flex', alignItems:'center', gap:12, padding:'8px 14px', minHeight:52, boxSizing:'border-box' }}>
              <span style={{ flex:1, minWidth:0, fontSize:16, fontWeight:600, color:M.rustText, overflowWrap:'anywhere' }}>{m.text}</span>
              <button onClick={() => onNav(3)} style={{ ...svLink(), alignSelf:'center', flexShrink:0 }}>{m.act}</button>
            </div>
          ))}
        </section>
        {/* P0 tidy: the Send block (sendBlock) now follows these questions and
            the supplier routing, so the surveyor answers before sending. */}
        <section aria-label="Before you leave" style={sec}>
          <h2 style={svH2()}>Before you leave</h2>
          <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
            <b style={qLabel}>What’s driving it</b>
            {opts(['Fault / end of life', 'Client experience', 'Energy reduction', 'Compliance'], ['Fault or end of life', 'Client experience', 'Energy reduction', 'Compliance'], v => scopeDriver.includes(v), v => toggleArrayItem(scopeDriver, setScopeDriver, v), 'What’s driving it')}
          </div>
          <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
            <b style={qLabel}>When it needs doing</b>
            {opts(['ASAP', 'This quarter', '6–12 months', 'No rush'], ['As soon as possible', 'This quarter', '6 to 12 months', 'No rush'], v => scopeTimeline.includes(v), v => toggleArrayItem(scopeTimeline, setScopeTimeline, v), 'When it needs doing')}
          </div>
          <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
            <b style={qLabel}>Budget</b>
            {opts(['Approved', 'Under review', 'Needs ROI first', 'No budget'], ['Approved', 'Under review', 'Needs ROI first', 'No budget yet'], v => scopeBudget.includes(v), v => setScopeBudget(scopeBudget.includes(v) ? [] : [v]), 'Budget')}
            <label style={{ position:'relative', display:'block' }}>
              <span aria-hidden="true" style={{ position:'absolute', left:12, top:'50%', transform:'translateY(-50%)', fontSize:16, fontWeight:700, color:M.ochre }}>£</span>
              <input type="number" inputMode="numeric" aria-label="Job value, if they said" value={scopeBudgetValue} onChange={e => setScopeBudgetValue(e.target.value)} placeholder="Job value, if they said" style={{ ...field, paddingLeft:28, color:M.ochre, fontWeight:700, fontVariantNumeric:'tabular-nums' }} />
            </label>
          </div>
          <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
            <b style={qLabel}>Who decides</b>
            <input aria-label="Who decides" value={scopeDecisionMaker} onChange={e => setScopeDecisionMaker(e.target.value)} placeholder="Name or role" style={field} />
          </div>
          <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
            <b style={qLabel}>Access</b>
            <textarea aria-label="Access" rows={2} value={scopeAccessNotes} onChange={e => setScopeAccessNotes(e.target.value)} placeholder="Heights, towers, hours" style={field} />
            {firstNote ? <p style={{ margin:0, fontSize:14, lineHeight:1.4, color:S.muted }}>{firstNote.siteWide ? 'Site-wide note' : 'Note'}: “{firstNote.text.length > 80 ? firstNote.text.slice(0, 80).trim() + '…' : firstNote.text}”</p> : null}
          </div>
          <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
            <b style={qLabel}>Follow up</b>
            {followWords ? <p style={{ margin:0, fontSize:16, color:S.ink }}>{followWords}</p> : null}
            {opts(['This week', 'Next week', 'pick'], ['This week', 'Next week', 'Pick a date'], v => followUpChip === v, pickFollow, 'Follow up')}
            {followUpChip === 'pick' && <input type="date" aria-label="Follow-up date" value={followUpDate} onChange={e => setFollowUpDate(e.target.value)} style={field} />}
          </div>
          <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
            <b style={qLabel}>First impressions</b>
            <textarea aria-label="First impressions" rows={3} value={wrapNote} onChange={e => setWrapNote(e.target.value)} placeholder="What you found, what they asked for" style={field} />
          </div>
        </section>

        {typeRows.length > 0 && (
          <section aria-label="Prices from" style={sec}>
            <h2 style={svH2()}>Prices from</h2>
            {typeRows.map(({ type, qty, category }, k) => {
              const avail = getSuppliersForType(category);
              const sel = routingSelections[type] || [];
              const names = sel.map(id => { const sp = getSuppliers().find(x => x.id === id); return sp ? sp.name : ''; }).filter(Boolean);
              return (
                <div key={type} style={{ display:'flex', flexDirection:'column', gap:6, padding:'8px 0', borderTop: k ? `1px solid ${S.hairline}` : 'none' }}>
                  <div style={{ display:'flex', justifyContent:'space-between', gap:12, fontSize:14, color:S.ink }}>
                    <span><b>{type}</b> {qty}</span>
                    <span style={{ textAlign:'right', color: names.length ? S.ink : S.muted }}>{names.length ? names.join(', ') : 'No supplier assigned yet'}</span>
                  </div>
                  {avail.length > 0 ? (
                    <div role="group" aria-label={`Send ${type} to`} style={{ display:'flex', flexWrap:'wrap', gap:6 }}>
                      {avail.map(sp => {
                        const on = sel.includes(sp.id);
                        return <button key={sp.id} aria-pressed={on} onClick={() => toggleRoute(type, sp.id)} style={{ ...(on ? studioSurface.pressed() : studioSurface.slip()), minHeight:44, padding:'0 12px', borderRadius:S.button.radius, fontFamily:'inherit', fontSize:14, fontWeight: on ? 700 : 400, color:S.ink, cursor:'pointer' }}>{sp.name}</button>;
                      })}
                    </div>
                  ) : (
                    <button onClick={() => setSupplierSheet({ category })} style={{ ...svLink(), fontSize:14 }}>Add a supplier for this type</button>
                  )}
                </div>
              );
            })}
          </section>
        )}
        {sendBlock}
      </div>
    );
  };

  const ScopeChip = ({ label, selected, onToggle }) => (
    <button onClick={onToggle} style={{
      background: selected ? t.colors.green13 : t.colors.paper85,
      border: selected ? `1.5px solid ${t.colors.green45}` : `1px solid ${t.colors.ink13}`,
      borderRadius:20, padding:'8px 16px', display:'flex', alignItems:'center', gap:5,
      cursor:'pointer', fontFamily:'inherit'
    }}>
      {selected && <svg width="10" height="10" viewBox="0 0 10 10"><polyline points="2,5 4.2,7.5 8,2.5" stroke={t.colors.green} strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round"/></svg>}
      <span style={{ fontSize:13, fontWeight: selected ? 700 : 500, color: selected ? t.colors.green : t.colors.ink6 }}>{label}</span>
    </button>
  );

  // WRITE-UP-APP-V1: the question, then the prompts, before Check and send.
  if (reportStage === 'ask' || reportStage === 'notes') {
    return studioShape(
      <div className="tab-clear" style={{ flex:1, overflowY:"auto", WebkitOverflowScrolling:"touch", overscrollBehavior:"contain", paddingBottom:100, background:t.colors.ground, display:"flex", flexDirection:"column" }}>
        <ReportWriteUp stage={reportStage} value={reportReq} projectName={activeProject?.name} projectId={activeProject?.id}
          onChoose={reportChoice} onChange={saveReportReq} onRecorded={reportRecorded} onTranscript={reportTranscript}
          onFinish={reportFinish} onBack={() => onNav(3)} onAsk={() => setReportStage('ask')} voiceTick={reportVoiceTick} />
      </div>
    );
  }
  // The report's line on Check and send, with a way back in while nothing
  // has gone.
  const reportCanChange = (() => { try { return readSendState(activeProject, { sending }).state === 'not_sent'; } catch (e) { return false; } })();
  const reportRow = reportAsked(reportReq) ? (
    <section aria-label="Report" style={{ ...studioSurface.lit(), borderRadius:STUDIO_TOKENS.radius.card, padding:'12px 16px', display:'flex', alignItems:'center', gap:10, flexWrap:'wrap' }}>
      <p style={{ margin:0, flex:'1 1 180px', fontSize:15, lineHeight:1.4, color:STUDIO_TOKENS.ink }}>{reportSummaryWords(reportReq)}</p>
      {reportCanChange ? (
        reportReq && reportReq.wanted === true
          ? <button onClick={() => setReportStage('notes')} style={{ ...svGhost(), minHeight:44 }}>Notes for the report</button>
          : <button onClick={() => setReportStage('ask')} style={{ ...svGhost(), minHeight:44 }}>Change</button>
      ) : null}
    </section>
  ) : null;

  return studioShape(
    <div style={{ flex:1, overflowY:"auto", WebkitOverflowScrolling:"touch", overscrollBehavior:"contain", paddingBottom:100, background:t.colors.ground, display:"flex", flexDirection:"column" }}>
      <input ref={photoRef} type="file" accept="image/*" capture="environment" style={{ display:"none" }}
        onChange={e=>{ if(e.target.files[0]) handleWrapPhoto(e.target.files[0]); e.target.value=""; }} />

      {/* Wrap header — green tinted (switch off; STUDIO-LIT-PHONE-V1 item 7
          draws the switch-on header inside the lit body below) */}
      {t.theme !== 'uv' && (
      <div style={{ background:t.colors.wrapHeaderBg, borderBottom:`1px solid ${t.colors.green16}`, padding:'12px 18px 10px', flexShrink:0 }}>
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:8 }}>
          <span onClick={() => onNav(3)} style={{ color:t.colors.goldInk, fontSize:15, fontWeight:600, cursor:'pointer' }}>{t.theme === 'uv' ? 'Back' : '← Back'}</span>
          <div style={{ display:'flex', alignItems:'center', gap:5 }}>
            <svg width="12" height="12" viewBox="0 0 12 12"><circle cx="6" cy="6" r="5.2" fill={t.colors.green22} stroke={t.colors.green} strokeWidth="1.1"/><polyline points="3,6 5.3,8.5 9.5,3.5" stroke={t.colors.green} strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round"/></svg>
            <span style={{ fontSize:13, fontWeight:700, color:t.colors.green }}>Check and send</span>
          </div>
          <div style={{ width:60 }} />
        </div>
        {/* Stage breadcrumb — Wrap active */}
        <div style={{ display:'flex', alignItems:'center', gap:6 }}>
          <span style={{ fontSize:11, color:t.colors.ink35, display:'flex', alignItems:'center', gap:3 }}>
            <CheckCircleSVG size={9} color={t.colors.green} /> Start
          </span>
          <span style={{ fontSize:10, color:t.colors.ink2 }}>›</span>
          <span style={{ fontSize:11, color:t.colors.ink35, display:'flex', alignItems:'center', gap:3 }}>
            <CheckCircleSVG size={9} color={t.colors.green} /> Survey
          </span>
          <span style={{ fontSize:10, color:t.colors.ink2 }}>›</span>
          <span style={{ fontSize:12, fontWeight:700, color:t.colors.green, display:'flex', alignItems:'center', gap:4 }}>
            <span style={{ width:7, height:7, borderRadius:'50%', background:t.colors.green, display:'inline-block' }} />
            Send
          </span>
          <div style={{ flex:1, height:1, background:t.colors.green15, marginLeft:4 }} />
          <span style={{ fontSize:11, color:t.colors.green65, fontWeight:600 }}>
            {wrapSummary.doneCount === totalZoneCount && totalZoneCount > 0
              ? `${totalZoneCount} ${totalZoneCount === 1 ? 'zone' : 'zones'} done`
              : wrapSummary.doneCount > 0
                ? `${wrapSummary.doneCount} of ${totalZoneCount} zones done`
                : `${totalZoneCount} ${totalZoneCount === 1 ? 'zone' : 'zones'}`}
          </span>
        </div>
      </div>

      )}

      {/* Single vertical scroll */}
      <div style={{ flex:1, overflowY:"auto", overscrollBehavior:"none", WebkitOverflowScrolling:"touch", paddingBottom:100 }}>

        {/* STUDIO-LIT-PHONE-V1 item 7: Check and send with the switch on. */}
        {t.theme === 'uv' && <SvLit draw={drawLitWrap} />}

        {t.theme !== 'uv' && (<>
        {/* ═══ SECTION 1: ARRIVAL ═══ */}
        {reportRow ? <div style={{ margin:'16px 18px 0' }}>{reportRow}</div> : null}

        {/* Hero summary card */}
        <div style={{ margin:'16px 18px 0', background:t.colors.wrapHeroBg, border:`1px solid ${t.colors.wrapHeroBorder}`, borderRadius:18, padding:'18px 18px 16px', boxShadow:t.shadow.card }}>
          <div style={{ fontFamily:t.font.serif, fontStyle:t.font.italic, fontSize:24, fontWeight:700, color:t.colors.text, lineHeight:1.2, marginBottom:4, ...uvx(() => ({ ...studioType.title(), fontSize:31, lineHeight:1.15 })) }}>
            {openAreasCount > 0 ? openAreasText : "Everything's in."}
          </div>
          <div style={{ fontSize:13, color:t.colors.ink5, marginBottom:14, lineHeight:1.5, ...uvx({ fontSize:16 }) }}>
            Don't leave the site without sending this.
          </div>
          {/* COMPANION-STUDIO-V1 track 2: the fixtures counted are the one big
              number here; the other three stay as a row beside it. */}
          {t.theme === 'uv' && (
            <div style={{ display:'flex', alignItems:'flex-end', gap:14, marginBottom:14 }}>
              <div style={{ ...studioType.display(), fontSize:84 }}>{totalFixtures}</div>
              <div style={{ paddingBottom:4, fontSize:16, color:STUDIO_TOKENS.ink }}>fixture{totalFixtures !== 1 ? 's' : ''}</div>
            </div>
          )}
          <div style={{ display:'flex', borderTop:`1px solid ${t.colors.green14}`, paddingTop:14 }}>
            {[
              { value: totalFixtures, label:'Fixtures', color:t.colors.green },
              { value: parseFloat(totalExistingKw) > 0 ? `${totalExistingKw}kW` : '—', label:'Existing', color:t.colors.teal },
              { value: reductionPct > 0 ? `${reductionPct}%` : '—', label:'Reduction', color:t.colors.statGold },
              { value: totalZoneCount, label:'Zones', color:t.colors.statPurple },
            ].filter((stat) => !(t.theme === 'uv' && stat.label === 'Fixtures')).map((stat, i, arr) => (
              <React.Fragment key={stat.label}>
                <div style={{ flex:1, textAlign:'center' }}>
                  <div style={{ fontFamily:t.font.serif, fontStyle:t.font.italic, fontSize:21, fontWeight:700, color:stat.color, fontVariantNumeric:t.font.tabular }}>{stat.value}</div>
                  <div style={{ fontSize:9, fontWeight:t.font.lw700, color:t.colors.ink38, marginTop:2, textTransform:'uppercase', letterSpacing:t.font.ls04em }}>{stat.label}</div>
                </div>
                {i < arr.length - 1 && <div style={{ width:1, background:t.colors.green14 }} />}
              </React.Fragment>
            ))}
          </div>
        </div>

        {/* Zone breakdown */}
        <div style={{ padding:'14px 18px 0' }}>
          <div style={labelStyle}>Zone breakdown</div>
          <div style={glassCardStyle}>
            {/* S160 — one row per zone from the canonical derivation: a done
                zone with photos and zero fittings stays listed at "0 fittings"
                rather than vanishing; the tick is honest (doneZones), not
                decoration. */}
            {/* S162 — ONE interleaved list (wrapBreakdownOrder): each zone header
                is immediately followed by its OWN fitting rows when expanded, so a
                fitting can never detach from its header and render under the wrong
                zone. The separator sits at the foot of each zone group. */}
            {wrapBreakdownOrder(wrapSummary.zoneRows, expandedZones).map((item, i, arr) => {
              const lastOfZone = i === arr.length - 1 || arr[i + 1].kind === 'header';
              const showBorder = lastOfZone && i < arr.length - 1;
              if (item.kind === 'fittings') {
                return (
                  <div key={item.zone+'-exp'} style={{ padding:'4px 14px 8px 36px', borderBottom: showBorder ? `1px solid ${t.colors.ink05}` : 'none' }}>
                    {item.types.map(type => (
                      <p key={type} style={{ fontSize:11, color:t.colors.ink5, padding:'2px 0' }}>• {type}</p>
                    ))}
                  </div>
                );
              }
              return (
                <button key={item.zone} onClick={() => item.types.length > 0 && setExpandedZones(prev => ({ ...prev, [item.zone]: !prev[item.zone] }))} style={{
                  display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%',
                  padding:'10px 14px', background:'none', border:'none',
                  borderBottom: showBorder ? `1px solid ${t.colors.ink05}` : 'none',
                  cursor: item.types.length > 0 ? 'pointer' : 'default', fontFamily:'inherit', textAlign:'left'
                }}>
                  <div style={{ display:'flex', alignItems:'center', gap:7 }}>
                    {item.done
                      ? <CheckCircleSVG />
                      : <svg width="10" height="10" viewBox="0 0 10 10" fill="none"><circle cx="5" cy="5" r="4" stroke={t.colors.ink25} strokeWidth="1.5"/></svg>}
                    <span style={{ fontSize:13, fontWeight:600, color:t.colors.text }}>{item.zone}</span>
                    <span style={{ fontSize:12, color:t.colors.ink38 }}>{item.count} fitting{item.count !== 1 ? 's' : ''}</span>
                  </div>
                  {item.types.length > 0 && (
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke={t.colors.ink35} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                      {expandedZones[item.zone] ? <polyline points="3,5 6,8 9,5"/> : <polyline points="3,4 6,7 9,4"/>}
                    </svg>
                  )}
                </button>
              );
            })}
          </div>
        </div>

        {/* First impressions */}
        <div style={{ padding:'14px 18px' }}>
          <div style={labelStyle}>First impressions</div>
          <div style={{ ...glassCardStyle, padding:'14px' }}>
            <button onClick={handleWrapRecord} style={{ display:'flex', alignItems:'center', gap:10, marginBottom:12, background:'none', border:'none', cursor:'pointer', fontFamily:'inherit', width:'100%', textAlign:'left' }}>
              <div style={{ width:36, height:36, borderRadius:'50%', background: wrapRecording ? t.colors.recBg : t.colors.ink07, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0, animation: wrapRecording ? (t.theme === 'uv' ? 'micpulseUv 1.5s ease-in-out infinite' : 'micpulse 1.5s ease-in-out infinite') : 'none' }}>
                <Icon name="mic" size={16} color={wrapRecording ? t.colors.onFill : t.colors.ink45} />
              </div>
              <div>
                <div style={{ fontSize:13, fontWeight:600, color: wrapRecording ? t.colors.recText : t.colors.text }}>{wrapRecording ? 'Recording…' : 'Record first impressions'}</div>
                <div style={{ fontSize:11, color:t.colors.ink42, marginTop:1 }}>Two minutes now saves an hour on Monday.</div>
              </div>
            </button>
            {wrapVoiceMsg ? (
              <div role="status" style={{ fontSize:12, color:t.colors.alertText, background:t.colors.alert11, borderRadius:8, padding:'8px 10px', marginBottom:10, lineHeight:1.4 }}>{wrapVoiceMsg}</div>
            ) : null}
            <textarea value={wrapNote} onChange={e => setWrapNote(e.target.value)}
              placeholder="Overall findings, access issues, recommendations…"
              style={{ width:'100%', background:t.colors.ink04, border:`1px solid ${t.colors.ink08}`, borderRadius:10, padding:'12px 14px', fontFamily:'inherit', fontSize:13, color:t.colors.text, resize:'none', minHeight:80, lineHeight:1.5, boxSizing:'border-box', outline:'none' }} />
          </div>
        </div>

        {/* ═══ SECTION 2: QUALIFY ═══ */}

        <div style={{ padding:'16px 18px 0' }}>
          <div style={{ fontSize:10, fontWeight:t.font.lw700, letterSpacing:t.font.ls08em, textTransform:'uppercase', color:t.colors.ink35, marginBottom:4 }}>BEFORE YOU LEAVE</div>
          <div style={{ fontFamily:t.font.serif, fontStyle:t.font.italic, fontSize:20, fontWeight:700, color:t.colors.ink7, marginBottom:18 }}>
            Qualify this opportunity.
          </div>

          {/* Q1 — Driver */}
          {(() => { const answered = scopeDriver.length > 0; return (
            <div style={{ marginBottom:16 }}>
              <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:10 }}>
                <div style={{ width:20, height:20, borderRadius:'50%', background: answered ? t.colors.green : t.colors.ink08, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                  {answered ? <svg width="10" height="10" viewBox="0 0 10 10"><polyline points="2,5 4.2,7.5 8,2.5" stroke={t.colors.onFill} strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round"/></svg> : <span style={{ fontSize:10, fontWeight:700, color:t.colors.ink3 }}>1</span>}
                </div>
                <span style={{ fontSize:13, fontWeight:600, color:t.colors.text }}>What's driving this?</span>
              </div>
              <div style={{ display:'flex', flexWrap:'wrap', gap:7 }}>
                {['Fault / end of life', 'Client experience', 'Energy reduction', 'Compliance'].map(opt => (
                  <button key={opt} onClick={() => toggleArrayItem(scopeDriver, setScopeDriver, opt)} style={{
                    fontSize:14, padding:'10px 16px', borderRadius:24, cursor:'pointer', fontFamily:'inherit', fontWeight: scopeDriver.includes(opt) ? 700 : 500,
                    background: scopeDriver.includes(opt) ? t.colors.green : t.colors.chipBg,
                    color: scopeDriver.includes(opt) ? t.colors.onFill : t.colors.ink6,
                    border: scopeDriver.includes(opt) ? `1.5px solid ${t.colors.green}` : `1.5px solid ${t.colors.ink14}`
                  }}>{opt}</button>
                ))}
              </div>
            </div>
          ); })()}

          <div style={{ height:1, background:t.colors.ink06, margin:'0 0 16px' }} />

          {/* Q2 — Timeline */}
          {(() => { const answered = scopeTimeline.length > 0; return (
            <div style={{ marginBottom:16 }}>
              <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:10 }}>
                <div style={{ width:20, height:20, borderRadius:'50%', background: answered ? t.colors.green : t.colors.ink08, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                  {answered ? <svg width="10" height="10" viewBox="0 0 10 10"><polyline points="2,5 4.2,7.5 8,2.5" stroke={t.colors.onFill} strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round"/></svg> : <span style={{ fontSize:10, fontWeight:700, color:t.colors.ink3 }}>2</span>}
                </div>
                <span style={{ fontSize:13, fontWeight:600, color:t.colors.text }}>When does it need to happen?</span>
              </div>
              <div style={{ display:'flex', flexWrap:'wrap', gap:7 }}>
                {['ASAP', 'This quarter', '6–12 months', 'No rush'].map(opt => (
                  <button key={opt} onClick={() => toggleArrayItem(scopeTimeline, setScopeTimeline, opt)} style={{
                    fontSize:14, padding:'10px 16px', borderRadius:24, cursor:'pointer', fontFamily:'inherit', fontWeight: scopeTimeline.includes(opt) ? 700 : 500,
                    background: scopeTimeline.includes(opt) ? t.colors.goldInk : t.colors.chipBg,
                    color: scopeTimeline.includes(opt) ? t.colors.onFill : t.colors.ink6,
                    border: scopeTimeline.includes(opt) ? `1.5px solid ${t.colors.goldInk}` : `1.5px solid ${t.colors.ink14}`
                  }}>{opt}</button>
                ))}
              </div>
            </div>
          ); })()}

          <div style={{ height:1, background:t.colors.ink06, margin:'0 0 16px' }} />

          {/* Q3 — Budget status */}
          {(() => { const answered = scopeBudget.length > 0; const budgetCards = [
            { label:'Approved', sub:'Budget confirmed', dot:t.colors.green, selBg:t.colors.green10, selBorder:t.colors.green },
            { label:'Under review', sub:'Awaiting sign-off', dot:t.colors.sevMedium, selBg:t.colors.gold10, selBorder:t.colors.goldInk },
            { label:'Needs ROI first', sub:'Business case required', dot:t.colors.sevMedium, selBg:t.colors.gold10, selBorder:t.colors.goldInk },
            { label:'No budget', sub:'Not yet allocated', dot:t.colors.budgetNoneDot, selBg:t.colors.budgetNoneSel, selBorder:t.colors.budgetNoneBorder }
          ]; return (
            <div style={{ marginBottom:16 }}>
              <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:10 }}>
                <div style={{ width:20, height:20, borderRadius:'50%', background: answered ? t.colors.green : t.colors.ink08, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                  {answered ? <svg width="10" height="10" viewBox="0 0 10 10"><polyline points="2,5 4.2,7.5 8,2.5" stroke={t.colors.onFill} strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round"/></svg> : <span style={{ fontSize:10, fontWeight:700, color:t.colors.ink3 }}>3</span>}
                </div>
                <span style={{ fontSize:13, fontWeight:600, color:t.colors.text }}>Budget status</span>
              </div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8, marginBottom:10 }}>
                {budgetCards.map(card => { const sel = scopeBudget.includes(card.label); return (
                  <button key={card.label} onClick={() => { setScopeBudget(sel ? [] : [card.label]); }} style={{
                    borderRadius:16, padding:'12px 14px', cursor:'pointer', fontFamily:'inherit', textAlign:'left',
                    background: sel ? card.selBg : t.colors.fieldBg,
                    border: sel ? `1.5px solid ${card.selBorder}` : `1.5px solid ${t.colors.ink08}`
                  }}>
                    <div style={{ display:'flex', alignItems:'center', gap:6, marginBottom:3 }}>
                      <div style={{ width:8, height:8, borderRadius:'50%', background: card.dot, flexShrink:0 }} />
                      <span style={{ fontSize:13, fontWeight:700, color: sel ? card.selBorder : t.colors.text }}>{card.label}</span>
                    </div>
                    <div style={{ fontSize:11, color:t.colors.ink42, paddingLeft:14 }}>{card.sub}</div>
                  </button>
                ); })}
              </div>
              <div style={{ position:'relative' }}>
                <span style={{ position:'absolute', left:14, top:'50%', transform:'translateY(-50%)', fontSize:16, fontWeight:700, color:t.colors.moneySign }}>£</span>
                <input type="number" value={scopeBudgetValue} onChange={e => setScopeBudgetValue(e.target.value)}
                  placeholder="Estimated job value…"
                  style={{ width:'100%', background:t.colors.fieldBg, border:`1.5px solid ${t.colors.ink08}`, borderRadius:14, padding:'12px 14px 12px 30px', fontSize:16, fontWeight:700, color:t.colors.moneyInput, fontFamily:'inherit', boxSizing:'border-box', outline:'none', fontStyle: scopeBudgetValue ? 'normal' : t.font.italic, fontVariantNumeric:t.font.tabular }} />
              </div>
            </div>
          ); })()}

          <div style={{ height:1, background:t.colors.ink06, margin:'0 0 16px' }} />

          {/* Q4 — Decision maker */}
          {(() => { const answered = scopeDecisionMaker.trim().length > 0; return (
            <div style={{ marginBottom:16 }}>
              <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:10 }}>
                <div style={{ width:20, height:20, borderRadius:'50%', background: answered ? t.colors.green : t.colors.ink08, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                  {answered ? <svg width="10" height="10" viewBox="0 0 10 10"><polyline points="2,5 4.2,7.5 8,2.5" stroke={t.colors.onFill} strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round"/></svg> : <span style={{ fontSize:10, fontWeight:700, color:t.colors.ink3 }}>4</span>}
                </div>
                <span style={{ fontSize:13, fontWeight:600, color:t.colors.text }}>Who's the decision maker?</span>
              </div>
              <input value={scopeDecisionMaker} onChange={e => setScopeDecisionMaker(e.target.value)}
                placeholder="Name or role…"
                style={{ width:'100%', background:t.colors.fieldBg, border:`1.5px solid ${t.colors.ink08}`, borderRadius:14, padding:'12px 14px', fontSize:13, color:t.colors.text, fontFamily:'inherit', boxSizing:'border-box', outline:'none', fontStyle: scopeDecisionMaker ? 'normal' : t.font.italic }} />
            </div>
          ); })()}

          <div style={{ height:1, background:t.colors.ink06, margin:'0 0 16px' }} />

          {/* Q5 — Access / site notes */}
          {(() => { const answered = scopeAccessNotes.trim().length > 0; return (
            <div style={{ marginBottom:16 }}>
              <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:10 }}>
                <div style={{ width:20, height:20, borderRadius:'50%', background: answered ? t.colors.green : t.colors.ink08, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                  {answered ? <svg width="10" height="10" viewBox="0 0 10 10"><polyline points="2,5 4.2,7.5 8,2.5" stroke={t.colors.onFill} strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round"/></svg> : <span style={{ fontSize:10, fontWeight:700, color:t.colors.ink3 }}>5</span>}
                </div>
                <span style={{ fontSize:13, fontWeight:600, color:t.colors.text }}>Access or site notes</span>
              </div>
              <textarea value={scopeAccessNotes} onChange={e => setScopeAccessNotes(e.target.value)}
                placeholder="Heights, access equipment, restrictions…"
                rows={3}
                style={{ width:'100%', background:t.colors.fieldBg, border:`1.5px solid ${t.colors.ink08}`, borderRadius:14, padding:'12px 14px', fontSize:13, color:t.colors.text, fontFamily:'inherit', resize:'none', lineHeight:1.5, boxSizing:'border-box', outline:'none', fontStyle: scopeAccessNotes ? 'normal' : t.font.italic }} />
            </div>
          ); })()}

          <div style={{ height:1, background:t.colors.ink06, margin:'0 0 16px' }} />

          {/* Q6 — Follow-up date */}
          {(() => { const answered = !!followUpDate; const handleChip = (chip) => {
            const now = new Date();
            if (chip === 'This week') { const d = new Date(now); d.setDate(d.getDate() + (5 - d.getDay())); setFollowUpDate(d.toISOString().split('T')[0]); setFollowUpChip('This week'); }
            else if (chip === 'Next week') { const d = new Date(now); d.setDate(d.getDate() + (8 - d.getDay())); setFollowUpDate(d.toISOString().split('T')[0]); setFollowUpChip('Next week'); }
            else { setFollowUpChip('pick'); }
          }; return (
            <div style={{ marginBottom:8 }}>
              <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:10 }}>
                <div style={{ width:20, height:20, borderRadius:'50%', background: answered ? t.colors.green : t.colors.ink08, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                  {answered ? <svg width="10" height="10" viewBox="0 0 10 10"><polyline points="2,5 4.2,7.5 8,2.5" stroke={t.colors.onFill} strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round"/></svg> : <span style={{ fontSize:10, fontWeight:700, color:t.colors.ink3 }}>6</span>}
                </div>
                <span style={{ fontSize:13, fontWeight:600, color:t.colors.text }}>Follow-up date</span>
              </div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:8, marginBottom: followUpChip === 'pick' ? 10 : 0 }}>
                {['This week', 'Next week', 'Pick date →'].map(chip => { const key = chip === 'Pick date →' ? 'pick' : chip; const sel = followUpChip === key; return (
                  <button key={chip} onClick={() => handleChip(chip === 'Pick date →' ? 'pick' : chip)} style={{
                    padding:'10px 8px', borderRadius:14, cursor:'pointer', fontFamily:'inherit', fontSize:13, fontWeight: sel ? 700 : 500,
                    background: sel ? t.colors.green12 : t.colors.chipBg,
                    color: sel ? t.colors.green : t.colors.ink5,
                    border: sel ? `1.5px solid ${t.colors.green}` : `1.5px solid ${t.colors.ink08}`,
                    textAlign:'center'
                  }}>{chip === 'Pick date →' ? 'Pick date' + studioArrow() : chip}</button>
                ); })}
              </div>
              {followUpChip === 'pick' && (
                <input type="date" value={followUpDate} onChange={e => setFollowUpDate(e.target.value)}
                  style={{ width:'100%', background:t.colors.fieldBg, border:`1.5px solid ${t.colors.ink08}`, borderRadius:14, padding:'12px 16px', fontSize:13, color: followUpDate ? t.colors.text : t.colors.ink3, fontFamily:'inherit', boxSizing:'border-box' }} />
              )}
            </div>
          ); })()}
        </div>

        {/* ═══ SECTION 3: SEND ═══ */}

        {/* Compact summary card */}
        <div style={{ margin:'16px 18px 0', background:t.colors.wrapSummaryBg, border:`1px solid ${t.colors.wrapSummaryBorder}`, borderRadius:t.radius.lg, padding:'14px 16px', marginBottom:12, boxShadow:t.shadow.card }}>
          <div style={{ display:'flex', alignItems:'flex-start', justifyContent:'space-between', marginBottom:12 }}>
            <div>
              <div style={{ fontFamily:t.font.serif, fontStyle:t.font.italic, fontSize:18, fontWeight:700, color:t.colors.text }}>
                {activeProject?.name}
              </div>
              <div style={{ fontSize:12, color:t.colors.ink45, marginTop:2 }}>
                {dateStr}{studioSep()}{totalZoneCount} zone{totalZoneCount !== 1 ? 's' : ''}{studioSep()}{totalFixtures} fitting{totalFixtures !== 1 ? 's' : ''}
              </div>
            </div>
            <div style={{ display:'flex', alignItems:'center', gap:4, background:t.colors.readyPillBg, borderRadius:20, padding:'4px 10px' }}>
              <svg width="10" height="10" viewBox="0 0 10 10"><polyline points="2,5 4.2,7.5 8,2.5" stroke={t.colors.green} strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round"/></svg>
              <span style={{ fontSize:11, fontWeight:700, color:t.colors.green }}>{openAreasCount > 0 ? openAreasText : 'Ready'}</span>
            </div>
          </div>
          <div style={{ display:'flex', borderTop:`1px solid ${t.colors.green12}`, paddingTop:10 }}>
            {[
              { value: totalFixtures, label:'Fixtures', color:t.colors.green },
              { value: parseFloat(totalExistingKw) > 0 ? `${totalExistingKw}kW` : '—', label:'Existing', color:t.colors.teal },
              { value: reductionPct > 0 ? `${reductionPct}%` : '—', label:'Reduction', color:t.colors.statGold },
              { value: totalZoneCount, label:'Zones', color:t.colors.statPurple },
            ].map((stat, i, arr) => (
              <React.Fragment key={stat.label}>
                <div style={{ flex:1, textAlign:'center' }}>
                  <div style={{ fontSize:15, fontWeight:700, color:stat.color, fontFamily:t.font.serif, fontStyle:t.font.italic, fontVariantNumeric:t.font.tabular }}>{stat.value}</div>
                  <div style={{ fontSize:9, color:t.colors.ink38, textTransform:'uppercase', letterSpacing:t.font.ls04em, marginTop:1, fontWeight:t.font.labelW }}>{stat.label}</div>
                </div>
                {i < arr.length - 1 && <div style={{ width:1, background:t.colors.green12 }} />}
              </React.Fragment>
            ))}
          </div>
        </div>

        {/* STUDIO-LIT-PHONE-V1 item 7, Andrew's decision 6 (6 October 2026):
            the hard-coded "68% win rate" card ("Your fastest-converting
            opportunity type") is removed for everyone, switch off too. No win
            rate by driver is signed (DATA-MAP); it is not to be rebuilt. */}

        {/* What's being sent — dynamic */}
        <div style={{ margin:'0 18px 14px' }}>
          <div style={labelStyle}>What's being sent</div>
          <div style={{ ...glassCardStyle, padding:'10px 14px' }}>
            {(() => {
              const videoCount = (activeProject?.sitePhotos || []).filter(p => p.type === 'video').length;
              // COMPANION-STUDIO-LIT-V1 track 2: the same store and body reader
              // the send uses (survey_active, then the prop), so the line shows
              // real note text, never "[object Object]".
              const _noteSrc = (() => {
                let _sa = null;
                try { _sa = JSON.parse(localStorage.getItem('survey_active') || 'null'); } catch (e) { _sa = null; }
                return resolveZoneNotesForPayload(_sa, activeProject);
              })();
              const firstNoteInfo = firstNoteForSummary(_noteSrc);
              const firstNote = firstNoteInfo ? firstNoteInfo.text : '';
              const voiceNotesCount = (() => { try { const vn = JSON.parse(localStorage.getItem('lumen_voice_notes') || '[]'); return vn.filter(n => n.projectId === activeProject?.id).length; } catch(e) { return 0; } })();
              const planPins = (activeProject?.plans || []).reduce((s, p) => s + ((p.pins || []).length), 0);
              const summaryLines = [];
              summaryLines.push(`${totalFixtures} fixture${totalFixtures !== 1 ? 's' : ''} across ${totalZoneCount} zone${totalZoneCount !== 1 ? 's' : ''}, ${uniqueTypes} fixture type${uniqueTypes !== 1 ? 's' : ''}`);
              if (photoCount > 0 || videoCount > 0) {
                const parts = [];
                if (photoCount > 0) parts.push(`${photoCount} photo${photoCount > 1 ? 's' : ''}`);
                if (videoCount > 0) parts.push(`${videoCount} video`);
                summaryLines.push(parts.join(' \u00b7 '));
              }
              if (voiceNotesCount > 0) summaryLines.push(`${voiceNotesCount} voice note${voiceNotesCount !== 1 ? 's' : ''}`);
              if (firstNote) summaryLines.push(`${firstNoteInfo.siteWide ? 'Site-wide note' : 'Note'}: "${firstNote.length > 60 ? firstNote.slice(0, 60) + '...' : firstNote}"`);
              if (planPins > 0) summaryLines.push(`${planPins} plan pin${planPins !== 1 ? 's' : ''}`);
              if (parseFloat(totalExistingKw) > 0) summaryLines.push(`Energy: ${totalExistingKw}kW → ${totalLedKw}kW \u00b7 ${reductionPct}% reduction`);
              return summaryLines.map((item, i, arr) => (
                <div key={i} style={{ display:'flex', alignItems:'center', gap:8, paddingBottom: i < arr.length - 1 ? 8 : 0, borderBottom: i < arr.length - 1 ? `1px solid ${t.colors.ink04}` : 'none', paddingTop: i > 0 ? 8 : 0 }}>
                  <CheckCircleSVG size={10} color={t.colors.green} />
                  <span style={{ fontSize:12, color:t.colors.ink6 }}>{item}</span>
                </div>
              ));
            })()}
          </div>
        </div>

        {/* ═══ ROUTE TO SUPPLIERS ═══ */}
        {(() => {
          const fixtureRows = supplierTypeRows(surveyZones);
          if (fixtureRows.length === 0) return null;

          const toggleRouting = (type, supplierId) => {
            setRoutingSelections(prev => {
              const current = prev[type] || [];
              const updated = current.includes(supplierId) ? current.filter(id => id !== supplierId) : [...current, supplierId];
              return { ...prev, [type]: updated };
            });
          };

          return (
            <div style={{ margin:'0 18px 14px' }}>
              <div style={labelStyle}>Route to suppliers</div>
              <div style={{ ...glassCardStyle, padding:'10px 14px' }}>
                {fixtureRows.map((row, ri) => {
                  const available = getSuppliersForType(row.category);
                  const selected = routingSelections[row.type] || [];
                  const selectedNames = selected.map(id => { const s = getSuppliers().find(sup => sup.id === id); return s ? s.name : ''; }).filter(Boolean);
                  return (
                    <div key={row.type}>
                      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:6, marginTop: ri > 0 ? 10 : 0 }}>
                        <span style={{ fontSize:13, fontWeight:700, color:t.colors.inkWarm }}>{row.type}</span>
                        <span style={{ fontFamily:t.font.serif, fontStyle:t.font.italic, fontSize:12, fontWeight:700, color:t.colors.green, background:t.colors.green1, borderRadius:10, padding:'2px 8px' }}>{row.qty}</span>
                      </div>
                      <div style={{ display:'flex', flexWrap:'wrap', gap:6, marginBottom:4 }}>
                        {available.length > 0 ? available.map(sup => {
                          const sel = selected.includes(sup.id);
                          return (
                            <button key={sup.id} onClick={() => toggleRouting(row.type, sup.id)} style={{
                              padding:'6px 12px', borderRadius:16, cursor:'pointer', fontFamily:'inherit', fontSize:12, fontWeight:600,
                              background: sel ? t.colors.green : t.colors.paper85,
                              color: sel ? t.colors.onFill : t.colors.supplierText,
                              border: sel ? `1.5px solid ${t.colors.green}` : `1px solid ${t.colors.stone1}`,
                              transition:'all 0.15s ease',
                            }}>{sup.name}</button>
                          );
                        }) : (
                          <button onClick={() => setSupplierSheet({ category: row.category })} style={{
                            padding:'6px 12px', borderRadius:16, cursor:'pointer', fontFamily:'inherit', fontSize:12, fontWeight:500,
                            background:t.colors.paper85, color:t.colors.stone35, border:`1px solid ${t.colors.stone08}`,
                            fontStyle:t.font.italic,
                          }}>Add a supplier for this type</button>
                        )}
                      </div>
                      <div style={{ fontSize:11, marginBottom: ri < fixtureRows.length - 1 ? 0 : 0 }}>
                        {available.length === 0 ? (
                          <span style={{ fontStyle:t.font.italic, color:t.colors.stone35 }}>No suppliers saved for this type</span>
                        ) : selectedNames.length === 0 ? (
                          <span style={{ fontStyle:t.font.italic, color:t.colors.stone35 }}>No supplier assigned yet</span>
                        ) : (
                          <span style={{ fontWeight:700, color:t.colors.green }}>Routed to: {selectedNames.join(' · ')}</span>
                        )}
                      </div>
                      {ri < fixtureRows.length - 1 && <div style={{ height:1, background:t.colors.ink06, marginTop:10 }} />}
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })()}
        </>)}

        {/* Send error */}
        {sendError && t.theme !== 'uv' && (
          <div style={{ margin:'0 18px 10px', padding:12, background:t.colors.alert08, border:`1px solid ${t.colors.alert22}`, borderRadius:12, textAlign:'center' }}>
            <p style={{ fontSize:13, fontWeight:700, color:t.colors.alert }}>{sendError === 'full' ? 'It didn’t send, and this phone is too full to keep a copy to send later. Your survey is still here. Free some space, then send it again.' : 'Failed to send — check your connection and try again'}</p>
          </div>
        )}

        {/* S106 — survey conflict modal. Renders when
            /api/companion/survey-conflict reports prior non-superseded
            rows for this project. Three branches:
              choose            → Update existing | New visit | Duplicate — discard
              name_visit        → text input for visit_label, default = "Survey N — DD MMM"
              confirm_duplicate → "Discard this submission?" confirmation step
        */}
        {supplierSheet && <SupplierAddSheet category={supplierSheet.category} onClose={() => setSupplierSheet(null)} onAdded={supplierAdded} />}
        {conflictModal && (() => {
          const fmtExisting = (e) => {
            const d = e.submitted_at ? new Date(e.submitted_at) : null;
            const dateStr = d && !isNaN(d.getTime())
              ? d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' })
              : '—';
            const label = (e.visit_label || `Survey #${e.id}`);
            const meta = `${e.zone_count || 0} zone${e.zone_count === 1 ? '' : 's'}, ${e.fixture_count || 0} fixture${e.fixture_count === 1 ? '' : 's'}`;
            return { dateStr, label, meta };
          };
          const defaultNewVisitLabel = (() => {
            const n = (conflictModal.existing || []).length + 1;
            const today = new Date();
            const dStr = today.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
            return `Survey ${n} — ${dStr}`;
          })();
          if (conflictModal.step === 'choose') {
            return (
              <SheetPortal>
              <div onClick={(e) => { if (e.target === e.currentTarget) setConflictModal(null); }}
                style={{ position:'fixed', inset:0, background:t.colors.scrim55, zIndex:9998, display:'flex', alignItems:'center', justifyContent:'center', padding:24 }}>
                <div style={{ background:t.colors.creamCard, borderRadius:18, padding:'22px 22px 18px', maxWidth:380, width:'100%', boxShadow:t.shadow.modal }}>
                  <div style={{ fontFamily:t.font.serif, fontStyle:t.font.italic, fontSize:18, color:t.colors.text, marginBottom:6 }}>
                    This project already has surveys submitted.
                  </div>
                  <div style={{ fontSize:11, fontWeight:t.font.lw700, textTransform:'uppercase', letterSpacing:t.font.ls06, color:t.colors.ink45, marginTop:14, marginBottom:6 }}>Existing</div>
                  <div style={{ marginBottom:14, borderTop:`1px solid ${t.colors.ink08}` }}>
                    {(conflictModal.existing || []).map((ex, i) => {
                      const f = fmtExisting(ex);
                      return (
                        <div key={ex.id || i} style={{ padding:'8px 0', borderBottom:`1px solid ${t.colors.ink06}`, display:'flex', alignItems:'baseline', gap:8 }}>
                          <span style={{ fontSize:13, color:t.colors.text, fontWeight:600 }}>{f.label}</span>
                          <span style={{ fontSize:11, color:t.colors.ink55 }}>· Submitted {f.dateStr}</span>
                          <span style={{ flex:1 }} />
                          <span style={{ fontSize:11, color:t.colors.ink45 }}>{f.meta}</span>
                        </div>
                      );
                    })}
                  </div>
                  <div style={{ fontSize:13, fontWeight:600, color:t.colors.text, marginBottom:10 }}>What's this submission?</div>
                  <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
                    <button onClick={() => { setConflictModal(null); sendToPortal(true, 'update', null); }}
                      style={{ width:'100%', padding:'12px 16px', borderRadius:10, background:t.colors.green, color:t.colors.creamOnFill, border:'none', fontSize:14, fontWeight:700, cursor:'pointer', fontFamily:'inherit' }}>
                      Update existing
                    </button>
                    <button onClick={() => { setConflictModal(prev => ({ ...prev, step: 'name_visit', visitLabel: defaultNewVisitLabel })); }}
                      style={{ width:'100%', padding:'12px 16px', borderRadius:10, background:t.colors.green08, color:t.colors.green, border:`1px solid ${t.colors.green32}`, fontSize:14, fontWeight:700, cursor:'pointer', fontFamily:'inherit' }}>
                      New visit
                    </button>
                    <button onClick={() => { setConflictModal(prev => ({ ...prev, step: 'confirm_duplicate' })); }}
                      style={{ width:'100%', padding:'12px 16px', borderRadius:10, background:'transparent', color:t.colors.discardChoice, border:`1px solid ${t.colors.discardChoiceBorder}`, fontSize:14, fontWeight:600, cursor:'pointer', fontFamily:'inherit' }}>
                      Duplicate — discard
                    </button>
                  </div>
                  <button onClick={() => setConflictModal(null)}
                    style={{ width:'100%', padding:'8px 0 0', background:'none', color:t.colors.ink4, border:'none', fontSize:12, cursor:'pointer', fontFamily:'inherit', marginTop:8 }}>
                    Cancel
                  </button>
                </div>
              </div>
              </SheetPortal>
            );
          }
          if (conflictModal.step === 'name_visit') {
            return (
              <SheetPortal>
              <div onClick={(e) => { if (e.target === e.currentTarget) setConflictModal(prev => ({ ...prev, step: 'choose' })); }}
                style={{ position:'fixed', inset:0, background:t.colors.scrim55, zIndex:9998, display:'flex', alignItems:'center', justifyContent:'center', padding:24 }}>
                <div style={{ background:t.colors.creamCard, borderRadius:18, padding:'22px 22px 18px', maxWidth:360, width:'100%', boxShadow:t.shadow.modal }}>
                  <div style={{ fontFamily:t.font.serif, fontStyle:t.font.italic, fontSize:18, color:t.colors.text, marginBottom:6 }}>
                    Name this visit
                  </div>
                  <div style={{ fontSize:13, color:t.colors.ink62, lineHeight:1.45, marginBottom:14 }}>
                    Helps you tell visits apart on the project hub later. "Phase 2", "Reception only", whatever fits.
                  </div>
                  <input type="text" value={conflictModal.visitLabel || ''}
                    onChange={(e) => setConflictModal(prev => ({ ...prev, visitLabel: e.target.value }))}
                    autoFocus maxLength={100}
                    style={{ width:'100%', boxSizing:'border-box', padding:'10px 12px', borderRadius:10, border:`1px solid ${t.colors.ink2}`, background:t.colors.inputWhite, fontSize:14, fontFamily:'inherit', marginBottom:14 }} />
                  <div style={{ display:'flex', gap:10 }}>
                    <button onClick={() => setConflictModal(prev => ({ ...prev, step: 'choose' }))}
                      style={{ flex:1, padding:'12px 16px', borderRadius:10, background:'transparent', color:t.colors.brown, border:`1px solid ${t.colors.ink18}`, fontSize:14, fontWeight:600, cursor:'pointer', fontFamily:'inherit' }}>
                      Back
                    </button>
                    <button onClick={() => {
                        const lbl = (conflictModal.visitLabel || defaultNewVisitLabel || '').trim().slice(0, 100) || defaultNewVisitLabel;
                        setConflictModal(null);
                        sendToPortal(true, 'new_visit', lbl);
                      }}
                      style={{ flex:1, padding:'12px 16px', borderRadius:10, background:t.colors.green, color:t.colors.creamOnFill, border:'none', fontSize:14, fontWeight:700, cursor:'pointer', fontFamily:'inherit' }}>
                      Send →
                    </button>
                  </div>
                </div>
              </div>
              </SheetPortal>
            );
          }
          if (conflictModal.step === 'confirm_duplicate') {
            return (
              <SheetPortal>
              <div onClick={(e) => { if (e.target === e.currentTarget) setConflictModal(prev => ({ ...prev, step: 'choose' })); }}
                style={{ position:'fixed', inset:0, background:t.colors.scrim55, zIndex:9998, display:'flex', alignItems:'center', justifyContent:'center', padding:24 }}>
                <div style={{ background:t.colors.creamCard, borderRadius:18, padding:'22px 22px 18px', maxWidth:340, width:'100%', boxShadow:t.shadow.modal }}>
                  <div style={{ fontFamily:t.font.serif, fontStyle:t.font.italic, fontSize:18, color:t.colors.text, marginBottom:6 }}>
                    Discard this submission?
                  </div>
                  <div style={{ fontSize:13, color:t.colors.ink62, lineHeight:1.45, marginBottom:14 }}>
                    The portal already has this project's data. The current submission will be marked as a duplicate and discarded — nothing new gets sent.
                  </div>
                  <div style={{ display:'flex', gap:10 }}>
                    <button onClick={() => setConflictModal(prev => ({ ...prev, step: 'choose' }))}
                      style={{ flex:1, padding:'12px 16px', borderRadius:10, background:'transparent', color:t.colors.brown, border:`1px solid ${t.colors.ink18}`, fontSize:14, fontWeight:600, cursor:'pointer', fontFamily:'inherit' }}>
                      Back
                    </button>
                    <button onClick={() => { setConflictModal(null); sendToPortal(true, 'duplicate', null); }}
                      style={{ flex:1, padding:'12px 16px', borderRadius:10, background:t.colors.discardBtn, color:t.colors.discardText, border:'none', fontSize:14, fontWeight:700, cursor:'pointer', fontFamily:'inherit' }}>
                      Discard
                    </button>
                  </div>
                </div>
              </div>
              </SheetPortal>
            );
          }
          return null;
        })()}

        {/* S105 — pre-submit pending-photos dialog. Renders only when
            sendToPortal() detects base64 / uploadFailed photos in the
            project. "Wait" forces a flush of the retry queue with live
            progress; "Send anyway" calls sendToPortal(true) to bypass
            the guard. */}
        {pendingPhotoWarn && (
          <SheetPortal>
          <div onClick={(e) => { if (e.target === e.currentTarget) setPendingPhotoWarn(null); }}
            style={{ position:'fixed', inset:0, background:t.colors.scrim55, zIndex:9998, display:'flex', alignItems:'center', justifyContent:'center', padding:24 }}>
            <div style={{ background:t.colors.creamCard, borderRadius:18, padding:'22px 22px 18px', maxWidth:340, width:'100%', boxShadow:t.shadow.modal }}>
              <div style={{ fontFamily:t.font.serif, fontStyle:t.font.italic, fontSize:18, color:t.colors.text, marginBottom:6 }}>
                {pendingPhotoWarn.count} photo{pendingPhotoWarn.count === 1 ? '' : 's'} not yet uploaded
              </div>
              <div style={{ fontSize:13, color:t.colors.ink62, lineHeight:1.45, marginBottom:14 }}>
                {waitFlushProgress
                  ? `Retrying… ${waitFlushProgress.ok}/${waitFlushProgress.attempted} succeeded`
                  : 'They will retry in the background, but you can wait for the queue to flush before sending.'}
              </div>
              <div style={{ display:'flex', gap:10 }}>
                <button onClick={async () => {
                    setWaitFlushProgress({ attempted: pendingPhotoWarn.count, ok: 0, failed: 0 });
                    try { await flushPhotoRetryQueue(); } catch (e) {}
                    // After the flush, recount pending — surface a quick
                    // result and let the user re-press Send (or Send Anyway).
                    const stillPending = (activeProject?.sitePhotos || []).filter(_isPhotoPending).length;
                    setWaitFlushProgress({
                      attempted: pendingPhotoWarn.count,
                      ok: pendingPhotoWarn.count - stillPending,
                      failed: stillPending,
                    });
                    if (stillPending === 0) {
                      setPendingPhotoWarn(null);
                      sendToPortal(true);
                    } else {
                      setPendingPhotoWarn({ count: stillPending });
                    }
                  }} style={{ flex:1, padding:'12px 16px', borderRadius:10, background:t.colors.green, color:t.colors.onFill, border:'none', fontSize:14, fontWeight:700, cursor:'pointer', fontFamily:'inherit' }}>
                  Wait & retry
                </button>
                <button onClick={() => { setPendingPhotoWarn(null); sendToPortal(true); }}
                  style={{ flex:1, padding:'12px 16px', borderRadius:10, background:'transparent', color:t.colors.brown, border:`1px solid ${t.colors.ink18}`, fontSize:14, fontWeight:600, cursor:'pointer', fontFamily:'inherit' }}>
                  Send anyway
                </button>
              </div>
              <button onClick={() => setPendingPhotoWarn(null)}
                style={{ width:'100%', padding:'8px 0 0', background:'none', color:t.colors.ink4, border:'none', fontSize:12, cursor:'pointer', fontFamily:'inherit', marginTop:6 }}>
                Cancel
              </button>
            </div>
          </div>
          </SheetPortal>
        )}

        {/* P2C: the send stopped because photos didn't upload (switch off;
            switch on draws this in the lit body above). Old look, and drawn
            only while that choice is open, so the resting screen is as before. */}
        {uploadShortfall && !sending && t.theme !== 'uv' && (
          <SheetPortal>
          <div role="alertdialog" aria-label="Photos didn’t upload"
            style={{ position:'fixed', inset:0, background:t.colors.scrim55, zIndex:9998, display:'flex', alignItems:'center', justifyContent:'center', padding:24 }}>
            <div style={{ background:t.colors.creamCard, borderRadius:18, padding:'22px 22px 18px', maxWidth:340, width:'100%', boxShadow:t.shadow.modal }}>
              <div style={{ fontFamily:t.font.serif, fontStyle:t.font.italic, fontSize:18, color:t.colors.text, marginBottom:6 }}>
                {wrapPhotoWords(uploadShortfall.total)} didn’t upload
              </div>
              <div style={{ fontSize:13, color:t.colors.ink62, lineHeight:1.45, marginBottom:14 }}>
                {wrapLossWords(uploadShortfall.byArea)}. Nothing has been sent yet.
              </div>
              <div style={{ display:'flex', gap:10 }}>
                <button onClick={() => retryShortfall(false)} style={{ flex:1, padding:'12px 16px', borderRadius:10, background:t.colors.green, color:t.colors.onFill, border:'none', fontSize:14, fontWeight:700, cursor:'pointer', fontFamily:'inherit' }}>
                  Try again
                </button>
                <button onClick={() => retryShortfall(true)} style={{ flex:1, padding:'12px 16px', borderRadius:10, background:'transparent', color:t.colors.brown, border:`1px solid ${t.colors.ink18}`, fontSize:14, fontWeight:600, cursor:'pointer', fontFamily:'inherit' }}>
                  Send without them
                </button>
              </div>
            </div>
          </div>
          </SheetPortal>
        )}

        {/* Send button (switch on: in the lit body above). SEND-STATE-V1: with
            the switch off a job waiting, failed or sent shows the panel below
            in its place, never the Send button. */}
        {!sent && !offBlocked ? (t.theme === 'uv' ? null : (
          <div style={{ padding:'0 18px 36px' }}>
            <button onClick={() => { setSendError(false); sendToPortal(); }} disabled={sending}
              style={{ width:'100%', background:t.colors.green, color:t.colors.onFill, fontSize:15, fontWeight:'700', borderRadius:t.radius.wrapBtn, padding:'14px 24px', border:'none', textAlign:'center', marginTop:16, marginBottom:20, display:'flex', alignItems:'center', justifyContent:'center', gap:10, cursor: sending ? 'default' : 'pointer', opacity: sending ? 0.7 : 1, fontFamily:'inherit', ...uvx(() => ({ ...studioSurface.primary(), padding:'0 18px' })) }}>
              {t.theme !== 'uv' && <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M2 2 L16 9 L2 16 L5 9 Z" fill="white" opacity="0.9"/><line x1="5" y1="9" x2="16" y2="9" stroke="white" strokeWidth="1.5" strokeLinecap="round"/></svg>}
              <span style={{ color:'white', fontSize:17, fontWeight:700, letterSpacing:'0.02em', ...uvx({ fontSize:16, fontWeight:600 }) }}>{sending ? (uploadStatus || 'Sending…') : 'Send to portal'}</span>
            </button>
            <div style={{ textAlign:'center' }}>
              <span style={{ fontSize:11, color:t.colors.ink3 }}>{t.theme === 'uv' ? 'Survey ready, ' : 'Survey ready · '}{dateTimeStr}</span>
            </div>
          </div>
        )) : (sent || t.theme !== 'uv') ? (
          <div style={{ margin:'0 18px 28px' }}>
            {/* S95 D14 — surface send outcome + routing summary */}
            <div role={offQueued ? 'status' : undefined} style={{ padding:20, background: offQueued ? t.colors.gold10 : t.colors.green08, border: offQueued ? `1px solid ${t.colors.gold30}` : `1px solid ${t.colors.green22}`, borderRadius:14, textAlign:'center' }}>
              <p style={{ fontSize:18, fontWeight:800, color: offQueued ? t.colors.amberText : t.colors.green, marginBottom:4, display:"flex", alignItems:"center", justifyContent:"center", gap:6 }}>
                {offQueued ? (
                  <>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={t.colors.amberText} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg> {sendStateWords(sendStNow).title}
                  </>
                ) : (
                  <>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={t.colors.green} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg> Sent
                  </>
                )}
              </p>
              <p style={{ fontSize:12, color:t.colors.ink55 }}>
                {offQueued
                  ? sendStateWords(sendStNow).line
                  : sent ? `Survey data landed in ${activeProject?.name}${sentSummary?.surveyId ? ` · id ${sentSummary.surveyId}` : ''}` : sendStateWords(sendStNow).line}
              </p>
              {offQueued && wrapActFor(sendStNow) ? (
                <button onClick={tryQueuedSend} style={{ marginTop:10, minHeight:44, padding:'0 22px', borderRadius:10, background:t.colors.green, color:t.colors.onFill, border:'none', fontSize:15, fontWeight:700, cursor:'pointer', fontFamily:'inherit' }}>{wrapActFor(sendStNow)}</button>
              ) : null}
              {offQueued && tryMsg ? <p style={{ fontSize:12, color:t.colors.ink55, marginTop:8 }}>{tryMsg}</p> : null}
              {/* B.2 — binding echo via the shared BindingEchoLines (Slice 2
                  extraction — survey and snag success copy can't drift apart).
                  Queued mode has no echo yet, so neither line renders. */}
              <BindingEchoLines echo={sent && sentMode !== 'queued' && sentSummary ? { bound: sentSummary.bound, boundProjectId: sentSummary.boundProjectId, sentProjectId: sentSummary.sentProjectId } : null} />
              {/* P2C: only after "Send without them": what was left out, by area. */}
              {sentSummary && sentSummary.photosLeftOut ? (
                <>
                  <p role="status" style={{ fontSize:14, fontWeight:700, color:t.colors.text, marginTop:10, lineHeight:1.4 }}>
                    {sent ? 'Sent without' : 'Going without'} {wrapPhotoWords(sentSummary.photosLeftOut.total)}: {wrapLossWords(sentSummary.photosLeftOut.byArea)}
                  </p>
                  <button onClick={() => onNav(10)} style={{ marginTop:10, minHeight:44, padding:'0 22px', borderRadius:10, background:'transparent', color:t.colors.text, border:`1px solid ${t.colors.ink18}`, fontSize:15, fontWeight:600, cursor:'pointer', fontFamily:'inherit' }}>Done</button>
                </>
              ) : null}
            </div>
            {/* Routing outcome card */}
            {sentSummary && sentSummary.perType.length > 0 && (
              <div style={{ marginTop:12, padding:'14px 16px', background:t.colors.glass, border:`1px solid ${t.colors.ink08}`, borderRadius:12 }}>
                <div style={{ fontSize:10, fontWeight:t.font.lw800, color:t.colors.khaki, textTransform:'uppercase', letterSpacing:t.font.ls07, marginBottom:8 }}>Routed to suppliers</div>
                {sentSummary.perType.map(row => (
                  <div key={row.type} style={{ display:'flex', alignItems:'flex-start', gap:8, padding:'6px 0', borderTop:`0.5px solid ${t.colors.ink06}` }}>
                    <span style={{ fontSize:12, fontWeight:700, color:t.colors.text, flex:1 }}>{row.type}</span>
                    <span style={{ fontSize:12, color:t.colors.green, fontWeight:600, textAlign:'right' }}>{row.suppliers.join(' · ')}</span>
                  </div>
                ))}
              </div>
            )}
            {sentSummary && sentSummary.perType.length === 0 && (
              <div style={{ marginTop:12, padding:'12px 14px', background:t.colors.ink04, border:`1px solid ${t.colors.ink08}`, borderRadius:12, fontSize:11, color:t.colors.ink5, fontStyle:t.font.italic, textAlign:'center' }}>
                No suppliers routed — estimator will pick these up manually
              </div>
            )}
          </div>
        ) : null}

      </div>
      <TabBar active={11} onChange={onNav} divisionId={div && div.id ? div.id : "lighting"} />
    </div>
  );
};


// ════════════════════════════════════════════════════
// SCREENS 12–14: SNAGGING (S138 rebuild to snag_workspace_v3)
// ────────────────────────────────────────────────────
// A standalone snag job that can optionally link to a completed survey project
// and inherit its areas. Area-first list, photo-first flexible capture, a full
// close-out lifecycle (Open → In progress → Fixed → Verified) and a warm report
// routed by owner. Capture runs on the SHARED engine (savePhotoReliableCore +
// useBurstCamera + camZoneRef) — never a forked second path. Owners are generic
// and editable; no client name is ever hardcoded as an owner. The AI defect
// pass is deferred to the shared vision phase and is intentionally absent here.
// ════════════════════════════════════════════════════

const SNAG_STORE_KEY = 'lumen_snags';
const SNAG_KINDS = [
  { id: 'defect', label: 'Defect' },
  { id: 'safety', label: 'Safety' },
  { id: 'observation', label: 'Observation' },
];
// Soft, warm-toned severity scale — the only place red / amber / green appear.
const SNAG_SEV = {
  high: { label: 'High',   g1: '#F6E4DF', g2: '#EDCEC6', border: '#E1B4A8', solid: '#C0483B', text: '#7A271C', dot: '#C0483B' },
  med:  { label: 'Medium', g1: '#F7ECCF', g2: '#F0DFB2', border: '#E0C886', solid: '#C08820', text: '#7A5A12', dot: '#C08820' },
  low:  { label: 'Low',    g1: '#E1F0DB', g2: '#CFE6C5', border: '#B6D7AA', solid: '#5A9048', text: '#284820', dot: '#5A9048' },
};
// snag_workspace_v3 chrome tokens (token-for-token from the signed-off file).
// The snag system is sage-teal led with a gold warm accent and sky for the
// interactive add-links. Terracotta is NOT a snag UI colour — it is the snag
// PIN / type marker only, and lives elsewhere (the "Snag" tag on the landing).
const SNAG_TEAL      = '#4A6462';  // --st-deep — filters, chips, FAB, primary chrome
const SNAG_TEAL_SOFT = 'rgba(74,100,98,0.3)';   // disabled/idle teal
const SNAG_TEAL_SH   = 'rgba(74,100,98,0.55)';  // teal shadow
const SNAG_TEAL_PALE = '#E4ECEB';  // --st-pale — chip/icon wash
const SNAG_GOLD      = '#C8A96E';  // --gold — warm accent (save/start, dock, sendgo &)
const SNAG_PRIMARY   = 'linear-gradient(100deg, #C8A96E, #4A6462)'; // --gold → --st-deep
const SNAG_SKY       = '#2A72A8';  // --k600 — interactive add-links
const SNAG_SKY_LINE  = '#3E8BBF';  // --k500
const SNAG_SKY_BG    = '#F0F7FB';  // --k50
const SNAG_STATUSES = ['Open', 'In progress', 'Fixed', 'Verified'];
// Map the warm three-step severity to the portal /api/snags vocabulary so the
// server's critical_count stays meaningful (it counts severity === 'critical').
const SNAG_SEV_DISPATCH = { high: 'critical', med: 'major', low: 'minor' };
// Generic, editable owner defaults. NEVER a client or company name — an owner
// can be any party (our team / a contractor / the client), chosen per job.
const SNAG_OWNER_DEFAULTS = ['Our team', 'Contractor', 'Client'];

const snagLoad = () => { try { const a = JSON.parse(localStorage.getItem(SNAG_STORE_KEY) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; } };
const snagSave = (arr) => { try { localStorage.setItem(SNAG_STORE_KEY, JSON.stringify(arr)); } catch (e) { debugLog('snag.persist.fail', { error: (e && e.message) || String(e) }); } };
const snagGet = (id) => snagLoad().find(s => s.id === id) || null;
const snagUpsert = (job) => { const arr = snagLoad(); const i = arr.findIndex(s => s.id === job.id); if (i !== -1) arr[i] = job; else arr.unshift(job); snagSave(arr); return job; };
const _snagUid = (pfx) => pfx + '-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
const snagStatusColor = (s) => s === 'Open' ? '#7A271C' : s === 'In progress' ? '#7A5A12' : s === 'Fixed' ? '#1A5A78' : '#3E6B30';
const snagIsOpen = (i) => i && (i.status === 'Open' || i.status === 'In progress');
const snagFirstUrl = (i) => { const p = (i && i.photos || [])[0]; return p && (p.url || (typeof p.src === 'string' && p.src.indexOf('http') === 0 ? p.src : null)) || null; };
const showToastSafe = (m, color) => { try { showSavedToast(m, color || SNAG_TEAL); } catch (e) {} };

// ── STUDIO-LIT-PHONE-V1 item 8a: the snag screens with the Studio switch on ──
// Built to the lit v5 prototype (docs/studio-lit/target/screens/app.js
// `snags`, `snag`, `route`) from the snag job the phone holds (lumen_snags):
// nothing here is sent by the portal or worked out from anything but the job's
// own issues and their dated history. Severity is a word in its meaning
// colour (High needs attention, rust; Medium ink; Low slate), never a dot.
// The switch-on bodies render inside a component of their own (SnagLitBody),
// so the capture walker does not re-colour them.
const SnagLitBody = ({ draw }) => draw();
const snagSevLit = (sev) => {
  const M = STUDIO_MEANING; const S = STUDIO_TOKENS;
  if (sev === 'high') return { word: 'High', color: M.rustText, fontWeight: 700 };
  if (sev === 'low') return { word: 'Low', color: M.slateText, fontWeight: 600 };
  return { word: 'Medium', color: S.ink, fontWeight: 700 };
};
const snagIsClosed = (i) => !!i && (i.status === 'Fixed' || i.status === 'Verified');
// Who fixes it, as the prototype says it: "ours to fix", "Apleona FM to fix".
const snagOwnerWords = (o) => (!o ? 'no owner yet' : o === 'Our team' ? 'ours to fix' : `${o} to fix`);
// Fixed today: a closed snag whose own history has a Fixed or Verified entry
// dated today (the history is written on the phone at each status change).
const snagFixedToday = (issues, now) => {
  const d = (now || new Date()).toDateString();
  return (issues || []).filter((i) => snagIsClosed(i) && (i.history || []).some((h) => h && (h.status === 'Fixed' || h.status === 'Verified') && h.at && new Date(h.at).toDateString() === d)).length;
};
// The prototype's back link (.app-back): a chevron and the place you came from.
const SnagBack = ({ label, onClick }) => (
  <button onClick={onClick} style={{ minHeight: 44, display: 'inline-flex', alignItems: 'center', gap: 4, padding: '0 6px 0 0', marginLeft: -6, border: 'none', background: 'none', cursor: 'pointer', fontFamily: STUDIO_TOKENS.fonts.body, fontSize: 16, fontWeight: 600, color: STUDIO_TOKENS.ink }}>
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M15 6l-6 6 6 6"/></svg>{label}
  </button>
);
// A snag's photo, or a well where there is none.
const SnagPic = ({ photo, h, radius, count }) => (
  <span style={{ position: 'relative', display: 'block', height: h, borderRadius: radius, overflow: 'hidden', background: STUDIO_TOKENS.pressed.fill, boxShadow: photo ? 'none' : STUDIO_TOKENS.shadow.pressed }}>
    {photo ? <MediaThumb photo={photo} style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} /> : null}
    {count > 1 && <span style={{ position: 'absolute', right: 6, bottom: 5, fontSize: 13, fontWeight: 700, color: STUDIO_TOKENS.onPrimary, textShadow: `0 1px 3px ${studioInk(0.6)}` }}>{count}</span>}
  </span>
);
// The prototype's .app-opts: options in a well, the one chosen on raised paper.
const snagOptsLit = (label, options, on, onPick, cols) => {
  const S = STUDIO_TOKENS;
  const n = options.length;
  const c = cols || Math.min(n, 4);
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
      <b style={{ fontSize: 14, fontWeight: 700, color: S.ink }}>{label}</b>
      <div role="radiogroup" aria-label={label} style={{ display: 'grid', gridTemplateColumns: `repeat(${c}, minmax(0, 1fr))`, gap: 4, padding: 5, borderRadius: 12, background: S.pressed.fill, boxShadow: S.shadow.pressed }}>
        {options.map((o) => {
          const sel = o.key === on;
          const hi = sel && o.key === 'high';
          return (
            <button key={o.key} role="radio" aria-checked={sel} onClick={() => onPick(o.key)} style={{ position: 'relative', minWidth: 0, minHeight: 44, padding: '4px 6px', borderRadius: 9, border: 'none', cursor: 'pointer', fontFamily: S.fonts.body, fontSize: 14, lineHeight: 1.2, overflowWrap: 'anywhere',
              color: hi ? STUDIO_MEANING.rustText : sel ? S.ink : S.muted, fontWeight: sel ? 700 : 400,
              background: sel ? S.litpaper.css : 'transparent',
              boxShadow: hi ? `${S.shadow.slip}, inset 0 0 0 1.5px ${studioRgba(STUDIO_MEANING.rustFill, 0.7)}, 0 0 14px -4px ${studioRgba(STUDIO_MEANING.rustFill, 0.8)}` : sel ? S.shadow.slip : 'none' }}>
              {o.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};


// ════════════════════════════════════════════════════
// SCREEN 12: SNAG SETUP — Standalone vs From a completed project
// ════════════════════════════════════════════════════
const SnagSetupScreenBody = ({ onBack, onNav, currentUser, projects }) => {
  const div = getDivisionConfig(currentUser);
  const [mode, setMode] = useState('standalone');   // 'standalone' | 'project'
  const [linkedId, setLinkedId] = useState(null);
  const [jobName, setJobName] = useState('');
  // B.2 Slice 2 — capture-time PORTAL binding, alongside (never instead of)
  // the local completed-survey picker below: that picker is functional — it
  // feeds the job's inherited areas + client/address — while this binds the
  // dispatch to a canonical PRJ-XXXX. Same accessor pair, same three states
  // as surveys; optional, never blocks Start (ratified).
  const [binding, setBinding] = useState(null);
  const [pickerOpen, setPickerOpen] = useState(false);

  // Completed survey projects only — the installs worth snagging. Their areas
  // are inherited so they aren't retyped (v3 §4.1).
  const completed = (projects || []).filter(p => { try { return getSurveyState(p) === 'submitted'; } catch (e) { return false; } });
  const linked = completed.find(p => p.id === linkedId) || null;
  const canStart = mode === 'standalone' ? jobName.trim().length > 0 : !!linked;

  const pickProject = (p) => { setLinkedId(p.id); if (!jobName.trim()) setJobName(p.name || ''); };

  const startJob = () => {
    const nm = jobName.trim() || (linked ? linked.name : 'New snag job');
    const inheritedAreas = (mode === 'project' && linked && Array.isArray(linked.zones)) ? linked.zones.slice() : [];
    const job = {
      id: _snagUid('snag'),
      mode,
      projectId: mode === 'project' && linked ? linked.id : null,
      projectName: nm,
      clientName: mode === 'project' && linked ? (linked.client || '') : '',
      address: mode === 'project' && linked ? (linked.address || '') : '',
      isUnlinked: mode === 'standalone',
      status: 'in-progress',
      areas: inheritedAreas,
      owners: SNAG_OWNER_DEFAULTS.slice(),
      issues: [],
      createdAt: new Date().toISOString(),
      submittedAt: null,
      // B.2 — the chosen portal binding rides the job through the snag store
      // (snagUpsert persists it verbatim); absent = not chosen, legal.
      ...(binding ? setProjectBinding(null, binding) : {}),
    };
    snagUpsert(job);
    debugLog('snag.job.created', { id: job.id, mode, areas: inheritedAreas.length });
    onNav(13, { snagId: job.id });
  };

  const OptionCard = ({ id, glyph, title, sub }) => {
    const on = mode === id;
    // Under the theme the choice you are on is pressed in, the other is a raised
    // slip; the glyph tile and the radio character are not drawn, an ink tick
    // marks the one chosen.
    return studioCapture(
      <button onClick={() => { setMode(id); if (id === 'standalone') setLinkedId(null); }}
        style={{ width:'100%', display:'flex', alignItems:'center', gap:14, background:t.colors.glass, border:`1.5px solid ${on ? SNAG_TEAL : t.colors.glassBorder}`, boxShadow: on ? `inset 0 0 0 1px ${SNAG_TEAL}` : 'none', borderRadius:16, padding:18, marginBottom:12, cursor:'pointer', textAlign:'left', fontFamily:'inherit', ...uvx(() => ({ ...(on ? studioSurface.pressed() : studioSurface.slip()), borderRadius: STUDIO_TOKENS.radius.card })) }}>
        {t.theme === 'uv' ? null : <div style={{ width:46, height:46, borderRadius:12, background:SNAG_TEAL_PALE, color:SNAG_TEAL, display:'flex', alignItems:'center', justifyContent:'center', fontSize:20, flexShrink:0 }}>{glyph}</div>}
        <div style={{ flex:1, minWidth:0 }}>
          <div style={{ fontSize:17, fontWeight:700, color:t.colors.text, ...uvx({ fontSize: 16 }) }}>{title}</div>
          <div style={{ fontSize:13, color:t.colors.textSecondary, marginTop:2, ...uvx({ fontSize: 14 }) }}>{sub}</div>
        </div>
        {t.theme === 'uv'
          ? (on ? <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={STUDIO_TOKENS.ink} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg> : null)
          : <span style={{ color: on ? SNAG_TEAL : t.colors.textTertiary, fontSize:16 }}>{on ? '●' : '○'}</span>}
      </button>
    );
  };

  return (
    <div style={{ flex:1, overflowY:'auto', WebkitOverflowScrolling:'touch', overscrollBehavior:'contain', paddingBottom:100, background:'#E8DCC8', display:'flex', flexDirection:'column' }}>
      <NavBar title="New snag job" onBack={() => onNav(10)} />
      <div style={{ flex:1, overflowY:'auto', padding:'10px 18px 110px', overscrollBehavior:'contain' }}>
        {t.theme === 'uv' ? null : <p style={{ fontSize:11, letterSpacing:'0.12em', textTransform:'uppercase', color:t.colors.textTertiary, fontWeight:700 }}>New snag job</p>}
        <h2 style={{ fontFamily:'Georgia, serif', fontStyle:'italic', fontSize:27, color:t.colors.text, margin:'6px 0 20px', ...uvx(() => ({ ...studioType.heading(), fontSize: 25 })) }}>Where are we snagging?</h2>

        <OptionCard id="standalone" glyph="◆" title="Standalone" sub="A fresh snag list for any site" />
        <OptionCard id="project" glyph="⧉" title="From a completed project" sub="Snag an install that began as a survey" />

        {mode === 'project' && (
          <div style={{ marginTop:4 }}>
            <p style={{ fontSize:11, letterSpacing:'0.1em', textTransform:'uppercase', color:t.colors.textTertiary, fontWeight:700, margin:'8px 2px 10px' }}>Pick the project</p>
            {completed.length === 0 && (
              <div style={{ padding:'16px 14px', background:t.colors.glass, border:`1px solid ${t.colors.glassBorder}`, borderRadius:13, fontSize:13, color:t.colors.textSecondary }}>
                {`No completed surveys on this device yet. Start a standalone job instead${studioDash()}you can still add areas by hand.`}
              </div>
            )}
            {completed.map(p => {
              const on = linkedId === p.id;
              const areaN = Array.isArray(p.zones) ? p.zones.length : 0;
              return (
                <button key={p.id} onClick={() => pickProject(p)}
                  style={{ width:'100%', display:'flex', alignItems:'center', gap:12, background:t.colors.glass, border:`1px solid ${on ? SNAG_TEAL : t.colors.glassBorder}`, boxShadow: on ? `inset 0 0 0 1px ${SNAG_TEAL}` : 'none', borderRadius:13, padding:14, marginBottom:9, cursor:'pointer', textAlign:'left', fontFamily:'inherit', ...uvx(() => ({ ...(on ? studioSurface.pressed() : studioSurface.slip()), borderRadius: STUDIO_TOKENS.radius.card })) }}>
                  <div style={{ flex:1, minWidth:0 }}>
                    <div style={{ fontSize:15, fontWeight:700, color:t.colors.text, ...uvx({ fontSize: 16 }) }}>{p.name}</div>
                    <div style={{ fontSize:12, color:t.colors.textSecondary, marginTop:2, ...uvx({ fontSize: 14 }) }}>{(p.client || 'No client') + studioSep() + areaN + ' area' + (areaN === 1 ? '' : 's')}</div>
                  </div>
                  <span style={{ fontSize:10, fontWeight:700, background:'rgba(90,144,72,0.14)', color:'#3E6B30', padding:'3px 8px', borderRadius:6 }}>from survey</span>
                </button>
              );
            })}
          </div>
        )}

        <p style={{ fontSize:11, letterSpacing:'0.1em', textTransform:'uppercase', color:t.colors.textTertiary, fontWeight:700, margin:'18px 2px 9px' }}>Job name</p>
        <input value={jobName} onChange={e => setJobName(e.target.value)} placeholder="Name this snag job…"
          style={{ width:'100%', background:t.colors.input, border:`1px solid ${t.colors.separator}`, borderRadius:12, padding:'13px 14px', fontFamily:'inherit', fontSize:16, color:t.colors.text, outline:'none', boxSizing:'border-box' }} />

        {/* B.2 — portal binding card (shared component, snag chrome family:
            sage-teal per snag_workspace_v3 / S138.2 — terracotta is the snag
            PIN marker only, never chrome). Three states; Start never blocked. */}
        <p style={{ fontSize:11, letterSpacing:'0.1em', textTransform:'uppercase', color:t.colors.textTertiary, fontWeight:700, margin:'18px 2px 9px' }}>Portal project</p>
        <ProjectBindingCard binding={binding} onChoose={() => setPickerOpen(true)} accent={BIND_ACCENT_SNAG}
          unboundHint="Link this snag job to a portal project so it lands bound." />

        <button onClick={startJob} disabled={!canStart}
          style={{ width:'100%', marginTop:22, padding:16, border:'none', borderRadius:14, background: canStart ? SNAG_PRIMARY : SNAG_TEAL_SOFT, color:'#fff', fontFamily:'Georgia, serif', fontStyle:'italic', fontSize:18, cursor: canStart ? 'pointer' : 'default', boxShadow: canStart ? '0 8px 22px -10px ' + SNAG_TEAL_SH : 'none', ...uvx(() => ({ ...studioSurface.primary(), fontFamily: STUDIO_TOKENS.fonts.body, fontStyle: 'normal', opacity: canStart ? 1 : 0.5 })) }}>
          Start snagging
        </button>
      </div>
      {/* B.2 — shared bottom-sheet picker, snag chrome */}
      {pickerOpen && (
        <ProjectPickerSheet binding={binding} accent={BIND_ACCENT_SNAG}
          onApply={(b) => { setBinding(b); setPickerOpen(false); }}
          onClose={() => setPickerOpen(false)}
          noun="snag job"
          prefill={{ name: jobName, client_name: (mode === 'project' && linked) ? (linked.client || '') : '' }} />
      )}
      <TabBar active={12} onChange={onNav} divisionId={div && div.id ? div.id : 'lighting'} />
    </div>
  );
};


// ════════════════════════════════════════════════════
// SCREEN 13: SNAG WORKSPACE — area-first list + photo-first capture + close-out
// ════════════════════════════════════════════════════
const SnagCaptureScreenBody = ({ onBack, onNav, snagId, currentUser }) => {
  const div = getDivisionConfig(currentUser);
  const [job, setJob] = useState(() => snagGet(snagId));
  const [filter, setFilter] = useState('all');
  const [areaOpen, setAreaOpen] = useState(() => {
    const j = snagGet(snagId); const o = {}; const first = (j && j.areas || [])[0]; if (first) o[first] = true; return o;
  });
  const [sheet, setSheet] = useState(null);        // null | 'snag'
  const [draft, setDraft] = useState(null);
  const [draftNew, setDraftNew] = useState(false);
  const [addOwner, setAddOwner] = useState(false);
  const [ownerInput, setOwnerInput] = useState('');
  const [addLoc, setAddLoc] = useState(false);
  const [locInput, setLocInput] = useState('');
  const [addArea, setAddArea] = useState(false);
  const [areaInput, setAreaInput] = useState('');
  // S153 — defect scan state. Held here (not on the draft) so the display-only
  // confidence / label / note never persist onto the saved issue.
  const [scanInfo, setScanInfo] = useState(null);   // null | {running}|{error}|{conf,label,note,filled}
  const fileRef = useRef(null);
  const captureRef = useRef(null);   // { mode:'new'|'add'|'after', area, issueId }
  const pendingRef = useRef([]);      // photos captured for a not-yet-saved snag

  const persist = (updated) => { snagUpsert(updated); setJob(Object.assign({}, updated)); };

  // Best-effort: when a capture-time upload resolves, write the URL onto the
  // matching photo wherever it now lives (pending draft, open draft, or a saved
  // issue's photos / afterPhotos). MediaThumb renders from IndexedDB regardless,
  // so a missed URL only costs the portal a thumbnail link, never the photo.
  const patchPhotoUrl = (id, url) => {
    let hit = false;
    pendingRef.current = pendingRef.current.map(p => p && p.id === id ? (hit = true, Object.assign({}, p, { url, src: url })) : p);
    setDraft(d => { if (!d) return d; let any = false; const mp = a => (a || []).map(p => p && p.id === id ? (any = true, Object.assign({}, p, { url, src: url })) : p); const nd = Object.assign({}, d, { photos: mp(d.photos), afterPhotos: mp(d.afterPhotos) }); return any ? nd : d; });
    const j = snagGet(snagId);
    if (j) {
      let any = false;
      const mp = a => (a || []).map(p => p && p.id === id ? (any = true, Object.assign({}, p, { url, src: url })) : p);
      const issues = (j.issues || []).map(i => Object.assign({}, i, { photos: mp(i.photos), afterPhotos: mp(i.afterPhotos) }));
      if (any) persist(Object.assign({}, j, { issues }));
    }
  };

  const routeCaptured = (p) => {
    const tgt = captureRef.current || {};
    if (tgt.mode === 'add') { setDraft(d => d ? Object.assign({}, d, { photos: [...(d.photos || []), p] }) : d); }
    else if (tgt.mode === 'after' && tgt.issueId) { attachAfterPhoto(tgt.issueId, p); }
    else { pendingRef.current.push(p); }
  };

  const cam = useBurstCamera({
    uploadProjectId: snagId,
    label: 'Snag photo',
    onAdd: routeCaptured,
    onUrl: patchPhotoUrl,
    onFileFallback: () => { setTimeout(() => { if (fileRef.current) fileRef.current.click(); }, 50); },
    onClosed: () => {
      const tgt = captureRef.current || {};
      if (tgt.mode === 'new') { openNewSnag(tgt.area, pendingRef.current.slice()); pendingRef.current = []; }
    },
  });

  const handleFile = async (file) => {
    if (!file) return;
    let dataUrl = null, rawBlob = null;
    try { dataUrl = await compressImage(file, 1280, 0.6); }
    catch (e) { try { dataUrl = await blobToDataUrl(file); } catch (e2) { dataUrl = null; } if (!dataUrl) rawBlob = file; }
    const tgt = captureRef.current || {};
    await savePhotoReliableCore({ dataUrl, rawBlob, zone: tgt.area || null, label: 'Snag photo', uploadProjectId: snagId, onAdd: routeCaptured, onUrl: patchPhotoUrl });
    if (tgt.mode === 'new') { openNewSnag(tgt.area, pendingRef.current.slice()); pendingRef.current = []; }
  };

  if (!job) return <div style={{ padding:40, textAlign:'center', color:t.colors.textTertiary }}>Snag job not found</div>;

  const issues = job.issues || [];
  const openCount = issues.filter(snagIsOpen).length;
  const highCount = issues.filter(i => i.sev === 'high' && snagIsOpen(i)).length;
  const visFilter = (i) => filter === 'open' ? snagIsOpen(i) : filter === 'high' ? i.sev === 'high' : filter === 'fixed' ? (i.status === 'Fixed' || i.status === 'Verified') : true;
  const vis = issues.filter(visFilter);
  const jobWide = vis.filter(i => !i.area);
  const displayAreas = [];
  (job.areas || []).forEach(a => { if (displayAreas.indexOf(a) === -1) displayAreas.push(a); });
  vis.forEach(i => { if (i.area && displayAreas.indexOf(i.area) === -1) displayAreas.push(i.area); });

  // ── capture / sheet flow ──
  const startNew = (area) => { captureRef.current = { mode: 'new', area: area || '' }; pendingRef.current = []; cam.open(area || ''); };
  const openNewSnag = (area, photos) => {
    setDraftNew(true);
    setDraft({ id: _snagUid('iss'), kind: 'defect', sev: 'med', fault: '', area: area || '', owner: '', photos: photos || [], afterPhotos: [], status: 'Open', history: [] });
    setAddOwner(false); setAddLoc(false); setOwnerInput(''); setLocInput('');
    setSheet('snag');
  };
  const openExisting = (issue) => {
    setDraftNew(false);
    setDraft(Object.assign({ afterPhotos: [], history: [] }, JSON.parse(JSON.stringify(issue))));
    setAddOwner(false); setAddLoc(false); setOwnerInput(''); setLocInput('');
    setSheet('snag');
  };
  const closeSheet = () => { setSheet(null); setDraft(null); setScanInfo(null); };

  // S153 — on-demand defect scan. Proposes fault / kind / severity onto the open
  // snag draft; the surveyor confirms or edits before Save, exactly as a manual
  // snag. Offline / error / success:false all leave the draft untouched and the
  // surveyor carries on by hand. severity_confidence, label_text and the model
  // note are display-only (no home on the v3 sheet — surfaced, never persisted).
  // S154 — per-photo: scan the chosen photo (Treatment A button under each). A snag
  // is one defect = one proposal, so it prefills the open draft directly rather than
  // a multi-result collector. Sequential only; scanInfo.photoId scopes the wait/error
  // to the tapped photo's button.
  const scanDefect = async (photo) => {
    if (!draft) return;
    const ph = photo || (draft.photos || [])[0];
    if (!ph) { showToastSafe('Add a photo first, then scan'); return; }
    if (scanInfo && scanInfo.running) return;   // never fire parallel calls
    const photoId = ph.id || null;
    setScanInfo({ running: true, photoId });
    const res = await callVisionScan('defect', ph, { area_name: draft.area || '', job_type: 'snag' });
    if (!res.ok) { setScanInfo({ error: res.error || 'Scan unavailable. Add it by hand.', photoId }); return; }
    const p = res.proposal || {};
    const sevMap = { high: 'high', medium: 'med', low: 'low' };
    setDraft(d => d ? Object.assign({}, d, {
      fault: (p.fault && String(p.fault).trim()) ? p.fault : d.fault,
      sev: sevMap[p.severity] || d.sev,
      kind: ['defect', 'safety', 'observation'].indexOf(p.kind) > -1 ? p.kind : d.kind,
    }) : d);
    setScanInfo({ conf: p.severity_confidence || null, label: p.label_text || null, note: p.note || null, filled: true, photoId });
  };

  const addPhotosToDraft = () => { captureRef.current = { mode: 'add', area: draft && draft.area || '' }; cam.open(draft && draft.area || ''); };
  const removeDraftPhoto = (id) => {
    logDestructiveAction('snag.photo.delete', { projectId: snagId, id, meta: { issueId: draft && draft.id, photoId: id } });
    try { idbDeleteBlob(id); } catch (e) {}
    setDraft(d => d ? Object.assign({}, d, { photos: (d.photos || []).filter(p => p.id !== id) }) : d);
  };

  const commitOwner = () => { const v = ownerInput.trim(); if (!v) { setAddOwner(false); return; } if ((job.owners || []).indexOf(v) === -1) persist(Object.assign({}, job, { owners: [...(job.owners || []), v] })); setDraft(d => d ? Object.assign({}, d, { owner: v }) : d); setOwnerInput(''); setAddOwner(false); };
  const commitLoc = () => { const v = locInput.trim(); if (!v) { setAddLoc(false); return; } if ((job.areas || []).indexOf(v) === -1) persist(Object.assign({}, job, { areas: [...(job.areas || []), v] })); setDraft(d => d ? Object.assign({}, d, { area: v }) : d); setLocInput(''); setAddLoc(false); };
  const removeOwner = (name) => {
    if (SNAG_OWNER_DEFAULTS.indexOf(name) !== -1) return;   // generic defaults stay
    logDestructiveAction('snag.owner.delete', { projectId: snagId, meta: { owner: name } });
    persist(Object.assign({}, job, { owners: (job.owners || []).filter(o => o !== name) }));
    setDraft(d => d && d.owner === name ? Object.assign({}, d, { owner: '' }) : d);
  };
  const commitArea = () => { const v = areaInput.trim(); if (!v) { setAddArea(false); return; } if ((job.areas || []).indexOf(v) === -1) persist(Object.assign({}, job, { areas: [...(job.areas || []), v] })); setAreaOpen(o => Object.assign({}, o, { [v]: true })); setAreaInput(''); setAddArea(false); };

  const saveSnag = () => {
    if (!draft) return;
    const fault = (draft.fault || '').trim();
    if (!fault) { showToastSafe('Add a one-line fault first'); return; }
    const j = snagGet(snagId) || job;
    if (draftNew) {
      const issue = Object.assign({}, draft, { fault, raisedAt: new Date().toISOString(), history: [{ status: 'Open', at: new Date().toISOString() }] });
      const areas = (j.areas || []).slice();
      if (issue.area && areas.indexOf(issue.area) === -1) areas.push(issue.area);
      persist(Object.assign({}, j, { areas, issues: [issue, ...(j.issues || [])] }));
      if (issue.area) setAreaOpen(o => Object.assign({}, o, { [issue.area]: true }));
      debugLog('snag.issue.added', { projectId: snagId, kind: issue.kind, sev: issue.sev, photos: (issue.photos || []).length });
      showToastSafe('Snag raised');
    } else {
      const issues = (j.issues || []).map(i => i.id === draft.id ? Object.assign({}, i, { kind: draft.kind, sev: draft.sev, fault, area: draft.area, owner: draft.owner, photos: draft.photos }) : i);
      const areas = (j.areas || []).slice();
      if (draft.area && areas.indexOf(draft.area) === -1) areas.push(draft.area);
      persist(Object.assign({}, j, { areas, issues }));
      showToastSafe('Snag updated');
    }
    closeSheet();
  };

  const removeSnag = () => {
    if (!draft) return;
    logDestructiveAction('snag.issue.delete', { projectId: snagId, id: draft.id, meta: { issueId: draft.id, fault: draft.fault || '', status: draft.status || 'Open' } });
    const j = snagGet(snagId) || job;
    persist(Object.assign({}, j, { issues: (j.issues || []).filter(i => i.id !== draft.id) }));
    closeSheet();
    showToastSafe('Snag removed');
  };

  // ── close-out lifecycle ──
  const setIssueStatus = (issueId, status) => {
    const j = snagGet(snagId) || job;
    const at = new Date().toISOString();
    const issues = (j.issues || []).map(i => {
      if (i.id !== issueId) return i;
      const history = [...(i.history || []), { status, at }];
      return Object.assign({}, i, { status, history, closedAt: status === 'Verified' ? at : i.closedAt || null });
    });
    persist(Object.assign({}, j, { issues }));
    debugLog('snag.status.change', { projectId: snagId, id: issueId, status });
    setDraft(d => d && d.id === issueId ? Object.assign({}, d, { status, history: [...(d.history || []), { status, at }] }) : d);
  };
  const verifyClose = (issueId) => {
    logDestructiveAction('snag.closeout', { projectId: snagId, id: issueId, meta: { issueId: issueId, action: 'verify_and_close' } });
    setIssueStatus(issueId, 'Verified');
    showToastSafe('Snag verified and closed');
  };
  const attachAfterPhoto = (issueId, photo) => {
    const j = snagGet(snagId) || job;
    const issues = (j.issues || []).map(i => i.id === issueId ? Object.assign({}, i, { afterPhotos: [...(i.afterPhotos || []), photo] }) : i);
    persist(Object.assign({}, j, { issues }));
    debugLog('snag.afterphoto.added', { projectId: snagId, id: issueId });
    setDraft(d => d && d.id === issueId ? Object.assign({}, d, { afterPhotos: [...(d.afterPhotos || []), photo] }) : d);
  };
  const addAfterPhoto = () => { if (!draft) return; captureRef.current = { mode: 'after', area: draft.area || '', issueId: draft.id }; cam.open(draft.area || ''); };

  // ── snag card ──
  const SnagCard = ({ issue }) => {
    const sv = SNAG_SEV[issue.sev] || SNAG_SEV.med;
    const n = (issue.photos || []).length;
    const first = (issue.photos || [])[0];
    // Under the theme severity is a word (the pastel wash is colour for looks),
    // the card is a raised slip, owner and status are plain words.
    return studioCapture(
      <button onClick={() => openExisting(issue)} style={{ width:'100%', display:'flex', gap:12, textAlign:'left', borderRadius:13, padding:12, marginBottom:8, cursor:'pointer', fontFamily:'inherit', background:`linear-gradient(135deg, ${sv.g1}, ${sv.g2})`, border:`1px solid ${sv.border}`, ...uvx(() => ({ ...studioSurface.slip(), borderRadius: STUDIO_TOKENS.radius.card })) }}>
        <div style={{ width:60, height:60, borderRadius:10, background:'rgba(255,255,255,0.55)', flexShrink:0, position:'relative', overflow:'hidden', display:'flex', alignItems:'center', justifyContent:'center', color:'rgba(0,0,0,0.25)', fontSize:20 }}>
          {first ? <MediaThumb photo={first} style={{ width:'100%', height:'100%', objectFit:'cover', display:'block' }} /> : '▣'}
          {n > 1 && <span style={{ position:'absolute', bottom:3, right:3, background:'rgba(0,0,0,0.5)', color:'#fff', fontSize:10, fontWeight:600, padding:'1px 6px', borderRadius:7, ...uvx({ padding: '5px 8px', fontSize: 13 }) }}>{n}</span>}
        </div>
        <div style={{ flex:1, minWidth:0, display:'flex', flexDirection:'column', justifyContent:'center', gap:7 }}>
          <div style={{ fontWeight:600, fontSize:15, lineHeight:1.3, color:t.colors.text, ...uvx({ fontSize: 16, fontWeight: 700 }) }}>{issue.fault || 'Snag'}</div>
          <div style={{ display:'flex', alignItems:'center', gap:8 }}>
            {issue.owner ? <span style={{ fontSize:11, fontWeight:600, background:'rgba(255,255,255,0.65)', color:'#564A38', padding:'3px 9px', borderRadius:7 }}>{issue.owner}</span> : <span style={{ fontSize:11, color:t.colors.textTertiary }}>No owner</span>}
            <span style={{ fontSize:11, fontWeight:600, marginLeft:'auto', color: snagStatusColor(issue.status) }}>{t.theme === 'uv' ? `${sv.label}, ${issue.status}` : issue.status}</span>
          </div>
        </div>
      </button>
    );
  };

  const AreaCard = ({ area, label, items, jobWideCard }) => {
    const open = jobWideCard ? (areaOpen.__job__ !== false) : !!areaOpen[area];
    const sevs = {}; items.forEach(i => { sevs[i.sev] = 1; });
    const dots = ['high', 'med', 'low'].filter(k => sevs[k]).map(k => <span key={k} style={{ width:9, height:9, borderRadius:'50%', background:SNAG_SEV[k].dot }} />);
    // Under the theme the severities present in the area are named, not dotted.
    const sevWords = ['high', 'med', 'low'].filter(k => sevs[k]).map(k => SNAG_SEV[k].label).join(', ');
    const toggle = () => setAreaOpen(o => Object.assign({}, o, jobWideCard ? { __job__: !open } : { [area]: !open }));
    return studioCapture(
      <div style={{ background: jobWideCard ? 'rgba(22,38,58,0.03)' : t.colors.glass, border:`1px solid ${jobWideCard ? '#16263A' : t.colors.glassBorder}`, borderRadius:16, marginBottom:11, overflow:'hidden', ...uvx(() => ({ ...studioSurface.raised(), borderRadius: STUDIO_TOKENS.radius.card })) }}>
        <button onClick={toggle} style={{ width:'100%', display:'flex', alignItems:'center', gap:12, padding:16, cursor:'pointer', background:'none', border:'none', textAlign:'left', fontFamily:'inherit' }}>
          {jobWideCard && <span style={{ width:11, height:11, borderRadius:'50%', background:'#16263A', flexShrink:0 }} />}
          <div style={{ flex:1, minWidth:0 }}>
            <div style={{ fontFamily:'Georgia, serif', fontSize:jobWideCard ? 16 : 19, fontWeight:600, color: jobWideCard ? '#16263A' : t.colors.text, ...uvx(() => ({ ...studioType.heading(), fontSize: 20 })) }}>{label}</div>
            <div style={{ fontSize:12.5, color:t.colors.textSecondary, marginTop:2 }}>{items.length ? (items.length + ' snag' + (items.length === 1 ? '' : 's')) : 'No snags yet'}</div>
          </div>
          {t.theme === 'uv' ? <span style={{ fontSize:13, color:STUDIO_TOKENS.muted }}>{sevWords}</span> : <div style={{ display:'flex', gap:4 }}>{dots}</div>}
          <span style={{ color:t.colors.textTertiary, fontSize:18, transition:'.2s', transform: open ? 'rotate(180deg)' : 'none' }}>⌄</span>
        </button>
        {open && (
          <div style={{ padding:'0 12px 12px' }}>
            {items.map(i => <SnagCard key={i.id} issue={i} />)}
            <button onClick={(e) => { e.stopPropagation(); startNew(jobWideCard ? '' : area); }}
              style={{ width:'100%', padding:11, border:`1.5px dashed rgba(74,100,98,0.32)`, borderRadius:11, background:'none', color:SNAG_TEAL, fontWeight:600, fontSize:13.5, cursor:'pointer', marginTop:2, fontFamily:'inherit', ...uvx(() => ({ ...studioType.action(), padding: 11, border: `1px dashed ${STUDIO_TOKENS.hairline}` })) }}>
              ＋ {jobWideCard ? 'Add a job-wide snag' : 'Add snag in ' + area}
            </button>
          </div>
        )}
      </div>
    );
  };

  const filters = [['all', 'All'], ['open', 'Open'], ['high', 'High'], ['fixed', 'Fixed']];
  const uvLink = t.theme === 'uv';
  const linkLabel = job.mode === 'project' && job.projectName ? ((uvLink ? '' : '⧉ ') + 'Linked to ' + (job.clientName || job.projectName)) : ((uvLink ? '' : '◆ ') + 'Standalone');
  // While the snag sheet is open its Save is the one main action, so the Snag
  // button below it is a raised slip, not a second ultraviolet surface.
  const sheetOpen = sheet === 'snag' && !!draft;

  // STUDIO-LIT-PHONE-V1 item 8a: the Snag list (#app/snags) with the switch on.
  if (t.theme === 'uv') {
    const drawLit = () => {
      const S = STUDIO_TOKENS; const M = STUDIO_MEANING;
      const fixedToday = snagFixedToday(issues);
      const medCount = issues.filter((i) => i.sev === 'med' && snagIsOpen(i)).length;
      const lowCount = openCount - highCount - medCount;
      const act = { ...studioType.action(), fontSize: 14, minHeight: 44, cursor: 'pointer', fontFamily: 'inherit' };
      const row = (issue) => {
        const closed = snagIsClosed(issue);
        const sv = snagSevLit(issue.sev);
        const n = (issue.photos || []).length;
        const tail = issue.status === 'Verified' ? 'Verified and closed'
          : issue.status === 'Fixed' ? ((issue.afterPhotos || []).length ? 'Fixed, with photos' : 'Fixed')
          : null;
        return (
          <button key={issue.id} onClick={() => openExisting(issue)} style={{ display: 'grid', gridTemplateColumns: '96px minmax(0, 1fr)', gap: 12, alignItems: 'center', width: '100%', minHeight: 88, padding: '6px 12px 6px 6px', borderRadius: 16, border: 'none', cursor: 'pointer', textAlign: 'left', fontFamily: 'inherit', ...(closed ? studioSurface.pressed() : studioSurface.slip()) }}>
            <span style={{ opacity: closed ? 0.6 : 1 }}><SnagPic photo={(issue.photos || [])[0]} h={76} radius={12} count={n} /></span>
            <span style={{ display: 'flex', flexDirection: 'column', gap: 3, minWidth: 0 }}>
              <b style={{ fontSize: 16, lineHeight: 1.28, fontWeight: closed ? 600 : 700, color: closed ? S.muted : S.ink }}>{issue.fault || 'Snag'}</b>
              <span style={{ fontSize: 14, color: S.muted }}>
                {tail || <><span style={{ color: sv.color, fontWeight: sv.fontWeight }}>{sv.word}</span>{issue.status === 'In progress' ? ', in progress' : ''}{', ' + snagOwnerWords(issue.owner)}</>}
              </span>
            </span>
          </button>
        );
      };
      const group = (key, label, items, area) => (
        <section key={key} style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 10 }}>
            <h2 style={{ ...studioType.heading(), fontSize: 20, margin: 0, minWidth: 0, overflowWrap: 'anywhere' }}>{label}</h2>
            <button onClick={() => startNew(area)} style={act}>Add here</button>
          </div>
          {items.map(row)}
        </section>
      );
      // Every area stays on the list whatever the filter, so "Add here" is
      // always to hand (as the live list).
      const areasShown = displayAreas;
      const segs = [['high', highCount, 'high', M.rustFill], ['med', medCount, 'medium', studioRgba(M.rustFill, 0.5)], ['low', lowCount, 'low', studioRgba(M.slateFill, 0.3)]];
      return (
        <div style={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column', fontFamily: S.fonts.body, color: S.ink }}>
          <input ref={fileRef} type="file" accept="image/*" capture="environment" style={{ display: 'none' }}
            onChange={e => { if (e.target.files[0]) handleFile(e.target.files[0]); e.target.value = ''; }} />
          <div style={{ flex: 1, overflowY: 'auto', WebkitOverflowScrolling: 'touch', overscrollBehavior: 'contain', padding: '4px 20px 130px', display: 'flex', flexDirection: 'column', gap: 14 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10, minHeight: 46 }}>
              <SnagBack label="Survey" onClick={() => onNav(10)} />
              <button onClick={() => startNew('')} style={{ ...(sheetOpen ? { ...studioSurface.slip(), color: S.ink, borderRadius: S.button.radius, minHeight: 44, fontSize: 16, fontWeight: 600 } : studioSurface.primary()), padding: '0 16px', cursor: 'pointer', fontFamily: 'inherit' }}>Add a snag</button>
            </div>
            <div>
              <h1 style={{ ...studioType.title(), fontSize: 31, lineHeight: 1.06, overflowWrap: 'anywhere' }}>{job.projectName || 'Snag list'}</h1>
              <p style={{ fontSize: 16, color: S.muted, lineHeight: 1.45, marginTop: 4 }}>
                {job.clientName ? job.clientName + '. ' : (job.mode === 'project' ? '' : 'Standalone. ')}
                {openCount > 0 ? <span style={{ color: M.rustText, fontWeight: 600 }}>Snags open</span> : issues.length ? 'Nothing open' : ''}
              </p>
            </div>
            {issues.length > 0 ? (
              <>
                <div style={{ display: 'flex', alignItems: 'flex-end', gap: 14 }}>
                  <span style={{ ...studioType.display(), fontSize: 84, lineHeight: 0.9 }}>{openCount}</span>
                  <p style={{ fontSize: 16, lineHeight: 1.4, paddingBottom: 8 }}>{openCount === 1 ? 'snag open' : 'snags open'}{fixedToday > 0 ? <>,<br />{fixedToday} fixed today</> : null}</p>
                </div>
                {openCount > 0 && (
                  <div role="img" aria-label={`${openCount} open: ${highCount} high, ${medCount} medium, ${lowCount} low`} style={{ display: 'flex', gap: 3 }}>
                    {segs.filter((x) => x[1] > 0).map((x) => (
                      <span key={x[0]} style={{ flex: x[1], display: 'flex', flexDirection: 'column', gap: 6, minWidth: 56, fontSize: 14, color: S.muted }}>
                        <i style={{ display: 'block', height: 12, borderRadius: 4, background: x[3], boxShadow: x[0] === 'high' ? `0 0 14px -2px ${studioRgba(M.rustFill, 0.9)}` : 'none' }} />
                        <span style={{ display: 'flex', flexDirection: 'column' }}><b style={{ color: x[0] === 'high' ? M.rustText : S.ink }}>{x[1]}</b>{x[2]}</span>
                      </span>
                    ))}
                  </div>
                )}
              </>
            ) : (
              <p style={{ fontSize: 16, color: S.muted, lineHeight: 1.45 }}>No snags on this job yet. A photo and a line on what's wrong is all a snag needs.</p>
            )}
            <div role="group" aria-label="Show" style={{ display: 'flex', gap: 4, padding: 5, borderRadius: 12, ...studioSurface.pressed() }}>
              {filters.map((f) => {
                const on = filter === f[0];
                return <button key={f[0]} aria-pressed={on} onClick={() => setFilter(f[0])} style={{ flex: 1, minHeight: 44, borderRadius: 9, border: 'none', cursor: 'pointer', fontFamily: 'inherit', fontSize: 14, fontWeight: on ? 700 : 400, color: on ? S.ink : S.muted, background: on ? S.litpaper.css : 'transparent', boxShadow: on ? S.shadow.slip : 'none' }}>{f[1]}</button>;
              })}
            </div>
            {jobWide.length > 0
              ? group('__job__', 'Whole job', jobWide, '')
              : (
                <button onClick={() => startNew('')} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', minHeight: 48, padding: '0 14px', borderRadius: 12, border: `1.5px dashed ${studioInk(0.22)}`, background: 'none', cursor: 'pointer', fontFamily: 'inherit', fontSize: 16, color: S.ink }}>
                  <b style={{ fontWeight: 700 }}>Whole job</b><span style={{ ...act, minHeight: 0 }}>Add one</span>
                </button>
              )}
            {areasShown.map((a) => group(a, a, vis.filter((i) => i.area === a), a))}
            {filter !== 'all' && vis.length === 0 && issues.length > 0 && (
              <p style={{ fontSize: 16, color: S.muted }}>{filter === 'fixed' ? 'Nothing fixed yet.' : filter === 'high' ? 'No high snags.' : 'Nothing open.'}</p>
            )}
            {addArea ? (
              <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                <input value={areaInput} onChange={e => setAreaInput(e.target.value)} autoFocus
                  onKeyDown={e => { if (e.key === 'Enter') commitArea(); if (e.key === 'Escape') { setAddArea(false); setAreaInput(''); } }}
                  placeholder="Area name…"
                  style={{ flex: 1, minWidth: 0, minHeight: 44, ...studioSurface.pressed(), borderRadius: S.button.radius, padding: '0 14px', color: S.ink, fontFamily: 'inherit', fontSize: 16, outline: 'none' }} />
                <button onClick={commitArea} style={{ minHeight: 44, padding: '0 16px', borderRadius: S.button.radius, ...studioSurface.slip(), color: S.ink, fontFamily: 'inherit', fontSize: 16, fontWeight: 600, cursor: 'pointer' }}>Add</button>
              </div>
            ) : (
              <button onClick={() => setAddArea(true)} style={{ ...act, alignSelf: 'flex-start', minHeight: 44 }}>Add an area</button>
            )}
            <button onClick={() => onNav(14, { snagId })} style={{ width: '100%', minHeight: 56, borderRadius: 14, ...studioSurface.pressed(), color: S.ink, fontFamily: 'inherit', fontSize: 16, fontWeight: 600, cursor: 'pointer' }}>Review and send</button>
          </div>
          <TabBar active={13} onChange={onNav} divisionId={div && div.id ? div.id : 'lighting'} />
          {sheet === 'snag' && draft && (
            <SnagSheet
              job={job} draft={draft} setDraft={setDraft} draftNew={draftNew}
              addOwner={addOwner} setAddOwner={setAddOwner} ownerInput={ownerInput} setOwnerInput={setOwnerInput} commitOwner={commitOwner} onRemoveOwner={removeOwner}
              addLoc={addLoc} setAddLoc={setAddLoc} locInput={locInput} setLocInput={setLocInput} commitLoc={commitLoc}
              onClose={closeSheet} onSave={saveSnag} onRemove={removeSnag}
              onAddPhotos={addPhotosToDraft} onRemovePhoto={removeDraftPhoto}
              onStatus={(st) => setIssueStatus(draft.id, st)} onVerify={() => verifyClose(draft.id)} onAddAfter={addAfterPhoto}
              scanInfo={scanInfo} onScan={scanDefect}
            />
          )}
          <BurstCameraOverlay cam={cam} headerLabel={(captureRef.current && captureRef.current.mode === 'after') ? 'Fix photo' : ((captureRef.current && captureRef.current.area) ? ('Snag, ' + captureRef.current.area) : 'Snag photo')} />
        </div>
      );
    };
    return <SnagLitBody draw={drawLit} />;
  }

  return (
    <div style={{ flex:1, overflow:'hidden', background:'#E8DCC8', display:'flex', flexDirection:'column' }}>
      <input ref={fileRef} type="file" accept="image/*" capture="environment" style={{ display:'none' }}
        onChange={e => { if (e.target.files[0]) handleFile(e.target.files[0]); e.target.value = ''; }} />

      <NavBar title={job.projectName || 'Snag'} onBack={() => onNav(10)} />

      {/* Job header */}
      <div style={{ padding:'4px 18px 0', flexShrink:0 }}>
        {t.theme === 'uv' ? null : <div style={{ fontFamily:'Georgia, serif', fontStyle:'italic', fontSize:23, color:t.colors.text }}>{job.projectName}</div>}
        <span style={{ display:'inline-flex', alignItems:'center', gap:6, marginTop:6, fontSize:12, color:SNAG_TEAL, background:SNAG_TEAL_PALE, padding:'5px 11px', borderRadius:18, ...uvx({ background: 'transparent', padding: 0, fontSize: 14, color: STUDIO_TOKENS.muted }) }}>{linkLabel}</span>
      </div>

      {/* Filter bar */}
      <div style={{ display:'flex', alignItems:'center', gap:8, padding:'12px 18px 6px', flexShrink:0 }}>
        {filters.map(f => (
          <button key={f[0]} onClick={() => setFilter(f[0])}
            style={{ padding:'8px 15px', borderRadius:18, border:`1px solid ${filter === f[0] ? SNAG_TEAL : t.colors.separator}`, background: filter === f[0] ? SNAG_TEAL : t.colors.glass, color: filter === f[0] ? '#fff' : t.colors.textSecondary, fontSize:13, fontWeight:600, cursor:'pointer', fontFamily:'inherit', ...uvx(() => (filter === f[0] ? { ...studioSurface.pressed(), color: STUDIO_TOKENS.ink, fontWeight: 700 } : { ...studioSurface.slip(), color: STUDIO_TOKENS.muted, fontWeight: 400 })) }}>{f[1]}</button>
        ))}
      </div>

      {/* List */}
      <div style={{ flex:1, overflowY:'auto', WebkitOverflowScrolling:'touch', overscrollBehavior:'contain', padding:'8px 18px 220px' }}>
        {!issues.length && (
          <div style={{ textAlign:'center', color:t.colors.textSecondary, padding:'6px 10px 16px', fontSize:12.5 }}>
            No snags yet. Open an area to add one, or ＋ Snag for a job-wide item. A photo and a one-line fault is all it takes.
          </div>
        )}
        {/* Whole-job level — job-wide snags + media, mirrors the survey's whole-project card */}
        <AreaCard jobWideCard label="Whole job" items={jobWide} />
        {/* Area-first list — inherited / added areas, each expandable to its snags */}
        {displayAreas.map(a => (
          <AreaCard key={a} area={a} label={a} items={vis.filter(i => i.area === a)} />
        ))}

        {/* Add area */}
        {addArea ? (
          <div style={{ display:'flex', gap:6, alignItems:'center', marginTop:4 }}>
            <input value={areaInput} onChange={e => setAreaInput(e.target.value)} autoFocus
              onKeyDown={e => { if (e.key === 'Enter') commitArea(); if (e.key === 'Escape') { setAddArea(false); setAreaInput(''); } }}
              placeholder="Area name…"
              style={{ flex:1, background:t.colors.input, border:`1px solid ${t.colors.separator}`, borderRadius:11, padding:'12px 14px', color:t.colors.text, fontFamily:'inherit', fontSize:15, fontWeight:600, outline:'none' }} />
            <button onClick={commitArea} style={{ minHeight:46, padding:'0 16px', borderRadius:11, background:SNAG_TEAL, border:'none', color:'#fff', fontFamily:'inherit', fontSize:14, fontWeight:700, cursor:'pointer', ...uvx(() => ({ ...studioSurface.slip(), color: STUDIO_TOKENS.ink, borderRadius: STUDIO_TOKENS.button.radius, fontSize: 16, fontWeight: 600 })) }}>Add</button>
          </div>
        ) : (
          <button onClick={() => setAddArea(true)} style={{ width:'100%', padding:11, border:`1.5px dashed ${t.colors.separator}`, borderRadius:11, background:'none', color:t.colors.textSecondary, fontWeight:600, fontSize:13.5, cursor:'pointer', fontFamily:'inherit', ...uvx(() => ({ ...studioType.action(), padding: 11, border: `1px dashed ${STUDIO_TOKENS.hairline}` })) }}>＋ Add an area</button>
        )}
      </div>

      {/* Dock — FAB + status/report bar, floating above the tab bar */}
      <div style={{ position:'fixed', left:14, right:14, bottom:'calc(72px + env(safe-area-inset-bottom,0px))', zIndex:18, display:'flex', flexDirection:'column', gap:8, pointerEvents:'none' }}>
        <button onClick={() => startNew('')} style={{ pointerEvents:'auto', background:SNAG_TEAL, color:'#fff', border:'none', borderRadius:16, padding:16, fontFamily:'Georgia, serif', fontStyle:'italic', fontSize:18, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', gap:10, boxShadow:'0 14px 32px -12px ' + SNAG_TEAL_SH, ...uvx(() => ({ ...(sheetOpen ? { ...studioSurface.slip(), color: STUDIO_TOKENS.ink } : studioSurface.primary()), fontFamily: STUDIO_TOKENS.fonts.body, fontStyle: 'normal', fontSize: 16, fontWeight: 600 })) }}>＋ Snag</button>
        <div onClick={() => onNav(14, { snagId })} style={{ pointerEvents:'auto', background:SNAG_PRIMARY, color:'#fff', borderRadius:15, padding:'12px 15px', display:'flex', alignItems:'center', gap:12, cursor:'pointer', boxShadow:'0 12px 30px -12px ' + SNAG_TEAL_SH, ...uvx(() => ({ ...studioSurface.raised(), borderRadius: STUDIO_TOKENS.radius.card, color: STUDIO_TOKENS.ink })) }}>
          <div style={{ flex:1, minWidth:0, textShadow:'0 1px 3px rgba(0,0,0,0.45)', ...uvx({ textShadow: 'none' }) }}>
            <div style={{ fontSize:13, fontWeight:600 }}>{issues.length} snag{issues.length === 1 ? '' : 's'}{studioSep()}{openCount}{' open' + studioSep()}{highCount} high</div>
            <div style={{ fontSize:11.5, color:'rgba(255,255,255,0.85)', marginTop:2, ...uvx({ color: STUDIO_TOKENS.muted }) }}>Tap to wrap and route the list</div>
          </div>
          <span style={{ fontWeight:700, fontSize:13, padding:'9px 14px', borderRadius:11, flexShrink:0, background:'#fff', color:SNAG_TEAL, ...uvx(() => ({ ...studioType.action(), padding: '9px 0' })) }}>{`Report${studioArrow()}`}</span>
        </div>
      </div>

      <TabBar active={13} onChange={onNav} divisionId={div && div.id ? div.id : 'lighting'} />

      {/* Snag sheet */}
      {sheet === 'snag' && draft && (
        <SnagSheet
          job={job} draft={draft} setDraft={setDraft} draftNew={draftNew}
          addOwner={addOwner} setAddOwner={setAddOwner} ownerInput={ownerInput} setOwnerInput={setOwnerInput} commitOwner={commitOwner} onRemoveOwner={removeOwner}
          addLoc={addLoc} setAddLoc={setAddLoc} locInput={locInput} setLocInput={setLocInput} commitLoc={commitLoc}
          onClose={closeSheet} onSave={saveSnag} onRemove={removeSnag}
          onAddPhotos={addPhotosToDraft} onRemovePhoto={removeDraftPhoto}
          onStatus={(st) => setIssueStatus(draft.id, st)} onVerify={() => verifyClose(draft.id)} onAddAfter={addAfterPhoto}
          scanInfo={scanInfo} onScan={scanDefect}
        />
      )}

      <BurstCameraOverlay cam={cam} headerLabel={(captureRef.current && captureRef.current.mode === 'after') ? 'Fix photo' : ((captureRef.current && captureRef.current.area) ? ('Snag · ' + captureRef.current.area) : 'Snag photo')} />
    </div>
  );
};


// ── Snag capture / detail / close-out sheet ──
const SnagSheetBody = ({ job, draft, setDraft, draftNew, addOwner, setAddOwner, ownerInput, setOwnerInput, commitOwner, onRemoveOwner, addLoc, setAddLoc, locInput, setLocInput, commitLoc, onClose, onSave, onRemove, onAddPhotos, onRemovePhoto, onStatus, onVerify, onAddAfter, scanInfo, onScan }) => {
  const Lbl = ({ children, opt }) => studioCapture(
    <div style={{ fontSize:11.5, letterSpacing:'0.09em', textTransform:'uppercase', color:'#564A38', fontWeight:800, margin:'17px 0 9px', ...uvx(() => ({ ...studioType.colhead(), fontSize: 14 })) }}>{children}{opt && <span style={{ textTransform:'none', letterSpacing:0, color:t.colors.textSecondary, fontWeight:500 }}>{studioSep()}{opt}</span>}</div>
  );
  // Generic snag chip — selected fills sage-teal (--st-deep), the v3 .chip.on
  // treatment. Severity is the only place soft red/amber/green appears (inline
  // below); terracotta is never used here (it is the snag pin / type marker).
  // Under the theme the chip you are on is pressed in, the rest are raised
  // slips, and the dashed Add chips are actions written in violet text.
  const Chip = ({ on, onClick, children, style }) => studioCapture(
    <button onClick={onClick} style={Object.assign({ padding:'11px 16px', borderRadius:20, border:`1.5px solid ${on ? SNAG_TEAL : t.colors.separator}`, background: on ? SNAG_TEAL : t.colors.glass, color: on ? '#fff' : t.colors.text, fontSize:14.5, fontWeight: on ? 700 : 500, cursor:'pointer', fontFamily:'inherit' }, style || {}, uvx(() => (style && style.borderStyle === 'dashed' ? { ...studioSurface.slip(), color: STUDIO_TOKENS.violetText, fontWeight: 600, border: `1px dashed ${STUDIO_TOKENS.hairline}`, fontSize: 16 } : { ...(on ? studioSurface.pressed() : studioSurface.slip()), color: STUDIO_TOKENS.ink, fontWeight: on ? 700 : 400, fontSize: 16 }))) }>{children}</button>
  );
  const sv = SNAG_SEV[draft.sev] || SNAG_SEV.med;
  const closeoutOpen = !draftNew && draft.status !== 'Open';
  const history = (draft.history && draft.history.length) ? draft.history : [{ status: 'Open', at: draft.raisedAt || draft.history && draft.history[0] && draft.history[0].at }];
  // One ultraviolet main action: Verify and close out when the snag is Fixed,
  // otherwise Save or Update.
  const verifyIsMain = closeoutOpen && draft.status === 'Fixed';

  return (
    <SheetPortal>
      <div onClick={onClose} style={{ position:'fixed', inset:0, background:'rgba(58,48,24,0.4)', zIndex:199, ...uvx(() => ({ background: studioInk(0.45) })) }} />
      <div style={{ position:'fixed', left:0, right:0, bottom:0, background:'#FAF8F3', borderRadius:'22px 22px 0 0', zIndex:200, padding:'8px 18px calc(83px + env(safe-area-inset-bottom,0px))', maxHeight:'92%', overflowY:'auto', WebkitOverflowScrolling:'touch', ...uvx(() => ({ background: STUDIO_TOKENS.paper.css, boxShadow: STUDIO_TOKENS.shadow.raised })) }}>
        <div style={{ width:40, height:4, borderRadius:2, background:t.colors.separator, margin:'4px auto 12px' }} />
        <div style={{ display:'flex', alignItems:'center', marginBottom:8 }}>
          <div style={{ fontFamily:'Georgia, serif', fontSize:22, flex:1, color:t.colors.text, ...uvx(() => ({ ...studioType.heading(), fontSize: 25 })) }}>{draftNew ? 'New snag' : 'Snag'}</div>
          <button onClick={onClose} aria-label={t.theme === 'uv' ? 'Close' : undefined} style={{ width:38, height:38, borderRadius:11, background:t.colors.glass, border:'none', fontSize:17, color:t.colors.textSecondary, cursor:'pointer', ...uvx({ width: 44, height: 44, background: 'transparent', color: STUDIO_TOKENS.ink }) }}>✕</button>
        </div>

        {/* Photos — each captured photo carries its own prominent Scan trigger (Treatment A, S154) */}
        <Lbl>Photos</Lbl>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:8 }}>
          {(draft.photos || []).map(p => (
            <div key={p.id} style={{ display:'flex', flexDirection:'column' }}>
              <div style={{ position:'relative', width:'100%', aspectRatio:'1' }}>
                <MediaThumb photo={p} style={{ width:'100%', height:'100%', borderRadius:10, objectFit:'cover', display:'block' }} />
                <button onClick={() => onRemovePhoto(p.id)} aria-label={t.theme === 'uv' ? 'Remove photo' : undefined} style={{ position:'absolute', top:-6, right:-6, width:22, height:22, borderRadius:'50%', background:'rgba(0,0,0,0.6)', color:'#fff', border:'none', fontSize:11, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', ...uvx({ top: -16, right: -16, width: 44, height: 44, background: 'transparent' }) }}>{t.theme === 'uv' ? <span style={{ width:22, height:22, borderRadius:'50%', background:STUDIO_TOKENS.ink, color:STUDIO_TOKENS.onPrimary, fontSize:13, display:'flex', alignItems:'center', justifyContent:'center' }}>✕</span> : '✕'}</button>
              </div>
              <ScanTriggerButton onClick={() => onScan(p)}
                busy={scanInfo && scanInfo.running && scanInfo.photoId === (p.id || null)}
                error={scanInfo && scanInfo.error && scanInfo.photoId === (p.id || null) ? scanInfo.error : null} />
            </div>
          ))}
          <button onClick={onAddPhotos} style={{ width:'100%', aspectRatio:'1', borderRadius:10, border:`1.5px dashed ${SNAG_SKY_LINE}`, background:SNAG_SKY_BG, color:SNAG_SKY, display:'flex', alignItems:'center', justifyContent:'center', fontSize:22, cursor:'pointer', ...uvx({ background: STUDIO_TOKENS.pressed.fill, color: STUDIO_TOKENS.ink, fontSize: 25 }) }}>＋</button>
        </div>
        {(draft.photos || []).length > 0 && (
          <p style={{ fontSize:10.5, color:t.colors.textTertiary, margin:'9px 2px 0', lineHeight:1.4 }}>A scan proposes, you decide. A framed shot of the one defect reads best.</p>
        )}

        {/* Fault (required) */}
        <Lbl>What is wrong</Lbl>
        <textarea value={draft.fault} onChange={e => setDraft(d => Object.assign({}, d, { fault: e.target.value }))}
          placeholder="One line, plain English…"
          style={{ width:'100%', border:`1px solid ${t.colors.separator}`, borderRadius:12, background:t.colors.input, padding:14, fontFamily:'inherit', fontSize:15, lineHeight:1.5, minHeight:70, resize:'none', boxSizing:'border-box', color:t.colors.text }} />

        {/* Severity */}
        <div style={{ display:'flex', alignItems:'baseline', gap:10, flexWrap:'wrap' }}>
          <Lbl>Severity</Lbl>
          {scanInfo && scanInfo.conf && <VisionConfPill level={scanInfo.conf} />}
        </div>
        <div style={{ display:'flex', flexWrap:'wrap', gap:9 }}>
          {['high', 'med', 'low'].map(k => {
            const on = draft.sev === k;
            const sc = SNAG_SEV[k];
            return <button key={k} onClick={() => setDraft(d => Object.assign({}, d, { sev: k }))} style={{ padding:'11px 18px', borderRadius:20, border:`2px solid ${on ? sc.solid : t.colors.separator}`, background: on ? `linear-gradient(135deg, ${sc.g1}, ${sc.g2})` : t.colors.glass, color: on ? sc.text : t.colors.text, fontSize:14.5, fontWeight: on ? 800 : 500, cursor:'pointer', fontFamily:'inherit', ...uvx(() => ({ ...(on ? studioSurface.pressed() : studioSurface.slip()), color: STUDIO_TOKENS.ink, fontSize: 16, fontWeight: on ? 700 : 400 })) }}>{sc.label}</button>;
          })}
        </div>

        {/* Kind */}
        <Lbl opt="optional">Kind</Lbl>
        <div style={{ display:'flex', flexWrap:'wrap', gap:9 }}>
          {SNAG_KINDS.map(k => <Chip key={k.id} on={draft.kind === k.id} onClick={() => setDraft(d => Object.assign({}, d, { kind: k.id }))}>{k.label}</Chip>)}
        </div>

        {/* S153 — what the scan read, for context only. No home on the v3 sheet,
            so it is surfaced here and never written to a field (flagged in brief). */}
        {scanInfo && scanInfo.filled && (scanInfo.label || scanInfo.note) && (
          <div style={{ marginTop:16, padding:'11px 13px', borderRadius:11, background:'rgba(74,100,98,0.05)', border:'1px solid rgba(74,100,98,0.18)', ...uvx(() => ({ ...studioSurface.pressed(), borderRadius: STUDIO_TOKENS.radius.card })) }}>
            <FromPhotoTag />
            {scanInfo.label && <VisionGuessRow label="Label read" value={scanInfo.label} guess={false} />}
            {scanInfo.note && <div style={{ fontSize:11.5, color:'#7A6C5A', marginTop:4, lineHeight:1.4, fontStyle:'italic' }}>{scanInfo.note}</div>}
            <div style={{ fontSize:10.5, color:t.colors.textTertiary, marginTop:6 }}>Shown for context only. Type it into the fault line if it matters.</div>
          </div>
        )}

        {/* Location */}
        <Lbl>Location</Lbl>
        <div style={{ display:'flex', flexWrap:'wrap', gap:9 }}>
          {(job.areas || []).map(a => <Chip key={a} on={draft.area === a} onClick={() => setDraft(d => Object.assign({}, d, { area: a }))}>{a}</Chip>)}
          <Chip on={false} onClick={() => setAddLoc(true)} style={{ borderStyle:'dashed', borderColor:SNAG_SKY, color:SNAG_SKY, background:t.colors.glass }}>＋ Add</Chip>
        </div>
        {addLoc && (
          <div style={{ display:'flex', gap:8, marginTop:9 }}>
            <input value={locInput} onChange={e => setLocInput(e.target.value)} autoFocus placeholder="Name a location…"
              onKeyDown={e => { if (e.key === 'Enter') commitLoc(); }}
              style={{ flex:1, border:`1px solid ${t.colors.separator}`, borderRadius:11, background:t.colors.input, padding:'12px 14px', fontFamily:'inherit', fontSize:15, color:t.colors.text, outline:'none' }} />
            <button onClick={commitLoc} style={{ border:'none', borderRadius:11, background:SNAG_TEAL, color:'#fff', fontWeight:600, padding:'0 18px', cursor:'pointer', fontFamily:'inherit', ...uvx(() => ({ ...studioSurface.slip(), color: STUDIO_TOKENS.ink, borderRadius: STUDIO_TOKENS.button.radius, fontSize: 16 })) }}>Add</button>
          </div>
        )}

        {/* Owner */}
        <Lbl opt="who fixes it">Owner</Lbl>
        <div style={{ display:'flex', flexWrap:'wrap', gap:9 }}>
          {(job.owners || []).map(o => {
            const custom = SNAG_OWNER_DEFAULTS.indexOf(o) === -1;
            return (
              <div key={o} style={{ position:'relative', display:'inline-flex' }}>
                <Chip on={draft.owner === o} onClick={() => setDraft(d => Object.assign({}, d, { owner: o }))} style={custom ? { paddingRight: 26 } : null}>{o}</Chip>
                {custom && <button aria-label={'Remove ' + o} onClick={(e) => { e.stopPropagation(); onRemoveOwner(o); }} style={{ position:'absolute', top:-6, right:-6, width:20, height:20, borderRadius:'50%', background:'rgba(58,48,24,0.62)', color:'#fff', border:'none', fontSize:10, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', ...uvx({ top: -14, right: -14, width: 44, height: 44, background: 'transparent' }) }}>{t.theme === 'uv' ? <span style={{ width:20, height:20, borderRadius:'50%', background:STUDIO_TOKENS.ink, color:STUDIO_TOKENS.onPrimary, fontSize:13, display:'flex', alignItems:'center', justifyContent:'center' }}>✕</span> : '✕'}</button>}
              </div>
            );
          })}
          <Chip on={false} onClick={() => setAddOwner(true)} style={{ borderStyle:'dashed', borderColor:SNAG_SKY, color:SNAG_SKY, background:t.colors.glass }}>＋ Add</Chip>
        </div>
        {addOwner && (
          <div style={{ display:'flex', gap:8, marginTop:9 }}>
            <input value={ownerInput} onChange={e => setOwnerInput(e.target.value)} autoFocus placeholder="Name a person or company…"
              onKeyDown={e => { if (e.key === 'Enter') commitOwner(); }}
              style={{ flex:1, border:`1px solid ${t.colors.separator}`, borderRadius:11, background:t.colors.input, padding:'12px 14px', fontFamily:'inherit', fontSize:15, color:t.colors.text, outline:'none' }} />
            <button onClick={commitOwner} style={{ border:'none', borderRadius:11, background:SNAG_TEAL, color:'#fff', fontWeight:600, padding:'0 18px', cursor:'pointer', fontFamily:'inherit', ...uvx(() => ({ ...studioSurface.slip(), color: STUDIO_TOKENS.ink, borderRadius: STUDIO_TOKENS.button.radius, fontSize: 16 })) }}>Add</button>
          </div>
        )}

        {/* Close-out lifecycle (existing snags) */}
        {!draftNew && (
          <>
            <Lbl>Status</Lbl>
            <div style={{ display:'flex', gap:6 }}>
              {SNAG_STATUSES.map(st => {
                const on = draft.status === st;
                return <button key={st} onClick={() => onStatus(st)} style={{ flex:1, textAlign:'center', padding:'9px 4px', borderRadius:9, border:`1.5px solid ${on ? SNAG_TEAL : t.colors.separator}`, background: on ? SNAG_TEAL : t.colors.glass, color: on ? '#fff' : t.colors.textSecondary, fontSize:11.5, fontWeight: on ? 800 : 600, cursor:'pointer', fontFamily:'inherit', ...uvx(() => ({ ...(on ? studioSurface.pressed() : studioSurface.slip()), color: on ? STUDIO_TOKENS.ink : STUDIO_TOKENS.muted, fontSize: 14, fontWeight: on ? 700 : 400, borderRadius: STUDIO_TOKENS.button.radius })) }}>{st}</button>;
              })}
            </div>

            {closeoutOpen && (
              <>
                <Lbl>Before and after</Lbl>
                <div style={{ display:'flex', gap:10 }}>
                  <div style={{ flex:1 }}>
                    <span style={{ fontSize:11, fontWeight:700, letterSpacing:'0.04em', textTransform:'uppercase', color:t.colors.textSecondary, display:'block', marginBottom:6 }}>Before</span>
                    {(draft.photos || [])[0]
                      ? <MediaThumb photo={draft.photos[0]} style={{ width:'100%', aspectRatio:'1', borderRadius:12, objectFit:'cover', display:'block' }} />
                      : <div style={{ width:'100%', aspectRatio:'1', borderRadius:12, background:'linear-gradient(135deg,#b9c2bd,#8a958f)' }} />}
                  </div>
                  <div style={{ flex:1 }}>
                    <span style={{ fontSize:11, fontWeight:700, letterSpacing:'0.04em', textTransform:'uppercase', color:t.colors.textSecondary, display:'block', marginBottom:6 }}>After</span>
                    {(draft.afterPhotos || [])[0]
                      ? <MediaThumb photo={draft.afterPhotos[draft.afterPhotos.length - 1]} style={{ width:'100%', aspectRatio:'1', borderRadius:12, objectFit:'cover', display:'block' }} />
                      : <button onClick={onAddAfter} style={{ width:'100%', aspectRatio:'1', borderRadius:12, border:'1.5px dashed #5A9048', background:'rgba(90,144,72,0.12)', color:'#3E6B30', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', gap:4, fontSize:12, fontWeight:600, cursor:'pointer', fontFamily:'inherit', ...uvx({ color: STUDIO_TOKENS.violetText, fontSize: 14 }) }}><span style={{ fontSize:24 }}>＋</span>Add fix photo</button>}
                  </div>
                </div>

                <Lbl>History</Lbl>
                <div style={{ position:'relative' }}>
                  {history.map((e, i) => {
                    const now = i === history.length - 1;
                    return (
                      <div key={i} style={{ display:'flex', gap:13, padding:'0 0 16px', position:'relative' }}>
                        {t.theme !== 'uv' && i !== history.length - 1 && <span style={{ position:'absolute', left:6, top:15, bottom:-3, width:2, background:t.colors.separator }} />}
                        {t.theme === 'uv' ? null : <span style={{ width:14, height:14, borderRadius:'50%', flexShrink:0, marginTop:2, zIndex:1, background: now ? SNAG_TEAL : '#5A9048', boxShadow: now ? '0 0 0 4px rgba(74,100,98,0.15)' : 'none' }} />}
                        <div>
                          <b style={{ fontWeight:600, fontSize:14.5, color:t.colors.text, ...uvx({ fontSize: 16, fontWeight: now ? 700 : 400 }) }}>{e.status}</b>
                          <span style={{ fontSize:12, color:t.colors.textTertiary, display:'block' }}>{e.at ? new Date(e.at).toLocaleString('en-GB', { day:'numeric', month:'short', hour:'2-digit', minute:'2-digit' }) : ''}</span>
                        </div>
                      </div>
                    );
                  })}
                </div>

                {draft.status === 'Fixed' && (
                  <button onClick={onVerify} style={{ width:'100%', marginTop:4, padding:15, border:'none', borderRadius:13, background:'#5A9048', color:'#fff', fontFamily:'Georgia, serif', fontStyle:'italic', fontSize:17, cursor:'pointer', ...uvx(() => ({ ...studioSurface.primary(), fontFamily: STUDIO_TOKENS.fonts.body, fontStyle: 'normal' })) }}>Verify and close out</button>
                )}
              </>
            )}
          </>
        )}

        <div style={{ height:1, background:t.colors.separator, margin:'22px 0 0' }} />
        <button onClick={onSave} style={{ width:'100%', marginTop:16, padding:17, border:'none', borderRadius:14, background:SNAG_PRIMARY, color:'#fff', fontFamily:'Georgia, serif', fontStyle:'italic', fontSize:18, cursor:'pointer', boxShadow:'0 8px 22px -10px ' + SNAG_TEAL_SH, ...uvx(() => ({ ...(verifyIsMain ? { ...studioSurface.slip(), color: STUDIO_TOKENS.ink } : studioSurface.primary()), fontFamily: STUDIO_TOKENS.fonts.body, fontStyle: 'normal', fontSize: 16, fontWeight: 600 })) }}>{draftNew ? 'Save snag' : 'Update snag'}</button>
        {!draftNew && <button onClick={onRemove} style={{ width:'100%', marginTop:10, padding:13, border:'1px solid #C0483B', borderRadius:13, background:'none', color:'#7A271C', fontWeight:600, fontSize:14, cursor:'pointer', fontFamily:'inherit', ...uvx({ border: 'none', color: STUDIO_TOKENS.ink, fontSize: 16 }) }}>Remove this snag</button>}
      </div>
    </SheetPortal>
  );
};


// STUDIO-LIT-PHONE-V1 item 8a: A snag (#app/snag) with the switch on: the
// sheet over the list, photo first, then every field a tap (the prototype's
// .app-sheet and .app-opts). Same draft, same handlers, same saves as the
// sheet above. Eva's line shows only after the photo scan has filled the
// draft (the scan proposes the fault, how serious and the kind; the label it
// read and its note are context, never written to a field).
const SnagSheetLit = ({ job, draft, setDraft, draftNew, addOwner, setAddOwner, ownerInput, setOwnerInput, commitOwner, onRemoveOwner, addLoc, setAddLoc, locInput, setLocInput, commitLoc, onClose, onSave, onRemove, onAddPhotos, onRemovePhoto, onStatus, onVerify, onAddAfter, scanInfo, onScan }) => {
  const S = STUDIO_TOKENS;
  const set = (k) => (v) => setDraft((d) => Object.assign({}, d, { [k]: v }));
  const closeoutOpen = !draftNew && draft.status !== 'Open';
  const verifyIsMain = closeoutOpen && draft.status === 'Fixed';
  const history = (draft.history && draft.history.length) ? draft.history : [{ status: 'Open', at: draft.raisedAt || null }];
  const photos = draft.photos || [];
  const act = { ...studioType.action(), fontSize: 14, minHeight: 44, cursor: 'pointer', fontFamily: 'inherit' };
  const field = { width: '100%', boxSizing: 'border-box', ...studioSurface.pressed(), borderRadius: S.button.radius, padding: '12px 14px', fontFamily: S.fonts.body, fontSize: 16, lineHeight: 1.45, color: S.ink, outline: 'none' };
  const inline = (val, onChange, onCommit, placeholder) => (
    <div style={{ display: 'flex', gap: 8 }}>
      <input value={val} onChange={(e) => onChange(e.target.value)} autoFocus placeholder={placeholder}
        onKeyDown={(e) => { if (e.key === 'Enter') onCommit(); }} style={{ ...field, flex: 1, minWidth: 0, minHeight: 44, padding: '0 14px' }} />
      <button onClick={onCommit} style={{ minHeight: 44, padding: '0 16px', borderRadius: S.button.radius, ...studioSurface.slip(), color: S.ink, fontFamily: 'inherit', fontSize: 16, fontWeight: 600, cursor: 'pointer' }}>Add</button>
    </div>
  );
  const photoTile = (p, h) => (
    <div key={p.id} style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
      <div style={{ position: 'relative' }}>
        <SnagPic photo={p} h={h} radius={12} />
        <button onClick={() => onRemovePhoto(p.id)} aria-label="Remove photo" style={{ position: 'absolute', top: 0, right: 0, width: 44, height: 44, border: 'none', background: 'none', cursor: 'pointer', display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-end', padding: 6 }}>
          <span style={{ width: 22, height: 22, borderRadius: '50%', background: studioInk(0.6), color: S.onPrimary, fontSize: 13, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>✕</span>
        </button>
      </div>
      <ScanTriggerButton onClick={() => onScan(p)}
        busy={scanInfo && scanInfo.running && scanInfo.photoId === (p.id || null)}
        error={scanInfo && scanInfo.error && scanInfo.photoId === (p.id || null) ? scanInfo.error : null} />
    </div>
  );
  const addTile = (h) => (
    <button key="add" onClick={onAddPhotos} aria-label="Add a photo" style={{ height: h, borderRadius: 12, border: 'none', ...studioSurface.pressed(), color: S.ink, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" aria-hidden="true"><path d="M12 6v12M6 12h12"/></svg>
    </button>
  );
  const areaOpts = [{ key: '', label: 'Whole job' }].concat((job.areas || []).map((a) => ({ key: a, label: a })));
  if (draft.area && !(job.areas || []).includes(draft.area)) areaOpts.push({ key: draft.area, label: draft.area });
  const owners = (job.owners || []).map((o) => ({ key: o, label: o }));
  const customOwner = draft.owner && SNAG_OWNER_DEFAULTS.indexOf(draft.owner) === -1 && (job.owners || []).includes(draft.owner);
  return (
    <SheetPortal>
      <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: studioInk(0.32), zIndex: 199 }} />
      <section role="dialog" aria-label={draftNew ? 'New snag' : 'A snag'} style={{ position: 'fixed', left: 0, right: 0, bottom: 0, maxHeight: '90%', overflowY: 'auto', WebkitOverflowScrolling: 'touch', zIndex: 200, padding: '10px 20px calc(96px + env(safe-area-inset-bottom,0px))', borderRadius: '28px 28px 0 0', background: S.paper.css, boxShadow: S.shadow.raised, display: 'flex', flexDirection: 'column', gap: 14, fontFamily: S.fonts.body, color: S.ink, boxSizing: 'border-box' }}>
        <span aria-hidden="true" style={{ alignSelf: 'center', width: 44, height: 5, borderRadius: 3, background: studioInk(0.2), flexShrink: 0 }} />
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10 }}>
          <h2 style={{ ...studioType.heading(), fontSize: 25, margin: 0, minWidth: 0, overflowWrap: 'anywhere' }}>{draft.area || 'Whole job'}</h2>
          <button onClick={onClose} aria-label="Close" style={{ width: 44, height: 44, flexShrink: 0, borderRadius: 12, border: 'none', background: S.pressed.fill, color: S.ink, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>
          </button>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'minmax(0, 1fr) 96px', gap: 8, alignItems: 'start' }}>
          {photos.length ? photoTile(photos[0], 150) : addTile(150)}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {photos.slice(1).map((p) => photoTile(p, 70))}
            {photos.length ? addTile(70) : null}
          </div>
        </div>
        {scanInfo && scanInfo.filled && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            <p style={{ display: 'flex', gap: 6, alignItems: 'flex-start', fontSize: 16, lineHeight: 1.4, color: S.ink, margin: 0 }}>
              <span aria-label="Eva" style={{ display: 'inline-flex', marginTop: 3, color: S.violetText, flexShrink: 0 }}>
                <svg width="15" height="15" viewBox="0 0 20 20" aria-hidden="true"><circle cx="10" cy="10" r="9" fill="none" stroke="currentColor" strokeWidth="1.4" strokeDasharray="1.2 1.6" /><circle cx="10" cy="10" r="4.5" fill="currentColor" /></svg>
              </span>
              <span>I've filled in what I could from the photo. Change anything that's wrong.</span>
            </p>
            {scanInfo.label && <p style={{ fontSize: 14, color: S.muted, margin: 0 }}>{'The label reads "' + scanInfo.label + '".'}</p>}
            {scanInfo.note && <p style={{ fontSize: 14, color: S.muted, margin: 0 }}>{scanInfo.note}</p>}
          </div>
        )}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          <b style={{ fontSize: 14, fontWeight: 700 }}>What's wrong</b>
          <textarea value={draft.fault} onChange={(e) => set('fault')(e.target.value)} placeholder="One line, plain English…"
            style={{ ...field, minHeight: 64, resize: 'none' }} />
        </div>
        {snagOptsLit('How serious', [{ key: 'high', label: 'High' }, { key: 'med', label: 'Medium' }, { key: 'low', label: 'Low' }], draft.sev, set('sev'))}
        {snagOptsLit('Kind', SNAG_KINDS.map((k) => ({ key: k.id, label: k.label })), draft.kind, set('kind'))}
        {snagOptsLit('Where', areaOpts, draft.area || '', set('area'), 2)}
        <button onClick={() => setAddLoc(true)} style={{ ...act, alignSelf: 'flex-start', marginTop: -8 }}>Add a place</button>
        {addLoc && inline(locInput, setLocInput, commitLoc, 'Name a location…')}
        {snagOptsLit('Who fixes it', owners, draft.owner, set('owner'), owners.length > 4 ? 2 : null)}
        <div style={{ display: 'flex', gap: 18, flexWrap: 'wrap', marginTop: -8 }}>
          <button onClick={() => setAddOwner(true)} style={act}>Add someone</button>
          {customOwner && <button onClick={() => onRemoveOwner(draft.owner)} style={act}>{'Take ' + draft.owner + ' off the list'}</button>}
        </div>
        {addOwner && inline(ownerInput, setOwnerInput, commitOwner, 'Name a person or company…')}
        {!draftNew && snagOptsLit('Status', SNAG_STATUSES.map((s) => ({ key: s, label: s })), draft.status, onStatus)}
        {closeoutOpen && (
          <>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
              <b style={{ fontSize: 14, fontWeight: 700 }}>Before and after</b>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
                <SnagPic photo={photos[0]} h={120} radius={12} />
                {(draft.afterPhotos || []).length
                  ? <SnagPic photo={draft.afterPhotos[draft.afterPhotos.length - 1]} h={120} radius={12} />
                  : <button onClick={onAddAfter} style={{ ...studioType.action(), ...studioSurface.pressed(), height: 120, borderRadius: 12, fontSize: 14, cursor: 'pointer', fontFamily: 'inherit' }}>Add the fix photo</button>}
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <b style={{ fontSize: 14, fontWeight: 700, paddingBottom: 4 }}>History</b>
              {history.map((e, i) => (
                <div key={i} style={{ display: 'flex', justifyContent: 'space-between', gap: 12, padding: '9px 0', borderTop: `1px solid ${S.hairline}`, fontSize: 16 }}>
                  <span style={{ fontWeight: i === history.length - 1 ? 700 : 400 }}>{e.status}</span>
                  <span style={{ color: S.muted, fontSize: 14 }}>{e.at ? new Date(e.at).toLocaleString('en-GB', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }) : ''}</span>
                </div>
              ))}
            </div>
            {draft.status === 'Fixed' && <button onClick={onVerify} style={{ ...studioSurface.primary(), width: '100%', minHeight: 52, cursor: 'pointer', fontFamily: 'inherit' }}>Verify and close out</button>}
          </>
        )}
        <div style={{ display: 'flex', gap: 10, alignItems: 'center', justifyContent: 'space-between' }}>
          {!draftNew && <button onClick={onRemove} style={{ ...act, fontSize: 16 }}>Remove</button>}
          <button onClick={onSave} style={{ flex: 1, minHeight: 52, cursor: 'pointer', fontFamily: 'inherit', ...(verifyIsMain ? { ...studioSurface.slip(), color: S.ink, borderRadius: S.button.radius, fontSize: 16, fontWeight: 600 } : studioSurface.primary()) }}>{draftNew ? 'Save snag' : 'Update snag'}</button>
        </div>
      </section>
    </SheetPortal>
  );
};


// ════════════════════════════════════════════════════
// SCREEN 14: SNAG REPORT — warm, routed by owner, dispatched to /api/snags
// ════════════════════════════════════════════════════
const SnagReviewScreenBody = ({ onBack, onNav, snagId, currentUser }) => {
  const div = getDivisionConfig(currentUser);
  const [job, setJob] = useState(() => snagGet(snagId));
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  // B.2 — binding echo from the dispatch response: what the portal ACTUALLY
  // bound (post-canonicalisation). null until a live response arrives, so a
  // queued dispatch renders no echo line — honest silence, never a guess.
  const [echo, setEcho] = useState(null);

  if (!job) return <div style={{ padding:40, textAlign:'center', color:t.colors.textTertiary }}>Snag job not found</div>;

  const issues = job.issues || [];
  const openCount = issues.filter(snagIsOpen).length;
  const highCount = issues.filter(i => i.sev === 'high').length;
  const byOwner = {};
  issues.forEach(i => { const o = i.owner || 'Unassigned'; (byOwner[o] = byOwner[o] || []).push(i); });
  const owners = Object.keys(byOwner);

  const dispatch = async () => {
    setSending(true);
    const submittedAt = new Date().toISOString();
    const updated = Object.assign({}, snagGet(snagId) || job, { status: 'submitted', submittedAt });
    snagUpsert(updated);
    setJob(updated);

    // Map the v3 snag model onto the confirmed POST /api/snags contract. Photo
    // payloads carry the uploaded URL only (no base64 src) so the request stays
    // lean; the server strips photoData and counts severity === 'critical'.
    const payload = {
      id: job.id,
      projectName: job.projectName || '',
      clientName: job.clientName || '',
      status: 'submitted',
      submittedAt,
      isUnlinked: !!job.isUnlinked,
      // B.2 Slice 2 — capture-time binding. The picked canonical PRJ-XXXX,
      // or EXPLICIT null when unchosen / "No project" — unbound must be
      // visibly deliberate on the wire (never omit). queueWrite carries the
      // payload verbatim, so a queued snag keeps its project_id unchanged.
      project_id: (() => {
        const _b = getProjectBinding(job);
        return (_b && _b.project_id) ? _b.project_id : null;
      })(),
      issues: issues.map(i => ({
        type: i.kind || 'defect',
        severity: SNAG_SEV_DISPATCH[i.sev] || 'minor',
        description: i.fault || '',
        zone: i.area || '',
        owner: i.owner || '',
        status: i.status || 'Open',
        raisedAt: i.raisedAt || submittedAt,
        photoUrl: snagFirstUrl(i),
        photoCount: (i.photos || []).length,
      })),
    };

    // B.2 Slice 4 (D1c) — the unlinked-snag /api/leads call is RETIRED.
    // An unlinked snag is simply a No-project snag: it dispatches unbound
    // (isUnlinked + the payload above are unchanged - the standalone inbox
    // feed relies on them) and stays routable from the portal inbox. New
    // field prospects go through "+ New project" in the binding sheet
    // (POST /api/companion/projects), which returns a real PRJ id to bind.
    // Retirement loss (made visible, not silent): the lead row in
    // companion_leads and the portal-side fuzzy contact upsert no longer
    // happen for unlinked snags.

    try {
      // B.2 — Bearer identity, matching the /api/survey-wrap header pattern.
      // Additive: origin fallback stays portal-side; sending the token is
      // what gets submitted_by recorded. (Queued replays already attach it
      // inside flushOfflineQueue.)
      const _snagToken = localStorage.getItem('lumen_token');
      const r = await fetch(`${PORTAL_URL}/api/snags`, {
        method:'POST',
        headers: Object.assign({ 'Content-Type':'application/json' }, _snagToken ? { 'Authorization': `Bearer ${_snagToken}` } : {}),
        body: JSON.stringify(payload),
      });
      bearerRefused(r.status, _snagToken, 'snag');   // track C: a 401 ends the sign-in; the snag is queued below
      if (!r.ok) throw new Error('HTTP ' + r.status);
      // B.2 — binding echo: bound / bound_project_id, post-canonicalisation.
      // Parsed in its OWN try: the server already accepted this payload, so
      // a malformed body must never fall through to the catch below — that
      // would queueWrite a duplicate for replay. No echo = silent success.
      let _echoData = null;
      try { _echoData = await r.json(); } catch (e2) {}
      if (_echoData && typeof _echoData === 'object') {
        const _e = { bound: _echoData.bound === true, boundProjectId: _echoData.bound_project_id || null, sentProjectId: payload.project_id || null };
        setEcho(_e);
        // Store what the portal confirmed on the job (echo truth, never the
        // sent value) — same convention as the survey's _portalBound* fields.
        snagUpsert(Object.assign({}, snagGet(snagId) || updated, { _portalBound: _e.bound, _portalBoundProjectId: _e.boundProjectId }));
      }
      debugLog('snag.dispatch.ok', { id: job.id, issues: issues.length, bound: !!(_echoData && _echoData.bound === true) });
    } catch (e) { debugLog('snag.dispatch.queue', { error: (e && e.message) || String(e) }); queueWrite('/api/snags', payload); }

    setSending(false);
    setSent(true);
  };

  if (sent) {
    return (
      <div style={{ flex:1, overflowY:'auto', background:'linear-gradient(160deg,#E4ECEB,#F4EFE5 45%,#D1B79D)', display:'flex', flexDirection:'column', padding:'30px 24px', overscrollBehavior:'contain', ...uvx({ background: 'transparent', padding: '30px 24px 130px' }) }}>
        <div style={{ width:52, height:52, borderRadius:'50%', background:'rgba(90,144,72,0.18)', color:'#5A9048', display:'flex', alignItems:'center', justifyContent:'center', fontSize:26, marginBottom:16, ...uvx(() => ({ ...studioSurface.pressed(), borderRadius: '50%', color: STUDIO_TOKENS.ink })) }}>✓</div>
        <h2 style={{ fontFamily:'Georgia, serif', fontStyle:'italic', fontSize:28, color:t.colors.text, marginBottom:8, ...uvx(() => ({ ...studioType.title(), fontSize: 39, marginBottom: 8 })) }}>List routed</h2>
        <p style={{ fontSize:14, color:t.colors.textSecondary, lineHeight:1.5, marginBottom:8 }}>Each owner has their own items, and the portal has the full list ready to turn into emails.{job.isUnlinked ? ' A pipeline lead was created too.' : ''}</p>
        {/* B.2 — binding echo (shared lines, Slice 1 copy): "Linked to PRJ-X"
            only when the portal CONFIRMED; the couldn't-link line when a sent
            id was refused; nothing when queued / unbound. Never pretend. */}
        <div style={{ marginBottom:24 }}>
          <BindingEchoLines echo={echo} align="left" />
        </div>
        <div style={{ fontSize:11, letterSpacing:'0.1em', textTransform:'uppercase', color:t.colors.textTertiary, fontWeight:600, marginBottom:11 }}>By owner</div>
        {owners.map(o => (
          <div key={o} style={{ background:t.colors.glass, border:`1px solid ${t.colors.glassBorder}`, borderRadius:14, padding:15, marginBottom:10, display:'flex', alignItems:'center', gap:13, ...uvx(() => ({ ...studioSurface.slip(), borderRadius: STUDIO_TOKENS.radius.card })) }}>
            <span style={{ fontFamily:'Georgia, serif', fontSize:22, color:SNAG_TEAL, width:34, textAlign:'center', ...uvx({ fontSize: 25 }) }}>{byOwner[o].length}</span>
            <div style={{ flex:1 }}>
              <b style={{ fontWeight:600, fontSize:16, color:t.colors.text, ...uvx({ fontWeight: 700 }) }}>{o}</b>
              <span style={{ fontSize:12.5, color:t.colors.textTertiary, display:'block' }}>{byOwner[o].length} item{byOwner[o].length === 1 ? '' : 's'} routed</span>
            </div>
            <span style={{ fontSize:12, fontWeight:600, color:'#3E6B30', background:'rgba(90,144,72,0.16)', padding:'5px 11px', borderRadius:18, ...uvx({ background: 'transparent', padding: 0, color: STUDIO_TOKENS.ink, fontSize: 14 }) }}>Sent</span>
          </div>
        ))}
        <button onClick={() => onNav(10)} style={{ textAlign:'center', marginTop:14, color:'#3E6B30', fontWeight:600, fontSize:14, background:'none', border:'none', cursor:'pointer', fontFamily:'inherit', ...uvx(() => ({ ...studioSurface.primary(), marginTop: 14 })) }}>Back to the list</button>
        <TabBar active={14} onChange={onNav} divisionId={div && div.id ? div.id : 'lighting'} />
      </div>
    );
  }

  // STUDIO-LIT-PHONE-V1 item 8a: Send and route (#app/route) with the switch
  // on: who gets what, as it will travel. Open snags by owner (ours first),
  // then the fixed ones, kept on the record. The payload is unchanged: every
  // snag on the job is sent, as before.
  if (t.theme === 'uv') {
    const drawLit = () => {
      const S = STUDIO_TOKENS; const M = STUDIO_MEANING;
      const open = issues.filter((i) => !snagIsClosed(i));
      const fixed = issues.filter(snagIsClosed);
      const by = {};
      open.forEach((i) => { const o = i.owner || ''; (by[o] = by[o] || []).push(i); });
      const order = Object.keys(by).sort((a, b) => (a === 'Our team' ? -1 : b === 'Our team' ? 1 : a === '' ? 1 : b === '' ? -1 : a.localeCompare(b)));
      const rowLit = (i, closed) => {
        const sv = snagSevLit(i.sev);
        return (
          <div key={i.id} style={{ display: 'grid', gridTemplateColumns: '64px minmax(0, 1fr)', gap: 12, alignItems: 'center', padding: '8px 0', borderTop: `1px solid ${S.hairline}` }}>
            <SnagPic photo={(i.photos || [])[0]} h={48} radius={9} />
            <span style={{ display: 'flex', flexDirection: 'column', gap: 1, minWidth: 0 }}>
              <b style={{ fontSize: 16, fontWeight: 600, overflowWrap: 'anywhere' }}>{i.fault || 'Snag'}</b>
              <span style={{ fontSize: 14, color: S.muted }}>{i.area || 'Whole job'}{closed ? '' : <>{', '}<span style={{ color: sv.color, fontWeight: sv.fontWeight }}>{sv.word}</span></>}</span>
            </span>
          </div>
        );
      };
      const grp = (key, title, sub, list, ours, closed) => (
        <section key={key} style={{ display: 'flex', flexDirection: 'column', opacity: closed ? 0.8 : 1 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 10, paddingBottom: 4 }}>
            <h2 style={{ ...studioType.heading(), fontSize: 20, margin: 0, minWidth: 0, overflowWrap: 'anywhere' }}>{title}</h2>
            <span style={{ fontSize: 14, color: ours ? M.rustText : S.muted, fontWeight: ours ? 700 : 400, flexShrink: 0 }}>{sub}</span>
          </div>
          {list.map((i) => rowLit(i, closed))}
        </section>
      );
      return (
        <div style={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column', fontFamily: S.fonts.body, color: S.ink }}>
          <div style={{ flex: 1, overflowY: 'auto', WebkitOverflowScrolling: 'touch', overscrollBehavior: 'contain', padding: '4px 20px 130px', display: 'flex', flexDirection: 'column', gap: 16 }}>
            <div style={{ minHeight: 46, display: 'flex', alignItems: 'center' }}><SnagBack label="Snag list" onClick={() => onNav(13, { snagId })} /></div>
            <div>
              <h1 style={{ ...studioType.title(), fontSize: 31, lineHeight: 1.06 }}>Send and route</h1>
              <p style={{ fontSize: 16, color: S.muted, lineHeight: 1.45, marginTop: 4, overflowWrap: 'anywhere' }}>{(job.projectName || 'Snag list') + (job.clientName ? ', ' + job.clientName : '') + '. '}{open.length > 0 && <span style={{ color: M.rustText, fontWeight: 600 }}>Snags open</span>}</p>
            </div>
            {!issues.length && <p style={{ fontSize: 16, color: S.muted }}>There's nothing to send yet. Add a snag first.</p>}
            {order.map((o) => grp(o || '__none__', o || 'No owner yet', by[o].length + ' to fix', by[o], o === 'Our team', false))}
            {fixed.length > 0 && grp('__fixed__', 'Fixed', 'Kept on the record', fixed, false, true)}
            <button onClick={dispatch} disabled={sending || !issues.length} style={{ ...studioSurface.primary(), width: '100%', minHeight: 56, borderRadius: 14, cursor: (sending || !issues.length) ? 'default' : 'pointer', opacity: (sending || !issues.length) ? 0.5 : 1, fontFamily: 'inherit' }}>{sending ? 'Sending' : 'Send and route'}</button>
          </div>
          <TabBar active={14} onChange={onNav} divisionId={div && div.id ? div.id : 'lighting'} />
        </div>
      );
    };
    return <SnagLitBody draw={drawLit} />;
  }

  return (
    <div style={{ flex:1, overflow:'hidden', background:'linear-gradient(160deg,#E4ECEB,#F4EFE5 45%,#D1B79D)', display:'flex', flexDirection:'column', ...uvx({ background: STUDIO_TOKENS.ground.css }) }}>
      <NavBar title="Snag report" onBack={() => onNav(13, { snagId })} />
      <div style={{ flex:1, overflowY:'auto', WebkitOverflowScrolling:'touch', overscrollBehavior:'contain', padding:'14px 18px 120px' }}>
        {/* Warm hero summary */}
        <div style={{ background:'linear-gradient(145deg, rgba(228,236,235,0.85), rgba(255,252,242,0.92))', border:`1px solid rgba(74,100,98,0.18)`, borderRadius:18, padding:20, marginBottom:16, ...uvx(() => ({ ...studioSurface.pressed(), borderRadius: STUDIO_TOKENS.radius.card })) }}>
          <div style={{ fontFamily:'Georgia, serif', fontStyle:'italic', fontSize:25, color:t.colors.text, ...uvx(() => ({ ...studioType.heading(), fontSize: 25 })) }}>{job.projectName}</div>
          <div style={{ fontSize:13, color:t.colors.textSecondary, marginTop:2 }}>{job.mode === 'project' && job.clientName ? job.clientName + studioSep(' · ') + 'linked install' : 'Standalone snag list'}</div>
          <div style={{ display:'flex', gap:16, marginTop:14, ...uvx({ alignItems: 'flex-end', gap: 24 }) }}>
            <div><div style={{ fontFamily:'Georgia, serif', fontSize:26, color:SNAG_TEAL, ...uvx(() => ({ ...studioType.display(), fontSize: 84 })) }}>{issues.length}</div><div style={{ fontSize:11, color:t.colors.textTertiary, textTransform:'uppercase', letterSpacing:'0.06em', fontWeight:600 }}>Snags</div></div>
            <div><div style={{ fontFamily:'Georgia, serif', fontSize:26, color:'#7A271C', ...uvx(() => ({ ...studioType.title(), fontSize: 31 })) }}>{highCount}</div><div style={{ fontSize:11, color:t.colors.textTertiary, textTransform:'uppercase', letterSpacing:'0.06em', fontWeight:600 }}>High</div></div>
            <div><div style={{ fontFamily:'Georgia, serif', fontSize:26, color:'#3E6B30', ...uvx(() => ({ ...studioType.title(), fontSize: 31 })) }}>{issues.length - openCount}</div><div style={{ fontSize:11, color:t.colors.textTertiary, textTransform:'uppercase', letterSpacing:'0.06em', fontWeight:600 }}>Closed</div></div>
          </div>
        </div>

        {!issues.length && (
          <div style={{ textAlign:'center', color:t.colors.textSecondary, padding:'24px 10px', fontSize:13 }}>No snags to route yet. Add at least one before sending.</div>
        )}

        {/* By owner */}
        {owners.length > 0 && <div style={{ fontSize:11, letterSpacing:'0.1em', textTransform:'uppercase', color:t.colors.textTertiary, fontWeight:600, margin:'2px 2px 11px' }}>By owner</div>}
        {owners.map(o => {
          const items = byOwner[o];
          const openN = items.filter(snagIsOpen).length;
          return (
            <div key={o} style={{ background:t.colors.glass, border:`1px solid ${t.colors.glassBorder}`, borderRadius:14, padding:'14px 15px', marginBottom:10, ...uvx(() => ({ ...studioSurface.raised(), borderRadius: STUDIO_TOKENS.radius.card })) }}>
              <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                <span style={{ fontFamily:'Georgia, serif', fontSize:22, color:SNAG_TEAL, width:30, textAlign:'center', ...uvx({ fontSize: 25 }) }}>{items.length}</span>
                <div style={{ flex:1, minWidth:0 }}>
                  <b style={{ fontWeight:600, fontSize:16, color:t.colors.text, ...uvx({ fontWeight: 700 }) }}>{o}</b>
                  <span style={{ fontSize:12, color:t.colors.textTertiary, display:'block' }}>{items.length} item{items.length === 1 ? '' : 's'}{studioSep()}{openN} open</span>
                </div>
              </div>
              <div style={{ marginTop:10, display:'flex', flexDirection:'column', gap:6 }}>
                {items.map(i => {
                  const sv = SNAG_SEV[i.sev] || SNAG_SEV.med;
                  return (
                    <div key={i.id} style={{ display:'flex', alignItems:'center', gap:9, padding:'8px 10px', borderRadius:10, background:`linear-gradient(135deg, ${sv.g1}, ${sv.g2})`, border:`1px solid ${sv.border}`, ...uvx({ background: 'transparent', border: 'none', borderTop: `1px solid ${STUDIO_TOKENS.hairline}`, borderRadius: 0 }) }}>
                      <span style={{ width:8, height:8, borderRadius:'50%', background:sv.dot, flexShrink:0 }} />
                      <span style={{ flex:1, minWidth:0, fontSize:13, fontWeight:600, color:t.colors.text, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', ...uvx({ fontSize: 14 }) }}>{i.fault || 'Snag'}</span>
                      <span style={{ fontSize:11, color:i.area ? t.colors.textSecondary : t.colors.textTertiary }}>{i.area || 'Job-wide'}</span>
                      <span style={{ fontSize:11, fontWeight:600, color: snagStatusColor(i.status) }}>{t.theme === 'uv' ? `${sv.label}, ${i.status}` : i.status}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>

      <div style={{ position:'fixed', left:14, right:14, bottom:'calc(72px + env(safe-area-inset-bottom,0px))', zIndex:18 }}>
        <button onClick={dispatch} disabled={sending || !issues.length}
          style={{ width:'100%', padding:16, border:'none', borderRadius:15, background: (sending || !issues.length) ? SNAG_TEAL_SOFT : 'linear-gradient(135deg, #4A6462, #3a514f)', color:'#fff', fontFamily:'Georgia, serif', fontStyle:'italic', fontSize:18, cursor: (sending || !issues.length) ? 'default' : 'pointer', boxShadow:'0 14px 32px -12px ' + SNAG_TEAL_SH, ...uvx(() => ({ ...studioSurface.primary(), fontFamily: STUDIO_TOKENS.fonts.body, fontStyle: 'normal', opacity: (sending || !issues.length) ? 0.5 : 1 })) }}>
          {sending ? 'Routing…' : <>Send <span style={{ color:SNAG_GOLD }}>&amp;</span> route</>}
        </button>
      </div>

      <TabBar active={14} onChange={onNav} divisionId={div && div.id ? div.id : 'lighting'} />
    </div>
  );
};


// ════════════════════════════════════════════════════
// SCREEN 5: ON-SITE PROPOSAL — REMOVED (S81 Batch 2)
// ════════════════════════════════════════════════════
const ProposalScreen = ({ onBack, onNav, currentUser, activeProject, proposals, onSaveProposal, fromSurvey, onUpdateProject, onSendToPortal, portalStatus, allProjects, setActiveProject }) => {
  // Screen deleted per design review — redirects to survey landing
  useEffect(() => { onNav(10); }, []);
  return null;
};

// ── Proposal History Card ───────────────────────────
const ProposalCard = ({ prop, divColor, divColorLight, divBorder, onToggleWon, onOpen }) => {
  const tierColors = { Value: t.colors.blue, Standard: divColor, Premium: t.colors.purple };
  const tc = tierColors[prop.tier] || divColor;
  // S95 D21 — single shared currency formatter
  const fmt = (n) => (Number(n) > 0 ? formatCurrency(n) : "—");
  const fmtPayback = (n) => n > 0 ? `${n}y` : "—";
  return (
    <GlassCard style={{ padding: 0, marginBottom: 10, overflow: "hidden" }} hover={!!onOpen}>
      {/* Tappable header — opens project */}
      <button onClick={() => onOpen && onOpen(prop)} style={{ width: "100%", background: "none", border: "none", cursor: onOpen ? "pointer" : "default", textAlign: "left", padding: "14px 16px 10px", display: "block" }}>
        <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: 8 }}>
          <div style={{ flex: 1, minWidth: 0 }}>
            <p style={{ fontSize: 15, fontWeight: 800, color: t.colors.text, letterSpacing: -0.3, fontFamily: "system-ui, -apple-system, sans-serif", marginBottom: 2 }}>{prop.projectName}</p>
            {prop.projectClient && <p style={{ fontSize: 12, color: t.colors.textSecondary }}>{prop.projectClient}</p>}
            <div style={{ display: "flex", gap: 8, alignItems: "center", marginTop: 3 }}>
              <p style={{ fontSize: 11, color: t.colors.textTertiary }}>{prop.date}</p>
              {prop.zonesLogged > 0 && <span style={{ fontSize: 11, color: t.colors.textTertiary }}>· {prop.zonesLogged} zone{prop.zonesLogged !== 1 ? "s" : ""}</span>}
              {prop.unitsLogged > 0 && <span style={{ fontSize: 11, color: t.colors.textTertiary }}>· {prop.unitsLogged} units</span>}
            </div>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <Pill label={prop.tierLabel || prop.tier} color={tc} small />
            {onOpen && <Icon name="chevron-right" size={14} color={t.colors.textTertiary} />}
          </div>
        </div>
      <div style={{ padding: "0 16px 12px", display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8 }}>
        {[
          { label: "CAPEX", value: fmt(prop.capex), color: t.colors.text },
          { label: "Saving/yr", value: fmt(prop.saving), color: t.colors.green },
          { label: "Payback", value: fmtPayback(prop.payback), color: t.colors.blue },
        ].map(s => (
          <div key={s.label} style={{ textAlign: "center", padding: "8px 4px", background: t.colors.glass, borderRadius: t.radius.md }}>
            <p style={{ fontSize: 14, fontWeight: 800, color: s.color, fontFamily: "system-ui, -apple-system, sans-serif" }}>{s.value}</p>
            <p style={{ fontSize: 11, color: t.colors.textSecondary, textTransform: "uppercase", letterSpacing: 0.4, fontWeight: 600, marginTop: 3 }}>{s.label}</p>
          </div>
        ))}
      </div>
      </button>
      <div style={{ padding: "0 16px 14px" }}>
      <button onClick={() => onToggleWon(prop.id)} style={{
        width: "100%", padding: "8px 14px", borderRadius: t.radius.md, cursor: "pointer",
        background: prop.won ? "rgba(74,222,128,0.1)" : t.colors.glass,
        border: prop.won ? `0.5px solid rgba(74,222,128,0.3)` : `0.5px solid ${t.colors.glassBorder}`,
        color: prop.won ? t.colors.green : t.colors.textTertiary,
        fontSize: 12, fontWeight: 700, transition: "all 0.2s ease",
        display: "flex", alignItems: "center", justifyContent: "center", gap: 6,
      }}>
        <Icon name="check" size={14} color={prop.won ? t.colors.green : t.colors.textTertiary} />
        {prop.won ? "Marked as Won" : "Mark as Won"}
      </button>
      </div>
    </GlassCard>
  );
};

// STUDIO-LIT-PHONE-V1: a served pipeline row's stage words with its odds (the
// prototype's sw()), coloured by meaning. Today's visit rows and Pipeline's job
// rows read this one rule. A sent quote is Quoted, with the odds the portal
// holds (confidence stops 10, 25, 50, 75, 90: 75 and up strong, 50 even, under
// 50 low, as the desk's Pipeline reads them). A quote still being built has no
// stage word: which live stage is New is DEC-1, not decided here.
const studioQuoteStage = (q) => {
  const M = STUDIO_MEANING;
  if (!q) return null;
  if (q.won || q.status === 'won') return { word: 'Won', c: M.wonText, fill: M.wonFill };
  if (q.lost || q.status === 'lost') return { word: 'Lost', c: M.slateText, fill: M.slateFill };
  if (!['sent', 'quoted', 'pending'].includes(String(q.status || '').toLowerCase())) return null;
  const o = truthNumber(q.odds);
  if (o != null && o >= 75) return { word: 'Quoted, strong odds', c: M.strongText, fill: M.strongFill };
  if (o === 50) return { word: 'Quoted, even odds', c: M.quotedText, fill: M.quotedFill };
  return { word: o == null ? 'Quoted, no odds yet' : 'Quoted, low odds', c: M.quotedText, fill: M.quotedFill };
};
// The switch-on Pipeline is drawn from the lit tokens already, so it sits in
// its own component: studioDesk's auto-mapper (which restyles the legacy
// switch-off markup) walks elements, not what a component renders, and would
// otherwise read Eva's light jewel text as a stray light colour and ink it.
const PipelineLitBody = ({ draw }) => draw();
// Three-letter months, as the prototype writes them (the browser's en-GB short
// month is "Sept" in newer engines and "Sep" in older ones).
const PL_MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// ════════════════════════════════════════════════════
// SCREEN 13: PIPELINE (full rebuild S73)
// ════════════════════════════════════════════════════
const PipelineScreen = ({ onNav, currentUser, proposals, onSaveProposal }) => {
  const div = getDivisionConfig(currentUser);
  const userId = currentUser?.id;

  // ── Portal pipeline data (cached) ──
  const portalPipeline = getPortalData('lumen_pipeline', null);
  const pipelineLoading = !localStorage.getItem('lumen_pipeline');

  // Pull-to-refresh state
  const [pullY, setPullY] = React.useState(0);
  const [isPulling, setIsPulling] = React.useState(false);
  const [isSyncing, setIsSyncing] = React.useState(false);
  const pullRef = React.useRef({ startY: 0, active: false });

  const handlePullStart = (e) => { pullRef.current = { startY: e.touches[0].clientY, active: true }; };
  const handlePullMove = (e) => {
    if (!pullRef.current.active) return;
    const scrollEl = e.currentTarget;
    if (scrollEl.scrollTop > 0) return;
    const dist = e.touches[0].clientY - pullRef.current.startY;
    if (dist > 0 && dist < 80) { setPullY(dist); setIsPulling(true); }
  };
  const handlePullEnd = async () => {
    if (isPulling && pullY > 60) {
      setIsSyncing(true);
      await syncPortalData();
      setIsSyncing(false);
    }
    setPullY(0);
    setIsPulling(false);
    pullRef.current.active = false;
  };

  // ── Normalise proposal status ──
  // Track 3e: the one definition, quoteStatusOf (above ContactsScreen), shared with Contacts.
  const getStatus = quoteStatusOf;

  const allProps = (proposals || []).filter(p => p.division === div.id || !p.division);
  const excluded = (proposals || []).length - allProps.length;
  if (excluded > 0) console.log(`[Pipeline] Excluded ${excluded} other-division quote(s) from ${div.id} view`);
  const active = allProps.filter(quoteIsOpen);
  const pipelineValue = active.reduce((s,p) => s + parseFloat(p.capex || p.value || p.totalValue || 0), 0);
  const wonProps = allProps.filter(p => getStatus(p) === 'won');
  // COMPANION-TRUTH-V2 B5: the stats tiles read the kernel's figures, never
  // the phone's own sums. WON YTD is D4 and D5 mine over the financial year
  // (won_fy, won_fy_count) with D20, the blended margin over those won jobs
  // (DECISIONS 176.140); QUOTES YTD is D8 mine over the financial year
  // (quotes_built_fy), and its £ quoted is D22 over exactly those jobs
  // (quoted_fy.value, DECISIONS 176.158), the dash when missing;
  // AVG DEAL is D14 (avg_won), the dash while withheld. Missing: the dash.
  const wonYTD = truthPipelineFigure('won_fy');
  const wonYTDCount = truthPipelineFigure('won_fy_count');
  const wonYTDMargin = truthGroupMargin(truthWonMargin());
  const avgDeal = truthPipelineFigure('avg_won', 'avg_won_withheld');
  const quotesYTDCount = truthQuotesBuiltFy();
  const quotesYTDValue = truthQuotedFyValue();
  // COMPANION-TRUTH-V1 (b): quotes out is the portal's D10 count, mine; null
  // when the figures were never fetched. COMPANION-TRUTH-V2 B5 (DECISIONS
  // 176.133): the £ beside it is D19, waiting.value, the dash when missing.
  const awaitingCount = truthWaitingCount();
  const awaitingValue = truthWaitingValue();

  // S95 D21 — single shared currency formatter; "—" for empty
  const fmt = (v) => (Number(v) > 0 ? formatCurrency(v) : '—');

  // Stage counts (the live statuses, quoteIsLive: quoting, quoted and sent, merged into ACTIVE for funnel)
  const stageCount = {
    active: allProps.filter(p => quoteIsLive(getStatus(p))).length,
    won:    wonProps.length,
    lost:   allProps.filter(p => getStatus(p) === 'lost').length,
  };

  // Stage filter
  const [stageFilter, setStageFilter] = useState(null);
  const [expandedZone, setExpandedZone] = useState(null);
  // COMPANION-STUDIO-LIT-V1 track 3b: the quote whose chase sheet is open
  // (Chase in "No reply in over a week"; switch on only).
  const [chaseItem, setChaseItem] = useState(null);

  // Month navigation
  const [selectedMonth, setSelectedMonth] = useState(() => {
    const now = new Date();
    return { year: now.getFullYear(), month: now.getMonth() };
  });

  // Search
  const [searchQuery, setSearchQuery] = useState('');

  // Consume pipeline hint from Company Pulse actions
  useEffect(() => {
    try {
      const hint = JSON.parse(localStorage.getItem('lumen_pipeline_hint') || 'null');
      if (hint) {
        if (hint.month != null && hint.year) setSelectedMonth({ year: hint.year, month: hint.month });
        if (hint.search) setSearchQuery(hint.search);
        localStorage.removeItem('lumen_pipeline_hint');
      }
    } catch(e) {}
  }, []);

  // Heat scoring
  const heatCards = active.filter(p => {
    const opens = parseInt(p.opens || 0);
    return opens >= 1;
  }).map(p => {
    const opens = parseInt(p.opens || 0);
    const lastOpened = p.lastOpened ? new Date(p.lastOpened) : null;
    const now2 = Date.now();
    const openedToday = lastOpened && (now2 - lastOpened.getTime()) < 86400000;
    const within48h = lastOpened && (now2 - lastOpened.getTime()) < 172800000;
    const within7d = lastOpened && (now2 - lastOpened.getTime()) < 604800000;
    const timeOnPage = parseInt(p.timeOnPage || 0);
    const returns = parseInt(p.returns || 0);
    const engagementScore = (opens * 15) + (timeOnPage * 2) + (returns * 25);
    let tier = 'warm';
    if (openedToday && opens >= 2) tier = 'burning';
    else if (opens >= 2 && within48h) tier = 'hot';
    else if (opens >= 1 && within7d) tier = 'warm';
    return { ...p, tier, engagementScore, opens, timeOnPage, lastOpened, openedToday };
  }).sort((a,b) => {
    const tierOrder = { burning: 0, hot: 1, warm: 2 };
    return (tierOrder[a.tier] || 2) - (tierOrder[b.tier] || 2);
  });

  // Silent proposals. COMPANION-TRUTH-V1 (b): the portal's D10 jobs (waiting
  // on you, oldest silence first), so the rows agree with the count. Their £
  // total is D19 (DECISIONS 176.133), the kernel's sum, never the phone's.
  const silentProps = truthWaitingRows(proposals);
  const silentValue = awaitingValue;

  // Status pill styles
  const statusPillStyle = {
    quoted: { bg: 'linear-gradient(135deg,rgba(26,90,120,0.18),rgba(26,90,120,0.06))', color: '#1A5A78' },
    sent:   { bg: 'linear-gradient(135deg,rgba(200,144,48,0.18),rgba(200,100,30,0.06))', color: '#C89030' },
    won:    { bg: 'linear-gradient(135deg,rgba(46,104,56,0.18),rgba(46,104,56,0.06))', color: '#2E6838' },
    lost:   { bg: 'linear-gradient(135deg,rgba(106,88,64,0.15),rgba(106,88,64,0.05))', color: '#6A5840' },
  };

  const stageLabels = {
    quoted: 'Quoted' + studioDash() + 'built in portal, not yet sent',
    sent:   'Sent' + studioDash() + 'awaiting client response',
    won:    'Won' + studioDash() + 'closed won',
    lost:   'Lost' + studioDash() + 'closed lost'
  };

  // Mark proposal status — always use __markStatus for consistency
  const markProposal = (proposalId, newStatus) => {
    onSaveProposal({ __markStatus: true, id: proposalId, status: newStatus });
  };

  const getRef = (p) => {
    const raw = (p.quoteRef || p.reference || '').toString().replace('SP-L', '').trim();
    // Filter out placeholder refs
    const placeholders = ['Q-000', 'Q-QQ', 'QQ', 'Q-', '000'];
    if (!raw || placeholders.includes(raw.toUpperCase()) || raw.toUpperCase() === 'Q-000' || raw.toUpperCase() === 'Q-QQ') {
      return p.projectRef || '';
    }
    return raw;
  };

  const getValue = quoteValueOf;

  // Month-filtered proposals — pin each quote to its creation month (not updatedAt which can shift)
  // The one month rule: a quote's month is its creation date (createdAt, else
  // date); an undated or unreadable one has no month. Used by the month
  // navigation and, switch on, by "Quoted each month" (track 3b).
  const pipelineMonthOf = (p) => {
    if (p.undated) return null;
    const dateVal = p.createdAt || p.date;
    if (!dateVal) return null;
    const d = new Date(dateVal);
    return isNaN(d.getTime()) ? null : d;
  };
  const monthProps = allProps.filter(p => {
    const d = pipelineMonthOf(p);
    if (!d) return false;
    const dateVal = p.createdAt || p.date;
    const match = d.getFullYear() === selectedMonth.year && d.getMonth() === selectedMonth.month;
    console.log(`[Month] "${p.projectName}" createdAt=${dateVal} → ${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')} vs selected ${selectedMonth.year}-${String(selectedMonth.month+1).padStart(2,'0')} → ${match ? 'SHOW' : 'HIDE'}`);
    return match;
  });
  console.log(`[Month] ${selectedMonth.year}-${String(selectedMonth.month+1).padStart(2,'0')}: ${monthProps.length} of ${allProps.length} proposals match`);

  // Search filter on top of month filter
  const displayProps = searchQuery.trim()
    ? allProps.filter(p => {
        const q = searchQuery.toLowerCase();
        return (p.projectName || '').toLowerCase().includes(q) ||
               (p.projectClient || p.client || '').toLowerCase().includes(q) ||
               (p.quoteRef || '').toLowerCase().includes(q);
      })
    : monthProps;

  // Filtered proposals (active = quoteIsLive: quoting, quoted and sent)
  const filteredProps = stageFilter
    ? stageFilter === 'active'
      ? allProps.filter(p => quoteIsLive(getStatus(p)))
      : allProps.filter(p => getStatus(p) === stageFilter)
    : [];

  // Stage filter chip styles
  const chipStyles = {
    active: { bg: 'linear-gradient(145deg, rgba(200,144,48,0.18), rgba(255,252,242,0.95))', shadow: '0 2px 10px rgba(200,144,48,0.14), inset 0 1px 0 rgba(255,255,255,0.9)', numCol: '#C89030', lblCol: '#A07020' },
    won:    { bg: 'linear-gradient(145deg, rgba(46,104,56,0.16), rgba(255,252,242,0.95))', shadow: '0 2px 10px rgba(46,104,56,0.12), inset 0 1px 0 rgba(255,255,255,0.9)', numCol: '#2E6838', lblCol: '#1A5028' },
    lost:   { bg: 'linear-gradient(145deg, rgba(200,80,60,0.16), rgba(255,252,242,0.95))', shadow: '0 2px 10px rgba(200,80,60,0.12), inset 0 1px 0 rgba(255,255,255,0.9)', numCol: '#C85040', lblCol: '#A03020' },
  };

  // ── Render proposal card ──
  // (Switch off only: with the switch on the rows are renderStudioPipeline's.)
  const renderProposalCard = (p) => {
    const status = getStatus(p);
    const pill = statusPillStyle[status] || statusPillStyle.sent;
    const ref = getRef(p);
    const val = getValue(p);

    let cardBg = 'linear-gradient(145deg, rgba(26,90,120,0.08) 0%, rgba(255,252,242,0.88) 52%)';
    let cardOpacity = 1;
    if (status === 'won') cardBg = 'linear-gradient(145deg, rgba(46,104,56,0.10) 0%, rgba(255,252,242,0.88) 52%)';
    if (status === 'lost') { cardBg = 'rgba(255,252,242,0.75)'; cardOpacity = 0.88; }

    return (
      <div key={p.id} style={{ background: cardBg, opacity: cardOpacity, borderRadius: 16, padding: '14px 16px 13px', marginBottom: 8, border: '1px solid rgba(255,255,255,0.85)', borderTop: '1px solid rgba(255,255,255,0.95)', ...uvx(() => ({ ...studioLit(studioStageOf(status === 'sent' ? 'proposed' : status === 'quoted' ? 'proposed' : status, 'quoted')), opacity: 1, borderRadius: STUDIO_TOKENS.radius.card })) }}>
        {/* Head row */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
          {ref && <span style={{ fontSize: 11, color: '#9A8870', fontWeight: 600 }}>{ref}</span>}
          <span style={{ fontSize: 10, fontWeight: 700, padding: '3px 10px', borderRadius: 12, background: pill.bg, color: pill.color, boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.3)', textTransform: 'uppercase', letterSpacing: 0.4 }}>{status}</span>
        </div>
        {/* Name + client */}
        <div style={{ fontSize: 13, fontWeight: 600, color: '#3A2E1A', marginBottom: 2 }}>{p.projectName || 'Untitled'}</div>
        <div style={{ fontSize: 12, color: '#6A5840', marginBottom: 10 }}>{p.projectClient || p.client || ''}</div>
        {/* COMPANION-TRUTH-V2 B5 (DECISIONS 176.137, 176.140): the job's own
            D16 margin, in plMargin's words (the lit rows' own). A decided or
            phone-made proposal carries none: "Margin not available". */}
        <div style={{ fontSize: 12, color: '#6A5840', marginBottom: 10 }}>{plSentence(plMargin(p).text)}</div>
        {/* Footer */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic', fontSize: 17, color: '#3A2E1A' }}>{fmt(val)}</span>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            {quoteIsLive(status) && (
              <>
                <button onClick={() => markProposal(p.id, 'won')} style={{
                  background: 'rgba(255,252,242,0.88)', border: '1.5px solid rgba(46,138,72,0.55)',
                  boxShadow: '0 0 0 3px rgba(46,138,72,0.12), 0 0 14px rgba(46,138,72,0.28), inset 0 1px 0 rgba(255,255,255,0.9)',
                  color: '#3A2E1A', fontSize: 13, fontWeight: 800, padding: '8px 18px', borderRadius: 20, cursor: 'pointer'
                }}>Won</button>
                <button onClick={() => markProposal(p.id, 'lost')} style={{
                  background: 'rgba(255,252,242,0.88)', border: '1.5px solid rgba(200,80,60,0.50)',
                  boxShadow: '0 0 0 3px rgba(200,80,60,0.10), 0 0 14px rgba(200,80,60,0.26), inset 0 1px 0 rgba(255,255,255,0.9)',
                  color: '#3A2E1A', fontSize: 13, fontWeight: 800, padding: '8px 18px', borderRadius: 20, cursor: 'pointer'
                }}>Lost</button>
              </>
            )}
            {status === 'won' && (
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <span style={{ fontSize: 12, fontWeight: 600, padding: '6px 12px', borderRadius: 14, background: '#D4EDDA', border: '1px solid rgba(46,104,56,0.3)', color: '#1A5028', display: 'inline-flex', alignItems: 'center', gap: 4 }}><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#1A5028" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg> Won</span>
                <span onClick={() => markProposal(p.id, 'sent')} style={{ fontSize: 11, fontStyle: 'italic', textDecoration: 'underline', color: '#9A8870', cursor: 'pointer' }}>Re-open</span>
              </div>
            )}
            {status === 'lost' && (
              <button onClick={() => markProposal(p.id, 'sent')} style={{
                background: 'rgba(255,252,242,0.88)', border: '1px solid rgba(106,88,64,0.3)',
                boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.8)',
                color: '#3A2E1A', fontSize: 12, fontWeight: 700, padding: '7px 14px', borderRadius: 16, cursor: 'pointer'
              }}>{studioArrow('↩ ') + 'Re-activate'}</button>
            )}
          </div>
        </div>
      </div>
    );
  };

  // ── Render heat card ──
  const renderHeatCard = (p, compact) => {
    const val = getValue(p);
    const tierConf = {
      burning: {
        bg: 'linear-gradient(135deg, #1A7ACC 0%, #0E4A90 50%, #0A2860 100%)',
        shadow: '0 4px 24px rgba(26,122,204,0.35), 0 2px 10px rgba(10,40,96,0.3)',
        dot: '#7FE8F8', dotAnim: true, label: 'Burning',
        statusLabel: 'Reading now', statusDot: '#7FE8F8', statusDotAnim: true,
        ctaColor: '#0E4A90', ctaLabel: 'Call now' + studioArrow()
      },
      hot: {
        bg: 'linear-gradient(135deg, #C85040 0%, #C87030 55%, #8A3010 100%)',
        shadow: '0 4px 20px rgba(200,80,60,0.28), 0 2px 8px rgba(138,48,16,0.2)',
        dot: '#FFD070', dotAnim: false, label: 'Hot',
        statusLabel: 'High intent signal', statusDot: '#FFD070', statusDotAnim: false,
        ctaColor: '#8A3010', ctaLabel: 'Follow up' + studioArrow()
      },
      warm: {
        bg: 'linear-gradient(135deg, #A87020 0%, #C89030 60%, #8A6020 100%)',
        shadow: '0 3px 14px rgba(168,112,32,0.22)',
        dot: 'rgba(255,255,255,0.4)', dotAnim: false, label: 'Warm',
        statusLabel: 'Cooling' + studioDash() + 'worth a nudge', statusDot: 'rgba(255,255,255,0.35)', statusDotAnim: false,
        ctaColor: '#7A5010', ctaLabel: 'Send message' + studioArrow()
      }
    };
    const tc = tierConf[p.tier] || tierConf.warm;
    const pad = compact ? '12px 14px' : '16px 18px 15px';
    const lastOpenLabel = p.openedToday ? 'Today' : p.lastOpened ? Math.floor((Date.now() - p.lastOpened.getTime()) / 86400000) + ' days ago' : '';
    const maxScore = Math.max(...heatCards.map(h => h.engagementScore), 1);

    return (
      <div key={p.id} style={{ background: tc.bg, boxShadow: tc.shadow, borderRadius: 18, padding: pad, marginBottom: 8, position: 'relative', overflow: 'hidden' }}>
        {/* Decorative circle */}
        <div style={{ position: 'absolute', top: -35, right: -35, width: 120, height: 120, borderRadius: '50%', background: 'rgba(255,255,255,0.07)' }} />
        {/* Row 1 */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8, position: 'relative', zIndex: 1 }}>
          <div style={{ flex: 1, ...uvx({ display: 'flex', flexDirection: 'column' }) }}>
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5, fontSize: 10, fontWeight: 700, padding: '3px 10px', borderRadius: 12, background: 'rgba(255,255,255,0.2)', boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.15)', color: 'rgba(255,255,255,0.88)', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 6, ...uvx({ order: 3, alignSelf: 'flex-start', marginBottom: 0 }) }}>
              <span style={{ width: 6, height: 6, borderRadius: '50%', background: tc.dot, ...(tc.dotAnim ? { animation: 'pulse 1.5s ease-in-out infinite' } : {}) }} />
              {tc.label}
            </span>
            <div style={{ fontSize: 15, fontWeight: 700, color: '#fff', marginBottom: 2 }}>{p.projectName || 'Untitled'}</div>
            <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.68)' }}>{p.projectClient || p.client || ''}</div>
          </div>
          <div style={{ textAlign: 'right', ...uvx({ display: 'flex', flexDirection: 'column' }) }}>
            <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.45)', textTransform: 'uppercase', letterSpacing: 0.5, ...uvx({ order: 2 }) }}>Value</div>
            <div style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic', fontSize: 20, color: '#fff', textShadow: '0 1px 6px rgba(0,0,0,0.3)' }}>{fmt(val)}</div>
          </div>
        </div>
        {/* Engagement bar */}
        <div style={{ marginBottom: 10, position: 'relative', zIndex: 1 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
            <span style={{ fontSize: 10, color: 'rgba(255,255,255,0.55)' }}>{lastOpenLabel}</span>
            <span style={{ fontSize: 10, color: 'rgba(255,255,255,0.55)', ...uvx(() => ({ color: STUDIO_MEANING.clientText, fontWeight: 600 })) }}>{p.opens}× opened{p.timeOnPage > 0 ? studioSep() + p.timeOnPage + ' min' : ''}</span>
          </div>
          <div style={{ height: 4, borderRadius: 2, background: 'rgba(255,255,255,0.18)' }}>
            <div style={{ height: 4, borderRadius: 2, background: 'rgba(255,255,255,0.82)', width: Math.round((p.engagementScore / maxScore) * 100) + '%', transition: 'width 0.3s' }} />
          </div>
        </div>
        {/* Buttons row */}
        <div style={{ display: 'flex', gap: 8, position: 'relative', zIndex: 1 }}>
          <span style={{ flex: 1, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 6, fontSize: 11, fontWeight: 600, padding: '8px 12px', borderRadius: 14, background: 'rgba(255,255,255,0.18)', boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.12)', color: '#fff' }}>
            <span style={{ width: 6, height: 6, borderRadius: '50%', background: tc.statusDot, ...(tc.statusDotAnim ? { animation: 'pulse 1.5s ease-in-out infinite' } : {}) }} />
            {tc.statusLabel}
          </span>
          <button style={{ fontSize: 11, fontWeight: 700, padding: '8px 16px', borderRadius: 14, background: 'rgba(255,255,255,0.94)', color: tc.ctaColor, border: 'none', cursor: 'pointer', boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.9)' }}>{tc.ctaLabel}</button>
        </div>
      </div>
    );
  };

  // ── Render silent card ──
  // COMPANION-TRUTH-V1 (b): a D10 row ({ proposal, daysSince, local }, from
  // truthWaitingRows). Days are the portal's days_silent; Chase opens only for
  // a job the phone holds (row.local).
  const renderSilentCard = (row) => {
    const p = row.proposal;
    const val = getValue(p);
    const daysSilent = row.daysSince;
    const chaseLocal = row.local;
    return (
      <div key={p.id} style={{ background: 'linear-gradient(145deg, rgba(200,80,60,0.09) 0%, rgba(255,252,242,0.88) 52%)', borderRadius: 16, padding: '14px 16px 13px', marginBottom: 8, border: '1px solid rgba(255,255,255,0.85)', borderTop: '1px solid rgba(255,255,255,0.95)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 6 }}>
          <div>
            <div style={{ fontSize: 13, fontWeight: 600, color: '#3A2E1A', marginBottom: 2 }}>{p.projectName || 'Untitled'}</div>
            <div style={{ fontSize: 12, color: '#6A5840' }}>{p.projectClient || p.client || ''}</div>
            {/* COMPANION-TRUTH-V2 B5: the job's own D16 margin, from the figures route's margins list (truthWaitingRows). */}
            <div style={{ fontSize: 12, color: '#6A5840', marginTop: 2 }}>{plSentence(plMargin(p).text)}</div>
          </div>
          <span style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic', fontSize: 15, color: '#3A2E1A' }}>{fmt(val)}</span>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontSize: 10, fontWeight: 600, padding: '3px 10px', borderRadius: 12, background: 'rgba(200,80,60,0.12)', color: '#A03020' }}>{daysSilent}{' days' + studioSep() + 'no response'}</span>
          <span onClick={t.theme === 'uv' && chaseLocal ? () => setChaseItem({ proposal: chaseLocal, daysSince: daysSilent }) : undefined} style={{ fontSize: 11, fontWeight: 600, color: '#C85040', cursor: chaseLocal ? 'pointer' : 'default', ...uvx({ fontSize: 14, minHeight: 44, display: 'inline-flex', alignItems: 'center' }) }}>{'Chase now' + studioArrow()}</span>
        </div>
      </div>
    );
  };

  // ── Render placeholder skeleton ──
  const renderSkeleton = (msg) => (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '14px 16px', background: 'linear-gradient(145deg, rgba(200,180,140,0.06) 0%, rgba(255,252,242,0.65) 52%)', borderRadius: 16, border: '1px solid rgba(255,255,255,0.7)', marginBottom: 8 }}>
      <div style={{ width: 28, height: 28, borderRadius: 8, background: 'rgba(200,180,140,0.15)' }} />
      <div style={{ flex: 1 }}>
        <div style={{ height: 10, borderRadius: 4, background: 'rgba(200,180,140,0.22)', width: '72%', marginBottom: 6 }} />
        <div style={{ height: 8, borderRadius: 4, background: 'rgba(200,180,140,0.14)', width: '46%' }} />
      </div>
      <span style={{ fontSize: 10, color: '#B0A090', fontStyle: 'italic' }}>{msg || 'More intelligence builds as you use the app.'}</span>
    </div>
  );

  // ── Win rate ring circumference ──
  const ringCirc = 2 * Math.PI * 30; // 188.5

  // ── Quarterly forecast (moved from Today) ──
  const monthlyTarget = parseFloat(readMyMonthlyTarget()) || 0;
  const quarterlyTarget = monthlyTarget * 3;
  // COMPANION-TRUTH-V2 B5: the forecast is the kernel's D3 mine
  // (/api/companion/pipeline forecast.forecast), never the phone's sum of
  // value times winProbability; null (the dash) when missing. The ring is D3
  // over the local quarterly target, as before; no D3 means no ring percent
  // (the dash, no arc). No figure is served for this month's forecast: its
  // amount is the dash and its bar stays at 0.
  const forecastBody = truthObject(portalPipeline && portalPipeline.forecast);
  const forecastAmount = forecastBody ? truthNumber(forecastBody.forecast) : null;
  const monthlyForecast = null;
  const ringPercent = forecastAmount == null ? null : quarterlyTarget > 0 ? Math.min(100, Math.round((forecastAmount / quarterlyTarget) * 100)) : 0;
  const monthlyPercent = 0;
  // S95 D21 — shared formatter; return without £ to keep existing template literals that prepend £
  const fmtCurrency = (v) => formatCurrency(v).replace(/^\u00a3/, '');
  // COMPANION-TRUTH-V2 B3: fmtCurrency is TRUTH_DASH for a missing value, so a
  // site that prepends £ to a value that can be missing checks for it first
  // and prints the dash alone (forecastAmount and monthlyForecast below).
  // quarterlyTarget is always a finite number (parseFloat(...) || 0, times 3).
  const forecastRingR = 28;
  const forecastRingCirc = 2 * Math.PI * forecastRingR;

  // COMPANION-TRUTH-V1 (a): the pipeline value and the live count are the
  // portal's D1 and D2 (mine, across divisions; FINDINGS Open question 1),
  // null when not available, which fmt draws as the dash.
  // COMPANION-TRUTH-V2 B5: the ring's win rate is D7 mine over the financial
  // year (DECISIONS 176.135, win_rate_fy), the dash with no arc when null;
  // the live margin beside the total is D16 over the same jobs (176.140).
  const heroPipelineValue = truthPipelineValue();
  const heroWinRate = truthWinRateFy();
  const heroQuoteCount = truthLiveCount();
  const heroMargin = truthGroupMargin(truthLiveMargin());

  // ── COMPANION-STUDIO-LIT-V1 track 3b: the v6 phone target (switch on) ──
  // Everything below reads values this screen already holds; nothing here is a
  // new portal figure. With the switch off none of it is drawn.
  const studioOn = t.theme === 'uv';

  // ════ STUDIO-LIT-PHONE-V1 item 3: Pipeline to the lit v5 prototype ════
  // (docs/studio-lit/target/screens/app.js `pipeline`), switch on only. Every
  // figure is the portal's own (/api/companion/pipeline, cached as
  // lumen_pipeline; the D10 jobs from /api/companion/figures, lumen_figures):
  // the phone sums nothing the portal sends, and a figure the portal holds
  // back is shown as its reason, never 0. The rows are the served D1 rows (the
  // ones pipeline_total sums). A row's actions (Mark won, Mark lost, Re-open,
  // Re-activate, Chase) need the phone's own proposal for that job, matched by
  // job id, then project id, never by name. docs/studio-lit/FINDINGS.md
  // "Item 3" records each decision and its source.
  const [plStage, setPlStage] = useState('quoted');
  const [plShowAll, setPlShowAll] = useState(false);
  const [plOpenRow, setPlOpenRow] = useState(null);
  const [plShowLost, setPlShowLost] = useState(false);
  const plBody = studioOn ? truthBody('lumen_pipeline') : null;
  const plList = (v) => (Array.isArray(v) ? v.filter(q => q && typeof q === 'object') : []);
  const plLive = plList(plBody && plBody.quotes);
  const plDecided = plList(plBody && plBody.all_quotes).filter(q => q.won || q.lost);
  const plNum = (k) => (plBody ? truthNumber(plBody[k]) : null);
  const plWhy = truthWhy;
  const plObj = truthObject;
  const plValue = (q) => truthNumber(q.total);
  const plSame = (a, b) => a != null && b != null && String(a) !== '' && String(a) === String(b);
  const plLocal = (q) => {
    const list = proposals || [];
    return list.find(p => p && plSame(p.id, q.job_id)) || list.find(p => p && plSame(p.projectId, q.project_id)) || null;
  };
  // A portal reason read inside a sentence: first letter lower case, no full stop.
  const plReason = truthReason;
  const plSentence = truthSentence;
  const plTimes = (n) => (n === 1 ? 'once' : n === 2 ? 'twice' : `${n} times`);
  // When something happened, as a person says it: today, yesterday, on
  // Tuesday (this past week), else on 29 Sep.
  const plWhen = (iso) => {
    const d = iso ? new Date(iso) : null;
    if (!d || isNaN(d.getTime())) return null;
    const now = new Date();
    const day = (x) => new Date(x.getFullYear(), x.getMonth(), x.getDate()).getTime();
    const ago = Math.round((day(now) - day(d)) / 86400000);
    if (ago === 0) return 'today';
    if (ago === 1) return 'yesterday';
    if (ago > 1 && ago < 7) return 'on ' + d.toLocaleDateString('en-GB', { weekday: 'long' });
    return `on ${d.getDate()} ${PL_MONTHS[d.getMonth()]}`;
  };
  // What the client did with the quote (K10 opens, last_open), in client
  // blue. Who opened it is not stored (DATA-GAPS G7), so it is never named.
  const plClientLine = (q) => {
    if (!q) return null;
    const opens = truthNumber(q.opens);
    if (opens != null && opens > 0) {
      const when = plWhen(q.last_open);
      return { client: `Opened ${plTimes(opens)}${when ? ', last ' + when : ''}` };
    }
    if (q.won || q.lost) return null;
    if (q.sent_at) { const when = plWhen(q.sent_at); return { plain: when ? `Sent ${when.replace(/^on /, '')}, not opened yet` : 'Sent, not opened yet' }; }
    if (String(q.status || '').toLowerCase() === 'quoting') return { plain: 'Not sent yet' };
    return opens === 0 ? { plain: 'Not opened yet' } : null;
  };
  // The job's own D16 margin, or the portal's reason it is held back
  // (DECISIONS 176.140). The decided rows the portal sends carry no margin
  // and no reason (FINDINGS, owed to the portal). COMPANION-TRUTH-V2 B5: the
  // words live in truthJobMargin, which also reads a mapped proposal's
  // marginPct and marginWithheld, so the switch-off cards say the same thing.
  const plMargin = truthJobMargin;
  // Odds order (the prototype's): strong, even, low, then no odds yet; the
  // bigger job first within each.
  const plOddsRank = (q) => { const o = truthNumber(q.odds); return o == null ? 3 : o >= 75 ? 0 : o === 50 ? 1 : 2; };
  const plByValue = (a, b) => (plValue(b) || 0) - (plValue(a) || 0);
  const plQuoted = plLive.slice().sort((a, b) => (plOddsRank(a) - plOddsRank(b)) || plByValue(a, b));
  // Won this financial year: the portal sends won_fy_count, and every won job
  // of the person's with its won_at (all_quotes). The year's wins are the
  // latest won_fy_count of those; the phone never decides where the year starts.
  const plWonCount = plNum('won_fy_count');
  const plWonRows = plWonCount ? plDecided.filter(q => q.won && q.won_at && !isNaN(new Date(q.won_at).getTime()))
    .sort((a, b) => new Date(b.won_at) - new Date(a.won_at)).slice(0, plWonCount).sort(plByValue) : [];
  const plLostRows = plDecided.filter(q => q.lost).sort(plByValue);
  const plTotal = plNum('pipeline_total');
  const plCount = plNum('quote_count');
  const plMarginAll = plObj(plBody && plBody.margin);
  const plForecast = plObj(plBody && plBody.forecast);
  const plLikely = plObj(plBody && plBody.likely_profit);
  const plWonFy = plNum('won_fy');
  // When the figures were read: the time on Eva's read.
  const plAt = (() => {
    if (!studioOn) return null;
    // With the date when it was not today (DECISIONS 176.136).
    try {
      const v = localStorage.getItem('lumen_pipeline_synced_at'); const d = v ? new Date(v) : null;
      if (!d || isNaN(d.getTime())) return null;
      const hhmm = d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
      const now = new Date();
      const sameDay = d.getFullYear() === now.getFullYear() && d.getMonth() === now.getMonth() && d.getDate() === now.getDate();
      return sameDay ? hhmm : `${d.getDate()} ${PL_MONTHS[d.getMonth()]}${d.getFullYear() === now.getFullYear() ? '' : ' ' + d.getFullYear()}, ${hhmm}`;
    } catch (e) { return null; }
  })();
  // Quoted each month, and what you won: the nine months to this one. A
  // quote sits in the month it was made (pipelineMonthOf, the month
  // navigation's rule), a win in the month it was won (wonAt, kept by the
  // mapping from the portal's won_at). The bars are drawn from those rows;
  // no figure here is one the portal sends.
  const plMonths = studioOn ? (() => {
    const list = proposals || [];
    const now = new Date();
    const bars = [];
    for (let i = 8; i >= 0; i--) {
      const m = new Date(now.getFullYear(), now.getMonth() - i, 1);
      const inMonth = (d) => d && !isNaN(d.getTime()) && d.getFullYear() === m.getFullYear() && d.getMonth() === m.getMonth();
      bars.push({
        key: `${m.getFullYear()}-${m.getMonth()}`,
        label: PL_MONTHS[m.getMonth()],
        long: m.toLocaleDateString('en-GB', { month: 'long', year: 'numeric' }),
        quoted: list.filter(p => inMonth(pipelineMonthOf(p))).reduce((s, p) => s + getValue(p), 0),
        won: list.filter(p => p.wonAt && inMonth(new Date(p.wonAt))).reduce((s, p) => s + getValue(p), 0),
        now: i === 0,
      });
    }
    const max = Math.max(...bars.map(b => Math.max(b.quoted, b.won)));
    return max > 0 ? { bars, max } : null;
  })() : null;

  const renderStudioPipeline = () => {
    const S = STUDIO_TOKENS; const M = STUDIO_MEANING;
    const sec = { fontFamily: S.fonts.body, fontSize: 16, fontWeight: 700, color: S.ink, margin: '0 0 8px' };
    const act = { ...studioType.action(), minHeight: 44, display: 'inline-flex', alignItems: 'center', cursor: 'pointer', fontFamily: 'inherit' };
    const money = { color: M.ochre, fontVariantNumeric: 'tabular-nums' };
    const big = { ...studioType.display(), lineHeight: 0.9 };
    // Eva's read (DEC-5 still open: a fixed sentence from the served figures,
    // D3 forecast, likely profit and the quotes with no odds). Never money on
    // the jewel (studio-lit.md, which wins over the prototype on detail): her
    // words are on the jewel and the sums she cites sit beside it, in ochre,
    // once each. "Rate the N" is a capability (a write), so there is no button.
    const fcValue = plForecast ? truthNumber(plForecast.forecast) : null;
    const unrated = plForecast ? truthNumber(plForecast.unrated_count) : null;
    const unratedValue = plForecast ? truthNumber(plForecast.unrated_value) : null;
    const likely = plLikely && !plWhy(plLikely.withheld) ? truthNumber(plLikely.value) : null;
    const fcShown = fcValue != null && fcValue > 0;
    const likelyShown = fcShown && likely != null && likely > 0;
    const unratedShown = unrated > 0 && unratedValue != null && unratedValue > 0;
    const sum = (v) => <b style={{ ...money, fontWeight: 700 }}>{formatCurrency(v)}</b>;
    // Nothing to say (no forecast and every job rated): no read.
    const eva = fcShown || unrated > 0 ? (
      <>
        <section aria-label="Eva" style={{ position: 'relative', overflow: 'hidden', margin: '14px 16px 4px', padding: '14px 14px 12px 16px', borderRadius: S.radius.card, background: S.jewel.fill, boxShadow: S.jewel.shadow, display: 'flex', flexDirection: 'column', gap: 6 }}>
          <span aria-hidden="true" style={{ position: 'absolute', right: -30, top: -34, width: 120, height: 120, borderRadius: '50%', background: `radial-gradient(circle, ${S.jewel.text}, ${studioRgba(S.ultraviolet, 0.45)} 30%, ${studioRgba(S.ultraviolet, 0)} 66%)`, opacity: 0.9, pointerEvents: 'none' }} />
          <p style={{ position: 'relative', margin: 0, paddingRight: 14, fontFamily: S.fonts.display, fontWeight: 300, fontSize: 20, lineHeight: 1.3, color: S.jewel.text }}>
            <span aria-hidden="true" style={{ display: 'inline-flex', verticalAlign: -2, marginRight: 8, color: S.jewel.ring }}>
              <svg width="17" height="17" viewBox="0 0 20 20"><circle cx="10" cy="10" r="9" fill="none" stroke="currentColor" strokeWidth="1.4" strokeDasharray="1.2 1.6" /><circle cx="10" cy="10" r="4.5" fill="currentColor" /></svg>
            </span>
            {fcShown ? (likelyShown ? 'Here’s what I think you’ll win of this, and roughly the profit in it.' : 'Here’s what I think you’ll win of this.') : null}
            {unrated > 0 ? `${fcShown ? ' ' : ''}${unrated} ${unrated === 1 ? 'quote still has' : 'quotes still have'} no odds.` : ''}
          </p>
          {plAt && (
            <div style={{ position: 'relative', display: 'flex' }}>
              <span style={{ marginLeft: 'auto', fontSize: 13, color: S.jewel.textSecondary }}>{plAt}</span>
            </div>
          )}
        </section>
        {(fcShown || unratedShown) && (
          <p aria-label="What Eva cites" style={{ margin: '8px 20px 0', fontSize: 14, lineHeight: 1.45, color: S.ink }}>
            {fcShown && <>{sum(fcValue)} likely to be won{likelyShown ? <>, {sum(likely)} of it profit</> : null}.</>}
            {unratedShown && <>{fcShown ? ' ' : ''}{sum(unratedValue)} on the {unrated === 1 ? 'one' : 'ones'} with no odds.</>}
          </p>
        )}
      </>
    ) : null;

    // The big figure: D1, D2 and the estimated margin over the same jobs.
    // The words are truthGroupMargin's, which the switch-off totals share.
    const groupMargin = truthGroupMargin(plMarginAll);
    const marginPct = plMarginAll ? groupMargin.pct : null;
    const figure = (
      <section aria-label="Your pipeline" style={{ display: 'flex', alignItems: 'flex-end', gap: 14, margin: '14px 16px 0' }}>
        {pipelineLoading
          ? <div style={{ height: 70, width: 180, borderRadius: 8, ...shimmerBg(studioInk(0.08)) }} />
          : <span style={{ ...big, ...money, fontSize: 84 }}>{plTotal == null ? TRUTH_DASH : formatCurrency(plTotal)}</span>}
        <p style={{ margin: 0, fontSize: 16, lineHeight: 1.35, paddingBottom: 4, color: S.ink, minWidth: 0 }}>
          in your pipeline,<br />
          {plCount == null ? TRUTH_DASH : plCount} open job{plCount === 1 ? '' : 's'}{marginPct != null ? ' at' : '.'}<br />
          {marginPct != null
            ? <b style={{ fontWeight: 700 }}>{groupMargin.text}</b>
            : (plMarginAll ? <span style={{ color: S.muted }}>{groupMargin.text}</span> : null)}
        </p>
      </section>
    );

    // Win rate (D7, this financial year, 176.135), won and lost counts, the
    // average job won (D14) and days from enquiry to order (D18).
    const wr = plNum('win_rate'); const wrWhy = plWhy(plBody && plBody.win_rate_withheld);
    const wonN = plNum('won_fy_count'); const lostN = plNum('lost_fy_count');
    const avg = plNum('avg_won'); const avgWhy = plWhy(plBody && plBody.avg_won_withheld);
    const dtw = plNum('days_to_win'); const dtwWhy = plWhy(plBody && plBody.days_to_win_withheld);
    const counts = [wonN != null ? `${wonN} won` : null, lostN != null ? `${lostN} lost` : null].filter(Boolean).join(', ');
    const col = { display: 'flex', flexDirection: 'column', gap: 3, fontSize: 13, color: S.ink, minWidth: 0 };
    const small = { fontSize: 13, color: S.muted };
    const showWr = wr != null || wrWhy || counts;
    const showAvg = avg != null || avgWhy || dtw != null || dtwWhy;
    const pk = plBody && (showWr || showAvg) ? (
      <section aria-label="Win rate and average job won" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, margin: '18px 16px 6px' }}>
        <div style={col}>
          {wr != null ? <>
            <span style={{ ...big, fontSize: 31, lineHeight: 1 }}>{wr}%</span>
            <span>won of what’s been decided this financial year</span>
            <span aria-hidden="true" style={{ display: 'block', height: 8, borderRadius: 4, background: studioRgba(M.slateFill, 0.25), marginTop: 4 }}>
              <span style={{ display: 'block', height: '100%', width: Math.max(0, Math.min(100, wr)) + '%', borderRadius: 4, background: M.wonFill }} />
            </span>
          </> : wrWhy ? <>
            <span>Win rate this financial year</span>
            <span style={small}>{plSentence(wrWhy)}</span>
          </> : null}
          {counts && <span style={small}>{counts}</span>}
        </div>
        <div style={col}>
          {avg != null ? <>
            <span style={{ ...big, ...money, fontSize: 31, lineHeight: 1 }}>{formatCurrency(avg)}</span>
            <span>average job won</span>
          </> : avgWhy ? <>
            <span>Average job won</span>
            <span style={small}>{plSentence(avgWhy)}</span>
          </> : null}
          {dtw != null ? <span style={small}>{dtw} day{dtw === 1 ? '' : 's'} from enquiry to order</span>
            : dtwWhy ? <span style={small}>Days from enquiry to order: {plReason(dtwWhy)}</span> : null}
        </div>
      </section>
    ) : null;

    // The stage ladder: Quoted and Won only until DEC-1 says which live stage
    // is New. Quoted is every open job (the figure above, so its value is not
    // said again); Won is this financial year's, by value (won_fy).
    const rungMax = Math.max(plTotal || 0, plWonFy || 0, 1);
    const rung = (stage, word, sub, value, fill) => {
      const on = plStage === stage;
      return (
        <button key={stage} data-stage={stage} aria-pressed={on} onClick={() => { setPlStage(stage); setPlShowAll(false); setPlOpenRow(null); }} style={{
          display: 'grid', gridTemplateColumns: '118px minmax(0,1fr)', alignItems: 'center', gap: 12, minHeight: 50, width: '100%',
          padding: '4px 10px 4px 12px', borderRadius: 12, border: 'none', cursor: 'pointer', textAlign: 'left', fontFamily: 'inherit',
          ...(on ? studioSurface.raised() : { background: 'transparent', boxShadow: 'none' }),
        }}>
          <span style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.3, minWidth: 0 }}>
            <span style={{ fontSize: 16, fontWeight: on ? 800 : 600, color: S.ink }}>{word}</span>
            <span style={{ fontSize: 13, color: S.muted }}>{sub}</span>
          </span>
          <span aria-hidden="true" style={{ display: 'block', height: 14, borderRadius: 7, background: studioInk(0.06) }}>
            <span style={{ display: 'block', height: '100%', borderRadius: 7, width: Math.max(8, Math.round((value || 0) / rungMax * 100)) + '%', background: fill, backgroundImage: 'linear-gradient(180deg, rgba(255,255,255,.28), rgba(255,255,255,0) 60%)', boxShadow: on ? `0 0 16px -2px ${fill}` : 'none' }} />
          </span>
        </button>
      );
    };
    const ladder = plBody ? (
      <div role="group" aria-label="Show a stage" style={{ display: 'flex', flexDirection: 'column', gap: 4, margin: '12px 12px 8px' }}>
        {rung('quoted', 'Quoted', 'open now', plTotal, M.quotedFill)}
        {plWonFy != null && rung('won', 'Won this year', <span style={money}>{formatCurrency(plWonFy)}</span>, plWonFy, M.wonFill)}
      </div>
    ) : null;

    // A job row: name and value, the stage word with its odds and the margin,
    // what the client did. Tapping a row the phone holds opens its actions.
    const row = (q, i) => {
      const id = q.job_id != null ? String(q.job_id) : `row-${i}`;
      const local = plLocal(q);
      const open = plOpenRow === id && !!local;
      const sw = studioQuoteStage(q);
      const mg = plMargin(q);
      const cl = plClientLine(q);
      const value = plValue(q);
      const wonOn = q.won && plWhen(q.won_at);
      const status = local ? quoteStatusOf(local) : null;
      const toggle = local ? () => setPlOpenRow(open ? null : id) : undefined;
      return (
        <div key={id} data-row={id} role={local ? 'button' : undefined} tabIndex={local ? 0 : undefined} aria-expanded={local ? open : undefined}
          onClick={toggle} onKeyDown={local ? (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } } : undefined}
          style={{ padding: '10px 14px 10px 18px', minHeight: 44, boxSizing: 'border-box', borderRadius: 12, cursor: local ? 'pointer' : 'default', ...(open ? studioSurface.slip() : { background: 'transparent' }) }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 10 }}>
            <b style={{ fontSize: 16, fontWeight: 700, color: S.ink, minWidth: 0, overflowWrap: 'anywhere' }}>{q.project_name || q.client_name || 'Untitled'}</b>
            {value != null && <span style={{ ...money, fontSize: 16, fontWeight: 700, whiteSpace: 'nowrap' }}>{formatCurrency(value)}</span>}
          </div>
          <p style={{ margin: '2px 0 0', fontSize: 14, lineHeight: 1.35, color: S.muted }}>
            {sw && <span style={{ fontWeight: 600, color: sw.c }}>{sw.word}{wonOn ? ' ' + wonOn : ''}</span>}
            {sw ? ', ' : ''}
            {mg.shown ? <b style={{ fontWeight: 700, color: S.ink }}>{mg.text}</b> : (sw ? mg.text : plSentence(mg.text))}
          </p>
          {cl && (
            <p style={{ margin: '2px 0 0', fontSize: 14, lineHeight: 1.35, color: S.muted }}>
              {cl.client ? <span style={{ color: M.clientText, fontWeight: 600 }}>{cl.client}</span> : cl.plain}
            </p>
          )}
          {open && (
            <div style={{ display: 'flex', gap: 18, flexWrap: 'wrap', marginTop: 2 }} onClick={(e) => e.stopPropagation()}>
              {quoteIsLive(status) && <>
                <button onClick={() => markProposal(local.id, 'won')} style={act}>Mark won</button>
                <button onClick={() => markProposal(local.id, 'lost')} style={act}>Mark lost</button>
              </>}
              {status === 'won' && <button onClick={() => markProposal(local.id, 'sent')} style={act}>Re-open</button>}
              {status === 'lost' && <button onClick={() => markProposal(local.id, 'sent')} style={act}>Re-activate</button>}
            </div>
          )}
        </div>
      );
    };
    const stageRows = plStage === 'won' ? plWonRows : plQuoted;
    const shown = plShowAll ? stageRows : stageRows.slice(0, 5);
    const rest = stageRows.slice(5);
    const restValue = rest.reduce((s, q) => s + (plValue(q) || 0), 0);
    // When the rest are exactly the quotes with no odds, their sum is the one
    // already beside Eva's read: said once, so the tail names them instead.
    const restIsUnrated = plStage === 'quoted' && unratedShown && restValue === unratedValue
      && rest.length === unrated && rest.every(q => truthNumber(q.odds) == null);
    const rows = plBody ? (
      <section aria-label={plStage === 'won' ? 'Won this year' : 'Quoted'}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6, margin: '0 4px' }}>{shown.map(row)}</div>
        {rest.length > 0 && (
          <button onClick={() => setPlShowAll(!plShowAll)} style={{ ...act, fontSize: 14, margin: '0 22px' }}>
            {plShowAll ? 'Show fewer' : restIsUnrated ? `${rest.length} more, the ones with no odds`
              : <>{rest.length} more, <span style={{ ...money, marginLeft: 4 }}>{formatCurrency(restValue)}</span></>}
          </button>
        )}
      </section>
    ) : null;

    // Waiting on a reply: the portal's D10 jobs (the signed decision list,
    // DECISIONS 176.133), each with its own days_silent; Chase opens the
    // chase sheet for a job the phone holds.
    const waiting = silentProps;
    const replies = waiting.length > 0 ? (
      <section aria-label="Waiting on a reply" style={{ ...studioSurface.raised(), borderRadius: S.radius.card, padding: '14px 16px', margin: '16px 12px 0' }}>
        <h2 style={sec}>Waiting on a reply</h2>
        {waiting.map(({ proposal: p, daysSince, local }, i) => {
          const name = p.projectName || p.client || 'Untitled';
          const served = plLive.find(q => plSame(q.job_id, p.id) || plSame(q.project_id, p.projectId));
          const cl = served ? plClientLine(served) : null;
          return (
            <div key={p.id || i} style={{ display: 'grid', gridTemplateColumns: 'minmax(0,1fr) auto', gap: 10, alignItems: 'center', padding: '10px 0', borderTop: i ? `1px solid ${S.hairline}` : 'none' }}>
              <span style={{ display: 'flex', flexDirection: 'column', gap: 2, minWidth: 0 }}>
                <b style={{ fontSize: 16, fontWeight: 700, color: S.ink, overflowWrap: 'anywhere' }}>{name}</b>
                {daysSince != null && <span style={{ fontSize: 13, fontWeight: 600, color: M.rustText }}>No reply in {daysSince} day{daysSince === 1 ? '' : 's'}</span>}
                {cl && <span style={{ fontSize: 13, color: S.muted }}>{cl.client ? <span style={{ color: M.clientText, fontWeight: 600 }}>{cl.client}</span> : cl.plain}</span>}
              </span>
              {local ? <button onClick={() => setChaseItem({ proposal: local, daysSince })} aria-label={`Chase ${name}`} style={{ ...studioSurface.slip(), borderRadius: S.button.radius, minHeight: 44, padding: '0 14px', fontSize: 14, fontWeight: 600, color: S.ink, cursor: 'pointer', fontFamily: 'inherit' }}>Chase</button> : <span />}
            </div>
          );
        })}
      </section>
    ) : null;

    const months = plMonths ? (
      <section aria-label="Quoted each month, and what you won" style={{ margin: '20px 16px 0' }}>
        <h2 style={sec}>Quoted each month, and what you won</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(9, minmax(0,1fr))', gap: 5, alignItems: 'end', height: 118 }}>
          {plMonths.bars.map(b => (
            <div key={b.key} role="img" aria-label={`${b.long}: ${formatCurrency(b.quoted)} quoted, ${formatCurrency(b.won)} won`} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4, height: '100%' }}>
              <div style={{ position: 'relative', flex: 1, width: '100%' }}>
                {b.quoted > 0 && <div style={{ position: 'absolute', bottom: 0, left: '15%', right: '15%', height: (b.quoted / plMonths.max * 100).toFixed(1) + '%', borderRadius: '4px 4px 2px 2px', background: M.quotedFill, opacity: 0.85 }} />}
                {b.won > 0 && <div style={{ position: 'absolute', bottom: 0, left: '15%', right: '15%', height: (b.won / plMonths.max * 100).toFixed(1) + '%', borderRadius: '4px 4px 2px 2px', background: M.wonFill }} />}
              </div>
              <span style={{ fontSize: 13, fontWeight: 600, color: b.now ? M.wonText : S.muted }}>{b.label}</span>
            </div>
          ))}
        </div>
        <p style={{ display: 'flex', gap: 14, fontSize: 13, color: S.muted, margin: '6px 0 0' }}>
          <span><i aria-hidden="true" style={{ display: 'inline-block', width: 12, height: 9, borderRadius: 2, marginRight: 6, verticalAlign: -1, background: M.quotedFill }} />Quoted</span>
          <span><i aria-hidden="true" style={{ display: 'inline-block', width: 12, height: 9, borderRadius: 2, marginRight: 6, verticalAlign: -1, background: M.wonFill }} />Won</span>
        </p>
      </section>
    ) : null;

    // The jobs lost: the count this year is said once, under the win rate;
    // here the lost jobs open (every one the portal sends) with Re-activate.
    const lost = plLostRows.length > 0 ? (
      <section aria-label="Lost jobs" style={{ margin: '10px 0 0' }}>
        <button onClick={() => { setPlShowLost(!plShowLost); setPlOpenRow(null); }} aria-expanded={plShowLost} style={{ ...act, fontSize: 14, margin: '0 16px' }}>
          {plShowLost ? 'Hide the jobs you’ve lost' : 'Show the jobs you’ve lost'}
        </button>
        {plShowLost && <div style={{ display: 'flex', flexDirection: 'column', gap: 6, margin: '4px 4px 0' }}>{plLostRows.map((q, i) => row(q, 'lost-' + i))}</div>}
      </section>
    ) : null;

    return (
      <>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, minHeight: 50, margin: '4px 16px 0' }}>
          <h1 style={{ ...studioType.title(), fontSize: 39, lineHeight: 1.02 }}>Pipeline</h1>
          <span style={{ fontSize: 16, color: S.muted }}>Yours</span>
        </div>
        {eva}
        {figure}
        {pk}
        {ladder}
        {rows}
        {replies}
        {months}
        {lost}
      </>
    );
  };
  return studioDesk(
    <div style={{ flex: 1, overflowY: 'auto', WebkitOverflowScrolling: 'touch', overscrollBehavior: 'contain', paddingBottom: 100, background: '#E8DCC8', display: 'flex', flexDirection: 'column' }}>
      <ScreenBlobs />
      {/* Pull-to-refresh indicator */}
      {(isPulling || isSyncing) && (
        <div style={{ position: 'absolute', top: 8, left: '50%', transform: 'translateX(-50%)', zIndex: 10, display: 'flex', alignItems: 'center', gap: 6, padding: '6px 14px', borderRadius: 20, background: 'rgba(26,22,8,0.35)', color: '#E8DCC8', fontSize: 11, fontWeight: 600 }}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" style={{ animation: isSyncing ? 'lumenShimmer 0.8s linear infinite' : 'none' }}><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></svg>
          {isSyncing ? 'Syncing…' : 'Pull to refresh'}
        </div>
      )}
      <div style={{ flex: 1, overflowY: 'auto', padding: '4px 0 83px', position: 'relative', ...uvx(studioColumn) }}
        onTouchStart={handlePullStart}
        onTouchMove={handlePullMove}
        onTouchEnd={handlePullEnd}
      >

        {/* STUDIO-LIT-PHONE-V1 item 3: switch on, the whole screen is the
            lit v5 prototype's; everything below it is the switch-off look. */}
        {studioOn && <PipelineLitBody draw={renderStudioPipeline} />}

        {!studioOn && (<>
        {/* ── COMBINED HERO CARD ── */}
        <div style={{ margin: '4px 12px 0', background: 'linear-gradient(145deg, #1A3A5A 0%, #0A2A18 52%, #2A1A08 100%)', boxShadow: '0 4px 16px rgba(13,52,72,0.25)', borderRadius: 18, padding: 18, position: 'relative', overflow: 'hidden' }}>
          <div style={{ position: 'absolute', top: -35, right: -35, width: 120, height: 120, borderRadius: '50%', background: 'rgba(255,255,255,0.04)' }} />

          {/* Top section: Pipeline summary */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', position: 'relative', zIndex: 1, marginBottom: 14 }}>
            {/* Left — pipeline value */}
            <div>
              <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.5)', textTransform: 'uppercase', letterSpacing: 0.8, marginBottom: 4 }}>My pipeline</div>
              {pipelineLoading
                ? <div style={{ height: 32, width: 120, borderRadius: 8, ...shimmerBg('rgba(200,180,140,0.18)'), marginBottom: 4 }} />
                : <div style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic', fontSize: 28, color: '#fff', lineHeight: 1.1, marginBottom: 4, ...uvx(() => ({ ...studioType.display(), fontSize: 84, color: STUDIO_TOKENS.ochre, marginBottom: 8 })) }}>{fmt(heroPipelineValue)}</div>
              }
              <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.5)', marginBottom: 8 }}>{heroQuoteCount == null ? TRUTH_DASH : heroQuoteCount} active proposal{heroQuoteCount !== 1 ? 's' : ''}</div>
              {/* COMPANION-TRUTH-V2 B5 (DECISIONS 176.140): the margin of the jobs the total sums (D16), or not available with the portal's reason. */}
              {!pipelineLoading && <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.5)', marginTop: -4, marginBottom: 8 }}>{heroMargin.text}</div>}
              {(() => {
                const lastQ = parseFloat(localStorage.getItem('lumen_pipeline_last_quarter_value') || '0');
                if (lastQ <= 0 && pipelineValue > 0) {
                  try { localStorage.setItem('lumen_pipeline_last_quarter_value', pipelineValue.toString()); } catch(e) {}
                }
                const diff = pipelineValue - lastQ;
                if (lastQ > 0 && diff !== 0) {
                  const up = diff > 0;
                  return (
                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 11, fontWeight: 600, padding: '4px 10px', borderRadius: 20, background: 'rgba(255,255,255,0.18)', color: 'rgba(255,255,255,0.88)' }}>
                      <span style={{ width: 6, height: 6, borderRadius: '50%', background: up ? '#2ECC8A' : '#C85040' }} />
                      {studioArrow(up ? '\u2191' : '\u2193')} {up ? '+' : ''}{fmt(diff)} vs last quarter
                    </span>
                  );
                }
                return null;
              })()}
            </div>
            {/* Right — win rate ring */}
            <div style={{ textAlign: 'center' }}>
              <svg width="76" height="76" viewBox="0 0 76 76">
                <circle cx="38" cy="38" r="30" stroke="rgba(255,255,255,0.15)" strokeWidth="6" fill="none" />
                {heroWinRate != null && <circle cx="38" cy="38" r="30" stroke="rgba(255,255,255,0.88)" strokeWidth="6" fill="none"
                  strokeLinecap="round"
                  strokeDasharray={`${(heroWinRate/100)*ringCirc} ${ringCirc - (heroWinRate/100)*ringCirc}`}
                  transform="rotate(-90 38 38)" />}
                <text x="38" y="35" textAnchor="middle" style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic', fontSize: 17, fill: '#fff' }}>{heroWinRate != null ? <>{heroWinRate}%</> : TRUTH_DASH}</text>
                {/* DECISIONS 176.135: the label names the window. "this financial year" does not fit inside the ring at 9px, so the shortest honest form, FY as Year at a Glance writes it. */}
                <text x="38" y="46" textAnchor="middle" style={{ fontSize: 9, fill: 'rgba(255,255,255,0.55)', textTransform: 'uppercase' }}>win rate</text>
                <text x="38" y="55" textAnchor="middle" style={{ fontSize: 9, fill: 'rgba(255,255,255,0.55)', textTransform: 'uppercase' }}>this FY</text>
              </svg>
            </div>
          </div>

          {/* Divider */}
          <div style={{ height: 1, background: 'rgba(255,255,255,0.1)', marginBottom: 14, position: 'relative', zIndex: 1 }} />

          {/* Bottom section: Quarterly forecast */}
          <div style={{ display: 'flex', gap: 14, position: 'relative', zIndex: 1 }}>
            {/* Forecast ring */}
            <div style={{ width: 64, height: 64, position: 'relative', flexShrink: 0 }}>
              <svg width="64" height="64" viewBox="0 0 64 64">
                {monthlyTarget === 0 ? (
                  <circle cx="32" cy="32" r={forecastRingR} fill="none" stroke="rgba(255,255,255,0.15)" strokeWidth="5" strokeDasharray="5 4" />
                ) : (
                  <>
                    <circle cx="32" cy="32" r={forecastRingR} fill="none" stroke="rgba(255,255,255,0.15)" strokeWidth="5" />
                    {ringPercent != null && <circle cx="32" cy="32" r={forecastRingR} fill="none" stroke="rgba(200,169,110,0.85)" strokeWidth="5" strokeLinecap="round"
                      strokeDasharray={`${(ringPercent / 100) * forecastRingCirc} ${forecastRingCirc - (ringPercent / 100) * forecastRingCirc}`}
                      transform="rotate(-90 32 32)" />}
                  </>
                )}
              </svg>
              <div style={{ position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                <span style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic', fontSize: 14, color: '#fff', lineHeight: 1 }}>{ringPercent != null ? <>{ringPercent}%</> : TRUTH_DASH}</span>
                <span style={{ fontSize: 8, color: 'rgba(255,255,255,0.5)', marginTop: 1 }}>of target</span>
              </div>
            </div>

            {/* Forecast details */}
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 10, textTransform: 'uppercase', color: 'rgba(255,255,255,0.45)', letterSpacing: '0.08em', marginBottom: 4 }}>Quarterly forecast</div>
              {(forecastAmount != null && forecastAmount > 0) || monthlyTarget > 0 ? (
                <div style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic', fontSize: 20, color: '#fff', lineHeight: 1.1, marginBottom: 6 }}>
                  {fmtCurrency(forecastAmount) !== TRUTH_DASH && '£'}{fmtCurrency(forecastAmount)}
                  {quarterlyTarget > 0 && <span style={{ fontSize: 12, color: 'rgba(255,255,255,0.45)', fontStyle: 'normal', fontFamily: 'inherit', marginLeft: 4 }}>of £{fmtCurrency(quarterlyTarget)}</span>}
                </div>
              ) : (
                <div style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic', fontSize: 20, color: '#fff', opacity: 0.4, lineHeight: 1.1, marginBottom: 6 }}>No target set</div>
              )}
              {/* Monthly bar */}
              {monthlyTarget > 0 && (
                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                  <span style={{ fontSize: 10, color: 'rgba(255,255,255,0.4)' }}>This month</span>
                  <div style={{ flex: 1, height: 3, background: 'rgba(255,255,255,0.12)', borderRadius: 2, overflow: 'hidden' }}>
                    <div style={{ height: '100%', width: `${monthlyPercent}%`, background: 'rgba(200,169,110,0.7)', borderRadius: 2 }} />
                  </div>
                  <span style={{ fontSize: 10, color: 'rgba(255,255,255,0.5)' }}>{fmtCurrency(monthlyForecast) !== TRUTH_DASH && '£'}{fmtCurrency(monthlyForecast)}</span>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* ── STATS BENTO ── */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6, margin: '8px 12px 0' }}>
          {[
            { label: 'WON YTD', value: fmt(wonYTD), sub: (wonYTDCount == null ? TRUTH_DASH : wonYTDCount) + ' project' + (wonYTDCount !== 1 ? 's' : ''), margin: wonYTDMargin.text, tint: 'rgba(46,104,56,0.14)', col: '#2E6838' },
            { label: 'QUOTES YTD', value: quotesYTDCount == null ? TRUTH_DASH : String(quotesYTDCount), sub: quotesYTDValue == null ? (t.theme === 'uv' ? 'nothing quoted' : TRUTH_DASH + ' quoted') : ((t.theme === 'uv' && fmt(quotesYTDValue) === TRUTH_DASH) ? 'nothing quoted' : fmt(quotesYTDValue) + ' quoted'), tint: 'rgba(200,144,48,0.14)', col: '#C89030' },
            { label: 'AVG DEAL', value: fmt(avgDeal), sub: '', tint: 'rgba(26,90,120,0.12)', col: '#1A5A78' },
            { label: 'CHASING', value: fmt(awaitingValue), sub: (awaitingCount == null ? TRUTH_DASH : awaitingCount) + ' quote' + (awaitingCount !== 1 ? 's' : '') + ' out', tint: 'rgba(200,80,60,0.12)', col: '#C85040' },
          ].map(tile => (
            <div key={tile.label} style={{ background: tile.tint, borderRadius: 12, padding: '10px 12px', borderTop: '1px solid rgba(255,255,255,0.85)', textAlign: 'center' }}>
              <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.5, color: tile.col, marginBottom: 4 }}>{tile.label}</div>
              <div style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic', fontSize: 18, color: tile.col, lineHeight: 1.2 }}>{tile.value}</div>
              {tile.sub && <div style={{ fontSize: 10, color: '#6A5840', marginTop: 3 }}>{tile.sub}</div>}
              {/* COMPANION-TRUTH-V2 B5 (DECISIONS 176.140): a total shows its margin (WON YTD: D20), or not available with the reason. */}
              {tile.margin && <div style={{ fontSize: 10, color: '#6A5840', marginTop: 2 }}>{tile.margin}</div>}
            </div>
          ))}
        </div>

        {/* ── FUNNEL STRIP ── */}
        <div style={{ margin: '10px 12px 0' }}>
          <div style={{ fontSize: 10, fontWeight: 600, color: '#9A8870', textTransform: 'uppercase', letterSpacing: 0.7, marginBottom: 6 }}>Stage</div>
          <div style={{ display: 'flex', gap: 0, background: 'rgba(255,252,242,0.6)', borderRadius: 14, padding: 5, borderTop: '1px solid rgba(255,255,255,0.8)' }}>
            {['active', 'won', 'lost'].map(stage => {
              const isActive = stageFilter === stage;
              const cs = chipStyles[stage];
              return (
                <button key={stage} onClick={() => { setStageFilter(isActive ? null : stage); setExpandedZone(null); }} style={{
                  flex: 1, borderRadius: 10, padding: '9px 4px 8px', textAlign: 'center', cursor: 'pointer', border: 'none',
                  transition: 'all 0.18s',
                  background: isActive ? cs.bg : 'transparent',
                  boxShadow: isActive ? cs.shadow : 'none',
                  ...uvx(isActive ? studioSurface.pressed : {}),
                }}>
                  <div style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic', fontSize: 17, color: isActive ? cs.numCol : '#9A8870', lineHeight: 1.2 }}>{stageCount[stage]}</div>
                  <div style={{ fontSize: 10, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.5, color: isActive ? cs.lblCol : '#B0A090', marginTop: 2 }}>{stage}</div>
                </button>
              );
            })}
          </div>
        </div>
        </>)}

        {!studioOn && (<>
        {/* Search bar */}
        <div style={{ margin:'10px 12px 0', background:t.colors.glass, border:`1px solid ${t.colors.glassBorder}`, borderTop:`1px solid ${t.colors.glassBorderTop}`, borderRadius:14, padding:'9px 14px', display:'flex', alignItems:'center', gap:10, ...uvx(() => ({ ...studioSurface.pressed(), minHeight: 44 })) }}>
          <Icon name="filter" size={16} color={t.colors.textTertiary} />
          <input value={searchQuery} onChange={e => setSearchQuery(e.target.value)} placeholder="Search projects, clients…"
            style={{ flex:1, background:'none', border:'none', outline:'none', fontSize:14, color:t.colors.text, fontFamily:'inherit' }} />
          {searchQuery && (
            <button onClick={() => setSearchQuery('')} style={{ background:'none', border:'none', cursor:'pointer', color:t.colors.textTertiary, fontSize:16, lineHeight:1 }}><svg width="10" height="10" viewBox="0 0 10 10" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><line x1="2" y1="2" x2="8" y2="8"/><line x1="8" y1="2" x2="2" y2="8"/></svg></button>
          )}
        </div>

        {/* Gone silent zone — persistent, not affected by month navigation.
            Switch on, "No reply in over a week" (Today's stale rule) takes
            its place below the rows; the Gone silent list stays one tap
            away in the stage view (COMPANION-STUDIO-LIT-V1 track 3b). */}
        {!studioOn && silentProps.length > 0 && !stageFilter && !searchQuery && (
          <div style={{ margin: '8px 12px 0' }}>
            <div style={{ marginBottom: 14 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8, flexWrap: 'wrap' }}>
                <div style={{ width: 3, height: 22, borderRadius: 2, background: 'linear-gradient(180deg, #C85040, #982830)', flexShrink: 0 }} />
                <div style={{ fontSize: 13, fontWeight: 700, letterSpacing: -0.2, lineHeight: 1, color: '#A03020', ...uvx(studioSection) }}>Gone silent</div>
                <div style={{ fontSize: 11, color: '#C06050', marginTop: 2 }}>{'No engagement' + studioSep() + 'at risk'}</div>
                <span style={{ fontSize: 11, fontWeight: 600, padding: '3px 9px', borderRadius: 20, background: 'rgba(200,80,60,0.12)', color: '#A03020', marginLeft: 'auto' }}>{fmt(silentValue)}</span>
              </div>
              {silentProps.map(p => renderSilentCard(p))}
            </div>
          </div>
        )}

        {/* Month navigation — only show when not searching */}
        {!searchQuery && !stageFilter && (
          <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', margin:'8px 12px 0' }}>
            <button onClick={() => setSelectedMonth(prev => { const d = new Date(prev.year, prev.month - 1); return { year: d.getFullYear(), month: d.getMonth() }; })}
              style={{ width:32, height:32, background:t.colors.glass, border:`1px solid ${t.colors.glassBorder}`, borderTop:`1px solid ${t.colors.glassBorderTop}`, borderRadius:16, display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer' }}>
              <Icon name="arrow" size={16} color={t.colors.textSecondary} />
            </button>
            <div style={{ textAlign:'center' }}>
              <div style={{ fontSize:14, fontWeight:700, color:t.colors.text }}>
                {new Date(selectedMonth.year, selectedMonth.month).toLocaleDateString('en-GB', { month:'long', year:'numeric' })}
              </div>
              <div style={{ fontSize:11, color:t.colors.textTertiary }}>
                {monthProps.length} proposal{monthProps.length !== 1 ? 's' : ''}{studioSep()}{fmt(monthProps.reduce((s,p) => s + getValue(p), 0))}
              </div>
            </div>
            <button onClick={() => setSelectedMonth(prev => { const d = new Date(prev.year, prev.month + 1); return { year: d.getFullYear(), month: d.getMonth() }; })}
              style={{ width:32, height:32, background:t.colors.glass, border:`1px solid ${t.colors.glassBorder}`, borderTop:`1px solid ${t.colors.glassBorderTop}`, borderRadius:16, display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer' }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M5 12h14M12 5l7 7-7 7" stroke={t.colors.textSecondary} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
            </button>
          </div>
        )}

        {/* ── FILTERED VIEW ── */}
        {stageFilter && (
          <div style={{ margin: '12px 12px 0' }}>
            {/* Filter header */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
              <span style={{ fontSize: 13, fontWeight: 700, color: '#3A2E1A' }}>{stageLabels[stageFilter]}</span>
              <span onClick={() => { setStageFilter(null); setExpandedZone(null); }} style={{ fontSize: 11, color: '#1A5A78', cursor: 'pointer' }}>× Clear filter</span>
            </div>
            {/* Compressed zone tabs */}
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 10 }}>
              {heatCards.length > 0 && (
                <button onClick={() => setExpandedZone(expandedZone === 'heat' ? null : 'heat')} style={{
                  background: 'linear-gradient(135deg, rgba(200,144,48,0.18), rgba(200,100,30,0.06))',
                  boxShadow: '0 0 8px rgba(200,144,48,0.15), inset 0 1px 0 rgba(255,255,255,0.4)',
                  color: '#A07020', padding: '7px 13px', borderRadius: 20, fontSize: 11, fontWeight: 600, border: 'none', cursor: 'pointer'
                }}>{(t.theme === 'uv' ? '' : '• ') + 'Live heat '}{heatCards.length} {studioCaret(expandedZone === 'heat', '▴', '▾')}</button>
              )}
              {silentProps.length > 0 && (
                <button onClick={() => setExpandedZone(expandedZone === 'silent' ? null : 'silent')} style={{
                  background: 'linear-gradient(135deg, rgba(200,80,60,0.16), rgba(200,80,60,0.05))',
                  boxShadow: '0 0 8px rgba(200,80,60,0.12), inset 0 1px 0 rgba(255,255,255,0.35)',
                  color: '#A03020', padding: '7px 13px', borderRadius: 20, fontSize: 11, fontWeight: 600, border: 'none', cursor: 'pointer'
                }}>{(t.theme === 'uv' ? '' : '• ') + 'Gone silent '}{fmt(silentValue)} {studioCaret(expandedZone === 'silent', '▴', '▾')}</button>
              )}
            </div>
            {/* Accordion panels */}
            {expandedZone === 'heat' && (
              <div style={{ marginBottom: 10, overflow: 'hidden', transition: 'max-height 0.25s ease' }}>
                {heatCards.map(p => renderHeatCard(p, true))}
              </div>
            )}
            {expandedZone === 'silent' && (
              <div style={{ marginBottom: 10, overflow: 'hidden', transition: 'max-height 0.25s ease' }}>
                {silentProps.map(p => renderSilentCard(p))}
              </div>
            )}
            {/* Filtered proposals */}
            {filteredProps.length > 0 ? filteredProps.map(p => renderProposalCard(p)) : (
              <div style={{ padding: 20, textAlign: 'center' }}>
                <span style={{ fontSize: 13, fontStyle: 'italic', color: '#9A8870' }}>No {stageFilter} proposals</span>
              </div>
            )}
          </div>
        )}

        {/* ── DEFAULT VIEW (no stage filter) ── */}
        {!stageFilter && (
          <div style={{ margin: '12px 12px 0' }}>
            {/* Heat zone */}
            {heatCards.length > 0 && (
              <div style={{ marginBottom: 14 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8, flexWrap: 'wrap' }}>
                  <div style={{ width: 3, height: 22, borderRadius: 2, background: 'linear-gradient(180deg, #C89030, #A06820)', flexShrink: 0 }} />
                  <div style={{ fontSize: 13, fontWeight: 700, letterSpacing: -0.2, lineHeight: 1, color: '#8A5A10', ...uvx(studioSection) }}>Live heat</div>
                  <div style={{ fontSize: 11, color: '#B08040', marginTop: 2 }}>Proposals being read now</div>
                  <span style={{ fontSize: 11, fontWeight: 600, padding: '3px 9px', borderRadius: 20, background: 'rgba(200,144,48,0.12)', color: '#A07020', marginLeft: 'auto' }}>{heatCards.length} signal{heatCards.length !== 1 ? 's' : ''}</span>
                </div>
                {heatCards.map(p => renderHeatCard(p, false))}
              </div>
            )}

            {/* Proposals zone — month-filtered */}
            {displayProps.length > 0 && (
              <div style={{ marginBottom: 14 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8, flexWrap: 'wrap' }}>
                  <div style={{ width: 3, height: 22, borderRadius: 2, background: 'linear-gradient(180deg, #1A6A90, #0E4060)', flexShrink: 0 }} />
                  <div style={{ fontSize: 13, fontWeight: 700, letterSpacing: -0.2, lineHeight: 1, color: '#0E4A70', ...uvx(studioSection) }}>Proposals</div>
                  <div style={{ fontSize: 11, color: '#3A7090', marginTop: 2 }}>{searchQuery ? 'Search results' : new Date(selectedMonth.year, selectedMonth.month).toLocaleDateString('en-GB', { month: 'long' })}</div>
                  <span style={{ fontSize: 11, fontWeight: 600, padding: '3px 9px', borderRadius: 20, background: 'rgba(26,106,144,0.12)', color: '#1A5A78', marginLeft: 'auto' }}>{displayProps.length} proposal{displayProps.length !== 1 ? 's' : ''}</span>
                </div>
                {displayProps.map(p => renderProposalCard(p))}
              </div>
            )}
            {displayProps.length === 0 && allProps.length > 0 && !searchQuery && (
              <div style={{ padding: '20px 16px', textAlign: 'center' }}>
                <div style={{ fontSize: 13, fontStyle: 'italic', color: '#9A8870' }}>No proposals in {new Date(selectedMonth.year, selectedMonth.month).toLocaleDateString('en-GB', { month: 'long', year: 'numeric' })}</div>
              </div>
            )}

            {/* Empty state */}
            {allProps.length === 0 && (
              <div style={{ padding: '30px 20px', textAlign: 'center' }}>
                <div style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic', fontSize: 18, color: '#9A8870', marginBottom: 8 }}>Nothing in the pipe yet.</div>
                <div style={{ fontSize: 12, color: '#B0A090' }}>A site visit is the fastest way to change that.</div>
              </div>
            )}

            {allProps.length > 0 && awaitingCount === 0 && heatCards.length === 0 && silentProps.length === 0 && (
              <>
                {renderSkeleton('Nothing active yet. Time to get in front of someone.')}
              </>
            )}
          </div>
        )}
        </>)}

        {studioOn && chaseItem && (
          <ChaseSheet item={chaseItem} onClose={() => setChaseItem(null)} onNav={onNav} currentUser={currentUser} source="companion-pipeline" />
        )}

      </div>
      <TabBar active={18} onChange={onNav} divisionId={div && div.id ? div.id : "lighting"} />
    </div>
  );
};

// ════════════════════════════════════════════════════
// SCREEN 6: ISSUE CAPTURE (simplified)
// ════════════════════════════════════════════════════
const IssueCaptureScreenBody = ({ onBack, onNav, project, onUpdateProject, currentUser }) => {
  const div = getDivisionConfig(currentUser);
  const divColor = div.id === "aircon" ? t.colors.blue : t.colors.gold;
  const [severity, setSeverity] = useState("Medium");
  const [description, setDescription] = useState("");
  const [done, setDone] = useState(false);
  const photoRef = useRef(null);
  const [photo, setPhoto] = useState(null);

  const saveIssue = () => {
    if (!description.trim()) return;
    const issue = {
      id: Date.now(),
      description: description.trim(),
      severity,
      photo: photo || null,
      date: new Date().toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }),
      time: new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" }),
    };
    if (project?.id && onUpdateProject) {
      const existing = project.issues || [];
      onUpdateProject(project.id, { issues: [...existing, issue] });
    }
    setDone(true);
  };

  const handlePhoto = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = ev => setPhoto(ev.target.result);
    reader.readAsDataURL(file);
    e.target.value = "";
  };

  if (done) return (
    <div style={{ flex: 1, overflowY: "auto", WebkitOverflowScrolling: "touch", overscrollBehavior: "contain", paddingBottom: 100, background: "#E8DCC8", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: 32, textAlign: "center" }}>
      <div style={{ width: 80, height: 80, borderRadius: "50%", background: `${divColor}18`, border: `1px solid ${divColor}40`, display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 20, boxShadow: `0 4px 20px ${divColor}30`, ...uvx(() => ({ ...studioSurface.pressed(), borderRadius: "50%" })) }}>
        <Icon name="check" size={40} color={t.theme === 'uv' ? STUDIO_TOKENS.ink : divColor} />
      </div>
      <h2 style={{ fontSize: 22, fontWeight: 800, color: t.colors.text, letterSpacing: -0.5, fontFamily: "system-ui, -apple-system, sans-serif", marginBottom: 8, ...uvx(() => ({ ...studioType.title(), fontSize: 39, marginBottom: 8 })) }}>Issue Logged</h2>
      <p style={{ fontSize: 13, color: t.colors.textSecondary, marginBottom: 8 }}>Saved to {project?.name || "project"}</p>
      <p style={{ fontSize: 11, color: t.colors.textTertiary, marginBottom: 28 }}>{new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}</p>
      <Btn label="Back to Project" variant="primary" color={divColor} fullWidth studioMain onClick={() => onNav(1)} />
      <Btn label="Log Another" variant="ghost" fullWidth color={divColor} onClick={() => { setDone(false); setDescription(""); setPhoto(null); setSeverity("Medium"); }} />
    </div>
  );

  return (
    <div style={{ flex: 1, overflowY: "auto", WebkitOverflowScrolling: "touch", overscrollBehavior: "contain", paddingBottom: 100, background: "#E8DCC8", display: "flex", flexDirection: "column" }}>
      <NavBar title={project?.name ? `Issue${studioSep()}${project.name}` : "Log Issue"} onBack={onBack} color={divColor} />
      <input ref={photoRef} type="file" accept="image/*" capture="environment" style={{ display: "none" }} onChange={handlePhoto} />
      <div style={{ flex: 1, overflowY: "auto", padding: "20px 20px 100px" }}>

        {/* Photo capture — prominent */}
        <div onClick={() => photoRef.current?.click()} style={{ marginBottom: 16, borderRadius: t.radius.lg, overflow: "hidden", cursor: "pointer", border: `1px dashed ${photo ? "rgba(74,222,128,0.4)" : t.colors.glassBorder}`, background: photo ? "none" : "rgba(255,255,255,0.03)", minHeight: 140, display: "flex", alignItems: "center", justifyContent: "center", position: "relative" }}>
          {photo ? (
            <img src={photo} alt="issue" style={{ width: "100%", maxHeight: 220, objectFit: "cover", display: "block" }} />
          ) : (
            <div style={{ textAlign: "center", padding: 24 }}>
              <Icon name="camera" size={36} color={t.theme === 'uv' ? STUDIO_TOKENS.ink : t.colors.amber} style={{ margin: "0 auto 10px" }} />
              <p style={{ fontSize: 14, fontWeight: 700, color: t.colors.amber, ...uvx({ color: STUDIO_TOKENS.ink, fontSize: 16, fontWeight: 600 }) }}>Tap to photograph issue</p>
              <p style={{ fontSize: 11, color: t.colors.textTertiary, marginTop: 4 }}>{t.theme === 'uv' ? 'The photo is dated and saved with the job' : 'Evidence captured, timestamped, attached to project'}</p>
            </div>
          )}
          {photo && (
            <button onClick={e => { e.stopPropagation(); setPhoto(null); }} style={{ position: "absolute", top: 8, right: 8, background: "rgba(0,0,0,0.6)", border: "none", borderRadius: "50%", width: 28, height: 28, cursor: "pointer", color: "#fff", fontSize: 12, display: "flex", alignItems: "center", justifyContent: "center", ...uvx(() => ({ ...studioSurface.slip(), width: 44, height: 44, borderRadius: STUDIO_TOKENS.button.radius, top: 8, right: 8, color: STUDIO_TOKENS.ink })) }}><svg width="10" height="10" viewBox="0 0 10 10" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><line x1="2" y1="2" x2="8" y2="8"/><line x1="8" y1="2" x2="2" y2="8"/></svg></button>
          )}
        </div>

        <div style={{ marginBottom: 16 }}>
          <label style={{ fontSize: 11, fontWeight: 700, color: t.colors.textSecondary, textTransform: "uppercase", letterSpacing: 0.5, display: "block", marginBottom: 8 }}>Description</label>
          <div style={{ background: t.colors.glass, border: `0.5px solid ${description.trim() ? t.colors.glassBorderGold : t.colors.glassBorder}`, borderRadius: t.radius.lg, padding: 14, transition: "border 0.2s" }}>
            <textarea rows={4} value={description} onChange={e => setDescription(e.target.value)} placeholder={`Describe the issue${studioDash()}access denied, damaged equipment, safety concern, drawing discrepancy...`} style={{ width: "100%", background: "none", border: "none", outline: "none", color: t.colors.text, fontSize: 14, fontFamily: "'SF Pro Text', sans-serif", resize: "none", lineHeight: 1.5 }} />
          </div>
        </div>

        <div style={{ marginBottom: 24 }}>
          <label style={{ fontSize: 11, fontWeight: 700, color: t.colors.textSecondary, textTransform: "uppercase", letterSpacing: 0.5, display: "block", marginBottom: 8 }}>Severity</label>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: 8 }}>
            {["Low", "Medium", "High", "Critical"].map(s => {
              const c = { Critical: t.colors.red, High: t.colors.amber, Medium: t.colors.blue, Low: t.colors.green }[s];
              const active = severity === s;
              return (
                <button key={s} onClick={() => setSeverity(s)} style={{ padding: "10px 4px", borderRadius: t.radius.md, cursor: "pointer", background: active ? `${c}18` : t.colors.glass, border: active ? `1px solid ${c}50` : `0.5px solid ${t.colors.glassBorder}`, color: active ? c : t.colors.textTertiary, fontSize: 11, fontWeight: 700, transition: "all 0.15s ease", ...uvx(() => ({ ...(active ? studioSurface.pressed() : studioSurface.slip()), color: active ? STUDIO_TOKENS.ink : STUDIO_TOKENS.muted, fontSize: 14, fontWeight: active ? 700 : 400, borderRadius: STUDIO_TOKENS.button.radius })) }}>{s}</button>
              );
            })}
          </div>
        </div>

        <Btn label={t.theme === 'uv' ? 'Save the issue' : 'Save Issue to Project'} variant="primary" fullWidth studioMain onClick={saveIssue} disabled={!description.trim()} color={divColor} />
      </div>
      <TabBar active={0} onChange={onNav} divisionId={div && div.id ? div.id : "lighting"} />
    </div>
  );
};

// ════════════════════════════════════════════════════
// SCREEN 7: SETTINGS
// ════════════════════════════════════════════════════
// ════════════════════════════════════════════════════
// SCREEN 11: MORE — landing hub
// ════════════════════════════════════════════════════
// ==== STUDIO_C4_START ====
// COMPANION-STUDIO-V1 track C4: pieces the More, Settings, Suppliers, Contacts,
// MyTargets and sign-in screens share under the theme. Every one is only ever
// called when t.theme === 'uv' (or inside uvx), so with the switch off nothing
// here runs. Values come from STUDIO_TOKENS and the studio* helpers; no colour
// is typed in this block.
// The save toast and the Settings test-mode toast: raised paper, ink words.
// P0 tidy: under the theme a toast is a banner over the persistent header
// (8px below the safe-area inset, the same line as the autosave pill), never at
// the bottom and never over a screen's own buttons. At the bottom it sat over
// the area screen's Previous and Back to areas buttons ("Logged 6x Downlight"
// covered them); 74px down it hid the "M" of Mark done. It takes no taps, so
// the header's bell and mic work through it, and every toast that takes this
// style gets that (the Settings test-mode and the Recording for X toasts did
// not set it themselves). It is as wide as its words, up to the screen less
// 16px a side, so a long message wraps to a few lines rather than a tall
// column. Switch off keeps its place.
const studioToastStyle = () => ({
  position: 'fixed', top: 'calc(env(safe-area-inset-top, 0px) + 8px)', bottom: 'auto',
  width: 'max-content', maxWidth: 'calc(100vw - 32px)', textAlign: 'center', pointerEvents: 'none',
  background: STUDIO_TOKENS.paper.solid, color: STUDIO_TOKENS.ink,
  borderRadius: `${STUDIO_TOKENS.button.radius}px`, boxShadow: STUDIO_TOKENS.shadow.slip,
  fontFamily: STUDIO_TOKENS.fonts.body, fontSize: '14px', fontWeight: '600', padding: '12px 18px',
});
// The page frame: transparent, so the Studio ground and grain show through.
const studioPage = () => ({
  flex: 1, overflowY: "auto", WebkitOverflowScrolling: "touch", overscrollBehavior: "contain",
  paddingBottom: 100, display: "flex", flexDirection: "column",
});
// An input: pressed in, 44px, 16px (the shaping pass never enters inputs).
const studioInput = () => ({
  ...studioSurface.pressed(), width: "100%", boxSizing: "border-box", minHeight: 44, padding: "10px 14px",
  borderRadius: STUDIO_TOKENS.button.radius, fontSize: 16, fontFamily: STUDIO_TOKENS.fonts.body,
  color: STUDIO_TOKENS.ink, outline: "none", WebkitAppearance: "none",
});
// A row inside a raised card: 56px, hairline above all but the first.
const studioRow = (last) => ({
  display: "flex", alignItems: "center", gap: 14, padding: "12px 18px", minHeight: 56,
  borderBottom: last ? "none" : `1px solid ${STUDIO_TOKENS.hairline}`,
});
// The page head: an optional Back action in violet text, the title in Sentient
// Light 39, one muted line under it. These screens had no big number to lead
// with, so the title leads.
const StudioHead = ({ title, onBack, backLabel, sub }) => studioShape(
  <div style={{ padding: "14px 20px 12px", flexShrink: 0, position: "relative", zIndex: 1 }}>
    {onBack && (
      <button onClick={onBack} style={{ ...studioType.action(), display: "inline-flex", alignItems: "center", gap: 4, minHeight: 44, cursor: "pointer", fontFamily: "inherit", marginLeft: -4 }}>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M15 18l-6-6 6-6"/></svg>
        {backLabel || "Back"}
      </button>
    )}
    <h1 style={{ ...studioType.title(), fontSize: 39, lineHeight: 1.1, marginTop: onBack ? 2 : 0 }}>{title}</h1>
    {sub ? <div style={{ fontSize: 14, color: STUDIO_TOKENS.muted, marginTop: 6 }}>{sub}</div> : null}
  </div>
);
// A labelled text field for the sign-in screens: column head in muted words,
// the input pressed in. (Field itself is shared with the capture screens and
// belongs to track C3.)
const StudioField = ({ label, value, onChange, placeholder }) => (
  <div style={{ marginBottom: 16 }}>
    <label style={{ fontSize: 13, color: STUDIO_TOKENS.muted, display: "block", marginBottom: 6 }}>{label}</label>
    <input value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder} style={studioInput()} />
  </div>
);
// The one main action as a flat ultraviolet button (full width), used where the
// shared Btn is not themed. Disabled looks the same but dimmer and does nothing.
const StudioPrimary = ({ label, onClick, disabled, busy }) => (
  <button onClick={disabled ? undefined : onClick} disabled={!!disabled}
    style={{ ...studioSurface.primary(), width: "100%", cursor: disabled ? "not-allowed" : (busy ? "wait" : "pointer"), fontFamily: STUDIO_TOKENS.fonts.body, opacity: disabled ? 0.5 : 1 }}>
    {label}
  </button>
);
// ==== STUDIO_C4_END ====

// STUDIO-LIT-PHONE-V1 item 5 (More and My performance, switch on only).
// The five runs in the prototype's order, with the portal's streak keys.
const PERF_RUNS = [['prospector', 'Prospector'], ['builder', 'Builder'], ['closer', 'Closer'], ['conversion', 'Conversion'], ['platform', 'Platform']];
// The streaks cache Today and My performance write ({date, data}), and
// whether it was written today. at_risk and current_week_status are about
// today (streaks_at_risk reads the engine's clock), so a copy from another
// day never says a run breaks.
const perfStreaksCache = () => {
  try {
    const c = JSON.parse(localStorage.getItem('lumen_streaks') || 'null');
    if (!c || !c.data || !c.data.platform) return null;
    return { data: c.data, today: c.date === new Date().toISOString().split('T')[0] };
  } catch (e) { return null; }
};
// The runs at risk, by name, from the portal's at_risk list
// (streaks.streaks_at_risk: streak_type, label, current_length, days_remaining).
const perfAtRiskNames = (s) => {
  const list = s && Array.isArray(s.at_risk) ? s.at_risk : [];
  return list.map((r) => {
    if (!r) return '';
    if (r.label) return String(r.label);
    const k = String(r.streak_type || '');
    return k ? k.charAt(0).toUpperCase() + k.slice(1) : '';
  }).filter(Boolean);
};
// A run's week ends on Sunday; on the Sunday itself it breaks tonight.
const perfBreaksWhen = (now) => (now.getDay() === 0 ? 'tonight' : 'on Sunday');
// "Prospector breaks on Sunday", "Prospector and Closer break on Sunday", or ''.
const perfAtRiskLine = (s, now) => {
  const n = perfAtRiskNames(s);
  if (n.length === 0) return '';
  const names = n.length === 1 ? n[0] : `${n.slice(0, -1).join(', ')} and ${n[n.length - 1]}`;
  return `${names} ${n.length === 1 ? 'breaks' : 'break'} ${perfBreaksWhen(now)}`;
};
// A run's muted line: what happens this week when it is at risk (status and
// grace_banked), otherwise how far it is from the best run.
const perfRunHint = (r, statusToday, now) => {
  if (statusToday && r.current_week_status === 'at_risk') {
    return (r.grace_banked || 0) > 0
      ? 'Nothing yet this week. A grace week will hold it.'
      : `Breaks ${perfBreaksWhen(now)}. No grace left.`;
  }
  if (r.best <= 0) return 'No run yet.';
  const gap = r.best - r.current;
  if (gap <= 0) return 'At your best. One more week beats it.';
  if (gap === 1) return 'One more week matches your best.';
  return `${gap} more weeks to match your best.`;
};

const MoreScreen = ({ onNav, currentUser }) => {
  const div = getDivisionConfig(currentUser);
  const divColor = div.id === "aircon" ? t.colors.blue : t.colors.gold;
  const [showAboutModal, setShowAboutModal] = React.useState(false);

  // Intelligence Level formula from UX Architecture doc
  const intelligenceData = React.useMemo(() => {
    try {
      const projects = JSON.parse(localStorage.getItem(`asg_projects_${currentUser?.id}`) || "[]");
      const proposals = JSON.parse(localStorage.getItem(`asg_proposals_${currentUser?.id}`) || "[]");
      // Months active: 5% per month, max 25%
      const createdTimes = projects.map(p => p.createdAt).filter(Boolean);
      const firstCreated = createdTimes.length > 0 ? Math.min(...createdTimes) : Date.now();
      const monthsActive = Math.max(1, Math.round((Date.now() - firstCreated) / (30 * 24 * 60 * 60 * 1000)));
      const monthsScore = Math.min(monthsActive * 5, 25);
      // Surveys completed: 3% each, max 30%
      const surveysCompleted = projects.filter(p => p.surveyZones && p.surveyZones.length > 0).length;
      const surveysScore = Math.min(surveysCompleted * 3, 30);
      // Voice notes recorded: 2% each, max 20%
      const voiceNotes = projects.reduce((s, p) => s + ((p.voiceNotes || []).length), 0);
      const voiceScore = Math.min(voiceNotes * 2, 20);
      // Proposals tracked: 3% each, max 15%
      const proposalsScore = Math.min(proposals.length * 3, 15);
      // Win/loss debriefs: 2% each, max 10%
      const debriefs = projects.filter(p => p.debrief).length;
      const debriefsScore = Math.min(debriefs * 2, 10);
      const total = Math.min(monthsScore + surveysScore + voiceScore + proposalsScore + debriefsScore, 100);
      return { level: total, months: monthsActive, surveys: surveysCompleted, voiceNotes, proposals: proposals.length };
    } catch(e) { return { level: 0, months: 0, surveys: 0, voiceNotes: 0, proposals: 0 }; }
  }, [currentUser]);
  const intelligenceLevel = intelligenceData.level;

  // Studio (track C4). The five destinations are one raised card on hairline
  // rows (you act on them); the intelligence level is the screen's one big
  // number, pressed in (it is a total). Same rows, same actions, same figures.
  if (t.theme === 'uv') {
    const ink = STUDIO_TOKENS.ink; const muted = STUDIO_TOKENS.muted;
    // STUDIO-LIT-PHONE-V1 item 5 (the prototype's `more`): one paper card of
    // rows, each a line icon on a plain tile (ink strokes: violet is Eva and
    // the main action only), the row's name, one muted line from real data
    // and an arrow. Every muted line is either a count the phone holds, the
    // portal's own words, or a plain description; none is a sample line.
    // The device-made intelligence level is not shown with the switch on (the
    // prototype has no such score); About stays as the last row.
    const plural = (n, w) => `${n} ${w}${n !== 1 ? "s" : ""}`;
    // P0 tidy: the "Relationships" row is gone. It opened screen 21, which is
    // Contacts (the accounts list lives at the top of that screen), so it was
    // the same destination as the Contacts row two rows down.
    // My performance: the run at risk today (at_risk), or a plain line.
    const sc = perfStreaksCache();
    const riskLine = sc && sc.today ? perfAtRiskLine(sc.data, new Date()) : '';
    // Suppliers: the phone's own list has no dates (G8), so a count, not "this year".
    const supplierCount = getSuppliers().length;
    const userName = currentUser && typeof currentUser.name === 'string' ? currentUser.name.trim() : '';
    const lineIcons = {
      perf: <path d="M4 19h16M7 16V9M12 16V5M17 16v-4" />,
      worth: <path d="M12 3v18M16 7H10a2.5 2.5 0 0 0 0 5h4a2.5 2.5 0 0 1 0 5H8" />,
      plans: <g><path d="M4 5l5-2 6 2 5-2v16l-5 2-6-2-5 2z" /><path d="M9 3v16M15 5v16" /></g>,
      contacts: <path d="M5 4h11a3 3 0 0 1 3 3v13H8a3 3 0 0 1-3-3z" />,
      suppliers: <path d="M3 7h11v10H3zM14 10h4l3 3v4h-7" />,
      settings: <g><circle cx="12" cy="12" r="3" /><path d="M12 3v3M12 18v3M3 12h3M18 12h3" /></g>,
      about: <g><circle cx="12" cy="12" r="9" /><path d="M12 11v5M12 8h.01" /></g>,
    };
    const rows = [
      { label: "My performance", icon: "perf", hint: riskLine || "Your week, your runs and your bests", action: () => onNav(17) },
      { label: "Worth", icon: "worth", hint: "Supplier quotes compared", action: () => onNav(15) },
      { label: "Site plans", icon: "plans", hint: "Floor plans and annotations", action: () => onNav(8) },
      { label: "Contacts", icon: "contacts", hint: "Everyone you work with", action: () => onNav(21) },
      { label: "Suppliers", icon: "suppliers", hint: supplierCount > 0 ? plural(supplierCount, "supplier") : "Add the suppliers you use", action: () => onNav(22) },
      { label: "Settings", icon: "settings", hint: userName ? `Signed in as ${userName}` : "Your profile and sync", action: () => onNav(7) },
      { label: "About", icon: "about", hint: "App version and support", action: () => setShowAboutModal(true) },
    ];
    return studioShape(
      <div style={studioPage()}>
        <div style={{ padding: "14px 16px 8px", flexShrink: 0, position: "relative", zIndex: 1 }}>
          <h1 style={{ ...studioType.title(), fontSize: 39, lineHeight: 1.05, margin: 0, minHeight: 50, display: "flex", alignItems: "center" }}>More</h1>
        </div>
        <div style={{ padding: "0 16px 100px", position: "relative", zIndex: 1 }}>
          <section aria-label="More" style={{ ...studioSurface.raised(), borderRadius: STUDIO_TOKENS.radius.card, padding: "6px 14px" }}>
            {rows.map((row, i) => (
              <button key={row.label} data-more-row={row.label} onClick={row.action} style={{ display: "grid", gridTemplateColumns: "40px minmax(0, 1fr) 14px", gap: 12, alignItems: "center", minHeight: 44, width: "100%", boxSizing: "border-box", padding: "12px 0", background: "none", border: "none", borderTop: i === 0 ? "none" : `1px solid ${STUDIO_TOKENS.hairline}`, textAlign: "left", cursor: "pointer", fontFamily: "inherit" }}>
                <span aria-hidden="true" style={{ width: 38, height: 38, borderRadius: 12, display: "grid", placeItems: "center", background: studioInk(0.06) }}>
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={ink} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">{lineIcons[row.icon]}</svg>
                </span>
                <span style={{ display: "flex", flexDirection: "column", gap: 1, minWidth: 0 }}>
                  <b style={{ fontSize: 16, fontWeight: 700, color: ink }}>{row.label}</b>
                  <span data-more-line style={{ fontSize: 13, color: muted, overflowWrap: "anywhere" }}>{row.hint}</span>
                </span>
                <span aria-hidden="true" style={{ fontSize: 20, color: muted, alignSelf: "center" }}>{"›"}</span>
              </button>
            ))}
          </section>
        </div>
        <TabBar active={16} onChange={onNav} divisionId={div && div.id ? div.id : "lighting"} />
        {showAboutModal && (
          <SheetPortal>
          <div onClick={() => setShowAboutModal(false)} style={{ position: "fixed", inset: 0, background: studioInk(0.45), zIndex: 800, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
            <div onClick={e => e.stopPropagation()} style={{ ...studioSurface.raised(), borderRadius: t.radius.lg, padding: "28px 22px 22px", width: "100%", maxWidth: 340, textAlign: "center" }}>
              <img src={ASG_LOGO} alt="ASG" style={{ height: 40, width: "auto", marginBottom: 10 }} />
              <div style={{ fontSize: 14, color: muted, marginBottom: 16 }}>Companion app</div>
              <div style={{ fontSize: 16, color: ink, lineHeight: 1.5, marginBottom: 16 }}>Field intelligence for ASG engineers.</div>
              <div style={{ fontSize: 14, color: muted, lineHeight: 1.5, marginBottom: 12 }}>lumen-portal.up.railway.app</div>
              <button onClick={() => setShowAboutModal(false)} style={{ ...studioType.action(), minHeight: 44, padding: "0 16px", cursor: "pointer", fontFamily: "inherit" }}>Close</button>
            </div>
          </div>
          </SheetPortal>
        )}
      </div>
    );
  }

  return (
    <div style={{ flex: 1, overflowY: "auto", WebkitOverflowScrolling: "touch", overscrollBehavior: "contain", paddingBottom: 100, background: "#E8DCC8", display: "flex", flexDirection: "column" }}>
      <ScreenBlobs />
      <div style={{ padding: "8px 20px 16px", flexShrink: 0 }}>
        <div style={{ fontFamily: "Georgia, serif", fontStyle: "italic", fontSize: 26, color: "#1A1608" }}>More.</div>
        <div style={{ fontSize: 12, color: "rgba(28,24,16,0.52)", marginTop: 2 }}>Tools, contacts & settings</div>
      </div>
      <div style={{ flex: 1, overflowY: "auto", padding: "0 20px 83px", position: "relative" }}>
        <div style={{ background: "rgba(255,252,242,0.88)", border: "1px solid rgba(255,252,240,0.85)", borderTop: "1px solid rgba(255,255,250,0.96)", borderRadius: 18, overflow: "hidden", marginBottom: 20 }}>
          {[
            { label: "Site plans", icon: "plans", hint: "Floor plans and annotations", action: () => onNav(8), iconBg: "rgba(46,104,56,0.1)", iconColor: "#2E6838" },
            { label: "Contacts", icon: "person", hint: "Pre-call intelligence", action: () => onNav(21) },
            { label: "Suppliers", icon: "package", hint: "Your trusted supply chain", action: () => onNav(22), iconBg: "rgba(26,90,120,0.12)", iconColor: "#1A5A78" },
            { label: "Settings", icon: "gear", hint: "Profile, notifications & portal sync", action: () => onNav(7) },
            { label: "About", icon: "star", hint: "App version & support", action: () => setShowAboutModal(true) },
          ].map((row, i, arr) => (
            <div key={row.label}
              onClick={row.action || undefined}
              style={{
                display: "flex", alignItems: "center", gap: 14,
                padding: "15px 16px",
                borderBottom: i < arr.length - 1 ? "0.5px solid rgba(28,24,16,0.08)" : "none",
                cursor: row.action ? "pointer" : "default",
                background: "transparent",
              }}
            >
              <div style={{ width: 36, height: 36, borderRadius: 10, background: row.iconBg || "rgba(200,144,48,0.1)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                <Icon name={row.icon} size={18} color={row.iconColor || divColor} />
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 15, fontWeight: 600, color: "#1A1608", letterSpacing: -0.2 }}>{row.label}</div>
                <div style={{ fontSize: 11, color: "rgba(28,24,16,0.45)", marginTop: 2 }}>{row.hint}</div>
              </div>
              <svg width="7" height="12" viewBox="0 0 7 12" fill="none">
                <path d="M1 1l5 5-5 5" stroke="rgba(28,24,16,0.3)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
          ))}
        </div>
        <div style={{ background: "rgba(255,252,242,0.88)", border: "1px solid rgba(255,252,240,0.85)", borderRadius: 18, padding: "16px 18px" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10 }}>
            <span style={{ fontSize: 9, fontWeight: 700, color: "rgba(28,24,16,0.5)", letterSpacing: 1.2, textTransform: "uppercase" }}>Your Intelligence Level</span>
            <span style={{ fontSize: 13, fontWeight: 700, color: divColor }}>{intelligenceLevel}/100</span>
          </div>
          <div style={{ height: 8, background: "rgba(28,24,16,0.08)", borderRadius: 4, overflow: "hidden" }}>
            <div style={{
              height: "100%",
              width: `${intelligenceLevel}%`,
              background: intelligenceLevel < 30
                ? "linear-gradient(90deg, #C89030, #D4A84B)"
                : intelligenceLevel < 70
                ? "linear-gradient(90deg, #C89030, #2ECC8A)"
                : "linear-gradient(90deg, #2ECC8A, #1A5A78)",
              borderRadius: 4,
              transition: "width 0.8s ease",
            }} />
          </div>
          <p style={{ fontSize: 11, color: "rgba(28,24,16,0.4)", marginTop: 8 }}>
            {intelligenceData.months} month{intelligenceData.months !== 1 ? "s" : ""} · {intelligenceData.surveys} survey{intelligenceData.surveys !== 1 ? "s" : ""} · {intelligenceData.voiceNotes} voice note{intelligenceData.voiceNotes !== 1 ? "s" : ""} · {intelligenceData.proposals} proposal{intelligenceData.proposals !== 1 ? "s" : ""} tracked
          </p>
        </div>
      </div>
      <TabBar active={16} onChange={onNav} divisionId={div && div.id ? div.id : "lighting"} />

      {/* About modal */}
      {showAboutModal && (
        <SheetPortal>
        <div onClick={() => setShowAboutModal(false)} style={{ position: "fixed", inset: 0, background: "rgba(26,22,8,0.45)", zIndex: 800, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
          <div onClick={e => e.stopPropagation()} style={{ background: "#FAF7F0", borderTop: "1px solid rgba(255,255,250,0.96)", borderRadius: 20, padding: "28px 22px 22px", width: "100%", maxWidth: 340, textAlign: "center" }}>
            <img src={ASG_LOGO} alt="ASG" style={{ height: 40, width: "auto", marginBottom: 10 }} />
            <div style={{ fontSize: 11, fontWeight: 700, color: "#8A7A5A", letterSpacing: "0.08em", marginBottom: 16 }}>COMPANION APP</div>
            <div style={{ fontSize: 14, color: "#5A4A2A", lineHeight: 1.6, marginBottom: 16 }}>Field intelligence for ASG engineers.</div>
            <div style={{ fontSize: 11, color: "rgba(26,22,8,0.4)", lineHeight: 1.5, marginBottom: 20 }}>
              lumen-portal.up.railway.app
            </div>
            <button onClick={() => setShowAboutModal(false)} style={{ padding: "11px 32px", borderRadius: 12, background: "rgba(42,58,26,0.08)", border: "none", color: "#5A4A2A", fontSize: 14, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>Close</button>
          </div>
        </div>
        </SheetPortal>
      )}
    </div>
  );
};

// ════════════════════════════════════════════════════
// SCREEN 22: SUPPLIERS SETTINGS
// ════════════════════════════════════════════════════

// SLICE-A3: the add logic, once. SuppliersScreen (More) and SupplierAddSheet
// (over the survey wrap) both run on this hook, so there is one set of add
// rules (supplierAddOutcome / supplierCoversOutcome) and one place that saves.
//   initialCover  a fitting category to tick first (a real grid label, else none).
//   onAdded       called with the supplier after it is saved (an add, or a
//                 duplicate's cover changed). Not called by a remove.
// Saving can throw (storage full or blocked); that is said in the form
// (saveError), never swallowed and never shown as a success.
const useSupplierAdd = (initialCover, onAdded) => {
  const [suppliers, setSuppliers] = React.useState(() => getSuppliers());
  const [newName, setNewName] = React.useState('');
  // S164 — when reached from a wrap "Add suppliers in More" link for a specific
  // fixture type, pre-select that type on the Add Supplier form so the new
  // supplier is already scoped to the type the surveyor came from (one less
  // tap, intent pre-stated). Only seed a value that matches a real grid label
  // so the tick is always visibly reflected; an unknown label lands plainly.
  const [selectedCovers, setSelectedCovers] = React.useState(() =>
    supplierInitialCover(initialCover, FIXTURE_TYPES_GRID.map(ft => ft.label)));
  const [saveError, setSaveError] = React.useState('');

  const persist = (updated) => {
    try { saveSuppliers(updated); } catch (e) {
      setSaveError('Could not save the supplier. This phone’s storage is full or blocked.');
      return false;
    }
    setSaveError('');
    setSuppliers(updated);
    return true;
  };

  const handleDelete = (id) => {
    persist(suppliers.filter(s => s.id !== id));
  };

  const addBlock = supplierAddBlock(newName, suppliers, selectedCovers);
  // A duplicate offers to change what the supplier already held covers,
  // instead of adding a second copy of it.
  const handleUpdateCovers = () => {
    if (!addBlock || !addBlock.duplicate) return;
    const res = supplierCoversOutcome(suppliers, addBlock.duplicate.id, selectedCovers);
    if (res.refused) return;
    if (!persist(res.suppliers)) return;
    setNewName('');
    setSelectedCovers([]);
    if (onAdded && res.supplier) onAdded(res.supplier);
  };

  const handleAdd = () => {
    const res = supplierAddOutcome(suppliers, newName, selectedCovers, Date.now());
    if (!res.ok) return;
    if (!persist(res.suppliers)) return;
    setNewName('');
    setSelectedCovers([]);
    if (onAdded) onAdded(res.supplier);
  };

  const toggleCover = (label) => {
    setSelectedCovers(prev => prev.includes(label) ? prev.filter(x => x !== label) : [...prev, label]);
  };

  return { suppliers, newName, setNewName, selectedCovers, toggleCover, addBlock, handleAdd, handleUpdateCovers, handleDelete, saveError };
};

// The add form: the name, the types it covers, the one main action and why it
// cannot add. Drawn once for both themes and for both homes (the Suppliers
// screen and the sheet over the survey wrap); the headings stay with the caller.
const SupplierAddFields = ({ add }) => {
  const { newName, setNewName, selectedCovers, toggleCover, addBlock, handleAdd, handleUpdateCovers, saveError } = add;
  const addReason = addBlock ? (
    <div role="status" style={{ marginTop: 8, fontSize: 14, color: t.theme === 'uv' ? STUDIO_TOKENS.muted : 'rgba(28,24,16,0.6)' }}>
      {addBlock.reason}
      {addBlock.duplicate && selectedCovers.length > 0 && (
        <button onClick={handleUpdateCovers} style={{ marginLeft: 8, minHeight: 44, background: 'none', border: 'none', padding: 0, fontFamily: 'inherit', fontSize: 14, fontWeight: 700, textDecoration: 'underline', color: 'inherit', cursor: 'pointer' }}>
          Set {addBlock.duplicate.name} to cover {selectedCovers.join(', ')}
        </button>
      )}
      {addBlock.duplicate && selectedCovers.length === 0 && ' Tick the types to change what it covers.'}
    </div>
  ) : null;
  const failure = saveError ? (
    <div role="alert" style={{ marginTop: 8, fontSize: 14, fontWeight: 700, color: t.theme === 'uv' ? STUDIO_TOKENS.ink : '#7A2E18' }}>{saveError}</div>
  ) : null;
  if (t.theme === 'uv') {
    const ink = STUDIO_TOKENS.ink;
    return (
      <>
        <div style={{ ...studioSurface.raised(), borderRadius: t.radius.lg, padding: "16px 16px 18px", marginBottom: 16 }}>
          <input value={newName} onChange={e => setNewName(e.target.value)} placeholder="e.g. Eaton, Helvar..." style={{ ...studioInput(), marginBottom: 16 }} />
          <div style={{ ...studioType.colhead(), marginBottom: 8 }}>Covers these fitting types</div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
            {FIXTURE_TYPES_GRID.map(ft => {
              const sel = selectedCovers.includes(ft.label);
              return (
                <button key={ft.id} onClick={() => toggleCover(ft.label)} aria-pressed={sel} style={{
                  ...(sel ? studioSurface.pressed() : studioSurface.slip()),
                  minHeight: 44, padding: "0 16px", borderRadius: 12, cursor: "pointer", fontFamily: "inherit",
                  fontSize: 14, fontWeight: sel ? 700 : 400, color: ink,
                }}>{ft.label}</button>
              );
            })}
          </div>
        </div>
        <button onClick={handleAdd} aria-disabled={!!addBlock} style={{ ...studioSurface.primary(), width: "100%", cursor: "pointer", fontFamily: "inherit", opacity: addBlock ? 0.5 : 1 }}>Add to supply chain</button>
        {addReason}
        {failure}
      </>
    );
  }
  return (
    <>
      <div style={{ background: "rgba(255,252,242,0.88)", borderTop: "1px solid rgba(255,255,250,0.96)", border: "1px solid rgba(255,252,240,0.85)", borderRadius: 14, padding: "14px 14px 16px", marginBottom: 16 }}>
        <input
          value={newName}
          onChange={e => setNewName(e.target.value)}
          placeholder="e.g. Eaton, Helvar..."
          style={{ width: "100%", padding: "10px 14px", borderRadius: 10, border: "1px solid rgba(26,22,8,0.1)", background: "#F5EFE3", fontSize: 14, fontFamily: "inherit", color: "#1A1608", boxSizing: "border-box", marginBottom: 14 }}
        />

        <div style={{ fontSize: 9, fontWeight: 700, color: "rgba(28,24,16,0.5)", letterSpacing: 1.2, textTransform: "uppercase", marginBottom: 8 }}>Covers these fitting types</div>

        <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 16 }}>
          {FIXTURE_TYPES_GRID.map(ft => {
            const sel = selectedCovers.includes(ft.label);
            return (
              <button key={ft.id} onClick={() => toggleCover(ft.label)} style={{
                padding: "6px 12px", borderRadius: 16, cursor: "pointer", fontFamily: "inherit", fontSize: 12, fontWeight: 600,
                background: sel ? "#2E6838" : "rgba(232,220,200,0.6)",
                color: sel ? "#fff" : "rgba(28,24,16,0.45)",
                border: sel ? "1.5px solid #2E6838" : "1px solid rgba(28,24,16,0.1)",
                transition: "all 0.15s ease",
              }}>{ft.label}</button>
            );
          })}
        </div>
      </div>

      <button onClick={handleAdd} aria-disabled={!!addBlock} style={{
        width: "100%", padding: "13px 24px", borderRadius: 12, border: "none", cursor: "pointer", fontFamily: "inherit",
        background: "#2E6838", color: "#fff", fontSize: 15, fontWeight: 700, textAlign: "center",
        opacity: addBlock ? 0.5 : 1,
      }}>Add to supply chain</button>
      {addReason}
      {failure}
    </>
  );
};

// SLICE-A3: Add a supplier as a sheet over the survey wrap, so the surveyor
// never leaves Prices from. category is the fitting's supplier category (null
// for a fitting that has none); it is ticked first when it is a real grid
// label. onAdded runs after the supplier is saved; the caller closes the sheet
// and re-runs the match.
const SupplierAddSheet = ({ category, onClose, onAdded }) => {
  const add = useSupplierAdd(category, onAdded);
  const uv = t.theme === 'uv';
  const ink = uv ? STUDIO_TOKENS.ink : '#1A1608';
  const muted = uv ? STUDIO_TOKENS.muted : 'rgba(28,24,16,0.6)';
  return (
    <SheetPortal>
    <div onClick={e => { if (e.target === e.currentTarget) onClose(); }}
      style={{ position:'fixed', inset:0, background: uv ? studioInk(0.45) : 'rgba(26,22,8,0.45)', zIndex:9998, display:'flex', alignItems:'center', justifyContent:'center', padding:20 }}>
      <div role="dialog" aria-modal="true" aria-label="Add a supplier"
        style={{ width:'100%', maxWidth:400, maxHeight:'85vh', overflowY:'auto', WebkitOverflowScrolling:'touch', boxSizing:'border-box', padding:'20px 18px 16px',
          ...(uv ? { ...studioSurface.raised(), borderRadius: STUDIO_TOKENS.radius.card } : { background:'#FAF7F0', borderRadius:20 }) }}>
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', gap:10, marginBottom:4 }}>
          <div style={uv ? { ...studioType.heading(), fontStyle:'normal', fontWeight:400 } : { fontFamily:'Georgia, serif', fontStyle:'italic', fontSize:18, fontWeight:700, color:ink }}>Add a supplier</div>
          <button onClick={onClose} aria-label="Close" style={{ width:44, height:44, flexShrink:0, borderRadius: uv ? 12 : '50%', border:'none', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:'inherit', ...(uv ? { ...studioSurface.slip(), color:ink } : { background:'rgba(26,22,8,0.07)' }) }}>
            <svg width="12" height="12" viewBox="0 0 10 10" fill="none" stroke={ink} strokeWidth="1.5" strokeLinecap="round"><line x1="2" y1="2" x2="8" y2="8"/><line x1="8" y1="2" x2="2" y2="8"/></svg>
          </button>
        </div>
        <div style={{ fontSize:14, color:muted, marginBottom:14 }}>
          {category ? `For ${category}. Tick more types if they cover them too.` : 'Covers every fitting type unless you tick some.'}
        </div>
        <SupplierAddFields add={add} />
      </div>
    </div>
    </SheetPortal>
  );
};

const SuppliersScreen = ({ onBack, initialCover, backLabel }) => {
  const add = useSupplierAdd(initialCover);
  const { suppliers, handleDelete } = add;

  // Studio (track C4). The supply chain is one raised card on hairline rows;
  // the add form is another, with pressed-in input and chips (a chosen chip is
  // pressed in, the others raised). Add to supply chain is the one main action.
  if (t.theme === 'uv') {
    const ink = STUDIO_TOKENS.ink; const muted = STUDIO_TOKENS.muted;
    return studioShape(
      <div style={studioPage()}>
        <StudioHead title="Suppliers" onBack={onBack} backLabel={backLabel || "More"} />
        <div style={{ padding: "0 20px 83px", position: "relative", zIndex: 1 }}>
          <div style={{ ...studioType.heading(), marginBottom: 12 }}>Your supply chain</div>
          {suppliers.length === 0 ? (
            <div style={{ ...studioSurface.pressed(), borderRadius: t.radius.lg, padding: "20px 16px", textAlign: "center", marginBottom: 24 }}>
              <div style={{ fontSize: 14, color: muted }}>No suppliers added yet</div>
            </div>
          ) : (
            <div style={{ ...studioSurface.raised(), borderRadius: t.radius.lg, overflow: "hidden", marginBottom: 24 }}>
              {suppliers.map((s, i) => (
                <div key={s.id} style={studioRow(i === suppliers.length - 1)}>
                  <div style={{ ...studioSurface.pressed(), width: 40, height: 40, borderRadius: 20, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                    <span style={{ fontSize: 14, fontWeight: 700, color: ink }}>{s.initials}</span>
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 16, fontWeight: 700, color: ink }}>{s.name}</div>
                    <div style={{ fontSize: 14, color: muted, marginTop: 1 }}>{s.covers && s.covers.length > 0 ? s.covers.join(', ') : 'All fitting types'}</div>
                  </div>
                  <button onClick={() => handleDelete(s.id)} aria-label={`Remove ${s.name}`} style={{ background: "none", border: "none", cursor: "pointer", minWidth: 44, minHeight: 44, fontSize: 20, color: ink, fontWeight: 400, lineHeight: 1, fontFamily: "inherit" }}>&times;</button>
                </div>
              ))}
            </div>
          )}

          <div style={{ ...studioType.heading(), marginBottom: 12 }}>Add a supplier</div>
          <SupplierAddFields add={add} />
        </div>
      </div>
    );
  }

  return (
    <div style={{ flex: 1, overflowY: "auto", WebkitOverflowScrolling: "touch", overscrollBehavior: "contain", background: "#E8DCC8", display: "flex", flexDirection: "column" }}>
      <ScreenBlobs />
      <div style={{ padding: "12px 16px 10px", display: "flex", alignItems: "center", gap: 10, flexShrink: 0 }}>
        <button onClick={onBack} style={{ background: "none", border: "none", cursor: "pointer", padding: 0, display: "flex", alignItems: "center", gap: 4 }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#A87818" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M15 18l-6-6 6-6"/></svg>
          <span style={{ fontSize: 14, fontWeight: 600, color: "#A87818" }}>{backLabel || "More"}</span>
        </button>
        <div style={{ flex: 1, textAlign: "center" }}>
          <span style={{ fontSize: 16, fontWeight: 700, color: "#1A1608" }}>Suppliers</span>
        </div>
        <div style={{ width: 50 }} />
      </div>

      <div style={{ flex: 1, overflowY: "auto", padding: "0 16px 83px", position: "relative" }}>

        {/* YOUR SUPPLY CHAIN */}
        <div style={{ fontSize: 9, fontWeight: 700, color: "rgba(28,24,16,0.5)", letterSpacing: 1.2, textTransform: "uppercase", marginBottom: 10, marginTop: 8 }}>Your Supply Chain</div>

        {suppliers.length === 0 ? (
          <div style={{ background: "rgba(255,252,242,0.88)", borderTop: "1px solid rgba(255,255,250,0.96)", border: "1px solid rgba(255,252,240,0.85)", borderRadius: 14, padding: "20px 16px", textAlign: "center", marginBottom: 20 }}>
            <div style={{ fontSize: 13, color: "rgba(28,24,16,0.4)", fontStyle: "italic" }}>No suppliers added yet</div>
          </div>
        ) : (
          <div style={{ background: "rgba(255,252,242,0.88)", borderTop: "1px solid rgba(255,255,250,0.96)", border: "1px solid rgba(255,252,240,0.85)", borderRadius: 14, overflow: "hidden", marginBottom: 20 }}>
            {suppliers.map((s, i) => (
              <div key={s.id} style={{ display: "flex", alignItems: "center", gap: 12, padding: "12px 14px", borderBottom: i < suppliers.length - 1 ? "0.5px solid rgba(28,24,16,0.08)" : "none" }}>
                <div style={{ width: 36, height: 36, borderRadius: 10, background: "rgba(26,90,120,0.12)", border: "1.5px solid rgba(26,90,120,0.25)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  <span style={{ fontSize: 13, fontWeight: 700, color: "#1A5A78" }}>{s.initials}</span>
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 14, fontWeight: 700, color: "#1A1608" }}>{s.name}</div>
                  <div style={{ fontSize: 11, color: "rgba(28,24,16,0.4)", marginTop: 1 }}>{s.covers && s.covers.length > 0 ? s.covers.join(', ') : 'All fitting types'}</div>
                </div>
                <button onClick={() => handleDelete(s.id)} style={{ background: "none", border: "none", cursor: "pointer", padding: 4, fontSize: 16, color: "#C07070", fontWeight: 700, lineHeight: 1 }}>&times;</button>
              </div>
            ))}
          </div>
        )}

        {/* ADD SUPPLIER */}
        <div style={{ fontSize: 9, fontWeight: 700, color: "rgba(28,24,16,0.5)", letterSpacing: 1.2, textTransform: "uppercase", marginBottom: 10 }}>Add Supplier</div>

        <SupplierAddFields add={add} />

      </div>
    </div>
  );
};


// ════════════════════════════════════════════════════
// CONTACTS SCREEN (screen 21)
// ════════════════════════════════════════════════════
// COMPANION-STUDIO-LIT-V1 track 3e: the pieces Relationships and a person
// read (switch on only). quoteStatusOf, quoteIsOpen, quoteValueOf and
// quoteStageWord are the ONE definition of a quote's status, whether it is
// open, its value and its stage word: PipelineScreen's getStatus, `active`,
// getValue and studioStageWord are these same functions. The contact-to-quote match is the
// chase sheet's (chaseProposalPhone): a quote's client equals the contact's
// company or the contact's name, compared lower-case.
const quoteStatusOf = (p) => {
  if (p.status) return p.status;
  if (p.won) return 'won';
  if (p.lost) return 'lost';
  return 'sent';
};
const quoteIsOpen = (p) => !['won', 'lost'].includes(quoteStatusOf(p));
// COMPANION-TRUTH-V2 B2: a quote status that is out and still live, in both
// vocabularies. The portal's /api/companion/pipeline sends a live job's board
// stage as 'quoting' (built, not sent yet) or 'sent'; the phone's own
// proposals (ProposalScreen) may carry 'quoted'. Won and lost are decided.
// Every site that asks "is this a live quote?" of a status reads this.
const quoteIsLive = (status) => status === 'quoting' || status === 'quoted' || status === 'sent';
// ... and the live statuses not sent yet: the portal's 'quoting', the phone's 'quoted'.
const quoteIsUnsent = (status) => status === 'quoting' || status === 'quoted';
const quoteValueOf = (p) => parseFloat(p.capex || p.value || p.totalValue || 0);
const relNorm = (s) => String(s || '').trim().toLowerCase();
const relCompany = (c) => String((c && (c.company || c.account_name)) || '').trim();
const relQuotesFor = (list, keys) => {
  const ks = keys.map(relNorm).filter(Boolean);
  return (list || []).filter(p => ks.includes(relNorm(p.client)) || ks.includes(relNorm(p.projectClient)));
};
const relDate = (s) => {
  if (!s) return null;
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(s));
  const d = m ? new Date(+m[1], +m[2] - 1, +m[3]) : new Date(s);
  return isNaN(d.getTime()) ? null : d;
};
const relDay = (d) => d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
// The stage word for a quote, as Pipeline's studioStageWord draws it.
const quoteStageWord = (status) => {
  const M = STUDIO_MEANING;
  if (status === 'won') return { word: 'Won', fill: M.wonFill, ink: M.wonText };
  if (status === 'lost') return { word: 'Lost', fill: M.slateFill, ink: M.slateText };
  if (quoteIsUnsent(status)) return { word: 'Quoted, not sent yet', fill: M.quotedFill, ink: M.quotedText };
  if (status === 'sent') return { word: 'Quoted, sent', fill: M.quotedFill, ink: M.quotedText };
  const s = String(status || '');
  return { word: s.charAt(0).toUpperCase() + s.slice(1), fill: M.quotedFill, ink: M.quotedText };
};
const ContactsScreen = ({ onBack, onNav, currentUser, proposals }) => {
  const contacts = React.useMemo(() => {
    try {
      const stored = JSON.parse(localStorage.getItem('lumen_contacts') || '{}');
      const list = stored.contacts || stored;
      return Array.isArray(list) ? list : [];
    } catch(e) { return []; }
  }, []);
  const [search, setSearch] = React.useState('');
  // Track 3e (switch on only): the person whose card is open, the account
  // whose people are listed, and the quote the chase sheet is open for.
  const [person, setPerson] = React.useState(null);
  const [openAcct, setOpenAcct] = React.useState(null);
  const [chaseItem, setChaseItem] = React.useState(null);
  const filtered = contacts.filter(c => {
    if (!search) return true;
    const q = search.toLowerCase();
    return (c.name||'').toLowerCase().includes(q) || (c.company||'').toLowerCase().includes(q);
  });
  // Studio (track C4, then track 3e). Contacts are rows on hairlines (names
  // Satoshi bold 16, detail muted 14), the search field is pressed in, and a
  // contact's name, company and role are shown exactly as stored. Track 3e adds
  // the accounts above them and a person's card behind each row, from the
  // contacts, proposals and visits the app already holds.
  if (t.theme === 'uv') {
    const S = STUDIO_TOKENS; const M = STUDIO_MEANING;
    const ink = S.ink; const muted = S.muted;
    const nowMs = Date.now();
    // Quotes in this user's division, as Pipeline filters them.
    const div = getDivisionConfig(currentUser);
    const divProps = (proposals || []).filter(p => p.division === div.id || !p.division);
    const panel = { ...studioSurface.raised(), borderRadius: S.radius.card, padding: '14px 16px', margin: '0 12px 16px' };
    const heading = { ...studioSection(), margin: '0 0 8px' };
    const hairline = `1px solid ${S.hairline}`;
    const slipBtn = { ...studioSurface.slip(), borderRadius: S.button.radius, minHeight: 44, padding: '0 16px', fontSize: 16, fontWeight: 600, color: ink, cursor: 'pointer', fontFamily: 'inherit' };
    const chaseSheet = chaseItem && (
      <ChaseSheet item={chaseItem} onClose={() => setChaseItem(null)} onNav={onNav || (() => {})} currentUser={currentUser} source="companion-contacts" />
    );

    // ── A person ──
    if (person) {
      const c = person;
      const company = relCompany(c);
      const quotes = relQuotesFor(divProps, [company, c.name]);
      const open = quotes.filter(quoteIsOpen).sort((a, b) => new Date(b.updatedAt || b.createdAt || 0) - new Date(a.updatedAt || a.createdAt || 0));
      const order = (p) => (quoteIsOpen(p) ? 0 : quoteStatusOf(p) === 'won' ? 1 : 2);
      const shown = quotes.slice().sort((a, b) => order(a) - order(b) || new Date(b.updatedAt || b.createdAt || 0) - new Date(a.updatedAt || a.createdAt || 0));
      const last = relDate(c.last_contact_date);
      const todayKey = new Date().toISOString().split('T')[0];
      let visits = [];
      try { const v = JSON.parse(localStorage.getItem('lumen_visits') || '[]'); visits = Array.isArray(v) ? v : []; } catch (e) { visits = []; }
      const next = visits
        .filter(v => (v.date || '').split('T')[0] >= todayKey && ((c.id && v.contact_id && v.contact_id === c.id) || (v.contact && relNorm(v.contact) === relNorm(c.name))))
        .sort((a, b) => (a.date + (a.time || '')).localeCompare(b.date + (b.time || '')))[0];
      const nextDay = next ? relDate((next.date || '').split('T')[0]) : null;
      const phone = (c.phone || '').trim();
      const logQuote = open[0];
      const workName = company || c.name;
      return studioShape(
        <div style={studioPage()}>
          <div style={{ padding: '14px 20px 12px', flexShrink: 0, position: 'relative', zIndex: 1 }}>
            <button data-back-list onClick={() => setPerson(null)} style={{ ...studioType.action(), display: 'inline-flex', alignItems: 'center', gap: 4, minHeight: 44, cursor: 'pointer', fontFamily: 'inherit', marginLeft: -4 }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M15 18l-6-6 6-6"/></svg>
              Contacts
            </button>
            <h1 style={{ ...studioType.title(), fontSize: 39, lineHeight: 1.1, marginTop: 2, overflowWrap: 'anywhere' }}>{c.name}</h1>
            {(c.role || company) && <div style={{ fontSize: 16, color: ink, marginTop: 6 }}>{c.role && company ? `${c.role} at ${company}` : (c.role || company)}</div>}
            {phone && <div style={{ fontSize: 14, color: muted, marginTop: 4 }}>{phone}</div>}
            {c.email && <div style={{ fontSize: 14, color: muted, marginTop: 2, overflowWrap: 'anywhere' }}>{c.email}</div>}
            {last && <div style={{ fontSize: 14, color: muted, marginTop: 6 }}>You last spoke on {relDay(last)}.</div>}
          </div>
          {(phone || logQuote) && (
            <div style={{ display: 'flex', gap: 10, padding: '0 20px 16px', position: 'relative', zIndex: 1 }}>
              {phone && (
                <a href={`tel:${phone.replace(/\s+/g, '')}`} style={{ ...studioSurface.primary(), flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', textDecoration: 'none', fontFamily: 'inherit', cursor: 'pointer' }}>Call</a>
              )}
              {logQuote && (
                <button data-log onClick={() => {
                  const u = logQuote.updatedAt || logQuote.createdAt || 0;
                  setChaseItem({ proposal: logQuote, daysSince: Math.max(0, Math.floor((nowMs - new Date(u).getTime()) / 86400000)) });
                }} style={{ ...slipBtn, flex: 1 }}>Log</button>
              )}
            </div>
          )}
          {next && (
            <section aria-label="Next meeting" style={{ ...studioSurface.slip(), borderRadius: S.radius.card, padding: '12px 16px', margin: '0 12px 16px' }}>
              <div style={{ fontSize: 16, fontWeight: 700, color: ink }}>Next: {next.name || next.projectName || 'Visit'}</div>
              <div style={{ fontSize: 14, color: muted, marginTop: 2 }}>
                {nextDay ? nextDay.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' }) : (next.date || '')}{next.time ? `, ${next.time}` : ''}
              </div>
            </section>
          )}
          {shown.length > 0 && (
            <section aria-label={`Work with ${workName}`} style={panel}>
              <h2 style={heading}>Work with {workName}</h2>
              {shown.map((p, i) => {
                const sw = quoteStageWord(quoteStatusOf(p));
                const ref = (p.quoteRef || p.reference || '').replace('SP-L', '').trim();
                return (
                  <div key={p.id || i} data-quote={p.id} style={{ borderLeft: `3px solid ${sw.fill}`, padding: '8px 0 8px 12px', marginTop: i ? 6 : 0 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 10 }}>
                      <span style={{ fontSize: 16, fontWeight: 600, color: ink, minWidth: 0, overflowWrap: 'anywhere' }}>{p.projectName || p.client || 'Untitled'}</span>
                      <span style={{ fontSize: 16, fontWeight: 700, color: M.ochre, whiteSpace: 'nowrap', fontVariantNumeric: 'tabular-nums' }}>{formatCurrency(quoteValueOf(p) || 0)}</span>
                    </div>
                    <div style={{ fontSize: 14, color: muted, marginTop: 2 }}>
                      <span style={{ fontWeight: 600, color: sw.ink }}>{sw.word}</span>{ref ? `, ${ref}` : ''}
                    </div>
                  </div>
                );
              })}
              <p style={{ fontSize: 13, color: muted, margin: '10px 0 0' }}>Quotes are matched by company.</p>
            </section>
          )}
          {chaseSheet}
        </div>
      );
    }

    // ── Accounts: contacts grouped by company ──
    const acctMap = new Map();
    contacts.forEach(c => {
      const name = relCompany(c);
      if (!name) return;
      const key = relNorm(name);
      if (!acctMap.has(key)) acctMap.set(key, { name, people: [], last: null });
      const a = acctMap.get(key);
      a.people.push(c);
      const d = relDate(c.last_contact_date);
      if (d && (!a.last || d > a.last)) a.last = d;
    });
    const accounts = [...acctMap.values()].map(a => {
      const quotes = relQuotesFor(divProps, [a.name]);
      return { ...a, open: quotes.filter(quoteIsOpen).reduce((s, p) => s + (quoteValueOf(p) || 0), 0), stale: staleQuoteList(quotes, nowMs).length };
    });
    const byOpen = (x, y) => y.open - x.open || x.name.localeCompare(y.name);
    const noReply = accounts.filter(a => a.stale > 0).sort(byOpen);
    const rest = accounts.filter(a => a.stale === 0).sort(byOpen);
    const personRow = (c, i, inAccount) => (
      <button key={(c.id || '') + i} data-person={c.name} data-in-account={inAccount ? '' : undefined} onClick={() => setPerson(c)} style={{ display: 'block', width: '100%', textAlign: 'left', background: 'none', border: 'none', padding: '12px 0', minHeight: 56, cursor: 'pointer', fontFamily: 'inherit', color: ink }}>
        <div style={{ fontSize: 16, fontWeight: 700, color: ink }}>{c.name}</div>
        {c.company && <div style={{ fontSize: 14, color: ink, marginTop: 2 }}>{c.company}</div>}
        {c.role && <div style={{ fontSize: 14, color: muted, marginTop: 2 }}>{c.role}</div>}
      </button>
    );
    const accountRow = (a, i) => {
      const isOpen = openAcct === relNorm(a.name);
      return (
        <div key={a.name} data-account={a.name} style={{ borderTop: i ? hairline : 'none' }}>
          <button aria-expanded={isOpen} onClick={() => setOpenAcct(isOpen ? null : relNorm(a.name))} style={{ display: 'grid', gridTemplateColumns: 'minmax(0,1fr) auto', gap: 10, alignItems: 'center', width: '100%', textAlign: 'left', background: 'none', border: 'none', padding: '10px 0', minHeight: 56, cursor: 'pointer', fontFamily: 'inherit', color: ink }}>
            <span style={{ display: 'flex', flexDirection: 'column', gap: 2, minWidth: 0 }}>
              <span style={{ fontSize: 16, fontWeight: 700, color: ink, overflowWrap: 'anywhere' }}>{a.name}</span>
              <span style={{ fontSize: 14, color: muted }}>{a.people.length} {a.people.length === 1 ? 'person' : 'people'}{a.last ? `, last contact ${relDay(a.last)}` : ''}</span>
              {a.stale > 0 && <span style={{ fontSize: 14, fontWeight: 600, color: M.rustText }}>{a.stale} {a.stale === 1 ? 'quote' : 'quotes'} with no reply in over a week</span>}
            </span>
            <span style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 2 }}>
              {a.open > 0
                ? <><span style={{ fontSize: 16, fontWeight: 700, color: M.ochre, fontVariantNumeric: 'tabular-nums' }}>{formatCurrency(a.open)}</span><span style={{ fontSize: 14, color: muted }}>open</span></>
                : <span style={{ fontSize: 14, color: muted }}>Nothing open</span>}
            </span>
          </button>
          {isOpen && <div style={{ paddingLeft: 12 }}>{a.people.map((c, j) => personRow(c, j, true))}</div>}
        </div>
      );
    };
    return studioShape(
      <div style={studioPage()}>
        <StudioHead title="Contacts" onBack={onBack} sub={`${contacts.length} contact${contacts.length !== 1 ? 's' : ''} synced`} />
        {!search && noReply.length > 0 && (
          <section aria-label="Quote with no reply in over a week" style={panel}>
            <h2 style={{ ...heading, color: M.rustText }}>Quote with no reply in over a week</h2>
            {noReply.map(accountRow)}
          </section>
        )}
        {!search && rest.length > 0 && (
          <section aria-label="Every account, most open work first" style={panel}>
            <h2 style={heading}>Every account, most open work first</h2>
            {rest.map(accountRow)}
          </section>
        )}
        <div style={{ padding: "0 20px 12px", flexShrink: 0, position: "relative", zIndex: 1 }}>
          <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search by name or company…" style={studioInput()} />
        </div>
        <div style={{ flex: 1, padding: "0 20px 83px", position: "relative", zIndex: 1 }}>
          {filtered.length === 0 ? (
            <div style={{ textAlign: "center", padding: "40px 20px", color: muted, fontSize: 14 }}>{contacts.length === 0 ? "No contacts synced yet. Pull-to-refresh on Today to sync." : "No matches found."}</div>
          ) : filtered.map((c, i) => (
            <div key={i} style={{ borderTop: hairline }}>{personRow(c, i, false)}</div>
          ))}
        </div>
        {chaseSheet}
      </div>
    );
  }
  return (
    <div style={{ flex: 1, overflowY: "auto", WebkitOverflowScrolling: "touch", overscrollBehavior: "contain", paddingBottom: 100, background: "#E8DCC8", display: "flex", flexDirection: "column" }}>
      <div style={{ padding: "12px 16px 10px", display: "flex", alignItems: "center", gap: 10, flexShrink: 0 }}>
        <button onClick={onBack} style={{ width: 36, height: 36, borderRadius: 12, background: t.colors.glass, border: "1px solid " + t.colors.glassBorder, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", flexShrink: 0 }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={t.colors.text} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M15 18l-6-6 6-6"/></svg>
        </button>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 16, fontWeight: 700, color: "#1A1608" }}>Contacts</div>
          <div style={{ fontSize: 11, color: "#8A7A5A" }}>{contacts.length} contact{contacts.length !== 1 ? 's' : ''} synced</div>
        </div>
      </div>
      <div style={{ padding: "0 16px 10px", flexShrink: 0 }}>
        <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search by name or company…" style={{ width: "100%", padding: "10px 14px", borderRadius: 12, border: "0.5px solid rgba(42,58,26,0.12)", background: "rgba(255,252,242,0.88)", fontSize: 14, fontFamily: "inherit", color: "#1A1608", boxSizing: "border-box" }} />
      </div>
      <div style={{ flex: 1, overflowY: "auto", WebkitOverflowScrolling: "touch", padding: "0 16px 83px" }}>
        {filtered.length === 0 ? (
          <div style={{ textAlign: "center", padding: "40px 20px", color: "#8A7A5A", fontSize: 13 }}>{contacts.length === 0 ? "No contacts synced yet. Pull-to-refresh on Today to sync." : "No matches found."}</div>
        ) : filtered.map((c, i) => (
          <div key={i} style={{ background: "rgba(255,252,242,0.88)", borderTop: "1px solid rgba(255,255,250,0.96)", border: "0.5px solid rgba(42,58,26,0.08)", borderRadius: 14, padding: "12px 14px", marginBottom: 8 }}>
            <div style={{ fontSize: 14, fontWeight: 700, color: "#1A1608" }}>{c.name}</div>
            {c.company && <div style={{ fontSize: 12, color: "#5A4A2A", marginTop: 2 }}>{c.company}</div>}
            {c.role && <div style={{ fontSize: 11, color: "#8A7A5A", marginTop: 2 }}>{c.role}</div>}
          </div>
        ))}
      </div>
    </div>
  );
};

// ════════════════════════════════════════════════════
// SCREEN 12: MY TARGETS
// ════════════════════════════════════════════════════
const MyTargetsScreen = ({ onNav, onBack, currentUser, backLabel }) => {
  const div = getDivisionConfig(currentUser);
  const divColor = div.id === "aircon" ? t.colors.blue : t.colors.gold;

  // COMPANION-STUDIO-LIT-V1 track 3d (switch on only): the streaks and the
  // personal bests come from the SAME two endpoints and the SAME caches Today
  // uses (lumen_streaks, lumen_personal_bests, same shape checks); this screen
  // reads the cache first and refreshes it. Nothing is fetched with the switch off.
  const uvOn = t.theme === 'uv';
  const [uvStreaks, setUvStreaks] = React.useState(() => {
    if (!uvOn) return null;
    try { const c = JSON.parse(localStorage.getItem('lumen_streaks') || 'null'); return (c && c.data && c.data.platform) ? c.data : null; } catch (e) { return null; }
  });
  const [uvBests, setUvBests] = React.useState(() => {
    if (!uvOn) return null;
    try { const c = JSON.parse(localStorage.getItem('lumen_personal_bests') || 'null'); return (c && c.data && Array.isArray(c.data.records) && c.data.records.length > 0) ? c.data : null; } catch (e) { return null; }
  });
  React.useEffect(() => {
    if (!uvOn) return;
    const tk = localStorage.getItem('lumen_token');
    const authHeaders = tk ? { Authorization: `Bearer ${tk}` } : {};
    const todayKey = new Date().toISOString().split('T')[0];
    fetch(PORTAL_URL + '/api/companion/streaks', { headers: authHeaders })
      .then(r => r.ok ? r.json() : null)
      .then(d => { if (d && d.platform) { setUvStreaks(d); try { localStorage.setItem('lumen_streaks', JSON.stringify({ date: todayKey, data: d })); } catch (e) {} } })
      .catch(() => {});
    fetch(PORTAL_URL + '/api/companion/personal-bests', { headers: authHeaders })
      .then(r => r.ok ? r.json() : null)
      .then(d => { if (d && Array.isArray(d.records)) { setUvBests(d); try { localStorage.setItem('lumen_personal_bests', JSON.stringify({ date: todayKey, data: d })); } catch (e) {} } })
      .catch(() => {});
  }, []);
  // STUDIO-LIT-PHONE-V1 item 5: my week (lumen_week) arrives with the
  // five-minute sync; draw again when a sync lands.
  const [, setUvSyncTick] = React.useState(0);
  React.useEffect(() => {
    if (!uvOn) return undefined;
    const onSync = () => setUvSyncTick((n) => n + 1);
    window.addEventListener('lumenDataSync', onSync);
    return () => window.removeEventListener('lumenDataSync', onSync);
  }, []);

  // Portal targets — use if available, fall back to local
  const portalTargets = getPortalData('lumen_targets', null);

  const [monthlyTarget, setMonthlyTarget] = React.useState(() => {
    // Portal monthly_target takes precedence on first load
    if (portalTargets && portalTargets.monthly_target) return portalTargets.monthly_target.toString();
    const stored = readMyMonthlyTarget();
    return stored ? stored : '';
  });
  const quarterlyTarget = portalTargets && portalTargets.quarterly_target
    ? portalTargets.quarterly_target
    : (monthlyTarget ? (parseFloat(monthlyTarget) * 3) : 0);

  const actualThisMonth = portalTargets ? (portalTargets.actual_this_month || 0) : 0;
  const actualThisQuarter = portalTargets ? (portalTargets.actual_this_quarter || 0) : 0;

  const handleTargetChange = (val) => {
    setMonthlyTarget(val);
    if (val && !isNaN(parseFloat(val))) {
      writeMyMonthlyTarget(val);
      syncTargetToPortal(parseFloat(val));
    } else if (!val) {
      writeMyMonthlyTarget(null);
    }
  };

  const portalConnected = true; // Portal is always connected in current build

  // S95 D21 — shared formatter
  const fmtQ = (v) => formatCurrency(v);

  const myTargetsSwipe = createSwipeHandler(null, onBack);

  // Studio (track C4). Money is ochre in tabular figures: the monthly input,
  // the quarterly target and what was won. The three rows sit in one raised
  // card; Connected reads as an ink tick and plain words (no dot).
  if (t.theme === 'uv') {
    const ink = STUDIO_TOKENS.ink; const muted = STUDIO_TOKENS.muted; const ochre = STUDIO_TOKENS.ochre;
    const money = { fontFamily: STUDIO_TOKENS.fonts.display, fontWeight: 300, fontVariantNumeric: "tabular-nums", color: ochre, fontSize: 25 };
    const MN = STUDIO_MEANING;
    const hair = `1px solid ${STUDIO_TOKENS.hairline}`;
    const card = { borderRadius: STUDIO_TOKENS.radius.card, padding: "14px 16px", marginBottom: 20, ...studioSurface.raised() };
    // The prototype's section heading (.app-sec): Satoshi, bold, ink.
    const h2 = { fontFamily: STUDIO_TOKENS.fonts.body, fontSize: 16, fontWeight: 700, color: ink, margin: "0 0 8px" };

    // This week and last (Monday to Sunday). STUDIO-LIT-PHONE-V1 item 5:
    // quotes built (D8) and quotes sent (D9) are the portal's, mine, from
    // /api/companion/week (lumen_week); the device's own count of its
    // proposals is no longer shown. A copy for another week is not used.
    // Follow-ups are a row only when the portal counts them; until then it
    // says why, once. Surveys from the portal's surveys cache
    // (lumen_surveys_portal, surveys[].submitted_at) and site visits from
    // lumen_visits[].date up to today, as before. A source the app does not
    // hold leaves its row out.
    const readList = (key, pick) => { try { const v = JSON.parse(localStorage.getItem(key) || 'null'); const l = pick ? pick(v) : v; return Array.isArray(l) ? l : null; } catch (e) { return null; } };
    const nowD = new Date();
    const isNum = (v) => typeof v === 'number' && isFinite(v);
    const portalWeek = (() => {
      const w = getPortalData('lumen_week', null);
      if (!w || typeof w !== 'object' || !w.this_week || !w.last_week) return null;
      const mon = new Date(nowD.getFullYear(), nowD.getMonth(), nowD.getDate() - ((nowD.getDay() + 6) % 7));
      const monKey = `${mon.getFullYear()}-${String(mon.getMonth() + 1).padStart(2, '0')}-${String(mon.getDate()).padStart(2, '0')}`;
      return w.week_start === monKey ? w : null;
    })();
    const weekRows = (() => {
      const now = nowD;
      const mon = new Date(now.getFullYear(), now.getMonth(), now.getDate() - ((now.getDay() + 6) % 7));
      const lastMon = new Date(mon); lastMon.setDate(mon.getDate() - 7);
      const nextMon = new Date(mon); nextMon.setDate(mon.getDate() + 7);
      const toDate = (v) => {
        if (!v) return null;
        if (typeof v === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(v)) { const [y, m, d] = v.split('-').map(Number); return new Date(y, m - 1, d); }
        const d = new Date(v); return isNaN(d.getTime()) ? null : d;
      };
      const count = (list, pick, notAfterNow) => {
        const a = { last: 0, cur: 0 };
        list.forEach((x) => {
          const d = toDate(pick(x));
          if (!d || (notAfterNow && d > now)) return;
          if (d >= lastMon && d < mon) a.last++; else if (d >= mon && d < nextMon) a.cur++;
        });
        return a;
      };
      const out = [];
      if (portalWeek) {
        [['Quotes built', 'quotes_built'], ['Quotes sent', 'quotes_sent'], ['Follow-ups', 'follow_ups']].forEach(([name, k]) => {
          const last = portalWeek.last_week[k]; const cur = portalWeek.this_week[k];
          if (isNum(last) && isNum(cur)) out.push({ name, last, cur });
        });
      }
      const sv = readList('lumen_surveys_portal', (v) => v && v.surveys);
      if (sv) out.push({ name: 'Surveys', ...count(sv, (s) => s.submitted_at, false) });
      const vs = readList('lumen_visits');
      if (vs) out.push({ name: 'Site visits', ...count(vs, (v) => v.date, true) });
      return out;
    })();
    const weekMax = Math.max(1, ...weekRows.map((r) => Math.max(r.last, r.cur)));
    const followUpsWithheld = !!(portalWeek && !isNum(portalWeek.this_week.follow_ups) && (portalWeek.this_week.follow_ups_withheld || portalWeek.last_week.follow_ups_withheld));
    const weekFoot = [
      nowD.getDay() === 1 ? 'This week started today.' : 'Weeks run Monday to Sunday.',
      followUpsWithheld ? "Follow-ups aren't counted yet." : '',
    ].filter(Boolean).join(' ');

    // Eva's read and Your runs: the portal's five runs (/api/companion/streaks,
    // the streak engine's own current, best, current_week_status and
    // grace_banked). Decision 5 (Andrew, 6 October): one calm colour for every
    // run, the slate pair, so no run borrows a stage's colour. What a run's
    // status says about this week is used only from today's copy.
    const streaksToday = perfStreaksCache();
    const statusToday = !!(uvStreaks && streaksToday && streaksToday.today);
    const runs = uvStreaks ? PERF_RUNS.map(([key, name]) => {
      const r = uvStreaks[key];
      if (!r || !isNum(r.current) || !isNum(r.best)) return null;
      return { name, current: r.current, best: r.best, hint: perfRunHint(r, statusToday, nowD), dots: Math.min(Math.max(r.best, 0), 14) };
    }).filter(Boolean) : [];
    // Eva's read: the runs at risk today (at_risk), as a plain fixed sentence.
    // "Make it mine" is a capability (a write), so no action is offered.
    const riskNames = statusToday ? perfAtRiskNames(uvStreaks) : [];
    const evaRead = statusToday ? perfAtRiskLine(uvStreaks, nowD) : '';

    // Personal bests: the portal's records only (/api/companion/personal-bests,
    // the list Today reads). The device's own sums are not shown with the
    // switch on: the portal serves these. Four, as the prototype has. A record
    // the portal leaves out is left out; a record it could not read
    // (unavailable) says so, because a margin is never hidden (DECISIONS
    // 176.140). Highest margin won is a whole percent, never money.
    const bestRecords = uvBests ? uvBests.records : [];
    const bestDefs = [['Largest quote', 'largest_quote', 'money'], ['Best month won', 'best_sales_month', 'money'], ['Highest margin won', 'highest_margin', 'percent'], ['Most quotes built in a month', 'proposals_month', 'count']];
    const bests = bestDefs.map(([label, key, kind]) => {
      const rec = bestRecords.find((r) => r && r.key === key);
      if (!rec) return null;
      if (rec.unavailable) return { label, kind, value: '', context: rec.context || 'Not available' };
      if (rec.value == null || rec.value === '') return null;
      const value = kind === 'money' && isNum(rec.value) ? fmtQ(rec.value)
        : (kind === 'percent' || rec.unit === 'percent') && isNum(rec.value) ? `${Math.round(rec.value)}%`
        : String(rec.value);
      return { label, kind, value, context: rec.context || '' };
    }).filter(Boolean);
    const showQuarter = !!(portalTargets && portalTargets.quarterly_target > 0);

    return studioShape(
      <div style={studioPage()} onTouchStart={myTargetsSwipe.onTouchStart} onTouchEnd={myTargetsSwipe.onTouchEnd}>
        {/* The prototype's head: back to where it was opened, then the title
            with whose figures these are at its right. */}
        <div style={{ padding: "14px 16px 4px", flexShrink: 0, position: "relative", zIndex: 1 }}>
          {onBack && (
            <button onClick={onBack} style={{ ...studioType.action(), display: "inline-flex", alignItems: "center", gap: 4, minHeight: 44, cursor: "pointer", fontFamily: "inherit", marginLeft: -4 }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M15 18l-6-6 6-6"/></svg>
              {backLabel || "Back"}
            </button>
          )}
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12, minHeight: 50 }}>
            <h1 style={{ ...studioType.title(), fontSize: 39, lineHeight: 1.05, margin: 0 }}>My performance</h1>
            <span style={{ fontSize: 16, color: muted }}>Yours</span>
          </div>
        </div>
        <div style={{ padding: "0 16px 100px", position: "relative", zIndex: 1 }}>
          {evaRead && (
            <section aria-label="Eva" data-eva-read style={{ position: "relative", overflow: "hidden", margin: "8px 0 16px", padding: "14px 14px 14px 16px", borderRadius: STUDIO_TOKENS.radius.card, background: STUDIO_TOKENS.jewel.fill, boxShadow: STUDIO_TOKENS.jewel.shadow, display: "flex", flexDirection: "column", gap: 6 }}>
              {/* The lamp in the jewel's corner, as on Today. */}
              <span aria-hidden="true" style={{ position: "absolute", right: -30, top: -34, width: 120, height: 120, borderRadius: "50%", background: `radial-gradient(circle, ${STUDIO_TOKENS.jewel.text}, ${studioRgba(STUDIO_TOKENS.ultraviolet, 0.45)} 30%, ${studioRgba(STUDIO_TOKENS.ultraviolet, 0)} 66%)`, opacity: 0.9, pointerEvents: "none" }} />
              <p style={{ position: "relative", margin: 0, paddingRight: 14, fontFamily: STUDIO_TOKENS.fonts.display, fontWeight: 300, fontSize: 20, lineHeight: 1.3, color: STUDIO_TOKENS.jewel.text }}>
                <span aria-hidden="true" style={{ display: "inline-flex", verticalAlign: -2, marginRight: 8, color: STUDIO_TOKENS.jewel.ring }}>
                  <svg width="17" height="17" viewBox="0 0 20 20"><circle cx="10" cy="10" r="9" fill="none" stroke="currentColor" strokeWidth="1.4" strokeDasharray="1.2 1.6" /><circle cx="10" cy="10" r="4.5" fill="currentColor" /></svg>
                </span>
                {evaRead}.
              </p>
              <p style={{ position: "relative", margin: 0, fontSize: 14, lineHeight: 1.42, color: STUDIO_TOKENS.jewel.textSecondary }}>
                {riskNames.length === 1 ? "Anything that counts for it this week keeps it going." : "Anything that counts for them this week keeps them going."}
              </p>
            </section>
          )}
          {weekRows.length > 0 && (
            <section aria-label="This week and last" style={card}>
              <h2 style={h2}>This week and last</h2>
              <div style={{ display: "grid", gridTemplateColumns: "104px minmax(0,1fr) 64px", gap: 10, fontSize: 13, color: muted, paddingBottom: 4 }}>
                <span></span><span>Last week</span><span style={{ textAlign: "right" }}>This week</span>
              </div>
              {weekRows.map((r) => (
                <div key={r.name} data-row={r.name} data-last={r.last} data-this={r.cur} style={{ display: "grid", gridTemplateColumns: "104px minmax(0,1fr) 64px", gap: 10, alignItems: "center", minHeight: 36, padding: "4px 0", borderTop: hair, fontSize: 14, color: ink }}>
                  <span>{r.name}</span>
                  <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <i aria-hidden="true" style={{ display: "block", height: 9, borderRadius: 4, background: MN.slateFill, width: `${(r.last / weekMax * 100).toFixed(1)}%`, minWidth: 2 }} />
                    <b style={{ fontSize: 13 }}>{r.last}</b>
                  </span>
                  <span style={{ textAlign: "right", fontWeight: 700 }}>{r.cur}</span>
                </div>
              ))}
              <p data-week-foot style={{ fontSize: 13, color: muted, margin: "6px 0 0" }}>{weekFoot}</p>
            </section>
          )}
          {runs.length > 0 && (
            <section aria-label="Your runs" style={{ marginBottom: 24 }}>
              <h2 style={h2}>Your runs</h2>
              {runs.map((r, i) => (
                <div key={r.name} data-run={r.name} data-current={r.current} data-best={r.best} style={{ display: "grid", gridTemplateColumns: "minmax(0,1fr) auto 50px", gap: 10, alignItems: "center", minHeight: 44, padding: "9px 0", borderTop: i === 0 ? "none" : hair }}>
                  <span style={{ display: "flex", flexDirection: "column", gap: 1, fontSize: 14, minWidth: 0 }}>
                    <b style={{ color: MN.slateText }}>{r.name}</b>
                    <span style={{ fontSize: 13, color: muted }}>{r.hint}</span>
                  </span>
                  <span style={{ display: "flex", gap: 3 }}>
                    {Array.from({ length: r.dots }, (_, k) => <i key={k} aria-hidden="true" style={{ display: "block", width: 8, height: 18, borderRadius: 3, background: MN.slateFill, opacity: k < Math.min(r.current, r.dots) ? 1 : 0.2 }} />)}
                  </span>
                  <span style={{ textAlign: "right", fontFamily: STUDIO_TOKENS.fonts.display, fontSize: 20, fontWeight: 300, color: MN.slateText, fontVariantNumeric: "tabular-nums", whiteSpace: "nowrap" }}>{r.current}{r.best > 0 ? <small style={{ fontFamily: STUDIO_TOKENS.fonts.body, fontSize: 13, color: muted }}> of {r.best}</small> : null}</span>
                </div>
              ))}
              <p style={{ fontSize: 13, color: muted, margin: "6px 0 0" }}>Weeks in a row now, of your best run.</p>
            </section>
          )}
          {bests.length > 0 && (
            <section aria-label="Personal bests" style={card}>
              <h2 style={h2}>Personal bests</h2>
              {bests.map((b, i) => (
                <div key={b.label} data-best-row={b.label} style={{ display: "flex", justifyContent: "space-between", gap: 12, alignItems: "center", minHeight: 44, padding: "6px 0", borderTop: i === 0 ? "none" : hair, fontSize: 14, color: ink }}>
                  <span style={{ display: "flex", flexDirection: "column", gap: 1, minWidth: 0 }}>
                    <b>{b.label}</b>
                    {b.context ? <span style={{ fontSize: 13, color: muted }}>{b.context}</span> : null}
                  </span>
                  {b.value ? <span style={{ fontFamily: STUDIO_TOKENS.fonts.display, fontSize: 20, fontWeight: 300, fontVariantNumeric: "tabular-nums", whiteSpace: "nowrap", color: b.kind === 'money' ? MN.ochre : ink }}>{b.value}</span> : null}
                </div>
              ))}
            </section>
          )}
          <div style={{ ...studioType.heading(), marginBottom: 12 }}>Forecast targets</div>
          <div style={{ ...studioSurface.raised(), borderRadius: t.radius.lg, overflow: "hidden", marginBottom: 12 }}>
            <div style={studioRow(!showQuarter && !(actualThisMonth > 0))}>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 16, fontWeight: 700, color: ink }}>Monthly target</div>
                <div style={{ fontSize: 14, color: muted, marginTop: 1 }}>Your expected monthly revenue</div>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                <span style={{ ...money, fontSize: 20 }}>£</span>
                <input type="number" inputMode="decimal" value={monthlyTarget} onChange={(e) => handleTargetChange(e.target.value)} placeholder="0"
                  style={{ ...studioInput(), width: 110, textAlign: "right", color: ochre, fontWeight: 600, fontVariantNumeric: "tabular-nums" }} />
              </div>
            </div>
            {/* Switch on: only a quarterly target the portal sends. Monthly x 3 is a
                device sum of a portal-owned figure (CENSUS F12) and is not shown. */}
            {showQuarter && (
              <div style={studioRow(!(actualThisMonth > 0))}>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 16, fontWeight: 700, color: ink }}>Quarterly target</div>
                  <div style={{ fontSize: 14, color: muted, marginTop: 1 }}>From portal</div>
                </div>
                <div style={money}>{fmtQ(quarterlyTarget)}</div>
              </div>
            )}
            {actualThisMonth > 0 && (
              <div style={studioRow(true)}>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 16, fontWeight: 700, color: ink }}>Won this month</div>
                  <div style={{ fontSize: 14, color: muted, marginTop: 1 }}>From portal, live</div>
                </div>
                <div style={money}>{fmtQ(actualThisMonth)}</div>
              </div>
            )}
          </div>
          <p style={{ fontSize: 14, color: muted, lineHeight: 1.5, margin: "0 0 28px" }}>
            Set a realistic monthly figure. It is saved to the portal.
          </p>
          {/* STUDIO-LIT-PHONE-V1 item 5: the Portal connection card is not
              drawn with the switch on. It read a constant (portalConnected is
              always true), so it said nothing about the link. */}
        </div>
        <TabBar active={7} onChange={onNav} divisionId={div && div.id ? div.id : "lighting"} />
      </div>
    );
  }

  return (
    <div style={{ flex: 1, overflowY: "auto", WebkitOverflowScrolling: "touch", overscrollBehavior: "contain", paddingBottom: 100, background: "#E8DCC8", display: "flex", flexDirection: "column" }}
      onTouchStart={myTargetsSwipe.onTouchStart} onTouchEnd={myTargetsSwipe.onTouchEnd}>
      <ScreenBlobs />
      <NavBar title="My Targets" onBack={onBack} color={divColor} />
      <div style={{ flex: 1, overflowY: "auto", padding: "0 20px 100px" }}>

        <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", color: "rgba(28,24,16,0.38)", marginBottom: 8, marginTop: 4 }}>Forecast targets</div>

        <GlassCard style={{ padding: 0, marginBottom: 10, overflow: "hidden" }}>
          {/* Monthly target row */}
          <div style={{ display: "flex", alignItems: "center", padding: "14px 16px", borderBottom: "0.5px solid rgba(28,24,16,0.08)" }}>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 14, fontWeight: 600, color: t.colors.text }}>Monthly target</div>
              <div style={{ fontSize: 11, color: t.colors.textSecondary, marginTop: 1 }}>Your expected monthly revenue</div>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 2 }}>
              <span style={{ fontSize: 15, fontWeight: 700, color: "rgba(28,24,16,0.35)" }}>£</span>
              <input
                type="number"
                inputMode="decimal"
                value={monthlyTarget}
                onChange={(e) => handleTargetChange(e.target.value)}
                placeholder="0"
                style={{
                  width: 90, padding: "7px 10px", borderRadius: 10,
                  background: t.colors.input, border: `0.5px solid ${t.colors.inputBorder}`,
                  fontSize: 15, fontWeight: 600, color: t.colors.text,
                  textAlign: "right", outline: "none",
                  fontFamily: "-apple-system, 'Helvetica Neue', Arial, sans-serif",
                }}
              />
            </div>
          </div>
          {/* Quarterly target row (read-only) */}
          <div style={{ display: "flex", alignItems: "center", padding: "14px 16px", background: "rgba(200,144,48,0.04)", borderBottom: actualThisMonth > 0 ? "0.5px solid rgba(28,24,16,0.08)" : undefined }}>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 14, fontWeight: 600, color: t.colors.text }}>Quarterly target</div>
              <div style={{ fontSize: 11, color: t.colors.textSecondary, marginTop: 1 }}>{portalTargets ? 'From portal' : 'Calculated from monthly'}</div>
            </div>
            <div style={{ fontFamily: "Georgia, serif", fontStyle: "italic", fontSize: 17, color: "#6A5840", fontWeight: 500 }}>
              {quarterlyTarget > 0 ? fmtQ(quarterlyTarget) : '£0'}
            </div>
          </div>
          {/* Portal actuals — shown when portal data is available */}
          {actualThisMonth > 0 && (
            <div style={{ display: "flex", alignItems: "center", padding: "14px 16px", background: "rgba(46,104,56,0.04)" }}>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 14, fontWeight: 600, color: t.colors.text }}>Won this month</div>
                <div style={{ fontSize: 11, color: t.colors.textSecondary, marginTop: 1 }}>From portal · live</div>
              </div>
              <div style={{ fontFamily: "Georgia, serif", fontStyle: "italic", fontSize: 17, color: "#2E6838", fontWeight: 500 }}>
                {fmtQ(actualThisMonth)}
              </div>
            </div>
          )}
        </GlassCard>

        <div style={{ fontSize: 11, color: "rgba(28,24,16,0.38)", padding: "4px 4px 20px", lineHeight: 1.45 }}>
          Your targets drive the forecast ring on the Today screen. Set a realistic monthly figure and the quarterly target is calculated automatically.
        </div>

        <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: "0.14em", textTransform: "uppercase", color: "rgba(28,24,16,0.38)", marginBottom: 8 }}>Portal connection</div>

        <GlassCard style={{ padding: "14px 16px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <span style={{ width: 8, height: 8, borderRadius: "50%", background: portalConnected ? "#2E6838" : "rgba(28,24,16,0.25)", flexShrink: 0 }} />
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 14, fontWeight: 600, color: t.colors.text }}>{portalConnected ? 'Connected' : 'Not connected'}</div>
              <div style={{ fontSize: 11, color: t.colors.textSecondary, marginTop: 1 }}>{portalConnected ? 'Syncing with ASG portal' : 'Portal sync unavailable'}</div>
            </div>
          </div>
        </GlassCard>

      </div>
      <TabBar active={7} onChange={onNav} divisionId={div && div.id ? div.id : "lighting"} />
    </div>
  );
};

const SettingsScreen = ({ onNav, onBack, currentUser, onSwitchUser, onUpdateUser }) => {
  const div = getDivisionConfig(currentUser);
  const divColor = div.id === "aircon" ? t.colors.blue : t.colors.gold;
  const initials = currentUser ? currentUser.name.split(" ").map(n => n[0]).join("").toUpperCase().slice(0, 2) : "?";
  const role = currentUser ? currentUser.role : "";
  const divisionLabel = div.id === "aircon" ? "Mechanical" : "Lighting";
  const [_vTaps, _setVTaps] = React.useState(0);
  const _vTimer = React.useRef(null);
  const [_devMode, _setDevMode] = React.useState(() => {
    try { return localStorage.getItem('_devMode') === '1'; } catch(e) { return false; }
  });
  const [_forcedDiv, _setForcedDiv] = React.useState(() => {
    try { return localStorage.getItem('_forcedDiv') || null; } catch(e) { return null; }
  });
  // S158 — parked offline writes (queue entries that exhausted their retry
  // cap). Count read at mount; actions update it in place.
  const [_parkedCount, _setParkedCount] = React.useState(() => _readParkedWrites().length);
  const handleVersionTap = () => {
    const next = _vTaps + 1;
    _setVTaps(next);
    if (_vTimer.current) clearTimeout(_vTimer.current);
    _vTimer.current = setTimeout(() => _setVTaps(0), 700);
    if (next >= 3) {
      _setVTaps(0);
      // Toggle: off ↔ other division
      const myDiv = currentUser ? currentUser.division : 'lighting';
      const otherDiv = myDiv === 'lighting' ? 'aircon' : 'lighting';
      const current = localStorage.getItem('_forcedDiv') || 'off';
      let nextMode, msg;
      if (current === 'off') {
        nextMode = otherDiv;
        msg = otherDiv === 'aircon' ? 'Mechanical view — testing mode' : 'Lighting view — testing mode';
      } else {
        nextMode = 'off';
        msg = 'Back to your division';
      }
      if (nextMode === 'off') {
        localStorage.removeItem('_forcedDiv');
      } else {
        localStorage.setItem('_forcedDiv', nextMode);
      }
      _setForcedDiv(nextMode);
      // Toast
      const toastEl = document.createElement('div');
      toastEl.textContent = msg;
      Object.assign(toastEl.style, { position:'fixed', bottom:'110px', left:'50%', transform:'translateX(-50%)', background:'#C8A96E', color:'#0A1628', padding:'10px 20px', borderRadius:'20px', fontSize:'13px', fontWeight:'700', zIndex:'9999', opacity:'1', transition:'opacity 0.3s' });
      if (t.theme === 'uv') Object.assign(toastEl.style, studioToastStyle());
      document.body.appendChild(toastEl);
      setTimeout(() => { toastEl.style.opacity = '0'; setTimeout(() => toastEl.remove(), 300); }, 2000);
      setTimeout(() => window.location.reload(), 400);
    }
  };
  const settingsSwipe = createSwipeHandler(null, onBack);

  // Studio (track C4). Same blocks in the same order: who you are, the portal
  // link, My Targets, Switch user, Sign out, parked writes (when there are
  // any), sync status and version. The division is a plain word with its icon
  // (no pill); parked writes lose their dot; the secret three-tap on the
  // version line is unchanged.
  if (t.theme === 'uv') {
    const ink = STUDIO_TOKENS.ink; const muted = STUDIO_TOKENS.muted;
    const syncedAt = localStorage.getItem('lumen_pipeline_synced_at');
    // STUDIO-LIT-PHONE-V1 item 8b: "Last synced" carries the date when it
    // was not today (DECISIONS 176.136).
    const syncedStr = (() => {
      const d = syncedAt ? new Date(syncedAt) : null;
      if (!d || isNaN(d)) return 'Not yet synced';
      const hm = d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
      return d.toDateString() === new Date().toDateString()
        ? `Last synced at ${hm}`
        : `Last synced ${d.getDate()} ${PL_MONTHS[d.getMonth()]}, ${hm}`;
    })();
    // One paper of rows, not a stack of identical cards (studio-lit.md).
    const hair = STUDIO_TOKENS.hairline;
    const row = (i) => ({ width: "100%", minHeight: 56, padding: "8px 0", background: "none", border: "none", borderTop: i > 0 ? `1px solid ${hair}` : "none", color: ink, fontSize: 16, fontWeight: 600, cursor: "pointer", textAlign: "left", display: "flex", alignItems: "center", gap: 14, fontFamily: "inherit" });
    const slipBtn = row(1);
    return studioShape(
      <div style={studioPage()} onTouchStart={settingsSwipe.onTouchStart} onTouchEnd={settingsSwipe.onTouchEnd}>
        <StudioHead title="Settings" onBack={onBack} />
        <div style={{ padding: "0 20px 100px", position: "relative", zIndex: 1 }}>
          <GlassCard style={{ padding: 18, marginBottom: 24, display: "flex", alignItems: "center", gap: 14 }} hover={false}>
            <div style={{ ...studioSurface.pressed(), width: 56, height: 56, borderRadius: 28, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
              <span style={{ color: ink, fontWeight: 700, fontSize: 20 }}>{initials}</span>
            </div>
            <div style={{ flex: 1 }}>
              <p style={{ fontSize: 20, fontWeight: 700, color: ink, margin: 0 }}>{currentUser ? currentUser.name : "No user"}</p>
              <p style={{ fontSize: 14, color: muted, margin: "2px 0 0" }}>{role || "ASG"}</p>
              <div style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 6 }}>
                <Icon name={div.id === "aircon" ? "leaf" : "bulb"} size={16} color={ink} />
                <span style={{ fontSize: 14, color: ink }}>{divisionLabel}</span>
              </div>
            </div>
          </GlassCard>

          <div style={{ ...studioSurface.raised(), borderRadius: STUDIO_TOKENS.radius.card, padding: "6px 18px", marginBottom: 24 }}>
          <div role="button" tabIndex={0} onClick={() => window.open(PORTAL_URL, '_blank')} style={row(0)}>
            <Icon name="wifi" size={20} color={ink} />
            <div style={{ flex: 1 }}>
              <p style={{ fontSize: 16, fontWeight: 600, color: ink, margin: 0 }}>Open the portal</p>
              <p style={{ fontSize: 14, fontWeight: 400, color: muted, margin: "2px 0 0" }}>Opens in your browser</p>
            </div>
          </div>

          <div role="button" tabIndex={0} onClick={() => onNav(17)} style={row(1)}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M3 20h18M6 16V8M10 16V4M14 16v-5M18 16V7" stroke={ink} strokeWidth="2" strokeLinecap="round"/>
            </svg>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 16, fontWeight: 600, color: ink }}>My performance</div>
              <div style={{ fontSize: 14, fontWeight: 400, color: muted, marginTop: 2 }}>Your week, runs, bests and monthly target</div>
            </div>
            <Icon name="chevron" size={16} color={muted} />
          </div>

          <button onClick={onSwitchUser} style={slipBtn}>
            <Icon name="user" size={18} color={ink} />
            Switch user
          </button>

          <button onClick={() => {
            try { localStorage.removeItem('lumen_token'); } catch(e) {}
            clearSignInHoldOnSignOut();   // track C: a Sign Out is not a hold
            try { localStorage.removeItem('asg_current_user'); } catch(e) {}
            try { localStorage.removeItem('asg_last_active'); } catch(e) {}
            if (window._lumenSyncInterval) clearInterval(window._lumenSyncInterval);
            onSwitchUser();
          }} style={slipBtn}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9" stroke={ink} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
            Sign out
          </button>
          </div>

          {_parkedCount > 0 && (
            <GlassCard style={{ padding: "14px 18px", marginBottom: 12 }} hover={false}>
              <p style={{ fontSize: 16, fontWeight: 700, color: STUDIO_MEANING.rustText, margin: 0 }}>{_parkedCount} {_parkedCount === 1 ? 'update hasn’t' : 'updates haven’t'} reached the portal</p>
              <p style={{ fontSize: 14, color: muted, margin: "2px 0 8px" }}>Updates that couldn't reach the portal after repeated tries. Nothing has been lost.</p>
              <div style={{ display: "flex", gap: 20 }}>
                <button onClick={() => {
                  retryParkedWrites();
                  _setParkedCount(_readParkedWrites().length);
                  try { flushOfflineQueue(); } catch(e) {}
                }} style={{ ...studioType.action(), minHeight: 44, cursor: "pointer", fontFamily: "inherit" }}>
                  Retry all
                </button>
                <button onClick={() => {
                  if (window.confirm(`Discard ${_parkedCount} parked write${_parkedCount === 1 ? '' : 's'}? ${_parkedCount === 1 ? 'It' : 'They'} will never reach the portal.`)) {
                    discardParkedWrites();
                    _setParkedCount(0);
                  }
                }} style={{ ...studioType.link(), minHeight: 44, cursor: "pointer", fontFamily: "inherit", border: "none", textDecoration: "underline" }}>
                  Discard all
                </button>
              </div>
            </GlassCard>
          )}

          <p style={{ textAlign: "center", fontSize: 13, color: muted, marginTop: 12, marginBottom: 0 }}>{syncedStr}</p>
          <p onClick={handleVersionTap} style={{ textAlign: "center", fontSize: 13, color: ink, fontWeight: _forcedDiv && _forcedDiv !== 'off' ? 700 : 400, marginTop: 6, cursor: "default", userSelect: "none" }}>
            ASG Companion v7.5 (v114){_forcedDiv && _forcedDiv !== 'off' ? `${studioSep()}${_forcedDiv === 'aircon' ? 'Mechanical test' : 'Lighting test'}` : ''}
          </p>
        </div>
        <TabBar active={7} onChange={onNav} divisionId={div && div.id ? div.id : "lighting"} />
      </div>
    );
  }

  return (
    <div style={{ flex: 1, overflowY: "auto", WebkitOverflowScrolling: "touch", overscrollBehavior: "contain", paddingBottom: 100, background: "#E8DCC8", display: "flex", flexDirection: "column" }}
      onTouchStart={settingsSwipe.onTouchStart} onTouchEnd={settingsSwipe.onTouchEnd}>
      <ScreenBlobs />
      <NavBar title="Settings" onBack={onBack} color={divColor} />
      <div style={{ flex: 1, overflowY: "auto", padding: "0 20px 100px" }}>
        <GlassCard gold={divColor} style={{ padding: 18, marginBottom: 24, display: "flex", alignItems: "center", gap: 14 }}>
          <div style={{ width: 56, height: 56, borderRadius: 18, background: divColor, display: "flex", alignItems: "center", justifyContent: "center", boxShadow: `0 0 18px ${divColor}40`, flexShrink: 0 }}>
            <span style={{ color: t.colors.navy, fontWeight: 800, fontSize: 20, fontFamily: "system-ui, -apple-system, sans-serif" }}>{initials}</span>
          </div>
          <div style={{ flex: 1 }}>
            <p style={{ fontSize: 17, fontWeight: 700, color: t.colors.text, fontFamily: "system-ui, -apple-system, sans-serif", letterSpacing: -0.3 }}>{currentUser ? currentUser.name : "No user"}</p>
            <p style={{ fontSize: 12, color: divColor, fontWeight: 600 }}>{role || "ASG"}</p>
            <div style={{ display: "inline-flex", alignItems: "center", gap: 5, marginTop: 5, background: `${divColor}15`, border: `0.5px solid ${divColor}40`, borderRadius: 20, padding: "2px 10px 2px 7px" }}>
              <Icon name={div.id === "aircon" ? "leaf" : "bulb"} size={11} color={divColor} />
              <span style={{ fontSize: 11, fontWeight: 700, color: divColor }}>{divisionLabel}</span>
            </div>
          </div>
        </GlassCard>

        <GlassCard style={{ padding: "13px 16px", marginBottom: 24, background: "rgba(91,155,213,0.06)", border: "0.5px solid rgba(91,155,213,0.15)", cursor: "pointer" }} hover={false} onClick={() => window.open(PORTAL_URL, '_blank')}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <Icon name="wifi" size={18} color={t.colors.blue} />
            <div>
              <p style={{ fontSize: 13, fontWeight: 700, color: t.colors.text }}>Portal Connected</p>
              <p style={{ fontSize: 11, color: t.colors.textSecondary, fontWeight: 500, marginTop: 2 }}>Tap to open portal · Handoff enabled</p>
            </div>
          </div>
        </GlassCard>

        <div onClick={() => onNav(17)} style={{ display: "flex", alignItems: "center", gap: 14, padding: "15px 16px", marginBottom: 24, background: "rgba(255,252,242,0.88)", border: "1px solid rgba(255,252,240,0.85)", borderTop: "1px solid rgba(255,255,250,0.96)", borderRadius: 18, cursor: "pointer" }}>
          <div style={{ width: 36, height: 36, borderRadius: 10, background: "rgba(200,144,48,0.1)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path d="M3 20h18M6 16V8M10 16V4M14 16v-5M18 16V7" stroke={divColor} strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 15, fontWeight: 600, color: t.colors.text }}>My Targets</div>
            <div style={{ fontSize: 11, color: t.colors.textSecondary, marginTop: 2 }}>Monthly forecast target</div>
          </div>
          <svg width="7" height="12" viewBox="0 0 7 12" fill="none">
            <path d="M1 1l5 5-5 5" stroke="rgba(28,24,16,0.3)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>

        <button onClick={onSwitchUser} style={{ width: "100%", padding: "13px 16px", borderRadius: t.radius.lg, background: t.colors.glass, border: `0.5px solid ${t.colors.glassBorder}`, color: t.colors.textSecondary, fontSize: 14, fontWeight: 600, cursor: "pointer", marginBottom: 12, textAlign: "left", display: "flex", alignItems: "center", gap: 10 }}>
          <Icon name="user" size={16} color={t.colors.textSecondary} />
          Switch User
        </button>

        <button onClick={() => {
          try { localStorage.removeItem('lumen_token'); } catch(e) {}
          clearSignInHoldOnSignOut();   // track C: a Sign Out is not a hold
          try { localStorage.removeItem('asg_current_user'); } catch(e) {}
          try { localStorage.removeItem('asg_last_active'); } catch(e) {}
          if (window._lumenSyncInterval) clearInterval(window._lumenSyncInterval);
          onSwitchUser();
        }} style={{ width: "100%", padding: "13px 16px", borderRadius: t.radius.lg, background: t.colors.redLight, border: `0.5px solid rgba(176,64,64,0.2)`, color: t.colors.red, fontSize: 14, fontWeight: 600, cursor: "pointer", marginBottom: 12, textAlign: "left", display: "flex", alignItems: "center", gap: 10 }}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9" stroke={t.colors.red} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
          Sign Out
        </button>

        {/* S158 — parked writes: queue entries that exhausted their retry cap.
            Hidden at 0 (calm default); at N>0 it surfaces with the only two
            legal actions — retry (back to the live queue, attempts reset) or
            a human-confirmed discard. Code never discards. */}
        {_parkedCount > 0 && (
          <GlassCard style={{ padding: "13px 16px", marginBottom: 12, background: "rgba(200,80,64,0.05)", border: "0.5px solid rgba(200,80,64,0.18)" }} hover={false}>
            <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 10 }}>
              <div style={{ width: 8, height: 8, borderRadius: 4, background: "#C85040", flexShrink: 0 }} />
              <div style={{ flex: 1 }}>
                <p style={{ fontSize: 13, fontWeight: 700, color: t.colors.text }}>{_parkedCount} parked write{_parkedCount === 1 ? '' : 's'}</p>
                <p style={{ fontSize: 11, color: t.colors.textSecondary, fontWeight: 500, marginTop: 2 }}>Updates that couldn't reach the portal after repeated tries. Nothing has been lost.</p>
              </div>
            </div>
            <div style={{ display: "flex", gap: 8 }}>
              <button onClick={() => {
                retryParkedWrites();
                _setParkedCount(_readParkedWrites().length);
                try { flushOfflineQueue(); } catch(e) {}
              }} style={{ flex: 1, padding: "10px 0", borderRadius: 10, background: "rgba(255,252,242,0.88)", border: "0.5px solid rgba(26,22,8,0.14)", color: t.colors.text, fontSize: 12, fontWeight: 700, cursor: "pointer" }}>
                Retry all
              </button>
              <button onClick={() => {
                if (window.confirm(`Discard ${_parkedCount} parked write${_parkedCount === 1 ? '' : 's'}? ${_parkedCount === 1 ? 'It' : 'They'} will never reach the portal.`)) {
                  discardParkedWrites();
                  _setParkedCount(0);
                }
              }} style={{ flex: 1, padding: "10px 0", borderRadius: 10, background: "transparent", border: "0.5px solid rgba(200,80,64,0.3)", color: "#C85040", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>
                Discard all
              </button>
            </div>
          </GlassCard>
        )}

        {/* Sync status */}
        {(() => {
          const syncedAt = localStorage.getItem('lumen_pipeline_synced_at');
          const syncedStr = syncedAt
            ? `Last synced ${truthWhen(new Date(syncedAt))}`
            : 'Not yet synced';
          return (
            <p style={{ textAlign: "center", fontSize: 10, color: t.colors.textTertiary, marginTop: 6, marginBottom: 0 }}>
              {syncedStr}
            </p>
          );
        })()}

        <p onClick={handleVersionTap} style={{ textAlign: "center", fontSize: 11, color: _forcedDiv && _forcedDiv !== 'off' ? t.colors.gold : t.colors.textTertiary, marginTop: 6, cursor: "default", userSelect: "none" }}>
          ASG Companion v7.5 (v114){_forcedDiv && _forcedDiv !== 'off' ? ` · ${_forcedDiv === 'aircon' ? 'Mechanical TEST' : 'Lighting TEST'}` : ''}
        </p>
      </div>
      <TabBar active={7} onChange={onNav} divisionId={div && div.id ? div.id : "lighting"} />
    </div>
  );
};

// ════════════════════════════════════════════════════
// SCREEN 7: NEW ENQUIRY
// ════════════════════════════════════════════════════
// ── Stable form components — defined OUTSIDE screen components ──
// If defined inside, React recreates them on every state update,
// unmounting the input and dismissing the mobile keyboard.
const Field = ({ label, value, onChange, placeholder, half }) => (
  <div style={{ marginBottom: 16, flex: half ? "1" : "none" }}>
    <label style={{ fontSize: 11, fontWeight: 700, color: "rgba(26,22,8,0.45)", textTransform: "uppercase", letterSpacing: "0.12em", display: "block", marginBottom: 6 }}>{label}</label>
    <input value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder}
      style={{
        width: "100%", padding: "12px 14px",
        background: "rgba(255,252,242,0.60)",
        border: "1px solid rgba(26,22,8,0.10)",
        borderRadius: 10,
        fontSize: 16, color: "#1A1608",
        outline: "none", WebkitAppearance: "none",
        transition: "border-color 0.15s",
        fontFamily: "system-ui, -apple-system, sans-serif",
        boxSizing: "border-box",
      }}
      onFocus={e => e.target.style.borderColor = "rgba(74,100,98,0.4)"}
      onBlur={e => e.target.style.borderColor = "rgba(26,22,8,0.10)"}
    />
  </div>
);

const ChipSelect = ({ label, options, value, onChange, accentColor }) => {
  const ac = accentColor || t.colors.gold;
  const acLight = accentColor ? `${accentColor}18` : t.colors.goldLight;
  const acBorder = accentColor ? `${accentColor}50` : t.colors.glassBorderGold;
  return (
  <div style={{ marginBottom: 14 }}>
    <label style={{ fontSize: 11, fontWeight: 700, color: t.colors.textTertiary, textTransform: "uppercase", letterSpacing: 0.4, display: "block", marginBottom: 8 }}>{label}</label>
    <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
      {options.map(opt => (
        <button key={opt} onClick={() => onChange(opt)} style={{
          padding: "7px 14px", borderRadius: t.radius.pill, cursor: "pointer",
          background: value === opt ? acLight : t.colors.glass,
          border: value === opt ? `0.5px solid ${acBorder}` : `0.5px solid ${t.colors.glassBorder}`,
          color: value === opt ? ac : t.colors.textSecondary,
          fontSize: 12, fontWeight: 600, transition: "all 0.15s ease",
        }}>{opt}</button>
      ))}
    </div>
  </div>
  );
};

const TimeSelect = ({ value, onChange, accentColor }) => {
  const ac = accentColor || t.colors.gold;
  const acLight = accentColor ? `${accentColor}18` : t.colors.goldLight;
  const acBorder = accentColor ? `${accentColor}50` : t.colors.glassBorderGold;
  const morning = [];
  const afternoon = [];
  for (let h = 7; h < 13; h++) {
    for (let m = 0; m < 60; m += 15) {
      morning.push(`${String(h).padStart(2,'0')}:${String(m).padStart(2,'0')}`);
    }
  }
  for (let h = 13; h < 18; h++) {
    for (let m = 0; m < 60; m += 15) {
      afternoon.push(`${String(h).padStart(2,'0')}:${String(m).padStart(2,'0')}`);
    }
  }
  const Section = ({ label, times }) => (
    <div style={{ marginBottom: 12 }}>
      <p style={{ fontSize: 10, fontWeight: 700, color: t.colors.textTertiary, textTransform: "uppercase", letterSpacing: 0.6, marginBottom: 8 }}>{label}</p>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
        {times.map(time => (
          <button key={time} onClick={() => onChange(time)} style={{
            padding: "7px 12px", borderRadius: t.radius.md, cursor: "pointer",
            background: value === time ? acLight : t.colors.glass,
            border: value === time ? `1px solid ${acBorder}` : `0.5px solid ${t.colors.glassBorder}`,
            color: value === time ? ac : t.colors.textSecondary,
            fontSize: 13, fontWeight: value === time ? 700 : 500,
            transition: "all 0.15s ease", minWidth: 56, textAlign: "center",
          }}>{time}</button>
        ))}
      </div>
    </div>
  );
  return (
    <div style={{ marginBottom: 14 }}>
      <label style={{ fontSize: 11, fontWeight: 700, color: t.colors.textTertiary, textTransform: "uppercase", letterSpacing: 0.4, display: "block", marginBottom: 10 }}>Time *</label>
      <Section label="Morning" times={morning} />
      <Section label="Afternoon" times={afternoon} />
    </div>
  );
};

const NewEnquiryScreenBody = ({ onBack, onSave, currentUser }) => {
  const div = getDivisionConfig(currentUser);
  const divColor = div.id === "aircon" ? t.colors.blue : t.colors.gold;
  const divColorLight = div.id === "aircon" ? t.colors.blueLight : t.colors.goldLight;
  const divBorder = div.id === "aircon" ? "rgba(91,155,213,0.25)" : t.colors.glassBorderGold;
  const [form, setForm] = useState({
    name: "", address: "", client: "", contact: "", contactRole: "",
    contactEmail: "", floors: "", visitDate: "Today",
    visitTime: "", source: "Phone", driver: "", budget: "", visitTimeline: "", notes: "",
  });
  const [step, setStep] = useState(0); // 0=site, 1=contact, 2=visit, 3=intel
  const [saved, setSaved] = useState(false);
  const [quickMode, setQuickMode] = useState(true);
  const [quickName, setQuickName] = useState("");
  const [quickTime, setQuickTime] = useState("09:00");

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const steps = [
    { label: "Site", icon: "building" },
    { label: "Contact", icon: "user" },
    { label: "Visit", icon: "calendar" },
    { label: "Intel", icon: "zap" },
  ];

  const canAdvance = [
    form.name.trim().length > 0 && form.client.trim().length > 0,
    form.contact.trim().length > 0,
    form.visitTime.trim().length > 0,
    true,
  ];

  if (saved) {
    return (
      <div style={{ flex: 1, overflowY: "auto", WebkitOverflowScrolling: "touch", overscrollBehavior: "contain", paddingBottom: 100, background: "#E8DCC8", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: 32, textAlign: "center" }}>
        <style>{`@keyframes popIn { 0% { transform: scale(0.5); opacity: 0; } 100% { transform: scale(1); opacity: 1; } }`}</style>
        <div style={{ width: 80, height: 80, borderRadius: "50%", background: divColorLight, border: `1px solid ${divBorder}`, display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 20, boxShadow: `0 0 24px ${divColor}30`, animation: "popIn 0.5s cubic-bezier(0.34,1.56,0.64,1)", ...uvx(() => ({ ...studioSurface.pressed(), borderRadius: "50%" })) }}>
          <Icon name="check" size={40} color={t.theme === 'uv' ? STUDIO_TOKENS.ink : divColor} />
        </div>
        <h2 style={{ fontSize: 22, fontWeight: 800, color: t.colors.text, letterSpacing: -0.5, fontFamily: "system-ui, -apple-system, sans-serif", marginBottom: 8, ...uvx(() => ({ ...studioType.title(), fontSize: 39, marginBottom: 8 })) }}>Enquiry Saved</h2>
        <p style={{ fontSize: 14, color: divColor, fontWeight: 700, marginBottom: 4, ...uvx({ color: STUDIO_TOKENS.ink, fontSize: 16 }) }}>{form.name}</p>
        <p style={{ fontSize: 13, color: t.colors.textSecondary, marginBottom: 8 }}>{form.client}{studioSep()}{form.contact}</p>
        <p style={{ fontSize: 12, color: t.colors.textSecondary, marginBottom: 28 }}>{form.visitDate === "Today" ? "Today" : form.visitDate} at {form.visitTime || "TBC"}</p>
        <GlassCard gold={divColor} style={{ padding: 16, width: "100%", maxWidth: 300, marginBottom: 24 }} hover={false}>
          <p style={{ fontSize: 12, color: t.colors.textSecondary, marginBottom: 8 }}>It'll appear on the dashboard under <strong style={{ color: form.visitDate === "Today" ? t.colors.green : divColor }}>{form.visitDate === "Today" ? "Today's Sites" : "Upcoming"}</strong>. Tap it to load the pre-visit brief.</p>
        </GlassCard>
        <Btn label="Back to Dashboard" variant="primary" color={divColor} fullWidth studioMain onClick={onBack} />
      </div>
    );
  }

  // Render quick-add first if in quick mode
  if (quickMode) return (
    <div style={{ flex: 1, overflowY: "auto", WebkitOverflowScrolling: "touch", overscrollBehavior: "contain", paddingBottom: 100, background: "#E8DCC8", display: "flex", flexDirection: "column" }}>
      <NavBar title={t.theme === 'uv' ? "New job" : "New Job"} onBack={onBack} color={divColor} />
      <div style={{ flex: 1, padding: "24px 20px", display: "flex", flexDirection: "column" }}>
        <div style={{ background: divColorLight, border: `0.5px solid ${divBorder}`, borderRadius: 12, padding: "12px 14px", marginBottom: 24, display: "flex", alignItems: "center", gap: 10, ...uvx(() => ({ ...studioSurface.pressed(), borderRadius: STUDIO_TOKENS.pressed.radius })) }}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={t.theme === 'uv' ? STUDIO_TOKENS.ink : divColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>
          <p style={{ fontSize: 13, color: divColor, fontWeight: 600, lineHeight: 1.4, ...uvx({ color: STUDIO_TOKENS.ink, fontSize: 14, fontWeight: 400 }) }}>{`Quick add${studioDash()}site name and visit time. That's all you need to get started.`}</p>
        </div>
        <p style={{ fontSize: 11, fontWeight: 700, color: t.colors.textTertiary, letterSpacing: 0.8, textTransform: "uppercase", marginBottom: 6 }}>{t.theme === 'uv' ? "Site or building name *" : "Site / Building Name *"}</p>
        <input
          autoFocus
          value={quickName}
          onChange={e => setQuickName(e.target.value)}
          placeholder="e.g. Broadgate Tower"
          style={{ width: "100%", background: t.colors.glass, border: `0.5px solid ${quickName ? divBorder : t.colors.glassBorder}`, borderRadius: t.radius.md, padding: "14px 16px", color: t.colors.text, fontSize: 16, fontFamily: "inherit", outline: "none", marginBottom: 20, ...uvx(() => ({ ...studioSurface.pressed(), borderRadius: STUDIO_TOKENS.button.radius })) }}
        />
        <p style={{ fontSize: 11, fontWeight: 700, color: t.colors.textTertiary, letterSpacing: 0.8, textTransform: "uppercase", marginBottom: 6 }}>{t.theme === 'uv' ? "Visit time" : "Visit Time"}</p>
        <div style={{ display: "flex", gap: 8, marginBottom: 8 }}>
          {["Today", "Tomorrow"].map(d => (
            <button key={d} onClick={() => setForm(f => ({...f, visitDate: d}))} style={{ flex: 1, padding: "12px 0", borderRadius: t.radius.md, background: form.visitDate === d ? divColorLight : t.colors.glass, border: `0.5px solid ${form.visitDate === d ? divBorder : t.colors.glassBorder}`, color: form.visitDate === d ? divColor : t.colors.textSecondary, fontSize: 14, fontWeight: 700, cursor: "pointer", ...uvx(() => ({ ...(form.visitDate === d ? studioSurface.pressed() : studioSurface.slip()), color: STUDIO_TOKENS.ink, fontWeight: form.visitDate === d ? 700 : 400, borderRadius: STUDIO_TOKENS.button.radius })) }}>
              {d}
            </button>
          ))}
        </div>
        <input
          type="time"
          value={quickTime}
          onChange={e => setQuickTime(e.target.value)}
          style={{ width: "100%", background: t.colors.glass, border: `0.5px solid ${t.colors.glassBorder}`, borderRadius: t.radius.md, padding: "14px 16px", color: t.colors.text, fontSize: 16, fontFamily: "inherit", outline: "none", marginBottom: 32, colorScheme: "dark", ...uvx(() => ({ ...studioSurface.pressed(), borderRadius: STUDIO_TOKENS.button.radius, colorScheme: 'light' })) }}
        />
        <Btn
          label={quickName.trim() ? (t.theme === 'uv' ? 'Create the job' : `Create Job${studioArrow(' →')}`) : "Enter a site name to continue"}
          variant="primary" fullWidth studioMain color={divColor}
          disabled={!quickName.trim()}
          onClick={() => {
            if (!quickName.trim()) return;
            const id = `proj_${Date.now()}`;
            onSave({ id, name: quickName.trim(), client: "", contact: "", division: div.id, visitDate: form.visitDate || "Today", visitTime: quickTime, areas: "", intel: "", stage: "enquiry" });
          }}
        />
        <button onClick={() => setQuickMode(false)} style={{ background: "none", border: "none", color: t.colors.textSecondary, fontSize: 14, fontWeight: 500, marginTop: 16, cursor: "pointer", fontFamily: "inherit", ...uvx(() => ({ ...studioType.action(), marginTop: 16, fontFamily: STUDIO_TOKENS.fonts.body })) }}>
          {t.theme === 'uv' ? 'Add the contact, notes and areas' : '+ Add full details (contact, intel, areas)'}
        </button>
      </div>
    </div>
  );

  return (
    <div style={{ flex: 1, overflowY: "auto", WebkitOverflowScrolling: "touch", overscrollBehavior: "contain", paddingBottom: 100, background: "#E8DCC8", display: "flex", flexDirection: "column" }}>
      <NavBar title="New Enquiry" onBack={onBack} color={divColor} />

      {/* Step indicator */}
      <div style={{ padding: "12px 20px 0", flexShrink: 0 }}>
        <div style={{ display: "flex", gap: 6, marginBottom: 12 }}>
          {steps.map((s, i) => (
            <button key={s.label} onClick={() => i < step || canAdvance[step] ? setStep(i) : null} style={{
              flex: 1, padding: "8px 4px", borderRadius: t.radius.md, cursor: "pointer",
              background: step === i ? `${div.accentColor}18` : i < step ? "rgba(74,222,128,0.08)" : t.colors.glass,
              border: step === i ? `1px solid ${div.accentColor}50` : i < step ? `0.5px solid rgba(74,222,128,0.25)` : `0.5px solid ${t.colors.glassBorder}`,
              transition: "all 0.2s ease",
              ...uvx(() => ({ ...(step === i || i < step ? studioSurface.pressed() : studioSurface.slip()), borderRadius: STUDIO_TOKENS.button.radius })),
            }}>
              <p style={{ fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.3,
                color: step === i ? div.accentColor : i < step ? t.colors.green : t.colors.textTertiary, ...uvx({ fontSize: 14, color: step === i || i < step ? STUDIO_TOKENS.ink : STUDIO_TOKENS.muted, fontWeight: step === i ? 700 : 400 }) }}>
                {t.theme === 'uv' && i < step ? '✓ ' : null}{s.label}
              </p>
            </button>
          ))}
        </div>
        <div style={{ height: 2, background: t.colors.glass, borderRadius: 1, ...uvx({ background: STUDIO_TOKENS.pressed.fill }) }}>
          <div style={{ height: "100%", width: `${((step + 1) / steps.length) * 100}%`, background: `linear-gradient(90deg, ${div.accentColor}cc, ${div.accentColor})`, borderRadius: 2, transition: "width 0.4s ease", ...uvx({ background: STUDIO_TOKENS.lampAmber }) }} />
        </div>
      </div>

      <div style={{ flex: 1, overflowY: "auto", padding: "20px 20px 120px", WebkitOverflowScrolling: "touch" }}>

        {/* Step 0: Site */}
        {step === 0 && (
          <>
            <GlassCard gold={divColor} style={{ padding: "14px 16px", marginBottom: 20, display: "flex", alignItems: "center", gap: 10 }} hover={false}>
              <Icon name="building" size={18} color={divColor} />
              <p style={{ fontSize: 13, color: t.colors.textSecondary, lineHeight: 1.4 }}>{`Basic site details. Takes 30 seconds${studioDash()}just enough to create the project record.`}</p>
            </GlassCard>
            <Field label="Building / Site Name *" value={form.name} onChange={v => set("name", v)} placeholder="" />
            <Field label="Site Address" value={form.address} onChange={v => set("address", v)} placeholder="" />
            <Field label="Client Company *" value={form.client} onChange={v => set("client", v)} placeholder="" />
            <Field label="Areas / Floors in Scope" value={form.floors} onChange={v => set("floors", v)} placeholder="" />
          </>
        )}

        {/* Step 1: Contact */}
        {step === 1 && (
          <>
            <GlassCard gold={divColor} style={{ padding: "14px 16px", marginBottom: 20, display: "flex", alignItems: "center", gap: 10 }} hover={false}>
              <Icon name="user" size={18} color={divColor} />
              <p style={{ fontSize: 13, color: t.colors.textSecondary, lineHeight: 1.4 }}>Who are you meeting? This loads into the pre-visit brief so you walk in knowing their name and role.</p>
            </GlassCard>
            <Field label="Contact Name *" value={form.contact} onChange={v => set("contact", v)} placeholder="" />
            <Field label="Job Title" value={form.contactRole} onChange={v => set("contactRole", v)} placeholder="" />
            <Field label="Email" value={form.contactEmail} onChange={v => set("contactEmail", v)} placeholder="" />
            <ChipSelect label="How did this come in?" options={["Phone", "Email", "Referral", "Existing client", "Cold approach"]} value={form.source} onChange={v => set("source", v)} accentColor={div.accentColor} />
          </>
        )}

        {/* Step 2: Visit */}
        {step === 2 && (
          <>
            <GlassCard gold={divColor} style={{ padding: "14px 16px", marginBottom: 20, display: "flex", alignItems: "center", gap: 10 }} hover={false}>
              <Icon name="calendar" size={18} color={divColor} />
              <p style={{ fontSize: 13, color: t.colors.textSecondary, lineHeight: 1.4 }}>When are you going? This puts it on the dashboard under the right section.</p>
            </GlassCard>
            <ChipSelect label="Visit Date" options={["Today", "Tomorrow", "This week", "Next week"]} value={form.visitDate} onChange={v => set("visitDate", v)} accentColor={div.accentColor} />
            {(form.visitDate === "This week" || form.visitDate === "Next week") && (
              <Field label="Specific Date" value={form.visitDate === "This week" || form.visitDate === "Next week" ? "" : form.visitDate} onChange={v => set("visitDate", v)} placeholder="" />
            )}
            <TimeSelect value={form.visitTime} onChange={v => set("visitTime", v)}  accentColor={div.accentColor} />
          </>
        )}

        {/* Step 3: Intel */}
        {step === 3 && (
          <>
            <GlassCard gold={divColor} style={{ padding: "14px 16px", marginBottom: 20, display: "flex", alignItems: "center", gap: 10 }} hover={false}>
              <Icon name="zap" size={18} color={divColor} />
              <p style={{ fontSize: 13, color: t.colors.textSecondary, lineHeight: 1.4 }}>{`What do you know so far? Optional${studioDash()}but anything here means a better pre-visit brief.`}</p>
            </GlassCard>
            <ChipSelect label="What's driving the enquiry?" options={div.enquiryDrivers} value={form.driver} onChange={v => set("driver", v)} accentColor={div.accentColor} />
            <ChipSelect label="Budget signal?" options={["Under £10k", "£10k–25k", "£25k–50k", "£50k–100k", "£100k+", "Nothing mentioned", "TBC — need ROI first"]} value={form.budget} onChange={v => set("budget", v)} accentColor={div.accentColor} />
            <ChipSelect label="Timeline?" options={["Urgent", "Q2 2026", "Q3 2026", "Q4 2026", "2027", "Flexible"]} value={form.visitTimeline} onChange={v => set("visitTimeline", v)} accentColor={div.accentColor} />
            <div style={{ marginBottom: 14 }}>
              <label style={{ fontSize: 11, fontWeight: 700, color: t.colors.textTertiary, textTransform: "uppercase", letterSpacing: 0.4, display: "block", marginBottom: 6 }}>Notes</label>
              <div style={{ background: t.colors.glass, border: `0.5px solid ${t.colors.glassBorder}`, borderRadius: t.radius.md, padding: "11px 14px" }}>
                <textarea value={form.notes} onChange={e => set("notes", e.target.value)} placeholder="" rows={4}
                  style={{ width: "100%", background: "none", border: "none", outline: "none", color: t.colors.text, fontSize: 14, fontFamily: "'SF Pro Text', sans-serif", resize: "none", lineHeight: 1.5 }} />
              </div>
            </div>
          </>
        )}

        {/* Navigation */}
        <div style={{ display: "flex", gap: 10, marginTop: 4 }}>
          {step > 0 && <Btn label={t.theme === 'uv' ? 'Back' : '← Back'} variant="ghost" onClick={() => setStep(s => s - 1)} color={divColor} />}
          {step < steps.length - 1 ? (
            <Btn label={`Continue${studioArrow(' →')}`} variant="primary" studioMain fullWidth={step === 0} disabled={!canAdvance[step]} color={divColor}
              onClick={() => canAdvance[step] && setStep(s => s + 1)} />
          ) : (
            <Btn label="Save Enquiry" variant="primary" icon="check" studioMain fullWidth color={divColor}
              onClick={() => {
                const newProject = {
                  id: Date.now(),
                  ...form,
                  status: form.visitDate === "Today" ? "Active" : "Upcoming",
                };
                onSave(newProject);
                setSaved(true);
              }} />
          )}
        </div>
        {step === steps.length - 1 && (
          <p style={{ textAlign: "center", fontSize: 11, color: t.colors.textTertiary, marginTop: 10 }}>{`Intel fields are optional${studioDash()}save now and fill in what you know on the day`}</p>
        )}
      </div>
    </div>
  );
};
const SPECS = {
  0: { title: "Dashboard — Live, Not Hardcoded", insight: "Today's Sites now shows real enquiries from state — not mock data. If nothing is logged for today, the section says so and offers a direct route to New Enquiry. Upcoming visits stack below. The Site Visits count reflects the actual number of logged projects. Tap any project to load its pre-visit brief directly.", gap: "PlanRadar, SnagBricks, GoAudits — every competitor starts at defects. This starts at revenue." },
  1: { title: "Pre-Visit — Powered by Real Data", insight: "Every field in the pre-visit brief now comes from what was entered at enquiry stage. Notes from the PM's initial conversation surface here. MEES flag only shows if the driver field contains MEES — no false positives. If a field wasn't captured, it says 'Not yet captured' rather than breaking. Sparse data = sparse brief. Full data = full brief.", gap: "No competitor has pre-visit commercial intelligence. They all assume you walk onto site cold." },
  2: { title: "Scope Capture — Client Meeting Mode", insight: "Six structured questions replace free-form notes. Tapping an answer auto-advances — no friction. The generated Project Brief is sent to the client before they're back at their desk. That email arrives while the meeting is still fresh in their mind.", gap: "This is entirely absent from every snagging app on the market. They start after the sale. This wins the sale." },
  3: { title: "Live Survey — The Magic Screen", insight: "Three layers of completion visibility. Progress ring. Zone grid with persistent state per zone. Outstanding zones called out by name. Auto-advances to the next unlogged zone after each entry. Propose button reflects completion status honestly.", gap: "PlanRadar pins defects to floor plans. This tracks commercial survey progress in real time. Categorically different." },
  4: { title: "On-Site Proposal — Close Before You Leave", insight: "Three tiers pre-populated from survey data. One tap sends the preliminary scope document. Fixture schedule syncs to portal — the quote pipeline picks it up back at the office. Companion app's work ends at the client's inbox.", gap: "No tool on the market generates a commercial proposal on site. This is the LumenEssence differentiator in its purest form." },
  5: { title: "Issue Log — Snagging When Needed", insight: "Defect logging is still here. It's screen 6, not screen 1. The hierarchy of the app tells the story: win the job first, log the snags later.", gap: "" },
  6: { title: "New Enquiry — 90 Seconds to a Live Project", insight: "Four steps: Site → Contact → Visit → Intel. Only site name, contact name, and visit time are required — everything else is optional. Save a bare-bones record in under a minute and it immediately appears on the dashboard. The intel step captures what the PM already knows from the phone call or email: what's driving it, budget signal, timeline, any notes. That intelligence is what powers the pre-visit brief. Garbage in, garbage out — but even a little context is better than arriving cold.", gap: "Every snagging tool assumes the job has already been won. This is the moment before the sale. Nobody is here." },
  7: { title: "Settings — Platform Foundation", insight: "Portal connection live. Fixture data flows from companion app to portal, where the quote pipeline takes over. LumenEssence attribution in footer seeds the platform brand with every engineer who uses the white-label version.", gap: "" },
};

// ── PIN auth helpers ──────────────────────────────
// Simple hash — not cryptographic, but prevents casual plaintext reading
const hashPin = (pin) => {
  let h = 5381;
  for (let i = 0; i < pin.length; i++) {
    h = ((h << 5) + h) + pin.charCodeAt(i);
    h = h & h; // 32-bit int
  }
  return String(h >>> 0);
};

// Admin PIN — change this before sharing the URL with the team
// Default: 9999. Andrew should change to something private in Settings.
const ADMIN_PIN_HASH = hashPin("9999");

// ── Avatar colour helper — never gold, never copper ─────────────
// S95 D5 D30 (fourth attempt): the previous hash was landing on dusty-rose
// (#7A4856) for Andrew's name — he reported it as "dark mauve". Directors /
// owners (including Andrew) now force sky blue; other users hash across the
// exact palette the brief specifies. Aircon non-directors keep steel blue
// from the design system so Mechanical users remain visually distinct.
const SKY_AVATAR = { base: "#3E8BBF", bright: "#5EA7D1", text: "#FFFCF2", shadow: "0 0 20px rgba(62,139,191,0.18), 0 4px 16px rgba(28,24,16,0.08)" };
const avatarColorsForUser = (user) => {
  const role = (user?.role || "").toLowerCase().trim();
  const isDirector = role.includes("director") || role.includes("owner") || role === "md" || role === "founder" || role.includes("principal");
  if (isDirector) return SKY_AVATAR;
  if (user?.division === "aircon") {
    return { base: t.colors.blue, bright: "#7AB4E0", text: t.colors.navy, shadow: t.shadow.blue };
  }
  // Brief palette (S95 D5): sky / muted-slate / sage / dusty-rose. No copper,
  // no gold — both reserved for financial values and nav accents.
  const palette = [
    SKY_AVATAR,
    { base: "#4A6462", bright: "#6A8482", text: "#FFFCF2", shadow: "0 0 20px rgba(74,100,98,0.18), 0 4px 16px rgba(28,24,16,0.08)" },
    { base: "#2E6838", bright: "#4E8858", text: "#FFFCF2", shadow: "0 0 20px rgba(46,104,56,0.18), 0 4px 16px rgba(28,24,16,0.08)" },
    { base: "#7A4856", bright: "#9A6876", text: "#FFFCF2", shadow: "0 0 20px rgba(122,72,86,0.18), 0 4px 16px rgba(28,24,16,0.08)" },
  ];
  const name = user?.name || "";
  let h = 0;
  for (let i = 0; i < name.length; i++) h = ((h << 5) - h + name.charCodeAt(i)) | 0;
  return palette[Math.abs(h) % palette.length];
};

// ── Numpad component ─────────────────────────────
const Numpad = ({ onDigit, onDelete, onSubmit, value, maxLen = 4, submitLabel = "Confirm", accentColor }) => {
  const ac = accentColor || t.colors.gold;
  const keys = ["1","2","3","4","5","6","7","8","9","","0","⌫"];
  // Studio (track C4). The PIN progress marks are not status dots (they show
  // how many digits are in): ink when entered, an empty ring when not. Keys
  // are raised paper (you press them) with ink digits; the submit is the one
  // ultraviolet main action, drawn here because the shared Btn is not themed.
  if (t.theme === 'uv') {
    const ink = STUDIO_TOKENS.ink; const muted = STUDIO_TOKENS.muted;
    return studioShape(
      <div style={{ width: "100%" }}>
        <div style={{ display: "flex", justifyContent: "center", gap: 16, marginBottom: 28 }} aria-label={`${value.length} of ${maxLen} digits entered`}>
          {Array.from({ length: maxLen }).map((_, i) => (
            <div key={i} style={{ width: 16, height: 16, borderRadius: "50%", background: i < value.length ? ink : "transparent", border: `2px solid ${i < value.length ? ink : muted}`, boxSizing: "border-box", transition: "all 0.15s ease" }} />
          ))}
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10, maxWidth: 260, margin: "0 auto" }}>
          {keys.map((k, i) => {
            if (k === "") return <div key={i} />;
            const isDel = k === "⌫";
            return (
              <button key={i} onClick={() => isDel ? onDelete() : onDigit(k)} aria-label={isDel ? "Delete" : undefined}
                style={{ ...(isDel ? { background: "none", border: "none", boxShadow: "none" } : studioSurface.slip()), height: 64, borderRadius: t.radius.lg, color: isDel ? muted : ink, fontFamily: STUDIO_TOKENS.fonts.body, fontSize: 25, fontWeight: 500, cursor: "pointer" }}>
                {k}
              </button>
            );
          })}
        </div>
        {value.length === maxLen && (
          <div style={{ marginTop: 20, maxWidth: 260, margin: "20px auto 0" }}>
            <StudioPrimary label={submitLabel} onClick={onSubmit} />
          </div>
        )}
      </div>
    );
  }
  return (
    <div style={{ width: "100%" }}>
      {/* Dots */}
      <div style={{ display: "flex", justifyContent: "center", gap: 16, marginBottom: 32 }}>
        {Array.from({ length: maxLen }).map((_, i) => (
          <div key={i} style={{
            width: 16, height: 16, borderRadius: "50%",
            background: i < value.length ? ac : "transparent",
            border: `2px solid ${i < value.length ? ac : t.colors.textTertiary}`,
            transition: "all 0.15s ease",
          }} />
        ))}
      </div>
      {/* Grid */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10, maxWidth: 260, margin: "0 auto" }}>
        {keys.map((k, i) => {
          if (k === "") return <div key={i} />;
          const isDel = k === "⌫";
          return (
            <button key={i} onClick={() => isDel ? onDelete() : onDigit(k)}
              style={{
                height: 64, borderRadius: t.radius.lg,
                background: isDel ? "transparent" : t.colors.glass,
                border: `0.5px solid ${isDel ? "transparent" : t.colors.glassBorder}`,
                color: isDel ? t.colors.textSecondary : t.colors.text,
                fontSize: isDel ? 20 : 24, fontWeight: 600, cursor: "pointer",
                transition: "all 0.1s ease",
              }}>
              {k}
            </button>
          );
        })}
      </div>
      {value.length === maxLen && (
        <div style={{ marginTop: 20, maxWidth: 260, margin: "20px auto 0" }}>
          <Btn label={submitLabel} variant="primary" fullWidth onClick={onSubmit} />
        </div>
      )}
    </div>
  );
};

// ════════════════════════════════════════════════════
// AUTH SCREENS
// ════════════════════════════════════════════════════
// ── SIGNIN-AURORA-V1 (20 October 2026): the sign-in, the portal's current look ──
// Ported from the portal's sign-in (templates/index.html #login-screen and the
// ".lsi-*" rules in static/portal.css, the LIVE-FIX-V1 track C look of 12
// October 2026): a shifting ultraviolet field under one lamp (five drifting
// blobs, ribbons of light drawn on a canvas, grain), and one glass card with
// the brand, the time-of-day greeting and the view's own controls. It replaces
// SIGNIN-V1's lit grey ground and Eva ticker card (7 October 2026). The sign-in
// shows before a user's theme is known, so nothing here reads t.theme and
// nothing is wrapped in studioShape: every user sees this whatever the switch
// says. Nothing here fetches: the greeting is the local clock. The brand comes
// ONLY from SIGNIN_BRAND. The app's flow is unchanged (a profile, its PIN,
// then the portal password); only the presentation is the portal's.
//
// Motion: the blobs drift in CSS; the ribbons are drawn by startSigninWaves
// below, which stops (cancelAnimationFrame, listeners off) when the screen
// unmounts, pauses while the page is hidden, and under prefers-reduced-motion
// draws one still frame and never loops.
const SIGNIN_CSS = `
.lsi-ph{position:relative;overflow:hidden;flex:1;min-height:0;width:100%;background:#140C3C;font-family:'Satoshi',system-ui,sans-serif;color:#111827;-webkit-font-smoothing:antialiased}
.lsi-ph *,.lsi-ph *::before,.lsi-ph *::after{box-sizing:border-box}
.lsi-scroll{position:absolute;inset:0;display:flex;padding:max(24px,env(safe-area-inset-top)) clamp(16px,8vw,120px) max(24px,env(safe-area-inset-bottom));overflow-x:hidden;overflow-y:auto;overscroll-behavior:contain;-webkit-overflow-scrolling:touch}
.lsi-aurora{position:absolute;inset:-20%;filter:blur(56px) saturate(1.3) brightness(1.15);pointer-events:none}
.lsi-aurora i{position:absolute;border-radius:50%;mix-blend-mode:screen;opacity:1}
.lsi-aurora .lsi-a1{width:55vw;height:55vw;left:45%;top:-10%;background:radial-gradient(circle,#4B2BFF,rgba(75,43,255,0) 65%);animation:lsi-drift1 11s ease-in-out infinite alternate}
.lsi-aurora .lsi-a2{width:50vw;height:50vw;left:60%;top:35%;background:radial-gradient(circle,#FB7185,rgba(251,113,133,0) 65%);animation:lsi-drift2 13s ease-in-out infinite alternate}
.lsi-aurora .lsi-a3{width:45vw;height:45vw;left:25%;top:45%;background:radial-gradient(circle,#7C3CFF,rgba(124,60,255,0) 65%);animation:lsi-drift3 9s ease-in-out infinite alternate}
.lsi-aurora .lsi-a4{width:38vw;height:38vw;left:72%;top:-14%;background:radial-gradient(circle,#FFC46A,#F2A23A 25%,rgba(242,162,58,0) 62%);animation:lsi-drift4 8s ease-in-out infinite alternate;opacity:.95}
.lsi-aurora .lsi-a5{width:60vw;height:60vw;left:-15%;top:-25%;background:radial-gradient(circle,#2A1A6B,rgba(42,26,107,0) 70%);animation:lsi-drift3 15s ease-in-out infinite alternate-reverse}
@keyframes lsi-drift1{to{transform:translate(-18vw,14vh) scale(1.15)}}
@keyframes lsi-drift2{to{transform:translate(-22vw,-18vh) scale(.9)}}
@keyframes lsi-drift3{to{transform:translate(16vw,-12vh) scale(1.2)}}
@keyframes lsi-drift4{to{transform:translate(-8vw,10vh) scale(1.3)}}
.lsi-waves{position:absolute;inset:0;width:100%;height:100%;filter:blur(18px) saturate(1.4);opacity:.95;pointer-events:none}
.lsi-grain{position:absolute;inset:0;opacity:.14;mix-blend-mode:overlay;pointer-events:none;background-image:url("data:image/svg+xml;utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='160'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='.9' numOctaves='2' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E")}
.lsi-main{position:relative;width:min(420px,100%);margin:auto 0}
.lsi-card{width:100%;padding:34px 32px;border-radius:22px;display:flex;flex-direction:column;gap:18px;background:linear-gradient(200deg,rgba(255,252,246,.96),rgba(246,239,228,.93));box-shadow:-24px 40px 80px -30px rgba(10,4,40,.8),inset 0 1px 0 #fff}
.lsi-brand{display:flex;align-items:center;gap:12px}
.lsi-mark{width:44px;height:44px;flex:none;border-radius:11px;background:#26324A;color:#F4EFE6;display:flex;align-items:center;justify-content:center;font-weight:800;font-size:14px}
.lsi-brand-text{display:flex;flex-direction:column;min-width:0;font-size:15px;line-height:1.25}
.lsi-brand-name{font-weight:700;color:#111827}
.lsi-hello{margin:0;font-family:'Sentient',Georgia,serif;font-weight:300;font-size:49px;line-height:1.02;letter-spacing:-0.018em;color:#111827;text-wrap:balance}
.lsi-title{display:flex;flex-direction:column;gap:6px}
.lsi-h2{margin:0;font-family:'Sentient',Georgia,serif;font-weight:300;font-size:31px;line-height:1.05;letter-spacing:-0.018em;color:#111827}
.lsi-sub{margin:0;font-size:15px;line-height:1.4;color:#475569}
.lsi-field{display:flex;flex-direction:column;gap:6px}
.lsi-field label,.lsi-label{font-size:14px;font-weight:500;color:#111827}
.lsi-pw-row{display:flex;justify-content:space-between;align-items:center}
.lsi-input{width:100%;min-height:44px;padding:0 12px;border-radius:10px;border:0;background:rgba(60,62,70,.08);box-shadow:inset 1px 2px 6px rgba(30,32,40,.14);font:500 16px 'Satoshi',system-ui,sans-serif;color:#111827;outline:none;transition:box-shadow .15s ease,background .15s ease}
.lsi-input::placeholder{color:#475569}
.lsi-input:focus{background:#fff;box-shadow:0 0 0 3px rgba(75,43,255,.25),inset 0 0 0 1px #4B2BFF}
.lsi-btn{display:inline-flex;align-items:center;justify-content:center;width:100%;min-height:52px;padding:0 20px;border-radius:10px;border:0;background:#4B2BFF;color:#FBF8FF;font:700 16px/1 'Satoshi',system-ui,sans-serif;cursor:pointer;box-shadow:inset 0 0 0 1px rgba(30,10,140,.25),-3px 6px 14px -6px rgba(60,30,200,.5);transition:background .15s ease}
.lsi-btn:hover:not(:disabled){background:#3B22E0}
.lsi-btn:focus-visible,.lsi-link:focus-visible,.lsi-key:focus-visible{outline:3px solid rgba(75,43,255,.45);outline-offset:2px}
.lsi-link{align-self:flex-start;background:none;border:0;padding:0 4px;min-height:44px;font:600 14px 'Satoshi',system-ui,sans-serif;color:#111827;text-decoration:underline;text-underline-offset:4px;cursor:pointer}
.lsi-link:hover{color:#3B22E0}
.lsi-link.lsi-centre{align-self:center}
.lsi-link.lsi-show{align-self:auto;min-width:44px;font-size:13px}
.lsi-link.lsi-back{margin-left:auto;align-self:auto;display:flex;align-items:center;gap:4px}
.lsi-busy{display:flex;flex-direction:column;gap:18px;align-items:center;text-align:center;padding:24px 0}
.lsi-orb{width:64px;height:64px;border-radius:50%;flex:none;background:radial-gradient(circle at 35% 30%,#D6CCFF,#6E50FF 45%,#2A17B0 80%);animation:lsi-breathe 3.2s ease-in-out infinite}
.lsi-orb.lsi-busy-orb{animation-duration:.9s}
@keyframes lsi-breathe{0%,100%{box-shadow:0 0 18px rgba(124,90,255,.55);transform:scale(1)}50%{box-shadow:0 0 34px rgba(124,90,255,.95);transform:scale(1.06)}}
.lsi-error{margin:0;padding:12px 16px;border-radius:10px;background:rgba(60,62,70,.08);box-shadow:inset 1px 2px 6px rgba(30,32,40,.14);font-size:15px;font-weight:600;color:#111827;text-align:center}
.lsi-foot{margin:0;text-align:center;font-size:13px;line-height:1.4;color:#475569}
.lsi-pin-dots{display:flex;gap:14px;justify-content:center;min-height:16px;margin-bottom:14px}
.lsi-pin-dots span{width:14px;height:14px;border-radius:50%;box-shadow:inset 0 0 0 2px rgba(17,24,39,.25)}
.lsi-pin-dots span.on{background:#111827;box-shadow:none}
.lsi-pad{display:grid;grid-template-columns:repeat(3,1fr);gap:10px;max-width:300px;margin:0 auto}
.lsi-key{min-height:48px;border:0;border-radius:14px;background:linear-gradient(200deg,#FFFFFD,#F2F0EB);color:#111827;font:600 22px/1 'Satoshi',system-ui,sans-serif;cursor:pointer;box-shadow:-4px 8px 16px -10px rgba(30,32,40,.45),inset 0 1px 0 rgba(255,255,255,.9),inset 0 0 0 1px rgba(17,24,39,.06);transition:transform .1s ease,box-shadow .1s ease}
.lsi-key:active{transform:translateY(1px);box-shadow:inset 1px 2px 6px rgba(40,42,50,.18)}
.lsi-key.lsi-key-bare{background:none;box-shadow:none;display:flex;align-items:center;justify-content:center}
.lsi-key-gap{display:block}
@media (max-width:640px){.lsi-card{padding:28px 24px}}
@media (prefers-reduced-motion: reduce){.lsi-aurora i,.lsi-orb{animation:none !important}.lsi-btn,.lsi-input,.lsi-key{transition:none}.lsi-key:active{transform:none}}
`;

// The field's ribbons of light and its flashes: the portal's startWaves, with
// the same ribbons, colours, flash timing and blur. The array values are held
// equal to the warm-up's copy in index.html by tests/signin_aurora.test.js.
const SIGNIN_RIBBONS = [
  { c: ['rgba(75,43,255,0)', 'rgba(75,43,255,0.47)', 'rgba(124,60,255,0.45)', 'rgba(75,43,255,0)'], y: 0.30, a: 0.09, f: 1.3, s: 0.00042, w: 0.16, p: 0 },
  { c: ['rgba(124,60,255,0)', 'rgba(124,60,255,0.42)', 'rgba(251,113,133,0.47)', 'rgba(124,60,255,0)'], y: 0.52, a: 0.12, f: 1.0, s: -0.00035, w: 0.20, p: 2 },
  { c: ['rgba(251,113,133,0)', 'rgba(251,113,133,0.40)', 'rgba(242,162,58,0.42)', 'rgba(251,113,133,0)'], y: 0.70, a: 0.08, f: 1.7, s: 0.0005, w: 0.12, p: 4 },
  { c: ['rgba(42,26,107,0)', 'rgba(90,60,230,0.35)', 'rgba(42,26,107,0)'], y: 0.85, a: 0.06, f: 2.2, s: -0.0006, w: 0.10, p: 1 },
];
const SIGNIN_FLASH_COLOURS = ['255,196,106', '251,113,133', '137,243,54', '120,96,255', '255,120,190'];
// Phone battery: the canvas is drawn at half the screen's CSS size (the portal's
// choice; a blur of 18px sits over it) and never more than 1.5x of that on a
// dense screen, with a ceiling on the pixel count, and at about 30 frames a
// second, not 60: the ribbons move a few pixels a second.
const SIGNIN_WAVE_FRAME_MS = 33;
const SIGNIN_WAVE_MAX_PIXELS = 262144;
function signinWaveSize(cssW, cssH, dpr) {
  const d = Math.min(Math.max(Number(dpr) || 1, 1), 1.5);
  let w = Math.max(1, Math.ceil(cssW * 0.5 * d));
  let h = Math.max(1, Math.ceil(cssH * 0.5 * d));
  if (w * h > SIGNIN_WAVE_MAX_PIXELS) {
    const k = Math.sqrt(SIGNIN_WAVE_MAX_PIXELS / (w * h));
    w = Math.max(1, Math.floor(w * k)); h = Math.max(1, Math.floor(h * k));
  }
  return { w, h };
}
// Starts the ribbons on a canvas and returns stop(). It draws nothing it was not
// asked to: reduced motion gets one still frame and no loop; a hidden page
// pauses the loop and a visible one resumes it; stop() cancels the pending frame
// and removes every listener, so nothing keeps drawing behind the app.
function startSigninWaves(cv, env) {
  const win = (env && env.window) || (typeof window !== 'undefined' ? window : null);
  const doc = (env && env.document) || (win && win.document) || null;
  if (!cv || !win || !doc || typeof cv.getContext !== 'function') return () => {};
  let ctx = null;
  try { ctx = cv.getContext('2d'); } catch (e) { ctx = null; }
  if (!ctx) return () => {};
  const reduced = () => { try { return !!(win.matchMedia && win.matchMedia('(prefers-reduced-motion: reduce)').matches); } catch (e) { return false; } };
  let W = 0; let H = 0; let raf = null; let stopped = false; let last = -1e9; let flashes = []; let nextFlash = 0;
  const size = () => {
    const box = cv.parentElement;
    const cssW = (box && box.clientWidth) || win.innerWidth || 390;
    const cssH = (box && box.clientHeight) || win.innerHeight || 844;
    const s = signinWaveSize(cssW, cssH, win.devicePixelRatio);
    W = s.w; H = s.h; cv.width = W; cv.height = H;
  };
  const frame = (t) => {
    ctx.globalCompositeOperation = 'source-over';
    ctx.fillStyle = 'rgba(20,12,60,0.38)'; ctx.fillRect(0, 0, W, H);
    ctx.globalCompositeOperation = 'lighter';
    SIGNIN_RIBBONS.forEach((r) => {
      const g = ctx.createLinearGradient(0, 0, W, 0);
      r.c.forEach((col, i) => g.addColorStop(i / (r.c.length - 1), col));
      ctx.fillStyle = g; ctx.beginPath();
      const th = r.w * H; const ph = t * r.s + r.p;
      for (let x = 0; x <= W; x += 6) { const u = x / W; const y = H * (r.y + r.a * Math.sin(u * Math.PI * 2 * r.f + ph) + r.a * 0.45 * Math.sin(u * Math.PI * 5 * r.f - ph * 1.7)); ctx.lineTo(x, y - th * (0.6 + 0.4 * Math.sin(u * 9 + ph * 2))); }
      for (let x = W; x >= 0; x -= 6) { const u = x / W; const y = H * (r.y + r.a * Math.sin(u * Math.PI * 2 * r.f + ph) + r.a * 0.45 * Math.sin(u * Math.PI * 5 * r.f - ph * 1.7)); ctx.lineTo(x, y + th * (0.6 + 0.4 * Math.cos(u * 7 - ph * 2))); }
      ctx.closePath(); ctx.fill();
    });
    if (t > nextFlash) {
      flashes.push({ x: Math.random() * W, y: Math.random() * H, r: (0.08 + Math.random() * 0.14) * Math.max(W, H), c: SIGNIN_FLASH_COLOURS[Math.floor(Math.random() * SIGNIN_FLASH_COLOURS.length)], t0: t, d: 1400 + Math.random() * 900 });
      nextFlash = t + 700 + Math.random() * 1600;
    }
    flashes = flashes.filter((f) => {
      const k = (t - f.t0) / f.d; if (k > 1) return false;
      const a = Math.sin(k * Math.PI); const gr = ctx.createRadialGradient(f.x, f.y, 0, f.x, f.y, f.r * (0.6 + k * 0.6));
      gr.addColorStop(0, 'rgba(' + f.c + ',' + (0.6 * a) + ')'); gr.addColorStop(1, 'rgba(' + f.c + ',0)');
      ctx.fillStyle = gr; ctx.fillRect(f.x - f.r * 1.3, f.y - f.r * 1.3, f.r * 2.6, f.r * 2.6);
      return true;
    });
  };
  const still = () => {
    flashes = []; nextFlash = 0;
    ctx.fillStyle = '#140C3C'; ctx.fillRect(0, 0, W, H);
    for (let i = 0; i < 30; i++) frame(i * 400);
  };
  const cancel = () => { if (raf != null) { try { (win.cancelAnimationFrame || (() => {}))(raf); } catch (e) {} raf = null; } };
  const loop = (t) => {
    raf = null;
    if (stopped || doc.hidden) return;
    if (t - last >= SIGNIN_WAVE_FRAME_MS) {
      last = t;
      try { frame(t); } catch (e) { stop(); try { console.warn('signin waves stopped', e && e.message); } catch (e2) {} return; }
    }
    raf = win.requestAnimationFrame(loop);
  };
  const run = () => {
    if (stopped || raf != null || doc.hidden || reduced()) return;
    ctx.fillStyle = '#140C3C'; ctx.fillRect(0, 0, W, H);
    raf = win.requestAnimationFrame(loop);
  };
  const onVisibility = () => { if (doc.hidden) cancel(); else run(); };
  const onResize = () => { if (stopped) return; size(); if (reduced()) still(); };
  const stop = () => {
    if (stopped) return;
    stopped = true; cancel();
    try { doc.removeEventListener('visibilitychange', onVisibility); win.removeEventListener('resize', onResize); } catch (e) {}
  };
  try {
    size();
    doc.addEventListener('visibilitychange', onVisibility);
    win.addEventListener('resize', onResize);
    if (reduced()) still(); else run();
  } catch (e) {
    // The field is decoration: a canvas that will not draw must never stop the
    // sign-in. Stop the loop and say so once.
    stop();
    try { console.warn('signin waves stopped', e && e.message); } catch (e2) {}
  }
  return stop;
}

// The orb of the busy state (the portal's .lsi-orb.busy).
const SigninOrb = () => <span aria-hidden="true" className="lsi-orb lsi-busy-orb" />;

// The brand mark: the short brand on an ink rounded square (the portal's
// .lsi-mark). The name beside it is the readable text.
const SigninMark = () => <span className="lsi-mark" aria-hidden="true">{SIGNIN_BRAND.short}</span>;

// An ink text action, underlined (the portal's .lsi-link). Never violet.
const SigninLink = ({ children, onClick, className, style, ...rest }) => (
  <button type="button" onClick={onClick} {...rest} className={className ? `lsi-link ${className}` : 'lsi-link'}
    style={{ minHeight: 44, ...(style || {}) }}>
    {children}
  </button>
);

// The one main action: flat violet (the portal's .lsi-btn).
const SigninPrimary = ({ label, onClick, disabled }) => (
  <button type="button" className="lsi-btn" onClick={disabled ? undefined : onClick} disabled={!!disabled}
    style={{ minHeight: 52, background: STUDIO_TOKENS.ultraviolet, color: STUDIO_TOKENS.onPrimary, cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.5 : 1 }}>
    {label}
  </button>
);

// A field and its label (the portal's .lsi-field and .lsi-input).
const SigninField = ({ id, label, value, onChange, placeholder }) => (
  <div className="lsi-field">
    <label htmlFor={id}>{label}</label>
    <input id={id} className="lsi-input" value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} />
  </div>
);

// The sign-in's own numpad (LockScreen keeps the shared Numpad): raised paper
// keys with ink digits, 48px tall so a view fits the phone, and the violet
// submit once every digit is in.
const SigninNumpad = ({ value, maxLen = 4, onDigit, onDelete, onSubmit, submitLabel }) => {
  const S = STUDIO_TOKENS;
  const keys = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '', '0', 'del'];
  return (
    <div style={{ width: '100%' }}>
      <div className="lsi-pin-dots" aria-label={`${value.length} of ${maxLen} digits entered`}>
        {Array.from({ length: maxLen }).map((_, i) => <span key={i} className={i < value.length ? 'on' : undefined} />)}
      </div>
      <div className="lsi-pad">
        {keys.map((k, i) => {
          if (k === '') return <span key={i} className="lsi-key-gap" aria-hidden="true" />;
          if (k === 'del') return (
            <button key={i} type="button" className="lsi-key lsi-key-bare" onClick={onDelete} aria-label="Delete" style={{ minHeight: 48 }}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={S.muted} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 5H9l-6 7 6 7h12a1 1 0 001-1V6a1 1 0 00-1-1z" /><path d="M17 9l-5 6M12 9l5 6" /></svg>
            </button>
          );
          return (
            <button key={i} type="button" className="lsi-key" onClick={() => onDigit(k)} style={{ minHeight: 48 }}>
              {k}
            </button>
          );
        })}
      </div>
      {value.length === maxLen && (
        <div style={{ maxWidth: 300, margin: '12px auto 0' }}>
          <SigninPrimary label={submitLabel} onClick={onSubmit} />
        </div>
      )}
    </div>
  );
};

// The shell every sign-in view renders in: the aurora field, the ribbons canvas
// and the grain, then one glass card holding the brand, the greeting and the
// view's own controls. While a request runs (busy) the card keeps the brand and
// shows the view's busy block in place of the rest. Defined OUTSIDE
// UserSelectScreen so a state change never remounts it, which keeps the field
// drawing without a break between views.
const AuthScreen = ({ title, subtitle, onBack, error, children, busy = false }) => {
  const S = STUDIO_TOKENS;
  const h = new Date().getHours();
  const greeting = h < 12 ? 'Good morning.' : h < 17 ? 'Good afternoon.' : 'Good evening.';
  const wavesRef = useRef(null);
  useEffect(() => startSigninWaves(wavesRef.current), []);
  return (
    <div className="lsi-ph">
      <style>{SIGNIN_CSS}</style>
      {/* No zIndex anywhere here: a later sibling already paints over an earlier one, and a z-index would trap any fixed sheet below the tab bar (tests/overlay_layers.test.js). */}
      <div className="lsi-aurora" aria-hidden="true"><i className="lsi-a1" /><i className="lsi-a2" /><i className="lsi-a3" /><i className="lsi-a4" /><i className="lsi-a5" /></div>
      <canvas className="lsi-waves" ref={wavesRef} aria-hidden="true" />
      <div className="lsi-grain" aria-hidden="true" />
      <div className="lsi-scroll">
        <main className="lsi-main" aria-label="Sign in">
          <div className="lsi-card">
            <div className="lsi-brand">
              <SigninMark />
              <span className="lsi-brand-text"><b className="lsi-brand-name">{SIGNIN_BRAND.name}</b></span>
              {onBack && !busy && (
                <SigninLink onClick={onBack} className="lsi-back">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M15 18l-6-6 6-6" /></svg>
                  Back
                </SigninLink>
              )}
            </div>
            {busy ? children : (
              <>
                <h1 className="lsi-hello" style={{ fontFamily: S.fonts.display, fontWeight: 300, fontSize: 49 }}>{greeting}</h1>
                {(title || subtitle) && (
                  <div className="lsi-title">
                    {title && <h2 className="lsi-h2" style={{ fontFamily: S.fonts.display, fontWeight: 300, fontSize: 31 }}>{title}</h2>}
                    {subtitle && <p className="lsi-sub">{subtitle}</p>}
                  </div>
                )}
                {error && <div role="alert" className="lsi-error">{error}</div>}
                {children}
                <p className="lsi-foot">{`For ${SIGNIN_BRAND.name} staff. The same sign-in as the portal.`}</p>
              </>
            )}
          </div>
        </main>
      </div>
    </div>
  );
};

// ── Lock screen — shown when app returns from background ──────
const LockScreen = ({ user, onUnlock }) => {
  const [pin, setPin] = useState("");
  const [error, setError] = useState("");
  const initials = user ? user.name.split(" ").map(n => n[0]).join("").toUpperCase().slice(0, 2) : "?";

  const handleDigit = (d) => {
    if (pin.length >= 4) return;
    const next = pin + d;
    setPin(next);
    setError("");
    if (next.length === 4) {
      setTimeout(() => {
        if (hashPin(next) === user.pinHash || hashPin(next) === ADMIN_PIN_HASH) {
          setPin("");
          onUnlock();
        } else {
          setError("Incorrect PIN");
          setPin("");
        }
      }, 120);
    }
  };

  // Studio (track C4). The avatar is a raised disc with ink initials (the
  // hashed avatar colours are colour for looks); the name is a Sentient Light
  // title; the numpad is the shared Studio one above.
  if (t.theme === 'uv') {
    return studioShape(
      <div style={{ flex: 1, overflowY: "auto", WebkitOverflowScrolling: "touch", overscrollBehavior: "contain", display: "flex", flexDirection: "column", alignItems: "center", padding: "40px 28px 32px", position: "relative" }}>
        <div style={{ marginTop: "auto" }} />
        <div style={{ ...studioSurface.raised(), width: 80, height: 80, borderRadius: 40, display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 16 }}>
          <span style={{ color: STUDIO_TOKENS.ink, fontWeight: 700, fontSize: 25, lineHeight: 1, display: "block" }}>{initials}</span>
        </div>
        <h2 style={{ ...studioType.title(), fontSize: 31, lineHeight: 1.15, marginBottom: 6, textAlign: "center" }}>{user?.name}</h2>
        <p style={{ fontSize: 14, color: STUDIO_TOKENS.muted, marginBottom: 28, textAlign: "center" }}>App locked. Enter your PIN to continue.</p>
        {error && <div style={{ ...studioSurface.pressed(), padding: "10px 16px", borderRadius: 12, fontSize: 14, fontWeight: 600, color: STUDIO_TOKENS.ink, marginBottom: 16, textAlign: "center" }}>{error}</div>}
        <div style={{ width: "100%", maxWidth: 300 }}>
          <Numpad onDigit={handleDigit} onDelete={() => { setPin(p => p.slice(0, -1)); setError(""); }} value={pin} submitLabel="Unlock" />
        </div>
        <div style={{ marginBottom: "auto" }} />
      </div>
    );
  }

  return (
    <div style={{ flex: 1, overflowY: "auto", WebkitOverflowScrolling: "touch", overscrollBehavior: "contain", paddingBottom: 100, background: "radial-gradient(ellipse 90% 80% at 95% 100%, rgba(195,160,120,0.80) 0%, transparent 50%), radial-gradient(ellipse 75% 65% at 5% 0%, rgba(180,200,195,0.50) 0%, transparent 48%), radial-gradient(ellipse 55% 50% at 50% 40%, rgba(255,252,242,0.35) 0%, transparent 65%), linear-gradient(155deg, #D8E2DF 0%, #E4DDD0 22%, #EDE5D5 44%, #E8DCC8 66%, #D4C0A0 100%)", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "40px 28px", position: "relative" }}>
      {/* Home indicator bar */}
      <div style={{ position: "absolute", bottom: 8, left: "50%", transform: "translateX(-50%)", width: 134, height: 5, borderRadius: 3, background: "rgba(26,22,8,0.18)" }} />
      {/* Avatar */}
      {(() => {
        const ac = avatarColorsForUser(user);
        return (
          <div style={{ width: 80, height: 80, borderRadius: 24, background: `linear-gradient(135deg, ${ac.bright}, ${ac.base})`, display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 16, boxShadow: ac.shadow }}>
            <span style={{ color: ac.text, fontWeight: 800, fontSize: 28, fontFamily: "system-ui, -apple-system, sans-serif", lineHeight: 1, display: "block" }}>{initials}</span>
          </div>
        );
      })()}
      <h2 style={{ fontSize: 20, fontWeight: 800, color: t.colors.text, letterSpacing: -0.4, fontFamily: "system-ui, -apple-system, sans-serif", marginBottom: 4, textAlign: "center" }}>{user?.name}</h2>
      <p style={{ fontSize: 13, color: t.colors.textSecondary, marginBottom: 32, textAlign: "center" }}>App locked · Enter your PIN to continue</p>
      {error && <p style={{ fontSize: 12, color: t.colors.red, fontWeight: 600, marginBottom: 16, textAlign: "center" }}>{error}</p>}
      <Numpad onDigit={handleDigit} onDelete={() => { setPin(p => p.slice(0, -1)); setError(""); }} value={pin} submitLabel="Unlock" />
    </div>
  );
};

const UserSelectScreen = ({ onLogin }) => {
  const [knownUsers, setKnownUsers] = useState([]);
  const [view, setView] = useState("pick"); // "pick" | "new" | "pin" | "setpin" | "confirmpin" | "admin"
  const [selectedUser, setSelectedUser] = useState(null);
  const [name, setName] = useState("");
  const [role, setRole] = useState("");
  const [division, setDivision] = useState("");
  const [pin, setPin] = useState("");
  const [newPin, setNewPin] = useState("");
  const [confirmPin, setConfirmPin] = useState("");
  const [error, setError] = useState("");
  const [adminPin, setAdminPin] = useState("");
  const [portalPassword, setPortalPassword] = useState("");
  const [portalLoading, setPortalLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [pendingUser, setPendingUser] = useState(null);

  useEffect(() => {
    try {
      const stored = localStorage.getItem("asg_users");
      if (stored) {
        const users = JSON.parse(stored);
        // Filter out old-format users without pinHash (previous app version)
        const validUsers = users.filter(u => u.pinHash);
        if (validUsers.length !== users.length) {
          localStorage.setItem("asg_users", JSON.stringify(validUsers));
        }
        setKnownUsers(validUsers);
        if (validUsers.length === 0) setView("new");
      } else {
        setView("new");
      }
    } catch(e) { setView("new"); }
  }, []);

  const saveUsers = (users) => {
    try { localStorage.setItem("asg_users", JSON.stringify(users)); } catch(e) {}
    setKnownUsers(users);
  };

  const deleteUser = (userId) => {
    const updated = knownUsers.filter(u => u.id !== userId);
    saveUsers(updated);
    if (updated.length === 0) setView("new");
  };

  const [confirmDeleteUserId, setConfirmDeleteUserId] = useState(null);

  const addDigit = (setter, current) => (d) => {
    if (current.length < 4) setter(current + d);
  };
  const delDigit = (setter, current) => () => setter(current.slice(0, -1));

  // ── New user flow ──
  const goToSetPin = () => {
    if (!name.trim() || !division) return;
    setView("setpin");
    setNewPin("");
  };
  const goToConfirmPin = () => {
    setConfirmPin("");
    setView("confirmpin");
  };
  const createUser = () => {
    if (newPin !== confirmPin) {
      setError("PINs don't match. Try again.");
      setConfirmPin("");
      setView("setpin");
      setNewPin("");
      return;
    }
    const user = {
      id: `user_${Date.now()}`,
      name: name.trim(),
      role: role.trim() || "ASG",
      division: division || "lighting",
      pinHash: hashPin(newPin),
      createdAt: new Date().toISOString(),
    };
    setPendingUser(user);
    setPortalPassword("");
    setError("");
    setView("portalauth");
  };

  const finishLogin = (user) => {
    const updated = pendingUser
      ? [...knownUsers, user]  // new user — add to list
      : knownUsers.map(u => u.id === user.id ? user : u);  // existing — update
    saveUsers(updated);
    onLogin(user);
  };

  // SIGNIN-V1: each sign-in request takes a number. "Back to sign in" (or Back)
  // while one is running moves the number on, so the late answer of the
  // request left behind is ignored: no token stored, no sign-in, no error.
  const portalRequestRef = useRef(0);
  const cancelPortal = () => {
    portalRequestRef.current += 1;
    setPortalLoading(false);
    setError("");
  };

  const connectPortal = async () => {
    if (!portalPassword || portalLoading) return;
    const requestNo = ++portalRequestRef.current;
    const current = () => requestNo === portalRequestRef.current;
    setPortalLoading(true);
    setError("");
    const user = pendingUser || selectedUser;
    const username = (user.name || '').split(' ')[0].toLowerCase().trim();
    try {
      const res = await fetch(PORTAL_URL + '/api/companion/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password: portalPassword }),
      });
      const data = await res.json();
      if (!current()) return;
      if (data.ok && data.token) {
        try { localStorage.setItem('lumen_token', data.token); } catch(e) {}
        // Track C: a fresh sign-in un-parks every parked write and restarts
        // the photo and voice queues; the login below flushes the rest.
        afterFreshSignIn();
        // Merge portal user data into local user
        const enriched = {
          ...user,
          portalId: data.user.id,
          email: data.user.email || user.email,
          title: data.user.title || user.title,
        };
        finishLogin(enriched);
      } else {
        setError(data.error || 'Invalid credentials');
      }
    } catch(e) {
      if (!current()) return;
      setError('Could not reach the portal. Check your connection.');
    }
    if (current()) setPortalLoading(false);
  };

  const skipPortalAuth = () => {
    const user = pendingUser || selectedUser;
    finishLogin(user);
  };

  // ── Existing user PIN entry ──
  const checkPin = () => {
    setError("");
    if (hashPin(pin) === selectedUser.pinHash) {
      // No portal token yet: prompt for portal auth before proceeding, except
      // on a phone whose token the portal refused (pinUnlockNeedsPortal,
      // SECURITY-WAVE-1 track C): that surveyor may have no signal and must
      // still be able to work.
      if (pinUnlockNeedsPortal()) {
        setPendingUser(null);  // null signals existing user flow
        setPortalPassword("");
        setError("");
        setView("portalauth");
      } else {
        onLogin(selectedUser);
      }
    } else {
      setError("Incorrect PIN");
      setPin("");
    }
  };

  // ── Admin reset ──
  const checkAdminPin = () => {
    if (hashPin(adminPin) === ADMIN_PIN_HASH) {
      // S96 BRIEF A · forensic — log BEFORE the wipe so the entry exists
      // even if the removeItem below throws. This wipes ALL projects for the
      // target user, which is the most destructive single action in the app.
      try {
        const projectsKey = `asg_projects_${selectedUser.id}`;
        let projectCount = 0;
        try { projectCount = (JSON.parse(localStorage.getItem(projectsKey) || '[]') || []).length; } catch(e) {}
        logDestructiveAction('admin_pin_reset', {
          projectId: '',
          meta: { targetUserId: selectedUser.id, targetUserName: selectedUser.name, projectsWiped: projectCount },
        });
      } catch(e) {}
      // Wipe selected user's PIN and projects, return to new-user flow for that person
      const updated = knownUsers.map(u =>
        u.id === selectedUser.id ? { ...u, pinHash: null } : u
      );
      saveUsers(updated);
      try { localStorage.removeItem(`asg_projects_${selectedUser.id}`); } catch(e) {}
      const cleaned = { ...selectedUser, pinHash: null };
      setSelectedUser(cleaned);
      setAdminPin("");
      setError("");
      setNewPin("");
      setView("setpin");
    } else {
      setError("Incorrect admin PIN");
      setAdminPin("");
    }
  };

  // ── SIGNIN-V1: every view in the one shell (AuthScreen above), the same
  // fields, buttons and handlers as before, for every user whatever the theme.
  const ink = STUDIO_TOKENS.ink; const muted = STUDIO_TOKENS.muted;
  const initialsOf = (u) => (u && u.name ? u.name.split(" ").map(n => n[0]).join("").toUpperCase().slice(0, 2) : "?");

  // ── Pick user ──
  if (view === "pick") return (
    <AuthScreen error={error} subtitle="Who’s using this device?">
      <div style={{ width: "100%" }}>
        {knownUsers.map((user, i, arr) => {
          const divLabel = user.division === "aircon" ? "Mechanical" : "Lighting";
          return (
            <div key={user.id} style={{ display: "flex", alignItems: "center", gap: 4, borderBottom: i < arr.length - 1 ? `1px solid ${STUDIO_TOKENS.hairline}` : "none" }}>
              <div onClick={() => { setSelectedUser(user); setPin(""); setError(""); setView("pin"); setConfirmDeleteUserId(null); }}
                style={{ display: "flex", alignItems: "center", gap: 12, flex: 1, minWidth: 0, minHeight: 60, padding: "8px 0", cursor: "pointer" }}>
                <div style={{ ...studioSurface.pressed(), width: 42, height: 42, borderRadius: 21, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  <span style={{ color: ink, fontWeight: 700, fontSize: 14, lineHeight: 1, display: "block" }}>{initialsOf(user)}</span>
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <p style={{ fontSize: 16, fontWeight: 700, color: ink, margin: 0 }}>{user.name}</p>
                  <p style={{ fontSize: 14, color: muted, margin: "2px 0 0" }}>{user.role ? `${user.role}, ${divLabel}` : divLabel}</p>
                </div>
                <Icon name="chevron" size={16} color={muted} />
              </div>
              {confirmDeleteUserId === user.id ? (
                <SigninLink onClick={e => { e.stopPropagation(); deleteUser(user.id); }} style={{ minWidth: 44, flexShrink: 0 }}>
                  Sure?
                </SigninLink>
              ) : (
                <button type="button" onClick={e => { e.stopPropagation(); setConfirmDeleteUserId(user.id); }} aria-label={`Remove ${user.name}`}
                  style={{ background: "none", border: "none", cursor: "pointer", minWidth: 44, minHeight: 44, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  <Icon name="trash" size={16} color={muted} />
                </button>
              )}
            </div>
          );
        })}
        <button type="button" onClick={() => { setView("new"); setName(""); setRole(""); setError(""); }}
          style={{ ...studioSurface.slip(), width: "100%", minHeight: 48, marginTop: 12, borderRadius: 12, color: ink, fontSize: 16, fontWeight: 600, cursor: "pointer", fontFamily: STUDIO_TOKENS.fonts.body, display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
          <Icon name="plus" size={16} color={ink} />
          Add new user
        </button>
      </div>
    </AuthScreen>
  );

  // ── New user: name, role, division ──
  if (view === "new") return (
    <AuthScreen error={error} title="Create profile" subtitle="Your details stay on this device." onBack={knownUsers.length > 0 ? () => setView("pick") : undefined}>
      <div style={{ width: "100%", display: "flex", flexDirection: "column", gap: 14 }}>
        <SigninField id="lsi-name" label="Your full name *" value={name} onChange={setName} placeholder="Full name" />
        <SigninField id="lsi-role" label="Your role" value={role} onChange={setRole} placeholder="e.g. Project Manager, Head of M&E" />
        <div role="group" aria-labelledby="lsi-division" style={{ display: "flex", flexDirection: "column", gap: 6 }}>
          <span id="lsi-division" className="lsi-label">Division *</span>
          <div style={{ display: "flex", gap: 10 }}>
            {[{ id: "lighting", label: "Lighting", icon: "bulb" }, { id: "aircon", label: "Mechanical", icon: "leaf" }].map(d => {
              const sel = division === d.id;
              return (
                <button key={d.id} type="button" onClick={() => setDivision(d.id)} aria-pressed={sel} style={{
                  ...(sel ? studioSurface.pressed() : studioSurface.slip()),
                  flex: 1, minHeight: 64, padding: "10px", borderRadius: 12, cursor: "pointer", fontFamily: STUDIO_TOKENS.fonts.body,
                  display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 6, color: ink, fontSize: 14, fontWeight: sel ? 700 : 500,
                }}>
                  <Icon name={d.icon} size={20} color={ink} />
                  {d.label}
                </button>
              );
            })}
          </div>
        </div>
        <SigninPrimary label="Next: set your PIN" onClick={goToSetPin} disabled={!name.trim() || !division} />
      </div>
    </AuthScreen>
  );

  // ── New user (or after an admin reset): set PIN ──
  if (view === "setpin") return (
    <AuthScreen error={error} title="Set your PIN" subtitle={`Choose a 4-digit PIN for ${name || selectedUser?.name}.`} onBack={() => setView(selectedUser ? "pick" : "new")}>
      <SigninNumpad value={newPin} onDigit={addDigit(setNewPin, newPin)} onDelete={delDigit(setNewPin, newPin)} onSubmit={goToConfirmPin} submitLabel="Next" />
    </AuthScreen>
  );

  // ── New user: confirm PIN ──
  if (view === "confirmpin") return (
    <AuthScreen error={error} title="Confirm PIN" subtitle="Enter your PIN again to confirm." onBack={() => { setView("setpin"); setNewPin(""); setConfirmPin(""); }}>
      <SigninNumpad value={confirmPin} onDigit={addDigit(setConfirmPin, confirmPin)} onDelete={delDigit(setConfirmPin, confirmPin)} onSubmit={createUser} submitLabel="Create profile" />
    </AuthScreen>
  );

  // ── Portal sign-in: the target's form (password, Show/Hide, Sign in), and
  // while the request runs the busy card ("Signing you in"). The app signs in
  // with the profile's first name, so there is no email field, and it has no
  // forgotten-password flow, so there is no such link (FINDINGS SIGNIN-V1).
  if (view === "portalauth") {
    const displayUser = pendingUser || selectedUser;
    const displayName = displayUser ? displayUser.name : '';
    if (portalLoading) return (
      <AuthScreen busy>
        <div className="lsi-busy" role="status" aria-live="polite">
          <SigninOrb />
          <h2 className="lsi-h2" style={{ fontFamily: STUDIO_TOKENS.fonts.display, fontWeight: 300, fontSize: 31 }}>Signing you in</h2>
          <p className="lsi-sub">Opening today’s list.</p>
          <SigninLink onClick={cancelPortal} className="lsi-centre">Back to sign in</SigninLink>
        </div>
      </AuthScreen>
    );
    return (
      <AuthScreen error={error} subtitle={`Enter your portal password to sync ${displayName}’s data.`}
        onBack={() => { cancelPortal(); setView(pendingUser ? "confirmpin" : "pin"); setPortalPassword(""); setShowPassword(false); }}>
        <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
          <div className="lsi-field">
            <div className="lsi-pw-row">
              <label htmlFor="lsi-password">Password</label>
              <SigninLink onClick={() => setShowPassword(p => !p)} className="lsi-show" aria-label={showPassword ? "Hide password" : "Show password"}>
                {showPassword ? "Hide" : "Show"}
              </SigninLink>
            </div>
            <input id="lsi-password" className="lsi-input" type={showPassword ? "text" : "password"} autoComplete="current-password"
              value={portalPassword} onChange={e => setPortalPassword(e.target.value)}
              onKeyDown={e => { if (e.key === 'Enter') connectPortal(); }}
              autoFocus />
          </div>
          <SigninPrimary label="Sign in" onClick={connectPortal} disabled={!portalPassword} />
        </div>
      </AuthScreen>
    );
  }

  // ── Existing user: enter PIN ──
  if (view === "pin" && selectedUser) return (
    <AuthScreen error={error} title={selectedUser.name} subtitle="Enter your PIN to continue." onBack={() => { setView("pick"); setPin(""); setError(""); }}>
      <SigninNumpad value={pin} onDigit={addDigit(setPin, pin)} onDelete={delDigit(setPin, pin)} onSubmit={checkPin} submitLabel="Continue" />
      <div style={{ textAlign: "center" }}>
        <SigninLink onClick={() => { setAdminPin(""); setError(""); setView("admin"); }}>Forgot PIN? Admin reset</SigninLink>
      </div>
    </AuthScreen>
  );

  // ── Admin reset ──
  if (view === "admin") return (
    <AuthScreen error={error} title="Admin reset" subtitle={`Enter the admin PIN to reset ${selectedUser?.name}’s access. This will clear their project history.`} onBack={() => { setView("pin"); setAdminPin(""); setError(""); }}>
      <SigninNumpad value={adminPin} onDigit={addDigit(setAdminPin, adminPin)} onDelete={delDigit(setAdminPin, adminPin)} onSubmit={checkAdminPin} submitLabel="Reset access" />
    </AuthScreen>
  );

  return null;
};

// ════════════════════════════════════════════════════
// ── OnboardingFlow ────────────────────────────────
// P0 tidy (21 October 2026): the first open has no signed-in profile on the
// phone, so the Studio switch is always off here (the switch is read from the
// cached profile); the sign-in that follows already draws in the lit look
// whatever the switch says. So this screen is lit-only by construction and
// takes its values straight from STUDIO_TOKENS, not through uvx. It used cream
// type (#F0EDE8) and pale blue-grey (#8A9BB5) written for a dark ground onto a
// sand one: 1.2:1 and 2.4:1. Now: ink and muted words on one paper card,
// 31px title, 17px body, a step count in words (no dots), the one violet main
// action and an ink underlined Skip. Content is unchanged apart from one dash
// in the second slide's body, which is a comma now.
const ONBOARDING_STEPS = [
  { icon: "lightning", title: "Turn site visits\ninto signed proposals", body: "Capture scope, run ROI, and send a branded proposal before you leave the building." },
  { icon: "clipboard", title: "Every job,\none place", body: "Pre-visit intel, live survey zones, photos, and notes, all linked to the project." },
  { icon: "trophy", title: "Built for\nASG engineers", body: "M&E and Lighting divisions. Works offline. Syncs to the portal automatically." },
];
const OnboardingFlow = ({ onDone }) => {
  const [step, setStep] = useState(0);
  const S = STUDIO_TOKENS;
  const steps = ONBOARDING_STEPS;
  const s = steps[step];
  const last = step === steps.length - 1;
  const svg = { width: 48, height: 48, viewBox: "0 0 24 24", fill: "none", stroke: S.ink, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true" };
  return (
    <div data-onboarding="" style={{ position: "fixed", inset: 0, overflowY: "auto", WebkitOverflowScrolling: "touch", overscrollBehavior: "contain", boxSizing: "border-box", display: "flex", flexDirection: "column", justifyContent: "center", padding: "calc(env(safe-area-inset-top, 0px) + 32px) 20px calc(env(safe-area-inset-bottom, 0px) + 32px)", background: S.ground.css, backgroundColor: S.ground.base, fontFamily: S.fonts.body, color: S.ink }}>
      <section aria-label={`Step ${step + 1} of ${steps.length}`} style={{ ...studioSurface.raised(), borderRadius: S.radius.card, padding: "28px 24px 26px", display: "flex", flexDirection: "column", alignItems: "flex-start", textAlign: "left" }}>
        {s.icon === "lightning" && <svg {...svg}><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>}
        {s.icon === "clipboard" && <svg {...svg}><rect x="9" y="2" width="6" height="4" rx="1"/><path d="M9 2H7a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2h-2"/><path d="M12 11h4M12 15h4M8 11h.01M8 15h.01"/></svg>}
        {s.icon === "trophy" && <svg {...svg}><path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"/><path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"/><path d="M4 22h16"/><path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"/><path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"/><path d="M18 2H6v7a6 6 0 0 0 12 0V2Z"/></svg>}
        <h1 style={{ ...studioType.title(), fontSize: 31, lineHeight: 1.12, margin: "20px 0 12px", whiteSpace: "pre-line" }}>{s.title}</h1>
        <p style={{ margin: 0, fontSize: 17, lineHeight: 1.5, color: S.muted }}>{s.body}</p>
      </section>
      <p style={{ margin: "18px 4px 14px", fontSize: 14, color: S.muted }}>{`${step + 1} of ${steps.length}`}</p>
      <button onClick={() => last ? onDone() : setStep(step + 1)} style={{ ...studioSurface.primary(), width: "100%", minHeight: 52, borderRadius: 14, fontFamily: "inherit", cursor: "pointer" }}>
        {last ? "Get started" : "Next"}
      </button>
      {!last && (
        <button onClick={onDone} style={{ ...studioType.action(), alignSelf: "center", minHeight: 44, marginTop: 8, padding: "0 16px", cursor: "pointer", fontFamily: "inherit" }}>Skip</button>
      )}
    </div>
  );
};

// ── ProjectTimeline ───────────────────────────────
const ProjectTimelineBody = ({ project, divColor }) => {
  const entries = project?.timeline || [];
  if (entries.length === 0) return null;
  const sorted = [...entries].reverse(); // newest first
  const icons = { created: "star", previsit: "clipboard", surveyed: "chart", proposed: "send", won: "check", lost: "close" };
  return (
    <div>
      <p style={{ fontSize: 11, fontWeight: 700, color: divColor, letterSpacing: 1, textTransform: "uppercase", marginBottom: 12 }}>Project Timeline</p>
      <div style={{ position: "relative" }}>
        <div style={{ position: "absolute", left: 9, top: 6, bottom: 6, width: 1, background: "rgba(255,255,255,0.06)" }} />
        {sorted.map((entry, i) => {
          const d = new Date(entry.ts);
          const dateStr = d.toLocaleDateString("en-GB", { day: "numeric", month: "short" });
          const timeStr = d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
          return (
            <div key={i} style={{ display: "flex", gap: 14, marginBottom: i < sorted.length - 1 ? 14 : 0, alignItems: "flex-start" }}>
              <div style={{ width: 19, height: 19, borderRadius: "50%", background: i === 0 ? divColor : "rgba(255,255,255,0.06)", border: i === 0 ? "none" : "1px solid rgba(255,255,255,0.1)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 10, flexShrink: 0, marginTop: 1, zIndex: 1, ...uvx(() => ({ background: i === 0 ? STUDIO_TOKENS.ink : STUDIO_TOKENS.pressed.fill, border: i === 0 ? "none" : `1px solid ${STUDIO_TOKENS.hairline}` })) }}>
                {t.theme === 'uv' ? null : (i === 0 ? "●" : "○")}
              </div>
              <div style={{ flex: 1 }}>
                <p style={{ fontSize: 13, fontWeight: i === 0 ? 600 : 400, color: i === 0 ? "#F0EDE8" : "#8A9BB5" }}>{entry.label}</p>
                <p style={{ fontSize: 11, color: "#3A4A60", marginTop: 2 }}>{dateStr}{studioSep()}{timeStr}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

// ════════════════════════════════════════════════════
// MAIN APP — PWA fullscreen build
// Prototype chrome (spec panel, screen nav, phone frame)
// has been stripped. App renders edge-to-edge on device.
// ════════════════════════════════════════════════════

// PERSISTENT HEADER
const PersistentHeader = ({ onVoice, divisionId, hideGlobalMic, onBellTap, briefingUnread, showNotifPanel, setShowNotifPanel, onReadBriefing, hideDate }) => {
  const isAircon = divisionId === "aircon";
  const gradient = isAircon ? "linear-gradient(135deg, #5B9BD5 0%, #1A5A78 100%)" : "linear-gradient(135deg, #C89030 0%, #1A5A78 100%)";

  // Triple-tap ASG logo → toggle director dev mode (existing).
  // S105 — five-tap also opens the photo-upload debug overlay so
  // Andrew can post-mortem a survey on-site without a Mac. To support
  // both gestures from the same tap stream, the 3-tap toggle is
  // deferred 350ms; if a 4th/5th tap arrives within the same 800ms
  // window the 5-tap action wins and the deferred toggle is cancelled.
  const tapTimesRef = useRef({ taps: [], timerId: null });
  const handleLogoTap = () => {
    const now = Date.now();
    const state = tapTimesRef.current;
    state.taps.push(now);
    state.taps = state.taps.filter(t => now - t < 800);
    const count = state.taps.length;
    if (count >= 5) {
      // 5-tap: open debug overlay regardless of dev mode flag.
      if (state.timerId) { clearTimeout(state.timerId); state.timerId = null; }
      tapTimesRef.current = { taps: [], timerId: null };
      window.dispatchEvent(new CustomEvent('lumenOpenDebugOverlay'));
      return;
    }
    if (count === 3) {
      if (state.timerId) clearTimeout(state.timerId);
      state.timerId = setTimeout(() => {
        // Confirm we landed on 3 taps before firing the toggle —
        // a 5-tap completion would have cleared this timer.
        const current = localStorage.getItem('lumenDevMode') === 'true';
        const next = !current;
        localStorage.setItem('lumenDevMode', next ? 'true' : 'false');
        const toast = document.createElement('div');
        toast.textContent = next ? 'Director view unlocked' : 'Director view off';
        Object.assign(toast.style, {
          position: 'fixed', top: '80px', left: '50%', transform: 'translateX(-50%)',
          background: next ? 'rgba(46,104,56,0.92)' : 'rgba(28,24,16,0.75)',
          color: '#fff', padding: '10px 22px', borderRadius: '20px', fontSize: '13px',
          fontWeight: '700', zIndex: '9999', opacity: '1', transition: 'opacity 0.3s',
        });
        document.body.appendChild(toast);
        setTimeout(() => { toast.style.opacity = '0'; setTimeout(() => toast.remove(), 300); }, 2000);
        window.dispatchEvent(new Event('lumenDevModeChanged'));
        tapTimesRef.current = { taps: [], timerId: null };
      }, 350);
    }
  };

  const now = new Date();
  const dayNames = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
  const monthNames = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  const dateStr = `${dayNames[now.getDay()]} ${now.getDate()} ${monthNames[now.getMonth()]}`;

  // Reads through the shared validator, so a poisoned or legacy-shaped entry
  // yields no preview rather than an empty string. Note this reader asked for
  // `cached.data.opening` on the ENVELOPE, so it never resolved even on a good
  // response -- the preview has been silently absent, not merely stale.
  const briefingPreview = (() => {
    const b = readCachedBriefing();
    // THIRD briefing surface. It read `b.opening` -- the retired key -- under a
    // different variable name, so neither the census nor the source-lock saw
    // it. Now goes through the same selection as the other two.
    const pb = briefingBeats(b);
    return pb.stand || (pb.move && pb.move.headline) || pb.meta.hookLine || null;
  })();

  // STUDIO-LIT-PHONE-V1 item 8a (F23): the header with the Studio switch on.
  // The prototype's phone has no header of its own; its chrome is the lit
  // ground, raised paper and Eva's orb (the dock's "Ask Eva, or hold to talk").
  // The live header keeps every job it does (the logo and its taps, the date,
  // the bell and its panel, the mic) in that chrome: the date in muted words,
  // the bell on raised paper with an ink stroke and the unread briefing as a
  // count in ink beside it (never a dot), the mic as Eva's orb (it records a
  // voice note, the orb's "hold to talk"), and the panel as raised paper.
  if (t.theme === 'uv') {
    const S = STUDIO_TOKENS;
    // P0 tidy: the bell counts what the panel holds. The day's briefing is the
    // one item the panel can show, so the count is 1 only while there IS a
    // briefing to read and it has not been read; with nothing in the panel the
    // bell shows nothing (it showed "1" over "Nothing new" on an empty account).
    const unread = !!briefingUnread && !!briefingPreview;
    return (
      <div style={{ flexShrink: 0, zIndex: 10, position: "relative" }}>
        <style>{STUDIO_ORB_KEYFRAMES}</style>
        <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "8px 16px 6px" }}>
          <img src="asg_logo_clean.png" alt="ASG" onClick={handleLogoTap} style={{ width: 44, height: 44, borderRadius: 12, objectFit: "cover", flexShrink: 0, cursor: "pointer", boxShadow: S.shadow.slip }} />
          {/* P0 tidy: Today draws the date itself as its one big number, so on
              Today the header holds the space and says no date (it said it twice). */}
          {hideDate
            ? <div data-header-date="hidden" style={{ flex: 1, minWidth: 0 }} />
            : <div data-header-date="shown" style={{ flex: 1, minWidth: 0, fontFamily: S.fonts.body, fontSize: 13, color: S.muted, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{dateStr}</div>}
          <button onClick={onBellTap} aria-label={unread ? "Notifications, one unread" : "Notifications"} style={{ minWidth: 44, height: 44, padding: unread ? "0 12px 0 10px" : 0, borderRadius: 22, border: "none", background: S.paper.css, boxShadow: S.shadow.slip, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: 4, flexShrink: 0, color: S.ink, fontFamily: S.fonts.body }}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>
            {unread && <span style={{ fontSize: 14, fontWeight: 700, fontVariantNumeric: "tabular-nums" }}>1</span>}
          </button>
          {!hideGlobalMic && (
            <button onClick={onVoice} aria-label="Record a voice note" style={{ width: 54, height: 54, padding: 0, border: "none", background: "none", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
              <StudioOrb size={54} />
            </button>
          )}
        </div>
        {showNotifPanel && (
          // Through SheetPortal, so fixed where it was absolute: the header
          // starts at the top left of the fixed app shell, so the same offsets
          // put it in the same place.
          <SheetPortal>
            <div onClick={() => setShowNotifPanel(false)} style={{ position: "fixed", inset: 0, zIndex: 998 }} />
            <div role="dialog" aria-label="Notifications" style={{ position: "fixed", top: 64, right: 12, width: 300, maxWidth: "calc(100vw - 24px)", zIndex: 999, background: S.paper.css, boxShadow: S.shadow.raised, borderRadius: S.radius.card, overflow: "hidden", fontFamily: S.fonts.body }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 8px 4px 16px" }}>
                <span style={{ fontFamily: S.fonts.display, fontWeight: 400, fontSize: 20, color: S.ink }}>Notifications</span>
                <button onClick={() => setShowNotifPanel(false)} aria-label="Close" style={{ width: 44, height: 44, border: "none", borderRadius: 12, background: S.pressed.fill, cursor: "pointer", color: S.ink, display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>
                </button>
              </div>
              {briefingPreview ? (
                <div style={{ padding: "10px 16px 14px", borderTop: `1px solid ${S.hairline}` }}>
                  <div style={{ fontSize: 16, fontWeight: 700, color: S.ink, marginBottom: 4 }}>Today's briefing</div>
                  <div style={{ fontSize: 14, color: S.muted, lineHeight: 1.42, overflow: "hidden", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical" }}>{briefingPreview}</div>
                  <button onClick={onReadBriefing} style={{ ...studioType.action(), minHeight: 44, cursor: "pointer", fontFamily: "inherit" }}>Read it</button>
                </div>
              ) : (
                <div style={{ padding: "12px 16px 16px", borderTop: `1px solid ${S.hairline}`, fontSize: 14, color: S.muted }}>Nothing new.</div>
              )}
            </div>
          </SheetPortal>
        )}
      </div>
    );
  }

  return (
    <div style={{ flexShrink: 0, zIndex: 10, position: "relative" }}>
      <div style={{ display: "flex", alignItems: "center", padding: "10px 18px 8px" }}>
        <img src="asg_logo_clean.png" alt="ASG" onClick={handleLogoTap} style={{ width: 52, height: 52, borderRadius: 14, objectFit: "cover", flexShrink: 0, cursor: "pointer" }} />
        <div style={{ flex: 1, textAlign: "center" }}>
          <div style={{ fontSize: 12, fontWeight: 600, color: "rgba(26,22,8,0.45)" }}>{dateStr}</div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          {/* Notification bell — B3: 32×32, gap 10 */}
          <button onClick={onBellTap} style={{ width: 32, height: 32, borderRadius: "50%", background: "rgba(255,252,242,0.70)", border: "0.5px solid rgba(42,58,26,0.12)", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", position: "relative", flexShrink: 0 }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#5A4A2A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/>
            </svg>
            {briefingUnread && <div style={{ position: "absolute", top: 2, right: 2, width: 8, height: 8, borderRadius: "50%", background: "#C85040", border: "1.5px solid #E8DCC8" }} />}
          </button>
          {/* Voice button */}
          {!hideGlobalMic && (
            <button onClick={onVoice} style={{ width: 52, height: 52, borderRadius: "50%", background: gradient, border: "none", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", animation: "micpulse 3s ease-in-out infinite", flexShrink: 0 }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none"><rect x="9" y="2" width="6" height="11" rx="3" stroke="#fff" strokeWidth="2"/><path d="M5 10a7 7 0 0014 0M12 19v3M8 22h8" stroke="#fff" strokeWidth="2" strokeLinecap="round"/></svg>
            </button>
          )}
        </div>
      </div>

      {/* B4 — Notification panel */}
      {showNotifPanel && (
        <SheetPortal>
          <div onClick={() => setShowNotifPanel(false)} style={{ position: "fixed", inset: 0, zIndex: 998 }} />
          <div style={{ position: "fixed", top: 70, right: 12, width: 280, zIndex: 999, background: "rgba(255,252,242,0.97)", border: "0.5px solid rgba(42,58,26,0.15)", borderTop: "1px solid rgba(255,255,250,0.96)", borderRadius: 16, boxShadow: "0 8px 32px rgba(26,22,8,0.14)", overflow: "hidden" }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 14px 10px" }}>
              <span style={{ fontFamily: "Georgia, serif", fontStyle: "italic", fontSize: 15, color: "#1A1608", fontWeight: 700 }}>Notifications</span>
              <button onClick={() => setShowNotifPanel(false)} style={{ background: "none", border: "none", cursor: "pointer", padding: 4, color: "#8A7A5A", fontSize: 16, lineHeight: 1 }}>✕</button>
            </div>
            <div style={{ borderTop: "0.5px solid rgba(42,58,26,0.08)" }}>
              {briefingPreview ? (
                <div style={{ padding: "10px 14px 12px", background: "linear-gradient(135deg, rgba(26,22,8,0.06) 0%, rgba(200,144,48,0.06) 100%)", display: "flex", alignItems: "flex-start", gap: 10 }}>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 12, fontWeight: 700, color: "#1A1608", marginBottom: 3 }}>Today's Briefing</div>
                    <div style={{ fontSize: 11, color: "#5A4A2A", lineHeight: 1.4, overflow: "hidden", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical" }}>{briefingPreview}</div>
                  </div>
                  <button onClick={onReadBriefing} style={{ background: "none", border: "none", cursor: "pointer", padding: 0, flexShrink: 0 }}>
                    <span style={{ fontSize: 12, fontWeight: 700, color: "#C89030" }}>Read →</span>
                  </button>
                </div>
              ) : (
                <div style={{ padding: "16px 14px", textAlign: "center", fontSize: 12, color: "#8A7A5A" }}>No new notifications</div>
              )}
            </div>
          </div>
        </SheetPortal>
      )}
    </div>
  );
};

// VOICE MODAL — centre-screen
// B.2 Slice 3 — re-sourced: the attach list is portal projects from the
// lumen_projects cache (shared readProjectFeedCache accessor — the same read,
// staleness line and binding-object semantics as ProjectPickerSheet). Local
// projects are never offered as attach targets (D3: local drafts are not
// binding identities). "General note" stays, and maps to project_id: null.
// onStartRecording now receives a BINDING object (bindingNone() /
// bindingFromFeedRow(p)), never a local project. The sheet itself can't mount
// here — it is a full-viewport bottom sheet at zIndex 300 under this modal's
// 900, and swapping the modal for it would lose the General-note framing —
// so the modal renders its own rows from the shared accessors instead.
const VoiceModalBody = ({ onClose, onStartRecording }) => {
  const [{ rows: feedRows, syncedAt: feedSyncedAt, ageMin: feedAgeMin }] = useState(() => readProjectFeedCache());
  const handleGeneral = () => { if (onStartRecording) onStartRecording(bindingNone()); onClose(); };
  const handleProj = (p) => { if (onStartRecording) onStartRecording(bindingFromFeedRow(p)); onClose(); };
  return (
    <SheetPortal>
    <div onClick={onClose} style={{ position: "fixed", inset: 0, zIndex: 900, background: "rgba(26,22,8,0.45)", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
      <div onClick={e => e.stopPropagation()} style={{ background: "#FAF7F0", borderRadius: 20, padding: "20px 18px 16px", width: "100%", maxWidth: 400, maxHeight: "85vh", display: "flex", flexDirection: "column", overflowY: "auto", WebkitOverflowScrolling: "touch" }}>
        <div style={{ marginBottom: 16 }}>
          <p style={{ fontSize: 13, fontWeight: 700, color: "#1A1608", marginBottom: 3 }}>Start recording</p>
          {/* STUDIO-LIT-PHONE-V1 item 8a: "signals" is on the banned list, and
              nothing on the phone extracts actions from a note. */}
          <p style={{ fontSize: 11, color: "rgba(28,24,16,0.52)" }}>{t.theme === 'uv' ? "Pick the job it's about, or keep it general." : 'AI extracts client, actions and budget signals'}</p>
        </div>
        <div onClick={handleGeneral} style={{ display: "flex", alignItems: "center", gap: 12, background: "linear-gradient(135deg, rgba(200,144,48,0.10), rgba(26,90,120,0.08))", border: "1.5px solid rgba(200,144,48,0.30)", borderRadius: 14, padding: "13px 16px", cursor: "pointer", marginBottom: 16 }}>
          <div style={{ width: 30, height: 30, borderRadius: "50%", background: "linear-gradient(135deg, #C89030, #1A5A78)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><rect x="9" y="2" width="6" height="11" rx="3" stroke={t.theme === 'uv' ? STUDIO_TOKENS.ink : "#fff"} strokeWidth="2"/><path d="M5 10a7 7 0 0014 0M12 19v3M8 22h8" stroke={t.theme === 'uv' ? STUDIO_TOKENS.ink : "#fff"} strokeWidth="2" strokeLinecap="round"/></svg>
          </div>
          <div style={{ flex: 1 }}>
            <p style={{ fontSize: 13, fontWeight: 700, color: "#1A1608" }}>General note</p>
            <p style={{ fontSize: 11, color: "rgba(28,24,16,0.42)" }}>Not attached to project</p>
          </div>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M9 6l6 6-6 6" stroke="rgba(28,24,16,0.35)" strokeWidth="2" strokeLinecap="round"/></svg>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 4 }}>
          <div style={{ flex: 1, height: 1, background: "rgba(28,24,16,0.10)" }} />
          <span style={{ fontSize: 10, fontWeight: 700, letterSpacing: "0.18em", textTransform: "uppercase", color: "rgba(28,24,16,0.38)" }}>Or attach to a portal project</span>
          <div style={{ flex: 1, height: 1, background: "rgba(28,24,16,0.10)" }} />
        </div>
        <div style={{ marginBottom: 12 }}>
          <ProjectFeedStaleness syncedAt={feedSyncedAt} ageMin={feedAgeMin} />
        </div>
        {feedRows.length === 0 && (
          <p style={{ fontSize: 12, color: "rgba(26,22,8,0.5)", lineHeight: 1.5, marginBottom: 8 }}>No portal projects in the synced list yet.</p>
        )}
        {feedRows.map(p => (
          <div key={p.id} onClick={() => handleProj(p)} style={{ display: "flex", alignItems: "center", gap: 10, background: "rgba(255,252,242,0.88)", border: "1px solid rgba(255,252,240,0.85)", borderTop: "1px solid rgba(255,255,250,0.96)", borderRadius: 14, padding: "11px 16px", marginBottom: 8, cursor: "pointer" }}>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 10, fontWeight: 700, color: "#2E6838", fontFamily: "JetBrains Mono, monospace", letterSpacing: 0.4, marginBottom: 2 }}>{p.id}</div>
              <div style={{ fontSize: 13, fontWeight: 600, color: "#1A1608", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{p.name}</div>
              {p.client_name ? <div style={{ fontSize: 11, color: "rgba(26,22,8,0.45)", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{p.client_name}</div> : null}
            </div>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0 }}><path d="M9 6l6 6-6 6" stroke="rgba(28,24,16,0.35)" strokeWidth="2" strokeLinecap="round"/></svg>
          </div>
        ))}
        <p onClick={onClose} style={{ fontSize: 12, textAlign: "center", color: "rgba(28,24,16,0.45)", marginTop: 12, cursor: "pointer", padding: "8px 0" }}>Cancel</p>
      </div>
    </div>
    </SheetPortal>
  );
};
const VoiceModal = (props) => studioCapture(VoiceModalBody(props));


// ════════════════════════════════════════════════════
// COMPANY SCREEN — Business Momentum Intelligence (Screen 19)
// Sub-screens: 0=Pulse, 1=Performance, 2=Team (director only)
// ════════════════════════════════════════════════════

// STUDIO-LIT-PHONE-V1 item 4 (Andrew's decision 3, 6 October 2026): the
// device-calculated business score is gone, in both looks. Its engine
// (calculateDimensionScore, calculateMomentumScore and the director weights
// read from lumen_score_weights), the Pulse hero with its score, dimension
// bars, "Move the score today" and current streak, and the Breakdown and
// weights views were here. TRUTH-V1 DEFINITIONS K3 and K5 retire it. Whether
// the phone shows the portal's own score (K1) instead is DEC-4, open, so the
// business score section is left out.

// STUDIO-LIT-PHONE-V1 item 4: Company with the Studio switch on, built to the
// lit v5 prototype (docs/studio-lit/target/screens/app.js `company`) from the
// portal's whole-team read, GET /api/companion/company, synced by
// syncPortalData as lumen_company. Every figure is the portal's (D4, D5, D3,
// the pace, D16 over the year's won jobs, the team rows); nothing is summed
// here. When the read is not on the phone (403 for someone who may not see
// sales figures, which also clears any old copy, or not synced yet), the
// screen says so once and shows only what the person's own feeds send.
const companyLitView = ({ onNav, currentUser, touch }) => {
  const S = STUDIO_TOKENS;
  const M = STUDIO_MEANING;
  const co = truthBody('lumen_company');
  const wonFy = co ? truthNumber(co.won_fy) : null;
  const whole = co != null && wonFy != null;
  const money = { color: M.ochre, fontWeight: 700, fontVariantNumeric: 'tabular-nums' };
  const sec = { fontFamily: S.fonts.body, fontSize: 16, fontWeight: 700, color: S.ink, margin: '0 0 8px' };
  const small = { fontSize: 13, color: S.muted, margin: '6px 0 0', lineHeight: 1.4 };
  const jobs = (n) => (n === 1 ? '1 job' : `${n} jobs`);

  // The year so far: the whole team's, or the person's own when that is all
  // the phone holds (D4 and D5 mine from /api/companion/pipeline, their own
  // annual target from /api/companion/targets). No pace for one person: the
  // phone holds no financial-year progress for them, and it is not worked out
  // here.
  const own = whole ? null : (() => {
    const pp = truthBody('lumen_pipeline');
    const tg = truthBody('lumen_targets');
    const won = pp ? truthNumber(pp.won_fy) : null;
    if (won == null) return null;
    const tgt = tg ? truthNumber(tg.annual_target) : null;
    return { won, count: truthNumber(pp.won_fy_count), target: tgt && tgt > 0 ? tgt : null };
  })();
  const year = whole
    ? { won: wonFy, count: truthNumber(co.won_fy_count), target: (truthNumber(co.annual_target_total) || 0) > 0 ? co.annual_target_total : null, pace: truthNumber(co.pace_value) }
    : own ? { won: own.won, count: own.count, target: own.target, pace: null } : null;

  // Eva's read: a fixed sentence from the portal's figures (DEC-5, the
  // wording, is open): the year against the pace, and where it ends if the
  // likely quotes win (year_end_estimate, D4 plus D3).
  let eva = null;
  if (whole) {
    const yearEnd = truthNumber(co.year_end_estimate);
    const pace = year.pace;
    const lead = pace == null ? '' : wonFy < pace ? 'The year is behind pace. ' : wonFy > pace ? 'The year is ahead of pace. ' : 'The year is level with pace. ';
    if (lead || yearEnd != null) {
      const at = (() => {
        const raw = localStorage.getItem('lumen_company_synced_at');
        const d = raw ? new Date(raw) : null;
        if (!d || isNaN(d.getTime())) return '';
        return d.toDateString() === new Date().toDateString()
          ? d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })
          : d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
      })();
      eva = (
        <section aria-label="Eva" style={{ position: 'relative', overflow: 'hidden', margin: '14px 16px 0', padding: '14px 14px 12px 16px', borderRadius: S.radius.card, background: S.jewel.fill, boxShadow: S.jewel.shadow, display: 'flex', flexDirection: 'column', gap: 6 }}>
          <span aria-hidden="true" style={{ position: 'absolute', right: -30, top: -34, width: 120, height: 120, borderRadius: '50%', background: `radial-gradient(circle, ${S.jewel.text}, ${studioRgba(S.ultraviolet, 0.45)} 30%, ${studioRgba(S.ultraviolet, 0)} 66%)`, opacity: 0.9, pointerEvents: 'none' }} />
          <p style={{ position: 'relative', margin: 0, paddingRight: 14, fontFamily: S.fonts.display, fontWeight: 300, fontSize: 20, lineHeight: 1.3, color: S.jewel.text }}>
            <span aria-hidden="true" style={{ display: 'inline-flex', verticalAlign: -2, marginRight: 8, color: S.jewel.ring }}>
              <svg width="17" height="17" viewBox="0 0 20 20"><circle cx="10" cy="10" r="9" fill="none" stroke="currentColor" strokeWidth="1.4" strokeDasharray="1.2 1.6" /><circle cx="10" cy="10" r="4.5" fill="currentColor" /></svg>
            </span>
            {lead}
            {yearEnd != null && <>Here's where {lead ? 'it' : 'the year'} ends if the likely quotes win.</>}
          </p>
          {at && <div style={{ position: 'relative', display: 'flex', justifyContent: 'flex-end' }}><span style={{ fontSize: 13, color: S.jewel.textSecondary }}>{at}</span></div>}
        </section>
      );
      // No money on the jewel (studio-lit.md, the same ruling as Pipeline):
      // the figure Eva cites sits just below it, in ochre, once.
      if (yearEnd != null) {
        eva = (
          <>
            {eva}
            <p aria-label="What Eva cites" style={{ margin: '8px 20px 0', fontSize: 14, lineHeight: 1.45, color: S.ink }}>
              About <span style={money}>{formatCurrency(yearEnd)}</span> by the end of the year if the likely quotes win.
            </p>
          </>
        );
      }
    }
  }

  // Margin over the same jobs (DECISIONS 176.140): shown, or not available
  // with the portal's reason; never left out.
  // COMPANION-TRUTH-V2 B5: with no whole-team read the year is the person's
  // own (won_fy mine), so its margin is D20 over the same won jobs, mine
  // (/api/companion/figures won_margin), in the same sentences.
  const marginLine = (() => {
    const m = whole ? truthObject(co.margin) : truthWonMargin();
    if (!m) return <p style={small}>Margin not available. The portal didn't send it.</p>;
    const pct = truthNumber(m.pct);
    if (m.withheld || pct == null) return <p style={small}>Margin not available. {m.withheld ? String(m.withheld) : 'The portal didn’t send it.'}</p>;
    const profit = truthNumber(m.profit);
    const left = truthNumber(m.unpriced_count) || 0;
    const leftValue = truthNumber(m.unpriced_value);
    return (
      <p style={small}>
        {profit != null ? <>That's <span style={money}>{formatCurrency(profit)}</span> profit at {pct}% estimated margin.</> : <>That's {pct}% estimated margin.</>}
        {left > 0 && <> {left === 1 ? '1 job' : `${left} jobs`}{leftValue != null && leftValue > 0 ? <> worth <span style={money}>{formatCurrency(leftValue)}</span></> : null} {left === 1 ? "isn't" : "aren't"} priced yet, so {left === 1 ? "it's" : "they're"} left out.</>}
      </p>
    );
  })();

  // Won this financial year: the one big number, the jobs, the target, and
  // the pace marker (pace_value), drawn as the prototype's .app-co.
  const wonCard = year && (() => {
    const max = year.target ? Math.max(year.target, year.won) : null;
    const pctOf = (v) => (max ? Math.min(100, Math.max(0, (v / max) * 100)).toFixed(1) + '%' : '0%');
    const against = year.target ? `, against ${whole ? 'a' : 'your'} ${formatCurrency(year.target)} target` : '';
    return (
      <section aria-label="Won this financial year" style={{ margin: '14px 16px 0', padding: 16, borderRadius: S.radius.card, ...studioSurface.lit() }}>
        <p style={{ margin: '6px 0 4px', fontSize: 13, fontWeight: 700, color: S.ink }}>Won this financial year</p>
        <span style={{ display: 'block', fontFamily: S.fonts.display, fontWeight: 300, fontSize: 39, lineHeight: 1.05, letterSpacing: '-0.04em', color: M.ochre, fontVariantNumeric: 'tabular-nums' }}>{formatCurrency(year.won)}</span>
        {(year.count != null || against) && <p style={{ margin: '2px 0 0', fontSize: 14, color: S.muted }}>{year.count != null ? `from ${jobs(year.count)}` : 'Won'}{against}</p>}
        {max && (
          <>
            <div role="img" aria-label={`${formatCurrency(year.won)} won of ${formatCurrency(year.target)}${year.pace != null ? `, pace today ${formatCurrency(year.pace)}` : ''}`} style={{ position: 'relative', height: 14, borderRadius: 5, background: 'rgba(100,116,139,0.18)', margin: '12px 0 6px' }}>
              <i style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: pctOf(year.won), borderRadius: 5, background: M.wonFill }} />
              {year.pace != null && <i style={{ position: 'absolute', top: -4, bottom: -4, left: pctOf(year.pace), width: 0, borderLeft: `2px dashed ${S.muted}` }} />}
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px 14px', fontSize: 13, color: S.muted }}>
              <span><i style={{ display: 'inline-block', width: 12, height: 9, borderRadius: 2, marginRight: 6, verticalAlign: -1, background: M.wonFill }} />Won</span>
              {year.pace != null && <span><i style={{ display: 'inline-block', width: 0, height: 12, marginRight: 6, verticalAlign: -1, borderLeft: `2px dashed ${S.muted}` }} />Where pace says you should be today</span>}
            </div>
          </>
        )}
        {marginLine}
      </section>
    );
  })();

  // Won each month: the whole team's won value for each month of the
  // financial year so far (won_by_month, D4 by win date), amber bars (won).
  const months = whole && Array.isArray(co.won_by_month)
    ? co.won_by_month.filter((m) => m && /^\d{4}-\d{2}$/.test(String(m.month)) && truthNumber(m.value) != null)
    : [];
  const nowKey = (() => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`; })();
  const monthOf = (k) => { const [y, mo] = k.split('-').map(Number); return new Date(y, mo - 1, 1); };
  // Three-letter month names, as the prototype draws them (en-GB's own short
  // form for September is "Sept").
  const SHORT_MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const monthMax = Math.max(1, ...months.map((m) => m.value));
  const current = months.find((m) => m.month === nowKey);
  const monthBars = months.length > 0 && (
    <section aria-label="Won each month" style={{ margin: '16px 16px 0' }}>
      <h2 style={sec}>Won each month</h2>
      <div style={{ display: 'grid', gridTemplateColumns: `repeat(${months.length}, minmax(0, 1fr))`, gap: 5, alignItems: 'end', height: 118 }}>
        {months.map((m) => {
          const d = monthOf(m.month);
          const n = truthNumber(m.count);
          return (
            <div key={m.month} role="img" aria-label={`${d.toLocaleString('en-GB', { month: 'long', year: 'numeric' })}: ${formatCurrency(m.value)} won${n != null ? ` from ${jobs(n)}` : ''}`} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4, height: '100%' }}>
              <div style={{ position: 'relative', flex: 1, width: '100%' }}>
                {m.value > 0 && <div style={{ position: 'absolute', bottom: 0, left: '15%', right: '15%', height: Math.max(4, (m.value / monthMax) * 100).toFixed(1) + '%', borderRadius: '4px 4px 2px 2px', background: M.wonFill }} />}
              </div>
              <span style={{ fontSize: 13, fontWeight: 600, color: m.month === nowKey ? M.wonText : S.muted }}>{SHORT_MONTHS[d.getMonth()]}</span>
            </div>
          );
        })}
      </div>
      {current && current.value === 0 && <p style={small}>{monthOf(current.month).toLocaleString('en-GB', { month: 'long' })} has nothing won yet.</p>}
    </section>
  );

  // The team this year: each person's won value, and won from quoted (D4,
  // D5 and D8 by owner). The portal sends the caller's own row unless they
  // are a director, so one row that is the caller's own is "You this year".
  const team = whole && Array.isArray(co.team)
    ? co.team.filter((r) => r && typeof r.name === 'string' && r.name.trim() && truthNumber(r.won_value) != null)
    : [];
  const me = String((currentUser && (currentUser.id || currentUser.name)) || '').trim().toLowerCase();
  const onlyMe = team.length === 1 && me && (String(team[0].user || '').toLowerCase() === me || team[0].name.trim().toLowerCase() === me);
  const firsts = team.map((r) => r.name.trim().split(/\s+/)[0]);
  const shown = team.map((r, i) => (firsts.filter((f) => f === firsts[i]).length > 1 ? r.name.trim() : firsts[i]));
  const nameW = Math.min(120, Math.max(58, Math.ceil(Math.max(0, ...shown.map((s) => s.length)) * 8.6)));
  const teamMax = Math.max(0, ...team.map((r) => r.won_value));
  const teamCard = team.length > 0 && (
    <section aria-label="The team" style={{ margin: '14px 16px 0', padding: '14px 16px', borderRadius: S.radius.card, ...studioSurface.raised() }}>
      <h2 style={sec}>{onlyMe ? 'You this year' : 'The team this year'}</h2>
      {team.map((r, i) => {
        const wc = truthNumber(r.won_count); const qc = truthNumber(r.quoted_count);
        return (
          <div key={(r.user || r.name) + i} style={{ display: 'grid', gridTemplateColumns: `${nameW}px minmax(0, 1fr) 58px`, gap: '4px 10px', alignItems: 'center', padding: '8px 0', borderTop: i === 0 ? 'none' : `1px solid ${studioRgba(S.ink, 0.07)}`, fontSize: 14 }}>
            <b style={{ color: S.ink }}>{shown[i]}</b>
            <span style={{ height: 10, borderRadius: 4, background: 'rgba(100,116,139,0.15)' }}>
              <i style={{ display: 'block', height: '100%', borderRadius: 4, background: M.wonFill, minWidth: 2, width: teamMax > 0 ? ((r.won_value / teamMax) * 100).toFixed(1) + '%' : '0%' }} />
            </span>
            <span style={{ ...money, textAlign: 'right' }}>{formatCurrency(r.won_value)}</span>
            {(wc != null || qc != null) && <span style={{ gridColumn: '2 / 4', fontSize: 13, color: S.muted }}>{wc != null ? wc : TRUTH_DASH} won from {qc != null ? qc : TRUTH_DASH} quoted</span>}
          </div>
        );
      })}
      <p style={small}>Margin by person isn't sent to the phone yet, so it's not available here.</p>
    </section>
  );

  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', background: 'transparent' }}>
      <div style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden', WebkitOverflowScrolling: 'touch', overscrollBehavior: 'contain', paddingBottom: 100 }}
        onTouchStart={touch.start} onTouchMove={touch.move} onTouchEnd={touch.end}>
        <div style={{ width: '100%', maxWidth: 960, margin: '0 auto' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, minHeight: 50, padding: '14px 16px 0' }}>
            <h1 style={{ ...studioType.title(), fontSize: 39, lineHeight: 1.02 }}>Company</h1>
            {whole && <span style={{ fontSize: 16, color: S.muted }}>Whole team</span>}
          </div>
          {!whole && <p style={{ margin: '10px 16px 0', fontSize: 16, lineHeight: 1.4, color: S.ink }}>The whole team's figures aren't on this phone yet.</p>}
          {eva}
          {wonCard}
          {monthBars}
          {teamCard}
        </div>
      </div>
      <TabBar active={19} onChange={onNav} divisionId={(currentUser && currentUser.division) || 'lighting'} />
    </div>
  );
};

const CompanyScreen = ({ onNav, currentUser, projects, proposals }) => {
  const [companyScreen, setCompanyScreen] = useState(0);
  const [swipeOffset, setSwipeOffset] = useState(0);
  const [swiping, setSwiping] = useState(false);
  const [companyIsSyncing, setCompanyIsSyncing] = useState(false);
  const touchRef = useRef(null);
  const divId = (currentUser && currentUser.division) || 'lighting';

  // COMPANION-TRUTH-V1: the portal's score shim is retired (K-retire) and is
  // neither synced nor read; the Pulse score shows its not-available state.
  const portalPipeline = getPortalData('lumen_pipeline', null);

  const isDevMode = localStorage.getItem('lumenDevMode') === 'true';
  const userType = (currentUser?.role === 'director' || currentUser?.role === 'owner' || isDevMode) ? 'director' : currentUser?.role === 'staff' ? 'staff' : 'solo';
  const maxScreens = userType === 'director' ? 3 : 2;

  // Swipe handlers — live finger tracking with translateX
  const handleTouchStart = (e) => {
    touchRef.current = { x: e.touches[0].clientX, y: e.touches[0].clientY, locked: null };
  };
  const handleTouchMove = (e) => {
    if (!touchRef.current) return;
    const dx = e.touches[0].clientX - touchRef.current.x;
    const dy = e.touches[0].clientY - touchRef.current.y;
    // Lock direction on first significant move
    if (touchRef.current.locked === null && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) {
      touchRef.current.locked = Math.abs(dx) > Math.abs(dy) ? 'h' : 'v';
    }
    if (touchRef.current.locked === 'h') {
      e.preventDefault();
      // Resist at edges
      const atEdge = (dx > 0 && companyScreen === 0) || (dx < 0 && companyScreen === maxScreens - 1);
      setSwipeOffset(atEdge ? dx * 0.25 : dx);
      setSwiping(true);
    }
  };
  const handleTouchEnd = (e) => {
    if (!touchRef.current) return;
    const dx = e.changedTouches[0].clientX - touchRef.current.x;
    const dy = e.changedTouches[0].clientY - touchRef.current.y;
    if (touchRef.current.locked === 'h' && Math.abs(dx) > 40) {
      if (dx < 0 && companyScreen < maxScreens - 1) { setCompanyScreen(companyScreen + 1); }
      else if (dx < 0 && companyScreen === maxScreens - 1 && Math.abs(dx) > 60) { onNav(18); } // swipe left at last sub → Pipeline
      else if (dx > 0 && companyScreen > 0) { setCompanyScreen(companyScreen - 1); }
      else if (dx > 0 && companyScreen === 0 && Math.abs(dx) > 60) { onNav(0); } // swipe right at first sub → Today
    }
    // Pull-to-refresh: vertical pull > 60px from top triggers sync
    if (touchRef.current.locked === 'v' && dy > 60) {
      setCompanyIsSyncing(true);
      syncPortalData().then(() => setCompanyIsSyncing(false));
    }
    setSwipeOffset(0);
    setSwiping(false);
    touchRef.current = null;
  };

  // STUDIO-LIT-PHONE-V1 item 4: with the Studio switch on, Company is the lit
  // v5 screen (companyLitView above), one column from the portal's whole-team
  // read. A sideways swipe still goes to Today or Pipeline; a pull down syncs.
  if (t.theme === 'uv') {
    const litTouch = {
      start: (e) => { touchRef.current = { x: e.touches[0].clientX, y: e.touches[0].clientY }; },
      move: () => {},
      end: (e) => {
        if (!touchRef.current) return;
        const dx = e.changedTouches[0].clientX - touchRef.current.x;
        const dy = e.changedTouches[0].clientY - touchRef.current.y;
        touchRef.current = null;
        if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy)) onNav(dx < 0 ? 18 : 0);
        else if (dy > 60 && Math.abs(dy) > Math.abs(dx)) syncPortalData();
      },
    };
    return companyLitView({ onNav, currentUser, touch: litTouch });
  }

  // Decision 3: the device-calculated business score (its dimension scores,
  // radar, weak-dimension text and "Move the score today" actions) is gone.
  const wonProjects = (proposals || []).filter(p => p.won);

  // Performance chart data — use snapshots for past months when live data is zero
  const monthlyData = Array.from({ length: 12 }, (_, i) => {
    const d = new Date();
    d.setMonth(d.getMonth() - (11 - i));
    const m = d.getMonth();
    const y = d.getFullYear();
    const monthWon = wonProjects.filter(p => { const pd = new Date(p.createdAt || p.uploadedAt || 0); return pd.getMonth() === m && pd.getFullYear() === y; });
    let value = monthWon.reduce((s, p) => s + (p.capex || p.value || 0), 0);
    // Fall back to snapshot for past months with no live data
    if (value === 0 && i < 11) {
      try {
        const snapKey = `lumen_monthly_snapshot_${y}_${String(m + 1).padStart(2, '0')}`;
        const snap = JSON.parse(localStorage.getItem(snapKey) || 'null');
        if (snap && snap.wonValue > 0) value = snap.wonValue;
      } catch(e) {}
    }
    return {
      month: d.toLocaleString('en-GB', { month: 'short' }),
      value,
      isCurrent: i === 11,
    };
  });
  const monthlyTarget = JSON.parse(readMyMonthlyTarget() || '0');
  const maxMonthVal = Math.max(...monthlyData.map(m => m.value), monthlyTarget, 1);

  // Linear regression for trend line
  const trendN = monthlyData.length;
  const trendSumX = monthlyData.reduce((s, _, i) => s + i, 0);
  const trendSumY = monthlyData.reduce((s, m) => s + m.value, 0);
  const trendSumXY = monthlyData.reduce((s, m, i) => s + i * m.value, 0);
  const trendSumX2 = monthlyData.reduce((s, _, i) => s + i * i, 0);
  const trendSlope = (trendN * trendSumXY - trendSumX * trendSumY) / Math.max(1, trendN * trendSumX2 - trendSumX * trendSumX);
  const trendIntercept = (trendSumY - trendSlope * trendSumX) / trendN;
  const trendY0 = 128 - ((trendIntercept) / Math.max(1, maxMonthVal)) * 110;
  const trendY11 = 128 - ((trendSlope * 11 + trendIntercept) / Math.max(1, maxMonthVal)) * 110;

  // Win rate data (6 months)
  const winRateData = Array.from({ length: 6 }, (_, i) => {
    const d = new Date();
    d.setMonth(d.getMonth() - (5 - i));
    const m = d.getMonth();
    const y = d.getFullYear();
    const monthProps = (proposals || []).filter(p => { const pd = new Date(p.createdAt || p.uploadedAt || 0); return pd.getMonth() === m && pd.getFullYear() === y; });
    const monthWon = monthProps.filter(p => p.won);
    return {
      month: d.toLocaleString('en-GB', { month: 'short' }),
      rate: monthProps.length > 0 ? Math.round((monthWon.length / monthProps.length) * 100) : 0,
      isCurrent: i === 5,
    };
  });

  // Margin variance data — empty until Xero integration (Sprint 3+)
  const varianceData = JSON.parse(localStorage.getItem('lumen_margin_variance') || '[]');
  const worstVariance = varianceData.length > 0 ? varianceData.reduce((w, v) => v.variance < w.variance ? v : w, varianceData[0]) : null;

  // Team data (director only) — loaded from localStorage, Ella excluded (sales_visible: false)
  const teamMembersRaw = userType === 'director' ? JSON.parse(localStorage.getItem('lumen_team_members') || '[]') : [];
  const teamMembers = teamMembersRaw.filter(m => m.sales_visible !== false);
  const teamScore = teamMembers.length > 0 ? Math.round(teamMembers.reduce((s, m) => s + (m.active ? 68 : 30), 0) / teamMembers.length) : 0;
  const sortedTeam = [...teamMembers].sort((a, b) => b.pipeline - a.pipeline);
  const fmt = v => v >= 1000 ? '\u00A3' + Math.round(v / 1000) + 'k' : '\u00A3' + Math.round(v);

  // Nav dots
  // Under the theme each dot is a 44px target with a short line drawn in it:
  // ink for the pane you are on, the hairline for the others.
  const NavDots = () => studioDesk(
    <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
      {Array.from({ length: maxScreens }, (_, i) => (
        <button key={i} onClick={() => { setCompanyScreen(i); }} style={{
          width: companyScreen === i ? 16 : 6, height: 6, borderRadius: 3,
          background: companyScreen === i ? '#1A3A5A' : 'rgba(28,24,16,0.18)',
          border: 'none', cursor: 'pointer', padding: 0, transition: 'all .2s',
          ...uvx({ width: 32, height: 44, background: 'transparent', display: 'flex', alignItems: 'center', justifyContent: 'center' }),
        }}>{t.theme === 'uv' ? <span style={{ display: 'block', width: companyScreen === i ? 16 : 8, height: 3, borderRadius: 1, background: companyScreen === i ? STUDIO_TOKENS.ink : STUDIO_TOKENS.hairline }} /> : null}</button>
      ))}
    </div>
  );

  // ── PULSE (companyScreen === 0) ──
  // STUDIO-LIT-PHONE-V1 item 4 (decision 3): the Pulse hero (the business
  // score, its dimension bars, "Move the score today" and the current
  // streak) is gone in both looks; Year at a Glance and the intelligence
  // cards stay.
  const renderPulse = () => {
    // ── Year at a Glance data ──
    // FY runs March (month 1) → February. Ella Boothroyd (sales_visible:false)
    // is excluded at project level where applicable. Metrics show "—" when
    // data is absent rather than fabricating zeros for an empty app.
    // COMPANION-TRUTH-V2 B5: every tile reads a kernel figure for this
    // financial year, mine, or shows the dash; nothing here is worked out from
    // the phone's own proposals any more. Proposals Built is D8
    // (quotes_built_fy); Total Quoted is D22, the latest quote of every job
    // whose first quote was built this year, summed (quoted_fy.value, exactly
    // the jobs Proposals Built counts), and its GP sub is D23, the blended
    // estimated margin over the same jobs (quoted_fy.margin.pct), "GP" and the
    // dash while withheld or missing (DECISIONS 176.158, D22, D23); Quote Conversion is D7 over the year
    // (win_rate_fy, 176.135) over won and lost this year (won_fy_count,
    // lost_fy_count); Active Clients has no served figure (the dash); Avg
    // Deal Size is D14 (avg_won) with D18 (days_to_win) as its cycle.
    const builtFy = truthQuotesBuiltFy();
    const quotedFy = truthQuotedFyValue();
    const quotedFyGp = truthQuotedFyMarginPct();
    const conversion = truthWinRateFy();
    const wonFyN = truthPipelineFigure('won_fy_count');
    const lostFyN = truthPipelineFigure('lost_fy_count');
    const avgDealSize = truthPipelineFigure('avg_won', 'avg_won_withheld');
    const avgCycleDays = truthPipelineFigure('days_to_win', 'days_to_win_withheld');
    const fmtGold = (v) => {
      if (v == null) return '\u2014';
      if (v >= 1_000_000) return `\u00A3${(v/1_000_000).toFixed(1)}m`;
      if (v >= 1_000) return `\u00A3${(v/1_000).toFixed(0)}k`;
      return `\u00A3${Math.round(v)}`;
    };
    const yearGlanceTiles = [
      { label: 'Proposals Built', value: builtFy != null ? builtFy : TRUTH_DASH, sub: 'FY to date', tone: 'plain' },
      { label: 'Total Quoted',    value: quotedFy != null ? fmtGold(quotedFy) : TRUTH_DASH, sub: quotedFyGp != null ? `GP ${quotedFyGp}%` : (t.theme === 'uv' ? 'GP' : 'GP \u2014'), tone: 'gold' },
      { label: 'Quote Conversion',value: conversion != null ? `${conversion}%` : TRUTH_DASH, sub: wonFyN != null && lostFyN != null ? `${wonFyN}/${wonFyN + lostFyN}` : 'awaiting wins', tone: 'plain' },
      { label: 'Active Clients',  value: TRUTH_DASH, sub: t.theme === 'uv' ? '0 this Q' : 'this Q \u2014', tone: 'plain' },
      { label: 'Avg Deal Size',   value: avgDealSize != null ? fmtGold(avgDealSize) : TRUTH_DASH, sub: avgCycleDays != null ? `${avgCycleDays}d cycle` : (t.theme === 'uv' ? 'cycle' : 'cycle \u2014'), tone: 'gold' },
    ];

    return (
    <>
      {/* ── Year at a Glance — horizontal stats strip ── */}
      <div style={{ margin: '4px 14px 10px', padding: '11px 12px 12px', background: 'rgba(255,252,242,0.88)', border: '1px solid rgba(221,208,184,0.35)', borderRadius: 14 }}>
        <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', marginBottom: 9 }}>
          <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.09em', textTransform: 'uppercase', color: 'rgba(28,24,16,0.5)' }}>Year at a Glance</span>
          <span style={{ fontSize: 11, color: 'rgba(28,24,16,0.38)' }}>FY to date</span>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: 6 }}>
          {yearGlanceTiles.map((t2, i) => (
            <div key={i} style={{ minWidth: 0, textAlign: 'center' }}>
              <div style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic', fontSize: 16, color: t2.tone === 'gold' ? '#C89030' : '#1A1608', lineHeight: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{t2.value}</div>
              <div style={{ fontSize: 11, fontWeight: 700, color: '#1A1608', marginTop: 4, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{t2.label}</div>
              <div style={{ fontSize: 11, color: 'rgba(28,24,16,0.4)', marginTop: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{t2.sub}</div>
            </div>
          ))}
        </div>
      </div>

      {/* ── Intelligence placeholder below Pulse hero ── last visible element before tab bar */}
      <div style={{ marginTop: 12, marginLeft: 14, marginRight: 14, marginBottom: 0 }}>
        {(() => {
          const intelligenceData = getPortalData('lumen_intelligence', { cards: [] });
          const intelCards = (intelligenceData.cards || []).slice(0, 3);
          if (intelCards.length > 0) {
            return intelCards.map((card, i) => {
              const accent = { pipeline: '#1A5A78', commercial: '#C89030', financial: '#2E6838', operational: '#7A4856' }[card.insight_type] || '#1A5A78';
              return (
                <div key={i} style={{ background: t.colors.glass, border: `1px solid ${t.colors.glassBorder}`, borderTop: `1px solid ${t.colors.glassBorderTop}`, borderRadius: 14, padding: '12px 14px', marginBottom: 8 }}>
                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10 }}>
                    <div style={{ width: 8, height: 8, borderRadius: 4, background: accent, flexShrink: 0, marginTop: 5 }} />
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: 13, fontWeight: 600, color: t.colors.text, marginBottom: 3 }}>{card.title}</div>
                      <div style={{ fontSize: 12, color: t.colors.textSecondary, lineHeight: 1.4 }}>{card.body}</div>
                    </div>
                  </div>
                </div>
              );
            });
          }
          return (
            <div style={{ background: t.colors.glass, border: `1px solid ${t.colors.glassBorder}`, borderTop: `1px solid ${t.colors.glassBorderTop}`, borderRadius: 14, padding: '14px', textAlign: 'center', marginBottom: 0 }}>
              <div style={{ fontSize: 12, color: t.colors.textTertiary, fontStyle: 'italic', lineHeight: 1.4 }}>More intelligence builds as you use the app.</div>
            </div>
          );
        })()}
      </div>
    </>
  ); };

  // ── PERFORMANCE (companyScreen === 1) ──
  const renderPerformance = () => {
    // ── Performance hero data wiring ──
    const now = new Date();
    const currentMonthName = now.toLocaleString('en-GB', { month: 'long', year: 'numeric' });
    const monthStartTs = new Date(now.getFullYear(), now.getMonth(), 1).getTime();
    const lastMonthStartTs = new Date(now.getFullYear(), now.getMonth() - 1, 1).getTime();
    const day90 = Date.now() - 90 * 86400000;

    // Division-filtered portal quotes (same source as Pipeline screen)
    const perfDiv = getDivisionConfig(currentUser);
    const ppQuotesRaw = (portalPipeline && (portalPipeline.all_quotes || portalPipeline.quotes)) || [];
    const ppQuotes = ppQuotesRaw.filter(q => {
      const rawDiv = (q.division || q.category || q.dept || '').toLowerCase().trim();
      const normDiv = (rawDiv === 'me' || rawDiv === 'ac' || rawDiv === 'air_conditioning' || rawDiv === 'air conditioning' || rawDiv === 'aircon') ? 'me' : (rawDiv || 'lighting');
      return normDiv === perfDiv.id || !rawDiv;
    });
    // COMPANION-TRUTH-V2 B5: "Won this month" is the kernel's D4 mine over
    // this month (/api/companion/pipeline won_this_month), never the phone's
    // own sum of the division's quotes; "Still to go" is the target less that
    // same figure (one source, skill section 5). The win rate is D7 over the
    // financial year (DECISIONS 176.135, win_rate_fy) and its label says so.
    const wonThisMonthVal = truthPipelineFigure('won_this_month');
    // COMPANION-TRUTH-V1 (b): quotes chasing is the portal's D10 count, mine;
    // null (the dash) when the figures were never fetched.
    const quotesChasing = truthWaitingCount();
    const ppWinRate = truthWinRateFy();

    // Last month won value
    const lastMonthQuotes = ppQuotes.filter(q => {
      const ts = new Date(q.won ? (q.won_at || q.timestamp || q.created_at || q.createdAt || 0) : (q.created_at || q.createdAt || 0)).getTime();
      return ts >= lastMonthStartTs && ts < monthStartTs && q.won;
    });
    const lastMonthWon = lastMonthQuotes.reduce((s, q) => s + (q.total || q.value || 0), 0);

    // Still to go
    const stillToGo = wonThisMonthVal == null ? null : Math.max(0, monthlyTarget - wonThisMonthVal);

    // The rolling 90-day turnover tile is retired (DECISIONS 176.138), in both looks.

    // Monthly bars (7 months: 6 past + current)
    const monthBars = Array.from({ length: 7 }, (_, i) => {
      const d = new Date();
      d.setMonth(d.getMonth() - (6 - i));
      const m = d.getMonth();
      const y = d.getFullYear();
      const monthWon = ppQuotes.filter(q => {
        const pd = new Date(q.won ? (q.won_at || q.timestamp || q.created_at || q.createdAt || 0) : (q.created_at || q.createdAt || 0));
        return pd.getMonth() === m && pd.getFullYear() === y && q.won;
      });
      return {
        month: d.toLocaleString('en-GB', { month: 'short' }),
        value: monthWon.reduce((s, q) => s + (q.total || q.value || 0), 0),
        isCurrent: i === 6,
      };
    });
    const maxBarVal = Math.max(...monthBars.map(b => b.value), 1);

    // Best month ever
    const allMonthsMap = {};
    ppQuotes.filter(q => q.won).forEach(q => {
      const d = new Date(q.won_at || q.timestamp || q.created_at || q.createdAt || 0);
      const key = d.getFullYear() + '-' + String(d.getMonth()).padStart(2, '0');
      if (!allMonthsMap[key]) allMonthsMap[key] = { value: 0, date: d };
      allMonthsMap[key].value += (q.total || q.value || 0);
    });
    const bestMonthEntry = Object.values(allMonthsMap).reduce((best, m) => m.value > (best ? best.value : 0) ? m : best, null);
    const bestMonthLabel = bestMonthEntry ? (fmt(bestMonthEntry.value) + studioSep(' \u00b7 ') + bestMonthEntry.date.toLocaleString('en-GB', { month: 'short', year: 'numeric' })) : '\u2014';

    const hasPP = portalPipeline != null;
    const dash = '\u2014';

    return (
    <>
      {/* ── Performance hero card ── */}
      <div style={{ background: 'linear-gradient(145deg, #1E3A2F 0%, #1A2E3E 52%, #2A3828 100%)', borderRadius: 16, padding: '20px 18px 18px', margin: '4px 14px 0' }}>
        {/* Header */}
        <div style={{ fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.08em', color: 'rgba(255,255,255,0.5)', marginBottom: 16 }}>{'Your Performance' + studioSep()}{currentMonthName}</div>

        {/* Top row */}
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 16 }}>
          <div>
            <div style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic', fontSize: 36, color: '#F0C060', lineHeight: 1, ...uvx(() => (companyScreen === 1 ? { ...studioType.display(), fontSize: 84, color: STUDIO_TOKENS.ochre } : { fontSize: 31 })) }}>{wonThisMonthVal != null && wonThisMonthVal > 0 ? fmt(wonThisMonthVal) : dash}</div>
            <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.5)', marginTop: 5 }}>Won this month</div>
            {/* DECISIONS 176.140 and 176.158: a total shows the blended margin of the jobs it sums. Here that is D20 over this month's won jobs (lumen_figures won_margin_month), or not available with the portal's reason; with nothing cached, "Margin not available." */}
            <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.5)', marginTop: 3 }}>{truthGroupMargin(truthWonMarginMonth()).text}</div>
          </div>
          {quotesChasing !== 0 && (
            <div style={{ background: 'rgba(80,200,130,0.15)', border: '1px solid rgba(80,200,130,0.35)', borderRadius: 20, padding: '5px 11px', display: 'flex', alignItems: 'center', gap: 4 }}>
              <span style={{ color: '#70D8A0', fontSize: 12 }}>{studioArrow('\u2191')}</span>
              <span style={{ color: '#70D8A0', fontSize: 12, fontWeight: 500 }}>{quotesChasing == null ? TRUTH_DASH : quotesChasing} quotes chasing</span>
            </div>
          )}
        </div>

        {/* 4-metric grid */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
          <div style={{ background: 'rgba(255,255,255,0.09)', borderRadius: 10, padding: '10px 12px' }}>
            <div style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic', fontSize: 18, color: '#fff' }}>{hasPP && lastMonthWon > 0 ? fmt(lastMonthWon) : dash}</div>
            <div style={{ fontSize: 10, textTransform: 'uppercase', letterSpacing: '0.06em', color: 'rgba(255,255,255,0.35)', marginTop: 4 }}>Last month</div>
          </div>
          <div style={{ background: 'rgba(255,255,255,0.09)', borderRadius: 10, padding: '10px 12px' }}>
            <div style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic', fontSize: 18, color: '#70D8A0' }}>{ppWinRate != null ? ppWinRate + '%' : dash}</div>
            <div style={{ fontSize: 10, textTransform: 'uppercase', letterSpacing: '0.06em', color: 'rgba(255,255,255,0.35)', marginTop: 4 }}>Win rate, this financial year</div>
          </div>
          <div style={{ background: 'rgba(255,255,255,0.09)', borderRadius: 10, padding: '10px 12px' }}>
            <div style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic', fontSize: 18, color: '#fff' }}>{monthlyTarget > 0 ? fmt(monthlyTarget) : dash}</div>
            <div style={{ fontSize: 10, textTransform: 'uppercase', letterSpacing: '0.06em', color: 'rgba(255,255,255,0.35)', marginTop: 4 }}>Monthly target</div>
          </div>
          <div style={{ background: 'rgba(255,255,255,0.09)', borderRadius: 10, padding: '10px 12px' }}>
            <div style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic', fontSize: 18, color: '#F0C060' }}>{monthlyTarget > 0 && stillToGo != null ? fmt(stillToGo) : dash}</div>
            <div style={{ fontSize: 10, textTransform: 'uppercase', letterSpacing: '0.06em', color: 'rgba(255,255,255,0.35)', marginTop: 4 }}>Still to go</div>
          </div>
        </div>

        {/* Divider */}
        <div style={{ borderTop: '1px solid rgba(255,255,255,0.12)', margin: '14px 0' }} />

        {/* Mini bar chart — 7 months */}
        <div style={{ display: 'flex', alignItems: 'flex-end', gap: 4, height: 36 }}>
          {monthBars.slice().reverse().map((b, i) => (
            <div key={i} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3 }}>
              <div style={{ width: '100%', height: Math.max(3, (b.value / maxBarVal) * 32), borderRadius: '3px 3px 0 0', background: b.isCurrent ? '#F0C060' : 'rgba(255,255,255,0.18)', ...uvx(() => (b.isCurrent ? { background: STUDIO_MEANING.wonFill } : {})) }} />
            </div>
          ))}
        </div>
        <div style={{ display: 'flex', gap: 4, marginTop: 3 }}>
          {monthBars.slice().reverse().map((b, i) => (
            <div key={i} style={{ flex: 1, textAlign: 'center', fontSize: 9, color: b.isCurrent ? 'rgba(255,255,255,0.7)' : 'rgba(255,255,255,0.3)' }}>
              {b.isCurrent ? b.month + studioArrow(' \u25B2') : b.month}
            </div>
          ))}
        </div>

        {/* Best month ever */}
        <div style={{ borderTop: '1px solid rgba(255,255,255,0.12)', marginTop: 14, paddingTop: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontSize: 11, color: 'rgba(255,255,255,0.4)' }}>Best month ever</span>
          <span style={{ fontSize: 12, fontWeight: 500, color: 'rgba(255,255,255,0.7)' }}>{bestMonthEntry ? <><span style={{ color: '#F0C060' }}>{fmt(bestMonthEntry.value)}</span>{studioSep(' \u00b7 ') + bestMonthEntry.date.toLocaleString('en-GB', { month: 'short', year: 'numeric' })}</> : dash}</span>
        </div>
      </div>

      {/* Chart 1 — Turnover by month */}
      <div style={{ background: t.colors.glass, border: `1px solid ${t.colors.glassBorder}`, borderRadius: 16, padding: '16px 14px', margin: '12px 14px 0' }}>
        <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'rgba(28,24,16,0.35)', marginBottom: 10 }}>Turnover by month</div>
        <svg viewBox="0 0 312 160" style={{ width: '100%', height: 'auto', minHeight: 160, ...uvx({ maxWidth: 440, display: 'block' }) }}>
          {/* Target line */}
          {monthlyTarget > 0 && (() => {
            const targetY = 128 - (monthlyTarget / maxMonthVal) * 110;
            return (
              <>
                <line x1="0" y1={targetY} x2="312" y2={targetY} stroke="rgba(200,144,48,0.4)" strokeWidth="1" strokeDasharray="4,3" />
                <text x="4" y={targetY - 4} fontSize="7" fill="rgba(200,144,48,0.6)" fontWeight="700">{fmt(monthlyTarget)} target</text>
              </>
            );
          })()}
          {/* Trend line (reversed: current month leftmost) */}
          <line x1="9" y1={trendY11} x2={11 * 26 + 9} y2={trendY0} stroke="rgba(28,24,16,0.35)" strokeWidth="1.5" strokeDasharray="3,2" />
          {/* Bars (reversed: current month leftmost) */}
          {monthlyData.slice().reverse().map((m, i) => {
            const barH = maxMonthVal > 0 ? (m.value / maxMonthVal) * 110 : 0;
            const barY = 128 - barH;
            const opacity = m.isCurrent ? 1 : 0.5 - (i / 11) * 0.25;
            const reversed = monthlyData.slice().reverse();
            const bestMonth = reversed.reduce((b, v, j) => v.value > reversed[b].value ? j : b, 0);
            return (
              <g key={i}>
                <rect x={i * 26} y={barY} width="18" height={Math.max(1, barH)} rx="3" fill={m.isCurrent ? '#1A3A5A' : `rgba(26,58,90,${opacity})`} />
                {/* Value labels */}
                {m.isCurrent && m.value > 0 && <text x={i * 26 + 9} y={barY - 4} textAnchor="middle" fontSize="9" fontWeight="800" fill="#1A3A5A">{fmt(m.value)}</text>}
                {i === bestMonth && !m.isCurrent && m.value > 0 && <text x={i * 26 + 9} y={barY - 4} textAnchor="middle" fontSize="8.5" fill="rgba(26,58,90,0.7)">{fmt(m.value)}</text>}
                {/* Month labels */}
                <text x={i * 26 + 9} y="142" textAnchor="middle" fontSize="8.5" fill={m.isCurrent ? '#1A3A5A' : 'rgba(28,24,16,0.45)'} fontWeight={m.isCurrent ? '800' : '400'}>
                  {m.isCurrent ? m.month + studioArrow(' \u25B2') : m.month}
                </text>
              </g>
            );
          })}
        </svg>
        {monthlyData.every(m => m.value === 0) && (
          <div style={{ marginTop: 8 }}>
            <div style={{ display: 'flex', gap: 4, marginBottom: 6 }}>
              {Array.from({ length: 12 }, (_, i) => (
                <div key={i} style={{ flex: 1, height: Math.max(6, 10 + Math.random() * 30), borderRadius: 3, ...shimmerBgWarm }} />
              ))}
            </div>
            <div style={{ fontSize: 10, color: t.colors.textTertiary, textAlign: 'center', fontStyle: 'italic' }}>Turnover appears as jobs are invoiced</div>
          </div>
        )}
        {monthlyTarget === 0 && !monthlyData.every(m => m.value === 0) && <div style={{ fontSize: 10, color: t.colors.textTertiary, marginTop: 6, fontStyle: 'italic' }}>Set a target to track progress →</div>}
        {/* Legend */}
        <div style={{ display: 'flex', gap: 14, marginTop: 8, alignItems: 'center' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}><div style={{ width: 8, height: 8, borderRadius: 2, background: '#1A3A5A' }} /><span style={{ fontSize: 9, color: t.colors.textTertiary }}>This month</span></div>
          {monthlyTarget > 0 && <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}><div style={{ width: 12, height: 0, borderTop: '1.5px dashed rgba(200,144,48,0.5)' }} /><span style={{ fontSize: 9, color: t.colors.textTertiary }}>{fmt(monthlyTarget)} target</span></div>}
        </div>
      </div>

      {/* Chart 2 — Win rate (6 months) */}
      <div style={{ background: t.colors.glass, border: `1px solid ${t.colors.glassBorder}`, borderRadius: 16, padding: '16px 14px', margin: '10px 14px 0' }}>
        <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'rgba(28,24,16,0.35)', marginBottom: 10 }}>Win rate</div>
        <div style={{ display: 'flex', alignItems: 'flex-end', gap: 6, height: 120 }}>
          {winRateData.slice().reverse().map((m, i) => (
            <div key={i} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
              <span style={{ fontSize: 9, fontWeight: m.isCurrent ? 800 : 400, color: m.isCurrent ? '#1A3A5A' : t.colors.textTertiary }}>{m.rate}%</span>
              <div style={{ width: '100%', height: Math.max(3, m.rate * 1.0), borderRadius: 3, background: m.isCurrent ? '#1A3A5A' : `rgba(26,58,90,${0.45 - (i / 5) * 0.3})` }} />
              <span style={{ fontSize: 8.5, color: m.isCurrent ? '#1A3A5A' : 'rgba(28,24,16,0.45)', fontWeight: m.isCurrent ? 800 : 400 }}>{m.month}</span>
            </div>
          ))}
        </div>
        {winRateData.every(m => m.rate === 0) && (
          <div style={{ marginTop: 8 }}>
            <div style={{ height: 2, borderRadius: 1, ...shimmerBgWarm, marginBottom: 6 }} />
            <div style={{ fontSize: 10, color: t.colors.textTertiary, textAlign: 'center', fontStyle: 'italic' }}>Win rate builds as you close jobs</div>
          </div>
        )}
      </div>

      {/* Chart 3 — Margin variance */}
      <div style={{ background: t.colors.glass, border: `1px solid ${t.colors.glassBorder}`, borderRadius: 16, padding: '16px 14px', margin: '10px 14px 0' }}>
        <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'rgba(28,24,16,0.35)', marginBottom: 10 }}>Quoted vs invoiced margin</div>
        {varianceData.length > 0 ? (
          <>
            <svg viewBox={`0 0 280 ${varianceData.length * 32 + 18}`} style={{ width: '100%', height: 'auto' }}>
              {/* Centre axis */}
              <line x1="140" y1="0" x2="140" y2={varianceData.length * 32} stroke="rgba(28,24,16,0.12)" strokeWidth="1" />
              <text x="140" y={varianceData.length * 32 + 14} textAnchor="middle" fontSize="7" fill="rgba(28,24,16,0.35)">Quoted margin</text>
              {varianceData.map((v, i) => {
                const barY = 4 + i * 32;
                const barW = Math.abs(v.variance) * 10;
                const isShortfall = v.variance < 0;
                const severity = Math.abs(v.variance);
                const fillOpacity = severity >= 6 ? 0.80 : severity >= 3 ? 0.55 : 0.35;
                const jobLabel = v.job.length > 14 ? v.job.slice(0, 14) + '\u2026' : v.job;
                const barWide = barW > 60;
                return (
                  <g key={i}>
                    <text x="4" y={barY + 11} textAnchor="start" fontSize="11" fontWeight="600" fill={isShortfall ? '#C03C32' : 'rgba(28,24,16,0.65)'}>{jobLabel}</text>
                    <rect x={isShortfall ? 140 - barW : 140} y={barY + 16} width={barW || 2} height="12" rx="3" fill={isShortfall ? `rgba(192,60,50,${fillOpacity})` : 'rgba(28,28,28,0.45)'} />
                    <text x={barWide ? (isShortfall ? 140 - barW / 2 : 140 + barW / 2) : (isShortfall ? 140 - barW - 4 : 140 + barW + 4)} y={barY + 25} textAnchor={barWide ? 'middle' : (isShortfall ? 'end' : 'start')} fontSize="11" fontWeight="800" fill={barWide ? '#fff' : (isShortfall ? '#C03C32' : 'rgba(28,24,16,0.65)')}>{v.variance}%</text>
                  </g>
                );
              })}
            </svg>
            {worstVariance && (
              <div style={{ background: 'rgba(192,60,50,0.06)', border: '1px solid rgba(192,60,50,0.18)', borderRadius: 10, padding: '10px 12px', marginTop: 8 }}>
                <p style={{ fontSize: 11, color: '#C03C32', lineHeight: 1.4 }}>{worstVariance.job} lost {Math.abs(worstVariance.variance)}{'%' + studioDash() + 'largest variance this year. Worth reviewing what changed on site.'}</p>
              </div>
            )}
            <div style={{ display: 'flex', gap: 14, marginTop: 8, alignItems: 'center' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}><div style={{ width: 8, height: 8, borderRadius: 2, background: 'rgba(192,60,50,0.55)' }} /><span style={{ fontSize: 9, color: t.colors.textTertiary }}>Margin shortfall</span></div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}><div style={{ width: 8, height: 8, borderRadius: 2, background: 'rgba(28,28,28,0.45)' }} /><span style={{ fontSize: 9, color: t.colors.textTertiary }}>Delivered on quote</span></div>
            </div>
          </>
        ) : (
          <div style={{ padding: '8px 0' }}>
            {Array.from({ length: 4 }, (_, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
                <div style={{ width: 80, height: 11, borderRadius: 4, ...shimmerBgWarm }} />
                <div style={{ flex: 1, height: 12, borderRadius: 3, ...shimmerBgWarm }} />
                <div style={{ width: 28, height: 11, borderRadius: 4, ...shimmerBgWarm }} />
              </div>
            ))}
            <div style={{ fontSize: 10, color: t.colors.textTertiary, textAlign: 'center', fontStyle: 'italic', marginTop: 4 }}>No completed jobs yet</div>
          </div>
        )}
      </div>

      {/* ── KPI Metric Cards ── */}
      {(() => {
        // Use division-filtered proposals for all KPI metrics (same source as Pipeline screen)
        const kpiDiv = getDivisionConfig(currentUser);
        const allProp = (proposals || []).filter(p => p.division === kpiDiv.id || !p.division);
        const allProj = proposals || []; // unfiltered — used by Division Split for cross-division comparison
        // COMPANION-TRUTH-V2 B3: null, undefined or not a finite number is the
        // not-available mark, never "\u00a30"; a real 0 still prints "\u00a30".
        const fmtM = (v) => { if (v == null || !isFinite(Number(v))) return TRUTH_DASH; if (!v || v === 0) return "\u00a30"; if (v >= 1000000) return "\u00a3" + (v / 1000000).toFixed(1) + "M"; if (v >= 1000) return "\u00a3" + Math.round(v / 1000) + "k"; return "\u00a3" + v.toLocaleString("en-GB"); };

        const now = new Date();
        const monthStart = new Date(now.getFullYear(), now.getMonth(), 1).getTime();
        const lastMonthStart = new Date(now.getFullYear(), now.getMonth() - 1, 1).getTime();
        const day90 = Date.now() - 90 * 86400000;
        const toTs = (d) => d ? new Date(d).getTime() : 0;

        const thisMonthQuotes = allProp.filter(p => toTs(p.createdAt) >= monthStart).length;
        const lastMonthQuotes = allProp.filter(p => toTs(p.createdAt) >= lastMonthStart && toTs(p.createdAt) < monthStart).length;
        const monthDelta = thisMonthQuotes - lastMonthQuotes;
        const thisMonthValue = allProp.filter(p => toTs(p.createdAt) >= monthStart).reduce((s, p) => s + parseFloat(p.value || p.capex || 0), 0);

        // COMPANION-TRUTH-V1 (a): Live Pipeline is the portal's D1 and D2,
        // mine. Each null draws the dash, never fmtM's "£0".
        // COMPANION-TRUTH-V2 B5: its margin is D16 over the same live jobs
        // (DECISIONS 176.140); the win rate is D7 mine over the financial year
        // (176.135, win_rate_fy) and its label says so; Days to Win is D18
        // (days_to_win, the dash while withheld; no fastest win is served, so
        // that sub stays empty); Lost is D6 this financial year
        // (lost_fy_count), and no lost value is served (the dash).
        const pendingValue = truthPipelineValue();
        const pendingCount = truthLiveCount();
        const pendingMargin = truthGroupMargin(truthLiveMargin());
        const winRate = truthWinRateFy();

        // "Revenue velocity" is retired (DECISIONS 176.138), in both looks.

        const avgDays = truthPipelineFigure('days_to_win', 'days_to_win_withheld');
        const lostCount = truthPipelineFigure('lost_fy_count');

        const kpiCardStyle = { background:"rgba(255,252,242,0.88)", borderTop:"1.5px solid rgba(255,255,250,0.96)", borderRadius:14, padding:14 };
        const kpiLabel = { fontSize:10, fontWeight:700, color:"#8A7A5A", textTransform:"uppercase", letterSpacing:0.8, marginBottom:6 };
        const kpiSub = { fontSize:11, color:"#8A7A5A", marginTop:4 };

        return (
          <div style={{ margin:'12px 14px 0' }}>
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:12 }}>
              <div style={kpiCardStyle}>
                <div style={kpiLabel}>Quotes This Month</div>
                <div style={{ fontSize:22, fontWeight:600, color:"#C89030" }}>{thisMonthQuotes}</div>
                <div style={kpiSub}>{monthDelta > 0 ? "+" + monthDelta + " vs last month" : monthDelta < 0 ? monthDelta + " vs last month" : fmtM(thisMonthValue) + " value"}</div>
              </div>
              <div style={kpiCardStyle}>
                <div style={kpiLabel}>Live Pipeline</div>
                <div style={{ fontSize:22, fontWeight:600, color:"#1A1608" }}>{pendingValue == null ? TRUTH_DASH : fmtM(pendingValue)}</div>
                <div style={kpiSub}>{pendingCount == null ? <>{TRUTH_DASH}{" pending"}</> : pendingCount + " pending"}</div>
                <div style={kpiSub}>{pendingMargin.text}</div>
              </div>
              <div style={kpiCardStyle}>
                <div style={kpiLabel}>Win rate</div>
                <div style={{ fontSize:22, fontWeight:600, color:"#1A1608" }}>{winRate != null ? winRate + "%" : TRUTH_DASH}</div>
                <div style={kpiSub}>This financial year</div>
              </div>
              <div style={kpiCardStyle}>
                <div style={kpiLabel}>Days to Win</div>
                <div style={{ fontSize:22, fontWeight:600, color:"#1A1608" }}>{avgDays != null ? avgDays + "d" : "\u2014"}</div>
                <div style={kpiSub}>{""}</div>
              </div>
              <div style={kpiCardStyle}>
                <div style={kpiLabel}>Lost</div>
                <div style={{ fontSize:22, fontWeight:600, color:"#C89030" }}>{lostCount != null ? lostCount : TRUTH_DASH}</div>
                <div style={kpiSub}><>{TRUTH_DASH}{" value"}</></div>
              </div>
            </div>

            {/* Division split */}
            <div style={{ marginTop:4 }}>
              <div style={{ fontSize:10, fontWeight:700, color:"#8A7A5A", textTransform:"uppercase", letterSpacing:1.2, marginBottom:10 }}>Division Split</div>
              {(() => {
                const lightingPipeline = allProj.filter(p => (p.division || 'lighting') === 'lighting' && p.status !== 'won' && p.status !== 'lost').reduce((s, p) => s + (p.value || 0), 0);
                const airconPipeline = allProj.filter(p => p.division === 'aircon' && p.status !== 'won' && p.status !== 'lost').reduce((s, p) => s + (p.value || 0), 0);
                const totalPipeline = lightingPipeline + airconPipeline || 1;
                const divisionRows = [
                  { name:"Lighting", divKey:"lighting", pipeline: lightingPipeline, color:"#2E6838", pct: (lightingPipeline / totalPipeline) * 100 },
                  { name:"Mechanicalditioning", divKey:"aircon", pipeline: airconPipeline, color:"#1A5A78", pct: (airconPipeline / totalPipeline) * 100 },
                ].filter(d => {
                  // Only show user's own division unless director
                  if (userType === 'director') return true;
                  const userDiv = divId || 'lighting';
                  if (userDiv === 'me' || userDiv === 'ac' || userDiv === 'aircon') return d.divKey === 'aircon';
                  return d.divKey === userDiv;
                });
                return (
                  <>
                    {divisionRows.map(div => (
                      <div key={div.name} style={{ marginBottom:10 }}>
                        <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:4 }}>
                          <span style={{ fontSize:13, color:"#1A1608" }}>{div.name}</span>
                          <div style={{ display:"flex", gap:10, alignItems:"center" }}>
                            <span style={{ fontSize:12, fontWeight:600, color:"#C89030" }}>{fmtM(div.pipeline)}</span>
                            {/* COMPANION-TRUTH-V2 B5 (DECISIONS 176.135): no per-division D7 is served, so the dash, never the phone's own rate. */}
                            <span style={{ fontSize:11, fontWeight:600, color:"#2E6838" }}>{TRUTH_DASH}{" win"}</span>
                          </div>
                        </div>
                        <div style={{ height:6, borderRadius:4, background:"rgba(42,58,26,0.08)", overflow:"hidden" }}>
                          <div style={{ height:"100%", width:`${div.pct}%`, borderRadius:4, background:`${div.color}99`, transition:"width 0.5s ease" }} />
                        </div>
                      </div>
                    ))}
                  </>
                );
              })()}
            </div>
          </div>
        );
      })()}

      {/* S95 D5 — full Personal Bests grid on Performance tab.
          The summary tile remains on Today (SECTION 1c); here we render all
          ten records at full width so users can review/celebrate history in
          the same place they look at their pipeline numbers. */}
      {(() => {
        const records = computePersonalBestsFromProposals(proposals);
        const byKey = (k) => records.find(r => r.key === k) || null;
        const fmtGoldLocal = (v) => (v == null || v === '') ? '\u2014' : (typeof v === 'number' ? `\u00A3${v >= 1000 ? (v >= 1000000 ? (v/1000000).toFixed(1)+'m' : (v/1000).toFixed(0)+'k') : v}` : v);
        const tiles = [
          { key: 'largest_quote',       label: 'Largest Quote',        tone: 'gold' },
          { key: 'pipeline_month',      label: 'Pipeline / Month',     tone: 'gold' },
          { key: 'best_sales_month',    label: 'Best Sales Month',     tone: 'gold' },
          { key: 'highest_margin',      label: 'Highest Margin Order', tone: 'gold' },
          { key: 'proposals_month',     label: 'Proposals / Month',    tone: 'plain' },
          { key: 'proposals_year',      label: 'Proposals / Year',     tone: 'plain' },
          { key: 'best_week',           label: 'Best week quoting',     tone: 'gold' },
          { key: 'avg_margin_month',    label: 'Best Avg Margin',       tone: 'plain' },
          { key: 'new_clients_month',   label: 'New Clients / Month',  tone: 'plain' },
          { key: 'active_clients_month',label: 'Active Clients / Mo',  tone: 'plain' },
        ];
        const thisMonthRecord = records.find(r => r.set_this_month);
        return (
          <div style={{ margin: '14px 14px 0', padding: '14px 14px 12px', background: 'rgba(255,252,242,0.88)', border: '1px solid rgba(221,208,184,0.35)', borderRadius: 14 }}>
            <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', marginBottom: 10 }}>
              <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.09em', textTransform: 'uppercase', color: 'rgba(28,24,16,0.5)' }}>Records</span>
              <span style={{ fontSize: 11, color: 'rgba(28,24,16,0.38)' }}>{records.length > 0 ? `${records.length} records` : '\u2014'}</span>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6 }}>
              {tiles.map(t2 => {
                const rec = byKey(t2.key);
                const valueRaw = rec?.value;
                const valueStr = t2.tone === 'gold'
                  ? (valueRaw != null && valueRaw !== '' ? fmtGoldLocal(valueRaw) : 'None yet')
                  : (valueRaw != null && valueRaw !== '' ? String(valueRaw) : 'None yet');
                const numColor = (t2.tone === 'gold' && valueRaw != null && valueRaw !== '') ? '#C89030' : '#1A1608';
                return (
                  <div key={t2.key} style={{ background: 'rgba(221,208,184,0.15)', border: '1px solid rgba(221,208,184,0.35)', borderRadius: 10, padding: '9px 10px', minWidth: 0 }}>
                    <div style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic', fontSize: 17, color: numColor, lineHeight: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{valueStr}</div>
                    <div style={{ fontSize: 11, fontWeight: 700, color: '#1A1608', marginTop: 4, whiteSpace: 'normal', lineHeight: 1.2 }}>{t2.label}</div>
                    <div style={{ fontSize: 11, color: 'rgba(28,24,16,0.4)', marginTop: 2, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{personalBestContext(rec?.context) || 'None yet'}</div>
                  </div>
                );
              })}
            </div>
            {thisMonthRecord && (
              <div style={{ fontSize: 11, fontStyle: 'italic', color: 'rgba(28,24,16,0.5)', marginTop: 10, textAlign: 'center' }}>
                New record this month: <b style={{ color: '#C89030' }}>{thisMonthRecord.label}</b>
              </div>
            )}
            {records.length === 0 && (
              <div style={{ fontSize: 11, fontStyle: 'italic', color: 'rgba(28,24,16,0.4)', marginTop: 10, textAlign: 'center' }}>
                Records appear as you use the app.
              </div>
            )}
          </div>
        );
      })()}

      <div style={{ height: 24 }} />
    </>
  ); };

  // ── TEAM (companyScreen === 2, director only) ──
  const renderTeam = () => (
    <>
      {/* Team hero */}
      <div style={{ background: 'linear-gradient(145deg, #0A1628 0%, #0C2018 52%, #162818 100%)', borderRadius: 16, padding: 14, margin: '0 14px', display: 'flex', alignItems: 'center', gap: 14 }}>
        <div style={{ position: 'relative', width: 48, height: 48, flexShrink: 0, ...uvx({ width: 'auto', height: 'auto' }) }}>
          {t.theme === 'uv' ? null : <svg width="48" height="48" viewBox="0 0 48 48">
            <circle cx="24" cy="24" r="19" fill="none" stroke="rgba(255,255,255,0.07)" strokeWidth="4" />
            <circle cx="24" cy="24" r="19" fill="none" stroke={teamScore >= 70 ? '#5EC080' : teamScore >= 40 ? '#D4A030' : '#E06050'} strokeWidth="4" strokeDasharray={`${(teamScore/100)*119.4} 119.4`} strokeLinecap="round" transform="rotate(-90 24 24)" />
          </svg>}
          <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', ...uvx({ position: 'static' }) }}>
            <span style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic', fontSize: 16, color: teamMembers.length > 0 ? (teamScore >= 70 ? '#5EC080' : '#D4A030') : 'rgba(255,252,242,0.4)', ...uvx(() => (companyScreen === 2 ? { ...studioType.display(), fontSize: 84 } : { fontSize: 25 })) }}>{teamMembers.length > 0 ? teamScore : '\u2014'}</span>
          </div>
        </div>
        <div>
          <div style={{ fontSize: 14, fontWeight: 800, color: '#fff' }}>Team</div>
          <div style={{ fontSize: 11, color: 'rgba(255,252,242,0.38)' }}>{teamMembers.filter(m => m.active).length} of {teamMembers.length} active</div>
        </div>
      </div>

      {/* Decision 4 (Andrew, 6 October 2026), for everyone: the activity
          heatmap (Math.random cells, CENSUS F2), the leaderboard sparklines
          (Math.random) and the "Team vs quarterly target" card (a hard-coded
          500,000 target) are gone, switch off too. */}

      {/* Leaderboard */}
      <div style={{ background: t.colors.glass, border: `1px solid ${t.colors.glassBorder}`, borderRadius: 16, padding: '16px 14px', margin: '10px 14px 0' }}>
        <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'rgba(28,24,16,0.35)', marginBottom: 10 }}>Leaderboard</div>
        {sortedTeam.map((m, i) => {
          const posColors = ['#BF9428', 'rgba(28,24,16,0.45)', '#8A6040', 'rgba(28,24,16,0.25)'];
          const daysSince = Math.floor((Date.now() - m.lastActive) / 86400000);
          return (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 0', borderTop: i > 0 ? `1px solid ${t.colors.separator}` : 'none', background: !m.active ? 'rgba(192,60,50,0.03)' : 'transparent' }}>
              <div style={{ width: 22, height: 22, borderRadius: 6, background: `${posColors[i]}18`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <span style={{ fontSize: 10, fontWeight: 800, color: posColors[i] }}>{i + 1}</span>
              </div>
              <div style={{ width: 28, height: 28, borderRadius: 8, background: 'rgba(28,24,16,0.08)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, fontSize: 11, fontWeight: 700, color: t.colors.textSecondary }}>
                {m.name.split(' ').filter(n => t.theme !== 'uv' || /^[A-Za-z0-9]/.test(n)).map(n => n[0]).join('')}
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 12, fontWeight: 700, color: m.active ? t.colors.text : '#C03C32' }}>{m.name}</div>
                <div style={{ fontSize: 10, color: m.active ? t.colors.textTertiary : '#C03C32' }}>
                  {m.active ? `${m.surveys} surveys` : `${daysSince}d since last activity`}
                </div>
              </div>
              <div style={{ textAlign: 'right', flexShrink: 0 }}>
                <div style={{ fontSize: 12, fontWeight: 800, color: t.colors.text }}>{fmt(m.pipeline)}</div>
                <div style={{ fontSize: 9, color: m.pipeline > 80000 ? '#1E6030' : t.colors.textTertiary }}>
                  {t.theme === 'uv' ? (m.pipeline > 80000 ? 'High' : 'Low') : (m.pipeline > 80000 ? '\u25B2' : '\u25BC')}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div style={{ height: 24 }} />
    </>
  );

  return studioDesk(
    <div style={{ flex: 1, background: '#E8DCC8', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      <ScreenBlobs />

      {/* Header dots only — no title text (hero card aligns with Today) */}
      <div style={{ padding: '4px 20px 4px', display: 'flex', alignItems: 'center', justifyContent: 'flex-end', position: 'relative', zIndex: 1, flexShrink: 0 }}>
        <NavDots />
      </div>

      <div style={{ flex: 1, position: 'relative', zIndex: 1, overflow: 'hidden' }}
        onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd}>
        <div style={{
          position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
          display: 'flex', width: `${maxScreens * 100}%`,
          transform: `translateX(calc(-${companyScreen * (100 / maxScreens)}% + ${swipeOffset}px))`,
          transition: swiping ? 'none' : 'transform 200ms ease-out',
        }}>
          <div style={{ width: `${100 / maxScreens}%`, flexShrink: 0, overflowY: 'auto', overflowX: 'hidden', WebkitOverflowScrolling: 'touch', overscrollBehavior: 'contain', paddingBottom: 83 }}>
            {studioWrapColumn(<>
              {renderPulse()}
            </>)}
          </div>
          <div style={{ width: `${100 / maxScreens}%`, flexShrink: 0, overflowY: 'auto', overflowX: 'hidden', WebkitOverflowScrolling: 'touch', overscrollBehavior: 'contain', paddingBottom: 100 }}>
            {studioWrapColumn(renderPerformance())}
          </div>
          {userType === 'director' && (
            <div style={{ width: `${100 / maxScreens}%`, flexShrink: 0, overflowY: 'auto', overflowX: 'hidden', WebkitOverflowScrolling: 'touch', overscrollBehavior: 'contain', paddingBottom: 100 }}>
              {studioWrapColumn(renderTeam())}
            </div>
          )}
        </div>
      </div>

      <TabBar active={19} onChange={onNav} divisionId={divId} />
    </div>
  );
};

// ════════════════════════════════════════════════════
// WORTH SCREEN — Procurement Intelligence (Screen 15)
// Replaces old QuotesScreen entirely
// ════════════════════════════════════════════════════
// Its own component, so studioDesk's mapper never walks the lit Worth screen.
const WorthLitBody = ({ draw }) => draw();
const WorthScreen = ({ onNav, currentUser }) => {
  const divId = (currentUser && currentUser.division) || "lighting";
  const [worthView, setWorthView] = useState('main');
  const [selectedProjectId, setSelectedProjectId] = useState(null);
  const [worthSupplier, setWorthSupplier] = useState(null);
  const [worthProject, setWorthProject] = useState(null);
  const importFileRef = useRef(null);

  // ── Import button state ──
  const [importUploading, setImportUploading] = useState(false);
  const [importError, setImportError] = useState(false);

  // ── Polling state ──
  const [pollingQuoteId, setPollingQuoteId] = useState(null);
  const [pollingStatus, setPollingStatus] = useState('idle'); // 'idle'|'polling'|'complete'|'failed'|'timeout'
  const [pollingCount, setPollingCount] = useState(0);
  const [quotesRefreshKey, setQuotesRefreshKey] = useState(0);

  // ── Portal quotes state ──
  const [portalQuotes, setPortalQuotes] = useState([]);
  const [portalQuotesLoading, setPortalQuotesLoading] = useState(false);
  const [expandedQuoteId, setExpandedQuoteId] = useState(null);

  // ── Dismissed quotes (local only — moved above conditional returns for hooks safety) ──
  const [dismissedIds, setDismissedIds] = useState(() => {
    try { return JSON.parse(localStorage.getItem('lumen_worth_dismissed') || '[]'); } catch(e) { return []; }
  });
  const dismissQuote = (id) => {
    const next = [...dismissedIds, id];
    setDismissedIds(next);
    try { localStorage.setItem('lumen_worth_dismissed', JSON.stringify(next)); } catch(e) {}
  };

  // Fetch portal quotes on mount and after successful uploads
  useEffect(() => {
    const token = localStorage.getItem('lumen_token');
    if (!token) return;
    setPortalQuotesLoading(true);
    fetch('https://lumen-portal.up.railway.app/api/worth/quotes', {
      headers: { 'Authorization': 'Bearer ' + token }
    })
      .then(r => { if (!r.ok) throw new Error('Failed'); return r.json(); })
      .then(data => { setPortalQuotes(Array.isArray(data) ? data : (data.quotes || [])); setPortalQuotesLoading(false); })
      .catch(() => setPortalQuotesLoading(false));
  }, [quotesRefreshKey]);

  // Auto-refresh every 5 s while any portal quote is still processing
  useEffect(() => {
    const hasProcessing = portalQuotes.some(q => q.status === 'processing');
    if (!hasProcessing) return;
    const interval = setInterval(() => setQuotesRefreshKey(k => k + 1), 5000);
    return () => clearInterval(interval);
  }, [portalQuotes]);

  // Polling effect — fires every 3 s until complete / failed / timeout (20 polls = 60 s)
  useEffect(() => {
    if (pollingStatus !== 'polling' || !pollingQuoteId) return;
    if (pollingCount >= 20) {
      setPollingStatus('timeout');
      // Extraction may have just finished — refresh quotes immediately and again after 10 s
      setQuotesRefreshKey(k => k + 1);
      const retryTimer = setTimeout(() => setQuotesRefreshKey(k => k + 1), 10000);
      return () => clearTimeout(retryTimer);
    }
    const token = localStorage.getItem('lumen_token');
    if (!token) { setPollingStatus('failed'); return; }
    const timer = setTimeout(async () => {
      try {
        const resp = await fetch('https://lumen-portal.up.railway.app/api/worth/quotes/' + pollingQuoteId, {
          headers: { 'Authorization': 'Bearer ' + token }
        });
        if (resp.ok) {
          const data = await resp.json();
          if (data.status === 'complete') {
            setPollingStatus('complete');
            setQuotesRefreshKey(k => k + 1);
          } else if (data.status === 'failed') {
            setPollingStatus('failed');
          } else {
            setPollingCount(c => c + 1);
          }
        } else {
          setPollingCount(c => c + 1);
        }
      } catch(e) {
        setPollingCount(c => c + 1);
      }
    }, 3000);
    return () => clearTimeout(timer);
  }, [pollingStatus, pollingQuoteId, pollingCount]);

  // Handle file selected from Import Quote button
  const handleImportFileSelect = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (importFileRef.current) importFileRef.current.value = '';
    const token = localStorage.getItem('lumen_token');
    console.log('[Worth] import file selected:', file.name, '| token present:', !!token);
    if (!token) { setImportError(true); return; }
    setImportUploading(true);
    setImportError(false);
    // S95 D28 — project-linking: upload has historically gone out with no project hint, so
    // portal records every import as project_name=NULL and the UI shows "Unassigned". Derive
    // a best-effort project guess from the filename matched against the user's own project
    // list (asg_projects_<user.id>) — portal may or may not use it, but it also lets us write
    // a client-side override so the row renders correctly here even if portal ignores the hint.
    let projectHint = null;
    try {
      const stash = JSON.parse(localStorage.getItem(`asg_projects_${currentUser?.id}`) || '[]');
      const fnameLc = (file.name || '').toLowerCase();
      const match = stash.find(p => p.name && fnameLc.includes(p.name.toLowerCase()));
      if (match) projectHint = match.name;
      if (!projectHint) {
        const lastCtx = localStorage.getItem('lumen_last_project_context');
        if (lastCtx) projectHint = lastCtx;
      }
    } catch(e) {}
    const reader = new FileReader();
    reader.onerror = () => { setImportUploading(false); setImportError(true); };
    reader.onload = async (ev) => {
      // Strip data URI prefix — portal expects raw base64 only
      const raw = ev.target.result;
      const commaIdx = raw.indexOf(',');
      const base64 = commaIdx !== -1 ? raw.slice(commaIdx + 1) : raw;
      console.log('[Worth] base64 prefix check — first 100 chars:', base64.slice(0, 100));
      console.log('[Worth] POST to /api/worth/upload — fileName:', file.name, '| projectHint:', projectHint || '(none)', '| Content-Type: application/json | Auth: Bearer present:', !!token);
      try {
        const resp = await fetch('https://lumen-portal.up.railway.app/api/worth/upload', {
          method: 'POST',
          headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' },
          body: JSON.stringify({ fileName: file.name, base64, receivedAt: new Date().toISOString(), projectName: projectHint || null })
        });
        console.log('[Worth] upload response status:', resp.status);
        if (!resp.ok) {
          const errBody = await resp.text().catch(() => '');
          console.error('[Worth] upload failed:', resp.status, errBody);
          throw new Error('Upload failed: ' + resp.status + ' ' + errBody);
        }
        const result = await resp.json();
        console.log('[Worth] upload accepted, worth_quote_id:', result.worth_quote_id || result.id);
        setImportUploading(false);
        setPollingQuoteId(result.worth_quote_id || result.id);
        setPollingCount(0);
        setPollingStatus('polling');
      } catch(err) {
        console.error('[Worth] upload error:', err.message || err);
        setImportUploading(false);
        setImportError(true);
      }
    };
    reader.readAsDataURL(file);
  };

  const worthColors = {
    heroGradient: 'linear-gradient(135deg, #BF9428 0%, #2D1540 52%, #081C38 100%)',
    navy: '#091E38',
    navyMid: '#1A3A5A',
    gold: '#BF9428',
    goldMuted: 'rgba(191,148,40,0.65)',
    green: '#1E6030',
    greenLight: 'rgba(30,80,30,0.08)',
    greenBorder: 'rgba(30,80,30,0.2)',
    red: '#C03C32',
    redLight: 'rgba(192,60,50,0.07)',
    amber: '#8A6010',
    amberLight: 'rgba(191,148,40,0.07)',
  };

  // ── Combined data model ──
  const quotes = JSON.parse(localStorage.getItem('lumen_worth_quotes') || '[]');
  const hasQuotes = quotes.length > 0;
  const allQuotes = [...portalQuotes.filter(q => !dismissedIds.includes(q.id))];
  const hasAnyQuotes = allQuotes.length > 0 || hasQuotes;
  const totalSupplyValue = allQuotes.reduce((s, q) => s + (q.total_value || 0), 0);
  const allSupplierNames = [...new Set(allQuotes.map(q => q.supplier_name || q.supplier).filter(Boolean))];

  const fmt = v => v >= 1000 ? '\u00A3' + Math.round(v/1000) + 'k' : '\u00A3' + Math.round(v);
  const fmtFull = v => '\u00A3' + Number(v || 0).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  // ── Group by project_name (portal) + projectName (local) ──
  const projectsByName = {};
  allQuotes.forEach(q => {
    const pName = q.project_name || 'Unassigned';
    if (!projectsByName[pName]) projectsByName[pName] = { quotes: [], totalValue: 0 };
    projectsByName[pName].quotes.push(q);
    projectsByName[pName].totalValue += (q.total_value || 0);
  });
  // Also fold in localStorage quotes
  quotes.forEach(q => {
    const pName = q.projectName || 'Unassigned';
    if (!projectsByName[pName]) projectsByName[pName] = { quotes: [], totalValue: 0 };
    projectsByName[pName].quotes.push({
      ...q, total_value: q.totalValue, supplier_name: q.supplier,
      line_items: (q.lineItems || []).map(li => ({
        description: li.normDescription || li.rawDescription,
        norm_description: li.normDescription, category: li.category,
        quantity: li.quantity, unit: li.unit, unit_price: li.unitPrice, total_price: li.totalPrice
      }))
    });
    projectsByName[pName].totalValue += (q.totalValue || 0);
  });

  // Legacy projectGroups for old localStorage-only comparison
  const projectGroups = quotes.reduce((acc, q) => {
    if (!acc[q.projectId]) acc[q.projectId] = {
      projectName: q.projectName, clientName: q.clientName,
      quotes: [], updatedAt: q.uploadDate
    };
    acc[q.projectId].quotes.push(q);
    if (q.uploadDate > acc[q.projectId].updatedAt) acc[q.projectId].updatedAt = q.uploadDate;
    return acc;
  }, {});

  // ── Group by supplier ──
  const supplierGroups = {};
  const normalizeQuote = q => ({
    id: q.id, supplier_name: q.supplier_name || q.supplier || 'Unknown',
    total_value: q.total_value || q.totalValue || 0,
    project_name: q.project_name || q.projectName || 'Unassigned',
    status: q.status || 'complete', received_at: q.received_at || q.uploadDate,
    line_items: q.line_items || (q.lineItems || []).map(li => ({
      description: li.normDescription || li.rawDescription,
      norm_description: li.normDescription, category: li.category,
      quantity: li.quantity, unit: li.unit, unit_price: li.unitPrice, total_price: li.totalPrice
    }))
  });
  [...allQuotes, ...quotes].forEach(q => {
    const nq = normalizeQuote(q);
    const sName = nq.supplier_name;
    if (!supplierGroups[sName]) supplierGroups[sName] = { quotes: [], totalValue: 0, categories: new Set(), projectNames: new Set() };
    supplierGroups[sName].quotes.push(nq);
    supplierGroups[sName].totalValue += nq.total_value;
    supplierGroups[sName].projectNames.add(nq.project_name);
    (nq.line_items || []).forEach(li => { if (li.category) supplierGroups[sName].categories.add(li.category); });
  });

  // ── Clear failed quotes ──
  // S95 D5 D28 (third attempt) — STRICT filter on status==='failed' only.
  // The prior "processing > 2 hrs" heuristic wiped legitimately-still-processing
  // quotes and, because the "Clear" button batched all matches, collapsed whole
  // Worth views. Only quotes the portal itself has marked failed are eligible;
  // everything else must stay visible until the user explicitly dismisses it
  // per-quote. No Worth data is ever cleared in bulk from anywhere else.
  const failedIds = portalQuotes
    .filter(q => q.status === 'failed' && !dismissedIds.includes(q.id))
    .map(q => q.id);
  const failedCount = failedIds.length;
  const clearFailedQuotes = () => {
    if (failedCount > 0) {
      const next = [...dismissedIds, ...failedIds];
      setDismissedIds(next);
      try { localStorage.setItem('lumen_worth_dismissed', JSON.stringify(next)); } catch(e) {}
      // Remove only the strictly-failed rows from the live list — never touch
      // processing / succeeded / any other status.
      setPortalQuotes(prev => prev.filter(q => !failedIds.includes(q.id)));
    }
  };

  // ── Supplier competitive score (0-100) ──
  const computeSupplierScore = (supplierName) => {
    let wins = 0, total = 0;
    const categoryScores = {};
    Object.entries(projectsByName).forEach(([pName, pGroup]) => {
      const pQuotes = pGroup.quotes;
      if (pQuotes.length < 2) return;
      const thisQ = pQuotes.find(q => (q.supplier_name || q.supplier) === supplierName);
      if (!thisQ) return;
      total++;
      const cheapest = pQuotes.reduce((min, q) => ((q.total_value || 0) < (min.total_value || 0)) ? q : min, pQuotes[0]);
      if ((thisQ.total_value || 0) <= (cheapest.total_value || 0)) wins++;
      // Category-level
      (thisQ.line_items || []).forEach(li => {
        const cat = li.category || 'other';
        if (!categoryScores[cat]) categoryScores[cat] = { wins: 0, total: 0 };
        categoryScores[cat].total++;
        const desc = (li.norm_description || li.description || '').toLowerCase();
        const allLi = pQuotes.flatMap(q => (q.line_items || []).filter(l => (l.norm_description || l.description || '').toLowerCase() === desc));
        if (allLi.length > 1) {
          const cheapLi = allLi.reduce((min, l) => ((l.unit_price || 0) < (min.unit_price || 0)) ? l : min, allLi[0]);
          if ((li.unit_price || 0) <= (cheapLi.unit_price || 0)) categoryScores[cat].wins++;
        }
      });
    });
    const score = total > 0 ? Math.round((wins / total) * 100) : 50;
    return { score, wins, total, categories: categoryScores };
  };

  const scoreColor = s => s >= 70 ? worthColors.green : s >= 40 ? worthColors.amber : worthColors.red;
  const scoreBg = s => s >= 70 ? worthColors.greenLight : s >= 40 ? worthColors.amberLight : worthColors.redLight;

  // STUDIO-LIT-PHONE-V1 item 8b: with the switch on, the main view and a
  // job's comparison are the lit v5 prototype's #app/wshare and #app/wverdict,
  // drawn from what /api/worth/quotes sends (and the old device-only quotes).
  // The supplier view is not in the prototype and keeps its mapped look.
  if (t.theme === 'uv' && worthView !== 'supplier' && worthView !== 'comparison') {
    const renderWorthLit = () => {
      const S = STUDIO_TOKENS; const M = STUDIO_MEANING;
      // Emerald means savings and falling prices, in Worth only (studio-lit.md,
      // "One colour, one meaning"); the text shade is the reference's own.
      const EMERALD_TEXT = '#157A52';
      const money = { color: M.ochre, fontVariantNumeric: 'tabular-nums', fontWeight: 700 };
      const sec = { fontFamily: S.fonts.body, fontSize: 16, fontWeight: 700, color: S.ink, margin: 0 };
      const small = { fontSize: 13, color: S.muted, lineHeight: 1.4 };
      const paper = { ...studioSurface.raised(), borderRadius: S.radius.card, margin: '0 16px', padding: '6px 16px' };
      const act = { ...studioType.action(), minHeight: 44, display: 'inline-flex', alignItems: 'center', cursor: 'pointer', fontFamily: 'inherit' };
      const rowLine = (i) => ({ borderTop: i > 0 ? `1px solid ${S.hairline}` : 'none' });
      // Whole pounds: supplier totals often differ by less than the £1k the
      // app's short form rounds to, so Worth keeps its exact figures.
      const pounds = (v) => '£' + Math.round(Number(v) || 0).toLocaleString('en-GB');
      const pence = (v) => '£' + (Number(v) || 0).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      const when = (iso) => {
        const d = iso ? new Date(iso) : null;
        if (!d || isNaN(d)) return null;
        const hm = d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
        const now = new Date();
        const today = d.getFullYear() === now.getFullYear() && d.getMonth() === now.getMonth() && d.getDate() === now.getDate();
        return today ? `today at ${hm}` : `${d.getDate()} ${PL_MONTHS[d.getMonth()]}, ${hm}`;
      };
      const jobName = (n) => (n === 'Unassigned' ? 'Not filed to a job' : n);
      const firstWord = (s) => String(s || '').split(' ')[0];
      const openAdd = () => { if (!importUploading && importFileRef.current) importFileRef.current.click(); };
      const addButton = (
        <button onClick={openAdd} disabled={importUploading}
          style={{ ...studioSurface.primary(), width: 'calc(100% - 32px)', margin: '14px 16px 0', cursor: importUploading ? 'default' : 'pointer', fontFamily: 'inherit', opacity: importUploading ? 0.7 : 1 }}>
          {importUploading ? 'Uploading' : 'Add a quote'}
        </button>
      );
      const backLink = (
        <button onClick={() => { setWorthView('main'); setWorthProject(null); }} style={{ ...act, gap: 4, margin: '6px 16px 0', fontWeight: 600 }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7" /></svg>
          Worth
        </button>
      );

      // ── A job's quotes side by side (#app/wverdict) ──
      // A job with no quotes left (all dismissed) shows the main view.
      if (worthView === 'project' && worthProject && projectsByName[worthProject] && projectsByName[worthProject].quotes.length) {
        const pGroup = projectsByName[worthProject];
        const pQuotes = pGroup.quotes.map((q) => ({ ...normalizeQuote(q), status: q.status || 'complete' }));
        const priced = pQuotes.filter((q) => q.status === 'complete' && Number(q.total_value) > 0).sort((a, b) => a.total_value - b.total_value);
        const others = pQuotes.filter((q) => !priced.includes(q));
        const comparable = priced.length >= 2;
        // The portal stores no job on a supplier quote (DATA-GAPS G10), so its
        // quotes all arrive unfiled; they are still set side by side, as the
        // app always has, but never called one job's verdict.
        const filed = worthProject !== 'Unassigned';
        const cheapest = priced[0] || null;
        const dearest = priced[priced.length - 1] || null;
        const max = dearest ? dearest.total_value : 0;
        // A price the reading did not find is null, never £0: it is left out
        // of every comparison and said ("no price on it").
        const num = (v) => (v === null || v === undefined || v === '' || !isFinite(Number(v)) ? null : Number(v));
        const items = pQuotes.flatMap((q) => (q.line_items || []).map((li) => ({
          supplier: q.supplier_name,
          key: String(li.norm_description || li.description || '').toLowerCase().trim(),
          label: li.description || li.norm_description || '',
          quantity: li.quantity, unit: li.unit,
          unit_price: num(li.unit_price != null ? li.unit_price : li.unitPrice),
          total_price: num(li.total_price != null ? li.total_price : li.totalPrice),
        }))).filter((li) => li.key);
        const groups = {};
        items.forEach((li) => { (groups[li.key] = groups[li.key] || { label: li.label, unit: li.unit, items: [] }).items.push(li); });
        // "Priced by more than one" means more than one supplier, not one
        // supplier listing the same line twice.
        const suppliersOf = (g) => new Set(g.items.map((li) => li.supplier)).size;
        const shared = Object.values(groups).filter((g) => suppliersOf(g) > 1);
        const single = Object.values(groups).filter((g) => suppliersOf(g) === 1);
        // Two suppliers whose names start alike are named in full.
        const shortName = (n) => (priced.filter((q) => firstWord(q.supplier_name) === firstWord(n)).length > 1 ? n : firstWord(n));
        // The saving is worked from the totals as shown, so the sum adds up.
        const shownSaving = comparable ? Math.round(dearest.total_value) - Math.round(cheapest.total_value) : 0;
        const lineCount = (q) => (q.line_items || []).length;
        const each = (u) => (u === 'm' ? 'a metre' : 'each');
        return (
          <>
            {backLink}
            <h1 style={{ ...studioType.title(), fontSize: 31, lineHeight: 1.1, margin: '6px 16px 0' }}>
              {comparable && filed ? `${shortName(cheapest.supplier_name)} is cheapest` : jobName(worthProject)}
            </h1>
            <p style={{ ...small, fontSize: 14, margin: '6px 16px 14px' }}>
              {comparable && filed ? `${jobName(worthProject)}. ` : ''}
              {`${pQuotes.length} ${pQuotes.length === 1 ? 'quote' : 'quotes'}`}
              {shared.length ? `, ${shared.length} ${shared.length === 1 ? 'line' : 'lines'} priced by more than one.` : '.'}
              {filed ? '' : ' They aren’t filed to a job, so they may be for different work.'}
            </p>
            <section aria-label="Totals" style={{ ...studioSurface.lit(), borderRadius: S.radius.card, margin: '0 16px', padding: '8px 16px 12px' }}>
              {priced.map((q, i) => {
                // Amber is the cheapest (studio-lit.md), and only for one job's quotes.
                const win = comparable && filed && i === 0;
                const w = max > 0 ? Math.max(8, (q.total_value / max) * 100) : 0;
                return (
                  <div key={q.id || i} title={q.supplier_name} style={{ display: 'grid', gridTemplateColumns: '96px minmax(0,1fr) auto', alignItems: 'center', gap: 12, padding: '12px 0', ...rowLine(i) }}>
                    <span style={{ minWidth: 0 }}>
                      <b style={{ display: 'block', fontSize: 16, color: win ? M.wonText : S.ink, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{shortName(q.supplier_name)}</b>
                      <span style={{ ...small, display: 'block' }}>{lineCount(q)} {lineCount(q) === 1 ? 'line' : 'lines'}</span>
                    </span>
                    <span aria-hidden="true" style={{ display: 'block', height: 14, borderRadius: 7, background: studioRgba(M.slateFill, 0.16) }}>
                      <span style={{ display: 'block', height: '100%', width: w + '%', borderRadius: 7, background: win ? M.wonFill : studioRgba(M.slateFill, 0.45) }} />
                    </span>
                    <span style={{ ...money, fontSize: 16 }}>{pounds(q.total_value)}</span>
                  </div>
                );
              })}
              {others.map((q, i) => (
                <div key={'o' + (q.id || i)} style={{ padding: '10px 0', ...rowLine(priced.length + i) }}>
                  <b style={{ fontSize: 16, color: S.ink }}>{q.supplier_name !== 'Unknown' ? q.supplier_name : 'A quote'}</b>
                  <span style={{ ...small, display: 'block', color: q.status === 'failed' ? M.rustText : S.muted }}>
                    {q.status === 'processing' ? 'Still being read.' : q.status === 'failed' ? 'Couldn’t be read, so it isn’t compared.' : 'No total on it, so it isn’t compared.'}
                  </span>
                </div>
              ))}
              {comparable && filed && shownSaving > 0 && (
                <p data-worth-saving style={{ margin: '4px 0 0', fontSize: 14, color: EMERALD_TEXT, fontWeight: 600 }}>
                  {pounds(shownSaving)} less than {shortName(dearest.supplier_name)}.
                </p>
              )}
              {!comparable && filed && <p style={{ ...small, margin: '4px 0 0' }}>Add another quote for this job to compare them.</p>}
            </section>
            {shared.length > 0 && (
              <section aria-label="Line by line" style={{ margin: '22px 0 0' }}>
                <h2 style={{ ...sec, margin: '0 16px 8px' }}>Line by line</h2>
                <div style={paper}>
                  {shared.map((g, gi) => {
                    // Cheapest only among the lines that carry a price, only
                    // when two or more do, and only for one job's quotes.
                    const withPrice = g.items.filter((li) => li.unit_price != null);
                    const low = filed && withPrice.length >= 2 ? Math.min(...withPrice.map((li) => li.unit_price)) : null;
                    const qty = (li) => (num(li.quantity) != null ? `${li.quantity} ${li.unit === 'm' ? 'm' : 'off'}` : null);
                    // One quantity for the line only when every quote says the same.
                    const sameQty = new Set(g.items.map(qty)).size === 1 ? qty(g.items[0]) : null;
                    return (
                      <div key={gi} style={{ padding: '10px 0', ...rowLine(gi) }}>
                        <div style={{ display: 'flex', gap: 10, alignItems: 'baseline' }}>
                          <b style={{ flex: 1, minWidth: 0, fontSize: 14, color: S.ink, lineHeight: 1.35 }}>{g.label}</b>
                          {sameQty ? <span style={small}>{sameQty}</span> : null}
                        </div>
                        {g.items.map((li, lii) => {
                          const cheap = low != null && li.unit_price === low;
                          const own = !sameQty && qty(li) ? `${qty(li)}, ` : '';
                          return (
                            <div key={lii} style={{ display: 'flex', gap: 10, fontSize: 14, marginTop: 4 }}>
                              <span style={{ flex: 1, minWidth: 0, color: S.ink }}>{li.supplier}{cheap ? <span style={{ color: M.wonText, fontWeight: 600 }}>, cheapest</span> : null}</span>
                              {li.unit_price == null
                                ? <span style={{ fontSize: 14, color: S.muted }}>{own}no price on it</span>
                                : <span style={{ fontSize: 14, color: S.muted }}>{own}<span style={{ ...money, fontWeight: cheap ? 700 : 400 }}>{pence(li.unit_price)}</span> {each(li.unit)}</span>}
                            </div>
                          );
                        })}
                      </div>
                    );
                  })}
                </div>
              </section>
            )}
            {single.length > 0 && (
              <section aria-label="Priced by one supplier" style={{ margin: '22px 0 0' }}>
                <h2 style={{ ...sec, margin: '0 16px 8px' }}>Priced by one supplier</h2>
                <div style={paper}>
                  {single.map((g, gi) => {
                    // Every listing of the line by that supplier, added up;
                    // none priced says so rather than £0.
                    const totals = g.items.map((li) => li.total_price).filter((v) => v != null);
                    return (
                      <div key={gi} style={{ display: 'flex', gap: 10, padding: '10px 0', ...rowLine(gi) }}>
                        <span style={{ flex: 1, minWidth: 0 }}>
                          <b style={{ fontSize: 14, color: S.ink, lineHeight: 1.35 }}>{g.label}</b>
                          <span style={{ ...small, display: 'block' }}>{g.items[0].supplier} only</span>
                        </span>
                        {totals.length
                          ? <span style={{ ...money, fontWeight: 400, fontSize: 14 }}>{pounds(totals.reduce((a, b) => a + b, 0))}</span>
                          : <span style={{ fontSize: 14, color: S.muted }}>no price on it</span>}
                      </div>
                    );
                  })}
                </div>
              </section>
            )}
          </>
        );
      }

      // ── The quotes that came in, and what they compare to (#app/wshare) ──
      const fileOf = (q) => q.file_name || q.fileName || '';
      const extOf = (q) => { const m = fileOf(q).match(/\.([a-z0-9]{2,4})$/i); return m ? m[1].toUpperCase() : 'File'; };
      const at = (q) => { const d = new Date(q.received_at || q.uploadDate || 0); return isNaN(d) ? 0 : d.getTime(); };
      const inbound = [...allQuotes, ...quotes].slice().sort((a, b) => at(b) - at(a) || (Number(b.id) || 0) - (Number(a.id) || 0));
      const newest = inbound[0] || null;
      const sameDay = (q) => newest && new Date(at(q)).toDateString() === new Date(at(newest)).toDateString();
      const latest = inbound.filter(sameDay).slice(0, 6);
      const projects = Object.entries(projectsByName);
      // A quote with no supplier read yet is not a supplier.
      const suppliers = Object.entries(supplierGroups).filter(([n]) => n !== 'Unknown');
      const expiring = inbound.filter((q) => {
        const exp = q.expiryDate || q.expiry_date;
        return exp && new Date(exp) > new Date() && (new Date(exp) - new Date()) / 86400000 < 14;
      }).slice(0, 2);
      const status = (q) => {
        if (q.status === 'processing') return <span style={small}>Reading</span>;
        if (q.status === 'failed') return <span style={{ ...small, color: M.rustText }}>Couldn’t read it</span>;
        return (
          <span style={{ ...small, color: S.ink, display: 'inline-flex', alignItems: 'center', gap: 4 }}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M4 8.5l2.6 2.6L12 5.5" /></svg>
            {q.confirmed ? 'Checked' : 'Read'}
          </span>
        );
      };
      const nameOf = (q) => q.supplier_name || q.supplier || (q.status === 'processing' ? 'Supplier not read yet' : 'No supplier on it');
      return (
        <>
          <input ref={importFileRef} type="file" accept="application/pdf,image/*" style={{ display: 'none' }} onChange={handleImportFileSelect} />
          <h1 style={{ ...studioType.title(), fontSize: 39, lineHeight: 1.02, margin: '10px 16px 0' }}>{newest ? `${latest.length} ${latest.length === 1 ? 'quote' : 'quotes'} in` : 'Worth'}</h1>
          {newest ? (
            <section aria-label="Quotes in" style={{ margin: '6px 0 0' }}>
              <p style={{ ...small, fontSize: 14, margin: '0 16px 14px' }}>Supplier quotes. The last one came in {when(newest.received_at || newest.uploadDate) || 'recently'}.</p>
              <div style={paper}>
                {latest.map((q, i) => (
                  <div key={q.id || i} style={{ display: 'flex', alignItems: 'center', gap: 12, minHeight: 56, padding: '8px 0', ...rowLine(i) }}>
                    <span aria-hidden="true" style={{ ...studioSurface.pressed(), borderRadius: 10, width: 44, height: 44, flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 700, color: S.muted }}>{extOf(q)}</span>
                    <span style={{ flex: 1, minWidth: 0 }}>
                      <b style={{ display: 'block', fontSize: 16, color: S.ink, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{nameOf(q)}</b>
                      {fileOf(q) && <span style={{ ...small, display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{fileOf(q)}</span>}
                    </span>
                    {status(q)}
                  </div>
                ))}
              </div>
            </section>
          ) : (
            <p style={{ margin: '14px 16px 0', fontSize: 16, lineHeight: 1.45, color: S.ink }}>
              No supplier quotes yet. Photograph one or upload a PDF and it’s read line by line, so you can see who’s cheapest.
            </p>
          )}
          {pollingStatus === 'polling' && <p style={{ ...small, fontSize: 14, margin: '10px 16px 0' }}>Reading the quote you added. It takes a few seconds.</p>}
          {pollingStatus === 'failed' && <p style={{ ...small, fontSize: 14, margin: '10px 16px 0', color: M.rustText }}>Couldn’t read that quote. A clearer photo usually works.</p>}
          {pollingStatus === 'timeout' && <p style={{ ...small, fontSize: 14, margin: '10px 16px 0' }}>Still reading. A big quote can take a minute.</p>}
          {importError && <p style={{ ...small, fontSize: 14, margin: '10px 16px 0', color: M.rustText }}>That didn’t upload. Try Add a quote again.</p>}
          {addButton}
          {(expiring.length > 0 || failedCount > 0) && (
            <section aria-label="Needs a look" style={{ margin: '14px 16px 0' }}>
              {expiring.map((q, qi) => (
                <p key={q.id || qi} style={{ margin: '0 0 6px', fontSize: 14, color: M.rustText, lineHeight: 1.4 }}>
                  {q.supplier_name || q.supplier}’s quote runs out in {Math.ceil((new Date(q.expiryDate || q.expiry_date) - new Date()) / 86400000)} days.
                </p>
              ))}
              {failedCount > 0 && (
                <button onClick={clearFailedQuotes} style={act}>
                  {failedCount === 1 ? 'Clear the one that couldn’t be read' : `Clear the ${failedCount} that couldn’t be read`}
                </button>
              )}
            </section>
          )}
          {projects.length > 0 && (
            <section aria-label="Compared by job" style={{ margin: '22px 0 0' }}>
              <h2 style={{ ...sec, margin: '0 16px 8px' }}>Compared by job</h2>
              <div style={paper}>
                {projects.map(([pName, pGroup], i) => {
                  const pr = pGroup.quotes.filter((q) => (q.status || 'complete') === 'complete' && Number(q.total_value || q.totalValue) > 0)
                    .map((q) => ({ name: q.supplier_name || q.supplier, total: Number(q.total_value || q.totalValue) }))
                    .sort((a, b) => a.total - b.total);
                  const n = pGroup.quotes.length;
                  return (
                    <div key={pName} role="button" tabIndex={0} onClick={() => { setWorthProject(pName); setWorthView('project'); }}
                      style={{ display: 'flex', alignItems: 'center', gap: 12, minHeight: 56, padding: '8px 0', cursor: 'pointer', ...rowLine(i) }}>
                      <span style={{ flex: 1, minWidth: 0 }}>
                        <b style={{ display: 'block', fontSize: 16, color: S.ink }}>{jobName(pName)}</b>
                        <span style={{ ...small, display: 'block' }}>
                          {n} {n === 1 ? 'quote' : 'quotes'}{pName === 'Unassigned' ? '' : pr.length >= 2 ? `, ${firstWord(pr[0].name)} cheapest` : n === 1 ? '. Add another to compare.' : ''}
                        </span>
                      </span>
                      {pr.length > 0 && pName !== 'Unassigned' && <span style={{ ...money, fontSize: 16 }}>{pounds(pr[0].total)}</span>}
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={S.muted} strokeWidth="2" strokeLinecap="round" aria-hidden="true"><path d="M9 6l6 6-6 6" /></svg>
                    </div>
                  );
                })}
              </div>
            </section>
          )}
          {suppliers.length > 0 && (
            <section aria-label="Your suppliers" style={{ margin: '22px 0 0' }}>
              <h2 style={{ ...sec, margin: '0 16px 8px' }}>Your suppliers</h2>
              <div style={paper}>
                {suppliers.map(([sName, sGroup], i) => {
                  // "Not filed to a job" is not a job.
                  const jobs = [...sGroup.projectNames].filter((n) => n !== 'Unassigned').length;
                  return (
                    <div key={sName} role="button" tabIndex={0} onClick={() => { setWorthSupplier(sName); setWorthView('supplier'); }}
                      style={{ display: 'flex', alignItems: 'center', gap: 12, minHeight: 52, padding: '6px 0', cursor: 'pointer', ...rowLine(i) }}>
                      <span style={{ flex: 1, minWidth: 0 }}>
                        <b style={{ display: 'block', fontSize: 16, color: S.ink }}>{sName}</b>
                        <span style={{ ...small, display: 'block' }}>{sGroup.quotes.length} {sGroup.quotes.length === 1 ? 'quote' : 'quotes'}{jobs > 0 ? `, ${jobs} ${jobs === 1 ? 'job' : 'jobs'}` : ''}</span>
                      </span>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={S.muted} strokeWidth="2" strokeLinecap="round" aria-hidden="true"><path d="M9 6l6 6-6 6" /></svg>
                    </div>
                  );
                })}
              </div>
            </section>
          )}
        </>
      );
    };
    return (
      <div style={{ flex: 1, overflowY: 'auto', WebkitOverflowScrolling: 'touch', overscrollBehavior: 'contain', display: 'flex', flexDirection: 'column', background: 'transparent' }}>
        <div data-worth-lit style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden', padding: '4px 0 120px', position: 'relative', fontFamily: STUDIO_TOKENS.fonts.body, color: STUDIO_TOKENS.ink, ...studioColumn }}>
          <WorthLitBody draw={renderWorthLit} />
        </div>
        <TabBar active={15} onChange={onNav} divisionId={divId} />
      </div>
    );
  }

  // ── View 2: Supplier detail ──
  if (worthView === 'supplier' && worthSupplier) {
    const sGroup = supplierGroups[worthSupplier];
    if (!sGroup) { setWorthView('main'); return null; }
    const sData = computeSupplierScore(worthSupplier);
    const catEntries = Object.entries(sData.categories).filter(([,v]) => v.total > 0);
    const sQuotes = sGroup.quotes;
    const projectCount = sGroup.projectNames.size;

    return studioDesk(
      <div style={{ flex: 1, overflowY: 'auto', WebkitOverflowScrolling: 'touch', overscrollBehavior: 'contain', paddingBottom: 100, background: '#E8DCC8', display: 'flex', flexDirection: 'column' }}>
        <ScreenBlobs />
        <div style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden', paddingBottom: 83, position: 'relative', ...uvx(studioColumn) }}>
          {/* Back nav */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 18px 12px', background: 'rgba(232,220,200,0.97)', backdropFilter: 'blur(16px)', WebkitBackdropFilter: 'blur(16px)', position: 'sticky', top: 0, zIndex: 20, borderBottom: '1px solid rgba(28,24,16,0.07)' }}>
            <button onClick={() => { setWorthView('main'); setWorthSupplier(null); }} style={{ display: 'flex', alignItems: 'center', gap: 4, background: 'none', border: 'none', cursor: 'pointer', fontFamily: 'inherit', padding: 0 }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M15 18l-6-6 6-6" stroke="#BF9428" strokeWidth="2.5" strokeLinecap="round"/></svg>
              <span style={{ fontSize: 15, fontWeight: 700, color: '#BF9428' }}>Worth</span>
            </button>
            <span style={{ fontSize: 15, fontWeight: 800, color: '#1C1810' }}>{worthSupplier}</span>
            <div style={{ width: 60 }} />
          </div>

          {/* Hero — supplier competitive score */}
          <div style={{ margin: '14px 14px 0', background: worthColors.heroGradient, borderRadius: 22, padding: '22px 20px 18px', position: 'relative', overflow: 'hidden', ...uvx({ display: 'flex', flexDirection: 'column' }) }}>
            <div style={{ position: 'absolute', top: -50, right: -30, width: 140, height: 140, borderRadius: 70, background: 'rgba(191,148,40,0.12)', pointerEvents: 'none' }} />
            <div style={{ position: 'absolute', bottom: -25, left: 20, width: 90, height: 90, borderRadius: 45, background: 'rgba(8,28,56,0.4)', pointerEvents: 'none' }} />
            <div style={{ fontSize: 10, fontWeight: 800, letterSpacing: '0.14em', textTransform: 'uppercase', color: worthColors.goldMuted, marginBottom: 10, position: 'relative', zIndex: 1, ...uvx({ order: 2, marginTop: 10, marginBottom: 0 }) }}>COMPETITIVE SCORE</div>
            <div style={{ position: 'relative', zIndex: 1 }}>
              <div style={{ display: 'flex', alignItems: 'flex-end', gap: 8, marginBottom: 6 }}>
                <div style={{ fontSize: 52, fontWeight: 800, color: 'rgba(255,252,242,0.97)', letterSpacing: '-0.03em', fontStyle: 'italic', lineHeight: 1, fontFamily: 'Georgia, serif', ...uvx(() => ({ ...studioType.display(), fontSize: 84 })) }}>{sData.score}</div>
                <div style={{ fontSize: 18, fontWeight: 600, color: 'rgba(255,252,242,0.35)', marginBottom: 6 }}>/100</div>
              </div>
              <div style={{ fontSize: 12, color: 'rgba(255,252,242,0.38)', marginBottom: 14 }}>
                {sData.wins > 0 ? `Won ${sData.wins} of ${sData.total} projects` : `${sQuotes.length} quotes across ${projectCount} project${projectCount !== 1 ? 's' : ''}`}
              </div>
              <div style={{ height: 1, background: 'rgba(255,252,242,0.08)', marginBottom: 12 }} />
              <div style={{ display: 'flex' }}>
                {[
                  { label: 'Quotes', value: sQuotes.length },
                  { label: 'Projects', value: projectCount },
                  { label: 'Total value', value: fmt(sGroup.totalValue) },
                ].map((s, si) => (
                  <div key={s.label} style={{ flex: 1, textAlign: 'center', borderLeft: si > 0 ? '1px solid rgba(255,252,242,0.08)' : 'none' }}>
                    <div style={{ fontSize: 14, fontWeight: 800, color: 'rgba(255,252,242,0.82)' }}>{s.value}</div>
                    <div style={{ fontSize: 9, color: 'rgba(255,252,242,0.3)', fontWeight: 700, letterSpacing: '0.07em', textTransform: 'uppercase', marginTop: 2 }}>{s.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Category competitiveness */}
          {catEntries.length > 0 && (
            <div style={{ margin: '14px 14px 0' }}>
              <div style={{ fontSize: 11, fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.09em', color: 'rgba(28,24,16,0.35)', marginBottom: 9, ...uvx(studioSection) }}>CATEGORY COMPETITIVENESS</div>
              <div style={{ background: 'rgba(255,252,242,0.88)', border: '1px solid rgba(255,255,250,0.92)', borderRadius: 17, padding: '4px 14px', overflow: 'hidden' }}>
                {catEntries.map(([cat, cv], ci) => {
                  const catScore = cv.total > 0 ? Math.round((cv.wins / cv.total) * 100) : 50;
                  const catLabel = cat.charAt(0).toUpperCase() + cat.slice(1);
                  return (
                    <div key={cat} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '11px 0', borderTop: ci > 0 ? '1px solid rgba(28,24,16,0.06)' : 'none' }}>
                      <span style={{ fontSize: 12, fontWeight: 700, color: '#1C1810', flex: 1 }}>{catLabel}</span>
                      <div style={{ width: 80, height: 5, background: 'rgba(28,24,16,0.08)', borderRadius: 3, overflow: 'hidden' }}>
                        <div style={{ width: `${catScore}%`, height: '100%', borderRadius: 3, background: scoreColor(catScore) }} />
                      </div>
                      <span style={{ fontSize: 12, fontWeight: 800, color: scoreColor(catScore), width: 36, textAlign: 'right' }}>{catScore}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {/* Coverage chips */}
          {sGroup.categories.size > 0 && (
            <div style={{ margin: '14px 14px 0' }}>
              <div style={{ fontSize: 11, fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.09em', color: 'rgba(28,24,16,0.35)', marginBottom: 9, ...uvx(studioSection) }}>COVERAGE</div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                {[...sGroup.categories].map(cat => (
                  <div key={cat} style={{ background: 'rgba(191,148,40,0.08)', border: '1px solid rgba(191,148,40,0.2)', borderRadius: 20, padding: '5px 12px' }}>
                    <span style={{ fontSize: 11, fontWeight: 700, color: '#8A6010' }}>{cat.charAt(0).toUpperCase() + cat.slice(1)}</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Intelligence insight cards */}
          <div style={{ margin: '14px 14px 0' }}>
            <div style={{ fontSize: 11, fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.09em', color: 'rgba(28,24,16,0.35)', marginBottom: 9, ...uvx(studioSection) }}>INTELLIGENCE</div>
            {[
              { icon: 'M20 12V8H6a2 2 0 010-4h12V2M6 12h14v4H6a2 2 0 000 4h14v2', title: 'Price trend', body: sData.score >= 70 ? 'Consistently competitive' + studioDash() + 'good pricing reliability.' : sData.score >= 40 ? 'Mixed competitiveness' + studioDash() + 'worth comparing on larger orders.' : 'Above market on most categories' + studioDash() + 'consider alternatives.' },
              { icon: 'M12 2v10l4.5 4.5', title: 'Quote coverage', body: `${sQuotes.length} quote${sQuotes.length !== 1 ? 's' : ''} submitted across ${projectCount} project${projectCount !== 1 ? 's' : ''}. ${sGroup.categories.size > 3 ? 'Wide product range.' : 'Narrow product focus.'}` },
              { icon: 'M17 1l4 4-4 4M3 11V9a4 4 0 014-4h14M7 23l-4-4 4-4M21 13v2a4 4 0 01-4 4H3', title: 'Recommendation', body: sData.score >= 70 ? 'Strong supplier' + studioDash() + 'consider for preferred status.' : sData.score >= 40 ? 'Adequate supplier' + studioDash() + 'benchmark regularly.' : 'Underperforming' + studioDash() + 'negotiate harder or diversify.' }
            ].map((card, ci) => (
              <div key={ci} style={{ background: 'rgba(255,252,242,0.88)', border: '1px solid rgba(255,255,250,0.92)', borderRadius: 15, padding: '12px 14px', marginBottom: 7 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <div style={{ width: 32, height: 32, borderRadius: 9, background: 'rgba(28,24,16,0.05)', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="rgba(28,24,16,0.45)" strokeWidth="2" strokeLinecap="round"><path d={card.icon}/></svg>
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 13, fontWeight: 800, color: '#1C1810', marginBottom: 2 }}>{card.title}</div>
                    <div style={{ fontSize: 11, color: 'rgba(28,24,16,0.5)', lineHeight: 1.45 }}>{card.body}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Recent quotes from this supplier */}
          <div style={{ margin: '14px 14px 0', paddingBottom: 20 }}>
            <div style={{ fontSize: 11, fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.09em', color: 'rgba(28,24,16,0.35)', marginBottom: 9, ...uvx(() => ({ ...studioSection(), textTransform: 'none' })) }}>{t.theme === 'uv' ? 'Quotes from ' : 'QUOTES FROM '}{t.theme === 'uv' ? worthSupplier : worthSupplier.toUpperCase()}</div>
            {sQuotes.map((sq, si) => (
              <div key={sq.id || si} style={{ background: 'rgba(255,252,242,0.88)', border: '1px solid rgba(255,255,250,0.92)', borderRadius: 15, padding: '11px 14px', marginBottom: 6, cursor: 'pointer' }}
                onClick={() => { setWorthProject(sq.project_name || 'Unassigned'); setWorthView('project'); }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <div style={{ fontSize: 13, fontWeight: 700, color: '#1C1810' }}>{sq.project_name || 'Unassigned'}</div>
                    <div style={{ fontSize: 11, color: 'rgba(28,24,16,0.38)', marginTop: 1 }}>{sq.received_at ? new Date(sq.received_at).toLocaleDateString('en-GB', { day: 'numeric', month: 'short' }) : ''}</div>
                  </div>
                  <div style={{ fontSize: 15, fontWeight: 800, color: worthColors.gold, fontFamily: "system-ui, -apple-system, sans-serif", fontStyle: 'italic' }}>{fmtFull(sq.total_value)}</div>
                </div>
              </div>
            ))}
          </div>

          <div style={{ height: 24 }} />
        </div>
        <TabBar active={15} onChange={onNav} divisionId={divId} />
      </div>
    );
  }

  // ── View 3: Project quotes ──
  if (worthView === 'project' && worthProject) {
    const pGroup = projectsByName[worthProject];
    if (!pGroup || !pGroup.quotes.length) { setWorthView('main'); return null; }
    const pQuotes = pGroup.quotes;
    const cheapestQuote = pQuotes.reduce((min, q) => ((q.total_value || 0) < (min.total_value || 0)) ? q : min, pQuotes[0]);
    // Build line item comparison
    const allLineItems = pQuotes.flatMap(q => (q.line_items || []).map(li => ({
      ...li, supplier: q.supplier_name || q.supplier, quoteId: q.id,
      unit_price: li.unit_price || li.unitPrice || 0,
      total_price: li.total_price || li.totalPrice || 0,
      description: li.norm_description || li.description || li.rawDescription || '\u2014',
      quantity: li.quantity || li.qty || 0
    })));
    const matchGroups = {};
    allLineItems.forEach(li => {
      const key = (li.norm_description || li.description || '').toLowerCase().trim();
      if (!key) return;
      if (!matchGroups[key]) matchGroups[key] = { label: li.description, items: [] };
      matchGroups[key].items.push(li);
    });
    const lineGroups = Object.values(matchGroups);
    const totalLineItems = lineGroups.length;

    return studioDesk(
      <div style={{ flex: 1, overflowY: 'auto', WebkitOverflowScrolling: 'touch', overscrollBehavior: 'contain', paddingBottom: 100, background: '#E8DCC8', display: 'flex', flexDirection: 'column' }}>
        <ScreenBlobs />
        <div style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden', paddingBottom: 83, position: 'relative', ...uvx(studioColumn) }}>
          {/* Back nav */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 18px 12px', background: 'rgba(232,220,200,0.97)', backdropFilter: 'blur(16px)', WebkitBackdropFilter: 'blur(16px)', position: 'sticky', top: 0, zIndex: 20, borderBottom: '1px solid rgba(28,24,16,0.07)' }}>
            <button onClick={() => { setWorthView('main'); setWorthProject(null); }} style={{ display: 'flex', alignItems: 'center', gap: 4, background: 'none', border: 'none', cursor: 'pointer', fontFamily: 'inherit', padding: 0 }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M15 18l-6-6 6-6" stroke="#BF9428" strokeWidth="2.5" strokeLinecap="round"/></svg>
              <span style={{ fontSize: 15, fontWeight: 700, color: '#BF9428' }}>Worth</span>
            </button>
            <span style={{ fontSize: 15, fontWeight: 800, color: '#1C1810' }}>{worthProject}</span>
            <div style={{ width: 60 }} />
          </div>

          {/* Hero — cheapest total with supplier columns */}
          <div style={{ margin: '14px 14px 0', background: worthColors.heroGradient, borderRadius: 22, padding: '20px 18px 16px', position: 'relative', overflow: 'hidden', ...uvx({ display: 'flex', flexDirection: 'column' }) }}>
            <div style={{ position: 'absolute', top: -50, right: -30, width: 140, height: 140, borderRadius: 70, background: 'rgba(191,148,40,0.12)', pointerEvents: 'none' }} />
            <div style={{ fontSize: 10, fontWeight: 800, letterSpacing: '0.14em', textTransform: 'uppercase', color: worthColors.goldMuted, marginBottom: 4, position: 'relative', zIndex: 1, ...uvx({ order: 2, marginTop: 10, marginBottom: 0 }) }}>CHEAPEST TOTAL</div>
            <div style={{ position: 'relative', zIndex: 1 }}>
              <div style={{ fontSize: 36, fontWeight: 800, color: 'rgba(255,252,242,0.97)', letterSpacing: '-0.025em', fontStyle: 'italic', lineHeight: 1, fontFamily: 'Georgia, serif', marginBottom: 4, ...uvx(() => ({ ...studioType.display(), fontSize: 84, color: STUDIO_TOKENS.ochre })) }}>{fmtFull(cheapestQuote.total_value)}</div>
              <div style={{ fontSize: 12, color: 'rgba(255,252,242,0.38)', marginBottom: 14 }}>{pQuotes.length} quote{pQuotes.length !== 1 ? 's' : ''}{t.theme === 'uv' ? ', ' : ' \\u00B7 '}{totalLineItems} line items</div>
              <div style={{ display: 'flex', gap: 6 }}>
                {pQuotes.map(q => {
                  const isWinner = q.id === cheapestQuote.id;
                  return (
                    <div key={q.id} style={{ flex: 1, borderRadius: 11, padding: '9px 8px', textAlign: 'center', background: isWinner ? 'rgba(30,96,48,0.28)' : 'rgba(255,252,242,0.08)', border: isWinner ? '1px solid rgba(60,160,80,0.35)' : '1px solid rgba(255,252,242,0.12)' }}>
                      <div style={{ fontSize: 10, fontWeight: 800, color: 'rgba(255,252,242,0.55)', marginBottom: 3, letterSpacing: '0.04em', textTransform: 'uppercase', ...uvx({ textTransform: 'none' }) }}>{q.supplier_name || q.supplier}</div>
                      <div style={{ fontSize: 16, fontWeight: 800, color: 'rgba(255,252,242,0.93)', fontStyle: 'italic' }}>{fmt(q.total_value)}</div>
                      {isWinner && <div style={{ fontSize: 9, fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.07em', color: 'rgba(100,210,140,0.8)', marginTop: 3 }}>{'\u2713'} Best price</div>}
                      {!isWinner && <div style={{ fontSize: 10, fontWeight: 700, color: 'rgba(255,252,242,0.4)', marginTop: 2 }}>+{fmt((q.total_value || 0) - (cheapestQuote.total_value || 0))}</div>}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          {/* Line items — always expanded */}
          <div style={{ margin: '14px 14px 0' }}>
            <div style={{ fontSize: 11, fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.09em', color: 'rgba(28,24,16,0.35)', marginBottom: 9, ...uvx(studioSection) }}>LINE ITEM COMPARISON</div>
            {lineGroups.map((lg, lgi) => {
              const cheapestLi = lg.items.reduce((min, li) => (li.unit_price < min.unit_price) ? li : min, lg.items[0]);
              return (
                <div key={lgi} style={{ background: 'rgba(255,252,242,0.88)', border: '1px solid rgba(255,255,250,0.92)', borderRadius: 13, padding: '10px 12px', marginBottom: 6 }}>
                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8, marginBottom: 7 }}>
                    <div style={{ flex: 1, fontSize: 12, fontWeight: 700, color: '#1C1810', lineHeight: 1.3 }}>{lg.label}</div>
                    {lg.items[0] && <div style={{ fontSize: 11, color: 'rgba(28,24,16,0.38)', fontWeight: 600, whiteSpace: 'nowrap' }}>{'\u00D7'}{lg.items[0].quantity}</div>}
                  </div>
                  <div style={{ display: 'flex', gap: 5 }}>
                    {lg.items.map((li, lii) => {
                      const isCheap = li.unit_price <= cheapestLi.unit_price && lg.items.length > 1;
                      return (
                        <div key={lii} style={{ flex: 1, borderRadius: 9, padding: '6px 7px', textAlign: 'center', background: isCheap ? 'rgba(30,80,30,0.07)' : 'rgba(28,24,16,0.03)', border: isCheap ? '1px solid rgba(30,80,30,0.18)' : '1px solid rgba(28,24,16,0.07)' }}>
                          <div style={{ fontSize: 9, fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.05em', color: isCheap ? '#1E6030' : 'rgba(28,24,16,0.38)', marginBottom: 2, ...uvx({ textTransform: 'none' }) }}>{li.supplier}</div>
                          <div style={{ fontSize: 13, fontWeight: 800, color: isCheap ? '#1E6030' : '#1C1810' }}>{isCheap ? (t.theme === 'uv' ? <span style={{ color: STUDIO_TOKENS.ink }}>{'\u2713 '}</span> : '\u2713 ') : ''}{studioPound(Number(li.unit_price).toFixed(2))[0]}{studioPound(Number(li.unit_price).toFixed(2))[1]}</div>
                          <div style={{ fontSize: 9, color: 'rgba(28,24,16,0.38)', fontWeight: 600 }}>{li.unit === 'm' ? 'per m' : 'each'}</div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>

          {/* Unmatched / single-supplier items */}
          {allLineItems.filter(li => {
            const key = (li.norm_description || li.description || '').toLowerCase().trim();
            return matchGroups[key] && matchGroups[key].items.length === 1;
          }).length > 0 && (
            <div style={{ margin: '14px 14px 0' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 7, marginBottom: 8 }}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none"><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" stroke="#8A6010" strokeWidth="2.5" strokeLinecap="round"/></svg>
                <span style={{ fontSize: 11, fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.08em', color: 'rgba(191,148,40,0.8)', ...uvx(studioSection) }}>Single-supplier items</span>
              </div>
              {lineGroups.filter(lg => lg.items.length === 1).map((lg, lgi) => (
                <div key={lgi} style={{ display: 'flex', alignItems: 'center', gap: 10, background: 'rgba(191,148,40,0.05)', border: '1px solid rgba(191,148,40,0.18)', borderRadius: 11, padding: '9px 12px', marginBottom: 6 }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 11, fontWeight: 800, color: 'rgba(28,24,16,0.55)' }}>{lg.items[0].supplier} only</div>
                    <div style={{ fontSize: 12, fontWeight: 700, color: '#1C1810', marginTop: 1 }}>{lg.label}</div>
                  </div>
                  <div style={{ fontSize: 13, fontWeight: 800, color: 'rgba(28,24,16,0.6)' }}>{studioPound(Number(lg.items[0].total_price).toFixed(2))[0]}{studioPound(Number(lg.items[0].total_price).toFixed(2))[1]}</div>
                </div>
              ))}
            </div>
          )}

          {/* Project assignment info */}
          <div style={{ margin: '14px 14px 0', paddingBottom: 20 }}>
            <div style={{ background: 'rgba(255,252,242,0.88)', border: '1px solid rgba(255,255,250,0.92)', borderRadius: 15, padding: '12px 14px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <div style={{ width: 32, height: 32, borderRadius: 9, background: 'rgba(30,80,30,0.08)', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><polyline points="20 6 9 17 4 12" stroke="#1E6030" strokeWidth="2.5" strokeLinecap="round"/></svg>
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 13, fontWeight: 800, color: '#1C1810' }}>Project: {worthProject}</div>
                  <div style={{ fontSize: 11, color: 'rgba(28,24,16,0.45)', marginTop: 2 }}>{pQuotes.length} quote{pQuotes.length !== 1 ? 's' : ''}{t.theme === 'uv' ? ', best: ' : ' \\u00B7 Best: '}{cheapestQuote.supplier_name || cheapestQuote.supplier} at {fmtFull(cheapestQuote.total_value)}</div>
                </div>
              </div>
            </div>
          </div>

          <div style={{ height: 24 }} />
        </div>
        <TabBar active={15} onChange={onNav} divisionId={divId} />
      </div>
    );
  }

  // ── Legacy comparison view (localStorage quotes) ──
  if (worthView === 'comparison' && selectedProjectId) {
    const group = projectGroups[selectedProjectId];
    if (!group) { setWorthView('main'); return null; }
    // Redirect to new project view
    setWorthProject(group.projectName);
    setWorthView('project');
    return null;
  }

  // ── Main view ──
  return studioDesk(
    <div style={{ flex: 1, overflowY: 'auto', WebkitOverflowScrolling: 'touch', overscrollBehavior: 'contain', paddingBottom: 100, background: '#E8DCC8', display: 'flex', flexDirection: 'column' }}>
      <ScreenBlobs />
      {/* Hidden inputs */}
      <input ref={importFileRef} type="file" accept="application/pdf,image/*" style={{ display: 'none' }} onChange={handleImportFileSelect} />

      {/* ── Nav bar ── */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 18px 12px', background: 'rgba(232,220,200,0.97)', backdropFilter: 'blur(16px)', WebkitBackdropFilter: 'blur(16px)', position: 'sticky', top: 0, zIndex: 20, borderBottom: '1px solid rgba(28,24,16,0.07)', ...uvx(studioColumn) }}>
        <span style={{ fontSize: 22, fontWeight: 800, color: '#1C1810', letterSpacing: '-0.02em', ...uvx(studioPageTitle) }}>Worth</span>
        <button
          onClick={() => { if (!importUploading && importFileRef.current) importFileRef.current.click(); }}
          disabled={importUploading}
          style={{ display: 'flex', alignItems: 'center', gap: 5, background: '#091E38', border: 'none', borderRadius: 18, padding: '7px 14px', cursor: importUploading ? 'default' : 'pointer', fontFamily: 'inherit', opacity: importUploading ? 0.7 : 1, ...uvx(hasAnyQuotes ? { ...studioSurface.primary(), padding: '7px 18px', opacity: 1 } : {}) }}
        >
          {importUploading ? (
            <>
              <div style={{ width: 13, height: 13, border: '2px solid rgba(255,252,242,0.3)', borderTopColor: 'rgba(255,252,242,0.88)', borderRadius: '50%', animation: 'spin 0.6s linear infinite', flexShrink: 0 }} />
              <span style={{ fontSize: 13, fontWeight: 800, color: 'rgba(255,252,242,0.88)' }}>Uploading</span>
            </>
          ) : (
            <>
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none"><path d="M12 5v14M5 12h14" stroke={t.theme === 'uv' && hasAnyQuotes ? STUDIO_TOKENS.onPrimary : "rgba(255,252,242,0.85)"} strokeWidth="2.5" strokeLinecap="round"/></svg>
              <span style={{ fontSize: 13, fontWeight: 800, color: 'rgba(255,252,242,0.88)', ...uvx({ fontSize: 16, fontWeight: 600 }) }}>Add quote</span>
            </>
          )}
        </button>
      </div>

      {importError && (
        <div style={{ fontSize: 12, color: '#C03C32', fontWeight: 600, textAlign: 'center', margin: '8px 16px 0', position: 'relative', zIndex: 2 }}>{'Upload failed' + studioDash() + 'tap Add quote to retry'}</div>
      )}

      <div style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden', paddingBottom: 83, position: 'relative', ...uvx(studioColumn) }}>

        {/* ── Hero — gold → deep plum → near-black navy ── */}
        <div style={{ margin: '16px 14px 0', background: 'linear-gradient(135deg, #BF9428 0%, #2D1540 52%, #081C38 100%)', borderRadius: 22, padding: '20px 20px 18px', position: 'relative', overflow: 'hidden', ...uvx({ display: 'flex', flexDirection: 'column' }) }}>
          {/* Decorative circles */}
          <div style={{ position: 'absolute', top: -50, right: -30, width: 140, height: 140, borderRadius: 70, background: 'rgba(191,148,40,0.12)', pointerEvents: 'none' }} />
          <div style={{ position: 'absolute', bottom: -25, left: 20, width: 90, height: 90, borderRadius: 45, background: 'rgba(8,28,56,0.4)', pointerEvents: 'none' }} />

          <div style={{ fontSize: 10, fontWeight: 800, letterSpacing: '0.14em', textTransform: 'uppercase', color: 'rgba(191,148,40,0.65)', marginBottom: 10, position: 'relative', zIndex: 1, ...uvx({ order: 2, marginTop: 10, marginBottom: 0 }) }}>PROCUREMENT INTELLIGENCE</div>

          {hasAnyQuotes ? (
            <div style={{ position: 'relative', zIndex: 1 }}>
              <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 14 }}>
                <div>
                  <div style={{ fontSize: 36, fontWeight: 800, color: 'rgba(255,252,242,0.97)', letterSpacing: '-0.025em', fontStyle: 'italic', lineHeight: 1, fontFamily: 'Georgia, serif', ...uvx(() => ({ ...studioType.display(), fontSize: 84, color: STUDIO_TOKENS.ochre })) }}>
                    {studioPound(totalSupplyValue >= 1000 ? (totalSupplyValue / 1000).toFixed(1) + 'k' : totalSupplyValue.toLocaleString('en-GB'))[0]}{studioPound(totalSupplyValue >= 1000 ? (totalSupplyValue / 1000).toFixed(1) + 'k' : totalSupplyValue.toLocaleString('en-GB'))[1]}
                  </div>
                  <div style={{ fontSize: 12, color: 'rgba(255,252,242,0.38)', marginTop: 5, letterSpacing: '0.01em' }}>total supply value</div>
                </div>
                <div style={{ background: 'rgba(255,252,242,0.1)', border: '1px solid rgba(255,252,242,0.15)', borderRadius: 20, padding: '7px 11px', textAlign: 'right', flexShrink: 0 }}>
                  <div style={{ fontSize: 14, fontWeight: 800, color: 'rgba(100,210,150,0.9)' }}>+{allQuotes.length}</div>
                  <div style={{ fontSize: 9, color: 'rgba(255,252,242,0.35)', fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', marginTop: 1 }}>This month</div>
                </div>
              </div>
              <div style={{ height: 1, background: 'rgba(255,252,242,0.08)', marginBottom: 12 }} />
              <div style={{ display: 'flex' }}>
                {[
                  { label: 'Quotes', value: allQuotes.length },
                  { label: 'Suppliers', value: allSupplierNames.length },
                  { label: 'Avg margin', value: '\u2014' },
                ].map((s, si) => (
                  <div key={s.label} style={{ flex: 1, textAlign: 'center', borderLeft: si > 0 ? '1px solid rgba(255,252,242,0.08)' : 'none' }}>
                    <div style={{ fontSize: 14, fontWeight: 800, color: 'rgba(255,252,242,0.82)' }}>{s.value}</div>
                    <div style={{ fontSize: 9, color: 'rgba(255,252,242,0.3)', fontWeight: 700, letterSpacing: '0.07em', textTransform: 'uppercase', marginTop: 2 }}>{s.label}</div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div style={{ position: 'relative', zIndex: 1 }}>
              <div style={{ fontSize: 20, fontWeight: 800, color: 'rgba(255,252,242,0.95)', lineHeight: 1.22, marginBottom: 8, letterSpacing: '-0.01em' }}>Know exactly what your supply is costing you.</div>
              <div style={{ fontSize: 13, color: 'rgba(255,252,242,0.38)', lineHeight: 1.55 }}>{"Upload 3 quotes for any project. AI parses every line item. See who's cheapest" + studioDash() + "and when prices creep above your history."}</div>
            </div>
          )}
        </div>

        {/* ── Polling shimmer card ── */}
        {pollingStatus === 'polling' && (
          <div style={{ margin: '12px 14px 0', background: 'rgba(255,252,242,0.88)', border: '1px solid rgba(200,144,48,0.18)', borderRadius: 17, padding: '14px 16px', display: 'flex', alignItems: 'center', gap: 10, animation: 'lumenShimmer 2s infinite ease-in-out', backgroundSize: '200% 100%', backgroundImage: 'linear-gradient(90deg, rgba(255,252,242,0.88) 25%, rgba(255,248,230,0.95) 50%, rgba(255,252,242,0.88) 75%)' }}>
            <div style={{ width: 14, height: 14, border: '2px solid rgba(191,148,40,0.28)', borderTopColor: '#BF9428', borderRadius: '50%', animation: 'spin 0.6s linear infinite', flexShrink: 0 }} />
            <span style={{ fontSize: 13, fontWeight: 700, color: '#BF9428' }}>Claude is reading your quote...</span>
          </div>
        )}
        {pollingStatus === 'failed' && (
          <div style={{ margin: '12px 14px 0', background: 'rgba(192,60,50,0.07)', border: '1px solid rgba(192,60,50,0.18)', borderRadius: 17, padding: '12px 14px' }}>
            <span style={{ fontSize: 13, fontWeight: 600, color: '#C03C32' }}>Couldn't read this quote. Try a clearer photo.</span>
          </div>
        )}
        {pollingStatus === 'timeout' && (
          <div style={{ margin: '12px 14px 0', background: 'rgba(138,96,16,0.06)', border: '1px solid rgba(138,96,16,0.15)', borderRadius: 17, padding: '12px 14px' }}>
            <span style={{ fontSize: 13, fontWeight: 600, color: '#8A6010' }}>{'Still processing' + studioDash() + 'this can take up to a minute for large quotes.'}</span>
          </div>
        )}

        {/* ── Price alerts section ── */}
        {hasAnyQuotes && (
          <div style={{ margin: '14px 14px 0' }}>
            {/* Expiry warnings */}
            {[...allQuotes, ...quotes].filter(q => {
              const exp = q.expiryDate || q.expiry_date;
              return exp && new Date(exp) > new Date() && (new Date(exp) - new Date()) / 86400000 < 14;
            }).slice(0, 2).map((q, qi) => (
              <div key={q.id || qi} style={{ display: 'flex', alignItems: 'flex-start', gap: 9, borderRadius: 13, padding: '10px 13px', marginBottom: 7, background: 'rgba(191,148,40,0.07)', border: '1px solid rgba(191,148,40,0.2)' }}>
                <div style={{ width: 7, height: 7, borderRadius: 4, background: '#BF9428', flexShrink: 0, marginTop: 4 }} />
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 12, color: 'rgba(28,24,16,0.65)', lineHeight: 1.45, fontWeight: 500 }}><b>{q.supplier_name || q.supplier}</b> quote expires in {Math.ceil((new Date(q.expiryDate || q.expiry_date) - new Date()) / 86400000)} days</div>
                  <div style={{ fontSize: 11, fontWeight: 800, color: '#8A6010', marginTop: 3 }}>Re-quote or chase {studioArrow('\u2192')}</div>
                </div>
              </div>
            ))}
            {/* Clear failed button */}
            {failedCount > 0 && (
              <button onClick={clearFailedQuotes} style={{ display: 'flex', alignItems: 'center', gap: 8, width: '100%', background: 'rgba(192,60,50,0.06)', border: '1px solid rgba(192,60,50,0.15)', borderRadius: 13, padding: '10px 13px', marginBottom: 7, cursor: 'pointer', fontFamily: 'inherit' }}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6l12 12" stroke="#C03C32" strokeWidth="2.5" strokeLinecap="round"/></svg>
                <span style={{ fontSize: 12, fontWeight: 700, color: '#C03C32', flex: 1, textAlign: 'left' }}>Clear {failedCount} failed quote{failedCount !== 1 ? 's' : ''}</span>
                <span style={{ fontSize: 10, color: 'rgba(192,60,50,0.5)' }}>Processing {'>'}2 hrs</span>
              </button>
            )}
          </div>
        )}

        {/* ── YOUR SUPPLIERS section ── */}
        {Object.keys(supplierGroups).length > 0 && (
          <div style={{ margin: '4px 14px 0' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 9, marginTop: 10 }}>
              <span style={{ fontSize: 11, fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.09em', color: 'rgba(28,24,16,0.35)', ...uvx(studioSection) }}>YOUR SUPPLIERS</span>
              <span style={{ fontSize: 11, color: 'rgba(28,24,16,0.35)' }}>{allSupplierNames.length}</span>
            </div>
            {Object.entries(supplierGroups).map(([sName, sGroup], si) => {
              const sScore = computeSupplierScore(sName);
              const initials = sName.split(' ').filter(w => t.theme !== 'uv' || /^[A-Za-z0-9]/.test(w)).map(w => w[0]).join('').slice(0, 2).toUpperCase();
              const sc = sScore.score;
              return (
                <div key={sName} onClick={() => { setWorthSupplier(sName); setWorthView('supplier'); }}
                  style={{ background: 'rgba(255,252,242,0.88)', border: '1px solid rgba(255,255,250,0.92)', borderRadius: 17, padding: '13px 14px', marginBottom: 7, cursor: 'pointer' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
                    <div style={{ width: 36, height: 36, borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, fontSize: 12, fontWeight: 800, background: scoreBg(sc), color: scoreColor(sc) }}>{initials}</div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: 14, fontWeight: 800, color: '#1C1810' }}>{sName}</div>
                      <div style={{ fontSize: 11, color: 'rgba(28,24,16,0.38)', marginTop: 1 }}>{sGroup.quotes.length} quote{sGroup.quotes.length !== 1 ? 's' : ''}{studioDot3()[0]}{studioDot3()[1]}{studioDot3()[2]}{fmt(sGroup.totalValue)}</div>
                    </div>
                    <div style={{ textAlign: 'right' }}>
                      <div style={{ fontSize: 20, fontWeight: 800, color: scoreColor(sc), lineHeight: 1 }}>{sc}</div>
                      <div style={{ fontSize: 9, color: 'rgba(28,24,16,0.35)', fontWeight: 700, letterSpacing: '0.05em', marginTop: 2 }}>/100</div>
                    </div>
                  </div>
                  {/* Score bar */}
                  <div style={{ height: 4, background: 'rgba(28,24,16,0.08)', borderRadius: 2, overflow: 'hidden', marginBottom: 8 }}>
                    <div style={{ width: `${sc}%`, height: '100%', borderRadius: 2, background: scoreColor(sc) }} />
                  </div>
                  {/* Coverage chips */}
                  {sGroup.categories.size > 0 && (
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                      {[...sGroup.categories].slice(0, 4).map(cat => (
                        <span key={cat} style={{ fontSize: 9, fontWeight: 700, padding: '3px 8px', borderRadius: 12, background: 'rgba(191,148,40,0.07)', border: '1px solid rgba(191,148,40,0.15)', color: '#8A6010' }}>{cat}</span>
                      ))}
                      {sGroup.categories.size > 4 && (
                        <span style={{ fontSize: 9, fontWeight: 700, padding: '3px 8px', borderRadius: 12, background: 'rgba(28,24,16,0.04)', color: 'rgba(28,24,16,0.4)' }}>+{sGroup.categories.size - 4}</span>
                      )}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}

        {/* ── RECENT PROJECTS section ── */}
        {Object.keys(projectsByName).length > 0 && (
          <div style={{ margin: '4px 14px 0' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 9, marginTop: 14 }}>
              <span style={{ fontSize: 11, fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.09em', color: 'rgba(28,24,16,0.35)', ...uvx(studioSection) }}>RECENT PROJECTS</span>
              <span style={{ fontSize: 11, color: 'rgba(28,24,16,0.35)' }}>{Object.keys(projectsByName).length}</span>
            </div>
            {Object.entries(projectsByName).map(([pName, pGroup]) => {
              const pQuotes = pGroup.quotes;
              const sorted = [...pQuotes].sort((a, b) => (a.total_value || 0) - (b.total_value || 0));
              const cheapest = sorted[0];
              const maxVal = sorted[sorted.length - 1]?.total_value || 1;
              const saving = pQuotes.length >= 2 ? (sorted[sorted.length - 1].total_value || 0) - (sorted[0].total_value || 0) : 0;
              const chipLabel = pQuotes.length >= 2 ? ((cheapest.supplier_name || cheapest.supplier) + ' wins') : (pQuotes.length + ' of 3');
              const chipIsWin = pQuotes.length >= 2;
              return (
                <div key={pName} onClick={() => { setWorthProject(pName); setWorthView('project'); }}
                  style={{ background: 'rgba(255,252,242,0.88)', border: '1px solid rgba(255,255,250,0.92)', borderRadius: 17, padding: '13px 14px', marginBottom: 8, cursor: 'pointer' }}>
                  <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 9 }}>
                    <div>
                      <div style={{ fontSize: 14, fontWeight: 800, color: '#1C1810' }}>{pName}</div>
                      <div style={{ fontSize: 11, color: 'rgba(28,24,16,0.4)', marginTop: 2 }}>{pQuotes.length} quote{pQuotes.length !== 1 ? 's' : ''}{studioDot3()[0]}{studioDot3()[1]}{studioDot3()[2]}{pQuotes.map(q => q.supplier_name || q.supplier).filter(Boolean).join(', ')}</div>
                    </div>
                    <div style={{ background: chipIsWin ? 'rgba(30,80,30,0.08)' : 'rgba(191,148,40,0.09)', border: chipIsWin ? '1px solid rgba(30,80,30,0.2)' : '1px solid rgba(191,148,40,0.22)', borderRadius: 20, padding: '4px 9px', flexShrink: 0 }}>
                      <span style={{ fontSize: 10, fontWeight: 800, color: chipIsWin ? '#1E6030' : '#8A6010', whiteSpace: 'nowrap' }}>{chipLabel}</span>
                    </div>
                  </div>
                  {/* Price bars */}
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 5, marginBottom: 9 }}>
                    {sorted.map((q, qi) => {
                      const isWinner = qi === 0 && pQuotes.length >= 2;
                      const barW = maxVal > 0 ? Math.max(20, ((q.total_value || 0) / maxVal) * 100) : 50;
                      return (
                        <div key={q.id || qi} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                          <span style={{ fontSize: 11, fontWeight: 700, color: 'rgba(28,24,16,0.5)', width: 90, flexShrink: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{((q.supplier_name || q.supplier) || '').split(' ')[0]}</span>
                          <div style={{ flex: 1, height: 5, background: 'rgba(28,24,16,0.07)', borderRadius: 3, overflow: 'hidden' }}>
                            <div style={{ width: `${barW}%`, height: '100%', borderRadius: 3, background: isWinner ? '#1E6030' : 'rgba(28,24,16,' + Math.max(0.12, 0.3 - qi * 0.08) + ')' }} />
                          </div>
                          <span style={{ fontSize: 11, fontWeight: 800, width: 50, textAlign: 'right', flexShrink: 0, color: isWinner ? '#1E6030' : 'rgba(28,24,16,' + Math.max(0.3, 0.6 - qi * 0.08) + ')', fontFamily: "system-ui, -apple-system, sans-serif" }}>{fmt(q.total_value)}</span>
                        </div>
                      );
                    })}
                  </div>
                  {saving > 0 && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6, background: 'rgba(30,80,30,0.05)', borderRadius: 9, padding: '5px 9px' }}>
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none"><polyline points="20 6 9 17 4 12" stroke="#1E6030" strokeWidth="2.5" strokeLinecap="round"/></svg>
                      <span style={{ fontSize: 11, color: 'rgba(28,24,16,0.45)', flex: 1 }}>Best vs most expensive</span>
                      <span style={{ fontSize: 12, fontWeight: 800, color: '#1E6030' }}>Save {fmt(saving)}</span>
                    </div>
                  )}
                  {pQuotes.length === 1 && (
                    <div style={{ fontSize: 11, color: 'rgba(8,28,56,0.5)', fontStyle: 'italic', fontWeight: 600 }}>Add more quotes to compare {studioArrow('\u2192')}</div>
                  )}
                </div>
              );
            })}
          </div>
        )}

        {/* ── Empty state: locked feature cards + CTA ── */}
        {!hasAnyQuotes && !importUploading && pollingStatus === 'idle' && (
          <div style={{ padding: '16px 14px 0' }}>
            <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: '0.09em', textTransform: 'uppercase', color: 'rgba(28,24,16,0.35)', marginBottom: 10 }}>Unlocks as you add quotes</div>

            {/* Lock 1 — 3 quotes on one project → Side-by-side comparison */}
            <div style={{ background: 'rgba(255,252,242,0.88)', border: '1px solid rgba(255,255,250,0.92)', borderRadius: 16, marginBottom: 8, overflow: 'hidden', position: 'relative', minHeight: 82 }}>
              {t.theme === 'uv' ? null : <div style={{ padding: '13px 15px', filter: 'blur(2px)', opacity: 0.3, pointerEvents: 'none' }}>
                <div style={{ display: 'flex', gap: 5 }}>
                  <div style={{ flex: 1, background: 'rgba(30,80,30,0.1)', borderRadius: 9, padding: 7, textAlign: 'center' }}><div style={{ fontSize: 13, fontWeight: 800, color: '#1E6030' }}>Yesss</div><div style={{ fontSize: 11, color: 'rgba(28,24,16,0.45)' }}>{'\u00A3'}6,840 {'\u2713'}</div></div>
                  <div style={{ flex: 1, background: 'rgba(28,24,16,0.04)', borderRadius: 9, padding: 7, textAlign: 'center' }}><div style={{ fontSize: 13, fontWeight: 800, color: '#1C1810' }}>CEF</div><div style={{ fontSize: 11, color: 'rgba(28,24,16,0.45)' }}>{'\u00A3'}7,100</div></div>
                  <div style={{ flex: 1, background: 'rgba(28,24,16,0.04)', borderRadius: 9, padding: 7, textAlign: 'center' }}><div style={{ fontSize: 13, fontWeight: 800, color: '#1C1810' }}>Rexel</div><div style={{ fontSize: 11, color: 'rgba(28,24,16,0.45)' }}>{'\u00A3'}7,420</div></div>
                </div>
              </div>}
              <div style={{ position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 5, background: 'rgba(240,232,212,0.7)' }}>
                <div style={{ background: 'rgba(28,24,16,0.06)', border: '1px solid rgba(28,24,16,0.1)', borderRadius: 20, padding: '5px 12px', display: 'flex', alignItems: 'center', gap: 5 }}>
                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none"><rect x="3" y="11" width="18" height="11" rx="2" stroke="rgba(28,24,16,0.4)" strokeWidth="2.5"/><path d="M7 11V7a5 5 0 0110 0v4" stroke="rgba(28,24,16,0.4)" strokeWidth="2.5" strokeLinecap="round"/></svg>
                  <span style={{ fontSize: 11, fontWeight: 800, color: 'rgba(28,24,16,0.5)' }}>3 quotes on one project</span>
                </div>
                <div style={{ fontSize: 12, fontWeight: 800, color: 'rgba(28,24,16,0.65)' }}>Side-by-side comparison</div>
              </div>
            </div>

            {/* Lock 2 — 5 quotes total → Price history alerts */}
            <div style={{ background: 'rgba(255,252,242,0.88)', border: '1px solid rgba(255,255,250,0.92)', borderRadius: 16, marginBottom: 8, overflow: 'hidden', position: 'relative', minHeight: 72 }}>
              {t.theme === 'uv' ? null : <div style={{ padding: '12px 15px', filter: 'blur(2px)', opacity: 0.3, pointerEvents: 'none' }}>
                <div style={{ background: 'rgba(192,60,50,0.07)', borderRadius: 9, padding: '8px 10px' }}><div style={{ fontSize: 11, fontWeight: 800, color: '#C03C32' }}>T&E 2.5mm up 11% — query before accepting</div></div>
              </div>}
              <div style={{ position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 5, background: 'rgba(240,232,212,0.7)' }}>
                <div style={{ background: 'rgba(28,24,16,0.06)', border: '1px solid rgba(28,24,16,0.1)', borderRadius: 20, padding: '5px 12px', display: 'flex', alignItems: 'center', gap: 5 }}>
                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none"><rect x="3" y="11" width="18" height="11" rx="2" stroke="rgba(28,24,16,0.4)" strokeWidth="2.5"/><path d="M7 11V7a5 5 0 0110 0v4" stroke="rgba(28,24,16,0.4)" strokeWidth="2.5" strokeLinecap="round"/></svg>
                  <span style={{ fontSize: 11, fontWeight: 800, color: 'rgba(28,24,16,0.5)' }}>5 quotes total</span>
                </div>
                <div style={{ fontSize: 12, fontWeight: 800, color: 'rgba(28,24,16,0.65)' }}>Price history alerts</div>
              </div>
            </div>

            {/* Lock 3 — 20 quotes → Profit coaching engine */}
            <div style={{ background: 'rgba(255,252,242,0.88)', border: '1px solid rgba(255,255,250,0.92)', borderRadius: 16, marginBottom: 20, overflow: 'hidden', position: 'relative', minHeight: 72 }}>
              {t.theme === 'uv' ? null : <div style={{ padding: '12px 15px', filter: 'blur(2px)', opacity: 0.3, pointerEvents: 'none' }}>
                <div style={{ fontSize: 28, fontWeight: 800, color: '#1E6030', fontStyle: 'italic' }}>{'\u00A3'}47,200/yr</div>
                <div style={{ fontSize: 11, color: 'rgba(28,24,16,0.4)' }}>across 4 levers</div>
              </div>}
              <div style={{ position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 5, background: 'rgba(240,232,212,0.7)' }}>
                <div style={{ background: 'rgba(28,24,16,0.06)', border: '1px solid rgba(28,24,16,0.1)', borderRadius: 20, padding: '5px 12px', display: 'flex', alignItems: 'center', gap: 5 }}>
                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none"><rect x="3" y="11" width="18" height="11" rx="2" stroke="rgba(28,24,16,0.4)" strokeWidth="2.5"/><path d="M7 11V7a5 5 0 0110 0v4" stroke="rgba(28,24,16,0.4)" strokeWidth="2.5" strokeLinecap="round"/></svg>
                  <span style={{ fontSize: 11, fontWeight: 800, color: 'rgba(28,24,16,0.5)' }}>20 quotes</span>
                </div>
                <div style={{ fontSize: 12, fontWeight: 800, color: 'rgba(28,24,16,0.65)' }}>Profit coaching engine</div>
              </div>
            </div>

            {/* Bottom CTA */}
            <button
              onClick={() => { if (!importUploading && importFileRef.current) importFileRef.current.click(); }}
              style={{ width: '100%', background: '#091E38', border: 'none', borderRadius: 16, padding: 16, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 12, marginBottom: 100, fontFamily: 'inherit', ...uvx(() => ({ ...studioSurface.primary(), padding: 16, textAlign: 'left' })) }}
            >
              <div style={{ width: 40, height: 40, background: 'rgba(255,252,242,0.08)', borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, ...uvx({ background: 'transparent' }) }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M12 5v14M5 12h14" stroke={t.theme === 'uv' ? STUDIO_TOKENS.onPrimary : "rgba(255,252,242,0.7)"} strokeWidth="2" strokeLinecap="round"/></svg>
              </div>
              <div style={{ textAlign: 'left', flex: 1 }}>
                <div style={{ fontSize: 15, fontWeight: 800, color: 'rgba(255,252,242,0.93)', ...uvx({ fontSize: 16, fontWeight: 600 }) }}>Add your first quote</div>
                <div style={{ fontSize: 12, color: 'rgba(255,252,242,0.4)', marginTop: 2, ...uvx({ fontSize: 14 }) }}>Photograph or upload a PDF</div>
              </div>
              {t.theme === 'uv' ? null : <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M9 18l6-6-6-6" stroke="rgba(255,252,242,0.3)" strokeWidth="2.5" strokeLinecap="round"/></svg>}
            </button>
          </div>
        )}
      </div>

      <TabBar active={15} onChange={onNav} divisionId={divId} />
    </div>
  );
};

// ═══════════════════════════════════════════════════════════════
// ── Push notification registration ────────────────────────────
// ═══════════════════════════════════════════════════════════════
const registerPushNotifications = async (user) => {
  try {
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;
    const reg = await navigator.serviceWorker.ready;
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') return;
    let sub = await reg.pushManager.getSubscription();
    if (!sub) {
      // Get VAPID public key from portal
      const vapidRes = await fetch(PORTAL_URL + '/api/push/vapid-key');
      if (!vapidRes.ok) return;
      const { publicKey } = await vapidRes.json();
      const applicationServerKey = Uint8Array.from(atob(publicKey.replace(/-/g, '+').replace(/_/g, '/')), c => c.charCodeAt(0));
      sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey });
    }
    // Register subscription with portal
    await fetch(PORTAL_URL + '/api/push/register', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ subscription: sub.toJSON(), username: (user.name || '').toLowerCase() })
    });
  } catch(e) {
    console.warn('Push registration failed:', e);
  }
};

// ═══════════════════════════════════════════════════════════════
// ── MorningBriefingScreen (screen 20) ─────────────────────────
// ═══════════════════════════════════════════════════════════════
// Its own component, so studioDesk's mapper never walks the lit briefing.
const BriefingLitBody = ({ draw }) => draw();

// ── MORNING-BRIEFING-V2 track C: the ranked plan, in the Studio look ──
// Plain text React escapes; no dangerouslySetInnerHTML anywhere near it. Money
// (any £ amount) is ochre text in tabular figures, the one colour for money.
// The only violet is the one Ring action on Today's card; every other action
// is an ink underlined link.
const planWords = (text) => {
  const S = STUDIO_TOKENS;
  return String(text).split(/(£\d[\d,]*(?:\.\d+)?[kKmM]?)/).map((part, i) => (
    i % 2 === 1
      ? <span key={i} style={{ color: S.ochre, fontVariantNumeric: 'tabular-nums' }}>{part}</span>
      : part));
};
const planInkLink = () => ({ ...studioType.action(), minHeight: 44, display: 'inline-flex', alignItems: 'center', cursor: 'pointer', fontFamily: 'inherit' });

// Today's card: Do this first (text, why, the one Ring action), up to three
// more lines as plain text, and Read it.
const BriefingPlanToday = ({ plan, onRead }) => {
  const S = STUDIO_TOKENS;
  const body = { fontSize: 16, lineHeight: 1.5, color: S.ink, margin: 0 };
  const first = plan.first;
  return (
    <section aria-label="Today's plan" style={{ ...studioSurface.lit(), borderRadius: S.radius.card, margin: '18px 16px 16px', padding: '16px 18px 8px', display: 'flex', flexDirection: 'column', gap: 8 }}>
      {first ? (
        <>
          <h2 style={{ ...studioType.heading(), margin: 0 }}>Do this first</h2>
          <p style={{ ...body, fontWeight: 600 }}>{planWords(sanitiseText(first.text))}</p>
          {first.why && <p style={{ ...body, fontSize: 14, color: S.muted }}>{planWords(sanitiseText(first.why))}</p>}
          {first.call && (
            <a href={'tel:' + first.call.tel} style={{ ...studioSurface.primary(), alignSelf: 'flex-start', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', padding: '0 20px', textDecoration: 'none', fontFamily: 'inherit', cursor: 'pointer' }}>{sanitiseText(first.call.label)}</a>
          )}
          {plan.more.length > 0 && (
            <div style={{ borderTop: `1px solid ${S.hairline}`, marginTop: 6, paddingTop: 10, display: 'flex', flexDirection: 'column', gap: 8 }}>
              {plan.more.map((it, i) => <p key={(it.id || 'm') + i} style={{ ...body, fontSize: 15 }}>{planWords(sanitiseText(it.text))}</p>)}
            </div>
          )}
        </>
      ) : null}
      {!first && plan.error && <p style={body}>{sanitiseText(plan.error)}</p>}
      <div style={{ borderTop: `1px solid ${S.hairline}`, marginTop: 4 }}>
        <button onClick={onRead} style={planInkLink()}>Read it</button>
      </div>
    </section>
  );
};

// The full plan on the morning briefing screen: every section in order, with
// its title and items, tel links for phones, money in ochre.
const BriefingPlanFull = ({ plan }) => {
  const S = STUDIO_TOKENS;
  const body = { fontSize: 16, lineHeight: 1.5, color: S.ink, margin: 0 };
  return (
    <div style={{ padding: '4px 16px 24px', ...studioColumn }}>
      <section aria-label="Plan" style={{ ...studioSurface.lit(), borderRadius: S.radius.card, padding: '6px 18px' }}>
        {plan.sections.map((sec, si) => (
          <div key={sec.key} style={{ padding: '16px 0', borderTop: si > 0 ? `1px solid ${S.hairline}` : 'none' }}>
            <h2 style={{ ...studioType.heading(), margin: '0 0 8px' }}>{sanitiseText(sec.title)}</h2>
            {sec.items.map((it, ii) => (
              <div key={(it.id || 'i') + ii} style={{ marginTop: ii > 0 ? 12 : 0 }}>
                <p style={{ ...body, fontWeight: 600 }}>{planWords(sanitiseText(it.text))}</p>
                {it.why && <p style={{ ...body, fontSize: 14, color: S.muted, marginTop: 2 }}>{planWords(sanitiseText(it.why))}</p>}
                {it.lastSaid && <p style={{ ...body, fontSize: 14, color: S.muted, marginTop: 2 }}>{planWords(sanitiseText(it.lastSaid))}</p>}
                {it.call && <a href={'tel:' + it.call.tel} style={{ ...planInkLink(), textDecoration: 'underline', textDecorationColor: S.link.underline, textUnderlineOffset: 4 }}>{sanitiseText(it.call.label)}</a>}
              </div>
            ))}
          </div>
        ))}
      </section>
    </div>
  );
};

// The sentence the portal sends when the plan could not be read, said as it
// is sent rather than as an empty screen.
const BriefingPlanNote = ({ text }) => (
  <div style={{ padding: '4px 16px 24px', ...studioColumn }}>
    <p style={{ fontSize: 16, lineHeight: 1.5, color: STUDIO_TOKENS.ink, margin: 0 }}>{sanitiseText(text)}</p>
  </div>
);
const MorningBriefingScreen = ({ onNav, currentUser }) => {
  const div = getDivisionConfig(currentUser);
  const divId = div.id === "aircon" ? "aircon" : "lighting";
  const [briefingData, setBriefingData] = useState(null);
  const [loading, setLoading] = useState(true);
  // The REASON, not a boolean. "No briefing was written for you today" and
  // "we could not reach the portal" are different facts, and the old copy told
  // both of them the same reassuring story ("generates at 07:00") -- which is
  // a lie to the second, and to a signed-out user especially.
  const [failure, setFailure] = useState(null); // null | 'signed_out' | 'unreachable'

  useEffect(() => {
    // Check cache first. The truthiness test this replaced is what made the
    // poison sticky: an error object is truthy, so this short-circuited and the
    // authed fetch below never ran. Validating instead means a bad entry simply
    // misses and we refetch immediately, rather than waiting for midnight.
    const cachedBriefing = readCachedBriefing();
    if (cachedBriefing) {
      setBriefingData(cachedBriefing);
      setLoading(false);
      return;
    }
    // S95 D5 D31 — fetch with Bearer auth. The briefing endpoint requires the
    // Lumen token for per-user personalisation; without it the portal returned
    // 401 and the screen rendered as a blank shell.
    const token = (() => { try { return localStorage.getItem('lumen_token'); } catch(e) { return null; } })();
    const headers = token ? { 'Authorization': `Bearer ${token}` } : {};
    fetch(PORTAL_URL + '/api/companion/briefing', { headers })
      .then(r => { if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.json(); })
      .then(payload => {
        const briefing = briefingFromPayload(payload);
        // `{briefing: null, generated: false}` is a 200 meaning "none written
        // for you today". That is an EMPTY state, not an error state -- the
        // screen shows EmptyState, and nothing is cached.
        setBriefingData(briefing);
        cacheBriefing(briefing);
        setLoading(false);
      })
      .catch(e => {
        const why = (e && e.message) ? e.message : String(e);
        try {
          console.warn('[briefing] screen fetch failed: ' + why
            + (token ? '' : ' (no lumen_token in storage -- signed out?)'));
        } catch (e2) {}
        // A 401, or no token at all, is a sign-in problem and says so. Anything
        // else is "we could not reach the portal". Neither is "not generated".
        setFailure((why === 'HTTP 401' || !token) ? 'signed_out' : 'unreachable');
        setLoading(false);
      });
  }, []);

  // Mark as read
  useEffect(() => {
    if (briefingData) {
      try { localStorage.setItem('lumen_briefing_read_' + new Date().toISOString().split('T')[0], '1'); } catch(e) {}
    }
  }, [briefingData]);

  const firstName = (currentUser?.name || '').split(' ')[0] || 'there';

  // The three beats, selected from the producer's schema. Safe on null —
  // briefingBeats returns a fully-shaped result with hasContent false — so the
  // render branches below can read it before any briefing has arrived.
  const beats = briefingBeats(briefingData);
  // See the hook-line note in the render below: on a three-beat row the hook
  // IS the move headline, so showing both prints one sentence twice.
  const showHook = !!beats.meta.hookLine
    && !(beats.move && beats.move.headline
         && beats.move.headline.trim().toLowerCase() === beats.meta.hookLine.trim().toLowerCase());

  // ── Loading skeleton ──
  const Skeleton = () => studioDesk(
    <div style={{ padding: "0 16px" }}>
      {[1,2,3].map(i => (
        <div key={i} style={{ background: t.colors.glass, borderRadius: 16, padding: "18px 16px", marginBottom: 12, border: "1px solid " + t.colors.glassBorder }}>
          <div style={{ ...shimmerBgWarm, height: 14, width: "40%", borderRadius: 6, marginBottom: 12 }} />
          <div style={{ ...shimmerBgWarm, height: 12, width: "90%", borderRadius: 6, marginBottom: 8 }} />
          <div style={{ ...shimmerBgWarm, height: 12, width: "70%", borderRadius: 6 }} />
        </div>
      ))}
    </div>
  );

  // ── Empty / failed states ──
  // THREE causes, three answers. Previously all three showed "generates at
  // 07:00", which is true only of the first — and to a signed-out surveyor it
  // was a reassuring lie about a problem they could actually have fixed.
  const StateCard = ({ glyph, headline, body }) => studioDesk(
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", flex: 1, padding: "60px 32px", textAlign: "center" }}>
      {t.theme === 'uv' ? null : <div style={{ fontSize: 48, marginBottom: 16, opacity: 0.4 }}>{glyph}</div>}
      <div style={{ fontFamily: "Georgia, serif", fontStyle: "italic", fontSize: 20, color: t.colors.text, lineHeight: 1.4, marginBottom: 8 }}>
        {headline}
      </div>
      <div style={{ fontSize: 13, color: t.colors.textSecondary, lineHeight: 1.5, maxWidth: 280 }}>
        {body}
      </div>
    </div>
  );

  const EmptyState = () => (
    <StateCard glyph="☀️" headline="No briefing yet today."
      body="Your morning briefing generates at 07:00. Check back then, or get ahead and start your day now." />
  );

  // "Signed out", not "expired": this also fires when the device never held a
  // token, and telling someone their session expired when they never had one
  // is the same class of reassuring untruth as the copy being replaced.
  const SignedOutState = () => (
    <StateCard glyph="🔑" headline="Sign in to see your briefing."
      body="You are signed out on this device. Nothing you've captured is affected." />
  );

  // Says only what the app can know, and asks for nothing it cannot do.
  // It cannot know whether a briefing exists (a transport failure is exactly
  // the state with no evidence either way), so it does not claim one is
  // waiting. It also does NOT say "pull down to try again": this screen has no
  // touch handlers and its fetch effect has an empty dependency array, so the
  // gesture would do nothing and the user would conclude the app is broken.
  // Pull-to-refresh exists on TodayScreen; it was never wired here. Instructing
  // an action the screen does not implement is the same failure as asserting a
  // fact it cannot check. No em dash: §24.
  const UnreachableState = () => (
    <StateCard glyph="🌥️" headline="Couldn't load your briefing."
      body="We couldn't reach the portal just now. Nothing you've captured is affected." />
  );

  // ── Section card helper ──
  const SectionCard = ({ children, style: extraStyle }) => studioDesk(
    <div style={{ background: t.colors.glass, borderRadius: 16, padding: "16px 16px", marginBottom: 12, border: "1px solid " + t.colors.glassBorder, ...extraStyle }}>
      {children}
    </div>
  );


  return studioDesk(
    <div style={{ flex: 1, overflowY: "auto", WebkitOverflowScrolling: "touch", overscrollBehavior: "contain", paddingBottom: 100, background: "#E8DCC8", display: "flex", flexDirection: "column" }}>
      <ScreenBlobs />

      {/* ── Header ── */}
      <div style={{ padding: "14px 16px 10px", display: "flex", alignItems: "center", gap: 12, flexShrink: 0, position: "relative", zIndex: 2, ...uvx(studioColumn) }}>
        <button onClick={() => onNav(0)} style={{ width: 36, height: 36, borderRadius: 12, background: t.colors.glass, border: "1px solid " + t.colors.glassBorder, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", flexShrink: 0 }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={t.colors.text} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M15 18l-6-6 6-6"/></svg>
        </button>
        <div style={{ flex: 1, ...uvx({ display: 'flex', flexDirection: 'column' }) }}>
          <div style={{ fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.1em", color: t.colors.textTertiary, ...uvx(() => ({ ...studioPageTitle(), order: 1 })) }}>{t.theme === 'uv' ? 'Today’s briefing' : "Today's Briefing"}</div>
          <div style={{ fontSize: 16, fontWeight: 800, color: t.colors.text, ...uvx({ order: 2, fontSize: 14, fontWeight: 400, color: STUDIO_TOKENS.muted }) }}>{new Date().toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long' })}</div>
        </div>
      </div>

      {/* ── Scrollable content ── */}
      <div style={{ flex: 1, overflowY: "auto", overflowX: "hidden", WebkitOverflowScrolling: "touch", position: "relative" }}>

        {loading && <Skeleton />}

        {/* THE THREE BEATS. This renders the PRODUCER's schema
            (morning_briefing.verify_and_blank) via `briefingBeats`, which owns
            every selection rule. The retired `opening` / `score_context` /
            `sections.*` reads that stood here until v190 are gone; a grep for
            them is part of this change's proof.

            Honest degradation: the verifier BLANKS prose it cannot ground, so
            an absent beat renders NOTHING. No placeholders, no "not
            available" — putting words where the producer removed them is the
            failure this whole arc has been about. */}
        {!loading && failure === 'signed_out' && <SignedOutState />}
        {!loading && failure === 'unreachable' && <UnreachableState />}
        {!loading && !failure && !beats.hasContent && <EmptyState />}

        {/* STUDIO-LIT-PHONE-V1 item 8b, switch on: the three beats on one
            lit paper, a hairline between them, not three identical cards
            (studio-lit.md). Her words are not on the jewel: model prose can
            carry sums, and the jewel never carries money. Same beats, same
            rules (briefingBeats), same hook test. */}
        {/* MORNING-BRIEFING-V2 C: the ranked plan, every section in order. The
            three beats below stay as the fallback when there is no plan. */}
        {!loading && !failure && beats.plan.hasPlan && <BriefingPlanFull plan={beats.plan} />}
        {!loading && !failure && !beats.plan.hasPlan && beats.plan.error && <BriefingPlanNote text={beats.plan.error} />}

        {!loading && !failure && !beats.plan.hasPlan && beats.legacyContent && t.theme === 'uv' && (
          <BriefingLitBody draw={() => {
            const S = STUDIO_TOKENS;
            const head = { fontFamily: S.fonts.body, fontSize: 16, fontWeight: 700, color: S.ink, margin: '0 0 6px' };
            const body = { fontSize: 16, lineHeight: 1.5, color: S.ink, margin: 0 };
            const parts = [];
            if (showHook) parts.push(<p key="hook" style={{ ...body, fontWeight: 600 }}>{sanitiseText(beats.meta.hookLine)}</p>);
            if (beats.stand) parts.push(<div key="stand"><h2 style={head}>Where you stand</h2><p style={body}>{sanitiseText(beats.stand)}</p></div>);
            if (beats.move) parts.push(
              <div key="move">
                <h2 style={head}>Your move</h2>
                <p style={{ ...body, fontWeight: 600 }}>{sanitiseText(beats.move.headline)}</p>
                {beats.move.reason && <p style={{ ...body, color: S.muted, marginTop: 4 }}>{sanitiseText(beats.move.reason)}</p>}
                {beats.move.contactName && <p style={{ ...body, fontSize: 14, marginTop: 8 }}>With {sanitiseText(beats.move.contactName)}</p>}
              </div>);
            if (beats.momentum) parts.push(
              <div key="momentum">
                <h2 style={head}>Momentum</h2>
                <p style={body}>{sanitiseText(beats.momentum.prose)}</p>
                {/* The prose already says how many weeks the run is (each
                    figure once); only the best, when it is more, is added. */}
                {beats.momentum.streakWeeks !== null && beats.momentum.streakWindow !== null && beats.momentum.streakWindow > beats.momentum.streakWeeks && (
                  <p style={{ ...body, fontSize: 14, color: S.muted, marginTop: 4 }}>
                    Your best is {beats.momentum.streakWindow} weeks.
                  </p>
                )}
              </div>);
            const gen = beats.meta.generatedAt ? new Date(beats.meta.generatedAt) : null;
            const genStr = gen && !isNaN(gen)
              ? `Written ${gen.toDateString() === new Date().toDateString() ? 'today' : `${gen.getDate()} ${PL_MONTHS[gen.getMonth()]}`} at ${gen.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}`
              : null;
            return (
              <div style={{ padding: '4px 16px 24px', ...studioColumn }}>
                <section aria-label="Briefing" style={{ ...studioSurface.lit(), borderRadius: S.radius.card, padding: '6px 18px' }}>
                  {parts.map((p, i) => (
                    <div key={i} style={{ padding: '16px 0', borderTop: i > 0 ? `1px solid ${S.hairline}` : 'none' }}>{p}</div>
                  ))}
                </section>
                {genStr && <p style={{ fontSize: 13, color: S.muted, margin: '10px 2px 0' }}>{genStr}</p>}
              </div>
            );
          }} />
        )}

        {!loading && !failure && !beats.plan.hasPlan && beats.legacyContent && t.theme !== 'uv' && (
          <div style={{ padding: "0 12px 24px", ...uvx({ width: '100%', maxWidth: 960, margin: '0 auto', boxSizing: 'border-box' }) }}>

            {/* ── Hook (from the briefings table, via meta; the score card is
                retired, COMPANION-TRUTH-V1) ── */}
            {/* `hook_line` is NOT an independent field on a three-beat row.
                store_briefing writes it as
                  briefing_json.get('hook_line') or move.headline
                and verify_and_blank returns only {stand, move, momentum} — no
                hook_line survives — so for every current row the column IS the
                move headline. The first draft printed it as an all-caps
                eyebrow AND again as the move, two cards apart, and the fixture
                hid it by pairing a hook with a different headline, which the
                producer has no path to emit. Show it only when it genuinely
                differs (legacy rows), so nothing is said twice. */}
            {showHook && (
              <SectionCard>
                <div style={{ fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em", color: t.colors.textSecondary, marginBottom: 8, ...uvx({ textTransform: 'none' }) }}>{sanitiseText(beats.meta.hookLine)}</div>
              </SectionCard>
            )}

            {/* ── STAND — where you stand ── */}
            {beats.stand && (
              <SectionCard>
                <div style={{ fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.1em", color: t.colors.textTertiary, marginBottom: 8, ...uvx(studioSection) }}>Where you stand</div>
                <div style={{ fontFamily: "Georgia, serif", fontStyle: "italic", fontSize: 16, color: t.colors.text, lineHeight: 1.5 }}>
                  {sanitiseText(beats.stand)}
                </div>
              </SectionCard>
            )}

            {/* ── MOVE — the one thing to do ──
                `tier` is the producer's own rung, not a companion invention:
                relationship / unsent / clear. Empty contact fields are LEGAL on
                the clear rung, so a missing name is never flagged as a gap. */}
            {beats.move && (
              /* Accent: teal is the Intelligence hue and a briefing move is
                 intelligence. NOT gold (§18: £ values, financial metrics,
                 Worth, CTAs only) and NOT green (§18: Plans/Survey/EM
                 exclusively) — both were used here in the first draft. An
                 unrecognised rung gets the neutral border, never another
                 rung's accent. */
              <SectionCard style={beats.move.tier === 'relationship'
                ? { borderLeft: "3px solid " + t.colors.teal } : undefined}>
                <div style={{ fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.1em", color: t.colors.textTertiary, marginBottom: 8, ...uvx(studioSection) }}>Your move</div>
                <div style={{ fontSize: 15, fontWeight: 700, color: t.colors.text, lineHeight: 1.4, marginBottom: beats.move.reason ? 6 : 0 }}>
                  {sanitiseText(beats.move.headline)}
                </div>
                {beats.move.reason && (
                  <div style={{ fontFamily: "Georgia, serif", fontStyle: "italic", fontSize: 13, color: t.colors.textSecondary, lineHeight: 1.5 }}>
                    {sanitiseText(beats.move.reason)}
                  </div>
                )}
                {/* `action_target` is DELIBERATELY NOT RENDERED. It is a
                    project_id, not copy: morning_briefing's output contract
                    says "The project_id the move acts on, copied from the
                    data", and both fallback rungs fill it with
                    str(card['project_id']). The first draft printed it beside
                    the contact, so a surveyor would have read
                    "Tom Casson  1043". It exists to carry identity for a
                    deep-link; until that link is built it renders nothing. */}
                {beats.move.contactName && (
                  <div style={{ marginTop: 10 }}>
                    <span style={{ fontSize: 12, fontWeight: 700, color: t.colors.teal }}>{sanitiseText(beats.move.contactName)}</span>
                  </div>
                )}
              </SectionCard>
            )}

            {/* ── MOMENTUM — keep the run going ── */}
            {beats.momentum && (
              <SectionCard>
                <div style={{ fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.1em", color: t.colors.textTertiary, marginBottom: 8, ...uvx(studioSection) }}>Momentum</div>
                <div style={{ fontFamily: "Georgia, serif", fontStyle: "italic", fontSize: 14, color: t.colors.text, lineHeight: 1.5 }}>
                  {sanitiseText(beats.momentum.prose)}
                </div>
                {beats.momentum.streakWeeks !== null && (
                  <div style={{ marginTop: 8, fontSize: 12, color: t.colors.textSecondary }}>
                    {beats.momentum.streakWeeks} week{beats.momentum.streakWeeks === 1 ? '' : 's'} running
                    {beats.momentum.streakWindow !== null && beats.momentum.streakWindow > beats.momentum.streakWeeks
                      ? studioSep() + 'best ' + beats.momentum.streakWindow : ''}
                  </div>
                )}
              </SectionCard>
            )}

            {/* ── Generated timestamp ── */}
            {beats.meta.generatedAt && (
              <div style={{ textAlign: "center", fontSize: 11, color: t.colors.textTertiary, marginTop: 8 }}>
                Briefing generated {new Date(beats.meta.generatedAt).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}
              </div>
            )}
          </div>
        )}
      </div>

      <TabBar active={0} onChange={onNav} divisionId={divId} />
    </div>
  );
};

// ── Map portal pipeline quotes to companion proposal shape ──
const mapPortalQuotesToProposals = (portalQuotes) => {
  if (!portalQuotes || !Array.isArray(portalQuotes) || portalQuotes.length === 0) return [];
  return portalQuotes.map(q => {
    // Use the best available date — try all known field names in priority order
    const dateFields = [
      ['created_at', q.created_at], ['sent_date', q.sent_date], ['sent_at', q.sent_at],
      ['updated_at', q.updated_at], ['timestamp', q.timestamp], ['quote_date', q.quote_date], ['date', q.date],
    ];
    const found = dateFields.find(([, v]) => v != null && v !== '' && !isNaN(new Date(v).getTime()));
    const fieldUsed = found ? found[0] : null;
    const realDate = found ? found[1] : null;
    const undated = !realDate;
    const dateStr = realDate ? new Date(realDate).toISOString() : null;
    const assignedMonth = dateStr ? new Date(dateStr).toLocaleString('en-GB', { month: 'short', year: 'numeric' }) : 'undated';
    console.log(`[Pipeline] Quote "${q.project_name || q.quote_ref}" → month="${assignedMonth}" (field used: ${fieldUsed || 'NONE'})`);
    if (undated) console.warn('[Pipeline] Quote missing ALL date fields — marked undated:', q.quote_ref || q.job_id);
    // Division: check multiple field names the portal may use
    const rawDiv = q.division || q.category || q.dept || '';
    const normDiv = rawDiv.toLowerCase().trim();
    const division = (normDiv === 'me' || normDiv === 'ac' || normDiv === 'air_conditioning' || normDiv === 'air conditioning' || normDiv === 'aircon') ? 'me' : (normDiv || 'lighting');
    return {
      id: q.job_id || ('portal_' + (q.quote_ref || '') + '_' + (q.created_at || Date.now())),
      projectName: q.project_name || '',
      projectClient: q.client_name || '',
      client: q.client_name || '',
      projectRef: q.project_ref || q.project_code || '',
      quoteRef: q.quote_ref || '',
      reference: q.quote_ref || '',
      capex: q.total || 0,
      value: q.total || 0,
      totalValue: q.total || 0,
      division: division,
      status: q.status === 'pending' ? 'sent' : (q.status || 'sent'),
      won: q.status === 'won',
      lost: q.status === 'lost',
      date: dateStr,
      createdAt: dateStr,
      updatedAt: dateStr,
      undated: undated,
      source: 'portal',
      // STUDIO-LIT-PHONE-V1 (the won_at drop, DATA-MAP F1c): what the portal
      // sends per quote and the screens read, passed through as sent. A field
      // the portal did not send is null, never a made-up value.
      wonAt: q.won_at != null && q.won_at !== '' ? q.won_at : null,
      projectId: q.project_id != null && q.project_id !== '' ? q.project_id : null,
      odds: typeof q.odds === 'number' && isFinite(q.odds) ? q.odds : null,
      opens: typeof q.opens === 'number' && isFinite(q.opens) ? q.opens : null,
      lastOpen: q.last_open != null && q.last_open !== '' ? q.last_open : null,
      marginPct: typeof q.margin_pct === 'number' && isFinite(q.margin_pct) ? q.margin_pct : null,
      marginWithheld: q.margin_withheld != null && q.margin_withheld !== '' ? q.margin_withheld : null,
    };
  });
};

// ── Deduplicate proposals by client + projectName + value ──
const deduplicateProposals = (proposals) => {
  if (!proposals || proposals.length === 0) return proposals;
  const seen = new Map();
  const deduped = [];
  for (const p of proposals) {
    const key = [
      (p.client || p.projectClient || '').toLowerCase().trim(),
      (p.projectName || '').toLowerCase().trim(),
      Math.round(parseFloat(p.value || p.capex || p.totalValue || 0)),
    ].join('|');
    const existing = seen.get(key);
    if (existing) {
      // Keep the most recent
      const existingDate = new Date(existing.updatedAt || existing.date || 0).getTime();
      const newDate = new Date(p.updatedAt || p.date || 0).getTime();
      if (newDate > existingDate) {
        deduped[deduped.indexOf(existing)] = p;
        seen.set(key, p);
      }
    } else {
      seen.set(key, p);
      deduped.push(p);
    }
  }
  const removed = proposals.length - deduped.length;
  if (removed > 0) console.log(`[Pipeline] Dedup: removed ${removed} duplicate proposal(s)`);
  return deduped;
};

// ── Hydrate proposals from portal pipeline when local is empty ──
// COMPANION-TRUTH-V2 B1: userId is the signed-in person. The cache is read
// only when its owner stamp (lumen_cache_owner) names that person; with no
// stamp, another person's, or nobody signed in, nothing is filled.
const hydrateProposalsFromPortal = (localProposals, setProposals, userId) => {
  if (userId == null || userId === '' || portalCacheOwner() !== String(userId)) return;
  const portalData = getPortalData('lumen_pipeline', null);
  const allQ = portalData && (portalData.all_quotes || portalData.quotes);
  if (!allQ || allQ.length === 0) return;
  const mapped = deduplicateProposals(mapPortalQuotesToProposals(allQ));
  if (mapped.length === 0) return;
  // Preserve local status overrides (won/lost markings by user)
  if (localProposals && localProposals.length > 0) {
    const localOverrides = new Map();
    localProposals.forEach(p => {
      if (p.source === 'portal' && (p.won || p.lost || p.status === 'won' || p.status === 'lost')) {
        localOverrides.set(p.id, { status: p.status, won: p.won, lost: p.lost });
      }
    });
    if (localOverrides.size > 0) {
      mapped.forEach(p => {
        const override = localOverrides.get(p.id);
        if (override) {
          p.status = override.status;
          p.won = override.won;
          p.lost = override.lost;
        }
      });
      console.log(`[Pipeline] Preserved ${localOverrides.size} local status override(s) during re-hydration`);
    }
  }
  console.log(`[Pipeline] Re-hydrated ${mapped.length} proposals from portal (was ${(localProposals || []).length} local)`);
  setProposals(mapped);
};

function ASGCompanionApp() {
  const [currentUser, setCurrentUser] = useState(null);
  const [screen, setScreen] = useState(0);
  const [projects, setProjects] = useState([]);
  const [proposals, setProposals] = useState([]);
  const [activeProject, setActiveProject] = useState(null);
  // S135 — cold-start active-survey resume candidate. Set when a draft
  // survived a crash / tab-kill and getSurveyState classifies it 'live'.
  const [resumeDraft, setResumeDraft] = useState(null);
  // SEND-STATE-V1: the resume banner reads the job's send state (a survey
  // waiting in the queue is never offered to carry on), so it re-renders
  // when that changes.
  useSendStateTick();
  const [fromSurvey, setFromSurvey] = useState(false);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  // SECURITY-WAVE-1 track C: the portal refused this phone's sign-in (see
  // C_SIGNIN_AGAIN_SEAM). Drives the "Sign in again" banner.
  const [signInNeeded, setSignInNeeded] = useState(() => signInAgainNeeded());
  useEffect(() => {
    const need = () => setSignInNeeded(true);
    const done = () => setSignInNeeded(false);
    window.addEventListener('lumenSignInNeeded', need);
    window.addEventListener('lumenSignedInAgain', done);
    return () => {
      window.removeEventListener('lumenSignInNeeded', need);
      window.removeEventListener('lumenSignedInAgain', done);
    };
  }, []);
  const [isDirector, setIsDirector] = useState(() => {
    try { return localStorage.getItem('_isDirector') === '1'; } catch(e) { return false; }
  });
  const [showPMView, setShowPMView] = useState(false); // director toggle to PM view
  const [showVoiceModal, setShowVoiceModal] = useState(false);
  // B.2 Slice 3 — the binding the NEXT voice note carries on the wire.
  // Set explicitly by every path into the voice screen (auto-attach inherits
  // getProjectBinding(activeProject); VoiceModal pick / General note pass a
  // binding object). null ⇒ unbound ⇒ project_id: null on the event — never
  // omitted, never guessed (no name-matching, no preselection).
  const [voiceNoteBinding, setVoiceNoteBinding] = useState(null);
  // S105 — debug overlay opened by 5-tap on the ASG logo. Reads
  // lumen_debug_log on each open so the most recent events show. Useful
  // forensic surface for the photo-upload-reliability investigation.
  const [showDebugOverlay, setShowDebugOverlay] = useState(false);
  // PATCH 3: briefing unread state for notification bell
  const [briefingUnread, setBriefingUnread] = useState(() => {
    try {
      const readToday = localStorage.getItem('lumen_briefing_read_' + new Date().toISOString().split('T')[0]) === '1';
      return !readToday;
    } catch(e) { return true; }
  });
  const [showNotifPanel, setShowNotifPanel] = useState(false);
  const handleBellTap = () => {
    setShowNotifPanel(prev => !prev);
    if (!showNotifPanel) {
      setBriefingUnread(false);
      try { localStorage.setItem('lumen_briefing_read_' + new Date().toISOString().split('T')[0], '1'); } catch(e) {}
    }
  };
  const [, forceUpdate] = useState(0);

  // S135 — cold-start active-survey resume. If a survey_active draft survived
  // a crash / signal-drop / tab-kill, rehydrate it and surface a resume
  // banner. Routed through getSurveyState (via classifyResume) as the SOLE
  // classifier — no parallel state vocabulary. `parsedProjects` is the freshly
  // loaded project array (passed directly to avoid a setProjects race).
  const maybeResumeActiveSurvey = (parsedProjects) => {
    try {
      const draft = JSON.parse(localStorage.getItem('survey_active') || 'null');
      if (!draft || !draft.projectId) return;
      const row = (parsedProjects || []).find(p => p && p.id === draft.projectId) || null;
      const res = classifyResume(row, draft);
      try { debugLog('survey.resume.checked', { projectId: draft.projectId, state: res.state, resume: res.resume }); } catch (e) {}
      if (res.resume && res.project) {
        setActiveProject(res.project);
        setResumeDraft({ project: res.project, draft: draft });
      }
    } catch (e) {}
  };

  // FIX 5: Prevent iOS overscroll bounce
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.style.height = '100%';
  }, []);

  // One-time migration: backfill missing date fields on visits/surveys
  useEffect(() => {
    try {
      const today = new Date().toISOString().split('T')[0];
      const visits = JSON.parse(localStorage.getItem('lumen_visits') || '[]');
      let patched = 0;
      visits.forEach(v => { if (!v.date) { v.date = today; patched++; } });
      if (patched > 0) {
        localStorage.setItem('lumen_visits', JSON.stringify(visits));
        console.log(`[Migration] Backfilled date on ${patched} visit(s)`);
      }
    } catch(e) {}
  }, []);

  // Monthly snapshot — capture previous month's metrics on first load of a new month
  useEffect(() => {
    try {
      const now = new Date();
      const prevMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      const snapKey = `lumen_monthly_snapshot_${prevMonth.getFullYear()}_${String(prevMonth.getMonth() + 1).padStart(2, '0')}`;
      if (!localStorage.getItem(snapKey) && proposals.length > 0) {
        const prevStart = prevMonth.getTime();
        const prevEnd = new Date(now.getFullYear(), now.getMonth(), 1).getTime();
        const toTs = (d) => d ? new Date(d).getTime() : 0;
        const monthQuotes = proposals.filter(p => { const t = toTs(p.createdAt); return t >= prevStart && t < prevEnd; });
        const wonQuotes = monthQuotes.filter(p => p.won || p.status === 'won');
        const lostQuotes = monthQuotes.filter(p => p.lost || p.status === 'lost');
        const snap = {
          month: `${prevMonth.getFullYear()}-${String(prevMonth.getMonth() + 1).padStart(2, '0')}`,
          quotesCount: monthQuotes.length,
          quotesValue: monthQuotes.reduce((s, p) => s + parseFloat(p.value || p.capex || 0), 0),
          wonCount: wonQuotes.length,
          wonValue: wonQuotes.reduce((s, p) => s + parseFloat(p.value || p.capex || 0), 0),
          lostCount: lostQuotes.length,
          capturedAt: now.toISOString(),
        };
        localStorage.setItem(snapKey, JSON.stringify(snap));
        const fmt = (v) => v >= 1000 ? '\u00a3' + Math.round(v / 1000) + 'k' : '\u00a3' + Math.round(v);
        console.log(`[Snapshot] Wrote ${snap.month} snapshot: ${snap.quotesCount} quotes, ${fmt(snap.quotesValue)}`);
      }
    } catch(e) {}
  }, [proposals]);

  // Listen for dev mode toggle to force re-render
  useEffect(() => {
    const handler = () => forceUpdate(n => n + 1);
    window.addEventListener('lumenDevModeChanged', handler);
    return () => window.removeEventListener('lumenDevModeChanged', handler);
  }, []);

  // Listen for portal sync completion to re-render with fresh data + hydrate proposals
  useEffect(() => {
    const handler = () => {
      hydrateProposalsFromPortal(proposals, setProposals, currentLocalUserId());
      forceUpdate(n => n + 1);
    };
    window.addEventListener('lumenDataSync', handler);
    return () => window.removeEventListener('lumenDataSync', handler);
  }, [proposals]);

  // Listen for service worker push notification navigation
  useEffect(() => {
    const handler = (e) => setScreen(e.detail || 20);
    window.addEventListener('sw-navigate', handler);
    // Check if opened via notification tap
    if (window.__asgNavigateScreen) { setScreen(window.__asgNavigateScreen); window.__asgNavigateScreen = null; }
    return () => window.removeEventListener('sw-navigate', handler);
  }, []);

  const SESSION_TTL = 3 * 60 * 60 * 1000; // 3 hours in ms

  useEffect(() => {
    // S105 — also kick the photo retry queue when the network comes
    // back. Pre-S105 the online listener only flipped React state; the
    // queue waited for the next 5-minute syncPortalData tick, which on
    // a quick offline→online transition could leave photos sitting for
    // minutes. Now we attempt a flush immediately. flushPhotoRetryQueue
    // is internally guarded against concurrent runs.
    // SLICE-A5: move any recording still held as base64 into IndexedDB, once
    // at start; local work, so it needs no signal.
    try { Promise.resolve(moveVoiceAudioToIdb()).catch(() => {}); } catch (e) {}
    const on = () => {
      setIsOnline(true);
      try { flushPhotoRetryQueue(); } catch (e) {}
      try { Promise.resolve(moveVoiceAudioToIdb()).catch(() => {}); } catch (e) {}   // SLICE-A5
      // S4b — audio rides the same signal. Retry first (those recordings have
      // already failed once), then trickle the stranded back-fill behind it.
      try { flushAudioRetryQueue()
        .then(() => backfillVoiceAudio())
        .then(() => reclaimUploadedAudioBytes())
        .catch(() => {}); } catch (e) {}
    };
    const off = () => setIsOnline(false);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => { window.removeEventListener("online", on); window.removeEventListener("offline", off); };
  }, []);

  const [showOnboarding, setShowOnboarding] = useState(() => {
    try { return !localStorage.getItem("asg_onboarded"); } catch(e) { return false; }
  });

  // Auto-restore session on load if within 3-hour window
  useEffect(() => {
    try {
      const stored = localStorage.getItem("asg_current_user");
      const rawLastActive = localStorage.getItem("asg_last_active");
      // If no timestamp exists (upgrading from pre-v70), treat as just now
      const lastActive = rawLastActive ? parseInt(rawLastActive, 10) : Date.now();
      if (!rawLastActive) localStorage.setItem("asg_last_active", lastActive.toString());
      if (stored && Date.now() - lastActive < SESSION_TTL) {
        const user = JSON.parse(stored);
        // PATCH 1: one-time migration — deduplicate projects in localStorage
        try {
          const raw = localStorage.getItem(`asg_projects_${user.id}`);
          if (raw) {
            const parsed = JSON.parse(raw);
            const seen = new Set();
            const deduped = parsed.filter(p => {
              const key = p.id || p.name;
              if (seen.has(key)) return false;
              seen.add(key);
              return true;
            });
            if (deduped.length !== parsed.length) {
              localStorage.setItem(`asg_projects_${user.id}`, JSON.stringify(deduped));
            }
          }
        } catch(e) {}
        const savedProjects = localStorage.getItem(`asg_projects_${user.id}`);
        const savedProposals = localStorage.getItem(`asg_proposals_${user.id}`);
        const parsedProposals = savedProposals ? JSON.parse(savedProposals) : [];
        const parsedProjects = savedProjects ? JSON.parse(savedProjects) : [];
        setProjects(parsedProjects);
        setProposals(parsedProposals);
        // Hydrate from portal pipeline if local proposals is empty, and only
        // from this person's own cache (COMPANION-TRUTH-V2 B1).
        if (parsedProposals.length === 0) {
          hydrateProposalsFromPortal(parsedProposals, setProposals, user.id);
        }
        setCurrentUser(user);
        // S135 — surface + rehydrate an in-progress survey that survived a
        // crash / signal-drop / tab-kill (uses the just-parsed projects).
        maybeResumeActiveSurvey(parsedProjects);
        // Sync portal data in background on session restore, then every five
        // minutes, exactly as sign-in does.
        syncPortalData();
        startPortalSyncInterval();
        // Check director status on session restore
        fetch(PORTAL_URL + '/api/check-director?username=' + encodeURIComponent((user.name || '').toLowerCase()))
          .then(r => r.json())
          .then(d => {
          const v = !!d.is_director;
          setIsDirector(v);
          try { localStorage.setItem('_isDirector', v ? '1' : '0'); } catch(e) {}
        })
          .catch(() => {});
      } else {
        // Expired or no session — clear it
        localStorage.removeItem("asg_current_user");
      }
    } catch(e) {}
  }, []);

  // Update last-active timestamp when app comes back into view
  useEffect(() => {
    const handleVisibility = () => {
      if (!document.hidden && currentUser) {
        localStorage.setItem("asg_last_active", Date.now().toString());
        // S105 — also flush the photo retry queue when the user
        // foregrounds the app. iOS Safari often suspends in-flight
        // fetches when the tab becomes hidden; foregrounding is the
        // moment to retry anything that failed mid-suspend.
        try { flushPhotoRetryQueue(); } catch (e) {}
        // S1 — same moment, same reason, for pending voice transcriptions.
        // Before this, an in-zone recording only ever retried if the user
        // opened the standalone Voice Notes screen by hand.
        try { retryPendingVoiceTranscriptions(); } catch (e) {}
        // SLICE-A5: and move any base64 recording into IndexedDB.
        try { Promise.resolve(moveVoiceAudioToIdb()).catch(() => {}); } catch (e) {}
        // S4b — and the audio itself. Retry queue first (already-failed
        // uploads), then the trickle back-fill for recordings stranded before
        // this build existed. Both are internally guarded against concurrent
        // runs, and the back-fill stamps each note before attempting it, so a
        // rapid foreground/background cycle cannot double-upload.
        try { flushAudioRetryQueue()
        .then(() => backfillVoiceAudio())
        .then(() => reclaimUploadedAudioBytes())
        .catch(() => {}); } catch (e) {}
      }
    };
    document.addEventListener("visibilitychange", handleVisibility);
    return () => document.removeEventListener("visibilitychange", handleVisibility);
  }, [currentUser]);

  // S105 — react to background photo upload events. flushPhotoRetryQueue
  // can't call setProjects directly (it runs from event listeners and
  // module-scope helpers without React context), so it dispatches custom
  // events that this handler turns into setProjects calls. lumenPhotoUploaded
  // → swap base64 src for the returned URL in the project's sitePhotos.
  // lumenPhotoFailed → mark the photo uploadFailed=true so the UI surfaces
  // a red dot and the user knows the queue gave up.
  useEffect(() => {
    // SEND-STATE-V1: matched by photo id (the stored photo has no base64 to
    // match on), through the same test-locked helpers the survey screen uses,
    // and written to the survey draft too, so a restart (which prefers the
    // draft's photos) keeps the url and the send does not upload it again.
    const patchDraftPhotos = patchActiveDraftPhotos;
    const onUploaded = (e) => {
      const { projectId, oldSrc, newUrl, photoId, keepExisting } = e.detail || {};
      if (!projectId || !newUrl) return;
      setProjects(prev => prev.map(p => {
        if (p.id !== projectId) return p;
        const sitePhotos = applyPhotoUploaded(p.sitePhotos || [], oldSrc, newUrl, photoId, keepExisting);
        return sitePhotos === p.sitePhotos ? p : Object.assign({}, p, { sitePhotos });
      }));
      // Also reflect into activeProject if it's the matching one
      setActiveProject(prev => {
        if (!prev || prev.id !== projectId) return prev;
        const sitePhotos = applyPhotoUploaded(prev.sitePhotos || [], oldSrc, newUrl, photoId, keepExisting);
        return sitePhotos === prev.sitePhotos ? prev : Object.assign({}, prev, { sitePhotos });
      });
      patchDraftPhotos(projectId, (photos) => applyPhotoUploaded(photos, oldSrc, newUrl, photoId, keepExisting));
    };
    const onFailed = (e) => {
      const { projectId, src, photoId } = e.detail || {};
      if (!projectId || (!src && !photoId)) return;
      patchDraftPhotos(projectId, (photos) => applyPhotoFailed(photos, src, photoId));
      const markFailed = (photos) => applyPhotoFailed(photos || [], src, photoId);
      setProjects(prev => prev.map(p =>
        p.id === projectId ? Object.assign({}, p, { sitePhotos: markFailed(p.sitePhotos) }) : p
      ));
      setActiveProject(prev =>
        prev && prev.id === projectId
          ? Object.assign({}, prev, { sitePhotos: markFailed(prev.sitePhotos) })
          : prev
      );
    };
    window.addEventListener('lumenPhotoUploaded', onUploaded);
    window.addEventListener('lumenPhotoFailed', onFailed);
    return () => {
      window.removeEventListener('lumenPhotoUploaded', onUploaded);
      window.removeEventListener('lumenPhotoFailed', onFailed);
    };
  }, []);

  // SEND-STATE-V1: a survey the offline queue delivered is marked sent here,
  // exactly as Check and send marks an immediate success: the same fields
  // (wrapSentFields, with the portal's survey id and binding echo), the draft
  // cleared when it is this job's, the visit and survey queue rows flipped,
  // and the resume banner gone. The queue's delivery record is kept on the
  // phone (lumen_wrap_delivered), so one that carries its job's print is
  // applied at the next start; one with no print or no job id only as heard
  // in this session (_wrapHeard). Applying it twice changes
  // nothing: a job already sent is left alone.
  const projectsRef = useRef(projects);
  projectsRef.current = projects;
  // The person whose jobs `projects` holds. The start and sign-in set the
  // person and their jobs in one render, and Sign out clears both, so the
  // person drawn is the one whose jobs are loaded.
  const jobsOwnerRef = useRef(null);
  jobsOwnerRef.current = currentUser && currentUser.id != null && currentUser.id !== '' ? String(currentUser.id) : null;
  // The person signed in, once their jobs are drawn; null before then.
  const jobsLoadedFor = () => {
    const who = currentLocalUserId();
    return who && jobsOwnerRef.current === who ? who : null;
  };
  const wrapAppliedRef = useRef(new Set());
  // Which job (wrapDeliveryTarget): by job id, only while the job is still
  // the survey that was delivered; a record with no job id only when this
  // session's queue delivered it (live, _wrapHeard), never on the replay at
  // start, and once judged it is cut down to its client id so its name can
  // never mark a later job. Judged only against the jobs of the person signed
  // in, once drawn: before then nothing is decided and nothing is cut (a live
  // one waits in _wrapHeard, and the replay runs again when they are drawn).
  const applyWrapDelivery = (rec, live) => {
    if (!rec || !rec.client_id || rec.stub) return;
    // A survey queued by someone else on this phone, delivered while this
    // person is signed in: it is recorded for them (their own list), and
    // marked on their job when they are next signed in, never on this
    // person's jobs.
    if (rec.userId && rec.userId !== currentLocalUserId()) return;
    if (!jobsLoadedFor()) return;
    const target = wrapDeliveryTarget(rec, projectsRef.current || [], _readDraft(), !!live);
    if (!rec.projectId) _stubWrapDelivered(rec.client_id);
    if (!target.id) {
      if (target.why !== 'already_sent' && target.why !== 'no_record') {
        try { debugLog('wrap.delivered.not_applied', { client_id: rec.client_id, projectId: rec.projectId || null, why: target.why }); } catch (e) {}
        if (target.why === 'changed' || target.why === 'ambiguous') { try { console.warn('[send-state] a delivered survey was not marked sent:', target.why, rec.projectId || rec.projectName); } catch (e) {} }
      }
      return;
    }
    if (wrapAppliedRef.current.has(rec.client_id)) return;
    wrapAppliedRef.current.add(rec.client_id);
    const iso = rec.at || new Date().toISOString();
    // The voice notes still not transcribed are not in the survey that went
    // (the job is still that survey: its print matched); they are kept on the
    // job, so it reads as changed once one is transcribed.
    const _job = (projectsRef.current || []).find((p) => p && p.id === target.id) || null;
    const _d = _readDraft();
    // The notes the print matched (a draft of this job), onto the job in the
    // same update that stamps it sent, as the direct send does.
    updateProject(target.id, Object.assign(wrapSentNotesField(_d, _job), wrapSentFields(rec, iso, rec.jobPrint), wrapUnsentNotesField(resolveZoneNotesForPayload(_d && _d.projectId === target.id ? _d : null, _job))));
    wrapSentAfter(target.id, rec.surveyId, iso, { reason: 'wrap_queue_delivered', onlyIfDraftIsThisJob: true });
    setResumeDraft(prev => (prev && prev.project && prev.project.id === target.id) ? null : prev);
    try { debugLog('wrap.delivered.applied', { projectId: target.id, surveyId: rec.surveyId || '' }); } catch (e) {}
  };
  // This session's deliveries for the person signed in, each judged once, as
  // heard live, now their jobs are drawn; until then they wait in _wrapHeard.
  const judgeHeardDeliveries = () => {
    const who = jobsLoadedFor();
    if (who) _wrapHeardTake(who).forEach((r) => applyWrapDelivery(r, true));
  };
  useEffect(() => {
    const onDelivered = () => judgeHeardDeliveries();
    window.addEventListener('lumenWrapDelivered', onDelivered);
    return () => window.removeEventListener('lumenWrapDelivered', onDelivered);
  }, []);
  useEffect(() => {
    if (!currentUser) return;
    judgeHeardDeliveries();
    _readWrapDelivered().forEach((r) => applyWrapDelivery(r, false));
  }, [currentUser, projects.length]);
  // The resume banner's job and its send state (the stored row when there is
  // one, so a delivery that just landed counts).
  const resumeProject = resumeDraft && resumeDraft.project
    ? ((projects || []).find(p => p && p.id === resumeDraft.project.id) || resumeDraft.project) : null;
  const resumeSt = resumeProject ? readSendState(resumeProject) : null;
  // Waiting, failed or going: the banner says so (never Carry on), opens the
  // job when tapped, and offers the state's own action. Sent: no banner.
  const resumeWaiting = !!resumeSt && sendStateBlocksSend(resumeSt);
  const resumeBlocked = resumeWaiting || (!!resumeSt && resumeSt.state === 'sent');
  const resumeAct = () => {
    if (!resumeProject) return;
    if (sendStateNeedsWrap(resumeSt)) { setActiveProject(resumeProject); setScreen(11); setResumeDraft(null); return; }
    sendQueuedNow(resumeProject);
  };

  // S105 — open the debug overlay on the lumenOpenDebugOverlay custom
  // event (dispatched by the 5-tap-on-ASG-logo gesture in
  // PersistentHeader.handleLogoTap).
  useEffect(() => {
    const onOpen = () => setShowDebugOverlay(true);
    window.addEventListener('lumenOpenDebugOverlay', onOpen);
    return () => window.removeEventListener('lumenOpenDebugOverlay', onOpen);
  }, []);

  // ── S107 — Portal-authority hydration ─────────────────────────────
  // Pre-S107 the companion treated localStorage as canonical for
  // submitted-state. Hard reset / quota error / tab reload could lose
  // already-submitted surveys with no recovery path. Now: every mount
  // and every syncPortalData tick reconciles `lumen_surveys_portal`
  // (now populated by the rewired /api/companion/surveys endpoint
  // reading from companion_surveys) against the local projects array.
  //
  // Reconciliation rules (a local match is by id only, portalSurveyLocalIndex;
  // a job that only shares the row's name is left alone, and gets no shell):
  //   1. Portal row, no local match
  //        → create local "shell" project with _portalAuthority: true.
  //          Renders in Recently Submitted; tap opens /survey/view/<id>.
  //   2. Local match has surveyWrapCompletedAt
  //        → no-op (already submitted locally).
  //   3. Local match without surveyWrapCompletedAt
  //        → flip stage='surveyed', surveyWrapCompletedAt=<portal>,
  //          _portalAuthority: true. Preserve all local data
  //          (surveyZones, sitePhotos, scope) — user might be drafting
  //          a re-submission. Forensic-log via logDestructiveAction.
  //   4. Orphan survey_queue 'planned' row
  //        → handled by SurveyLandingScreen mount-time reconciliation
  //          (S99). No additional logic here.
  const hydratePortalSubmittedSurveys = React.useCallback(() => {
    if (!currentUser || !currentUser.id) return;
    const portalData = getPortalData('lumen_surveys_portal', { surveys: [] });
    const portalSurveys = (portalData.surveys || []).filter(
      s => s && !s.superseded_by_id && (s.project_name || '').trim()
    );
    if (portalSurveys.length === 0) return;
    const _deletedIds = getDeletedSurveyIds();
    const userDivision = (getDivisionConfig(currentUser) || {}).id || 'lighting';

    setProjects(prev => {
      let next = prev.slice();
      let mutated = false;
      let shellsCreated = 0;
      let flipped = 0;

      for (const ps of portalSurveys) {
        const psNorm = _normProjName(ps.project_name);
        if (!psNorm) continue;
        const shellId = `portal_${ps.id}`;
        // Skip if user explicitly tombstoned this portal-id
        if (_deletedIds.has(shellId)) continue;

        // SEND-STATE-V1 follow-up: the local job is found by id only (the
        // shell's job id, or the portal survey id the job carries), never by
        // name: a later job sharing an earlier survey's name was marked sent.
        const localIdx = portalSurveyLocalIndex(next, ps);

        if (localIdx === -1) {
          // A job that only shares the survey's name is left alone: not marked
          // sent, and no shell is made beside it (as before, when the name
          // matched).
          if (next.some(p => p && _normProjName(p.name) === psNorm)) continue;
          // Case 1 — no local match: create portal-authority shell.
          next.push({
            id: shellId,
            name: ps.project_name,
            client: ps.site_address || '',
            division: userDivision,
            stage: 'surveyed',
            surveyWrapCompletedAt: ps.submitted_at,
            submitted_at: ps.submitted_at,
            fixture_count: ps.fixture_count || 0,
            visit_label: ps.visit_label || null,
            surveyZones: [],
            customZones: [],
            scopeAnswers: {},
            visitNotes: [],
            timeline: [{ ts: Date.now(), type: 'portal_authority',
                         label: 'Synced from portal', icon: 'check' }],
            createdAt: ps.submitted_at ? new Date(ps.submitted_at).getTime() : Date.now(),
            updatedAt: Date.now(),
            _portalAuthority: true,
            _portalSurveyId: ps.id,
          });
          shellsCreated += 1;
          mutated = true;
          try { debugLog('portal_authority.shell_created', {
            portalId: ps.id, name: ps.project_name,
          }); } catch (e) {}
          continue;
        }

        const local = next[localIdx];
        if (local.surveyWrapCompletedAt) {
          // Case 2 — already submitted locally; no-op.
          continue;
        }

        // Case 3 — flip without destroying any local data.
        try {
          logDestructiveAction('portal_authority_flip', {
            projectId: local.id,
            meta: {
              name: local.name,
              before: {
                stage: local.stage || 'enquiry',
                surveyWrapCompletedAt: null,
                surveyZones_count: Array.isArray(local.surveyZones) ? local.surveyZones.length : 0,
              },
              portalState: {
                portalId: ps.id,
                submitted_at: ps.submitted_at,
                visit_label: ps.visit_label || null,
              },
            },
          });
        } catch (e) {}
        next[localIdx] = Object.assign({}, local, {
          surveyWrapCompletedAt: ps.submitted_at,
          submitted_at: ps.submitted_at,
          stage: 'surveyed',
          fixture_count: ps.fixture_count || local.fixture_count || 0,
          visit_label: ps.visit_label || local.visit_label || null,
          _portalAuthority: true,
          _portalSurveyId: ps.id,
          updatedAt: Date.now(),
        });
        flipped += 1;
        mutated = true;
        try { debugLog('portal_authority.flipped', {
          projectId: local.id, name: local.name, portalId: ps.id,
        }); } catch (e) {}
      }

      if (mutated) {
        try { debugLog('portal_authority.summary', {
          shellsCreated, flipped, totalPortalRows: portalSurveys.length,
        }); } catch (e) {}
      }
      return mutated ? next : prev;
    });
  }, [currentUser]);

  // UV-RESKIN-V1 track B: re-read the theme after every sync (the moment
  // lumen_profile is refreshed). applyUiTheme rewrites `t` in place; the tick
  // re-renders the tree without remounting it.
  const [, setUiThemeTick] = useState(0);
  useEffect(() => {
    const onSync = () => {
      if (applyUiTheme(readCachedUiTheme())) setUiThemeTick((n) => n + 1);
    };
    window.addEventListener('lumenDataSync', onSync);
    return () => window.removeEventListener('lumenDataSync', onSync);
  }, []);
  // Run hydration once whenever currentUser becomes truthy (login or
  // session restore — both call setCurrentUser).
  useEffect(() => {
    if (!currentUser) return;
    hydratePortalSubmittedSurveys();
  }, [currentUser, hydratePortalSubmittedSurveys]);

  // Run hydration on every lumenDataSync — fired by syncPortalData
  // after each 5-minute portal poll, after a manual pull-to-refresh,
  // and after queue/visit writes that touch local state. The 'sync'
  // event is the moment lumen_surveys_portal has been refreshed, so
  // re-reconciling here catches new portal-side submissions.
  useEffect(() => {
    const onSync = () => hydratePortalSubmittedSurveys();
    window.addEventListener('lumenDataSync', onSync);
    return () => window.removeEventListener('lumenDataSync', onSync);
  }, [hydratePortalSubmittedSurveys]);

  // S107 — mount-time localStorage snapshot. Single debugLog entry on
  // first useEffect tick captures the size of every state bucket the
  // companion cares about, so when something disappears from the UI
  // we can compare "state when user opened the app" against "state
  // after the bug" instead of guessing.
  useEffect(() => {
    try {
      const _safeLen = (k, sub) => {
        try {
          const raw = localStorage.getItem(k);
          if (!raw) return 0;
          const obj = JSON.parse(raw);
          if (Array.isArray(obj)) return obj.length;
          if (sub && obj && Array.isArray(obj[sub])) return obj[sub].length;
          if (obj && typeof obj === 'object') return Object.keys(obj).length;
          return 0;
        } catch (e) { return -1; }
      };
      const _userId = (() => {
        try { return JSON.parse(localStorage.getItem('asg_current_user') || '{}').id || ''; }
        catch (e) { return ''; }
      })();
      debugLog('mount.localstorage.snapshot', {
        projects_count:        _userId ? _safeLen(`asg_projects_${_userId}`) : 0,
        queue_count:           _safeLen('survey_queue'),
        visits_count:          _safeLen('lumen_visits'),
        snags_count:           _safeLen('lumen_snags'),
        surveys_portal_count:  _safeLen('lumen_surveys_portal', 'surveys'),
        deleted_surveys_count: _safeLen('lumen_deleted_surveys'),
        deleted_snags_count:   _safeLen('lumen_deleted_snags'),
        photo_retry_count:     _safeLen('lumen_photo_retry_queue'),
        offline_queue_count:   _safeLen('lumen_offline_queue'),
      });
    } catch (e) {}
  }, []);

  // Persist projects to localStorage whenever they change
  useEffect(() => {
    if (!currentUser) return;
    try { localStorage.setItem(`asg_projects_${currentUser.id}`, JSON.stringify(projects)); } catch(e) {}
  }, [projects, currentUser]);

  // Persist proposals to localStorage whenever they change
  useEffect(() => {
    if (!currentUser) return;
    try { localStorage.setItem(`asg_proposals_${currentUser.id}`, JSON.stringify(proposals)); } catch(e) {}
  }, [proposals, currentUser]);

  const [restoreAvailable, setRestoreAvailable] = useState(null); // null | {projects: [...]}

  const login = (user) => {
    let loadedProjects = [];
    try {
      localStorage.setItem("asg_current_user", JSON.stringify(user));
      localStorage.setItem("asg_last_active", Date.now().toString());
      const savedProjects = localStorage.getItem(`asg_projects_${user.id}`);
      loadedProjects = savedProjects ? JSON.parse(savedProjects) : [];
      setProjects(loadedProjects);
      const savedProposals = localStorage.getItem(`asg_proposals_${user.id}`);
      const parsedLoginProposals = savedProposals ? JSON.parse(savedProposals) : [];
      setProposals(parsedLoginProposals);
      // COMPANION-TRUTH-V2 B1: the caches on this phone become this person's;
      // any another person (or nobody we can name) left are cleared first,
      // which covers a session that lapsed with no switch (SESSION_TTL).
      claimPortalCaches(user.id);
      // Hydrate from portal pipeline if local proposals is empty, and only
      // from this person's own cache.
      if (parsedLoginProposals.length === 0) {
        hydrateProposalsFromPortal(parsedLoginProposals, setProposals, user.id);
      }
    } catch(e) {
      setProjects([]);
      setProposals([]);
    }
    setCurrentUser(user);
    setScreen(0);
    // S135 — resume an in-progress survey for this user if a draft survived.
    maybeResumeActiveSurvey(loadedProjects);
    // Check director status
    fetch(PORTAL_URL + '/api/check-director?username=' + encodeURIComponent((user.name || '').toLowerCase()))
      .then(r => r.json())
      .then(d => {
        const v = !!d.is_director;
        setIsDirector(v);
        try { localStorage.setItem('_isDirector', v ? '1' : '0'); } catch(e) {}
      })
      .catch(() => setIsDirector(false));
    // Register push notifications
    registerPushNotifications(user);
    // COMPANION-TRUTH-V1: the retired score shim is no longer synced; drop any
    // body an older build cached so nothing can read it again.
    try { localStorage.removeItem('lumen_score'); localStorage.removeItem('lumen_score_synced_at'); } catch(e) {}
    // STUDIO-LIT-PHONE-V1 item 4 (decision 3): the device score's director
    // weights are gone with it; drop any an older build saved.
    try { localStorage.removeItem('lumen_score_weights'); } catch(e) {}
    // Sync portal data — runs immediately, updates localStorage cache
    syncPortalData();
    // Fetch target from portal — portal is source of truth
    fetchTargetFromPortal();
    // Background refresh every 5 minutes
    startPortalSyncInterval();
    // If no local projects, check portal for restore
    if (loadedProjects.length === 0) {
      fetch(PORTAL_URL + '/api/companion/restore')
        .then(r => r.json())
        .then(data => {
          if (data.projects && data.projects.length > 0) {
            setRestoreAvailable(data);
          }
        })
        .catch(() => {});
    }
  };

  const handleRestore = () => {
    if (!restoreAvailable || !restoreAvailable.projects) return;
    const restored = restoreAvailable.projects.map((p, i) => ({
      id: `restored_${Date.now()}_${i}`,
      name: p.name, client: p.client, contact: p.contact, contactRole: p.contactRole,
      contactEmail: p.contactEmail, address: p.address, floors: p.floors,
      driver: p.driver, budget: p.budget, division: p.division, notes: p.notes,
      scopeAnswers: p.scopeAnswers || {}, surveyZones: p.surveyZones || [],
      stage: p.stage || "enquiry", source: "restored",
      createdAt: Date.now(), updatedAt: Date.now(),
      timeline: [{ ts: Date.now(), type: "restored", label: "Restored from portal", icon: "undo" }],
    }));
    // S96 BRIEF A · forensic — handleRestore replaces the ENTIRE projects
    // state with the portal payload. This only fires when the user explicitly
    // taps the restore card, but is logged because it's a wholesale local
    // overwrite and we want a forensic trail if data ever appears wrong post-
    // restore.
    try {
      logDestructiveAction('handle_restore_from_portal', {
        projectId: '',
        meta: { restoredCount: restored.length, names: restored.map(r => r.name).slice(0, 20) },
      });
    } catch(e) {}
    setProjects(restored);
    setRestoreAvailable(null);
  };

  const dismissRestore = () => setRestoreAvailable(null);

  // COMPANION-TRUTH-V2 B1: the person, the token and every portal cache go
  // (clearForNextPerson), so the next person on this phone never sees or
  // builds on the last person's portal data; any sign-in hold ends, as on
  // Sign out. UV-RESKIN-V1 track B: lumen_profile goes with the caches, so
  // the next person starts on today's look; their own profile sync sets
  // theirs. The banner's "Sign in again" keeps the hold and its request.
  const resetForNextPerson = () => {
    // The last person's five-minute sync stops with them, on both paths here
    // (Sign out and the banner's Sign in again); the next sign-in starts its own.
    try { if (window._lumenSyncInterval) clearInterval(window._lumenSyncInterval); } catch (e) {}
    window._lumenSyncInterval = null;
    setCurrentUser(null);
    setIsDirector(false);
    setShowPMView(false);
    if (applyUiTheme(null)) setUiThemeTick((n) => n + 1);
    setProjects([]);
    setProposals([]);
    setActiveProject(null);
    setScreen(0);
  };
  const switchUser = () => {
    clearForNextPerson();
    resetForNextPerson();
  };
  const signInAgainFromBanner = () => {
    clearForNextPerson({ keepSignInHold: true });
    resetForNextPerson();
  };

  const updateUser = (updatedUser) => {
    try {
      // Update in the users list
      const stored = localStorage.getItem("asg_users");
      if (stored) {
        const users = JSON.parse(stored);
        const updated = users.map(u => u.id === updatedUser.id ? updatedUser : u);
        localStorage.setItem("asg_users", JSON.stringify(updated));
      }
      // Update current session
      localStorage.setItem("asg_current_user", JSON.stringify(updatedUser));
    } catch(e) {}
    setCurrentUser(updatedUser);
  };

  const addProject = (proj) => {
    const now = Date.now();
    const firstEvent = { ts: now, type: "created", label: "Enquiry logged", icon: "zap" };
    const full = { id: 'proj_' + now + '_' + Math.random().toString(36).slice(2,8), stage: "enquiry", surveyZones: [], scopeAnswers: {}, visitNotes: [], createdAt: now, updatedAt: now, ...proj, timeline: [firstEvent] };
    setProjects(prev => {
      // BUG-02 fix: deduplicate on write — prevent phantom duplicate entries
      const exists = prev.find(p => p.id === full.id || (p.name && full.name && p.name.toLowerCase() === full.name.toLowerCase()));
      if (exists) return prev.map(p => p.id === exists.id ? { ...p, ...full, id: exists.id } : p);
      return [...prev, full];
    });
    setActiveProject(full);
    return full;
  };

  const updateProject = (id, updates) => {
    const now = Date.now();
    // S135 — ref-shape any sitePhotos before they reach localStorage so base64
    // never persists (durable blobs live in IndexedDB by id; see photoToRef).
    if (updates && updates.sitePhotos) {
      updates = Object.assign({}, updates, { sitePhotos: photosToRefs(updates.sitePhotos) });
    }
    const withTs = { ...updates, updatedAt: now };
    // Auto-log stage changes to timeline
    const stageLabels = {
      previsit: { label: "Pre-visit brief reviewed", icon: "star" },
      surveyed: { label: "Site survey completed", icon: "chart" },
      proposed: { label: "Proposal generated", icon: "send" },
      won: { label: "Project won!", icon: "check" },
      lost: { label: "Project marked lost", icon: "close" },
    };
    if (updates.stage && stageLabels[updates.stage]) {
      const entry = { ts: now, type: updates.stage, ...stageLabels[updates.stage] };
      withTs.timeline = undefined; // handled below
      setProjects(prev => prev.map(p => {
        if (p.id !== id) return p;
        const lastTl = (p.timeline||[]).slice(-1)[0];
        const alreadyLogged = lastTl && lastTl.type === updates.stage;
        const tl = alreadyLogged ? (p.timeline||[]) : [...(p.timeline||[]), entry];
        return { ...p, ...withTs, timeline: tl };
      }));
      setActiveProject(prev => {
        if (!prev || prev.id !== id) return prev;
        const lastTl = (prev.timeline||[]).slice(-1)[0];
        const alreadyLogged = lastTl && lastTl.type === updates.stage;
        const tl = alreadyLogged ? (prev.timeline||[]) : [...(prev.timeline||[]), entry];
        return { ...prev, ...withTs, timeline: tl };
      });
    } else {
      setProjects(prev => prev.map(p => p.id === id ? { ...p, ...withTs } : p));
      setActiveProject(prev => prev && prev.id === id ? { ...prev, ...withTs } : prev);
    }
  };

  const saveProposal = (prop) => {
    if (prop.__markStatus) {
      setProposals(prev => prev.map(p => {
        if (p.id !== prop.id) return p;
        const newP = { ...p, status: prop.status, updatedAt: new Date().toISOString() };
        if (prop.status === 'won') { newP.won = true; newP.lost = false; }
        else if (prop.status === 'lost') { newP.won = false; newP.lost = true; }
        else { newP.won = false; newP.lost = false; }
        return newP;
      }));
    } else if (prop.__toggle) {
      setProposals(prev => prev.map(p => p.id === prop.id ? { ...p, won: !p.won } : p));
    } else {
      setProposals(prev => [...prev, prop]);
      // Advance project stage to "proposed" if not already won/lost
      if (prop.projectId) {
        updateProject(prop.projectId, { stage: "proposed" });
      }
    }
  };

  const deleteProject = (projId) => {
    setProjects(prev => prev.filter(p => p.id !== projId));
  };

  const [portalStatus, setPortalStatus] = useState(null); // null | 'sending' | 'sent' | 'error'

  const sendROIToPortal = async (project) => {
    if (!project) return;
    const surveyZones = project.surveyZones || [];
    if (surveyZones.length === 0) { setPortalStatus('error'); return; }
    setPortalStatus('sending');
    try {
      const div = getDivisionConfig(currentUser);
      const totalOldW  = surveyZones.reduce((s, z) => s + (z.unit.wattage      * z.qty), 0);
      const totalNewW  = surveyZones.reduce((s, z) => s + (z.unit.replacementW * z.qty), 0);
      const totalCapex = capexOrNull(surveyZones); // null when any line has no real cost
      const opHours = 2920; // 8hrs × 365
      const elecRate = 28.0; // p/kWh
      const carbonFactor = 0.233;
      const annualSaving = ((totalOldW - totalNewW) / 1000) * opHours * elecRate / 100;
      const co2 = ((totalOldW - totalNewW) / 1000) * opHours * carbonFactor;

      const payload = {
        projectName:   project.name    || 'Site Survey',
        clientName:    project.client  || '',
        contactName:   currentUser?.name || 'Andrew Cowper',
        contactEmail:  'a.cowper@asgsl.co.uk',
        contactPhone:  '07742 621 211',
        division:      div.id || 'lighting',
        elecRate,
        opHours,
        carbonFactor,
        tariffIncrease: 5,
        // Fixture items for portal calculator
        items: surveyZones.map(z => ({
          zone:             z.zone || 'General',
          existingType:     z.unit?.name  || z.unit?.label || 'Existing Fitting',
          existingWattage:  z.unit?.wattage      || 0,
          proposedType:     (z.unit?.label || 'LED') + ' LED',
          proposedWattage:  z.unit?.replacementW || 0,
          qty:              z.qty || 1,
          unitCost:         costOrNull(z.unit?.unitCost),
        })),
        // Pre-computed summary as fallback
        total_old_kw:         totalOldW / 1000,
        total_new_kw:         totalNewW / 1000,
        total_annual_saving:  Math.round(annualSaving),
        total_capex:          totalCapex,
        total_co2:            Math.round(co2 * 1000) / 1000,
        source: 'companion',
      };

      const resp = await fetch(PORTAL_URL + '/api/roi-report', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      const data = await resp.json();
      if (data.ref) {
        setPortalStatus('sent');
        window.open(PORTAL_URL + '/roi/' + data.ref, '_blank');
        updateProject(project.id, { roiRef: data.ref, roiSentAt: Date.now() });
        return data.ref;
      } else {
        setPortalStatus('error');
      }
    } catch (e) {
      console.error('ROI portal handoff failed:', e);
      setPortalStatus('error');
    }
  };

  const sendToPortal = async (project) => {
    if (!project) return;
    setPortalStatus('sending');
    try {
      const payload = {
        name: project.name || '',
        address: project.address || '',
        client: project.client || '',
        contact: project.contact || '',
        contactRole: project.contactRole || '',
        contactEmail: project.contactEmail || '',
        floors: project.floors || '',
        driver: project.driver || '',
        budget: project.budget || '',
        visitTimeline: project.visitTimeline || '',
        notes: project.notes || '',
        division: getDivisionConfig(currentUser).id || 'lighting',
        scopeAnswers: project.scopeAnswers || {},
        surveyZones: project.surveyZones || [],
        // Only send zones that actually have entries
        activeZones: (project.surveyZones || []).map(e => e.zone).filter((z, i, a) => a.indexOf(z) === i),
        zoneNotes: project.zoneNotes || {},
        voiceNotes: (project.voiceNotes || []).map(n => ({ ts: n.ts, text: n.text || n.transcript || '', duration: n.duration || 0 })),
        // Photos: upload each to portal first, attach returned URL to metadata
        photoMeta: await Promise.all(
          (project.sitePhotos || []).filter(p => p.type !== 'video' && p.src).map(async (p) => {
            try {
              const uploadResp = await fetch(PORTAL_URL + '/api/photo', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ image: p.src }),
              });
              const uploadData = await uploadResp.json();
              return { type: p.type || 'photo', zone: p.zone, ts: p.ts, label: p.label, url: uploadData.url || null };
            } catch (e) {
              return { type: p.type || 'photo', zone: p.zone, ts: p.ts, label: p.label, url: null };
            }
          })
        ),
        photoCount: (project.sitePhotos || []).filter(p => p.type !== 'video').length,
        videoCount: (project.sitePhotos || []).filter(p => p.type === 'video').length,
        source: 'companion',
      };
      const resp = await fetch(PORTAL_URL + '/api/handoff', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      const data = await resp.json();
      if (data.success && data.draft_id) {
        setPortalStatus('sent');
        // Open portal with draft pre-loaded
        window.open(PORTAL_URL + '/?draft=' + data.draft_id, '_blank');
        // Update project timeline
        updateProject(project.id, {
          portalDraftId: data.draft_id,
          portalSentAt: Date.now(),
        });
        return data.draft_id;
      } else {
        setPortalStatus('error');
        return null;
      }
    } catch (e) {
      console.error('Portal handoff failed:', e);
      setPortalStatus('error');
      return null;
    }
  };

  const [newEnquiryOrigin, setNewEnquiryOrigin] = useState(4); // track where NewEnquiry was triggered from
  // Where My performance (17) was opened from: Settings (7, the only way in
  // with the switch off) or More (16, switch on). Back returns there.
  const [perfOrigin, setPerfOrigin] = useState(7);

  const [navOpts, setNavOpts] = useState({});
  // SLICE-A4: bumped by the header mic while the survey (screen 3) is open;
  // LiveSurveyScreen opens its own voice sheet on a change.
  const [surveyVoiceTick, setSurveyVoiceTick] = useState(0);
  const nav = (s, opts = {}) => {
    setNavOpts(opts);
    if (s === 4 && opts.fromSurvey) setFromSurvey(true);
    else if (s === 4) setFromSurvey(false);
    // Tab bar Home clears active project — but NOT if a survey is in progress
    if (s === 0) {
      const hasSurveyActive = (() => { try { return !!localStorage.getItem('survey_active'); } catch(e) { return false; } })();
      if (!hasSurveyActive) setActiveProject(null);
    }
    // Start new survey from landing — check if survey_prefill points to an existing project
    if (s === 2 && screen === 10) {
      try {
        const prefill = JSON.parse(localStorage.getItem('survey_prefill') || 'null');
        if (prefill) {
          const prefillName = (prefill.visitName || '').toLowerCase().trim();
          const existingProj = (prefill.surveyId && projects.find(p => p.id === prefill.surveyId))
            || (prefillName && projects.find(p => (p.name || '').toLowerCase().trim() === prefillName));
          if (existingProj) {
            // Survey project exists — skip name entry, go straight to live survey
            localStorage.removeItem('survey_prefill');
            setActiveProject(existingProj);
            setScreen(3);
            return;
          }
          // S99 — DO NOT remove the prefill here. QuickEntryScreen reads
          // it on mount to inherit the visit's surveyId so the new
          // project's id matches the existing queue / visit row, then
          // clears the key itself in handleStart. Clearing here would
          // strand the id and reproduce the original phantom-Planned bug.
        }
      } catch(e) {}
      setActiveProject(null);
    }

    // Track NewEnquiry origin for proper Back navigation
    if (s === 6) setNewEnquiryOrigin(screen);
    if (s === 17) setPerfOrigin(screen === 16 ? 16 : 7);

    setScreen(s);
  };
  const back = () => setScreen(0);

  // First launch onboarding
  if (showOnboarding) return <OnboardingFlow onDone={() => {
    try { localStorage.setItem("asg_onboarded", "1"); } catch(e) {}
    setShowOnboarding(false);
  }} />;

  // Not logged in — show user select
  if (!currentUser) return <UserSelectScreen onLogin={login} />;

  // ── Main tab swipe navigation ──
  const TAB_ORDER = [0, 19, 18, 10, 15];
  const currentTabPos = TAB_ORDER.indexOf(screen);
  const isMainTab = currentTabPos !== -1;
  const mainSwipe = createSwipeHandler(
    () => { // swipe left → next tab
      if (!isMainTab || showVoiceModal || showNotifPanel) return;
      if (currentTabPos < TAB_ORDER.length - 1) nav(TAB_ORDER[currentTabPos + 1]);
    },
    () => { // swipe right → previous tab
      if (!isMainTab || showVoiceModal || showNotifPanel) return;
      if (currentTabPos > 0) nav(TAB_ORDER[currentTabPos - 1]);
    }
  );

  const renderScreen = () => {
    switch (screen) {
      case 0: return <TodayScreen onNav={nav} projects={projects} proposals={proposals} setActiveProject={(p) => { setActiveProject(p); }} currentUser={currentUser} onDeleteProject={deleteProject} onUpdateProject={updateProject} restoreAvailable={restoreAvailable} onRestore={handleRestore} onDismissRestore={dismissRestore} isDirector={isDirector} onSwitchToDirector={() => setShowPMView(false)} />;
      case 1: return <PreVisitScreen onBack={back} onNav={nav} project={activeProject} currentUser={currentUser} onUpdateProject={updateProject} />;
      case 2: return <QuickEntryScreen onBack={() => setScreen(10)} onNav={nav} currentUser={currentUser} project={activeProject} onUpdateProject={updateProject} onCreateProject={(data) => { const div = getDivisionConfig(currentUser); const proj = addProject({ ...data, division: div.id }); return proj; }} />;
      case 3: return <LiveSurveyScreen onBack={() => setScreen(10)} onNav={nav} currentUser={currentUser} activeProject={activeProject} onUpdateProject={updateProject} projects={projects} onOpenProject={(proj) => { setActiveProject(proj); setScreen(3); }} voiceRequest={surveyVoiceTick} />;
      case 4: return <ProposalScreen onBack={() => setScreen(fromSurvey ? 3 : 0)} onNav={nav} currentUser={currentUser} activeProject={activeProject} proposals={proposals} onSaveProposal={saveProposal} fromSurvey={fromSurvey} onUpdateProject={updateProject} onSendToPortal={sendROIToPortal} portalStatus={portalStatus} allProjects={projects} setActiveProject={setActiveProject} />;
      case 5: return <IssueCaptureScreen onBack={() => setScreen(1)} onNav={nav} project={activeProject} onUpdateProject={updateProject} currentUser={currentUser} />;
      case 6: return <NewEnquiryScreen onBack={() => setScreen(newEnquiryOrigin)} onSave={proj => { const div = getDivisionConfig(currentUser); addProject({ ...proj, division: div.id }); setScreen(newEnquiryOrigin === 10 ? 2 : (newEnquiryOrigin === 3 ? 2 : newEnquiryOrigin)); }} currentUser={currentUser} />;
      case 7: return <SettingsScreen onNav={nav} onBack={() => setScreen(16)} currentUser={currentUser} onSwitchUser={switchUser} onUpdateUser={updateUser} />;
      case 8: return <SitePlanScreen onBack={() => setScreen(10)} onNav={nav} project={activeProject} onUpdateProject={updateProject} currentUser={currentUser} />;
      case 9: return <VoiceNotesScreen onNav={nav} currentUser={currentUser} activeProject={activeProject} onUpdateProject={updateProject} noteBinding={voiceNoteBinding} onPickJob={() => setShowVoiceModal(true)} />;
      case 10: return <SurveyLandingScreen onBack={() => setScreen(0)} onNav={nav} currentUser={currentUser} projects={projects} onOpenProject={(proj) => { setActiveProject(proj); setScreen(3); }} onCreateProject={(data) => { const div = getDivisionConfig(currentUser); const proj = addProject({ ...data, division: div.id }); return proj; }} onDeleteProject={deleteProject} />;
      case 11: return <SurveyWrapScreen onBack={() => setScreen(3)} onNav={nav} activeProject={activeProject} onUpdateProject={updateProject} currentUser={currentUser} askReport={!!navOpts.askReport} />;
      case 12: return <SnagSetupScreen onBack={() => setScreen(10)} onNav={nav} currentUser={currentUser} projects={projects} />;
      case 13: return <SnagCaptureScreen onBack={() => setScreen(10)} onNav={nav} snagId={navOpts.snagId} currentUser={currentUser} />;
      case 14: return <SnagReviewScreen onBack={() => setScreen(10)} onNav={nav} snagId={navOpts.snagId} currentUser={currentUser} />;
      case 15: return <WorthScreen onNav={nav} currentUser={currentUser} />;
      case 16: return <MoreScreen onNav={nav} currentUser={currentUser} />;
      case 17: return <MyTargetsScreen onNav={nav} onBack={() => setScreen(perfOrigin)} backLabel={perfOrigin === 16 ? 'More' : undefined} currentUser={currentUser} />;
      case 18: return <PipelineScreen onNav={nav} currentUser={currentUser} proposals={proposals} onSaveProposal={saveProposal} />;
      case 19: return <CompanyScreen onNav={nav} currentUser={currentUser} projects={projects} proposals={proposals} />;
      case 20: return <MorningBriefingScreen onNav={nav} currentUser={currentUser} />;
      case 21: return <ContactsScreen onBack={() => setScreen(16)} onNav={nav} currentUser={currentUser} proposals={proposals} />;
      case 22: {
        // SLICE-A3: Back returns to the survey when it was opened from one
        // (navOpts.backTo), and to More otherwise.
        const back22 = supplierBackTarget(navOpts);
        return <SuppliersScreen onBack={() => setScreen(back22.screen)} backLabel={back22.label} initialCover={navOpts.coverType} />;
      }
      default: return null;
    }
  };

  return (
    <div style={{
      position: "fixed",
      top: 0, left: 0, right: 0, bottom: 0,
      width: "100%",
      height: "100%",
      background: "#E8DCC8",
      display: "flex",
      flexDirection: "column",
      fontFamily: "-apple-system, 'Helvetica Neue', Arial, sans-serif",
      overflow: "hidden",
      overscrollBehavior: "none",
      color: "#1A1608",
      // STUDIO-LIT-REDO-V1 P2: under the theme the shell paints no warm stone of
      // its own, so body.theme-uv's lit ground shows behind the header and any
      // screen that leaves its own ground clear (Pipeline did, so it read cream).
      ...uvx(() => ({ background: 'transparent', color: STUDIO_TOKENS.ink })),
    }}>
      <style>{`
        * { box-sizing: border-box; margin: 0; padding: 0; }
        button { font-family: inherit; }
        :root { --sab: env(safe-area-inset-bottom, 0px); }
      `}</style>
      {currentUser && <PersistentHeader divisionId={currentUser.division || "lighting"} hideGlobalMic={screen === 11} hideDate={screen === 0} briefingUnread={briefingUnread} onBellTap={handleBellTap} showNotifPanel={showNotifPanel} setShowNotifPanel={setShowNotifPanel} onReadBriefing={() => { setShowNotifPanel(false); setScreen(20); }} onVoice={() => {
        // SLICE-A4: with the survey open (screen 3) the mic records INTO the
        // survey: the survey's own voice sheet opens over it and files the note
        // to the open area (or Site-wide). It never leaves for the Voice notes
        // screen, which binds a note to the project only.
        if (activeProject && screen === 3) {
          setSurveyVoiceTick(n => n + 1);
          return;
        }
        // UX doc: if inside open project or survey workflow, skip modal & auto-attach
        if (activeProject && [1,2,5,8,11].includes(screen)) {
          // B.2 Slice 3 — the note inherits the active project's binding
          // (explicitly picked at QuickEntry, so inheritance is not guessing).
          // Unbound active project ⇒ null ⇒ project_id: null on the wire.
          setVoiceNoteBinding(getProjectBinding(activeProject));
          setScreen(9); // go to voice screen, project already set
          // Confirmation toast
          const te = document.createElement('div');
          te.textContent = `Recording for ${activeProject.name}`;
          Object.assign(te.style, { position:'fixed', bottom:'110px', left:'50%', transform:'translateX(-50%)', background:'#2E6838', color:'#fff', padding:'10px 20px', borderRadius:'20px', fontSize:'13px', fontWeight:'700', zIndex:'9999', opacity:'1', transition:'opacity 0.3s' });
          // P0 tidy: with the switch on this toast is the shared top-of-screen
          // one, not a green pill at the bottom over the voice screen's buttons.
          if (t.theme === 'uv') Object.assign(te.style, studioToastStyle());
          document.body.appendChild(te);
          setTimeout(() => { te.style.opacity = '0'; setTimeout(() => te.remove(), 300); }, 2000);
        } else {
          setShowVoiceModal(true);
        }
      }} />}
      {/* STUDIO-LIT-PHONE-V1 item 8a: with the switch on the app's banners are
          the lit layer: offline is a well with ink words (no dark panel but
          Eva's jewel), resume is raised paper with the action in ink, and the
          active project is a plain line under the header (no beating dot). */}
      {!isOnline && t.theme === 'uv' && (
        <div role="status" style={{ margin: "2px 16px 6px", padding: "8px 14px", borderRadius: STUDIO_TOKENS.pressed.radius, ...studioSurface.pressed(), display: "flex", alignItems: "center", gap: 8, flexShrink: 0, fontFamily: STUDIO_TOKENS.fonts.body }}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={STUDIO_TOKENS.ink} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M1.05 12.05A11 11 0 0 1 12 2"/><path d="M4.93 15.07A7 7 0 0 1 12 6"/><path d="M8.83 18.17A3 3 0 0 1 12 14"/><line x1="12" y1="14" x2="12" y2="22"/></svg>
          <p style={{ fontSize: 14, color: STUDIO_TOKENS.ink }}>You're offline. Everything you do is saved on this phone.</p>
        </div>
      )}
      {!isOnline && t.theme !== 'uv' && (
        <div style={{ background: "#1A1200", borderBottom: "0.5px solid rgba(251,176,64,0.3)", padding: "8px 20px", display: "flex", alignItems: "center", gap: 8, animation: "slideDown 0.3s ease", flexShrink: 0 }}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#FBB040" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1.05 12.05A11 11 0 0 1 12 2"/><path d="M4.93 15.07A7 7 0 0 1 12 6"/><path d="M8.83 18.17A3 3 0 0 1 12 14"/><line x1="12" y1="14" x2="12" y2="22"/></svg>
          <p style={{ fontSize: 12, fontWeight: 600, color: "#FBB040" }}>Working offline — all changes saved locally</p>
        </div>
      )}
      {/* SECURITY-WAVE-1 track C: the portal refused the sign-in. Switching
          user leads to the PIN, which asks for the portal password because
          the dead token is gone; nothing queued is touched. */}
      {currentUser && signInNeeded && (
        <SignInAgainBanner online={isOnline} onSignIn={signInAgainFromBanner} />
      )}
      {/* ── S135 cold-start resume banner — survey-green, prominent, one-tap back into the live survey ── */}
      {/* SEND-STATE-V1: a survey waiting in the queue (or parked) is never
          offered to carry on: the banner says it is waiting, why, and offers
          Try now. A sent one shows no banner at all. */}
      {resumeSt && resumeWaiting && screen !== 3 && screen !== 11 && (
        <div role="status" aria-label={`${(resumeDraft.project && resumeDraft.project.name) || 'Your survey'}: ${sendStateWords(resumeSt).title}`}
          style={t.theme === 'uv'
            ? { margin: "2px 16px 8px", padding: "10px 6px 10px 16px", borderRadius: STUDIO_TOKENS.radius.card, ...studioSurface.lit(), display: "flex", alignItems: "center", gap: 10, flexShrink: 0, fontFamily: STUDIO_TOKENS.fonts.body }
            : { background: "linear-gradient(135deg, #8A6A1E 0%, #6E5416 100%)", borderBottom: "0.5px solid rgba(255,255,255,0.14)", padding: "11px 18px", display: "flex", alignItems: "center", gap: 12, flexShrink: 0 }}>
          {/* The job stays editable: tapping the words opens it, as before. */}
          <button onClick={() => { setActiveProject(resumeProject); setScreen(3); setResumeDraft(null); }} aria-label={`Open ${(resumeDraft.project && resumeDraft.project.name) || 'the survey'}`}
            style={{ flex: 1, minWidth: 0, minHeight: 44, background: 'none', border: 'none', padding: 0, margin: 0, textAlign: 'left', cursor: 'pointer', fontFamily: 'inherit' }}>
            <p style={t.theme === 'uv' ? { fontSize: 16, fontWeight: 700, color: STUDIO_TOKENS.ink, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" } : { fontSize: 13, fontWeight: 700, color: "#fff", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{(resumeDraft.project && resumeDraft.project.name) || "Your survey"}</p>
            <p style={t.theme === 'uv' ? { fontSize: 14, color: STUDIO_TOKENS.muted } : { fontSize: 11, fontWeight: 600, color: "rgba(255,255,255,0.82)" }}>{sendStateWords(resumeSt).title}. {sendStateWords(resumeSt).short}</p>
          </button>
          {sendStateWords(resumeSt).act ? (
            <button onClick={resumeAct}
              style={t.theme === 'uv' ? { ...svLink(), fontSize: 16, flexShrink: 0, background: 'none', border: 'none' } : { minHeight: 44, padding: '0 12px', background: "rgba(255,255,255,0.16)", border: "none", borderRadius: 8, color: '#fff', fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit', flexShrink: 0 }}>{sendStateWords(resumeSt).act}</button>
          ) : null}
          <button onClick={(e) => { e.stopPropagation(); setResumeDraft(null); }} aria-label="Dismiss"
            style={{ width: 44, height: 44, border: "none", borderRadius: 12, background: "none", color: t.theme === 'uv' ? STUDIO_TOKENS.ink : '#fff', cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
            <svg width="14" height="14" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" aria-hidden="true"><line x1="2" y1="2" x2="10" y2="10"/><line x1="10" y1="2" x2="2" y2="10"/></svg>
          </button>
        </div>
      )}
      {resumeDraft && !resumeBlocked && screen !== 3 && screen !== 11 && t.theme === 'uv' && (
        <div onClick={() => { setScreen(3); setResumeDraft(null); }} role="button"
          style={{ cursor: "pointer", margin: "2px 16px 8px", padding: "10px 6px 10px 16px", borderRadius: STUDIO_TOKENS.radius.card, ...studioSurface.lit(), display: "flex", alignItems: "center", gap: 10, flexShrink: 0, fontFamily: STUDIO_TOKENS.fonts.body }}>
          <div style={{ flex: 1, minWidth: 0 }}>
            <p style={{ fontSize: 16, fontWeight: 700, color: STUDIO_TOKENS.ink, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{(resumeDraft.project && resumeDraft.project.name) || "Your survey"}</p>
            <p style={{ fontSize: 14, color: STUDIO_TOKENS.muted }}>Your work was saved. <span style={{ ...studioType.action(), fontSize: 14 }}>Carry on with the survey</span></p>
          </div>
          <button onClick={(e) => { e.stopPropagation(); setResumeDraft(null); }} aria-label="Dismiss"
            style={{ width: 44, height: 44, border: "none", borderRadius: 12, background: "none", color: STUDIO_TOKENS.ink, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
            <svg width="14" height="14" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" aria-hidden="true"><line x1="2" y1="2" x2="10" y2="10"/><line x1="10" y1="2" x2="2" y2="10"/></svg>
          </button>
        </div>
      )}
      {resumeDraft && !resumeBlocked && screen !== 3 && screen !== 11 && t.theme !== 'uv' && (
        <div onClick={() => { setScreen(3); setResumeDraft(null); }}
          style={{ cursor: "pointer", background: "linear-gradient(135deg, #2E6838 0%, #234E29 100%)", borderBottom: "0.5px solid rgba(255,255,255,0.14)", padding: "11px 18px", display: "flex", alignItems: "center", gap: 12, flexShrink: 0, animation: "slideDown 0.3s ease" }}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12a9 9 0 1 1-3-6.7"/><polyline points="21 3 21 9 15 9"/></svg>
          <div style={{ flex: 1, minWidth: 0 }}>
            <p style={{ fontSize: 13, fontWeight: 700, color: "#fff", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>Resume survey — {(resumeDraft.project && resumeDraft.project.name) || "in progress"}</p>
            <p style={{ fontSize: 11, fontWeight: 600, color: "rgba(255,255,255,0.82)" }}>Your work was saved. Tap to pick up where you left off.</p>
          </div>
          <button onClick={(e) => { e.stopPropagation(); setResumeDraft(null); }} aria-label="Dismiss"
            style={{ background: "rgba(255,255,255,0.16)", border: "none", borderRadius: 8, width: 28, height: 28, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", flexShrink: 0 }}>
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round"><line x1="2" y1="2" x2="10" y2="10"/><line x1="10" y1="2" x2="2" y2="10"/></svg>
          </button>
        </div>
      )}
      {/* ── Active project indicator — warm stone glass, visible on sub-screens ── */}
      {activeProject && t.theme === 'uv' && screen !== 0 && screen !== 3 && screen !== 6 && screen !== 7 && screen !== 10 && screen !== 12 && screen !== 16 && screen !== 17 && screen !== 18 && screen !== 20 && (
        <p style={{ padding: "0 20px 4px", flexShrink: 0, fontFamily: STUDIO_TOKENS.fonts.body, fontSize: 13, color: STUDIO_TOKENS.muted, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
          {'On '}<b style={{ color: STUDIO_TOKENS.ink, fontWeight: 600 }}>{activeProject.name}</b>{activeProject.client ? `, ${activeProject.client}` : ''}
        </p>
      )}
      {activeProject && t.theme !== 'uv' && screen !== 0 && screen !== 3 && screen !== 6 && screen !== 7 && screen !== 10 && screen !== 12 && screen !== 16 && screen !== 17 && screen !== 18 && screen !== 20 && (
        <div style={{
          background: "rgba(255,252,242,0.92)",
          borderBottom: "0.5px solid rgba(28,24,16,0.08)",
          padding: "6px 20px",
          display: "flex",
          alignItems: "center",
          gap: 8,
          flexShrink: 0,
          animation: "slideDown 0.2s ease",
        }}>
          <div style={{
            width: 6, height: 6, borderRadius: "50%",
            background: "#E08030",
            boxShadow: "0 0 5px rgba(224,128,48,0.5)",
            animation: "beat 2s ease-in-out infinite",
          }} />
          <p style={{ fontSize: 11, fontWeight: 700, color: "#1A1608", letterSpacing: 0.2, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", flex: 1 }}>
            {activeProject.name}
          </p>
          {activeProject.client && (
            <p style={{ fontSize: 11, color: "rgba(28,24,16,0.38)", flexShrink: 0 }}>{activeProject.client}</p>
          )}
        </div>
      )}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', transition: 'opacity 0.15s ease' }}
        {...(isMainTab && screen !== 19 ? { onTouchStart: mainSwipe.onTouchStart, onTouchEnd: mainSwipe.onTouchEnd } : {})}>
        {renderScreen()}
      </div>
      {/* B.2 Slice 3 — the modal hands back a BINDING (portal pick or
          bindingNone() for General note), never a local project, so it no
          longer touches activeProject (D3: local drafts are not binding
          targets; portal rows are not local project objects). */}
      {showVoiceModal && <VoiceModal onClose={() => setShowVoiceModal(false)} onStartRecording={(binding) => { setVoiceNoteBinding(binding && typeof binding === 'object' ? binding : null); setScreen(9); }} />}
      {/* S105 — Debug overlay (5-tap-on-ASG-logo). Shows the most
          recent 100 entries from lumen_debug_log with a copy-to-
          clipboard button. Read fresh from localStorage on each open
          so the user always sees current state. */}
      {showDebugOverlay && (() => {
        let entries = [];
        try {
          const arr = JSON.parse(localStorage.getItem('lumen_debug_log') || '[]');
          entries = Array.isArray(arr) ? arr.slice(-100).reverse() : [];
        } catch (e) {}
        const eventColor = (ev) => {
          if (!ev) return '#8A7A5A';
          if (ev.endsWith('.fail') || ev.endsWith('.error')) return '#C85040';
          if (ev.endsWith('.ok')) return '#2E6838';
          if (ev.includes('queue') || ev.includes('queued')) return '#C89030';
          return '#5A4A2A';
        };
        const copyAll = () => {
          try {
            const raw = JSON.stringify(entries, null, 2);
            if (navigator.clipboard && navigator.clipboard.writeText) {
              navigator.clipboard.writeText(raw);
            } else {
              const ta = document.createElement('textarea');
              ta.value = raw; document.body.appendChild(ta); ta.select();
              document.execCommand('copy'); document.body.removeChild(ta);
            }
            const toast = document.createElement('div');
            toast.textContent = `Copied ${entries.length} entries`;
            Object.assign(toast.style, {
              position: 'fixed', top: '40%', left: '50%', transform: 'translateX(-50%)',
              background: 'rgba(46,104,56,0.92)', color: '#fff',
              padding: '10px 22px', borderRadius: '20px', fontSize: '13px',
              fontWeight: '700', zIndex: '99999',
            });
            document.body.appendChild(toast);
            setTimeout(() => toast.remove(), 1500);
          } catch (e) {}
        };
        const clearAll = () => {
          try { localStorage.removeItem('lumen_debug_log'); } catch (e) {}
          setShowDebugOverlay(false);
        };
        return (
          <SheetPortal>
          <div onClick={(e) => { if (e.target === e.currentTarget) setShowDebugOverlay(false); }}
            style={{ position: 'fixed', inset: 0, background: 'rgba(15,15,20,0.92)', zIndex: 99998, display: 'flex', flexDirection: 'column', padding: 16 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
              <span style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic', fontSize: 16, color: '#FBF6E8' }}>
                Debug log
              </span>
              <span style={{ fontSize: 11, color: 'rgba(255,255,255,0.5)' }}>
                · last {entries.length}
              </span>
              <span style={{ flex: 1 }} />
              <button onClick={copyAll} style={{ padding: '6px 12px', borderRadius: 8, background: '#2E6838', border: 'none', color: '#fff', fontSize: 12, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>
                Copy
              </button>
              <button onClick={clearAll} style={{ padding: '6px 12px', borderRadius: 8, background: 'transparent', border: '1px solid rgba(255,255,255,0.25)', color: 'rgba(255,255,255,0.7)', fontSize: 12, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>
                Clear
              </button>
              <button onClick={() => setShowDebugOverlay(false)} aria-label="Close" style={{ width: 32, height: 32, borderRadius: 8, background: 'rgba(255,255,255,0.1)', border: 'none', color: '#fff', fontSize: 16, cursor: 'pointer' }}>
                ×
              </button>
            </div>
            <div style={{ flex: 1, overflowY: 'auto', WebkitOverflowScrolling: 'touch', background: 'rgba(255,255,255,0.04)', borderRadius: 8, padding: 8 }}>
              {entries.length === 0 ? (
                <div style={{ padding: 24, textAlign: 'center', fontSize: 12, color: 'rgba(255,255,255,0.5)', fontStyle: 'italic' }}>
                  No events logged yet. Capture a photo or trigger a sync to populate.
                </div>
              ) : entries.map((e, i) => {
                const { ts, event, ...meta } = e || {};
                const tsShort = (ts || '').slice(11, 23); // HH:MM:SS.mmm
                return (
                  <div key={i} style={{ display: 'flex', gap: 8, padding: '5px 6px', borderBottom: '1px solid rgba(255,255,255,0.05)', fontSize: 11, fontFamily: 'ui-monospace, "SF Mono", Menlo, monospace', color: 'rgba(255,255,255,0.85)' }}>
                    <span style={{ color: 'rgba(255,255,255,0.45)', flexShrink: 0, width: 90 }}>{tsShort}</span>
                    <span style={{ color: eventColor(event), fontWeight: 600, flexShrink: 0, minWidth: 130 }}>{event}</span>
                    <span style={{ color: 'rgba(255,255,255,0.7)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {Object.keys(meta).length ? JSON.stringify(meta) : ''}
                    </span>
                  </div>
                );
              })}
            </div>
            <div style={{ paddingTop: 8, fontSize: 10, color: 'rgba(255,255,255,0.4)', textAlign: 'center' }}>
              5-tap ASG logo to reopen · Capped at 500 entries · Tap outside to close
            </div>
          </div>
          </SheetPortal>
        );
      })()}
    </div>
  );
}

// ════════════════════════════════════════════════════
// SCREEN 8: SITE PLAN — Upload, annotate, pin
// ════════════════════════════════════════════════════

// ── Fitting type symbol presets ──
// Auto-assigned in order as new fitting types are created.
const FITTING_SYMBOLS = [
  { shape: "circle",   color: "#C8A96E" },
  { shape: "square",   color: "#5B9BD5" },
  { shape: "triangle", color: "#34C759" },
  { shape: "diamond",  color: "#FF9500" },
  { shape: "hexagon",  color: "#AF52DE" },
  { shape: "cross",    color: "#FF3B30" },
];

// ── SVG shape renderer for fitting pins ──
const FittingPinShape = ({ x, y, shape, color, letter, onClick, erase }) => {
  const s = 1.5;
  const strokeProps = { stroke: "#fff", strokeWidth: "0.25", vectorEffect: "non-scaling-stroke" };
  let shapeEl;
  if (shape === "square") {
    shapeEl = <rect x={x - s} y={y - s} width={s * 2} height={s * 2} rx="0.3" fill={color} {...strokeProps} />;
  } else if (shape === "triangle") {
    shapeEl = <polygon points={`${x},${y - s} ${x + s * 0.95},${y + s * 0.7} ${x - s * 0.95},${y + s * 0.7}`} fill={color} {...strokeProps} />;
  } else if (shape === "diamond") {
    shapeEl = <polygon points={`${x},${y - s} ${x + s * 0.8},${y} ${x},${y + s} ${x - s * 0.8},${y}`} fill={color} {...strokeProps} />;
  } else if (shape === "hexagon") {
    const pts = Array.from({ length: 6 }, (_, i) => {
      const a = (i * 60 - 90) * Math.PI / 180;
      return `${(x + s * Math.cos(a)).toFixed(2)},${(y + s * Math.sin(a)).toFixed(2)}`;
    }).join(" ");
    shapeEl = <polygon points={pts} fill={color} {...strokeProps} />;
  } else if (shape === "cross") {
    shapeEl = (
      <>
        <rect x={x - s * 0.85} y={y - s * 0.28} width={s * 1.7} height={s * 0.56} rx="0.2" fill={color} {...strokeProps} />
        <rect x={x - s * 0.28} y={y - s * 0.85} width={s * 0.56} height={s * 1.7} rx="0.2" fill={color} {...strokeProps} />
      </>
    );
  } else {
    shapeEl = <circle cx={x} cy={y} r={s} fill={color} {...strokeProps} />;
  }

  const textY = shape === "triangle" ? y + s * 0.2 : y + 0.52;

  return (
    <g
      style={{ cursor: erase ? "pointer" : "default" }}
      onClick={onClick}
    >
      {shapeEl}
      {shape !== "cross" && (
        <text
          x={x}
          y={textY}
          fontSize="1.4"
          fontWeight="900"
          textAnchor="middle"
          fill="#fff"
          style={{ pointerEvents: "none", fontFamily: "sans-serif", userSelect: "none" }}
        >{letter}</text>
      )}
    </g>
  );
};

const SitePlanScreenBody = ({ onBack, onNav, project, onUpdateProject, currentUser }) => {
  const div = getDivisionConfig(currentUser);
  const divColor = "#2E6838";

  // ── State ──
  const [plans, setPlans] = useState(() => {
    const all = project?.plans || [];
    return all.filter(p => !p.division || p.division === div.id);
  });
  const [activePlanIdx, setActivePlanIdx] = useState(0);
  const [tool, setTool] = useState("pen");   // pen | pin | erase
  const [penColor, setPenColor] = useState(divColor);
  const [penWidth, setPenWidth] = useState(3);
  const [drawing, setDrawing] = useState(false);
  const [currentPath, setCurrentPath] = useState([]);
  const [lightbox, setLightbox] = useState(false);
  const [history, setHistory] = useState([]);
  const [showColorPicker, setShowColorPicker] = useState(false);

  // Fitting type pin state
  const [activeFittingTypeId, setActiveFittingTypeId] = useState(null);
  const [showFittingCreator, setShowFittingCreator] = useState(false);
  const [newFittingLabel, setNewFittingLabel] = useState("");

  const canvasRef = useRef(null);
  const fileRef = useRef(null);
  const svgRef = useRef(null);

  const activePlan = plans[activePlanIdx] || null;

  // ── Save plans to project ──
  const savePlans = (newPlans) => {
    setPlans(newPlans);
    if (project?.id && onUpdateProject) {
      const otherDivPlans = (project?.plans || []).filter(p => p.division && p.division !== div.id);
      onUpdateProject(project.id, { plans: [...otherDivPlans, ...newPlans] });
    }
  };

  // ── No project open guard ──
  const noProject = !project?.id;

  // ── Upload image/PDF ──
  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    e.target.value = "";
    if (noProject) return;

    const compressDataUrl = (dataUrl) => new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        const MAX = 1400;
        const scale = Math.min(1, MAX / Math.max(img.width, img.height));
        const w = Math.round(img.width * scale);
        const h = Math.round(img.height * scale);
        const canvas = document.createElement("canvas");
        canvas.width = w; canvas.height = h;
        canvas.getContext("2d").drawImage(img, 0, 0, w, h);
        resolve(canvas.toDataURL("image/jpeg", 0.82));
      };
      img.onerror = () => resolve(dataUrl);
      img.src = dataUrl;
    });

    let src = null;

    if (file.type === "application/pdf" || file.name.toLowerCase().endsWith(".pdf")) {
      try {
        const pdfjsLib = window.pdfjsLib;
        if (!pdfjsLib) throw new Error("PDF.js not loaded");
        const arrayBuffer = await file.arrayBuffer();
        const pdfDoc = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
        const page = await pdfDoc.getPage(1);
        const baseViewport = page.getViewport({ scale: 1 });
        const scale = Math.min(2.5, 1400 / baseViewport.width);
        const viewport = page.getViewport({ scale });
        const canvas = document.createElement("canvas");
        canvas.width = viewport.width;
        canvas.height = viewport.height;
        await page.render({ canvasContext: canvas.getContext("2d"), viewport }).promise;
        src = canvas.toDataURL("image/jpeg", 0.85);
      } catch(err) {
        console.error("PDF render failed:", err);
        return;
      }
    } else {
      src = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (ev) => resolve(ev.target.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
      src = await compressDataUrl(src);
    }

    if (!src) return;
    const newPlan = {
      id: Date.now(),
      name: file.name.replace(/\.[^.]+$/, ""),
      src,
      division: getDivisionConfig(currentUser).id,
      strokes: [],
      pins: [],
      fittingTypes: [],
    };
    const updated = [...plans, newPlan];
    savePlans(updated);
    setActivePlanIdx(updated.length - 1);
    setHistory([]);
  };

  // ── Pointer events on SVG overlay ──
  const getPos = (e) => {
    const svg = svgRef.current;
    if (!svg) return { x: 0, y: 0 };
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;
    const pt = svg.createSVGPoint();
    pt.x = clientX;
    pt.y = clientY;
    const svgP = pt.matrixTransform(svg.getScreenCTM().inverse());
    return { x: svgP.x, y: svgP.y };
  };

  const onPointerDown = (e) => {
    if (!activePlan) return;
    e.preventDefault();
    if (tool === "pin") {
      if (!activeFittingTypeId) {
        setShowFittingCreator(true);
        return;
      }
      const pos = getPos(e);
      const pin = { id: Date.now(), x: pos.x, y: pos.y, fittingTypeId: activeFittingTypeId };
      const updated = plans.map((p, i) => i === activePlanIdx ? { ...p, pins: [...(p.pins || []), pin] } : p);
      setHistory(prev => [...prev, { type: "pin", planIdx: activePlanIdx }]);
      savePlans(updated);
      return;
    }
    if (tool === "erase") return;
    setDrawing(true);
    setCurrentPath([getPos(e)]);
  };

  const onPointerMove = (e) => {
    if (!drawing || tool !== "pen") return;
    e.preventDefault();
    setCurrentPath(prev => [...prev, getPos(e)]);
  };

  const onPointerUp = (e) => {
    if (!drawing || tool !== "pen") return;
    e.preventDefault();
    setDrawing(false);
    if (currentPath.length < 2) { setCurrentPath([]); return; }
    const newStroke = { points: currentPath, color: penColor, width: penWidth, id: Date.now() };
    const updated = plans.map((p, i) => i === activePlanIdx ? { ...p, strokes: [...(p.strokes || []), newStroke] } : p);
    setHistory(prev => [...prev, { type: "stroke", planIdx: activePlanIdx }]);
    savePlans(updated);
    setCurrentPath([]);
  };

  // ── Erase stroke by clicking near it ──
  const onSvgClick = (e) => {
    if (tool !== "erase" || !activePlan) return;
    const pos = getPos(e);
    const strokes = activePlan.strokes || [];
    let removeIdx = -1;
    let minDist = 4;
    strokes.forEach((s, si) => {
      s.points.forEach(pt => {
        const d = Math.hypot(pt.x - pos.x, pt.y - pos.y);
        if (d < minDist) { minDist = d; removeIdx = si; }
      });
    });
    if (removeIdx >= 0) {
      const updated = plans.map((p, i) => i === activePlanIdx ? { ...p, strokes: strokes.filter((_, si) => si !== removeIdx) } : p);
      savePlans(updated);
    }
  };

  // ── Remove pin ──
  const removePin = (pinId) => {
    const updated = plans.map((p, i) => i === activePlanIdx ? { ...p, pins: (p.pins || []).filter(pin => pin.id !== pinId) } : p);
    savePlans(updated);
  };

  // ── Create a new fitting type ──
  const createFittingType = () => {
    if (!newFittingLabel.trim() || !activePlan) return;
    const existing = activePlan.fittingTypes || [];
    const symbolIdx = existing.length % FITTING_SYMBOLS.length;
    const newType = {
      id: Date.now(),
      label: newFittingLabel.trim(),
      ...FITTING_SYMBOLS[symbolIdx],
    };
    const updated = plans.map((p, i) => i === activePlanIdx ? { ...p, fittingTypes: [...existing, newType] } : p);
    savePlans(updated);
    setActiveFittingTypeId(newType.id);
    setNewFittingLabel("");
    setShowFittingCreator(false);
  };

  // ── Remove a fitting type and its pins ──
  const removeFittingType = (typeId) => {
    const updated = plans.map((p, i) => i === activePlanIdx ? {
      ...p,
      fittingTypes: (p.fittingTypes || []).filter(ft => ft.id !== typeId),
      pins: (p.pins || []).filter(pin => pin.fittingTypeId !== typeId),
    } : p);
    savePlans(updated);
    if (activeFittingTypeId === typeId) setActiveFittingTypeId(null);
  };

  // ── Undo last action ──
  const undo = () => {
    const last = history[history.length - 1];
    if (!last) return;
    const updated = plans.map((p, i) => {
      if (i !== last.planIdx) return p;
      if (last.type === "stroke") return { ...p, strokes: (p.strokes || []).slice(0, -1) };
      if (last.type === "pin") return { ...p, pins: (p.pins || []).slice(0, -1) };
      return p;
    });
    savePlans(updated);
    setHistory(prev => prev.slice(0, -1));
  };

  // ── Delete plan ──
  const deletePlan = (idx) => {
    const updated = plans.filter((_, i) => i !== idx);
    savePlans(updated);
    setActivePlanIdx(Math.max(0, idx - 1));
  };

  // ── Path to SVG d string ──
  const pathToD = (points) => {
    if (points.length < 2) return "";
    return points.map((pt, i) => `${i === 0 ? "M" : "L"}${pt.x} ${pt.y}`).join(" ");
  };

  const COLORS = [divColor, "#FF3B30", "#34C759", "#007AFF", "#FF9500", "#AF52DE", "#FFFFFF", "#FFD60A"];

  // ── Derived: fitting types and pin counts ──
  const fittingTypes = activePlan?.fittingTypes || [];
  const activeFitting = fittingTypes.find(ft => ft.id === activeFittingTypeId) || null;
  const pinsForType = (typeId) => (activePlan?.pins || []).filter(p => p.fittingTypeId === typeId);
  // Legacy pins (old format with label, no fittingTypeId)
  const legacyPins = (activePlan?.pins || []).filter(p => !p.fittingTypeId);

  return (
    <div style={{ flex: 1, overflowY: "auto", WebkitOverflowScrolling: "touch", overscrollBehavior: "contain", paddingBottom: 100, background: "#E8DCC8", display: "flex", flexDirection: "column" }}>

      {/* NavBar */}
      <div style={{ padding: "10px 20px 12px", display: "flex", alignItems: "center", justifyContent: "space-between", borderBottom: `0.5px solid ${t.colors.separator}`, flexShrink: 0 }}>
        <button onClick={onBack} style={{ background: "none", border: "none", cursor: "pointer", display: "flex", alignItems: "center", gap: 6 }}>
          <Icon name="arrow" size={20} color={t.theme === 'uv' ? STUDIO_TOKENS.ink : divColor} />
          <span style={{ color: divColor, fontSize: 15, fontWeight: 600 }}>Back</span>
        </button>
        <span style={{ fontSize: 16, fontWeight: 700, color: t.colors.text, letterSpacing: -0.3 }}>
          {activePlan ? activePlan.name : (t.theme === 'uv' ? "Site plans" : "Site Plans")}
        </span>
        <button onClick={() => fileRef.current?.click()} disabled={noProject} style={{ background: noProject ? "rgba(255,255,255,0.06)" : divColor, border: "none", borderRadius: 9, padding: "7px 13px", cursor: noProject ? "default" : "pointer", display: "flex", alignItems: "center", gap: 5, opacity: noProject ? 0.3 : 1 }}>
          <Icon name="plus" size={14} color={t.colors.navy} />
          <span style={{ color: t.colors.navy, fontSize: 12, fontWeight: 800 }}>Plan</span>
        </button>
        <input ref={fileRef} type="file" accept="image/*,.pdf" style={{ display: "none" }} onChange={handleFileUpload} />
      </div>

      {/* Plan tabs */}
      {plans.length > 0 && !noProject && (
        <div style={{ display: "flex", gap: 6, padding: "10px 20px 0", overflowX: "auto", flexShrink: 0 }}>
          {plans.map((plan, i) => (
            <button key={plan.id} onClick={() => { setActivePlanIdx(i); setHistory([]); setActiveFittingTypeId(null); }} style={{
              padding: "6px 14px", borderRadius: 20, border: "none", cursor: "pointer", flexShrink: 0, display: "flex", alignItems: "center", gap: 6,
              background: i === activePlanIdx ? divColor : "rgba(255,255,255,0.06)",
              color: i === activePlanIdx ? t.colors.navy : t.colors.textSecondary,
              fontSize: 12, fontWeight: 700,
            }}>
              {plan.name}
              <span onClick={e => { e.stopPropagation(); deletePlan(i); }} style={{ fontSize: 10, opacity: 0.7, cursor: "pointer", marginLeft: 2 }}><svg width="8" height="8" viewBox="0 0 10 10" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><line x1="2" y1="2" x2="8" y2="8"/><line x1="8" y1="2" x2="2" y2="8"/></svg></span>
            </button>
          ))}
        </div>
      )}

      {/* Main content */}
      <div style={{ flex: 1, overflow: "hidden", position: "relative" }}>
        {noProject ? (
          <div style={{ height: "100%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: 32, textAlign: "center" }}>
            <div style={{ width: 72, height: 72, borderRadius: 20, background: "rgba(255,255,255,0.04)", border: `0.5px solid ${t.colors.glassBorder}`, display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 20 }}>
              <Icon name="building" size={32} color={t.colors.textTertiary} />
            </div>
            <p style={{ fontSize: 16, fontWeight: 700, color: t.colors.text, marginBottom: 8 }}>No project open</p>
            <p style={{ fontSize: 13, color: t.colors.textSecondary, lineHeight: 1.5, maxWidth: 260, marginBottom: 24 }}>{t.theme === 'uv' ? 'Open a survey first, then come back here to add its site plans and mark them up.' : 'Open a project from the Home screen first, then come back here to attach and annotate site plans.'}</p>
            <Btn label={t.theme === 'uv' ? 'Go to surveys' : 'Go to Home'} variant="secondary" onClick={onBack} color={divColor} />
          </div>
        ) : !activePlan ? (
          <div style={{ height: "100%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: 32, textAlign: "center" }}>
            <div style={{ width: 72, height: 72, background: 'rgba(46,104,56,0.08)', border: '1.5px solid rgba(46,104,56,0.2)', borderRadius: 20, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 16 }}>
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke={t.theme === 'uv' ? STUDIO_TOKENS.ink : "#2E6838"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                <polyline points="14 2 14 8 20 8"/>
                <line x1="8" y1="13" x2="16" y2="13"/>
                <line x1="8" y1="17" x2="16" y2="17"/>
              </svg>
            </div>
            <div style={{ fontSize: 17, fontWeight: 800, color: '#1C1810', marginBottom: 6, textAlign: 'center' }}>No drawings yet</div>
            <div style={{ fontSize: 13, color: 'rgba(28,24,16,0.5)', textAlign: 'center', lineHeight: 1.5, marginBottom: 24 }}>
              {t.theme === 'uv' ? 'Add floor plans or as-builts and have them with you on site.' : 'Upload floor plans or as-builts. Reference them on site. No more squinting at a PDF.'}
            </div>
            <button onClick={() => fileRef.current?.click()} style={{ background: '#2E6838', border: 'none', borderRadius: 14, padding: '12px 28px', fontSize: 14, fontWeight: 800, color: '#fff', cursor: 'pointer', ...uvx(() => Object.assign(studioSurface.primary(), { minHeight: 44, fontWeight: 600, fontSize: 16, fontFamily: STUDIO_TOKENS.fonts.body })) }}>
              Upload first plan
            </button>
            <p style={{ fontSize: 11, color: t.colors.textTertiary, marginTop: 12 }}>{`JPG, PNG or PDF${studioDash()}engineering drawings supported`}</p>
          </div>
        ) : (
          /* Annotation canvas */
          <div style={{ height: "100%", display: "flex", flexDirection: "column", paddingBottom: 90 }}>

            {/* Drawing area */}
            <div style={{ flex: 1, position: "relative", overflow: "hidden", background: "#0A0F1A", cursor: tool === "pen" ? "crosshair" : "cell" }}>
              <img
                src={activePlan.src}
                alt="site plan"
                style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "contain", userSelect: "none", pointerEvents: "none" }}
                onClick={() => setLightbox(true)}
              />

              {/* SVG overlay — strokes + pins */}
              <svg
                ref={svgRef}
                viewBox="0 0 100 100"
                preserveAspectRatio="xMidYMid meet"
                style={{ position: "absolute", inset: 0, width: "100%", height: "100%", touchAction: "none" }}
                onMouseDown={onPointerDown}
                onMouseMove={onPointerMove}
                onMouseUp={onPointerUp}
                onMouseLeave={onPointerUp}
                onTouchStart={onPointerDown}
                onTouchMove={onPointerMove}
                onTouchEnd={onPointerUp}
                onClick={onSvgClick}
              >
                {/* Saved strokes */}
                {(activePlan.strokes || []).map(stroke => (
                  <path
                    key={stroke.id}
                    d={pathToD(stroke.points)}
                    fill="none"
                    stroke={stroke.color}
                    strokeWidth={stroke.width * 0.4}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    opacity="0.92"
                  />
                ))}
                {/* Live stroke */}
                {currentPath.length > 1 && (
                  <path
                    d={pathToD(currentPath)}
                    fill="none"
                    stroke={penColor}
                    strokeWidth={penWidth * 0.4}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    opacity="0.92"
                  />
                )}
                {/* Fitting type pins (new format) */}
                {fittingTypes.map(ft => {
                  const letter = String.fromCharCode(65 + fittingTypes.indexOf(ft));
                  return pinsForType(ft.id).map(pin => (
                    <FittingPinShape
                      key={pin.id}
                      x={pin.x}
                      y={pin.y}
                      shape={ft.shape}
                      color={ft.color}
                      letter={letter}
                      erase={tool === "erase"}
                      onClick={(e) => { e.stopPropagation(); if (tool === "erase") removePin(pin.id); }}
                    />
                  ));
                })}
                {/* Legacy pins (old format with label) — render as crosshair */}
                {legacyPins.map((pin, idx) => (
                  <g key={pin.id} style={{ cursor: tool === "erase" ? "pointer" : "default" }}
                     onClick={(e) => { e.stopPropagation(); if (tool === "erase") removePin(pin.id); }}>
                    <line x1={pin.x - 1.2} y1={pin.y} x2={pin.x + 1.2} y2={pin.y}
                      stroke={divColor} strokeWidth="0.35" vectorEffect="non-scaling-stroke" />
                    <line x1={pin.x} y1={pin.y - 1.2} x2={pin.x} y2={pin.y + 1.2}
                      stroke={divColor} strokeWidth="0.35" vectorEffect="non-scaling-stroke" />
                    <circle cx={pin.x} cy={pin.y} r="0.45"
                      fill={divColor} stroke="#fff" strokeWidth="0.15" vectorEffect="non-scaling-stroke" />
                    <rect x={pin.x + 1.0} y={pin.y - 2.2} width="3.2" height="2.2" rx="0.4"
                      fill={divColor} opacity="0.92" />
                    <text x={pin.x + 2.6} y={pin.y - 0.65}
                      fontSize="1.6" fontWeight="800" textAnchor="middle"
                      fill="#fff" style={{ pointerEvents: "none", fontFamily: "sans-serif" }}
                    >{idx + 1}</text>
                  </g>
                ))}
              </svg>
            </div>

            {/* ── Fitting type palette — shown when pin tool active ── */}
            {tool === "pin" && !showFittingCreator && (
              <div style={{ padding: "8px 12px", background: `${divColor}08`, borderTop: `0.5px solid ${divColor}30`, flexShrink: 0 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap" }}>
                  {fittingTypes.length === 0 && (
                    <span style={{ fontSize: 12, color: t.colors.textSecondary, fontStyle: "italic", marginRight: 4 }}>{`No fittings defined${studioArrow(' —')}`}</span>
                  )}
                  {fittingTypes.map((ft, idx) => {
                    const letter = String.fromCharCode(65 + idx);
                    const count = pinsForType(ft.id).length;
                    const isActive = activeFittingTypeId === ft.id;
                    return (
                      <button
                        key={ft.id}
                        onClick={() => setActiveFittingTypeId(isActive ? null : ft.id)}
                        style={{
                          display: "flex", alignItems: "center", gap: 5,
                          background: isActive ? ft.color : "rgba(255,255,255,0.06)",
                          border: `1.5px solid ${isActive ? ft.color : "rgba(255,255,255,0.1)"}`,
                          borderRadius: 20, padding: "4px 10px 4px 5px", cursor: "pointer",
                        }}
                      >
                        {/* Mini symbol preview */}
                        <svg width="16" height="16" viewBox="-4 -4 8 8" style={{ flexShrink: 0 }}>
                          <FittingPinShape x={0} y={0} shape={ft.shape} color={isActive ? "#fff" : ft.color} letter={letter} />
                        </svg>
                        <span style={{ fontSize: 12, fontWeight: 700, color: isActive ? "#fff" : t.colors.text, maxWidth: 90, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                          {ft.label}
                        </span>
                        {count > 0 && (
                          <span style={{ fontSize: 10, fontWeight: 800, color: isActive ? "rgba(255,255,255,0.7)" : t.colors.textTertiary }}>×{count}</span>
                        )}
                        <span
                          onClick={e => { e.stopPropagation(); removeFittingType(ft.id); }}
                          style={{ fontSize: 10, color: isActive ? "rgba(255,255,255,0.6)" : t.colors.textTertiary, marginLeft: 2, lineHeight: 1, cursor: "pointer" }}
                        ><svg width="8" height="8" viewBox="0 0 10 10" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><line x1="2" y1="2" x2="8" y2="8"/><line x1="8" y1="2" x2="2" y2="8"/></svg></span>
                      </button>
                    );
                  })}
                  {/* New fitting type button */}
                  <button
                    onClick={() => setShowFittingCreator(true)}
                    style={{ display: "flex", alignItems: "center", gap: 4, background: "rgba(255,255,255,0.05)", border: `1px dashed ${divColor}50`, borderRadius: 20, padding: "4px 10px", cursor: "pointer" }}
                  >
                    <span style={{ fontSize: 14, color: divColor, fontWeight: 700, lineHeight: 1 }}>+</span>
                    <span style={{ fontSize: 12, color: divColor, fontWeight: 600 }}>New Type</span>
                  </button>
                </div>
                {/* Hint */}
                {activeFitting && (
                  <p style={{ fontSize: 11, color: divColor, fontWeight: 600, marginTop: 5 }}>
                    Tap the plan to mark each <span style={{ color: activeFitting.color }}>{activeFitting.label}</span>{`${studioDash()}tap as many times as needed`}
                  </p>
                )}
                {!activeFitting && fittingTypes.length > 0 && (
                  <p style={{ fontSize: 11, color: t.colors.textTertiary, marginTop: 5 }}>Select a fitting type above, then tap the plan</p>
                )}
              </div>
            )}

            {/* ── New fitting type creator ── */}
            {tool === "pin" && showFittingCreator && (
              <div style={{ padding: "10px 12px", background: t.colors.navy, borderTop: `0.5px solid ${divColor}40`, display: "flex", gap: 8, alignItems: "center", flexShrink: 0 }}>
                {/* Preview of next symbol */}
                {(() => {
                  const nextIdx = (activePlan.fittingTypes || []).length % FITTING_SYMBOLS.length;
                  const sym = FITTING_SYMBOLS[nextIdx];
                  const letter = String.fromCharCode(65 + (activePlan.fittingTypes || []).length);
                  return (
                    <svg width="28" height="28" viewBox="-4 -4 8 8" style={{ flexShrink: 0 }}>
                      <FittingPinShape x={0} y={0} shape={sym.shape} color={sym.color} letter={letter} />
                    </svg>
                  );
                })()}
                <input
                  value={newFittingLabel}
                  onChange={e => setNewFittingLabel(e.target.value)}
                  onKeyDown={e => { if (e.key === "Enter") createFittingType(); if (e.key === "Escape") { setShowFittingCreator(false); setNewFittingLabel(""); } }}
                  placeholder="e.g. 200mm 52w downlight, 4ft batten…"
                  style={{ flex: 1, background: "rgba(255,255,255,0.07)", border: `0.5px solid ${divColor}40`, borderRadius: 9, padding: "9px 12px", color: t.colors.text, fontSize: 16, fontFamily: "inherit", outline: "none" }}
                />
                <button onClick={createFittingType} style={{ background: divColor, border: "none", borderRadius: 9, padding: "9px 16px", cursor: "pointer", color: t.colors.navy, fontSize: 13, fontWeight: 800, flexShrink: 0 }}>Add</button>
                <button onClick={() => { setShowFittingCreator(false); setNewFittingLabel(""); }} style={{ background: "none", border: "none", cursor: "pointer", color: t.colors.textTertiary, fontSize: 18, padding: "0 4px", flexShrink: 0 }}><svg width="10" height="10" viewBox="0 0 10 10" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><line x1="2" y1="2" x2="8" y2="8"/><line x1="8" y1="2" x2="2" y2="8"/></svg></button>
              </div>
            )}

            {/* ── Legend — fitting type summary ── */}
            {fittingTypes.length > 0 && tool !== "pin" && (
              <div style={{ padding: "8px 12px", background: "rgba(0,0,0,0.25)", borderTop: `0.5px solid ${t.colors.separator}`, flexShrink: 0 }}>
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
                  {fittingTypes.map((ft, idx) => {
                    const letter = String.fromCharCode(65 + idx);
                    const count = pinsForType(ft.id).length;
                    return (
                      <div key={ft.id} style={{ display: "flex", alignItems: "center", gap: 5, background: `${ft.color}12`, border: `0.5px solid ${ft.color}30`, borderRadius: 20, padding: "3px 10px 3px 5px" }}>
                        <svg width="14" height="14" viewBox="-4 -4 8 8" style={{ flexShrink: 0 }}>
                          <FittingPinShape x={0} y={0} shape={ft.shape} color={ft.color} letter={letter} />
                        </svg>
                        <span style={{ fontSize: 11, color: t.colors.text, fontWeight: 600, maxWidth: 100, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{ft.label}</span>
                        <span style={{ fontSize: 11, fontWeight: 800, color: ft.color }}>×{count}</span>
                      </div>
                    );
                  })}
                  {legacyPins.length > 0 && (
                    <div style={{ display: "flex", alignItems: "center", gap: 5, background: `${divColor}10`, border: `0.5px solid ${divColor}25`, borderRadius: 20, padding: "3px 10px" }}>
                      <span style={{ fontSize: 11, color: t.colors.textSecondary, fontWeight: 600 }}>Other pins ×{legacyPins.length}</span>
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Toolbar */}
            <div style={{ padding: "10px 16px 30px", background: "rgba(10,22,40,0.97)", borderTop: `0.5px solid ${t.colors.separator}`, flexShrink: 0, display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>

              {/* Tool buttons */}
              {[
                { id: "pen",   icon: "pen",     label: "Draw" },
                { id: "pin",   icon: "pin",     label: "Pin" },
                { id: "erase", icon: "trash",   label: "Erase" },
              ].map(tb => (
                <button key={tb.id} onClick={() => { setTool(tb.id); setShowFittingCreator(false); }} style={{
                  display: "flex", flexDirection: "column", alignItems: "center", gap: 3,
                  background: tool === tb.id ? `${divColor}18` : "rgba(255,255,255,0.05)",
                  border: `0.5px solid ${tool === tb.id ? divColor + "50" : "rgba(255,255,255,0.08)"}`,
                  borderRadius: 10, padding: "8px 12px", cursor: "pointer",
                }}>
                  <Icon name={tb.icon} size={18} color={tool === tb.id ? divColor : t.colors.textSecondary} />
                  <span style={{ fontSize: 10, color: tool === tb.id ? divColor : t.colors.textTertiary, fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.3 }}>{tb.label}</span>
                </button>
              ))}

              <div style={{ width: "0.5px", height: 36, background: t.colors.separator, margin: "0 2px" }} />

              {/* Pen width + colour */}
              {tool === "pen" && (
                <>
                  {[2, 4, 7].map(w => (
                    <button key={w} onClick={() => setPenWidth(w)} style={{ width: 36, height: 36, borderRadius: 10, background: penWidth === w ? `${divColor}18` : "rgba(255,255,255,0.05)", border: `0.5px solid ${penWidth === w ? divColor + "50" : "rgba(255,255,255,0.08)"}`, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <div {...(t.theme === 'uv' ? { 'data-cap-keep': '1' } : {})} style={{ width: w * 2.5, height: w * 2.5, borderRadius: "50%", background: penColor, ...uvx(() => ({ width: 24, height: w, borderRadius: w / 2 })) }} />
                    </button>
                  ))}
                  <div style={{ width: "0.5px", height: 36, background: t.colors.separator, margin: "0 2px" }} />
                  {COLORS.map(c => (
                    <button key={c} onClick={() => setPenColor(c)} style={{ width: 28, height: 28, borderRadius: "50%", background: c, border: penColor === c ? "2.5px solid #fff" : "2px solid rgba(255,255,255,0.15)", cursor: "pointer", flexShrink: 0, ...uvx(() => ({ width: 44, height: 44, background: "transparent", border: "none", borderRadius: 0, display: "flex", alignItems: "center", justifyContent: "center", padding: 0 })) }}>
                      {t.theme === 'uv' ? <span data-cap-keep="1" style={{ display: "block", width: 24, height: 24, borderRadius: "50%", background: c, boxShadow: penColor === c ? `0 0 0 2px ${STUDIO_TOKENS.ground.base}, 0 0 0 4px ${STUDIO_TOKENS.ink}` : `0 0 0 1px ${STUDIO_TOKENS.hairline}` }} /> : null}
                    </button>
                  ))}
                </>
              )}

              {/* Undo */}
              {history.length > 0 && (
                <>
                  <div style={{ flex: 1 }} />
                  <button onClick={undo} style={{ display: "flex", alignItems: "center", gap: 5, background: "rgba(255,255,255,0.05)", border: "0.5px solid rgba(255,255,255,0.1)", borderRadius: 10, padding: "8px 12px", cursor: "pointer" }}>
                    <Icon name="undo" size={16} color={t.colors.textSecondary} />
                    <span style={{ fontSize: 11, color: t.colors.textSecondary, fontWeight: 600 }}>Undo</span>
                  </button>
                </>
              )}
            </div>
          </div>
        )}
      </div>

      {/* Lightbox */}
      {lightbox && activePlan && (
        <SheetPortal>
        <div onClick={() => setLightbox(false)} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.95)", zIndex: 600, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <img src={activePlan.src} alt="plan" style={{ maxWidth: "95%", maxHeight: "90%", objectFit: "contain", borderRadius: 8 }} />
          <p style={{ position: "absolute", bottom: 24, left: 0, right: 0, textAlign: "center", color: "rgba(255,255,255,0.4)", fontSize: 12 }}>Tap to close</p>
        </div>
        </SheetPortal>
      )}

      <TabBar active={8} onChange={onNav} divisionId={div && div.id ? div.id : "lighting"} />
    </div>
  );
};


// ── Error Boundary ────────────────────────────────
// Catches any render error in any child component.
// Without this, a single throw in any screen = blank blue screen in PWA.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(err) {
    return { error: err };
  }
  componentDidCatch(err, info) {
    // Log for debugging — visible in Safari Web Inspector
    console.error("ErrorBoundary caught:", err, info?.componentStack);
  }
  render() {
    if (this.state.error) {
      const msg = this.state.error?.message || String(this.state.error);
      return (
        <div style={{ height: "100%", background: "#E8DCC8", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: 32, textAlign: "center" }}>
          <div style={{ marginBottom: 20 }}><svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#C89030" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg></div>
          <p style={{ fontSize: 18, fontWeight: 700, color: "#1A1608", marginBottom: 12 }}>Something went wrong</p>
          <p style={{ fontSize: 13, color: "rgba(28,24,16,0.52)", marginBottom: 32, lineHeight: 1.5, maxWidth: 300 }}>{msg}</p>
          <button
            onClick={() => { this.setState({ error: null }); }}
            style={{ padding: "12px 28px", borderRadius: 12, background: "linear-gradient(135deg,#C89030,#1A5A78)", border: "none", color: "#fff", fontSize: 15, fontWeight: 700, cursor: "pointer" }}
          >
            Try Again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

// Mount
const _root = ReactDOM.createRoot(document.getElementById("root"));
_root.render(<ErrorBoundary><ASGCompanionApp /></ErrorBoundary>);
// v114

// ── S155 — guarded export for the headless screen-render check (tools/screen_render_check.js).
// INERT IN THE BROWSER: app.js loads as an ES module via babel-standalone, where `module` is
// undefined, so this never runs in production and changes nothing at runtime. Only node (CJS
// require after a JSX transform) sees it, exposing each major screen so the harness can
// renderToString them and fail loudly on any render-time throw — the class (the S154 `isProj`
// out-of-scope reference) that the parse and boot checks both pass straight through. The
// scan-results collector is an inline IIFE inside LiveSurveyScreen, so rendering that screen
// exercises it (which is exactly where the isProj bug lived).
if (typeof module !== 'undefined' && module.exports) {
  module.exports = {
    TodayScreen, CompanyScreen, PipelineScreen,
    // COMPANION-STUDIO-LIT-V1 track 3d: More and My performance, for tests.
    MoreScreen, MyTargetsScreen,
    // COMPANION-STUDIO-LIT-V1 track 3e: Relationships and a person (in Contacts), for tests.
    ContactsScreen,
    // P0 tidy: the first-open slides and the toast, for tests.
    OnboardingFlow, ONBOARDING_STEPS, showSavedToast, studioToastStyle,
    LiveSurveyScreen, SnagCaptureScreen, SnagSheet, WorthScreen,
    // B.2 Slice 1 — the two screens carrying the binding UI / wire change.
    QuickEntryScreen, SurveyWrapScreen,
    // B.2 Slice 2 — snag binding: setup + review screens, plus the shared
    // binding components so the harness can mount every card/echo state
    // directly (the in-screen bound states are interaction-gated).
    SnagSetupScreen, SnagReviewScreen,
    ProjectBindingCard, ProjectPickerSheet, BindingEchoLines,
    BIND_ACCENT_SNAG, BIND_ACCENT_SURVEY,
    // B.2 Slice 3 — voice binding: the re-sourced modal (portal list +
    // staleness + General note) and the voice screen that stamps the
    // binding onto the note.
    VoiceModal, VoiceNotesScreen,
    // SLICE-A3: the sheet over the survey wrap, and the Suppliers screen it
    // shares its add form with.
    SupplierAddSheet, SuppliersScreen,
    // S158 — queue hardening: Settings carries the parked-writes section
    // (0 and N states), so the harness mounts it directly. The queue/event
    // functions are exposed for tests/dedup_queue.test.js — compose-time
    // client_event_id stamping and park-never-discard are wire contracts,
    // locked functionally under node:test (the browser can't reach
    // module-scope consts).
    SettingsScreen,
    writePortalEvent, queueWrite, flushOfflineQueue,
    retryParkedWrites, discardParkedWrites, _genClientEventId,
    // SEND-STATE-V1: the per-job send state, its words, the queue's dedupe and
    // delivery record, and the photo upload state, for tests/send_state.test.js.
    surveySendState, readSendState, sendStateWords, sendStateBlocksSend, sendStateNeedsWrap, sendWhy,
    wrapQueueMatches, wrapClientId, wrapSentFields, sendQueuedNow, wrapDeliveredKey,
    wrapJobPrint, wrapPayloadSame, wrapDeliveryTarget, wrapCopyOf,
    photoUploadPending, photoPendingLabel, photoWithUrl, frontPendingCounts, frontPendingLine,
    applyPhotoUploaded, applyPhotoFailed, wrapWirePhotos, wrapWireZones, dropFromPhotoRetryQueue,
    // SEND-STATE-V1 follow-ups (send edges): the queue merge after a flush,
    // a job's copies superseded, the notes a sent survey left out, a failed
    // photo upload, and the portal hydration's match by id.
    _mergeQueueAfterFlush, dropWrapCopies, wrapPendingNoteIds, wrapUnsentNotesField, wrapLeftOutNoteLanded,
    photoUploadFailed, portalSurveyLocalIndex,
    // COMPANION-FOLLOWUPS-V2: the sent notes onto the job, the untyped-line
    // count and the one five-minute sync starter (tests/followups_v2.test.js).
    wrapSentNotesField, wrapUntypedLineCount, startPortalSyncInterval, PORTAL_SYNC_EVERY_MS,
    // SEND-TIMEOUT-V1: the send's deadline and the survey the portal already
    // holds, for tests/send_edges.test.js.
    _WRAP_SEND_TIMEOUT_MS, _WRAP_CHECK_TIMEOUT_MS, _portalDeadline, wrapLandedRow,
    // SECURITY-WAVE-1 track C: the sign-in-again seam and the three queues
    // it holds, for tests/signin_again.test.js.
    bearerRefused, signInAgainNeeded, afterFreshSignIn, SIGNIN_AGAIN_MESSAGE,
    SIGNIN_AGAIN_OFFLINE_MESSAGE, pinUnlockNeedsPortal, requestSignInAgain,
    SignInAgainBanner, UserSelectScreen, hashPin, PORTAL_RETIRED_ENDPOINTS,
    clearSignInHoldOnSignOut,
    addToPhotoRetryQueue, flushPhotoRetryQueue,
    addToAudioRetryQueue, flushAudioRetryQueue, backfillVoiceAudio,
    // BRIEFING-RENDER-V1 — the briefing parse/selection seam. Exposed for the
    // same reason the queue functions above are: the browser cannot reach
    // module-scope consts, and this pair is where a schema drift would land
    // silently. tests/briefing_render.test.js locks them against fixtures
    // copied from morning_briefing.py, NOT from a description of it.
    briefingFromPayload, briefingBeats, BRIEFING_MOVE_TIERS,
    // MORNING-BRIEFING-V2 C: the plan seam and its two surfaces.
    briefingPlan, BriefingPlanToday, BriefingPlanFull,
    // UV-RESKIN-V1 track B: the theme seam, for tests/ui_theme.test.js.
    t, T_STANDARD, T_UV_OVERRIDES, uiThemeOf, readCachedUiTheme, applyUiTheme,
    // COMPANION-STUDIO-V1 track 1: the Studio token source, for tests.
    STUDIO_TOKENS, studioCssVars, studioShape,
    // COMPANION-STUDIO-LIT-V1: the meaning colours, for tests.
    STUDIO_MEANING,
    // STUDIO-LIT-PHONE-V1 item 8a: the shell and the snag helpers, for
    // tests/studio_lit_phone_shell.test.js.
    PersistentHeader, TabBar, screenToTab, StudioOrb, snagFixedToday, snagOwnerWords, snagSevLit,
    // Sheets over the tab bar (21 October 2026): the portal every overlay goes
    // through, for tests/sheet_portal.test.js.
    SheetPortal,
    // NOTES-IN-AREA (21 October 2026): the area's note list on the Fittings
    // tab, for tests/area_notes.test.js.
    areaNoteLines, AREA_NOTES_SHOWN,
    // COMPANION-STUDIO-LIT-V1 track 3b: the one stale-quote rule (Today and
    // Pipeline), for tests/studio_lit_pipeline.test.js.
    staleQuoteList,
    // STUDIO-LIT-PHONE-V1 item 2: the portal quote mapping (the won_at drop),
    // for tests/studio_lit_phone_today.test.js.
    mapPortalQuotesToProposals,
    // STUDIO-LIT-PHONE-V1 item 3: the stage words with odds (Today and
    // Pipeline), for tests/studio_lit_phone_pipeline.test.js.
    studioQuoteStage,
    // COMPANION-TRUTH-V2 B2: the one live-quote predicate and the stage word,
    // for tests/companion_truth_v2_vocab.test.js.
    quoteIsLive, quoteIsUnsent, quoteStageWord,
    // ... and the sync, for its 403 rule on the whole team's figures.
    syncPortalData,
    // COMPANION-TRUTH-V2 B4: the one date-or-time rule for "Last synced"
    // (tests/companion_truth_v2_synced.test.js).
    truthWhen, truthSyncedLine,
    // COMPANION-TRUTH-V1 track C, widened by COMPANION-TRUTH-V2 B1: the
    // portal caches that go with a person, and the shared-phone identity
    // helpers, for tests/companion_truth.test.js and
    // tests/companion_truth_v2_identity.test.js.
    PORTAL_CACHE_KEYS, clearPortalCaches, clearForNextPerson,
    claimPortalCaches, hydrateProposalsFromPortal,
    // COMPANION-TRUTH-V3: the monthly target per person
    // (tests/companion_truth_v3.test.js).
    readMyMonthlyTarget, writeMyMonthlyTarget, fetchTargetFromPortal,
    // STUDIO-LIT-PHONE-V1 item 5: the run lines on More and My performance
    // (tests/studio_lit_phone_more_perf.test.js).
    perfAtRiskLine, perfRunHint,
    // COMPANION-TRUTH-V2 B3: the shared currency formatter and the
    // not-available mark it prints for a missing value
    // (tests/companion_truth_v2_null.test.js).
    formatCurrency, TRUTH_DASH,
    // Track 4: the chase sheet's age line (tests/studio_lit_colour.test.js).
    ChaseSheet,
    // UV-RESKIN-V1 track E: the survey landing screen is the one wave-1
    // screen render-check did not already mount (tests/uv_reskin_screens.test.js).
    SurveyLandingScreen,
    // The screen this PR rewrites. Exported so render-check MOUNTS it:
    // the first draft referenced `beats` without computing it and rendered
    // a blank screen, which was caught by eye rather than by CI.
    MorningBriefingScreen,
    // COMPANION-HEALTH-V1: the fault reporter's queue, fixed fields and backoff
    // (tests/health_report.test.js).
    createHealthReporter, createHealthMemoryStore, createHealthIdbStore, healthCode,
    healthLocation, healthSanitiseReport, healthFingerprint, healthDevice, healthBackoff,
    healthAnswerClears, HEALTH_FAULT_EVENTS, HEALTH_KINDS, HEALTH_CODES, HEALTH_CAP,
    HEALTH_BATCH, HEALTH_BACKOFF_BASE_MS, HEALTH_BACKOFF_MAX_MS, debugLog,
    healthUseReporter, reportFault,
  };
}
